"use client";
import { jsxs as Re, jsx as R, Fragment as la } from "react/jsx-runtime";
import * as p from "react";
import yn, { forwardRef as dc, createElement as qr, useRef as wt, useState as Je, useCallback as Jt, useEffect as gt, createContext as p_, useMemo as Ct, useImperativeHandle as m_, Fragment as Qo, useId as E_, useContext as g_, memo as S_ } from "react";
import { createPortal as uc } from "react-dom";
import { getUploadUrl as h_ } from "@repo/edtech-api";
import { useThemeSwitcher as f_, Theme as T_, EdtechProvider as b_ } from "@repo/edtech-shared";
const C_ = (t) => t.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), y_ = (t) => t.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (e, n, i) => i ? i.toUpperCase() : n.toLowerCase()
), Xo = (t) => {
  const e = y_(t);
  return e.charAt(0).toUpperCase() + e.slice(1);
}, _c = (...t) => t.filter((e, n, i) => !!e && e.trim() !== "" && i.indexOf(e) === n).join(" ").trim(), R_ = (t) => {
  for (const e in t)
    if (e.startsWith("aria-") || e === "role" || e === "title")
      return !0;
};
var N_ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
const O_ = dc(
  ({
    color: t = "currentColor",
    size: e = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: i,
    className: r = "",
    children: a,
    iconNode: s,
    ...o
  }, l) => qr(
    "svg",
    {
      ref: l,
      ...N_,
      width: e,
      height: e,
      stroke: t,
      strokeWidth: i ? Number(n) * 24 / Number(e) : n,
      className: _c("lucide", r),
      ...!a && !R_(o) && { "aria-hidden": "true" },
      ...o
    },
    [
      ...s.map(([c, d]) => qr(c, d)),
      ...Array.isArray(a) ? a : [a]
    ]
  )
);
const vn = (t, e) => {
  const n = dc(
    ({ className: i, ...r }, a) => qr(O_, {
      ref: a,
      iconNode: e,
      className: _c(
        `lucide-${C_(Xo(t))}`,
        `lucide-${t}`,
        i
      ),
      ...r
    })
  );
  return n.displayName = Xo(t), n;
};
const v_ = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], A_ = vn("chevron-down", v_);
const I_ = [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]], D_ = vn("chevron-left", I_);
const M_ = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], w_ = vn("chevron-right", M_);
const x_ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 3v18", key: "bbkbws" }],
  ["path", { d: "M3 7.5h4", key: "zfgn84" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["path", { d: "M3 16.5h4", key: "1230mu" }],
  ["path", { d: "M17 3v18", key: "in4fa5" }],
  ["path", { d: "M17 7.5h4", key: "myr1c1" }],
  ["path", { d: "M17 16.5h4", key: "go4c1d" }]
], L_ = vn("film", x_);
const P_ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
], k_ = vn("image", P_);
const U_ = [
  [
    "path",
    {
      d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
      key: "18887p"
    }
  ],
  ["path", { d: "M7 11h10", key: "1twpyw" }],
  ["path", { d: "M7 15h6", key: "d9of3u" }],
  ["path", { d: "M7 7h8", key: "af5zfr" }]
], F_ = vn("message-square-text", U_);
const B_ = [
  ["path", { d: "M13 5H19V11", key: "1n1gyv" }],
  ["path", { d: "M19 5L5 19", key: "72u4yj" }]
], G_ = vn("move-up-right", B_);
const Y_ = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], $_ = vn("x", Y_), V_ = "_accordion_jeqx4_1", H_ = "_root_jeqx4_11", q_ = "_item_jeqx4_23", z_ = "_header_jeqx4_33", W_ = "_trigger_jeqx4_39", K_ = "_title_jeqx4_77", Q_ = "_indicatorSlot_jeqx4_93", X_ = "_chevron_jeqx4_105", Z_ = "_itemOpen_jeqx4_117", J_ = "_panel_jeqx4_125", j_ = "_panelInner_jeqx4_171", Yt = {
  accordion: V_,
  root: H_,
  item: q_,
  header: z_,
  trigger: W_,
  title: K_,
  indicatorSlot: Q_,
  chevron: X_,
  itemOpen: Z_,
  panel: J_,
  panelInner: j_
}, ep = "_taskList_12hqz_1", tp = "_linkButtonWrapper_12hqz_13", np = "_linkButton_12hqz_13", ip = "_linkButton_variant_primary_12hqz_49", rp = "_linkButton_variant_secondary_12hqz_59", ap = "_linkButton_variant_ghost_12hqz_69", sp = "_linkButton_size_sm_12hqz_89", op = "_linkButton_size_md_12hqz_99", lp = "_linkButton_size_lg_12hqz_109", cp = "_colorNote_12hqz_119", dp = "_accordionItemIndicator_12hqz_133", up = "_checkBoxroot_12hqz_141", _p = "_checkBoxIsDisabled_12hqz_159", pp = "_checkBoxBox_12hqz_173", mp = "_checkBoxRoot_12hqz_211", Ep = "_checkBoxInput_12hqz_221", gp = "_checkBoxIcon_12hqz_241", Sp = "_checkBoxCheckSvg_12hqz_257", hp = "_checkBoxIsSelected_12hqz_267", fp = "_checkBoxIsInvalid_12hqz_289", Tp = "_checkBoxLabel_12hqz_297", bp = "_checkBoxLabelLineThrough_12hqz_307", dt = {
  taskList: ep,
  linkButtonWrapper: tp,
  linkButton: np,
  linkButton_variant_primary: ip,
  linkButton_variant_secondary: rp,
  linkButton_variant_ghost: ap,
  linkButton_size_sm: sp,
  linkButton_size_md: op,
  linkButton_size_lg: lp,
  colorNote: cp,
  accordionItemIndicator: dp,
  checkBoxroot: up,
  checkBoxIsDisabled: _p,
  checkBoxBox: pp,
  checkBoxRoot: mp,
  checkBoxInput: Ep,
  checkBoxIcon: gp,
  checkBoxCheckSvg: Sp,
  checkBoxIsSelected: hp,
  checkBoxIsInvalid: fp,
  checkBoxLabel: Tp,
  checkBoxLabelLineThrough: bp
};
function Cp(t, e) {
  const n = {};
  return (t[t.length - 1] === "" ? [...t, ""] : t).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
const yp = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, Rp = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, Np = {};
function Zo(t, e) {
  return (Np.jsx ? Rp : yp).test(t);
}
const Op = /[ \t\n\f\r]/g;
function vp(t) {
  return typeof t == "object" ? t.type === "text" ? Jo(t.value) : !1 : Jo(t);
}
function Jo(t) {
  return t.replace(Op, "") === "";
}
class or {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(e, n, i) {
    this.normal = n, this.property = e, i && (this.space = i);
  }
}
or.prototype.normal = {};
or.prototype.property = {};
or.prototype.space = void 0;
function pc(t, e) {
  const n = {}, i = {};
  for (const r of t)
    Object.assign(n, r.property), Object.assign(i, r.normal);
  return new or(n, i, e);
}
function ja(t) {
  return t.toLowerCase();
}
class Ot {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(e, n) {
    this.attribute = n, this.property = e;
  }
}
Ot.prototype.attribute = "";
Ot.prototype.booleanish = !1;
Ot.prototype.boolean = !1;
Ot.prototype.commaOrSpaceSeparated = !1;
Ot.prototype.commaSeparated = !1;
Ot.prototype.defined = !1;
Ot.prototype.mustUseProperty = !1;
Ot.prototype.number = !1;
Ot.prototype.overloadedBoolean = !1;
Ot.prototype.property = "";
Ot.prototype.spaceSeparated = !1;
Ot.prototype.space = void 0;
let Ap = 0;
const oe = Hn(), Ze = Hn(), es = Hn(), M = Hn(), Le = Hn(), _i = Hn(), At = Hn();
function Hn() {
  return 2 ** ++Ap;
}
const ts = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: oe,
  booleanish: Ze,
  commaOrSpaceSeparated: At,
  commaSeparated: _i,
  number: M,
  overloadedBoolean: es,
  spaceSeparated: Le
}, Symbol.toStringTag, { value: "Module" })), wa = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(ts)
);
class Os extends Ot {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(e, n, i, r) {
    let a = -1;
    if (super(e, n), jo(this, "space", r), typeof i == "number")
      for (; ++a < wa.length; ) {
        const s = wa[a];
        jo(this, wa[a], (i & ts[s]) === ts[s]);
      }
  }
}
Os.prototype.defined = !0;
function jo(t, e, n) {
  n && (t[e] = n);
}
function bi(t) {
  const e = {}, n = {};
  for (const [i, r] of Object.entries(t.properties)) {
    const a = new Os(
      i,
      t.transform(t.attributes || {}, i),
      r,
      t.space
    );
    t.mustUseProperty && t.mustUseProperty.includes(i) && (a.mustUseProperty = !0), e[i] = a, n[ja(i)] = i, n[ja(a.attribute)] = i;
  }
  return new or(e, n, t.space);
}
const mc = bi({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: Ze,
    ariaAutoComplete: null,
    ariaBusy: Ze,
    ariaChecked: Ze,
    ariaColCount: M,
    ariaColIndex: M,
    ariaColSpan: M,
    ariaControls: Le,
    ariaCurrent: null,
    ariaDescribedBy: Le,
    ariaDetails: null,
    ariaDisabled: Ze,
    ariaDropEffect: Le,
    ariaErrorMessage: null,
    ariaExpanded: Ze,
    ariaFlowTo: Le,
    ariaGrabbed: Ze,
    ariaHasPopup: null,
    ariaHidden: Ze,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Le,
    ariaLevel: M,
    ariaLive: null,
    ariaModal: Ze,
    ariaMultiLine: Ze,
    ariaMultiSelectable: Ze,
    ariaOrientation: null,
    ariaOwns: Le,
    ariaPlaceholder: null,
    ariaPosInSet: M,
    ariaPressed: Ze,
    ariaReadOnly: Ze,
    ariaRelevant: null,
    ariaRequired: Ze,
    ariaRoleDescription: Le,
    ariaRowCount: M,
    ariaRowIndex: M,
    ariaRowSpan: M,
    ariaSelected: Ze,
    ariaSetSize: M,
    ariaSort: null,
    ariaValueMax: M,
    ariaValueMin: M,
    ariaValueNow: M,
    ariaValueText: null,
    role: null
  },
  transform(t, e) {
    return e === "role" ? e : "aria-" + e.slice(4).toLowerCase();
  }
});
function Ec(t, e) {
  return e in t ? t[e] : e;
}
function gc(t, e) {
  return Ec(t, e.toLowerCase());
}
const Ip = bi({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: _i,
    acceptCharset: Le,
    accessKey: Le,
    action: null,
    allow: null,
    allowFullScreen: oe,
    allowPaymentRequest: oe,
    allowUserMedia: oe,
    alt: null,
    as: null,
    async: oe,
    autoCapitalize: null,
    autoComplete: Le,
    autoFocus: oe,
    autoPlay: oe,
    blocking: Le,
    capture: null,
    charSet: null,
    checked: oe,
    cite: null,
    className: Le,
    cols: M,
    colSpan: null,
    content: null,
    contentEditable: Ze,
    controls: oe,
    controlsList: Le,
    coords: M | _i,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: oe,
    defer: oe,
    dir: null,
    dirName: null,
    disabled: oe,
    download: es,
    draggable: Ze,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: oe,
    formTarget: null,
    headers: Le,
    height: M,
    hidden: es,
    high: M,
    href: null,
    hrefLang: null,
    htmlFor: Le,
    httpEquiv: Le,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: oe,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: oe,
    itemId: null,
    itemProp: Le,
    itemRef: Le,
    itemScope: oe,
    itemType: Le,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: oe,
    low: M,
    manifest: null,
    max: null,
    maxLength: M,
    media: null,
    method: null,
    min: null,
    minLength: M,
    multiple: oe,
    muted: oe,
    name: null,
    nonce: null,
    noModule: oe,
    noValidate: oe,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: oe,
    optimum: M,
    pattern: null,
    ping: Le,
    placeholder: null,
    playsInline: oe,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: oe,
    referrerPolicy: null,
    rel: Le,
    required: oe,
    reversed: oe,
    rows: M,
    rowSpan: M,
    sandbox: Le,
    scope: null,
    scoped: oe,
    seamless: oe,
    selected: oe,
    shadowRootClonable: oe,
    shadowRootDelegatesFocus: oe,
    shadowRootMode: null,
    shape: null,
    size: M,
    sizes: null,
    slot: null,
    span: M,
    spellCheck: Ze,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: M,
    step: null,
    style: null,
    tabIndex: M,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: oe,
    useMap: null,
    value: Ze,
    width: M,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Le,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: M,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: M,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: oe,
    // Lists. Use CSS to reduce space between items instead
    declare: oe,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: M,
    // `<img>` and `<object>`
    leftMargin: M,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: M,
    // `<body>`
    marginWidth: M,
    // `<body>`
    noResize: oe,
    // `<frame>`
    noHref: oe,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: oe,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: oe,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: M,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: Ze,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: M,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: M,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: oe,
    disableRemotePlayback: oe,
    prefix: null,
    property: null,
    results: M,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: gc
}), Dp = bi({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: At,
    accentHeight: M,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: M,
    amplitude: M,
    arabicForm: null,
    ascent: M,
    attributeName: null,
    attributeType: null,
    azimuth: M,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: M,
    by: null,
    calcMode: null,
    capHeight: M,
    className: Le,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: M,
    diffuseConstant: M,
    direction: null,
    display: null,
    dur: null,
    divisor: M,
    dominantBaseline: null,
    download: oe,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: M,
    enableBackground: null,
    end: null,
    event: null,
    exponent: M,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: M,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: _i,
    g2: _i,
    glyphName: _i,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: M,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: M,
    horizOriginX: M,
    horizOriginY: M,
    id: null,
    ideographic: M,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: M,
    k: M,
    k1: M,
    k2: M,
    k3: M,
    k4: M,
    kernelMatrix: At,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: M,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: M,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: M,
    overlineThickness: M,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: M,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Le,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: M,
    pointsAtY: M,
    pointsAtZ: M,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: At,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: At,
    rev: At,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: At,
    requiredFeatures: At,
    requiredFonts: At,
    requiredFormats: At,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: M,
    specularExponent: M,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: M,
    strikethroughThickness: M,
    string: null,
    stroke: null,
    strokeDashArray: At,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: M,
    strokeOpacity: M,
    strokeWidth: null,
    style: null,
    surfaceScale: M,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: At,
    tabIndex: M,
    tableValues: null,
    target: null,
    targetX: M,
    targetY: M,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: At,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: M,
    underlineThickness: M,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: M,
    values: null,
    vAlphabetic: M,
    vMathematical: M,
    vectorEffect: null,
    vHanging: M,
    vIdeographic: M,
    version: null,
    vertAdvY: M,
    vertOriginX: M,
    vertOriginY: M,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: M,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: Ec
}), Sc = bi({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(t, e) {
    return "xlink:" + e.slice(5).toLowerCase();
  }
}), hc = bi({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: gc
}), fc = bi({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(t, e) {
    return "xml:" + e.slice(3).toLowerCase();
  }
}), Mp = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, wp = /[A-Z]/g, el = /-[a-z]/g, xp = /^data[-\w.:]+$/i;
function Lp(t, e) {
  const n = ja(e);
  let i = e, r = Ot;
  if (n in t.normal)
    return t.property[t.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && xp.test(e)) {
    if (e.charAt(4) === "-") {
      const a = e.slice(5).replace(el, kp);
      i = "data" + a.charAt(0).toUpperCase() + a.slice(1);
    } else {
      const a = e.slice(4);
      if (!el.test(a)) {
        let s = a.replace(wp, Pp);
        s.charAt(0) !== "-" && (s = "-" + s), e = "data" + s;
      }
    }
    r = Os;
  }
  return new r(i, e);
}
function Pp(t) {
  return "-" + t.toLowerCase();
}
function kp(t) {
  return t.charAt(1).toUpperCase();
}
const Up = pc([mc, Ip, Sc, hc, fc], "html"), vs = pc([mc, Dp, Sc, hc, fc], "svg");
function Fp(t) {
  return t.join(" ").trim();
}
function Tc(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var oi = {}, xa, tl;
function Bp() {
  if (tl) return xa;
  tl = 1;
  var t = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, e = /\n/g, n = /^\s*/, i = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, r = /^:\s*/, a = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, s = /^[;\s]*/, o = /^\s+|\s+$/g, l = `
`, c = "/", d = "*", u = "", _ = "comment", m = "declaration";
  function g(E, h) {
    if (typeof E != "string")
      throw new TypeError("First argument must be a string");
    if (!E) return [];
    h = h || {};
    var T = 1, b = 1;
    function C(D) {
      var L = D.match(e);
      L && (T += L.length);
      var G = D.lastIndexOf(l);
      b = ~G ? D.length - G : b + D.length;
    }
    function y() {
      var D = { line: T, column: b };
      return function(L) {
        return L.position = new O(D), k(), L;
      };
    }
    function O(D) {
      this.start = D, this.end = { line: T, column: b }, this.source = h.source;
    }
    O.prototype.content = E;
    function A(D) {
      var L = new Error(
        h.source + ":" + T + ":" + b + ": " + D
      );
      if (L.reason = D, L.filename = h.source, L.line = T, L.column = b, L.source = E, !h.silent) throw L;
    }
    function I(D) {
      var L = D.exec(E);
      if (L) {
        var G = L[0];
        return C(G), E = E.slice(G.length), L;
      }
    }
    function k() {
      I(n);
    }
    function x(D) {
      var L;
      for (D = D || []; L = B(); )
        L !== !1 && D.push(L);
      return D;
    }
    function B() {
      var D = y();
      if (!(c != E.charAt(0) || d != E.charAt(1))) {
        for (var L = 2; u != E.charAt(L) && (d != E.charAt(L) || c != E.charAt(L + 1)); )
          ++L;
        if (L += 2, u === E.charAt(L - 1))
          return A("End of comment missing");
        var G = E.slice(2, L - 2);
        return b += 2, C(G), E = E.slice(L), b += 2, D({
          type: _,
          comment: G
        });
      }
    }
    function X() {
      var D = y(), L = I(i);
      if (L) {
        if (B(), !I(r)) return A("property missing ':'");
        var G = I(a), q = D({
          type: m,
          property: S(L[0].replace(t, u)),
          value: G ? S(G[0].replace(t, u)) : u
        });
        return I(s), q;
      }
    }
    function J() {
      var D = [];
      x(D);
      for (var L; L = X(); )
        L !== !1 && (D.push(L), x(D));
      return D;
    }
    return k(), J();
  }
  function S(E) {
    return E ? E.replace(o, u) : u;
  }
  return xa = g, xa;
}
var nl;
function Gp() {
  if (nl) return oi;
  nl = 1;
  var t = oi && oi.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(oi, "__esModule", { value: !0 }), oi.default = n;
  const e = t(Bp());
  function n(i, r) {
    let a = null;
    if (!i || typeof i != "string")
      return a;
    const s = (0, e.default)(i), o = typeof r == "function";
    return s.forEach((l) => {
      if (l.type !== "declaration")
        return;
      const { property: c, value: d } = l;
      o ? r(c, d, l) : d && (a = a || {}, a[c] = d);
    }), a;
  }
  return oi;
}
var Gi = {}, il;
function Yp() {
  if (il) return Gi;
  il = 1, Object.defineProperty(Gi, "__esModule", { value: !0 }), Gi.camelCase = void 0;
  var t = /^--[a-zA-Z0-9_-]+$/, e = /-([a-z])/g, n = /^[^-]+$/, i = /^-(webkit|moz|ms|o|khtml)-/, r = /^-(ms)-/, a = function(c) {
    return !c || n.test(c) || t.test(c);
  }, s = function(c, d) {
    return d.toUpperCase();
  }, o = function(c, d) {
    return "".concat(d, "-");
  }, l = function(c, d) {
    return d === void 0 && (d = {}), a(c) ? c : (c = c.toLowerCase(), d.reactCompat ? c = c.replace(r, o) : c = c.replace(i, o), c.replace(e, s));
  };
  return Gi.camelCase = l, Gi;
}
var Yi, rl;
function $p() {
  if (rl) return Yi;
  rl = 1;
  var t = Yi && Yi.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  }, e = t(Gp()), n = Yp();
  function i(r, a) {
    var s = {};
    return !r || typeof r != "string" || (0, e.default)(r, function(o, l) {
      o && l && (s[(0, n.camelCase)(o, a)] = l);
    }), s;
  }
  return i.default = i, Yi = i, Yi;
}
var Vp = $p();
const Hp = /* @__PURE__ */ Tc(Vp), qp = zp("start");
function zp(t) {
  return e;
  function e(n) {
    const i = n && n.position && n.position[t] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function Wp(t) {
  return !t || typeof t != "object" ? "" : "position" in t || "type" in t ? al(t.position) : "start" in t || "end" in t ? al(t) : "line" in t || "column" in t ? ns(t) : "";
}
function ns(t) {
  return sl(t && t.line) + ":" + sl(t && t.column);
}
function al(t) {
  return ns(t && t.start) + "-" + ns(t && t.end);
}
function sl(t) {
  return t && typeof t == "number" ? t : 1;
}
class St extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(e, n, i) {
    super(), typeof n == "string" && (i = n, n = void 0);
    let r = "", a = {}, s = !1;
    if (n && ("line" in n && "column" in n ? a = { place: n } : "start" in n && "end" in n ? a = { place: n } : "type" in n ? a = {
      ancestors: [n],
      place: n.position
    } : a = { ...n }), typeof e == "string" ? r = e : !a.cause && e && (s = !0, r = e.message, a.cause = e), !a.ruleId && !a.source && typeof i == "string") {
      const l = i.indexOf(":");
      l === -1 ? a.ruleId = i : (a.source = i.slice(0, l), a.ruleId = i.slice(l + 1));
    }
    if (!a.place && a.ancestors && a.ancestors) {
      const l = a.ancestors[a.ancestors.length - 1];
      l && (a.place = l.position);
    }
    const o = a.place && "start" in a.place ? a.place.start : a.place;
    this.ancestors = a.ancestors || void 0, this.cause = a.cause || void 0, this.column = o ? o.column : void 0, this.fatal = void 0, this.file = "", this.message = r, this.line = o ? o.line : void 0, this.name = Wp(a.place) || "1:1", this.place = a.place || void 0, this.reason = this.message, this.ruleId = a.ruleId || void 0, this.source = a.source || void 0, this.stack = s && a.cause && typeof a.cause.stack == "string" ? a.cause.stack : "", this.actual = void 0, this.expected = void 0, this.note = void 0, this.url = void 0;
  }
}
St.prototype.file = "";
St.prototype.name = "";
St.prototype.reason = "";
St.prototype.message = "";
St.prototype.stack = "";
St.prototype.column = void 0;
St.prototype.line = void 0;
St.prototype.ancestors = void 0;
St.prototype.cause = void 0;
St.prototype.fatal = void 0;
St.prototype.place = void 0;
St.prototype.ruleId = void 0;
St.prototype.source = void 0;
const As = {}.hasOwnProperty, Kp = /* @__PURE__ */ new Map(), Qp = /[A-Z]/g, Xp = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), Zp = /* @__PURE__ */ new Set(["td", "th"]), bc = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function Jp(t, e) {
  if (!e || e.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const n = e.filePath || void 0;
  let i;
  if (e.development) {
    if (typeof e.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    i = sm(n, e.jsxDEV);
  } else {
    if (typeof e.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof e.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    i = am(n, e.jsx, e.jsxs);
  }
  const r = {
    Fragment: e.Fragment,
    ancestors: [],
    components: e.components || {},
    create: i,
    elementAttributeNameCase: e.elementAttributeNameCase || "react",
    evaluater: e.createEvaluater ? e.createEvaluater() : void 0,
    filePath: n,
    ignoreInvalidStyle: e.ignoreInvalidStyle || !1,
    passKeys: e.passKeys !== !1,
    passNode: e.passNode || !1,
    schema: e.space === "svg" ? vs : Up,
    stylePropertyNameCase: e.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: e.tableCellAlignToStyle !== !1
  }, a = Cc(r, t, void 0);
  return a && typeof a != "string" ? a : r.create(
    t,
    r.Fragment,
    { children: a || void 0 },
    void 0
  );
}
function Cc(t, e, n) {
  if (e.type === "element")
    return jp(t, e, n);
  if (e.type === "mdxFlowExpression" || e.type === "mdxTextExpression")
    return em(t, e);
  if (e.type === "mdxJsxFlowElement" || e.type === "mdxJsxTextElement")
    return nm(t, e, n);
  if (e.type === "mdxjsEsm")
    return tm(t, e);
  if (e.type === "root")
    return im(t, e, n);
  if (e.type === "text")
    return rm(t, e);
}
function jp(t, e, n) {
  const i = t.schema;
  let r = i;
  e.tagName.toLowerCase() === "svg" && i.space === "html" && (r = vs, t.schema = r), t.ancestors.push(e);
  const a = Rc(t, e.tagName, !1), s = om(t, e);
  let o = Ds(t, e);
  return Xp.has(e.tagName) && (o = o.filter(function(l) {
    return typeof l == "string" ? !vp(l) : !0;
  })), yc(t, s, a, e), Is(s, o), t.ancestors.pop(), t.schema = i, t.create(e, a, s, n);
}
function em(t, e) {
  if (e.data && e.data.estree && t.evaluater) {
    const i = e.data.estree.body[0];
    return i.type, /** @type {Child | undefined} */
    t.evaluater.evaluateExpression(i.expression);
  }
  er(t, e.position);
}
function tm(t, e) {
  if (e.data && e.data.estree && t.evaluater)
    return (
      /** @type {Child | undefined} */
      t.evaluater.evaluateProgram(e.data.estree)
    );
  er(t, e.position);
}
function nm(t, e, n) {
  const i = t.schema;
  let r = i;
  e.name === "svg" && i.space === "html" && (r = vs, t.schema = r), t.ancestors.push(e);
  const a = e.name === null ? t.Fragment : Rc(t, e.name, !0), s = lm(t, e), o = Ds(t, e);
  return yc(t, s, a, e), Is(s, o), t.ancestors.pop(), t.schema = i, t.create(e, a, s, n);
}
function im(t, e, n) {
  const i = {};
  return Is(i, Ds(t, e)), t.create(e, t.Fragment, i, n);
}
function rm(t, e) {
  return e.value;
}
function yc(t, e, n, i) {
  typeof n != "string" && n !== t.Fragment && t.passNode && (e.node = i);
}
function Is(t, e) {
  if (e.length > 0) {
    const n = e.length > 1 ? e : e[0];
    n && (t.children = n);
  }
}
function am(t, e, n) {
  return i;
  function i(r, a, s, o) {
    const c = Array.isArray(s.children) ? n : e;
    return o ? c(a, s, o) : c(a, s);
  }
}
function sm(t, e) {
  return n;
  function n(i, r, a, s) {
    const o = Array.isArray(a.children), l = qp(i);
    return e(
      r,
      a,
      s,
      o,
      {
        columnNumber: l ? l.column - 1 : void 0,
        fileName: t,
        lineNumber: l ? l.line : void 0
      },
      void 0
    );
  }
}
function om(t, e) {
  const n = {};
  let i, r;
  for (r in e.properties)
    if (r !== "children" && As.call(e.properties, r)) {
      const a = cm(t, r, e.properties[r]);
      if (a) {
        const [s, o] = a;
        t.tableCellAlignToStyle && s === "align" && typeof o == "string" && Zp.has(e.tagName) ? i = o : n[s] = o;
      }
    }
  if (i) {
    const a = (
      /** @type {Style} */
      n.style || (n.style = {})
    );
    a[t.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
  }
  return n;
}
function lm(t, e) {
  const n = {};
  for (const i of e.attributes)
    if (i.type === "mdxJsxExpressionAttribute")
      if (i.data && i.data.estree && t.evaluater) {
        const a = i.data.estree.body[0];
        a.type;
        const s = a.expression;
        s.type;
        const o = s.properties[0];
        o.type, Object.assign(
          n,
          t.evaluater.evaluateExpression(o.argument)
        );
      } else
        er(t, e.position);
    else {
      const r = i.name;
      let a;
      if (i.value && typeof i.value == "object")
        if (i.value.data && i.value.data.estree && t.evaluater) {
          const o = i.value.data.estree.body[0];
          o.type, a = t.evaluater.evaluateExpression(o.expression);
        } else
          er(t, e.position);
      else
        a = i.value === null ? !0 : i.value;
      n[r] = /** @type {Props[keyof Props]} */
      a;
    }
  return n;
}
function Ds(t, e) {
  const n = [];
  let i = -1;
  const r = t.passKeys ? /* @__PURE__ */ new Map() : Kp;
  for (; ++i < e.children.length; ) {
    const a = e.children[i];
    let s;
    if (t.passKeys) {
      const l = a.type === "element" ? a.tagName : a.type === "mdxJsxFlowElement" || a.type === "mdxJsxTextElement" ? a.name : void 0;
      if (l) {
        const c = r.get(l) || 0;
        s = l + "-" + c, r.set(l, c + 1);
      }
    }
    const o = Cc(t, a, s);
    o !== void 0 && n.push(o);
  }
  return n;
}
function cm(t, e, n) {
  const i = Lp(t.schema, e);
  if (!(n == null || typeof n == "number" && Number.isNaN(n))) {
    if (Array.isArray(n) && (n = i.commaSeparated ? Cp(n) : Fp(n)), i.property === "style") {
      let r = typeof n == "object" ? n : dm(t, String(n));
      return t.stylePropertyNameCase === "css" && (r = um(r)), ["style", r];
    }
    return [
      t.elementAttributeNameCase === "react" && i.space ? Mp[i.property] || i.property : i.attribute,
      n
    ];
  }
}
function dm(t, e) {
  try {
    return Hp(e, { reactCompat: !0 });
  } catch (n) {
    if (t.ignoreInvalidStyle)
      return {};
    const i = (
      /** @type {Error} */
      n
    ), r = new St("Cannot parse `style` attribute", {
      ancestors: t.ancestors,
      cause: i,
      ruleId: "style",
      source: "hast-util-to-jsx-runtime"
    });
    throw r.file = t.filePath || void 0, r.url = bc + "#cannot-parse-style-attribute", r;
  }
}
function Rc(t, e, n) {
  let i;
  if (!n)
    i = { type: "Literal", value: e };
  else if (e.includes(".")) {
    const r = e.split(".");
    let a = -1, s;
    for (; ++a < r.length; ) {
      const o = Zo(r[a]) ? { type: "Identifier", name: r[a] } : { type: "Literal", value: r[a] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: o,
        computed: !!(a && o.type === "Literal"),
        optional: !1
      } : o;
    }
    i = s;
  } else
    i = Zo(e) && !/^[a-z]/.test(e) ? { type: "Identifier", name: e } : { type: "Literal", value: e };
  if (i.type === "Literal") {
    const r = (
      /** @type {string | number} */
      i.value
    );
    return As.call(t.components, r) ? t.components[r] : r;
  }
  if (t.evaluater)
    return t.evaluater.evaluateExpression(i);
  er(t);
}
function er(t, e) {
  const n = new St(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: t.ancestors,
      place: e,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw n.file = t.filePath || void 0, n.url = bc + "#cannot-handle-mdx-estrees-without-createevaluater", n;
}
function um(t) {
  const e = {};
  let n;
  for (n in t)
    As.call(t, n) && (e[_m(n)] = t[n]);
  return e;
}
function _m(t) {
  let e = t.replace(Qp, pm);
  return e.slice(0, 3) === "ms-" && (e = "-" + e), e;
}
function pm(t) {
  return "-" + t.toLowerCase();
}
function mm(t) {
  const e = "[A-Za-zА-Яа-яёЁ_][A-Za-zА-Яа-яёЁ_0-9]+", r = "далее " + "возврат вызватьисключение выполнить для если и из или иначе иначеесли исключение каждого конецесли конецпопытки конеццикла не новый перейти перем по пока попытка прервать продолжить тогда цикл экспорт ", o = "загрузитьизфайла " + "вебклиент вместо внешнеесоединение клиент конецобласти мобильноеприложениеклиент мобильноеприложениесервер наклиенте наклиентенасервере наклиентенасерверебезконтекста насервере насерверебезконтекста область перед после сервер толстыйклиентобычноеприложение толстыйклиентуправляемоеприложение тонкийклиент ", _ = "разделительстраниц разделительстрок символтабуляции " + "ansitooem oemtoansi ввестивидсубконто ввестиперечисление ввестипериод ввестиплансчетов выбранныйплансчетов датагод датамесяц датачисло заголовоксистемы значениевстроку значениеизстроки каталогиб каталогпользователя кодсимв конгода конецпериодаби конецрассчитанногопериодаби конецстандартногоинтервала конквартала конмесяца коннедели лог лог10 максимальноеколичествосубконто названиеинтерфейса названиенабораправ назначитьвид назначитьсчет найтиссылки началопериодаби началостандартногоинтервала начгода начквартала начмесяца начнедели номерднягода номерднянедели номернеделигода обработкаожидания основнойжурналрасчетов основнойплансчетов основнойязык очиститьокносообщений периодстр получитьвремята получитьдатута получитьдокументта получитьзначенияотбора получитьпозициюта получитьпустоезначение получитьта префиксавтонумерации пропись пустоезначение разм разобратьпозициюдокумента рассчитатьрегистрына рассчитатьрегистрыпо симв создатьобъект статусвозврата стрколичествострок сформироватьпозициюдокумента счетпокоду текущеевремя типзначения типзначениястр установитьтана установитьтапо фиксшаблон шаблон " + "acos asin atan base64значение base64строка cos exp log log10 pow sin sqrt tan xmlзначение xmlстрока xmlтип xmlтипзнч активноеокно безопасныйрежим безопасныйрежимразделенияданных булево ввестидату ввестизначение ввестистроку ввестичисло возможностьчтенияxml вопрос восстановитьзначение врег выгрузитьжурналрегистрации выполнитьобработкуоповещения выполнитьпроверкуправдоступа вычислить год данныеформывзначение дата день деньгода деньнедели добавитьмесяц заблокироватьданныедляредактирования заблокироватьработупользователя завершитьработусистемы загрузитьвнешнююкомпоненту закрытьсправку записатьjson записатьxml записатьдатуjson записьжурналарегистрации заполнитьзначениясвойств запроситьразрешениепользователя запуститьприложение запуститьсистему зафиксироватьтранзакцию значениевданныеформы значениевстрокувнутр значениевфайл значениезаполнено значениеизстрокивнутр значениеизфайла изxmlтипа импортмоделиxdto имякомпьютера имяпользователя инициализироватьпредопределенныеданные информацияобошибке каталогбиблиотекимобильногоустройства каталогвременныхфайлов каталогдокументов каталогпрограммы кодироватьстроку кодлокализацииинформационнойбазы кодсимвола командасистемы конецгода конецдня конецквартала конецмесяца конецминуты конецнедели конецчаса конфигурациябазыданныхизмененадинамически конфигурацияизменена копироватьданныеформы копироватьфайл краткоепредставлениеошибки лев макс местноевремя месяц мин минута монопольныйрежим найти найтинедопустимыесимволыxml найтиокнопонавигационнойссылке найтипомеченныенаудаление найтипоссылкам найтифайлы началогода началодня началоквартала началомесяца началоминуты началонедели началочаса начатьзапросразрешенияпользователя начатьзапускприложения начатькопированиефайла начатьперемещениефайла начатьподключениевнешнейкомпоненты начатьподключениерасширенияработыскриптографией начатьподключениерасширенияработысфайлами начатьпоискфайлов начатьполучениекаталогавременныхфайлов начатьполучениекаталогадокументов начатьполучениерабочегокаталогаданныхпользователя начатьполучениефайлов начатьпомещениефайла начатьпомещениефайлов начатьсозданиедвоичныхданныхизфайла начатьсозданиекаталога начатьтранзакцию начатьудалениефайлов начатьустановкувнешнейкомпоненты начатьустановкурасширенияработыскриптографией начатьустановкурасширенияработысфайлами неделягода необходимостьзавершениясоединения номерсеансаинформационнойбазы номерсоединенияинформационнойбазы нрег нстр обновитьинтерфейс обновитьнумерациюобъектов обновитьповторноиспользуемыезначения обработкапрерыванияпользователя объединитьфайлы окр описаниеошибки оповестить оповеститьобизменении отключитьобработчикзапросанастроекклиенталицензирования отключитьобработчикожидания отключитьобработчикоповещения открытьзначение открытьиндекссправки открытьсодержаниесправки открытьсправку открытьформу открытьформумодально отменитьтранзакцию очиститьжурналрегистрации очиститьнастройкипользователя очиститьсообщения параметрыдоступа перейтипонавигационнойссылке переместитьфайл подключитьвнешнююкомпоненту подключитьобработчикзапросанастроекклиенталицензирования подключитьобработчикожидания подключитьобработчикоповещения подключитьрасширениеработыскриптографией подключитьрасширениеработысфайлами подробноепредставлениеошибки показатьвводдаты показатьвводзначения показатьвводстроки показатьвводчисла показатьвопрос показатьзначение показатьинформациюобошибке показатьнакарте показатьоповещениепользователя показатьпредупреждение полноеимяпользователя получитьcomобъект получитьxmlтип получитьадреспоместоположению получитьблокировкусеансов получитьвремязавершенияспящегосеанса получитьвремязасыпанияпассивногосеанса получитьвремяожиданияблокировкиданных получитьданныевыбора получитьдополнительныйпараметрклиенталицензирования получитьдопустимыекодылокализации получитьдопустимыечасовыепояса получитьзаголовокклиентскогоприложения получитьзаголовоксистемы получитьзначенияотборажурналарегистрации получитьидентификаторконфигурации получитьизвременногохранилища получитьимявременногофайла получитьимяклиенталицензирования получитьинформациюэкрановклиента получитьиспользованиежурналарегистрации получитьиспользованиесобытияжурналарегистрации получитькраткийзаголовокприложения получитьмакетоформления получитьмаскувсефайлы получитьмаскувсефайлыклиента получитьмаскувсефайлысервера получитьместоположениепоадресу получитьминимальнуюдлинупаролейпользователей получитьнавигационнуюссылку получитьнавигационнуюссылкуинформационнойбазы получитьобновлениеконфигурациибазыданных получитьобновлениепредопределенныхданныхинформационнойбазы получитьобщиймакет получитьобщуюформу получитьокна получитьоперативнуюотметкувремени получитьотключениебезопасногорежима получитьпараметрыфункциональныхопцийинтерфейса получитьполноеимяпредопределенногозначения получитьпредставлениянавигационныхссылок получитьпроверкусложностипаролейпользователей получитьразделительпути получитьразделительпутиклиента получитьразделительпутисервера получитьсеансыинформационнойбазы получитьскоростьклиентскогосоединения получитьсоединенияинформационнойбазы получитьсообщенияпользователю получитьсоответствиеобъектаиформы получитьсоставстандартногоинтерфейсаodata получитьструктурухранениябазыданных получитьтекущийсеансинформационнойбазы получитьфайл получитьфайлы получитьформу получитьфункциональнуюопцию получитьфункциональнуюопциюинтерфейса получитьчасовойпоясинформационнойбазы пользователиос поместитьвовременноехранилище поместитьфайл поместитьфайлы прав праводоступа предопределенноезначение представлениекодалокализации представлениепериода представлениеправа представлениеприложения представлениесобытияжурналарегистрации представлениечасовогопояса предупреждение прекратитьработусистемы привилегированныйрежим продолжитьвызов прочитатьjson прочитатьxml прочитатьдатуjson пустаястрока рабочийкаталогданныхпользователя разблокироватьданныедляредактирования разделитьфайл разорватьсоединениесвнешнимисточникомданных раскодироватьстроку рольдоступна секунда сигнал символ скопироватьжурналрегистрации смещениелетнеговремени смещениестандартноговремени соединитьбуферыдвоичныхданных создатькаталог создатьфабрикуxdto сокрл сокрлп сокрп сообщить состояние сохранитьзначение сохранитьнастройкипользователя сред стрдлина стрзаканчиваетсяна стрзаменить стрнайти стрначинаетсяс строка строкасоединенияинформационнойбазы стрполучитьстроку стрразделить стрсоединить стрсравнить стрчисловхождений стрчислострок стршаблон текущаядата текущаядатасеанса текущаяуниверсальнаядата текущаяуниверсальнаядатавмиллисекундах текущийвариантинтерфейсаклиентскогоприложения текущийвариантосновногошрифтаклиентскогоприложения текущийкодлокализации текущийрежимзапуска текущийязык текущийязыксистемы тип типзнч транзакцияактивна трег удалитьданныеинформационнойбазы удалитьизвременногохранилища удалитьобъекты удалитьфайлы универсальноевремя установитьбезопасныйрежим установитьбезопасныйрежимразделенияданных установитьблокировкусеансов установитьвнешнююкомпоненту установитьвремязавершенияспящегосеанса установитьвремязасыпанияпассивногосеанса установитьвремяожиданияблокировкиданных установитьзаголовокклиентскогоприложения установитьзаголовоксистемы установитьиспользованиежурналарегистрации установитьиспользованиесобытияжурналарегистрации установитькраткийзаголовокприложения установитьминимальнуюдлинупаролейпользователей установитьмонопольныйрежим установитьнастройкиклиенталицензирования установитьобновлениепредопределенныхданныхинформационнойбазы установитьотключениебезопасногорежима установитьпараметрыфункциональныхопцийинтерфейса установитьпривилегированныйрежим установитьпроверкусложностипаролейпользователей установитьрасширениеработыскриптографией установитьрасширениеработысфайлами установитьсоединениесвнешнимисточникомданных установитьсоответствиеобъектаиформы установитьсоставстандартногоинтерфейсаodata установитьчасовойпоясинформационнойбазы установитьчасовойпояссеанса формат цел час часовойпояс часовойпояссеанса число числопрописью этоадресвременногохранилища " + "wsссылки библиотекакартинок библиотекамакетовоформлениякомпоновкиданных библиотекастилей бизнеспроцессы внешниеисточникиданных внешниеобработки внешниеотчеты встроенныепокупки главныйинтерфейс главныйстиль документы доставляемыеуведомления журналыдокументов задачи информацияобинтернетсоединении использованиерабочейдаты историяработыпользователя константы критерииотбора метаданные обработки отображениерекламы отправкадоставляемыхуведомлений отчеты панельзадачос параметрзапуска параметрысеанса перечисления планывидоврасчета планывидовхарактеристик планыобмена планысчетов полнотекстовыйпоиск пользователиинформационнойбазы последовательности проверкавстроенныхпокупок рабочаядата расширенияконфигурации регистрыбухгалтерии регистрынакопления регистрырасчета регистрысведений регламентныезадания сериализаторxdto справочники средствагеопозиционирования средствакриптографии средствамультимедиа средстваотображениярекламы средствапочты средствателефонии фабрикаxdto файловыепотоки фоновыезадания хранилищанастроек хранилищевариантовотчетов хранилищенастроекданныхформ хранилищеобщихнастроек хранилищепользовательскихнастроекдинамическихсписков хранилищепользовательскихнастроекотчетов хранилищесистемныхнастроек ", Z = "webцвета windowsцвета windowsшрифты библиотекакартинок рамкистиля символы цветастиля шрифтыстиля " + "автоматическоесохранениеданныхформывнастройках автонумерациявформе автораздвижениесерий анимациядиаграммы вариантвыравниванияэлементовизаголовков вариантуправлениявысотойтаблицы вертикальнаяпрокруткаформы вертикальноеположение вертикальноеположениеэлемента видгруппыформы виддекорацииформы виддополненияэлементаформы видизмененияданных видкнопкиформы видпереключателя видподписейкдиаграмме видполяформы видфлажка влияниеразмеранапузырекдиаграммы горизонтальноеположение горизонтальноеположениеэлемента группировкаколонок группировкаподчиненныхэлементовформы группыиэлементы действиеперетаскивания дополнительныйрежимотображения допустимыедействияперетаскивания интервалмеждуэлементамиформы использованиевывода использованиеполосыпрокрутки используемоезначениеточкибиржевойдиаграммы историявыборапривводе источникзначенийоситочекдиаграммы источникзначенияразмерапузырькадиаграммы категориягруппыкоманд максимумсерий начальноеотображениедерева начальноеотображениесписка обновлениетекстаредактирования ориентациядендрограммы ориентациядиаграммы ориентацияметокдиаграммы ориентацияметоксводнойдиаграммы ориентацияэлементаформы отображениевдиаграмме отображениевлегендедиаграммы отображениегруппыкнопок отображениезаголовкашкалыдиаграммы отображениезначенийсводнойдиаграммы отображениезначенияизмерительнойдиаграммы отображениеинтерваладиаграммыганта отображениекнопки отображениекнопкивыбора отображениеобсужденийформы отображениеобычнойгруппы отображениеотрицательныхзначенийпузырьковойдиаграммы отображениепанелипоиска отображениеподсказки отображениепредупрежденияприредактировании отображениеразметкиполосырегулирования отображениестраницформы отображениетаблицы отображениетекстазначениядиаграммыганта отображениеуправленияобычнойгруппы отображениефигурыкнопки палитрацветовдиаграммы поведениеобычнойгруппы поддержкамасштабадендрограммы поддержкамасштабадиаграммыганта поддержкамасштабасводнойдиаграммы поисквтаблицепривводе положениезаголовкаэлементаформы положениекартинкикнопкиформы положениекартинкиэлементаграфическойсхемы положениекоманднойпанелиформы положениекоманднойпанелиэлементаформы положениеопорнойточкиотрисовки положениеподписейкдиаграмме положениеподписейшкалызначенийизмерительнойдиаграммы положениесостоянияпросмотра положениестрокипоиска положениетекстасоединительнойлинии положениеуправленияпоиском положениешкалывремени порядокотображенияточекгоризонтальнойгистограммы порядоксерийвлегендедиаграммы размеркартинки расположениезаголовкашкалыдиаграммы растягиваниеповертикалидиаграммыганта режимавтоотображениясостояния режимвводастроктаблицы режимвыборанезаполненного режимвыделениядаты режимвыделениястрокитаблицы режимвыделениятаблицы режимизмененияразмера режимизменениясвязанногозначения режимиспользованиядиалогапечати режимиспользованияпараметракоманды режиммасштабированияпросмотра режимосновногоокнаклиентскогоприложения режимоткрытияокнаформы режимотображениявыделения режимотображениягеографическойсхемы режимотображениязначенийсерии режимотрисовкисеткиграфическойсхемы режимполупрозрачностидиаграммы режимпробеловдиаграммы режимразмещениянастранице режимредактированияколонки режимсглаживаниядиаграммы режимсглаживанияиндикатора режимсписказадач сквозноевыравнивание сохранениеданныхформывнастройках способзаполнениятекстазаголовкашкалыдиаграммы способопределенияограничивающегозначениядиаграммы стандартнаягруппакоманд стандартноеоформление статусоповещенияпользователя стильстрелки типаппроксимациилиниитрендадиаграммы типдиаграммы типединицышкалывремени типимпортасерийслоягеографическойсхемы типлиниигеографическойсхемы типлиниидиаграммы типмаркерагеографическойсхемы типмаркерадиаграммы типобластиоформления типорганизацииисточникаданныхгеографическойсхемы типотображениясериислоягеографическойсхемы типотображенияточечногообъектагеографическойсхемы типотображенияшкалыэлементалегендыгеографическойсхемы типпоискаобъектовгеографическойсхемы типпроекциигеографическойсхемы типразмещенияизмерений типразмещенияреквизитовизмерений типрамкиэлементауправления типсводнойдиаграммы типсвязидиаграммыганта типсоединениязначенийпосериямдиаграммы типсоединенияточекдиаграммы типсоединительнойлинии типстороныэлементаграфическойсхемы типформыотчета типшкалырадарнойдиаграммы факторлиниитрендадиаграммы фигуракнопки фигурыграфическойсхемы фиксациявтаблице форматдняшкалывремени форматкартинки ширинаподчиненныхэлементовформы " + "виддвижениябухгалтерии виддвижениянакопления видпериодарегистрарасчета видсчета видточкимаршрутабизнеспроцесса использованиеагрегатарегистранакопления использованиегруппиэлементов использованиережимапроведения использованиесреза периодичностьагрегатарегистранакопления режимавтовремя режимзаписидокумента режимпроведениядокумента " + "авторегистрацияизменений допустимыйномерсообщения отправкаэлементаданных получениеэлементаданных " + "использованиерасшифровкитабличногодокумента ориентациястраницы положениеитоговколоноксводнойтаблицы положениеитоговстроксводнойтаблицы положениетекстаотносительнокартинки расположениезаголовкагруппировкитабличногодокумента способчтениязначенийтабличногодокумента типдвустороннейпечати типзаполненияобластитабличногодокумента типкурсоровтабличногодокумента типлиниирисункатабличногодокумента типлинииячейкитабличногодокумента типнаправленияпереходатабличногодокумента типотображениявыделениятабличногодокумента типотображениялинийсводнойтаблицы типразмещениятекстатабличногодокумента типрисункатабличногодокумента типсмещениятабличногодокумента типузоратабличногодокумента типфайлатабличногодокумента точностьпечати чередованиерасположениястраниц " + "отображениевремениэлементовпланировщика " + "типфайлаформатированногодокумента " + "обходрезультатазапроса типзаписизапроса " + "видзаполнениярасшифровкипостроителяотчета типдобавленияпредставлений типизмеренияпостроителяотчета типразмещенияитогов " + "доступкфайлу режимдиалогавыборафайла режимоткрытияфайла " + "типизмеренияпостроителязапроса " + "видданныханализа методкластеризации типединицыинтервалавременианализаданных типзаполнениятаблицырезультатаанализаданных типиспользованиячисловыхзначенийанализаданных типисточникаданныхпоискаассоциаций типколонкианализаданныхдереворешений типколонкианализаданныхкластеризация типколонкианализаданныхобщаястатистика типколонкианализаданныхпоискассоциаций типколонкианализаданныхпоискпоследовательностей типколонкимоделипрогноза типмерырасстоянияанализаданных типотсеченияправилассоциации типполяанализаданных типстандартизациианализаданных типупорядочиванияправилассоциациианализаданных типупорядочиванияшаблоновпоследовательностейанализаданных типупрощениядереварешений " + "wsнаправлениепараметра вариантxpathxs вариантзаписидатыjson вариантпростоготипаxs видгруппымоделиxs видфасетаxdto действиепостроителяdom завершенностьпростоготипаxs завершенностьсоставноготипаxs завершенностьсхемыxs запрещенныеподстановкиxs исключениягруппподстановкиxs категорияиспользованияатрибутаxs категорияограниченияидентичностиxs категорияограниченияпространствименxs методнаследованияxs модельсодержимогоxs назначениетипаxml недопустимыеподстановкиxs обработкапробельныхсимволовxs обработкасодержимогоxs ограничениезначенияxs параметрыотбораузловdom переносстрокjson позициявдокументеdom пробельныесимволыxml типатрибутаxml типзначенияjson типканоническогоxml типкомпонентыxs типпроверкиxml типрезультатаdomxpath типузлаdom типузлаxml формаxml формапредставленияxs форматдатыjson экранированиесимволовjson " + "видсравнениякомпоновкиданных действиеобработкирасшифровкикомпоновкиданных направлениесортировкикомпоновкиданных расположениевложенныхэлементоврезультатакомпоновкиданных расположениеитоговкомпоновкиданных расположениегруппировкикомпоновкиданных расположениеполейгруппировкикомпоновкиданных расположениеполякомпоновкиданных расположениереквизитовкомпоновкиданных расположениересурсовкомпоновкиданных типбухгалтерскогоостаткакомпоновкиданных типвыводатекстакомпоновкиданных типгруппировкикомпоновкиданных типгруппыэлементовотборакомпоновкиданных типдополненияпериодакомпоновкиданных типзаголовкаполейкомпоновкиданных типмакетагруппировкикомпоновкиданных типмакетаобластикомпоновкиданных типостаткакомпоновкиданных типпериодакомпоновкиданных типразмещениятекстакомпоновкиданных типсвязинаборовданныхкомпоновкиданных типэлементарезультатакомпоновкиданных расположениелегендыдиаграммыкомпоновкиданных типпримененияотборакомпоновкиданных режимотображенияэлементанастройкикомпоновкиданных режимотображениянастроеккомпоновкиданных состояниеэлементанастройкикомпоновкиданных способвосстановлениянастроеккомпоновкиданных режимкомпоновкирезультата использованиепараметракомпоновкиданных автопозицияресурсовкомпоновкиданных вариантиспользованиягруппировкикомпоновкиданных расположениересурсоввдиаграммекомпоновкиданных фиксациякомпоновкиданных использованиеусловногооформлениякомпоновкиданных " + "важностьинтернетпочтовогосообщения обработкатекстаинтернетпочтовогосообщения способкодированияинтернетпочтовоговложения способкодированиянеasciiсимволовинтернетпочтовогосообщения типтекстапочтовогосообщения протоколинтернетпочты статусразборапочтовогосообщения " + "режимтранзакциизаписижурналарегистрации статустранзакциизаписижурналарегистрации уровеньжурналарегистрации " + "расположениехранилищасертификатовкриптографии режимвключениясертификатовкриптографии режимпроверкисертификатакриптографии типхранилищасертификатовкриптографии " + "кодировкаименфайловвzipфайле методсжатияzip методшифрованияzip режимвосстановленияпутейфайловzip режимобработкиподкаталоговzip режимсохраненияпутейzip уровеньсжатияzip " + "звуковоеоповещение направлениепереходакстроке позициявпотоке порядокбайтов режимблокировкиданных режимуправленияблокировкойданных сервисвстроенныхпокупок состояниефоновогозадания типподписчикадоставляемыхуведомлений уровеньиспользованиязащищенногосоединенияftp " + "направлениепорядкасхемызапроса типдополненияпериодамисхемызапроса типконтрольнойточкисхемызапроса типобъединениясхемызапроса типпараметрадоступнойтаблицысхемызапроса типсоединениясхемызапроса " + "httpметод автоиспользованиеобщегореквизита автопрефиксномеразадачи вариантвстроенногоязыка видиерархии видрегистранакопления видтаблицывнешнегоисточникаданных записьдвиженийприпроведении заполнениепоследовательностей индексирование использованиебазыпланавидоврасчета использованиебыстроговыбора использованиеобщегореквизита использованиеподчинения использованиеполнотекстовогопоиска использованиеразделяемыхданныхобщегореквизита использованиереквизита назначениеиспользованияприложения назначениерасширенияконфигурации направлениепередачи обновлениепредопределенныхданных оперативноепроведение основноепредставлениевидарасчета основноепредставлениевидахарактеристики основноепредставлениезадачи основноепредставлениепланаобмена основноепредставлениесправочника основноепредставлениесчета перемещениеграницыприпроведении периодичностьномерабизнеспроцесса периодичностьномерадокумента периодичностьрегистрарасчета периодичностьрегистрасведений повторноеиспользованиевозвращаемыхзначений полнотекстовыйпоискпривводепостроке принадлежностьобъекта проведение разделениеаутентификацииобщегореквизита разделениеданныхобщегореквизита разделениерасширенийконфигурацииобщегореквизита режимавтонумерацииобъектов режимзаписирегистра режимиспользованиямодальности режимиспользованиясинхронныхвызововрасширенийплатформыивнешнихкомпонент режимповторногоиспользованиясеансов режимполученияданныхвыборапривводепостроке режимсовместимости режимсовместимостиинтерфейса режимуправленияблокировкойданныхпоумолчанию сериикодовпланавидовхарактеристик сериикодовпланасчетов сериикодовсправочника созданиепривводе способвыбора способпоискастрокипривводепостроке способредактирования типданныхтаблицывнешнегоисточникаданных типкодапланавидоврасчета типкодасправочника типмакета типномерабизнеспроцесса типномерадокумента типномеразадачи типформы удалениедвижений " + "важностьпроблемыприменениярасширенияконфигурации вариантинтерфейсаклиентскогоприложения вариантмасштабаформклиентскогоприложения вариантосновногошрифтаклиентскогоприложения вариантстандартногопериода вариантстандартнойдатыначала видграницы видкартинки видотображенияполнотекстовогопоиска видрамки видсравнения видцвета видчисловогозначения видшрифта допустимаядлина допустимыйзнак использованиеbyteordermark использованиеметаданныхполнотекстовогопоиска источникрасширенийконфигурации клавиша кодвозвратадиалога кодировкаxbase кодировкатекста направлениепоиска направлениесортировки обновлениепредопределенныхданных обновлениеприизмененииданных отображениепанелиразделов проверказаполнения режимдиалогавопрос режимзапускаклиентскогоприложения режимокругления режимоткрытияформприложения режимполнотекстовогопоиска скоростьклиентскогосоединения состояниевнешнегоисточникаданных состояниеобновленияконфигурациибазыданных способвыборасертификатаwindows способкодированиястроки статуссообщения типвнешнейкомпоненты типплатформы типповеденияклавишиenter типэлементаинформацииовыполненииобновленияконфигурациибазыданных уровеньизоляциитранзакций хешфункция частидаты", me = "comобъект ftpсоединение httpзапрос httpсервисответ httpсоединение wsопределения wsпрокси xbase анализданных аннотацияxs блокировкаданных буфердвоичныхданных включениеxs выражениекомпоновкиданных генераторслучайныхчисел географическаясхема географическиекоординаты графическаясхема группамоделиxs данныерасшифровкикомпоновкиданных двоичныеданные дендрограмма диаграмма диаграммаганта диалогвыборафайла диалогвыборацвета диалогвыборашрифта диалограсписаниярегламентногозадания диалогредактированиястандартногопериода диапазон документdom документhtml документацияxs доставляемоеуведомление записьdom записьfastinfoset записьhtml записьjson записьxml записьzipфайла записьданных записьтекста записьузловdom запрос защищенноесоединениеopenssl значенияполейрасшифровкикомпоновкиданных извлечениетекста импортxs интернетпочта интернетпочтовоесообщение интернетпочтовыйпрофиль интернетпрокси интернетсоединение информациядляприложенияxs использованиеатрибутаxs использованиесобытияжурналарегистрации источникдоступныхнастроеккомпоновкиданных итераторузловdom картинка квалификаторыдаты квалификаторыдвоичныхданных квалификаторыстроки квалификаторычисла компоновщикмакетакомпоновкиданных компоновщикнастроеккомпоновкиданных конструктормакетаоформлениякомпоновкиданных конструкторнастроеккомпоновкиданных конструкторформатнойстроки линия макеткомпоновкиданных макетобластикомпоновкиданных макетоформлениякомпоновкиданных маскаxs менеджеркриптографии наборсхемxml настройкикомпоновкиданных настройкисериализацииjson обработкакартинок обработкарасшифровкикомпоновкиданных обходдереваdom объявлениеатрибутаxs объявлениенотацииxs объявлениеэлементаxs описаниеиспользованиясобытиядоступжурналарегистрации описаниеиспользованиясобытияотказвдоступежурналарегистрации описаниеобработкирасшифровкикомпоновкиданных описаниепередаваемогофайла описаниетипов определениегруппыатрибутовxs определениегруппымоделиxs определениеограниченияидентичностиxs определениепростоготипаxs определениесоставноготипаxs определениетипадокументаdom определенияxpathxs отборкомпоновкиданных пакетотображаемыхдокументов параметрвыбора параметркомпоновкиданных параметрызаписиjson параметрызаписиxml параметрычтенияxml переопределениеxs планировщик полеанализаданных полекомпоновкиданных построительdom построительзапроса построительотчета построительотчетаанализаданных построительсхемxml поток потоквпамяти почта почтовоесообщение преобразованиеxsl преобразованиекканоническомуxml процессорвыводарезультатакомпоновкиданныхвколлекциюзначений процессорвыводарезультатакомпоновкиданныхвтабличныйдокумент процессоркомпоновкиданных разыменовательпространствименdom рамка расписаниерегламентногозадания расширенноеимяxml результатчтенияданных своднаядиаграмма связьпараметравыбора связьпотипу связьпотипукомпоновкиданных сериализаторxdto сертификатклиентаwindows сертификатклиентафайл сертификаткриптографии сертификатыудостоверяющихцентровwindows сертификатыудостоверяющихцентровфайл сжатиеданных системнаяинформация сообщениепользователю сочетаниеклавиш сравнениезначений стандартнаядатаначала стандартныйпериод схемаxml схемакомпоновкиданных табличныйдокумент текстовыйдокумент тестируемоеприложение типданныхxml уникальныйидентификатор фабрикаxdto файл файловыйпоток фасетдлиныxs фасетколичестваразрядовдробнойчастиxs фасетмаксимальноговключающегозначенияxs фасетмаксимальногоисключающегозначенияxs фасетмаксимальнойдлиныxs фасетминимальноговключающегозначенияxs фасетминимальногоисключающегозначенияxs фасетминимальнойдлиныxs фасетобразцаxs фасетобщегоколичестваразрядовxs фасетперечисленияxs фасетпробельныхсимволовxs фильтрузловdom форматированнаястрока форматированныйдокумент фрагментxs хешированиеданных хранилищезначения цвет чтениеfastinfoset чтениеhtml чтениеjson чтениеxml чтениеzipфайла чтениеданных чтениетекста чтениеузловdom шрифт элементрезультатакомпоновкиданных " + "comsafearray деревозначений массив соответствие списокзначений структура таблицазначений фиксированнаяструктура фиксированноесоответствие фиксированныймассив ", Me = "null истина ложь неопределено", ke = t.inherit(t.NUMBER_MODE), tt = {
    className: "string",
    begin: '"|\\|',
    end: '"|$',
    contains: [{ begin: '""' }]
  }, Ke = {
    begin: "'",
    end: "'",
    excludeBegin: !0,
    excludeEnd: !0,
    contains: [
      {
        className: "number",
        begin: "\\d{4}([\\.\\\\/:-]?\\d{2}){0,5}"
      }
    ]
  }, Ue = {
    match: /[;()+\-:=,]/,
    className: "punctuation",
    relevance: 0
  }, ye = t.inherit(t.C_LINE_COMMENT_MODE), Fe = {
    className: "meta",
    begin: "#|&",
    end: "$",
    keywords: {
      $pattern: e,
      keyword: r + o
    },
    contains: [ye]
  }, Ce = {
    className: "symbol",
    begin: "~",
    end: ";|:",
    excludeEnd: !0
  }, Ee = {
    className: "function",
    variants: [
      {
        begin: "процедура|функция",
        end: "\\)",
        keywords: "процедура функция"
      },
      {
        begin: "конецпроцедуры|конецфункции",
        keywords: "конецпроцедуры конецфункции"
      }
    ],
    contains: [
      {
        begin: "\\(",
        end: "\\)",
        endsParent: !0,
        contains: [
          {
            className: "params",
            begin: e,
            end: ",",
            excludeEnd: !0,
            endsWithParent: !0,
            keywords: {
              $pattern: e,
              keyword: "знач",
              literal: Me
            },
            contains: [
              ke,
              tt,
              Ke
            ]
          },
          ye
        ]
      },
      t.inherit(t.TITLE_MODE, { begin: e })
    ]
  };
  return {
    name: "1C:Enterprise",
    case_insensitive: !0,
    keywords: {
      $pattern: e,
      keyword: r,
      built_in: _,
      class: Z,
      type: me,
      literal: Me
    },
    contains: [
      Fe,
      Ee,
      ye,
      Ce,
      ke,
      tt,
      Ke,
      Ue
    ]
  };
}
function Em(t) {
  const e = t.regex, n = /^[a-zA-Z][a-zA-Z0-9-]*/, i = [
    "ALPHA",
    "BIT",
    "CHAR",
    "CR",
    "CRLF",
    "CTL",
    "DIGIT",
    "DQUOTE",
    "HEXDIG",
    "HTAB",
    "LF",
    "LWSP",
    "OCTET",
    "SP",
    "VCHAR",
    "WSP"
  ], r = t.COMMENT(/;/, /$/), a = {
    scope: "symbol",
    match: /%b[0-1]+(-[0-1]+|(\.[0-1]+)+)?/
  }, s = {
    scope: "symbol",
    match: /%d[0-9]+(-[0-9]+|(\.[0-9]+)+)?/
  }, o = {
    scope: "symbol",
    match: /%x[0-9A-F]+(-[0-9A-F]+|(\.[0-9A-F]+)+)?/
  }, l = {
    scope: "symbol",
    match: /%[si](?=".*")/
  }, c = {
    scope: "attribute",
    match: e.concat(n, /(?=\s*=)/)
  };
  return {
    name: "Augmented Backus-Naur Form",
    illegal: /[!@#$^&',?+~`|:]/,
    keywords: i,
    contains: [
      {
        scope: "operator",
        match: /=\/?/
      },
      c,
      r,
      a,
      s,
      o,
      l,
      t.QUOTE_STRING_MODE,
      t.NUMBER_MODE
    ]
  };
}
function gm(t) {
  const e = t.regex, n = [
    "GET",
    "POST",
    "HEAD",
    "PUT",
    "DELETE",
    "CONNECT",
    "OPTIONS",
    "PATCH",
    "TRACE"
  ];
  return {
    name: "Apache Access Log",
    contains: [
      // IP
      {
        className: "number",
        begin: /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}(:\d{1,5})?\b/,
        relevance: 5
      },
      // Other numbers
      {
        className: "number",
        begin: /\b\d+\b/,
        relevance: 0
      },
      // Requests
      {
        className: "string",
        begin: e.concat(/"/, e.either(...n)),
        end: /"/,
        keywords: n,
        illegal: /\n/,
        relevance: 5,
        contains: [
          {
            begin: /HTTP\/[12]\.\d'/,
            relevance: 5
          }
        ]
      },
      // Dates
      {
        className: "string",
        // dates must have a certain length, this prevents matching
        // simple array accesses a[123] and [] and other common patterns
        // found in other languages
        begin: /\[\d[^\]\n]{8,}\]/,
        illegal: /\n/,
        relevance: 1
      },
      {
        className: "string",
        begin: /\[/,
        end: /\]/,
        illegal: /\n/,
        relevance: 0
      },
      // User agent / relevance boost
      {
        className: "string",
        begin: /"Mozilla\/\d\.\d \(/,
        end: /"/,
        illegal: /\n/,
        relevance: 3
      },
      // Strings
      {
        className: "string",
        begin: /"/,
        end: /"/,
        illegal: /\n/,
        relevance: 0
      }
    ]
  };
}
function Sm(t) {
  const e = t.regex, n = /[a-zA-Z_$][a-zA-Z0-9_$]*/, i = e.concat(
    n,
    e.concat("(\\.", n, ")*")
  ), r = /([*]|[a-zA-Z_$][a-zA-Z0-9_$]*)/, a = {
    className: "rest_arg",
    begin: /[.]{3}/,
    end: n,
    relevance: 10
  };
  return {
    name: "ActionScript",
    aliases: ["as"],
    keywords: {
      keyword: [
        "as",
        "break",
        "case",
        "catch",
        "class",
        "const",
        "continue",
        "default",
        "delete",
        "do",
        "dynamic",
        "each",
        "else",
        "extends",
        "final",
        "finally",
        "for",
        "function",
        "get",
        "if",
        "implements",
        "import",
        "in",
        "include",
        "instanceof",
        "interface",
        "internal",
        "is",
        "namespace",
        "native",
        "new",
        "override",
        "package",
        "private",
        "protected",
        "public",
        "return",
        "set",
        "static",
        "super",
        "switch",
        "this",
        "throw",
        "try",
        "typeof",
        "use",
        "var",
        "void",
        "while",
        "with"
      ],
      literal: [
        "true",
        "false",
        "null",
        "undefined"
      ]
    },
    contains: [
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE,
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      t.C_NUMBER_MODE,
      {
        match: [
          /\bpackage/,
          /\s+/,
          i
        ],
        className: {
          1: "keyword",
          3: "title.class"
        }
      },
      {
        match: [
          /\b(?:class|interface|extends|implements)/,
          /\s+/,
          n
        ],
        className: {
          1: "keyword",
          3: "title.class"
        }
      },
      {
        className: "meta",
        beginKeywords: "import include",
        end: /;/,
        keywords: { keyword: "import include" }
      },
      {
        beginKeywords: "function",
        end: /[{;]/,
        excludeEnd: !0,
        illegal: /\S/,
        contains: [
          t.inherit(t.TITLE_MODE, { className: "title.function" }),
          {
            className: "params",
            begin: /\(/,
            end: /\)/,
            contains: [
              t.APOS_STRING_MODE,
              t.QUOTE_STRING_MODE,
              t.C_LINE_COMMENT_MODE,
              t.C_BLOCK_COMMENT_MODE,
              a
            ]
          },
          { begin: e.concat(/:\s*/, r) }
        ]
      },
      t.METHOD_GUARD
    ],
    illegal: /#/
  };
}
function hm(t) {
  const e = "\\d(_|\\d)*", n = "[eE][-+]?" + e, i = e + "(\\." + e + ")?(" + n + ")?", r = "\\w+", s = "\\b(" + (e + "#" + r + "(\\." + r + ")?#(" + n + ")?") + "|" + i + ")", o = "[A-Za-z](_?[A-Za-z0-9.])*", l = `[]\\{\\}%#'"`, c = t.COMMENT("--", "$"), d = {
    // TODO: These spaces are not required by the Ada syntax
    // however, I have yet to see handwritten Ada code where
    // someone does not put spaces around :
    begin: "\\s+:\\s+",
    end: "\\s*(:=|;|\\)|=>|$)",
    // endsWithParent: true,
    // returnBegin: true,
    illegal: l,
    contains: [
      {
        // workaround to avoid highlighting
        // named loops and declare blocks
        beginKeywords: "loop for declare others",
        endsParent: !0
      },
      {
        // properly highlight all modifiers
        className: "keyword",
        beginKeywords: "not null constant access function procedure in out aliased exception"
      },
      {
        className: "type",
        begin: o,
        endsParent: !0,
        relevance: 0
      }
    ]
  };
  return {
    name: "Ada",
    case_insensitive: !0,
    keywords: {
      keyword: [
        "abort",
        "else",
        "new",
        "return",
        "abs",
        "elsif",
        "not",
        "reverse",
        "abstract",
        "end",
        "accept",
        "entry",
        "select",
        "access",
        "exception",
        "of",
        "separate",
        "aliased",
        "exit",
        "or",
        "some",
        "all",
        "others",
        "subtype",
        "and",
        "for",
        "out",
        "synchronized",
        "array",
        "function",
        "overriding",
        "at",
        "tagged",
        "generic",
        "package",
        "task",
        "begin",
        "goto",
        "pragma",
        "terminate",
        "body",
        "private",
        "then",
        "if",
        "procedure",
        "type",
        "case",
        "in",
        "protected",
        "constant",
        "interface",
        "is",
        "raise",
        "use",
        "declare",
        "range",
        "delay",
        "limited",
        "record",
        "when",
        "delta",
        "loop",
        "rem",
        "while",
        "digits",
        "renames",
        "with",
        "do",
        "mod",
        "requeue",
        "xor"
      ],
      literal: [
        "True",
        "False"
      ]
    },
    contains: [
      c,
      // strings "foobar"
      {
        className: "string",
        begin: /"/,
        end: /"/,
        contains: [
          {
            begin: /""/,
            relevance: 0
          }
        ]
      },
      // characters ''
      {
        // character literals always contain one char
        className: "string",
        begin: /'.'/
      },
      {
        // number literals
        className: "number",
        begin: s,
        relevance: 0
      },
      {
        // Attributes
        className: "symbol",
        begin: "'" + o
      },
      {
        // package definition, maybe inside generic
        className: "title",
        begin: "(\\bwith\\s+)?(\\bprivate\\s+)?\\bpackage\\s+(\\bbody\\s+)?",
        end: "(is|$)",
        keywords: "package body",
        excludeBegin: !0,
        excludeEnd: !0,
        illegal: l
      },
      {
        // function/procedure declaration/definition
        // maybe inside generic
        begin: "(\\b(with|overriding)\\s+)?\\b(function|procedure)\\s+",
        end: "(\\bis|\\bwith|\\brenames|\\)\\s*;)",
        keywords: "overriding function procedure with is renames return",
        // we need to re-match the 'function' keyword, so that
        // the title mode below matches only exactly once
        returnBegin: !0,
        contains: [
          c,
          {
            // name of the function/procedure
            className: "title",
            begin: "(\\bwith\\s+)?\\b(function|procedure)\\s+",
            end: "(\\(|\\s+|$)",
            excludeBegin: !0,
            excludeEnd: !0,
            illegal: l
          },
          // 'self'
          // // parameter types
          d,
          {
            // return type
            className: "type",
            begin: "\\breturn\\s+",
            end: "(\\s+|;|$)",
            keywords: "return",
            excludeBegin: !0,
            excludeEnd: !0,
            // we are done with functions
            endsParent: !0,
            illegal: l
          }
        ]
      },
      {
        // new type declarations
        // maybe inside generic
        className: "type",
        begin: "\\b(sub)?type\\s+",
        end: "\\s+",
        keywords: "type",
        excludeBegin: !0,
        illegal: l
      },
      // see comment above the definition
      d
      // no markup
      // relevance boosters for small snippets
      // {begin: '\\s*=>\\s*'},
      // {begin: '\\s*:=\\s*'},
      // {begin: '\\s+:=\\s+'},
    ]
  };
}
function fm(t) {
  const e = {
    className: "built_in",
    begin: "\\b(void|bool|int8|int16|int32|int64|int|uint8|uint16|uint32|uint64|uint|string|ref|array|double|float|auto|dictionary)"
  }, n = {
    className: "symbol",
    begin: "[a-zA-Z0-9_]+@"
  }, i = {
    className: "keyword",
    begin: "<",
    end: ">",
    contains: [
      e,
      n
    ]
  };
  return e.contains = [i], n.contains = [i], {
    name: "AngelScript",
    aliases: ["asc"],
    keywords: [
      "for",
      "in|0",
      "break",
      "continue",
      "while",
      "do|0",
      "return",
      "if",
      "else",
      "case",
      "switch",
      "namespace",
      "is",
      "cast",
      "or",
      "and",
      "xor",
      "not",
      "get|0",
      "in",
      "inout|10",
      "out",
      "override",
      "set|0",
      "private",
      "public",
      "const",
      "default|0",
      "final",
      "shared",
      "external",
      "mixin|10",
      "enum",
      "typedef",
      "funcdef",
      "this",
      "super",
      "import",
      "from",
      "interface",
      "abstract|0",
      "try",
      "catch",
      "protected",
      "explicit",
      "property"
    ],
    // avoid close detection with C# and JS
    illegal: "(^using\\s+[A-Za-z0-9_\\.]+;$|\\bfunction\\s*[^\\(])",
    contains: [
      {
        // 'strings'
        className: "string",
        begin: "'",
        end: "'",
        illegal: "\\n",
        contains: [t.BACKSLASH_ESCAPE],
        relevance: 0
      },
      // """heredoc strings"""
      {
        className: "string",
        begin: '"""',
        end: '"""'
      },
      {
        // "strings"
        className: "string",
        begin: '"',
        end: '"',
        illegal: "\\n",
        contains: [t.BACKSLASH_ESCAPE],
        relevance: 0
      },
      t.C_LINE_COMMENT_MODE,
      // single-line comments
      t.C_BLOCK_COMMENT_MODE,
      // comment blocks
      {
        // metadata
        className: "string",
        begin: "^\\s*\\[",
        end: "\\]"
      },
      {
        // interface or namespace declaration
        beginKeywords: "interface namespace",
        end: /\{/,
        illegal: "[;.\\-]",
        contains: [
          {
            // interface or namespace name
            className: "symbol",
            begin: "[a-zA-Z0-9_]+"
          }
        ]
      },
      {
        // class declaration
        beginKeywords: "class",
        end: /\{/,
        illegal: "[;.\\-]",
        contains: [
          {
            // class name
            className: "symbol",
            begin: "[a-zA-Z0-9_]+",
            contains: [
              {
                begin: "[:,]\\s*",
                contains: [
                  {
                    className: "symbol",
                    begin: "[a-zA-Z0-9_]+"
                  }
                ]
              }
            ]
          }
        ]
      },
      e,
      // built-in types
      n,
      // object handles
      {
        // literals
        className: "literal",
        begin: "\\b(null|true|false)"
      },
      {
        // numbers
        className: "number",
        relevance: 0,
        begin: "(-?)(\\b0[xXbBoOdD][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?f?|\\.\\d+f?)([eE][-+]?\\d+f?)?)"
      }
    ]
  };
}
function Tm(t) {
  const e = {
    className: "number",
    begin: /[$%]\d+/
  }, n = {
    className: "number",
    begin: /\b\d+/
  }, i = {
    className: "number",
    begin: /\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}(:\d{1,5})?/
  }, r = {
    className: "number",
    begin: /:\d{1,5}/
  };
  return {
    name: "Apache config",
    aliases: ["apacheconf"],
    case_insensitive: !0,
    contains: [
      t.HASH_COMMENT_MODE,
      {
        className: "section",
        begin: /<\/?/,
        end: />/,
        contains: [
          i,
          r,
          // low relevance prevents us from claming XML/HTML where this rule would
          // match strings inside of XML tags
          t.inherit(t.QUOTE_STRING_MODE, { relevance: 0 })
        ]
      },
      {
        className: "attribute",
        begin: /\w+/,
        relevance: 0,
        // keywords aren’t needed for highlighting per se, they only boost relevance
        // for a very generally defined mode (starts with a word, ends with line-end
        keywords: { _: [
          "order",
          "deny",
          "allow",
          "setenv",
          "rewriterule",
          "rewriteengine",
          "rewritecond",
          "documentroot",
          "sethandler",
          "errordocument",
          "loadmodule",
          "options",
          "header",
          "listen",
          "serverroot",
          "servername"
        ] },
        starts: {
          end: /$/,
          relevance: 0,
          keywords: { literal: "on off all deny allow" },
          contains: [
            {
              scope: "punctuation",
              match: /\\\n/
            },
            {
              className: "meta",
              begin: /\s\[/,
              end: /\]$/
            },
            {
              className: "variable",
              begin: /[\$%]\{/,
              end: /\}/,
              contains: [
                "self",
                e
              ]
            },
            i,
            n,
            t.QUOTE_STRING_MODE
          ]
        }
      }
    ],
    illegal: /\S/
  };
}
function bm(t) {
  const e = t.regex, n = t.inherit(
    t.QUOTE_STRING_MODE,
    { illegal: null }
  ), i = {
    className: "params",
    begin: /\(/,
    end: /\)/,
    contains: [
      "self",
      t.C_NUMBER_MODE,
      n
    ]
  }, r = t.COMMENT(/--/, /$/), a = t.COMMENT(
    /\(\*/,
    /\*\)/,
    { contains: [
      "self",
      // allow nesting
      r
    ] }
  ), s = [
    r,
    a,
    t.HASH_COMMENT_MODE
  ], o = [
    /apart from/,
    /aside from/,
    /instead of/,
    /out of/,
    /greater than/,
    /isn't|(doesn't|does not) (equal|come before|come after|contain)/,
    /(greater|less) than( or equal)?/,
    /(starts?|ends|begins?) with/,
    /contained by/,
    /comes (before|after)/,
    /a (ref|reference)/,
    /POSIX (file|path)/,
    /(date|time) string/,
    /quoted form/
  ], l = [
    /clipboard info/,
    /the clipboard/,
    /info for/,
    /list (disks|folder)/,
    /mount volume/,
    /path to/,
    /(close|open for) access/,
    /(get|set) eof/,
    /current date/,
    /do shell script/,
    /get volume settings/,
    /random number/,
    /set volume/,
    /system attribute/,
    /system info/,
    /time to GMT/,
    /(load|run|store) script/,
    /scripting components/,
    /ASCII (character|number)/,
    /localized string/,
    /choose (application|color|file|file name|folder|from list|remote application|URL)/,
    /display (alert|dialog)/
  ];
  return {
    name: "AppleScript",
    aliases: ["osascript"],
    keywords: {
      keyword: "about above after against and around as at back before beginning behind below beneath beside between but by considering contain contains continue copy div does eighth else end equal equals error every exit fifth first for fourth from front get given global if ignoring in into is it its last local me middle mod my ninth not of on onto or over prop property put ref reference repeat returning script second set seventh since sixth some tell tenth that the|0 then third through thru timeout times to transaction try until where while whose with without",
      literal: "AppleScript false linefeed return pi quote result space tab true",
      built_in: "alias application boolean class constant date file integer list number real record string text activate beep count delay launch log offset read round run say summarize write character characters contents day frontmost id item length month name|0 paragraph paragraphs rest reverse running time version weekday word words year"
    },
    contains: [
      n,
      t.C_NUMBER_MODE,
      {
        className: "built_in",
        begin: e.concat(
          /\b/,
          e.either(...l),
          /\b/
        )
      },
      {
        className: "built_in",
        begin: /^\s*return\b/
      },
      {
        className: "literal",
        begin: /\b(text item delimiters|current application|missing value)\b/
      },
      {
        className: "keyword",
        begin: e.concat(
          /\b/,
          e.either(...o),
          /\b/
        )
      },
      {
        beginKeywords: "on",
        illegal: /[${=;\n]/,
        contains: [
          t.UNDERSCORE_TITLE_MODE,
          i
        ]
      },
      ...s
    ],
    illegal: /\/\/|->|=>|\[\[/
  };
}
function Cm(t) {
  const e = t.regex, n = "[A-Za-z_][0-9A-Za-z_]*", i = {
    keyword: [
      "break",
      "case",
      "catch",
      "continue",
      "debugger",
      "do",
      "else",
      "export",
      "for",
      "function",
      "if",
      "import",
      "in",
      "new",
      "of",
      "return",
      "switch",
      "try",
      "var",
      "void",
      "while"
    ],
    literal: [
      "BackSlash",
      "DoubleQuote",
      "ForwardSlash",
      "Infinity",
      "NaN",
      "NewLine",
      "PI",
      "SingleQuote",
      "Tab",
      "TextFormatting",
      "false",
      "null",
      "true",
      "undefined"
    ],
    built_in: [
      "Abs",
      "Acos",
      "All",
      "Angle",
      "Any",
      "Area",
      "AreaGeodetic",
      "Array",
      "Asin",
      "Atan",
      "Atan2",
      "Attachments",
      "Average",
      "Back",
      "Bearing",
      "Boolean",
      "Buffer",
      "BufferGeodetic",
      "Ceil",
      "Centroid",
      "ChangeTimeZone",
      "Clip",
      "Concatenate",
      "Console",
      "Constrain",
      "Contains",
      "ConvertDirection",
      "ConvexHull",
      "Cos",
      "Count",
      "Crosses",
      "Cut",
      "Date|0",
      "DateAdd",
      "DateDiff",
      "DateOnly",
      "Day",
      "Decode",
      "DefaultValue",
      "Densify",
      "DensifyGeodetic",
      "Dictionary",
      "Difference",
      "Disjoint",
      "Distance",
      "DistanceGeodetic",
      "DistanceToCoordinate",
      "Distinct",
      "Domain",
      "DomainCode",
      "DomainName",
      "EnvelopeIntersects",
      "Equals",
      "Erase",
      "Exp",
      "Expects",
      "Extent",
      "Feature",
      "FeatureInFilter",
      "FeatureSet",
      "FeatureSetByAssociation",
      "FeatureSetById",
      "FeatureSetByName",
      "FeatureSetByPortalItem",
      "FeatureSetByRelationshipClass",
      "FeatureSetByRelationshipName",
      "Filter",
      "FilterBySubtypeCode",
      "Find",
      "First|0",
      "Floor",
      "FromCharCode",
      "FromCodePoint",
      "FromJSON",
      "Front",
      "GdbVersion",
      "Generalize",
      "Geometry",
      "GetEnvironment",
      "GetFeatureSet",
      "GetFeatureSetInfo",
      "GetUser",
      "GroupBy",
      "Guid",
      "HasKey",
      "HasValue",
      "Hash",
      "Hour",
      "IIf",
      "ISOMonth",
      "ISOWeek",
      "ISOWeekday",
      "ISOYear",
      "Includes",
      "IndexOf",
      "Insert",
      "Intersection",
      "Intersects",
      "IsEmpty",
      "IsNan",
      "IsSelfIntersecting",
      "IsSimple",
      "KnowledgeGraphByPortalItem",
      "Left|0",
      "Length",
      "Length3D",
      "LengthGeodetic",
      "Log",
      "Lower",
      "Map",
      "Max",
      "Mean",
      "MeasureToCoordinate",
      "Mid",
      "Millisecond",
      "Min",
      "Minute",
      "Month",
      "MultiPartToSinglePart",
      "Multipoint",
      "NearestCoordinate",
      "NearestVertex",
      "NextSequenceValue",
      "None",
      "Now",
      "Number",
      "Offset",
      "OrderBy",
      "Overlaps",
      "Point",
      "PointToCoordinate",
      "Polygon",
      "Polyline",
      "Pop",
      "Portal",
      "Pow",
      "Proper",
      "Push",
      "QueryGraph",
      "Random",
      "Reduce",
      "Relate",
      "Replace",
      "Resize",
      "Reverse",
      "Right|0",
      "RingIsClockwise",
      "Rotate",
      "Round",
      "Schema",
      "Second",
      "SetGeometry",
      "Simplify",
      "Sin",
      "Slice",
      "Sort",
      "Splice",
      "Split",
      "Sqrt",
      "StandardizeFilename",
      "StandardizeGuid",
      "Stdev",
      "SubtypeCode",
      "SubtypeName",
      "Subtypes",
      "Sum",
      "SymmetricDifference",
      "Tan",
      "Text",
      "Time",
      "TimeZone",
      "TimeZoneOffset",
      "Timestamp",
      "ToCharCode",
      "ToCodePoint",
      "ToHex",
      "ToLocal",
      "ToUTC",
      "Today",
      "Top|0",
      "Touches",
      "TrackAccelerationAt",
      "TrackAccelerationWindow",
      "TrackCurrentAcceleration",
      "TrackCurrentDistance",
      "TrackCurrentSpeed",
      "TrackCurrentTime",
      "TrackDistanceAt",
      "TrackDistanceWindow",
      "TrackDuration",
      "TrackFieldWindow",
      "TrackGeometryWindow",
      "TrackIndex",
      "TrackSpeedAt",
      "TrackSpeedWindow",
      "TrackStartTime",
      "TrackWindow",
      "Trim",
      "TypeOf",
      "Union",
      "Upper",
      "UrlEncode",
      "Variance",
      "Week",
      "Weekday",
      "When|0",
      "Within",
      "Year|0"
    ]
  }, r = [
    "aggregatedFeatures",
    "analytic",
    "config",
    "datapoint",
    "datastore",
    "editcontext",
    "feature",
    "featureSet",
    "feedfeature",
    "fencefeature",
    "fencenotificationtype",
    "graph",
    "join",
    "layer",
    "locationupdate",
    "map",
    "measure",
    "measure",
    "originalFeature",
    "record",
    "reference",
    "rowindex",
    "sourcedatastore",
    "sourcefeature",
    "sourcelayer",
    "target",
    "targetdatastore",
    "targetfeature",
    "targetlayer",
    "userInput",
    "value",
    "variables",
    "view"
  ], a = {
    className: "symbol",
    begin: "\\$" + e.either(...r)
  }, s = {
    className: "number",
    variants: [
      { begin: "\\b(0[bB][01]+)" },
      { begin: "\\b(0[oO][0-7]+)" },
      { begin: t.C_NUMBER_RE }
    ],
    relevance: 0
  }, o = {
    className: "subst",
    begin: "\\$\\{",
    end: "\\}",
    keywords: i,
    contains: []
    // defined later
  }, l = {
    className: "string",
    begin: "`",
    end: "`",
    contains: [
      t.BACKSLASH_ESCAPE,
      o
    ]
  };
  o.contains = [
    t.APOS_STRING_MODE,
    t.QUOTE_STRING_MODE,
    l,
    s,
    t.REGEXP_MODE
  ];
  const c = o.contains.concat([
    t.C_BLOCK_COMMENT_MODE,
    t.C_LINE_COMMENT_MODE
  ]);
  return {
    name: "ArcGIS Arcade",
    case_insensitive: !0,
    keywords: i,
    contains: [
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE,
      l,
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      a,
      s,
      {
        // object attr container
        begin: /[{,]\s*/,
        relevance: 0,
        contains: [
          {
            begin: n + "\\s*:",
            returnBegin: !0,
            relevance: 0,
            contains: [
              {
                className: "attr",
                begin: n,
                relevance: 0
              }
            ]
          }
        ]
      },
      {
        // "value" container
        begin: "(" + t.RE_STARTERS_RE + "|\\b(return)\\b)\\s*",
        keywords: "return",
        contains: [
          t.C_LINE_COMMENT_MODE,
          t.C_BLOCK_COMMENT_MODE,
          t.REGEXP_MODE,
          {
            className: "function",
            begin: "(\\(.*?\\)|" + n + ")\\s*=>",
            returnBegin: !0,
            end: "\\s*=>",
            contains: [
              {
                className: "params",
                variants: [
                  { begin: n },
                  { begin: /\(\s*\)/ },
                  {
                    begin: /\(/,
                    end: /\)/,
                    excludeBegin: !0,
                    excludeEnd: !0,
                    keywords: i,
                    contains: c
                  }
                ]
              }
            ]
          }
        ],
        relevance: 0
      },
      {
        beginKeywords: "function",
        end: /\{/,
        excludeEnd: !0,
        contains: [
          t.inherit(t.TITLE_MODE, {
            className: "title.function",
            begin: n
          }),
          {
            className: "params",
            begin: /\(/,
            end: /\)/,
            excludeBegin: !0,
            excludeEnd: !0,
            contains: c
          }
        ],
        illegal: /\[|%/
      },
      { begin: /\$[(.]/ }
    ],
    illegal: /#(?!!)/
  };
}
function ym(t) {
  const e = { variants: [
    t.COMMENT("^[ \\t]*(?=#)", "$", {
      relevance: 0,
      excludeBegin: !0
    }),
    t.COMMENT("[;@]", "$", { relevance: 0 }),
    t.C_LINE_COMMENT_MODE,
    t.C_BLOCK_COMMENT_MODE
  ] };
  return {
    name: "ARM Assembly",
    case_insensitive: !0,
    aliases: ["arm"],
    keywords: {
      $pattern: "\\.?" + t.IDENT_RE,
      meta: (
        // GNU preprocs
        ".2byte .4byte .align .ascii .asciz .balign .byte .code .data .else .end .endif .endm .endr .equ .err .exitm .extern .global .hword .if .ifdef .ifndef .include .irp .long .macro .rept .req .section .set .skip .space .text .word .arm .thumb .code16 .code32 .force_thumb .thumb_func .ltorg ALIAS ALIGN ARM AREA ASSERT ATTR CN CODE CODE16 CODE32 COMMON CP DATA DCB DCD DCDU DCDO DCFD DCFDU DCI DCQ DCQU DCW DCWU DN ELIF ELSE END ENDFUNC ENDIF ENDP ENTRY EQU EXPORT EXPORTAS EXTERN FIELD FILL FUNCTION GBLA GBLL GBLS GET GLOBAL IF IMPORT INCBIN INCLUDE INFO KEEP LCLA LCLL LCLS LTORG MACRO MAP MEND MEXIT NOFP OPT PRESERVE8 PROC QN READONLY RELOC REQUIRE REQUIRE8 RLIST FN ROUT SETA SETL SETS SN SPACE SUBT THUMB THUMBX TTL WHILE WEND "
      ),
      built_in: "r0 r1 r2 r3 r4 r5 r6 r7 r8 r9 r10 r11 r12 r13 r14 r15 w0 w1 w2 w3 w4 w5 w6 w7 w8 w9 w10 w11 w12 w13 w14 w15 w16 w17 w18 w19 w20 w21 w22 w23 w24 w25 w26 w27 w28 w29 w30 x0 x1 x2 x3 x4 x5 x6 x7 x8 x9 x10 x11 x12 x13 x14 x15 x16 x17 x18 x19 x20 x21 x22 x23 x24 x25 x26 x27 x28 x29 x30 pc lr sp ip sl sb fp a1 a2 a3 a4 v1 v2 v3 v4 v5 v6 v7 v8 f0 f1 f2 f3 f4 f5 f6 f7 p0 p1 p2 p3 p4 p5 p6 p7 p8 p9 p10 p11 p12 p13 p14 p15 c0 c1 c2 c3 c4 c5 c6 c7 c8 c9 c10 c11 c12 c13 c14 c15 q0 q1 q2 q3 q4 q5 q6 q7 q8 q9 q10 q11 q12 q13 q14 q15 cpsr_c cpsr_x cpsr_s cpsr_f cpsr_cx cpsr_cxs cpsr_xs cpsr_xsf cpsr_sf cpsr_cxsf spsr_c spsr_x spsr_s spsr_f spsr_cx spsr_cxs spsr_xs spsr_xsf spsr_sf spsr_cxsf s0 s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 d0 d1 d2 d3 d4 d5 d6 d7 d8 d9 d10 d11 d12 d13 d14 d15 d16 d17 d18 d19 d20 d21 d22 d23 d24 d25 d26 d27 d28 d29 d30 d31 {PC} {VAR} {TRUE} {FALSE} {OPT} {CONFIG} {ENDIAN} {CODESIZE} {CPU} {FPU} {ARCHITECTURE} {PCSTOREOFFSET} {ARMASM_VERSION} {INTER} {ROPI} {RWPI} {SWST} {NOSWST} . @"
    },
    contains: [
      {
        className: "keyword",
        begin: "\\b(adc|(qd?|sh?|u[qh]?)?add(8|16)?|usada?8|(q|sh?|u[qh]?)?(as|sa)x|and|adrl?|sbc|rs[bc]|asr|b[lx]?|blx|bxj|cbn?z|tb[bh]|bic|bfc|bfi|[su]bfx|bkpt|cdp2?|clz|clrex|cmp|cmn|cpsi[ed]|cps|setend|dbg|dmb|dsb|eor|isb|it[te]{0,3}|lsl|lsr|ror|rrx|ldm(([id][ab])|f[ds])?|ldr((s|ex)?[bhd])?|movt?|mvn|mra|mar|mul|[us]mull|smul[bwt][bt]|smu[as]d|smmul|smmla|mla|umlaal|smlal?([wbt][bt]|d)|mls|smlsl?[ds]|smc|svc|sev|mia([bt]{2}|ph)?|mrr?c2?|mcrr2?|mrs|msr|orr|orn|pkh(tb|bt)|rbit|rev(16|sh)?|sel|[su]sat(16)?|nop|pop|push|rfe([id][ab])?|stm([id][ab])?|str(ex)?[bhd]?|(qd?)?sub|(sh?|q|u[qh]?)?sub(8|16)|[su]xt(a?h|a?b(16)?)|srs([id][ab])?|swpb?|swi|smi|tst|teq|wfe|wfi|yield)(eq|ne|cs|cc|mi|pl|vs|vc|hi|ls|ge|lt|gt|le|al|hs|lo)?[sptrx]?(?=\\s)"
        // followed by space
      },
      e,
      t.QUOTE_STRING_MODE,
      {
        className: "string",
        begin: "'",
        end: "[^\\\\]'",
        relevance: 0
      },
      {
        className: "title",
        begin: "\\|",
        end: "\\|",
        illegal: "\\n",
        relevance: 0
      },
      {
        className: "number",
        variants: [
          {
            // hex
            begin: "[#$=]?0x[0-9a-f]+"
          },
          {
            // bin
            begin: "[#$=]?0b[01]+"
          },
          {
            // literal
            begin: "[#$=]\\d+"
          },
          {
            // bare number
            begin: "\\b\\d+"
          }
        ],
        relevance: 0
      },
      {
        className: "symbol",
        variants: [
          {
            // GNU ARM syntax
            begin: "^[ \\t]*[a-z_\\.\\$][a-z0-9_\\.\\$]+:"
          },
          {
            // ARM syntax
            begin: "^[a-z_\\.\\$][a-z0-9_\\.\\$]+"
          },
          {
            // label reference
            begin: "[=#]\\w+"
          }
        ],
        relevance: 0
      }
    ]
  };
}
function Rm(t) {
  const e = t.regex, n = {
    begin: "^'{3,}[ \\t]*$",
    relevance: 10
  }, i = [
    // escaped constrained formatting marks (i.e., \* \_ or \`)
    { begin: /\\[*_`]/ },
    // escaped unconstrained formatting marks (i.e., \\** \\__ or \\``)
    // must ignore until the next formatting marks
    // this rule might not be 100% compliant with Asciidoctor 2.0 but we are entering undefined behavior territory...
    { begin: /\\\\\*{2}[^\n]*?\*{2}/ },
    { begin: /\\\\_{2}[^\n]*_{2}/ },
    { begin: /\\\\`{2}[^\n]*`{2}/ },
    // guard: constrained formatting mark may not be preceded by ":", ";" or
    // "}". match these so the constrained rule doesn't see them
    { begin: /[:;}][*_`](?![*_`])/ }
  ], r = [
    // inline unconstrained strong (single line)
    {
      className: "strong",
      begin: /\*{2}([^\n]+?)\*{2}/
    },
    // inline unconstrained strong (multi-line)
    {
      className: "strong",
      begin: e.concat(
        /\*\*/,
        /((\*(?!\*)|\\[^\n]|[^*\n\\])+\n)+/,
        /(\*(?!\*)|\\[^\n]|[^*\n\\])*/,
        /\*\*/
      ),
      relevance: 0
    },
    // inline constrained strong (single line)
    {
      className: "strong",
      // must not precede or follow a word character
      begin: /\B\*(\S|\S[^\n]*?\S)\*(?!\w)/
    },
    // inline constrained strong (multi-line)
    {
      className: "strong",
      // must not precede or follow a word character
      begin: /\*[^\s]([^\n]+\n)+([^\n]+)\*/
    }
  ], a = [
    // inline unconstrained emphasis (single line)
    {
      className: "emphasis",
      begin: /_{2}([^\n]+?)_{2}/
    },
    // inline unconstrained emphasis (multi-line)
    {
      className: "emphasis",
      begin: e.concat(
        /__/,
        /((_(?!_)|\\[^\n]|[^_\n\\])+\n)+/,
        /(_(?!_)|\\[^\n]|[^_\n\\])*/,
        /__/
      ),
      relevance: 0
    },
    // inline constrained emphasis (single line)
    {
      className: "emphasis",
      // must not precede or follow a word character
      begin: /\b_(\S|\S[^\n]*?\S)_(?!\w)/
    },
    // inline constrained emphasis (multi-line)
    {
      className: "emphasis",
      // must not precede or follow a word character
      begin: /_[^\s]([^\n]+\n)+([^\n]+)_/
    },
    // inline constrained emphasis using single quote (legacy)
    {
      className: "emphasis",
      // must not follow a word character or be followed by a single quote or space
      begin: "\\B'(?!['\\s])",
      end: "(\\n{2}|')",
      // allow escaped single quote followed by word char
      contains: [
        {
          begin: "\\\\'\\w",
          relevance: 0
        }
      ],
      relevance: 0
    }
  ], s = {
    className: "symbol",
    begin: "^(NOTE|TIP|IMPORTANT|WARNING|CAUTION):\\s+",
    relevance: 10
  }, o = {
    className: "bullet",
    begin: "^(\\*+|-+|\\.+|[^\\n]+?::)\\s+"
  };
  return {
    name: "AsciiDoc",
    aliases: ["adoc"],
    contains: [
      // block comment
      t.COMMENT(
        "^/{4,}\\n",
        "\\n/{4,}$",
        // can also be done as...
        // '^/{4,}$',
        // '^/{4,}$',
        { relevance: 10 }
      ),
      // line comment
      t.COMMENT(
        "^//",
        "$",
        { relevance: 0 }
      ),
      // title
      {
        className: "title",
        begin: "^\\.\\w.*$"
      },
      // example, admonition & sidebar blocks
      {
        begin: "^[=\\*]{4,}\\n",
        end: "\\n^[=\\*]{4,}$",
        relevance: 10
      },
      // headings
      {
        className: "section",
        relevance: 10,
        variants: [
          { begin: "^(={1,6})[ 	].+?([ 	]\\1)?$" },
          { begin: "^[^\\[\\]\\n]+?\\n[=\\-~\\^\\+]{2,}$" }
        ]
      },
      // document attributes
      {
        className: "meta",
        begin: "^:.+?:",
        end: "\\s",
        excludeEnd: !0,
        relevance: 10
      },
      // block attributes
      {
        className: "meta",
        begin: "^\\[.+?\\]$",
        relevance: 0
      },
      // quoteblocks
      {
        className: "quote",
        begin: "^_{4,}\\n",
        end: "\\n_{4,}$",
        relevance: 10
      },
      // listing and literal blocks
      {
        className: "code",
        begin: "^[\\-\\.]{4,}\\n",
        end: "\\n[\\-\\.]{4,}$",
        relevance: 10
      },
      // passthrough blocks
      {
        begin: "^\\+{4,}\\n",
        end: "\\n\\+{4,}$",
        contains: [
          {
            begin: "<",
            end: ">",
            subLanguage: "xml",
            relevance: 0
          }
        ],
        relevance: 10
      },
      o,
      s,
      ...i,
      ...r,
      ...a,
      // inline smart quotes
      {
        className: "string",
        variants: [
          { begin: "``.+?''" },
          { begin: "`.+?'" }
        ]
      },
      // inline unconstrained emphasis
      {
        className: "code",
        begin: /`{2}/,
        end: /(\n{2}|`{2})/
      },
      // inline code snippets (TODO should get same treatment as strong and emphasis)
      {
        className: "code",
        begin: "(`.+?`|\\+.+?\\+)",
        relevance: 0
      },
      // indented literal block
      {
        className: "code",
        begin: "^[ \\t]",
        end: "$",
        relevance: 0
      },
      n,
      // images and links
      {
        begin: "(link:)?(http|https|ftp|file|irc|image:?):\\S+?\\[[^[]*?\\]",
        returnBegin: !0,
        contains: [
          {
            begin: "(link|image:?):",
            relevance: 0
          },
          {
            className: "link",
            begin: "\\w",
            end: "[^\\[]+",
            relevance: 0
          },
          {
            className: "string",
            begin: "\\[",
            end: "\\]",
            excludeBegin: !0,
            excludeEnd: !0,
            relevance: 0
          }
        ],
        relevance: 10
      }
    ]
  };
}
function Nm(t) {
  const e = t.regex, n = [
    "false",
    "synchronized",
    "int",
    "abstract",
    "float",
    "private",
    "char",
    "boolean",
    "static",
    "null",
    "if",
    "const",
    "for",
    "true",
    "while",
    "long",
    "throw",
    "strictfp",
    "finally",
    "protected",
    "import",
    "native",
    "final",
    "return",
    "void",
    "enum",
    "else",
    "extends",
    "implements",
    "break",
    "transient",
    "new",
    "catch",
    "instanceof",
    "byte",
    "super",
    "volatile",
    "case",
    "assert",
    "short",
    "package",
    "default",
    "double",
    "public",
    "try",
    "this",
    "switch",
    "continue",
    "throws",
    "privileged",
    "aspectOf",
    "adviceexecution",
    "proceed",
    "cflowbelow",
    "cflow",
    "initialization",
    "preinitialization",
    "staticinitialization",
    "withincode",
    "target",
    "within",
    "execution",
    "getWithinTypeName",
    "handler",
    "thisJoinPoint",
    "thisJoinPointStaticPart",
    "thisEnclosingJoinPointStaticPart",
    "declare",
    "parents",
    "warning",
    "error",
    "soft",
    "precedence",
    "thisAspectInstance"
  ], i = [
    "get",
    "set",
    "args",
    "call"
  ];
  return {
    name: "AspectJ",
    keywords: n,
    illegal: /<\/|#/,
    contains: [
      t.COMMENT(
        /\/\*\*/,
        /\*\//,
        {
          relevance: 0,
          contains: [
            {
              // eat up @'s in emails to prevent them to be recognized as doctags
              begin: /\w+@/,
              relevance: 0
            },
            {
              className: "doctag",
              begin: /@[A-Za-z]+/
            }
          ]
        }
      ),
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE,
      {
        className: "class",
        beginKeywords: "aspect",
        end: /[{;=]/,
        excludeEnd: !0,
        illegal: /[:;"\[\]]/,
        contains: [
          { beginKeywords: "extends implements pertypewithin perthis pertarget percflowbelow percflow issingleton" },
          t.UNDERSCORE_TITLE_MODE,
          {
            begin: /\([^\)]*/,
            end: /[)]+/,
            keywords: n.concat(i),
            excludeEnd: !1
          }
        ]
      },
      {
        className: "class",
        beginKeywords: "class interface",
        end: /[{;=]/,
        excludeEnd: !0,
        relevance: 0,
        keywords: "class interface",
        illegal: /[:"\[\]]/,
        contains: [
          { beginKeywords: "extends implements" },
          t.UNDERSCORE_TITLE_MODE
        ]
      },
      {
        // AspectJ Constructs
        beginKeywords: "pointcut after before around throwing returning",
        end: /[)]/,
        excludeEnd: !1,
        illegal: /["\[\]]/,
        contains: [
          {
            begin: e.concat(t.UNDERSCORE_IDENT_RE, /\s*\(/),
            returnBegin: !0,
            contains: [t.UNDERSCORE_TITLE_MODE]
          }
        ]
      },
      {
        begin: /[:]/,
        returnBegin: !0,
        end: /[{;]/,
        relevance: 0,
        excludeEnd: !1,
        keywords: n,
        illegal: /["\[\]]/,
        contains: [
          {
            begin: e.concat(t.UNDERSCORE_IDENT_RE, /\s*\(/),
            keywords: n.concat(i),
            relevance: 0
          },
          t.QUOTE_STRING_MODE
        ]
      },
      {
        // this prevents 'new Name(...), or throw ...' from being recognized as a function definition
        beginKeywords: "new throw",
        relevance: 0
      },
      {
        // the function class is a bit different for AspectJ compared to the Java language
        className: "function",
        begin: /\w+ +\w+(\.\w+)?\s*\([^\)]*\)\s*((throws)[\w\s,]+)?[\{;]/,
        returnBegin: !0,
        end: /[{;=]/,
        keywords: n,
        excludeEnd: !0,
        contains: [
          {
            begin: e.concat(t.UNDERSCORE_IDENT_RE, /\s*\(/),
            returnBegin: !0,
            relevance: 0,
            contains: [t.UNDERSCORE_TITLE_MODE]
          },
          {
            className: "params",
            begin: /\(/,
            end: /\)/,
            relevance: 0,
            keywords: n,
            contains: [
              t.APOS_STRING_MODE,
              t.QUOTE_STRING_MODE,
              t.C_NUMBER_MODE,
              t.C_BLOCK_COMMENT_MODE
            ]
          },
          t.C_LINE_COMMENT_MODE,
          t.C_BLOCK_COMMENT_MODE
        ]
      },
      t.C_NUMBER_MODE,
      {
        // annotation is also used in this language
        className: "meta",
        begin: /@[A-Za-z]+/
      }
    ]
  };
}
function Om(t) {
  const e = { begin: "`[\\s\\S]" };
  return {
    name: "AutoHotkey",
    case_insensitive: !0,
    aliases: ["ahk"],
    keywords: {
      keyword: "Break Continue Critical Exit ExitApp Gosub Goto New OnExit Pause return SetBatchLines SetTimer Suspend Thread Throw Until ahk_id ahk_class ahk_pid ahk_exe ahk_group",
      literal: "true false NOT AND OR",
      built_in: "ComSpec Clipboard ClipboardAll ErrorLevel"
    },
    contains: [
      e,
      t.inherit(t.QUOTE_STRING_MODE, { contains: [e] }),
      t.COMMENT(";", "$", { relevance: 0 }),
      t.C_BLOCK_COMMENT_MODE,
      {
        className: "number",
        begin: t.NUMBER_RE,
        relevance: 0
      },
      {
        // subst would be the most accurate however fails the point of
        // highlighting. variable is comparably the most accurate that actually
        // has some effect
        className: "variable",
        begin: "%[a-zA-Z0-9#_$@]+%"
      },
      {
        className: "built_in",
        begin: "^\\s*\\w+\\s*(,|%)"
        // I don't really know if this is totally relevant
      },
      {
        // symbol would be most accurate however is highlighted just like
        // built_in and that makes up a lot of AutoHotkey code meaning that it
        // would fail to highlight anything
        className: "title",
        variants: [
          { begin: '^[^\\n";]+::(?!=)' },
          {
            begin: '^[^\\n";]+:(?!=)',
            // zero relevance as it catches a lot of things
            // followed by a single ':' in many languages
            relevance: 0
          }
        ]
      },
      {
        className: "meta",
        begin: "^\\s*#\\w+",
        end: "$",
        relevance: 0
      },
      {
        className: "built_in",
        begin: "A_[a-zA-Z0-9]+"
      },
      {
        // consecutive commas, not for highlighting but just for relevance
        begin: ",\\s*,"
      }
    ]
  };
}
function vm(t) {
  const e = "ByRef Case Const ContinueCase ContinueLoop Dim Do Else ElseIf EndFunc EndIf EndSelect EndSwitch EndWith Enum Exit ExitLoop For Func Global If In Local Next ReDim Return Select Static Step Switch Then To Until Volatile WEnd While With", n = [
    "EndRegion",
    "forcedef",
    "forceref",
    "ignorefunc",
    "include",
    "include-once",
    "NoTrayIcon",
    "OnAutoItStartRegister",
    "pragma",
    "Region",
    "RequireAdmin",
    "Tidy_Off",
    "Tidy_On",
    "Tidy_Parameters"
  ], i = "True False And Null Not Or Default", r = "Abs ACos AdlibRegister AdlibUnRegister Asc AscW ASin Assign ATan AutoItSetOption AutoItWinGetTitle AutoItWinSetTitle Beep Binary BinaryLen BinaryMid BinaryToString BitAND BitNOT BitOR BitRotate BitShift BitXOR BlockInput Break Call CDTray Ceiling Chr ChrW ClipGet ClipPut ConsoleRead ConsoleWrite ConsoleWriteError ControlClick ControlCommand ControlDisable ControlEnable ControlFocus ControlGetFocus ControlGetHandle ControlGetPos ControlGetText ControlHide ControlListView ControlMove ControlSend ControlSetText ControlShow ControlTreeView Cos Dec DirCopy DirCreate DirGetSize DirMove DirRemove DllCall DllCallAddress DllCallbackFree DllCallbackGetPtr DllCallbackRegister DllClose DllOpen DllStructCreate DllStructGetData DllStructGetPtr DllStructGetSize DllStructSetData DriveGetDrive DriveGetFileSystem DriveGetLabel DriveGetSerial DriveGetType DriveMapAdd DriveMapDel DriveMapGet DriveSetLabel DriveSpaceFree DriveSpaceTotal DriveStatus EnvGet EnvSet EnvUpdate Eval Execute Exp FileChangeDir FileClose FileCopy FileCreateNTFSLink FileCreateShortcut FileDelete FileExists FileFindFirstFile FileFindNextFile FileFlush FileGetAttrib FileGetEncoding FileGetLongName FileGetPos FileGetShortcut FileGetShortName FileGetSize FileGetTime FileGetVersion FileInstall FileMove FileOpen FileOpenDialog FileRead FileReadLine FileReadToArray FileRecycle FileRecycleEmpty FileSaveDialog FileSelectFolder FileSetAttrib FileSetEnd FileSetPos FileSetTime FileWrite FileWriteLine Floor FtpSetProxy FuncName GUICreate GUICtrlCreateAvi GUICtrlCreateButton GUICtrlCreateCheckbox GUICtrlCreateCombo GUICtrlCreateContextMenu GUICtrlCreateDate GUICtrlCreateDummy GUICtrlCreateEdit GUICtrlCreateGraphic GUICtrlCreateGroup GUICtrlCreateIcon GUICtrlCreateInput GUICtrlCreateLabel GUICtrlCreateList GUICtrlCreateListView GUICtrlCreateListViewItem GUICtrlCreateMenu GUICtrlCreateMenuItem GUICtrlCreateMonthCal GUICtrlCreateObj GUICtrlCreatePic GUICtrlCreateProgress GUICtrlCreateRadio GUICtrlCreateSlider GUICtrlCreateTab GUICtrlCreateTabItem GUICtrlCreateTreeView GUICtrlCreateTreeViewItem GUICtrlCreateUpdown GUICtrlDelete GUICtrlGetHandle GUICtrlGetState GUICtrlRead GUICtrlRecvMsg GUICtrlRegisterListViewSort GUICtrlSendMsg GUICtrlSendToDummy GUICtrlSetBkColor GUICtrlSetColor GUICtrlSetCursor GUICtrlSetData GUICtrlSetDefBkColor GUICtrlSetDefColor GUICtrlSetFont GUICtrlSetGraphic GUICtrlSetImage GUICtrlSetLimit GUICtrlSetOnEvent GUICtrlSetPos GUICtrlSetResizing GUICtrlSetState GUICtrlSetStyle GUICtrlSetTip GUIDelete GUIGetCursorInfo GUIGetMsg GUIGetStyle GUIRegisterMsg GUISetAccelerators GUISetBkColor GUISetCoord GUISetCursor GUISetFont GUISetHelp GUISetIcon GUISetOnEvent GUISetState GUISetStyle GUIStartGroup GUISwitch Hex HotKeySet HttpSetProxy HttpSetUserAgent HWnd InetClose InetGet InetGetInfo InetGetSize InetRead IniDelete IniRead IniReadSection IniReadSectionNames IniRenameSection IniWrite IniWriteSection InputBox Int IsAdmin IsArray IsBinary IsBool IsDeclared IsDllStruct IsFloat IsFunc IsHWnd IsInt IsKeyword IsNumber IsObj IsPtr IsString Log MemGetStats Mod MouseClick MouseClickDrag MouseDown MouseGetCursor MouseGetPos MouseMove MouseUp MouseWheel MsgBox Number ObjCreate ObjCreateInterface ObjEvent ObjGet ObjName OnAutoItExitRegister OnAutoItExitUnRegister Ping PixelChecksum PixelGetColor PixelSearch ProcessClose ProcessExists ProcessGetStats ProcessList ProcessSetPriority ProcessWait ProcessWaitClose ProgressOff ProgressOn ProgressSet Ptr Random RegDelete RegEnumKey RegEnumVal RegRead RegWrite Round Run RunAs RunAsWait RunWait Send SendKeepActive SetError SetExtended ShellExecute ShellExecuteWait Shutdown Sin Sleep SoundPlay SoundSetWaveVolume SplashImageOn SplashOff SplashTextOn Sqrt SRandom StatusbarGetText StderrRead StdinWrite StdioClose StdoutRead String StringAddCR StringCompare StringFormat StringFromASCIIArray StringInStr StringIsAlNum StringIsAlpha StringIsASCII StringIsDigit StringIsFloat StringIsInt StringIsLower StringIsSpace StringIsUpper StringIsXDigit StringLeft StringLen StringLower StringMid StringRegExp StringRegExpReplace StringReplace StringReverse StringRight StringSplit StringStripCR StringStripWS StringToASCIIArray StringToBinary StringTrimLeft StringTrimRight StringUpper Tan TCPAccept TCPCloseSocket TCPConnect TCPListen TCPNameToIP TCPRecv TCPSend TCPShutdown, UDPShutdown TCPStartup, UDPStartup TimerDiff TimerInit ToolTip TrayCreateItem TrayCreateMenu TrayGetMsg TrayItemDelete TrayItemGetHandle TrayItemGetState TrayItemGetText TrayItemSetOnEvent TrayItemSetState TrayItemSetText TraySetClick TraySetIcon TraySetOnEvent TraySetPauseIcon TraySetState TraySetToolTip TrayTip UBound UDPBind UDPCloseSocket UDPOpen UDPRecv UDPSend VarGetType WinActivate WinActive WinClose WinExists WinFlash WinGetCaretPos WinGetClassList WinGetClientSize WinGetHandle WinGetPos WinGetProcess WinGetState WinGetText WinGetTitle WinKill WinList WinMenuSelectItem WinMinimizeAll WinMinimizeAllUndo WinMove WinSetOnTop WinSetState WinSetTitle WinSetTrans WinWait WinWaitActive WinWaitClose WinWaitNotActive", a = { variants: [
    t.COMMENT(";", "$", { relevance: 0 }),
    t.COMMENT("#cs", "#ce"),
    t.COMMENT("#comments-start", "#comments-end")
  ] }, s = { begin: "\\$[A-z0-9_]+" }, o = {
    className: "string",
    variants: [
      {
        begin: /"/,
        end: /"/,
        contains: [
          {
            begin: /""/,
            relevance: 0
          }
        ]
      },
      {
        begin: /'/,
        end: /'/,
        contains: [
          {
            begin: /''/,
            relevance: 0
          }
        ]
      }
    ]
  }, l = { variants: [
    t.BINARY_NUMBER_MODE,
    t.C_NUMBER_MODE
  ] }, c = {
    className: "meta",
    begin: "#",
    end: "$",
    keywords: { keyword: n },
    contains: [
      {
        begin: /\\\n/,
        relevance: 0
      },
      {
        beginKeywords: "include",
        keywords: { keyword: "include" },
        end: "$",
        contains: [
          o,
          {
            className: "string",
            variants: [
              {
                begin: "<",
                end: ">"
              },
              {
                begin: /"/,
                end: /"/,
                contains: [
                  {
                    begin: /""/,
                    relevance: 0
                  }
                ]
              },
              {
                begin: /'/,
                end: /'/,
                contains: [
                  {
                    begin: /''/,
                    relevance: 0
                  }
                ]
              }
            ]
          }
        ]
      },
      o,
      a
    ]
  }, d = {
    className: "symbol",
    // begin: '@',
    // end: '$',
    // keywords: 'AppDataCommonDir AppDataDir AutoItExe AutoItPID AutoItVersion AutoItX64 COM_EventObj CommonFilesDir Compiled ComputerName ComSpec CPUArch CR CRLF DesktopCommonDir DesktopDepth DesktopDir DesktopHeight DesktopRefresh DesktopWidth DocumentsCommonDir error exitCode exitMethod extended FavoritesCommonDir FavoritesDir GUI_CtrlHandle GUI_CtrlId GUI_DragFile GUI_DragId GUI_DropId GUI_WinHandle HomeDrive HomePath HomeShare HotKeyPressed HOUR IPAddress1 IPAddress2 IPAddress3 IPAddress4 KBLayout LF LocalAppDataDir LogonDNSDomain LogonDomain LogonServer MDAY MIN MON MSEC MUILang MyDocumentsDir NumParams OSArch OSBuild OSLang OSServicePack OSType OSVersion ProgramFilesDir ProgramsCommonDir ProgramsDir ScriptDir ScriptFullPath ScriptLineNumber ScriptName SEC StartMenuCommonDir StartMenuDir StartupCommonDir StartupDir SW_DISABLE SW_ENABLE SW_HIDE SW_LOCK SW_MAXIMIZE SW_MINIMIZE SW_RESTORE SW_SHOW SW_SHOWDEFAULT SW_SHOWMAXIMIZED SW_SHOWMINIMIZED SW_SHOWMINNOACTIVE SW_SHOWNA SW_SHOWNOACTIVATE SW_SHOWNORMAL SW_UNLOCK SystemDir TAB TempDir TRAY_ID TrayIconFlashing TrayIconVisible UserName UserProfileDir WDAY WindowsDir WorkingDir YDAY YEAR',
    // relevance: 5
    begin: "@[A-z0-9_]+"
  }, u = {
    beginKeywords: "Func",
    end: "$",
    illegal: "\\$|\\[|%",
    contains: [
      t.inherit(t.UNDERSCORE_TITLE_MODE, { className: "title.function" }),
      {
        className: "params",
        begin: "\\(",
        end: "\\)",
        contains: [
          s,
          o,
          l
        ]
      }
    ]
  };
  return {
    name: "AutoIt",
    case_insensitive: !0,
    illegal: /\/\*/,
    keywords: {
      keyword: e,
      built_in: r,
      literal: i
    },
    contains: [
      a,
      s,
      o,
      l,
      c,
      d,
      u
    ]
  };
}
function Am(t) {
  return {
    name: "AVR Assembly",
    case_insensitive: !0,
    keywords: {
      $pattern: "\\.?" + t.IDENT_RE,
      keyword: (
        /* mnemonic */
        "adc add adiw and andi asr bclr bld brbc brbs brcc brcs break breq brge brhc brhs brid brie brlo brlt brmi brne brpl brsh brtc brts brvc brvs bset bst call cbi cbr clc clh cli cln clr cls clt clv clz com cp cpc cpi cpse dec eicall eijmp elpm eor fmul fmuls fmulsu icall ijmp in inc jmp ld ldd ldi lds lpm lsl lsr mov movw mul muls mulsu neg nop or ori out pop push rcall ret reti rjmp rol ror sbc sbr sbrc sbrs sec seh sbi sbci sbic sbis sbiw sei sen ser ses set sev sez sleep spm st std sts sub subi swap tst wdr"
      ),
      built_in: (
        /* general purpose registers */
        "r0 r1 r2 r3 r4 r5 r6 r7 r8 r9 r10 r11 r12 r13 r14 r15 r16 r17 r18 r19 r20 r21 r22 r23 r24 r25 r26 r27 r28 r29 r30 r31 x|0 xh xl y|0 yh yl z|0 zh zl ucsr1c udr1 ucsr1a ucsr1b ubrr1l ubrr1h ucsr0c ubrr0h tccr3c tccr3a tccr3b tcnt3h tcnt3l ocr3ah ocr3al ocr3bh ocr3bl ocr3ch ocr3cl icr3h icr3l etimsk etifr tccr1c ocr1ch ocr1cl twcr twdr twar twsr twbr osccal xmcra xmcrb eicra spmcsr spmcr portg ddrg ping portf ddrf sreg sph spl xdiv rampz eicrb eimsk gimsk gicr eifr gifr timsk tifr mcucr mcucsr tccr0 tcnt0 ocr0 assr tccr1a tccr1b tcnt1h tcnt1l ocr1ah ocr1al ocr1bh ocr1bl icr1h icr1l tccr2 tcnt2 ocr2 ocdr wdtcr sfior eearh eearl eedr eecr porta ddra pina portb ddrb pinb portc ddrc pinc portd ddrd pind spdr spsr spcr udr0 ucsr0a ucsr0b ubrr0l acsr admux adcsr adch adcl porte ddre pine pinf"
      ),
      meta: ".byte .cseg .db .def .device .dseg .dw .endmacro .equ .eseg .exit .include .list .listmac .macro .nolist .org .set"
    },
    contains: [
      t.C_BLOCK_COMMENT_MODE,
      t.COMMENT(
        ";",
        "$",
        { relevance: 0 }
      ),
      t.C_NUMBER_MODE,
      // 0x..., decimal, float
      t.BINARY_NUMBER_MODE,
      // 0b...
      {
        className: "number",
        begin: "\\b(\\$[a-zA-Z0-9]+|0o[0-7]+)"
        // $..., 0o...
      },
      t.QUOTE_STRING_MODE,
      {
        className: "string",
        begin: "'",
        end: "[^\\\\]'",
        illegal: "[^\\\\][^']"
      },
      {
        className: "symbol",
        begin: "^[A-Za-z0-9_.$]+:"
      },
      {
        className: "meta",
        begin: "#",
        end: "$"
      },
      {
        // substitution within a macro
        className: "subst",
        begin: "@[0-9]+"
      }
    ]
  };
}
function Im(t) {
  const e = {
    className: "variable",
    variants: [
      { begin: /\$[\w\d#@][\w\d_]*/ },
      { begin: /\$\{(.*?)\}/ }
    ]
  }, n = "BEGIN END if else while do for in break continue delete next nextfile function func exit|10", i = {
    className: "string",
    contains: [t.BACKSLASH_ESCAPE],
    variants: [
      {
        begin: /(u|b)?r?'''/,
        end: /'''/,
        relevance: 10
      },
      {
        begin: /(u|b)?r?"""/,
        end: /"""/,
        relevance: 10
      },
      {
        begin: /(u|r|ur)'/,
        end: /'/,
        relevance: 10
      },
      {
        begin: /(u|r|ur)"/,
        end: /"/,
        relevance: 10
      },
      {
        begin: /(b|br)'/,
        end: /'/
      },
      {
        begin: /(b|br)"/,
        end: /"/
      },
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE
    ]
  };
  return {
    name: "Awk",
    keywords: { keyword: n },
    contains: [
      e,
      i,
      t.REGEXP_MODE,
      t.HASH_COMMENT_MODE,
      t.NUMBER_MODE
    ]
  };
}
function Dm(t) {
  const e = t.UNDERSCORE_IDENT_RE, a = {
    keyword: [
      "abstract",
      "as",
      "asc",
      "avg",
      "break",
      "breakpoint",
      "by",
      "byref",
      "case",
      "catch",
      "changecompany",
      "class",
      "client",
      "client",
      "common",
      "const",
      "continue",
      "count",
      "crosscompany",
      "delegate",
      "delete_from",
      "desc",
      "display",
      "div",
      "do",
      "edit",
      "else",
      "eventhandler",
      "exists",
      "extends",
      "final",
      "finally",
      "firstfast",
      "firstonly",
      "firstonly1",
      "firstonly10",
      "firstonly100",
      "firstonly1000",
      "flush",
      "for",
      "forceliterals",
      "forcenestedloop",
      "forceplaceholders",
      "forceselectorder",
      "forupdate",
      "from",
      "generateonly",
      "group",
      "hint",
      "if",
      "implements",
      "in",
      "index",
      "insert_recordset",
      "interface",
      "internal",
      "is",
      "join",
      "like",
      "maxof",
      "minof",
      "mod",
      "namespace",
      "new",
      "next",
      "nofetch",
      "notexists",
      "optimisticlock",
      "order",
      "outer",
      "pessimisticlock",
      "print",
      "private",
      "protected",
      "public",
      "readonly",
      "repeatableread",
      "retry",
      "return",
      "reverse",
      "select",
      "server",
      "setting",
      "static",
      "sum",
      "super",
      "switch",
      "this",
      "throw",
      "try",
      "ttsabort",
      "ttsbegin",
      "ttscommit",
      "unchecked",
      "update_recordset",
      "using",
      "validtimestate",
      "void",
      "where",
      "while"
    ],
    built_in: [
      "anytype",
      "boolean",
      "byte",
      "char",
      "container",
      "date",
      "double",
      "enum",
      "guid",
      "int",
      "int64",
      "long",
      "real",
      "short",
      "str",
      "utcdatetime",
      "var"
    ],
    literal: [
      "default",
      "false",
      "null",
      "true"
    ]
  }, s = {
    variants: [
      { match: [
        /(class|interface)\s+/,
        e,
        /\s+(extends|implements)\s+/,
        e
      ] },
      { match: [
        /class\s+/,
        e
      ] }
    ],
    scope: {
      2: "title.class",
      4: "title.class.inherited"
    },
    keywords: a
  };
  return {
    name: "X++",
    aliases: ["x++"],
    keywords: a,
    contains: [
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE,
      t.C_NUMBER_MODE,
      {
        className: "meta",
        begin: "#",
        end: "$"
      },
      s
    ]
  };
}
function Mm(t) {
  return {
    name: "BASIC",
    case_insensitive: !0,
    illegal: "^.",
    // Support explicitly typed variables that end with $%! or #.
    keywords: {
      $pattern: "[a-zA-Z][a-zA-Z0-9_$%!#]*",
      keyword: [
        "ABS",
        "ASC",
        "AND",
        "ATN",
        "AUTO|0",
        "BEEP",
        "BLOAD|10",
        "BSAVE|10",
        "CALL",
        "CALLS",
        "CDBL",
        "CHAIN",
        "CHDIR",
        "CHR$|10",
        "CINT",
        "CIRCLE",
        "CLEAR",
        "CLOSE",
        "CLS",
        "COLOR",
        "COM",
        "COMMON",
        "CONT",
        "COS",
        "CSNG",
        "CSRLIN",
        "CVD",
        "CVI",
        "CVS",
        "DATA",
        "DATE$",
        "DEFDBL",
        "DEFINT",
        "DEFSNG",
        "DEFSTR",
        "DEF|0",
        "SEG",
        "USR",
        "DELETE",
        "DIM",
        "DRAW",
        "EDIT",
        "END",
        "ENVIRON",
        "ENVIRON$",
        "EOF",
        "EQV",
        "ERASE",
        "ERDEV",
        "ERDEV$",
        "ERL",
        "ERR",
        "ERROR",
        "EXP",
        "FIELD",
        "FILES",
        "FIX",
        "FOR|0",
        "FRE",
        "GET",
        "GOSUB|10",
        "GOTO",
        "HEX$",
        "IF",
        "THEN",
        "ELSE|0",
        "INKEY$",
        "INP",
        "INPUT",
        "INPUT#",
        "INPUT$",
        "INSTR",
        "IMP",
        "INT",
        "IOCTL",
        "IOCTL$",
        "KEY",
        "ON",
        "OFF",
        "LIST",
        "KILL",
        "LEFT$",
        "LEN",
        "LET",
        "LINE",
        "LLIST",
        "LOAD",
        "LOC",
        "LOCATE",
        "LOF",
        "LOG",
        "LPRINT",
        "USING",
        "LSET",
        "MERGE",
        "MID$",
        "MKDIR",
        "MKD$",
        "MKI$",
        "MKS$",
        "MOD",
        "NAME",
        "NEW",
        "NEXT",
        "NOISE",
        "NOT",
        "OCT$",
        "ON",
        "OR",
        "PEN",
        "PLAY",
        "STRIG",
        "OPEN",
        "OPTION",
        "BASE",
        "OUT",
        "PAINT",
        "PALETTE",
        "PCOPY",
        "PEEK",
        "PMAP",
        "POINT",
        "POKE",
        "POS",
        "PRINT",
        "PRINT]",
        "PSET",
        "PRESET",
        "PUT",
        "RANDOMIZE",
        "READ",
        "REM",
        "RENUM",
        "RESET|0",
        "RESTORE",
        "RESUME",
        "RETURN|0",
        "RIGHT$",
        "RMDIR",
        "RND",
        "RSET",
        "RUN",
        "SAVE",
        "SCREEN",
        "SGN",
        "SHELL",
        "SIN",
        "SOUND",
        "SPACE$",
        "SPC",
        "SQR",
        "STEP",
        "STICK",
        "STOP",
        "STR$",
        "STRING$",
        "SWAP",
        "SYSTEM",
        "TAB",
        "TAN",
        "TIME$",
        "TIMER",
        "TROFF",
        "TRON",
        "TO",
        "USR",
        "VAL",
        "VARPTR",
        "VARPTR$",
        "VIEW",
        "WAIT",
        "WHILE",
        "WEND",
        "WIDTH",
        "WINDOW",
        "WRITE",
        "XOR"
      ]
    },
    contains: [
      {
        // Match strings that start with " and end with " or a line break
        scope: "string",
        begin: /"/,
        end: /"|$/,
        contains: [t.BACKSLASH_ESCAPE]
      },
      t.COMMENT("REM", "$", { relevance: 10 }),
      t.COMMENT("'", "$", { relevance: 0 }),
      {
        // Match line numbers
        className: "symbol",
        begin: "^[0-9]+ ",
        relevance: 10
      },
      {
        // Match typed numeric constants (1000, 12.34!, 1.2e5, 1.5#, 1.2D2)
        className: "number",
        begin: "\\b\\d+(\\.\\d+)?([edED]\\d+)?[#!]?",
        relevance: 0
      },
      {
        // Match hexadecimal numbers (&Hxxxx)
        className: "number",
        begin: "(&[hH][0-9a-fA-F]{1,4})"
      },
      {
        // Match octal numbers (&Oxxxxxx)
        className: "number",
        begin: "(&[oO][0-7]{1,6})"
      }
    ]
  };
}
function wm(t) {
  return {
    name: "Backus–Naur Form",
    contains: [
      // Attribute
      {
        className: "attribute",
        begin: /</,
        end: />/
      },
      // Specific
      {
        begin: /::=/,
        end: /$/,
        contains: [
          {
            begin: /</,
            end: />/
          },
          // Common
          t.C_LINE_COMMENT_MODE,
          t.C_BLOCK_COMMENT_MODE,
          t.APOS_STRING_MODE,
          t.QUOTE_STRING_MODE
        ]
      }
    ]
  };
}
function xm(t) {
  const e = {
    className: "literal",
    begin: /[+-]+/,
    relevance: 0
  };
  return {
    name: "Brainfuck",
    aliases: ["bf"],
    contains: [
      t.COMMENT(
        /[^\[\]\.,\+\-<> \r\n]/,
        /[\[\]\.,\+\-<> \r\n]/,
        {
          contains: [
            {
              match: /[ ]+[^\[\]\.,\+\-<> \r\n]/,
              relevance: 0
            }
          ],
          returnEnd: !0,
          relevance: 0
        }
      ),
      {
        className: "title",
        begin: "[\\[\\]]",
        relevance: 0
      },
      {
        className: "string",
        begin: "[\\.,]",
        relevance: 0
      },
      {
        // this mode works as the only relevance counter
        // it looks ahead to find the start of a run of literals
        // so only the runs are counted as relevant
        begin: /(?=\+\+|--)/,
        contains: [e]
      },
      e
    ]
  };
}
function Lm(t) {
  const e = t.regex, n = [
    "div",
    "mod",
    "in",
    "and",
    "or",
    "not",
    "xor",
    "asserterror",
    "begin",
    "case",
    "do",
    "downto",
    "else",
    "end",
    "exit",
    "for",
    "local",
    "if",
    "of",
    "repeat",
    "then",
    "to",
    "until",
    "while",
    "with",
    "var"
  ], i = "false true", r = [
    t.C_LINE_COMMENT_MODE,
    t.COMMENT(
      /\{/,
      /\}/,
      { relevance: 0 }
    ),
    t.COMMENT(
      /\(\*/,
      /\*\)/,
      { relevance: 10 }
    )
  ], a = {
    className: "string",
    begin: /'/,
    end: /'/,
    contains: [{ begin: /''/ }]
  }, s = {
    className: "string",
    begin: /(#\d+)+/
  }, o = {
    className: "number",
    begin: "\\b\\d+(\\.\\d+)?(DT|D|T)",
    relevance: 0
  }, l = {
    className: "string",
    // not a string technically but makes sense to be highlighted in the same style
    begin: '"',
    end: '"'
  }, c = {
    match: [
      /procedure/,
      /\s+/,
      /[a-zA-Z_][\w@]*/,
      /\s*/
    ],
    scope: {
      1: "keyword",
      3: "title.function"
    },
    contains: [
      {
        className: "params",
        begin: /\(/,
        end: /\)/,
        keywords: n,
        contains: [
          a,
          s,
          t.NUMBER_MODE
        ]
      },
      ...r
    ]
  }, d = [
    "Table",
    "Form",
    "Report",
    "Dataport",
    "Codeunit",
    "XMLport",
    "MenuSuite",
    "Page",
    "Query"
  ], u = {
    match: [
      /OBJECT/,
      /\s+/,
      e.either(...d),
      /\s+/,
      /\d+/,
      /\s+(?=[^\s])/,
      /.*/,
      /$/
    ],
    relevance: 3,
    scope: {
      1: "keyword",
      3: "type",
      5: "number",
      7: "title"
    }
  };
  return {
    name: "C/AL",
    case_insensitive: !0,
    keywords: {
      keyword: n,
      literal: i
    },
    illegal: /\/\*/,
    contains: [
      {
        match: /[\w]+(?=\=)/,
        scope: "attribute",
        relevance: 0
      },
      a,
      s,
      o,
      l,
      t.NUMBER_MODE,
      u,
      c
    ]
  };
}
function Pm(t) {
  const e = [
    "struct",
    "enum",
    "interface",
    "union",
    "group",
    "import",
    "using",
    "const",
    "annotation",
    "extends",
    "in",
    "of",
    "on",
    "as",
    "with",
    "from",
    "fixed"
  ], n = [
    "Void",
    "Bool",
    "Int8",
    "Int16",
    "Int32",
    "Int64",
    "UInt8",
    "UInt16",
    "UInt32",
    "UInt64",
    "Float32",
    "Float64",
    "Text",
    "Data",
    "AnyPointer",
    "AnyStruct",
    "Capability",
    "List"
  ], i = [
    "true",
    "false"
  ], r = {
    variants: [
      { match: [
        /(struct|enum|interface)/,
        /\s+/,
        t.IDENT_RE
      ] },
      { match: [
        /extends/,
        /\s*\(/,
        t.IDENT_RE,
        /\s*\)/
      ] }
    ],
    scope: {
      1: "keyword",
      3: "title.class"
    }
  };
  return {
    name: "Cap’n Proto",
    aliases: ["capnp"],
    keywords: {
      keyword: e,
      type: n,
      literal: i
    },
    contains: [
      t.QUOTE_STRING_MODE,
      t.NUMBER_MODE,
      t.HASH_COMMENT_MODE,
      {
        className: "meta",
        begin: /@0x[\w\d]{16};/,
        illegal: /\n/
      },
      {
        className: "symbol",
        begin: /@\d+\b/
      },
      r
    ]
  };
}
function km(t) {
  const e = [
    "assembly",
    "module",
    "package",
    "import",
    "alias",
    "class",
    "interface",
    "object",
    "given",
    "value",
    "assign",
    "void",
    "function",
    "new",
    "of",
    "extends",
    "satisfies",
    "abstracts",
    "in",
    "out",
    "return",
    "break",
    "continue",
    "throw",
    "assert",
    "dynamic",
    "if",
    "else",
    "switch",
    "case",
    "for",
    "while",
    "try",
    "catch",
    "finally",
    "then",
    "let",
    "this",
    "outer",
    "super",
    "is",
    "exists",
    "nonempty"
  ], n = [
    "shared",
    "abstract",
    "formal",
    "default",
    "actual",
    "variable",
    "late",
    "native",
    "deprecated",
    "final",
    "sealed",
    "annotation",
    "suppressWarnings",
    "small"
  ], i = [
    "doc",
    "by",
    "license",
    "see",
    "throws",
    "tagged"
  ], r = {
    className: "subst",
    excludeBegin: !0,
    excludeEnd: !0,
    begin: /``/,
    end: /``/,
    keywords: e,
    relevance: 10
  }, a = [
    {
      // verbatim string
      className: "string",
      begin: '"""',
      end: '"""',
      relevance: 10
    },
    {
      // string literal or template
      className: "string",
      begin: '"',
      end: '"',
      contains: [r]
    },
    {
      // character literal
      className: "string",
      begin: "'",
      end: "'"
    },
    {
      // numeric literal
      className: "number",
      begin: "#[0-9a-fA-F_]+|\\$[01_]+|[0-9_]+(?:\\.[0-9_](?:[eE][+-]?\\d+)?)?[kMGTPmunpf]?",
      relevance: 0
    }
  ];
  return r.contains = a, {
    name: "Ceylon",
    keywords: {
      keyword: e.concat(n),
      meta: i
    },
    illegal: "\\$[^01]|#[^0-9a-fA-F]",
    contains: [
      t.C_LINE_COMMENT_MODE,
      t.COMMENT("/\\*", "\\*/", { contains: ["self"] }),
      {
        // compiler annotation
        className: "meta",
        begin: '@[a-z]\\w*(?::"[^"]*")?'
      }
    ].concat(a)
  };
}
function Um(t) {
  return {
    name: "Clean",
    aliases: [
      "icl",
      "dcl"
    ],
    keywords: {
      keyword: [
        "if",
        "let",
        "in",
        "with",
        "where",
        "case",
        "of",
        "class",
        "instance",
        "otherwise",
        "implementation",
        "definition",
        "system",
        "module",
        "from",
        "import",
        "qualified",
        "as",
        "special",
        "code",
        "inline",
        "foreign",
        "export",
        "ccall",
        "stdcall",
        "generic",
        "derive",
        "infix",
        "infixl",
        "infixr"
      ],
      built_in: "Int Real Char Bool",
      literal: "True False"
    },
    contains: [
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE,
      t.C_NUMBER_MODE,
      {
        // relevance booster
        begin: "->|<-[|:]?|#!?|>>=|\\{\\||\\|\\}|:==|=:|<>"
      }
    ]
  };
}
function Fm(t) {
  const e = "a-zA-Z_\\-!.?+*=<>&'", n = "[#]?[" + e + "][" + e + "0-9/;:$#]*", i = "def defonce defprotocol defstruct defmulti defmethod defn- defn defmacro deftype defrecord", r = {
    $pattern: n,
    built_in: (
      // Clojure keywords
      i + " cond apply if-not if-let if not not= =|0 <|0 >|0 <=|0 >=|0 ==|0 +|0 /|0 *|0 -|0 rem quot neg? pos? delay? symbol? keyword? true? false? integer? empty? coll? list? set? ifn? fn? associative? sequential? sorted? counted? reversible? number? decimal? class? distinct? isa? float? rational? reduced? ratio? odd? even? char? seq? vector? string? map? nil? contains? zero? instance? not-every? not-any? libspec? -> ->> .. . inc compare do dotimes mapcat take remove take-while drop letfn drop-last take-last drop-while while intern condp case reduced cycle split-at split-with repeat replicate iterate range merge zipmap declare line-seq sort comparator sort-by dorun doall nthnext nthrest partition eval doseq await await-for let agent atom send send-off release-pending-sends add-watch mapv filterv remove-watch agent-error restart-agent set-error-handler error-handler set-error-mode! error-mode shutdown-agents quote var fn loop recur throw try monitor-enter monitor-exit macroexpand macroexpand-1 for dosync and or when when-not when-let comp juxt partial sequence memoize constantly complement identity assert peek pop doto proxy first rest cons cast coll last butlast sigs reify second ffirst fnext nfirst nnext meta with-meta ns in-ns create-ns import refer keys select-keys vals key val rseq name namespace promise into transient persistent! conj! assoc! dissoc! pop! disj! use class type num float double short byte boolean bigint biginteger bigdec print-method print-dup throw-if printf format load compile get-in update-in pr pr-on newline flush read slurp read-line subvec with-open memfn time re-find re-groups rand-int rand mod locking assert-valid-fdecl alias resolve ref deref refset swap! reset! set-validator! compare-and-set! alter-meta! reset-meta! commute get-validator alter ref-set ref-history-count ref-min-history ref-max-history ensure sync io! new next conj set! to-array future future-call into-array aset gen-class reduce map filter find empty hash-map hash-set sorted-map sorted-map-by sorted-set sorted-set-by vec vector seq flatten reverse assoc dissoc list disj get union difference intersection extend extend-type extend-protocol int nth delay count concat chunk chunk-buffer chunk-append chunk-first chunk-rest max min dec unchecked-inc-int unchecked-inc unchecked-dec-inc unchecked-dec unchecked-negate unchecked-add-int unchecked-add unchecked-subtract-int unchecked-subtract chunk-next chunk-cons chunked-seq? prn vary-meta lazy-seq spread list* str find-keyword keyword symbol gensym force rationalize"
    )
  }, a = {
    begin: n,
    relevance: 0
  }, s = {
    scope: "number",
    relevance: 0,
    variants: [
      { match: /[-+]?0[xX][0-9a-fA-F]+N?/ },
      // hexadecimal                 // 0x2a
      { match: /[-+]?0[0-7]+N?/ },
      // octal                       // 052
      { match: /[-+]?[1-9][0-9]?[rR][0-9a-zA-Z]+N?/ },
      // variable radix from 2 to 36 // 2r101010, 8r52, 36r16
      { match: /[-+]?[0-9]+\/[0-9]+N?/ },
      // ratio                       // 1/2
      { match: /[-+]?[0-9]+((\.[0-9]*([eE][+-]?[0-9]+)?M?)|([eE][+-]?[0-9]+M?|M))/ },
      // float        // 0.42 4.2E-1M 42E1 42M
      { match: /[-+]?([1-9][0-9]*|0)N?/ }
      // int (don't match leading 0) // 42 42N
    ]
  }, o = {
    scope: "character",
    variants: [
      { match: /\\o[0-3]?[0-7]{1,2}/ },
      // Unicode Octal 0 - 377
      { match: /\\u[0-9a-fA-F]{4}/ },
      // Unicode Hex 0000 - FFFF
      { match: /\\(newline|space|tab|formfeed|backspace|return)/ },
      // special characters
      {
        match: /\\\S/,
        relevance: 0
      }
      // any non-whitespace char
    ]
  }, l = {
    scope: "regex",
    begin: /#"/,
    end: /"/,
    contains: [t.BACKSLASH_ESCAPE]
  }, c = t.inherit(t.QUOTE_STRING_MODE, { illegal: null }), d = {
    scope: "punctuation",
    match: /,/,
    relevance: 0
  }, u = t.COMMENT(
    ";",
    "$",
    { relevance: 0 }
  ), _ = {
    className: "literal",
    begin: /\b(true|false|nil)\b/
  }, m = {
    begin: "\\[|(#::?" + n + ")?\\{",
    end: "[\\]\\}]",
    relevance: 0
  }, g = {
    className: "symbol",
    begin: "[:]{1,2}" + n
  }, S = {
    begin: "\\(",
    end: "\\)"
  }, E = {
    endsWithParent: !0,
    relevance: 0
  }, h = {
    keywords: r,
    className: "name",
    begin: n,
    relevance: 0,
    starts: E
  }, T = [
    d,
    S,
    o,
    l,
    c,
    u,
    g,
    m,
    s,
    _,
    a
  ], b = {
    beginKeywords: i,
    keywords: {
      $pattern: n,
      keyword: i
    },
    end: '(\\[|#|\\d|"|:|\\{|\\)|\\(|$)',
    contains: [
      {
        className: "title",
        begin: n,
        relevance: 0,
        excludeEnd: !0,
        // we can only have a single title
        endsParent: !0
      }
    ].concat(T)
  };
  return S.contains = [
    b,
    h,
    E
  ], E.contains = T, m.contains = T, {
    name: "Clojure",
    aliases: [
      "clj",
      "edn"
    ],
    illegal: /\S/,
    contains: [
      d,
      S,
      o,
      l,
      c,
      u,
      g,
      m,
      s,
      _
    ]
  };
}
function Bm(t) {
  return {
    name: "Clojure REPL",
    contains: [
      {
        className: "meta.prompt",
        begin: /^([\w.-]+|\s*#_)?=>/,
        starts: {
          end: /$/,
          subLanguage: "clojure"
        }
      }
    ]
  };
}
function Gm(t) {
  return {
    name: "CMake",
    aliases: ["cmake.in"],
    case_insensitive: !0,
    keywords: { keyword: (
      // scripting commands
      "break cmake_host_system_information cmake_minimum_required cmake_parse_arguments cmake_policy configure_file continue elseif else endforeach endfunction endif endmacro endwhile execute_process file find_file find_library find_package find_path find_program foreach function get_cmake_property get_directory_property get_filename_component get_property if include include_guard list macro mark_as_advanced math message option return separate_arguments set_directory_properties set_property set site_name string unset variable_watch while add_compile_definitions add_compile_options add_custom_command add_custom_target add_definitions add_dependencies add_executable add_library add_link_options add_subdirectory add_test aux_source_directory build_command create_test_sourcelist define_property enable_language enable_testing export fltk_wrap_ui get_source_file_property get_target_property get_test_property include_directories include_external_msproject include_regular_expression install link_directories link_libraries load_cache project qt_wrap_cpp qt_wrap_ui remove_definitions set_source_files_properties set_target_properties set_tests_properties source_group target_compile_definitions target_compile_features target_compile_options target_include_directories target_link_directories target_link_libraries target_link_options target_sources try_compile try_run ctest_build ctest_configure ctest_coverage ctest_empty_binary_directory ctest_memcheck ctest_read_custom_files ctest_run_script ctest_sleep ctest_start ctest_submit ctest_test ctest_update ctest_upload build_name exec_program export_library_dependencies install_files install_programs install_targets load_command make_directory output_required_files remove subdir_depends subdirs use_mangled_mesa utility_source variable_requires write_file qt5_use_modules qt5_use_package qt5_wrap_cpp on off true false and or not command policy target test exists is_newer_than is_directory is_symlink is_absolute matches less greater equal less_equal greater_equal strless strgreater strequal strless_equal strgreater_equal version_less version_greater version_equal version_less_equal version_greater_equal in_list defined"
    ) },
    contains: [
      {
        className: "variable",
        begin: /\$\{/,
        end: /\}/
      },
      t.COMMENT(/#\[\[/, /]]/),
      t.HASH_COMMENT_MODE,
      t.QUOTE_STRING_MODE,
      t.NUMBER_MODE
    ]
  };
}
const Ym = [
  "as",
  // for exports
  "in",
  "of",
  "if",
  "for",
  "while",
  "finally",
  "var",
  "new",
  "function",
  "do",
  "return",
  "void",
  "else",
  "break",
  "catch",
  "instanceof",
  "with",
  "throw",
  "case",
  "default",
  "try",
  "switch",
  "continue",
  "typeof",
  "delete",
  "let",
  "yield",
  "const",
  "class",
  // JS handles these with a special rule
  // "get",
  // "set",
  "debugger",
  "async",
  "await",
  "static",
  "import",
  "from",
  "export",
  "extends",
  // It's reached stage 3, which is "recommended for implementation":
  "using"
], $m = [
  "true",
  "false",
  "null",
  "undefined",
  "NaN",
  "Infinity"
], Vm = [
  // Fundamental objects
  "Object",
  "Function",
  "Boolean",
  "Symbol",
  // numbers and dates
  "Math",
  "Date",
  "Number",
  "BigInt",
  // text
  "String",
  "RegExp",
  // Indexed collections
  "Array",
  "Float32Array",
  "Float64Array",
  "Int8Array",
  "Uint8Array",
  "Uint8ClampedArray",
  "Int16Array",
  "Int32Array",
  "Uint16Array",
  "Uint32Array",
  "BigInt64Array",
  "BigUint64Array",
  // Keyed collections
  "Set",
  "Map",
  "WeakSet",
  "WeakMap",
  // Structured data
  "ArrayBuffer",
  "SharedArrayBuffer",
  "Atomics",
  "DataView",
  "JSON",
  // Control abstraction objects
  "Promise",
  "Generator",
  "GeneratorFunction",
  "AsyncFunction",
  // Reflection
  "Reflect",
  "Proxy",
  // Internationalization
  "Intl",
  // WebAssembly
  "WebAssembly"
], Hm = [
  "Error",
  "EvalError",
  "InternalError",
  "RangeError",
  "ReferenceError",
  "SyntaxError",
  "TypeError",
  "URIError"
], qm = [
  "setInterval",
  "setTimeout",
  "clearInterval",
  "clearTimeout",
  "require",
  "exports",
  "eval",
  "isFinite",
  "isNaN",
  "parseFloat",
  "parseInt",
  "decodeURI",
  "decodeURIComponent",
  "encodeURI",
  "encodeURIComponent",
  "escape",
  "unescape"
], zm = [].concat(
  qm,
  Vm,
  Hm
);
function Wm(t) {
  const e = [
    "npm",
    "print"
  ], n = [
    "yes",
    "no",
    "on",
    "off"
  ], i = [
    "then",
    "unless",
    "until",
    "loop",
    "by",
    "when",
    "and",
    "or",
    "is",
    "isnt",
    "not"
  ], r = [
    "var",
    "const",
    "let",
    "function",
    "static"
  ], a = (g) => (S) => !g.includes(S), s = {
    keyword: Ym.concat(i).filter(a(r)),
    literal: $m.concat(n),
    built_in: zm.concat(e)
  }, o = "[A-Za-z$_][0-9A-Za-z$_]*", l = {
    className: "subst",
    begin: /#\{/,
    end: /\}/,
    keywords: s
  }, c = [
    t.BINARY_NUMBER_MODE,
    t.inherit(t.C_NUMBER_MODE, { starts: {
      end: "(\\s*/)?",
      relevance: 0
    } }),
    // a number tries to eat the following slash to prevent treating it as a regexp
    {
      className: "string",
      variants: [
        {
          begin: /'''/,
          end: /'''/,
          contains: [t.BACKSLASH_ESCAPE]
        },
        {
          begin: /'/,
          end: /'/,
          contains: [t.BACKSLASH_ESCAPE]
        },
        {
          begin: /"""/,
          end: /"""/,
          contains: [
            t.BACKSLASH_ESCAPE,
            l
          ]
        },
        {
          begin: /"/,
          end: /"/,
          contains: [
            t.BACKSLASH_ESCAPE,
            l
          ]
        }
      ]
    },
    {
      className: "regexp",
      variants: [
        {
          begin: "///",
          end: "///",
          contains: [
            l,
            t.HASH_COMMENT_MODE
          ]
        },
        {
          begin: "//[gim]{0,3}(?=\\W)",
          relevance: 0
        },
        {
          // regex can't start with space to parse x / 2 / 3 as two divisions
          // regex can't start with *, and it supports an "illegal" in the main mode
          begin: /\/(?![ *]).*?(?![\\]).\/[gim]{0,3}(?=\W)/
        }
      ]
    },
    {
      begin: "@" + o
      // relevance booster
    },
    {
      subLanguage: "javascript",
      excludeBegin: !0,
      excludeEnd: !0,
      variants: [
        {
          begin: "```",
          end: "```"
        },
        {
          begin: "`",
          end: "`"
        }
      ]
    }
  ];
  l.contains = c;
  const d = t.inherit(t.TITLE_MODE, { begin: o }), u = "(\\(.*\\)\\s*)?\\B[-=]>", _ = {
    className: "params",
    begin: "\\([^\\(]",
    returnBegin: !0,
    /* We need another contained nameless mode to not have every nested
    pair of parens to be called "params" */
    contains: [
      {
        begin: /\(/,
        end: /\)/,
        keywords: s,
        contains: ["self"].concat(c)
      }
    ]
  }, m = {
    variants: [
      { match: [
        /class\s+/,
        o,
        /\s+extends\s+/,
        o
      ] },
      { match: [
        /class\s+/,
        o
      ] }
    ],
    scope: {
      2: "title.class",
      4: "title.class.inherited"
    },
    keywords: s
  };
  return {
    name: "CoffeeScript",
    aliases: [
      "coffee",
      "cson",
      "iced"
    ],
    keywords: s,
    illegal: /\/\*/,
    contains: [
      ...c,
      t.COMMENT("###", "###"),
      t.HASH_COMMENT_MODE,
      {
        className: "function",
        begin: "^\\s*" + o + "\\s*=\\s*" + u,
        end: "[-=]>",
        returnBegin: !0,
        contains: [
          d,
          _
        ]
      },
      {
        // anonymous function start
        begin: /[:\(,=]\s*/,
        relevance: 0,
        contains: [
          {
            className: "function",
            begin: u,
            end: "[-=]>",
            returnBegin: !0,
            contains: [_]
          }
        ]
      },
      m,
      {
        begin: o + ":",
        end: ":",
        returnBegin: !0,
        returnEnd: !0,
        relevance: 0
      }
    ]
  };
}
function Km(t) {
  return {
    name: "Coq",
    keywords: {
      keyword: [
        "_|0",
        "as",
        "at",
        "cofix",
        "else",
        "end",
        "exists",
        "exists2",
        "fix",
        "for",
        "forall",
        "fun",
        "if",
        "IF",
        "in",
        "let",
        "match",
        "mod",
        "Prop",
        "return",
        "Set",
        "then",
        "Type",
        "using",
        "where",
        "with",
        "Abort",
        "About",
        "Add",
        "Admit",
        "Admitted",
        "All",
        "Arguments",
        "Assumptions",
        "Axiom",
        "Back",
        "BackTo",
        "Backtrack",
        "Bind",
        "Blacklist",
        "Canonical",
        "Cd",
        "Check",
        "Class",
        "Classes",
        "Close",
        "Coercion",
        "Coercions",
        "CoFixpoint",
        "CoInductive",
        "Collection",
        "Combined",
        "Compute",
        "Conjecture",
        "Conjectures",
        "Constant",
        "constr",
        "Constraint",
        "Constructors",
        "Context",
        "Corollary",
        "CreateHintDb",
        "Cut",
        "Declare",
        "Defined",
        "Definition",
        "Delimit",
        "Dependencies",
        "Dependent",
        "Derive",
        "Drop",
        "eauto",
        "End",
        "Equality",
        "Eval",
        "Example",
        "Existential",
        "Existentials",
        "Existing",
        "Export",
        "exporting",
        "Extern",
        "Extract",
        "Extraction",
        "Fact",
        "Field",
        "Fields",
        "File",
        "Fixpoint",
        "Focus",
        "for",
        "From",
        "Function",
        "Functional",
        "Generalizable",
        "Global",
        "Goal",
        "Grab",
        "Grammar",
        "Graph",
        "Guarded",
        "Heap",
        "Hint",
        "HintDb",
        "Hints",
        "Hypotheses",
        "Hypothesis",
        "ident",
        "Identity",
        "If",
        "Immediate",
        "Implicit",
        "Import",
        "Include",
        "Inductive",
        "Infix",
        "Info",
        "Initial",
        "Inline",
        "Inspect",
        "Instance",
        "Instances",
        "Intro",
        "Intros",
        "Inversion",
        "Inversion_clear",
        "Language",
        "Left",
        "Lemma",
        "Let",
        "Libraries",
        "Library",
        "Load",
        "LoadPath",
        "Local",
        "Locate",
        "Ltac",
        "ML",
        "Mode",
        "Module",
        "Modules",
        "Monomorphic",
        "Morphism",
        "Next",
        "NoInline",
        "Notation",
        "Obligation",
        "Obligations",
        "Opaque",
        "Open",
        "Optimize",
        "Options",
        "Parameter",
        "Parameters",
        "Parametric",
        "Path",
        "Paths",
        "pattern",
        "Polymorphic",
        "Preterm",
        "Print",
        "Printing",
        "Program",
        "Projections",
        "Proof",
        "Proposition",
        "Pwd",
        "Qed",
        "Quit",
        "Rec",
        "Record",
        "Recursive",
        "Redirect",
        "Relation",
        "Remark",
        "Remove",
        "Require",
        "Reserved",
        "Reset",
        "Resolve",
        "Restart",
        "Rewrite",
        "Right",
        "Ring",
        "Rings",
        "Save",
        "Scheme",
        "Scope",
        "Scopes",
        "Script",
        "Search",
        "SearchAbout",
        "SearchHead",
        "SearchPattern",
        "SearchRewrite",
        "Section",
        "Separate",
        "Set",
        "Setoid",
        "Show",
        "Solve",
        "Sorted",
        "Step",
        "Strategies",
        "Strategy",
        "Structure",
        "SubClass",
        "Table",
        "Tables",
        "Tactic",
        "Term",
        "Test",
        "Theorem",
        "Time",
        "Timeout",
        "Transparent",
        "Type",
        "Typeclasses",
        "Types",
        "Undelimit",
        "Undo",
        "Unfocus",
        "Unfocused",
        "Unfold",
        "Universe",
        "Universes",
        "Unset",
        "Unshelve",
        "using",
        "Variable",
        "Variables",
        "Variant",
        "Verbose",
        "Visibility",
        "where",
        "with"
      ],
      built_in: [
        "abstract",
        "absurd",
        "admit",
        "after",
        "apply",
        "as",
        "assert",
        "assumption",
        "at",
        "auto",
        "autorewrite",
        "autounfold",
        "before",
        "bottom",
        "btauto",
        "by",
        "case",
        "case_eq",
        "cbn",
        "cbv",
        "change",
        "classical_left",
        "classical_right",
        "clear",
        "clearbody",
        "cofix",
        "compare",
        "compute",
        "congruence",
        "constr_eq",
        "constructor",
        "contradict",
        "contradiction",
        "cut",
        "cutrewrite",
        "cycle",
        "decide",
        "decompose",
        "dependent",
        "destruct",
        "destruction",
        "dintuition",
        "discriminate",
        "discrR",
        "do",
        "double",
        "dtauto",
        "eapply",
        "eassumption",
        "eauto",
        "ecase",
        "econstructor",
        "edestruct",
        "ediscriminate",
        "eelim",
        "eexact",
        "eexists",
        "einduction",
        "einjection",
        "eleft",
        "elim",
        "elimtype",
        "enough",
        "equality",
        "erewrite",
        "eright",
        "esimplify_eq",
        "esplit",
        "evar",
        "exact",
        "exactly_once",
        "exfalso",
        "exists",
        "f_equal",
        "fail",
        "field",
        "field_simplify",
        "field_simplify_eq",
        "first",
        "firstorder",
        "fix",
        "fold",
        "fourier",
        "functional",
        "generalize",
        "generalizing",
        "gfail",
        "give_up",
        "has_evar",
        "hnf",
        "idtac",
        "in",
        "induction",
        "injection",
        "instantiate",
        "intro",
        "intro_pattern",
        "intros",
        "intuition",
        "inversion",
        "inversion_clear",
        "is_evar",
        "is_var",
        "lapply",
        "lazy",
        "left",
        "lia",
        "lra",
        "move",
        "native_compute",
        "nia",
        "nsatz",
        "omega",
        "once",
        "pattern",
        "pose",
        "progress",
        "proof",
        "psatz",
        "quote",
        "record",
        "red",
        "refine",
        "reflexivity",
        "remember",
        "rename",
        "repeat",
        "replace",
        "revert",
        "revgoals",
        "rewrite",
        "rewrite_strat",
        "right",
        "ring",
        "ring_simplify",
        "rtauto",
        "set",
        "setoid_reflexivity",
        "setoid_replace",
        "setoid_rewrite",
        "setoid_symmetry",
        "setoid_transitivity",
        "shelve",
        "shelve_unifiable",
        "simpl",
        "simple",
        "simplify_eq",
        "solve",
        "specialize",
        "split",
        "split_Rabs",
        "split_Rmult",
        "stepl",
        "stepr",
        "subst",
        "sum",
        "swap",
        "symmetry",
        "tactic",
        "tauto",
        "time",
        "timeout",
        "top",
        "transitivity",
        "trivial",
        "try",
        "tryif",
        "unfold",
        "unify",
        "until",
        "using",
        "vm_compute",
        "with"
      ]
    },
    contains: [
      t.QUOTE_STRING_MODE,
      t.COMMENT("\\(\\*", "\\*\\)"),
      t.C_NUMBER_MODE,
      {
        className: "type",
        excludeBegin: !0,
        begin: "\\|\\s*",
        end: "\\w+"
      },
      {
        // relevance booster
        begin: /[-=]>/
      }
    ]
  };
}
function Qm(t) {
  return {
    name: "Caché Object Script",
    case_insensitive: !0,
    aliases: ["cls"],
    keywords: "property parameter class classmethod clientmethod extends as break catch close continue do d|0 else elseif for goto halt hang h|0 if job j|0 kill k|0 lock l|0 merge new open quit q|0 read r|0 return set s|0 tcommit throw trollback try tstart use view while write w|0 xecute x|0 zkill znspace zn ztrap zwrite zw zzdump zzwrite print zbreak zinsert zload zprint zremove zsave zzprint mv mvcall mvcrt mvdim mvprint zquit zsync ascii",
    contains: [
      {
        className: "number",
        begin: "\\b(\\d+(\\.\\d*)?|\\.\\d+)",
        relevance: 0
      },
      {
        className: "string",
        variants: [
          {
            begin: '"',
            end: '"',
            contains: [
              {
                // escaped
                begin: '""',
                relevance: 0
              }
            ]
          }
        ]
      },
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      {
        className: "comment",
        begin: /;/,
        end: "$",
        relevance: 0
      },
      {
        // Functions and user-defined functions: write $ztime(60*60*3), $$myFunc(10), $$^Val(1)
        className: "built_in",
        begin: /(?:\$\$?|\.\.)\^?[a-zA-Z]+/
      },
      {
        // Macro command: quit $$$OK
        className: "built_in",
        begin: /\$\$\$[a-zA-Z]+/
      },
      {
        // Special (global) variables: write %request.Content; Built-in classes: %Library.Integer
        className: "built_in",
        begin: /%[a-z]+(?:\.[a-z]+)*/
      },
      {
        // Global variable: set ^globalName = 12 write ^globalName
        className: "symbol",
        begin: /\^%?[a-zA-Z][\w]*/
      },
      {
        // Some control constructions: do ##class(Package.ClassName).Method(), ##super()
        className: "keyword",
        begin: /##class|##super|#define|#dim/
      },
      // sub-languages: are not fully supported by hljs by 11/15/2015
      // left for the future implementation.
      {
        begin: /&sql\(/,
        end: /\)/,
        excludeBegin: !0,
        excludeEnd: !0,
        subLanguage: "sql"
      },
      {
        begin: /&(js|jscript|javascript)</,
        end: />/,
        excludeBegin: !0,
        excludeEnd: !0,
        subLanguage: "javascript"
      },
      {
        // this brakes first and last tag, but this is the only way to embed a valid html
        begin: /&html<\s*</,
        end: />\s*>/,
        subLanguage: "xml"
      }
    ]
  };
}
function Xm(t) {
  const e = "primitive rsc_template", n = "group clone ms master location colocation order fencing_topology rsc_ticket acl_target acl_group user role tag xml";
  return {
    name: "crmsh",
    aliases: [
      "crm",
      "pcmk"
    ],
    case_insensitive: !0,
    keywords: {
      keyword: "params meta operations op rule attributes utilization" + " " + "read write deny defined not_defined in_range date spec in ref reference attribute type xpath version and or lt gt tag lte gte eq ne \\" + " " + "number string",
      literal: "Master Started Slave Stopped start promote demote stop monitor true false"
    },
    contains: [
      t.HASH_COMMENT_MODE,
      {
        beginKeywords: "node",
        starts: {
          end: "\\s*([\\w_-]+:)?",
          starts: {
            className: "title",
            end: "\\s*[\\$\\w_][\\w_-]*"
          }
        }
      },
      {
        beginKeywords: e,
        starts: {
          className: "title",
          end: "\\s*[\\$\\w_][\\w_-]*",
          starts: { end: "\\s*@?[\\w_][\\w_\\.:-]*" }
        }
      },
      {
        begin: "\\b(" + n.split(" ").join("|") + ")\\s+",
        keywords: n,
        starts: {
          className: "title",
          end: "[\\$\\w_][\\w_-]*"
        }
      },
      {
        beginKeywords: "property rsc_defaults op_defaults",
        starts: {
          className: "title",
          end: "\\s*([\\w_-]+:)?"
        }
      },
      t.QUOTE_STRING_MODE,
      {
        className: "meta",
        begin: "(ocf|systemd|service|lsb):[\\w_:-]+",
        relevance: 0
      },
      {
        className: "number",
        begin: "\\b\\d+(\\.\\d+)?(ms|s|h|m)?",
        relevance: 0
      },
      {
        className: "literal",
        begin: "[-]?(infinity|inf)",
        relevance: 0
      },
      {
        className: "attr",
        begin: /([A-Za-z$_#][\w_-]+)=/,
        relevance: 0
      },
      {
        className: "tag",
        begin: "</?",
        end: "/?>",
        relevance: 0
      }
    ]
  };
}
function Zm(t) {
  const e = "(_?[ui](8|16|32|64|128))?", n = "(_?f(32|64))?", i = "[a-zA-Z_]\\w*[!?=]?", r = "[a-zA-Z_]\\w*[!?=]?|[-+~]@|<<|>>|[=!]~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~|]|//|//=|&[-+*]=?|&\\*\\*|\\[\\][=?]?", a = "[A-Za-z_]\\w*(::\\w+)*(\\?|!)?", s = {
    $pattern: i,
    keyword: "abstract alias annotation as as? asm begin break case class def do else elsif end ensure enum extend for fun if include instance_sizeof is_a? lib macro module next nil? of out pointerof private protected rescue responds_to? return require select self sizeof struct super then type typeof union uninitialized unless until verbatim when while with yield __DIR__ __END_LINE__ __FILE__ __LINE__",
    literal: "false nil true"
  }, o = {
    className: "subst",
    begin: /#\{/,
    end: /\}/,
    keywords: s
  }, l = {
    // negative-look forward attemps to prevent false matches like:
    // @ident@ or $ident$ that might indicate this is not ruby at all
    className: "variable",
    begin: "(\\$\\W)|((\\$|@@?)(\\w+))(?=[^@$?])(?![A-Za-z])(?![@$?'])"
  }, c = {
    className: "template-variable",
    variants: [
      {
        begin: "\\{\\{",
        end: "\\}\\}"
      },
      {
        begin: "\\{%",
        end: "%\\}"
      }
    ],
    keywords: s
  };
  function d(h, T) {
    const b = [
      {
        begin: h,
        end: T
      }
    ];
    return b[0].contains = b, b;
  }
  const u = {
    className: "string",
    contains: [
      t.BACKSLASH_ESCAPE,
      o
    ],
    variants: [
      {
        begin: /'/,
        end: /'/
      },
      {
        begin: /"/,
        end: /"/
      },
      {
        begin: /`/,
        end: /`/
      },
      {
        begin: "%[Qwi]?\\(",
        end: "\\)",
        contains: d("\\(", "\\)")
      },
      {
        begin: "%[Qwi]?\\[",
        end: "\\]",
        contains: d("\\[", "\\]")
      },
      {
        begin: "%[Qwi]?\\{",
        end: /\}/,
        contains: d(/\{/, /\}/)
      },
      {
        begin: "%[Qwi]?<",
        end: ">",
        contains: d("<", ">")
      },
      {
        begin: "%[Qwi]?\\|",
        end: "\\|"
      },
      {
        begin: /<<-\w+$/,
        end: /^\s*\w+$/
      }
    ],
    relevance: 0
  }, _ = {
    className: "string",
    variants: [
      {
        begin: "%q\\(",
        end: "\\)",
        contains: d("\\(", "\\)")
      },
      {
        begin: "%q\\[",
        end: "\\]",
        contains: d("\\[", "\\]")
      },
      {
        begin: "%q\\{",
        end: /\}/,
        contains: d(/\{/, /\}/)
      },
      {
        begin: "%q<",
        end: ">",
        contains: d("<", ">")
      },
      {
        begin: "%q\\|",
        end: "\\|"
      },
      {
        begin: /<<-'\w+'$/,
        end: /^\s*\w+$/
      }
    ],
    relevance: 0
  }, m = {
    begin: "(?!%\\})(" + t.RE_STARTERS_RE + "|\\n|\\b(case|if|select|unless|until|when|while)\\b)\\s*",
    keywords: "case if select unless until when while",
    contains: [
      {
        className: "regexp",
        contains: [
          t.BACKSLASH_ESCAPE,
          o
        ],
        variants: [
          {
            begin: "//[a-z]*",
            relevance: 0
          },
          {
            begin: "/(?!\\/)",
            end: "/[a-z]*"
          }
        ]
      }
    ],
    relevance: 0
  }, g = {
    className: "regexp",
    contains: [
      t.BACKSLASH_ESCAPE,
      o
    ],
    variants: [
      {
        begin: "%r\\(",
        end: "\\)",
        contains: d("\\(", "\\)")
      },
      {
        begin: "%r\\[",
        end: "\\]",
        contains: d("\\[", "\\]")
      },
      {
        begin: "%r\\{",
        end: /\}/,
        contains: d(/\{/, /\}/)
      },
      {
        begin: "%r<",
        end: ">",
        contains: d("<", ">")
      },
      {
        begin: "%r\\|",
        end: "\\|"
      }
    ],
    relevance: 0
  }, S = {
    className: "meta",
    begin: "@\\[",
    end: "\\]",
    contains: [t.inherit(t.QUOTE_STRING_MODE, { className: "string" })]
  }, E = [
    c,
    u,
    _,
    g,
    m,
    S,
    l,
    t.HASH_COMMENT_MODE,
    {
      className: "class",
      beginKeywords: "class module struct",
      end: "$|;",
      illegal: /=/,
      contains: [
        t.HASH_COMMENT_MODE,
        t.inherit(t.TITLE_MODE, { begin: a }),
        {
          // relevance booster for inheritance
          begin: "<"
        }
      ]
    },
    {
      className: "class",
      beginKeywords: "lib enum union",
      end: "$|;",
      illegal: /=/,
      contains: [
        t.HASH_COMMENT_MODE,
        t.inherit(t.TITLE_MODE, { begin: a })
      ]
    },
    {
      beginKeywords: "annotation",
      end: "$|;",
      illegal: /=/,
      contains: [
        t.HASH_COMMENT_MODE,
        t.inherit(t.TITLE_MODE, { begin: a })
      ],
      relevance: 2
    },
    {
      className: "function",
      beginKeywords: "def",
      end: /\B\b/,
      contains: [
        t.inherit(t.TITLE_MODE, {
          begin: r,
          endsParent: !0
        })
      ]
    },
    {
      className: "function",
      beginKeywords: "fun macro",
      end: /\B\b/,
      contains: [
        t.inherit(t.TITLE_MODE, {
          begin: r,
          endsParent: !0
        })
      ],
      relevance: 2
    },
    {
      className: "symbol",
      begin: t.UNDERSCORE_IDENT_RE + "(!|\\?)?:",
      relevance: 0
    },
    {
      className: "symbol",
      begin: ":",
      contains: [
        u,
        { begin: r }
      ],
      relevance: 0
    },
    {
      className: "number",
      variants: [
        { begin: "\\b0b([01_]+)" + e },
        { begin: "\\b0o([0-7_]+)" + e },
        { begin: "\\b0x([A-Fa-f0-9_]+)" + e },
        { begin: "\\b([1-9][0-9_]*[0-9]|[0-9])(\\.[0-9][0-9_]*)?([eE]_?[-+]?[0-9_]*)?" + n + "(?!_)" },
        { begin: "\\b([1-9][0-9_]*|0)" + e }
      ],
      relevance: 0
    }
  ];
  return o.contains = E, c.contains = E.slice(1), {
    name: "Crystal",
    aliases: ["cr"],
    keywords: s,
    contains: E
  };
}
function Jm(t) {
  return {
    name: "CSP",
    case_insensitive: !1,
    keywords: {
      $pattern: "[a-zA-Z][a-zA-Z0-9_-]*",
      keyword: [
        "base-uri",
        "child-src",
        "connect-src",
        "default-src",
        "font-src",
        "form-action",
        "frame-ancestors",
        "frame-src",
        "img-src",
        "manifest-src",
        "media-src",
        "object-src",
        "plugin-types",
        "report-uri",
        "sandbox",
        "script-src",
        "style-src",
        "trusted-types",
        "unsafe-hashes",
        "worker-src"
      ]
    },
    contains: [
      {
        className: "string",
        begin: "'",
        end: "'"
      },
      {
        className: "attribute",
        begin: "^Content",
        end: ":",
        excludeEnd: !0
      }
    ]
  };
}
function jm(t) {
  const e = {
    $pattern: t.UNDERSCORE_IDENT_RE,
    keyword: "abstract alias align asm assert auto body break byte case cast catch class const continue debug default delete deprecated do else enum export extern final finally for foreach foreach_reverse|10 goto if immutable import in inout int interface invariant is lazy macro mixin module new nothrow out override package pragma private protected public pure ref return scope shared static struct super switch synchronized template this throw try typedef typeid typeof union unittest version void volatile while with __FILE__ __LINE__ __gshared|10 __thread __traits __DATE__ __EOF__ __TIME__ __TIMESTAMP__ __VENDOR__ __VERSION__",
    built_in: "bool cdouble cent cfloat char creal dchar delegate double dstring float function idouble ifloat ireal long real short string ubyte ucent uint ulong ushort wchar wstring",
    literal: "false null true"
  }, n = "(0|[1-9][\\d_]*)", i = "(0|[1-9][\\d_]*|\\d[\\d_]*|[\\d_]+?\\d)", r = "0[bB][01_]+", a = "([\\da-fA-F][\\da-fA-F_]*|_[\\da-fA-F][\\da-fA-F_]*)", s = "0[xX]" + a, o = "([eE][+-]?" + i + ")", l = "(" + i + "(\\.\\d*|" + o + ")|\\d+\\." + i + "|\\." + n + o + "?)", c = "(0[xX](" + a + "\\." + a + "|\\.?" + a + ")[pP][+-]?" + i + ")", d = "(" + n + "|" + r + "|" + s + ")", u = "(" + c + "|" + l + ")", _ = `\\\\(['"\\?\\\\abfnrtv]|u[\\dA-Fa-f]{4}|[0-7]{1,3}|x[\\dA-Fa-f]{2}|U[\\dA-Fa-f]{8})|&[a-zA-Z\\d]{2,};`, m = {
    className: "number",
    begin: "\\b" + d + "(L|u|U|Lu|LU|uL|UL)?",
    relevance: 0
  }, g = {
    className: "number",
    begin: "\\b(" + u + "([fF]|L|i|[fF]i|Li)?|" + d + "(i|[fF]i|Li))",
    relevance: 0
  }, S = {
    className: "string",
    begin: "'(" + _ + "|.)",
    end: "'",
    illegal: "."
  }, h = {
    className: "string",
    begin: '"',
    contains: [{
      begin: _,
      relevance: 0
    }],
    end: '"[cwd]?'
  }, T = {
    className: "string",
    begin: '[rq]"',
    end: '"[cwd]?',
    relevance: 5
  }, b = {
    className: "string",
    begin: "`",
    end: "`[cwd]?"
  }, C = {
    className: "string",
    begin: 'x"[\\da-fA-F\\s\\n\\r]*"[cwd]?',
    relevance: 10
  }, y = {
    className: "string",
    begin: 'q"\\{',
    end: '\\}"'
  }, O = {
    className: "meta",
    begin: "^#!",
    end: "$",
    relevance: 5
  }, A = {
    className: "meta",
    begin: "#(line)",
    end: "$",
    relevance: 5
  }, I = {
    className: "keyword",
    begin: "@[a-zA-Z_][a-zA-Z_\\d]*"
  }, k = t.COMMENT(
    "\\/\\+",
    "\\+\\/",
    {
      contains: ["self"],
      relevance: 10
    }
  );
  return {
    name: "D",
    keywords: e,
    contains: [
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      k,
      C,
      h,
      T,
      b,
      y,
      g,
      m,
      S,
      O,
      A,
      I
    ]
  };
}
function eE(t) {
  const e = {
    className: "subst",
    variants: [{ begin: "\\$[A-Za-z0-9_]+" }]
  }, n = {
    className: "subst",
    variants: [
      {
        begin: /\$\{/,
        end: /\}/
      }
    ],
    keywords: "true false null this is new super"
  }, i = {
    className: "number",
    relevance: 0,
    variants: [
      { match: /\b[0-9][0-9_]*(\.[0-9][0-9_]*)?([eE][+-]?[0-9][0-9_]*)?\b/ },
      { match: /\b0[xX][0-9A-Fa-f][0-9A-Fa-f_]*\b/ }
    ]
  }, r = {
    className: "string",
    variants: [
      {
        begin: "r'''",
        end: "'''"
      },
      {
        begin: 'r"""',
        end: '"""'
      },
      {
        begin: "r'",
        end: "'",
        illegal: "\\n"
      },
      {
        begin: 'r"',
        end: '"',
        illegal: "\\n"
      },
      {
        begin: "'''",
        end: "'''",
        contains: [
          t.BACKSLASH_ESCAPE,
          e,
          n
        ]
      },
      {
        begin: '"""',
        end: '"""',
        contains: [
          t.BACKSLASH_ESCAPE,
          e,
          n
        ]
      },
      {
        begin: "'",
        end: "'",
        illegal: "\\n",
        contains: [
          t.BACKSLASH_ESCAPE,
          e,
          n
        ]
      },
      {
        begin: '"',
        end: '"',
        illegal: "\\n",
        contains: [
          t.BACKSLASH_ESCAPE,
          e,
          n
        ]
      }
    ]
  };
  n.contains = [
    i,
    r
  ];
  const a = [
    // dart:core
    "Comparable",
    "DateTime",
    "Duration",
    "Function",
    "Iterable",
    "Iterator",
    "List",
    "Map",
    "Match",
    "Object",
    "Pattern",
    "RegExp",
    "Set",
    "Stopwatch",
    "String",
    "StringBuffer",
    "StringSink",
    "Symbol",
    "Type",
    "Uri",
    "bool",
    "double",
    "int",
    "num",
    // dart:html
    "Element",
    "ElementList"
  ], s = a.map((c) => `${c}?`);
  return {
    name: "Dart",
    keywords: {
      keyword: [
        "abstract",
        "as",
        "assert",
        "async",
        "await",
        "base",
        "break",
        "case",
        "catch",
        "class",
        "const",
        "continue",
        "covariant",
        "default",
        "deferred",
        "do",
        "dynamic",
        "else",
        "enum",
        "export",
        "extends",
        "extension",
        "external",
        "factory",
        "false",
        "final",
        "finally",
        "for",
        "Function",
        "get",
        "hide",
        "if",
        "implements",
        "import",
        "in",
        "interface",
        "is",
        "late",
        "library",
        "mixin",
        "new",
        "null",
        "on",
        "operator",
        "part",
        "required",
        "rethrow",
        "return",
        "sealed",
        "set",
        "show",
        "static",
        "super",
        "switch",
        "sync",
        "this",
        "throw",
        "true",
        "try",
        "typedef",
        "var",
        "void",
        "when",
        "while",
        "with",
        "yield"
      ],
      built_in: a.concat(s).concat([
        // dart:core
        "Never",
        "Null",
        "dynamic",
        "print",
        // dart:html
        "document",
        "querySelector",
        "querySelectorAll",
        "window"
      ]),
      $pattern: /[A-Za-z][A-Za-z0-9_]*\??/
    },
    contains: [
      r,
      t.COMMENT(
        /\/\*\*(?!\/)/,
        /\*\//,
        {
          subLanguage: "markdown",
          relevance: 0
        }
      ),
      t.COMMENT(
        /\/{3,} ?/,
        /$/,
        { contains: [
          {
            subLanguage: "markdown",
            begin: ".",
            end: "$",
            relevance: 0
          }
        ] }
      ),
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      {
        className: "class",
        beginKeywords: "class interface",
        end: /\{/,
        excludeEnd: !0,
        contains: [
          { beginKeywords: "extends implements" },
          t.UNDERSCORE_TITLE_MODE
        ]
      },
      i,
      {
        className: "meta",
        begin: "@[A-Za-z]+"
      },
      {
        begin: "=>"
        // No markup, just a relevance booster
      }
    ]
  };
}
function tE(t) {
  const e = [
    "exports",
    "register",
    "file",
    "shl",
    "array",
    "record",
    "property",
    "for",
    "mod",
    "while",
    "set",
    "ally",
    "label",
    "uses",
    "raise",
    "not",
    "stored",
    "class",
    "safecall",
    "var",
    "interface",
    "or",
    "private",
    "static",
    "exit",
    "index",
    "inherited",
    "to",
    "else",
    "stdcall",
    "override",
    "shr",
    "asm",
    "far",
    "resourcestring",
    "finalization",
    "packed",
    "virtual",
    "out",
    "and",
    "protected",
    "library",
    "do",
    "xorwrite",
    "goto",
    "near",
    "function",
    "end",
    "div",
    "overload",
    "object",
    "unit",
    "begin",
    "string",
    "on",
    "inline",
    "repeat",
    "until",
    "destructor",
    "write",
    "message",
    "program",
    "with",
    "read",
    "initialization",
    "except",
    "default",
    "nil",
    "if",
    "case",
    "cdecl",
    "in",
    "downto",
    "threadvar",
    "of",
    "try",
    "pascal",
    "const",
    "external",
    "constructor",
    "type",
    "public",
    "then",
    "implementation",
    "finally",
    "published",
    "procedure",
    "absolute",
    "reintroduce",
    "operator",
    "as",
    "is",
    "abstract",
    "alias",
    "assembler",
    "bitpacked",
    "break",
    "continue",
    "cppdecl",
    "cvar",
    "enumerator",
    "experimental",
    "platform",
    "deprecated",
    "unimplemented",
    "dynamic",
    "export",
    "far16",
    "forward",
    "generic",
    "helper",
    "implements",
    "interrupt",
    "iochecks",
    "local",
    "name",
    "nodefault",
    "noreturn",
    "nostackframe",
    "oldfpccall",
    "otherwise",
    "saveregisters",
    "softfloat",
    "specialize",
    "strict",
    "unaligned",
    "varargs"
  ], n = [
    t.C_LINE_COMMENT_MODE,
    t.COMMENT(/\{/, /\}/, { relevance: 0 }),
    t.COMMENT(/\(\*/, /\*\)/, { relevance: 10 })
  ], i = {
    className: "meta",
    variants: [
      {
        begin: /\{\$/,
        end: /\}/
      },
      {
        begin: /\(\*\$/,
        end: /\*\)/
      }
    ]
  }, r = {
    className: "string",
    begin: /'/,
    end: /'/,
    contains: [{ begin: /''/ }]
  }, a = {
    className: "number",
    relevance: 0,
    // Source: https://www.freepascal.org/docs-html/ref/refse6.html
    variants: [
      {
        // Regular numbers, e.g., 123, 123.456.
        match: /\b\d[\d_]*(\.\d[\d_]*)?/
      },
      {
        // Hexadecimal notation, e.g., $7F.
        match: /\$[\dA-Fa-f_]+/
      },
      {
        // Hexadecimal literal with no digits
        match: /\$/,
        relevance: 0
      },
      {
        // Octal notation, e.g., &42.
        match: /&[0-7][0-7_]*/
      },
      {
        // Binary notation, e.g., %1010.
        match: /%[01_]+/
      },
      {
        // Binary literal with no digits
        match: /%/,
        relevance: 0
      }
    ]
  }, s = {
    className: "string",
    variants: [
      { match: /#\d[\d_]*/ },
      { match: /#\$[\dA-Fa-f][\dA-Fa-f_]*/ },
      { match: /#&[0-7][0-7_]*/ },
      { match: /#%[01][01_]*/ }
    ]
  }, o = {
    begin: t.IDENT_RE + "\\s*=\\s*class\\s*\\(",
    returnBegin: !0,
    contains: [t.TITLE_MODE]
  }, l = {
    className: "function",
    beginKeywords: "function constructor destructor procedure",
    end: /[:;]/,
    keywords: "function constructor|10 destructor|10 procedure|10",
    contains: [
      t.TITLE_MODE,
      {
        className: "params",
        begin: /\(/,
        end: /\)/,
        keywords: e,
        contains: [
          r,
          s,
          i
        ].concat(n)
      },
      i
    ].concat(n)
  };
  return {
    name: "Delphi",
    aliases: [
      "dpr",
      "dfm",
      "pas",
      "pascal"
    ],
    case_insensitive: !0,
    keywords: e,
    illegal: /"|\$[G-Zg-z]|\/\*|<\/|\|/,
    contains: [
      r,
      s,
      a,
      o,
      l,
      i
    ].concat(n)
  };
}
function nE(t) {
  const e = {
    begin: /\|[A-Za-z]+:?/,
    keywords: { name: "truncatewords removetags linebreaksbr yesno get_digit timesince random striptags filesizeformat escape linebreaks length_is ljust rjust cut urlize fix_ampersands title floatformat capfirst pprint divisibleby add make_list unordered_list urlencode timeuntil urlizetrunc wordcount stringformat linenumbers slice date dictsort dictsortreversed default_if_none pluralize lower join center default truncatewords_html upper length phone2numeric wordwrap time addslashes slugify first escapejs force_escape iriencode last safe safeseq truncatechars localize unlocalize localtime utc timezone" },
    contains: [
      t.QUOTE_STRING_MODE,
      t.APOS_STRING_MODE
    ]
  };
  return {
    name: "Django",
    aliases: ["jinja"],
    case_insensitive: !0,
    subLanguage: "xml",
    contains: [
      t.COMMENT(/\{%\s*comment\s*%\}/, /\{%\s*endcomment\s*%\}/),
      t.COMMENT(/\{#/, /#\}/),
      {
        className: "template-tag",
        begin: /\{%/,
        end: /%\}/,
        contains: [
          {
            className: "name",
            begin: /\w+/,
            keywords: { name: "comment endcomment load templatetag ifchanged endifchanged if endif firstof for endfor ifnotequal endifnotequal widthratio extends include spaceless endspaceless regroup ifequal endifequal ssi now with cycle url filter endfilter debug block endblock else autoescape endautoescape csrf_token empty elif endwith static trans blocktrans endblocktrans get_static_prefix get_media_prefix plural get_current_language language get_available_languages get_current_language_bidi get_language_info get_language_info_list localize endlocalize localtime endlocaltime timezone endtimezone get_current_timezone verbatim" },
            starts: {
              endsWithParent: !0,
              keywords: "in by as",
              contains: [e],
              relevance: 0
            }
          }
        ]
      },
      {
        className: "template-variable",
        begin: /\{\{/,
        end: /\}\}/,
        contains: [e]
      }
    ]
  };
}
function iE(t) {
  return {
    name: "DNS Zone",
    aliases: [
      "bind",
      "zone"
    ],
    keywords: [
      "IN",
      "A",
      "AAAA",
      "AFSDB",
      "APL",
      "CAA",
      "CDNSKEY",
      "CDS",
      "CERT",
      "CNAME",
      "DHCID",
      "DLV",
      "DNAME",
      "DNSKEY",
      "DS",
      "HIP",
      "IPSECKEY",
      "KEY",
      "KX",
      "LOC",
      "MX",
      "NAPTR",
      "NS",
      "NSEC",
      "NSEC3",
      "NSEC3PARAM",
      "PTR",
      "RRSIG",
      "RP",
      "SIG",
      "SOA",
      "SRV",
      "SSHFP",
      "TA",
      "TKEY",
      "TLSA",
      "TSIG",
      "TXT"
    ],
    contains: [
      t.COMMENT(";", "$", { relevance: 0 }),
      {
        className: "meta",
        begin: /^\$(TTL|GENERATE|INCLUDE|ORIGIN)\b/
      },
      // IPv6
      {
        className: "number",
        begin: "((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:)))\\b"
      },
      // IPv4
      {
        className: "number",
        begin: "((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\b"
      },
      t.inherit(t.NUMBER_MODE, { begin: /\b\d+[dhwm]?/ })
    ]
  };
}
function rE(t) {
  return {
    name: "Dockerfile",
    aliases: ["docker"],
    case_insensitive: !0,
    keywords: [
      "from",
      "maintainer",
      "expose",
      "env",
      "arg",
      "user",
      "onbuild",
      "stopsignal"
    ],
    contains: [
      t.HASH_COMMENT_MODE,
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE,
      t.NUMBER_MODE,
      {
        beginKeywords: "run cmd entrypoint volume add copy workdir label healthcheck shell",
        starts: {
          end: /[^\\]$/,
          subLanguage: "bash"
        }
      }
    ],
    illegal: "</"
  };
}
function aE(t) {
  const e = t.COMMENT(
    /^\s*@?rem\b/,
    /$/,
    { relevance: 10 }
  );
  return {
    name: "Batch file (DOS)",
    aliases: [
      "bat",
      "cmd"
    ],
    case_insensitive: !0,
    illegal: /\/\*/,
    keywords: {
      keyword: [
        "if",
        "else",
        "goto",
        "for",
        "in",
        "do",
        "call",
        "exit",
        "not",
        "exist",
        "errorlevel",
        "defined",
        "equ",
        "neq",
        "lss",
        "leq",
        "gtr",
        "geq"
      ],
      built_in: [
        "prn",
        "nul",
        "lpt3",
        "lpt2",
        "lpt1",
        "con",
        "com4",
        "com3",
        "com2",
        "com1",
        "aux",
        "shift",
        "cd",
        "dir",
        "echo",
        "setlocal",
        "endlocal",
        "set",
        "pause",
        "copy",
        "append",
        "assoc",
        "at",
        "attrib",
        "break",
        "cacls",
        "cd",
        "chcp",
        "chdir",
        "chkdsk",
        "chkntfs",
        "cls",
        "cmd",
        "color",
        "comp",
        "compact",
        "convert",
        "date",
        "dir",
        "diskcomp",
        "diskcopy",
        "doskey",
        "erase",
        "fs",
        "find",
        "findstr",
        "format",
        "ftype",
        "graftabl",
        "help",
        "keyb",
        "label",
        "md",
        "mkdir",
        "mode",
        "more",
        "move",
        "path",
        "pause",
        "print",
        "popd",
        "pushd",
        "promt",
        "rd",
        "recover",
        "rem",
        "rename",
        "replace",
        "restore",
        "rmdir",
        "shift",
        "sort",
        "start",
        "subst",
        "time",
        "title",
        "tree",
        "type",
        "ver",
        "verify",
        "vol",
        // winutils
        "ping",
        "net",
        "ipconfig",
        "taskkill",
        "xcopy",
        "ren",
        "del"
      ]
    },
    contains: [
      {
        className: "variable",
        begin: /%%[^ ]|%[^ ]+?%|![^ ]+?!/
      },
      {
        className: "function",
        begin: {
          begin: "^\\s*[A-Za-z._?][A-Za-z0-9_$#@~.?]*(:|\\s+label)"
        }.begin,
        end: "goto:eof",
        contains: [
          t.inherit(t.TITLE_MODE, { begin: "([_a-zA-Z]\\w*\\.)*([_a-zA-Z]\\w*:)?[_a-zA-Z]\\w*" }),
          e
        ]
      },
      {
        className: "number",
        begin: "\\b\\d+",
        relevance: 0
      },
      e
    ]
  };
}
function sE(t) {
  return {
    keywords: "dsconfig",
    contains: [
      {
        className: "keyword",
        begin: "^dsconfig",
        end: /\s/,
        excludeEnd: !0,
        relevance: 10
      },
      {
        className: "built_in",
        begin: /(list|create|get|set|delete)-(\w+)/,
        end: /\s/,
        excludeEnd: !0,
        illegal: "!@#$%^&*()",
        relevance: 10
      },
      {
        className: "built_in",
        begin: /--(\w+)/,
        end: /\s/,
        excludeEnd: !0
      },
      {
        className: "string",
        begin: /"/,
        end: /"/
      },
      {
        className: "string",
        begin: /'/,
        end: /'/
      },
      {
        className: "string",
        begin: /[\w\-?]+:\w+/,
        end: /\W/,
        relevance: 0
      },
      {
        className: "string",
        begin: /\w+(\-\w+)*/,
        end: /(?=\W)/,
        relevance: 0
      },
      t.HASH_COMMENT_MODE
    ]
  };
}
function oE(t) {
  const e = {
    className: "string",
    variants: [
      t.inherit(t.QUOTE_STRING_MODE, { begin: '((u8?|U)|L)?"' }),
      {
        begin: '(u8?|U)?R"',
        end: '"',
        contains: [t.BACKSLASH_ESCAPE]
      },
      {
        begin: "'\\\\?.",
        end: "'",
        illegal: "."
      }
    ]
  }, n = {
    className: "number",
    variants: [
      { begin: "\\b(\\d+(\\.\\d*)?|\\.\\d+)(u|U|l|L|ul|UL|f|F)" },
      { begin: t.C_NUMBER_RE }
    ],
    relevance: 0
  }, i = {
    className: "meta",
    begin: "#",
    end: "$",
    keywords: { keyword: "if else elif endif define undef ifdef ifndef" },
    contains: [
      {
        begin: /\\\n/,
        relevance: 0
      },
      {
        beginKeywords: "include",
        end: "$",
        keywords: { keyword: "include" },
        contains: [
          t.inherit(e, { className: "string" }),
          {
            className: "string",
            begin: "<",
            end: ">",
            illegal: "\\n"
          }
        ]
      },
      e,
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE
    ]
  }, r = {
    className: "variable",
    begin: /&[a-z\d_]*\b/
  }, a = {
    className: "keyword",
    begin: "/[a-z][a-z\\d-]*/"
  }, s = {
    className: "symbol",
    begin: "^\\s*[a-zA-Z_][a-zA-Z\\d_]*:"
  }, o = {
    className: "params",
    relevance: 0,
    begin: "<",
    end: ">",
    contains: [
      n,
      r
    ]
  }, l = {
    className: "title.class",
    begin: /[a-zA-Z_][a-zA-Z\d_@-]*(?=\s\{)/,
    relevance: 0.2
  }, c = {
    className: "title.class",
    begin: /^\/(?=\s*\{)/,
    relevance: 10
  }, d = {
    match: /[a-z][a-z-,]+(?=;)/,
    relevance: 0,
    scope: "attr"
  }, u = {
    relevance: 0,
    match: [
      /[a-z][a-z-,]+/,
      /\s*/,
      /=/
    ],
    scope: {
      1: "attr",
      3: "operator"
    }
  }, _ = {
    scope: "punctuation",
    relevance: 0,
    // `};` combined is just to avoid tons of useless punctuation nodes
    match: /\};|[;{}]/
  };
  return {
    name: "Device Tree",
    contains: [
      c,
      r,
      a,
      s,
      l,
      u,
      d,
      o,
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      n,
      e,
      i,
      _,
      {
        begin: t.IDENT_RE + "::",
        keywords: ""
      }
    ]
  };
}
function lE(t) {
  return {
    name: "Dust",
    aliases: ["dst"],
    case_insensitive: !0,
    subLanguage: "xml",
    contains: [
      {
        className: "template-tag",
        begin: /\{[#\/]/,
        end: /\}/,
        illegal: /;/,
        contains: [
          {
            className: "name",
            begin: /[a-zA-Z\.-]+/,
            starts: {
              endsWithParent: !0,
              relevance: 0,
              contains: [t.QUOTE_STRING_MODE]
            }
          }
        ]
      },
      {
        className: "template-variable",
        begin: /\{/,
        end: /\}/,
        illegal: /;/,
        keywords: "if eq ne lt lte gt gte select default math sep"
      }
    ]
  };
}
function cE(t) {
  const e = t.COMMENT(/\(\*/, /\*\)/), n = {
    className: "attribute",
    begin: /^[ ]*[a-zA-Z]+([\s_-]+[a-zA-Z]+)*/
  }, r = {
    begin: /=/,
    end: /[.;]/,
    contains: [
      e,
      {
        className: "meta",
        begin: /\?.*\?/
      },
      {
        // terminals
        className: "string",
        variants: [
          t.APOS_STRING_MODE,
          t.QUOTE_STRING_MODE,
          {
            begin: "`",
            end: "`"
          }
        ]
      }
    ]
  };
  return {
    name: "Extended Backus-Naur Form",
    illegal: /\S/,
    contains: [
      e,
      n,
      r
    ]
  };
}
function dE(t) {
  const e = t.regex, n = "[a-zA-Z_][a-zA-Z0-9_.]*(!|\\?)?", i = "[a-zA-Z_]\\w*[!?=]?|[-+~]@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?", s = {
    $pattern: n,
    keyword: [
      "after",
      "alias",
      "and",
      "case",
      "catch",
      "cond",
      "defstruct",
      "defguard",
      "do",
      "else",
      "end",
      "fn",
      "for",
      "if",
      "import",
      "in",
      "not",
      "or",
      "quote",
      "raise",
      "receive",
      "require",
      "reraise",
      "rescue",
      "try",
      "unless",
      "unquote",
      "unquote_splicing",
      "use",
      "when",
      "with|0"
    ],
    literal: [
      "false",
      "nil",
      "true"
    ]
  }, o = {
    className: "subst",
    begin: /#\{/,
    end: /\}/,
    keywords: s
  }, l = {
    className: "number",
    begin: "(\\b0o[0-7_]+)|(\\b0b[01_]+)|(\\b0x[0-9a-fA-F_]+)|(-?\\b[0-9][0-9_]*(\\.[0-9_]+([eE][-+]?[0-9]+)?)?)",
    relevance: 0
  }, d = {
    match: /\\[\s\S]/,
    scope: "char.escape",
    relevance: 0
  }, u = `[/|([{<"']`, _ = [
    {
      begin: /"/,
      end: /"/
    },
    {
      begin: /'/,
      end: /'/
    },
    {
      begin: /\//,
      end: /\//
    },
    {
      begin: /\|/,
      end: /\|/
    },
    {
      begin: /\(/,
      end: /\)/
    },
    {
      begin: /\[/,
      end: /\]/
    },
    {
      begin: /\{/,
      end: /\}/
    },
    {
      begin: /</,
      end: />/
    }
  ], m = (y) => ({
    scope: "char.escape",
    begin: e.concat(/\\/, y),
    relevance: 0
  }), g = {
    className: "string",
    begin: "~[a-z](?=" + u + ")",
    contains: _.map((y) => t.inherit(
      y,
      { contains: [
        m(y.end),
        d,
        o
      ] }
    ))
  }, S = {
    className: "string",
    begin: "~[A-Z](?=" + u + ")",
    contains: _.map((y) => t.inherit(
      y,
      { contains: [m(y.end)] }
    ))
  }, E = {
    className: "regex",
    variants: [
      {
        begin: "~r(?=" + u + ")",
        contains: _.map((y) => t.inherit(
          y,
          {
            end: e.concat(y.end, /[uismxfU]{0,7}/),
            contains: [
              m(y.end),
              d,
              o
            ]
          }
        ))
      },
      {
        begin: "~R(?=" + u + ")",
        contains: _.map(
          (y) => t.inherit(
            y,
            {
              end: e.concat(y.end, /[uismxfU]{0,7}/),
              contains: [m(y.end)]
            }
          )
        )
      }
    ]
  }, h = {
    className: "string",
    contains: [
      t.BACKSLASH_ESCAPE,
      o
    ],
    variants: [
      {
        begin: /"""/,
        end: /"""/
      },
      {
        begin: /'''/,
        end: /'''/
      },
      {
        begin: /~S"""/,
        end: /"""/,
        contains: []
        // override default
      },
      {
        begin: /~S"/,
        end: /"/,
        contains: []
        // override default
      },
      {
        begin: /~S'''/,
        end: /'''/,
        contains: []
        // override default
      },
      {
        begin: /~S'/,
        end: /'/,
        contains: []
        // override default
      },
      {
        begin: /'/,
        end: /'/
      },
      {
        begin: /"/,
        end: /"/
      }
    ]
  }, T = {
    className: "function",
    beginKeywords: "def defp defmacro defmacrop",
    end: /\B\b/,
    // the mode is ended by the title
    contains: [
      t.inherit(t.TITLE_MODE, {
        begin: n,
        endsParent: !0
      })
    ]
  }, b = t.inherit(T, {
    className: "class",
    beginKeywords: "defimpl defmodule defprotocol defrecord",
    end: /\bdo\b|$|;/
  }), C = [
    h,
    E,
    S,
    g,
    t.HASH_COMMENT_MODE,
    b,
    T,
    { begin: "::" },
    {
      className: "symbol",
      begin: ":(?![\\s:])",
      contains: [
        h,
        { begin: i }
      ],
      relevance: 0
    },
    {
      className: "symbol",
      begin: n + ":(?!:)",
      relevance: 0
    },
    {
      // Usage of a module, struct, etc.
      className: "title.class",
      begin: /(\b[A-Z][a-zA-Z0-9_]+)/,
      relevance: 0
    },
    l,
    {
      className: "variable",
      begin: "(\\$\\W)|((\\$|@@?)(\\w+))"
    }
    // -> has been removed, capnproto always uses this grammar construct
  ];
  return o.contains = C, {
    name: "Elixir",
    aliases: [
      "ex",
      "exs"
    ],
    keywords: s,
    contains: C
  };
}
function uE(t) {
  const e = { variants: [
    t.COMMENT("--", "$"),
    t.COMMENT(
      /\{-/,
      /-\}/,
      { contains: ["self"] }
    )
  ] }, n = {
    className: "type",
    begin: "\\b[A-Z][\\w']*",
    // TODO: other constructors (built-in, infix).
    relevance: 0
  }, i = {
    begin: "\\(",
    end: "\\)",
    illegal: '"',
    contains: [
      {
        className: "type",
        begin: "\\b[A-Z][\\w]*(\\((\\.\\.|,|\\w+)\\))?"
      },
      e
    ]
  }, r = {
    begin: /\{/,
    end: /\}/,
    contains: i.contains
  }, a = {
    className: "string",
    begin: "'\\\\?.",
    end: "'",
    illegal: "."
  };
  return {
    name: "Elm",
    keywords: [
      "let",
      "in",
      "if",
      "then",
      "else",
      "case",
      "of",
      "where",
      "module",
      "import",
      "exposing",
      "type",
      "alias",
      "as",
      "infix",
      "infixl",
      "infixr",
      "port",
      "effect",
      "command",
      "subscription"
    ],
    contains: [
      // Top-level constructions.
      {
        beginKeywords: "port effect module",
        end: "exposing",
        keywords: "port effect module where command subscription exposing",
        contains: [
          i,
          e
        ],
        illegal: "\\W\\.|;"
      },
      {
        begin: "import",
        end: "$",
        keywords: "import as exposing",
        contains: [
          i,
          e
        ],
        illegal: "\\W\\.|;"
      },
      {
        begin: "type",
        end: "$",
        keywords: "type alias",
        contains: [
          n,
          i,
          r,
          e
        ]
      },
      {
        beginKeywords: "infix infixl infixr",
        end: "$",
        contains: [
          t.C_NUMBER_MODE,
          e
        ]
      },
      {
        begin: "port",
        end: "$",
        keywords: "port",
        contains: [e]
      },
      // Literals and names.
      a,
      t.QUOTE_STRING_MODE,
      t.C_NUMBER_MODE,
      n,
      t.inherit(t.TITLE_MODE, { begin: "^[_a-z][\\w']*" }),
      e,
      {
        // No markup, relevance booster
        begin: "->|<-"
      }
    ],
    illegal: /;/
  };
}
function _E(t) {
  return {
    name: "ERB",
    subLanguage: "xml",
    contains: [
      t.COMMENT("<%#", "%>"),
      {
        begin: "<%[%=-]?",
        end: "[%-]?%>",
        subLanguage: "ruby",
        excludeBegin: !0,
        excludeEnd: !0
      }
    ]
  };
}
function pE(t) {
  const e = "[a-z'][a-zA-Z0-9_']*", n = "(" + e + ":" + e + "|" + e + ")", i = {
    keyword: "after and andalso|10 band begin bnot bor bsl bzr bxor case catch cond div end fun if let not of orelse|10 query receive rem try when xor maybe else",
    literal: "false true"
  }, r = t.COMMENT("%", "$"), a = {
    className: "number",
    begin: "\\b(\\d+(_\\d+)*#[a-fA-F0-9]+(_[a-fA-F0-9]+)*|\\d+(_\\d+)*(\\.\\d+(_\\d+)*)?([eE][-+]?\\d+)?)",
    relevance: 0
  }, s = { begin: "fun\\s+" + e + "/\\d+" }, o = {
    begin: n + "\\(",
    end: "\\)",
    returnBegin: !0,
    relevance: 0,
    contains: [
      {
        begin: n,
        relevance: 0
      },
      {
        begin: "\\(",
        end: "\\)",
        endsWithParent: !0,
        returnEnd: !0,
        relevance: 0
        // "contains" defined later
      }
    ]
  }, l = {
    begin: /\{/,
    end: /\}/,
    relevance: 0
    // "contains" defined later
  }, c = {
    begin: "\\b_([A-Z][A-Za-z0-9_]*)?",
    relevance: 0
  }, d = {
    begin: "[A-Z][a-zA-Z0-9_]*",
    relevance: 0
  }, u = {
    begin: "#" + t.UNDERSCORE_IDENT_RE,
    relevance: 0,
    returnBegin: !0,
    contains: [
      {
        begin: "#" + t.UNDERSCORE_IDENT_RE,
        relevance: 0
      },
      {
        begin: /\{/,
        end: /\}/,
        relevance: 0
        // "contains" defined later
      }
    ]
  }, _ = {
    scope: "string",
    match: /\$(\\([^0-9]|[0-9]{1,3}|)|.)/
  }, m = {
    scope: "string",
    match: /"""("*)(?!")[\s\S]*?"""\1/
  }, g = {
    scope: "string",
    contains: [t.BACKSLASH_ESCAPE],
    variants: [
      { match: /~\w?"""("*)(?!")[\s\S]*?"""\1/ },
      { begin: /~\w?\(/, end: /\)/ },
      { begin: /~\w?\[/, end: /\]/ },
      { begin: /~\w?{/, end: /}/ },
      { begin: /~\w?</, end: />/ },
      { begin: /~\w?\//, end: /\// },
      { begin: /~\w?\|/, end: /\|/ },
      { begin: /~\w?'/, end: /'/ },
      { begin: /~\w?"/, end: /"/ },
      { begin: /~\w?`/, end: /`/ },
      { begin: /~\w?#/, end: /#/ }
    ]
  }, S = {
    beginKeywords: "fun receive if try case maybe",
    end: "end",
    keywords: i
  };
  S.contains = [
    r,
    s,
    t.inherit(t.APOS_STRING_MODE, { className: "" }),
    S,
    o,
    g,
    m,
    t.QUOTE_STRING_MODE,
    a,
    l,
    c,
    d,
    u,
    _
  ];
  const E = [
    r,
    s,
    S,
    o,
    g,
    m,
    t.QUOTE_STRING_MODE,
    a,
    l,
    c,
    d,
    u,
    _
  ];
  o.contains[1].contains = E, l.contains = E, u.contains[1].contains = E;
  const h = [
    "-module",
    "-record",
    "-undef",
    "-export",
    "-ifdef",
    "-ifndef",
    "-author",
    "-copyright",
    "-doc",
    "-moduledoc",
    "-vsn",
    "-import",
    "-include",
    "-include_lib",
    "-compile",
    "-define",
    "-else",
    "-endif",
    "-file",
    "-behaviour",
    "-behavior",
    "-spec",
    "-on_load",
    "-nifs"
  ], T = {
    className: "params",
    begin: "\\(",
    end: "\\)",
    contains: E
  };
  return {
    name: "Erlang",
    aliases: ["erl"],
    keywords: i,
    illegal: "(</|\\*=|\\+=|-=|/\\*|\\*/|\\(\\*|\\*\\))",
    contains: [
      {
        className: "function",
        begin: "^" + e + "\\s*\\(",
        end: "->",
        returnBegin: !0,
        illegal: "\\(|#|//|/\\*|\\\\|:|;",
        contains: [
          T,
          t.inherit(t.TITLE_MODE, { begin: e })
        ],
        starts: {
          end: ";|\\.",
          keywords: i,
          contains: E
        }
      },
      r,
      {
        begin: "^-",
        end: "\\.",
        relevance: 0,
        excludeEnd: !0,
        returnBegin: !0,
        keywords: {
          $pattern: "-" + t.IDENT_RE,
          keyword: h.map((b) => `${b}|1.5`).join(" ")
        },
        contains: [
          T,
          g,
          m,
          t.QUOTE_STRING_MODE
        ]
      },
      a,
      g,
      m,
      t.QUOTE_STRING_MODE,
      u,
      c,
      d,
      l,
      _,
      { begin: /\.$/ }
      // relevance booster
    ]
  };
}
function mE(t) {
  const e = t.regex;
  return {
    name: "Erlang REPL",
    keywords: {
      built_in: "spawn spawn_link self",
      keyword: "after and andalso|10 band begin bnot bor bsl bsr bxor case catch cond div end fun if let not of or orelse|10 query receive rem try when xor"
    },
    contains: [
      {
        className: "meta.prompt",
        begin: "^[0-9]+> ",
        relevance: 10
      },
      t.COMMENT("%", "$"),
      {
        className: "number",
        begin: "\\b(\\d+(_\\d+)*#[a-fA-F0-9]+(_[a-fA-F0-9]+)*|\\d+(_\\d+)*(\\.\\d+(_\\d+)*)?([eE][-+]?\\d+)?)",
        relevance: 0
      },
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE,
      { begin: e.concat(
        /\?(::)?/,
        /([A-Z]\w*)/,
        // at least one identifier
        /((::)[A-Z]\w*)*/
        // perhaps more
      ) },
      { begin: "->" },
      { begin: "ok" },
      { begin: "!" },
      {
        begin: "(\\b[a-z'][a-zA-Z0-9_']*:[a-z'][a-zA-Z0-9_']*)|(\\b[a-z'][a-zA-Z0-9_']*)",
        relevance: 0
      },
      {
        begin: "[A-Z][a-zA-Z0-9_']*",
        relevance: 0
      }
    ]
  };
}
function EE(t) {
  return {
    name: "Excel formulae",
    aliases: [
      "xlsx",
      "xls"
    ],
    case_insensitive: !0,
    keywords: {
      $pattern: /[a-zA-Z][\w\.]*/,
      built_in: [
        "ABS",
        "ACCRINT",
        "ACCRINTM",
        "ACOS",
        "ACOSH",
        "ACOT",
        "ACOTH",
        "AGGREGATE",
        "ADDRESS",
        "AMORDEGRC",
        "AMORLINC",
        "AND",
        "ARABIC",
        "AREAS",
        "ARRAYTOTEXT",
        "ASC",
        "ASIN",
        "ASINH",
        "ATAN",
        "ATAN2",
        "ATANH",
        "AVEDEV",
        "AVERAGE",
        "AVERAGEA",
        "AVERAGEIF",
        "AVERAGEIFS",
        "BAHTTEXT",
        "BASE",
        "BESSELI",
        "BESSELJ",
        "BESSELK",
        "BESSELY",
        "BETADIST",
        "BETA.DIST",
        "BETAINV",
        "BETA.INV",
        "BIN2DEC",
        "BIN2HEX",
        "BIN2OCT",
        "BINOMDIST",
        "BINOM.DIST",
        "BINOM.DIST.RANGE",
        "BINOM.INV",
        "BITAND",
        "BITLSHIFT",
        "BITOR",
        "BITRSHIFT",
        "BITXOR",
        "BYCOL",
        "BYROW",
        "CALL",
        "CEILING",
        "CEILING.MATH",
        "CEILING.PRECISE",
        "CELL",
        "CHAR",
        "CHIDIST",
        "CHIINV",
        "CHITEST",
        "CHISQ.DIST",
        "CHISQ.DIST.RT",
        "CHISQ.INV",
        "CHISQ.INV.RT",
        "CHISQ.TEST",
        "CHOOSE",
        "CHOOSECOLS",
        "CHOOSEROWS",
        "CLEAN",
        "CODE",
        "COLUMN",
        "COLUMNS",
        "COMBIN",
        "COMBINA",
        "COMPLEX",
        "CONCAT",
        "CONCATENATE",
        "CONFIDENCE",
        "CONFIDENCE.NORM",
        "CONFIDENCE.T",
        "CONVERT",
        "CORREL",
        "COS",
        "COSH",
        "COT",
        "COTH",
        "COUNT",
        "COUNTA",
        "COUNTBLANK",
        "COUNTIF",
        "COUNTIFS",
        "COUPDAYBS",
        "COUPDAYS",
        "COUPDAYSNC",
        "COUPNCD",
        "COUPNUM",
        "COUPPCD",
        "COVAR",
        "COVARIANCE.P",
        "COVARIANCE.S",
        "CRITBINOM",
        "CSC",
        "CSCH",
        "CUBEKPIMEMBER",
        "CUBEMEMBER",
        "CUBEMEMBERPROPERTY",
        "CUBERANKEDMEMBER",
        "CUBESET",
        "CUBESETCOUNT",
        "CUBEVALUE",
        "CUMIPMT",
        "CUMPRINC",
        "DATE",
        "DATEDIF",
        "DATEVALUE",
        "DAVERAGE",
        "DAY",
        "DAYS",
        "DAYS360",
        "DB",
        "DBCS",
        "DCOUNT",
        "DCOUNTA",
        "DDB",
        "DEC2BIN",
        "DEC2HEX",
        "DEC2OCT",
        "DECIMAL",
        "DEGREES",
        "DELTA",
        "DEVSQ",
        "DGET",
        "DISC",
        "DMAX",
        "DMIN",
        "DOLLAR",
        "DOLLARDE",
        "DOLLARFR",
        "DPRODUCT",
        "DROP",
        "DSTDEV",
        "DSTDEVP",
        "DSUM",
        "DURATION",
        "DVAR",
        "DVARP",
        "EDATE",
        "EFFECT",
        "ENCODEURL",
        "EOMONTH",
        "ERF",
        "ERF.PRECISE",
        "ERFC",
        "ERFC.PRECISE",
        "ERROR.TYPE",
        "EUROCONVERT",
        "EVEN",
        "EXACT",
        "EXP",
        "EXPAND",
        "EXPON.DIST",
        "EXPONDIST",
        "FACT",
        "FACTDOUBLE",
        "FALSE",
        "F.DIST",
        "FDIST",
        "F.DIST.RT",
        "FILTER",
        "FILTERXML",
        "FIND",
        "FINDB",
        "F.INV",
        "F.INV.RT",
        "FINV",
        "FISHER",
        "FISHERINV",
        "FIXED",
        "FLOOR",
        "FLOOR.MATH",
        "FLOOR.PRECISE",
        "FORECAST",
        "FORECAST.ETS",
        "FORECAST.ETS.CONFINT",
        "FORECAST.ETS.SEASONALITY",
        "FORECAST.ETS.STAT",
        "FORECAST.LINEAR",
        "FORMULATEXT",
        "FREQUENCY",
        "F.TEST",
        "FTEST",
        "FV",
        "FVSCHEDULE",
        "GAMMA",
        "GAMMA.DIST",
        "GAMMADIST",
        "GAMMA.INV",
        "GAMMAINV",
        "GAMMALN",
        "GAMMALN.PRECISE",
        "GAUSS",
        "GCD",
        "GEOMEAN",
        "GESTEP",
        "GETPIVOTDATA",
        "GROWTH",
        "HARMEAN",
        "HEX2BIN",
        "HEX2DEC",
        "HEX2OCT",
        "HLOOKUP",
        "HOUR",
        "HSTACK",
        "HYPERLINK",
        "HYPGEOM.DIST",
        "HYPGEOMDIST",
        "IF",
        "IFERROR",
        "IFNA",
        "IFS",
        "IMABS",
        "IMAGE",
        "IMAGINARY",
        "IMARGUMENT",
        "IMCONJUGATE",
        "IMCOS",
        "IMCOSH",
        "IMCOT",
        "IMCSC",
        "IMCSCH",
        "IMDIV",
        "IMEXP",
        "IMLN",
        "IMLOG10",
        "IMLOG2",
        "IMPOWER",
        "IMPRODUCT",
        "IMREAL",
        "IMSEC",
        "IMSECH",
        "IMSIN",
        "IMSINH",
        "IMSQRT",
        "IMSUB",
        "IMSUM",
        "IMTAN",
        "INDEX",
        "INDIRECT",
        "INFO",
        "INT",
        "INTERCEPT",
        "INTRATE",
        "IPMT",
        "IRR",
        "ISBLANK",
        "ISERR",
        "ISERROR",
        "ISEVEN",
        "ISFORMULA",
        "ISLOGICAL",
        "ISNA",
        "ISNONTEXT",
        "ISNUMBER",
        "ISODD",
        "ISOMITTED",
        "ISREF",
        "ISTEXT",
        "ISO.CEILING",
        "ISOWEEKNUM",
        "ISPMT",
        "JIS",
        "KURT",
        "LAMBDA",
        "LARGE",
        "LCM",
        "LEFT",
        "LEFTB",
        "LEN",
        "LENB",
        "LET",
        "LINEST",
        "LN",
        "LOG",
        "LOG10",
        "LOGEST",
        "LOGINV",
        "LOGNORM.DIST",
        "LOGNORMDIST",
        "LOGNORM.INV",
        "LOOKUP",
        "LOWER",
        "MAKEARRAY",
        "MAP",
        "MATCH",
        "MAX",
        "MAXA",
        "MAXIFS",
        "MDETERM",
        "MDURATION",
        "MEDIAN",
        "MID",
        "MIDB",
        "MIN",
        "MINIFS",
        "MINA",
        "MINUTE",
        "MINVERSE",
        "MIRR",
        "MMULT",
        "MOD",
        "MODE",
        "MODE.MULT",
        "MODE.SNGL",
        "MONTH",
        "MROUND",
        "MULTINOMIAL",
        "MUNIT",
        "N",
        "NA",
        "NEGBINOM.DIST",
        "NEGBINOMDIST",
        "NETWORKDAYS",
        "NETWORKDAYS.INTL",
        "NOMINAL",
        "NORM.DIST",
        "NORMDIST",
        "NORMINV",
        "NORM.INV",
        "NORM.S.DIST",
        "NORMSDIST",
        "NORM.S.INV",
        "NORMSINV",
        "NOT",
        "NOW",
        "NPER",
        "NPV",
        "NUMBERVALUE",
        "OCT2BIN",
        "OCT2DEC",
        "OCT2HEX",
        "ODD",
        "ODDFPRICE",
        "ODDFYIELD",
        "ODDLPRICE",
        "ODDLYIELD",
        "OFFSET",
        "OR",
        "PDURATION",
        "PEARSON",
        "PERCENTILE.EXC",
        "PERCENTILE.INC",
        "PERCENTILE",
        "PERCENTRANK.EXC",
        "PERCENTRANK.INC",
        "PERCENTRANK",
        "PERMUT",
        "PERMUTATIONA",
        "PHI",
        "PHONETIC",
        "PI",
        "PMT",
        "POISSON.DIST",
        "POISSON",
        "POWER",
        "PPMT",
        "PRICE",
        "PRICEDISC",
        "PRICEMAT",
        "PROB",
        "PRODUCT",
        "PROPER",
        "PV",
        "QUARTILE",
        "QUARTILE.EXC",
        "QUARTILE.INC",
        "QUOTIENT",
        "RADIANS",
        "RAND",
        "RANDARRAY",
        "RANDBETWEEN",
        "RANK.AVG",
        "RANK.EQ",
        "RANK",
        "RATE",
        "RECEIVED",
        "REDUCE",
        "REGISTER.ID",
        "REPLACE",
        "REPLACEB",
        "REPT",
        "RIGHT",
        "RIGHTB",
        "ROMAN",
        "ROUND",
        "ROUNDDOWN",
        "ROUNDUP",
        "ROW",
        "ROWS",
        "RRI",
        "RSQ",
        "RTD",
        "SCAN",
        "SEARCH",
        "SEARCHB",
        "SEC",
        "SECH",
        "SECOND",
        "SEQUENCE",
        "SERIESSUM",
        "SHEET",
        "SHEETS",
        "SIGN",
        "SIN",
        "SINH",
        "SKEW",
        "SKEW.P",
        "SLN",
        "SLOPE",
        "SMALL",
        "SORT",
        "SORTBY",
        "SQRT",
        "SQRTPI",
        "SQL.REQUEST",
        "STANDARDIZE",
        "STOCKHISTORY",
        "STDEV",
        "STDEV.P",
        "STDEV.S",
        "STDEVA",
        "STDEVP",
        "STDEVPA",
        "STEYX",
        "SUBSTITUTE",
        "SUBTOTAL",
        "SUM",
        "SUMIF",
        "SUMIFS",
        "SUMPRODUCT",
        "SUMSQ",
        "SUMX2MY2",
        "SUMX2PY2",
        "SUMXMY2",
        "SWITCH",
        "SYD",
        "T",
        "TAN",
        "TANH",
        "TAKE",
        "TBILLEQ",
        "TBILLPRICE",
        "TBILLYIELD",
        "T.DIST",
        "T.DIST.2T",
        "T.DIST.RT",
        "TDIST",
        "TEXT",
        "TEXTAFTER",
        "TEXTBEFORE",
        "TEXTJOIN",
        "TEXTSPLIT",
        "TIME",
        "TIMEVALUE",
        "T.INV",
        "T.INV.2T",
        "TINV",
        "TOCOL",
        "TOROW",
        "TODAY",
        "TRANSPOSE",
        "TREND",
        "TRIM",
        "TRIMMEAN",
        "TRUE",
        "TRUNC",
        "T.TEST",
        "TTEST",
        "TYPE",
        "UNICHAR",
        "UNICODE",
        "UNIQUE",
        "UPPER",
        "VALUE",
        "VALUETOTEXT",
        "VAR",
        "VAR.P",
        "VAR.S",
        "VARA",
        "VARP",
        "VARPA",
        "VDB",
        "VLOOKUP",
        "VSTACK",
        "WEBSERVICE",
        "WEEKDAY",
        "WEEKNUM",
        "WEIBULL",
        "WEIBULL.DIST",
        "WORKDAY",
        "WORKDAY.INTL",
        "WRAPCOLS",
        "WRAPROWS",
        "XIRR",
        "XLOOKUP",
        "XMATCH",
        "XNPV",
        "XOR",
        "YEAR",
        "YEARFRAC",
        "YIELD",
        "YIELDDISC",
        "YIELDMAT",
        "Z.TEST",
        "ZTEST"
      ]
    },
    contains: [
      {
        /* matches a beginning equal sign found in Excel formula examples */
        begin: /^=/,
        end: /[^=]/,
        returnEnd: !0,
        illegal: /=/,
        /* only allow single equal sign at front of line */
        relevance: 10
      },
      /* technically, there can be more than 2 letters in column names, but this prevents conflict with some keywords */
      {
        /* matches a reference to a single cell */
        className: "symbol",
        begin: /\b[A-Z]{1,2}\d+\b/,
        end: /[^\d]/,
        excludeEnd: !0,
        relevance: 0
      },
      {
        /* matches a reference to a range of cells */
        className: "symbol",
        begin: /[A-Z]{0,2}\d*:[A-Z]{0,2}\d*/,
        relevance: 0
      },
      t.BACKSLASH_ESCAPE,
      t.QUOTE_STRING_MODE,
      {
        className: "number",
        begin: t.NUMBER_RE + "(%)?",
        relevance: 0
      },
      /* Excel formula comments are done by putting the comment in a function call to N() */
      t.COMMENT(
        /\bN\(/,
        /\)/,
        {
          excludeBegin: !0,
          excludeEnd: !0,
          illegal: /\n/
        }
      )
    ]
  };
}
function gE(t) {
  return {
    name: "FIX",
    contains: [
      {
        begin: /[^\u2401\u0001]+/,
        end: /[\u2401\u0001]/,
        excludeEnd: !0,
        returnBegin: !0,
        returnEnd: !1,
        contains: [
          {
            begin: /([^\u2401\u0001=]+)/,
            end: /=([^\u2401\u0001=]+)/,
            returnEnd: !0,
            returnBegin: !1,
            className: "attr"
          },
          {
            begin: /=/,
            end: /([\u2401\u0001])/,
            excludeEnd: !0,
            excludeBegin: !0,
            className: "string"
          }
        ]
      }
    ],
    case_insensitive: !0
  };
}
function SE(t) {
  const e = {
    className: "string",
    begin: /'(.|\\[xXuU][a-zA-Z0-9]+)'/
  }, n = {
    className: "string",
    variants: [
      {
        begin: '"',
        end: '"'
      }
    ]
  }, r = {
    className: "function",
    beginKeywords: "def",
    end: /[:={\[(\n;]/,
    excludeEnd: !0,
    contains: [{
      className: "title",
      relevance: 0,
      begin: /[^0-9\n\t "'(),.`{}\[\]:;][^\n\t "'(),.`{}\[\]:;]+|[^0-9\n\t "'(),.`{}\[\]:;=]/
    }]
  };
  return {
    name: "Flix",
    keywords: {
      keyword: [
        "case",
        "class",
        "def",
        "else",
        "enum",
        "if",
        "impl",
        "import",
        "in",
        "lat",
        "rel",
        "index",
        "let",
        "match",
        "namespace",
        "switch",
        "type",
        "yield",
        "with"
      ],
      literal: [
        "true",
        "false"
      ]
    },
    contains: [
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      e,
      n,
      r,
      t.C_NUMBER_MODE
    ]
  };
}
function hE(t) {
  const e = t.regex, n = {
    className: "params",
    begin: "\\(",
    end: "\\)"
  }, i = { variants: [
    t.COMMENT("!", "$", { relevance: 0 }),
    // allow FORTRAN 77 style comments
    t.COMMENT("^C[ ]", "$", { relevance: 0 }),
    t.COMMENT("^C$", "$", { relevance: 0 })
  ] }, r = /(_[a-z_\d]+)?/, a = /([de][+-]?\d+)?/, s = {
    className: "number",
    variants: [
      { begin: e.concat(/\b\d+/, /\.(\d*)/, a, r) },
      { begin: e.concat(/\b\d+/, a, r) },
      { begin: e.concat(/\.\d+/, a, r) }
    ],
    relevance: 0
  }, o = {
    className: "function",
    beginKeywords: "subroutine function program",
    illegal: "[${=\\n]",
    contains: [
      t.UNDERSCORE_TITLE_MODE,
      n
    ]
  }, l = {
    className: "string",
    relevance: 0,
    variants: [
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE
    ]
  };
  return {
    name: "Fortran",
    case_insensitive: !0,
    aliases: [
      "f90",
      "f95"
    ],
    keywords: {
      $pattern: /\b[a-z][a-z0-9_]+\b|\.[a-z][a-z0-9_]+\./,
      keyword: [
        "kind",
        "do",
        "concurrent",
        "local",
        "shared",
        "while",
        "private",
        "call",
        "intrinsic",
        "where",
        "elsewhere",
        "type",
        "endtype",
        "endmodule",
        "endselect",
        "endinterface",
        "end",
        "enddo",
        "endif",
        "if",
        "forall",
        "endforall",
        "only",
        "contains",
        "default",
        "return",
        "stop",
        "then",
        "block",
        "endblock",
        "endassociate",
        "public",
        "subroutine|10",
        "function",
        "program",
        ".and.",
        ".or.",
        ".not.",
        ".le.",
        ".eq.",
        ".ge.",
        ".gt.",
        ".lt.",
        "goto",
        "save",
        "else",
        "use",
        "module",
        "select",
        "case",
        "access",
        "blank",
        "direct",
        "exist",
        "file",
        "fmt",
        "form",
        "formatted",
        "iostat",
        "name",
        "named",
        "nextrec",
        "number",
        "opened",
        "rec",
        "recl",
        "sequential",
        "status",
        "unformatted",
        "unit",
        "continue",
        "format",
        "pause",
        "cycle",
        "exit",
        "c_null_char",
        "c_alert",
        "c_backspace",
        "c_form_feed",
        "flush",
        "wait",
        "decimal",
        "round",
        "iomsg",
        "synchronous",
        "nopass",
        "non_overridable",
        "pass",
        "protected",
        "volatile",
        "abstract",
        "extends",
        "import",
        "non_intrinsic",
        "value",
        "deferred",
        "generic",
        "final",
        "enumerator",
        "class",
        "associate",
        "bind",
        "enum",
        "c_int",
        "c_short",
        "c_long",
        "c_long_long",
        "c_signed_char",
        "c_size_t",
        "c_int8_t",
        "c_int16_t",
        "c_int32_t",
        "c_int64_t",
        "c_int_least8_t",
        "c_int_least16_t",
        "c_int_least32_t",
        "c_int_least64_t",
        "c_int_fast8_t",
        "c_int_fast16_t",
        "c_int_fast32_t",
        "c_int_fast64_t",
        "c_intmax_t",
        "C_intptr_t",
        "c_float",
        "c_double",
        "c_long_double",
        "c_float_complex",
        "c_double_complex",
        "c_long_double_complex",
        "c_bool",
        "c_char",
        "c_null_ptr",
        "c_null_funptr",
        "c_new_line",
        "c_carriage_return",
        "c_horizontal_tab",
        "c_vertical_tab",
        "iso_c_binding",
        "c_loc",
        "c_funloc",
        "c_associated",
        "c_f_pointer",
        "c_ptr",
        "c_funptr",
        "iso_fortran_env",
        "character_storage_size",
        "error_unit",
        "file_storage_size",
        "input_unit",
        "iostat_end",
        "iostat_eor",
        "numeric_storage_size",
        "output_unit",
        "c_f_procpointer",
        "ieee_arithmetic",
        "ieee_support_underflow_control",
        "ieee_get_underflow_mode",
        "ieee_set_underflow_mode",
        "newunit",
        "contiguous",
        "recursive",
        "pad",
        "position",
        "action",
        "delim",
        "readwrite",
        "eor",
        "advance",
        "nml",
        "interface",
        "procedure",
        "namelist",
        "include",
        "sequence",
        "elemental",
        "pure",
        "impure",
        "integer",
        "real",
        "character",
        "complex",
        "logical",
        "codimension",
        "dimension",
        "allocatable|10",
        "parameter",
        "external",
        "implicit|10",
        "none",
        "double",
        "precision",
        "assign",
        "intent",
        "optional",
        "pointer",
        "target",
        "in",
        "out",
        "common",
        "equivalence",
        "data"
      ],
      literal: [
        ".False.",
        ".True."
      ],
      built_in: [
        "alog",
        "alog10",
        "amax0",
        "amax1",
        "amin0",
        "amin1",
        "amod",
        "cabs",
        "ccos",
        "cexp",
        "clog",
        "csin",
        "csqrt",
        "dabs",
        "dacos",
        "dasin",
        "datan",
        "datan2",
        "dcos",
        "dcosh",
        "ddim",
        "dexp",
        "dint",
        "dlog",
        "dlog10",
        "dmax1",
        "dmin1",
        "dmod",
        "dnint",
        "dsign",
        "dsin",
        "dsinh",
        "dsqrt",
        "dtan",
        "dtanh",
        "float",
        "iabs",
        "idim",
        "idint",
        "idnint",
        "ifix",
        "isign",
        "max0",
        "max1",
        "min0",
        "min1",
        "sngl",
        "algama",
        "cdabs",
        "cdcos",
        "cdexp",
        "cdlog",
        "cdsin",
        "cdsqrt",
        "cqabs",
        "cqcos",
        "cqexp",
        "cqlog",
        "cqsin",
        "cqsqrt",
        "dcmplx",
        "dconjg",
        "derf",
        "derfc",
        "dfloat",
        "dgamma",
        "dimag",
        "dlgama",
        "iqint",
        "qabs",
        "qacos",
        "qasin",
        "qatan",
        "qatan2",
        "qcmplx",
        "qconjg",
        "qcos",
        "qcosh",
        "qdim",
        "qerf",
        "qerfc",
        "qexp",
        "qgamma",
        "qimag",
        "qlgama",
        "qlog",
        "qlog10",
        "qmax1",
        "qmin1",
        "qmod",
        "qnint",
        "qsign",
        "qsin",
        "qsinh",
        "qsqrt",
        "qtan",
        "qtanh",
        "abs",
        "acos",
        "aimag",
        "aint",
        "anint",
        "asin",
        "atan",
        "atan2",
        "char",
        "cmplx",
        "conjg",
        "cos",
        "cosh",
        "exp",
        "ichar",
        "index",
        "int",
        "log",
        "log10",
        "max",
        "min",
        "nint",
        "sign",
        "sin",
        "sinh",
        "sqrt",
        "tan",
        "tanh",
        "print",
        "write",
        "dim",
        "lge",
        "lgt",
        "lle",
        "llt",
        "mod",
        "nullify",
        "allocate",
        "deallocate",
        "adjustl",
        "adjustr",
        "all",
        "allocated",
        "any",
        "associated",
        "bit_size",
        "btest",
        "ceiling",
        "count",
        "cshift",
        "date_and_time",
        "digits",
        "dot_product",
        "eoshift",
        "epsilon",
        "exponent",
        "floor",
        "fraction",
        "huge",
        "iand",
        "ibclr",
        "ibits",
        "ibset",
        "ieor",
        "ior",
        "ishft",
        "ishftc",
        "lbound",
        "len_trim",
        "matmul",
        "maxexponent",
        "maxloc",
        "maxval",
        "merge",
        "minexponent",
        "minloc",
        "minval",
        "modulo",
        "mvbits",
        "nearest",
        "pack",
        "present",
        "product",
        "radix",
        "random_number",
        "random_seed",
        "range",
        "repeat",
        "reshape",
        "rrspacing",
        "scale",
        "scan",
        "selected_int_kind",
        "selected_real_kind",
        "set_exponent",
        "shape",
        "size",
        "spacing",
        "spread",
        "sum",
        "system_clock",
        "tiny",
        "transpose",
        "trim",
        "ubound",
        "unpack",
        "verify",
        "achar",
        "iachar",
        "transfer",
        "dble",
        "entry",
        "dprod",
        "cpu_time",
        "command_argument_count",
        "get_command",
        "get_command_argument",
        "get_environment_variable",
        "is_iostat_end",
        "ieee_arithmetic",
        "ieee_support_underflow_control",
        "ieee_get_underflow_mode",
        "ieee_set_underflow_mode",
        "is_iostat_eor",
        "move_alloc",
        "new_line",
        "selected_char_kind",
        "same_type_as",
        "extends_type_of",
        "acosh",
        "asinh",
        "atanh",
        "bessel_j0",
        "bessel_j1",
        "bessel_jn",
        "bessel_y0",
        "bessel_y1",
        "bessel_yn",
        "erf",
        "erfc",
        "erfc_scaled",
        "gamma",
        "log_gamma",
        "hypot",
        "norm2",
        "atomic_define",
        "atomic_ref",
        "execute_command_line",
        "leadz",
        "trailz",
        "storage_size",
        "merge_bits",
        "bge",
        "bgt",
        "ble",
        "blt",
        "dshiftl",
        "dshiftr",
        "findloc",
        "iall",
        "iany",
        "iparity",
        "image_index",
        "lcobound",
        "ucobound",
        "maskl",
        "maskr",
        "num_images",
        "parity",
        "popcnt",
        "poppar",
        "shifta",
        "shiftl",
        "shiftr",
        "this_image",
        "sync",
        "change",
        "team",
        "co_broadcast",
        "co_max",
        "co_min",
        "co_sum",
        "co_reduce"
      ]
    },
    illegal: /\/\*/,
    contains: [
      l,
      o,
      // allow `C = value` for assignments so they aren't misdetected
      // as Fortran 77 style comments
      {
        begin: /^C\s*=(?!=)/,
        relevance: 0
      },
      i,
      s
    ]
  };
}
function fE(t) {
  return new RegExp(t.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), "m");
}
function Nc(t) {
  return t ? typeof t == "string" ? t : t.source : null;
}
function $i(t) {
  return zt("(?=", t, ")");
}
function zt(...t) {
  return t.map((n) => Nc(n)).join("");
}
function TE(t) {
  const e = t[t.length - 1];
  return typeof e == "object" && e.constructor === Object ? (t.splice(t.length - 1, 1), e) : {};
}
function Ln(...t) {
  return "(" + (TE(t).capture ? "" : "?:") + t.map((i) => Nc(i)).join("|") + ")";
}
function bE(t) {
  const e = [
    "abstract",
    "and",
    "as",
    "assert",
    "base",
    "begin",
    "class",
    "default",
    "delegate",
    "do",
    "done",
    "downcast",
    "downto",
    "elif",
    "else",
    "end",
    "exception",
    "extern",
    // "false", // literal
    "finally",
    "fixed",
    "for",
    "fun",
    "function",
    "global",
    "if",
    "in",
    "inherit",
    "inline",
    "interface",
    "internal",
    "lazy",
    "let",
    "match",
    "member",
    "module",
    "mutable",
    "namespace",
    "new",
    // "not", // built_in
    // "null", // literal
    "of",
    "open",
    "or",
    "override",
    "private",
    "public",
    "rec",
    "return",
    "static",
    "struct",
    "then",
    "to",
    // "true", // literal
    "try",
    "type",
    "upcast",
    "use",
    "val",
    "void",
    "when",
    "while",
    "with",
    "yield"
  ], n = {
    // monad builder keywords (matches before non-bang keywords)
    scope: "keyword",
    match: /\b(yield|return|let|do|match|use)!/
  }, i = [
    "if",
    "else",
    "endif",
    "line",
    "nowarn",
    "light",
    "r",
    "i",
    "I",
    "load",
    "time",
    "help",
    "quit"
  ], r = [
    "true",
    "false",
    "null",
    "Some",
    "None",
    "Ok",
    "Error",
    "infinity",
    "infinityf",
    "nan",
    "nanf"
  ], a = [
    "__LINE__",
    "__SOURCE_DIRECTORY__",
    "__SOURCE_FILE__"
  ], s = [
    // basic types
    "bool",
    "byte",
    "sbyte",
    "int8",
    "int16",
    "int32",
    "uint8",
    "uint16",
    "uint32",
    "int",
    "uint",
    "int64",
    "uint64",
    "nativeint",
    "unativeint",
    "decimal",
    "float",
    "double",
    "float32",
    "single",
    "char",
    "string",
    "unit",
    "bigint",
    // other native types or lowercase aliases
    "option",
    "voption",
    "list",
    "array",
    "seq",
    "byref",
    "exn",
    "inref",
    "nativeptr",
    "obj",
    "outref",
    "voidptr",
    // other important FSharp types
    "Result"
  ], l = {
    keyword: e,
    literal: r,
    built_in: [
      // Somewhat arbitrary list of builtin functions and values.
      // Most of them are declared in Microsoft.FSharp.Core
      // I tried to stay relevant by adding only the most idiomatic
      // and most used symbols that are not already declared as types.
      "not",
      "ref",
      "raise",
      "reraise",
      "dict",
      "readOnlyDict",
      "set",
      "get",
      "enum",
      "sizeof",
      "typeof",
      "typedefof",
      "nameof",
      "nullArg",
      "invalidArg",
      "invalidOp",
      "id",
      "fst",
      "snd",
      "ignore",
      "lock",
      "using",
      "box",
      "unbox",
      "tryUnbox",
      "printf",
      "printfn",
      "sprintf",
      "eprintf",
      "eprintfn",
      "fprintf",
      "fprintfn",
      "failwith",
      "failwithf"
    ],
    "variable.constant": a
  }, d = {
    variants: [
      t.COMMENT(/\(\*(?!\))/, /\*\)/, {
        contains: ["self"]
      }),
      t.C_LINE_COMMENT_MODE
    ]
  }, u = /[a-zA-Z_](\w|')*/, _ = {
    scope: "variable",
    begin: /``/,
    end: /``/
  }, m = /\B('|\^)/, g = {
    scope: "symbol",
    variants: [
      // the type name is a quoted identifier:
      { match: zt(m, /``.*?``/) },
      // the type name is a normal identifier (we don't use IDENTIFIER_RE because there cannot be another apostrophe here):
      { match: zt(m, t.UNDERSCORE_IDENT_RE) }
    ],
    relevance: 0
  }, S = function({ includeEqual: V }) {
    let Z;
    V ? Z = "!%&*+-/<=>@^|~?" : Z = "!%&*+-/<>@^|~?";
    const fe = Array.from(Z), _e = zt("[", ...fe.map(fE), "]"), me = Ln(_e, /\./), Me = zt(me, $i(me)), ke = Ln(
      zt(Me, me, "*"),
      // Matches at least 2 chars operators
      zt(_e, "+")
      // Matches at least one char operators
    );
    return {
      scope: "operator",
      match: Ln(
        // symbolic operators:
        ke,
        // other symbolic keywords:
        // Type casting and conversion operators:
        /:\?>/,
        /:\?/,
        /:>/,
        /:=/,
        // Reference cell assignment
        /::?/,
        // : or ::
        /\$/
      ),
      // A single $ can be used as an operator
      relevance: 0
    };
  }, E = S({ includeEqual: !0 }), h = S({ includeEqual: !1 }), T = function(V, Z) {
    return {
      begin: zt(
        // a type annotation is a
        V,
        // should be a colon or the 'of' keyword
        $i(
          // that has to be followed by
          zt(
            /\s*/,
            // optional space
            Ln(
              // then either of:
              /\w/,
              // word
              /'/,
              // generic type name
              /\^/,
              // generic type name
              /#/,
              // flexible type name
              /``/,
              // quoted type name
              /\(/,
              // parens type expression
              /{\|/
              // anonymous type annotation
            )
          )
        )
      ),
      beginScope: Z,
      // BUG: because ending with \n is necessary for some cases, multi-line type annotations are not properly supported.
      // Examples where \n is required at the end:
      // - abstract member definitions in classes: abstract Property : int * string
      // - return type annotations: let f f' = f' () : returnTypeAnnotation
      // - record fields definitions: { A : int \n B : string }
      end: $i(
        Ln(
          /\n/,
          /=/
        )
      ),
      relevance: 0,
      // we need the known types, and we need the type constraint keywords and literals. e.g.: when 'a : null
      keywords: t.inherit(l, { type: s }),
      contains: [
        d,
        g,
        t.inherit(_, { scope: null }),
        // match to avoid strange patterns inside that may break the parsing
        h
      ]
    };
  }, b = T(/:/, "operator"), C = T(/\bof\b/, "keyword"), y = {
    begin: [
      /(^|\s+)/,
      // prevents matching the following: `match s.stype with`
      /type/,
      /\s+/,
      u
    ],
    beginScope: {
      2: "keyword",
      4: "title.class"
    },
    end: $i(/\(|=|$/),
    keywords: l,
    // match keywords in type constraints. e.g.: when 'a : null
    contains: [
      d,
      t.inherit(_, { scope: null }),
      // match to avoid strange patterns inside that may break the parsing
      g,
      {
        // For visual consistency, highlight type brackets as operators.
        scope: "operator",
        match: /<|>/
      },
      b
      // generic types can have constraints, which are type annotations. e.g. type MyType<'T when 'T : delegate<obj * string>> =
    ]
  }, O = {
    // computation expressions:
    scope: "computation-expression",
    // BUG: might conflict with record deconstruction. e.g. let f { Name = name } = name // will highlight f
    match: /\b[_a-z]\w*(?=\s*\{)/
  }, A = {
    // preprocessor directives and fsi commands:
    begin: [
      /^\s*/,
      zt(/#/, Ln(...i)),
      /\b/
    ],
    beginScope: { 2: "meta" },
    end: $i(/\s|$/)
  }, I = {
    variants: [
      t.BINARY_NUMBER_MODE,
      t.C_NUMBER_MODE
    ]
  }, k = {
    scope: "string",
    begin: /"/,
    end: /"/,
    contains: [
      t.BACKSLASH_ESCAPE
    ]
  }, x = {
    scope: "string",
    begin: /@"/,
    end: /"/,
    contains: [
      {
        match: /""/
        // escaped "
      },
      t.BACKSLASH_ESCAPE
    ]
  }, B = {
    scope: "string",
    begin: /"""/,
    end: /"""/,
    relevance: 2
  }, X = {
    scope: "subst",
    begin: /\{/,
    end: /\}/,
    keywords: l
  }, J = {
    scope: "string",
    begin: /\$"/,
    end: /"/,
    contains: [
      {
        match: /\{\{/
        // escaped {
      },
      {
        match: /\}\}/
        // escaped }
      },
      t.BACKSLASH_ESCAPE,
      X
    ]
  }, D = {
    scope: "string",
    begin: /(\$@|@\$)"/,
    end: /"/,
    contains: [
      {
        match: /\{\{/
        // escaped {
      },
      {
        match: /\}\}/
        // escaped }
      },
      {
        match: /""/
      },
      t.BACKSLASH_ESCAPE,
      X
    ]
  }, L = {
    scope: "string",
    begin: /\$"""/,
    end: /"""/,
    contains: [
      {
        match: /\{\{/
        // escaped {
      },
      {
        match: /\}\}/
        // escaped }
      },
      X
    ],
    relevance: 2
  }, G = {
    scope: "string",
    match: zt(
      /'/,
      Ln(
        /[^\\']/,
        // either a single non escaped char...
        /\\(?:.|\d{3}|x[a-fA-F\d]{2}|u[a-fA-F\d]{4}|U[a-fA-F\d]{8})/
        // ...or an escape sequence
      ),
      /'/
    )
  };
  return X.contains = [
    D,
    J,
    x,
    k,
    G,
    n,
    d,
    _,
    b,
    O,
    A,
    I,
    g,
    E
  ], {
    name: "F#",
    aliases: [
      "fs",
      "f#"
    ],
    keywords: l,
    illegal: /\/\*/,
    classNameAliases: {
      "computation-expression": "keyword"
    },
    contains: [
      n,
      {
        variants: [
          L,
          D,
          J,
          B,
          x,
          k,
          G
        ]
      },
      d,
      _,
      y,
      {
        // e.g. [<Attributes("")>] or [<``module``: MyCustomAttributeThatWorksOnModules>]
        // or [<Sealed; NoEquality; NoComparison; CompiledName("FSharpAsync`1")>]
        scope: "meta",
        begin: /\[</,
        end: />\]/,
        relevance: 2,
        contains: [
          _,
          // can contain any constant value
          B,
          x,
          k,
          G,
          I
        ]
      },
      C,
      b,
      O,
      A,
      I,
      g,
      E
    ]
  };
}
function CE(t) {
  const e = t.regex, n = {
    keyword: "abort acronym acronyms alias all and assign binary card diag display else eq file files for free ge gt if integer le loop lt maximizing minimizing model models ne negative no not option options or ord positive prod put putpage puttl repeat sameas semicont semiint smax smin solve sos1 sos2 sum system table then until using while xor yes",
    literal: "eps inf na",
    built_in: "abs arccos arcsin arctan arctan2 Beta betaReg binomial ceil centropy cos cosh cvPower div div0 eDist entropy errorf execSeed exp fact floor frac gamma gammaReg log logBeta logGamma log10 log2 mapVal max min mod ncpCM ncpF ncpVUpow ncpVUsin normal pi poly power randBinomial randLinear randTriangle round rPower sigmoid sign signPower sin sinh slexp sllog10 slrec sqexp sqlog10 sqr sqrec sqrt tan tanh trunc uniform uniformInt vcPower bool_and bool_eqv bool_imp bool_not bool_or bool_xor ifThen rel_eq rel_ge rel_gt rel_le rel_lt rel_ne gday gdow ghour gleap gmillisec gminute gmonth gsecond gyear jdate jnow jstart jtime errorLevel execError gamsRelease gamsVersion handleCollect handleDelete handleStatus handleSubmit heapFree heapLimit heapSize jobHandle jobKill jobStatus jobTerminate licenseLevel licenseStatus maxExecError sleep timeClose timeComp timeElapsed timeExec timeStart"
  }, i = {
    className: "params",
    begin: /\(/,
    end: /\)/,
    excludeBegin: !0,
    excludeEnd: !0
  }, r = {
    className: "symbol",
    variants: [
      { begin: /=[lgenxc]=/ },
      { begin: /\$/ }
    ]
  }, a = {
    // One-line quoted comment string
    className: "comment",
    variants: [
      {
        begin: "'",
        end: "'"
      },
      {
        begin: '"',
        end: '"'
      }
    ],
    illegal: "\\n",
    contains: [t.BACKSLASH_ESCAPE]
  }, s = {
    begin: "/",
    end: "/",
    keywords: n,
    contains: [
      a,
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      t.QUOTE_STRING_MODE,
      t.APOS_STRING_MODE,
      t.C_NUMBER_MODE
    ]
  }, o = /[a-z0-9&#*=?@\\><:,()$[\]_.{}!+%^-]+/, l = {
    // Parameter/set/variable description text
    begin: /[a-z][a-z0-9_]*(\([a-z0-9_, ]*\))?[ \t]+/,
    excludeBegin: !0,
    end: "$",
    endsWithParent: !0,
    contains: [
      a,
      s,
      {
        className: "comment",
        // one comment word, then possibly more
        begin: e.concat(
          o,
          // [ ] because \s would be too broad (matching newlines)
          e.anyNumberOfTimes(e.concat(/[ ]+/, o))
        ),
        relevance: 0
      }
    ]
  };
  return {
    name: "GAMS",
    aliases: ["gms"],
    case_insensitive: !0,
    keywords: n,
    contains: [
      t.COMMENT(/^\$ontext/, /^\$offtext/),
      {
        className: "meta",
        begin: "^\\$[a-z0-9]+",
        end: "$",
        returnBegin: !0,
        contains: [
          {
            className: "keyword",
            begin: "^\\$[a-z0-9]+"
          }
        ]
      },
      t.COMMENT("^\\*", "$"),
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      t.QUOTE_STRING_MODE,
      t.APOS_STRING_MODE,
      // Declarations
      {
        beginKeywords: "set sets parameter parameters variable variables scalar scalars equation equations",
        end: ";",
        contains: [
          t.COMMENT("^\\*", "$"),
          t.C_LINE_COMMENT_MODE,
          t.C_BLOCK_COMMENT_MODE,
          t.QUOTE_STRING_MODE,
          t.APOS_STRING_MODE,
          s,
          l
        ]
      },
      {
        // table environment
        beginKeywords: "table",
        end: ";",
        returnBegin: !0,
        contains: [
          {
            // table header row
            beginKeywords: "table",
            end: "$",
            contains: [l]
          },
          t.COMMENT("^\\*", "$"),
          t.C_LINE_COMMENT_MODE,
          t.C_BLOCK_COMMENT_MODE,
          t.QUOTE_STRING_MODE,
          t.APOS_STRING_MODE,
          t.C_NUMBER_MODE
          // Table does not contain DESCTEXT or ASSIGNMENT
        ]
      },
      // Function definitions
      {
        className: "function",
        begin: /^[a-z][a-z0-9_,\-+' ()$]+\.{2}/,
        returnBegin: !0,
        contains: [
          {
            // Function title
            className: "title",
            begin: /^[a-z0-9_]+/
          },
          i,
          r
        ]
      },
      t.C_NUMBER_MODE,
      r
    ]
  };
}
function yE(t) {
  const e = {
    keyword: "bool break call callexe checkinterrupt clear clearg closeall cls comlog compile continue create debug declare delete disable dlibrary dllcall do dos ed edit else elseif enable end endfor endif endp endo errorlog errorlogat expr external fn for format goto gosub graph if keyword let lib library line load loadarray loadexe loadf loadk loadm loadp loads loadx local locate loopnextindex lprint lpwidth lshow matrix msym ndpclex new open output outwidth plot plotsym pop prcsn print printdos proc push retp return rndcon rndmod rndmult rndseed run save saveall screen scroll setarray show sparse stop string struct system trace trap threadfor threadendfor threadbegin threadjoin threadstat threadend until use while winprint ne ge le gt lt and xor or not eq eqv",
    built_in: "abs acf aconcat aeye amax amean AmericanBinomCall AmericanBinomCall_Greeks AmericanBinomCall_ImpVol AmericanBinomPut AmericanBinomPut_Greeks AmericanBinomPut_ImpVol AmericanBSCall AmericanBSCall_Greeks AmericanBSCall_ImpVol AmericanBSPut AmericanBSPut_Greeks AmericanBSPut_ImpVol amin amult annotationGetDefaults annotationSetBkd annotationSetFont annotationSetLineColor annotationSetLineStyle annotationSetLineThickness annualTradingDays arccos arcsin areshape arrayalloc arrayindex arrayinit arraytomat asciiload asclabel astd astds asum atan atan2 atranspose axmargin balance band bandchol bandcholsol bandltsol bandrv bandsolpd bar base10 begwind besselj bessely beta box boxcox cdfBeta cdfBetaInv cdfBinomial cdfBinomialInv cdfBvn cdfBvn2 cdfBvn2e cdfCauchy cdfCauchyInv cdfChic cdfChii cdfChinc cdfChincInv cdfExp cdfExpInv cdfFc cdfFnc cdfFncInv cdfGam cdfGenPareto cdfHyperGeo cdfLaplace cdfLaplaceInv cdfLogistic cdfLogisticInv cdfmControlCreate cdfMvn cdfMvn2e cdfMvnce cdfMvne cdfMvt2e cdfMvtce cdfMvte cdfN cdfN2 cdfNc cdfNegBinomial cdfNegBinomialInv cdfNi cdfPoisson cdfPoissonInv cdfRayleigh cdfRayleighInv cdfTc cdfTci cdfTnc cdfTvn cdfWeibull cdfWeibullInv cdir ceil ChangeDir chdir chiBarSquare chol choldn cholsol cholup chrs close code cols colsf combinate combinated complex con cond conj cons ConScore contour conv convertsatostr convertstrtosa corrm corrms corrvc corrx corrxs cos cosh counts countwts crossprd crout croutp csrcol csrlin csvReadM csvReadSA cumprodc cumsumc curve cvtos datacreate datacreatecomplex datalist dataload dataloop dataopen datasave date datestr datestring datestrymd dayinyr dayofweek dbAddDatabase dbClose dbCommit dbCreateQuery dbExecQuery dbGetConnectOptions dbGetDatabaseName dbGetDriverName dbGetDrivers dbGetHostName dbGetLastErrorNum dbGetLastErrorText dbGetNumericalPrecPolicy dbGetPassword dbGetPort dbGetTableHeaders dbGetTables dbGetUserName dbHasFeature dbIsDriverAvailable dbIsOpen dbIsOpenError dbOpen dbQueryBindValue dbQueryClear dbQueryCols dbQueryExecPrepared dbQueryFetchAllM dbQueryFetchAllSA dbQueryFetchOneM dbQueryFetchOneSA dbQueryFinish dbQueryGetBoundValue dbQueryGetBoundValues dbQueryGetField dbQueryGetLastErrorNum dbQueryGetLastErrorText dbQueryGetLastInsertID dbQueryGetLastQuery dbQueryGetPosition dbQueryIsActive dbQueryIsForwardOnly dbQueryIsNull dbQueryIsSelect dbQueryIsValid dbQueryPrepare dbQueryRows dbQuerySeek dbQuerySeekFirst dbQuerySeekLast dbQuerySeekNext dbQuerySeekPrevious dbQuerySetForwardOnly dbRemoveDatabase dbRollback dbSetConnectOptions dbSetDatabaseName dbSetHostName dbSetNumericalPrecPolicy dbSetPort dbSetUserName dbTransaction DeleteFile delif delrows denseToSp denseToSpRE denToZero design det detl dfft dffti diag diagrv digamma doswin DOSWinCloseall DOSWinOpen dotfeq dotfeqmt dotfge dotfgemt dotfgt dotfgtmt dotfle dotflemt dotflt dotfltmt dotfne dotfnemt draw drop dsCreate dstat dstatmt dstatmtControlCreate dtdate dtday dttime dttodtv dttostr dttoutc dtvnormal dtvtodt dtvtoutc dummy dummybr dummydn eig eigh eighv eigv elapsedTradingDays endwind envget eof eqSolve eqSolvemt eqSolvemtControlCreate eqSolvemtOutCreate eqSolveset erf erfc erfccplx erfcplx error etdays ethsec etstr EuropeanBinomCall EuropeanBinomCall_Greeks EuropeanBinomCall_ImpVol EuropeanBinomPut EuropeanBinomPut_Greeks EuropeanBinomPut_ImpVol EuropeanBSCall EuropeanBSCall_Greeks EuropeanBSCall_ImpVol EuropeanBSPut EuropeanBSPut_Greeks EuropeanBSPut_ImpVol exctsmpl exec execbg exp extern eye fcheckerr fclearerr feq feqmt fflush fft ffti fftm fftmi fftn fge fgemt fgets fgetsa fgetsat fgetst fgt fgtmt fileinfo filesa fle flemt floor flt fltmt fmod fne fnemt fonts fopen formatcv formatnv fputs fputst fseek fstrerror ftell ftocv ftos ftostrC gamma gammacplx gammaii gausset gdaAppend gdaCreate gdaDStat gdaDStatMat gdaGetIndex gdaGetName gdaGetNames gdaGetOrders gdaGetType gdaGetTypes gdaGetVarInfo gdaIsCplx gdaLoad gdaPack gdaRead gdaReadByIndex gdaReadSome gdaReadSparse gdaReadStruct gdaReportVarInfo gdaSave gdaUpdate gdaUpdateAndPack gdaVars gdaWrite gdaWrite32 gdaWriteSome getarray getdims getf getGAUSShome getmatrix getmatrix4D getname getnamef getNextTradingDay getNextWeekDay getnr getorders getpath getPreviousTradingDay getPreviousWeekDay getRow getscalar3D getscalar4D getTrRow getwind glm gradcplx gradMT gradMTm gradMTT gradMTTm gradp graphprt graphset hasimag header headermt hess hessMT hessMTg hessMTgw hessMTm hessMTmw hessMTT hessMTTg hessMTTgw hessMTTm hessMTw hessp hist histf histp hsec imag indcv indexcat indices indices2 indicesf indicesfn indnv indsav integrate1d integrateControlCreate intgrat2 intgrat3 inthp1 inthp2 inthp3 inthp4 inthpControlCreate intquad1 intquad2 intquad3 intrleav intrleavsa intrsect intsimp inv invpd invswp iscplx iscplxf isden isinfnanmiss ismiss key keyav keyw lag lag1 lagn lapEighb lapEighi lapEighvb lapEighvi lapgEig lapgEigh lapgEighv lapgEigv lapgSchur lapgSvdcst lapgSvds lapgSvdst lapSvdcusv lapSvds lapSvdusv ldlp ldlsol linSolve listwise ln lncdfbvn lncdfbvn2 lncdfmvn lncdfn lncdfn2 lncdfnc lnfact lngammacplx lnpdfmvn lnpdfmvt lnpdfn lnpdft loadd loadstruct loadwind loess loessmt loessmtControlCreate log loglog logx logy lower lowmat lowmat1 ltrisol lu lusol machEpsilon make makevars makewind margin matalloc matinit mattoarray maxbytes maxc maxindc maxv maxvec mbesselei mbesselei0 mbesselei1 mbesseli mbesseli0 mbesseli1 meanc median mergeby mergevar minc minindc minv miss missex missrv moment momentd movingave movingaveExpwgt movingaveWgt nextindex nextn nextnevn nextwind ntos null null1 numCombinations ols olsmt olsmtControlCreate olsqr olsqr2 olsqrmt ones optn optnevn orth outtyp pacf packedToSp packr parse pause pdfCauchy pdfChi pdfExp pdfGenPareto pdfHyperGeo pdfLaplace pdfLogistic pdfn pdfPoisson pdfRayleigh pdfWeibull pi pinv pinvmt plotAddArrow plotAddBar plotAddBox plotAddHist plotAddHistF plotAddHistP plotAddPolar plotAddScatter plotAddShape plotAddTextbox plotAddTS plotAddXY plotArea plotBar plotBox plotClearLayout plotContour plotCustomLayout plotGetDefaults plotHist plotHistF plotHistP plotLayout plotLogLog plotLogX plotLogY plotOpenWindow plotPolar plotSave plotScatter plotSetAxesPen plotSetBar plotSetBarFill plotSetBarStacked plotSetBkdColor plotSetFill plotSetGrid plotSetLegend plotSetLineColor plotSetLineStyle plotSetLineSymbol plotSetLineThickness plotSetNewWindow plotSetTitle plotSetWhichYAxis plotSetXAxisShow plotSetXLabel plotSetXRange plotSetXTicInterval plotSetXTicLabel plotSetYAxisShow plotSetYLabel plotSetYRange plotSetZAxisShow plotSetZLabel plotSurface plotTS plotXY polar polychar polyeval polygamma polyint polymake polymat polymroot polymult polyroot pqgwin previousindex princomp printfm printfmt prodc psi putarray putf putvals pvCreate pvGetIndex pvGetParNames pvGetParVector pvLength pvList pvPack pvPacki pvPackm pvPackmi pvPacks pvPacksi pvPacksm pvPacksmi pvPutParVector pvTest pvUnpack QNewton QNewtonmt QNewtonmtControlCreate QNewtonmtOutCreate QNewtonSet QProg QProgmt QProgmtInCreate qqr qqre qqrep qr qre qrep qrsol qrtsol qtyr qtyre qtyrep quantile quantiled qyr qyre qyrep qz rank rankindx readr real reclassify reclassifyCuts recode recserar recsercp recserrc rerun rescale reshape rets rev rfft rffti rfftip rfftn rfftnp rfftp rndBernoulli rndBeta rndBinomial rndCauchy rndChiSquare rndCon rndCreateState rndExp rndGamma rndGeo rndGumbel rndHyperGeo rndi rndKMbeta rndKMgam rndKMi rndKMn rndKMnb rndKMp rndKMu rndKMvm rndLaplace rndLCbeta rndLCgam rndLCi rndLCn rndLCnb rndLCp rndLCu rndLCvm rndLogNorm rndMTu rndMVn rndMVt rndn rndnb rndNegBinomial rndp rndPoisson rndRayleigh rndStateSkip rndu rndvm rndWeibull rndWishart rotater round rows rowsf rref sampleData satostrC saved saveStruct savewind scale scale3d scalerr scalinfnanmiss scalmiss schtoc schur searchsourcepath seekr select selif seqa seqm setdif setdifsa setvars setvwrmode setwind shell shiftr sin singleindex sinh sleep solpd sortc sortcc sortd sorthc sorthcc sortind sortindc sortmc sortr sortrc spBiconjGradSol spChol spConjGradSol spCreate spDenseSubmat spDiagRvMat spEigv spEye spLDL spline spLU spNumNZE spOnes spreadSheetReadM spreadSheetReadSA spreadSheetWrite spScale spSubmat spToDense spTrTDense spTScalar spZeros sqpSolve sqpSolveMT sqpSolveMTControlCreate sqpSolveMTlagrangeCreate sqpSolveMToutCreate sqpSolveSet sqrt statements stdc stdsc stocv stof strcombine strindx strlen strput strrindx strsect strsplit strsplitPad strtodt strtof strtofcplx strtriml strtrimr strtrunc strtruncl strtruncpad strtruncr submat subscat substute subvec sumc sumr surface svd svd1 svd2 svdcusv svds svdusv sysstate tab tan tanh tempname time timedt timestr timeutc title tkf2eps tkf2ps tocart todaydt toeplitz token topolar trapchk trigamma trimr trunc type typecv typef union unionsa uniqindx uniqindxsa unique uniquesa upmat upmat1 upper utctodt utctodtv utrisol vals varCovMS varCovXS varget vargetl varmall varmares varput varputl vartypef vcm vcms vcx vcxs vec vech vecr vector vget view viewxyz vlist vnamecv volume vput vread vtypecv wait waitc walkindex where window writer xlabel xlsGetSheetCount xlsGetSheetSize xlsGetSheetTypes xlsMakeRange xlsReadM xlsReadSA xlsWrite xlsWriteM xlsWriteSA xpnd xtics xy xyz ylabel ytics zeros zeta zlabel ztics cdfEmpirical dot h5create h5open h5read h5readAttribute h5write h5writeAttribute ldl plotAddErrorBar plotAddSurface plotCDFEmpirical plotSetColormap plotSetContourLabels plotSetLegendFont plotSetTextInterpreter plotSetXTicCount plotSetYTicCount plotSetZLevels powerm strjoin sylvester strtrim",
    literal: "DB_AFTER_LAST_ROW DB_ALL_TABLES DB_BATCH_OPERATIONS DB_BEFORE_FIRST_ROW DB_BLOB DB_EVENT_NOTIFICATIONS DB_FINISH_QUERY DB_HIGH_PRECISION DB_LAST_INSERT_ID DB_LOW_PRECISION_DOUBLE DB_LOW_PRECISION_INT32 DB_LOW_PRECISION_INT64 DB_LOW_PRECISION_NUMBERS DB_MULTIPLE_RESULT_SETS DB_NAMED_PLACEHOLDERS DB_POSITIONAL_PLACEHOLDERS DB_PREPARED_QUERIES DB_QUERY_SIZE DB_SIMPLE_LOCKING DB_SYSTEM_TABLES DB_TABLES DB_TRANSACTIONS DB_UNICODE DB_VIEWS __STDIN __STDOUT __STDERR __FILE_DIR"
  }, n = t.COMMENT("@", "@"), i = {
    className: "meta",
    begin: "#",
    end: "$",
    keywords: { keyword: "define definecs|10 undef ifdef ifndef iflight ifdllcall ifmac ifos2win ifunix else endif lineson linesoff srcfile srcline" },
    contains: [
      {
        begin: /\\\n/,
        relevance: 0
      },
      {
        beginKeywords: "include",
        end: "$",
        keywords: { keyword: "include" },
        contains: [
          {
            className: "string",
            begin: '"',
            end: '"',
            illegal: "\\n"
          }
        ]
      },
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      n
    ]
  }, r = {
    begin: /\bstruct\s+/,
    end: /\s/,
    keywords: "struct",
    contains: [
      {
        className: "type",
        begin: t.UNDERSCORE_IDENT_RE,
        relevance: 0
      }
    ]
  }, a = [
    {
      className: "params",
      begin: /\(/,
      end: /\)/,
      excludeBegin: !0,
      excludeEnd: !0,
      endsWithParent: !0,
      relevance: 0,
      contains: [
        {
          // dots
          className: "literal",
          begin: /\.\.\./
        },
        t.C_NUMBER_MODE,
        t.C_BLOCK_COMMENT_MODE,
        n,
        r
      ]
    }
  ], s = {
    className: "title",
    begin: t.UNDERSCORE_IDENT_RE,
    relevance: 0
  }, o = function(_, m, g) {
    const S = t.inherit(
      {
        className: "function",
        beginKeywords: _,
        end: m,
        excludeEnd: !0,
        contains: [].concat(a)
      },
      {}
    );
    return S.contains.push(s), S.contains.push(t.C_NUMBER_MODE), S.contains.push(t.C_BLOCK_COMMENT_MODE), S.contains.push(n), S;
  }, l = {
    // these are explicitly named internal function calls
    className: "built_in",
    begin: "\\b(" + e.built_in.split(" ").join("|") + ")\\b"
  }, c = {
    className: "string",
    begin: '"',
    end: '"',
    contains: [t.BACKSLASH_ESCAPE],
    relevance: 0
  }, d = {
    // className: "fn_ref",
    begin: t.UNDERSCORE_IDENT_RE + "\\s*\\(",
    returnBegin: !0,
    keywords: e,
    relevance: 0,
    contains: [
      { beginKeywords: e.keyword },
      l,
      {
        // ambiguously named function calls get a relevance of 0
        className: "built_in",
        begin: t.UNDERSCORE_IDENT_RE,
        relevance: 0
      }
    ]
  }, u = {
    // className: "fn_ref_params",
    begin: /\(/,
    end: /\)/,
    relevance: 0,
    keywords: {
      built_in: e.built_in,
      literal: e.literal
    },
    contains: [
      t.C_NUMBER_MODE,
      t.C_BLOCK_COMMENT_MODE,
      n,
      l,
      d,
      c,
      "self"
    ]
  };
  return d.contains.push(u), {
    name: "GAUSS",
    aliases: ["gss"],
    case_insensitive: !0,
    // language is case-insensitive
    keywords: e,
    illegal: /(\{[%#]|[%#]\}| <- )/,
    contains: [
      t.C_NUMBER_MODE,
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      n,
      c,
      i,
      {
        className: "keyword",
        begin: /\bexternal (matrix|string|array|sparse matrix|struct|proc|keyword|fn)/
      },
      o("proc keyword", ";"),
      o("fn", "="),
      {
        beginKeywords: "for threadfor",
        end: /;/,
        // end: /\(/,
        relevance: 0,
        contains: [
          t.C_BLOCK_COMMENT_MODE,
          n,
          u
        ]
      },
      {
        // custom method guard
        // excludes method names from keyword processing
        variants: [
          { begin: t.UNDERSCORE_IDENT_RE + "\\." + t.UNDERSCORE_IDENT_RE },
          { begin: t.UNDERSCORE_IDENT_RE + "\\s*=" }
        ],
        relevance: 0
      },
      d,
      r
    ]
  };
}
function RE(t) {
  const e = t.regex, n = {
    $pattern: /[A-Z]+|%/,
    keyword: [
      // conditions
      "THEN",
      "ELSE",
      "ENDIF",
      "IF",
      // controls
      "GOTO",
      "DO",
      "WHILE",
      "WH",
      "END",
      "CALL",
      // scoping
      "SUB",
      "ENDSUB",
      // comparisons
      "EQ",
      "NE",
      "LT",
      "GT",
      "LE",
      "GE",
      "AND",
      "OR",
      "XOR",
      // start/end of program
      "%"
    ],
    built_in: [
      "ATAN",
      "ABS",
      "ACOS",
      "ASIN",
      "COS",
      "EXP",
      "FIX",
      "FUP",
      "ROUND",
      "LN",
      "SIN",
      "SQRT",
      "TAN",
      "EXISTS"
    ]
  }, i = /\b/;
  function r(m, g) {
    if (m.index === 0)
      return;
    const S = m.input[m.index - 1];
    S >= "0" && S <= "9" || S !== "_" && g.ignoreMatch();
  }
  const a = /[+-]?((\.\d+)|(\d+)(\.\d*)?)/, s = /[GM]\s*\d+(\.\d+)?/, o = /T\s*\d+/, l = /O\s*\d+/, c = /O<.+>/, d = /[ABCUVWXYZ]\s*/, u = /[FHIJKPQRS]\s*/, _ = [
    // comments
    t.COMMENT(/\(/, /\)/),
    t.COMMENT(/;/, /$/),
    t.APOS_STRING_MODE,
    t.QUOTE_STRING_MODE,
    t.C_NUMBER_MODE,
    // gcodes
    {
      scope: "title.function",
      variants: [
        // G General functions: G0, G5.1, G5.2, …
        // M Misc functions: M0, M55.6, M199, …
        { match: e.concat(i, s) },
        {
          begin: s,
          "on:begin": r
        },
        // T Tools
        { match: e.concat(i, o) },
        {
          begin: o,
          "on:begin": r
        }
      ]
    },
    {
      scope: "symbol",
      variants: [
        // O Subroutine ID: O100, O110, …
        { match: e.concat(i, l) },
        {
          begin: l,
          "on:begin": r
        },
        // O Subroutine name: O<some>, …
        { match: e.concat(i, c) },
        {
          begin: c,
          "on:begin": r
        },
        // Checksum at end of line: *71, *199, …
        { match: /\*\s*\d+\s*$/ }
      ]
    },
    {
      scope: "operator",
      // N Line number: N1, N2, N1020, …
      match: /^N\s*\d+/
    },
    {
      scope: "variable",
      match: /-?#\s*\d+/
    },
    {
      scope: "property",
      // Physical axes,
      variants: [
        { match: e.concat(i, d, a) },
        {
          begin: e.concat(d, a),
          "on:begin": r
        }
      ]
    },
    {
      scope: "params",
      // Different types of parameters
      variants: [
        { match: e.concat(i, u, a) },
        {
          begin: e.concat(u, a),
          "on:begin": r
        }
      ]
    }
  ];
  return {
    name: "G-code (ISO 6983)",
    aliases: ["nc"],
    // Some implementations (CNC controls) of G-code are interoperable with uppercase and lowercase letters seamlessly.
    // However, most prefer all uppercase and uppercase is customary.
    case_insensitive: !0,
    // TODO: post v12 with the use of look-behind this can be enabled
    disableAutodetect: !0,
    keywords: n,
    contains: _
  };
}
function NE(t) {
  return {
    name: "Gherkin",
    aliases: ["feature"],
    keywords: "Feature Background Ability Business Need Scenario Scenarios Scenario Outline Scenario Template Examples Given And Then But When",
    contains: [
      {
        className: "symbol",
        begin: "\\*",
        relevance: 0
      },
      {
        className: "meta",
        begin: "@[^@\\s]+"
      },
      {
        begin: "\\|",
        end: "\\|\\w*$",
        contains: [
          {
            className: "string",
            begin: "[^|]+"
          }
        ]
      },
      {
        className: "variable",
        begin: "<",
        end: ">"
      },
      t.HASH_COMMENT_MODE,
      {
        className: "string",
        begin: '"""',
        end: '"""'
      },
      t.QUOTE_STRING_MODE
    ]
  };
}
function OE(t) {
  return {
    name: "GLSL",
    keywords: {
      keyword: (
        // Statements
        "break continue discard do else for if return while switch case default attribute binding buffer ccw centroid centroid varying coherent column_major const cw depth_any depth_greater depth_less depth_unchanged early_fragment_tests equal_spacing flat fractional_even_spacing fractional_odd_spacing highp in index inout invariant invocations isolines layout line_strip lines lines_adjacency local_size_x local_size_y local_size_z location lowp max_vertices mediump noperspective offset origin_upper_left out packed patch pixel_center_integer point_mode points precise precision quads r11f_g11f_b10f r16 r16_snorm r16f r16i r16ui r32f r32i r32ui r8 r8_snorm r8i r8ui readonly restrict rg16 rg16_snorm rg16f rg16i rg16ui rg32f rg32i rg32ui rg8 rg8_snorm rg8i rg8ui rgb10_a2 rgb10_a2ui rgba16 rgba16_snorm rgba16f rgba16i rgba16ui rgba32f rgba32i rgba32ui rgba8 rgba8_snorm rgba8i rgba8ui row_major sample shared smooth std140 std430 stream triangle_strip triangles triangles_adjacency uniform varying vertices volatile writeonly"
      ),
      type: "atomic_uint bool bvec2 bvec3 bvec4 dmat2 dmat2x2 dmat2x3 dmat2x4 dmat3 dmat3x2 dmat3x3 dmat3x4 dmat4 dmat4x2 dmat4x3 dmat4x4 double dvec2 dvec3 dvec4 float iimage1D iimage1DArray iimage2D iimage2DArray iimage2DMS iimage2DMSArray iimage2DRect iimage3D iimageBuffer iimageCube iimageCubeArray image1D image1DArray image2D image2DArray image2DMS image2DMSArray image2DRect image3D imageBuffer imageCube imageCubeArray int isampler1D isampler1DArray isampler2D isampler2DArray isampler2DMS isampler2DMSArray isampler2DRect isampler3D isamplerBuffer isamplerCube isamplerCubeArray ivec2 ivec3 ivec4 mat2 mat2x2 mat2x3 mat2x4 mat3 mat3x2 mat3x3 mat3x4 mat4 mat4x2 mat4x3 mat4x4 sampler1D sampler1DArray sampler1DArrayShadow sampler1DShadow sampler2D sampler2DArray sampler2DArrayShadow sampler2DMS sampler2DMSArray sampler2DRect sampler2DRectShadow sampler2DShadow sampler3D samplerBuffer samplerCube samplerCubeArray samplerCubeArrayShadow samplerCubeShadow image1D uimage1DArray uimage2D uimage2DArray uimage2DMS uimage2DMSArray uimage2DRect uimage3D uimageBuffer uimageCube uimageCubeArray uint usampler1D usampler1DArray usampler2D usampler2DArray usampler2DMS usampler2DMSArray usampler2DRect usampler3D samplerBuffer usamplerCube usamplerCubeArray uvec2 uvec3 uvec4 vec2 vec3 vec4 void",
      built_in: (
        // Constants
        "gl_MaxAtomicCounterBindings gl_MaxAtomicCounterBufferSize gl_MaxClipDistances gl_MaxClipPlanes gl_MaxCombinedAtomicCounterBuffers gl_MaxCombinedAtomicCounters gl_MaxCombinedImageUniforms gl_MaxCombinedImageUnitsAndFragmentOutputs gl_MaxCombinedTextureImageUnits gl_MaxComputeAtomicCounterBuffers gl_MaxComputeAtomicCounters gl_MaxComputeImageUniforms gl_MaxComputeTextureImageUnits gl_MaxComputeUniformComponents gl_MaxComputeWorkGroupCount gl_MaxComputeWorkGroupSize gl_MaxDrawBuffers gl_MaxFragmentAtomicCounterBuffers gl_MaxFragmentAtomicCounters gl_MaxFragmentImageUniforms gl_MaxFragmentInputComponents gl_MaxFragmentInputVectors gl_MaxFragmentUniformComponents gl_MaxFragmentUniformVectors gl_MaxGeometryAtomicCounterBuffers gl_MaxGeometryAtomicCounters gl_MaxGeometryImageUniforms gl_MaxGeometryInputComponents gl_MaxGeometryOutputComponents gl_MaxGeometryOutputVertices gl_MaxGeometryTextureImageUnits gl_MaxGeometryTotalOutputComponents gl_MaxGeometryUniformComponents gl_MaxGeometryVaryingComponents gl_MaxImageSamples gl_MaxImageUnits gl_MaxLights gl_MaxPatchVertices gl_MaxProgramTexelOffset gl_MaxTessControlAtomicCounterBuffers gl_MaxTessControlAtomicCounters gl_MaxTessControlImageUniforms gl_MaxTessControlInputComponents gl_MaxTessControlOutputComponents gl_MaxTessControlTextureImageUnits gl_MaxTessControlTotalOutputComponents gl_MaxTessControlUniformComponents gl_MaxTessEvaluationAtomicCounterBuffers gl_MaxTessEvaluationAtomicCounters gl_MaxTessEvaluationImageUniforms gl_MaxTessEvaluationInputComponents gl_MaxTessEvaluationOutputComponents gl_MaxTessEvaluationTextureImageUnits gl_MaxTessEvaluationUniformComponents gl_MaxTessGenLevel gl_MaxTessPatchComponents gl_MaxTextureCoords gl_MaxTextureImageUnits gl_MaxTextureUnits gl_MaxVaryingComponents gl_MaxVaryingFloats gl_MaxVaryingVectors gl_MaxVertexAtomicCounterBuffers gl_MaxVertexAtomicCounters gl_MaxVertexAttribs gl_MaxVertexImageUniforms gl_MaxVertexOutputComponents gl_MaxVertexOutputVectors gl_MaxVertexTextureImageUnits gl_MaxVertexUniformComponents gl_MaxVertexUniformVectors gl_MaxViewports gl_MinProgramTexelOffset gl_BackColor gl_BackLightModelProduct gl_BackLightProduct gl_BackMaterial gl_BackSecondaryColor gl_ClipDistance gl_ClipPlane gl_ClipVertex gl_Color gl_DepthRange gl_EyePlaneQ gl_EyePlaneR gl_EyePlaneS gl_EyePlaneT gl_Fog gl_FogCoord gl_FogFragCoord gl_FragColor gl_FragCoord gl_FragData gl_FragDepth gl_FrontColor gl_FrontFacing gl_FrontLightModelProduct gl_FrontLightProduct gl_FrontMaterial gl_FrontSecondaryColor gl_GlobalInvocationID gl_InstanceID gl_InvocationID gl_Layer gl_LightModel gl_LightSource gl_LocalInvocationID gl_LocalInvocationIndex gl_ModelViewMatrix gl_ModelViewMatrixInverse gl_ModelViewMatrixInverseTranspose gl_ModelViewMatrixTranspose gl_ModelViewProjectionMatrix gl_ModelViewProjectionMatrixInverse gl_ModelViewProjectionMatrixInverseTranspose gl_ModelViewProjectionMatrixTranspose gl_MultiTexCoord0 gl_MultiTexCoord1 gl_MultiTexCoord2 gl_MultiTexCoord3 gl_MultiTexCoord4 gl_MultiTexCoord5 gl_MultiTexCoord6 gl_MultiTexCoord7 gl_Normal gl_NormalMatrix gl_NormalScale gl_NumSamples gl_NumWorkGroups gl_ObjectPlaneQ gl_ObjectPlaneR gl_ObjectPlaneS gl_ObjectPlaneT gl_PatchVerticesIn gl_Point gl_PointCoord gl_PointSize gl_Position gl_PrimitiveID gl_PrimitiveIDIn gl_ProjectionMatrix gl_ProjectionMatrixInverse gl_ProjectionMatrixInverseTranspose gl_ProjectionMatrixTranspose gl_SampleID gl_SampleMask gl_SampleMaskIn gl_SamplePosition gl_SecondaryColor gl_TessCoord gl_TessLevelInner gl_TessLevelOuter gl_TexCoord gl_TextureEnvColor gl_TextureMatrix gl_TextureMatrixInverse gl_TextureMatrixInverseTranspose gl_TextureMatrixTranspose gl_Vertex gl_VertexID gl_ViewportIndex gl_WorkGroupID gl_WorkGroupSize gl_in gl_out EmitStreamVertex EmitVertex EndPrimitive EndStreamPrimitive abs acos acosh all any asin asinh atan atanh atomicAdd atomicAnd atomicCompSwap atomicCounter atomicCounterDecrement atomicCounterIncrement atomicExchange atomicMax atomicMin atomicOr atomicXor barrier bitCount bitfieldExtract bitfieldInsert bitfieldReverse ceil clamp cos cosh cross dFdx dFdy degrees determinant distance dot equal exp exp2 faceforward findLSB findMSB floatBitsToInt floatBitsToUint floor fma fract frexp ftransform fwidth greaterThan greaterThanEqual groupMemoryBarrier imageAtomicAdd imageAtomicAnd imageAtomicCompSwap imageAtomicExchange imageAtomicMax imageAtomicMin imageAtomicOr imageAtomicXor imageLoad imageSize imageStore imulExtended intBitsToFloat interpolateAtCentroid interpolateAtOffset interpolateAtSample inverse inversesqrt isinf isnan ldexp length lessThan lessThanEqual log log2 matrixCompMult max memoryBarrier memoryBarrierAtomicCounter memoryBarrierBuffer memoryBarrierImage memoryBarrierShared min mix mod modf noise1 noise2 noise3 noise4 normalize not notEqual outerProduct packDouble2x32 packHalf2x16 packSnorm2x16 packSnorm4x8 packUnorm2x16 packUnorm4x8 pow radians reflect refract round roundEven shadow1D shadow1DLod shadow1DProj shadow1DProjLod shadow2D shadow2DLod shadow2DProj shadow2DProjLod sign sin sinh smoothstep sqrt step tan tanh texelFetch texelFetchOffset texture texture1D texture1DLod texture1DProj texture1DProjLod texture2D texture2DLod texture2DProj texture2DProjLod texture3D texture3DLod texture3DProj texture3DProjLod textureCube textureCubeLod textureGather textureGatherOffset textureGatherOffsets textureGrad textureGradOffset textureLod textureLodOffset textureOffset textureProj textureProjGrad textureProjGradOffset textureProjLod textureProjLodOffset textureProjOffset textureQueryLevels textureQueryLod textureSize transpose trunc uaddCarry uintBitsToFloat umulExtended unpackDouble2x32 unpackHalf2x16 unpackSnorm2x16 unpackSnorm4x8 unpackUnorm2x16 unpackUnorm4x8 usubBorrow"
      ),
      literal: "true false"
    },
    illegal: '"',
    contains: [
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      t.C_NUMBER_MODE,
      {
        className: "meta",
        begin: "#",
        end: "$"
      }
    ]
  };
}
function vE(t) {
  return {
    name: "GML",
    case_insensitive: !1,
    // language is case-insensitive
    keywords: {
      keyword: [
        "#endregion",
        "#macro",
        "#region",
        "and",
        "begin",
        "break",
        "case",
        "constructor",
        "continue",
        "default",
        "delete",
        "div",
        "do",
        "else",
        "end",
        "enum",
        "exit",
        "for",
        "function",
        "globalvar",
        "if",
        "mod",
        "new",
        "not",
        "or",
        "repeat",
        "return",
        "static",
        "switch",
        "then",
        "until",
        "var",
        "while",
        "with",
        "xor"
      ],
      built_in: [
        "abs",
        "alarm_get",
        "alarm_set",
        "angle_difference",
        "animcurve_channel_evaluate",
        "animcurve_channel_new",
        "animcurve_create",
        "animcurve_destroy",
        "animcurve_exists",
        "animcurve_get",
        "animcurve_get_channel",
        "animcurve_get_channel_index",
        "animcurve_point_new",
        "ansi_char",
        "application_get_position",
        "application_surface_draw_enable",
        "application_surface_enable",
        "application_surface_is_enabled",
        "arccos",
        "arcsin",
        "arctan",
        "arctan2",
        "array_all",
        "array_any",
        "array_concat",
        "array_contains",
        "array_contains_ext",
        "array_copy",
        "array_copy_while",
        "array_create",
        "array_create_ext",
        "array_delete",
        "array_equals",
        "array_filter",
        "array_filter_ext",
        "array_find_index",
        "array_first",
        "array_foreach",
        "array_get",
        "array_get_index",
        "array_insert",
        "array_intersection",
        "array_last",
        "array_length",
        "array_map",
        "array_map_ext",
        "array_pop",
        "array_push",
        "array_reduce",
        "array_resize",
        "array_reverse",
        "array_reverse_ext",
        "array_set",
        "array_shuffle",
        "array_shuffle_ext",
        "array_sort",
        "array_union",
        "array_unique",
        "array_unique_ext",
        "asset_add_tags",
        "asset_clear_tags",
        "asset_get_ids",
        "asset_get_index",
        "asset_get_tags",
        "asset_get_type",
        "asset_has_any_tag",
        "asset_has_tags",
        "asset_remove_tags",
        "audio_bus_clear_emitters",
        "audio_bus_create",
        "audio_bus_get_emitters",
        "audio_channel_num",
        "audio_create_buffer_sound",
        "audio_create_play_queue",
        "audio_create_stream",
        "audio_create_sync_group",
        "audio_debug",
        "audio_destroy_stream",
        "audio_destroy_sync_group",
        "audio_effect_create",
        "audio_emitter_bus",
        "audio_emitter_create",
        "audio_emitter_exists",
        "audio_emitter_falloff",
        "audio_emitter_free",
        "audio_emitter_gain",
        "audio_emitter_get_bus",
        "audio_emitter_get_gain",
        "audio_emitter_get_listener_mask",
        "audio_emitter_get_pitch",
        "audio_emitter_get_vx",
        "audio_emitter_get_vy",
        "audio_emitter_get_vz",
        "audio_emitter_get_x",
        "audio_emitter_get_y",
        "audio_emitter_get_z",
        "audio_emitter_pitch",
        "audio_emitter_position",
        "audio_emitter_set_listener_mask",
        "audio_emitter_velocity",
        "audio_exists",
        "audio_falloff_set_model",
        "audio_free_buffer_sound",
        "audio_free_play_queue",
        "audio_get_listener_count",
        "audio_get_listener_info",
        "audio_get_listener_mask",
        "audio_get_master_gain",
        "audio_get_name",
        "audio_get_recorder_count",
        "audio_get_recorder_info",
        "audio_get_type",
        "audio_group_get_assets",
        "audio_group_get_gain",
        "audio_group_is_loaded",
        "audio_group_load",
        "audio_group_load_progress",
        "audio_group_name",
        "audio_group_set_gain",
        "audio_group_stop_all",
        "audio_group_unload",
        "audio_is_paused",
        "audio_is_playing",
        "audio_listener_get_data",
        "audio_listener_orientation",
        "audio_listener_position",
        "audio_listener_set_orientation",
        "audio_listener_set_position",
        "audio_listener_set_velocity",
        "audio_listener_velocity",
        "audio_master_gain",
        "audio_pause_all",
        "audio_pause_sound",
        "audio_pause_sync_group",
        "audio_play_in_sync_group",
        "audio_play_sound",
        "audio_play_sound_at",
        "audio_play_sound_ext",
        "audio_play_sound_on",
        "audio_queue_sound",
        "audio_resume_all",
        "audio_resume_sound",
        "audio_resume_sync_group",
        "audio_set_listener_mask",
        "audio_set_master_gain",
        "audio_sound_gain",
        "audio_sound_get_audio_group",
        "audio_sound_get_gain",
        "audio_sound_get_listener_mask",
        "audio_sound_get_loop",
        "audio_sound_get_loop_end",
        "audio_sound_get_loop_start",
        "audio_sound_get_pitch",
        "audio_sound_get_track_position",
        "audio_sound_is_playable",
        "audio_sound_length",
        "audio_sound_loop",
        "audio_sound_loop_end",
        "audio_sound_loop_start",
        "audio_sound_pitch",
        "audio_sound_set_listener_mask",
        "audio_sound_set_track_position",
        "audio_start_recording",
        "audio_start_sync_group",
        "audio_stop_all",
        "audio_stop_recording",
        "audio_stop_sound",
        "audio_stop_sync_group",
        "audio_sync_group_debug",
        "audio_sync_group_get_track_pos",
        "audio_sync_group_is_paused",
        "audio_sync_group_is_playing",
        "audio_system_is_available",
        "audio_system_is_initialised",
        "base64_decode",
        "base64_encode",
        "bool",
        "browser_input_capture",
        "buffer_async_group_begin",
        "buffer_async_group_end",
        "buffer_async_group_option",
        "buffer_base64_decode",
        "buffer_base64_decode_ext",
        "buffer_base64_encode",
        "buffer_compress",
        "buffer_copy",
        "buffer_copy_from_vertex_buffer",
        "buffer_copy_stride",
        "buffer_crc32",
        "buffer_create",
        "buffer_create_from_vertex_buffer",
        "buffer_create_from_vertex_buffer_ext",
        "buffer_decompress",
        "buffer_delete",
        "buffer_exists",
        "buffer_fill",
        "buffer_get_address",
        "buffer_get_alignment",
        "buffer_get_size",
        "buffer_get_surface",
        "buffer_get_type",
        "buffer_load",
        "buffer_load_async",
        "buffer_load_ext",
        "buffer_load_partial",
        "buffer_md5",
        "buffer_peek",
        "buffer_poke",
        "buffer_read",
        "buffer_resize",
        "buffer_save",
        "buffer_save_async",
        "buffer_save_ext",
        "buffer_seek",
        "buffer_set_surface",
        "buffer_set_used_size",
        "buffer_sha1",
        "buffer_sizeof",
        "buffer_tell",
        "buffer_write",
        "call_cancel",
        "call_later",
        "camera_apply",
        "camera_copy_transforms",
        "camera_create",
        "camera_create_view",
        "camera_destroy",
        "camera_get_active",
        "camera_get_begin_script",
        "camera_get_default",
        "camera_get_end_script",
        "camera_get_proj_mat",
        "camera_get_update_script",
        "camera_get_view_angle",
        "camera_get_view_border_x",
        "camera_get_view_border_y",
        "camera_get_view_height",
        "camera_get_view_mat",
        "camera_get_view_speed_x",
        "camera_get_view_speed_y",
        "camera_get_view_target",
        "camera_get_view_width",
        "camera_get_view_x",
        "camera_get_view_y",
        "camera_set_begin_script",
        "camera_set_default",
        "camera_set_end_script",
        "camera_set_proj_mat",
        "camera_set_update_script",
        "camera_set_view_angle",
        "camera_set_view_border",
        "camera_set_view_mat",
        "camera_set_view_pos",
        "camera_set_view_size",
        "camera_set_view_speed",
        "camera_set_view_target",
        "ceil",
        "choose",
        "chr",
        "clamp",
        "clickable_add",
        "clickable_add_ext",
        "clickable_change",
        "clickable_change_ext",
        "clickable_delete",
        "clickable_exists",
        "clickable_set_style",
        "clipboard_get_text",
        "clipboard_has_text",
        "clipboard_set_text",
        "cloud_file_save",
        "cloud_string_save",
        "cloud_synchronise",
        "code_is_compiled",
        "collision_circle",
        "collision_circle_list",
        "collision_ellipse",
        "collision_ellipse_list",
        "collision_line",
        "collision_line_list",
        "collision_point",
        "collision_point_list",
        "collision_rectangle",
        "collision_rectangle_list",
        "color_get_blue",
        "color_get_green",
        "color_get_hue",
        "color_get_red",
        "color_get_saturation",
        "color_get_value",
        "colour_get_blue",
        "colour_get_green",
        "colour_get_hue",
        "colour_get_red",
        "colour_get_saturation",
        "colour_get_value",
        "cos",
        "darccos",
        "darcsin",
        "darctan",
        "darctan2",
        "date_compare_date",
        "date_compare_datetime",
        "date_compare_time",
        "date_create_datetime",
        "date_current_datetime",
        "date_date_of",
        "date_date_string",
        "date_datetime_string",
        "date_day_span",
        "date_days_in_month",
        "date_days_in_year",
        "date_get_day",
        "date_get_day_of_year",
        "date_get_hour",
        "date_get_hour_of_year",
        "date_get_minute",
        "date_get_minute_of_year",
        "date_get_month",
        "date_get_second",
        "date_get_second_of_year",
        "date_get_timezone",
        "date_get_week",
        "date_get_weekday",
        "date_get_year",
        "date_hour_span",
        "date_inc_day",
        "date_inc_hour",
        "date_inc_minute",
        "date_inc_month",
        "date_inc_second",
        "date_inc_week",
        "date_inc_year",
        "date_is_today",
        "date_leap_year",
        "date_minute_span",
        "date_month_span",
        "date_second_span",
        "date_set_timezone",
        "date_time_of",
        "date_time_string",
        "date_valid_datetime",
        "date_week_span",
        "date_year_span",
        "db_to_lin",
        "dbg_add_font_glyphs",
        "dbg_button",
        "dbg_checkbox",
        "dbg_color",
        "dbg_colour",
        "dbg_drop_down",
        "dbg_same_line",
        "dbg_section",
        "dbg_section_delete",
        "dbg_section_exists",
        "dbg_slider",
        "dbg_slider_int",
        "dbg_sprite",
        "dbg_text",
        "dbg_text_input",
        "dbg_view",
        "dbg_view_delete",
        "dbg_view_exists",
        "dbg_watch",
        "dcos",
        "debug_event",
        "debug_get_callstack",
        "degtorad",
        "device_get_tilt_x",
        "device_get_tilt_y",
        "device_get_tilt_z",
        "device_is_keypad_open",
        "device_mouse_check_button",
        "device_mouse_check_button_pressed",
        "device_mouse_check_button_released",
        "device_mouse_dbclick_enable",
        "device_mouse_raw_x",
        "device_mouse_raw_y",
        "device_mouse_x",
        "device_mouse_x_to_gui",
        "device_mouse_y",
        "device_mouse_y_to_gui",
        "directory_create",
        "directory_destroy",
        "directory_exists",
        "display_get_dpi_x",
        "display_get_dpi_y",
        "display_get_frequency",
        "display_get_gui_height",
        "display_get_gui_width",
        "display_get_height",
        "display_get_orientation",
        "display_get_sleep_margin",
        "display_get_timing_method",
        "display_get_width",
        "display_mouse_get_x",
        "display_mouse_get_y",
        "display_mouse_set",
        "display_reset",
        "display_set_gui_maximise",
        "display_set_gui_maximize",
        "display_set_gui_size",
        "display_set_sleep_margin",
        "display_set_timing_method",
        "display_set_ui_visibility",
        "distance_to_object",
        "distance_to_point",
        "dot_product",
        "dot_product_3d",
        "dot_product_3d_normalised",
        "dot_product_3d_normalized",
        "dot_product_normalised",
        "dot_product_normalized",
        "draw_arrow",
        "draw_button",
        "draw_circle",
        "draw_circle_color",
        "draw_circle_colour",
        "draw_clear",
        "draw_clear_alpha",
        "draw_ellipse",
        "draw_ellipse_color",
        "draw_ellipse_colour",
        "draw_enable_drawevent",
        "draw_enable_skeleton_blendmodes",
        "draw_enable_swf_aa",
        "draw_flush",
        "draw_get_alpha",
        "draw_get_color",
        "draw_get_colour",
        "draw_get_enable_skeleton_blendmodes",
        "draw_get_font",
        "draw_get_halign",
        "draw_get_lighting",
        "draw_get_swf_aa_level",
        "draw_get_valign",
        "draw_getpixel",
        "draw_getpixel_ext",
        "draw_healthbar",
        "draw_highscore",
        "draw_light_define_ambient",
        "draw_light_define_direction",
        "draw_light_define_point",
        "draw_light_enable",
        "draw_light_get",
        "draw_light_get_ambient",
        "draw_line",
        "draw_line_color",
        "draw_line_colour",
        "draw_line_width",
        "draw_line_width_color",
        "draw_line_width_colour",
        "draw_path",
        "draw_point",
        "draw_point_color",
        "draw_point_colour",
        "draw_primitive_begin",
        "draw_primitive_begin_texture",
        "draw_primitive_end",
        "draw_rectangle",
        "draw_rectangle_color",
        "draw_rectangle_colour",
        "draw_roundrect",
        "draw_roundrect_color",
        "draw_roundrect_color_ext",
        "draw_roundrect_colour",
        "draw_roundrect_colour_ext",
        "draw_roundrect_ext",
        "draw_self",
        "draw_set_alpha",
        "draw_set_circle_precision",
        "draw_set_color",
        "draw_set_colour",
        "draw_set_font",
        "draw_set_halign",
        "draw_set_lighting",
        "draw_set_swf_aa_level",
        "draw_set_valign",
        "draw_skeleton",
        "draw_skeleton_collision",
        "draw_skeleton_instance",
        "draw_skeleton_time",
        "draw_sprite",
        "draw_sprite_ext",
        "draw_sprite_general",
        "draw_sprite_part",
        "draw_sprite_part_ext",
        "draw_sprite_pos",
        "draw_sprite_stretched",
        "draw_sprite_stretched_ext",
        "draw_sprite_tiled",
        "draw_sprite_tiled_ext",
        "draw_surface",
        "draw_surface_ext",
        "draw_surface_general",
        "draw_surface_part",
        "draw_surface_part_ext",
        "draw_surface_stretched",
        "draw_surface_stretched_ext",
        "draw_surface_tiled",
        "draw_surface_tiled_ext",
        "draw_text",
        "draw_text_color",
        "draw_text_colour",
        "draw_text_ext",
        "draw_text_ext_color",
        "draw_text_ext_colour",
        "draw_text_ext_transformed",
        "draw_text_ext_transformed_color",
        "draw_text_ext_transformed_colour",
        "draw_text_transformed",
        "draw_text_transformed_color",
        "draw_text_transformed_colour",
        "draw_texture_flush",
        "draw_tile",
        "draw_tilemap",
        "draw_triangle",
        "draw_triangle_color",
        "draw_triangle_colour",
        "draw_vertex",
        "draw_vertex_color",
        "draw_vertex_colour",
        "draw_vertex_texture",
        "draw_vertex_texture_color",
        "draw_vertex_texture_colour",
        "ds_exists",
        "ds_grid_add",
        "ds_grid_add_disk",
        "ds_grid_add_grid_region",
        "ds_grid_add_region",
        "ds_grid_clear",
        "ds_grid_copy",
        "ds_grid_create",
        "ds_grid_destroy",
        "ds_grid_get",
        "ds_grid_get_disk_max",
        "ds_grid_get_disk_mean",
        "ds_grid_get_disk_min",
        "ds_grid_get_disk_sum",
        "ds_grid_get_max",
        "ds_grid_get_mean",
        "ds_grid_get_min",
        "ds_grid_get_sum",
        "ds_grid_height",
        "ds_grid_multiply",
        "ds_grid_multiply_disk",
        "ds_grid_multiply_grid_region",
        "ds_grid_multiply_region",
        "ds_grid_read",
        "ds_grid_resize",
        "ds_grid_set",
        "ds_grid_set_disk",
        "ds_grid_set_grid_region",
        "ds_grid_set_region",
        "ds_grid_shuffle",
        "ds_grid_sort",
        "ds_grid_to_mp_grid",
        "ds_grid_value_disk_exists",
        "ds_grid_value_disk_x",
        "ds_grid_value_disk_y",
        "ds_grid_value_exists",
        "ds_grid_value_x",
        "ds_grid_value_y",
        "ds_grid_width",
        "ds_grid_write",
        "ds_list_add",
        "ds_list_clear",
        "ds_list_copy",
        "ds_list_create",
        "ds_list_delete",
        "ds_list_destroy",
        "ds_list_empty",
        "ds_list_find_index",
        "ds_list_find_value",
        "ds_list_insert",
        "ds_list_is_list",
        "ds_list_is_map",
        "ds_list_mark_as_list",
        "ds_list_mark_as_map",
        "ds_list_read",
        "ds_list_replace",
        "ds_list_set",
        "ds_list_shuffle",
        "ds_list_size",
        "ds_list_sort",
        "ds_list_write",
        "ds_map_add",
        "ds_map_add_list",
        "ds_map_add_map",
        "ds_map_clear",
        "ds_map_copy",
        "ds_map_create",
        "ds_map_delete",
        "ds_map_destroy",
        "ds_map_empty",
        "ds_map_exists",
        "ds_map_find_first",
        "ds_map_find_last",
        "ds_map_find_next",
        "ds_map_find_previous",
        "ds_map_find_value",
        "ds_map_is_list",
        "ds_map_is_map",
        "ds_map_keys_to_array",
        "ds_map_read",
        "ds_map_replace",
        "ds_map_replace_list",
        "ds_map_replace_map",
        "ds_map_secure_load",
        "ds_map_secure_load_buffer",
        "ds_map_secure_save",
        "ds_map_secure_save_buffer",
        "ds_map_set",
        "ds_map_size",
        "ds_map_values_to_array",
        "ds_map_write",
        "ds_priority_add",
        "ds_priority_change_priority",
        "ds_priority_clear",
        "ds_priority_copy",
        "ds_priority_create",
        "ds_priority_delete_max",
        "ds_priority_delete_min",
        "ds_priority_delete_value",
        "ds_priority_destroy",
        "ds_priority_empty",
        "ds_priority_find_max",
        "ds_priority_find_min",
        "ds_priority_find_priority",
        "ds_priority_read",
        "ds_priority_size",
        "ds_priority_write",
        "ds_queue_clear",
        "ds_queue_copy",
        "ds_queue_create",
        "ds_queue_dequeue",
        "ds_queue_destroy",
        "ds_queue_empty",
        "ds_queue_enqueue",
        "ds_queue_head",
        "ds_queue_read",
        "ds_queue_size",
        "ds_queue_tail",
        "ds_queue_write",
        "ds_set_precision",
        "ds_stack_clear",
        "ds_stack_copy",
        "ds_stack_create",
        "ds_stack_destroy",
        "ds_stack_empty",
        "ds_stack_pop",
        "ds_stack_push",
        "ds_stack_read",
        "ds_stack_size",
        "ds_stack_top",
        "ds_stack_write",
        "dsin",
        "dtan",
        "effect_clear",
        "effect_create_above",
        "effect_create_below",
        "effect_create_depth",
        "effect_create_layer",
        "environment_get_variable",
        "event_inherited",
        "event_perform",
        "event_perform_async",
        "event_perform_object",
        "event_user",
        "exception_unhandled_handler",
        "exp",
        "extension_exists",
        "extension_get_option_count",
        "extension_get_option_names",
        "extension_get_option_value",
        "extension_get_options",
        "extension_get_version",
        "external_call",
        "external_define",
        "external_free",
        "file_attributes",
        "file_bin_close",
        "file_bin_open",
        "file_bin_position",
        "file_bin_read_byte",
        "file_bin_rewrite",
        "file_bin_seek",
        "file_bin_size",
        "file_bin_write_byte",
        "file_copy",
        "file_delete",
        "file_exists",
        "file_find_close",
        "file_find_first",
        "file_find_next",
        "file_rename",
        "file_text_close",
        "file_text_eof",
        "file_text_eoln",
        "file_text_open_append",
        "file_text_open_from_string",
        "file_text_open_read",
        "file_text_open_write",
        "file_text_read_real",
        "file_text_read_string",
        "file_text_readln",
        "file_text_write_real",
        "file_text_write_string",
        "file_text_writeln",
        "filename_change_ext",
        "filename_dir",
        "filename_drive",
        "filename_ext",
        "filename_name",
        "filename_path",
        "floor",
        "font_add",
        "font_add_enable_aa",
        "font_add_get_enable_aa",
        "font_add_sprite",
        "font_add_sprite_ext",
        "font_cache_glyph",
        "font_delete",
        "font_enable_effects",
        "font_enable_sdf",
        "font_exists",
        "font_get_bold",
        "font_get_first",
        "font_get_fontname",
        "font_get_info",
        "font_get_italic",
        "font_get_last",
        "font_get_name",
        "font_get_sdf_enabled",
        "font_get_sdf_spread",
        "font_get_size",
        "font_get_texture",
        "font_get_uvs",
        "font_replace_sprite",
        "font_replace_sprite_ext",
        "font_sdf_spread",
        "font_set_cache_size",
        "frac",
        "fx_create",
        "fx_get_name",
        "fx_get_parameter",
        "fx_get_parameter_names",
        "fx_get_parameters",
        "fx_get_single_layer",
        "fx_set_parameter",
        "fx_set_parameters",
        "fx_set_single_layer",
        "game_change",
        "game_end",
        "game_get_speed",
        "game_load",
        "game_load_buffer",
        "game_restart",
        "game_save",
        "game_save_buffer",
        "game_set_speed",
        "gamepad_axis_count",
        "gamepad_axis_value",
        "gamepad_button_check",
        "gamepad_button_check_pressed",
        "gamepad_button_check_released",
        "gamepad_button_count",
        "gamepad_button_value",
        "gamepad_get_axis_deadzone",
        "gamepad_get_button_threshold",
        "gamepad_get_description",
        "gamepad_get_device_count",
        "gamepad_get_guid",
        "gamepad_get_mapping",
        "gamepad_get_option",
        "gamepad_hat_count",
        "gamepad_hat_value",
        "gamepad_is_connected",
        "gamepad_is_supported",
        "gamepad_remove_mapping",
        "gamepad_set_axis_deadzone",
        "gamepad_set_button_threshold",
        "gamepad_set_color",
        "gamepad_set_colour",
        "gamepad_set_option",
        "gamepad_set_vibration",
        "gamepad_test_mapping",
        "gc_collect",
        "gc_enable",
        "gc_get_stats",
        "gc_get_target_frame_time",
        "gc_is_enabled",
        "gc_target_frame_time",
        "gesture_double_tap_distance",
        "gesture_double_tap_time",
        "gesture_drag_distance",
        "gesture_drag_time",
        "gesture_flick_speed",
        "gesture_get_double_tap_distance",
        "gesture_get_double_tap_time",
        "gesture_get_drag_distance",
        "gesture_get_drag_time",
        "gesture_get_flick_speed",
        "gesture_get_pinch_angle_away",
        "gesture_get_pinch_angle_towards",
        "gesture_get_pinch_distance",
        "gesture_get_rotate_angle",
        "gesture_get_rotate_time",
        "gesture_get_tap_count",
        "gesture_pinch_angle_away",
        "gesture_pinch_angle_towards",
        "gesture_pinch_distance",
        "gesture_rotate_angle",
        "gesture_rotate_time",
        "gesture_tap_count",
        "get_integer",
        "get_integer_async",
        "get_login_async",
        "get_open_filename",
        "get_open_filename_ext",
        "get_save_filename",
        "get_save_filename_ext",
        "get_string",
        "get_string_async",
        "get_timer",
        "gif_add_surface",
        "gif_open",
        "gif_save",
        "gif_save_buffer",
        "gml_pragma",
        "gml_release_mode",
        "gpu_get_alphatestenable",
        "gpu_get_alphatestref",
        "gpu_get_blendenable",
        "gpu_get_blendmode",
        "gpu_get_blendmode_dest",
        "gpu_get_blendmode_destalpha",
        "gpu_get_blendmode_ext",
        "gpu_get_blendmode_ext_sepalpha",
        "gpu_get_blendmode_src",
        "gpu_get_blendmode_srcalpha",
        "gpu_get_colorwriteenable",
        "gpu_get_colourwriteenable",
        "gpu_get_cullmode",
        "gpu_get_depth",
        "gpu_get_fog",
        "gpu_get_state",
        "gpu_get_tex_filter",
        "gpu_get_tex_filter_ext",
        "gpu_get_tex_max_aniso",
        "gpu_get_tex_max_aniso_ext",
        "gpu_get_tex_max_mip",
        "gpu_get_tex_max_mip_ext",
        "gpu_get_tex_min_mip",
        "gpu_get_tex_min_mip_ext",
        "gpu_get_tex_mip_bias",
        "gpu_get_tex_mip_bias_ext",
        "gpu_get_tex_mip_enable",
        "gpu_get_tex_mip_enable_ext",
        "gpu_get_tex_mip_filter",
        "gpu_get_tex_mip_filter_ext",
        "gpu_get_tex_repeat",
        "gpu_get_tex_repeat_ext",
        "gpu_get_texfilter",
        "gpu_get_texfilter_ext",
        "gpu_get_texrepeat",
        "gpu_get_texrepeat_ext",
        "gpu_get_zfunc",
        "gpu_get_ztestenable",
        "gpu_get_zwriteenable",
        "gpu_pop_state",
        "gpu_push_state",
        "gpu_set_alphatestenable",
        "gpu_set_alphatestref",
        "gpu_set_blendenable",
        "gpu_set_blendmode",
        "gpu_set_blendmode_ext",
        "gpu_set_blendmode_ext_sepalpha",
        "gpu_set_colorwriteenable",
        "gpu_set_colourwriteenable",
        "gpu_set_cullmode",
        "gpu_set_depth",
        "gpu_set_fog",
        "gpu_set_state",
        "gpu_set_tex_filter",
        "gpu_set_tex_filter_ext",
        "gpu_set_tex_max_aniso",
        "gpu_set_tex_max_aniso_ext",
        "gpu_set_tex_max_mip",
        "gpu_set_tex_max_mip_ext",
        "gpu_set_tex_min_mip",
        "gpu_set_tex_min_mip_ext",
        "gpu_set_tex_mip_bias",
        "gpu_set_tex_mip_bias_ext",
        "gpu_set_tex_mip_enable",
        "gpu_set_tex_mip_enable_ext",
        "gpu_set_tex_mip_filter",
        "gpu_set_tex_mip_filter_ext",
        "gpu_set_tex_repeat",
        "gpu_set_tex_repeat_ext",
        "gpu_set_texfilter",
        "gpu_set_texfilter_ext",
        "gpu_set_texrepeat",
        "gpu_set_texrepeat_ext",
        "gpu_set_zfunc",
        "gpu_set_ztestenable",
        "gpu_set_zwriteenable",
        "handle_parse",
        "highscore_add",
        "highscore_clear",
        "highscore_name",
        "highscore_value",
        "http_get",
        "http_get_file",
        "http_get_request_crossorigin",
        "http_post_string",
        "http_request",
        "http_set_request_crossorigin",
        "iap_acquire",
        "iap_activate",
        "iap_consume",
        "iap_enumerate_products",
        "iap_product_details",
        "iap_purchase_details",
        "iap_restore_all",
        "iap_status",
        "ini_close",
        "ini_key_delete",
        "ini_key_exists",
        "ini_open",
        "ini_open_from_string",
        "ini_read_real",
        "ini_read_string",
        "ini_section_delete",
        "ini_section_exists",
        "ini_write_real",
        "ini_write_string",
        "instance_activate_all",
        "instance_activate_layer",
        "instance_activate_object",
        "instance_activate_region",
        "instance_change",
        "instance_copy",
        "instance_create_depth",
        "instance_create_layer",
        "instance_deactivate_all",
        "instance_deactivate_layer",
        "instance_deactivate_object",
        "instance_deactivate_region",
        "instance_destroy",
        "instance_exists",
        "instance_find",
        "instance_furthest",
        "instance_id_get",
        "instance_nearest",
        "instance_number",
        "instance_place",
        "instance_place_list",
        "instance_position",
        "instance_position_list",
        "instanceof",
        "int64",
        "io_clear",
        "irandom",
        "irandom_range",
        "is_array",
        "is_bool",
        "is_callable",
        "is_debug_overlay_open",
        "is_handle",
        "is_infinity",
        "is_instanceof",
        "is_int32",
        "is_int64",
        "is_keyboard_used_debug_overlay",
        "is_method",
        "is_mouse_over_debug_overlay",
        "is_nan",
        "is_numeric",
        "is_ptr",
        "is_real",
        "is_string",
        "is_struct",
        "is_undefined",
        "json_decode",
        "json_encode",
        "json_parse",
        "json_stringify",
        "keyboard_check",
        "keyboard_check_direct",
        "keyboard_check_pressed",
        "keyboard_check_released",
        "keyboard_clear",
        "keyboard_get_map",
        "keyboard_get_numlock",
        "keyboard_key_press",
        "keyboard_key_release",
        "keyboard_set_map",
        "keyboard_set_numlock",
        "keyboard_unset_map",
        "keyboard_virtual_height",
        "keyboard_virtual_hide",
        "keyboard_virtual_show",
        "keyboard_virtual_status",
        "layer_add_instance",
        "layer_background_alpha",
        "layer_background_blend",
        "layer_background_change",
        "layer_background_create",
        "layer_background_destroy",
        "layer_background_exists",
        "layer_background_get_alpha",
        "layer_background_get_blend",
        "layer_background_get_htiled",
        "layer_background_get_id",
        "layer_background_get_index",
        "layer_background_get_speed",
        "layer_background_get_sprite",
        "layer_background_get_stretch",
        "layer_background_get_visible",
        "layer_background_get_vtiled",
        "layer_background_get_xscale",
        "layer_background_get_yscale",
        "layer_background_htiled",
        "layer_background_index",
        "layer_background_speed",
        "layer_background_sprite",
        "layer_background_stretch",
        "layer_background_visible",
        "layer_background_vtiled",
        "layer_background_xscale",
        "layer_background_yscale",
        "layer_clear_fx",
        "layer_create",
        "layer_depth",
        "layer_destroy",
        "layer_destroy_instances",
        "layer_element_move",
        "layer_enable_fx",
        "layer_exists",
        "layer_force_draw_depth",
        "layer_fx_is_enabled",
        "layer_get_all",
        "layer_get_all_elements",
        "layer_get_depth",
        "layer_get_element_layer",
        "layer_get_element_type",
        "layer_get_forced_depth",
        "layer_get_fx",
        "layer_get_hspeed",
        "layer_get_id",
        "layer_get_id_at_depth",
        "layer_get_name",
        "layer_get_script_begin",
        "layer_get_script_end",
        "layer_get_shader",
        "layer_get_target_room",
        "layer_get_visible",
        "layer_get_vspeed",
        "layer_get_x",
        "layer_get_y",
        "layer_has_instance",
        "layer_hspeed",
        "layer_instance_get_instance",
        "layer_is_draw_depth_forced",
        "layer_reset_target_room",
        "layer_script_begin",
        "layer_script_end",
        "layer_sequence_angle",
        "layer_sequence_create",
        "layer_sequence_destroy",
        "layer_sequence_exists",
        "layer_sequence_get_angle",
        "layer_sequence_get_headdir",
        "layer_sequence_get_headpos",
        "layer_sequence_get_instance",
        "layer_sequence_get_length",
        "layer_sequence_get_sequence",
        "layer_sequence_get_speedscale",
        "layer_sequence_get_x",
        "layer_sequence_get_xscale",
        "layer_sequence_get_y",
        "layer_sequence_get_yscale",
        "layer_sequence_headdir",
        "layer_sequence_headpos",
        "layer_sequence_is_finished",
        "layer_sequence_is_paused",
        "layer_sequence_pause",
        "layer_sequence_play",
        "layer_sequence_speedscale",
        "layer_sequence_x",
        "layer_sequence_xscale",
        "layer_sequence_y",
        "layer_sequence_yscale",
        "layer_set_fx",
        "layer_set_target_room",
        "layer_set_visible",
        "layer_shader",
        "layer_sprite_alpha",
        "layer_sprite_angle",
        "layer_sprite_blend",
        "layer_sprite_change",
        "layer_sprite_create",
        "layer_sprite_destroy",
        "layer_sprite_exists",
        "layer_sprite_get_alpha",
        "layer_sprite_get_angle",
        "layer_sprite_get_blend",
        "layer_sprite_get_id",
        "layer_sprite_get_index",
        "layer_sprite_get_speed",
        "layer_sprite_get_sprite",
        "layer_sprite_get_x",
        "layer_sprite_get_xscale",
        "layer_sprite_get_y",
        "layer_sprite_get_yscale",
        "layer_sprite_index",
        "layer_sprite_speed",
        "layer_sprite_x",
        "layer_sprite_xscale",
        "layer_sprite_y",
        "layer_sprite_yscale",
        "layer_tile_alpha",
        "layer_tile_blend",
        "layer_tile_change",
        "layer_tile_create",
        "layer_tile_destroy",
        "layer_tile_exists",
        "layer_tile_get_alpha",
        "layer_tile_get_blend",
        "layer_tile_get_region",
        "layer_tile_get_sprite",
        "layer_tile_get_visible",
        "layer_tile_get_x",
        "layer_tile_get_xscale",
        "layer_tile_get_y",
        "layer_tile_get_yscale",
        "layer_tile_region",
        "layer_tile_visible",
        "layer_tile_x",
        "layer_tile_xscale",
        "layer_tile_y",
        "layer_tile_yscale",
        "layer_tilemap_create",
        "layer_tilemap_destroy",
        "layer_tilemap_exists",
        "layer_tilemap_get_id",
        "layer_vspeed",
        "layer_x",
        "layer_y",
        "lengthdir_x",
        "lengthdir_y",
        "lerp",
        "lin_to_db",
        "ln",
        "load_csv",
        "log10",
        "log2",
        "logn",
        "make_color_hsv",
        "make_color_rgb",
        "make_colour_hsv",
        "make_colour_rgb",
        "math_get_epsilon",
        "math_set_epsilon",
        "matrix_build",
        "matrix_build_identity",
        "matrix_build_lookat",
        "matrix_build_projection_ortho",
        "matrix_build_projection_perspective",
        "matrix_build_projection_perspective_fov",
        "matrix_get",
        "matrix_multiply",
        "matrix_set",
        "matrix_stack_clear",
        "matrix_stack_is_empty",
        "matrix_stack_pop",
        "matrix_stack_push",
        "matrix_stack_set",
        "matrix_stack_top",
        "matrix_transform_vertex",
        "max",
        "md5_file",
        "md5_string_unicode",
        "md5_string_utf8",
        "mean",
        "median",
        "merge_color",
        "merge_colour",
        "method",
        "method_call",
        "method_get_index",
        "method_get_self",
        "min",
        "motion_add",
        "motion_set",
        "mouse_check_button",
        "mouse_check_button_pressed",
        "mouse_check_button_released",
        "mouse_clear",
        "mouse_wheel_down",
        "mouse_wheel_up",
        "move_and_collide",
        "move_bounce_all",
        "move_bounce_solid",
        "move_contact_all",
        "move_contact_solid",
        "move_outside_all",
        "move_outside_solid",
        "move_random",
        "move_snap",
        "move_towards_point",
        "move_wrap",
        "mp_grid_add_cell",
        "mp_grid_add_instances",
        "mp_grid_add_rectangle",
        "mp_grid_clear_all",
        "mp_grid_clear_cell",
        "mp_grid_clear_rectangle",
        "mp_grid_create",
        "mp_grid_destroy",
        "mp_grid_draw",
        "mp_grid_get_cell",
        "mp_grid_path",
        "mp_grid_to_ds_grid",
        "mp_linear_path",
        "mp_linear_path_object",
        "mp_linear_step",
        "mp_linear_step_object",
        "mp_potential_path",
        "mp_potential_path_object",
        "mp_potential_settings",
        "mp_potential_step",
        "mp_potential_step_object",
        "nameof",
        "network_connect",
        "network_connect_async",
        "network_connect_raw",
        "network_connect_raw_async",
        "network_create_server",
        "network_create_server_raw",
        "network_create_socket",
        "network_create_socket_ext",
        "network_destroy",
        "network_resolve",
        "network_send_broadcast",
        "network_send_packet",
        "network_send_raw",
        "network_send_udp",
        "network_send_udp_raw",
        "network_set_config",
        "network_set_timeout",
        "object_exists",
        "object_get_mask",
        "object_get_name",
        "object_get_parent",
        "object_get_persistent",
        "object_get_physics",
        "object_get_solid",
        "object_get_sprite",
        "object_get_visible",
        "object_is_ancestor",
        "object_set_mask",
        "object_set_persistent",
        "object_set_solid",
        "object_set_sprite",
        "object_set_visible",
        "ord",
        "os_check_permission",
        "os_get_config",
        "os_get_info",
        "os_get_language",
        "os_get_region",
        "os_is_network_connected",
        "os_is_paused",
        "os_lock_orientation",
        "os_powersave_enable",
        "os_request_permission",
        "os_set_orientation_lock",
        "parameter_count",
        "parameter_string",
        "part_emitter_burst",
        "part_emitter_clear",
        "part_emitter_create",
        "part_emitter_delay",
        "part_emitter_destroy",
        "part_emitter_destroy_all",
        "part_emitter_enable",
        "part_emitter_exists",
        "part_emitter_interval",
        "part_emitter_region",
        "part_emitter_relative",
        "part_emitter_stream",
        "part_particles_burst",
        "part_particles_clear",
        "part_particles_count",
        "part_particles_create",
        "part_particles_create_color",
        "part_particles_create_colour",
        "part_system_angle",
        "part_system_automatic_draw",
        "part_system_automatic_update",
        "part_system_clear",
        "part_system_color",
        "part_system_colour",
        "part_system_create",
        "part_system_create_layer",
        "part_system_depth",
        "part_system_destroy",
        "part_system_draw_order",
        "part_system_drawit",
        "part_system_exists",
        "part_system_get_info",
        "part_system_get_layer",
        "part_system_global_space",
        "part_system_layer",
        "part_system_position",
        "part_system_update",
        "part_type_alpha1",
        "part_type_alpha2",
        "part_type_alpha3",
        "part_type_blend",
        "part_type_clear",
        "part_type_color1",
        "part_type_color2",
        "part_type_color3",
        "part_type_color_hsv",
        "part_type_color_mix",
        "part_type_color_rgb",
        "part_type_colour1",
        "part_type_colour2",
        "part_type_colour3",
        "part_type_colour_hsv",
        "part_type_colour_mix",
        "part_type_colour_rgb",
        "part_type_create",
        "part_type_death",
        "part_type_destroy",
        "part_type_direction",
        "part_type_exists",
        "part_type_gravity",
        "part_type_life",
        "part_type_orientation",
        "part_type_scale",
        "part_type_shape",
        "part_type_size",
        "part_type_size_x",
        "part_type_size_y",
        "part_type_speed",
        "part_type_sprite",
        "part_type_step",
        "part_type_subimage",
        "particle_exists",
        "particle_get_info",
        "path_add",
        "path_add_point",
        "path_append",
        "path_assign",
        "path_change_point",
        "path_clear_points",
        "path_delete",
        "path_delete_point",
        "path_duplicate",
        "path_end",
        "path_exists",
        "path_flip",
        "path_get_closed",
        "path_get_kind",
        "path_get_length",
        "path_get_name",
        "path_get_number",
        "path_get_point_speed",
        "path_get_point_x",
        "path_get_point_y",
        "path_get_precision",
        "path_get_speed",
        "path_get_x",
        "path_get_y",
        "path_insert_point",
        "path_mirror",
        "path_rescale",
        "path_reverse",
        "path_rotate",
        "path_set_closed",
        "path_set_kind",
        "path_set_precision",
        "path_shift",
        "path_start",
        "physics_apply_angular_impulse",
        "physics_apply_force",
        "physics_apply_impulse",
        "physics_apply_local_force",
        "physics_apply_local_impulse",
        "physics_apply_torque",
        "physics_draw_debug",
        "physics_fixture_add_point",
        "physics_fixture_bind",
        "physics_fixture_bind_ext",
        "physics_fixture_create",
        "physics_fixture_delete",
        "physics_fixture_set_angular_damping",
        "physics_fixture_set_awake",
        "physics_fixture_set_box_shape",
        "physics_fixture_set_chain_shape",
        "physics_fixture_set_circle_shape",
        "physics_fixture_set_collision_group",
        "physics_fixture_set_density",
        "physics_fixture_set_edge_shape",
        "physics_fixture_set_friction",
        "physics_fixture_set_kinematic",
        "physics_fixture_set_linear_damping",
        "physics_fixture_set_polygon_shape",
        "physics_fixture_set_restitution",
        "physics_fixture_set_sensor",
        "physics_get_density",
        "physics_get_friction",
        "physics_get_restitution",
        "physics_joint_delete",
        "physics_joint_distance_create",
        "physics_joint_enable_motor",
        "physics_joint_friction_create",
        "physics_joint_gear_create",
        "physics_joint_get_value",
        "physics_joint_prismatic_create",
        "physics_joint_pulley_create",
        "physics_joint_revolute_create",
        "physics_joint_rope_create",
        "physics_joint_set_value",
        "physics_joint_weld_create",
        "physics_joint_wheel_create",
        "physics_mass_properties",
        "physics_particle_count",
        "physics_particle_create",
        "physics_particle_delete",
        "physics_particle_delete_region_box",
        "physics_particle_delete_region_circle",
        "physics_particle_delete_region_poly",
        "physics_particle_draw",
        "physics_particle_draw_ext",
        "physics_particle_get_damping",
        "physics_particle_get_data",
        "physics_particle_get_data_particle",
        "physics_particle_get_density",
        "physics_particle_get_gravity_scale",
        "physics_particle_get_group_flags",
        "physics_particle_get_max_count",
        "physics_particle_get_radius",
        "physics_particle_group_add_point",
        "physics_particle_group_begin",
        "physics_particle_group_box",
        "physics_particle_group_circle",
        "physics_particle_group_count",
        "physics_particle_group_delete",
        "physics_particle_group_end",
        "physics_particle_group_get_ang_vel",
        "physics_particle_group_get_angle",
        "physics_particle_group_get_centre_x",
        "physics_particle_group_get_centre_y",
        "physics_particle_group_get_data",
        "physics_particle_group_get_inertia",
        "physics_particle_group_get_mass",
        "physics_particle_group_get_vel_x",
        "physics_particle_group_get_vel_y",
        "physics_particle_group_get_x",
        "physics_particle_group_get_y",
        "physics_particle_group_join",
        "physics_particle_group_polygon",
        "physics_particle_set_category_flags",
        "physics_particle_set_damping",
        "physics_particle_set_density",
        "physics_particle_set_flags",
        "physics_particle_set_gravity_scale",
        "physics_particle_set_group_flags",
        "physics_particle_set_max_count",
        "physics_particle_set_radius",
        "physics_pause_enable",
        "physics_remove_fixture",
        "physics_set_density",
        "physics_set_friction",
        "physics_set_restitution",
        "physics_test_overlap",
        "physics_world_create",
        "physics_world_draw_debug",
        "physics_world_gravity",
        "physics_world_update_iterations",
        "physics_world_update_speed",
        "place_empty",
        "place_free",
        "place_meeting",
        "place_snapped",
        "point_direction",
        "point_distance",
        "point_distance_3d",
        "point_in_circle",
        "point_in_rectangle",
        "point_in_triangle",
        "position_change",
        "position_destroy",
        "position_empty",
        "position_meeting",
        "power",
        "ptr",
        "radtodeg",
        "random",
        "random_get_seed",
        "random_range",
        "random_set_seed",
        "randomise",
        "randomize",
        "real",
        "rectangle_in_circle",
        "rectangle_in_rectangle",
        "rectangle_in_triangle",
        "ref_create",
        "rollback_chat",
        "rollback_create_game",
        "rollback_define_extra_network_latency",
        "rollback_define_input",
        "rollback_define_input_frame_delay",
        "rollback_define_mock_input",
        "rollback_define_player",
        "rollback_display_events",
        "rollback_get_info",
        "rollback_get_input",
        "rollback_get_player_prefs",
        "rollback_join_game",
        "rollback_leave_game",
        "rollback_set_player_prefs",
        "rollback_start_game",
        "rollback_sync_on_frame",
        "rollback_use_late_join",
        "rollback_use_manual_start",
        "rollback_use_player_prefs",
        "rollback_use_random_input",
        "room_add",
        "room_assign",
        "room_duplicate",
        "room_exists",
        "room_get_camera",
        "room_get_info",
        "room_get_name",
        "room_get_viewport",
        "room_goto",
        "room_goto_next",
        "room_goto_previous",
        "room_instance_add",
        "room_instance_clear",
        "room_next",
        "room_previous",
        "room_restart",
        "room_set_camera",
        "room_set_height",
        "room_set_persistent",
        "room_set_view_enabled",
        "room_set_viewport",
        "room_set_width",
        "round",
        "scheduler_resolution_get",
        "scheduler_resolution_set",
        "screen_save",
        "screen_save_part",
        "script_execute",
        "script_execute_ext",
        "script_exists",
        "script_get_name",
        "sequence_create",
        "sequence_destroy",
        "sequence_exists",
        "sequence_get",
        "sequence_get_objects",
        "sequence_instance_override_object",
        "sequence_keyframe_new",
        "sequence_keyframedata_new",
        "sequence_track_new",
        "sha1_file",
        "sha1_string_unicode",
        "sha1_string_utf8",
        "shader_current",
        "shader_enable_corner_id",
        "shader_get_name",
        "shader_get_sampler_index",
        "shader_get_uniform",
        "shader_is_compiled",
        "shader_reset",
        "shader_set",
        "shader_set_uniform_f",
        "shader_set_uniform_f_array",
        "shader_set_uniform_f_buffer",
        "shader_set_uniform_i",
        "shader_set_uniform_i_array",
        "shader_set_uniform_matrix",
        "shader_set_uniform_matrix_array",
        "shaders_are_supported",
        "shop_leave_rating",
        "show_debug_message",
        "show_debug_message_ext",
        "show_debug_overlay",
        "show_error",
        "show_message",
        "show_message_async",
        "show_question",
        "show_question_async",
        "sign",
        "sin",
        "skeleton_animation_clear",
        "skeleton_animation_get",
        "skeleton_animation_get_duration",
        "skeleton_animation_get_event_frames",
        "skeleton_animation_get_ext",
        "skeleton_animation_get_frame",
        "skeleton_animation_get_frames",
        "skeleton_animation_get_position",
        "skeleton_animation_is_finished",
        "skeleton_animation_is_looping",
        "skeleton_animation_list",
        "skeleton_animation_mix",
        "skeleton_animation_set",
        "skeleton_animation_set_ext",
        "skeleton_animation_set_frame",
        "skeleton_animation_set_position",
        "skeleton_attachment_create",
        "skeleton_attachment_create_color",
        "skeleton_attachment_create_colour",
        "skeleton_attachment_destroy",
        "skeleton_attachment_exists",
        "skeleton_attachment_get",
        "skeleton_attachment_replace",
        "skeleton_attachment_replace_color",
        "skeleton_attachment_replace_colour",
        "skeleton_attachment_set",
        "skeleton_bone_data_get",
        "skeleton_bone_data_set",
        "skeleton_bone_list",
        "skeleton_bone_state_get",
        "skeleton_bone_state_set",
        "skeleton_collision_draw_set",
        "skeleton_find_slot",
        "skeleton_get_bounds",
        "skeleton_get_minmax",
        "skeleton_get_num_bounds",
        "skeleton_skin_create",
        "skeleton_skin_get",
        "skeleton_skin_list",
        "skeleton_skin_set",
        "skeleton_slot_alpha_get",
        "skeleton_slot_color_get",
        "skeleton_slot_color_set",
        "skeleton_slot_colour_get",
        "skeleton_slot_colour_set",
        "skeleton_slot_data",
        "skeleton_slot_data_instance",
        "skeleton_slot_list",
        "sprite_add",
        "sprite_add_ext",
        "sprite_add_from_surface",
        "sprite_assign",
        "sprite_collision_mask",
        "sprite_create_from_surface",
        "sprite_delete",
        "sprite_duplicate",
        "sprite_exists",
        "sprite_flush",
        "sprite_flush_multi",
        "sprite_get_bbox_bottom",
        "sprite_get_bbox_left",
        "sprite_get_bbox_mode",
        "sprite_get_bbox_right",
        "sprite_get_bbox_top",
        "sprite_get_height",
        "sprite_get_info",
        "sprite_get_name",
        "sprite_get_nineslice",
        "sprite_get_number",
        "sprite_get_speed",
        "sprite_get_speed_type",
        "sprite_get_texture",
        "sprite_get_tpe",
        "sprite_get_uvs",
        "sprite_get_width",
        "sprite_get_xoffset",
        "sprite_get_yoffset",
        "sprite_merge",
        "sprite_nineslice_create",
        "sprite_prefetch",
        "sprite_prefetch_multi",
        "sprite_replace",
        "sprite_save",
        "sprite_save_strip",
        "sprite_set_alpha_from_sprite",
        "sprite_set_bbox",
        "sprite_set_bbox_mode",
        "sprite_set_cache_size",
        "sprite_set_cache_size_ext",
        "sprite_set_nineslice",
        "sprite_set_offset",
        "sprite_set_speed",
        "sqr",
        "sqrt",
        "static_get",
        "static_set",
        "string",
        "string_byte_at",
        "string_byte_length",
        "string_char_at",
        "string_concat",
        "string_concat_ext",
        "string_copy",
        "string_count",
        "string_delete",
        "string_digits",
        "string_ends_with",
        "string_ext",
        "string_foreach",
        "string_format",
        "string_hash_to_newline",
        "string_height",
        "string_height_ext",
        "string_insert",
        "string_join",
        "string_join_ext",
        "string_last_pos",
        "string_last_pos_ext",
        "string_length",
        "string_letters",
        "string_lettersdigits",
        "string_lower",
        "string_ord_at",
        "string_pos",
        "string_pos_ext",
        "string_repeat",
        "string_replace",
        "string_replace_all",
        "string_set_byte_at",
        "string_split",
        "string_split_ext",
        "string_starts_with",
        "string_trim",
        "string_trim_end",
        "string_trim_start",
        "string_upper",
        "string_width",
        "string_width_ext",
        "struct_exists",
        "struct_foreach",
        "struct_get",
        "struct_get_from_hash",
        "struct_get_names",
        "struct_names_count",
        "struct_remove",
        "struct_set",
        "struct_set_from_hash",
        "surface_copy",
        "surface_copy_part",
        "surface_create",
        "surface_create_ext",
        "surface_depth_disable",
        "surface_exists",
        "surface_format_is_supported",
        "surface_free",
        "surface_get_depth_disable",
        "surface_get_format",
        "surface_get_height",
        "surface_get_target",
        "surface_get_target_ext",
        "surface_get_texture",
        "surface_get_width",
        "surface_getpixel",
        "surface_getpixel_ext",
        "surface_reset_target",
        "surface_resize",
        "surface_save",
        "surface_save_part",
        "surface_set_target",
        "surface_set_target_ext",
        "tag_get_asset_ids",
        "tag_get_assets",
        "tan",
        "texture_debug_messages",
        "texture_flush",
        "texture_get_height",
        "texture_get_texel_height",
        "texture_get_texel_width",
        "texture_get_uvs",
        "texture_get_width",
        "texture_global_scale",
        "texture_is_ready",
        "texture_prefetch",
        "texture_set_stage",
        "texturegroup_get_fonts",
        "texturegroup_get_names",
        "texturegroup_get_sprites",
        "texturegroup_get_status",
        "texturegroup_get_textures",
        "texturegroup_get_tilesets",
        "texturegroup_load",
        "texturegroup_set_mode",
        "texturegroup_unload",
        "tile_get_empty",
        "tile_get_flip",
        "tile_get_index",
        "tile_get_mirror",
        "tile_get_rotate",
        "tile_set_empty",
        "tile_set_flip",
        "tile_set_index",
        "tile_set_mirror",
        "tile_set_rotate",
        "tilemap_clear",
        "tilemap_get",
        "tilemap_get_at_pixel",
        "tilemap_get_cell_x_at_pixel",
        "tilemap_get_cell_y_at_pixel",
        "tilemap_get_frame",
        "tilemap_get_global_mask",
        "tilemap_get_height",
        "tilemap_get_mask",
        "tilemap_get_tile_height",
        "tilemap_get_tile_width",
        "tilemap_get_tileset",
        "tilemap_get_width",
        "tilemap_get_x",
        "tilemap_get_y",
        "tilemap_set",
        "tilemap_set_at_pixel",
        "tilemap_set_global_mask",
        "tilemap_set_height",
        "tilemap_set_mask",
        "tilemap_set_width",
        "tilemap_tileset",
        "tilemap_x",
        "tilemap_y",
        "tileset_get_info",
        "tileset_get_name",
        "tileset_get_texture",
        "tileset_get_uvs",
        "time_bpm_to_seconds",
        "time_seconds_to_bpm",
        "time_source_create",
        "time_source_destroy",
        "time_source_exists",
        "time_source_get_children",
        "time_source_get_parent",
        "time_source_get_period",
        "time_source_get_reps_completed",
        "time_source_get_reps_remaining",
        "time_source_get_state",
        "time_source_get_time_remaining",
        "time_source_get_units",
        "time_source_pause",
        "time_source_reconfigure",
        "time_source_reset",
        "time_source_resume",
        "time_source_start",
        "time_source_stop",
        "timeline_add",
        "timeline_clear",
        "timeline_delete",
        "timeline_exists",
        "timeline_get_name",
        "timeline_max_moment",
        "timeline_moment_add_script",
        "timeline_moment_clear",
        "timeline_size",
        "typeof",
        "url_get_domain",
        "url_open",
        "url_open_ext",
        "url_open_full",
        "uwp_device_touchscreen_available",
        "uwp_livetile_badge_clear",
        "uwp_livetile_badge_notification",
        "uwp_livetile_notification_begin",
        "uwp_livetile_notification_end",
        "uwp_livetile_notification_expiry",
        "uwp_livetile_notification_image_add",
        "uwp_livetile_notification_secondary_begin",
        "uwp_livetile_notification_tag",
        "uwp_livetile_notification_template_add",
        "uwp_livetile_notification_text_add",
        "uwp_livetile_queue_enable",
        "uwp_livetile_tile_clear",
        "uwp_secondarytile_badge_clear",
        "uwp_secondarytile_badge_notification",
        "uwp_secondarytile_delete",
        "uwp_secondarytile_pin",
        "uwp_secondarytile_tile_clear",
        "variable_clone",
        "variable_get_hash",
        "variable_global_exists",
        "variable_global_get",
        "variable_global_set",
        "variable_instance_exists",
        "variable_instance_get",
        "variable_instance_get_names",
        "variable_instance_names_count",
        "variable_instance_set",
        "variable_struct_exists",
        "variable_struct_get",
        "variable_struct_get_names",
        "variable_struct_names_count",
        "variable_struct_remove",
        "variable_struct_set",
        "vertex_argb",
        "vertex_begin",
        "vertex_color",
        "vertex_colour",
        "vertex_create_buffer",
        "vertex_create_buffer_ext",
        "vertex_create_buffer_from_buffer",
        "vertex_create_buffer_from_buffer_ext",
        "vertex_delete_buffer",
        "vertex_end",
        "vertex_float1",
        "vertex_float2",
        "vertex_float3",
        "vertex_float4",
        "vertex_format_add_color",
        "vertex_format_add_colour",
        "vertex_format_add_custom",
        "vertex_format_add_normal",
        "vertex_format_add_position",
        "vertex_format_add_position_3d",
        "vertex_format_add_texcoord",
        "vertex_format_begin",
        "vertex_format_delete",
        "vertex_format_end",
        "vertex_format_get_info",
        "vertex_freeze",
        "vertex_get_buffer_size",
        "vertex_get_number",
        "vertex_normal",
        "vertex_position",
        "vertex_position_3d",
        "vertex_submit",
        "vertex_submit_ext",
        "vertex_texcoord",
        "vertex_ubyte4",
        "vertex_update_buffer_from_buffer",
        "vertex_update_buffer_from_vertex",
        "video_close",
        "video_draw",
        "video_enable_loop",
        "video_get_duration",
        "video_get_format",
        "video_get_position",
        "video_get_status",
        "video_get_volume",
        "video_is_looping",
        "video_open",
        "video_pause",
        "video_resume",
        "video_seek_to",
        "video_set_volume",
        "view_get_camera",
        "view_get_hport",
        "view_get_surface_id",
        "view_get_visible",
        "view_get_wport",
        "view_get_xport",
        "view_get_yport",
        "view_set_camera",
        "view_set_hport",
        "view_set_surface_id",
        "view_set_visible",
        "view_set_wport",
        "view_set_xport",
        "view_set_yport",
        "virtual_key_add",
        "virtual_key_delete",
        "virtual_key_hide",
        "virtual_key_show",
        "wallpaper_set_config",
        "wallpaper_set_subscriptions",
        "weak_ref_alive",
        "weak_ref_any_alive",
        "weak_ref_create",
        "window_center",
        "window_device",
        "window_enable_borderless_fullscreen",
        "window_get_borderless_fullscreen",
        "window_get_caption",
        "window_get_color",
        "window_get_colour",
        "window_get_cursor",
        "window_get_fullscreen",
        "window_get_height",
        "window_get_showborder",
        "window_get_visible_rects",
        "window_get_width",
        "window_get_x",
        "window_get_y",
        "window_handle",
        "window_has_focus",
        "window_mouse_get_delta_x",
        "window_mouse_get_delta_y",
        "window_mouse_get_locked",
        "window_mouse_get_x",
        "window_mouse_get_y",
        "window_mouse_set",
        "window_mouse_set_locked",
        "window_set_caption",
        "window_set_color",
        "window_set_colour",
        "window_set_cursor",
        "window_set_fullscreen",
        "window_set_max_height",
        "window_set_max_width",
        "window_set_min_height",
        "window_set_min_width",
        "window_set_position",
        "window_set_rectangle",
        "window_set_showborder",
        "window_set_size",
        "window_view_mouse_get_x",
        "window_view_mouse_get_y",
        "window_views_mouse_get_x",
        "window_views_mouse_get_y",
        "winphone_tile_background_color",
        "winphone_tile_background_colour",
        "zip_add_file",
        "zip_create",
        "zip_save",
        "zip_unzip",
        "zip_unzip_async"
      ],
      symbol: [
        "AudioEffect",
        "AudioEffectType",
        "AudioLFOType",
        "GM_build_date",
        "GM_build_type",
        "GM_is_sandboxed",
        "GM_project_filename",
        "GM_runtime_version",
        "GM_version",
        "NaN",
        "_GMFILE_",
        "_GMFUNCTION_",
        "_GMLINE_",
        "alignmentH",
        "alignmentV",
        "all",
        "animcurvetype_bezier",
        "animcurvetype_catmullrom",
        "animcurvetype_linear",
        "asset_animationcurve",
        "asset_font",
        "asset_object",
        "asset_path",
        "asset_room",
        "asset_script",
        "asset_sequence",
        "asset_shader",
        "asset_sound",
        "asset_sprite",
        "asset_tiles",
        "asset_timeline",
        "asset_unknown",
        "audio_3D",
        "audio_bus_main",
        "audio_falloff_exponent_distance",
        "audio_falloff_exponent_distance_clamped",
        "audio_falloff_exponent_distance_scaled",
        "audio_falloff_inverse_distance",
        "audio_falloff_inverse_distance_clamped",
        "audio_falloff_inverse_distance_scaled",
        "audio_falloff_linear_distance",
        "audio_falloff_linear_distance_clamped",
        "audio_falloff_none",
        "audio_mono",
        "audio_stereo",
        "bboxkind_diamond",
        "bboxkind_ellipse",
        "bboxkind_precise",
        "bboxkind_rectangular",
        "bboxmode_automatic",
        "bboxmode_fullimage",
        "bboxmode_manual",
        "bm_add",
        "bm_dest_alpha",
        "bm_dest_color",
        "bm_dest_colour",
        "bm_inv_dest_alpha",
        "bm_inv_dest_color",
        "bm_inv_dest_colour",
        "bm_inv_src_alpha",
        "bm_inv_src_color",
        "bm_inv_src_colour",
        "bm_max",
        "bm_normal",
        "bm_one",
        "bm_src_alpha",
        "bm_src_alpha_sat",
        "bm_src_color",
        "bm_src_colour",
        "bm_subtract",
        "bm_zero",
        "browser_chrome",
        "browser_edge",
        "browser_firefox",
        "browser_ie",
        "browser_ie_mobile",
        "browser_not_a_browser",
        "browser_opera",
        "browser_safari",
        "browser_safari_mobile",
        "browser_tizen",
        "browser_unknown",
        "browser_windows_store",
        "buffer_bool",
        "buffer_f16",
        "buffer_f32",
        "buffer_f64",
        "buffer_fast",
        "buffer_fixed",
        "buffer_grow",
        "buffer_s16",
        "buffer_s32",
        "buffer_s8",
        "buffer_seek_end",
        "buffer_seek_relative",
        "buffer_seek_start",
        "buffer_string",
        "buffer_text",
        "buffer_u16",
        "buffer_u32",
        "buffer_u64",
        "buffer_u8",
        "buffer_vbuffer",
        "buffer_wrap",
        "c_aqua",
        "c_black",
        "c_blue",
        "c_dkgray",
        "c_dkgrey",
        "c_fuchsia",
        "c_gray",
        "c_green",
        "c_grey",
        "c_lime",
        "c_ltgray",
        "c_ltgrey",
        "c_maroon",
        "c_navy",
        "c_olive",
        "c_orange",
        "c_purple",
        "c_red",
        "c_silver",
        "c_teal",
        "c_white",
        "c_yellow",
        "cache_directory",
        "characterSpacing",
        "cmpfunc_always",
        "cmpfunc_equal",
        "cmpfunc_greater",
        "cmpfunc_greaterequal",
        "cmpfunc_less",
        "cmpfunc_lessequal",
        "cmpfunc_never",
        "cmpfunc_notequal",
        "coreColor",
        "coreColour",
        "cr_appstart",
        "cr_arrow",
        "cr_beam",
        "cr_cross",
        "cr_default",
        "cr_drag",
        "cr_handpoint",
        "cr_hourglass",
        "cr_none",
        "cr_size_all",
        "cr_size_nesw",
        "cr_size_ns",
        "cr_size_nwse",
        "cr_size_we",
        "cr_uparrow",
        "cull_clockwise",
        "cull_counterclockwise",
        "cull_noculling",
        "device_emulator",
        "device_ios_ipad",
        "device_ios_ipad_retina",
        "device_ios_iphone",
        "device_ios_iphone5",
        "device_ios_iphone6",
        "device_ios_iphone6plus",
        "device_ios_iphone_retina",
        "device_ios_unknown",
        "device_tablet",
        "display_landscape",
        "display_landscape_flipped",
        "display_portrait",
        "display_portrait_flipped",
        "dll_cdecl",
        "dll_stdcall",
        "dropShadowEnabled",
        "dropShadowEnabled",
        "ds_type_grid",
        "ds_type_list",
        "ds_type_map",
        "ds_type_priority",
        "ds_type_queue",
        "ds_type_stack",
        "ef_cloud",
        "ef_ellipse",
        "ef_explosion",
        "ef_firework",
        "ef_flare",
        "ef_rain",
        "ef_ring",
        "ef_smoke",
        "ef_smokeup",
        "ef_snow",
        "ef_spark",
        "ef_star",
        "effectsEnabled",
        "effectsEnabled",
        "ev_alarm",
        "ev_animation_end",
        "ev_animation_event",
        "ev_animation_update",
        "ev_async_audio_playback",
        "ev_async_audio_playback_ended",
        "ev_async_audio_recording",
        "ev_async_dialog",
        "ev_async_push_notification",
        "ev_async_save_load",
        "ev_async_save_load",
        "ev_async_social",
        "ev_async_system_event",
        "ev_async_web",
        "ev_async_web_cloud",
        "ev_async_web_iap",
        "ev_async_web_image_load",
        "ev_async_web_networking",
        "ev_async_web_steam",
        "ev_audio_playback",
        "ev_audio_playback_ended",
        "ev_audio_recording",
        "ev_boundary",
        "ev_boundary_view0",
        "ev_boundary_view1",
        "ev_boundary_view2",
        "ev_boundary_view3",
        "ev_boundary_view4",
        "ev_boundary_view5",
        "ev_boundary_view6",
        "ev_boundary_view7",
        "ev_broadcast_message",
        "ev_cleanup",
        "ev_collision",
        "ev_create",
        "ev_destroy",
        "ev_dialog_async",
        "ev_draw",
        "ev_draw_begin",
        "ev_draw_end",
        "ev_draw_normal",
        "ev_draw_post",
        "ev_draw_pre",
        "ev_end_of_path",
        "ev_game_end",
        "ev_game_start",
        "ev_gesture",
        "ev_gesture_double_tap",
        "ev_gesture_drag_end",
        "ev_gesture_drag_start",
        "ev_gesture_dragging",
        "ev_gesture_flick",
        "ev_gesture_pinch_end",
        "ev_gesture_pinch_in",
        "ev_gesture_pinch_out",
        "ev_gesture_pinch_start",
        "ev_gesture_rotate_end",
        "ev_gesture_rotate_start",
        "ev_gesture_rotating",
        "ev_gesture_tap",
        "ev_global_gesture_double_tap",
        "ev_global_gesture_drag_end",
        "ev_global_gesture_drag_start",
        "ev_global_gesture_dragging",
        "ev_global_gesture_flick",
        "ev_global_gesture_pinch_end",
        "ev_global_gesture_pinch_in",
        "ev_global_gesture_pinch_out",
        "ev_global_gesture_pinch_start",
        "ev_global_gesture_rotate_end",
        "ev_global_gesture_rotate_start",
        "ev_global_gesture_rotating",
        "ev_global_gesture_tap",
        "ev_global_left_button",
        "ev_global_left_press",
        "ev_global_left_release",
        "ev_global_middle_button",
        "ev_global_middle_press",
        "ev_global_middle_release",
        "ev_global_right_button",
        "ev_global_right_press",
        "ev_global_right_release",
        "ev_gui",
        "ev_gui_begin",
        "ev_gui_end",
        "ev_joystick1_button1",
        "ev_joystick1_button2",
        "ev_joystick1_button3",
        "ev_joystick1_button4",
        "ev_joystick1_button5",
        "ev_joystick1_button6",
        "ev_joystick1_button7",
        "ev_joystick1_button8",
        "ev_joystick1_down",
        "ev_joystick1_left",
        "ev_joystick1_right",
        "ev_joystick1_up",
        "ev_joystick2_button1",
        "ev_joystick2_button2",
        "ev_joystick2_button3",
        "ev_joystick2_button4",
        "ev_joystick2_button5",
        "ev_joystick2_button6",
        "ev_joystick2_button7",
        "ev_joystick2_button8",
        "ev_joystick2_down",
        "ev_joystick2_left",
        "ev_joystick2_right",
        "ev_joystick2_up",
        "ev_keyboard",
        "ev_keypress",
        "ev_keyrelease",
        "ev_left_button",
        "ev_left_press",
        "ev_left_release",
        "ev_middle_button",
        "ev_middle_press",
        "ev_middle_release",
        "ev_mouse",
        "ev_mouse_enter",
        "ev_mouse_leave",
        "ev_mouse_wheel_down",
        "ev_mouse_wheel_up",
        "ev_no_button",
        "ev_no_more_health",
        "ev_no_more_lives",
        "ev_other",
        "ev_outside",
        "ev_outside_view0",
        "ev_outside_view1",
        "ev_outside_view2",
        "ev_outside_view3",
        "ev_outside_view4",
        "ev_outside_view5",
        "ev_outside_view6",
        "ev_outside_view7",
        "ev_pre_create",
        "ev_push_notification",
        "ev_right_button",
        "ev_right_press",
        "ev_right_release",
        "ev_room_end",
        "ev_room_start",
        "ev_social",
        "ev_step",
        "ev_step_begin",
        "ev_step_end",
        "ev_step_normal",
        "ev_system_event",
        "ev_trigger",
        "ev_user0",
        "ev_user1",
        "ev_user10",
        "ev_user11",
        "ev_user12",
        "ev_user13",
        "ev_user14",
        "ev_user15",
        "ev_user2",
        "ev_user3",
        "ev_user4",
        "ev_user5",
        "ev_user6",
        "ev_user7",
        "ev_user8",
        "ev_user9",
        "ev_web_async",
        "ev_web_cloud",
        "ev_web_iap",
        "ev_web_image_load",
        "ev_web_networking",
        "ev_web_sound_load",
        "ev_web_steam",
        "fa_archive",
        "fa_bottom",
        "fa_center",
        "fa_directory",
        "fa_hidden",
        "fa_left",
        "fa_middle",
        "fa_none",
        "fa_readonly",
        "fa_right",
        "fa_sysfile",
        "fa_top",
        "fa_volumeid",
        "false",
        "frameSizeX",
        "frameSizeY",
        "gamespeed_fps",
        "gamespeed_microseconds",
        "global",
        "glowColor",
        "glowColour",
        "glowEnabled",
        "glowEnabled",
        "glowEnd",
        "glowStart",
        "gp_axis_acceleration_x",
        "gp_axis_acceleration_y",
        "gp_axis_acceleration_z",
        "gp_axis_angular_velocity_x",
        "gp_axis_angular_velocity_y",
        "gp_axis_angular_velocity_z",
        "gp_axis_orientation_w",
        "gp_axis_orientation_x",
        "gp_axis_orientation_y",
        "gp_axis_orientation_z",
        "gp_axislh",
        "gp_axislv",
        "gp_axisrh",
        "gp_axisrv",
        "gp_face1",
        "gp_face2",
        "gp_face3",
        "gp_face4",
        "gp_padd",
        "gp_padl",
        "gp_padr",
        "gp_padu",
        "gp_select",
        "gp_shoulderl",
        "gp_shoulderlb",
        "gp_shoulderr",
        "gp_shoulderrb",
        "gp_start",
        "gp_stickl",
        "gp_stickr",
        "iap_available",
        "iap_canceled",
        "iap_ev_consume",
        "iap_ev_product",
        "iap_ev_purchase",
        "iap_ev_restore",
        "iap_ev_storeload",
        "iap_failed",
        "iap_purchased",
        "iap_refunded",
        "iap_status_available",
        "iap_status_loading",
        "iap_status_processing",
        "iap_status_restoring",
        "iap_status_unavailable",
        "iap_status_uninitialised",
        "iap_storeload_failed",
        "iap_storeload_ok",
        "iap_unavailable",
        "infinity",
        "kbv_autocapitalize_characters",
        "kbv_autocapitalize_none",
        "kbv_autocapitalize_sentences",
        "kbv_autocapitalize_words",
        "kbv_returnkey_continue",
        "kbv_returnkey_default",
        "kbv_returnkey_done",
        "kbv_returnkey_emergency",
        "kbv_returnkey_go",
        "kbv_returnkey_google",
        "kbv_returnkey_join",
        "kbv_returnkey_next",
        "kbv_returnkey_route",
        "kbv_returnkey_search",
        "kbv_returnkey_send",
        "kbv_returnkey_yahoo",
        "kbv_type_ascii",
        "kbv_type_default",
        "kbv_type_email",
        "kbv_type_numbers",
        "kbv_type_phone",
        "kbv_type_phone_name",
        "kbv_type_url",
        "layerelementtype_background",
        "layerelementtype_instance",
        "layerelementtype_oldtilemap",
        "layerelementtype_particlesystem",
        "layerelementtype_sequence",
        "layerelementtype_sprite",
        "layerelementtype_tile",
        "layerelementtype_tilemap",
        "layerelementtype_undefined",
        "leaderboard_type_number",
        "leaderboard_type_time_mins_secs",
        "lighttype_dir",
        "lighttype_point",
        "lineSpacing",
        "m_axisx",
        "m_axisx_gui",
        "m_axisy",
        "m_axisy_gui",
        "m_scroll_down",
        "m_scroll_up",
        "matrix_projection",
        "matrix_view",
        "matrix_world",
        "mb_any",
        "mb_left",
        "mb_middle",
        "mb_none",
        "mb_right",
        "mb_side1",
        "mb_side2",
        "mip_markedonly",
        "mip_off",
        "mip_on",
        "network_config_avoid_time_wait",
        "network_config_connect_timeout",
        "network_config_disable_multicast",
        "network_config_disable_reliable_udp",
        "network_config_enable_multicast",
        "network_config_enable_reliable_udp",
        "network_config_use_non_blocking_socket",
        "network_config_websocket_protocol",
        "network_connect_active",
        "network_connect_blocking",
        "network_connect_nonblocking",
        "network_connect_none",
        "network_connect_passive",
        "network_send_binary",
        "network_send_text",
        "network_socket_bluetooth",
        "network_socket_tcp",
        "network_socket_udp",
        "network_socket_ws",
        "network_socket_wss",
        "network_type_connect",
        "network_type_data",
        "network_type_disconnect",
        "network_type_down",
        "network_type_non_blocking_connect",
        "network_type_up",
        "network_type_up_failed",
        "nineslice_blank",
        "nineslice_bottom",
        "nineslice_center",
        "nineslice_centre",
        "nineslice_hide",
        "nineslice_left",
        "nineslice_mirror",
        "nineslice_repeat",
        "nineslice_right",
        "nineslice_stretch",
        "nineslice_top",
        "noone",
        "of_challenge_lose",
        "of_challenge_tie",
        "of_challenge_win",
        "os_android",
        "os_gdk",
        "os_gxgames",
        "os_ios",
        "os_linux",
        "os_macosx",
        "os_operagx",
        "os_permission_denied",
        "os_permission_denied_dont_request",
        "os_permission_granted",
        "os_ps3",
        "os_ps4",
        "os_ps5",
        "os_psvita",
        "os_switch",
        "os_tvos",
        "os_unknown",
        "os_uwp",
        "os_win8native",
        "os_windows",
        "os_winphone",
        "os_xboxone",
        "os_xboxseriesxs",
        "other",
        "outlineColor",
        "outlineColour",
        "outlineDist",
        "outlineEnabled",
        "outlineEnabled",
        "paragraphSpacing",
        "path_action_continue",
        "path_action_restart",
        "path_action_reverse",
        "path_action_stop",
        "phy_debug_render_aabb",
        "phy_debug_render_collision_pairs",
        "phy_debug_render_coms",
        "phy_debug_render_core_shapes",
        "phy_debug_render_joints",
        "phy_debug_render_obb",
        "phy_debug_render_shapes",
        "phy_joint_anchor_1_x",
        "phy_joint_anchor_1_y",
        "phy_joint_anchor_2_x",
        "phy_joint_anchor_2_y",
        "phy_joint_angle",
        "phy_joint_angle_limits",
        "phy_joint_damping_ratio",
        "phy_joint_frequency",
        "phy_joint_length_1",
        "phy_joint_length_2",
        "phy_joint_lower_angle_limit",
        "phy_joint_max_force",
        "phy_joint_max_length",
        "phy_joint_max_motor_force",
        "phy_joint_max_motor_torque",
        "phy_joint_max_torque",
        "phy_joint_motor_force",
        "phy_joint_motor_speed",
        "phy_joint_motor_torque",
        "phy_joint_reaction_force_x",
        "phy_joint_reaction_force_y",
        "phy_joint_reaction_torque",
        "phy_joint_speed",
        "phy_joint_translation",
        "phy_joint_upper_angle_limit",
        "phy_particle_data_flag_category",
        "phy_particle_data_flag_color",
        "phy_particle_data_flag_colour",
        "phy_particle_data_flag_position",
        "phy_particle_data_flag_typeflags",
        "phy_particle_data_flag_velocity",
        "phy_particle_flag_colormixing",
        "phy_particle_flag_colourmixing",
        "phy_particle_flag_elastic",
        "phy_particle_flag_powder",
        "phy_particle_flag_spring",
        "phy_particle_flag_tensile",
        "phy_particle_flag_viscous",
        "phy_particle_flag_wall",
        "phy_particle_flag_water",
        "phy_particle_flag_zombie",
        "phy_particle_group_flag_rigid",
        "phy_particle_group_flag_solid",
        "pi",
        "pointer_invalid",
        "pointer_null",
        "pr_linelist",
        "pr_linestrip",
        "pr_pointlist",
        "pr_trianglefan",
        "pr_trianglelist",
        "pr_trianglestrip",
        "ps_distr_gaussian",
        "ps_distr_invgaussian",
        "ps_distr_linear",
        "ps_mode_burst",
        "ps_mode_stream",
        "ps_shape_diamond",
        "ps_shape_ellipse",
        "ps_shape_line",
        "ps_shape_rectangle",
        "pt_shape_circle",
        "pt_shape_cloud",
        "pt_shape_disk",
        "pt_shape_explosion",
        "pt_shape_flare",
        "pt_shape_line",
        "pt_shape_pixel",
        "pt_shape_ring",
        "pt_shape_smoke",
        "pt_shape_snow",
        "pt_shape_spark",
        "pt_shape_sphere",
        "pt_shape_square",
        "pt_shape_star",
        "rollback_chat_message",
        "rollback_connect_error",
        "rollback_connect_info",
        "rollback_connected_to_peer",
        "rollback_connection_rejected",
        "rollback_disconnected_from_peer",
        "rollback_end_game",
        "rollback_game_full",
        "rollback_game_info",
        "rollback_game_interrupted",
        "rollback_game_resumed",
        "rollback_high_latency",
        "rollback_player_prefs",
        "rollback_protocol_rejected",
        "rollback_synchronized_with_peer",
        "rollback_synchronizing_with_peer",
        "self",
        "seqaudiokey_loop",
        "seqaudiokey_oneshot",
        "seqdir_left",
        "seqdir_right",
        "seqinterpolation_assign",
        "seqinterpolation_lerp",
        "seqplay_loop",
        "seqplay_oneshot",
        "seqplay_pingpong",
        "seqtextkey_bottom",
        "seqtextkey_center",
        "seqtextkey_justify",
        "seqtextkey_left",
        "seqtextkey_middle",
        "seqtextkey_right",
        "seqtextkey_top",
        "seqtracktype_audio",
        "seqtracktype_bool",
        "seqtracktype_clipmask",
        "seqtracktype_clipmask_mask",
        "seqtracktype_clipmask_subject",
        "seqtracktype_color",
        "seqtracktype_colour",
        "seqtracktype_empty",
        "seqtracktype_graphic",
        "seqtracktype_group",
        "seqtracktype_instance",
        "seqtracktype_message",
        "seqtracktype_moment",
        "seqtracktype_particlesystem",
        "seqtracktype_real",
        "seqtracktype_sequence",
        "seqtracktype_spriteframes",
        "seqtracktype_string",
        "seqtracktype_text",
        "shadowColor",
        "shadowColour",
        "shadowOffsetX",
        "shadowOffsetY",
        "shadowSoftness",
        "sprite_add_ext_error_cancelled",
        "sprite_add_ext_error_decompressfailed",
        "sprite_add_ext_error_loadfailed",
        "sprite_add_ext_error_setupfailed",
        "sprite_add_ext_error_spritenotfound",
        "sprite_add_ext_error_unknown",
        "spritespeed_framespergameframe",
        "spritespeed_framespersecond",
        "surface_r16float",
        "surface_r32float",
        "surface_r8unorm",
        "surface_rg8unorm",
        "surface_rgba16float",
        "surface_rgba32float",
        "surface_rgba4unorm",
        "surface_rgba8unorm",
        "texturegroup_status_fetched",
        "texturegroup_status_loaded",
        "texturegroup_status_loading",
        "texturegroup_status_unloaded",
        "tf_anisotropic",
        "tf_linear",
        "tf_point",
        "thickness",
        "tile_flip",
        "tile_index_mask",
        "tile_mirror",
        "tile_rotate",
        "time_source_expire_after",
        "time_source_expire_nearest",
        "time_source_game",
        "time_source_global",
        "time_source_state_active",
        "time_source_state_initial",
        "time_source_state_paused",
        "time_source_state_stopped",
        "time_source_units_frames",
        "time_source_units_seconds",
        "timezone_local",
        "timezone_utc",
        "tm_countvsyncs",
        "tm_sleep",
        "tm_systemtiming",
        "true",
        "ty_real",
        "ty_string",
        "undefined",
        "vertex_type_color",
        "vertex_type_colour",
        "vertex_type_float1",
        "vertex_type_float2",
        "vertex_type_float3",
        "vertex_type_float4",
        "vertex_type_ubyte4",
        "vertex_usage_binormal",
        "vertex_usage_blendindices",
        "vertex_usage_blendweight",
        "vertex_usage_color",
        "vertex_usage_colour",
        "vertex_usage_depth",
        "vertex_usage_fog",
        "vertex_usage_normal",
        "vertex_usage_position",
        "vertex_usage_psize",
        "vertex_usage_sample",
        "vertex_usage_tangent",
        "vertex_usage_texcoord",
        "video_format_rgba",
        "video_format_yuv",
        "video_status_closed",
        "video_status_paused",
        "video_status_playing",
        "video_status_preparing",
        "vk_add",
        "vk_alt",
        "vk_anykey",
        "vk_backspace",
        "vk_control",
        "vk_decimal",
        "vk_delete",
        "vk_divide",
        "vk_down",
        "vk_end",
        "vk_enter",
        "vk_escape",
        "vk_f1",
        "vk_f10",
        "vk_f11",
        "vk_f12",
        "vk_f2",
        "vk_f3",
        "vk_f4",
        "vk_f5",
        "vk_f6",
        "vk_f7",
        "vk_f8",
        "vk_f9",
        "vk_home",
        "vk_insert",
        "vk_lalt",
        "vk_lcontrol",
        "vk_left",
        "vk_lshift",
        "vk_multiply",
        "vk_nokey",
        "vk_numpad0",
        "vk_numpad1",
        "vk_numpad2",
        "vk_numpad3",
        "vk_numpad4",
        "vk_numpad5",
        "vk_numpad6",
        "vk_numpad7",
        "vk_numpad8",
        "vk_numpad9",
        "vk_pagedown",
        "vk_pageup",
        "vk_pause",
        "vk_printscreen",
        "vk_ralt",
        "vk_rcontrol",
        "vk_return",
        "vk_right",
        "vk_rshift",
        "vk_shift",
        "vk_space",
        "vk_subtract",
        "vk_tab",
        "vk_up",
        "wallpaper_config",
        "wallpaper_subscription_data",
        "wrap"
      ],
      "variable.language": [
        "alarm",
        "application_surface",
        "argument",
        "argument0",
        "argument1",
        "argument2",
        "argument3",
        "argument4",
        "argument5",
        "argument6",
        "argument7",
        "argument8",
        "argument9",
        "argument10",
        "argument11",
        "argument12",
        "argument13",
        "argument14",
        "argument15",
        "argument_count",
        "async_load",
        "background_color",
        "background_colour",
        "background_showcolor",
        "background_showcolour",
        "bbox_bottom",
        "bbox_left",
        "bbox_right",
        "bbox_top",
        "browser_height",
        "browser_width",
        "colour?ColourTrack",
        "current_day",
        "current_hour",
        "current_minute",
        "current_month",
        "current_second",
        "current_time",
        "current_weekday",
        "current_year",
        "cursor_sprite",
        "debug_mode",
        "delta_time",
        "depth",
        "direction",
        "display_aa",
        "drawn_by_sequence",
        "event_action",
        "event_data",
        "event_number",
        "event_object",
        "event_type",
        "font_texture_page_size",
        "fps",
        "fps_real",
        "friction",
        "game_display_name",
        "game_id",
        "game_project_name",
        "game_save_id",
        "gravity",
        "gravity_direction",
        "health",
        "hspeed",
        "iap_data",
        "id",
        "image_alpha",
        "image_angle",
        "image_blend",
        "image_index",
        "image_number",
        "image_speed",
        "image_xscale",
        "image_yscale",
        "in_collision_tree",
        "in_sequence",
        "instance_count",
        "instance_id",
        "keyboard_key",
        "keyboard_lastchar",
        "keyboard_lastkey",
        "keyboard_string",
        "layer",
        "lives",
        "longMessage",
        "managed",
        "mask_index",
        "message",
        "mouse_button",
        "mouse_lastbutton",
        "mouse_x",
        "mouse_y",
        "object_index",
        "os_browser",
        "os_device",
        "os_type",
        "os_version",
        "path_endaction",
        "path_index",
        "path_orientation",
        "path_position",
        "path_positionprevious",
        "path_scale",
        "path_speed",
        "persistent",
        "phy_active",
        "phy_angular_damping",
        "phy_angular_velocity",
        "phy_bullet",
        "phy_col_normal_x",
        "phy_col_normal_y",
        "phy_collision_points",
        "phy_collision_x",
        "phy_collision_y",
        "phy_com_x",
        "phy_com_y",
        "phy_dynamic",
        "phy_fixed_rotation",
        "phy_inertia",
        "phy_kinematic",
        "phy_linear_damping",
        "phy_linear_velocity_x",
        "phy_linear_velocity_y",
        "phy_mass",
        "phy_position_x",
        "phy_position_xprevious",
        "phy_position_y",
        "phy_position_yprevious",
        "phy_rotation",
        "phy_sleeping",
        "phy_speed",
        "phy_speed_x",
        "phy_speed_y",
        "player_avatar_sprite",
        "player_avatar_url",
        "player_id",
        "player_local",
        "player_type",
        "player_user_id",
        "program_directory",
        "rollback_api_server",
        "rollback_confirmed_frame",
        "rollback_current_frame",
        "rollback_event_id",
        "rollback_event_param",
        "rollback_game_running",
        "room",
        "room_first",
        "room_height",
        "room_last",
        "room_persistent",
        "room_speed",
        "room_width",
        "score",
        "script",
        "sequence_instance",
        "solid",
        "speed",
        "sprite_height",
        "sprite_index",
        "sprite_width",
        "sprite_xoffset",
        "sprite_yoffset",
        "stacktrace",
        "temp_directory",
        "timeline_index",
        "timeline_loop",
        "timeline_position",
        "timeline_running",
        "timeline_speed",
        "view_camera",
        "view_current",
        "view_enabled",
        "view_hport",
        "view_surface_id",
        "view_visible",
        "view_wport",
        "view_xport",
        "view_yport",
        "visible",
        "vspeed",
        "webgl_enabled",
        "working_directory",
        "x",
        "xprevious",
        "xstart",
        "y",
        "yprevious",
        "ystart"
      ]
    },
    contains: [
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE,
      t.C_NUMBER_MODE
    ]
  };
}
function AE(t) {
  return {
    name: "Golo",
    keywords: {
      keyword: [
        "println",
        "readln",
        "print",
        "import",
        "module",
        "function",
        "local",
        "return",
        "let",
        "var",
        "while",
        "for",
        "foreach",
        "times",
        "in",
        "case",
        "when",
        "match",
        "with",
        "break",
        "continue",
        "augment",
        "augmentation",
        "each",
        "find",
        "filter",
        "reduce",
        "if",
        "then",
        "else",
        "otherwise",
        "try",
        "catch",
        "finally",
        "raise",
        "throw",
        "orIfNull",
        "DynamicObject|10",
        "DynamicVariable",
        "struct",
        "Observable",
        "map",
        "set",
        "vector",
        "list",
        "array"
      ],
      literal: [
        "true",
        "false",
        "null"
      ]
    },
    contains: [
      t.HASH_COMMENT_MODE,
      t.QUOTE_STRING_MODE,
      t.C_NUMBER_MODE,
      {
        className: "meta",
        begin: "@[A-Za-z]+"
      }
    ]
  };
}
function IE(t) {
  return {
    name: "Gradle",
    case_insensitive: !0,
    keywords: [
      "task",
      "project",
      "allprojects",
      "subprojects",
      "artifacts",
      "buildscript",
      "configurations",
      "dependencies",
      "repositories",
      "sourceSets",
      "description",
      "delete",
      "from",
      "into",
      "include",
      "exclude",
      "source",
      "classpath",
      "destinationDir",
      "includes",
      "options",
      "sourceCompatibility",
      "targetCompatibility",
      "group",
      "flatDir",
      "doLast",
      "doFirst",
      "flatten",
      "todir",
      "fromdir",
      "ant",
      "def",
      "abstract",
      "break",
      "case",
      "catch",
      "continue",
      "default",
      "do",
      "else",
      "extends",
      "final",
      "finally",
      "for",
      "if",
      "implements",
      "instanceof",
      "native",
      "new",
      "private",
      "protected",
      "public",
      "return",
      "static",
      "switch",
      "synchronized",
      "throw",
      "throws",
      "transient",
      "try",
      "volatile",
      "while",
      "strictfp",
      "package",
      "import",
      "false",
      "null",
      "super",
      "this",
      "true",
      "antlrtask",
      "checkstyle",
      "codenarc",
      "copy",
      "boolean",
      "byte",
      "char",
      "class",
      "double",
      "float",
      "int",
      "interface",
      "long",
      "short",
      "void",
      "compile",
      "runTime",
      "file",
      "fileTree",
      "abs",
      "any",
      "append",
      "asList",
      "asWritable",
      "call",
      "collect",
      "compareTo",
      "count",
      "div",
      "dump",
      "each",
      "eachByte",
      "eachFile",
      "eachLine",
      "every",
      "find",
      "findAll",
      "flatten",
      "getAt",
      "getErr",
      "getIn",
      "getOut",
      "getText",
      "grep",
      "immutable",
      "inject",
      "inspect",
      "intersect",
      "invokeMethods",
      "isCase",
      "join",
      "leftShift",
      "minus",
      "multiply",
      "newInputStream",
      "newOutputStream",
      "newPrintWriter",
      "newReader",
      "newWriter",
      "next",
      "plus",
      "pop",
      "power",
      "previous",
      "print",
      "println",
      "push",
      "putAt",
      "read",
      "readBytes",
      "readLines",
      "reverse",
      "reverseEach",
      "round",
      "size",
      "sort",
      "splitEachLine",
      "step",
      "subMap",
      "times",
      "toInteger",
      "toList",
      "tokenize",
      "upto",
      "waitForOrKill",
      "withPrintWriter",
      "withReader",
      "withStream",
      "withWriter",
      "withWriterAppend",
      "write",
      "writeLine"
    ],
    contains: [
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE,
      t.NUMBER_MODE,
      t.REGEXP_MODE
    ]
  };
}
function La(t, e = {}) {
  return e.variants = t, e;
}
function DE(t) {
  const e = t.regex, n = "[A-Za-z0-9_$]+", i = La([
    t.C_LINE_COMMENT_MODE,
    t.C_BLOCK_COMMENT_MODE,
    t.COMMENT(
      "/\\*\\*",
      "\\*/",
      {
        relevance: 0,
        contains: [
          {
            // eat up @'s in emails to prevent them to be recognized as doctags
            begin: /\w+@/,
            relevance: 0
          },
          {
            className: "doctag",
            begin: "@[A-Za-z]+"
          }
        ]
      }
    )
  ]), r = {
    className: "regexp",
    begin: /~?\/[^\/\n]+\//,
    contains: [t.BACKSLASH_ESCAPE]
  }, a = La([
    t.BINARY_NUMBER_MODE,
    t.C_NUMBER_MODE
  ]), s = La(
    [
      {
        begin: /"""/,
        end: /"""/
      },
      {
        begin: /'''/,
        end: /'''/
      },
      {
        begin: "\\$/",
        end: "/\\$",
        relevance: 10
      },
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE
    ],
    { className: "string" }
  ), o = {
    match: [
      /(class|interface|trait|enum|record|extends|implements)/,
      /\s+/,
      t.UNDERSCORE_IDENT_RE
    ],
    scope: {
      1: "keyword",
      3: "title.class"
    }
  };
  return {
    name: "Groovy",
    keywords: {
      "variable.language": "this super",
      literal: "true false null",
      type: [
        "byte",
        "short",
        "char",
        "int",
        "long",
        "boolean",
        "float",
        "double",
        "void"
      ],
      keyword: [
        // groovy specific keywords
        "def",
        "as",
        "in",
        "assert",
        "trait",
        // common keywords with Java
        "abstract",
        "static",
        "volatile",
        "transient",
        "public",
        "private",
        "protected",
        "synchronized",
        "final",
        "class",
        "interface",
        "enum",
        "if",
        "else",
        "for",
        "while",
        "switch",
        "case",
        "break",
        "default",
        "continue",
        "throw",
        "throws",
        "try",
        "catch",
        "finally",
        "implements",
        "extends",
        "new",
        "import",
        "package",
        "return",
        "instanceof",
        "var"
      ]
    },
    contains: [
      t.SHEBANG({
        binary: "groovy",
        relevance: 10
      }),
      i,
      s,
      r,
      a,
      o,
      {
        className: "meta",
        begin: "@[A-Za-z]+",
        relevance: 0
      },
      {
        // highlight map keys and named parameters as attrs
        className: "attr",
        begin: n + "[ 	]*:",
        relevance: 0
      },
      {
        // catch middle element of the ternary operator
        // to avoid highlight it as a label, named parameter, or map key
        begin: /\?/,
        end: /:/,
        relevance: 0,
        contains: [
          i,
          s,
          r,
          a,
          "self"
        ]
      },
      {
        // highlight labeled statements
        className: "symbol",
        begin: "^[ 	]*" + e.lookahead(n + ":"),
        excludeBegin: !0,
        end: n + ":",
        relevance: 0
      }
    ],
    illegal: /#|<\//
  };
}
function ME(t) {
  return {
    name: "HAML",
    case_insensitive: !0,
    contains: [
      {
        className: "meta",
        begin: "^!!!( (5|1\\.1|Strict|Frameset|Basic|Mobile|RDFa|XML\\b.*))?$",
        relevance: 10
      },
      // FIXME these comments should be allowed to span indented lines
      t.COMMENT(
        "^\\s*(!=#|=#|-#|/).*$",
        null,
        { relevance: 0 }
      ),
      {
        begin: "^\\s*(-|=|!=)(?!#)",
        end: /$/,
        subLanguage: "ruby",
        excludeBegin: !0,
        excludeEnd: !0
      },
      {
        className: "tag",
        begin: "^\\s*%",
        contains: [
          {
            className: "selector-tag",
            begin: "\\w+"
          },
          {
            className: "selector-id",
            begin: "#[\\w-]+"
          },
          {
            className: "selector-class",
            begin: "\\.[\\w-]+"
          },
          {
            begin: /\{\s*/,
            end: /\s*\}/,
            contains: [
              {
                begin: ":\\w+\\s*=>",
                end: ",\\s+",
                returnBegin: !0,
                endsWithParent: !0,
                contains: [
                  {
                    className: "attr",
                    begin: ":\\w+"
                  },
                  t.APOS_STRING_MODE,
                  t.QUOTE_STRING_MODE,
                  {
                    begin: "\\w+",
                    relevance: 0
                  }
                ]
              }
            ]
          },
          {
            begin: "\\(\\s*",
            end: "\\s*\\)",
            excludeEnd: !0,
            contains: [
              {
                begin: "\\w+\\s*=",
                end: "\\s+",
                returnBegin: !0,
                endsWithParent: !0,
                contains: [
                  {
                    className: "attr",
                    begin: "\\w+",
                    relevance: 0
                  },
                  t.APOS_STRING_MODE,
                  t.QUOTE_STRING_MODE,
                  {
                    begin: "\\w+",
                    relevance: 0
                  }
                ]
              }
            ]
          }
        ]
      },
      { begin: "^\\s*[=~]\\s*" },
      {
        begin: /#\{/,
        end: /\}/,
        subLanguage: "ruby",
        excludeBegin: !0,
        excludeEnd: !0
      }
    ]
  };
}
function wE(t) {
  const e = t.regex, n = {
    $pattern: /[\w.\/]+/,
    built_in: [
      "action",
      "bindattr",
      "collection",
      "component",
      "concat",
      "debugger",
      "each",
      "each-in",
      "get",
      "hash",
      "if",
      "in",
      "input",
      "link-to",
      "loc",
      "log",
      "lookup",
      "mut",
      "outlet",
      "partial",
      "query-params",
      "render",
      "template",
      "textarea",
      "unbound",
      "unless",
      "view",
      "with",
      "yield"
    ]
  }, i = {
    $pattern: /[\w.\/]+/,
    literal: [
      "true",
      "false",
      "undefined",
      "null"
    ]
  }, r = /""|"[^"]+"/, a = /''|'[^']+'/, s = /\[\]|\[[^\]]+\]/, o = /[^\s!"#%&'()*+,.\/;<=>@\[\\\]^`{|}~]+/, l = /(\.|\/)/, c = e.either(
    r,
    a,
    s,
    o
  ), d = e.concat(
    e.optional(/\.|\.\/|\//),
    // relative or absolute path
    c,
    e.anyNumberOfTimes(e.concat(
      l,
      c
    ))
  ), u = e.concat(
    "(",
    s,
    "|",
    o,
    ")(?==)"
  ), _ = { begin: d }, m = t.inherit(_, { keywords: i }), g = {
    begin: /\(/,
    end: /\)/
    // the "contains" is added below when all necessary sub-modes are defined
  }, S = {
    // fka "attribute-assignment", parameters of the form 'key=value'
    className: "attr",
    begin: u,
    relevance: 0,
    starts: {
      begin: /=/,
      end: /=/,
      starts: { contains: [
        t.NUMBER_MODE,
        t.QUOTE_STRING_MODE,
        t.APOS_STRING_MODE,
        m,
        g
      ] }
    }
  }, E = {
    // parameters of the form '{{#with x as | y |}}...{{/with}}'
    begin: /as\s+\|/,
    keywords: { keyword: "as" },
    end: /\|/,
    contains: [
      {
        // define sub-mode in order to prevent highlighting of block-parameter named "as"
        begin: /\w+/
      }
    ]
  }, h = {
    contains: [
      t.NUMBER_MODE,
      t.QUOTE_STRING_MODE,
      t.APOS_STRING_MODE,
      E,
      S,
      m,
      g
    ],
    returnEnd: !0
    // the property "end" is defined through inheritance when the mode is used. If depends
    // on the surrounding mode, but "endsWithParent" does not work here (i.e. it includes the
    // end-token of the surrounding mode)
  }, T = t.inherit(_, {
    className: "name",
    keywords: n,
    starts: t.inherit(h, { end: /\)/ })
  });
  g.contains = [T];
  const b = t.inherit(_, {
    keywords: n,
    className: "name",
    starts: t.inherit(h, { end: /\}\}/ })
  }), C = t.inherit(_, {
    keywords: n,
    className: "name"
  }), y = t.inherit(_, {
    className: "name",
    keywords: n,
    starts: t.inherit(h, { end: /\}\}/ })
  });
  return {
    name: "Handlebars",
    aliases: [
      "hbs",
      "html.hbs",
      "html.handlebars",
      "htmlbars"
    ],
    case_insensitive: !0,
    subLanguage: "xml",
    contains: [
      {
        begin: /\\\{\{/,
        skip: !0
      },
      {
        begin: /\\\\(?=\{\{)/,
        skip: !0
      },
      t.COMMENT(/\{\{!--/, /--\}\}/),
      t.COMMENT(/\{\{!/, /\}\}/),
      {
        // open raw block "{{{{raw}}}} content not evaluated {{{{/raw}}}}"
        className: "template-tag",
        begin: /\{\{\{\{(?!\/)/,
        end: /\}\}\}\}/,
        contains: [b],
        starts: {
          end: /\{\{\{\{\//,
          returnEnd: !0,
          subLanguage: "xml"
        }
      },
      {
        // close raw block
        className: "template-tag",
        begin: /\{\{\{\{\//,
        end: /\}\}\}\}/,
        contains: [C]
      },
      {
        // open block statement
        className: "template-tag",
        begin: /\{\{#/,
        end: /\}\}/,
        contains: [b]
      },
      {
        className: "template-tag",
        begin: /\{\{(?=else\}\})/,
        end: /\}\}/,
        keywords: "else"
      },
      {
        className: "template-tag",
        begin: /\{\{(?=else if)/,
        end: /\}\}/,
        keywords: "else if"
      },
      {
        // closing block statement
        className: "template-tag",
        begin: /\{\{\//,
        end: /\}\}/,
        contains: [C]
      },
      {
        // template variable or helper-call that is NOT html-escaped
        className: "template-variable",
        begin: /\{\{\{/,
        end: /\}\}\}/,
        contains: [y]
      },
      {
        // template variable or helper-call that is html-escaped
        className: "template-variable",
        begin: /\{\{/,
        end: /\}\}/,
        contains: [y]
      }
    ]
  };
}
function xE(t) {
  const e = "([0-9]_*)+", n = "([0-9a-fA-F]_*)+", i = "([01]_*)+", r = "([0-7]_*)+", l = "([!#$%&*+.\\/<=>?@\\\\^~-]|(?!([(),;\\[\\]`|{}]|[_:\"']))(\\p{S}|\\p{P}))", c = { variants: [
    // Double dash forms a valid comment only if it's not part of legal lexeme.
    // See: Haskell 98 report: https://www.haskell.org/onlinereport/lexemes.html
    //
    // The commented code does the job, but we can't use negative lookbehind,
    // due to poor support by Safari browser.
    // > hljs.COMMENT(`(?<!${symbol})--+(?!${symbol})`, '$'),
    // So instead, we'll add a no-markup rule before the COMMENT rule in the rules list
    // to match the problematic infix operators that contain double dash.
    t.COMMENT("--+", "$"),
    t.COMMENT(
      /\{-/,
      /-\}/,
      { contains: ["self"] }
    )
  ] }, d = {
    className: "meta",
    begin: /\{-#/,
    end: /#-\}/
  }, u = {
    className: "meta",
    begin: "^#",
    end: "$"
  }, _ = {
    className: "type",
    begin: "\\b[A-Z][\\w']*",
    // TODO: other constructors (build-in, infix).
    relevance: 0
  }, m = {
    begin: "\\(",
    end: "\\)",
    illegal: '"',
    contains: [
      d,
      u,
      {
        className: "type",
        begin: "\\b[A-Z][\\w]*(\\((\\.\\.|,|\\w+)\\))?"
      },
      t.inherit(t.TITLE_MODE, { begin: "[_a-z][\\w']*" }),
      c
    ]
  }, g = {
    begin: /\{/,
    end: /\}/,
    contains: m.contains
  }, S = {
    className: "number",
    relevance: 0,
    variants: [
      // decimal floating-point-literal (subsumes decimal-literal)
      { match: `\\b(${e})(\\.(${e}))?([eE][+-]?(${e}))?\\b` },
      // hexadecimal floating-point-literal (subsumes hexadecimal-literal)
      { match: `\\b0[xX]_*(${n})(\\.(${n}))?([pP][+-]?(${e}))?\\b` },
      // octal-literal
      { match: `\\b0[oO](${r})\\b` },
      // binary-literal
      { match: `\\b0[bB](${i})\\b` }
    ]
  };
  return {
    name: "Haskell",
    aliases: ["hs"],
    keywords: "let in if then else case of where do module import hiding qualified type data newtype deriving class instance as default infix infixl infixr foreign export ccall stdcall cplusplus jvm dotnet safe unsafe family forall mdo proc rec",
    unicodeRegex: !0,
    contains: [
      // Top-level constructions.
      {
        beginKeywords: "module",
        end: "where",
        keywords: "module where",
        contains: [
          m,
          c
        ],
        illegal: "\\W\\.|;"
      },
      {
        begin: "\\bimport\\b",
        end: "$",
        keywords: "import qualified as hiding",
        contains: [
          m,
          c
        ],
        illegal: "\\W\\.|;"
      },
      {
        className: "class",
        begin: "^(\\s*)?(class|instance)\\b",
        end: "where",
        keywords: "class family instance where",
        contains: [
          _,
          m,
          c
        ]
      },
      {
        className: "class",
        begin: "\\b(data|(new)?type)\\b",
        end: "$",
        keywords: "data family type newtype deriving",
        contains: [
          d,
          _,
          m,
          g,
          c
        ]
      },
      {
        beginKeywords: "default",
        end: "$",
        contains: [
          _,
          m,
          c
        ]
      },
      {
        beginKeywords: "infix infixl infixr",
        end: "$",
        contains: [
          t.C_NUMBER_MODE,
          c
        ]
      },
      {
        begin: "\\bforeign\\b",
        end: "$",
        keywords: "foreign import export ccall stdcall cplusplus jvm dotnet safe unsafe",
        contains: [
          _,
          t.QUOTE_STRING_MODE,
          c
        ]
      },
      {
        className: "meta",
        begin: "#!\\/usr\\/bin\\/env runhaskell",
        end: "$"
      },
      // "Whitespaces".
      d,
      u,
      // Literals and names.
      // Single characters.
      {
        scope: "string",
        begin: /'(?=\\?.')/,
        end: /'/,
        contains: [
          {
            scope: "char.escape",
            match: /\\./
          }
        ]
      },
      t.QUOTE_STRING_MODE,
      S,
      _,
      t.inherit(t.TITLE_MODE, { begin: "^[_a-z][\\w']*" }),
      // No markup, prevents infix operators from being recognized as comments.
      { begin: `(?!-)${l}--+|--+(?!-)${l}` },
      c,
      {
        // No markup, relevance booster
        begin: "->|<-"
      }
    ]
  };
}
function LE(t) {
  const e = "[a-zA-Z_$][a-zA-Z0-9_$]*", n = /(-?)(\b0[xX][a-fA-F0-9_]+|(\b\d+(\.[\d_]*)?|\.[\d_]+)(([eE][-+]?\d+)|i32|u32|i64|f64)?)/;
  return {
    name: "Haxe",
    aliases: ["hx"],
    keywords: {
      keyword: "abstract break case cast catch continue default do dynamic else enum extern final for function here if import in inline is macro never new override package private get set public return static super switch this throw trace try typedef untyped using var while " + "Int Float String Bool Dynamic Void Array ",
      built_in: "trace this",
      literal: "true false null _"
    },
    contains: [
      {
        className: "string",
        // interpolate-able strings
        begin: "'",
        end: "'",
        contains: [
          t.BACKSLASH_ESCAPE,
          {
            className: "subst",
            // interpolation
            begin: /\$\{/,
            end: /\}/
          },
          {
            className: "subst",
            // interpolation
            begin: /\$/,
            end: /\W\}/
          }
        ]
      },
      t.QUOTE_STRING_MODE,
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      {
        className: "number",
        begin: n,
        relevance: 0
      },
      {
        className: "variable",
        begin: "\\$" + e
      },
      {
        className: "meta",
        // compiler meta
        begin: /@:?/,
        end: /\(|$/,
        excludeEnd: !0
      },
      {
        className: "meta",
        // compiler conditionals
        begin: "#",
        end: "$",
        keywords: { keyword: "if else elseif end error" }
      },
      {
        className: "type",
        // function types
        begin: /:[ \t]*/,
        end: /[^A-Za-z0-9_ \t\->]/,
        excludeBegin: !0,
        excludeEnd: !0,
        relevance: 0
      },
      {
        className: "type",
        // types
        begin: /:[ \t]*/,
        end: /\W/,
        excludeBegin: !0,
        excludeEnd: !0
      },
      {
        className: "type",
        // instantiation
        beginKeywords: "new",
        end: /\W/,
        excludeBegin: !0,
        excludeEnd: !0
      },
      {
        className: "title.class",
        // enums
        beginKeywords: "enum",
        end: /\{/,
        contains: [t.TITLE_MODE]
      },
      {
        className: "title.class",
        // abstracts
        begin: "\\babstract\\b(?=\\s*" + t.IDENT_RE + "\\s*\\()",
        end: /[\{$]/,
        contains: [
          {
            className: "type",
            begin: /\(/,
            end: /\)/,
            excludeBegin: !0,
            excludeEnd: !0
          },
          {
            className: "type",
            begin: /from +/,
            end: /\W/,
            excludeBegin: !0,
            excludeEnd: !0
          },
          {
            className: "type",
            begin: /to +/,
            end: /\W/,
            excludeBegin: !0,
            excludeEnd: !0
          },
          t.TITLE_MODE
        ],
        keywords: { keyword: "abstract from to" }
      },
      {
        className: "title.class",
        // classes
        begin: /\b(class|interface) +/,
        end: /[\{$]/,
        excludeEnd: !0,
        keywords: "class interface",
        contains: [
          {
            className: "keyword",
            begin: /\b(extends|implements) +/,
            keywords: "extends implements",
            contains: [
              {
                className: "type",
                begin: t.IDENT_RE,
                relevance: 0
              }
            ]
          },
          t.TITLE_MODE
        ]
      },
      {
        className: "title.function",
        beginKeywords: "function",
        end: /\(/,
        excludeEnd: !0,
        illegal: /\S/,
        contains: [t.TITLE_MODE]
      }
    ],
    illegal: /<\//
  };
}
function PE(t) {
  return {
    name: "HSP",
    case_insensitive: !0,
    keywords: {
      $pattern: /[\w._]+/,
      keyword: "goto gosub return break repeat loop continue wait await dim sdim foreach dimtype dup dupptr end stop newmod delmod mref run exgoto on mcall assert logmes newlab resume yield onexit onerror onkey onclick oncmd exist delete mkdir chdir dirlist bload bsave bcopy memfile if else poke wpoke lpoke getstr chdpm memexpand memcpy memset notesel noteadd notedel noteload notesave randomize noteunsel noteget split strrep setease button chgdisp exec dialog mmload mmplay mmstop mci pset pget syscolor mes print title pos circle cls font sysfont objsize picload color palcolor palette redraw width gsel gcopy gzoom gmode bmpsave hsvcolor getkey listbox chkbox combox input mesbox buffer screen bgscr mouse objsel groll line clrobj boxf objprm objmode stick grect grotate gsquare gradf objimage objskip objenable celload celdiv celput newcom querycom delcom cnvstow comres axobj winobj sendmsg comevent comevarg sarrayconv callfunc cnvwtos comevdisp libptr system hspstat hspver stat cnt err strsize looplev sublev iparam wparam lparam refstr refdval int rnd strlen length length2 length3 length4 vartype gettime peek wpeek lpeek varptr varuse noteinfo instr abs limit getease str strmid strf getpath strtrim sin cos tan atan sqrt double absf expf logf limitf powf geteasef mousex mousey mousew hwnd hinstance hdc ginfo objinfo dirinfo sysinfo thismod __hspver__ __hsp30__ __date__ __time__ __line__ __file__ _debug __hspdef__ and or xor not screen_normal screen_palette screen_hide screen_fixedsize screen_tool screen_frame gmode_gdi gmode_mem gmode_rgb0 gmode_alpha gmode_rgb0alpha gmode_add gmode_sub gmode_pixela ginfo_mx ginfo_my ginfo_act ginfo_sel ginfo_wx1 ginfo_wy1 ginfo_wx2 ginfo_wy2 ginfo_vx ginfo_vy ginfo_sizex ginfo_sizey ginfo_winx ginfo_winy ginfo_mesx ginfo_mesy ginfo_r ginfo_g ginfo_b ginfo_paluse ginfo_dispx ginfo_dispy ginfo_cx ginfo_cy ginfo_intid ginfo_newid ginfo_sx ginfo_sy objinfo_mode objinfo_bmscr objinfo_hwnd notemax notesize dir_cur dir_exe dir_win dir_sys dir_cmdline dir_desktop dir_mydoc dir_tv font_normal font_bold font_italic font_underline font_strikeout font_antialias objmode_normal objmode_guifont objmode_usefont gsquare_grad msgothic msmincho do until while wend for next _break _continue switch case default swbreak swend ddim ldim alloc m_pi rad2deg deg2rad ease_linear ease_quad_in ease_quad_out ease_quad_inout ease_cubic_in ease_cubic_out ease_cubic_inout ease_quartic_in ease_quartic_out ease_quartic_inout ease_bounce_in ease_bounce_out ease_bounce_inout ease_shake_in ease_shake_out ease_shake_inout ease_loop"
    },
    contains: [
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      t.QUOTE_STRING_MODE,
      t.APOS_STRING_MODE,
      {
        // multi-line string
        className: "string",
        begin: /\{"/,
        end: /"\}/,
        contains: [t.BACKSLASH_ESCAPE]
      },
      t.COMMENT(";", "$", { relevance: 0 }),
      {
        // pre-processor
        className: "meta",
        begin: "#",
        end: "$",
        keywords: { keyword: "addion cfunc cmd cmpopt comfunc const defcfunc deffunc define else endif enum epack func global if ifdef ifndef include modcfunc modfunc modinit modterm module pack packopt regcmd runtime undef usecom uselib" },
        contains: [
          t.inherit(t.QUOTE_STRING_MODE, { className: "string" }),
          t.NUMBER_MODE,
          t.C_NUMBER_MODE,
          t.C_LINE_COMMENT_MODE,
          t.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        // label
        className: "symbol",
        begin: "^\\*(\\w+|@)"
      },
      t.NUMBER_MODE,
      t.C_NUMBER_MODE
    ]
  };
}
function kE(t) {
  const e = t.regex, n = "HTTP/([32]|1\\.[01])", i = /[A-Za-z][A-Za-z0-9-]*/, r = {
    className: "attribute",
    begin: e.concat("^", i, "(?=\\:\\s)"),
    starts: { contains: [
      {
        className: "punctuation",
        begin: /: /,
        relevance: 0,
        starts: {
          end: "$",
          relevance: 0
        }
      }
    ] }
  }, a = [
    r,
    {
      begin: "\\n\\n",
      starts: {
        subLanguage: [],
        endsWithParent: !0
      }
    }
  ];
  return {
    name: "HTTP",
    aliases: ["https"],
    illegal: /\S/,
    contains: [
      // response
      {
        begin: "^(?=" + n + " \\d{3})",
        end: /$/,
        contains: [
          {
            className: "meta",
            begin: n
          },
          {
            className: "number",
            begin: "\\b\\d{3}\\b"
          }
        ],
        starts: {
          end: /\b\B/,
          illegal: /\S/,
          contains: a
        }
      },
      // request
      {
        begin: "(?=^[A-Z]+ (.*?) " + n + "$)",
        end: /$/,
        contains: [
          {
            className: "string",
            begin: " ",
            end: " ",
            excludeBegin: !0,
            excludeEnd: !0
          },
          {
            className: "meta",
            begin: n
          },
          {
            className: "keyword",
            begin: "[A-Z]+"
          }
        ],
        starts: {
          end: /\b\B/,
          illegal: /\S/,
          contains: a
        }
      },
      // to allow headers to work even without a preamble
      t.inherit(r, { relevance: 0 })
    ]
  };
}
function UE(t) {
  const e = "a-zA-Z_\\-!.?+*=<>&#'", n = "[" + e + "][" + e + "0-9/;:]*", i = {
    $pattern: n,
    built_in: (
      // keywords
      "!= % %= & &= * ** **= *= *map + += , --build-class-- --import-- -= . / // //= /= < << <<= <= = > >= >> >>= @ @= ^ ^= abs accumulate all and any ap-compose ap-dotimes ap-each ap-each-while ap-filter ap-first ap-if ap-last ap-map ap-map-when ap-pipe ap-reduce ap-reject apply as-> ascii assert assoc bin break butlast callable calling-module-name car case cdr chain chr coll? combinations compile compress cond cons cons? continue count curry cut cycle dec def default-method defclass defmacro defmacro-alias defmacro/g! defmain defmethod defmulti defn defn-alias defnc defnr defreader defseq del delattr delete-route dict-comp dir disassemble dispatch-reader-macro distinct divmod do doto drop drop-last drop-while empty? end-sequence eval eval-and-compile eval-when-compile even? every? except exec filter first flatten float? fn fnc fnr for for* format fraction genexpr gensym get getattr global globals group-by hasattr hash hex id identity if if* if-not if-python2 import in inc input instance? integer integer-char? integer? interleave interpose is is-coll is-cons is-empty is-even is-every is-float is-instance is-integer is-integer-char is-iterable is-iterator is-keyword is-neg is-none is-not is-numeric is-odd is-pos is-string is-symbol is-zero isinstance islice issubclass iter iterable? iterate iterator? keyword keyword? lambda last len let lif lif-not list* list-comp locals loop macro-error macroexpand macroexpand-1 macroexpand-all map max merge-with method-decorator min multi-decorator multicombinations name neg? next none? nonlocal not not-in not? nth numeric? oct odd? open or ord partition permutations pos? post-route postwalk pow prewalk print product profile/calls profile/cpu put-route quasiquote quote raise range read read-str recursive-replace reduce remove repeat repeatedly repr require rest round route route-with-methods rwm second seq set-comp setattr setv some sorted string string? sum switch symbol? take take-nth take-while tee try unless unquote unquote-splicing vars walk when while with with* with-decorator with-gensyms xi xor yield yield-from zero? zip zip-longest | |= ~"
    )
  }, r = "[-+]?\\d+(\\.\\d+)?", a = {
    begin: n,
    relevance: 0
  }, s = {
    className: "number",
    begin: r,
    relevance: 0
  }, o = t.inherit(t.QUOTE_STRING_MODE, { illegal: null }), l = t.COMMENT(
    ";",
    "$",
    { relevance: 0 }
  ), c = {
    className: "literal",
    begin: /\b([Tt]rue|[Ff]alse|nil|None)\b/
  }, d = {
    begin: "[\\[\\{]",
    end: "[\\]\\}]",
    relevance: 0
  }, u = {
    className: "comment",
    begin: "\\^" + n
  }, _ = t.COMMENT("\\^\\{", "\\}"), m = {
    className: "symbol",
    begin: "[:]{1,2}" + n
  }, g = {
    begin: "\\(",
    end: "\\)"
  }, S = {
    endsWithParent: !0,
    relevance: 0
  }, E = {
    className: "name",
    relevance: 0,
    keywords: i,
    begin: n,
    starts: S
  }, h = [
    g,
    o,
    u,
    _,
    l,
    m,
    d,
    s,
    c,
    a
  ];
  return g.contains = [
    t.COMMENT("comment", ""),
    E,
    S
  ], S.contains = h, d.contains = h, {
    name: "Hy",
    aliases: ["hylang"],
    illegal: /\S/,
    contains: [
      t.SHEBANG(),
      g,
      o,
      u,
      _,
      l,
      m,
      d,
      s,
      c
    ]
  };
}
function FE(t) {
  return {
    name: "Inform 7",
    aliases: ["i7"],
    case_insensitive: !0,
    keywords: {
      // Some keywords more or less unique to I7, for relevance.
      keyword: (
        // kind:
        "thing room person man woman animal container supporter backdrop door scenery open closed locked inside gender is are say understand kind of rule"
      )
    },
    contains: [
      {
        className: "string",
        begin: '"',
        end: '"',
        relevance: 0,
        contains: [
          {
            className: "subst",
            begin: "\\[",
            end: "\\]"
          }
        ]
      },
      {
        className: "section",
        begin: /^(Volume|Book|Part|Chapter|Section|Table)\b/,
        end: "$"
      },
      {
        // Rule definition
        // This is here for relevance.
        begin: /^(Check|Carry out|Report|Instead of|To|Rule|When|Before|After)\b/,
        end: ":",
        contains: [
          {
            // Rule name
            begin: "\\(This",
            end: "\\)"
          }
        ]
      },
      {
        className: "comment",
        begin: "\\[",
        end: "\\]",
        contains: ["self"]
      }
    ]
  };
}
function BE(t) {
  const e = t.regex, n = {
    className: "params",
    begin: "\\(",
    end: "\\)"
  }, i = /(_[a-z_\d]+)?/, r = /([de][+-]?\d+)?/, a = {
    className: "number",
    variants: [
      { begin: e.concat(/\b\d+/, /\.(\d*)/, r, i) },
      { begin: e.concat(/\b\d+/, r, i) },
      { begin: e.concat(/\.\d+/, r, i) }
    ],
    relevance: 0
  };
  return {
    name: "IRPF90",
    case_insensitive: !0,
    keywords: {
      literal: ".False. .True.",
      keyword: "kind do while private call intrinsic where elsewhere type endtype endmodule endselect endinterface end enddo endif if forall endforall only contains default return stop then public subroutine|10 function program .and. .or. .not. .le. .eq. .ge. .gt. .lt. goto save else use module select case access blank direct exist file fmt form formatted iostat name named nextrec number opened rec recl sequential status unformatted unit continue format pause cycle exit c_null_char c_alert c_backspace c_form_feed flush wait decimal round iomsg synchronous nopass non_overridable pass protected volatile abstract extends import non_intrinsic value deferred generic final enumerator class associate bind enum c_int c_short c_long c_long_long c_signed_char c_size_t c_int8_t c_int16_t c_int32_t c_int64_t c_int_least8_t c_int_least16_t c_int_least32_t c_int_least64_t c_int_fast8_t c_int_fast16_t c_int_fast32_t c_int_fast64_t c_intmax_t C_intptr_t c_float c_double c_long_double c_float_complex c_double_complex c_long_double_complex c_bool c_char c_null_ptr c_null_funptr c_new_line c_carriage_return c_horizontal_tab c_vertical_tab iso_c_binding c_loc c_funloc c_associated  c_f_pointer c_ptr c_funptr iso_fortran_env character_storage_size error_unit file_storage_size input_unit iostat_end iostat_eor numeric_storage_size output_unit c_f_procpointer ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode newunit contiguous recursive pad position action delim readwrite eor advance nml interface procedure namelist include sequence elemental pure integer real character complex logical dimension allocatable|10 parameter external implicit|10 none double precision assign intent optional pointer target in out common equivalence data begin_provider &begin_provider end_provider begin_shell end_shell begin_template end_template subst assert touch soft_touch provide no_dep free irp_if irp_else irp_endif irp_write irp_read",
      built_in: "alog alog10 amax0 amax1 amin0 amin1 amod cabs ccos cexp clog csin csqrt dabs dacos dasin datan datan2 dcos dcosh ddim dexp dint dlog dlog10 dmax1 dmin1 dmod dnint dsign dsin dsinh dsqrt dtan dtanh float iabs idim idint idnint ifix isign max0 max1 min0 min1 sngl algama cdabs cdcos cdexp cdlog cdsin cdsqrt cqabs cqcos cqexp cqlog cqsin cqsqrt dcmplx dconjg derf derfc dfloat dgamma dimag dlgama iqint qabs qacos qasin qatan qatan2 qcmplx qconjg qcos qcosh qdim qerf qerfc qexp qgamma qimag qlgama qlog qlog10 qmax1 qmin1 qmod qnint qsign qsin qsinh qsqrt qtan qtanh abs acos aimag aint anint asin atan atan2 char cmplx conjg cos cosh exp ichar index int log log10 max min nint sign sin sinh sqrt tan tanh print write dim lge lgt lle llt mod nullify allocate deallocate adjustl adjustr all allocated any associated bit_size btest ceiling count cshift date_and_time digits dot_product eoshift epsilon exponent floor fraction huge iand ibclr ibits ibset ieor ior ishft ishftc lbound len_trim matmul maxexponent maxloc maxval merge minexponent minloc minval modulo mvbits nearest pack present product radix random_number random_seed range repeat reshape rrspacing scale scan selected_int_kind selected_real_kind set_exponent shape size spacing spread sum system_clock tiny transpose trim ubound unpack verify achar iachar transfer dble entry dprod cpu_time command_argument_count get_command get_command_argument get_environment_variable is_iostat_end ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode is_iostat_eor move_alloc new_line selected_char_kind same_type_as extends_type_of acosh asinh atanh bessel_j0 bessel_j1 bessel_jn bessel_y0 bessel_y1 bessel_yn erf erfc erfc_scaled gamma log_gamma hypot norm2 atomic_define atomic_ref execute_command_line leadz trailz storage_size merge_bits bge bgt ble blt dshiftl dshiftr findloc iall iany iparity image_index lcobound ucobound maskl maskr num_images parity popcnt poppar shifta shiftl shiftr this_image IRP_ALIGN irp_here"
    },
    illegal: /\/\*/,
    contains: [
      t.inherit(t.APOS_STRING_MODE, {
        className: "string",
        relevance: 0
      }),
      t.inherit(t.QUOTE_STRING_MODE, {
        className: "string",
        relevance: 0
      }),
      {
        className: "function",
        beginKeywords: "subroutine function program",
        illegal: "[${=\\n]",
        contains: [
          t.UNDERSCORE_TITLE_MODE,
          n
        ]
      },
      t.COMMENT("!", "$", { relevance: 0 }),
      t.COMMENT("begin_doc", "end_doc", { relevance: 10 }),
      a
    ]
  };
}
function GE(t) {
  const e = "[A-Za-zА-Яа-яёЁ_!][A-Za-zА-Яа-яёЁ_0-9]*", n = "[A-Za-zА-Яа-яёЁ_][A-Za-zА-Яа-яёЁ_0-9]*", i = "and и else иначе endexcept endfinally endforeach конецвсе endif конецесли endwhile конецпока except exitfor finally foreach все if если in в not не or или try while пока ", ke = "SYSRES_CONST_ACCES_RIGHT_TYPE_EDIT SYSRES_CONST_ACCES_RIGHT_TYPE_FULL SYSRES_CONST_ACCES_RIGHT_TYPE_VIEW SYSRES_CONST_ACCESS_MODE_REQUISITE_CODE SYSRES_CONST_ACCESS_NO_ACCESS_VIEW SYSRES_CONST_ACCESS_NO_ACCESS_VIEW_CODE SYSRES_CONST_ACCESS_RIGHTS_ADD_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_ADD_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_CHANGE_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_CHANGE_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_DELETE_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_DELETE_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_EXECUTE_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_EXECUTE_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_NO_ACCESS_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_NO_ACCESS_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_RATIFY_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_RATIFY_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_VIEW SYSRES_CONST_ACCESS_RIGHTS_VIEW_CODE SYSRES_CONST_ACCESS_RIGHTS_VIEW_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_VIEW_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_TYPE_CHANGE SYSRES_CONST_ACCESS_TYPE_CHANGE_CODE SYSRES_CONST_ACCESS_TYPE_EXISTS SYSRES_CONST_ACCESS_TYPE_EXISTS_CODE SYSRES_CONST_ACCESS_TYPE_FULL SYSRES_CONST_ACCESS_TYPE_FULL_CODE SYSRES_CONST_ACCESS_TYPE_VIEW SYSRES_CONST_ACCESS_TYPE_VIEW_CODE SYSRES_CONST_ACTION_TYPE_ABORT SYSRES_CONST_ACTION_TYPE_ACCEPT SYSRES_CONST_ACTION_TYPE_ACCESS_RIGHTS SYSRES_CONST_ACTION_TYPE_ADD_ATTACHMENT SYSRES_CONST_ACTION_TYPE_CHANGE_CARD SYSRES_CONST_ACTION_TYPE_CHANGE_KIND SYSRES_CONST_ACTION_TYPE_CHANGE_STORAGE SYSRES_CONST_ACTION_TYPE_CONTINUE SYSRES_CONST_ACTION_TYPE_COPY SYSRES_CONST_ACTION_TYPE_CREATE SYSRES_CONST_ACTION_TYPE_CREATE_VERSION SYSRES_CONST_ACTION_TYPE_DELETE SYSRES_CONST_ACTION_TYPE_DELETE_ATTACHMENT SYSRES_CONST_ACTION_TYPE_DELETE_VERSION SYSRES_CONST_ACTION_TYPE_DISABLE_DELEGATE_ACCESS_RIGHTS SYSRES_CONST_ACTION_TYPE_ENABLE_DELEGATE_ACCESS_RIGHTS SYSRES_CONST_ACTION_TYPE_ENCRYPTION_BY_CERTIFICATE SYSRES_CONST_ACTION_TYPE_ENCRYPTION_BY_CERTIFICATE_AND_PASSWORD SYSRES_CONST_ACTION_TYPE_ENCRYPTION_BY_PASSWORD SYSRES_CONST_ACTION_TYPE_EXPORT_WITH_LOCK SYSRES_CONST_ACTION_TYPE_EXPORT_WITHOUT_LOCK SYSRES_CONST_ACTION_TYPE_IMPORT_WITH_UNLOCK SYSRES_CONST_ACTION_TYPE_IMPORT_WITHOUT_UNLOCK SYSRES_CONST_ACTION_TYPE_LIFE_CYCLE_STAGE SYSRES_CONST_ACTION_TYPE_LOCK SYSRES_CONST_ACTION_TYPE_LOCK_FOR_SERVER SYSRES_CONST_ACTION_TYPE_LOCK_MODIFY SYSRES_CONST_ACTION_TYPE_MARK_AS_READED SYSRES_CONST_ACTION_TYPE_MARK_AS_UNREADED SYSRES_CONST_ACTION_TYPE_MODIFY SYSRES_CONST_ACTION_TYPE_MODIFY_CARD SYSRES_CONST_ACTION_TYPE_MOVE_TO_ARCHIVE SYSRES_CONST_ACTION_TYPE_OFF_ENCRYPTION SYSRES_CONST_ACTION_TYPE_PASSWORD_CHANGE SYSRES_CONST_ACTION_TYPE_PERFORM SYSRES_CONST_ACTION_TYPE_RECOVER_FROM_LOCAL_COPY SYSRES_CONST_ACTION_TYPE_RESTART SYSRES_CONST_ACTION_TYPE_RESTORE_FROM_ARCHIVE SYSRES_CONST_ACTION_TYPE_REVISION SYSRES_CONST_ACTION_TYPE_SEND_BY_MAIL SYSRES_CONST_ACTION_TYPE_SIGN SYSRES_CONST_ACTION_TYPE_START SYSRES_CONST_ACTION_TYPE_UNLOCK SYSRES_CONST_ACTION_TYPE_UNLOCK_FROM_SERVER SYSRES_CONST_ACTION_TYPE_VERSION_STATE SYSRES_CONST_ACTION_TYPE_VERSION_VISIBILITY SYSRES_CONST_ACTION_TYPE_VIEW SYSRES_CONST_ACTION_TYPE_VIEW_SHADOW_COPY SYSRES_CONST_ACTION_TYPE_WORKFLOW_DESCRIPTION_MODIFY SYSRES_CONST_ACTION_TYPE_WRITE_HISTORY SYSRES_CONST_ACTIVE_VERSION_STATE_PICK_VALUE SYSRES_CONST_ADD_REFERENCE_MODE_NAME SYSRES_CONST_ADDITION_REQUISITE_CODE SYSRES_CONST_ADDITIONAL_PARAMS_REQUISITE_CODE SYSRES_CONST_ADITIONAL_JOB_END_DATE_REQUISITE_NAME SYSRES_CONST_ADITIONAL_JOB_READ_REQUISITE_NAME SYSRES_CONST_ADITIONAL_JOB_START_DATE_REQUISITE_NAME SYSRES_CONST_ADITIONAL_JOB_STATE_REQUISITE_NAME SYSRES_CONST_ADMINISTRATION_HISTORY_ADDING_USER_TO_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_ADDING_USER_TO_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_COMP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_COMP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_USER_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_USER_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_CREATION SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_CREATION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_DELETION SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_DELETION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_COMP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_COMP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_FROM_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_FROM_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_RESTRICTION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_RESTRICTION_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_PRIVILEGE_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_PRIVILEGE_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_RIGHTS_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_RIGHTS_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_IS_MAIN_SERVER_CHANGED_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_IS_MAIN_SERVER_CHANGED_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_IS_PUBLIC_CHANGED_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_IS_PUBLIC_CHANGED_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_RESTRICTION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_RESTRICTION_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_PRIVILEGE_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_PRIVILEGE_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_RIGHTS_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_RIGHTS_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_CREATION SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_CREATION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_DELETION SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_DELETION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_CATEGORY_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_CATEGORY_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_COMP_TITLE_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_COMP_TITLE_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_FULL_NAME_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_FULL_NAME_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_PARENT_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_PARENT_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_AUTH_TYPE_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_AUTH_TYPE_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_LOGIN_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_LOGIN_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_STATUS_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_STATUS_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_USER_PASSWORD_CHANGE SYSRES_CONST_ADMINISTRATION_HISTORY_USER_PASSWORD_CHANGE_ACTION SYSRES_CONST_ALL_ACCEPT_CONDITION_RUS SYSRES_CONST_ALL_USERS_GROUP SYSRES_CONST_ALL_USERS_GROUP_NAME SYSRES_CONST_ALL_USERS_SERVER_GROUP_NAME SYSRES_CONST_ALLOWED_ACCESS_TYPE_CODE SYSRES_CONST_ALLOWED_ACCESS_TYPE_NAME SYSRES_CONST_APP_VIEWER_TYPE_REQUISITE_CODE SYSRES_CONST_APPROVING_SIGNATURE_NAME SYSRES_CONST_APPROVING_SIGNATURE_REQUISITE_CODE SYSRES_CONST_ASSISTANT_SUBSTITUE_TYPE SYSRES_CONST_ASSISTANT_SUBSTITUE_TYPE_CODE SYSRES_CONST_ATTACH_TYPE_COMPONENT_TOKEN SYSRES_CONST_ATTACH_TYPE_DOC SYSRES_CONST_ATTACH_TYPE_EDOC SYSRES_CONST_ATTACH_TYPE_FOLDER SYSRES_CONST_ATTACH_TYPE_JOB SYSRES_CONST_ATTACH_TYPE_REFERENCE SYSRES_CONST_ATTACH_TYPE_TASK SYSRES_CONST_AUTH_ENCODED_PASSWORD SYSRES_CONST_AUTH_ENCODED_PASSWORD_CODE SYSRES_CONST_AUTH_NOVELL SYSRES_CONST_AUTH_PASSWORD SYSRES_CONST_AUTH_PASSWORD_CODE SYSRES_CONST_AUTH_WINDOWS SYSRES_CONST_AUTHENTICATING_SIGNATURE_NAME SYSRES_CONST_AUTHENTICATING_SIGNATURE_REQUISITE_CODE SYSRES_CONST_AUTO_ENUM_METHOD_FLAG SYSRES_CONST_AUTO_NUMERATION_CODE SYSRES_CONST_AUTO_STRONG_ENUM_METHOD_FLAG SYSRES_CONST_AUTOTEXT_NAME_REQUISITE_CODE SYSRES_CONST_AUTOTEXT_TEXT_REQUISITE_CODE SYSRES_CONST_AUTOTEXT_USAGE_ALL SYSRES_CONST_AUTOTEXT_USAGE_ALL_CODE SYSRES_CONST_AUTOTEXT_USAGE_SIGN SYSRES_CONST_AUTOTEXT_USAGE_SIGN_CODE SYSRES_CONST_AUTOTEXT_USAGE_WORK SYSRES_CONST_AUTOTEXT_USAGE_WORK_CODE SYSRES_CONST_AUTOTEXT_USE_ANYWHERE_CODE SYSRES_CONST_AUTOTEXT_USE_ON_SIGNING_CODE SYSRES_CONST_AUTOTEXT_USE_ON_WORK_CODE SYSRES_CONST_BEGIN_DATE_REQUISITE_CODE SYSRES_CONST_BLACK_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_BLUE_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_BTN_PART SYSRES_CONST_CALCULATED_ROLE_TYPE_CODE SYSRES_CONST_CALL_TYPE_VARIABLE_BUTTON_VALUE SYSRES_CONST_CALL_TYPE_VARIABLE_PROGRAM_VALUE SYSRES_CONST_CANCEL_MESSAGE_FUNCTION_RESULT SYSRES_CONST_CARD_PART SYSRES_CONST_CARD_REFERENCE_MODE_NAME SYSRES_CONST_CERTIFICATE_TYPE_REQUISITE_ENCRYPT_VALUE SYSRES_CONST_CERTIFICATE_TYPE_REQUISITE_SIGN_AND_ENCRYPT_VALUE SYSRES_CONST_CERTIFICATE_TYPE_REQUISITE_SIGN_VALUE SYSRES_CONST_CHECK_PARAM_VALUE_DATE_PARAM_TYPE SYSRES_CONST_CHECK_PARAM_VALUE_FLOAT_PARAM_TYPE SYSRES_CONST_CHECK_PARAM_VALUE_INTEGER_PARAM_TYPE SYSRES_CONST_CHECK_PARAM_VALUE_PICK_PARAM_TYPE SYSRES_CONST_CHECK_PARAM_VALUE_REEFRENCE_PARAM_TYPE SYSRES_CONST_CLOSED_RECORD_FLAG_VALUE_FEMININE SYSRES_CONST_CLOSED_RECORD_FLAG_VALUE_MASCULINE SYSRES_CONST_CODE_COMPONENT_TYPE_ADMIN SYSRES_CONST_CODE_COMPONENT_TYPE_DEVELOPER SYSRES_CONST_CODE_COMPONENT_TYPE_DOCS SYSRES_CONST_CODE_COMPONENT_TYPE_EDOC_CARDS SYSRES_CONST_CODE_COMPONENT_TYPE_EXTERNAL_EXECUTABLE SYSRES_CONST_CODE_COMPONENT_TYPE_OTHER SYSRES_CONST_CODE_COMPONENT_TYPE_REFERENCE SYSRES_CONST_CODE_COMPONENT_TYPE_REPORT SYSRES_CONST_CODE_COMPONENT_TYPE_SCRIPT SYSRES_CONST_CODE_COMPONENT_TYPE_URL SYSRES_CONST_CODE_REQUISITE_ACCESS SYSRES_CONST_CODE_REQUISITE_CODE SYSRES_CONST_CODE_REQUISITE_COMPONENT SYSRES_CONST_CODE_REQUISITE_DESCRIPTION SYSRES_CONST_CODE_REQUISITE_EXCLUDE_COMPONENT SYSRES_CONST_CODE_REQUISITE_RECORD SYSRES_CONST_COMMENT_REQ_CODE SYSRES_CONST_COMMON_SETTINGS_REQUISITE_CODE SYSRES_CONST_COMP_CODE_GRD SYSRES_CONST_COMPONENT_GROUP_TYPE_REQUISITE_CODE SYSRES_CONST_COMPONENT_TYPE_ADMIN_COMPONENTS SYSRES_CONST_COMPONENT_TYPE_DEVELOPER_COMPONENTS SYSRES_CONST_COMPONENT_TYPE_DOCS SYSRES_CONST_COMPONENT_TYPE_EDOC_CARDS SYSRES_CONST_COMPONENT_TYPE_EDOCS SYSRES_CONST_COMPONENT_TYPE_EXTERNAL_EXECUTABLE SYSRES_CONST_COMPONENT_TYPE_OTHER SYSRES_CONST_COMPONENT_TYPE_REFERENCE_TYPES SYSRES_CONST_COMPONENT_TYPE_REFERENCES SYSRES_CONST_COMPONENT_TYPE_REPORTS SYSRES_CONST_COMPONENT_TYPE_SCRIPTS SYSRES_CONST_COMPONENT_TYPE_URL SYSRES_CONST_COMPONENTS_REMOTE_SERVERS_VIEW_CODE SYSRES_CONST_CONDITION_BLOCK_DESCRIPTION SYSRES_CONST_CONST_FIRM_STATUS_COMMON SYSRES_CONST_CONST_FIRM_STATUS_INDIVIDUAL SYSRES_CONST_CONST_NEGATIVE_VALUE SYSRES_CONST_CONST_POSITIVE_VALUE SYSRES_CONST_CONST_SERVER_STATUS_DONT_REPLICATE SYSRES_CONST_CONST_SERVER_STATUS_REPLICATE SYSRES_CONST_CONTENTS_REQUISITE_CODE SYSRES_CONST_DATA_TYPE_BOOLEAN SYSRES_CONST_DATA_TYPE_DATE SYSRES_CONST_DATA_TYPE_FLOAT SYSRES_CONST_DATA_TYPE_INTEGER SYSRES_CONST_DATA_TYPE_PICK SYSRES_CONST_DATA_TYPE_REFERENCE SYSRES_CONST_DATA_TYPE_STRING SYSRES_CONST_DATA_TYPE_TEXT SYSRES_CONST_DATA_TYPE_VARIANT SYSRES_CONST_DATE_CLOSE_REQ_CODE SYSRES_CONST_DATE_FORMAT_DATE_ONLY_CHAR SYSRES_CONST_DATE_OPEN_REQ_CODE SYSRES_CONST_DATE_REQUISITE SYSRES_CONST_DATE_REQUISITE_CODE SYSRES_CONST_DATE_REQUISITE_NAME SYSRES_CONST_DATE_REQUISITE_TYPE SYSRES_CONST_DATE_TYPE_CHAR SYSRES_CONST_DATETIME_FORMAT_VALUE SYSRES_CONST_DEA_ACCESS_RIGHTS_ACTION_CODE SYSRES_CONST_DESCRIPTION_LOCALIZE_ID_REQUISITE_CODE SYSRES_CONST_DESCRIPTION_REQUISITE_CODE SYSRES_CONST_DET1_PART SYSRES_CONST_DET2_PART SYSRES_CONST_DET3_PART SYSRES_CONST_DET4_PART SYSRES_CONST_DET5_PART SYSRES_CONST_DET6_PART SYSRES_CONST_DETAIL_DATASET_KEY_REQUISITE_CODE SYSRES_CONST_DETAIL_PICK_REQUISITE_CODE SYSRES_CONST_DETAIL_REQ_CODE SYSRES_CONST_DO_NOT_USE_ACCESS_TYPE_CODE SYSRES_CONST_DO_NOT_USE_ACCESS_TYPE_NAME SYSRES_CONST_DO_NOT_USE_ON_VIEW_ACCESS_TYPE_CODE SYSRES_CONST_DO_NOT_USE_ON_VIEW_ACCESS_TYPE_NAME SYSRES_CONST_DOCUMENT_STORAGES_CODE SYSRES_CONST_DOCUMENT_TEMPLATES_TYPE_NAME SYSRES_CONST_DOUBLE_REQUISITE_CODE SYSRES_CONST_EDITOR_CLOSE_FILE_OBSERV_TYPE_CODE SYSRES_CONST_EDITOR_CLOSE_PROCESS_OBSERV_TYPE_CODE SYSRES_CONST_EDITOR_TYPE_REQUISITE_CODE SYSRES_CONST_EDITORS_APPLICATION_NAME_REQUISITE_CODE SYSRES_CONST_EDITORS_CREATE_SEVERAL_PROCESSES_REQUISITE_CODE SYSRES_CONST_EDITORS_EXTENSION_REQUISITE_CODE SYSRES_CONST_EDITORS_OBSERVER_BY_PROCESS_TYPE SYSRES_CONST_EDITORS_REFERENCE_CODE SYSRES_CONST_EDITORS_REPLACE_SPEC_CHARS_REQUISITE_CODE SYSRES_CONST_EDITORS_USE_PLUGINS_REQUISITE_CODE SYSRES_CONST_EDITORS_VIEW_DOCUMENT_OPENED_TO_EDIT_CODE SYSRES_CONST_EDOC_CARD_TYPE_REQUISITE_CODE SYSRES_CONST_EDOC_CARD_TYPES_LINK_REQUISITE_CODE SYSRES_CONST_EDOC_CERTIFICATE_AND_PASSWORD_ENCODE_CODE SYSRES_CONST_EDOC_CERTIFICATE_ENCODE_CODE SYSRES_CONST_EDOC_DATE_REQUISITE_CODE SYSRES_CONST_EDOC_KIND_REFERENCE_CODE SYSRES_CONST_EDOC_KINDS_BY_TEMPLATE_ACTION_CODE SYSRES_CONST_EDOC_MANAGE_ACCESS_CODE SYSRES_CONST_EDOC_NONE_ENCODE_CODE SYSRES_CONST_EDOC_NUMBER_REQUISITE_CODE SYSRES_CONST_EDOC_PASSWORD_ENCODE_CODE SYSRES_CONST_EDOC_READONLY_ACCESS_CODE SYSRES_CONST_EDOC_SHELL_LIFE_TYPE_VIEW_VALUE SYSRES_CONST_EDOC_SIZE_RESTRICTION_PRIORITY_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_CHECK_ACCESS_RIGHTS_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_COMPUTER_NAME_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_DATABASE_NAME_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_EDIT_IN_STORAGE_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_LOCAL_PATH_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_SHARED_SOURCE_NAME_REQUISITE_CODE SYSRES_CONST_EDOC_TEMPLATE_REQUISITE_CODE SYSRES_CONST_EDOC_TYPES_REFERENCE_CODE SYSRES_CONST_EDOC_VERSION_ACTIVE_STAGE_CODE SYSRES_CONST_EDOC_VERSION_DESIGN_STAGE_CODE SYSRES_CONST_EDOC_VERSION_OBSOLETE_STAGE_CODE SYSRES_CONST_EDOC_WRITE_ACCES_CODE SYSRES_CONST_EDOCUMENT_CARD_REQUISITES_REFERENCE_CODE_SELECTED_REQUISITE SYSRES_CONST_ENCODE_CERTIFICATE_TYPE_CODE SYSRES_CONST_END_DATE_REQUISITE_CODE SYSRES_CONST_ENUMERATION_TYPE_REQUISITE_CODE SYSRES_CONST_EXECUTE_ACCESS_RIGHTS_TYPE_CODE SYSRES_CONST_EXECUTIVE_FILE_STORAGE_TYPE SYSRES_CONST_EXIST_CONST SYSRES_CONST_EXIST_VALUE SYSRES_CONST_EXPORT_LOCK_TYPE_ASK SYSRES_CONST_EXPORT_LOCK_TYPE_WITH_LOCK SYSRES_CONST_EXPORT_LOCK_TYPE_WITHOUT_LOCK SYSRES_CONST_EXPORT_VERSION_TYPE_ASK SYSRES_CONST_EXPORT_VERSION_TYPE_LAST SYSRES_CONST_EXPORT_VERSION_TYPE_LAST_ACTIVE SYSRES_CONST_EXTENSION_REQUISITE_CODE SYSRES_CONST_FILTER_NAME_REQUISITE_CODE SYSRES_CONST_FILTER_REQUISITE_CODE SYSRES_CONST_FILTER_TYPE_COMMON_CODE SYSRES_CONST_FILTER_TYPE_COMMON_NAME SYSRES_CONST_FILTER_TYPE_USER_CODE SYSRES_CONST_FILTER_TYPE_USER_NAME SYSRES_CONST_FILTER_VALUE_REQUISITE_NAME SYSRES_CONST_FLOAT_NUMBER_FORMAT_CHAR SYSRES_CONST_FLOAT_REQUISITE_TYPE SYSRES_CONST_FOLDER_AUTHOR_VALUE SYSRES_CONST_FOLDER_KIND_ANY_OBJECTS SYSRES_CONST_FOLDER_KIND_COMPONENTS SYSRES_CONST_FOLDER_KIND_EDOCS SYSRES_CONST_FOLDER_KIND_JOBS SYSRES_CONST_FOLDER_KIND_TASKS SYSRES_CONST_FOLDER_TYPE_COMMON SYSRES_CONST_FOLDER_TYPE_COMPONENT SYSRES_CONST_FOLDER_TYPE_FAVORITES SYSRES_CONST_FOLDER_TYPE_INBOX SYSRES_CONST_FOLDER_TYPE_OUTBOX SYSRES_CONST_FOLDER_TYPE_QUICK_LAUNCH SYSRES_CONST_FOLDER_TYPE_SEARCH SYSRES_CONST_FOLDER_TYPE_SHORTCUTS SYSRES_CONST_FOLDER_TYPE_USER SYSRES_CONST_FROM_DICTIONARY_ENUM_METHOD_FLAG SYSRES_CONST_FULL_SUBSTITUTE_TYPE SYSRES_CONST_FULL_SUBSTITUTE_TYPE_CODE SYSRES_CONST_FUNCTION_CANCEL_RESULT SYSRES_CONST_FUNCTION_CATEGORY_SYSTEM SYSRES_CONST_FUNCTION_CATEGORY_USER SYSRES_CONST_FUNCTION_FAILURE_RESULT SYSRES_CONST_FUNCTION_SAVE_RESULT SYSRES_CONST_GENERATED_REQUISITE SYSRES_CONST_GREEN_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_GROUP_ACCOUNT_TYPE_VALUE_CODE SYSRES_CONST_GROUP_CATEGORY_NORMAL_CODE SYSRES_CONST_GROUP_CATEGORY_NORMAL_NAME SYSRES_CONST_GROUP_CATEGORY_SERVICE_CODE SYSRES_CONST_GROUP_CATEGORY_SERVICE_NAME SYSRES_CONST_GROUP_COMMON_CATEGORY_FIELD_VALUE SYSRES_CONST_GROUP_FULL_NAME_REQUISITE_CODE SYSRES_CONST_GROUP_NAME_REQUISITE_CODE SYSRES_CONST_GROUP_RIGHTS_T_REQUISITE_CODE SYSRES_CONST_GROUP_SERVER_CODES_REQUISITE_CODE SYSRES_CONST_GROUP_SERVER_NAME_REQUISITE_CODE SYSRES_CONST_GROUP_SERVICE_CATEGORY_FIELD_VALUE SYSRES_CONST_GROUP_USER_REQUISITE_CODE SYSRES_CONST_GROUPS_REFERENCE_CODE SYSRES_CONST_GROUPS_REQUISITE_CODE SYSRES_CONST_HIDDEN_MODE_NAME SYSRES_CONST_HIGH_LVL_REQUISITE_CODE SYSRES_CONST_HISTORY_ACTION_CREATE_CODE SYSRES_CONST_HISTORY_ACTION_DELETE_CODE SYSRES_CONST_HISTORY_ACTION_EDIT_CODE SYSRES_CONST_HOUR_CHAR SYSRES_CONST_ID_REQUISITE_CODE SYSRES_CONST_IDSPS_REQUISITE_CODE SYSRES_CONST_IMAGE_MODE_COLOR SYSRES_CONST_IMAGE_MODE_GREYSCALE SYSRES_CONST_IMAGE_MODE_MONOCHROME SYSRES_CONST_IMPORTANCE_HIGH SYSRES_CONST_IMPORTANCE_LOW SYSRES_CONST_IMPORTANCE_NORMAL SYSRES_CONST_IN_DESIGN_VERSION_STATE_PICK_VALUE SYSRES_CONST_INCOMING_WORK_RULE_TYPE_CODE SYSRES_CONST_INT_REQUISITE SYSRES_CONST_INT_REQUISITE_TYPE SYSRES_CONST_INTEGER_NUMBER_FORMAT_CHAR SYSRES_CONST_INTEGER_TYPE_CHAR SYSRES_CONST_IS_GENERATED_REQUISITE_NEGATIVE_VALUE SYSRES_CONST_IS_PUBLIC_ROLE_REQUISITE_CODE SYSRES_CONST_IS_REMOTE_USER_NEGATIVE_VALUE SYSRES_CONST_IS_REMOTE_USER_POSITIVE_VALUE SYSRES_CONST_IS_STORED_REQUISITE_NEGATIVE_VALUE SYSRES_CONST_IS_STORED_REQUISITE_STORED_VALUE SYSRES_CONST_ITALIC_LIFE_CYCLE_STAGE_DRAW_STYLE SYSRES_CONST_JOB_BLOCK_DESCRIPTION SYSRES_CONST_JOB_KIND_CONTROL_JOB SYSRES_CONST_JOB_KIND_JOB SYSRES_CONST_JOB_KIND_NOTICE SYSRES_CONST_JOB_STATE_ABORTED SYSRES_CONST_JOB_STATE_COMPLETE SYSRES_CONST_JOB_STATE_WORKING SYSRES_CONST_KIND_REQUISITE_CODE SYSRES_CONST_KIND_REQUISITE_NAME SYSRES_CONST_KINDS_CREATE_SHADOW_COPIES_REQUISITE_CODE SYSRES_CONST_KINDS_DEFAULT_EDOC_LIFE_STAGE_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_ALL_TEPLATES_ALLOWED_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_ALLOW_LIFE_CYCLE_STAGE_CHANGING_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_ALLOW_MULTIPLE_ACTIVE_VERSIONS_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_SHARE_ACCES_RIGHTS_BY_DEFAULT_CODE SYSRES_CONST_KINDS_EDOC_TEMPLATE_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_TYPE_REQUISITE_CODE SYSRES_CONST_KINDS_SIGNERS_REQUISITES_CODE SYSRES_CONST_KOD_INPUT_TYPE SYSRES_CONST_LAST_UPDATE_DATE_REQUISITE_CODE SYSRES_CONST_LIFE_CYCLE_START_STAGE_REQUISITE_CODE SYSRES_CONST_LILAC_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_LINK_OBJECT_KIND_COMPONENT SYSRES_CONST_LINK_OBJECT_KIND_DOCUMENT SYSRES_CONST_LINK_OBJECT_KIND_EDOC SYSRES_CONST_LINK_OBJECT_KIND_FOLDER SYSRES_CONST_LINK_OBJECT_KIND_JOB SYSRES_CONST_LINK_OBJECT_KIND_REFERENCE SYSRES_CONST_LINK_OBJECT_KIND_TASK SYSRES_CONST_LINK_REF_TYPE_REQUISITE_CODE SYSRES_CONST_LIST_REFERENCE_MODE_NAME SYSRES_CONST_LOCALIZATION_DICTIONARY_MAIN_VIEW_CODE SYSRES_CONST_MAIN_VIEW_CODE SYSRES_CONST_MANUAL_ENUM_METHOD_FLAG SYSRES_CONST_MASTER_COMP_TYPE_REQUISITE_CODE SYSRES_CONST_MASTER_TABLE_REC_ID_REQUISITE_CODE SYSRES_CONST_MAXIMIZED_MODE_NAME SYSRES_CONST_ME_VALUE SYSRES_CONST_MESSAGE_ATTENTION_CAPTION SYSRES_CONST_MESSAGE_CONFIRMATION_CAPTION SYSRES_CONST_MESSAGE_ERROR_CAPTION SYSRES_CONST_MESSAGE_INFORMATION_CAPTION SYSRES_CONST_MINIMIZED_MODE_NAME SYSRES_CONST_MINUTE_CHAR SYSRES_CONST_MODULE_REQUISITE_CODE SYSRES_CONST_MONITORING_BLOCK_DESCRIPTION SYSRES_CONST_MONTH_FORMAT_VALUE SYSRES_CONST_NAME_LOCALIZE_ID_REQUISITE_CODE SYSRES_CONST_NAME_REQUISITE_CODE SYSRES_CONST_NAME_SINGULAR_REQUISITE_CODE SYSRES_CONST_NAMEAN_INPUT_TYPE SYSRES_CONST_NEGATIVE_PICK_VALUE SYSRES_CONST_NEGATIVE_VALUE SYSRES_CONST_NO SYSRES_CONST_NO_PICK_VALUE SYSRES_CONST_NO_SIGNATURE_REQUISITE_CODE SYSRES_CONST_NO_VALUE SYSRES_CONST_NONE_ACCESS_RIGHTS_TYPE_CODE SYSRES_CONST_NONOPERATING_RECORD_FLAG_VALUE SYSRES_CONST_NONOPERATING_RECORD_FLAG_VALUE_MASCULINE SYSRES_CONST_NORMAL_ACCESS_RIGHTS_TYPE_CODE SYSRES_CONST_NORMAL_LIFE_CYCLE_STAGE_DRAW_STYLE SYSRES_CONST_NORMAL_MODE_NAME SYSRES_CONST_NOT_ALLOWED_ACCESS_TYPE_CODE SYSRES_CONST_NOT_ALLOWED_ACCESS_TYPE_NAME SYSRES_CONST_NOTE_REQUISITE_CODE SYSRES_CONST_NOTICE_BLOCK_DESCRIPTION SYSRES_CONST_NUM_REQUISITE SYSRES_CONST_NUM_STR_REQUISITE_CODE SYSRES_CONST_NUMERATION_AUTO_NOT_STRONG SYSRES_CONST_NUMERATION_AUTO_STRONG SYSRES_CONST_NUMERATION_FROM_DICTONARY SYSRES_CONST_NUMERATION_MANUAL SYSRES_CONST_NUMERIC_TYPE_CHAR SYSRES_CONST_NUMREQ_REQUISITE_CODE SYSRES_CONST_OBSOLETE_VERSION_STATE_PICK_VALUE SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE_CODE SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE_FEMININE SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE_MASCULINE SYSRES_CONST_OPTIONAL_FORM_COMP_REQCODE_PREFIX SYSRES_CONST_ORANGE_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_ORIGINALREF_REQUISITE_CODE SYSRES_CONST_OURFIRM_REF_CODE SYSRES_CONST_OURFIRM_REQUISITE_CODE SYSRES_CONST_OURFIRM_VAR SYSRES_CONST_OUTGOING_WORK_RULE_TYPE_CODE SYSRES_CONST_PICK_NEGATIVE_RESULT SYSRES_CONST_PICK_POSITIVE_RESULT SYSRES_CONST_PICK_REQUISITE SYSRES_CONST_PICK_REQUISITE_TYPE SYSRES_CONST_PICK_TYPE_CHAR SYSRES_CONST_PLAN_STATUS_REQUISITE_CODE SYSRES_CONST_PLATFORM_VERSION_COMMENT SYSRES_CONST_PLUGINS_SETTINGS_DESCRIPTION_REQUISITE_CODE SYSRES_CONST_POSITIVE_PICK_VALUE SYSRES_CONST_POWER_TO_CREATE_ACTION_CODE SYSRES_CONST_POWER_TO_SIGN_ACTION_CODE SYSRES_CONST_PRIORITY_REQUISITE_CODE SYSRES_CONST_QUALIFIED_TASK_TYPE SYSRES_CONST_QUALIFIED_TASK_TYPE_CODE SYSRES_CONST_RECSTAT_REQUISITE_CODE SYSRES_CONST_RED_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_REF_ID_T_REF_TYPE_REQUISITE_CODE SYSRES_CONST_REF_REQUISITE SYSRES_CONST_REF_REQUISITE_TYPE SYSRES_CONST_REF_REQUISITES_REFERENCE_CODE_SELECTED_REQUISITE SYSRES_CONST_REFERENCE_RECORD_HISTORY_CREATE_ACTION_CODE SYSRES_CONST_REFERENCE_RECORD_HISTORY_DELETE_ACTION_CODE SYSRES_CONST_REFERENCE_RECORD_HISTORY_MODIFY_ACTION_CODE SYSRES_CONST_REFERENCE_TYPE_CHAR SYSRES_CONST_REFERENCE_TYPE_REQUISITE_NAME SYSRES_CONST_REFERENCES_ADD_PARAMS_REQUISITE_CODE SYSRES_CONST_REFERENCES_DISPLAY_REQUISITE_REQUISITE_CODE SYSRES_CONST_REMOTE_SERVER_STATUS_WORKING SYSRES_CONST_REMOTE_SERVER_TYPE_MAIN SYSRES_CONST_REMOTE_SERVER_TYPE_SECONDARY SYSRES_CONST_REMOTE_USER_FLAG_VALUE_CODE SYSRES_CONST_REPORT_APP_EDITOR_INTERNAL SYSRES_CONST_REPORT_BASE_REPORT_ID_REQUISITE_CODE SYSRES_CONST_REPORT_BASE_REPORT_REQUISITE_CODE SYSRES_CONST_REPORT_SCRIPT_REQUISITE_CODE SYSRES_CONST_REPORT_TEMPLATE_REQUISITE_CODE SYSRES_CONST_REPORT_VIEWER_CODE_REQUISITE_CODE SYSRES_CONST_REQ_ALLOW_COMPONENT_DEFAULT_VALUE SYSRES_CONST_REQ_ALLOW_RECORD_DEFAULT_VALUE SYSRES_CONST_REQ_ALLOW_SERVER_COMPONENT_DEFAULT_VALUE SYSRES_CONST_REQ_MODE_AVAILABLE_CODE SYSRES_CONST_REQ_MODE_EDIT_CODE SYSRES_CONST_REQ_MODE_HIDDEN_CODE SYSRES_CONST_REQ_MODE_NOT_AVAILABLE_CODE SYSRES_CONST_REQ_MODE_VIEW_CODE SYSRES_CONST_REQ_NUMBER_REQUISITE_CODE SYSRES_CONST_REQ_SECTION_VALUE SYSRES_CONST_REQ_TYPE_VALUE SYSRES_CONST_REQUISITE_FORMAT_BY_UNIT SYSRES_CONST_REQUISITE_FORMAT_DATE_FULL SYSRES_CONST_REQUISITE_FORMAT_DATE_TIME SYSRES_CONST_REQUISITE_FORMAT_LEFT SYSRES_CONST_REQUISITE_FORMAT_RIGHT SYSRES_CONST_REQUISITE_FORMAT_WITHOUT_UNIT SYSRES_CONST_REQUISITE_NUMBER_REQUISITE_CODE SYSRES_CONST_REQUISITE_SECTION_ACTIONS SYSRES_CONST_REQUISITE_SECTION_BUTTON SYSRES_CONST_REQUISITE_SECTION_BUTTONS SYSRES_CONST_REQUISITE_SECTION_CARD SYSRES_CONST_REQUISITE_SECTION_TABLE SYSRES_CONST_REQUISITE_SECTION_TABLE10 SYSRES_CONST_REQUISITE_SECTION_TABLE11 SYSRES_CONST_REQUISITE_SECTION_TABLE12 SYSRES_CONST_REQUISITE_SECTION_TABLE13 SYSRES_CONST_REQUISITE_SECTION_TABLE14 SYSRES_CONST_REQUISITE_SECTION_TABLE15 SYSRES_CONST_REQUISITE_SECTION_TABLE16 SYSRES_CONST_REQUISITE_SECTION_TABLE17 SYSRES_CONST_REQUISITE_SECTION_TABLE18 SYSRES_CONST_REQUISITE_SECTION_TABLE19 SYSRES_CONST_REQUISITE_SECTION_TABLE2 SYSRES_CONST_REQUISITE_SECTION_TABLE20 SYSRES_CONST_REQUISITE_SECTION_TABLE21 SYSRES_CONST_REQUISITE_SECTION_TABLE22 SYSRES_CONST_REQUISITE_SECTION_TABLE23 SYSRES_CONST_REQUISITE_SECTION_TABLE24 SYSRES_CONST_REQUISITE_SECTION_TABLE3 SYSRES_CONST_REQUISITE_SECTION_TABLE4 SYSRES_CONST_REQUISITE_SECTION_TABLE5 SYSRES_CONST_REQUISITE_SECTION_TABLE6 SYSRES_CONST_REQUISITE_SECTION_TABLE7 SYSRES_CONST_REQUISITE_SECTION_TABLE8 SYSRES_CONST_REQUISITE_SECTION_TABLE9 SYSRES_CONST_REQUISITES_PSEUDOREFERENCE_REQUISITE_NUMBER_REQUISITE_CODE SYSRES_CONST_RIGHT_ALIGNMENT_CODE SYSRES_CONST_ROLES_REFERENCE_CODE SYSRES_CONST_ROUTE_STEP_AFTER_RUS SYSRES_CONST_ROUTE_STEP_AND_CONDITION_RUS SYSRES_CONST_ROUTE_STEP_OR_CONDITION_RUS SYSRES_CONST_ROUTE_TYPE_COMPLEX SYSRES_CONST_ROUTE_TYPE_PARALLEL SYSRES_CONST_ROUTE_TYPE_SERIAL SYSRES_CONST_SBDATASETDESC_NEGATIVE_VALUE SYSRES_CONST_SBDATASETDESC_POSITIVE_VALUE SYSRES_CONST_SBVIEWSDESC_POSITIVE_VALUE SYSRES_CONST_SCRIPT_BLOCK_DESCRIPTION SYSRES_CONST_SEARCH_BY_TEXT_REQUISITE_CODE SYSRES_CONST_SEARCHES_COMPONENT_CONTENT SYSRES_CONST_SEARCHES_CRITERIA_ACTION_NAME SYSRES_CONST_SEARCHES_EDOC_CONTENT SYSRES_CONST_SEARCHES_FOLDER_CONTENT SYSRES_CONST_SEARCHES_JOB_CONTENT SYSRES_CONST_SEARCHES_REFERENCE_CODE SYSRES_CONST_SEARCHES_TASK_CONTENT SYSRES_CONST_SECOND_CHAR SYSRES_CONST_SECTION_REQUISITE_ACTIONS_VALUE SYSRES_CONST_SECTION_REQUISITE_CARD_VALUE SYSRES_CONST_SECTION_REQUISITE_CODE SYSRES_CONST_SECTION_REQUISITE_DETAIL_1_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_2_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_3_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_4_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_5_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_6_VALUE SYSRES_CONST_SELECT_REFERENCE_MODE_NAME SYSRES_CONST_SELECT_TYPE_SELECTABLE SYSRES_CONST_SELECT_TYPE_SELECTABLE_ONLY_CHILD SYSRES_CONST_SELECT_TYPE_SELECTABLE_WITH_CHILD SYSRES_CONST_SELECT_TYPE_UNSLECTABLE SYSRES_CONST_SERVER_TYPE_MAIN SYSRES_CONST_SERVICE_USER_CATEGORY_FIELD_VALUE SYSRES_CONST_SETTINGS_USER_REQUISITE_CODE SYSRES_CONST_SIGNATURE_AND_ENCODE_CERTIFICATE_TYPE_CODE SYSRES_CONST_SIGNATURE_CERTIFICATE_TYPE_CODE SYSRES_CONST_SINGULAR_TITLE_REQUISITE_CODE SYSRES_CONST_SQL_SERVER_AUTHENTIFICATION_FLAG_VALUE_CODE SYSRES_CONST_SQL_SERVER_ENCODE_AUTHENTIFICATION_FLAG_VALUE_CODE SYSRES_CONST_STANDART_ROUTE_REFERENCE_CODE SYSRES_CONST_STANDART_ROUTE_REFERENCE_COMMENT_REQUISITE_CODE SYSRES_CONST_STANDART_ROUTES_GROUPS_REFERENCE_CODE SYSRES_CONST_STATE_REQ_NAME SYSRES_CONST_STATE_REQUISITE_ACTIVE_VALUE SYSRES_CONST_STATE_REQUISITE_CLOSED_VALUE SYSRES_CONST_STATE_REQUISITE_CODE SYSRES_CONST_STATIC_ROLE_TYPE_CODE SYSRES_CONST_STATUS_PLAN_DEFAULT_VALUE SYSRES_CONST_STATUS_VALUE_AUTOCLEANING SYSRES_CONST_STATUS_VALUE_BLUE_SQUARE SYSRES_CONST_STATUS_VALUE_COMPLETE SYSRES_CONST_STATUS_VALUE_GREEN_SQUARE SYSRES_CONST_STATUS_VALUE_ORANGE_SQUARE SYSRES_CONST_STATUS_VALUE_PURPLE_SQUARE SYSRES_CONST_STATUS_VALUE_RED_SQUARE SYSRES_CONST_STATUS_VALUE_SUSPEND SYSRES_CONST_STATUS_VALUE_YELLOW_SQUARE SYSRES_CONST_STDROUTE_SHOW_TO_USERS_REQUISITE_CODE SYSRES_CONST_STORAGE_TYPE_FILE SYSRES_CONST_STORAGE_TYPE_SQL_SERVER SYSRES_CONST_STR_REQUISITE SYSRES_CONST_STRIKEOUT_LIFE_CYCLE_STAGE_DRAW_STYLE SYSRES_CONST_STRING_FORMAT_LEFT_ALIGN_CHAR SYSRES_CONST_STRING_FORMAT_RIGHT_ALIGN_CHAR SYSRES_CONST_STRING_REQUISITE_CODE SYSRES_CONST_STRING_REQUISITE_TYPE SYSRES_CONST_STRING_TYPE_CHAR SYSRES_CONST_SUBSTITUTES_PSEUDOREFERENCE_CODE SYSRES_CONST_SUBTASK_BLOCK_DESCRIPTION SYSRES_CONST_SYSTEM_SETTING_CURRENT_USER_PARAM_VALUE SYSRES_CONST_SYSTEM_SETTING_EMPTY_VALUE_PARAM_VALUE SYSRES_CONST_SYSTEM_VERSION_COMMENT SYSRES_CONST_TASK_ACCESS_TYPE_ALL SYSRES_CONST_TASK_ACCESS_TYPE_ALL_MEMBERS SYSRES_CONST_TASK_ACCESS_TYPE_MANUAL SYSRES_CONST_TASK_ENCODE_TYPE_CERTIFICATION SYSRES_CONST_TASK_ENCODE_TYPE_CERTIFICATION_AND_PASSWORD SYSRES_CONST_TASK_ENCODE_TYPE_NONE SYSRES_CONST_TASK_ENCODE_TYPE_PASSWORD SYSRES_CONST_TASK_ROUTE_ALL_CONDITION SYSRES_CONST_TASK_ROUTE_AND_CONDITION SYSRES_CONST_TASK_ROUTE_OR_CONDITION SYSRES_CONST_TASK_STATE_ABORTED SYSRES_CONST_TASK_STATE_COMPLETE SYSRES_CONST_TASK_STATE_CONTINUED SYSRES_CONST_TASK_STATE_CONTROL SYSRES_CONST_TASK_STATE_INIT SYSRES_CONST_TASK_STATE_WORKING SYSRES_CONST_TASK_TITLE SYSRES_CONST_TASK_TYPES_GROUPS_REFERENCE_CODE SYSRES_CONST_TASK_TYPES_REFERENCE_CODE SYSRES_CONST_TEMPLATES_REFERENCE_CODE SYSRES_CONST_TEST_DATE_REQUISITE_NAME SYSRES_CONST_TEST_DEV_DATABASE_NAME SYSRES_CONST_TEST_DEV_SYSTEM_CODE SYSRES_CONST_TEST_EDMS_DATABASE_NAME SYSRES_CONST_TEST_EDMS_MAIN_CODE SYSRES_CONST_TEST_EDMS_MAIN_DB_NAME SYSRES_CONST_TEST_EDMS_SECOND_CODE SYSRES_CONST_TEST_EDMS_SECOND_DB_NAME SYSRES_CONST_TEST_EDMS_SYSTEM_CODE SYSRES_CONST_TEST_NUMERIC_REQUISITE_NAME SYSRES_CONST_TEXT_REQUISITE SYSRES_CONST_TEXT_REQUISITE_CODE SYSRES_CONST_TEXT_REQUISITE_TYPE SYSRES_CONST_TEXT_TYPE_CHAR SYSRES_CONST_TYPE_CODE_REQUISITE_CODE SYSRES_CONST_TYPE_REQUISITE_CODE SYSRES_CONST_UNDEFINED_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_UNITS_SECTION_ID_REQUISITE_CODE SYSRES_CONST_UNITS_SECTION_REQUISITE_CODE SYSRES_CONST_UNOPERATING_RECORD_FLAG_VALUE_CODE SYSRES_CONST_UNSTORED_DATA_REQUISITE_CODE SYSRES_CONST_UNSTORED_DATA_REQUISITE_NAME SYSRES_CONST_USE_ACCESS_TYPE_CODE SYSRES_CONST_USE_ACCESS_TYPE_NAME SYSRES_CONST_USER_ACCOUNT_TYPE_VALUE_CODE SYSRES_CONST_USER_ADDITIONAL_INFORMATION_REQUISITE_CODE SYSRES_CONST_USER_AND_GROUP_ID_FROM_PSEUDOREFERENCE_REQUISITE_CODE SYSRES_CONST_USER_CATEGORY_NORMAL SYSRES_CONST_USER_CERTIFICATE_REQUISITE_CODE SYSRES_CONST_USER_CERTIFICATE_STATE_REQUISITE_CODE SYSRES_CONST_USER_CERTIFICATE_SUBJECT_NAME_REQUISITE_CODE SYSRES_CONST_USER_CERTIFICATE_THUMBPRINT_REQUISITE_CODE SYSRES_CONST_USER_COMMON_CATEGORY SYSRES_CONST_USER_COMMON_CATEGORY_CODE SYSRES_CONST_USER_FULL_NAME_REQUISITE_CODE SYSRES_CONST_USER_GROUP_TYPE_REQUISITE_CODE SYSRES_CONST_USER_LOGIN_REQUISITE_CODE SYSRES_CONST_USER_REMOTE_CONTROLLER_REQUISITE_CODE SYSRES_CONST_USER_REMOTE_SYSTEM_REQUISITE_CODE SYSRES_CONST_USER_RIGHTS_T_REQUISITE_CODE SYSRES_CONST_USER_SERVER_NAME_REQUISITE_CODE SYSRES_CONST_USER_SERVICE_CATEGORY SYSRES_CONST_USER_SERVICE_CATEGORY_CODE SYSRES_CONST_USER_STATUS_ADMINISTRATOR_CODE SYSRES_CONST_USER_STATUS_ADMINISTRATOR_NAME SYSRES_CONST_USER_STATUS_DEVELOPER_CODE SYSRES_CONST_USER_STATUS_DEVELOPER_NAME SYSRES_CONST_USER_STATUS_DISABLED_CODE SYSRES_CONST_USER_STATUS_DISABLED_NAME SYSRES_CONST_USER_STATUS_SYSTEM_DEVELOPER_CODE SYSRES_CONST_USER_STATUS_USER_CODE SYSRES_CONST_USER_STATUS_USER_NAME SYSRES_CONST_USER_STATUS_USER_NAME_DEPRECATED SYSRES_CONST_USER_TYPE_FIELD_VALUE_USER SYSRES_CONST_USER_TYPE_REQUISITE_CODE SYSRES_CONST_USERS_CONTROLLER_REQUISITE_CODE SYSRES_CONST_USERS_IS_MAIN_SERVER_REQUISITE_CODE SYSRES_CONST_USERS_REFERENCE_CODE SYSRES_CONST_USERS_REGISTRATION_CERTIFICATES_ACTION_NAME SYSRES_CONST_USERS_REQUISITE_CODE SYSRES_CONST_USERS_SYSTEM_REQUISITE_CODE SYSRES_CONST_USERS_USER_ACCESS_RIGHTS_TYPR_REQUISITE_CODE SYSRES_CONST_USERS_USER_AUTHENTICATION_REQUISITE_CODE SYSRES_CONST_USERS_USER_COMPONENT_REQUISITE_CODE SYSRES_CONST_USERS_USER_GROUP_REQUISITE_CODE SYSRES_CONST_USERS_VIEW_CERTIFICATES_ACTION_NAME SYSRES_CONST_VIEW_DEFAULT_CODE SYSRES_CONST_VIEW_DEFAULT_NAME SYSRES_CONST_VIEWER_REQUISITE_CODE SYSRES_CONST_WAITING_BLOCK_DESCRIPTION SYSRES_CONST_WIZARD_FORM_LABEL_TEST_STRING  SYSRES_CONST_WIZARD_QUERY_PARAM_HEIGHT_ETALON_STRING SYSRES_CONST_WIZARD_REFERENCE_COMMENT_REQUISITE_CODE SYSRES_CONST_WORK_RULES_DESCRIPTION_REQUISITE_CODE SYSRES_CONST_WORK_TIME_CALENDAR_REFERENCE_CODE SYSRES_CONST_WORK_WORKFLOW_HARD_ROUTE_TYPE_VALUE SYSRES_CONST_WORK_WORKFLOW_HARD_ROUTE_TYPE_VALUE_CODE SYSRES_CONST_WORK_WORKFLOW_HARD_ROUTE_TYPE_VALUE_CODE_RUS SYSRES_CONST_WORK_WORKFLOW_SOFT_ROUTE_TYPE_VALUE_CODE_RUS SYSRES_CONST_WORKFLOW_ROUTE_TYPR_HARD SYSRES_CONST_WORKFLOW_ROUTE_TYPR_SOFT SYSRES_CONST_XML_ENCODING SYSRES_CONST_XREC_STAT_REQUISITE_CODE SYSRES_CONST_XRECID_FIELD_NAME SYSRES_CONST_YES SYSRES_CONST_YES_NO_2_REQUISITE_CODE SYSRES_CONST_YES_NO_REQUISITE_CODE SYSRES_CONST_YES_NO_T_REF_TYPE_REQUISITE_CODE SYSRES_CONST_YES_PICK_VALUE SYSRES_CONST_YES_VALUE " + "CR FALSE nil NO_VALUE NULL TAB TRUE YES_VALUE " + "ADMINISTRATORS_GROUP_NAME CUSTOMIZERS_GROUP_NAME DEVELOPERS_GROUP_NAME SERVICE_USERS_GROUP_NAME " + "DECISION_BLOCK_FIRST_OPERAND_PROPERTY DECISION_BLOCK_NAME_PROPERTY DECISION_BLOCK_OPERATION_PROPERTY DECISION_BLOCK_RESULT_TYPE_PROPERTY DECISION_BLOCK_SECOND_OPERAND_PROPERTY " + "ANY_FILE_EXTENTION COMPRESSED_DOCUMENT_EXTENSION EXTENDED_DOCUMENT_EXTENSION SHORT_COMPRESSED_DOCUMENT_EXTENSION SHORT_EXTENDED_DOCUMENT_EXTENSION " + "JOB_BLOCK_ABORT_DEADLINE_PROPERTY JOB_BLOCK_AFTER_FINISH_EVENT JOB_BLOCK_AFTER_QUERY_PARAMETERS_EVENT JOB_BLOCK_ATTACHMENT_PROPERTY JOB_BLOCK_ATTACHMENTS_RIGHTS_GROUP_PROPERTY JOB_BLOCK_ATTACHMENTS_RIGHTS_TYPE_PROPERTY JOB_BLOCK_BEFORE_QUERY_PARAMETERS_EVENT JOB_BLOCK_BEFORE_START_EVENT JOB_BLOCK_CREATED_JOBS_PROPERTY JOB_BLOCK_DEADLINE_PROPERTY JOB_BLOCK_EXECUTION_RESULTS_PROPERTY JOB_BLOCK_IS_PARALLEL_PROPERTY JOB_BLOCK_IS_RELATIVE_ABORT_DEADLINE_PROPERTY JOB_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY JOB_BLOCK_JOB_TEXT_PROPERTY JOB_BLOCK_NAME_PROPERTY JOB_BLOCK_NEED_SIGN_ON_PERFORM_PROPERTY JOB_BLOCK_PERFORMER_PROPERTY JOB_BLOCK_RELATIVE_ABORT_DEADLINE_TYPE_PROPERTY JOB_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY JOB_BLOCK_SUBJECT_PROPERTY " + "ENGLISH_LANGUAGE_CODE RUSSIAN_LANGUAGE_CODE " + "smHidden smMaximized smMinimized smNormal wmNo wmYes " + "COMPONENT_TOKEN_LINK_KIND DOCUMENT_LINK_KIND EDOCUMENT_LINK_KIND FOLDER_LINK_KIND JOB_LINK_KIND REFERENCE_LINK_KIND TASK_LINK_KIND " + "COMPONENT_TOKEN_LOCK_TYPE EDOCUMENT_VERSION_LOCK_TYPE " + "MONITOR_BLOCK_AFTER_FINISH_EVENT MONITOR_BLOCK_BEFORE_START_EVENT MONITOR_BLOCK_DEADLINE_PROPERTY MONITOR_BLOCK_INTERVAL_PROPERTY MONITOR_BLOCK_INTERVAL_TYPE_PROPERTY MONITOR_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY MONITOR_BLOCK_NAME_PROPERTY MONITOR_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY MONITOR_BLOCK_SEARCH_SCRIPT_PROPERTY " + "NOTICE_BLOCK_AFTER_FINISH_EVENT NOTICE_BLOCK_ATTACHMENT_PROPERTY NOTICE_BLOCK_ATTACHMENTS_RIGHTS_GROUP_PROPERTY NOTICE_BLOCK_ATTACHMENTS_RIGHTS_TYPE_PROPERTY NOTICE_BLOCK_BEFORE_START_EVENT NOTICE_BLOCK_CREATED_NOTICES_PROPERTY NOTICE_BLOCK_DEADLINE_PROPERTY NOTICE_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY NOTICE_BLOCK_NAME_PROPERTY NOTICE_BLOCK_NOTICE_TEXT_PROPERTY NOTICE_BLOCK_PERFORMER_PROPERTY NOTICE_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY NOTICE_BLOCK_SUBJECT_PROPERTY " + "dseAfterCancel dseAfterClose dseAfterDelete dseAfterDeleteOutOfTransaction dseAfterInsert dseAfterOpen dseAfterScroll dseAfterUpdate dseAfterUpdateOutOfTransaction dseBeforeCancel dseBeforeClose dseBeforeDelete dseBeforeDetailUpdate dseBeforeInsert dseBeforeOpen dseBeforeUpdate dseOnAnyRequisiteChange dseOnCloseRecord dseOnDeleteError dseOnOpenRecord dseOnPrepareUpdate dseOnUpdateError dseOnUpdateRatifiedRecord dseOnValidDelete dseOnValidUpdate reOnChange reOnChangeValues SELECTION_BEGIN_ROUTE_EVENT SELECTION_END_ROUTE_EVENT " + "CURRENT_PERIOD_IS_REQUIRED PREVIOUS_CARD_TYPE_NAME SHOW_RECORD_PROPERTIES_FORM " + "ACCESS_RIGHTS_SETTING_DIALOG_CODE ADMINISTRATOR_USER_CODE ANALYTIC_REPORT_TYPE asrtHideLocal asrtHideRemote CALCULATED_ROLE_TYPE_CODE COMPONENTS_REFERENCE_DEVELOPER_VIEW_CODE DCTS_TEST_PROTOCOLS_FOLDER_PATH E_EDOC_VERSION_ALREADY_APPROVINGLY_SIGNED E_EDOC_VERSION_ALREADY_APPROVINGLY_SIGNED_BY_USER E_EDOC_VERSION_ALREDY_SIGNED E_EDOC_VERSION_ALREDY_SIGNED_BY_USER EDOC_TYPES_CODE_REQUISITE_FIELD_NAME EDOCUMENTS_ALIAS_NAME FILES_FOLDER_PATH FILTER_OPERANDS_DELIMITER FILTER_OPERATIONS_DELIMITER FORMCARD_NAME FORMLIST_NAME GET_EXTENDED_DOCUMENT_EXTENSION_CREATION_MODE GET_EXTENDED_DOCUMENT_EXTENSION_IMPORT_MODE INTEGRATED_REPORT_TYPE IS_BUILDER_APPLICATION_ROLE IS_BUILDER_APPLICATION_ROLE2 IS_BUILDER_USERS ISBSYSDEV LOG_FOLDER_PATH mbCancel mbNo mbNoToAll mbOK mbYes mbYesToAll MEMORY_DATASET_DESRIPTIONS_FILENAME mrNo mrNoToAll mrYes mrYesToAll MULTIPLE_SELECT_DIALOG_CODE NONOPERATING_RECORD_FLAG_FEMININE NONOPERATING_RECORD_FLAG_MASCULINE OPERATING_RECORD_FLAG_FEMININE OPERATING_RECORD_FLAG_MASCULINE PROFILING_SETTINGS_COMMON_SETTINGS_CODE_VALUE PROGRAM_INITIATED_LOOKUP_ACTION ratDelete ratEdit ratInsert REPORT_TYPE REQUIRED_PICK_VALUES_VARIABLE rmCard rmList SBRTE_PROGID_DEV SBRTE_PROGID_RELEASE STATIC_ROLE_TYPE_CODE SUPPRESS_EMPTY_TEMPLATE_CREATION SYSTEM_USER_CODE UPDATE_DIALOG_DATASET USED_IN_OBJECT_HINT_PARAM USER_INITIATED_LOOKUP_ACTION USER_NAME_FORMAT USER_SELECTION_RESTRICTIONS WORKFLOW_TEST_PROTOCOLS_FOLDER_PATH ELS_SUBTYPE_CONTROL_NAME ELS_FOLDER_KIND_CONTROL_NAME REPEAT_PROCESS_CURRENT_OBJECT_EXCEPTION_NAME " + "PRIVILEGE_COMPONENT_FULL_ACCESS PRIVILEGE_DEVELOPMENT_EXPORT PRIVILEGE_DEVELOPMENT_IMPORT PRIVILEGE_DOCUMENT_DELETE PRIVILEGE_ESD PRIVILEGE_FOLDER_DELETE PRIVILEGE_MANAGE_ACCESS_RIGHTS PRIVILEGE_MANAGE_REPLICATION PRIVILEGE_MANAGE_SESSION_SERVER PRIVILEGE_OBJECT_FULL_ACCESS PRIVILEGE_OBJECT_VIEW PRIVILEGE_RESERVE_LICENSE PRIVILEGE_SYSTEM_CUSTOMIZE PRIVILEGE_SYSTEM_DEVELOP PRIVILEGE_SYSTEM_INSTALL PRIVILEGE_TASK_DELETE PRIVILEGE_USER_PLUGIN_SETTINGS_CUSTOMIZE PRIVILEGES_PSEUDOREFERENCE_CODE " + "ACCESS_TYPES_PSEUDOREFERENCE_CODE ALL_AVAILABLE_COMPONENTS_PSEUDOREFERENCE_CODE ALL_AVAILABLE_PRIVILEGES_PSEUDOREFERENCE_CODE ALL_REPLICATE_COMPONENTS_PSEUDOREFERENCE_CODE AVAILABLE_DEVELOPERS_COMPONENTS_PSEUDOREFERENCE_CODE COMPONENTS_PSEUDOREFERENCE_CODE FILTRATER_SETTINGS_CONFLICTS_PSEUDOREFERENCE_CODE GROUPS_PSEUDOREFERENCE_CODE RECEIVE_PROTOCOL_PSEUDOREFERENCE_CODE REFERENCE_REQUISITE_PSEUDOREFERENCE_CODE REFERENCE_REQUISITES_PSEUDOREFERENCE_CODE REFTYPES_PSEUDOREFERENCE_CODE REPLICATION_SEANCES_DIARY_PSEUDOREFERENCE_CODE SEND_PROTOCOL_PSEUDOREFERENCE_CODE SUBSTITUTES_PSEUDOREFERENCE_CODE SYSTEM_SETTINGS_PSEUDOREFERENCE_CODE UNITS_PSEUDOREFERENCE_CODE USERS_PSEUDOREFERENCE_CODE VIEWERS_PSEUDOREFERENCE_CODE " + "CERTIFICATE_TYPE_ENCRYPT CERTIFICATE_TYPE_SIGN CERTIFICATE_TYPE_SIGN_AND_ENCRYPT " + "STORAGE_TYPE_FILE STORAGE_TYPE_NAS_CIFS STORAGE_TYPE_SAPERION STORAGE_TYPE_SQL_SERVER " + "COMPTYPE2_REQUISITE_DOCUMENTS_VALUE COMPTYPE2_REQUISITE_TASKS_VALUE COMPTYPE2_REQUISITE_FOLDERS_VALUE COMPTYPE2_REQUISITE_REFERENCES_VALUE " + "SYSREQ_CODE SYSREQ_COMPTYPE2 SYSREQ_CONST_AVAILABLE_FOR_WEB SYSREQ_CONST_COMMON_CODE SYSREQ_CONST_COMMON_VALUE SYSREQ_CONST_FIRM_CODE SYSREQ_CONST_FIRM_STATUS SYSREQ_CONST_FIRM_VALUE SYSREQ_CONST_SERVER_STATUS SYSREQ_CONTENTS SYSREQ_DATE_OPEN SYSREQ_DATE_CLOSE SYSREQ_DESCRIPTION SYSREQ_DESCRIPTION_LOCALIZE_ID SYSREQ_DOUBLE SYSREQ_EDOC_ACCESS_TYPE SYSREQ_EDOC_AUTHOR SYSREQ_EDOC_CREATED SYSREQ_EDOC_DELEGATE_RIGHTS_REQUISITE_CODE SYSREQ_EDOC_EDITOR SYSREQ_EDOC_ENCODE_TYPE SYSREQ_EDOC_ENCRYPTION_PLUGIN_NAME SYSREQ_EDOC_ENCRYPTION_PLUGIN_VERSION SYSREQ_EDOC_EXPORT_DATE SYSREQ_EDOC_EXPORTER SYSREQ_EDOC_KIND SYSREQ_EDOC_LIFE_STAGE_NAME SYSREQ_EDOC_LOCKED_FOR_SERVER_CODE SYSREQ_EDOC_MODIFIED SYSREQ_EDOC_NAME SYSREQ_EDOC_NOTE SYSREQ_EDOC_QUALIFIED_ID SYSREQ_EDOC_SESSION_KEY SYSREQ_EDOC_SESSION_KEY_ENCRYPTION_PLUGIN_NAME SYSREQ_EDOC_SESSION_KEY_ENCRYPTION_PLUGIN_VERSION SYSREQ_EDOC_SIGNATURE_TYPE SYSREQ_EDOC_SIGNED SYSREQ_EDOC_STORAGE SYSREQ_EDOC_STORAGES_ARCHIVE_STORAGE SYSREQ_EDOC_STORAGES_CHECK_RIGHTS SYSREQ_EDOC_STORAGES_COMPUTER_NAME SYSREQ_EDOC_STORAGES_EDIT_IN_STORAGE SYSREQ_EDOC_STORAGES_EXECUTIVE_STORAGE SYSREQ_EDOC_STORAGES_FUNCTION SYSREQ_EDOC_STORAGES_INITIALIZED SYSREQ_EDOC_STORAGES_LOCAL_PATH SYSREQ_EDOC_STORAGES_SAPERION_DATABASE_NAME SYSREQ_EDOC_STORAGES_SEARCH_BY_TEXT SYSREQ_EDOC_STORAGES_SERVER_NAME SYSREQ_EDOC_STORAGES_SHARED_SOURCE_NAME SYSREQ_EDOC_STORAGES_TYPE SYSREQ_EDOC_TEXT_MODIFIED SYSREQ_EDOC_TYPE_ACT_CODE SYSREQ_EDOC_TYPE_ACT_DESCRIPTION SYSREQ_EDOC_TYPE_ACT_DESCRIPTION_LOCALIZE_ID SYSREQ_EDOC_TYPE_ACT_ON_EXECUTE SYSREQ_EDOC_TYPE_ACT_ON_EXECUTE_EXISTS SYSREQ_EDOC_TYPE_ACT_SECTION SYSREQ_EDOC_TYPE_ADD_PARAMS SYSREQ_EDOC_TYPE_COMMENT SYSREQ_EDOC_TYPE_EVENT_TEXT SYSREQ_EDOC_TYPE_NAME_IN_SINGULAR SYSREQ_EDOC_TYPE_NAME_IN_SINGULAR_LOCALIZE_ID SYSREQ_EDOC_TYPE_NAME_LOCALIZE_ID SYSREQ_EDOC_TYPE_NUMERATION_METHOD SYSREQ_EDOC_TYPE_PSEUDO_REQUISITE_CODE SYSREQ_EDOC_TYPE_REQ_CODE SYSREQ_EDOC_TYPE_REQ_DESCRIPTION SYSREQ_EDOC_TYPE_REQ_DESCRIPTION_LOCALIZE_ID SYSREQ_EDOC_TYPE_REQ_IS_LEADING SYSREQ_EDOC_TYPE_REQ_IS_REQUIRED SYSREQ_EDOC_TYPE_REQ_NUMBER SYSREQ_EDOC_TYPE_REQ_ON_CHANGE SYSREQ_EDOC_TYPE_REQ_ON_CHANGE_EXISTS SYSREQ_EDOC_TYPE_REQ_ON_SELECT SYSREQ_EDOC_TYPE_REQ_ON_SELECT_KIND SYSREQ_EDOC_TYPE_REQ_SECTION SYSREQ_EDOC_TYPE_VIEW_CARD SYSREQ_EDOC_TYPE_VIEW_CODE SYSREQ_EDOC_TYPE_VIEW_COMMENT SYSREQ_EDOC_TYPE_VIEW_IS_MAIN SYSREQ_EDOC_TYPE_VIEW_NAME SYSREQ_EDOC_TYPE_VIEW_NAME_LOCALIZE_ID SYSREQ_EDOC_VERSION_AUTHOR SYSREQ_EDOC_VERSION_CRC SYSREQ_EDOC_VERSION_DATA SYSREQ_EDOC_VERSION_EDITOR SYSREQ_EDOC_VERSION_EXPORT_DATE SYSREQ_EDOC_VERSION_EXPORTER SYSREQ_EDOC_VERSION_HIDDEN SYSREQ_EDOC_VERSION_LIFE_STAGE SYSREQ_EDOC_VERSION_MODIFIED SYSREQ_EDOC_VERSION_NOTE SYSREQ_EDOC_VERSION_SIGNATURE_TYPE SYSREQ_EDOC_VERSION_SIGNED SYSREQ_EDOC_VERSION_SIZE SYSREQ_EDOC_VERSION_SOURCE SYSREQ_EDOC_VERSION_TEXT_MODIFIED SYSREQ_EDOCKIND_DEFAULT_VERSION_STATE_CODE SYSREQ_FOLDER_KIND SYSREQ_FUNC_CATEGORY SYSREQ_FUNC_COMMENT SYSREQ_FUNC_GROUP SYSREQ_FUNC_GROUP_COMMENT SYSREQ_FUNC_GROUP_NUMBER SYSREQ_FUNC_HELP SYSREQ_FUNC_PARAM_DEF_VALUE SYSREQ_FUNC_PARAM_IDENT SYSREQ_FUNC_PARAM_NUMBER SYSREQ_FUNC_PARAM_TYPE SYSREQ_FUNC_TEXT SYSREQ_GROUP_CATEGORY SYSREQ_ID SYSREQ_LAST_UPDATE SYSREQ_LEADER_REFERENCE SYSREQ_LINE_NUMBER SYSREQ_MAIN_RECORD_ID SYSREQ_NAME SYSREQ_NAME_LOCALIZE_ID SYSREQ_NOTE SYSREQ_ORIGINAL_RECORD SYSREQ_OUR_FIRM SYSREQ_PROFILING_SETTINGS_BATCH_LOGING SYSREQ_PROFILING_SETTINGS_BATCH_SIZE SYSREQ_PROFILING_SETTINGS_PROFILING_ENABLED SYSREQ_PROFILING_SETTINGS_SQL_PROFILING_ENABLED SYSREQ_PROFILING_SETTINGS_START_LOGGED SYSREQ_RECORD_STATUS SYSREQ_REF_REQ_FIELD_NAME SYSREQ_REF_REQ_FORMAT SYSREQ_REF_REQ_GENERATED SYSREQ_REF_REQ_LENGTH SYSREQ_REF_REQ_PRECISION SYSREQ_REF_REQ_REFERENCE SYSREQ_REF_REQ_SECTION SYSREQ_REF_REQ_STORED SYSREQ_REF_REQ_TOKENS SYSREQ_REF_REQ_TYPE SYSREQ_REF_REQ_VIEW SYSREQ_REF_TYPE_ACT_CODE SYSREQ_REF_TYPE_ACT_DESCRIPTION SYSREQ_REF_TYPE_ACT_DESCRIPTION_LOCALIZE_ID SYSREQ_REF_TYPE_ACT_ON_EXECUTE SYSREQ_REF_TYPE_ACT_ON_EXECUTE_EXISTS SYSREQ_REF_TYPE_ACT_SECTION SYSREQ_REF_TYPE_ADD_PARAMS SYSREQ_REF_TYPE_COMMENT SYSREQ_REF_TYPE_COMMON_SETTINGS SYSREQ_REF_TYPE_DISPLAY_REQUISITE_NAME SYSREQ_REF_TYPE_EVENT_TEXT SYSREQ_REF_TYPE_MAIN_LEADING_REF SYSREQ_REF_TYPE_NAME_IN_SINGULAR SYSREQ_REF_TYPE_NAME_IN_SINGULAR_LOCALIZE_ID SYSREQ_REF_TYPE_NAME_LOCALIZE_ID SYSREQ_REF_TYPE_NUMERATION_METHOD SYSREQ_REF_TYPE_REQ_CODE SYSREQ_REF_TYPE_REQ_DESCRIPTION SYSREQ_REF_TYPE_REQ_DESCRIPTION_LOCALIZE_ID SYSREQ_REF_TYPE_REQ_IS_CONTROL SYSREQ_REF_TYPE_REQ_IS_FILTER SYSREQ_REF_TYPE_REQ_IS_LEADING SYSREQ_REF_TYPE_REQ_IS_REQUIRED SYSREQ_REF_TYPE_REQ_NUMBER SYSREQ_REF_TYPE_REQ_ON_CHANGE SYSREQ_REF_TYPE_REQ_ON_CHANGE_EXISTS SYSREQ_REF_TYPE_REQ_ON_SELECT SYSREQ_REF_TYPE_REQ_ON_SELECT_KIND SYSREQ_REF_TYPE_REQ_SECTION SYSREQ_REF_TYPE_VIEW_CARD SYSREQ_REF_TYPE_VIEW_CODE SYSREQ_REF_TYPE_VIEW_COMMENT SYSREQ_REF_TYPE_VIEW_IS_MAIN SYSREQ_REF_TYPE_VIEW_NAME SYSREQ_REF_TYPE_VIEW_NAME_LOCALIZE_ID SYSREQ_REFERENCE_TYPE_ID SYSREQ_STATE SYSREQ_STATЕ SYSREQ_SYSTEM_SETTINGS_VALUE SYSREQ_TYPE SYSREQ_UNIT SYSREQ_UNIT_ID SYSREQ_USER_GROUPS_GROUP_FULL_NAME SYSREQ_USER_GROUPS_GROUP_NAME SYSREQ_USER_GROUPS_GROUP_SERVER_NAME SYSREQ_USERS_ACCESS_RIGHTS SYSREQ_USERS_AUTHENTICATION SYSREQ_USERS_CATEGORY SYSREQ_USERS_COMPONENT SYSREQ_USERS_COMPONENT_USER_IS_PUBLIC SYSREQ_USERS_DOMAIN SYSREQ_USERS_FULL_USER_NAME SYSREQ_USERS_GROUP SYSREQ_USERS_IS_MAIN_SERVER SYSREQ_USERS_LOGIN SYSREQ_USERS_REFERENCE_USER_IS_PUBLIC SYSREQ_USERS_STATUS SYSREQ_USERS_USER_CERTIFICATE SYSREQ_USERS_USER_CERTIFICATE_INFO SYSREQ_USERS_USER_CERTIFICATE_PLUGIN_NAME SYSREQ_USERS_USER_CERTIFICATE_PLUGIN_VERSION SYSREQ_USERS_USER_CERTIFICATE_STATE SYSREQ_USERS_USER_CERTIFICATE_SUBJECT_NAME SYSREQ_USERS_USER_CERTIFICATE_THUMBPRINT SYSREQ_USERS_USER_DEFAULT_CERTIFICATE SYSREQ_USERS_USER_DESCRIPTION SYSREQ_USERS_USER_GLOBAL_NAME SYSREQ_USERS_USER_LOGIN SYSREQ_USERS_USER_MAIN_SERVER SYSREQ_USERS_USER_TYPE SYSREQ_WORK_RULES_FOLDER_ID " + "RESULT_VAR_NAME RESULT_VAR_NAME_ENG " + "AUTO_NUMERATION_RULE_ID CANT_CHANGE_ID_REQUISITE_RULE_ID CANT_CHANGE_OURFIRM_REQUISITE_RULE_ID CHECK_CHANGING_REFERENCE_RECORD_USE_RULE_ID CHECK_CODE_REQUISITE_RULE_ID CHECK_DELETING_REFERENCE_RECORD_USE_RULE_ID CHECK_FILTRATER_CHANGES_RULE_ID CHECK_RECORD_INTERVAL_RULE_ID CHECK_REFERENCE_INTERVAL_RULE_ID CHECK_REQUIRED_DATA_FULLNESS_RULE_ID CHECK_REQUIRED_REQUISITES_FULLNESS_RULE_ID MAKE_RECORD_UNRATIFIED_RULE_ID RESTORE_AUTO_NUMERATION_RULE_ID SET_FIRM_CONTEXT_FROM_RECORD_RULE_ID SET_FIRST_RECORD_IN_LIST_FORM_RULE_ID SET_IDSPS_VALUE_RULE_ID SET_NEXT_CODE_VALUE_RULE_ID SET_OURFIRM_BOUNDS_RULE_ID SET_OURFIRM_REQUISITE_RULE_ID " + "SCRIPT_BLOCK_AFTER_FINISH_EVENT SCRIPT_BLOCK_BEFORE_START_EVENT SCRIPT_BLOCK_EXECUTION_RESULTS_PROPERTY SCRIPT_BLOCK_NAME_PROPERTY SCRIPT_BLOCK_SCRIPT_PROPERTY " + "SUBTASK_BLOCK_ABORT_DEADLINE_PROPERTY SUBTASK_BLOCK_AFTER_FINISH_EVENT SUBTASK_BLOCK_ASSIGN_PARAMS_EVENT SUBTASK_BLOCK_ATTACHMENTS_PROPERTY SUBTASK_BLOCK_ATTACHMENTS_RIGHTS_GROUP_PROPERTY SUBTASK_BLOCK_ATTACHMENTS_RIGHTS_TYPE_PROPERTY SUBTASK_BLOCK_BEFORE_START_EVENT SUBTASK_BLOCK_CREATED_TASK_PROPERTY SUBTASK_BLOCK_CREATION_EVENT SUBTASK_BLOCK_DEADLINE_PROPERTY SUBTASK_BLOCK_IMPORTANCE_PROPERTY SUBTASK_BLOCK_INITIATOR_PROPERTY SUBTASK_BLOCK_IS_RELATIVE_ABORT_DEADLINE_PROPERTY SUBTASK_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY SUBTASK_BLOCK_JOBS_TYPE_PROPERTY SUBTASK_BLOCK_NAME_PROPERTY SUBTASK_BLOCK_PARALLEL_ROUTE_PROPERTY SUBTASK_BLOCK_PERFORMERS_PROPERTY SUBTASK_BLOCK_RELATIVE_ABORT_DEADLINE_TYPE_PROPERTY SUBTASK_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY SUBTASK_BLOCK_REQUIRE_SIGN_PROPERTY SUBTASK_BLOCK_STANDARD_ROUTE_PROPERTY SUBTASK_BLOCK_START_EVENT SUBTASK_BLOCK_STEP_CONTROL_PROPERTY SUBTASK_BLOCK_SUBJECT_PROPERTY SUBTASK_BLOCK_TASK_CONTROL_PROPERTY SUBTASK_BLOCK_TEXT_PROPERTY SUBTASK_BLOCK_UNLOCK_ATTACHMENTS_ON_STOP_PROPERTY SUBTASK_BLOCK_USE_STANDARD_ROUTE_PROPERTY SUBTASK_BLOCK_WAIT_FOR_TASK_COMPLETE_PROPERTY " + "SYSCOMP_CONTROL_JOBS SYSCOMP_FOLDERS SYSCOMP_JOBS SYSCOMP_NOTICES SYSCOMP_TASKS " + "SYSDLG_CREATE_EDOCUMENT SYSDLG_CREATE_EDOCUMENT_VERSION SYSDLG_CURRENT_PERIOD SYSDLG_EDIT_FUNCTION_HELP SYSDLG_EDOCUMENT_KINDS_FOR_TEMPLATE SYSDLG_EXPORT_MULTIPLE_EDOCUMENTS SYSDLG_EXPORT_SINGLE_EDOCUMENT SYSDLG_IMPORT_EDOCUMENT SYSDLG_MULTIPLE_SELECT SYSDLG_SETUP_ACCESS_RIGHTS SYSDLG_SETUP_DEFAULT_RIGHTS SYSDLG_SETUP_FILTER_CONDITION SYSDLG_SETUP_SIGN_RIGHTS SYSDLG_SETUP_TASK_OBSERVERS SYSDLG_SETUP_TASK_ROUTE SYSDLG_SETUP_USERS_LIST SYSDLG_SIGN_EDOCUMENT SYSDLG_SIGN_MULTIPLE_EDOCUMENTS " + "SYSREF_ACCESS_RIGHTS_TYPES SYSREF_ADMINISTRATION_HISTORY SYSREF_ALL_AVAILABLE_COMPONENTS SYSREF_ALL_AVAILABLE_PRIVILEGES SYSREF_ALL_REPLICATING_COMPONENTS SYSREF_AVAILABLE_DEVELOPERS_COMPONENTS SYSREF_CALENDAR_EVENTS SYSREF_COMPONENT_TOKEN_HISTORY SYSREF_COMPONENT_TOKENS SYSREF_COMPONENTS SYSREF_CONSTANTS SYSREF_DATA_RECEIVE_PROTOCOL SYSREF_DATA_SEND_PROTOCOL SYSREF_DIALOGS SYSREF_DIALOGS_REQUISITES SYSREF_EDITORS SYSREF_EDOC_CARDS SYSREF_EDOC_TYPES SYSREF_EDOCUMENT_CARD_REQUISITES SYSREF_EDOCUMENT_CARD_TYPES SYSREF_EDOCUMENT_CARD_TYPES_REFERENCE SYSREF_EDOCUMENT_CARDS SYSREF_EDOCUMENT_HISTORY SYSREF_EDOCUMENT_KINDS SYSREF_EDOCUMENT_REQUISITES SYSREF_EDOCUMENT_SIGNATURES SYSREF_EDOCUMENT_TEMPLATES SYSREF_EDOCUMENT_TEXT_STORAGES SYSREF_EDOCUMENT_VIEWS SYSREF_FILTERER_SETUP_CONFLICTS SYSREF_FILTRATER_SETTING_CONFLICTS SYSREF_FOLDER_HISTORY SYSREF_FOLDERS SYSREF_FUNCTION_GROUPS SYSREF_FUNCTION_PARAMS SYSREF_FUNCTIONS SYSREF_JOB_HISTORY SYSREF_LINKS SYSREF_LOCALIZATION_DICTIONARY SYSREF_LOCALIZATION_LANGUAGES SYSREF_MODULES SYSREF_PRIVILEGES SYSREF_RECORD_HISTORY SYSREF_REFERENCE_REQUISITES SYSREF_REFERENCE_TYPE_VIEWS SYSREF_REFERENCE_TYPES SYSREF_REFERENCES SYSREF_REFERENCES_REQUISITES SYSREF_REMOTE_SERVERS SYSREF_REPLICATION_SESSIONS_LOG SYSREF_REPLICATION_SESSIONS_PROTOCOL SYSREF_REPORTS SYSREF_ROLES SYSREF_ROUTE_BLOCK_GROUPS SYSREF_ROUTE_BLOCKS SYSREF_SCRIPTS SYSREF_SEARCHES SYSREF_SERVER_EVENTS SYSREF_SERVER_EVENTS_HISTORY SYSREF_STANDARD_ROUTE_GROUPS SYSREF_STANDARD_ROUTES SYSREF_STATUSES SYSREF_SYSTEM_SETTINGS SYSREF_TASK_HISTORY SYSREF_TASK_KIND_GROUPS SYSREF_TASK_KINDS SYSREF_TASK_RIGHTS SYSREF_TASK_SIGNATURES SYSREF_TASKS SYSREF_UNITS SYSREF_USER_GROUPS SYSREF_USER_GROUPS_REFERENCE SYSREF_USER_SUBSTITUTION SYSREF_USERS SYSREF_USERS_REFERENCE SYSREF_VIEWERS SYSREF_WORKING_TIME_CALENDARS " + "ACCESS_RIGHTS_TABLE_NAME EDMS_ACCESS_TABLE_NAME EDOC_TYPES_TABLE_NAME " + "TEST_DEV_DB_NAME TEST_DEV_SYSTEM_CODE TEST_EDMS_DB_NAME TEST_EDMS_MAIN_CODE TEST_EDMS_MAIN_DB_NAME TEST_EDMS_SECOND_CODE TEST_EDMS_SECOND_DB_NAME TEST_EDMS_SYSTEM_CODE TEST_ISB5_MAIN_CODE TEST_ISB5_SECOND_CODE TEST_SQL_SERVER_2005_NAME TEST_SQL_SERVER_NAME " + "ATTENTION_CAPTION cbsCommandLinks cbsDefault CONFIRMATION_CAPTION ERROR_CAPTION INFORMATION_CAPTION mrCancel mrOk " + "EDOC_VERSION_ACTIVE_STAGE_CODE EDOC_VERSION_DESIGN_STAGE_CODE EDOC_VERSION_OBSOLETE_STAGE_CODE " + "cpDataEnciphermentEnabled cpDigitalSignatureEnabled cpID cpIssuer cpPluginVersion cpSerial cpSubjectName cpSubjSimpleName cpValidFromDate cpValidToDate " + "ISBL_SYNTAX NO_SYNTAX XML_SYNTAX " + "WAIT_BLOCK_AFTER_FINISH_EVENT WAIT_BLOCK_BEFORE_START_EVENT WAIT_BLOCK_DEADLINE_PROPERTY WAIT_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY WAIT_BLOCK_NAME_PROPERTY WAIT_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY " + "SYSRES_COMMON SYSRES_CONST SYSRES_MBFUNC SYSRES_SBDATA SYSRES_SBGUI SYSRES_SBINTF SYSRES_SBREFDSC SYSRES_SQLERRORS SYSRES_SYSCOMP ", ai = "atUser atGroup atRole " + "aemEnabledAlways aemDisabledAlways aemEnabledOnBrowse aemEnabledOnEdit aemDisabledOnBrowseEmpty " + "apBegin apEnd " + "alLeft alRight " + "asmNever asmNoButCustomize asmAsLastTime asmYesButCustomize asmAlways " + "cirCommon cirRevoked " + "ctSignature ctEncode ctSignatureEncode " + "clbUnchecked clbChecked clbGrayed " + "ceISB ceAlways ceNever " + "ctDocument ctReference ctScript ctUnknown ctReport ctDialog ctFunction ctFolder ctEDocument ctTask ctJob ctNotice ctControlJob " + "cfInternal cfDisplay " + "ciUnspecified ciWrite ciRead " + "ckFolder ckEDocument ckTask ckJob ckComponentToken ckAny ckReference ckScript ckReport ckDialog " + "ctISBLEditor ctBevel ctButton ctCheckListBox ctComboBox ctComboEdit ctGrid ctDBCheckBox ctDBComboBox ctDBEdit ctDBEllipsis ctDBMemo ctDBNavigator ctDBRadioGroup ctDBStatusLabel ctEdit ctGroupBox ctInplaceHint ctMemo ctPanel ctListBox ctRadioButton ctRichEdit ctTabSheet ctWebBrowser ctImage ctHyperLink ctLabel ctDBMultiEllipsis ctRibbon ctRichView ctInnerPanel ctPanelGroup ctBitButton " + "cctDate cctInteger cctNumeric cctPick cctReference cctString cctText " + "cltInternal cltPrimary cltGUI " + "dseBeforeOpen dseAfterOpen dseBeforeClose dseAfterClose dseOnValidDelete dseBeforeDelete dseAfterDelete dseAfterDeleteOutOfTransaction dseOnDeleteError dseBeforeInsert dseAfterInsert dseOnValidUpdate dseBeforeUpdate dseOnUpdateRatifiedRecord dseAfterUpdate dseAfterUpdateOutOfTransaction dseOnUpdateError dseAfterScroll dseOnOpenRecord dseOnCloseRecord dseBeforeCancel dseAfterCancel dseOnUpdateDeadlockError dseBeforeDetailUpdate dseOnPrepareUpdate dseOnAnyRequisiteChange " + "dssEdit dssInsert dssBrowse dssInActive " + "dftDate dftShortDate dftDateTime dftTimeStamp " + "dotDays dotHours dotMinutes dotSeconds " + "dtkndLocal dtkndUTC " + "arNone arView arEdit arFull " + "ddaView ddaEdit " + "emLock emEdit emSign emExportWithLock emImportWithUnlock emChangeVersionNote emOpenForModify emChangeLifeStage emDelete emCreateVersion emImport emUnlockExportedWithLock emStart emAbort emReInit emMarkAsReaded emMarkAsUnreaded emPerform emAccept emResume emChangeRights emEditRoute emEditObserver emRecoveryFromLocalCopy emChangeWorkAccessType emChangeEncodeTypeToCertificate emChangeEncodeTypeToPassword emChangeEncodeTypeToNone emChangeEncodeTypeToCertificatePassword emChangeStandardRoute emGetText emOpenForView emMoveToStorage emCreateObject emChangeVersionHidden emDeleteVersion emChangeLifeCycleStage emApprovingSign emExport emContinue emLockFromEdit emUnLockForEdit emLockForServer emUnlockFromServer emDelegateAccessRights emReEncode " + "ecotFile ecotProcess " + "eaGet eaCopy eaCreate eaCreateStandardRoute " + "edltAll edltNothing edltQuery " + "essmText essmCard " + "esvtLast esvtLastActive esvtSpecified " + "edsfExecutive edsfArchive " + "edstSQLServer edstFile " + "edvstNone edvstEDocumentVersionCopy edvstFile edvstTemplate edvstScannedFile " + "vsDefault vsDesign vsActive vsObsolete " + "etNone etCertificate etPassword etCertificatePassword " + "ecException ecWarning ecInformation " + "estAll estApprovingOnly " + "evtLast evtLastActive evtQuery " + "fdtString fdtNumeric fdtInteger fdtDate fdtText fdtUnknown fdtWideString fdtLargeInteger " + "ftInbox ftOutbox ftFavorites ftCommonFolder ftUserFolder ftComponents ftQuickLaunch ftShortcuts ftSearch " + "grhAuto grhX1 grhX2 grhX3 " + "hltText hltRTF hltHTML " + "iffBMP iffJPEG iffMultiPageTIFF iffSinglePageTIFF iffTIFF iffPNG " + "im8bGrayscale im24bRGB im1bMonochrome " + "itBMP itJPEG itWMF itPNG " + "ikhInformation ikhWarning ikhError ikhNoIcon " + "icUnknown icScript icFunction icIntegratedReport icAnalyticReport icDataSetEventHandler icActionHandler icFormEventHandler icLookUpEventHandler icRequisiteChangeEventHandler icBeforeSearchEventHandler icRoleCalculation icSelectRouteEventHandler icBlockPropertyCalculation icBlockQueryParamsEventHandler icChangeSearchResultEventHandler icBlockEventHandler icSubTaskInitEventHandler icEDocDataSetEventHandler icEDocLookUpEventHandler icEDocActionHandler icEDocFormEventHandler icEDocRequisiteChangeEventHandler icStructuredConversionRule icStructuredConversionEventBefore icStructuredConversionEventAfter icWizardEventHandler icWizardFinishEventHandler icWizardStepEventHandler icWizardStepFinishEventHandler icWizardActionEnableEventHandler icWizardActionExecuteEventHandler icCreateJobsHandler icCreateNoticesHandler icBeforeLookUpEventHandler icAfterLookUpEventHandler icTaskAbortEventHandler icWorkflowBlockActionHandler icDialogDataSetEventHandler icDialogActionHandler icDialogLookUpEventHandler icDialogRequisiteChangeEventHandler icDialogFormEventHandler icDialogValidCloseEventHandler icBlockFormEventHandler icTaskFormEventHandler icReferenceMethod icEDocMethod icDialogMethod icProcessMessageHandler " + "isShow isHide isByUserSettings " + "jkJob jkNotice jkControlJob " + "jtInner jtLeft jtRight jtFull jtCross " + "lbpAbove lbpBelow lbpLeft lbpRight " + "eltPerConnection eltPerUser " + "sfcUndefined sfcBlack sfcGreen sfcRed sfcBlue sfcOrange sfcLilac " + "sfsItalic sfsStrikeout sfsNormal " + "ldctStandardRoute ldctWizard ldctScript ldctFunction ldctRouteBlock ldctIntegratedReport ldctAnalyticReport ldctReferenceType ldctEDocumentType ldctDialog ldctServerEvents " + "mrcrtNone mrcrtUser mrcrtMaximal mrcrtCustom " + "vtEqual vtGreaterOrEqual vtLessOrEqual vtRange " + "rdYesterday rdToday rdTomorrow rdThisWeek rdThisMonth rdThisYear rdNextMonth rdNextWeek rdLastWeek rdLastMonth " + "rdWindow rdFile rdPrinter " + "rdtString rdtNumeric rdtInteger rdtDate rdtReference rdtAccount rdtText rdtPick rdtUnknown rdtLargeInteger rdtDocument " + "reOnChange reOnChangeValues " + "ttGlobal ttLocal ttUser ttSystem " + "ssmBrowse ssmSelect ssmMultiSelect ssmBrowseModal " + "smSelect smLike smCard " + "stNone stAuthenticating stApproving " + "sctString sctStream " + "sstAnsiSort sstNaturalSort " + "svtEqual svtContain " + "soatString soatNumeric soatInteger soatDatetime soatReferenceRecord soatText soatPick soatBoolean soatEDocument soatAccount soatIntegerCollection soatNumericCollection soatStringCollection soatPickCollection soatDatetimeCollection soatBooleanCollection soatReferenceRecordCollection soatEDocumentCollection soatAccountCollection soatContents soatUnknown " + "tarAbortByUser tarAbortByWorkflowException " + "tvtAllWords tvtExactPhrase tvtAnyWord " + "usNone usCompleted usRedSquare usBlueSquare usYellowSquare usGreenSquare usOrangeSquare usPurpleSquare usFollowUp " + "utUnknown utUser utDeveloper utAdministrator utSystemDeveloper utDisconnected " + "btAnd btDetailAnd btOr btNotOr btOnly " + "vmView vmSelect vmNavigation " + "vsmSingle vsmMultiple vsmMultipleCheck vsmNoSelection " + "wfatPrevious wfatNext wfatCancel wfatFinish " + "wfepUndefined wfepText3 wfepText6 wfepText9 wfepSpinEdit wfepDropDown wfepRadioGroup wfepFlag wfepText12 wfepText15 wfepText18 wfepText21 wfepText24 wfepText27 wfepText30 wfepRadioGroupColumn1 wfepRadioGroupColumn2 wfepRadioGroupColumn3 " + "wfetQueryParameter wfetText wfetDelimiter wfetLabel " + "wptString wptInteger wptNumeric wptBoolean wptDateTime wptPick wptText wptUser wptUserList wptEDocumentInfo wptEDocumentInfoList wptReferenceRecordInfo wptReferenceRecordInfoList wptFolderInfo wptTaskInfo wptContents wptFileName wptDate " + "wsrComplete wsrGoNext wsrGoPrevious wsrCustom wsrCancel wsrGoFinal " + "wstForm wstEDocument wstTaskCard wstReferenceRecordCard wstFinal " + "waAll waPerformers waManual " + "wsbStart wsbFinish wsbNotice wsbStep wsbDecision wsbWait wsbMonitor wsbScript wsbConnector wsbSubTask wsbLifeCycleStage wsbPause " + "wdtInteger wdtFloat wdtString wdtPick wdtDateTime wdtBoolean wdtTask wdtJob wdtFolder wdtEDocument wdtReferenceRecord wdtUser wdtGroup wdtRole wdtIntegerCollection wdtFloatCollection wdtStringCollection wdtPickCollection wdtDateTimeCollection wdtBooleanCollection wdtTaskCollection wdtJobCollection wdtFolderCollection wdtEDocumentCollection wdtReferenceRecordCollection wdtUserCollection wdtGroupCollection wdtRoleCollection wdtContents wdtUserList wdtSearchDescription wdtDeadLine wdtPickSet wdtAccountCollection " + "wiLow wiNormal wiHigh " + "wrtSoft wrtHard " + "wsInit wsRunning wsDone wsControlled wsAborted wsContinued " + "wtmFull wtmFromCurrent wtmOnlyCurrent ", Nr = "AddSubString AdjustLineBreaks AmountInWords Analysis ArrayDimCount ArrayHighBound ArrayLowBound ArrayOf ArrayReDim Assert Assigned BeginOfMonth BeginOfPeriod BuildProfilingOperationAnalysis CallProcedure CanReadFile CArrayElement CDataSetRequisite ChangeDate ChangeReferenceDataset Char CharPos CheckParam CheckParamValue CompareStrings ConstantExists ControlState ConvertDateStr Copy CopyFile CreateArray CreateCachedReference CreateConnection CreateDialog CreateDualListDialog CreateEditor CreateException CreateFile CreateFolderDialog CreateInputDialog CreateLinkFile CreateList CreateLock CreateMemoryDataSet CreateObject CreateOpenDialog CreateProgress CreateQuery CreateReference CreateReport CreateSaveDialog CreateScript CreateSQLPivotFunction CreateStringList CreateTreeListSelectDialog CSelectSQL CSQL CSubString CurrentUserID CurrentUserName CurrentVersion DataSetLocateEx DateDiff DateTimeDiff DateToStr DayOfWeek DeleteFile DirectoryExists DisableCheckAccessRights DisableCheckFullShowingRestriction DisableMassTaskSendingRestrictions DropTable DupeString EditText EnableCheckAccessRights EnableCheckFullShowingRestriction EnableMassTaskSendingRestrictions EndOfMonth EndOfPeriod ExceptionExists ExceptionsOff ExceptionsOn Execute ExecuteProcess Exit ExpandEnvironmentVariables ExtractFileDrive ExtractFileExt ExtractFileName ExtractFilePath ExtractParams FileExists FileSize FindFile FindSubString FirmContext ForceDirectories Format FormatDate FormatNumeric FormatSQLDate FormatString FreeException GetComponent GetComponentLaunchParam GetConstant GetLastException GetReferenceRecord GetRefTypeByRefID GetTableID GetTempFolder IfThen In IndexOf InputDialog InputDialogEx InteractiveMode IsFileLocked IsGraphicFile IsNumeric Length LoadString LoadStringFmt LocalTimeToUTC LowerCase Max MessageBox MessageBoxEx MimeDecodeBinary MimeDecodeString MimeEncodeBinary MimeEncodeString Min MoneyInWords MoveFile NewID Now OpenFile Ord Precision Raise ReadCertificateFromFile ReadFile ReferenceCodeByID ReferenceNumber ReferenceRequisiteMode ReferenceRequisiteValue RegionDateSettings RegionNumberSettings RegionTimeSettings RegRead RegWrite RenameFile Replace Round SelectServerCode SelectSQL ServerDateTime SetConstant SetManagedFolderFieldsState ShowConstantsInputDialog ShowMessage Sleep Split SQL SQL2XLSTAB SQLProfilingSendReport StrToDate SubString SubStringCount SystemSetting Time TimeDiff Today Transliterate Trim UpperCase UserStatus UTCToLocalTime ValidateXML VarIsClear VarIsEmpty VarIsNull WorkTimeDiff WriteFile WriteFileEx WriteObjectHistory Анализ БазаДанных БлокЕсть БлокЕстьРасш БлокИнфо БлокСнять БлокСнятьРасш БлокУстановить Ввод ВводМеню ВедС ВедСпр ВерхняяГраницаМассива ВнешПрогр Восст ВременнаяПапка Время ВыборSQL ВыбратьЗапись ВыделитьСтр Вызвать Выполнить ВыпПрогр ГрафическийФайл ГруппаДополнительно ДатаВремяСерв ДеньНедели ДиалогДаНет ДлинаСтр ДобПодстр ЕПусто ЕслиТо ЕЧисло ЗамПодстр ЗаписьСправочника ЗначПоляСпр ИДТипСпр ИзвлечьДиск ИзвлечьИмяФайла ИзвлечьПуть ИзвлечьРасширение ИзмДат ИзменитьРазмерМассива ИзмеренийМассива ИмяОрг ИмяПоляСпр Индекс ИндикаторЗакрыть ИндикаторОткрыть ИндикаторШаг ИнтерактивныйРежим ИтогТблСпр КодВидВедСпр КодВидСпрПоИД КодПоAnalit КодСимвола КодСпр КолПодстр КолПроп КонМес Конст КонстЕсть КонстЗнач КонТран КопироватьФайл КопияСтр КПериод КСтрТблСпр Макс МаксСтрТблСпр Массив Меню МенюРасш Мин НаборДанныхНайтиРасш НаимВидСпр НаимПоAnalit НаимСпр НастроитьПереводыСтрок НачМес НачТран НижняяГраницаМассива НомерСпр НПериод Окно Окр Окружение ОтлИнфДобавить ОтлИнфУдалить Отчет ОтчетАнал ОтчетИнт ПапкаСуществует Пауза ПВыборSQL ПереименоватьФайл Переменные ПереместитьФайл Подстр ПоискПодстр ПоискСтр ПолучитьИДТаблицы ПользовательДополнительно ПользовательИД ПользовательИмя ПользовательСтатус Прервать ПроверитьПараметр ПроверитьПараметрЗнач ПроверитьУсловие РазбСтр РазнВремя РазнДат РазнДатаВремя РазнРабВремя РегУстВрем РегУстДат РегУстЧсл РедТекст РеестрЗапись РеестрСписокИменПарам РеестрЧтение РеквСпр РеквСпрПр Сегодня Сейчас Сервер СерверПроцессИД СертификатФайлСчитать СжПроб Символ СистемаДиректумКод СистемаИнформация СистемаКод Содержит СоединениеЗакрыть СоединениеОткрыть СоздатьДиалог СоздатьДиалогВыбораИзДвухСписков СоздатьДиалогВыбораПапки СоздатьДиалогОткрытияФайла СоздатьДиалогСохраненияФайла СоздатьЗапрос СоздатьИндикатор СоздатьИсключение СоздатьКэшированныйСправочник СоздатьМассив СоздатьНаборДанных СоздатьОбъект СоздатьОтчет СоздатьПапку СоздатьРедактор СоздатьСоединение СоздатьСписок СоздатьСписокСтрок СоздатьСправочник СоздатьСценарий СоздСпр СостСпр Сохр СохрСпр СписокСистем Спр Справочник СпрБлокЕсть СпрБлокСнять СпрБлокСнятьРасш СпрБлокУстановить СпрИзмНабДан СпрКод СпрНомер СпрОбновить СпрОткрыть СпрОтменить СпрПарам СпрПолеЗнач СпрПолеИмя СпрРекв СпрРеквВведЗн СпрРеквНовые СпрРеквПр СпрРеквПредЗн СпрРеквРежим СпрРеквТипТекст СпрСоздать СпрСост СпрСохранить СпрТблИтог СпрТблСтр СпрТблСтрКол СпрТблСтрМакс СпрТблСтрМин СпрТблСтрПред СпрТблСтрСлед СпрТблСтрСозд СпрТблСтрУд СпрТекПредст СпрУдалить СравнитьСтр СтрВерхРегистр СтрНижнРегистр СтрТблСпр СумПроп Сценарий СценарийПарам ТекВерсия ТекОрг Точн Тран Транслитерация УдалитьТаблицу УдалитьФайл УдСпр УдСтрТблСпр Уст УстановкиКонстант ФайлАтрибутСчитать ФайлАтрибутУстановить ФайлВремя ФайлВремяУстановить ФайлВыбрать ФайлЗанят ФайлЗаписать ФайлИскать ФайлКопировать ФайлМожноЧитать ФайлОткрыть ФайлПереименовать ФайлПерекодировать ФайлПереместить ФайлПросмотреть ФайлРазмер ФайлСоздать ФайлСсылкаСоздать ФайлСуществует ФайлСчитать ФайлУдалить ФмтSQLДат ФмтДат ФмтСтр ФмтЧсл Формат ЦМассивЭлемент ЦНаборДанныхРеквизит ЦПодстр ", Bt = "AltState Application CallType ComponentTokens CreatedJobs CreatedNotices ControlState DialogResult Dialogs EDocuments EDocumentVersionSource Folders GlobalIDs Job Jobs InputValue LookUpReference LookUpRequisiteNames LookUpSearch Object ParentComponent Processes References Requisite ReportName Reports Result Scripts Searches SelectedAttachments SelectedItems SelectMode Sender ServerEvents ServiceFactory ShiftState SubTask SystemDialogs Tasks Wizard Wizards Work ВызовСпособ ИмяОтчета РеквЗнач ", Ma = "IApplication IAccessRights IAccountRepository IAccountSelectionRestrictions IAction IActionList IAdministrationHistoryDescription IAnchors IApplication IArchiveInfo IAttachment IAttachmentList ICheckListBox ICheckPointedList IColumn IComponent IComponentDescription IComponentToken IComponentTokenFactory IComponentTokenInfo ICompRecordInfo IConnection IContents IControl IControlJob IControlJobInfo IControlList ICrypto ICrypto2 ICustomJob ICustomJobInfo ICustomListBox ICustomObjectWizardStep ICustomWork ICustomWorkInfo IDataSet IDataSetAccessInfo IDataSigner IDateCriterion IDateRequisite IDateRequisiteDescription IDateValue IDeaAccessRights IDeaObjectInfo IDevelopmentComponentLock IDialog IDialogFactory IDialogPickRequisiteItems IDialogsFactory IDICSFactory IDocRequisite IDocumentInfo IDualListDialog IECertificate IECertificateInfo IECertificates IEditControl IEditorForm IEdmsExplorer IEdmsObject IEdmsObjectDescription IEdmsObjectFactory IEdmsObjectInfo IEDocument IEDocumentAccessRights IEDocumentDescription IEDocumentEditor IEDocumentFactory IEDocumentInfo IEDocumentStorage IEDocumentVersion IEDocumentVersionListDialog IEDocumentVersionSource IEDocumentWizardStep IEDocVerSignature IEDocVersionState IEnabledMode IEncodeProvider IEncrypter IEvent IEventList IException IExternalEvents IExternalHandler IFactory IField IFileDialog IFolder IFolderDescription IFolderDialog IFolderFactory IFolderInfo IForEach IForm IFormTitle IFormWizardStep IGlobalIDFactory IGlobalIDInfo IGrid IHasher IHistoryDescription IHyperLinkControl IImageButton IImageControl IInnerPanel IInplaceHint IIntegerCriterion IIntegerList IIntegerRequisite IIntegerValue IISBLEditorForm IJob IJobDescription IJobFactory IJobForm IJobInfo ILabelControl ILargeIntegerCriterion ILargeIntegerRequisite ILargeIntegerValue ILicenseInfo ILifeCycleStage IList IListBox ILocalIDInfo ILocalization ILock IMemoryDataSet IMessagingFactory IMetadataRepository INotice INoticeInfo INumericCriterion INumericRequisite INumericValue IObject IObjectDescription IObjectImporter IObjectInfo IObserver IPanelGroup IPickCriterion IPickProperty IPickRequisite IPickRequisiteDescription IPickRequisiteItem IPickRequisiteItems IPickValue IPrivilege IPrivilegeList IProcess IProcessFactory IProcessMessage IProgress IProperty IPropertyChangeEvent IQuery IReference IReferenceCriterion IReferenceEnabledMode IReferenceFactory IReferenceHistoryDescription IReferenceInfo IReferenceRecordCardWizardStep IReferenceRequisiteDescription IReferencesFactory IReferenceValue IRefRequisite IReport IReportFactory IRequisite IRequisiteDescription IRequisiteDescriptionList IRequisiteFactory IRichEdit IRouteStep IRule IRuleList ISchemeBlock IScript IScriptFactory ISearchCriteria ISearchCriterion ISearchDescription ISearchFactory ISearchFolderInfo ISearchForObjectDescription ISearchResultRestrictions ISecuredContext ISelectDialog IServerEvent IServerEventFactory IServiceDialog IServiceFactory ISignature ISignProvider ISignProvider2 ISignProvider3 ISimpleCriterion IStringCriterion IStringList IStringRequisite IStringRequisiteDescription IStringValue ISystemDialogsFactory ISystemInfo ITabSheet ITask ITaskAbortReasonInfo ITaskCardWizardStep ITaskDescription ITaskFactory ITaskInfo ITaskRoute ITextCriterion ITextRequisite ITextValue ITreeListSelectDialog IUser IUserList IValue IView IWebBrowserControl IWizard IWizardAction IWizardFactory IWizardFormElement IWizardParam IWizardPickParam IWizardReferenceParam IWizardStep IWorkAccessRights IWorkDescription IWorkflowAskableParam IWorkflowAskableParams IWorkflowBlock IWorkflowBlockResult IWorkflowEnabledMode IWorkflowParam IWorkflowPickParam IWorkflowReferenceParam IWorkState IWorkTreeCustomNode IWorkTreeJobNode IWorkTreeTaskNode IXMLEditorForm SBCrypto ", Fi = ke + ai, ne = Bt, Or = "null true false nil ", Xe = {
    className: "number",
    begin: t.NUMBER_RE,
    relevance: 0
  }, ve = {
    className: "string",
    variants: [
      {
        begin: '"',
        end: '"'
      },
      {
        begin: "'",
        end: "'"
      }
    ]
  }, xn = {
    className: "doctag",
    begin: "\\b(?:TODO|DONE|BEGIN|END|STUB|CHG|FIXME|NOTE|BUG|XXX)\\b",
    relevance: 0
  }, Sn = {
    className: "comment",
    begin: "//",
    end: "$",
    relevance: 0,
    contains: [
      t.PHRASAL_WORDS_MODE,
      xn
    ]
  }, Bi = {
    className: "comment",
    begin: "/\\*",
    end: "\\*/",
    relevance: 0,
    contains: [
      t.PHRASAL_WORDS_MODE,
      xn
    ]
  }, si = { variants: [
    Sn,
    Bi
  ] }, U = {
    $pattern: e,
    keyword: i,
    built_in: Fi,
    class: ne,
    literal: Or
  }, W = {
    begin: "\\.\\s*" + t.UNDERSCORE_IDENT_RE,
    keywords: U,
    relevance: 0
  }, se = {
    className: "type",
    begin: ":[ \\t]*(" + Ma.trim().replace(/\s/g, "|") + ")",
    end: "[ \\t]*=",
    excludeEnd: !0
  }, Te = {
    className: "variable",
    keywords: U,
    begin: e,
    relevance: 0,
    contains: [
      se,
      W
    ]
  }, it = n + "\\(";
  return {
    name: "ISBL",
    case_insensitive: !0,
    keywords: U,
    illegal: "\\$|\\?|%|,|;$|~|#|@|</",
    contains: [
      {
        className: "function",
        begin: it,
        end: "\\)$",
        returnBegin: !0,
        keywords: U,
        illegal: "[\\[\\]\\|\\$\\?%,~#@]",
        contains: [
          {
            className: "title",
            keywords: {
              $pattern: e,
              built_in: Nr
            },
            begin: it,
            end: "\\(",
            returnBegin: !0,
            excludeEnd: !0
          },
          W,
          Te,
          ve,
          Xe,
          si
        ]
      },
      se,
      W,
      Te,
      ve,
      Xe,
      si
    ]
  };
}
function YE(t) {
  const n = {
    className: "params",
    begin: /\(/,
    end: /\)/,
    contains: [{
      begin: /[\w-]+ *=/,
      returnBegin: !0,
      relevance: 0,
      contains: [
        {
          className: "attr",
          begin: /[\w-]+/
        }
      ]
    }],
    relevance: 0
  }, i = {
    className: "function",
    begin: /:[\w\-.]+/,
    relevance: 0
  }, r = {
    className: "string",
    begin: /\B([\/.])[\w\-.\/=]+/
  }, a = {
    className: "params",
    begin: /--[\w\-=\/]+/
  };
  return {
    name: "JBoss CLI",
    aliases: ["wildfly-cli"],
    keywords: {
      $pattern: "[a-z-]+",
      keyword: "alias batch cd clear command connect connection-factory connection-info data-source deploy deployment-info deployment-overlay echo echo-dmr help history if jdbc-driver-info jms-queue|20 jms-topic|20 ls patch pwd quit read-attribute read-operation reload rollout-plan run-batch set shutdown try unalias undeploy unset version xa-data-source",
      // module
      literal: "true false"
    },
    contains: [
      t.HASH_COMMENT_MODE,
      t.QUOTE_STRING_MODE,
      a,
      i,
      r,
      n
    ]
  };
}
function $E(t) {
  const e = "[A-Za-z_\\u00A1-\\uFFFF][A-Za-z_0-9\\u00A1-\\uFFFF]*", a = {
    $pattern: e,
    keyword: [
      "baremodule",
      "begin",
      "break",
      "catch",
      "ccall",
      "const",
      "continue",
      "do",
      "else",
      "elseif",
      "end",
      "export",
      "false",
      "finally",
      "for",
      "function",
      "global",
      "if",
      "import",
      "in",
      "isa",
      "let",
      "local",
      "macro",
      "module",
      "quote",
      "return",
      "true",
      "try",
      "using",
      "where",
      "while"
    ],
    literal: [
      "ARGS",
      "C_NULL",
      "DEPOT_PATH",
      "ENDIAN_BOM",
      "ENV",
      "Inf",
      "Inf16",
      "Inf32",
      "Inf64",
      "InsertionSort",
      "LOAD_PATH",
      "MergeSort",
      "NaN",
      "NaN16",
      "NaN32",
      "NaN64",
      "PROGRAM_FILE",
      "QuickSort",
      "RoundDown",
      "RoundFromZero",
      "RoundNearest",
      "RoundNearestTiesAway",
      "RoundNearestTiesUp",
      "RoundToZero",
      "RoundUp",
      "VERSION|0",
      "devnull",
      "false",
      "im",
      "missing",
      "nothing",
      "pi",
      "stderr",
      "stdin",
      "stdout",
      "true",
      "undef",
      "π",
      "ℯ"
    ],
    built_in: [
      "AbstractArray",
      "AbstractChannel",
      "AbstractChar",
      "AbstractDict",
      "AbstractDisplay",
      "AbstractFloat",
      "AbstractIrrational",
      "AbstractMatrix",
      "AbstractRange",
      "AbstractSet",
      "AbstractString",
      "AbstractUnitRange",
      "AbstractVecOrMat",
      "AbstractVector",
      "Any",
      "ArgumentError",
      "Array",
      "AssertionError",
      "BigFloat",
      "BigInt",
      "BitArray",
      "BitMatrix",
      "BitSet",
      "BitVector",
      "Bool",
      "BoundsError",
      "CapturedException",
      "CartesianIndex",
      "CartesianIndices",
      "Cchar",
      "Cdouble",
      "Cfloat",
      "Channel",
      "Char",
      "Cint",
      "Cintmax_t",
      "Clong",
      "Clonglong",
      "Cmd",
      "Colon",
      "Complex",
      "ComplexF16",
      "ComplexF32",
      "ComplexF64",
      "CompositeException",
      "Condition",
      "Cptrdiff_t",
      "Cshort",
      "Csize_t",
      "Cssize_t",
      "Cstring",
      "Cuchar",
      "Cuint",
      "Cuintmax_t",
      "Culong",
      "Culonglong",
      "Cushort",
      "Cvoid",
      "Cwchar_t",
      "Cwstring",
      "DataType",
      "DenseArray",
      "DenseMatrix",
      "DenseVecOrMat",
      "DenseVector",
      "Dict",
      "DimensionMismatch",
      "Dims",
      "DivideError",
      "DomainError",
      "EOFError",
      "Enum",
      "ErrorException",
      "Exception",
      "ExponentialBackOff",
      "Expr",
      "Float16",
      "Float32",
      "Float64",
      "Function",
      "GlobalRef",
      "HTML",
      "IO",
      "IOBuffer",
      "IOContext",
      "IOStream",
      "IdDict",
      "IndexCartesian",
      "IndexLinear",
      "IndexStyle",
      "InexactError",
      "InitError",
      "Int",
      "Int128",
      "Int16",
      "Int32",
      "Int64",
      "Int8",
      "Integer",
      "InterruptException",
      "InvalidStateException",
      "Irrational",
      "KeyError",
      "LinRange",
      "LineNumberNode",
      "LinearIndices",
      "LoadError",
      "MIME",
      "Matrix",
      "Method",
      "MethodError",
      "Missing",
      "MissingException",
      "Module",
      "NTuple",
      "NamedTuple",
      "Nothing",
      "Number",
      "OrdinalRange",
      "OutOfMemoryError",
      "OverflowError",
      "Pair",
      "PartialQuickSort",
      "PermutedDimsArray",
      "Pipe",
      "ProcessFailedException",
      "Ptr",
      "QuoteNode",
      "Rational",
      "RawFD",
      "ReadOnlyMemoryError",
      "Real",
      "ReentrantLock",
      "Ref",
      "Regex",
      "RegexMatch",
      "RoundingMode",
      "SegmentationFault",
      "Set",
      "Signed",
      "Some",
      "StackOverflowError",
      "StepRange",
      "StepRangeLen",
      "StridedArray",
      "StridedMatrix",
      "StridedVecOrMat",
      "StridedVector",
      "String",
      "StringIndexError",
      "SubArray",
      "SubString",
      "SubstitutionString",
      "Symbol",
      "SystemError",
      "Task",
      "TaskFailedException",
      "Text",
      "TextDisplay",
      "Timer",
      "Tuple",
      "Type",
      "TypeError",
      "TypeVar",
      "UInt",
      "UInt128",
      "UInt16",
      "UInt32",
      "UInt64",
      "UInt8",
      "UndefInitializer",
      "UndefKeywordError",
      "UndefRefError",
      "UndefVarError",
      "Union",
      "UnionAll",
      "UnitRange",
      "Unsigned",
      "Val",
      "Vararg",
      "VecElement",
      "VecOrMat",
      "Vector",
      "VersionNumber",
      "WeakKeyDict",
      "WeakRef"
    ]
  }, s = {
    keywords: a,
    illegal: /<\//
  }, o = {
    className: "number",
    // supported numeric literals:
    //  * binary literal (e.g. 0x10)
    //  * octal literal (e.g. 0o76543210)
    //  * hexadecimal literal (e.g. 0xfedcba876543210)
    //  * hexadecimal floating point literal (e.g. 0x1p0, 0x1.2p2)
    //  * decimal literal (e.g. 9876543210, 100_000_000)
    //  * floating pointe literal (e.g. 1.2, 1.2f, .2, 1., 1.2e10, 1.2e-10)
    begin: /(\b0x[\d_]*(\.[\d_]*)?|0x\.\d[\d_]*)p[-+]?\d+|\b0[box][a-fA-F0-9][a-fA-F0-9_]*|(\b\d[\d_]*(\.[\d_]*)?|\.\d[\d_]*)([eEfF][-+]?\d+)?/,
    relevance: 0
  }, l = {
    className: "string",
    begin: /'(.|\\[xXuU][a-zA-Z0-9]+)'/
  }, c = {
    className: "subst",
    begin: /\$\(/,
    end: /\)/,
    keywords: a
  }, d = {
    className: "variable",
    begin: "\\$" + e
  }, u = {
    className: "string",
    contains: [
      t.BACKSLASH_ESCAPE,
      c,
      d
    ],
    variants: [
      {
        begin: /\w*"""/,
        end: /"""\w*/,
        relevance: 10
      },
      {
        begin: /\w*"/,
        end: /"\w*/
      }
    ]
  }, _ = {
    className: "string",
    contains: [
      t.BACKSLASH_ESCAPE,
      c,
      d
    ],
    begin: "`",
    end: "`"
  }, m = {
    className: "meta",
    begin: "@" + e
  }, g = {
    className: "comment",
    variants: [
      {
        begin: "#=",
        end: "=#",
        relevance: 10
      },
      {
        begin: "#",
        end: "$"
      }
    ]
  };
  return s.name = "Julia", s.contains = [
    o,
    l,
    u,
    _,
    m,
    g,
    t.HASH_COMMENT_MODE,
    {
      className: "keyword",
      begin: "\\b(((abstract|primitive)\\s+)type|(mutable\\s+)?struct)\\b"
    },
    { begin: /<:/ }
    // relevance booster
  ], c.contains = s.contains, s;
}
function VE(t) {
  return {
    name: "Julia REPL",
    contains: [
      {
        className: "meta.prompt",
        begin: /^julia>/,
        relevance: 10,
        starts: {
          // end the highlighting if we are on a new line and the line does not have at
          // least six spaces in the beginning
          end: /^(?![ ]{6})/,
          subLanguage: "julia"
        }
      }
    ],
    // jldoctest Markdown blocks are used in the Julia manual and package docs indicate
    // code snippets that should be verified when the documentation is built. They can be
    // either REPL-like or script-like, but are usually REPL-like and therefore we apply
    // julia-repl highlighting to them. More information can be found in Documenter's
    // manual: https://juliadocs.github.io/Documenter.jl/latest/man/doctests.html
    aliases: ["jldoctest"]
  };
}
function HE(t) {
  const e = "[a-zA-Z_][\\w.]*", n = "<\\?(lasso(script)?|=)", i = "\\]|\\?>", r = {
    $pattern: e + "|&[lg]t;",
    literal: "true false none minimal full all void and or not bw nbw ew new cn ncn lt lte gt gte eq neq rx nrx ft",
    built_in: "array date decimal duration integer map pair string tag xml null boolean bytes keyword list locale queue set stack staticarray local var variable global data self inherited currentcapture givenblock",
    keyword: "cache database_names database_schemanames database_tablenames define_tag define_type email_batch encode_set html_comment handle handle_error header if inline iterate ljax_target link link_currentaction link_currentgroup link_currentrecord link_detail link_firstgroup link_firstrecord link_lastgroup link_lastrecord link_nextgroup link_nextrecord link_prevgroup link_prevrecord log loop namespace_using output_none portal private protect records referer referrer repeating resultset rows search_args search_arguments select sort_args sort_arguments thread_atomic value_list while abort case else fail_if fail_ifnot fail if_empty if_false if_null if_true loop_abort loop_continue loop_count params params_up return return_value run_children soap_definetag soap_lastrequest soap_lastresponse tag_name ascending average by define descending do equals frozen group handle_failure import in into join let match max min on order parent protected provide public require returnhome skip split_thread sum take thread to trait type where with yield yieldhome"
  }, a = t.COMMENT(
    "<!--",
    "-->",
    { relevance: 0 }
  ), s = {
    className: "meta",
    begin: "\\[noprocess\\]",
    starts: {
      end: "\\[/noprocess\\]",
      returnEnd: !0,
      contains: [a]
    }
  }, o = {
    className: "meta",
    begin: "\\[/noprocess|" + n
  }, l = {
    className: "symbol",
    begin: "'" + e + "'"
  }, c = [
    t.C_LINE_COMMENT_MODE,
    t.C_BLOCK_COMMENT_MODE,
    t.inherit(t.C_NUMBER_MODE, { begin: t.C_NUMBER_RE + "|(-?infinity|NaN)\\b" }),
    t.inherit(t.APOS_STRING_MODE, { illegal: null }),
    t.inherit(t.QUOTE_STRING_MODE, { illegal: null }),
    {
      className: "string",
      begin: "`",
      end: "`"
    },
    {
      // variables
      variants: [
        { begin: "[#$]" + e },
        {
          begin: "#",
          end: "\\d+",
          illegal: "\\W"
        }
      ]
    },
    {
      className: "type",
      begin: "::\\s*",
      end: e,
      illegal: "\\W"
    },
    {
      className: "params",
      variants: [
        {
          begin: "-(?!infinity)" + e,
          relevance: 0
        },
        { begin: "(\\.\\.\\.)" }
      ]
    },
    {
      begin: /(->|\.)\s*/,
      relevance: 0,
      contains: [l]
    },
    {
      className: "class",
      beginKeywords: "define",
      returnEnd: !0,
      end: "\\(|=>",
      contains: [t.inherit(t.TITLE_MODE, { begin: e + "(=(?!>))?|[-+*/%](?!>)" })]
    }
  ];
  return {
    name: "Lasso",
    aliases: [
      "ls",
      "lassoscript"
    ],
    case_insensitive: !0,
    keywords: r,
    contains: [
      {
        className: "meta",
        begin: i,
        relevance: 0,
        starts: {
          // markup
          end: "\\[|" + n,
          returnEnd: !0,
          relevance: 0,
          contains: [a]
        }
      },
      s,
      o,
      {
        className: "meta",
        begin: "\\[no_square_brackets",
        starts: {
          end: "\\[/no_square_brackets\\]",
          // not implemented in the language
          keywords: r,
          contains: [
            {
              className: "meta",
              begin: i,
              relevance: 0,
              starts: {
                end: "\\[noprocess\\]|" + n,
                returnEnd: !0,
                contains: [a]
              }
            },
            s,
            o
          ].concat(c)
        }
      },
      {
        className: "meta",
        begin: "\\[",
        relevance: 0
      },
      {
        className: "meta",
        begin: "^#!",
        end: "lasso9$",
        relevance: 10
      }
    ].concat(c)
  };
}
function qE(t) {
  const n = t.regex.either(...[
    "(?:NeedsTeXFormat|RequirePackage|GetIdInfo)",
    "Provides(?:Expl)?(?:Package|Class|File)",
    "(?:DeclareOption|ProcessOptions)",
    "(?:documentclass|usepackage|input|include)",
    "makeat(?:letter|other)",
    "ExplSyntax(?:On|Off)",
    "(?:new|renew|provide)?command",
    "(?:re)newenvironment",
    "(?:New|Renew|Provide|Declare)(?:Expandable)?DocumentCommand",
    "(?:New|Renew|Provide|Declare)DocumentEnvironment",
    "(?:(?:e|g|x)?def|let)",
    "(?:begin|end)",
    "(?:part|chapter|(?:sub){0,2}section|(?:sub)?paragraph)",
    "caption",
    "(?:label|(?:eq|page|name)?ref|(?:paren|foot|super)?cite)",
    "(?:alpha|beta|[Gg]amma|[Dd]elta|(?:var)?epsilon|zeta|eta|[Tt]heta|vartheta)",
    "(?:iota|(?:var)?kappa|[Ll]ambda|mu|nu|[Xx]i|[Pp]i|varpi|(?:var)rho)",
    "(?:[Ss]igma|varsigma|tau|[Uu]psilon|[Pp]hi|varphi|chi|[Pp]si|[Oo]mega)",
    "(?:frac|sum|prod|lim|infty|times|sqrt|leq|geq|left|right|middle|[bB]igg?)",
    "(?:[lr]angle|q?quad|[lcvdi]?dots|d?dot|hat|tilde|bar)"
  ].map((x) => x + "(?![a-zA-Z@:_])")), i = new RegExp([
    // A function \module_function_name:signature or \__module_function_name:signature,
    // where both module and function_name need at least two characters and
    // function_name may contain single underscores.
    "(?:__)?[a-zA-Z]{2,}_[a-zA-Z](?:_?[a-zA-Z])+:[a-zA-Z]*",
    // A variable \scope_module_and_name_type or \scope__module_ane_name_type,
    // where scope is one of l, g or c, type needs at least two characters
    // and module_and_name may contain single underscores.
    "[lgc]__?[a-zA-Z](?:_?[a-zA-Z])*_[a-zA-Z]{2,}",
    // A quark \q_the_name or \q__the_name or
    // scan mark \s_the_name or \s__vthe_name,
    // where variable_name needs at least two characters and
    // may contain single underscores.
    "[qs]__?[a-zA-Z](?:_?[a-zA-Z])+",
    // Other LaTeX3 macro names that are not covered by the three rules above.
    "use(?:_i)?:[a-zA-Z]*",
    "(?:else|fi|or):",
    "(?:if|cs|exp):w",
    "(?:hbox|vbox):n",
    "::[a-zA-Z]_unbraced",
    "::[a-zA-Z:]"
  ].map((x) => x + "(?![a-zA-Z:_])").join("|")), r = [
    { begin: /[a-zA-Z@]+/ },
    // control word
    { begin: /[^a-zA-Z@]?/ }
    // control symbol
  ], a = [
    { begin: /\^{6}[0-9a-f]{6}/ },
    { begin: /\^{5}[0-9a-f]{5}/ },
    { begin: /\^{4}[0-9a-f]{4}/ },
    { begin: /\^{3}[0-9a-f]{3}/ },
    { begin: /\^{2}[0-9a-f]{2}/ },
    { begin: /\^{2}[\u0000-\u007f]/ }
  ], s = {
    className: "keyword",
    begin: /\\/,
    relevance: 0,
    contains: [
      {
        endsParent: !0,
        begin: n
      },
      {
        endsParent: !0,
        begin: i
      },
      {
        endsParent: !0,
        variants: a
      },
      {
        endsParent: !0,
        relevance: 0,
        variants: r
      }
    ]
  }, o = {
    className: "params",
    relevance: 0,
    begin: /#+\d?/
  }, l = {
    // relevance: 1
    variants: a
  }, c = {
    className: "built_in",
    relevance: 0,
    begin: /[$&^_]/
  }, d = {
    className: "meta",
    begin: /% ?!(T[eE]X|tex|BIB|bib)/,
    end: "$",
    relevance: 10
  }, u = t.COMMENT(
    "%",
    "$",
    { relevance: 0 }
  ), _ = [
    s,
    o,
    l,
    c,
    d,
    u
  ], m = {
    begin: /\{/,
    end: /\}/,
    relevance: 0,
    contains: [
      "self",
      ..._
    ]
  }, g = t.inherit(
    m,
    {
      relevance: 0,
      endsParent: !0,
      contains: [
        m,
        ..._
      ]
    }
  ), S = {
    begin: /\[/,
    end: /\]/,
    endsParent: !0,
    relevance: 0,
    contains: [
      m,
      ..._
    ]
  }, E = {
    begin: /\s+/,
    relevance: 0
  }, h = [g], T = [S], b = function(x, B) {
    return {
      contains: [E],
      starts: {
        relevance: 0,
        contains: x,
        starts: B
      }
    };
  }, C = function(x, B) {
    return {
      begin: "\\\\" + x + "(?![a-zA-Z@:_])",
      keywords: {
        $pattern: /\\[a-zA-Z]+/,
        keyword: "\\" + x
      },
      relevance: 0,
      contains: [E],
      starts: B
    };
  }, y = function(x, B) {
    return t.inherit(
      {
        begin: "\\\\begin(?=[ 	]*(\\r?\\n[ 	]*)?\\{" + x + "\\})",
        keywords: {
          $pattern: /\\[a-zA-Z]+/,
          keyword: "\\begin"
        },
        relevance: 0
      },
      b(h, B)
    );
  }, O = (x = "string") => t.END_SAME_AS_BEGIN({
    className: x,
    begin: /(.|\r?\n)/,
    end: /(.|\r?\n)/,
    excludeBegin: !0,
    excludeEnd: !0,
    endsParent: !0
  }), A = function(x) {
    return {
      className: "string",
      end: "(?=\\\\end\\{" + x + "\\})"
    };
  }, I = (x = "string") => ({
    relevance: 0,
    begin: /\{/,
    starts: {
      endsParent: !0,
      contains: [
        {
          className: x,
          end: /(?=\})/,
          endsParent: !0,
          contains: [
            {
              begin: /\{/,
              end: /\}/,
              relevance: 0,
              contains: ["self"]
            }
          ]
        }
      ]
    }
  }), k = [
    ...[
      "verb",
      "lstinline"
    ].map((x) => C(x, { contains: [O()] })),
    C("mint", b(h, { contains: [O()] })),
    C("mintinline", b(h, { contains: [
      I(),
      O()
    ] })),
    C("url", { contains: [
      I("link"),
      I("link")
    ] }),
    C("hyperref", { contains: [I("link")] }),
    C("href", b(T, { contains: [I("link")] })),
    ...[].concat(...[
      "",
      "\\*"
    ].map((x) => [
      y("verbatim" + x, A("verbatim" + x)),
      y("filecontents" + x, b(h, A("filecontents" + x))),
      ...[
        "",
        "B",
        "L"
      ].map(
        (B) => y(B + "Verbatim" + x, b(T, A(B + "Verbatim" + x)))
      )
    ])),
    y("minted", b(T, b(h, A("minted"))))
  ];
  return {
    name: "LaTeX",
    aliases: ["tex"],
    contains: [
      ...k,
      ..._
    ]
  };
}
function zE(t) {
  return {
    name: "LDIF",
    contains: [
      {
        className: "attribute",
        match: "^dn(?=:)",
        relevance: 10
      },
      {
        className: "attribute",
        match: "^\\w+(?=:)"
      },
      {
        className: "literal",
        match: "^-"
      },
      t.HASH_COMMENT_MODE
    ]
  };
}
function WE(t) {
  const e = /([A-Za-z_][A-Za-z_0-9]*)?/, i = {
    scope: "params",
    begin: /\(/,
    end: /\)(?=\:?)/,
    endsParent: !0,
    relevance: 7,
    contains: [
      {
        scope: "string",
        begin: '"',
        end: '"'
      },
      {
        scope: "keyword",
        match: [
          "true",
          "false",
          "in"
        ].join("|")
      },
      {
        scope: "variable",
        match: /[A-Za-z_][A-Za-z_0-9]*/
      },
      {
        scope: "operator",
        match: /\+|\-|\*|\/|\%|\=\=|\=|\!|\>|\<|\&\&|\|\|/
      }
    ]
  }, r = {
    match: [
      e,
      /(?=\()/
    ],
    scope: {
      1: "keyword"
    },
    contains: [i]
  };
  return i.contains.unshift(r), {
    name: "Leaf",
    contains: [
      // #ident():
      {
        match: [
          /#+/,
          e,
          /(?=\()/
        ],
        scope: {
          1: "punctuation",
          2: "keyword"
        },
        // will start up after the ending `)` match from line ~44
        // just to grab the trailing `:` if we can match it
        starts: {
          contains: [
            {
              match: /\:/,
              scope: "punctuation"
            }
          ]
        },
        contains: [
          i
        ]
      },
      // #ident or #ident:
      {
        match: [
          /#+/,
          e,
          /:?/
        ],
        scope: {
          1: "punctuation",
          2: "keyword",
          3: "punctuation"
        }
      }
    ]
  };
}
function KE(t) {
  const e = "[a-zA-Z_\\-+\\*\\/<=>&#][a-zA-Z0-9_\\-+*\\/<=>&#!]*", n = "\\|[^]*?\\|", i = "(-|\\+)?\\d+(\\.\\d+|\\/\\d+)?((d|e|f|l|s|D|E|F|L|S)(\\+|-)?\\d+)?", r = {
    className: "literal",
    begin: "\\b(t{1}|nil)\\b"
  }, a = {
    className: "number",
    variants: [
      {
        begin: i,
        relevance: 0
      },
      { begin: "#(b|B)[0-1]+(/[0-1]+)?" },
      { begin: "#(o|O)[0-7]+(/[0-7]+)?" },
      { begin: "#(x|X)[0-9a-fA-F]+(/[0-9a-fA-F]+)?" },
      {
        begin: "#(c|C)\\(" + i + " +" + i,
        end: "\\)"
      }
    ]
  }, s = t.inherit(t.QUOTE_STRING_MODE, { illegal: null }), o = t.COMMENT(
    ";",
    "$",
    { relevance: 0 }
  ), l = {
    begin: "\\*",
    end: "\\*"
  }, c = {
    className: "symbol",
    begin: "[:&]" + e
  }, d = {
    begin: e,
    relevance: 0
  }, u = { begin: n }, m = {
    contains: [
      a,
      s,
      l,
      c,
      {
        begin: "\\(",
        end: "\\)",
        contains: [
          "self",
          r,
          s,
          a,
          d
        ]
      },
      d
    ],
    variants: [
      {
        begin: "['`]\\(",
        end: "\\)"
      },
      {
        begin: "\\(quote ",
        end: "\\)",
        keywords: { name: "quote" }
      },
      { begin: "'" + n }
    ]
  }, g = { variants: [
    { begin: "'" + e },
    { begin: "#'" + e + "(::" + e + ")*" }
  ] }, S = {
    begin: "\\(\\s*",
    end: "\\)"
  }, E = {
    endsWithParent: !0,
    relevance: 0
  };
  return S.contains = [
    {
      className: "name",
      variants: [
        {
          begin: e,
          relevance: 0
        },
        { begin: n }
      ]
    },
    E
  ], E.contains = [
    m,
    g,
    S,
    r,
    a,
    s,
    o,
    l,
    c,
    u,
    d
  ], {
    name: "Lisp",
    illegal: /\S/,
    contains: [
      a,
      t.SHEBANG(),
      r,
      s,
      o,
      m,
      g,
      S,
      d
    ]
  };
}
function QE(t) {
  const e = {
    className: "variable",
    variants: [
      { begin: "\\b([gtps][A-Z]{1}[a-zA-Z0-9]*)(\\[.+\\])?(?:\\s*?)" },
      { begin: "\\$_[A-Z]+" }
    ],
    relevance: 0
  }, n = [
    t.C_BLOCK_COMMENT_MODE,
    t.HASH_COMMENT_MODE,
    t.COMMENT("--", "$"),
    t.COMMENT("[^:]//", "$")
  ], i = t.inherit(t.TITLE_MODE, { variants: [
    { begin: "\\b_*rig[A-Z][A-Za-z0-9_\\-]*" },
    { begin: "\\b_[a-z0-9\\-]+" }
  ] }), r = t.inherit(t.TITLE_MODE, { begin: "\\b([A-Za-z0-9_\\-]+)\\b" });
  return {
    name: "LiveCode",
    case_insensitive: !1,
    keywords: {
      keyword: "$_COOKIE $_FILES $_GET $_GET_BINARY $_GET_RAW $_POST $_POST_BINARY $_POST_RAW $_SESSION $_SERVER codepoint codepoints segment segments codeunit codeunits sentence sentences trueWord trueWords paragraph after byte bytes english the until http forever descending using line real8 with seventh for stdout finally element word words fourth before black ninth sixth characters chars stderr uInt1 uInt1s uInt2 uInt2s stdin string lines relative rel any fifth items from middle mid at else of catch then third it file milliseconds seconds second secs sec int1 int1s int4 int4s internet int2 int2s normal text item last long detailed effective uInt4 uInt4s repeat end repeat URL in try into switch to words https token binfile each tenth as ticks tick system real4 by dateItems without char character ascending eighth whole dateTime numeric short first ftp integer abbreviated abbr abbrev private case while if div mod wrap and or bitAnd bitNot bitOr bitXor among not in a an within contains ends with begins the keys of keys",
      literal: "SIX TEN FORMFEED NINE ZERO NONE SPACE FOUR FALSE COLON CRLF PI COMMA ENDOFFILE EOF EIGHT FIVE QUOTE EMPTY ONE TRUE RETURN CR LINEFEED RIGHT BACKSLASH NULL SEVEN TAB THREE TWO six ten formfeed nine zero none space four false colon crlf pi comma endoffile eof eight five quote empty one true return cr linefeed right backslash null seven tab three two RIVERSION RISTATE FILE_READ_MODE FILE_WRITE_MODE FILE_WRITE_MODE DIR_WRITE_MODE FILE_READ_UMASK FILE_WRITE_UMASK DIR_READ_UMASK DIR_WRITE_UMASK",
      built_in: "put abs acos aliasReference annuity arrayDecode arrayEncode asin atan atan2 average avg avgDev base64Decode base64Encode baseConvert binaryDecode binaryEncode byteOffset byteToNum cachedURL cachedURLs charToNum cipherNames codepointOffset codepointProperty codepointToNum codeunitOffset commandNames compound compress constantNames cos date dateFormat decompress difference directories diskSpace DNSServers exp exp1 exp2 exp10 extents files flushEvents folders format functionNames geometricMean global globals hasMemory harmonicMean hostAddress hostAddressToName hostName hostNameToAddress isNumber ISOToMac itemOffset keys len length libURLErrorData libUrlFormData libURLftpCommand libURLLastHTTPHeaders libURLLastRHHeaders libUrlMultipartFormAddPart libUrlMultipartFormData libURLVersion lineOffset ln ln1 localNames log log2 log10 longFilePath lower macToISO matchChunk matchText matrixMultiply max md5Digest median merge messageAuthenticationCode messageDigest millisec millisecs millisecond milliseconds min monthNames nativeCharToNum normalizeText num number numToByte numToChar numToCodepoint numToNativeChar offset open openfiles openProcesses openProcessIDs openSockets paragraphOffset paramCount param params peerAddress pendingMessages platform popStdDev populationStandardDeviation populationVariance popVariance processID random randomBytes replaceText result revCreateXMLTree revCreateXMLTreeFromFile revCurrentRecord revCurrentRecordIsFirst revCurrentRecordIsLast revDatabaseColumnCount revDatabaseColumnIsNull revDatabaseColumnLengths revDatabaseColumnNames revDatabaseColumnNamed revDatabaseColumnNumbered revDatabaseColumnTypes revDatabaseConnectResult revDatabaseCursors revDatabaseID revDatabaseTableNames revDatabaseType revDataFromQuery revdb_closeCursor revdb_columnbynumber revdb_columncount revdb_columnisnull revdb_columnlengths revdb_columnnames revdb_columntypes revdb_commit revdb_connect revdb_connections revdb_connectionerr revdb_currentrecord revdb_cursorconnection revdb_cursorerr revdb_cursors revdb_dbtype revdb_disconnect revdb_execute revdb_iseof revdb_isbof revdb_movefirst revdb_movelast revdb_movenext revdb_moveprev revdb_query revdb_querylist revdb_recordcount revdb_rollback revdb_tablenames revGetDatabaseDriverPath revNumberOfRecords revOpenDatabase revOpenDatabases revQueryDatabase revQueryDatabaseBlob revQueryResult revQueryIsAtStart revQueryIsAtEnd revUnixFromMacPath revXMLAttribute revXMLAttributes revXMLAttributeValues revXMLChildContents revXMLChildNames revXMLCreateTreeFromFileWithNamespaces revXMLCreateTreeWithNamespaces revXMLDataFromXPathQuery revXMLEvaluateXPath revXMLFirstChild revXMLMatchingNode revXMLNextSibling revXMLNodeContents revXMLNumberOfChildren revXMLParent revXMLPreviousSibling revXMLRootNode revXMLRPC_CreateRequest revXMLRPC_Documents revXMLRPC_Error revXMLRPC_GetHost revXMLRPC_GetMethod revXMLRPC_GetParam revXMLText revXMLRPC_Execute revXMLRPC_GetParamCount revXMLRPC_GetParamNode revXMLRPC_GetParamType revXMLRPC_GetPath revXMLRPC_GetPort revXMLRPC_GetProtocol revXMLRPC_GetRequest revXMLRPC_GetResponse revXMLRPC_GetSocket revXMLTree revXMLTrees revXMLValidateDTD revZipDescribeItem revZipEnumerateItems revZipOpenArchives round sampVariance sec secs seconds sentenceOffset sha1Digest shell shortFilePath sin specialFolderPath sqrt standardDeviation statRound stdDev sum sysError systemVersion tan tempName textDecode textEncode tick ticks time to tokenOffset toLower toUpper transpose truewordOffset trunc uniDecode uniEncode upper URLDecode URLEncode URLStatus uuid value variableNames variance version waitDepth weekdayNames wordOffset xsltApplyStylesheet xsltApplyStylesheetFromFile xsltLoadStylesheet xsltLoadStylesheetFromFile add breakpoint cancel clear local variable file word line folder directory URL close socket process combine constant convert create new alias folder directory decrypt delete variable word line folder directory URL dispatch divide do encrypt filter get include intersect kill libURLDownloadToFile libURLFollowHttpRedirects libURLftpUpload libURLftpUploadFile libURLresetAll libUrlSetAuthCallback libURLSetDriver libURLSetCustomHTTPHeaders libUrlSetExpect100 libURLSetFTPListCommand libURLSetFTPMode libURLSetFTPStopTime libURLSetStatusCallback load extension loadedExtensions multiply socket prepare process post seek rel relative read from process rename replace require resetAll resolve revAddXMLNode revAppendXML revCloseCursor revCloseDatabase revCommitDatabase revCopyFile revCopyFolder revCopyXMLNode revDeleteFolder revDeleteXMLNode revDeleteAllXMLTrees revDeleteXMLTree revExecuteSQL revGoURL revInsertXMLNode revMoveFolder revMoveToFirstRecord revMoveToLastRecord revMoveToNextRecord revMoveToPreviousRecord revMoveToRecord revMoveXMLNode revPutIntoXMLNode revRollBackDatabase revSetDatabaseDriverPath revSetXMLAttribute revXMLRPC_AddParam revXMLRPC_DeleteAllDocuments revXMLAddDTD revXMLRPC_Free revXMLRPC_FreeAll revXMLRPC_DeleteDocument revXMLRPC_DeleteParam revXMLRPC_SetHost revXMLRPC_SetMethod revXMLRPC_SetPort revXMLRPC_SetProtocol revXMLRPC_SetSocket revZipAddItemWithData revZipAddItemWithFile revZipAddUncompressedItemWithData revZipAddUncompressedItemWithFile revZipCancel revZipCloseArchive revZipDeleteItem revZipExtractItemToFile revZipExtractItemToVariable revZipSetProgressCallback revZipRenameItem revZipReplaceItemWithData revZipReplaceItemWithFile revZipOpenArchive send set sort split start stop subtract symmetric union unload vectorDotProduct wait write"
    },
    contains: [
      e,
      {
        className: "keyword",
        begin: "\\bend\\sif\\b"
      },
      {
        className: "function",
        beginKeywords: "function",
        end: "$",
        contains: [
          e,
          r,
          t.APOS_STRING_MODE,
          t.QUOTE_STRING_MODE,
          t.BINARY_NUMBER_MODE,
          t.C_NUMBER_MODE,
          i
        ]
      },
      {
        className: "function",
        begin: "\\bend\\s+",
        end: "$",
        keywords: "end",
        contains: [
          r,
          i
        ],
        relevance: 0
      },
      {
        beginKeywords: "command on",
        end: "$",
        contains: [
          e,
          r,
          t.APOS_STRING_MODE,
          t.QUOTE_STRING_MODE,
          t.BINARY_NUMBER_MODE,
          t.C_NUMBER_MODE,
          i
        ]
      },
      {
        className: "meta",
        variants: [
          {
            begin: "<\\?(rev|lc|livecode)",
            relevance: 10
          },
          { begin: "<\\?" },
          { begin: "\\?>" }
        ]
      },
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE,
      t.BINARY_NUMBER_MODE,
      t.C_NUMBER_MODE,
      i
    ].concat(n),
    illegal: ";$|^\\[|^=|&|\\{"
  };
}
const XE = [
  "as",
  // for exports
  "in",
  "of",
  "if",
  "for",
  "while",
  "finally",
  "var",
  "new",
  "function",
  "do",
  "return",
  "void",
  "else",
  "break",
  "catch",
  "instanceof",
  "with",
  "throw",
  "case",
  "default",
  "try",
  "switch",
  "continue",
  "typeof",
  "delete",
  "let",
  "yield",
  "const",
  "class",
  // JS handles these with a special rule
  // "get",
  // "set",
  "debugger",
  "async",
  "await",
  "static",
  "import",
  "from",
  "export",
  "extends",
  // It's reached stage 3, which is "recommended for implementation":
  "using"
], ZE = [
  "true",
  "false",
  "null",
  "undefined",
  "NaN",
  "Infinity"
], JE = [
  // Fundamental objects
  "Object",
  "Function",
  "Boolean",
  "Symbol",
  // numbers and dates
  "Math",
  "Date",
  "Number",
  "BigInt",
  // text
  "String",
  "RegExp",
  // Indexed collections
  "Array",
  "Float32Array",
  "Float64Array",
  "Int8Array",
  "Uint8Array",
  "Uint8ClampedArray",
  "Int16Array",
  "Int32Array",
  "Uint16Array",
  "Uint32Array",
  "BigInt64Array",
  "BigUint64Array",
  // Keyed collections
  "Set",
  "Map",
  "WeakSet",
  "WeakMap",
  // Structured data
  "ArrayBuffer",
  "SharedArrayBuffer",
  "Atomics",
  "DataView",
  "JSON",
  // Control abstraction objects
  "Promise",
  "Generator",
  "GeneratorFunction",
  "AsyncFunction",
  // Reflection
  "Reflect",
  "Proxy",
  // Internationalization
  "Intl",
  // WebAssembly
  "WebAssembly"
], jE = [
  "Error",
  "EvalError",
  "InternalError",
  "RangeError",
  "ReferenceError",
  "SyntaxError",
  "TypeError",
  "URIError"
], eg = [
  "setInterval",
  "setTimeout",
  "clearInterval",
  "clearTimeout",
  "require",
  "exports",
  "eval",
  "isFinite",
  "isNaN",
  "parseFloat",
  "parseInt",
  "decodeURI",
  "decodeURIComponent",
  "encodeURI",
  "encodeURIComponent",
  "escape",
  "unescape"
], tg = [].concat(
  eg,
  JE,
  jE
);
function ng(t) {
  const e = [
    "npm",
    "print"
  ], n = [
    "yes",
    "no",
    "on",
    "off",
    "it",
    "that",
    "void"
  ], i = [
    "then",
    "unless",
    "until",
    "loop",
    "of",
    "by",
    "when",
    "and",
    "or",
    "is",
    "isnt",
    "not",
    "it",
    "that",
    "otherwise",
    "from",
    "to",
    "til",
    "fallthrough",
    "case",
    "enum",
    "native",
    "list",
    "map",
    "__hasProp",
    "__extends",
    "__slice",
    "__bind",
    "__indexOf"
  ], r = {
    keyword: XE.concat(i),
    literal: ZE.concat(n),
    built_in: tg.concat(e)
  }, a = "[A-Za-z$_](?:-[0-9A-Za-z$_]|[0-9A-Za-z$_])*", s = t.inherit(t.TITLE_MODE, { begin: a }), o = {
    className: "subst",
    begin: /#\{/,
    end: /\}/,
    keywords: r
  }, l = {
    className: "subst",
    begin: /#[A-Za-z$_]/,
    end: /(?:-[0-9A-Za-z$_]|[0-9A-Za-z$_])*/,
    keywords: r
  }, c = [
    t.BINARY_NUMBER_MODE,
    {
      className: "number",
      begin: "(\\b0[xX][a-fA-F0-9_]+)|(\\b\\d(\\d|_\\d)*(\\.(\\d(\\d|_\\d)*)?)?(_*[eE]([-+]\\d(_\\d|\\d)*)?)?[_a-z]*)",
      relevance: 0,
      starts: {
        end: "(\\s*/)?",
        relevance: 0
      }
      // a number tries to eat the following slash to prevent treating it as a regexp
    },
    {
      className: "string",
      variants: [
        {
          begin: /'''/,
          end: /'''/,
          contains: [t.BACKSLASH_ESCAPE]
        },
        {
          begin: /'/,
          end: /'/,
          contains: [t.BACKSLASH_ESCAPE]
        },
        {
          begin: /"""/,
          end: /"""/,
          contains: [
            t.BACKSLASH_ESCAPE,
            o,
            l
          ]
        },
        {
          begin: /"/,
          end: /"/,
          contains: [
            t.BACKSLASH_ESCAPE,
            o,
            l
          ]
        },
        {
          begin: /\\/,
          end: /(\s|$)/,
          excludeEnd: !0
        }
      ]
    },
    {
      className: "regexp",
      variants: [
        {
          begin: "//",
          end: "//[gim]*",
          contains: [
            o,
            t.HASH_COMMENT_MODE
          ]
        },
        {
          // regex can't start with space to parse x / 2 / 3 as two divisions
          // regex can't start with *, and it supports an "illegal" in the main mode
          begin: /\/(?![ *])(\\.|[^\\\n])*?\/[gim]*(?=\W)/
        }
      ]
    },
    { begin: "@" + a },
    {
      begin: "``",
      end: "``",
      excludeBegin: !0,
      excludeEnd: !0,
      subLanguage: "javascript"
    }
  ];
  o.contains = c;
  const d = {
    className: "params",
    begin: "\\(",
    returnBegin: !0,
    /* We need another contained nameless mode to not have every nested
    pair of parens to be called "params" */
    contains: [
      {
        begin: /\(/,
        end: /\)/,
        keywords: r,
        contains: ["self"].concat(c)
      }
    ]
  }, u = { begin: "(#=>|=>|\\|>>|-?->|!->)" }, _ = {
    variants: [
      { match: [
        /class\s+/,
        a,
        /\s+extends\s+/,
        a
      ] },
      { match: [
        /class\s+/,
        a
      ] }
    ],
    scope: {
      2: "title.class",
      4: "title.class.inherited"
    },
    keywords: r
  };
  return {
    name: "LiveScript",
    aliases: ["ls"],
    keywords: r,
    illegal: /\/\*/,
    contains: c.concat([
      t.COMMENT("\\/\\*", "\\*\\/"),
      t.HASH_COMMENT_MODE,
      u,
      // relevance booster
      {
        className: "function",
        contains: [
          s,
          d
        ],
        returnBegin: !0,
        variants: [
          {
            begin: "(" + a + "\\s*(?:=|:=)\\s*)?(\\(.*\\)\\s*)?\\B->\\*?",
            end: "->\\*?"
          },
          {
            begin: "(" + a + "\\s*(?:=|:=)\\s*)?!?(\\(.*\\)\\s*)?\\B[-~]{1,2}>\\*?",
            end: "[-~]{1,2}>\\*?"
          },
          {
            begin: "(" + a + "\\s*(?:=|:=)\\s*)?(\\(.*\\)\\s*)?\\B!?[-~]{1,2}>\\*?",
            end: "!?[-~]{1,2}>\\*?"
          }
        ]
      },
      _,
      {
        begin: a + ":",
        end: ":",
        returnBegin: !0,
        returnEnd: !0,
        relevance: 0
      }
    ])
  };
}
function ig(t) {
  const e = t.regex, n = /([-a-zA-Z$._][\w$.-]*)/, i = {
    className: "type",
    begin: /\bi\d+(?=\s|\b)/
  }, r = {
    className: "operator",
    relevance: 0,
    begin: /=/
  }, a = {
    className: "punctuation",
    relevance: 0,
    begin: /,/
  }, s = {
    className: "number",
    variants: [
      { begin: /[su]?0[xX][KMLHR]?[a-fA-F0-9]+/ },
      { begin: /[-+]?\d+(?:[.]\d+)?(?:[eE][-+]?\d+(?:[.]\d+)?)?/ }
    ],
    relevance: 0
  }, o = {
    className: "symbol",
    variants: [
      { begin: /^\s*[a-z]+:/ }
      // labels
    ],
    relevance: 0
  }, l = {
    className: "variable",
    variants: [
      { begin: e.concat(/%/, n) },
      { begin: /%\d+/ },
      { begin: /#\d+/ }
    ]
  }, c = {
    className: "title",
    variants: [
      { begin: e.concat(/@/, n) },
      { begin: /@\d+/ },
      { begin: e.concat(/!/, n) },
      { begin: e.concat(/!\d+/, n) },
      // https://llvm.org/docs/LangRef.html#namedmetadatastructure
      // obviously a single digit can also be used in this fashion
      { begin: /!\d+/ }
    ]
  };
  return {
    name: "LLVM IR",
    // TODO: split into different categories of keywords
    keywords: {
      keyword: "begin end true false declare define global constant private linker_private internal available_externally linkonce linkonce_odr weak weak_odr appending dllimport dllexport common default hidden protected extern_weak external thread_local zeroinitializer undef null to tail target triple datalayout volatile nuw nsw nnan ninf nsz arcp fast exact inbounds align addrspace section alias module asm sideeffect gc dbg linker_private_weak attributes blockaddress initialexec localdynamic localexec prefix unnamed_addr ccc fastcc coldcc x86_stdcallcc x86_fastcallcc arm_apcscc arm_aapcscc arm_aapcs_vfpcc ptx_device ptx_kernel intel_ocl_bicc msp430_intrcc spir_func spir_kernel x86_64_sysvcc x86_64_win64cc x86_thiscallcc cc c signext zeroext inreg sret nounwind noreturn noalias nocapture byval nest readnone readonly inlinehint noinline alwaysinline optsize ssp sspreq noredzone noimplicitfloat naked builtin cold nobuiltin noduplicate nonlazybind optnone returns_twice sanitize_address sanitize_memory sanitize_thread sspstrong uwtable returned type opaque eq ne slt sgt sle sge ult ugt ule uge oeq one olt ogt ole oge ord uno ueq une x acq_rel acquire alignstack atomic catch cleanup filter inteldialect max min monotonic nand personality release seq_cst singlethread umax umin unordered xchg add fadd sub fsub mul fmul udiv sdiv fdiv urem srem frem shl lshr ashr and or xor icmp fcmp phi call trunc zext sext fptrunc fpext uitofp sitofp fptoui fptosi inttoptr ptrtoint bitcast addrspacecast select va_arg ret br switch invoke unwind unreachable indirectbr landingpad resume malloc alloca free load store getelementptr extractelement insertelement shufflevector getresult extractvalue insertvalue atomicrmw cmpxchg fence argmemonly",
      type: "void half bfloat float double fp128 x86_fp80 ppc_fp128 x86_amx x86_mmx ptr label token metadata opaque"
    },
    contains: [
      i,
      // this matches "empty comments"...
      // ...because it's far more likely this is a statement terminator in
      // another language than an actual comment
      t.COMMENT(/;\s*$/, null, { relevance: 0 }),
      t.COMMENT(/;/, /$/),
      {
        className: "string",
        begin: /"/,
        end: /"/,
        contains: [
          {
            className: "char.escape",
            match: /\\\d\d/
          }
        ]
      },
      c,
      a,
      r,
      l,
      o,
      s
    ]
  };
}
function rg(t) {
  const n = {
    className: "string",
    begin: '"',
    end: '"',
    contains: [{
      className: "subst",
      begin: /\\[tn"\\]/
    }]
  }, i = {
    className: "number",
    relevance: 0,
    begin: t.C_NUMBER_RE
  }, r = {
    className: "literal",
    variants: [
      { begin: "\\b(PI|TWO_PI|PI_BY_TWO|DEG_TO_RAD|RAD_TO_DEG|SQRT2)\\b" },
      { begin: "\\b(XP_ERROR_(EXPERIENCES_DISABLED|EXPERIENCE_(DISABLED|SUSPENDED)|INVALID_(EXPERIENCE|PARAMETERS)|KEY_NOT_FOUND|MATURITY_EXCEEDED|NONE|NOT_(FOUND|PERMITTED(_LAND)?)|NO_EXPERIENCE|QUOTA_EXCEEDED|RETRY_UPDATE|STORAGE_EXCEPTION|STORE_DISABLED|THROTTLED|UNKNOWN_ERROR)|JSON_APPEND|STATUS_(PHYSICS|ROTATE_[XYZ]|PHANTOM|SANDBOX|BLOCK_GRAB(_OBJECT)?|(DIE|RETURN)_AT_EDGE|CAST_SHADOWS|OK|MALFORMED_PARAMS|TYPE_MISMATCH|BOUNDS_ERROR|NOT_(FOUND|SUPPORTED)|INTERNAL_ERROR|WHITELIST_FAILED)|AGENT(_(BY_(LEGACY_|USER)NAME|FLYING|ATTACHMENTS|SCRIPTED|MOUSELOOK|SITTING|ON_OBJECT|AWAY|WALKING|IN_AIR|TYPING|CROUCHING|BUSY|ALWAYS_RUN|AUTOPILOT|LIST_(PARCEL(_OWNER)?|REGION)))?|CAMERA_(PITCH|DISTANCE|BEHINDNESS_(ANGLE|LAG)|(FOCUS|POSITION)(_(THRESHOLD|LOCKED|LAG))?|FOCUS_OFFSET|ACTIVE)|ANIM_ON|LOOP|REVERSE|PING_PONG|SMOOTH|ROTATE|SCALE|ALL_SIDES|LINK_(ROOT|SET|ALL_(OTHERS|CHILDREN)|THIS)|ACTIVE|PASS(IVE|_(ALWAYS|IF_NOT_HANDLED|NEVER))|SCRIPTED|CONTROL_(FWD|BACK|(ROT_)?(LEFT|RIGHT)|UP|DOWN|(ML_)?LBUTTON)|PERMISSION_(RETURN_OBJECTS|DEBIT|OVERRIDE_ANIMATIONS|SILENT_ESTATE_MANAGEMENT|TAKE_CONTROLS|TRIGGER_ANIMATION|ATTACH|CHANGE_LINKS|(CONTROL|TRACK)_CAMERA|TELEPORT)|INVENTORY_(TEXTURE|SOUND|OBJECT|SCRIPT|LANDMARK|CLOTHING|NOTECARD|BODYPART|ANIMATION|GESTURE|ALL|NONE)|CHANGED_(INVENTORY|COLOR|SHAPE|SCALE|TEXTURE|LINK|ALLOWED_DROP|OWNER|REGION(_START)?|TELEPORT|MEDIA)|OBJECT_(CLICK_ACTION|HOVER_HEIGHT|LAST_OWNER_ID|(PHYSICS|SERVER|STREAMING)_COST|UNKNOWN_DETAIL|CHARACTER_TIME|PHANTOM|PHYSICS|TEMP_(ATTACHED|ON_REZ)|NAME|DESC|POS|PRIM_(COUNT|EQUIVALENCE)|RETURN_(PARCEL(_OWNER)?|REGION)|REZZER_KEY|ROO?T|VELOCITY|OMEGA|OWNER|GROUP(_TAG)?|CREATOR|ATTACHED_(POINT|SLOTS_AVAILABLE)|RENDER_WEIGHT|(BODY_SHAPE|PATHFINDING)_TYPE|(RUNNING|TOTAL)_SCRIPT_COUNT|TOTAL_INVENTORY_COUNT|SCRIPT_(MEMORY|TIME))|TYPE_(INTEGER|FLOAT|STRING|KEY|VECTOR|ROTATION|INVALID)|(DEBUG|PUBLIC)_CHANNEL|ATTACH_(AVATAR_CENTER|CHEST|HEAD|BACK|PELVIS|MOUTH|CHIN|NECK|NOSE|BELLY|[LR](SHOULDER|HAND|FOOT|EAR|EYE|[UL](ARM|LEG)|HIP)|(LEFT|RIGHT)_PEC|HUD_(CENTER_[12]|TOP_(RIGHT|CENTER|LEFT)|BOTTOM(_(RIGHT|LEFT))?)|[LR]HAND_RING1|TAIL_(BASE|TIP)|[LR]WING|FACE_(JAW|[LR]EAR|[LR]EYE|TOUNGE)|GROIN|HIND_[LR]FOOT)|LAND_(LEVEL|RAISE|LOWER|SMOOTH|NOISE|REVERT)|DATA_(ONLINE|NAME|BORN|SIM_(POS|STATUS|RATING)|PAYINFO)|PAYMENT_INFO_(ON_FILE|USED)|REMOTE_DATA_(CHANNEL|REQUEST|REPLY)|PSYS_(PART_(BF_(ZERO|ONE(_MINUS_(DEST_COLOR|SOURCE_(ALPHA|COLOR)))?|DEST_COLOR|SOURCE_(ALPHA|COLOR))|BLEND_FUNC_(DEST|SOURCE)|FLAGS|(START|END)_(COLOR|ALPHA|SCALE|GLOW)|MAX_AGE|(RIBBON|WIND|INTERP_(COLOR|SCALE)|BOUNCE|FOLLOW_(SRC|VELOCITY)|TARGET_(POS|LINEAR)|EMISSIVE)_MASK)|SRC_(MAX_AGE|PATTERN|ANGLE_(BEGIN|END)|BURST_(RATE|PART_COUNT|RADIUS|SPEED_(MIN|MAX))|ACCEL|TEXTURE|TARGET_KEY|OMEGA|PATTERN_(DROP|EXPLODE|ANGLE(_CONE(_EMPTY)?)?)))|VEHICLE_(REFERENCE_FRAME|TYPE_(NONE|SLED|CAR|BOAT|AIRPLANE|BALLOON)|(LINEAR|ANGULAR)_(FRICTION_TIMESCALE|MOTOR_DIRECTION)|LINEAR_MOTOR_OFFSET|HOVER_(HEIGHT|EFFICIENCY|TIMESCALE)|BUOYANCY|(LINEAR|ANGULAR)_(DEFLECTION_(EFFICIENCY|TIMESCALE)|MOTOR_(DECAY_)?TIMESCALE)|VERTICAL_ATTRACTION_(EFFICIENCY|TIMESCALE)|BANKING_(EFFICIENCY|MIX|TIMESCALE)|FLAG_(NO_DEFLECTION_UP|LIMIT_(ROLL_ONLY|MOTOR_UP)|HOVER_((WATER|TERRAIN|UP)_ONLY|GLOBAL_HEIGHT)|MOUSELOOK_(STEER|BANK)|CAMERA_DECOUPLED))|PRIM_(ALLOW_UNSIT|ALPHA_MODE(_(BLEND|EMISSIVE|MASK|NONE))?|NORMAL|SPECULAR|TYPE(_(BOX|CYLINDER|PRISM|SPHERE|TORUS|TUBE|RING|SCULPT))?|HOLE_(DEFAULT|CIRCLE|SQUARE|TRIANGLE)|MATERIAL(_(STONE|METAL|GLASS|WOOD|FLESH|PLASTIC|RUBBER))?|SHINY_(NONE|LOW|MEDIUM|HIGH)|BUMP_(NONE|BRIGHT|DARK|WOOD|BARK|BRICKS|CHECKER|CONCRETE|TILE|STONE|DISKS|GRAVEL|BLOBS|SIDING|LARGETILE|STUCCO|SUCTION|WEAVE)|TEXGEN_(DEFAULT|PLANAR)|SCRIPTED_SIT_ONLY|SCULPT_(TYPE_(SPHERE|TORUS|PLANE|CYLINDER|MASK)|FLAG_(MIRROR|INVERT))|PHYSICS(_(SHAPE_(CONVEX|NONE|PRIM|TYPE)))?|(POS|ROT)_LOCAL|SLICE|TEXT|FLEXIBLE|POINT_LIGHT|TEMP_ON_REZ|PHANTOM|POSITION|SIT_TARGET|SIZE|ROTATION|TEXTURE|NAME|OMEGA|DESC|LINK_TARGET|COLOR|BUMP_SHINY|FULLBRIGHT|TEXGEN|GLOW|MEDIA_(ALT_IMAGE_ENABLE|CONTROLS|(CURRENT|HOME)_URL|AUTO_(LOOP|PLAY|SCALE|ZOOM)|FIRST_CLICK_INTERACT|(WIDTH|HEIGHT)_PIXELS|WHITELIST(_ENABLE)?|PERMS_(INTERACT|CONTROL)|PARAM_MAX|CONTROLS_(STANDARD|MINI)|PERM_(NONE|OWNER|GROUP|ANYONE)|MAX_(URL_LENGTH|WHITELIST_(SIZE|COUNT)|(WIDTH|HEIGHT)_PIXELS)))|MASK_(BASE|OWNER|GROUP|EVERYONE|NEXT)|PERM_(TRANSFER|MODIFY|COPY|MOVE|ALL)|PARCEL_(MEDIA_COMMAND_(STOP|PAUSE|PLAY|LOOP|TEXTURE|URL|TIME|AGENT|UNLOAD|AUTO_ALIGN|TYPE|SIZE|DESC|LOOP_SET)|FLAG_(ALLOW_(FLY|(GROUP_)?SCRIPTS|LANDMARK|TERRAFORM|DAMAGE|CREATE_(GROUP_)?OBJECTS)|USE_(ACCESS_(GROUP|LIST)|BAN_LIST|LAND_PASS_LIST)|LOCAL_SOUND_ONLY|RESTRICT_PUSHOBJECT|ALLOW_(GROUP|ALL)_OBJECT_ENTRY)|COUNT_(TOTAL|OWNER|GROUP|OTHER|SELECTED|TEMP)|DETAILS_(NAME|DESC|OWNER|GROUP|AREA|ID|SEE_AVATARS))|LIST_STAT_(MAX|MIN|MEAN|MEDIAN|STD_DEV|SUM(_SQUARES)?|NUM_COUNT|GEOMETRIC_MEAN|RANGE)|PAY_(HIDE|DEFAULT)|REGION_FLAG_(ALLOW_DAMAGE|FIXED_SUN|BLOCK_TERRAFORM|SANDBOX|DISABLE_(COLLISIONS|PHYSICS)|BLOCK_FLY|ALLOW_DIRECT_TELEPORT|RESTRICT_PUSHOBJECT)|HTTP_(METHOD|MIMETYPE|BODY_(MAXLENGTH|TRUNCATED)|CUSTOM_HEADER|PRAGMA_NO_CACHE|VERBOSE_THROTTLE|VERIFY_CERT)|SIT_(INVALID_(AGENT|LINK_OBJECT)|NO(T_EXPERIENCE|_(ACCESS|EXPERIENCE_PERMISSION|SIT_TARGET)))|STRING_(TRIM(_(HEAD|TAIL))?)|CLICK_ACTION_(NONE|TOUCH|SIT|BUY|PAY|OPEN(_MEDIA)?|PLAY|ZOOM)|TOUCH_INVALID_FACE|PROFILE_(NONE|SCRIPT_MEMORY)|RC_(DATA_FLAGS|DETECT_PHANTOM|GET_(LINK_NUM|NORMAL|ROOT_KEY)|MAX_HITS|REJECT_(TYPES|AGENTS|(NON)?PHYSICAL|LAND))|RCERR_(CAST_TIME_EXCEEDED|SIM_PERF_LOW|UNKNOWN)|ESTATE_ACCESS_(ALLOWED_(AGENT|GROUP)_(ADD|REMOVE)|BANNED_AGENT_(ADD|REMOVE))|DENSITY|FRICTION|RESTITUTION|GRAVITY_MULTIPLIER|KFM_(COMMAND|CMD_(PLAY|STOP|PAUSE)|MODE|FORWARD|LOOP|PING_PONG|REVERSE|DATA|ROTATION|TRANSLATION)|ERR_(GENERIC|PARCEL_PERMISSIONS|MALFORMED_PARAMS|RUNTIME_PERMISSIONS|THROTTLED)|CHARACTER_(CMD_((SMOOTH_)?STOP|JUMP)|DESIRED_(TURN_)?SPEED|RADIUS|STAY_WITHIN_PARCEL|LENGTH|ORIENTATION|ACCOUNT_FOR_SKIPPED_FRAMES|AVOIDANCE_MODE|TYPE(_([ABCD]|NONE))?|MAX_(DECEL|TURN_RADIUS|(ACCEL|SPEED)))|PURSUIT_(OFFSET|FUZZ_FACTOR|GOAL_TOLERANCE|INTERCEPT)|REQUIRE_LINE_OF_SIGHT|FORCE_DIRECT_PATH|VERTICAL|HORIZONTAL|AVOID_(CHARACTERS|DYNAMIC_OBSTACLES|NONE)|PU_(EVADE_(HIDDEN|SPOTTED)|FAILURE_(DYNAMIC_PATHFINDING_DISABLED|INVALID_(GOAL|START)|NO_(NAVMESH|VALID_DESTINATION)|OTHER|TARGET_GONE|(PARCEL_)?UNREACHABLE)|(GOAL|SLOWDOWN_DISTANCE)_REACHED)|TRAVERSAL_TYPE(_(FAST|NONE|SLOW))?|CONTENT_TYPE_(ATOM|FORM|HTML|JSON|LLSD|RSS|TEXT|XHTML|XML)|GCNP_(RADIUS|STATIC)|(PATROL|WANDER)_PAUSE_AT_WAYPOINTS|OPT_(AVATAR|CHARACTER|EXCLUSION_VOLUME|LEGACY_LINKSET|MATERIAL_VOLUME|OTHER|STATIC_OBSTACLE|WALKABLE)|SIM_STAT_PCT_CHARS_STEPPED)\\b" },
      { begin: "\\b(FALSE|TRUE)\\b" },
      { begin: "\\b(ZERO_ROTATION)\\b" },
      { begin: "\\b(EOF|JSON_(ARRAY|DELETE|FALSE|INVALID|NULL|NUMBER|OBJECT|STRING|TRUE)|NULL_KEY|TEXTURE_(BLANK|DEFAULT|MEDIA|PLYWOOD|TRANSPARENT)|URL_REQUEST_(GRANTED|DENIED))\\b" },
      { begin: "\\b(ZERO_VECTOR|TOUCH_INVALID_(TEXCOORD|VECTOR))\\b" }
    ]
  }, a = {
    className: "built_in",
    begin: "\\b(ll(AgentInExperience|(Create|DataSize|Delete|KeyCount|Keys|Read|Update)KeyValue|GetExperience(Details|ErrorMessage)|ReturnObjectsBy(ID|Owner)|Json(2List|[GS]etValue|ValueType)|Sin|Cos|Tan|Atan2|Sqrt|Pow|Abs|Fabs|Frand|Floor|Ceil|Round|Vec(Mag|Norm|Dist)|Rot(Between|2(Euler|Fwd|Left|Up))|(Euler|Axes)2Rot|Whisper|(Region|Owner)?Say|Shout|Listen(Control|Remove)?|Sensor(Repeat|Remove)?|Detected(Name|Key|Owner|Type|Pos|Vel|Grab|Rot|Group|LinkNumber)|Die|Ground|Wind|([GS]et)(AnimationOverride|MemoryLimit|PrimMediaParams|ParcelMusicURL|Object(Desc|Name)|PhysicsMaterial|Status|Scale|Color|Alpha|Texture|Pos|Rot|Force|Torque)|ResetAnimationOverride|(Scale|Offset|Rotate)Texture|(Rot)?Target(Remove)?|(Stop)?MoveToTarget|Apply(Rotational)?Impulse|Set(KeyframedMotion|ContentType|RegionPos|(Angular)?Velocity|Buoyancy|HoverHeight|ForceAndTorque|TimerEvent|ScriptState|Damage|TextureAnim|Sound(Queueing|Radius)|Vehicle(Type|(Float|Vector|Rotation)Param)|(Touch|Sit)?Text|Camera(Eye|At)Offset|PrimitiveParams|ClickAction|Link(Alpha|Color|PrimitiveParams(Fast)?|Texture(Anim)?|Camera|Media)|RemoteScriptAccessPin|PayPrice|LocalRot)|ScaleByFactor|Get((Max|Min)ScaleFactor|ClosestNavPoint|StaticPath|SimStats|Env|PrimitiveParams|Link(PrimitiveParams|Number(OfSides)?|Key|Name|Media)|HTTPHeader|FreeURLs|Object(Details|PermMask|PrimCount)|Parcel(MaxPrims|Details|Prim(Count|Owners))|Attached(List)?|(SPMax|Free|Used)Memory|Region(Name|TimeDilation|FPS|Corner|AgentCount)|Root(Position|Rotation)|UnixTime|(Parcel|Region)Flags|(Wall|GMT)clock|SimulatorHostname|BoundingBox|GeometricCenter|Creator|NumberOf(Prims|NotecardLines|Sides)|Animation(List)?|(Camera|Local)(Pos|Rot)|Vel|Accel|Omega|Time(stamp|OfDay)|(Object|CenterOf)?Mass|MassMKS|Energy|Owner|(Owner)?Key|SunDirection|Texture(Offset|Scale|Rot)|Inventory(Number|Name|Key|Type|Creator|PermMask)|Permissions(Key)?|StartParameter|List(Length|EntryType)|Date|Agent(Size|Info|Language|List)|LandOwnerAt|NotecardLine|Script(Name|State))|(Get|Reset|GetAndReset)Time|PlaySound(Slave)?|LoopSound(Master|Slave)?|(Trigger|Stop|Preload)Sound|((Get|Delete)Sub|Insert)String|To(Upper|Lower)|Give(InventoryList|Money)|RezObject|(Stop)?LookAt|Sleep|CollisionFilter|(Take|Release)Controls|DetachFromAvatar|AttachToAvatar(Temp)?|InstantMessage|(GetNext)?Email|StopHover|MinEventDelay|RotLookAt|String(Length|Trim)|(Start|Stop)Animation|TargetOmega|Request(Experience)?Permissions|(Create|Break)Link|BreakAllLinks|(Give|Remove)Inventory|Water|PassTouches|Request(Agent|Inventory)Data|TeleportAgent(Home|GlobalCoords)?|ModifyLand|CollisionSound|ResetScript|MessageLinked|PushObject|PassCollisions|AxisAngle2Rot|Rot2(Axis|Angle)|A(cos|sin)|AngleBetween|AllowInventoryDrop|SubStringIndex|List2(CSV|Integer|Json|Float|String|Key|Vector|Rot|List(Strided)?)|DeleteSubList|List(Statistics|Sort|Randomize|(Insert|Find|Replace)List)|EdgeOfWorld|AdjustSoundVolume|Key2Name|TriggerSoundLimited|EjectFromLand|(CSV|ParseString)2List|OverMyLand|SameGroup|UnSit|Ground(Slope|Normal|Contour)|GroundRepel|(Set|Remove)VehicleFlags|SitOnLink|(AvatarOn)?(Link)?SitTarget|Script(Danger|Profiler)|Dialog|VolumeDetect|ResetOtherScript|RemoteLoadScriptPin|(Open|Close)RemoteDataChannel|SendRemoteData|RemoteDataReply|(Integer|String)ToBase64|XorBase64|Log(10)?|Base64To(String|Integer)|ParseStringKeepNulls|RezAtRoot|RequestSimulatorData|ForceMouselook|(Load|Release|(E|Une)scape)URL|ParcelMedia(CommandList|Query)|ModPow|MapDestination|(RemoveFrom|AddTo|Reset)Land(Pass|Ban)List|(Set|Clear)CameraParams|HTTP(Request|Response)|TextBox|DetectedTouch(UV|Face|Pos|(N|Bin)ormal|ST)|(MD5|SHA1|DumpList2)String|Request(Secure)?URL|Clear(Prim|Link)Media|(Link)?ParticleSystem|(Get|Request)(Username|DisplayName)|RegionSayTo|CastRay|GenerateKey|TransferLindenDollars|ManageEstateAccess|(Create|Delete)Character|ExecCharacterCmd|Evade|FleeFrom|NavigateTo|PatrolPoints|Pursue|UpdateCharacter|WanderWithin))\\b"
  };
  return {
    name: "LSL (Linden Scripting Language)",
    illegal: ":",
    contains: [
      n,
      {
        className: "comment",
        variants: [
          t.COMMENT("//", "$"),
          t.COMMENT("/\\*", "\\*/")
        ],
        relevance: 0
      },
      i,
      {
        className: "section",
        variants: [
          { begin: "\\b(state|default)\\b" },
          { begin: "\\b(state_(entry|exit)|touch(_(start|end))?|(land_)?collision(_(start|end))?|timer|listen|(no_)?sensor|control|(not_)?at_(rot_)?target|money|email|experience_permissions(_denied)?|run_time_permissions|changed|attach|dataserver|moving_(start|end)|link_message|(on|object)_rez|remote_data|http_re(sponse|quest)|path_update|transaction_result)\\b" }
        ]
      },
      a,
      r,
      {
        className: "type",
        begin: "\\b(integer|float|string|key|vector|quaternion|rotation|list)\\b"
      }
    ]
  };
}
const ag = [
  "AASTriangle",
  "AbelianGroup",
  "Abort",
  "AbortKernels",
  "AbortProtect",
  "AbortScheduledTask",
  "Above",
  "Abs",
  "AbsArg",
  "AbsArgPlot",
  "Absolute",
  "AbsoluteCorrelation",
  "AbsoluteCorrelationFunction",
  "AbsoluteCurrentValue",
  "AbsoluteDashing",
  "AbsoluteFileName",
  "AbsoluteOptions",
  "AbsolutePointSize",
  "AbsoluteThickness",
  "AbsoluteTime",
  "AbsoluteTiming",
  "AcceptanceThreshold",
  "AccountingForm",
  "Accumulate",
  "Accuracy",
  "AccuracyGoal",
  "AcousticAbsorbingValue",
  "AcousticImpedanceValue",
  "AcousticNormalVelocityValue",
  "AcousticPDEComponent",
  "AcousticPressureCondition",
  "AcousticRadiationValue",
  "AcousticSoundHardValue",
  "AcousticSoundSoftCondition",
  "ActionDelay",
  "ActionMenu",
  "ActionMenuBox",
  "ActionMenuBoxOptions",
  "Activate",
  "Active",
  "ActiveClassification",
  "ActiveClassificationObject",
  "ActiveItem",
  "ActivePrediction",
  "ActivePredictionObject",
  "ActiveStyle",
  "AcyclicGraphQ",
  "AddOnHelpPath",
  "AddSides",
  "AddTo",
  "AddToSearchIndex",
  "AddUsers",
  "AdjacencyGraph",
  "AdjacencyList",
  "AdjacencyMatrix",
  "AdjacentMeshCells",
  "Adjugate",
  "AdjustmentBox",
  "AdjustmentBoxOptions",
  "AdjustTimeSeriesForecast",
  "AdministrativeDivisionData",
  "AffineHalfSpace",
  "AffineSpace",
  "AffineStateSpaceModel",
  "AffineTransform",
  "After",
  "AggregatedEntityClass",
  "AggregationLayer",
  "AircraftData",
  "AirportData",
  "AirPressureData",
  "AirSoundAttenuation",
  "AirTemperatureData",
  "AiryAi",
  "AiryAiPrime",
  "AiryAiZero",
  "AiryBi",
  "AiryBiPrime",
  "AiryBiZero",
  "AlgebraicIntegerQ",
  "AlgebraicNumber",
  "AlgebraicNumberDenominator",
  "AlgebraicNumberNorm",
  "AlgebraicNumberPolynomial",
  "AlgebraicNumberTrace",
  "AlgebraicRules",
  "AlgebraicRulesData",
  "Algebraics",
  "AlgebraicUnitQ",
  "Alignment",
  "AlignmentMarker",
  "AlignmentPoint",
  "All",
  "AllowAdultContent",
  "AllowChatServices",
  "AllowedCloudExtraParameters",
  "AllowedCloudParameterExtensions",
  "AllowedDimensions",
  "AllowedFrequencyRange",
  "AllowedHeads",
  "AllowGroupClose",
  "AllowIncomplete",
  "AllowInlineCells",
  "AllowKernelInitialization",
  "AllowLooseGrammar",
  "AllowReverseGroupClose",
  "AllowScriptLevelChange",
  "AllowVersionUpdate",
  "AllTrue",
  "Alphabet",
  "AlphabeticOrder",
  "AlphabeticSort",
  "AlphaChannel",
  "AlternateImage",
  "AlternatingFactorial",
  "AlternatingGroup",
  "AlternativeHypothesis",
  "Alternatives",
  "AltitudeMethod",
  "AmbientLight",
  "AmbiguityFunction",
  "AmbiguityList",
  "Analytic",
  "AnatomyData",
  "AnatomyForm",
  "AnatomyPlot3D",
  "AnatomySkinStyle",
  "AnatomyStyling",
  "AnchoredSearch",
  "And",
  "AndersonDarlingTest",
  "AngerJ",
  "AngleBisector",
  "AngleBracket",
  "AnglePath",
  "AnglePath3D",
  "AngleVector",
  "AngularGauge",
  "Animate",
  "AnimatedImage",
  "AnimationCycleOffset",
  "AnimationCycleRepetitions",
  "AnimationDirection",
  "AnimationDisplayTime",
  "AnimationRate",
  "AnimationRepetitions",
  "AnimationRunning",
  "AnimationRunTime",
  "AnimationTimeIndex",
  "AnimationVideo",
  "Animator",
  "AnimatorBox",
  "AnimatorBoxOptions",
  "AnimatorElements",
  "Annotate",
  "Annotation",
  "AnnotationDelete",
  "AnnotationKeys",
  "AnnotationRules",
  "AnnotationValue",
  "Annuity",
  "AnnuityDue",
  "Annulus",
  "AnomalyDetection",
  "AnomalyDetector",
  "AnomalyDetectorFunction",
  "Anonymous",
  "Antialiasing",
  "Antihermitian",
  "AntihermitianMatrixQ",
  "Antisymmetric",
  "AntisymmetricMatrixQ",
  "Antonyms",
  "AnyOrder",
  "AnySubset",
  "AnyTrue",
  "Apart",
  "ApartSquareFree",
  "APIFunction",
  "Appearance",
  "AppearanceElements",
  "AppearanceRules",
  "AppellF1",
  "Append",
  "AppendCheck",
  "AppendLayer",
  "AppendTo",
  "Application",
  "Apply",
  "ApplyReaction",
  "ApplySides",
  "ApplyTo",
  "ArcCos",
  "ArcCosh",
  "ArcCot",
  "ArcCoth",
  "ArcCsc",
  "ArcCsch",
  "ArcCurvature",
  "ARCHProcess",
  "ArcLength",
  "ArcSec",
  "ArcSech",
  "ArcSin",
  "ArcSinDistribution",
  "ArcSinh",
  "ArcTan",
  "ArcTanh",
  "Area",
  "Arg",
  "ArgMax",
  "ArgMin",
  "ArgumentCountQ",
  "ArgumentsOptions",
  "ARIMAProcess",
  "ArithmeticGeometricMean",
  "ARMAProcess",
  "Around",
  "AroundReplace",
  "ARProcess",
  "Array",
  "ArrayComponents",
  "ArrayDepth",
  "ArrayFilter",
  "ArrayFlatten",
  "ArrayMesh",
  "ArrayPad",
  "ArrayPlot",
  "ArrayPlot3D",
  "ArrayQ",
  "ArrayReduce",
  "ArrayResample",
  "ArrayReshape",
  "ArrayRules",
  "Arrays",
  "Arrow",
  "Arrow3DBox",
  "ArrowBox",
  "Arrowheads",
  "ASATriangle",
  "Ask",
  "AskAppend",
  "AskConfirm",
  "AskDisplay",
  "AskedQ",
  "AskedValue",
  "AskFunction",
  "AskState",
  "AskTemplateDisplay",
  "AspectRatio",
  "AspectRatioFixed",
  "Assert",
  "AssessmentFunction",
  "AssessmentResultObject",
  "AssociateTo",
  "Association",
  "AssociationFormat",
  "AssociationMap",
  "AssociationQ",
  "AssociationThread",
  "AssumeDeterministic",
  "Assuming",
  "Assumptions",
  "AstroAngularSeparation",
  "AstroBackground",
  "AstroCenter",
  "AstroDistance",
  "AstroGraphics",
  "AstroGridLines",
  "AstroGridLinesStyle",
  "AstronomicalData",
  "AstroPosition",
  "AstroProjection",
  "AstroRange",
  "AstroRangePadding",
  "AstroReferenceFrame",
  "AstroStyling",
  "AstroZoomLevel",
  "Asymptotic",
  "AsymptoticDSolveValue",
  "AsymptoticEqual",
  "AsymptoticEquivalent",
  "AsymptoticExpectation",
  "AsymptoticGreater",
  "AsymptoticGreaterEqual",
  "AsymptoticIntegrate",
  "AsymptoticLess",
  "AsymptoticLessEqual",
  "AsymptoticOutputTracker",
  "AsymptoticProbability",
  "AsymptoticProduct",
  "AsymptoticRSolveValue",
  "AsymptoticSolve",
  "AsymptoticSum",
  "Asynchronous",
  "AsynchronousTaskObject",
  "AsynchronousTasks",
  "Atom",
  "AtomCoordinates",
  "AtomCount",
  "AtomDiagramCoordinates",
  "AtomLabels",
  "AtomLabelStyle",
  "AtomList",
  "AtomQ",
  "AttachCell",
  "AttachedCell",
  "AttentionLayer",
  "Attributes",
  "Audio",
  "AudioAmplify",
  "AudioAnnotate",
  "AudioAnnotationLookup",
  "AudioBlockMap",
  "AudioCapture",
  "AudioChannelAssignment",
  "AudioChannelCombine",
  "AudioChannelMix",
  "AudioChannels",
  "AudioChannelSeparate",
  "AudioData",
  "AudioDelay",
  "AudioDelete",
  "AudioDevice",
  "AudioDistance",
  "AudioEncoding",
  "AudioFade",
  "AudioFrequencyShift",
  "AudioGenerator",
  "AudioIdentify",
  "AudioInputDevice",
  "AudioInsert",
  "AudioInstanceQ",
  "AudioIntervals",
  "AudioJoin",
  "AudioLabel",
  "AudioLength",
  "AudioLocalMeasurements",
  "AudioLooping",
  "AudioLoudness",
  "AudioMeasurements",
  "AudioNormalize",
  "AudioOutputDevice",
  "AudioOverlay",
  "AudioPad",
  "AudioPan",
  "AudioPartition",
  "AudioPause",
  "AudioPitchShift",
  "AudioPlay",
  "AudioPlot",
  "AudioQ",
  "AudioRecord",
  "AudioReplace",
  "AudioResample",
  "AudioReverb",
  "AudioReverse",
  "AudioSampleRate",
  "AudioSpectralMap",
  "AudioSpectralTransformation",
  "AudioSplit",
  "AudioStop",
  "AudioStream",
  "AudioStreams",
  "AudioTimeStretch",
  "AudioTrackApply",
  "AudioTrackSelection",
  "AudioTrim",
  "AudioType",
  "AugmentedPolyhedron",
  "AugmentedSymmetricPolynomial",
  "Authenticate",
  "Authentication",
  "AuthenticationDialog",
  "AutoAction",
  "Autocomplete",
  "AutocompletionFunction",
  "AutoCopy",
  "AutocorrelationTest",
  "AutoDelete",
  "AutoEvaluateEvents",
  "AutoGeneratedPackage",
  "AutoIndent",
  "AutoIndentSpacings",
  "AutoItalicWords",
  "AutoloadPath",
  "AutoMatch",
  "Automatic",
  "AutomaticImageSize",
  "AutoMultiplicationSymbol",
  "AutoNumberFormatting",
  "AutoOpenNotebooks",
  "AutoOpenPalettes",
  "AutoOperatorRenderings",
  "AutoQuoteCharacters",
  "AutoRefreshed",
  "AutoRemove",
  "AutorunSequencing",
  "AutoScaling",
  "AutoScroll",
  "AutoSpacing",
  "AutoStyleOptions",
  "AutoStyleWords",
  "AutoSubmitting",
  "Axes",
  "AxesEdge",
  "AxesLabel",
  "AxesOrigin",
  "AxesStyle",
  "AxiomaticTheory",
  "Axis",
  "Axis3DBox",
  "Axis3DBoxOptions",
  "AxisBox",
  "AxisBoxOptions",
  "AxisLabel",
  "AxisObject",
  "AxisStyle",
  "BabyMonsterGroupB",
  "Back",
  "BackFaceColor",
  "BackFaceGlowColor",
  "BackFaceOpacity",
  "BackFaceSpecularColor",
  "BackFaceSpecularExponent",
  "BackFaceSurfaceAppearance",
  "BackFaceTexture",
  "Background",
  "BackgroundAppearance",
  "BackgroundTasksSettings",
  "Backslash",
  "Backsubstitution",
  "Backward",
  "Ball",
  "Band",
  "BandpassFilter",
  "BandstopFilter",
  "BarabasiAlbertGraphDistribution",
  "BarChart",
  "BarChart3D",
  "BarcodeImage",
  "BarcodeRecognize",
  "BaringhausHenzeTest",
  "BarLegend",
  "BarlowProschanImportance",
  "BarnesG",
  "BarOrigin",
  "BarSpacing",
  "BartlettHannWindow",
  "BartlettWindow",
  "BaseDecode",
  "BaseEncode",
  "BaseForm",
  "Baseline",
  "BaselinePosition",
  "BaseStyle",
  "BasicRecurrentLayer",
  "BatchNormalizationLayer",
  "BatchSize",
  "BatesDistribution",
  "BattleLemarieWavelet",
  "BayesianMaximization",
  "BayesianMaximizationObject",
  "BayesianMinimization",
  "BayesianMinimizationObject",
  "Because",
  "BeckmannDistribution",
  "Beep",
  "Before",
  "Begin",
  "BeginDialogPacket",
  "BeginPackage",
  "BellB",
  "BellY",
  "Below",
  "BenfordDistribution",
  "BeniniDistribution",
  "BenktanderGibratDistribution",
  "BenktanderWeibullDistribution",
  "BernoulliB",
  "BernoulliDistribution",
  "BernoulliGraphDistribution",
  "BernoulliProcess",
  "BernsteinBasis",
  "BesagL",
  "BesselFilterModel",
  "BesselI",
  "BesselJ",
  "BesselJZero",
  "BesselK",
  "BesselY",
  "BesselYZero",
  "Beta",
  "BetaBinomialDistribution",
  "BetaDistribution",
  "BetaNegativeBinomialDistribution",
  "BetaPrimeDistribution",
  "BetaRegularized",
  "Between",
  "BetweennessCentrality",
  "Beveled",
  "BeveledPolyhedron",
  "BezierCurve",
  "BezierCurve3DBox",
  "BezierCurve3DBoxOptions",
  "BezierCurveBox",
  "BezierCurveBoxOptions",
  "BezierFunction",
  "BilateralFilter",
  "BilateralLaplaceTransform",
  "BilateralZTransform",
  "Binarize",
  "BinaryDeserialize",
  "BinaryDistance",
  "BinaryFormat",
  "BinaryImageQ",
  "BinaryRead",
  "BinaryReadList",
  "BinarySerialize",
  "BinaryWrite",
  "BinCounts",
  "BinLists",
  "BinnedVariogramList",
  "Binomial",
  "BinomialDistribution",
  "BinomialPointProcess",
  "BinomialProcess",
  "BinormalDistribution",
  "BiorthogonalSplineWavelet",
  "BioSequence",
  "BioSequenceBackTranslateList",
  "BioSequenceComplement",
  "BioSequenceInstances",
  "BioSequenceModify",
  "BioSequencePlot",
  "BioSequenceQ",
  "BioSequenceReverseComplement",
  "BioSequenceTranscribe",
  "BioSequenceTranslate",
  "BipartiteGraphQ",
  "BiquadraticFilterModel",
  "BirnbaumImportance",
  "BirnbaumSaundersDistribution",
  "BitAnd",
  "BitClear",
  "BitGet",
  "BitLength",
  "BitNot",
  "BitOr",
  "BitRate",
  "BitSet",
  "BitShiftLeft",
  "BitShiftRight",
  "BitXor",
  "BiweightLocation",
  "BiweightMidvariance",
  "Black",
  "BlackmanHarrisWindow",
  "BlackmanNuttallWindow",
  "BlackmanWindow",
  "Blank",
  "BlankForm",
  "BlankNullSequence",
  "BlankSequence",
  "Blend",
  "Block",
  "BlockchainAddressData",
  "BlockchainBase",
  "BlockchainBlockData",
  "BlockchainContractValue",
  "BlockchainData",
  "BlockchainGet",
  "BlockchainKeyEncode",
  "BlockchainPut",
  "BlockchainTokenData",
  "BlockchainTransaction",
  "BlockchainTransactionData",
  "BlockchainTransactionSign",
  "BlockchainTransactionSubmit",
  "BlockDiagonalMatrix",
  "BlockLowerTriangularMatrix",
  "BlockMap",
  "BlockRandom",
  "BlockUpperTriangularMatrix",
  "BlomqvistBeta",
  "BlomqvistBetaTest",
  "Blue",
  "Blur",
  "Blurring",
  "BodePlot",
  "BohmanWindow",
  "Bold",
  "Bond",
  "BondCount",
  "BondLabels",
  "BondLabelStyle",
  "BondList",
  "BondQ",
  "Bookmarks",
  "Boole",
  "BooleanConsecutiveFunction",
  "BooleanConvert",
  "BooleanCountingFunction",
  "BooleanFunction",
  "BooleanGraph",
  "BooleanMaxterms",
  "BooleanMinimize",
  "BooleanMinterms",
  "BooleanQ",
  "BooleanRegion",
  "Booleans",
  "BooleanStrings",
  "BooleanTable",
  "BooleanVariables",
  "BorderDimensions",
  "BorelTannerDistribution",
  "Bottom",
  "BottomHatTransform",
  "BoundaryDiscretizeGraphics",
  "BoundaryDiscretizeRegion",
  "BoundaryMesh",
  "BoundaryMeshRegion",
  "BoundaryMeshRegionQ",
  "BoundaryStyle",
  "BoundedRegionQ",
  "BoundingRegion",
  "Bounds",
  "Box",
  "BoxBaselineShift",
  "BoxData",
  "BoxDimensions",
  "Boxed",
  "Boxes",
  "BoxForm",
  "BoxFormFormatTypes",
  "BoxFrame",
  "BoxID",
  "BoxMargins",
  "BoxMatrix",
  "BoxObject",
  "BoxRatios",
  "BoxRotation",
  "BoxRotationPoint",
  "BoxStyle",
  "BoxWhiskerChart",
  "Bra",
  "BracketingBar",
  "BraKet",
  "BrayCurtisDistance",
  "BreadthFirstScan",
  "Break",
  "BridgeData",
  "BrightnessEqualize",
  "BroadcastStationData",
  "Brown",
  "BrownForsytheTest",
  "BrownianBridgeProcess",
  "BrowserCategory",
  "BSplineBasis",
  "BSplineCurve",
  "BSplineCurve3DBox",
  "BSplineCurve3DBoxOptions",
  "BSplineCurveBox",
  "BSplineCurveBoxOptions",
  "BSplineFunction",
  "BSplineSurface",
  "BSplineSurface3DBox",
  "BSplineSurface3DBoxOptions",
  "BubbleChart",
  "BubbleChart3D",
  "BubbleScale",
  "BubbleSizes",
  "BuckyballGraph",
  "BuildCompiledComponent",
  "BuildingData",
  "BulletGauge",
  "BusinessDayQ",
  "ButterflyGraph",
  "ButterworthFilterModel",
  "Button",
  "ButtonBar",
  "ButtonBox",
  "ButtonBoxOptions",
  "ButtonCell",
  "ButtonContents",
  "ButtonData",
  "ButtonEvaluator",
  "ButtonExpandable",
  "ButtonFrame",
  "ButtonFunction",
  "ButtonMargins",
  "ButtonMinHeight",
  "ButtonNote",
  "ButtonNotebook",
  "ButtonSource",
  "ButtonStyle",
  "ButtonStyleMenuListing",
  "Byte",
  "ByteArray",
  "ByteArrayFormat",
  "ByteArrayFormatQ",
  "ByteArrayQ",
  "ByteArrayToString",
  "ByteCount",
  "ByteOrdering",
  "C",
  "CachedValue",
  "CacheGraphics",
  "CachePersistence",
  "CalendarConvert",
  "CalendarData",
  "CalendarType",
  "Callout",
  "CalloutMarker",
  "CalloutStyle",
  "CallPacket",
  "CanberraDistance",
  "Cancel",
  "CancelButton",
  "CandlestickChart",
  "CanonicalGraph",
  "CanonicalizePolygon",
  "CanonicalizePolyhedron",
  "CanonicalizeRegion",
  "CanonicalName",
  "CanonicalWarpingCorrespondence",
  "CanonicalWarpingDistance",
  "CantorMesh",
  "CantorStaircase",
  "Canvas",
  "Cap",
  "CapForm",
  "CapitalDifferentialD",
  "Capitalize",
  "CapsuleShape",
  "CaptureRunning",
  "CaputoD",
  "CardinalBSplineBasis",
  "CarlemanLinearize",
  "CarlsonRC",
  "CarlsonRD",
  "CarlsonRE",
  "CarlsonRF",
  "CarlsonRG",
  "CarlsonRJ",
  "CarlsonRK",
  "CarlsonRM",
  "CarmichaelLambda",
  "CaseOrdering",
  "Cases",
  "CaseSensitive",
  "Cashflow",
  "Casoratian",
  "Cast",
  "Catalan",
  "CatalanNumber",
  "Catch",
  "CategoricalDistribution",
  "Catenate",
  "CatenateLayer",
  "CauchyDistribution",
  "CauchyMatrix",
  "CauchyPointProcess",
  "CauchyWindow",
  "CayleyGraph",
  "CDF",
  "CDFDeploy",
  "CDFInformation",
  "CDFWavelet",
  "Ceiling",
  "CelestialSystem",
  "Cell",
  "CellAutoOverwrite",
  "CellBaseline",
  "CellBoundingBox",
  "CellBracketOptions",
  "CellChangeTimes",
  "CellContents",
  "CellContext",
  "CellDingbat",
  "CellDingbatMargin",
  "CellDynamicExpression",
  "CellEditDuplicate",
  "CellElementsBoundingBox",
  "CellElementSpacings",
  "CellEpilog",
  "CellEvaluationDuplicate",
  "CellEvaluationFunction",
  "CellEvaluationLanguage",
  "CellEventActions",
  "CellFrame",
  "CellFrameColor",
  "CellFrameLabelMargins",
  "CellFrameLabels",
  "CellFrameMargins",
  "CellFrameStyle",
  "CellGroup",
  "CellGroupData",
  "CellGrouping",
  "CellGroupingRules",
  "CellHorizontalScrolling",
  "CellID",
  "CellInsertionPointCell",
  "CellLabel",
  "CellLabelAutoDelete",
  "CellLabelMargins",
  "CellLabelPositioning",
  "CellLabelStyle",
  "CellLabelTemplate",
  "CellMargins",
  "CellObject",
  "CellOpen",
  "CellPrint",
  "CellProlog",
  "Cells",
  "CellSize",
  "CellStyle",
  "CellTags",
  "CellTrayPosition",
  "CellTrayWidgets",
  "CellularAutomaton",
  "CensoredDistribution",
  "Censoring",
  "Center",
  "CenterArray",
  "CenterDot",
  "CenteredInterval",
  "CentralFeature",
  "CentralMoment",
  "CentralMomentGeneratingFunction",
  "Cepstrogram",
  "CepstrogramArray",
  "CepstrumArray",
  "CForm",
  "ChampernowneNumber",
  "ChangeOptions",
  "ChannelBase",
  "ChannelBrokerAction",
  "ChannelDatabin",
  "ChannelHistoryLength",
  "ChannelListen",
  "ChannelListener",
  "ChannelListeners",
  "ChannelListenerWait",
  "ChannelObject",
  "ChannelPreSendFunction",
  "ChannelReceiverFunction",
  "ChannelSend",
  "ChannelSubscribers",
  "ChanVeseBinarize",
  "Character",
  "CharacterCounts",
  "CharacterEncoding",
  "CharacterEncodingsPath",
  "CharacteristicFunction",
  "CharacteristicPolynomial",
  "CharacterName",
  "CharacterNormalize",
  "CharacterRange",
  "Characters",
  "ChartBaseStyle",
  "ChartElementData",
  "ChartElementDataFunction",
  "ChartElementFunction",
  "ChartElements",
  "ChartLabels",
  "ChartLayout",
  "ChartLegends",
  "ChartStyle",
  "Chebyshev1FilterModel",
  "Chebyshev2FilterModel",
  "ChebyshevDistance",
  "ChebyshevT",
  "ChebyshevU",
  "Check",
  "CheckAbort",
  "CheckAll",
  "CheckArguments",
  "Checkbox",
  "CheckboxBar",
  "CheckboxBox",
  "CheckboxBoxOptions",
  "ChemicalConvert",
  "ChemicalData",
  "ChemicalFormula",
  "ChemicalInstance",
  "ChemicalReaction",
  "ChessboardDistance",
  "ChiDistribution",
  "ChineseRemainder",
  "ChiSquareDistribution",
  "ChoiceButtons",
  "ChoiceDialog",
  "CholeskyDecomposition",
  "Chop",
  "ChromaticityPlot",
  "ChromaticityPlot3D",
  "ChromaticPolynomial",
  "Circle",
  "CircleBox",
  "CircleDot",
  "CircleMinus",
  "CirclePlus",
  "CirclePoints",
  "CircleThrough",
  "CircleTimes",
  "CirculantGraph",
  "CircularArcThrough",
  "CircularOrthogonalMatrixDistribution",
  "CircularQuaternionMatrixDistribution",
  "CircularRealMatrixDistribution",
  "CircularSymplecticMatrixDistribution",
  "CircularUnitaryMatrixDistribution",
  "Circumsphere",
  "CityData",
  "ClassifierFunction",
  "ClassifierInformation",
  "ClassifierMeasurements",
  "ClassifierMeasurementsObject",
  "Classify",
  "ClassPriors",
  "Clear",
  "ClearAll",
  "ClearAttributes",
  "ClearCookies",
  "ClearPermissions",
  "ClearSystemCache",
  "ClebschGordan",
  "ClickPane",
  "ClickToCopy",
  "ClickToCopyEnabled",
  "Clip",
  "ClipboardNotebook",
  "ClipFill",
  "ClippingStyle",
  "ClipPlanes",
  "ClipPlanesStyle",
  "ClipRange",
  "Clock",
  "ClockGauge",
  "ClockwiseContourIntegral",
  "Close",
  "Closed",
  "CloseKernels",
  "ClosenessCentrality",
  "Closing",
  "ClosingAutoSave",
  "ClosingEvent",
  "CloudAccountData",
  "CloudBase",
  "CloudConnect",
  "CloudConnections",
  "CloudDeploy",
  "CloudDirectory",
  "CloudDisconnect",
  "CloudEvaluate",
  "CloudExport",
  "CloudExpression",
  "CloudExpressions",
  "CloudFunction",
  "CloudGet",
  "CloudImport",
  "CloudLoggingData",
  "CloudObject",
  "CloudObjectInformation",
  "CloudObjectInformationData",
  "CloudObjectNameFormat",
  "CloudObjects",
  "CloudObjectURLType",
  "CloudPublish",
  "CloudPut",
  "CloudRenderingMethod",
  "CloudSave",
  "CloudShare",
  "CloudSubmit",
  "CloudSymbol",
  "CloudUnshare",
  "CloudUserID",
  "ClusterClassify",
  "ClusterDissimilarityFunction",
  "ClusteringComponents",
  "ClusteringMeasurements",
  "ClusteringTree",
  "CMYKColor",
  "Coarse",
  "CodeAssistOptions",
  "Coefficient",
  "CoefficientArrays",
  "CoefficientDomain",
  "CoefficientList",
  "CoefficientRules",
  "CoifletWavelet",
  "Collect",
  "CollinearPoints",
  "Colon",
  "ColonForm",
  "ColorBalance",
  "ColorCombine",
  "ColorConvert",
  "ColorCoverage",
  "ColorData",
  "ColorDataFunction",
  "ColorDetect",
  "ColorDistance",
  "ColorFunction",
  "ColorFunctionBinning",
  "ColorFunctionScaling",
  "Colorize",
  "ColorNegate",
  "ColorOutput",
  "ColorProfileData",
  "ColorQ",
  "ColorQuantize",
  "ColorReplace",
  "ColorRules",
  "ColorSelectorSettings",
  "ColorSeparate",
  "ColorSetter",
  "ColorSetterBox",
  "ColorSetterBoxOptions",
  "ColorSlider",
  "ColorsNear",
  "ColorSpace",
  "ColorToneMapping",
  "Column",
  "ColumnAlignments",
  "ColumnBackgrounds",
  "ColumnForm",
  "ColumnLines",
  "ColumnsEqual",
  "ColumnSpacings",
  "ColumnWidths",
  "CombinatorB",
  "CombinatorC",
  "CombinatorI",
  "CombinatorK",
  "CombinatorS",
  "CombinatorW",
  "CombinatorY",
  "CombinedEntityClass",
  "CombinerFunction",
  "CometData",
  "CommonDefaultFormatTypes",
  "Commonest",
  "CommonestFilter",
  "CommonName",
  "CommonUnits",
  "CommunityBoundaryStyle",
  "CommunityGraphPlot",
  "CommunityLabels",
  "CommunityRegionStyle",
  "CompanyData",
  "CompatibleUnitQ",
  "CompilationOptions",
  "CompilationTarget",
  "Compile",
  "Compiled",
  "CompiledCodeFunction",
  "CompiledComponent",
  "CompiledExpressionDeclaration",
  "CompiledFunction",
  "CompiledLayer",
  "CompilerCallback",
  "CompilerEnvironment",
  "CompilerEnvironmentAppend",
  "CompilerEnvironmentAppendTo",
  "CompilerEnvironmentObject",
  "CompilerOptions",
  "Complement",
  "ComplementedEntityClass",
  "CompleteGraph",
  "CompleteGraphQ",
  "CompleteIntegral",
  "CompleteKaryTree",
  "CompletionsListPacket",
  "Complex",
  "ComplexArrayPlot",
  "ComplexContourPlot",
  "Complexes",
  "ComplexExpand",
  "ComplexInfinity",
  "ComplexityFunction",
  "ComplexListPlot",
  "ComplexPlot",
  "ComplexPlot3D",
  "ComplexRegionPlot",
  "ComplexStreamPlot",
  "ComplexVectorPlot",
  "ComponentMeasurements",
  "ComponentwiseContextMenu",
  "Compose",
  "ComposeList",
  "ComposeSeries",
  "CompositeQ",
  "Composition",
  "CompoundElement",
  "CompoundExpression",
  "CompoundPoissonDistribution",
  "CompoundPoissonProcess",
  "CompoundRenewalProcess",
  "Compress",
  "CompressedData",
  "CompressionLevel",
  "ComputeUncertainty",
  "ConcaveHullMesh",
  "Condition",
  "ConditionalExpression",
  "Conditioned",
  "Cone",
  "ConeBox",
  "ConfidenceLevel",
  "ConfidenceRange",
  "ConfidenceTransform",
  "ConfigurationPath",
  "Confirm",
  "ConfirmAssert",
  "ConfirmBy",
  "ConfirmMatch",
  "ConfirmQuiet",
  "ConformationMethod",
  "ConformAudio",
  "ConformImages",
  "Congruent",
  "ConicGradientFilling",
  "ConicHullRegion",
  "ConicHullRegion3DBox",
  "ConicHullRegion3DBoxOptions",
  "ConicHullRegionBox",
  "ConicHullRegionBoxOptions",
  "ConicOptimization",
  "Conjugate",
  "ConjugateTranspose",
  "Conjunction",
  "Connect",
  "ConnectedComponents",
  "ConnectedGraphComponents",
  "ConnectedGraphQ",
  "ConnectedMeshComponents",
  "ConnectedMoleculeComponents",
  "ConnectedMoleculeQ",
  "ConnectionSettings",
  "ConnectLibraryCallbackFunction",
  "ConnectSystemModelComponents",
  "ConnectSystemModelController",
  "ConnesWindow",
  "ConoverTest",
  "ConservativeConvectionPDETerm",
  "ConsoleMessage",
  "Constant",
  "ConstantArray",
  "ConstantArrayLayer",
  "ConstantImage",
  "ConstantPlusLayer",
  "ConstantRegionQ",
  "Constants",
  "ConstantTimesLayer",
  "ConstellationData",
  "ConstrainedMax",
  "ConstrainedMin",
  "Construct",
  "Containing",
  "ContainsAll",
  "ContainsAny",
  "ContainsExactly",
  "ContainsNone",
  "ContainsOnly",
  "ContentDetectorFunction",
  "ContentFieldOptions",
  "ContentLocationFunction",
  "ContentObject",
  "ContentPadding",
  "ContentsBoundingBox",
  "ContentSelectable",
  "ContentSize",
  "Context",
  "ContextMenu",
  "Contexts",
  "ContextToFileName",
  "Continuation",
  "Continue",
  "ContinuedFraction",
  "ContinuedFractionK",
  "ContinuousAction",
  "ContinuousMarkovProcess",
  "ContinuousTask",
  "ContinuousTimeModelQ",
  "ContinuousWaveletData",
  "ContinuousWaveletTransform",
  "ContourDetect",
  "ContourGraphics",
  "ContourIntegral",
  "ContourLabels",
  "ContourLines",
  "ContourPlot",
  "ContourPlot3D",
  "Contours",
  "ContourShading",
  "ContourSmoothing",
  "ContourStyle",
  "ContraharmonicMean",
  "ContrastiveLossLayer",
  "Control",
  "ControlActive",
  "ControlAlignment",
  "ControlGroupContentsBox",
  "ControllabilityGramian",
  "ControllabilityMatrix",
  "ControllableDecomposition",
  "ControllableModelQ",
  "ControllerDuration",
  "ControllerInformation",
  "ControllerInformationData",
  "ControllerLinking",
  "ControllerManipulate",
  "ControllerMethod",
  "ControllerPath",
  "ControllerState",
  "ControlPlacement",
  "ControlsRendering",
  "ControlType",
  "ConvectionPDETerm",
  "Convergents",
  "ConversionOptions",
  "ConversionRules",
  "ConvertToPostScript",
  "ConvertToPostScriptPacket",
  "ConvexHullMesh",
  "ConvexHullRegion",
  "ConvexOptimization",
  "ConvexPolygonQ",
  "ConvexPolyhedronQ",
  "ConvexRegionQ",
  "ConvolutionLayer",
  "Convolve",
  "ConwayGroupCo1",
  "ConwayGroupCo2",
  "ConwayGroupCo3",
  "CookieFunction",
  "Cookies",
  "CoordinateBoundingBox",
  "CoordinateBoundingBoxArray",
  "CoordinateBounds",
  "CoordinateBoundsArray",
  "CoordinateChartData",
  "CoordinatesToolOptions",
  "CoordinateTransform",
  "CoordinateTransformData",
  "CoplanarPoints",
  "CoprimeQ",
  "Coproduct",
  "CopulaDistribution",
  "Copyable",
  "CopyDatabin",
  "CopyDirectory",
  "CopyFile",
  "CopyFunction",
  "CopyTag",
  "CopyToClipboard",
  "CoreNilpotentDecomposition",
  "CornerFilter",
  "CornerNeighbors",
  "Correlation",
  "CorrelationDistance",
  "CorrelationFunction",
  "CorrelationTest",
  "Cos",
  "Cosh",
  "CoshIntegral",
  "CosineDistance",
  "CosineWindow",
  "CosIntegral",
  "Cot",
  "Coth",
  "CoulombF",
  "CoulombG",
  "CoulombH1",
  "CoulombH2",
  "Count",
  "CountDistinct",
  "CountDistinctBy",
  "CounterAssignments",
  "CounterBox",
  "CounterBoxOptions",
  "CounterClockwiseContourIntegral",
  "CounterEvaluator",
  "CounterFunction",
  "CounterIncrements",
  "CounterStyle",
  "CounterStyleMenuListing",
  "CountRoots",
  "CountryData",
  "Counts",
  "CountsBy",
  "Covariance",
  "CovarianceEstimatorFunction",
  "CovarianceFunction",
  "CoxianDistribution",
  "CoxIngersollRossProcess",
  "CoxModel",
  "CoxModelFit",
  "CramerVonMisesTest",
  "CreateArchive",
  "CreateCellID",
  "CreateChannel",
  "CreateCloudExpression",
  "CreateCompilerEnvironment",
  "CreateDatabin",
  "CreateDataStructure",
  "CreateDataSystemModel",
  "CreateDialog",
  "CreateDirectory",
  "CreateDocument",
  "CreateFile",
  "CreateIntermediateDirectories",
  "CreateLicenseEntitlement",
  "CreateManagedLibraryExpression",
  "CreateNotebook",
  "CreatePacletArchive",
  "CreatePalette",
  "CreatePermissionsGroup",
  "CreateScheduledTask",
  "CreateSearchIndex",
  "CreateSystemModel",
  "CreateTemporary",
  "CreateTypeInstance",
  "CreateUUID",
  "CreateWindow",
  "CriterionFunction",
  "CriticalityFailureImportance",
  "CriticalitySuccessImportance",
  "CriticalSection",
  "Cross",
  "CrossEntropyLossLayer",
  "CrossingCount",
  "CrossingDetect",
  "CrossingPolygon",
  "CrossMatrix",
  "Csc",
  "Csch",
  "CSGRegion",
  "CSGRegionQ",
  "CSGRegionTree",
  "CTCLossLayer",
  "Cube",
  "CubeRoot",
  "Cubics",
  "Cuboid",
  "CuboidBox",
  "CuboidBoxOptions",
  "Cumulant",
  "CumulantGeneratingFunction",
  "CumulativeFeatureImpactPlot",
  "Cup",
  "CupCap",
  "Curl",
  "CurlyDoubleQuote",
  "CurlyQuote",
  "CurrencyConvert",
  "CurrentDate",
  "CurrentImage",
  "CurrentNotebookImage",
  "CurrentScreenImage",
  "CurrentValue",
  "Curry",
  "CurryApplied",
  "CurvatureFlowFilter",
  "CurveClosed",
  "Cyan",
  "CycleGraph",
  "CycleIndexPolynomial",
  "Cycles",
  "CyclicGroup",
  "Cyclotomic",
  "Cylinder",
  "CylinderBox",
  "CylinderBoxOptions",
  "CylindricalDecomposition",
  "CylindricalDecompositionFunction",
  "D",
  "DagumDistribution",
  "DamData",
  "DamerauLevenshteinDistance",
  "DampingFactor",
  "Darker",
  "Dashed",
  "Dashing",
  "DatabaseConnect",
  "DatabaseDisconnect",
  "DatabaseReference",
  "Databin",
  "DatabinAdd",
  "DatabinRemove",
  "Databins",
  "DatabinSubmit",
  "DatabinUpload",
  "DataCompression",
  "DataDistribution",
  "DataRange",
  "DataReversed",
  "Dataset",
  "DatasetDisplayPanel",
  "DatasetTheme",
  "DataStructure",
  "DataStructureQ",
  "Date",
  "DateBounds",
  "Dated",
  "DateDelimiters",
  "DateDifference",
  "DatedUnit",
  "DateFormat",
  "DateFunction",
  "DateGranularity",
  "DateHistogram",
  "DateInterval",
  "DateList",
  "DateListLogPlot",
  "DateListPlot",
  "DateListStepPlot",
  "DateObject",
  "DateObjectQ",
  "DateOverlapsQ",
  "DatePattern",
  "DatePlus",
  "DateRange",
  "DateReduction",
  "DateScale",
  "DateSelect",
  "DateString",
  "DateTicksFormat",
  "DateValue",
  "DateWithinQ",
  "DaubechiesWavelet",
  "DavisDistribution",
  "DawsonF",
  "DayCount",
  "DayCountConvention",
  "DayHemisphere",
  "DaylightQ",
  "DayMatchQ",
  "DayName",
  "DayNightTerminator",
  "DayPlus",
  "DayRange",
  "DayRound",
  "DeBruijnGraph",
  "DeBruijnSequence",
  "Debug",
  "DebugTag",
  "Decapitalize",
  "Decimal",
  "DecimalForm",
  "DeclareCompiledComponent",
  "DeclareKnownSymbols",
  "DeclarePackage",
  "Decompose",
  "DeconvolutionLayer",
  "Decrement",
  "Decrypt",
  "DecryptFile",
  "DedekindEta",
  "DeepSpaceProbeData",
  "Default",
  "Default2DTool",
  "Default3DTool",
  "DefaultAttachedCellStyle",
  "DefaultAxesStyle",
  "DefaultBaseStyle",
  "DefaultBoxStyle",
  "DefaultButton",
  "DefaultColor",
  "DefaultControlPlacement",
  "DefaultDockedCellStyle",
  "DefaultDuplicateCellStyle",
  "DefaultDuration",
  "DefaultElement",
  "DefaultFaceGridsStyle",
  "DefaultFieldHintStyle",
  "DefaultFont",
  "DefaultFontProperties",
  "DefaultFormatType",
  "DefaultFrameStyle",
  "DefaultFrameTicksStyle",
  "DefaultGridLinesStyle",
  "DefaultInlineFormatType",
  "DefaultInputFormatType",
  "DefaultLabelStyle",
  "DefaultMenuStyle",
  "DefaultNaturalLanguage",
  "DefaultNewCellStyle",
  "DefaultNewInlineCellStyle",
  "DefaultNotebook",
  "DefaultOptions",
  "DefaultOutputFormatType",
  "DefaultPrintPrecision",
  "DefaultStyle",
  "DefaultStyleDefinitions",
  "DefaultTextFormatType",
  "DefaultTextInlineFormatType",
  "DefaultTicksStyle",
  "DefaultTooltipStyle",
  "DefaultValue",
  "DefaultValues",
  "Defer",
  "DefineExternal",
  "DefineInputStreamMethod",
  "DefineOutputStreamMethod",
  "DefineResourceFunction",
  "Definition",
  "Degree",
  "DegreeCentrality",
  "DegreeGraphDistribution",
  "DegreeLexicographic",
  "DegreeReverseLexicographic",
  "DEigensystem",
  "DEigenvalues",
  "Deinitialization",
  "Del",
  "DelaunayMesh",
  "Delayed",
  "Deletable",
  "Delete",
  "DeleteAdjacentDuplicates",
  "DeleteAnomalies",
  "DeleteBorderComponents",
  "DeleteCases",
  "DeleteChannel",
  "DeleteCloudExpression",
  "DeleteContents",
  "DeleteDirectory",
  "DeleteDuplicates",
  "DeleteDuplicatesBy",
  "DeleteElements",
  "DeleteFile",
  "DeleteMissing",
  "DeleteObject",
  "DeletePermissionsKey",
  "DeleteSearchIndex",
  "DeleteSmallComponents",
  "DeleteStopwords",
  "DeleteWithContents",
  "DeletionWarning",
  "DelimitedArray",
  "DelimitedSequence",
  "Delimiter",
  "DelimiterAutoMatching",
  "DelimiterFlashTime",
  "DelimiterMatching",
  "Delimiters",
  "DeliveryFunction",
  "Dendrogram",
  "Denominator",
  "DensityGraphics",
  "DensityHistogram",
  "DensityPlot",
  "DensityPlot3D",
  "DependentVariables",
  "Deploy",
  "Deployed",
  "Depth",
  "DepthFirstScan",
  "Derivative",
  "DerivativeFilter",
  "DerivativePDETerm",
  "DerivedKey",
  "DescriptorStateSpace",
  "DesignMatrix",
  "DestroyAfterEvaluation",
  "Det",
  "DeviceClose",
  "DeviceConfigure",
  "DeviceExecute",
  "DeviceExecuteAsynchronous",
  "DeviceObject",
  "DeviceOpen",
  "DeviceOpenQ",
  "DeviceRead",
  "DeviceReadBuffer",
  "DeviceReadLatest",
  "DeviceReadList",
  "DeviceReadTimeSeries",
  "Devices",
  "DeviceStreams",
  "DeviceWrite",
  "DeviceWriteBuffer",
  "DGaussianWavelet",
  "DiacriticalPositioning",
  "Diagonal",
  "DiagonalizableMatrixQ",
  "DiagonalMatrix",
  "DiagonalMatrixQ",
  "Dialog",
  "DialogIndent",
  "DialogInput",
  "DialogLevel",
  "DialogNotebook",
  "DialogProlog",
  "DialogReturn",
  "DialogSymbols",
  "Diamond",
  "DiamondMatrix",
  "DiceDissimilarity",
  "DictionaryLookup",
  "DictionaryWordQ",
  "DifferenceDelta",
  "DifferenceOrder",
  "DifferenceQuotient",
  "DifferenceRoot",
  "DifferenceRootReduce",
  "Differences",
  "DifferentialD",
  "DifferentialRoot",
  "DifferentialRootReduce",
  "DifferentiatorFilter",
  "DiffusionPDETerm",
  "DiggleGatesPointProcess",
  "DiggleGrattonPointProcess",
  "DigitalSignature",
  "DigitBlock",
  "DigitBlockMinimum",
  "DigitCharacter",
  "DigitCount",
  "DigitQ",
  "DihedralAngle",
  "DihedralGroup",
  "Dilation",
  "DimensionalCombinations",
  "DimensionalMeshComponents",
  "DimensionReduce",
  "DimensionReducerFunction",
  "DimensionReduction",
  "Dimensions",
  "DiracComb",
  "DiracDelta",
  "DirectedEdge",
  "DirectedEdges",
  "DirectedGraph",
  "DirectedGraphQ",
  "DirectedInfinity",
  "Direction",
  "DirectionalLight",
  "Directive",
  "Directory",
  "DirectoryName",
  "DirectoryQ",
  "DirectoryStack",
  "DirichletBeta",
  "DirichletCharacter",
  "DirichletCondition",
  "DirichletConvolve",
  "DirichletDistribution",
  "DirichletEta",
  "DirichletL",
  "DirichletLambda",
  "DirichletTransform",
  "DirichletWindow",
  "DisableConsolePrintPacket",
  "DisableFormatting",
  "DiscreteAsymptotic",
  "DiscreteChirpZTransform",
  "DiscreteConvolve",
  "DiscreteDelta",
  "DiscreteHadamardTransform",
  "DiscreteIndicator",
  "DiscreteInputOutputModel",
  "DiscreteLimit",
  "DiscreteLQEstimatorGains",
  "DiscreteLQRegulatorGains",
  "DiscreteLyapunovSolve",
  "DiscreteMarkovProcess",
  "DiscreteMaxLimit",
  "DiscreteMinLimit",
  "DiscretePlot",
  "DiscretePlot3D",
  "DiscreteRatio",
  "DiscreteRiccatiSolve",
  "DiscreteShift",
  "DiscreteTimeModelQ",
  "DiscreteUniformDistribution",
  "DiscreteVariables",
  "DiscreteWaveletData",
  "DiscreteWaveletPacketTransform",
  "DiscreteWaveletTransform",
  "DiscretizeGraphics",
  "DiscretizeRegion",
  "Discriminant",
  "DisjointQ",
  "Disjunction",
  "Disk",
  "DiskBox",
  "DiskBoxOptions",
  "DiskMatrix",
  "DiskSegment",
  "Dispatch",
  "DispatchQ",
  "DispersionEstimatorFunction",
  "Display",
  "DisplayAllSteps",
  "DisplayEndPacket",
  "DisplayForm",
  "DisplayFunction",
  "DisplayPacket",
  "DisplayRules",
  "DisplayString",
  "DisplayTemporary",
  "DisplayWith",
  "DisplayWithRef",
  "DisplayWithVariable",
  "DistanceFunction",
  "DistanceMatrix",
  "DistanceTransform",
  "Distribute",
  "Distributed",
  "DistributedContexts",
  "DistributeDefinitions",
  "DistributionChart",
  "DistributionDomain",
  "DistributionFitTest",
  "DistributionParameterAssumptions",
  "DistributionParameterQ",
  "Dithering",
  "Div",
  "Divergence",
  "Divide",
  "DivideBy",
  "Dividers",
  "DivideSides",
  "Divisible",
  "Divisors",
  "DivisorSigma",
  "DivisorSum",
  "DMSList",
  "DMSString",
  "Do",
  "DockedCell",
  "DockedCells",
  "DocumentGenerator",
  "DocumentGeneratorInformation",
  "DocumentGeneratorInformationData",
  "DocumentGenerators",
  "DocumentNotebook",
  "DocumentWeightingRules",
  "Dodecahedron",
  "DomainRegistrationInformation",
  "DominantColors",
  "DominatorTreeGraph",
  "DominatorVertexList",
  "DOSTextFormat",
  "Dot",
  "DotDashed",
  "DotEqual",
  "DotLayer",
  "DotPlusLayer",
  "Dotted",
  "DoubleBracketingBar",
  "DoubleContourIntegral",
  "DoubleDownArrow",
  "DoubleLeftArrow",
  "DoubleLeftRightArrow",
  "DoubleLeftTee",
  "DoubleLongLeftArrow",
  "DoubleLongLeftRightArrow",
  "DoubleLongRightArrow",
  "DoubleRightArrow",
  "DoubleRightTee",
  "DoubleUpArrow",
  "DoubleUpDownArrow",
  "DoubleVerticalBar",
  "DoublyInfinite",
  "Down",
  "DownArrow",
  "DownArrowBar",
  "DownArrowUpArrow",
  "DownLeftRightVector",
  "DownLeftTeeVector",
  "DownLeftVector",
  "DownLeftVectorBar",
  "DownRightTeeVector",
  "DownRightVector",
  "DownRightVectorBar",
  "Downsample",
  "DownTee",
  "DownTeeArrow",
  "DownValues",
  "DownValuesFunction",
  "DragAndDrop",
  "DrawBackFaces",
  "DrawEdges",
  "DrawFrontFaces",
  "DrawHighlighted",
  "DrazinInverse",
  "Drop",
  "DropoutLayer",
  "DropShadowing",
  "DSolve",
  "DSolveChangeVariables",
  "DSolveValue",
  "Dt",
  "DualLinearProgramming",
  "DualPlanarGraph",
  "DualPolyhedron",
  "DualSystemsModel",
  "DumpGet",
  "DumpSave",
  "DuplicateFreeQ",
  "Duration",
  "Dynamic",
  "DynamicBox",
  "DynamicBoxOptions",
  "DynamicEvaluationTimeout",
  "DynamicGeoGraphics",
  "DynamicImage",
  "DynamicLocation",
  "DynamicModule",
  "DynamicModuleBox",
  "DynamicModuleBoxOptions",
  "DynamicModuleParent",
  "DynamicModuleValues",
  "DynamicName",
  "DynamicNamespace",
  "DynamicReference",
  "DynamicSetting",
  "DynamicUpdating",
  "DynamicWrapper",
  "DynamicWrapperBox",
  "DynamicWrapperBoxOptions",
  "E",
  "EarthImpactData",
  "EarthquakeData",
  "EccentricityCentrality",
  "Echo",
  "EchoEvaluation",
  "EchoFunction",
  "EchoLabel",
  "EchoTiming",
  "EclipseType",
  "EdgeAdd",
  "EdgeBetweennessCentrality",
  "EdgeCapacity",
  "EdgeCapForm",
  "EdgeChromaticNumber",
  "EdgeColor",
  "EdgeConnectivity",
  "EdgeContract",
  "EdgeCost",
  "EdgeCount",
  "EdgeCoverQ",
  "EdgeCycleMatrix",
  "EdgeDashing",
  "EdgeDelete",
  "EdgeDetect",
  "EdgeForm",
  "EdgeIndex",
  "EdgeJoinForm",
  "EdgeLabeling",
  "EdgeLabels",
  "EdgeLabelStyle",
  "EdgeList",
  "EdgeOpacity",
  "EdgeQ",
  "EdgeRenderingFunction",
  "EdgeRules",
  "EdgeShapeFunction",
  "EdgeStyle",
  "EdgeTaggedGraph",
  "EdgeTaggedGraphQ",
  "EdgeTags",
  "EdgeThickness",
  "EdgeTransitiveGraphQ",
  "EdgeValueRange",
  "EdgeValueSizes",
  "EdgeWeight",
  "EdgeWeightedGraphQ",
  "Editable",
  "EditButtonSettings",
  "EditCellTagsSettings",
  "EditDistance",
  "EffectiveInterest",
  "Eigensystem",
  "Eigenvalues",
  "EigenvectorCentrality",
  "Eigenvectors",
  "Element",
  "ElementData",
  "ElementwiseLayer",
  "ElidedForms",
  "Eliminate",
  "EliminationOrder",
  "Ellipsoid",
  "EllipticE",
  "EllipticExp",
  "EllipticExpPrime",
  "EllipticF",
  "EllipticFilterModel",
  "EllipticK",
  "EllipticLog",
  "EllipticNomeQ",
  "EllipticPi",
  "EllipticReducedHalfPeriods",
  "EllipticTheta",
  "EllipticThetaPrime",
  "EmbedCode",
  "EmbeddedHTML",
  "EmbeddedService",
  "EmbeddedSQLEntityClass",
  "EmbeddedSQLExpression",
  "EmbeddingLayer",
  "EmbeddingObject",
  "EmitSound",
  "EmphasizeSyntaxErrors",
  "EmpiricalDistribution",
  "Empty",
  "EmptyGraphQ",
  "EmptyRegion",
  "EmptySpaceF",
  "EnableConsolePrintPacket",
  "Enabled",
  "Enclose",
  "Encode",
  "Encrypt",
  "EncryptedObject",
  "EncryptFile",
  "End",
  "EndAdd",
  "EndDialogPacket",
  "EndOfBuffer",
  "EndOfFile",
  "EndOfLine",
  "EndOfString",
  "EndPackage",
  "EngineEnvironment",
  "EngineeringForm",
  "Enter",
  "EnterExpressionPacket",
  "EnterTextPacket",
  "Entity",
  "EntityClass",
  "EntityClassList",
  "EntityCopies",
  "EntityFunction",
  "EntityGroup",
  "EntityInstance",
  "EntityList",
  "EntityPrefetch",
  "EntityProperties",
  "EntityProperty",
  "EntityPropertyClass",
  "EntityRegister",
  "EntityStore",
  "EntityStores",
  "EntityTypeName",
  "EntityUnregister",
  "EntityValue",
  "Entropy",
  "EntropyFilter",
  "Environment",
  "Epilog",
  "EpilogFunction",
  "Equal",
  "EqualColumns",
  "EqualRows",
  "EqualTilde",
  "EqualTo",
  "EquatedTo",
  "Equilibrium",
  "EquirippleFilterKernel",
  "Equivalent",
  "Erf",
  "Erfc",
  "Erfi",
  "ErlangB",
  "ErlangC",
  "ErlangDistribution",
  "Erosion",
  "ErrorBox",
  "ErrorBoxOptions",
  "ErrorNorm",
  "ErrorPacket",
  "ErrorsDialogSettings",
  "EscapeRadius",
  "EstimatedBackground",
  "EstimatedDistribution",
  "EstimatedPointNormals",
  "EstimatedPointProcess",
  "EstimatedProcess",
  "EstimatedVariogramModel",
  "EstimatorGains",
  "EstimatorRegulator",
  "EuclideanDistance",
  "EulerAngles",
  "EulerCharacteristic",
  "EulerE",
  "EulerGamma",
  "EulerianGraphQ",
  "EulerMatrix",
  "EulerPhi",
  "Evaluatable",
  "Evaluate",
  "Evaluated",
  "EvaluatePacket",
  "EvaluateScheduledTask",
  "EvaluationBox",
  "EvaluationCell",
  "EvaluationCompletionAction",
  "EvaluationData",
  "EvaluationElements",
  "EvaluationEnvironment",
  "EvaluationMode",
  "EvaluationMonitor",
  "EvaluationNotebook",
  "EvaluationObject",
  "EvaluationOrder",
  "EvaluationPrivileges",
  "EvaluationRateLimit",
  "Evaluator",
  "EvaluatorNames",
  "EvenQ",
  "EventData",
  "EventEvaluator",
  "EventHandler",
  "EventHandlerTag",
  "EventLabels",
  "EventSeries",
  "ExactBlackmanWindow",
  "ExactNumberQ",
  "ExactRootIsolation",
  "ExampleData",
  "Except",
  "ExcludedContexts",
  "ExcludedForms",
  "ExcludedLines",
  "ExcludedPhysicalQuantities",
  "ExcludePods",
  "Exclusions",
  "ExclusionsStyle",
  "Exists",
  "Exit",
  "ExitDialog",
  "ExoplanetData",
  "Exp",
  "Expand",
  "ExpandAll",
  "ExpandDenominator",
  "ExpandFileName",
  "ExpandNumerator",
  "Expectation",
  "ExpectationE",
  "ExpectedValue",
  "ExpGammaDistribution",
  "ExpIntegralE",
  "ExpIntegralEi",
  "ExpirationDate",
  "Exponent",
  "ExponentFunction",
  "ExponentialDistribution",
  "ExponentialFamily",
  "ExponentialGeneratingFunction",
  "ExponentialMovingAverage",
  "ExponentialPowerDistribution",
  "ExponentPosition",
  "ExponentStep",
  "Export",
  "ExportAutoReplacements",
  "ExportByteArray",
  "ExportForm",
  "ExportPacket",
  "ExportString",
  "Expression",
  "ExpressionCell",
  "ExpressionGraph",
  "ExpressionPacket",
  "ExpressionTree",
  "ExpressionUUID",
  "ExpToTrig",
  "ExtendedEntityClass",
  "ExtendedGCD",
  "Extension",
  "ExtentElementFunction",
  "ExtentMarkers",
  "ExtentSize",
  "ExternalBundle",
  "ExternalCall",
  "ExternalDataCharacterEncoding",
  "ExternalEvaluate",
  "ExternalFunction",
  "ExternalFunctionName",
  "ExternalIdentifier",
  "ExternalObject",
  "ExternalOptions",
  "ExternalSessionObject",
  "ExternalSessions",
  "ExternalStorageBase",
  "ExternalStorageDownload",
  "ExternalStorageGet",
  "ExternalStorageObject",
  "ExternalStoragePut",
  "ExternalStorageUpload",
  "ExternalTypeSignature",
  "ExternalValue",
  "Extract",
  "ExtractArchive",
  "ExtractLayer",
  "ExtractPacletArchive",
  "ExtremeValueDistribution",
  "FaceAlign",
  "FaceForm",
  "FaceGrids",
  "FaceGridsStyle",
  "FaceRecognize",
  "FacialFeatures",
  "Factor",
  "FactorComplete",
  "Factorial",
  "Factorial2",
  "FactorialMoment",
  "FactorialMomentGeneratingFunction",
  "FactorialPower",
  "FactorInteger",
  "FactorList",
  "FactorSquareFree",
  "FactorSquareFreeList",
  "FactorTerms",
  "FactorTermsList",
  "Fail",
  "Failure",
  "FailureAction",
  "FailureDistribution",
  "FailureQ",
  "False",
  "FareySequence",
  "FARIMAProcess",
  "FeatureDistance",
  "FeatureExtract",
  "FeatureExtraction",
  "FeatureExtractor",
  "FeatureExtractorFunction",
  "FeatureImpactPlot",
  "FeatureNames",
  "FeatureNearest",
  "FeatureSpacePlot",
  "FeatureSpacePlot3D",
  "FeatureTypes",
  "FeatureValueDependencyPlot",
  "FeatureValueImpactPlot",
  "FEDisableConsolePrintPacket",
  "FeedbackLinearize",
  "FeedbackSector",
  "FeedbackSectorStyle",
  "FeedbackType",
  "FEEnableConsolePrintPacket",
  "FetalGrowthData",
  "Fibonacci",
  "Fibonorial",
  "FieldCompletionFunction",
  "FieldHint",
  "FieldHintStyle",
  "FieldMasked",
  "FieldSize",
  "File",
  "FileBaseName",
  "FileByteCount",
  "FileConvert",
  "FileDate",
  "FileExistsQ",
  "FileExtension",
  "FileFormat",
  "FileFormatProperties",
  "FileFormatQ",
  "FileHandler",
  "FileHash",
  "FileInformation",
  "FileName",
  "FileNameDepth",
  "FileNameDialogSettings",
  "FileNameDrop",
  "FileNameForms",
  "FileNameJoin",
  "FileNames",
  "FileNameSetter",
  "FileNameSplit",
  "FileNameTake",
  "FileNameToFormatList",
  "FilePrint",
  "FileSize",
  "FileSystemMap",
  "FileSystemScan",
  "FileSystemTree",
  "FileTemplate",
  "FileTemplateApply",
  "FileType",
  "FilledCurve",
  "FilledCurveBox",
  "FilledCurveBoxOptions",
  "FilledTorus",
  "FillForm",
  "Filling",
  "FillingStyle",
  "FillingTransform",
  "FilteredEntityClass",
  "FilterRules",
  "FinancialBond",
  "FinancialData",
  "FinancialDerivative",
  "FinancialIndicator",
  "Find",
  "FindAnomalies",
  "FindArgMax",
  "FindArgMin",
  "FindChannels",
  "FindClique",
  "FindClusters",
  "FindCookies",
  "FindCurvePath",
  "FindCycle",
  "FindDevices",
  "FindDistribution",
  "FindDistributionParameters",
  "FindDivisions",
  "FindEdgeColoring",
  "FindEdgeCover",
  "FindEdgeCut",
  "FindEdgeIndependentPaths",
  "FindEquationalProof",
  "FindEulerianCycle",
  "FindExternalEvaluators",
  "FindFaces",
  "FindFile",
  "FindFit",
  "FindFormula",
  "FindFundamentalCycles",
  "FindGeneratingFunction",
  "FindGeoLocation",
  "FindGeometricConjectures",
  "FindGeometricTransform",
  "FindGraphCommunities",
  "FindGraphIsomorphism",
  "FindGraphPartition",
  "FindHamiltonianCycle",
  "FindHamiltonianPath",
  "FindHiddenMarkovStates",
  "FindImageText",
  "FindIndependentEdgeSet",
  "FindIndependentVertexSet",
  "FindInstance",
  "FindIntegerNullVector",
  "FindIsomers",
  "FindIsomorphicSubgraph",
  "FindKClan",
  "FindKClique",
  "FindKClub",
  "FindKPlex",
  "FindLibrary",
  "FindLinearRecurrence",
  "FindList",
  "FindMatchingColor",
  "FindMaximum",
  "FindMaximumCut",
  "FindMaximumFlow",
  "FindMaxValue",
  "FindMeshDefects",
  "FindMinimum",
  "FindMinimumCostFlow",
  "FindMinimumCut",
  "FindMinValue",
  "FindMoleculeSubstructure",
  "FindPath",
  "FindPeaks",
  "FindPermutation",
  "FindPlanarColoring",
  "FindPointProcessParameters",
  "FindPostmanTour",
  "FindProcessParameters",
  "FindRegionTransform",
  "FindRepeat",
  "FindRoot",
  "FindSequenceFunction",
  "FindSettings",
  "FindShortestPath",
  "FindShortestTour",
  "FindSpanningTree",
  "FindSubgraphIsomorphism",
  "FindSystemModelEquilibrium",
  "FindTextualAnswer",
  "FindThreshold",
  "FindTransientRepeat",
  "FindVertexColoring",
  "FindVertexCover",
  "FindVertexCut",
  "FindVertexIndependentPaths",
  "Fine",
  "FinishDynamic",
  "FiniteAbelianGroupCount",
  "FiniteGroupCount",
  "FiniteGroupData",
  "First",
  "FirstCase",
  "FirstPassageTimeDistribution",
  "FirstPosition",
  "FischerGroupFi22",
  "FischerGroupFi23",
  "FischerGroupFi24Prime",
  "FisherHypergeometricDistribution",
  "FisherRatioTest",
  "FisherZDistribution",
  "Fit",
  "FitAll",
  "FitRegularization",
  "FittedModel",
  "FixedOrder",
  "FixedPoint",
  "FixedPointList",
  "FlashSelection",
  "Flat",
  "FlatShading",
  "Flatten",
  "FlattenAt",
  "FlattenLayer",
  "FlatTopWindow",
  "FlightData",
  "FlipView",
  "Floor",
  "FlowPolynomial",
  "Fold",
  "FoldList",
  "FoldPair",
  "FoldPairList",
  "FoldWhile",
  "FoldWhileList",
  "FollowRedirects",
  "Font",
  "FontColor",
  "FontFamily",
  "FontForm",
  "FontName",
  "FontOpacity",
  "FontPostScriptName",
  "FontProperties",
  "FontReencoding",
  "FontSize",
  "FontSlant",
  "FontSubstitutions",
  "FontTracking",
  "FontVariations",
  "FontWeight",
  "For",
  "ForAll",
  "ForAllType",
  "ForceVersionInstall",
  "Format",
  "FormatRules",
  "FormatType",
  "FormatTypeAutoConvert",
  "FormatValues",
  "FormBox",
  "FormBoxOptions",
  "FormControl",
  "FormFunction",
  "FormLayoutFunction",
  "FormObject",
  "FormPage",
  "FormProtectionMethod",
  "FormTheme",
  "FormulaData",
  "FormulaLookup",
  "FortranForm",
  "Forward",
  "ForwardBackward",
  "ForwardCloudCredentials",
  "Fourier",
  "FourierCoefficient",
  "FourierCosCoefficient",
  "FourierCosSeries",
  "FourierCosTransform",
  "FourierDCT",
  "FourierDCTFilter",
  "FourierDCTMatrix",
  "FourierDST",
  "FourierDSTMatrix",
  "FourierMatrix",
  "FourierParameters",
  "FourierSequenceTransform",
  "FourierSeries",
  "FourierSinCoefficient",
  "FourierSinSeries",
  "FourierSinTransform",
  "FourierTransform",
  "FourierTrigSeries",
  "FoxH",
  "FoxHReduce",
  "FractionalBrownianMotionProcess",
  "FractionalD",
  "FractionalGaussianNoiseProcess",
  "FractionalPart",
  "FractionBox",
  "FractionBoxOptions",
  "FractionLine",
  "Frame",
  "FrameBox",
  "FrameBoxOptions",
  "Framed",
  "FrameInset",
  "FrameLabel",
  "Frameless",
  "FrameListVideo",
  "FrameMargins",
  "FrameRate",
  "FrameStyle",
  "FrameTicks",
  "FrameTicksStyle",
  "FRatioDistribution",
  "FrechetDistribution",
  "FreeQ",
  "FrenetSerretSystem",
  "FrequencySamplingFilterKernel",
  "FresnelC",
  "FresnelF",
  "FresnelG",
  "FresnelS",
  "Friday",
  "FrobeniusNumber",
  "FrobeniusSolve",
  "FromAbsoluteTime",
  "FromCharacterCode",
  "FromCoefficientRules",
  "FromContinuedFraction",
  "FromDate",
  "FromDateString",
  "FromDigits",
  "FromDMS",
  "FromEntity",
  "FromJulianDate",
  "FromLetterNumber",
  "FromPolarCoordinates",
  "FromRawPointer",
  "FromRomanNumeral",
  "FromSphericalCoordinates",
  "FromUnixTime",
  "Front",
  "FrontEndDynamicExpression",
  "FrontEndEventActions",
  "FrontEndExecute",
  "FrontEndObject",
  "FrontEndResource",
  "FrontEndResourceString",
  "FrontEndStackSize",
  "FrontEndToken",
  "FrontEndTokenExecute",
  "FrontEndValueCache",
  "FrontEndVersion",
  "FrontFaceColor",
  "FrontFaceGlowColor",
  "FrontFaceOpacity",
  "FrontFaceSpecularColor",
  "FrontFaceSpecularExponent",
  "FrontFaceSurfaceAppearance",
  "FrontFaceTexture",
  "Full",
  "FullAxes",
  "FullDefinition",
  "FullForm",
  "FullGraphics",
  "FullInformationOutputRegulator",
  "FullOptions",
  "FullRegion",
  "FullSimplify",
  "Function",
  "FunctionAnalytic",
  "FunctionBijective",
  "FunctionCompile",
  "FunctionCompileExport",
  "FunctionCompileExportByteArray",
  "FunctionCompileExportLibrary",
  "FunctionCompileExportString",
  "FunctionContinuous",
  "FunctionConvexity",
  "FunctionDeclaration",
  "FunctionDiscontinuities",
  "FunctionDomain",
  "FunctionExpand",
  "FunctionInjective",
  "FunctionInterpolation",
  "FunctionLayer",
  "FunctionMeromorphic",
  "FunctionMonotonicity",
  "FunctionPeriod",
  "FunctionPoles",
  "FunctionRange",
  "FunctionSign",
  "FunctionSingularities",
  "FunctionSpace",
  "FunctionSurjective",
  "FussellVeselyImportance",
  "GaborFilter",
  "GaborMatrix",
  "GaborWavelet",
  "GainMargins",
  "GainPhaseMargins",
  "GalaxyData",
  "GalleryView",
  "Gamma",
  "GammaDistribution",
  "GammaRegularized",
  "GapPenalty",
  "GARCHProcess",
  "GatedRecurrentLayer",
  "Gather",
  "GatherBy",
  "GaugeFaceElementFunction",
  "GaugeFaceStyle",
  "GaugeFrameElementFunction",
  "GaugeFrameSize",
  "GaugeFrameStyle",
  "GaugeLabels",
  "GaugeMarkers",
  "GaugeStyle",
  "GaussianFilter",
  "GaussianIntegers",
  "GaussianMatrix",
  "GaussianOrthogonalMatrixDistribution",
  "GaussianSymplecticMatrixDistribution",
  "GaussianUnitaryMatrixDistribution",
  "GaussianWindow",
  "GCD",
  "GegenbauerC",
  "General",
  "GeneralizedLinearModelFit",
  "GenerateAsymmetricKeyPair",
  "GenerateConditions",
  "GeneratedAssetFormat",
  "GeneratedAssetLocation",
  "GeneratedCell",
  "GeneratedCellStyles",
  "GeneratedDocumentBinding",
  "GenerateDerivedKey",
  "GenerateDigitalSignature",
  "GenerateDocument",
  "GeneratedParameters",
  "GeneratedQuantityMagnitudes",
  "GenerateFileSignature",
  "GenerateHTTPResponse",
  "GenerateSecuredAuthenticationKey",
  "GenerateSymmetricKey",
  "GeneratingFunction",
  "GeneratorDescription",
  "GeneratorHistoryLength",
  "GeneratorOutputType",
  "Generic",
  "GenericCylindricalDecomposition",
  "GenomeData",
  "GenomeLookup",
  "GeoAntipode",
  "GeoArea",
  "GeoArraySize",
  "GeoBackground",
  "GeoBoundary",
  "GeoBoundingBox",
  "GeoBounds",
  "GeoBoundsRegion",
  "GeoBoundsRegionBoundary",
  "GeoBubbleChart",
  "GeoCenter",
  "GeoCircle",
  "GeoContourPlot",
  "GeoDensityPlot",
  "GeodesicClosing",
  "GeodesicDilation",
  "GeodesicErosion",
  "GeodesicOpening",
  "GeodesicPolyhedron",
  "GeoDestination",
  "GeodesyData",
  "GeoDirection",
  "GeoDisk",
  "GeoDisplacement",
  "GeoDistance",
  "GeoDistanceList",
  "GeoElevationData",
  "GeoEntities",
  "GeoGraphics",
  "GeoGraphPlot",
  "GeoGraphValuePlot",
  "GeogravityModelData",
  "GeoGridDirectionDifference",
  "GeoGridLines",
  "GeoGridLinesStyle",
  "GeoGridPosition",
  "GeoGridRange",
  "GeoGridRangePadding",
  "GeoGridUnitArea",
  "GeoGridUnitDistance",
  "GeoGridVector",
  "GeoGroup",
  "GeoHemisphere",
  "GeoHemisphereBoundary",
  "GeoHistogram",
  "GeoIdentify",
  "GeoImage",
  "GeoLabels",
  "GeoLength",
  "GeoListPlot",
  "GeoLocation",
  "GeologicalPeriodData",
  "GeomagneticModelData",
  "GeoMarker",
  "GeometricAssertion",
  "GeometricBrownianMotionProcess",
  "GeometricDistribution",
  "GeometricMean",
  "GeometricMeanFilter",
  "GeometricOptimization",
  "GeometricScene",
  "GeometricStep",
  "GeometricStylingRules",
  "GeometricTest",
  "GeometricTransformation",
  "GeometricTransformation3DBox",
  "GeometricTransformation3DBoxOptions",
  "GeometricTransformationBox",
  "GeometricTransformationBoxOptions",
  "GeoModel",
  "GeoNearest",
  "GeoOrientationData",
  "GeoPath",
  "GeoPolygon",
  "GeoPosition",
  "GeoPositionENU",
  "GeoPositionXYZ",
  "GeoProjection",
  "GeoProjectionData",
  "GeoRange",
  "GeoRangePadding",
  "GeoRegionValuePlot",
  "GeoResolution",
  "GeoScaleBar",
  "GeoServer",
  "GeoSmoothHistogram",
  "GeoStreamPlot",
  "GeoStyling",
  "GeoStylingImageFunction",
  "GeoVariant",
  "GeoVector",
  "GeoVectorENU",
  "GeoVectorPlot",
  "GeoVectorXYZ",
  "GeoVisibleRegion",
  "GeoVisibleRegionBoundary",
  "GeoWithinQ",
  "GeoZoomLevel",
  "GestureHandler",
  "GestureHandlerTag",
  "Get",
  "GetContext",
  "GetEnvironment",
  "GetFileName",
  "GetLinebreakInformationPacket",
  "GibbsPointProcess",
  "Glaisher",
  "GlobalClusteringCoefficient",
  "GlobalPreferences",
  "GlobalSession",
  "Glow",
  "GoldenAngle",
  "GoldenRatio",
  "GompertzMakehamDistribution",
  "GoochShading",
  "GoodmanKruskalGamma",
  "GoodmanKruskalGammaTest",
  "Goto",
  "GouraudShading",
  "Grad",
  "Gradient",
  "GradientFilter",
  "GradientFittedMesh",
  "GradientOrientationFilter",
  "GrammarApply",
  "GrammarRules",
  "GrammarToken",
  "Graph",
  "Graph3D",
  "GraphAssortativity",
  "GraphAutomorphismGroup",
  "GraphCenter",
  "GraphComplement",
  "GraphData",
  "GraphDensity",
  "GraphDiameter",
  "GraphDifference",
  "GraphDisjointUnion",
  "GraphDistance",
  "GraphDistanceMatrix",
  "GraphEmbedding",
  "GraphHighlight",
  "GraphHighlightStyle",
  "GraphHub",
  "Graphics",
  "Graphics3D",
  "Graphics3DBox",
  "Graphics3DBoxOptions",
  "GraphicsArray",
  "GraphicsBaseline",
  "GraphicsBox",
  "GraphicsBoxOptions",
  "GraphicsColor",
  "GraphicsColumn",
  "GraphicsComplex",
  "GraphicsComplex3DBox",
  "GraphicsComplex3DBoxOptions",
  "GraphicsComplexBox",
  "GraphicsComplexBoxOptions",
  "GraphicsContents",
  "GraphicsData",
  "GraphicsGrid",
  "GraphicsGridBox",
  "GraphicsGroup",
  "GraphicsGroup3DBox",
  "GraphicsGroup3DBoxOptions",
  "GraphicsGroupBox",
  "GraphicsGroupBoxOptions",
  "GraphicsGrouping",
  "GraphicsHighlightColor",
  "GraphicsRow",
  "GraphicsSpacing",
  "GraphicsStyle",
  "GraphIntersection",
  "GraphJoin",
  "GraphLayerLabels",
  "GraphLayers",
  "GraphLayerStyle",
  "GraphLayout",
  "GraphLinkEfficiency",
  "GraphPeriphery",
  "GraphPlot",
  "GraphPlot3D",
  "GraphPower",
  "GraphProduct",
  "GraphPropertyDistribution",
  "GraphQ",
  "GraphRadius",
  "GraphReciprocity",
  "GraphRoot",
  "GraphStyle",
  "GraphSum",
  "GraphTree",
  "GraphUnion",
  "Gray",
  "GrayLevel",
  "Greater",
  "GreaterEqual",
  "GreaterEqualLess",
  "GreaterEqualThan",
  "GreaterFullEqual",
  "GreaterGreater",
  "GreaterLess",
  "GreaterSlantEqual",
  "GreaterThan",
  "GreaterTilde",
  "GreekStyle",
  "Green",
  "GreenFunction",
  "Grid",
  "GridBaseline",
  "GridBox",
  "GridBoxAlignment",
  "GridBoxBackground",
  "GridBoxDividers",
  "GridBoxFrame",
  "GridBoxItemSize",
  "GridBoxItemStyle",
  "GridBoxOptions",
  "GridBoxSpacings",
  "GridCreationSettings",
  "GridDefaultElement",
  "GridElementStyleOptions",
  "GridFrame",
  "GridFrameMargins",
  "GridGraph",
  "GridLines",
  "GridLinesStyle",
  "GridVideo",
  "GroebnerBasis",
  "GroupActionBase",
  "GroupBy",
  "GroupCentralizer",
  "GroupElementFromWord",
  "GroupElementPosition",
  "GroupElementQ",
  "GroupElements",
  "GroupElementToWord",
  "GroupGenerators",
  "Groupings",
  "GroupMultiplicationTable",
  "GroupOpenerColor",
  "GroupOpenerInsideFrame",
  "GroupOrbits",
  "GroupOrder",
  "GroupPageBreakWithin",
  "GroupSetwiseStabilizer",
  "GroupStabilizer",
  "GroupStabilizerChain",
  "GroupTogetherGrouping",
  "GroupTogetherNestedGrouping",
  "GrowCutComponents",
  "Gudermannian",
  "GuidedFilter",
  "GumbelDistribution",
  "HaarWavelet",
  "HadamardMatrix",
  "HalfLine",
  "HalfNormalDistribution",
  "HalfPlane",
  "HalfSpace",
  "HalftoneShading",
  "HamiltonianGraphQ",
  "HammingDistance",
  "HammingWindow",
  "HandlerFunctions",
  "HandlerFunctionsKeys",
  "HankelH1",
  "HankelH2",
  "HankelMatrix",
  "HankelTransform",
  "HannPoissonWindow",
  "HannWindow",
  "HaradaNortonGroupHN",
  "HararyGraph",
  "HardcorePointProcess",
  "HarmonicMean",
  "HarmonicMeanFilter",
  "HarmonicNumber",
  "Hash",
  "HatchFilling",
  "HatchShading",
  "Haversine",
  "HazardFunction",
  "Head",
  "HeadCompose",
  "HeaderAlignment",
  "HeaderBackground",
  "HeaderDisplayFunction",
  "HeaderLines",
  "Headers",
  "HeaderSize",
  "HeaderStyle",
  "Heads",
  "HeatFluxValue",
  "HeatInsulationValue",
  "HeatOutflowValue",
  "HeatRadiationValue",
  "HeatSymmetryValue",
  "HeatTemperatureCondition",
  "HeatTransferPDEComponent",
  "HeatTransferValue",
  "HeavisideLambda",
  "HeavisidePi",
  "HeavisideTheta",
  "HeldGroupHe",
  "HeldPart",
  "HelmholtzPDEComponent",
  "HelpBrowserLookup",
  "HelpBrowserNotebook",
  "HelpBrowserSettings",
  "HelpViewerSettings",
  "Here",
  "HermiteDecomposition",
  "HermiteH",
  "Hermitian",
  "HermitianMatrixQ",
  "HessenbergDecomposition",
  "Hessian",
  "HeunB",
  "HeunBPrime",
  "HeunC",
  "HeunCPrime",
  "HeunD",
  "HeunDPrime",
  "HeunG",
  "HeunGPrime",
  "HeunT",
  "HeunTPrime",
  "HexadecimalCharacter",
  "Hexahedron",
  "HexahedronBox",
  "HexahedronBoxOptions",
  "HiddenItems",
  "HiddenMarkovProcess",
  "HiddenSurface",
  "Highlighted",
  "HighlightGraph",
  "HighlightImage",
  "HighlightMesh",
  "HighlightString",
  "HighpassFilter",
  "HigmanSimsGroupHS",
  "HilbertCurve",
  "HilbertFilter",
  "HilbertMatrix",
  "Histogram",
  "Histogram3D",
  "HistogramDistribution",
  "HistogramList",
  "HistogramPointDensity",
  "HistogramTransform",
  "HistogramTransformInterpolation",
  "HistoricalPeriodData",
  "HitMissTransform",
  "HITSCentrality",
  "HjorthDistribution",
  "HodgeDual",
  "HoeffdingD",
  "HoeffdingDTest",
  "Hold",
  "HoldAll",
  "HoldAllComplete",
  "HoldComplete",
  "HoldFirst",
  "HoldForm",
  "HoldPattern",
  "HoldRest",
  "HolidayCalendar",
  "HomeDirectory",
  "HomePage",
  "Horizontal",
  "HorizontalForm",
  "HorizontalGauge",
  "HorizontalScrollPosition",
  "HornerForm",
  "HostLookup",
  "HotellingTSquareDistribution",
  "HoytDistribution",
  "HTMLSave",
  "HTTPErrorResponse",
  "HTTPRedirect",
  "HTTPRequest",
  "HTTPRequestData",
  "HTTPResponse",
  "Hue",
  "HumanGrowthData",
  "HumpDownHump",
  "HumpEqual",
  "HurwitzLerchPhi",
  "HurwitzZeta",
  "HyperbolicDistribution",
  "HypercubeGraph",
  "HyperexponentialDistribution",
  "Hyperfactorial",
  "Hypergeometric0F1",
  "Hypergeometric0F1Regularized",
  "Hypergeometric1F1",
  "Hypergeometric1F1Regularized",
  "Hypergeometric2F1",
  "Hypergeometric2F1Regularized",
  "HypergeometricDistribution",
  "HypergeometricPFQ",
  "HypergeometricPFQRegularized",
  "HypergeometricU",
  "Hyperlink",
  "HyperlinkAction",
  "HyperlinkCreationSettings",
  "Hyperplane",
  "Hyphenation",
  "HyphenationOptions",
  "HypoexponentialDistribution",
  "HypothesisTestData",
  "I",
  "IconData",
  "Iconize",
  "IconizedObject",
  "IconRules",
  "Icosahedron",
  "Identity",
  "IdentityMatrix",
  "If",
  "IfCompiled",
  "IgnoreCase",
  "IgnoreDiacritics",
  "IgnoreIsotopes",
  "IgnorePunctuation",
  "IgnoreSpellCheck",
  "IgnoreStereochemistry",
  "IgnoringInactive",
  "Im",
  "Image",
  "Image3D",
  "Image3DProjection",
  "Image3DSlices",
  "ImageAccumulate",
  "ImageAdd",
  "ImageAdjust",
  "ImageAlign",
  "ImageApply",
  "ImageApplyIndexed",
  "ImageAspectRatio",
  "ImageAssemble",
  "ImageAugmentationLayer",
  "ImageBoundingBoxes",
  "ImageCache",
  "ImageCacheValid",
  "ImageCapture",
  "ImageCaptureFunction",
  "ImageCases",
  "ImageChannels",
  "ImageClip",
  "ImageCollage",
  "ImageColorSpace",
  "ImageCompose",
  "ImageContainsQ",
  "ImageContents",
  "ImageConvolve",
  "ImageCooccurrence",
  "ImageCorners",
  "ImageCorrelate",
  "ImageCorrespondingPoints",
  "ImageCrop",
  "ImageData",
  "ImageDeconvolve",
  "ImageDemosaic",
  "ImageDifference",
  "ImageDimensions",
  "ImageDisplacements",
  "ImageDistance",
  "ImageEditMode",
  "ImageEffect",
  "ImageExposureCombine",
  "ImageFeatureTrack",
  "ImageFileApply",
  "ImageFileFilter",
  "ImageFileScan",
  "ImageFilter",
  "ImageFocusCombine",
  "ImageForestingComponents",
  "ImageFormattingWidth",
  "ImageForwardTransformation",
  "ImageGraphics",
  "ImageHistogram",
  "ImageIdentify",
  "ImageInstanceQ",
  "ImageKeypoints",
  "ImageLabels",
  "ImageLegends",
  "ImageLevels",
  "ImageLines",
  "ImageMargins",
  "ImageMarker",
  "ImageMarkers",
  "ImageMeasurements",
  "ImageMesh",
  "ImageMultiply",
  "ImageOffset",
  "ImagePad",
  "ImagePadding",
  "ImagePartition",
  "ImagePeriodogram",
  "ImagePerspectiveTransformation",
  "ImagePosition",
  "ImagePreviewFunction",
  "ImagePyramid",
  "ImagePyramidApply",
  "ImageQ",
  "ImageRangeCache",
  "ImageRecolor",
  "ImageReflect",
  "ImageRegion",
  "ImageResize",
  "ImageResolution",
  "ImageRestyle",
  "ImageRotate",
  "ImageRotated",
  "ImageSaliencyFilter",
  "ImageScaled",
  "ImageScan",
  "ImageSize",
  "ImageSizeAction",
  "ImageSizeCache",
  "ImageSizeMultipliers",
  "ImageSizeRaw",
  "ImageStitch",
  "ImageSubtract",
  "ImageTake",
  "ImageTransformation",
  "ImageTrim",
  "ImageType",
  "ImageValue",
  "ImageValuePositions",
  "ImageVectorscopePlot",
  "ImageWaveformPlot",
  "ImagingDevice",
  "ImplicitD",
  "ImplicitRegion",
  "Implies",
  "Import",
  "ImportAutoReplacements",
  "ImportByteArray",
  "ImportedObject",
  "ImportOptions",
  "ImportString",
  "ImprovementImportance",
  "In",
  "Inactivate",
  "Inactive",
  "InactiveStyle",
  "IncidenceGraph",
  "IncidenceList",
  "IncidenceMatrix",
  "IncludeAromaticBonds",
  "IncludeConstantBasis",
  "IncludedContexts",
  "IncludeDefinitions",
  "IncludeDirectories",
  "IncludeFileExtension",
  "IncludeGeneratorTasks",
  "IncludeHydrogens",
  "IncludeInflections",
  "IncludeMetaInformation",
  "IncludePods",
  "IncludeQuantities",
  "IncludeRelatedTables",
  "IncludeSingularSolutions",
  "IncludeSingularTerm",
  "IncludeWindowTimes",
  "Increment",
  "IndefiniteMatrixQ",
  "Indent",
  "IndentingNewlineSpacings",
  "IndentMaxFraction",
  "IndependenceTest",
  "IndependentEdgeSetQ",
  "IndependentPhysicalQuantity",
  "IndependentUnit",
  "IndependentUnitDimension",
  "IndependentVertexSetQ",
  "Indeterminate",
  "IndeterminateThreshold",
  "IndexCreationOptions",
  "Indexed",
  "IndexEdgeTaggedGraph",
  "IndexGraph",
  "IndexTag",
  "Inequality",
  "InertEvaluate",
  "InertExpression",
  "InexactNumberQ",
  "InexactNumbers",
  "InfiniteFuture",
  "InfiniteLine",
  "InfiniteLineThrough",
  "InfinitePast",
  "InfinitePlane",
  "Infinity",
  "Infix",
  "InflationAdjust",
  "InflationMethod",
  "Information",
  "InformationData",
  "InformationDataGrid",
  "Inherited",
  "InheritScope",
  "InhomogeneousPoissonPointProcess",
  "InhomogeneousPoissonProcess",
  "InitialEvaluationHistory",
  "Initialization",
  "InitializationCell",
  "InitializationCellEvaluation",
  "InitializationCellWarning",
  "InitializationObject",
  "InitializationObjects",
  "InitializationValue",
  "Initialize",
  "InitialSeeding",
  "InlineCounterAssignments",
  "InlineCounterIncrements",
  "InlineRules",
  "Inner",
  "InnerPolygon",
  "InnerPolyhedron",
  "Inpaint",
  "Input",
  "InputAliases",
  "InputAssumptions",
  "InputAutoReplacements",
  "InputField",
  "InputFieldBox",
  "InputFieldBoxOptions",
  "InputForm",
  "InputGrouping",
  "InputNamePacket",
  "InputNotebook",
  "InputPacket",
  "InputPorts",
  "InputSettings",
  "InputStream",
  "InputString",
  "InputStringPacket",
  "InputToBoxFormPacket",
  "Insert",
  "InsertionFunction",
  "InsertionPointObject",
  "InsertLinebreaks",
  "InsertResults",
  "Inset",
  "Inset3DBox",
  "Inset3DBoxOptions",
  "InsetBox",
  "InsetBoxOptions",
  "Insphere",
  "Install",
  "InstallService",
  "InstanceNormalizationLayer",
  "InString",
  "Integer",
  "IntegerDigits",
  "IntegerExponent",
  "IntegerLength",
  "IntegerName",
  "IntegerPart",
  "IntegerPartitions",
  "IntegerQ",
  "IntegerReverse",
  "Integers",
  "IntegerString",
  "Integral",
  "Integrate",
  "IntegrateChangeVariables",
  "Interactive",
  "InteractiveTradingChart",
  "InterfaceSwitched",
  "Interlaced",
  "Interleaving",
  "InternallyBalancedDecomposition",
  "InterpolatingFunction",
  "InterpolatingPolynomial",
  "Interpolation",
  "InterpolationOrder",
  "InterpolationPoints",
  "InterpolationPrecision",
  "Interpretation",
  "InterpretationBox",
  "InterpretationBoxOptions",
  "InterpretationFunction",
  "Interpreter",
  "InterpretTemplate",
  "InterquartileRange",
  "Interrupt",
  "InterruptSettings",
  "IntersectedEntityClass",
  "IntersectingQ",
  "Intersection",
  "Interval",
  "IntervalIntersection",
  "IntervalMarkers",
  "IntervalMarkersStyle",
  "IntervalMemberQ",
  "IntervalSlider",
  "IntervalUnion",
  "Into",
  "Inverse",
  "InverseBetaRegularized",
  "InverseBilateralLaplaceTransform",
  "InverseBilateralZTransform",
  "InverseCDF",
  "InverseChiSquareDistribution",
  "InverseContinuousWaveletTransform",
  "InverseDistanceTransform",
  "InverseEllipticNomeQ",
  "InverseErf",
  "InverseErfc",
  "InverseFourier",
  "InverseFourierCosTransform",
  "InverseFourierSequenceTransform",
  "InverseFourierSinTransform",
  "InverseFourierTransform",
  "InverseFunction",
  "InverseFunctions",
  "InverseGammaDistribution",
  "InverseGammaRegularized",
  "InverseGaussianDistribution",
  "InverseGudermannian",
  "InverseHankelTransform",
  "InverseHaversine",
  "InverseImagePyramid",
  "InverseJacobiCD",
  "InverseJacobiCN",
  "InverseJacobiCS",
  "InverseJacobiDC",
  "InverseJacobiDN",
  "InverseJacobiDS",
  "InverseJacobiNC",
  "InverseJacobiND",
  "InverseJacobiNS",
  "InverseJacobiSC",
  "InverseJacobiSD",
  "InverseJacobiSN",
  "InverseLaplaceTransform",
  "InverseMellinTransform",
  "InversePermutation",
  "InverseRadon",
  "InverseRadonTransform",
  "InverseSeries",
  "InverseShortTimeFourier",
  "InverseSpectrogram",
  "InverseSurvivalFunction",
  "InverseTransformedRegion",
  "InverseWaveletTransform",
  "InverseWeierstrassP",
  "InverseWishartMatrixDistribution",
  "InverseZTransform",
  "Invisible",
  "InvisibleApplication",
  "InvisibleTimes",
  "IPAddress",
  "IrreduciblePolynomialQ",
  "IslandData",
  "IsolatingInterval",
  "IsomorphicGraphQ",
  "IsomorphicSubgraphQ",
  "IsotopeData",
  "Italic",
  "Item",
  "ItemAspectRatio",
  "ItemBox",
  "ItemBoxOptions",
  "ItemDisplayFunction",
  "ItemSize",
  "ItemStyle",
  "ItoProcess",
  "JaccardDissimilarity",
  "JacobiAmplitude",
  "Jacobian",
  "JacobiCD",
  "JacobiCN",
  "JacobiCS",
  "JacobiDC",
  "JacobiDN",
  "JacobiDS",
  "JacobiEpsilon",
  "JacobiNC",
  "JacobiND",
  "JacobiNS",
  "JacobiP",
  "JacobiSC",
  "JacobiSD",
  "JacobiSN",
  "JacobiSymbol",
  "JacobiZeta",
  "JacobiZN",
  "JankoGroupJ1",
  "JankoGroupJ2",
  "JankoGroupJ3",
  "JankoGroupJ4",
  "JarqueBeraALMTest",
  "JohnsonDistribution",
  "Join",
  "JoinAcross",
  "Joined",
  "JoinedCurve",
  "JoinedCurveBox",
  "JoinedCurveBoxOptions",
  "JoinForm",
  "JordanDecomposition",
  "JordanModelDecomposition",
  "JulianDate",
  "JuliaSetBoettcher",
  "JuliaSetIterationCount",
  "JuliaSetPlot",
  "JuliaSetPoints",
  "K",
  "KagiChart",
  "KaiserBesselWindow",
  "KaiserWindow",
  "KalmanEstimator",
  "KalmanFilter",
  "KarhunenLoeveDecomposition",
  "KaryTree",
  "KatzCentrality",
  "KCoreComponents",
  "KDistribution",
  "KEdgeConnectedComponents",
  "KEdgeConnectedGraphQ",
  "KeepExistingVersion",
  "KelvinBei",
  "KelvinBer",
  "KelvinKei",
  "KelvinKer",
  "KendallTau",
  "KendallTauTest",
  "KernelConfiguration",
  "KernelExecute",
  "KernelFunction",
  "KernelMixtureDistribution",
  "KernelObject",
  "Kernels",
  "Ket",
  "Key",
  "KeyCollisionFunction",
  "KeyComplement",
  "KeyDrop",
  "KeyDropFrom",
  "KeyExistsQ",
  "KeyFreeQ",
  "KeyIntersection",
  "KeyMap",
  "KeyMemberQ",
  "KeypointStrength",
  "Keys",
  "KeySelect",
  "KeySort",
  "KeySortBy",
  "KeyTake",
  "KeyUnion",
  "KeyValueMap",
  "KeyValuePattern",
  "Khinchin",
  "KillProcess",
  "KirchhoffGraph",
  "KirchhoffMatrix",
  "KleinInvariantJ",
  "KnapsackSolve",
  "KnightTourGraph",
  "KnotData",
  "KnownUnitQ",
  "KochCurve",
  "KolmogorovSmirnovTest",
  "KroneckerDelta",
  "KroneckerModelDecomposition",
  "KroneckerProduct",
  "KroneckerSymbol",
  "KuiperTest",
  "KumaraswamyDistribution",
  "Kurtosis",
  "KuwaharaFilter",
  "KVertexConnectedComponents",
  "KVertexConnectedGraphQ",
  "LABColor",
  "Label",
  "Labeled",
  "LabeledSlider",
  "LabelingFunction",
  "LabelingSize",
  "LabelStyle",
  "LabelVisibility",
  "LaguerreL",
  "LakeData",
  "LambdaComponents",
  "LambertW",
  "LameC",
  "LameCPrime",
  "LameEigenvalueA",
  "LameEigenvalueB",
  "LameS",
  "LameSPrime",
  "LaminaData",
  "LanczosWindow",
  "LandauDistribution",
  "Language",
  "LanguageCategory",
  "LanguageData",
  "LanguageIdentify",
  "LanguageOptions",
  "LaplaceDistribution",
  "LaplaceTransform",
  "Laplacian",
  "LaplacianFilter",
  "LaplacianGaussianFilter",
  "LaplacianPDETerm",
  "Large",
  "Larger",
  "Last",
  "Latitude",
  "LatitudeLongitude",
  "LatticeData",
  "LatticeReduce",
  "Launch",
  "LaunchKernels",
  "LayeredGraphPlot",
  "LayeredGraphPlot3D",
  "LayerSizeFunction",
  "LayoutInformation",
  "LCHColor",
  "LCM",
  "LeaderSize",
  "LeafCount",
  "LeapVariant",
  "LeapYearQ",
  "LearnDistribution",
  "LearnedDistribution",
  "LearningRate",
  "LearningRateMultipliers",
  "LeastSquares",
  "LeastSquaresFilterKernel",
  "Left",
  "LeftArrow",
  "LeftArrowBar",
  "LeftArrowRightArrow",
  "LeftDownTeeVector",
  "LeftDownVector",
  "LeftDownVectorBar",
  "LeftRightArrow",
  "LeftRightVector",
  "LeftTee",
  "LeftTeeArrow",
  "LeftTeeVector",
  "LeftTriangle",
  "LeftTriangleBar",
  "LeftTriangleEqual",
  "LeftUpDownVector",
  "LeftUpTeeVector",
  "LeftUpVector",
  "LeftUpVectorBar",
  "LeftVector",
  "LeftVectorBar",
  "LegendAppearance",
  "Legended",
  "LegendFunction",
  "LegendLabel",
  "LegendLayout",
  "LegendMargins",
  "LegendMarkers",
  "LegendMarkerSize",
  "LegendreP",
  "LegendreQ",
  "LegendreType",
  "Length",
  "LengthWhile",
  "LerchPhi",
  "Less",
  "LessEqual",
  "LessEqualGreater",
  "LessEqualThan",
  "LessFullEqual",
  "LessGreater",
  "LessLess",
  "LessSlantEqual",
  "LessThan",
  "LessTilde",
  "LetterCharacter",
  "LetterCounts",
  "LetterNumber",
  "LetterQ",
  "Level",
  "LeveneTest",
  "LeviCivitaTensor",
  "LevyDistribution",
  "Lexicographic",
  "LexicographicOrder",
  "LexicographicSort",
  "LibraryDataType",
  "LibraryFunction",
  "LibraryFunctionDeclaration",
  "LibraryFunctionError",
  "LibraryFunctionInformation",
  "LibraryFunctionLoad",
  "LibraryFunctionUnload",
  "LibraryLoad",
  "LibraryUnload",
  "LicenseEntitlementObject",
  "LicenseEntitlements",
  "LicenseID",
  "LicensingSettings",
  "LiftingFilterData",
  "LiftingWaveletTransform",
  "LightBlue",
  "LightBrown",
  "LightCyan",
  "Lighter",
  "LightGray",
  "LightGreen",
  "Lighting",
  "LightingAngle",
  "LightMagenta",
  "LightOrange",
  "LightPink",
  "LightPurple",
  "LightRed",
  "LightSources",
  "LightYellow",
  "Likelihood",
  "Limit",
  "LimitsPositioning",
  "LimitsPositioningTokens",
  "LindleyDistribution",
  "Line",
  "Line3DBox",
  "Line3DBoxOptions",
  "LinearFilter",
  "LinearFractionalOptimization",
  "LinearFractionalTransform",
  "LinearGradientFilling",
  "LinearGradientImage",
  "LinearizingTransformationData",
  "LinearLayer",
  "LinearModelFit",
  "LinearOffsetFunction",
  "LinearOptimization",
  "LinearProgramming",
  "LinearRecurrence",
  "LinearSolve",
  "LinearSolveFunction",
  "LineBox",
  "LineBoxOptions",
  "LineBreak",
  "LinebreakAdjustments",
  "LineBreakChart",
  "LinebreakSemicolonWeighting",
  "LineBreakWithin",
  "LineColor",
  "LineGraph",
  "LineIndent",
  "LineIndentMaxFraction",
  "LineIntegralConvolutionPlot",
  "LineIntegralConvolutionScale",
  "LineLegend",
  "LineOpacity",
  "LineSpacing",
  "LineWrapParts",
  "LinkActivate",
  "LinkClose",
  "LinkConnect",
  "LinkConnectedQ",
  "LinkCreate",
  "LinkError",
  "LinkFlush",
  "LinkFunction",
  "LinkHost",
  "LinkInterrupt",
  "LinkLaunch",
  "LinkMode",
  "LinkObject",
  "LinkOpen",
  "LinkOptions",
  "LinkPatterns",
  "LinkProtocol",
  "LinkRankCentrality",
  "LinkRead",
  "LinkReadHeld",
  "LinkReadyQ",
  "Links",
  "LinkService",
  "LinkWrite",
  "LinkWriteHeld",
  "LiouvilleLambda",
  "List",
  "Listable",
  "ListAnimate",
  "ListContourPlot",
  "ListContourPlot3D",
  "ListConvolve",
  "ListCorrelate",
  "ListCurvePathPlot",
  "ListDeconvolve",
  "ListDensityPlot",
  "ListDensityPlot3D",
  "Listen",
  "ListFormat",
  "ListFourierSequenceTransform",
  "ListInterpolation",
  "ListLineIntegralConvolutionPlot",
  "ListLinePlot",
  "ListLinePlot3D",
  "ListLogLinearPlot",
  "ListLogLogPlot",
  "ListLogPlot",
  "ListPicker",
  "ListPickerBox",
  "ListPickerBoxBackground",
  "ListPickerBoxOptions",
  "ListPlay",
  "ListPlot",
  "ListPlot3D",
  "ListPointPlot3D",
  "ListPolarPlot",
  "ListQ",
  "ListSliceContourPlot3D",
  "ListSliceDensityPlot3D",
  "ListSliceVectorPlot3D",
  "ListStepPlot",
  "ListStreamDensityPlot",
  "ListStreamPlot",
  "ListStreamPlot3D",
  "ListSurfacePlot3D",
  "ListVectorDensityPlot",
  "ListVectorDisplacementPlot",
  "ListVectorDisplacementPlot3D",
  "ListVectorPlot",
  "ListVectorPlot3D",
  "ListZTransform",
  "Literal",
  "LiteralSearch",
  "LiteralType",
  "LoadCompiledComponent",
  "LocalAdaptiveBinarize",
  "LocalCache",
  "LocalClusteringCoefficient",
  "LocalEvaluate",
  "LocalizeDefinitions",
  "LocalizeVariables",
  "LocalObject",
  "LocalObjects",
  "LocalResponseNormalizationLayer",
  "LocalSubmit",
  "LocalSymbol",
  "LocalTime",
  "LocalTimeZone",
  "LocationEquivalenceTest",
  "LocationTest",
  "Locator",
  "LocatorAutoCreate",
  "LocatorBox",
  "LocatorBoxOptions",
  "LocatorCentering",
  "LocatorPane",
  "LocatorPaneBox",
  "LocatorPaneBoxOptions",
  "LocatorRegion",
  "Locked",
  "Log",
  "Log10",
  "Log2",
  "LogBarnesG",
  "LogGamma",
  "LogGammaDistribution",
  "LogicalExpand",
  "LogIntegral",
  "LogisticDistribution",
  "LogisticSigmoid",
  "LogitModelFit",
  "LogLikelihood",
  "LogLinearPlot",
  "LogLogisticDistribution",
  "LogLogPlot",
  "LogMultinormalDistribution",
  "LogNormalDistribution",
  "LogPlot",
  "LogRankTest",
  "LogSeriesDistribution",
  "LongEqual",
  "Longest",
  "LongestCommonSequence",
  "LongestCommonSequencePositions",
  "LongestCommonSubsequence",
  "LongestCommonSubsequencePositions",
  "LongestMatch",
  "LongestOrderedSequence",
  "LongForm",
  "Longitude",
  "LongLeftArrow",
  "LongLeftRightArrow",
  "LongRightArrow",
  "LongShortTermMemoryLayer",
  "Lookup",
  "Loopback",
  "LoopFreeGraphQ",
  "Looping",
  "LossFunction",
  "LowerCaseQ",
  "LowerLeftArrow",
  "LowerRightArrow",
  "LowerTriangularize",
  "LowerTriangularMatrix",
  "LowerTriangularMatrixQ",
  "LowpassFilter",
  "LQEstimatorGains",
  "LQGRegulator",
  "LQOutputRegulatorGains",
  "LQRegulatorGains",
  "LUBackSubstitution",
  "LucasL",
  "LuccioSamiComponents",
  "LUDecomposition",
  "LunarEclipse",
  "LUVColor",
  "LyapunovSolve",
  "LyonsGroupLy",
  "MachineID",
  "MachineName",
  "MachineNumberQ",
  "MachinePrecision",
  "MacintoshSystemPageSetup",
  "Magenta",
  "Magnification",
  "Magnify",
  "MailAddressValidation",
  "MailExecute",
  "MailFolder",
  "MailItem",
  "MailReceiverFunction",
  "MailResponseFunction",
  "MailSearch",
  "MailServerConnect",
  "MailServerConnection",
  "MailSettings",
  "MainSolve",
  "MaintainDynamicCaches",
  "Majority",
  "MakeBoxes",
  "MakeExpression",
  "MakeRules",
  "ManagedLibraryExpressionID",
  "ManagedLibraryExpressionQ",
  "MandelbrotSetBoettcher",
  "MandelbrotSetDistance",
  "MandelbrotSetIterationCount",
  "MandelbrotSetMemberQ",
  "MandelbrotSetPlot",
  "MangoldtLambda",
  "ManhattanDistance",
  "Manipulate",
  "Manipulator",
  "MannedSpaceMissionData",
  "MannWhitneyTest",
  "MantissaExponent",
  "Manual",
  "Map",
  "MapAll",
  "MapApply",
  "MapAt",
  "MapIndexed",
  "MAProcess",
  "MapThread",
  "MarchenkoPasturDistribution",
  "MarcumQ",
  "MardiaCombinedTest",
  "MardiaKurtosisTest",
  "MardiaSkewnessTest",
  "MarginalDistribution",
  "MarkovProcessProperties",
  "Masking",
  "MassConcentrationCondition",
  "MassFluxValue",
  "MassImpermeableBoundaryValue",
  "MassOutflowValue",
  "MassSymmetryValue",
  "MassTransferValue",
  "MassTransportPDEComponent",
  "MatchingDissimilarity",
  "MatchLocalNameQ",
  "MatchLocalNames",
  "MatchQ",
  "Material",
  "MaterialShading",
  "MaternPointProcess",
  "MathematicalFunctionData",
  "MathematicaNotation",
  "MathieuC",
  "MathieuCharacteristicA",
  "MathieuCharacteristicB",
  "MathieuCharacteristicExponent",
  "MathieuCPrime",
  "MathieuGroupM11",
  "MathieuGroupM12",
  "MathieuGroupM22",
  "MathieuGroupM23",
  "MathieuGroupM24",
  "MathieuS",
  "MathieuSPrime",
  "MathMLForm",
  "MathMLText",
  "Matrices",
  "MatrixExp",
  "MatrixForm",
  "MatrixFunction",
  "MatrixLog",
  "MatrixNormalDistribution",
  "MatrixPlot",
  "MatrixPower",
  "MatrixPropertyDistribution",
  "MatrixQ",
  "MatrixRank",
  "MatrixTDistribution",
  "Max",
  "MaxBend",
  "MaxCellMeasure",
  "MaxColorDistance",
  "MaxDate",
  "MaxDetect",
  "MaxDisplayedChildren",
  "MaxDuration",
  "MaxExtraBandwidths",
  "MaxExtraConditions",
  "MaxFeatureDisplacement",
  "MaxFeatures",
  "MaxFilter",
  "MaximalBy",
  "Maximize",
  "MaxItems",
  "MaxIterations",
  "MaxLimit",
  "MaxMemoryUsed",
  "MaxMixtureKernels",
  "MaxOverlapFraction",
  "MaxPlotPoints",
  "MaxPoints",
  "MaxRecursion",
  "MaxStableDistribution",
  "MaxStepFraction",
  "MaxSteps",
  "MaxStepSize",
  "MaxTrainingRounds",
  "MaxValue",
  "MaxwellDistribution",
  "MaxWordGap",
  "McLaughlinGroupMcL",
  "Mean",
  "MeanAbsoluteLossLayer",
  "MeanAround",
  "MeanClusteringCoefficient",
  "MeanDegreeConnectivity",
  "MeanDeviation",
  "MeanFilter",
  "MeanGraphDistance",
  "MeanNeighborDegree",
  "MeanPointDensity",
  "MeanShift",
  "MeanShiftFilter",
  "MeanSquaredLossLayer",
  "Median",
  "MedianDeviation",
  "MedianFilter",
  "MedicalTestData",
  "Medium",
  "MeijerG",
  "MeijerGReduce",
  "MeixnerDistribution",
  "MellinConvolve",
  "MellinTransform",
  "MemberQ",
  "MemoryAvailable",
  "MemoryConstrained",
  "MemoryConstraint",
  "MemoryInUse",
  "MengerMesh",
  "Menu",
  "MenuAppearance",
  "MenuCommandKey",
  "MenuEvaluator",
  "MenuItem",
  "MenuList",
  "MenuPacket",
  "MenuSortingValue",
  "MenuStyle",
  "MenuView",
  "Merge",
  "MergeDifferences",
  "MergingFunction",
  "MersennePrimeExponent",
  "MersennePrimeExponentQ",
  "Mesh",
  "MeshCellCentroid",
  "MeshCellCount",
  "MeshCellHighlight",
  "MeshCellIndex",
  "MeshCellLabel",
  "MeshCellMarker",
  "MeshCellMeasure",
  "MeshCellQuality",
  "MeshCells",
  "MeshCellShapeFunction",
  "MeshCellStyle",
  "MeshConnectivityGraph",
  "MeshCoordinates",
  "MeshFunctions",
  "MeshPrimitives",
  "MeshQualityGoal",
  "MeshRange",
  "MeshRefinementFunction",
  "MeshRegion",
  "MeshRegionQ",
  "MeshShading",
  "MeshStyle",
  "Message",
  "MessageDialog",
  "MessageList",
  "MessageName",
  "MessageObject",
  "MessageOptions",
  "MessagePacket",
  "Messages",
  "MessagesNotebook",
  "MetaCharacters",
  "MetaInformation",
  "MeteorShowerData",
  "Method",
  "MethodOptions",
  "MexicanHatWavelet",
  "MeyerWavelet",
  "Midpoint",
  "MIMETypeToFormatList",
  "Min",
  "MinColorDistance",
  "MinDate",
  "MinDetect",
  "MineralData",
  "MinFilter",
  "MinimalBy",
  "MinimalPolynomial",
  "MinimalStateSpaceModel",
  "Minimize",
  "MinimumTimeIncrement",
  "MinIntervalSize",
  "MinkowskiQuestionMark",
  "MinLimit",
  "MinMax",
  "MinorPlanetData",
  "Minors",
  "MinPointSeparation",
  "MinRecursion",
  "MinSize",
  "MinStableDistribution",
  "Minus",
  "MinusPlus",
  "MinValue",
  "Missing",
  "MissingBehavior",
  "MissingDataMethod",
  "MissingDataRules",
  "MissingQ",
  "MissingString",
  "MissingStyle",
  "MissingValuePattern",
  "MissingValueSynthesis",
  "MittagLefflerE",
  "MixedFractionParts",
  "MixedGraphQ",
  "MixedMagnitude",
  "MixedRadix",
  "MixedRadixQuantity",
  "MixedUnit",
  "MixtureDistribution",
  "Mod",
  "Modal",
  "Mode",
  "ModelPredictiveController",
  "Modular",
  "ModularInverse",
  "ModularLambda",
  "Module",
  "Modulus",
  "MoebiusMu",
  "Molecule",
  "MoleculeAlign",
  "MoleculeContainsQ",
  "MoleculeDraw",
  "MoleculeEquivalentQ",
  "MoleculeFreeQ",
  "MoleculeGraph",
  "MoleculeMatchQ",
  "MoleculeMaximumCommonSubstructure",
  "MoleculeModify",
  "MoleculeName",
  "MoleculePattern",
  "MoleculePlot",
  "MoleculePlot3D",
  "MoleculeProperty",
  "MoleculeQ",
  "MoleculeRecognize",
  "MoleculeSubstructureCount",
  "MoleculeValue",
  "Moment",
  "MomentConvert",
  "MomentEvaluate",
  "MomentGeneratingFunction",
  "MomentOfInertia",
  "Monday",
  "Monitor",
  "MonomialList",
  "MonomialOrder",
  "MonsterGroupM",
  "MoonPhase",
  "MoonPosition",
  "MorletWavelet",
  "MorphologicalBinarize",
  "MorphologicalBranchPoints",
  "MorphologicalComponents",
  "MorphologicalEulerNumber",
  "MorphologicalGraph",
  "MorphologicalPerimeter",
  "MorphologicalTransform",
  "MortalityData",
  "Most",
  "MountainData",
  "MouseAnnotation",
  "MouseAppearance",
  "MouseAppearanceTag",
  "MouseButtons",
  "Mouseover",
  "MousePointerNote",
  "MousePosition",
  "MovieData",
  "MovingAverage",
  "MovingMap",
  "MovingMedian",
  "MoyalDistribution",
  "MultiaxisArrangement",
  "Multicolumn",
  "MultiedgeStyle",
  "MultigraphQ",
  "MultilaunchWarning",
  "MultiLetterItalics",
  "MultiLetterStyle",
  "MultilineFunction",
  "Multinomial",
  "MultinomialDistribution",
  "MultinormalDistribution",
  "MultiplicativeOrder",
  "Multiplicity",
  "MultiplySides",
  "MultiscriptBoxOptions",
  "Multiselection",
  "MultivariateHypergeometricDistribution",
  "MultivariatePoissonDistribution",
  "MultivariateTDistribution",
  "N",
  "NakagamiDistribution",
  "NameQ",
  "Names",
  "NamespaceBox",
  "NamespaceBoxOptions",
  "Nand",
  "NArgMax",
  "NArgMin",
  "NBernoulliB",
  "NBodySimulation",
  "NBodySimulationData",
  "NCache",
  "NCaputoD",
  "NDEigensystem",
  "NDEigenvalues",
  "NDSolve",
  "NDSolveValue",
  "Nearest",
  "NearestFunction",
  "NearestMeshCells",
  "NearestNeighborG",
  "NearestNeighborGraph",
  "NearestTo",
  "NebulaData",
  "NeedlemanWunschSimilarity",
  "Needs",
  "Negative",
  "NegativeBinomialDistribution",
  "NegativeDefiniteMatrixQ",
  "NegativeIntegers",
  "NegativelyOrientedPoints",
  "NegativeMultinomialDistribution",
  "NegativeRationals",
  "NegativeReals",
  "NegativeSemidefiniteMatrixQ",
  "NeighborhoodData",
  "NeighborhoodGraph",
  "Nest",
  "NestedGreaterGreater",
  "NestedLessLess",
  "NestedScriptRules",
  "NestGraph",
  "NestList",
  "NestTree",
  "NestWhile",
  "NestWhileList",
  "NetAppend",
  "NetArray",
  "NetArrayLayer",
  "NetBidirectionalOperator",
  "NetChain",
  "NetDecoder",
  "NetDelete",
  "NetDrop",
  "NetEncoder",
  "NetEvaluationMode",
  "NetExternalObject",
  "NetExtract",
  "NetFlatten",
  "NetFoldOperator",
  "NetGANOperator",
  "NetGraph",
  "NetInformation",
  "NetInitialize",
  "NetInsert",
  "NetInsertSharedArrays",
  "NetJoin",
  "NetMapOperator",
  "NetMapThreadOperator",
  "NetMeasurements",
  "NetModel",
  "NetNestOperator",
  "NetPairEmbeddingOperator",
  "NetPort",
  "NetPortGradient",
  "NetPrepend",
  "NetRename",
  "NetReplace",
  "NetReplacePart",
  "NetSharedArray",
  "NetStateObject",
  "NetTake",
  "NetTrain",
  "NetTrainResultsObject",
  "NetUnfold",
  "NetworkPacketCapture",
  "NetworkPacketRecording",
  "NetworkPacketRecordingDuring",
  "NetworkPacketTrace",
  "NeumannValue",
  "NevilleThetaC",
  "NevilleThetaD",
  "NevilleThetaN",
  "NevilleThetaS",
  "NewPrimitiveStyle",
  "NExpectation",
  "Next",
  "NextCell",
  "NextDate",
  "NextPrime",
  "NextScheduledTaskTime",
  "NeymanScottPointProcess",
  "NFractionalD",
  "NHoldAll",
  "NHoldFirst",
  "NHoldRest",
  "NicholsGridLines",
  "NicholsPlot",
  "NightHemisphere",
  "NIntegrate",
  "NMaximize",
  "NMaxValue",
  "NMinimize",
  "NMinValue",
  "NominalScale",
  "NominalVariables",
  "NonAssociative",
  "NoncentralBetaDistribution",
  "NoncentralChiSquareDistribution",
  "NoncentralFRatioDistribution",
  "NoncentralStudentTDistribution",
  "NonCommutativeMultiply",
  "NonConstants",
  "NondimensionalizationTransform",
  "None",
  "NoneTrue",
  "NonlinearModelFit",
  "NonlinearStateSpaceModel",
  "NonlocalMeansFilter",
  "NonNegative",
  "NonNegativeIntegers",
  "NonNegativeRationals",
  "NonNegativeReals",
  "NonPositive",
  "NonPositiveIntegers",
  "NonPositiveRationals",
  "NonPositiveReals",
  "Nor",
  "NorlundB",
  "Norm",
  "Normal",
  "NormalDistribution",
  "NormalGrouping",
  "NormalizationLayer",
  "Normalize",
  "Normalized",
  "NormalizedSquaredEuclideanDistance",
  "NormalMatrixQ",
  "NormalsFunction",
  "NormFunction",
  "Not",
  "NotCongruent",
  "NotCupCap",
  "NotDoubleVerticalBar",
  "Notebook",
  "NotebookApply",
  "NotebookAutoSave",
  "NotebookBrowseDirectory",
  "NotebookClose",
  "NotebookConvertSettings",
  "NotebookCreate",
  "NotebookDefault",
  "NotebookDelete",
  "NotebookDirectory",
  "NotebookDynamicExpression",
  "NotebookEvaluate",
  "NotebookEventActions",
  "NotebookFileName",
  "NotebookFind",
  "NotebookGet",
  "NotebookImport",
  "NotebookInformation",
  "NotebookInterfaceObject",
  "NotebookLocate",
  "NotebookObject",
  "NotebookOpen",
  "NotebookPath",
  "NotebookPrint",
  "NotebookPut",
  "NotebookRead",
  "Notebooks",
  "NotebookSave",
  "NotebookSelection",
  "NotebooksMenu",
  "NotebookTemplate",
  "NotebookWrite",
  "NotElement",
  "NotEqualTilde",
  "NotExists",
  "NotGreater",
  "NotGreaterEqual",
  "NotGreaterFullEqual",
  "NotGreaterGreater",
  "NotGreaterLess",
  "NotGreaterSlantEqual",
  "NotGreaterTilde",
  "Nothing",
  "NotHumpDownHump",
  "NotHumpEqual",
  "NotificationFunction",
  "NotLeftTriangle",
  "NotLeftTriangleBar",
  "NotLeftTriangleEqual",
  "NotLess",
  "NotLessEqual",
  "NotLessFullEqual",
  "NotLessGreater",
  "NotLessLess",
  "NotLessSlantEqual",
  "NotLessTilde",
  "NotNestedGreaterGreater",
  "NotNestedLessLess",
  "NotPrecedes",
  "NotPrecedesEqual",
  "NotPrecedesSlantEqual",
  "NotPrecedesTilde",
  "NotReverseElement",
  "NotRightTriangle",
  "NotRightTriangleBar",
  "NotRightTriangleEqual",
  "NotSquareSubset",
  "NotSquareSubsetEqual",
  "NotSquareSuperset",
  "NotSquareSupersetEqual",
  "NotSubset",
  "NotSubsetEqual",
  "NotSucceeds",
  "NotSucceedsEqual",
  "NotSucceedsSlantEqual",
  "NotSucceedsTilde",
  "NotSuperset",
  "NotSupersetEqual",
  "NotTilde",
  "NotTildeEqual",
  "NotTildeFullEqual",
  "NotTildeTilde",
  "NotVerticalBar",
  "Now",
  "NoWhitespace",
  "NProbability",
  "NProduct",
  "NProductFactors",
  "NRoots",
  "NSolve",
  "NSolveValues",
  "NSum",
  "NSumTerms",
  "NuclearExplosionData",
  "NuclearReactorData",
  "Null",
  "NullRecords",
  "NullSpace",
  "NullWords",
  "Number",
  "NumberCompose",
  "NumberDecompose",
  "NumberDigit",
  "NumberExpand",
  "NumberFieldClassNumber",
  "NumberFieldDiscriminant",
  "NumberFieldFundamentalUnits",
  "NumberFieldIntegralBasis",
  "NumberFieldNormRepresentatives",
  "NumberFieldRegulator",
  "NumberFieldRootsOfUnity",
  "NumberFieldSignature",
  "NumberForm",
  "NumberFormat",
  "NumberLinePlot",
  "NumberMarks",
  "NumberMultiplier",
  "NumberPadding",
  "NumberPoint",
  "NumberQ",
  "NumberSeparator",
  "NumberSigns",
  "NumberString",
  "Numerator",
  "NumeratorDenominator",
  "NumericalOrder",
  "NumericalSort",
  "NumericArray",
  "NumericArrayQ",
  "NumericArrayType",
  "NumericFunction",
  "NumericQ",
  "NuttallWindow",
  "NValues",
  "NyquistGridLines",
  "NyquistPlot",
  "O",
  "ObjectExistsQ",
  "ObservabilityGramian",
  "ObservabilityMatrix",
  "ObservableDecomposition",
  "ObservableModelQ",
  "OceanData",
  "Octahedron",
  "OddQ",
  "Off",
  "Offset",
  "OLEData",
  "On",
  "ONanGroupON",
  "Once",
  "OneIdentity",
  "Opacity",
  "OpacityFunction",
  "OpacityFunctionScaling",
  "Open",
  "OpenAppend",
  "Opener",
  "OpenerBox",
  "OpenerBoxOptions",
  "OpenerView",
  "OpenFunctionInspectorPacket",
  "Opening",
  "OpenRead",
  "OpenSpecialOptions",
  "OpenTemporary",
  "OpenWrite",
  "Operate",
  "OperatingSystem",
  "OperatorApplied",
  "OptimumFlowData",
  "Optional",
  "OptionalElement",
  "OptionInspectorSettings",
  "OptionQ",
  "Options",
  "OptionsPacket",
  "OptionsPattern",
  "OptionValue",
  "OptionValueBox",
  "OptionValueBoxOptions",
  "Or",
  "Orange",
  "Order",
  "OrderDistribution",
  "OrderedQ",
  "Ordering",
  "OrderingBy",
  "OrderingLayer",
  "Orderless",
  "OrderlessPatternSequence",
  "OrdinalScale",
  "OrnsteinUhlenbeckProcess",
  "Orthogonalize",
  "OrthogonalMatrixQ",
  "Out",
  "Outer",
  "OuterPolygon",
  "OuterPolyhedron",
  "OutputAutoOverwrite",
  "OutputControllabilityMatrix",
  "OutputControllableModelQ",
  "OutputForm",
  "OutputFormData",
  "OutputGrouping",
  "OutputMathEditExpression",
  "OutputNamePacket",
  "OutputPorts",
  "OutputResponse",
  "OutputSizeLimit",
  "OutputStream",
  "Over",
  "OverBar",
  "OverDot",
  "Overflow",
  "OverHat",
  "Overlaps",
  "Overlay",
  "OverlayBox",
  "OverlayBoxOptions",
  "OverlayVideo",
  "Overscript",
  "OverscriptBox",
  "OverscriptBoxOptions",
  "OverTilde",
  "OverVector",
  "OverwriteTarget",
  "OwenT",
  "OwnValues",
  "Package",
  "PackingMethod",
  "PackPaclet",
  "PacletDataRebuild",
  "PacletDirectoryAdd",
  "PacletDirectoryLoad",
  "PacletDirectoryRemove",
  "PacletDirectoryUnload",
  "PacletDisable",
  "PacletEnable",
  "PacletFind",
  "PacletFindRemote",
  "PacletInformation",
  "PacletInstall",
  "PacletInstallSubmit",
  "PacletNewerQ",
  "PacletObject",
  "PacletObjectQ",
  "PacletSite",
  "PacletSiteObject",
  "PacletSiteRegister",
  "PacletSites",
  "PacletSiteUnregister",
  "PacletSiteUpdate",
  "PacletSymbol",
  "PacletUninstall",
  "PacletUpdate",
  "PaddedForm",
  "Padding",
  "PaddingLayer",
  "PaddingSize",
  "PadeApproximant",
  "PadLeft",
  "PadRight",
  "PageBreakAbove",
  "PageBreakBelow",
  "PageBreakWithin",
  "PageFooterLines",
  "PageFooters",
  "PageHeaderLines",
  "PageHeaders",
  "PageHeight",
  "PageRankCentrality",
  "PageTheme",
  "PageWidth",
  "Pagination",
  "PairCorrelationG",
  "PairedBarChart",
  "PairedHistogram",
  "PairedSmoothHistogram",
  "PairedTTest",
  "PairedZTest",
  "PaletteNotebook",
  "PalettePath",
  "PalettesMenuSettings",
  "PalindromeQ",
  "Pane",
  "PaneBox",
  "PaneBoxOptions",
  "Panel",
  "PanelBox",
  "PanelBoxOptions",
  "Paneled",
  "PaneSelector",
  "PaneSelectorBox",
  "PaneSelectorBoxOptions",
  "PaperWidth",
  "ParabolicCylinderD",
  "ParagraphIndent",
  "ParagraphSpacing",
  "ParallelArray",
  "ParallelAxisPlot",
  "ParallelCombine",
  "ParallelDo",
  "Parallelepiped",
  "ParallelEvaluate",
  "Parallelization",
  "Parallelize",
  "ParallelKernels",
  "ParallelMap",
  "ParallelNeeds",
  "Parallelogram",
  "ParallelProduct",
  "ParallelSubmit",
  "ParallelSum",
  "ParallelTable",
  "ParallelTry",
  "Parameter",
  "ParameterEstimator",
  "ParameterMixtureDistribution",
  "ParameterVariables",
  "ParametricConvexOptimization",
  "ParametricFunction",
  "ParametricNDSolve",
  "ParametricNDSolveValue",
  "ParametricPlot",
  "ParametricPlot3D",
  "ParametricRampLayer",
  "ParametricRegion",
  "ParentBox",
  "ParentCell",
  "ParentConnect",
  "ParentDirectory",
  "ParentEdgeLabel",
  "ParentEdgeLabelFunction",
  "ParentEdgeLabelStyle",
  "ParentEdgeShapeFunction",
  "ParentEdgeStyle",
  "ParentEdgeStyleFunction",
  "ParentForm",
  "Parenthesize",
  "ParentList",
  "ParentNotebook",
  "ParetoDistribution",
  "ParetoPickandsDistribution",
  "ParkData",
  "Part",
  "PartBehavior",
  "PartialCorrelationFunction",
  "PartialD",
  "ParticleAcceleratorData",
  "ParticleData",
  "Partition",
  "PartitionGranularity",
  "PartitionsP",
  "PartitionsQ",
  "PartLayer",
  "PartOfSpeech",
  "PartProtection",
  "ParzenWindow",
  "PascalDistribution",
  "PassEventsDown",
  "PassEventsUp",
  "Paste",
  "PasteAutoQuoteCharacters",
  "PasteBoxFormInlineCells",
  "PasteButton",
  "Path",
  "PathGraph",
  "PathGraphQ",
  "Pattern",
  "PatternFilling",
  "PatternReaction",
  "PatternSequence",
  "PatternTest",
  "PauliMatrix",
  "PaulWavelet",
  "Pause",
  "PausedTime",
  "PDF",
  "PeakDetect",
  "PeanoCurve",
  "PearsonChiSquareTest",
  "PearsonCorrelationTest",
  "PearsonDistribution",
  "PenttinenPointProcess",
  "PercentForm",
  "PerfectNumber",
  "PerfectNumberQ",
  "PerformanceGoal",
  "Perimeter",
  "PeriodicBoundaryCondition",
  "PeriodicInterpolation",
  "Periodogram",
  "PeriodogramArray",
  "Permanent",
  "Permissions",
  "PermissionsGroup",
  "PermissionsGroupMemberQ",
  "PermissionsGroups",
  "PermissionsKey",
  "PermissionsKeys",
  "PermutationCycles",
  "PermutationCyclesQ",
  "PermutationGroup",
  "PermutationLength",
  "PermutationList",
  "PermutationListQ",
  "PermutationMatrix",
  "PermutationMax",
  "PermutationMin",
  "PermutationOrder",
  "PermutationPower",
  "PermutationProduct",
  "PermutationReplace",
  "Permutations",
  "PermutationSupport",
  "Permute",
  "PeronaMalikFilter",
  "Perpendicular",
  "PerpendicularBisector",
  "PersistenceLocation",
  "PersistenceTime",
  "PersistentObject",
  "PersistentObjects",
  "PersistentSymbol",
  "PersistentValue",
  "PersonData",
  "PERTDistribution",
  "PetersenGraph",
  "PhaseMargins",
  "PhaseRange",
  "PhongShading",
  "PhysicalSystemData",
  "Pi",
  "Pick",
  "PickedElements",
  "PickMode",
  "PIDData",
  "PIDDerivativeFilter",
  "PIDFeedforward",
  "PIDTune",
  "Piecewise",
  "PiecewiseExpand",
  "PieChart",
  "PieChart3D",
  "PillaiTrace",
  "PillaiTraceTest",
  "PingTime",
  "Pink",
  "PitchRecognize",
  "Pivoting",
  "PixelConstrained",
  "PixelValue",
  "PixelValuePositions",
  "Placed",
  "Placeholder",
  "PlaceholderLayer",
  "PlaceholderReplace",
  "Plain",
  "PlanarAngle",
  "PlanarFaceList",
  "PlanarGraph",
  "PlanarGraphQ",
  "PlanckRadiationLaw",
  "PlaneCurveData",
  "PlanetaryMoonData",
  "PlanetData",
  "PlantData",
  "Play",
  "PlaybackSettings",
  "PlayRange",
  "Plot",
  "Plot3D",
  "Plot3Matrix",
  "PlotDivision",
  "PlotJoined",
  "PlotLabel",
  "PlotLabels",
  "PlotLayout",
  "PlotLegends",
  "PlotMarkers",
  "PlotPoints",
  "PlotRange",
  "PlotRangeClipping",
  "PlotRangeClipPlanesStyle",
  "PlotRangePadding",
  "PlotRegion",
  "PlotStyle",
  "PlotTheme",
  "Pluralize",
  "Plus",
  "PlusMinus",
  "Pochhammer",
  "PodStates",
  "PodWidth",
  "Point",
  "Point3DBox",
  "Point3DBoxOptions",
  "PointBox",
  "PointBoxOptions",
  "PointCountDistribution",
  "PointDensity",
  "PointDensityFunction",
  "PointFigureChart",
  "PointLegend",
  "PointLight",
  "PointProcessEstimator",
  "PointProcessFitTest",
  "PointProcessParameterAssumptions",
  "PointProcessParameterQ",
  "PointSize",
  "PointStatisticFunction",
  "PointValuePlot",
  "PoissonConsulDistribution",
  "PoissonDistribution",
  "PoissonPDEComponent",
  "PoissonPointProcess",
  "PoissonProcess",
  "PoissonWindow",
  "PolarAxes",
  "PolarAxesOrigin",
  "PolarGridLines",
  "PolarPlot",
  "PolarTicks",
  "PoleZeroMarkers",
  "PolyaAeppliDistribution",
  "PolyGamma",
  "Polygon",
  "Polygon3DBox",
  "Polygon3DBoxOptions",
  "PolygonalNumber",
  "PolygonAngle",
  "PolygonBox",
  "PolygonBoxOptions",
  "PolygonCoordinates",
  "PolygonDecomposition",
  "PolygonHoleScale",
  "PolygonIntersections",
  "PolygonScale",
  "Polyhedron",
  "PolyhedronAngle",
  "PolyhedronBox",
  "PolyhedronBoxOptions",
  "PolyhedronCoordinates",
  "PolyhedronData",
  "PolyhedronDecomposition",
  "PolyhedronGenus",
  "PolyLog",
  "PolynomialExpressionQ",
  "PolynomialExtendedGCD",
  "PolynomialForm",
  "PolynomialGCD",
  "PolynomialLCM",
  "PolynomialMod",
  "PolynomialQ",
  "PolynomialQuotient",
  "PolynomialQuotientRemainder",
  "PolynomialReduce",
  "PolynomialRemainder",
  "Polynomials",
  "PolynomialSumOfSquaresList",
  "PoolingLayer",
  "PopupMenu",
  "PopupMenuBox",
  "PopupMenuBoxOptions",
  "PopupView",
  "PopupWindow",
  "Position",
  "PositionIndex",
  "PositionLargest",
  "PositionSmallest",
  "Positive",
  "PositiveDefiniteMatrixQ",
  "PositiveIntegers",
  "PositivelyOrientedPoints",
  "PositiveRationals",
  "PositiveReals",
  "PositiveSemidefiniteMatrixQ",
  "PossibleZeroQ",
  "Postfix",
  "PostScript",
  "Power",
  "PowerDistribution",
  "PowerExpand",
  "PowerMod",
  "PowerModList",
  "PowerRange",
  "PowerSpectralDensity",
  "PowersRepresentations",
  "PowerSymmetricPolynomial",
  "Precedence",
  "PrecedenceForm",
  "Precedes",
  "PrecedesEqual",
  "PrecedesSlantEqual",
  "PrecedesTilde",
  "Precision",
  "PrecisionGoal",
  "PreDecrement",
  "Predict",
  "PredictionRoot",
  "PredictorFunction",
  "PredictorInformation",
  "PredictorMeasurements",
  "PredictorMeasurementsObject",
  "PreemptProtect",
  "PreferencesPath",
  "PreferencesSettings",
  "Prefix",
  "PreIncrement",
  "Prepend",
  "PrependLayer",
  "PrependTo",
  "PreprocessingRules",
  "PreserveColor",
  "PreserveImageOptions",
  "Previous",
  "PreviousCell",
  "PreviousDate",
  "PriceGraphDistribution",
  "PrimaryPlaceholder",
  "Prime",
  "PrimeNu",
  "PrimeOmega",
  "PrimePi",
  "PrimePowerQ",
  "PrimeQ",
  "Primes",
  "PrimeZetaP",
  "PrimitivePolynomialQ",
  "PrimitiveRoot",
  "PrimitiveRootList",
  "PrincipalComponents",
  "PrincipalValue",
  "Print",
  "PrintableASCIIQ",
  "PrintAction",
  "PrintForm",
  "PrintingCopies",
  "PrintingOptions",
  "PrintingPageRange",
  "PrintingStartingPageNumber",
  "PrintingStyleEnvironment",
  "Printout3D",
  "Printout3DPreviewer",
  "PrintPrecision",
  "PrintTemporary",
  "Prism",
  "PrismBox",
  "PrismBoxOptions",
  "PrivateCellOptions",
  "PrivateEvaluationOptions",
  "PrivateFontOptions",
  "PrivateFrontEndOptions",
  "PrivateKey",
  "PrivateNotebookOptions",
  "PrivatePaths",
  "Probability",
  "ProbabilityDistribution",
  "ProbabilityPlot",
  "ProbabilityPr",
  "ProbabilityScalePlot",
  "ProbitModelFit",
  "ProcessConnection",
  "ProcessDirectory",
  "ProcessEnvironment",
  "Processes",
  "ProcessEstimator",
  "ProcessInformation",
  "ProcessObject",
  "ProcessParameterAssumptions",
  "ProcessParameterQ",
  "ProcessStateDomain",
  "ProcessStatus",
  "ProcessTimeDomain",
  "Product",
  "ProductDistribution",
  "ProductLog",
  "ProgressIndicator",
  "ProgressIndicatorBox",
  "ProgressIndicatorBoxOptions",
  "ProgressReporting",
  "Projection",
  "Prolog",
  "PromptForm",
  "ProofObject",
  "PropagateAborts",
  "Properties",
  "Property",
  "PropertyList",
  "PropertyValue",
  "Proportion",
  "Proportional",
  "Protect",
  "Protected",
  "ProteinData",
  "Pruning",
  "PseudoInverse",
  "PsychrometricPropertyData",
  "PublicKey",
  "PublisherID",
  "PulsarData",
  "PunctuationCharacter",
  "Purple",
  "Put",
  "PutAppend",
  "Pyramid",
  "PyramidBox",
  "PyramidBoxOptions",
  "QBinomial",
  "QFactorial",
  "QGamma",
  "QHypergeometricPFQ",
  "QnDispersion",
  "QPochhammer",
  "QPolyGamma",
  "QRDecomposition",
  "QuadraticIrrationalQ",
  "QuadraticOptimization",
  "Quantile",
  "QuantilePlot",
  "Quantity",
  "QuantityArray",
  "QuantityDistribution",
  "QuantityForm",
  "QuantityMagnitude",
  "QuantityQ",
  "QuantityUnit",
  "QuantityVariable",
  "QuantityVariableCanonicalUnit",
  "QuantityVariableDimensions",
  "QuantityVariableIdentifier",
  "QuantityVariablePhysicalQuantity",
  "Quartics",
  "QuartileDeviation",
  "Quartiles",
  "QuartileSkewness",
  "Query",
  "QuestionGenerator",
  "QuestionInterface",
  "QuestionObject",
  "QuestionSelector",
  "QueueingNetworkProcess",
  "QueueingProcess",
  "QueueProperties",
  "Quiet",
  "QuietEcho",
  "Quit",
  "Quotient",
  "QuotientRemainder",
  "RadialAxisPlot",
  "RadialGradientFilling",
  "RadialGradientImage",
  "RadialityCentrality",
  "RadicalBox",
  "RadicalBoxOptions",
  "RadioButton",
  "RadioButtonBar",
  "RadioButtonBox",
  "RadioButtonBoxOptions",
  "Radon",
  "RadonTransform",
  "RamanujanTau",
  "RamanujanTauL",
  "RamanujanTauTheta",
  "RamanujanTauZ",
  "Ramp",
  "Random",
  "RandomArrayLayer",
  "RandomChoice",
  "RandomColor",
  "RandomComplex",
  "RandomDate",
  "RandomEntity",
  "RandomFunction",
  "RandomGeneratorState",
  "RandomGeoPosition",
  "RandomGraph",
  "RandomImage",
  "RandomInstance",
  "RandomInteger",
  "RandomPermutation",
  "RandomPoint",
  "RandomPointConfiguration",
  "RandomPolygon",
  "RandomPolyhedron",
  "RandomPrime",
  "RandomReal",
  "RandomSample",
  "RandomSeed",
  "RandomSeeding",
  "RandomTime",
  "RandomTree",
  "RandomVariate",
  "RandomWalkProcess",
  "RandomWord",
  "Range",
  "RangeFilter",
  "RangeSpecification",
  "RankedMax",
  "RankedMin",
  "RarerProbability",
  "Raster",
  "Raster3D",
  "Raster3DBox",
  "Raster3DBoxOptions",
  "RasterArray",
  "RasterBox",
  "RasterBoxOptions",
  "Rasterize",
  "RasterSize",
  "Rational",
  "RationalExpressionQ",
  "RationalFunctions",
  "Rationalize",
  "Rationals",
  "Ratios",
  "RawArray",
  "RawBoxes",
  "RawData",
  "RawMedium",
  "RayleighDistribution",
  "Re",
  "ReactionBalance",
  "ReactionBalancedQ",
  "ReactionPDETerm",
  "Read",
  "ReadByteArray",
  "ReadLine",
  "ReadList",
  "ReadProtected",
  "ReadString",
  "Real",
  "RealAbs",
  "RealBlockDiagonalForm",
  "RealDigits",
  "RealExponent",
  "Reals",
  "RealSign",
  "Reap",
  "RebuildPacletData",
  "RecalibrationFunction",
  "RecognitionPrior",
  "RecognitionThreshold",
  "ReconstructionMesh",
  "Record",
  "RecordLists",
  "RecordSeparators",
  "Rectangle",
  "RectangleBox",
  "RectangleBoxOptions",
  "RectangleChart",
  "RectangleChart3D",
  "RectangularRepeatingElement",
  "RecurrenceFilter",
  "RecurrenceTable",
  "RecurringDigitsForm",
  "Red",
  "Reduce",
  "RefBox",
  "ReferenceLineStyle",
  "ReferenceMarkers",
  "ReferenceMarkerStyle",
  "Refine",
  "ReflectionMatrix",
  "ReflectionTransform",
  "Refresh",
  "RefreshRate",
  "Region",
  "RegionBinarize",
  "RegionBoundary",
  "RegionBoundaryStyle",
  "RegionBounds",
  "RegionCentroid",
  "RegionCongruent",
  "RegionConvert",
  "RegionDifference",
  "RegionDilation",
  "RegionDimension",
  "RegionDisjoint",
  "RegionDistance",
  "RegionDistanceFunction",
  "RegionEmbeddingDimension",
  "RegionEqual",
  "RegionErosion",
  "RegionFillingStyle",
  "RegionFit",
  "RegionFunction",
  "RegionImage",
  "RegionIntersection",
  "RegionMeasure",
  "RegionMember",
  "RegionMemberFunction",
  "RegionMoment",
  "RegionNearest",
  "RegionNearestFunction",
  "RegionPlot",
  "RegionPlot3D",
  "RegionProduct",
  "RegionQ",
  "RegionResize",
  "RegionSimilar",
  "RegionSize",
  "RegionSymmetricDifference",
  "RegionUnion",
  "RegionWithin",
  "RegisterExternalEvaluator",
  "RegularExpression",
  "Regularization",
  "RegularlySampledQ",
  "RegularPolygon",
  "ReIm",
  "ReImLabels",
  "ReImPlot",
  "ReImStyle",
  "Reinstall",
  "RelationalDatabase",
  "RelationGraph",
  "Release",
  "ReleaseHold",
  "ReliabilityDistribution",
  "ReliefImage",
  "ReliefPlot",
  "RemoteAuthorizationCaching",
  "RemoteBatchJobAbort",
  "RemoteBatchJobObject",
  "RemoteBatchJobs",
  "RemoteBatchMapSubmit",
  "RemoteBatchSubmissionEnvironment",
  "RemoteBatchSubmit",
  "RemoteConnect",
  "RemoteConnectionObject",
  "RemoteEvaluate",
  "RemoteFile",
  "RemoteInputFiles",
  "RemoteKernelObject",
  "RemoteProviderSettings",
  "RemoteRun",
  "RemoteRunProcess",
  "RemovalConditions",
  "Remove",
  "RemoveAlphaChannel",
  "RemoveAsynchronousTask",
  "RemoveAudioStream",
  "RemoveBackground",
  "RemoveChannelListener",
  "RemoveChannelSubscribers",
  "Removed",
  "RemoveDiacritics",
  "RemoveInputStreamMethod",
  "RemoveOutputStreamMethod",
  "RemoveProperty",
  "RemoveScheduledTask",
  "RemoveUsers",
  "RemoveVideoStream",
  "RenameDirectory",
  "RenameFile",
  "RenderAll",
  "RenderingOptions",
  "RenewalProcess",
  "RenkoChart",
  "RepairMesh",
  "Repeated",
  "RepeatedNull",
  "RepeatedString",
  "RepeatedTiming",
  "RepeatingElement",
  "Replace",
  "ReplaceAll",
  "ReplaceAt",
  "ReplaceHeldPart",
  "ReplaceImageValue",
  "ReplaceList",
  "ReplacePart",
  "ReplacePixelValue",
  "ReplaceRepeated",
  "ReplicateLayer",
  "RequiredPhysicalQuantities",
  "Resampling",
  "ResamplingAlgorithmData",
  "ResamplingMethod",
  "Rescale",
  "RescalingTransform",
  "ResetDirectory",
  "ResetScheduledTask",
  "ReshapeLayer",
  "Residue",
  "ResidueSum",
  "ResizeLayer",
  "Resolve",
  "ResolveContextAliases",
  "ResourceAcquire",
  "ResourceData",
  "ResourceFunction",
  "ResourceObject",
  "ResourceRegister",
  "ResourceRemove",
  "ResourceSearch",
  "ResourceSubmissionObject",
  "ResourceSubmit",
  "ResourceSystemBase",
  "ResourceSystemPath",
  "ResourceUpdate",
  "ResourceVersion",
  "ResponseForm",
  "Rest",
  "RestartInterval",
  "Restricted",
  "Resultant",
  "ResumePacket",
  "Return",
  "ReturnCreatesNewCell",
  "ReturnEntersInput",
  "ReturnExpressionPacket",
  "ReturnInputFormPacket",
  "ReturnPacket",
  "ReturnReceiptFunction",
  "ReturnTextPacket",
  "Reverse",
  "ReverseApplied",
  "ReverseBiorthogonalSplineWavelet",
  "ReverseElement",
  "ReverseEquilibrium",
  "ReverseGraph",
  "ReverseSort",
  "ReverseSortBy",
  "ReverseUpEquilibrium",
  "RevolutionAxis",
  "RevolutionPlot3D",
  "RGBColor",
  "RiccatiSolve",
  "RiceDistribution",
  "RidgeFilter",
  "RiemannR",
  "RiemannSiegelTheta",
  "RiemannSiegelZ",
  "RiemannXi",
  "Riffle",
  "Right",
  "RightArrow",
  "RightArrowBar",
  "RightArrowLeftArrow",
  "RightComposition",
  "RightCosetRepresentative",
  "RightDownTeeVector",
  "RightDownVector",
  "RightDownVectorBar",
  "RightTee",
  "RightTeeArrow",
  "RightTeeVector",
  "RightTriangle",
  "RightTriangleBar",
  "RightTriangleEqual",
  "RightUpDownVector",
  "RightUpTeeVector",
  "RightUpVector",
  "RightUpVectorBar",
  "RightVector",
  "RightVectorBar",
  "RipleyK",
  "RipleyRassonRegion",
  "RiskAchievementImportance",
  "RiskReductionImportance",
  "RobustConvexOptimization",
  "RogersTanimotoDissimilarity",
  "RollPitchYawAngles",
  "RollPitchYawMatrix",
  "RomanNumeral",
  "Root",
  "RootApproximant",
  "RootIntervals",
  "RootLocusPlot",
  "RootMeanSquare",
  "RootOfUnityQ",
  "RootReduce",
  "Roots",
  "RootSum",
  "RootTree",
  "Rotate",
  "RotateLabel",
  "RotateLeft",
  "RotateRight",
  "RotationAction",
  "RotationBox",
  "RotationBoxOptions",
  "RotationMatrix",
  "RotationTransform",
  "Round",
  "RoundImplies",
  "RoundingRadius",
  "Row",
  "RowAlignments",
  "RowBackgrounds",
  "RowBox",
  "RowHeights",
  "RowLines",
  "RowMinHeight",
  "RowReduce",
  "RowsEqual",
  "RowSpacings",
  "RSolve",
  "RSolveValue",
  "RudinShapiro",
  "RudvalisGroupRu",
  "Rule",
  "RuleCondition",
  "RuleDelayed",
  "RuleForm",
  "RulePlot",
  "RulerUnits",
  "RulesTree",
  "Run",
  "RunProcess",
  "RunScheduledTask",
  "RunThrough",
  "RuntimeAttributes",
  "RuntimeOptions",
  "RussellRaoDissimilarity",
  "SameAs",
  "SameQ",
  "SameTest",
  "SameTestProperties",
  "SampledEntityClass",
  "SampleDepth",
  "SampledSoundFunction",
  "SampledSoundList",
  "SampleRate",
  "SamplingPeriod",
  "SARIMAProcess",
  "SARMAProcess",
  "SASTriangle",
  "SatelliteData",
  "SatisfiabilityCount",
  "SatisfiabilityInstances",
  "SatisfiableQ",
  "Saturday",
  "Save",
  "Saveable",
  "SaveAutoDelete",
  "SaveConnection",
  "SaveDefinitions",
  "SavitzkyGolayMatrix",
  "SawtoothWave",
  "Scale",
  "Scaled",
  "ScaleDivisions",
  "ScaledMousePosition",
  "ScaleOrigin",
  "ScalePadding",
  "ScaleRanges",
  "ScaleRangeStyle",
  "ScalingFunctions",
  "ScalingMatrix",
  "ScalingTransform",
  "Scan",
  "ScheduledTask",
  "ScheduledTaskActiveQ",
  "ScheduledTaskInformation",
  "ScheduledTaskInformationData",
  "ScheduledTaskObject",
  "ScheduledTasks",
  "SchurDecomposition",
  "ScientificForm",
  "ScientificNotationThreshold",
  "ScorerGi",
  "ScorerGiPrime",
  "ScorerHi",
  "ScorerHiPrime",
  "ScreenRectangle",
  "ScreenStyleEnvironment",
  "ScriptBaselineShifts",
  "ScriptForm",
  "ScriptLevel",
  "ScriptMinSize",
  "ScriptRules",
  "ScriptSizeMultipliers",
  "Scrollbars",
  "ScrollingOptions",
  "ScrollPosition",
  "SearchAdjustment",
  "SearchIndexObject",
  "SearchIndices",
  "SearchQueryString",
  "SearchResultObject",
  "Sec",
  "Sech",
  "SechDistribution",
  "SecondOrderConeOptimization",
  "SectionGrouping",
  "SectorChart",
  "SectorChart3D",
  "SectorOrigin",
  "SectorSpacing",
  "SecuredAuthenticationKey",
  "SecuredAuthenticationKeys",
  "SecurityCertificate",
  "SeedRandom",
  "Select",
  "Selectable",
  "SelectComponents",
  "SelectedCells",
  "SelectedNotebook",
  "SelectFirst",
  "Selection",
  "SelectionAnimate",
  "SelectionCell",
  "SelectionCellCreateCell",
  "SelectionCellDefaultStyle",
  "SelectionCellParentStyle",
  "SelectionCreateCell",
  "SelectionDebuggerTag",
  "SelectionEvaluate",
  "SelectionEvaluateCreateCell",
  "SelectionMove",
  "SelectionPlaceholder",
  "SelectWithContents",
  "SelfLoops",
  "SelfLoopStyle",
  "SemanticImport",
  "SemanticImportString",
  "SemanticInterpretation",
  "SemialgebraicComponentInstances",
  "SemidefiniteOptimization",
  "SendMail",
  "SendMessage",
  "Sequence",
  "SequenceAlignment",
  "SequenceAttentionLayer",
  "SequenceCases",
  "SequenceCount",
  "SequenceFold",
  "SequenceFoldList",
  "SequenceForm",
  "SequenceHold",
  "SequenceIndicesLayer",
  "SequenceLastLayer",
  "SequenceMostLayer",
  "SequencePosition",
  "SequencePredict",
  "SequencePredictorFunction",
  "SequenceReplace",
  "SequenceRestLayer",
  "SequenceReverseLayer",
  "SequenceSplit",
  "Series",
  "SeriesCoefficient",
  "SeriesData",
  "SeriesTermGoal",
  "ServiceConnect",
  "ServiceDisconnect",
  "ServiceExecute",
  "ServiceObject",
  "ServiceRequest",
  "ServiceResponse",
  "ServiceSubmit",
  "SessionSubmit",
  "SessionTime",
  "Set",
  "SetAccuracy",
  "SetAlphaChannel",
  "SetAttributes",
  "Setbacks",
  "SetCloudDirectory",
  "SetCookies",
  "SetDelayed",
  "SetDirectory",
  "SetEnvironment",
  "SetFileDate",
  "SetFileFormatProperties",
  "SetOptions",
  "SetOptionsPacket",
  "SetPermissions",
  "SetPrecision",
  "SetProperty",
  "SetSecuredAuthenticationKey",
  "SetSelectedNotebook",
  "SetSharedFunction",
  "SetSharedVariable",
  "SetStreamPosition",
  "SetSystemModel",
  "SetSystemOptions",
  "Setter",
  "SetterBar",
  "SetterBox",
  "SetterBoxOptions",
  "Setting",
  "SetUsers",
  "Shading",
  "Shallow",
  "ShannonWavelet",
  "ShapiroWilkTest",
  "Share",
  "SharingList",
  "Sharpen",
  "ShearingMatrix",
  "ShearingTransform",
  "ShellRegion",
  "ShenCastanMatrix",
  "ShiftedGompertzDistribution",
  "ShiftRegisterSequence",
  "Short",
  "ShortDownArrow",
  "Shortest",
  "ShortestMatch",
  "ShortestPathFunction",
  "ShortLeftArrow",
  "ShortRightArrow",
  "ShortTimeFourier",
  "ShortTimeFourierData",
  "ShortUpArrow",
  "Show",
  "ShowAutoConvert",
  "ShowAutoSpellCheck",
  "ShowAutoStyles",
  "ShowCellBracket",
  "ShowCellLabel",
  "ShowCellTags",
  "ShowClosedCellArea",
  "ShowCodeAssist",
  "ShowContents",
  "ShowControls",
  "ShowCursorTracker",
  "ShowGroupOpenCloseIcon",
  "ShowGroupOpener",
  "ShowInvisibleCharacters",
  "ShowPageBreaks",
  "ShowPredictiveInterface",
  "ShowSelection",
  "ShowShortBoxForm",
  "ShowSpecialCharacters",
  "ShowStringCharacters",
  "ShowSyntaxStyles",
  "ShrinkingDelay",
  "ShrinkWrapBoundingBox",
  "SiderealTime",
  "SiegelTheta",
  "SiegelTukeyTest",
  "SierpinskiCurve",
  "SierpinskiMesh",
  "Sign",
  "Signature",
  "SignedRankTest",
  "SignedRegionDistance",
  "SignificanceLevel",
  "SignPadding",
  "SignTest",
  "SimilarityRules",
  "SimpleGraph",
  "SimpleGraphQ",
  "SimplePolygonQ",
  "SimplePolyhedronQ",
  "Simplex",
  "Simplify",
  "Sin",
  "Sinc",
  "SinghMaddalaDistribution",
  "SingleEvaluation",
  "SingleLetterItalics",
  "SingleLetterStyle",
  "SingularValueDecomposition",
  "SingularValueList",
  "SingularValuePlot",
  "SingularValues",
  "Sinh",
  "SinhIntegral",
  "SinIntegral",
  "SixJSymbol",
  "Skeleton",
  "SkeletonTransform",
  "SkellamDistribution",
  "Skewness",
  "SkewNormalDistribution",
  "SkinStyle",
  "Skip",
  "SliceContourPlot3D",
  "SliceDensityPlot3D",
  "SliceDistribution",
  "SliceVectorPlot3D",
  "Slider",
  "Slider2D",
  "Slider2DBox",
  "Slider2DBoxOptions",
  "SliderBox",
  "SliderBoxOptions",
  "SlideShowVideo",
  "SlideView",
  "Slot",
  "SlotSequence",
  "Small",
  "SmallCircle",
  "Smaller",
  "SmithDecomposition",
  "SmithDelayCompensator",
  "SmithWatermanSimilarity",
  "SmoothDensityHistogram",
  "SmoothHistogram",
  "SmoothHistogram3D",
  "SmoothKernelDistribution",
  "SmoothPointDensity",
  "SnDispersion",
  "Snippet",
  "SnippetsVideo",
  "SnubPolyhedron",
  "SocialMediaData",
  "Socket",
  "SocketConnect",
  "SocketListen",
  "SocketListener",
  "SocketObject",
  "SocketOpen",
  "SocketReadMessage",
  "SocketReadyQ",
  "Sockets",
  "SocketWaitAll",
  "SocketWaitNext",
  "SoftmaxLayer",
  "SokalSneathDissimilarity",
  "SolarEclipse",
  "SolarSystemFeatureData",
  "SolarTime",
  "SolidAngle",
  "SolidBoundaryLoadValue",
  "SolidData",
  "SolidDisplacementCondition",
  "SolidFixedCondition",
  "SolidMechanicsPDEComponent",
  "SolidMechanicsStrain",
  "SolidMechanicsStress",
  "SolidRegionQ",
  "Solve",
  "SolveAlways",
  "SolveDelayed",
  "SolveValues",
  "Sort",
  "SortBy",
  "SortedBy",
  "SortedEntityClass",
  "Sound",
  "SoundAndGraphics",
  "SoundNote",
  "SoundVolume",
  "SourceLink",
  "SourcePDETerm",
  "Sow",
  "Space",
  "SpaceCurveData",
  "SpaceForm",
  "Spacer",
  "Spacings",
  "Span",
  "SpanAdjustments",
  "SpanCharacterRounding",
  "SpanFromAbove",
  "SpanFromBoth",
  "SpanFromLeft",
  "SpanLineThickness",
  "SpanMaxSize",
  "SpanMinSize",
  "SpanningCharacters",
  "SpanSymmetric",
  "SparseArray",
  "SparseArrayQ",
  "SpatialBinnedPointData",
  "SpatialBoundaryCorrection",
  "SpatialEstimate",
  "SpatialEstimatorFunction",
  "SpatialGraphDistribution",
  "SpatialJ",
  "SpatialMedian",
  "SpatialNoiseLevel",
  "SpatialObservationRegionQ",
  "SpatialPointData",
  "SpatialPointSelect",
  "SpatialRandomnessTest",
  "SpatialTransformationLayer",
  "SpatialTrendFunction",
  "Speak",
  "SpeakerMatchQ",
  "SpearmanRankTest",
  "SpearmanRho",
  "SpeciesData",
  "SpecificityGoal",
  "SpectralLineData",
  "Spectrogram",
  "SpectrogramArray",
  "Specularity",
  "SpeechCases",
  "SpeechInterpreter",
  "SpeechRecognize",
  "SpeechSynthesize",
  "SpellingCorrection",
  "SpellingCorrectionList",
  "SpellingDictionaries",
  "SpellingDictionariesPath",
  "SpellingOptions",
  "Sphere",
  "SphereBox",
  "SphereBoxOptions",
  "SpherePoints",
  "SphericalBesselJ",
  "SphericalBesselY",
  "SphericalHankelH1",
  "SphericalHankelH2",
  "SphericalHarmonicY",
  "SphericalPlot3D",
  "SphericalRegion",
  "SphericalShell",
  "SpheroidalEigenvalue",
  "SpheroidalJoiningFactor",
  "SpheroidalPS",
  "SpheroidalPSPrime",
  "SpheroidalQS",
  "SpheroidalQSPrime",
  "SpheroidalRadialFactor",
  "SpheroidalS1",
  "SpheroidalS1Prime",
  "SpheroidalS2",
  "SpheroidalS2Prime",
  "Splice",
  "SplicedDistribution",
  "SplineClosed",
  "SplineDegree",
  "SplineKnots",
  "SplineWeights",
  "Split",
  "SplitBy",
  "SpokenString",
  "SpotLight",
  "Sqrt",
  "SqrtBox",
  "SqrtBoxOptions",
  "Square",
  "SquaredEuclideanDistance",
  "SquareFreeQ",
  "SquareIntersection",
  "SquareMatrixQ",
  "SquareRepeatingElement",
  "SquaresR",
  "SquareSubset",
  "SquareSubsetEqual",
  "SquareSuperset",
  "SquareSupersetEqual",
  "SquareUnion",
  "SquareWave",
  "SSSTriangle",
  "StabilityMargins",
  "StabilityMarginsStyle",
  "StableDistribution",
  "Stack",
  "StackBegin",
  "StackComplete",
  "StackedDateListPlot",
  "StackedListPlot",
  "StackInhibit",
  "StadiumShape",
  "StandardAtmosphereData",
  "StandardDeviation",
  "StandardDeviationFilter",
  "StandardForm",
  "Standardize",
  "Standardized",
  "StandardOceanData",
  "StandbyDistribution",
  "Star",
  "StarClusterData",
  "StarData",
  "StarGraph",
  "StartAsynchronousTask",
  "StartExternalSession",
  "StartingStepSize",
  "StartOfLine",
  "StartOfString",
  "StartProcess",
  "StartScheduledTask",
  "StartupSound",
  "StartWebSession",
  "StateDimensions",
  "StateFeedbackGains",
  "StateOutputEstimator",
  "StateResponse",
  "StateSpaceModel",
  "StateSpaceRealization",
  "StateSpaceTransform",
  "StateTransformationLinearize",
  "StationaryDistribution",
  "StationaryWaveletPacketTransform",
  "StationaryWaveletTransform",
  "StatusArea",
  "StatusCentrality",
  "StepMonitor",
  "StereochemistryElements",
  "StieltjesGamma",
  "StippleShading",
  "StirlingS1",
  "StirlingS2",
  "StopAsynchronousTask",
  "StoppingPowerData",
  "StopScheduledTask",
  "StrataVariables",
  "StratonovichProcess",
  "StraussHardcorePointProcess",
  "StraussPointProcess",
  "StreamColorFunction",
  "StreamColorFunctionScaling",
  "StreamDensityPlot",
  "StreamMarkers",
  "StreamPlot",
  "StreamPlot3D",
  "StreamPoints",
  "StreamPosition",
  "Streams",
  "StreamScale",
  "StreamStyle",
  "StrictInequalities",
  "String",
  "StringBreak",
  "StringByteCount",
  "StringCases",
  "StringContainsQ",
  "StringCount",
  "StringDelete",
  "StringDrop",
  "StringEndsQ",
  "StringExpression",
  "StringExtract",
  "StringForm",
  "StringFormat",
  "StringFormatQ",
  "StringFreeQ",
  "StringInsert",
  "StringJoin",
  "StringLength",
  "StringMatchQ",
  "StringPadLeft",
  "StringPadRight",
  "StringPart",
  "StringPartition",
  "StringPosition",
  "StringQ",
  "StringRepeat",
  "StringReplace",
  "StringReplaceList",
  "StringReplacePart",
  "StringReverse",
  "StringRiffle",
  "StringRotateLeft",
  "StringRotateRight",
  "StringSkeleton",
  "StringSplit",
  "StringStartsQ",
  "StringTake",
  "StringTakeDrop",
  "StringTemplate",
  "StringToByteArray",
  "StringToStream",
  "StringTrim",
  "StripBoxes",
  "StripOnInput",
  "StripStyleOnPaste",
  "StripWrapperBoxes",
  "StrokeForm",
  "Struckthrough",
  "StructuralImportance",
  "StructuredArray",
  "StructuredArrayHeadQ",
  "StructuredSelection",
  "StruveH",
  "StruveL",
  "Stub",
  "StudentTDistribution",
  "Style",
  "StyleBox",
  "StyleBoxAutoDelete",
  "StyleData",
  "StyleDefinitions",
  "StyleForm",
  "StyleHints",
  "StyleKeyMapping",
  "StyleMenuListing",
  "StyleNameDialogSettings",
  "StyleNames",
  "StylePrint",
  "StyleSheetPath",
  "Subdivide",
  "Subfactorial",
  "Subgraph",
  "SubMinus",
  "SubPlus",
  "SubresultantPolynomialRemainders",
  "SubresultantPolynomials",
  "Subresultants",
  "Subscript",
  "SubscriptBox",
  "SubscriptBoxOptions",
  "Subscripted",
  "Subsequences",
  "Subset",
  "SubsetCases",
  "SubsetCount",
  "SubsetEqual",
  "SubsetMap",
  "SubsetPosition",
  "SubsetQ",
  "SubsetReplace",
  "Subsets",
  "SubStar",
  "SubstitutionSystem",
  "Subsuperscript",
  "SubsuperscriptBox",
  "SubsuperscriptBoxOptions",
  "SubtitleEncoding",
  "SubtitleTrackSelection",
  "Subtract",
  "SubtractFrom",
  "SubtractSides",
  "SubValues",
  "Succeeds",
  "SucceedsEqual",
  "SucceedsSlantEqual",
  "SucceedsTilde",
  "Success",
  "SuchThat",
  "Sum",
  "SumConvergence",
  "SummationLayer",
  "Sunday",
  "SunPosition",
  "Sunrise",
  "Sunset",
  "SuperDagger",
  "SuperMinus",
  "SupernovaData",
  "SuperPlus",
  "Superscript",
  "SuperscriptBox",
  "SuperscriptBoxOptions",
  "Superset",
  "SupersetEqual",
  "SuperStar",
  "Surd",
  "SurdForm",
  "SurfaceAppearance",
  "SurfaceArea",
  "SurfaceColor",
  "SurfaceData",
  "SurfaceGraphics",
  "SurvivalDistribution",
  "SurvivalFunction",
  "SurvivalModel",
  "SurvivalModelFit",
  "SuspendPacket",
  "SuzukiDistribution",
  "SuzukiGroupSuz",
  "SwatchLegend",
  "Switch",
  "Symbol",
  "SymbolName",
  "SymletWavelet",
  "Symmetric",
  "SymmetricDifference",
  "SymmetricGroup",
  "SymmetricKey",
  "SymmetricMatrixQ",
  "SymmetricPolynomial",
  "SymmetricReduction",
  "Symmetrize",
  "SymmetrizedArray",
  "SymmetrizedArrayRules",
  "SymmetrizedDependentComponents",
  "SymmetrizedIndependentComponents",
  "SymmetrizedReplacePart",
  "SynchronousInitialization",
  "SynchronousUpdating",
  "Synonyms",
  "Syntax",
  "SyntaxForm",
  "SyntaxInformation",
  "SyntaxLength",
  "SyntaxPacket",
  "SyntaxQ",
  "SynthesizeMissingValues",
  "SystemCredential",
  "SystemCredentialData",
  "SystemCredentialKey",
  "SystemCredentialKeys",
  "SystemCredentialStoreObject",
  "SystemDialogInput",
  "SystemException",
  "SystemGet",
  "SystemHelpPath",
  "SystemInformation",
  "SystemInformationData",
  "SystemInstall",
  "SystemModel",
  "SystemModeler",
  "SystemModelExamples",
  "SystemModelLinearize",
  "SystemModelMeasurements",
  "SystemModelParametricSimulate",
  "SystemModelPlot",
  "SystemModelProgressReporting",
  "SystemModelReliability",
  "SystemModels",
  "SystemModelSimulate",
  "SystemModelSimulateSensitivity",
  "SystemModelSimulationData",
  "SystemOpen",
  "SystemOptions",
  "SystemProcessData",
  "SystemProcesses",
  "SystemsConnectionsModel",
  "SystemsModelControllerData",
  "SystemsModelDelay",
  "SystemsModelDelayApproximate",
  "SystemsModelDelete",
  "SystemsModelDimensions",
  "SystemsModelExtract",
  "SystemsModelFeedbackConnect",
  "SystemsModelLabels",
  "SystemsModelLinearity",
  "SystemsModelMerge",
  "SystemsModelOrder",
  "SystemsModelParallelConnect",
  "SystemsModelSeriesConnect",
  "SystemsModelStateFeedbackConnect",
  "SystemsModelVectorRelativeOrders",
  "SystemStub",
  "SystemTest",
  "Tab",
  "TabFilling",
  "Table",
  "TableAlignments",
  "TableDepth",
  "TableDirections",
  "TableForm",
  "TableHeadings",
  "TableSpacing",
  "TableView",
  "TableViewBox",
  "TableViewBoxAlignment",
  "TableViewBoxBackground",
  "TableViewBoxHeaders",
  "TableViewBoxItemSize",
  "TableViewBoxItemStyle",
  "TableViewBoxOptions",
  "TabSpacings",
  "TabView",
  "TabViewBox",
  "TabViewBoxOptions",
  "TagBox",
  "TagBoxNote",
  "TagBoxOptions",
  "TaggingRules",
  "TagSet",
  "TagSetDelayed",
  "TagStyle",
  "TagUnset",
  "Take",
  "TakeDrop",
  "TakeLargest",
  "TakeLargestBy",
  "TakeList",
  "TakeSmallest",
  "TakeSmallestBy",
  "TakeWhile",
  "Tally",
  "Tan",
  "Tanh",
  "TargetDevice",
  "TargetFunctions",
  "TargetSystem",
  "TargetUnits",
  "TaskAbort",
  "TaskExecute",
  "TaskObject",
  "TaskRemove",
  "TaskResume",
  "Tasks",
  "TaskSuspend",
  "TaskWait",
  "TautologyQ",
  "TelegraphProcess",
  "TemplateApply",
  "TemplateArgBox",
  "TemplateBox",
  "TemplateBoxOptions",
  "TemplateEvaluate",
  "TemplateExpression",
  "TemplateIf",
  "TemplateObject",
  "TemplateSequence",
  "TemplateSlot",
  "TemplateSlotSequence",
  "TemplateUnevaluated",
  "TemplateVerbatim",
  "TemplateWith",
  "TemporalData",
  "TemporalRegularity",
  "Temporary",
  "TemporaryVariable",
  "TensorContract",
  "TensorDimensions",
  "TensorExpand",
  "TensorProduct",
  "TensorQ",
  "TensorRank",
  "TensorReduce",
  "TensorSymmetry",
  "TensorTranspose",
  "TensorWedge",
  "TerminatedEvaluation",
  "TernaryListPlot",
  "TernaryPlotCorners",
  "TestID",
  "TestReport",
  "TestReportObject",
  "TestResultObject",
  "Tetrahedron",
  "TetrahedronBox",
  "TetrahedronBoxOptions",
  "TeXForm",
  "TeXSave",
  "Text",
  "Text3DBox",
  "Text3DBoxOptions",
  "TextAlignment",
  "TextBand",
  "TextBoundingBox",
  "TextBox",
  "TextCases",
  "TextCell",
  "TextClipboardType",
  "TextContents",
  "TextData",
  "TextElement",
  "TextForm",
  "TextGrid",
  "TextJustification",
  "TextLine",
  "TextPacket",
  "TextParagraph",
  "TextPosition",
  "TextRecognize",
  "TextSearch",
  "TextSearchReport",
  "TextSentences",
  "TextString",
  "TextStructure",
  "TextStyle",
  "TextTranslation",
  "Texture",
  "TextureCoordinateFunction",
  "TextureCoordinateScaling",
  "TextWords",
  "Therefore",
  "ThermodynamicData",
  "ThermometerGauge",
  "Thick",
  "Thickness",
  "Thin",
  "Thinning",
  "ThisLink",
  "ThomasPointProcess",
  "ThompsonGroupTh",
  "Thread",
  "Threaded",
  "ThreadingLayer",
  "ThreeJSymbol",
  "Threshold",
  "Through",
  "Throw",
  "ThueMorse",
  "Thumbnail",
  "Thursday",
  "TickDirection",
  "TickLabelOrientation",
  "TickLabelPositioning",
  "TickLabels",
  "TickLengths",
  "TickPositions",
  "Ticks",
  "TicksStyle",
  "TideData",
  "Tilde",
  "TildeEqual",
  "TildeFullEqual",
  "TildeTilde",
  "TimeConstrained",
  "TimeConstraint",
  "TimeDirection",
  "TimeFormat",
  "TimeGoal",
  "TimelinePlot",
  "TimeObject",
  "TimeObjectQ",
  "TimeRemaining",
  "Times",
  "TimesBy",
  "TimeSeries",
  "TimeSeriesAggregate",
  "TimeSeriesForecast",
  "TimeSeriesInsert",
  "TimeSeriesInvertibility",
  "TimeSeriesMap",
  "TimeSeriesMapThread",
  "TimeSeriesModel",
  "TimeSeriesModelFit",
  "TimeSeriesResample",
  "TimeSeriesRescale",
  "TimeSeriesShift",
  "TimeSeriesThread",
  "TimeSeriesWindow",
  "TimeSystem",
  "TimeSystemConvert",
  "TimeUsed",
  "TimeValue",
  "TimeWarpingCorrespondence",
  "TimeWarpingDistance",
  "TimeZone",
  "TimeZoneConvert",
  "TimeZoneOffset",
  "Timing",
  "Tiny",
  "TitleGrouping",
  "TitsGroupT",
  "ToBoxes",
  "ToCharacterCode",
  "ToColor",
  "ToContinuousTimeModel",
  "ToDate",
  "Today",
  "ToDiscreteTimeModel",
  "ToEntity",
  "ToeplitzMatrix",
  "ToExpression",
  "ToFileName",
  "Together",
  "Toggle",
  "ToggleFalse",
  "Toggler",
  "TogglerBar",
  "TogglerBox",
  "TogglerBoxOptions",
  "ToHeldExpression",
  "ToInvertibleTimeSeries",
  "TokenWords",
  "Tolerance",
  "ToLowerCase",
  "Tomorrow",
  "ToNumberField",
  "TooBig",
  "Tooltip",
  "TooltipBox",
  "TooltipBoxOptions",
  "TooltipDelay",
  "TooltipStyle",
  "ToonShading",
  "Top",
  "TopHatTransform",
  "ToPolarCoordinates",
  "TopologicalSort",
  "ToRadicals",
  "ToRawPointer",
  "ToRules",
  "Torus",
  "TorusGraph",
  "ToSphericalCoordinates",
  "ToString",
  "Total",
  "TotalHeight",
  "TotalLayer",
  "TotalVariationFilter",
  "TotalWidth",
  "TouchPosition",
  "TouchscreenAutoZoom",
  "TouchscreenControlPlacement",
  "ToUpperCase",
  "TourVideo",
  "Tr",
  "Trace",
  "TraceAbove",
  "TraceAction",
  "TraceBackward",
  "TraceDepth",
  "TraceDialog",
  "TraceForward",
  "TraceInternal",
  "TraceLevel",
  "TraceOff",
  "TraceOn",
  "TraceOriginal",
  "TracePrint",
  "TraceScan",
  "TrackCellChangeTimes",
  "TrackedSymbols",
  "TrackingFunction",
  "TracyWidomDistribution",
  "TradingChart",
  "TraditionalForm",
  "TraditionalFunctionNotation",
  "TraditionalNotation",
  "TraditionalOrder",
  "TrainImageContentDetector",
  "TrainingProgressCheckpointing",
  "TrainingProgressFunction",
  "TrainingProgressMeasurements",
  "TrainingProgressReporting",
  "TrainingStoppingCriterion",
  "TrainingUpdateSchedule",
  "TrainTextContentDetector",
  "TransferFunctionCancel",
  "TransferFunctionExpand",
  "TransferFunctionFactor",
  "TransferFunctionModel",
  "TransferFunctionPoles",
  "TransferFunctionTransform",
  "TransferFunctionZeros",
  "TransformationClass",
  "TransformationFunction",
  "TransformationFunctions",
  "TransformationMatrix",
  "TransformedDistribution",
  "TransformedField",
  "TransformedProcess",
  "TransformedRegion",
  "TransitionDirection",
  "TransitionDuration",
  "TransitionEffect",
  "TransitiveClosureGraph",
  "TransitiveReductionGraph",
  "Translate",
  "TranslationOptions",
  "TranslationTransform",
  "Transliterate",
  "Transparent",
  "TransparentColor",
  "Transpose",
  "TransposeLayer",
  "TrapEnterKey",
  "TrapSelection",
  "TravelDirections",
  "TravelDirectionsData",
  "TravelDistance",
  "TravelDistanceList",
  "TravelMethod",
  "TravelTime",
  "Tree",
  "TreeCases",
  "TreeChildren",
  "TreeCount",
  "TreeData",
  "TreeDelete",
  "TreeDepth",
  "TreeElementCoordinates",
  "TreeElementLabel",
  "TreeElementLabelFunction",
  "TreeElementLabelStyle",
  "TreeElementShape",
  "TreeElementShapeFunction",
  "TreeElementSize",
  "TreeElementSizeFunction",
  "TreeElementStyle",
  "TreeElementStyleFunction",
  "TreeExpression",
  "TreeExtract",
  "TreeFold",
  "TreeForm",
  "TreeGraph",
  "TreeGraphQ",
  "TreeInsert",
  "TreeLayout",
  "TreeLeafCount",
  "TreeLeafQ",
  "TreeLeaves",
  "TreeLevel",
  "TreeMap",
  "TreeMapAt",
  "TreeOutline",
  "TreePlot",
  "TreePosition",
  "TreeQ",
  "TreeReplacePart",
  "TreeRules",
  "TreeScan",
  "TreeSelect",
  "TreeSize",
  "TreeTraversalOrder",
  "TrendStyle",
  "Triangle",
  "TriangleCenter",
  "TriangleConstruct",
  "TriangleMeasurement",
  "TriangleWave",
  "TriangularDistribution",
  "TriangulateMesh",
  "Trig",
  "TrigExpand",
  "TrigFactor",
  "TrigFactorList",
  "Trigger",
  "TrigReduce",
  "TrigToExp",
  "TrimmedMean",
  "TrimmedVariance",
  "TropicalStormData",
  "True",
  "TrueQ",
  "TruncatedDistribution",
  "TruncatedPolyhedron",
  "TsallisQExponentialDistribution",
  "TsallisQGaussianDistribution",
  "TTest",
  "Tube",
  "TubeBezierCurveBox",
  "TubeBezierCurveBoxOptions",
  "TubeBox",
  "TubeBoxOptions",
  "TubeBSplineCurveBox",
  "TubeBSplineCurveBoxOptions",
  "Tuesday",
  "TukeyLambdaDistribution",
  "TukeyWindow",
  "TunnelData",
  "Tuples",
  "TuranGraph",
  "TuringMachine",
  "TuttePolynomial",
  "TwoWayRule",
  "Typed",
  "TypeDeclaration",
  "TypeEvaluate",
  "TypeHint",
  "TypeOf",
  "TypeSpecifier",
  "UnateQ",
  "Uncompress",
  "UnconstrainedParameters",
  "Undefined",
  "UnderBar",
  "Underflow",
  "Underlined",
  "Underoverscript",
  "UnderoverscriptBox",
  "UnderoverscriptBoxOptions",
  "Underscript",
  "UnderscriptBox",
  "UnderscriptBoxOptions",
  "UnderseaFeatureData",
  "UndirectedEdge",
  "UndirectedGraph",
  "UndirectedGraphQ",
  "UndoOptions",
  "UndoTrackedVariables",
  "Unequal",
  "UnequalTo",
  "Unevaluated",
  "UniformDistribution",
  "UniformGraphDistribution",
  "UniformPolyhedron",
  "UniformSumDistribution",
  "Uninstall",
  "Union",
  "UnionedEntityClass",
  "UnionPlus",
  "Unique",
  "UniqueElements",
  "UnitaryMatrixQ",
  "UnitBox",
  "UnitConvert",
  "UnitDimensions",
  "Unitize",
  "UnitRootTest",
  "UnitSimplify",
  "UnitStep",
  "UnitSystem",
  "UnitTriangle",
  "UnitVector",
  "UnitVectorLayer",
  "UnityDimensions",
  "UniverseModelData",
  "UniversityData",
  "UnixTime",
  "UnlabeledTree",
  "UnmanageObject",
  "Unprotect",
  "UnregisterExternalEvaluator",
  "UnsameQ",
  "UnsavedVariables",
  "Unset",
  "UnsetShared",
  "Until",
  "UntrackedVariables",
  "Up",
  "UpArrow",
  "UpArrowBar",
  "UpArrowDownArrow",
  "Update",
  "UpdateDynamicObjects",
  "UpdateDynamicObjectsSynchronous",
  "UpdateInterval",
  "UpdatePacletSites",
  "UpdateSearchIndex",
  "UpDownArrow",
  "UpEquilibrium",
  "UpperCaseQ",
  "UpperLeftArrow",
  "UpperRightArrow",
  "UpperTriangularize",
  "UpperTriangularMatrix",
  "UpperTriangularMatrixQ",
  "Upsample",
  "UpSet",
  "UpSetDelayed",
  "UpTee",
  "UpTeeArrow",
  "UpTo",
  "UpValues",
  "URL",
  "URLBuild",
  "URLDecode",
  "URLDispatcher",
  "URLDownload",
  "URLDownloadSubmit",
  "URLEncode",
  "URLExecute",
  "URLExpand",
  "URLFetch",
  "URLFetchAsynchronous",
  "URLParse",
  "URLQueryDecode",
  "URLQueryEncode",
  "URLRead",
  "URLResponseTime",
  "URLSave",
  "URLSaveAsynchronous",
  "URLShorten",
  "URLSubmit",
  "UseEmbeddedLibrary",
  "UseGraphicsRange",
  "UserDefinedWavelet",
  "Using",
  "UsingFrontEnd",
  "UtilityFunction",
  "V2Get",
  "ValenceErrorHandling",
  "ValenceFilling",
  "ValidationLength",
  "ValidationSet",
  "ValueBox",
  "ValueBoxOptions",
  "ValueDimensions",
  "ValueForm",
  "ValuePreprocessingFunction",
  "ValueQ",
  "Values",
  "ValuesData",
  "VandermondeMatrix",
  "Variables",
  "Variance",
  "VarianceEquivalenceTest",
  "VarianceEstimatorFunction",
  "VarianceGammaDistribution",
  "VarianceGammaPointProcess",
  "VarianceTest",
  "VariogramFunction",
  "VariogramModel",
  "VectorAngle",
  "VectorAround",
  "VectorAspectRatio",
  "VectorColorFunction",
  "VectorColorFunctionScaling",
  "VectorDensityPlot",
  "VectorDisplacementPlot",
  "VectorDisplacementPlot3D",
  "VectorGlyphData",
  "VectorGreater",
  "VectorGreaterEqual",
  "VectorLess",
  "VectorLessEqual",
  "VectorMarkers",
  "VectorPlot",
  "VectorPlot3D",
  "VectorPoints",
  "VectorQ",
  "VectorRange",
  "Vectors",
  "VectorScale",
  "VectorScaling",
  "VectorSizes",
  "VectorStyle",
  "Vee",
  "Verbatim",
  "Verbose",
  "VerificationTest",
  "VerifyConvergence",
  "VerifyDerivedKey",
  "VerifyDigitalSignature",
  "VerifyFileSignature",
  "VerifyInterpretation",
  "VerifySecurityCertificates",
  "VerifySolutions",
  "VerifyTestAssumptions",
  "VersionedPreferences",
  "VertexAdd",
  "VertexCapacity",
  "VertexChromaticNumber",
  "VertexColors",
  "VertexComponent",
  "VertexConnectivity",
  "VertexContract",
  "VertexCoordinateRules",
  "VertexCoordinates",
  "VertexCorrelationSimilarity",
  "VertexCosineSimilarity",
  "VertexCount",
  "VertexCoverQ",
  "VertexDataCoordinates",
  "VertexDegree",
  "VertexDelete",
  "VertexDiceSimilarity",
  "VertexEccentricity",
  "VertexInComponent",
  "VertexInComponentGraph",
  "VertexInDegree",
  "VertexIndex",
  "VertexJaccardSimilarity",
  "VertexLabeling",
  "VertexLabels",
  "VertexLabelStyle",
  "VertexList",
  "VertexNormals",
  "VertexOutComponent",
  "VertexOutComponentGraph",
  "VertexOutDegree",
  "VertexQ",
  "VertexRenderingFunction",
  "VertexReplace",
  "VertexShape",
  "VertexShapeFunction",
  "VertexSize",
  "VertexStyle",
  "VertexTextureCoordinates",
  "VertexTransitiveGraphQ",
  "VertexWeight",
  "VertexWeightedGraphQ",
  "Vertical",
  "VerticalBar",
  "VerticalForm",
  "VerticalGauge",
  "VerticalSeparator",
  "VerticalSlider",
  "VerticalTilde",
  "Video",
  "VideoCapture",
  "VideoCombine",
  "VideoDelete",
  "VideoEncoding",
  "VideoExtractFrames",
  "VideoFrameList",
  "VideoFrameMap",
  "VideoGenerator",
  "VideoInsert",
  "VideoIntervals",
  "VideoJoin",
  "VideoMap",
  "VideoMapList",
  "VideoMapTimeSeries",
  "VideoPadding",
  "VideoPause",
  "VideoPlay",
  "VideoQ",
  "VideoRecord",
  "VideoReplace",
  "VideoScreenCapture",
  "VideoSplit",
  "VideoStop",
  "VideoStream",
  "VideoStreams",
  "VideoTimeStretch",
  "VideoTrackSelection",
  "VideoTranscode",
  "VideoTransparency",
  "VideoTrim",
  "ViewAngle",
  "ViewCenter",
  "ViewMatrix",
  "ViewPoint",
  "ViewPointSelectorSettings",
  "ViewPort",
  "ViewProjection",
  "ViewRange",
  "ViewVector",
  "ViewVertical",
  "VirtualGroupData",
  "Visible",
  "VisibleCell",
  "VoiceStyleData",
  "VoigtDistribution",
  "VolcanoData",
  "Volume",
  "VonMisesDistribution",
  "VoronoiMesh",
  "WaitAll",
  "WaitAsynchronousTask",
  "WaitNext",
  "WaitUntil",
  "WakebyDistribution",
  "WalleniusHypergeometricDistribution",
  "WaringYuleDistribution",
  "WarpingCorrespondence",
  "WarpingDistance",
  "WatershedComponents",
  "WatsonUSquareTest",
  "WattsStrogatzGraphDistribution",
  "WaveletBestBasis",
  "WaveletFilterCoefficients",
  "WaveletImagePlot",
  "WaveletListPlot",
  "WaveletMapIndexed",
  "WaveletMatrixPlot",
  "WaveletPhi",
  "WaveletPsi",
  "WaveletScale",
  "WaveletScalogram",
  "WaveletThreshold",
  "WavePDEComponent",
  "WeaklyConnectedComponents",
  "WeaklyConnectedGraphComponents",
  "WeaklyConnectedGraphQ",
  "WeakStationarity",
  "WeatherData",
  "WeatherForecastData",
  "WebAudioSearch",
  "WebColumn",
  "WebElementObject",
  "WeberE",
  "WebExecute",
  "WebImage",
  "WebImageSearch",
  "WebItem",
  "WebPageMetaInformation",
  "WebRow",
  "WebSearch",
  "WebSessionObject",
  "WebSessions",
  "WebWindowObject",
  "Wedge",
  "Wednesday",
  "WeibullDistribution",
  "WeierstrassE1",
  "WeierstrassE2",
  "WeierstrassE3",
  "WeierstrassEta1",
  "WeierstrassEta2",
  "WeierstrassEta3",
  "WeierstrassHalfPeriods",
  "WeierstrassHalfPeriodW1",
  "WeierstrassHalfPeriodW2",
  "WeierstrassHalfPeriodW3",
  "WeierstrassInvariantG2",
  "WeierstrassInvariantG3",
  "WeierstrassInvariants",
  "WeierstrassP",
  "WeierstrassPPrime",
  "WeierstrassSigma",
  "WeierstrassZeta",
  "WeightedAdjacencyGraph",
  "WeightedAdjacencyMatrix",
  "WeightedData",
  "WeightedGraphQ",
  "Weights",
  "WelchWindow",
  "WheelGraph",
  "WhenEvent",
  "Which",
  "While",
  "White",
  "WhiteNoiseProcess",
  "WhitePoint",
  "Whitespace",
  "WhitespaceCharacter",
  "WhittakerM",
  "WhittakerW",
  "WholeCellGroupOpener",
  "WienerFilter",
  "WienerProcess",
  "WignerD",
  "WignerSemicircleDistribution",
  "WikidataData",
  "WikidataSearch",
  "WikipediaData",
  "WikipediaSearch",
  "WilksW",
  "WilksWTest",
  "WindDirectionData",
  "WindingCount",
  "WindingPolygon",
  "WindowClickSelect",
  "WindowElements",
  "WindowFloating",
  "WindowFrame",
  "WindowFrameElements",
  "WindowMargins",
  "WindowMovable",
  "WindowOpacity",
  "WindowPersistentStyles",
  "WindowSelected",
  "WindowSize",
  "WindowStatusArea",
  "WindowTitle",
  "WindowToolbars",
  "WindowWidth",
  "WindSpeedData",
  "WindVectorData",
  "WinsorizedMean",
  "WinsorizedVariance",
  "WishartMatrixDistribution",
  "With",
  "WithCleanup",
  "WithLock",
  "WolframAlpha",
  "WolframAlphaDate",
  "WolframAlphaQuantity",
  "WolframAlphaResult",
  "WolframCloudSettings",
  "WolframLanguageData",
  "Word",
  "WordBoundary",
  "WordCharacter",
  "WordCloud",
  "WordCount",
  "WordCounts",
  "WordData",
  "WordDefinition",
  "WordFrequency",
  "WordFrequencyData",
  "WordList",
  "WordOrientation",
  "WordSearch",
  "WordSelectionFunction",
  "WordSeparators",
  "WordSpacings",
  "WordStem",
  "WordTranslation",
  "WorkingPrecision",
  "WrapAround",
  "Write",
  "WriteLine",
  "WriteString",
  "Wronskian",
  "XMLElement",
  "XMLObject",
  "XMLTemplate",
  "Xnor",
  "Xor",
  "XYZColor",
  "Yellow",
  "Yesterday",
  "YuleDissimilarity",
  "ZernikeR",
  "ZeroSymmetric",
  "ZeroTest",
  "ZeroWidthTimes",
  "Zeta",
  "ZetaZero",
  "ZIPCodeData",
  "ZipfDistribution",
  "ZoomCenter",
  "ZoomFactor",
  "ZTest",
  "ZTransform",
  "$Aborted",
  "$ActivationGroupID",
  "$ActivationKey",
  "$ActivationUserRegistered",
  "$AddOnsDirectory",
  "$AllowDataUpdates",
  "$AllowExternalChannelFunctions",
  "$AllowInternet",
  "$AssertFunction",
  "$Assumptions",
  "$AsynchronousTask",
  "$AudioDecoders",
  "$AudioEncoders",
  "$AudioInputDevices",
  "$AudioOutputDevices",
  "$BaseDirectory",
  "$BasePacletsDirectory",
  "$BatchInput",
  "$BatchOutput",
  "$BlockchainBase",
  "$BoxForms",
  "$ByteOrdering",
  "$CacheBaseDirectory",
  "$Canceled",
  "$ChannelBase",
  "$CharacterEncoding",
  "$CharacterEncodings",
  "$CloudAccountName",
  "$CloudBase",
  "$CloudConnected",
  "$CloudConnection",
  "$CloudCreditsAvailable",
  "$CloudEvaluation",
  "$CloudExpressionBase",
  "$CloudObjectNameFormat",
  "$CloudObjectURLType",
  "$CloudRootDirectory",
  "$CloudSymbolBase",
  "$CloudUserID",
  "$CloudUserUUID",
  "$CloudVersion",
  "$CloudVersionNumber",
  "$CloudWolframEngineVersionNumber",
  "$CommandLine",
  "$CompilationTarget",
  "$CompilerEnvironment",
  "$ConditionHold",
  "$ConfiguredKernels",
  "$Context",
  "$ContextAliases",
  "$ContextPath",
  "$ControlActiveSetting",
  "$Cookies",
  "$CookieStore",
  "$CreationDate",
  "$CryptographicEllipticCurveNames",
  "$CurrentLink",
  "$CurrentTask",
  "$CurrentWebSession",
  "$DataStructures",
  "$DateStringFormat",
  "$DefaultAudioInputDevice",
  "$DefaultAudioOutputDevice",
  "$DefaultFont",
  "$DefaultFrontEnd",
  "$DefaultImagingDevice",
  "$DefaultKernels",
  "$DefaultLocalBase",
  "$DefaultLocalKernel",
  "$DefaultMailbox",
  "$DefaultNetworkInterface",
  "$DefaultPath",
  "$DefaultProxyRules",
  "$DefaultRemoteBatchSubmissionEnvironment",
  "$DefaultRemoteKernel",
  "$DefaultSystemCredentialStore",
  "$Display",
  "$DisplayFunction",
  "$DistributedContexts",
  "$DynamicEvaluation",
  "$Echo",
  "$EmbedCodeEnvironments",
  "$EmbeddableServices",
  "$EntityStores",
  "$Epilog",
  "$EvaluationCloudBase",
  "$EvaluationCloudObject",
  "$EvaluationEnvironment",
  "$ExportFormats",
  "$ExternalIdentifierTypes",
  "$ExternalStorageBase",
  "$Failed",
  "$FinancialDataSource",
  "$FontFamilies",
  "$FormatType",
  "$FrontEnd",
  "$FrontEndSession",
  "$GeneratedAssetLocation",
  "$GeoEntityTypes",
  "$GeoLocation",
  "$GeoLocationCity",
  "$GeoLocationCountry",
  "$GeoLocationPrecision",
  "$GeoLocationSource",
  "$HistoryLength",
  "$HomeDirectory",
  "$HTMLExportRules",
  "$HTTPCookies",
  "$HTTPRequest",
  "$IgnoreEOF",
  "$ImageFormattingWidth",
  "$ImageResolution",
  "$ImagingDevice",
  "$ImagingDevices",
  "$ImportFormats",
  "$IncomingMailSettings",
  "$InitialDirectory",
  "$Initialization",
  "$InitializationContexts",
  "$Input",
  "$InputFileName",
  "$InputStreamMethods",
  "$Inspector",
  "$InstallationDate",
  "$InstallationDirectory",
  "$InterfaceEnvironment",
  "$InterpreterTypes",
  "$IterationLimit",
  "$KernelCount",
  "$KernelID",
  "$Language",
  "$LaunchDirectory",
  "$LibraryPath",
  "$LicenseExpirationDate",
  "$LicenseID",
  "$LicenseProcesses",
  "$LicenseServer",
  "$LicenseSubprocesses",
  "$LicenseType",
  "$Line",
  "$Linked",
  "$LinkSupported",
  "$LoadedFiles",
  "$LocalBase",
  "$LocalSymbolBase",
  "$MachineAddresses",
  "$MachineDomain",
  "$MachineDomains",
  "$MachineEpsilon",
  "$MachineID",
  "$MachineName",
  "$MachinePrecision",
  "$MachineType",
  "$MaxDisplayedChildren",
  "$MaxExtraPrecision",
  "$MaxLicenseProcesses",
  "$MaxLicenseSubprocesses",
  "$MaxMachineNumber",
  "$MaxNumber",
  "$MaxPiecewiseCases",
  "$MaxPrecision",
  "$MaxRootDegree",
  "$MessageGroups",
  "$MessageList",
  "$MessagePrePrint",
  "$Messages",
  "$MinMachineNumber",
  "$MinNumber",
  "$MinorReleaseNumber",
  "$MinPrecision",
  "$MobilePhone",
  "$ModuleNumber",
  "$NetworkConnected",
  "$NetworkInterfaces",
  "$NetworkLicense",
  "$NewMessage",
  "$NewSymbol",
  "$NotebookInlineStorageLimit",
  "$Notebooks",
  "$NoValue",
  "$NumberMarks",
  "$Off",
  "$OperatingSystem",
  "$Output",
  "$OutputForms",
  "$OutputSizeLimit",
  "$OutputStreamMethods",
  "$Packages",
  "$ParentLink",
  "$ParentProcessID",
  "$PasswordFile",
  "$PatchLevelID",
  "$Path",
  "$PathnameSeparator",
  "$PerformanceGoal",
  "$Permissions",
  "$PermissionsGroupBase",
  "$PersistenceBase",
  "$PersistencePath",
  "$PipeSupported",
  "$PlotTheme",
  "$Post",
  "$Pre",
  "$PreferencesDirectory",
  "$PreInitialization",
  "$PrePrint",
  "$PreRead",
  "$PrintForms",
  "$PrintLiteral",
  "$Printout3DPreviewer",
  "$ProcessID",
  "$ProcessorCount",
  "$ProcessorType",
  "$ProductInformation",
  "$ProgramName",
  "$ProgressReporting",
  "$PublisherID",
  "$RandomGeneratorState",
  "$RandomState",
  "$RecursionLimit",
  "$RegisteredDeviceClasses",
  "$RegisteredUserName",
  "$ReleaseNumber",
  "$RequesterAddress",
  "$RequesterCloudUserID",
  "$RequesterCloudUserUUID",
  "$RequesterWolframID",
  "$RequesterWolframUUID",
  "$ResourceSystemBase",
  "$ResourceSystemPath",
  "$RootDirectory",
  "$ScheduledTask",
  "$ScriptCommandLine",
  "$ScriptInputString",
  "$SecuredAuthenticationKeyTokens",
  "$ServiceCreditsAvailable",
  "$Services",
  "$SessionID",
  "$SetParentLink",
  "$SharedFunctions",
  "$SharedVariables",
  "$SoundDisplay",
  "$SoundDisplayFunction",
  "$SourceLink",
  "$SSHAuthentication",
  "$SubtitleDecoders",
  "$SubtitleEncoders",
  "$SummaryBoxDataSizeLimit",
  "$SuppressInputFormHeads",
  "$SynchronousEvaluation",
  "$SyntaxHandler",
  "$System",
  "$SystemCharacterEncoding",
  "$SystemCredentialStore",
  "$SystemID",
  "$SystemMemory",
  "$SystemShell",
  "$SystemTimeZone",
  "$SystemWordLength",
  "$TargetSystems",
  "$TemplatePath",
  "$TemporaryDirectory",
  "$TemporaryPrefix",
  "$TestFileName",
  "$TextStyle",
  "$TimedOut",
  "$TimeUnit",
  "$TimeZone",
  "$TimeZoneEntity",
  "$TopDirectory",
  "$TraceOff",
  "$TraceOn",
  "$TracePattern",
  "$TracePostAction",
  "$TracePreAction",
  "$UnitSystem",
  "$Urgent",
  "$UserAddOnsDirectory",
  "$UserAgentLanguages",
  "$UserAgentMachine",
  "$UserAgentName",
  "$UserAgentOperatingSystem",
  "$UserAgentString",
  "$UserAgentVersion",
  "$UserBaseDirectory",
  "$UserBasePacletsDirectory",
  "$UserDocumentsDirectory",
  "$Username",
  "$UserName",
  "$UserURLBase",
  "$Version",
  "$VersionNumber",
  "$VideoDecoders",
  "$VideoEncoders",
  "$VoiceStyles",
  "$WolframDocumentsDirectory",
  "$WolframID",
  "$WolframUUID"
];
function sg(t) {
  const e = t.regex, n = /([2-9]|[1-2]\d|[3][0-5])\^\^/, i = /(\w*\.\w+|\w+\.\w*|\w+)/, r = /(\d*\.\d+|\d+\.\d*|\d+)/, a = e.either(e.concat(n, i), r), s = /``[+-]?(\d*\.\d+|\d+\.\d*|\d+)/, o = /`([+-]?(\d*\.\d+|\d+\.\d*|\d+))?/, l = e.either(s, o), c = /\*\^[+-]?\d+/, u = {
    className: "number",
    relevance: 0,
    begin: e.concat(
      a,
      e.optional(l),
      e.optional(c)
    )
  }, _ = /[a-zA-Z$][a-zA-Z0-9$]*/, m = new Set(ag), g = { variants: [
    {
      className: "builtin-symbol",
      begin: _,
      // for performance out of fear of regex.either(...Mathematica.SYSTEM_SYMBOLS)
      "on:begin": (y, O) => {
        m.has(y[0]) || O.ignoreMatch();
      }
    },
    {
      className: "symbol",
      relevance: 0,
      begin: _
    }
  ] }, S = {
    className: "named-character",
    begin: /\\\[[$a-zA-Z][$a-zA-Z0-9]+\]/
  }, E = {
    className: "operator",
    relevance: 0,
    begin: /[+\-*/,;.:@~=><&|_`'^?!%]+/
  }, h = {
    className: "pattern",
    relevance: 0,
    begin: /([a-zA-Z$][a-zA-Z0-9$]*)?_+([a-zA-Z$][a-zA-Z0-9$]*)?/
  }, T = {
    className: "slot",
    relevance: 0,
    begin: /#[a-zA-Z$][a-zA-Z0-9$]*|#+[0-9]?/
  }, b = {
    className: "brace",
    relevance: 0,
    begin: /[[\](){}]/
  }, C = {
    className: "message-name",
    relevance: 0,
    begin: e.concat("::", _)
  };
  return {
    name: "Mathematica",
    aliases: [
      "mma",
      "wl"
    ],
    classNameAliases: {
      brace: "punctuation",
      pattern: "type",
      slot: "type",
      symbol: "variable",
      "named-character": "variable",
      "builtin-symbol": "built_in",
      "message-name": "string"
    },
    contains: [
      t.COMMENT(/\(\*/, /\*\)/, { contains: ["self"] }),
      h,
      T,
      C,
      g,
      S,
      t.QUOTE_STRING_MODE,
      u,
      E,
      b
    ]
  };
}
function og(t) {
  const e = "('|\\.')+", n = {
    relevance: 0,
    contains: [{ begin: e }]
  };
  return {
    name: "Matlab",
    keywords: {
      keyword: "arguments break case catch classdef continue else elseif end enumeration events for function global if methods otherwise parfor persistent properties return spmd switch try while",
      built_in: "sin sind sinh asin asind asinh cos cosd cosh acos acosd acosh tan tand tanh atan atand atan2 atanh sec secd sech asec asecd asech csc cscd csch acsc acscd acsch cot cotd coth acot acotd acoth hypot exp expm1 log log1p log10 log2 pow2 realpow reallog realsqrt sqrt nthroot nextpow2 abs angle complex conj imag real unwrap isreal cplxpair fix floor ceil round mod rem sign airy besselj bessely besselh besseli besselk beta betainc betaln ellipj ellipke erf erfc erfcx erfinv expint gamma gammainc gammaln psi legendre cross dot factor isprime primes gcd lcm rat rats perms nchoosek factorial cart2sph cart2pol pol2cart sph2cart hsv2rgb rgb2hsv zeros ones eye repmat rand randn linspace logspace freqspace meshgrid accumarray size length ndims numel disp isempty isequal isequalwithequalnans cat reshape diag blkdiag tril triu fliplr flipud flipdim rot90 find sub2ind ind2sub bsxfun ndgrid permute ipermute shiftdim circshift squeeze isscalar isvector ans eps realmax realmin pi i|0 inf nan isnan isinf isfinite j|0 why compan gallery hadamard hankel hilb invhilb magic pascal rosser toeplitz vander wilkinson max min nanmax nanmin mean nanmean type table readtable writetable sortrows sort figure plot plot3 scatter scatter3 cellfun legend intersect ismember procrustes hold num2cell "
    },
    illegal: '(//|"|#|/\\*|\\s+/\\w+)',
    contains: [
      {
        className: "function",
        beginKeywords: "function",
        end: "$",
        contains: [
          t.UNDERSCORE_TITLE_MODE,
          {
            className: "params",
            variants: [
              {
                begin: "\\(",
                end: "\\)"
              },
              {
                begin: "\\[",
                end: "\\]"
              }
            ]
          }
        ]
      },
      {
        className: "built_in",
        begin: /true|false/,
        relevance: 0,
        starts: n
      },
      {
        begin: "[a-zA-Z][a-zA-Z_0-9]*" + e,
        relevance: 0
      },
      {
        className: "number",
        begin: t.C_NUMBER_RE,
        relevance: 0,
        starts: n
      },
      {
        className: "string",
        begin: "'",
        end: "'",
        contains: [{ begin: "''" }]
      },
      {
        begin: /\]|\}|\)/,
        relevance: 0,
        starts: n
      },
      {
        className: "string",
        begin: '"',
        end: '"',
        contains: [{ begin: '""' }],
        starts: n
      },
      t.COMMENT("^\\s*%\\{\\s*$", "^\\s*%\\}\\s*$"),
      t.COMMENT("%", "$")
    ]
  };
}
function lg(t) {
  return {
    name: "Maxima",
    keywords: {
      $pattern: "[A-Za-z_%][0-9A-Za-z_%]*",
      keyword: "if then else elseif for thru do while unless step in and or not",
      literal: "true false unknown inf minf ind und %e %i %pi %phi %gamma",
      built_in: " abasep abs absint absolute_real_time acos acosh acot acoth acsc acsch activate addcol add_edge add_edges addmatrices addrow add_vertex add_vertices adjacency_matrix adjoin adjoint af agd airy airy_ai airy_bi airy_dai airy_dbi algsys alg_type alias allroots alphacharp alphanumericp amortization %and annuity_fv annuity_pv antid antidiff AntiDifference append appendfile apply apply1 apply2 applyb1 apropos args arit_amortization arithmetic arithsum array arrayapply arrayinfo arraymake arraysetapply ascii asec asech asin asinh askinteger asksign assoc assoc_legendre_p assoc_legendre_q assume assume_external_byte_order asympa at atan atan2 atanh atensimp atom atvalue augcoefmatrix augmented_lagrangian_method av average_degree backtrace bars barsplot barsplot_description base64 base64_decode bashindices batch batchload bc2 bdvac belln benefit_cost bern bernpoly bernstein_approx bernstein_expand bernstein_poly bessel bessel_i bessel_j bessel_k bessel_simplify bessel_y beta beta_incomplete beta_incomplete_generalized beta_incomplete_regularized bezout bfallroots bffac bf_find_root bf_fmin_cobyla bfhzeta bfloat bfloatp bfpsi bfpsi0 bfzeta biconnected_components bimetric binomial bipartition block blockmatrixp bode_gain bode_phase bothcoef box boxplot boxplot_description break bug_report build_info|10 buildq build_sample burn cabs canform canten cardinality carg cartan cartesian_product catch cauchy_matrix cbffac cdf_bernoulli cdf_beta cdf_binomial cdf_cauchy cdf_chi2 cdf_continuous_uniform cdf_discrete_uniform cdf_exp cdf_f cdf_gamma cdf_general_finite_discrete cdf_geometric cdf_gumbel cdf_hypergeometric cdf_laplace cdf_logistic cdf_lognormal cdf_negative_binomial cdf_noncentral_chi2 cdf_noncentral_student_t cdf_normal cdf_pareto cdf_poisson cdf_rank_sum cdf_rayleigh cdf_signed_rank cdf_student_t cdf_weibull cdisplay ceiling central_moment cequal cequalignore cf cfdisrep cfexpand cgeodesic cgreaterp cgreaterpignore changename changevar chaosgame charat charfun charfun2 charlist charp charpoly chdir chebyshev_t chebyshev_u checkdiv check_overlaps chinese cholesky christof chromatic_index chromatic_number cint circulant_graph clear_edge_weight clear_rules clear_vertex_label clebsch_gordan clebsch_graph clessp clesspignore close closefile cmetric coeff coefmatrix cograd col collapse collectterms columnop columnspace columnswap columnvector combination combine comp2pui compare compfile compile compile_file complement_graph complete_bipartite_graph complete_graph complex_number_p components compose_functions concan concat conjugate conmetderiv connected_components connect_vertices cons constant constantp constituent constvalue cont2part content continuous_freq contortion contour_plot contract contract_edge contragrad contrib_ode convert coord copy copy_file copy_graph copylist copymatrix cor cos cosh cot coth cov cov1 covdiff covect covers crc24sum create_graph create_list csc csch csetup cspline ctaylor ct_coordsys ctransform ctranspose cube_graph cuboctahedron_graph cunlisp cv cycle_digraph cycle_graph cylindrical days360 dblint deactivate declare declare_constvalue declare_dimensions declare_fundamental_dimensions declare_fundamental_units declare_qty declare_translated declare_unit_conversion declare_units declare_weights decsym defcon define define_alt_display define_variable defint defmatch defrule defstruct deftaylor degree_sequence del delete deleten delta demo demoivre denom depends derivdegree derivlist describe desolve determinant dfloat dgauss_a dgauss_b dgeev dgemm dgeqrf dgesv dgesvd diag diagmatrix diag_matrix diagmatrixp diameter diff digitcharp dimacs_export dimacs_import dimension dimensionless dimensions dimensions_as_list direct directory discrete_freq disjoin disjointp disolate disp dispcon dispform dispfun dispJordan display disprule dispterms distrib divide divisors divsum dkummer_m dkummer_u dlange dodecahedron_graph dotproduct dotsimp dpart draw draw2d draw3d drawdf draw_file draw_graph dscalar echelon edge_coloring edge_connectivity edges eigens_by_jacobi eigenvalues eigenvectors eighth einstein eivals eivects elapsed_real_time elapsed_run_time ele2comp ele2polynome ele2pui elem elementp elevation_grid elim elim_allbut eliminate eliminate_using ellipse elliptic_e elliptic_ec elliptic_eu elliptic_f elliptic_kc elliptic_pi ematrix empty_graph emptyp endcons entermatrix entertensor entier equal equalp equiv_classes erf erfc erf_generalized erfi errcatch error errormsg errors euler ev eval_string evenp every evolution evolution2d evundiff example exp expand expandwrt expandwrt_factored expint expintegral_chi expintegral_ci expintegral_e expintegral_e1 expintegral_ei expintegral_e_simplify expintegral_li expintegral_shi expintegral_si explicit explose exponentialize express expt exsec extdiff extract_linear_equations extremal_subset ezgcd %f f90 facsum factcomb factor factorfacsum factorial factorout factorsum facts fast_central_elements fast_linsolve fasttimes featurep fernfale fft fib fibtophi fifth filename_merge file_search file_type fillarray findde find_root find_root_abs find_root_error find_root_rel first fix flatten flength float floatnump floor flower_snark flush flush1deriv flushd flushnd flush_output fmin_cobyla forget fortran fourcos fourexpand fourier fourier_elim fourint fourintcos fourintsin foursimp foursin fourth fposition frame_bracket freeof freshline fresnel_c fresnel_s from_adjacency_matrix frucht_graph full_listify fullmap fullmapl fullratsimp fullratsubst fullsetify funcsolve fundamental_dimensions fundamental_units fundef funmake funp fv g0 g1 gamma gamma_greek gamma_incomplete gamma_incomplete_generalized gamma_incomplete_regularized gauss gauss_a gauss_b gaussprob gcd gcdex gcdivide gcfac gcfactor gd generalized_lambert_w genfact gen_laguerre genmatrix gensym geo_amortization geo_annuity_fv geo_annuity_pv geomap geometric geometric_mean geosum get getcurrentdirectory get_edge_weight getenv get_lu_factors get_output_stream_string get_pixel get_plot_option get_tex_environment get_tex_environment_default get_vertex_label gfactor gfactorsum ggf girth global_variances gn gnuplot_close gnuplot_replot gnuplot_reset gnuplot_restart gnuplot_start go Gosper GosperSum gr2d gr3d gradef gramschmidt graph6_decode graph6_encode graph6_export graph6_import graph_center graph_charpoly graph_eigenvalues graph_flow graph_order graph_periphery graph_product graph_size graph_union great_rhombicosidodecahedron_graph great_rhombicuboctahedron_graph grid_graph grind grobner_basis grotzch_graph hamilton_cycle hamilton_path hankel hankel_1 hankel_2 harmonic harmonic_mean hav heawood_graph hermite hessian hgfred hilbertmap hilbert_matrix hipow histogram histogram_description hodge horner hypergeometric i0 i1 %ibes ic1 ic2 ic_convert ichr1 ichr2 icosahedron_graph icosidodecahedron_graph icurvature ident identfor identity idiff idim idummy ieqn %if ifactors iframes ifs igcdex igeodesic_coords ilt image imagpart imetric implicit implicit_derivative implicit_plot indexed_tensor indices induced_subgraph inferencep inference_result infix info_display init_atensor init_ctensor in_neighbors innerproduct inpart inprod inrt integerp integer_partitions integrate intersect intersection intervalp intopois intosum invariant1 invariant2 inverse_fft inverse_jacobi_cd inverse_jacobi_cn inverse_jacobi_cs inverse_jacobi_dc inverse_jacobi_dn inverse_jacobi_ds inverse_jacobi_nc inverse_jacobi_nd inverse_jacobi_ns inverse_jacobi_sc inverse_jacobi_sd inverse_jacobi_sn invert invert_by_adjoint invert_by_lu inv_mod irr is is_biconnected is_bipartite is_connected is_digraph is_edge_in_graph is_graph is_graph_or_digraph ishow is_isomorphic isolate isomorphism is_planar isqrt isreal_p is_sconnected is_tree is_vertex_in_graph items_inference %j j0 j1 jacobi jacobian jacobi_cd jacobi_cn jacobi_cs jacobi_dc jacobi_dn jacobi_ds jacobi_nc jacobi_nd jacobi_ns jacobi_p jacobi_sc jacobi_sd jacobi_sn JF jn join jordan julia julia_set julia_sin %k kdels kdelta kill killcontext kostka kron_delta kronecker_product kummer_m kummer_u kurtosis kurtosis_bernoulli kurtosis_beta kurtosis_binomial kurtosis_chi2 kurtosis_continuous_uniform kurtosis_discrete_uniform kurtosis_exp kurtosis_f kurtosis_gamma kurtosis_general_finite_discrete kurtosis_geometric kurtosis_gumbel kurtosis_hypergeometric kurtosis_laplace kurtosis_logistic kurtosis_lognormal kurtosis_negative_binomial kurtosis_noncentral_chi2 kurtosis_noncentral_student_t kurtosis_normal kurtosis_pareto kurtosis_poisson kurtosis_rayleigh kurtosis_student_t kurtosis_weibull label labels lagrange laguerre lambda lambert_w laplace laplacian_matrix last lbfgs lc2kdt lcharp lc_l lcm lc_u ldefint ldisp ldisplay legendre_p legendre_q leinstein length let letrules letsimp levi_civita lfreeof lgtreillis lhs li liediff limit Lindstedt linear linearinterpol linear_program linear_regression line_graph linsolve listarray list_correlations listify list_matrix_entries list_nc_monomials listoftens listofvars listp lmax lmin load loadfile local locate_matrix_entry log logcontract log_gamma lopow lorentz_gauge lowercasep lpart lratsubst lreduce lriemann lsquares_estimates lsquares_estimates_approximate lsquares_estimates_exact lsquares_mse lsquares_residual_mse lsquares_residuals lsum ltreillis lu_backsub lucas lu_factor %m macroexpand macroexpand1 make_array makebox makefact makegamma make_graph make_level_picture makelist makeOrders make_poly_continent make_poly_country make_polygon make_random_state make_rgb_picture makeset make_string_input_stream make_string_output_stream make_transform mandelbrot mandelbrot_set map mapatom maplist matchdeclare matchfix mat_cond mat_fullunblocker mat_function mathml_display mat_norm matrix matrixmap matrixp matrix_size mattrace mat_trace mat_unblocker max max_clique max_degree max_flow maximize_lp max_independent_set max_matching maybe md5sum mean mean_bernoulli mean_beta mean_binomial mean_chi2 mean_continuous_uniform mean_deviation mean_discrete_uniform mean_exp mean_f mean_gamma mean_general_finite_discrete mean_geometric mean_gumbel mean_hypergeometric mean_laplace mean_logistic mean_lognormal mean_negative_binomial mean_noncentral_chi2 mean_noncentral_student_t mean_normal mean_pareto mean_poisson mean_rayleigh mean_student_t mean_weibull median median_deviation member mesh metricexpandall mgf1_sha1 min min_degree min_edge_cut minfactorial minimalPoly minimize_lp minimum_spanning_tree minor minpack_lsquares minpack_solve min_vertex_cover min_vertex_cut mkdir mnewton mod mode_declare mode_identity ModeMatrix moebius mon2schur mono monomial_dimensions multibernstein_poly multi_display_for_texinfo multi_elem multinomial multinomial_coeff multi_orbit multiplot_mode multi_pui multsym multthru mycielski_graph nary natural_unit nc_degree ncexpt ncharpoly negative_picture neighbors new newcontext newdet new_graph newline newton new_variable next_prime nicedummies niceindices ninth nofix nonarray noncentral_moment nonmetricity nonnegintegerp nonscalarp nonzeroandfreeof notequal nounify nptetrad npv nroots nterms ntermst nthroot nullity nullspace num numbered_boundaries numberp number_to_octets num_distinct_partitions numerval numfactor num_partitions nusum nzeta nzetai nzetar octets_to_number octets_to_oid odd_girth oddp ode2 ode_check odelin oid_to_octets op opena opena_binary openr openr_binary openw openw_binary operatorp opsubst optimize %or orbit orbits ordergreat ordergreatp orderless orderlessp orthogonal_complement orthopoly_recur orthopoly_weight outermap out_neighbors outofpois pade parabolic_cylinder_d parametric parametric_surface parg parGosper parse_string parse_timedate part part2cont partfrac partition partition_set partpol path_digraph path_graph pathname_directory pathname_name pathname_type pdf_bernoulli pdf_beta pdf_binomial pdf_cauchy pdf_chi2 pdf_continuous_uniform pdf_discrete_uniform pdf_exp pdf_f pdf_gamma pdf_general_finite_discrete pdf_geometric pdf_gumbel pdf_hypergeometric pdf_laplace pdf_logistic pdf_lognormal pdf_negative_binomial pdf_noncentral_chi2 pdf_noncentral_student_t pdf_normal pdf_pareto pdf_poisson pdf_rank_sum pdf_rayleigh pdf_signed_rank pdf_student_t pdf_weibull pearson_skewness permanent permut permutation permutations petersen_graph petrov pickapart picture_equalp picturep piechart piechart_description planar_embedding playback plog plot2d plot3d plotdf ploteq plsquares pochhammer points poisdiff poisexpt poisint poismap poisplus poissimp poissubst poistimes poistrim polar polarform polartorect polar_to_xy poly_add poly_buchberger poly_buchberger_criterion poly_colon_ideal poly_content polydecomp poly_depends_p poly_elimination_ideal poly_exact_divide poly_expand poly_expt poly_gcd polygon poly_grobner poly_grobner_equal poly_grobner_member poly_grobner_subsetp poly_ideal_intersection poly_ideal_polysaturation poly_ideal_polysaturation1 poly_ideal_saturation poly_ideal_saturation1 poly_lcm poly_minimization polymod poly_multiply polynome2ele polynomialp poly_normal_form poly_normalize poly_normalize_list poly_polysaturation_extension poly_primitive_part poly_pseudo_divide poly_reduced_grobner poly_reduction poly_saturation_extension poly_s_polynomial poly_subtract polytocompanion pop postfix potential power_mod powerseries powerset prefix prev_prime primep primes principal_components print printf printfile print_graph printpois printprops prodrac product properties propvars psi psubst ptriangularize pui pui2comp pui2ele pui2polynome pui_direct puireduc push put pv qput qrange qty quad_control quad_qag quad_qagi quad_qagp quad_qags quad_qawc quad_qawf quad_qawo quad_qaws quadrilateral quantile quantile_bernoulli quantile_beta quantile_binomial quantile_cauchy quantile_chi2 quantile_continuous_uniform quantile_discrete_uniform quantile_exp quantile_f quantile_gamma quantile_general_finite_discrete quantile_geometric quantile_gumbel quantile_hypergeometric quantile_laplace quantile_logistic quantile_lognormal quantile_negative_binomial quantile_noncentral_chi2 quantile_noncentral_student_t quantile_normal quantile_pareto quantile_poisson quantile_rayleigh quantile_student_t quantile_weibull quartile_skewness quit qunit quotient racah_v racah_w radcan radius random random_bernoulli random_beta random_binomial random_bipartite_graph random_cauchy random_chi2 random_continuous_uniform random_digraph random_discrete_uniform random_exp random_f random_gamma random_general_finite_discrete random_geometric random_graph random_graph1 random_gumbel random_hypergeometric random_laplace random_logistic random_lognormal random_negative_binomial random_network random_noncentral_chi2 random_noncentral_student_t random_normal random_pareto random_permutation random_poisson random_rayleigh random_regular_graph random_student_t random_tournament random_tree random_weibull range rank rat ratcoef ratdenom ratdiff ratdisrep ratexpand ratinterpol rational rationalize ratnumer ratnump ratp ratsimp ratsubst ratvars ratweight read read_array read_binary_array read_binary_list read_binary_matrix readbyte readchar read_hashed_array readline read_list read_matrix read_nested_list readonly read_xpm real_imagpart_to_conjugate realpart realroots rearray rectangle rectform rectform_log_if_constant recttopolar rediff reduce_consts reduce_order region region_boundaries region_boundaries_plus rem remainder remarray rembox remcomps remcon remcoord remfun remfunction remlet remove remove_constvalue remove_dimensions remove_edge remove_fundamental_dimensions remove_fundamental_units remove_plot_option remove_vertex rempart remrule remsym remvalue rename rename_file reset reset_displays residue resolvante resolvante_alternee1 resolvante_bipartite resolvante_diedrale resolvante_klein resolvante_klein3 resolvante_produit_sym resolvante_unitaire resolvante_vierer rest resultant return reveal reverse revert revert2 rgb2level rhs ricci riemann rinvariant risch rk rmdir rncombine romberg room rootscontract round row rowop rowswap rreduce run_testsuite %s save saving scalarp scaled_bessel_i scaled_bessel_i0 scaled_bessel_i1 scalefactors scanmap scatterplot scatterplot_description scene schur2comp sconcat scopy scsimp scurvature sdowncase sec sech second sequal sequalignore set_alt_display setdifference set_draw_defaults set_edge_weight setelmx setequalp setify setp set_partitions set_plot_option set_prompt set_random_state set_tex_environment set_tex_environment_default setunits setup_autoload set_up_dot_simplifications set_vertex_label seventh sexplode sf sha1sum sha256sum shortest_path shortest_weighted_path show showcomps showratvars sierpinskiale sierpinskimap sign signum similaritytransform simp_inequality simplify_sum simplode simpmetderiv simtran sin sinh sinsert sinvertcase sixth skewness skewness_bernoulli skewness_beta skewness_binomial skewness_chi2 skewness_continuous_uniform skewness_discrete_uniform skewness_exp skewness_f skewness_gamma skewness_general_finite_discrete skewness_geometric skewness_gumbel skewness_hypergeometric skewness_laplace skewness_logistic skewness_lognormal skewness_negative_binomial skewness_noncentral_chi2 skewness_noncentral_student_t skewness_normal skewness_pareto skewness_poisson skewness_rayleigh skewness_student_t skewness_weibull slength smake small_rhombicosidodecahedron_graph small_rhombicuboctahedron_graph smax smin smismatch snowmap snub_cube_graph snub_dodecahedron_graph solve solve_rec solve_rec_rat some somrac sort sparse6_decode sparse6_encode sparse6_export sparse6_import specint spherical spherical_bessel_j spherical_bessel_y spherical_hankel1 spherical_hankel2 spherical_harmonic spherical_to_xyz splice split sposition sprint sqfr sqrt sqrtdenest sremove sremovefirst sreverse ssearch ssort sstatus ssubst ssubstfirst staircase standardize standardize_inverse_trig starplot starplot_description status std std1 std_bernoulli std_beta std_binomial std_chi2 std_continuous_uniform std_discrete_uniform std_exp std_f std_gamma std_general_finite_discrete std_geometric std_gumbel std_hypergeometric std_laplace std_logistic std_lognormal std_negative_binomial std_noncentral_chi2 std_noncentral_student_t std_normal std_pareto std_poisson std_rayleigh std_student_t std_weibull stemplot stirling stirling1 stirling2 strim striml strimr string stringout stringp strong_components struve_h struve_l sublis sublist sublist_indices submatrix subsample subset subsetp subst substinpart subst_parallel substpart substring subvar subvarp sum sumcontract summand_to_rec supcase supcontext symbolp symmdifference symmetricp system take_channel take_inference tan tanh taylor taylorinfo taylorp taylor_simplifier taytorat tcl_output tcontract tellrat tellsimp tellsimpafter tentex tenth test_mean test_means_difference test_normality test_proportion test_proportions_difference test_rank_sum test_sign test_signed_rank test_variance test_variance_ratio tex tex1 tex_display texput %th third throw time timedate timer timer_info tldefint tlimit todd_coxeter toeplitz tokens to_lisp topological_sort to_poly to_poly_solve totaldisrep totalfourier totient tpartpol trace tracematrix trace_options transform_sample translate translate_file transpose treefale tree_reduce treillis treinat triangle triangularize trigexpand trigrat trigreduce trigsimp trunc truncate truncated_cube_graph truncated_dodecahedron_graph truncated_icosahedron_graph truncated_tetrahedron_graph tr_warnings_get tube tutte_graph ueivects uforget ultraspherical underlying_graph undiff union unique uniteigenvectors unitp units unit_step unitvector unorder unsum untellrat untimer untrace uppercasep uricci uriemann uvect vandermonde_matrix var var1 var_bernoulli var_beta var_binomial var_chi2 var_continuous_uniform var_discrete_uniform var_exp var_f var_gamma var_general_finite_discrete var_geometric var_gumbel var_hypergeometric var_laplace var_logistic var_lognormal var_negative_binomial var_noncentral_chi2 var_noncentral_student_t var_normal var_pareto var_poisson var_rayleigh var_student_t var_weibull vector vectorpotential vectorsimp verbify vers vertex_coloring vertex_connectivity vertex_degree vertex_distance vertex_eccentricity vertex_in_degree vertex_out_degree vertices vertices_to_cycle vertices_to_path %w weyl wheel_graph wiener_index wigner_3j wigner_6j wigner_9j with_stdout write_binary_data writebyte write_data writefile wronskian xreduce xthru %y Zeilberger zeroequiv zerofor zeromatrix zeromatrixp zeta zgeev zheev zlange zn_add_table zn_carmichael_lambda zn_characteristic_factors zn_determinant zn_factor_generators zn_invert_by_lu zn_log zn_mult_table absboxchar activecontexts adapt_depth additive adim aform algebraic algepsilon algexact aliases allbut all_dotsimp_denoms allocation allsym alphabetic animation antisymmetric arrays askexp assume_pos assume_pos_pred assumescalar asymbol atomgrad atrig1 axes axis_3d axis_bottom axis_left axis_right axis_top azimuth background background_color backsubst berlefact bernstein_explicit besselexpand beta_args_sum_to_integer beta_expand bftorat bftrunc bindtest border boundaries_array box boxchar breakup %c capping cauchysum cbrange cbtics center cflength cframe_flag cnonmet_flag color color_bar color_bar_tics colorbox columns commutative complex cone context contexts contour contour_levels cosnpiflag ctaypov ctaypt ctayswitch ctayvar ct_coords ctorsion_flag ctrgsimp cube current_let_rule_package cylinder data_file_name debugmode decreasing default_let_rule_package delay dependencies derivabbrev derivsubst detout diagmetric diff dim dimensions dispflag display2d|10 display_format_internal distribute_over doallmxops domain domxexpt domxmxops domxnctimes dontfactor doscmxops doscmxplus dot0nscsimp dot0simp dot1simp dotassoc dotconstrules dotdistrib dotexptsimp dotident dotscrules draw_graph_program draw_realpart edge_color edge_coloring edge_partition edge_type edge_width %edispflag elevation %emode endphi endtheta engineering_format_floats enhanced3d %enumer epsilon_lp erfflag erf_representation errormsg error_size error_syms error_type %e_to_numlog eval even evenfun evflag evfun ev_point expandwrt_denom expintexpand expintrep expon expop exptdispflag exptisolate exptsubst facexpand facsum_combine factlim factorflag factorial_expand factors_only fb feature features file_name file_output_append file_search_demo file_search_lisp file_search_maxima|10 file_search_tests file_search_usage file_type_lisp file_type_maxima|10 fill_color fill_density filled_func fixed_vertices flipflag float2bf font font_size fortindent fortspaces fpprec fpprintprec functions gamma_expand gammalim gdet genindex gensumnum GGFCFMAX GGFINFINITY globalsolve gnuplot_command gnuplot_curve_styles gnuplot_curve_titles gnuplot_default_term_command gnuplot_dumb_term_command gnuplot_file_args gnuplot_file_name gnuplot_out_file gnuplot_pdf_term_command gnuplot_pm3d gnuplot_png_term_command gnuplot_postamble gnuplot_preamble gnuplot_ps_term_command gnuplot_svg_term_command gnuplot_term gnuplot_view_args Gosper_in_Zeilberger gradefs grid grid2d grind halfangles head_angle head_both head_length head_type height hypergeometric_representation %iargs ibase icc1 icc2 icounter idummyx ieqnprint ifb ifc1 ifc2 ifg ifgi ifr iframe_bracket_form ifri igeowedge_flag ikt1 ikt2 imaginary inchar increasing infeval infinity inflag infolists inm inmc1 inmc2 intanalysis integer integervalued integrate_use_rootsof integration_constant integration_constant_counter interpolate_color intfaclim ip_grid ip_grid_in irrational isolate_wrt_times iterations itr julia_parameter %k1 %k2 keepfloat key key_pos kinvariant kt label label_alignment label_orientation labels lassociative lbfgs_ncorrections lbfgs_nfeval_max leftjust legend letrat let_rule_packages lfg lg lhospitallim limsubst linear linear_solver linechar linel|10 linenum line_type linewidth line_width linsolve_params linsolvewarn lispdisp listarith listconstvars listdummyvars lmxchar load_pathname loadprint logabs logarc logcb logconcoeffp logexpand lognegint logsimp logx logx_secondary logy logy_secondary logz lriem m1pbranch macroexpansion macros mainvar manual_demo maperror mapprint matrix_element_add matrix_element_mult matrix_element_transpose maxapplydepth maxapplyheight maxima_tempdir|10 maxima_userdir|10 maxnegex MAX_ORD maxposex maxpsifracdenom maxpsifracnum maxpsinegint maxpsiposint maxtayorder mesh_lines_color method mod_big_prime mode_check_errorp mode_checkp mode_check_warnp mod_test mod_threshold modular_linear_solver modulus multiplicative multiplicities myoptions nary negdistrib negsumdispflag newline newtonepsilon newtonmaxiter nextlayerfactor niceindicespref nm nmc noeval nolabels nonegative_lp noninteger nonscalar noun noundisp nouns np npi nticks ntrig numer numer_pbranch obase odd oddfun opacity opproperties opsubst optimprefix optionset orientation origin orthopoly_returns_intervals outative outchar packagefile palette partswitch pdf_file pfeformat phiresolution %piargs piece pivot_count_sx pivot_max_sx plot_format plot_options plot_realpart png_file pochhammer_max_index points pointsize point_size points_joined point_type poislim poisson poly_coefficient_ring poly_elimination_order polyfactor poly_grobner_algorithm poly_grobner_debug poly_monomial_order poly_primary_elimination_order poly_return_term_list poly_secondary_elimination_order poly_top_reduction_only posfun position powerdisp pred prederror primep_number_of_tests product_use_gamma program programmode promote_float_to_bigfloat prompt proportional_axes props psexpand ps_file radexpand radius radsubstflag rassociative ratalgdenom ratchristof ratdenomdivide rateinstein ratepsilon ratfac rational ratmx ratprint ratriemann ratsimpexpons ratvarswitch ratweights ratweyl ratwtlvl real realonly redraw refcheck resolution restart resultant ric riem rmxchar %rnum_list rombergabs rombergit rombergmin rombergtol rootsconmode rootsepsilon run_viewer same_xy same_xyz savedef savefactors scalar scalarmatrixp scale scale_lp setcheck setcheckbreak setval show_edge_color show_edges show_edge_type show_edge_width show_id show_label showtime show_vertex_color show_vertex_size show_vertex_type show_vertices show_weight simp simplified_output simplify_products simpproduct simpsum sinnpiflag solvedecomposes solveexplicit solvefactors solvenullwarn solveradcan solvetrigwarn space sparse sphere spring_embedding_depth sqrtdispflag stardisp startphi starttheta stats_numer stringdisp structures style sublis_apply_lambda subnumsimp sumexpand sumsplitfact surface surface_hide svg_file symmetric tab taylordepth taylor_logexpand taylor_order_coefficients taylor_truncate_polynomials tensorkill terminal testsuite_files thetaresolution timer_devalue title tlimswitch tr track transcompile transform transform_xy translate_fast_arrays transparent transrun tr_array_as_ref tr_bound_function_applyp tr_file_tty_messagesp tr_float_can_branch_complex tr_function_call_default trigexpandplus trigexpandtimes triginverses trigsign trivial_solutions tr_numer tr_optimize_max_loop tr_semicompile tr_state_vars tr_warn_bad_function_calls tr_warn_fexpr tr_warn_meval tr_warn_mode tr_warn_undeclared tr_warn_undefined_variable tstep ttyoff tube_extremes ufg ug %unitexpand unit_vectors uric uriem use_fast_arrays user_preamble usersetunits values vect_cross verbose vertex_color vertex_coloring vertex_partition vertex_size vertex_type view warnings weyl width windowname windowtitle wired_surface wireframe xaxis xaxis_color xaxis_secondary xaxis_type xaxis_width xlabel xlabel_secondary xlength xrange xrange_secondary xtics xtics_axis xtics_rotate xtics_rotate_secondary xtics_secondary xtics_secondary_axis xu_grid x_voxel xy_file xyplane xy_scale yaxis yaxis_color yaxis_secondary yaxis_type yaxis_width ylabel ylabel_secondary ylength yrange yrange_secondary ytics ytics_axis ytics_rotate ytics_rotate_secondary ytics_secondary ytics_secondary_axis yv_grid y_voxel yx_ratio zaxis zaxis_color zaxis_type zaxis_width zeroa zerob zerobern zeta%pi zlabel zlabel_rotate zlength zmin zn_primroot_limit zn_primroot_pretest",
      symbol: "_ __ %|0 %%|0"
    },
    contains: [
      {
        className: "comment",
        begin: "/\\*",
        end: "\\*/",
        contains: ["self"]
      },
      t.QUOTE_STRING_MODE,
      {
        className: "number",
        relevance: 0,
        variants: [
          {
            // float number w/ exponent
            // hmm, I wonder if we ought to include other exponent markers?
            begin: "\\b(\\d+|\\d+\\.|\\.\\d+|\\d+\\.\\d+)[Ee][-+]?\\d+\\b"
          },
          {
            // bigfloat number
            begin: "\\b(\\d+|\\d+\\.|\\.\\d+|\\d+\\.\\d+)[Bb][-+]?\\d+\\b",
            relevance: 10
          },
          {
            // float number w/out exponent
            // Doesn't seem to recognize floats which start with '.'
            begin: "\\b(\\.\\d+|\\d+\\.\\d+)\\b"
          },
          {
            // integer in base up to 36
            // Doesn't seem to recognize integers which end with '.'
            begin: "\\b(\\d+|0[0-9A-Za-z]+)\\.?\\b"
          }
        ]
      }
    ],
    illegal: /@/
  };
}
function cg(t) {
  return {
    name: "MEL",
    keywords: "int float string vector matrix if else switch case default while do for in break continue global proc return about abs addAttr addAttributeEditorNodeHelp addDynamic addNewShelfTab addPP addPanelCategory addPrefixToName advanceToNextDrivenKey affectedNet affects aimConstraint air alias aliasAttr align alignCtx alignCurve alignSurface allViewFit ambientLight angle angleBetween animCone animCurveEditor animDisplay animView annotate appendStringArray applicationName applyAttrPreset applyTake arcLenDimContext arcLengthDimension arclen arrayMapper art3dPaintCtx artAttrCtx artAttrPaintVertexCtx artAttrSkinPaintCtx artAttrTool artBuildPaintMenu artFluidAttrCtx artPuttyCtx artSelectCtx artSetPaintCtx artUserPaintCtx assignCommand assignInputDevice assignViewportFactories attachCurve attachDeviceAttr attachSurface attrColorSliderGrp attrCompatibility attrControlGrp attrEnumOptionMenu attrEnumOptionMenuGrp attrFieldGrp attrFieldSliderGrp attrNavigationControlGrp attrPresetEditWin attributeExists attributeInfo attributeMenu attributeQuery autoKeyframe autoPlace bakeClip bakeFluidShading bakePartialHistory bakeResults bakeSimulation basename basenameEx batchRender bessel bevel bevelPlus binMembership bindSkin blend2 blendShape blendShapeEditor blendShapePanel blendTwoAttr blindDataType boneLattice boundary boxDollyCtx boxZoomCtx bufferCurve buildBookmarkMenu buildKeyframeMenu button buttonManip CBG cacheFile cacheFileCombine cacheFileMerge cacheFileTrack camera cameraView canCreateManip canvas capitalizeString catch catchQuiet ceil changeSubdivComponentDisplayLevel changeSubdivRegion channelBox character characterMap characterOutlineEditor characterize chdir checkBox checkBoxGrp checkDefaultRenderGlobals choice circle circularFillet clamp clear clearCache clip clipEditor clipEditorCurrentTimeCtx clipSchedule clipSchedulerOutliner clipTrimBefore closeCurve closeSurface cluster cmdFileOutput cmdScrollFieldExecuter cmdScrollFieldReporter cmdShell coarsenSubdivSelectionList collision color colorAtPoint colorEditor colorIndex colorIndexSliderGrp colorSliderButtonGrp colorSliderGrp columnLayout commandEcho commandLine commandPort compactHairSystem componentEditor compositingInterop computePolysetVolume condition cone confirmDialog connectAttr connectControl connectDynamic connectJoint connectionInfo constrain constrainValue constructionHistory container containsMultibyte contextInfo control convertFromOldLayers convertIffToPsd convertLightmap convertSolidTx convertTessellation convertUnit copyArray copyFlexor copyKey copySkinWeights cos cpButton cpCache cpClothSet cpCollision cpConstraint cpConvClothToMesh cpForces cpGetSolverAttr cpPanel cpProperty cpRigidCollisionFilter cpSeam cpSetEdit cpSetSolverAttr cpSolver cpSolverTypes cpTool cpUpdateClothUVs createDisplayLayer createDrawCtx createEditor createLayeredPsdFile createMotionField createNewShelf createNode createRenderLayer createSubdivRegion cross crossProduct ctxAbort ctxCompletion ctxEditMode ctxTraverse currentCtx currentTime currentTimeCtx currentUnit curve curveAddPtCtx curveCVCtx curveEPCtx curveEditorCtx curveIntersect curveMoveEPCtx curveOnSurface curveSketchCtx cutKey cycleCheck cylinder dagPose date defaultLightListCheckBox defaultNavigation defineDataServer defineVirtualDevice deformer deg_to_rad delete deleteAttr deleteShadingGroupsAndMaterials deleteShelfTab deleteUI deleteUnusedBrushes delrandstr detachCurve detachDeviceAttr detachSurface deviceEditor devicePanel dgInfo dgdirty dgeval dgtimer dimWhen directKeyCtx directionalLight dirmap dirname disable disconnectAttr disconnectJoint diskCache displacementToPoly displayAffected displayColor displayCull displayLevelOfDetail displayPref displayRGBColor displaySmoothness displayStats displayString displaySurface distanceDimContext distanceDimension doBlur dolly dollyCtx dopeSheetEditor dot dotProduct doubleProfileBirailSurface drag dragAttrContext draggerContext dropoffLocator duplicate duplicateCurve duplicateSurface dynCache dynControl dynExport dynExpression dynGlobals dynPaintEditor dynParticleCtx dynPref dynRelEdPanel dynRelEditor dynamicLoad editAttrLimits editDisplayLayerGlobals editDisplayLayerMembers editRenderLayerAdjustment editRenderLayerGlobals editRenderLayerMembers editor editorTemplate effector emit emitter enableDevice encodeString endString endsWith env equivalent equivalentTol erf error eval evalDeferred evalEcho event exactWorldBoundingBox exclusiveLightCheckBox exec executeForEachObject exists exp expression expressionEditorListen extendCurve extendSurface extrude fcheck fclose feof fflush fgetline fgetword file fileBrowserDialog fileDialog fileExtension fileInfo filetest filletCurve filter filterCurve filterExpand filterStudioImport findAllIntersections findAnimCurves findKeyframe findMenuItem findRelatedSkinCluster finder firstParentOf fitBspline flexor floatEq floatField floatFieldGrp floatScrollBar floatSlider floatSlider2 floatSliderButtonGrp floatSliderGrp floor flow fluidCacheInfo fluidEmitter fluidVoxelInfo flushUndo fmod fontDialog fopen formLayout format fprint frameLayout fread freeFormFillet frewind fromNativePath fwrite gamma gauss geometryConstraint getApplicationVersionAsFloat getAttr getClassification getDefaultBrush getFileList getFluidAttr getInputDeviceRange getMayaPanelTypes getModifiers getPanel getParticleAttr getPluginResource getenv getpid glRender glRenderEditor globalStitch gmatch goal gotoBindPose grabColor gradientControl gradientControlNoAttr graphDollyCtx graphSelectContext graphTrackCtx gravity grid gridLayout group groupObjectsByName HfAddAttractorToAS HfAssignAS HfBuildEqualMap HfBuildFurFiles HfBuildFurImages HfCancelAFR HfConnectASToHF HfCreateAttractor HfDeleteAS HfEditAS HfPerformCreateAS HfRemoveAttractorFromAS HfSelectAttached HfSelectAttractors HfUnAssignAS hardenPointCurve hardware hardwareRenderPanel headsUpDisplay headsUpMessage help helpLine hermite hide hilite hitTest hotBox hotkey hotkeyCheck hsv_to_rgb hudButton hudSlider hudSliderButton hwReflectionMap hwRender hwRenderLoad hyperGraph hyperPanel hyperShade hypot iconTextButton iconTextCheckBox iconTextRadioButton iconTextRadioCollection iconTextScrollList iconTextStaticLabel ikHandle ikHandleCtx ikHandleDisplayScale ikSolver ikSplineHandleCtx ikSystem ikSystemInfo ikfkDisplayMethod illustratorCurves image imfPlugins inheritTransform insertJoint insertJointCtx insertKeyCtx insertKnotCurve insertKnotSurface instance instanceable instancer intField intFieldGrp intScrollBar intSlider intSliderGrp interToUI internalVar intersect iprEngine isAnimCurve isConnected isDirty isParentOf isSameObject isTrue isValidObjectName isValidString isValidUiName isolateSelect itemFilter itemFilterAttr itemFilterRender itemFilterType joint jointCluster jointCtx jointDisplayScale jointLattice keyTangent keyframe keyframeOutliner keyframeRegionCurrentTimeCtx keyframeRegionDirectKeyCtx keyframeRegionDollyCtx keyframeRegionInsertKeyCtx keyframeRegionMoveKeyCtx keyframeRegionScaleKeyCtx keyframeRegionSelectKeyCtx keyframeRegionSetKeyCtx keyframeRegionTrackCtx keyframeStats lassoContext lattice latticeDeformKeyCtx launch launchImageEditor layerButton layeredShaderPort layeredTexturePort layout layoutDialog lightList lightListEditor lightListPanel lightlink lineIntersection linearPrecision linstep listAnimatable listAttr listCameras listConnections listDeviceAttachments listHistory listInputDeviceAxes listInputDeviceButtons listInputDevices listMenuAnnotation listNodeTypes listPanelCategories listRelatives listSets listTransforms listUnselected listerEditor loadFluid loadNewShelf loadPlugin loadPluginLanguageResources loadPrefObjects localizedPanelLabel lockNode loft log longNameOf lookThru ls lsThroughFilter lsType lsUI Mayatomr mag makeIdentity makeLive makePaintable makeRoll makeSingleSurface makeTubeOn makebot manipMoveContext manipMoveLimitsCtx manipOptions manipRotateContext manipRotateLimitsCtx manipScaleContext manipScaleLimitsCtx marker match max memory menu menuBarLayout menuEditor menuItem menuItemToShelf menuSet menuSetPref messageLine min minimizeApp mirrorJoint modelCurrentTimeCtx modelEditor modelPanel mouse movIn movOut move moveIKtoFK moveKeyCtx moveVertexAlongDirection multiProfileBirailSurface mute nParticle nameCommand nameField namespace namespaceInfo newPanelItems newton nodeCast nodeIconButton nodeOutliner nodePreset nodeType noise nonLinear normalConstraint normalize nurbsBoolean nurbsCopyUVSet nurbsCube nurbsEditUV nurbsPlane nurbsSelect nurbsSquare nurbsToPoly nurbsToPolygonsPref nurbsToSubdiv nurbsToSubdivPref nurbsUVSet nurbsViewDirectionVector objExists objectCenter objectLayer objectType objectTypeUI obsoleteProc oceanNurbsPreviewPlane offsetCurve offsetCurveOnSurface offsetSurface openGLExtension openMayaPref optionMenu optionMenuGrp optionVar orbit orbitCtx orientConstraint outlinerEditor outlinerPanel overrideModifier paintEffectsDisplay pairBlend palettePort paneLayout panel panelConfiguration panelHistory paramDimContext paramDimension paramLocator parent parentConstraint particle particleExists particleInstancer particleRenderInfo partition pasteKey pathAnimation pause pclose percent performanceOptions pfxstrokes pickWalk picture pixelMove planarSrf plane play playbackOptions playblast plugAttr plugNode pluginInfo pluginResourceUtil pointConstraint pointCurveConstraint pointLight pointMatrixMult pointOnCurve pointOnSurface pointPosition poleVectorConstraint polyAppend polyAppendFacetCtx polyAppendVertex polyAutoProjection polyAverageNormal polyAverageVertex polyBevel polyBlendColor polyBlindData polyBoolOp polyBridgeEdge polyCacheMonitor polyCheck polyChipOff polyClipboard polyCloseBorder polyCollapseEdge polyCollapseFacet polyColorBlindData polyColorDel polyColorPerVertex polyColorSet polyCompare polyCone polyCopyUV polyCrease polyCreaseCtx polyCreateFacet polyCreateFacetCtx polyCube polyCut polyCutCtx polyCylinder polyCylindricalProjection polyDelEdge polyDelFacet polyDelVertex polyDuplicateAndConnect polyDuplicateEdge polyEditUV polyEditUVShell polyEvaluate polyExtrudeEdge polyExtrudeFacet polyExtrudeVertex polyFlipEdge polyFlipUV polyForceUV polyGeoSampler polyHelix polyInfo polyInstallAction polyLayoutUV polyListComponentConversion polyMapCut polyMapDel polyMapSew polyMapSewMove polyMergeEdge polyMergeEdgeCtx polyMergeFacet polyMergeFacetCtx polyMergeUV polyMergeVertex polyMirrorFace polyMoveEdge polyMoveFacet polyMoveFacetUV polyMoveUV polyMoveVertex polyNormal polyNormalPerVertex polyNormalizeUV polyOptUvs polyOptions polyOutput polyPipe polyPlanarProjection polyPlane polyPlatonicSolid polyPoke polyPrimitive polyPrism polyProjection polyPyramid polyQuad polyQueryBlindData polyReduce polySelect polySelectConstraint polySelectConstraintMonitor polySelectCtx polySelectEditCtx polySeparate polySetToFaceNormal polySewEdge polyShortestPathCtx polySmooth polySoftEdge polySphere polySphericalProjection polySplit polySplitCtx polySplitEdge polySplitRing polySplitVertex polyStraightenUVBorder polySubdivideEdge polySubdivideFacet polyToSubdiv polyTorus polyTransfer polyTriangulate polyUVSet polyUnite polyWedgeFace popen popupMenu pose pow preloadRefEd print progressBar progressWindow projFileViewer projectCurve projectTangent projectionContext projectionManip promptDialog propModCtx propMove psdChannelOutliner psdEditTextureFile psdExport psdTextureFile putenv pwd python querySubdiv quit rad_to_deg radial radioButton radioButtonGrp radioCollection radioMenuItemCollection rampColorPort rand randomizeFollicles randstate rangeControl readTake rebuildCurve rebuildSurface recordAttr recordDevice redo reference referenceEdit referenceQuery refineSubdivSelectionList refresh refreshAE registerPluginResource rehash reloadImage removeJoint removeMultiInstance removePanelCategory rename renameAttr renameSelectionList renameUI render renderGlobalsNode renderInfo renderLayerButton renderLayerParent renderLayerPostProcess renderLayerUnparent renderManip renderPartition renderQualityNode renderSettings renderThumbnailUpdate renderWindowEditor renderWindowSelectContext renderer reorder reorderDeformers requires reroot resampleFluid resetAE resetPfxToPolyCamera resetTool resolutionNode retarget reverseCurve reverseSurface revolve rgb_to_hsv rigidBody rigidSolver roll rollCtx rootOf rot rotate rotationInterpolation roundConstantRadius rowColumnLayout rowLayout runTimeCommand runup sampleImage saveAllShelves saveAttrPreset saveFluid saveImage saveInitialState saveMenu savePrefObjects savePrefs saveShelf saveToolSettings scale scaleBrushBrightness scaleComponents scaleConstraint scaleKey scaleKeyCtx sceneEditor sceneUIReplacement scmh scriptCtx scriptEditorInfo scriptJob scriptNode scriptTable scriptToShelf scriptedPanel scriptedPanelType scrollField scrollLayout sculpt searchPathArray seed selLoadSettings select selectContext selectCurveCV selectKey selectKeyCtx selectKeyframeRegionCtx selectMode selectPref selectPriority selectType selectedNodes selectionConnection separator setAttr setAttrEnumResource setAttrMapping setAttrNiceNameResource setConstraintRestPosition setDefaultShadingGroup setDrivenKeyframe setDynamic setEditCtx setEditor setFluidAttr setFocus setInfinity setInputDeviceMapping setKeyCtx setKeyPath setKeyframe setKeyframeBlendshapeTargetWts setMenuMode setNodeNiceNameResource setNodeTypeFlag setParent setParticleAttr setPfxToPolyCamera setPluginResource setProject setStampDensity setStartupMessage setState setToolTo setUITemplate setXformManip sets shadingConnection shadingGeometryRelCtx shadingLightRelCtx shadingNetworkCompare shadingNode shapeCompare shelfButton shelfLayout shelfTabLayout shellField shortNameOf showHelp showHidden showManipCtx showSelectionInTitle showShadingGroupAttrEditor showWindow sign simplify sin singleProfileBirailSurface size sizeBytes skinCluster skinPercent smoothCurve smoothTangentSurface smoothstep snap2to2 snapKey snapMode snapTogetherCtx snapshot soft softMod softModCtx sort sound soundControl source spaceLocator sphere sphrand spotLight spotLightPreviewPort spreadSheetEditor spring sqrt squareSurface srtContext stackTrace startString startsWith stitchAndExplodeShell stitchSurface stitchSurfacePoints strcmp stringArrayCatenate stringArrayContains stringArrayCount stringArrayInsertAtIndex stringArrayIntersector stringArrayRemove stringArrayRemoveAtIndex stringArrayRemoveDuplicates stringArrayRemoveExact stringArrayToString stringToStringArray strip stripPrefixFromName stroke subdAutoProjection subdCleanTopology subdCollapse subdDuplicateAndConnect subdEditUV subdListComponentConversion subdMapCut subdMapSewMove subdMatchTopology subdMirror subdToBlind subdToPoly subdTransferUVsToCache subdiv subdivCrease subdivDisplaySmoothness substitute substituteAllString substituteGeometry substring surface surfaceSampler surfaceShaderList swatchDisplayPort switchTable symbolButton symbolCheckBox sysFile system tabLayout tan tangentConstraint texLatticeDeformContext texManipContext texMoveContext texMoveUVShellContext texRotateContext texScaleContext texSelectContext texSelectShortestPathCtx texSmudgeUVContext texWinToolCtx text textCurves textField textFieldButtonGrp textFieldGrp textManip textScrollList textToShelf textureDisplacePlane textureHairColor texturePlacementContext textureWindow threadCount threePointArcCtx timeControl timePort timerX toNativePath toggle toggleAxis toggleWindowVisibility tokenize tokenizeList tolerance tolower toolButton toolCollection toolDropped toolHasOptions toolPropertyWindow torus toupper trace track trackCtx transferAttributes transformCompare transformLimits translator trim trunc truncateFluidCache truncateHairCache tumble tumbleCtx turbulence twoPointArcCtx uiRes uiTemplate unassignInputDevice undo undoInfo ungroup uniform unit unloadPlugin untangleUV untitledFileName untrim upAxis updateAE userCtx uvLink uvSnapshot validateShelfName vectorize view2dToolCtx viewCamera viewClipPlane viewFit viewHeadOn viewLookAt viewManip viewPlace viewSet visor volumeAxis vortex waitCursor warning webBrowser webBrowserPrefs whatIs window windowPref wire wireContext workspace wrinkle wrinkleContext writeTake xbmLangPathList xform",
    illegal: "</",
    contains: [
      t.C_NUMBER_MODE,
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE,
      {
        className: "string",
        begin: "`",
        end: "`",
        contains: [t.BACKSLASH_ESCAPE]
      },
      {
        // eats variables
        begin: /[$%@](\^\w\b|#\w+|[^\s\w{]|\{\w+\}|\w+)/
      },
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE
    ]
  };
}
function dg(t) {
  const e = {
    keyword: "module use_module import_module include_module end_module initialise mutable initialize finalize finalise interface implementation pred mode func type inst solver any_pred any_func is semidet det nondet multi erroneous failure cc_nondet cc_multi typeclass instance where pragma promise external trace atomic or_else require_complete_switch require_det require_semidet require_multi require_nondet require_cc_multi require_cc_nondet require_erroneous require_failure",
    meta: (
      // pragma
      "inline no_inline type_spec source_file fact_table obsolete memo loop_check minimal_model terminates does_not_terminate check_termination promise_equivalent_clauses foreign_proc foreign_decl foreign_code foreign_type foreign_import_module foreign_export_enum foreign_export foreign_enum may_call_mercury will_not_call_mercury thread_safe not_thread_safe maybe_thread_safe promise_pure promise_semipure tabled_for_io local untrailed trailed attach_to_io_state can_pass_as_mercury_type stable will_not_throw_exception may_modify_trail will_not_modify_trail may_duplicate may_not_duplicate affects_liveness does_not_affect_liveness doesnt_affect_liveness no_sharing unknown_sharing sharing"
    ),
    built_in: "some all not if then else true fail false try catch catch_any semidet_true semidet_false semidet_fail impure_true impure semipure"
  }, n = t.COMMENT("%", "$"), i = {
    className: "number",
    begin: "0'.\\|0[box][0-9a-fA-F]*"
  }, r = t.inherit(t.APOS_STRING_MODE, { relevance: 0 }), a = t.inherit(t.QUOTE_STRING_MODE, { relevance: 0 }), s = {
    className: "subst",
    begin: "\\\\[abfnrtv]\\|\\\\x[0-9a-fA-F]*\\\\\\|%[-+# *.0-9]*[dioxXucsfeEgGp]",
    relevance: 0
  };
  return a.contains = a.contains.slice(), a.contains.push(s), {
    name: "Mercury",
    aliases: [
      "m",
      "moo"
    ],
    keywords: e,
    contains: [
      {
        className: "built_in",
        variants: [
          { begin: "<=>" },
          {
            begin: "<=",
            relevance: 0
          },
          {
            begin: "=>",
            relevance: 0
          },
          { begin: "/\\\\" },
          { begin: "\\\\/" }
        ]
      },
      {
        className: "built_in",
        variants: [
          { begin: ":-\\|-->" },
          {
            begin: "=",
            relevance: 0
          }
        ]
      },
      n,
      t.C_BLOCK_COMMENT_MODE,
      i,
      t.NUMBER_MODE,
      r,
      a,
      {
        // relevance booster
        begin: /:-/
      },
      {
        // relevance booster
        begin: /\.$/
      }
    ]
  };
}
function ug(t) {
  return {
    name: "MIPS Assembly",
    case_insensitive: !0,
    aliases: ["mips"],
    keywords: {
      $pattern: "\\.?" + t.IDENT_RE,
      meta: (
        // GNU preprocs
        ".2byte .4byte .align .ascii .asciz .balign .byte .code .data .else .end .endif .endm .endr .equ .err .exitm .extern .global .hword .if .ifdef .ifndef .include .irp .long .macro .rept .req .section .set .skip .space .text .word .ltorg "
      ),
      built_in: "$0 $1 $2 $3 $4 $5 $6 $7 $8 $9 $10 $11 $12 $13 $14 $15 $16 $17 $18 $19 $20 $21 $22 $23 $24 $25 $26 $27 $28 $29 $30 $31 zero at v0 v1 a0 a1 a2 a3 a4 a5 a6 a7 t0 t1 t2 t3 t4 t5 t6 t7 t8 t9 s0 s1 s2 s3 s4 s5 s6 s7 s8 k0 k1 gp sp fp ra $f0 $f1 $f2 $f2 $f4 $f5 $f6 $f7 $f8 $f9 $f10 $f11 $f12 $f13 $f14 $f15 $f16 $f17 $f18 $f19 $f20 $f21 $f22 $f23 $f24 $f25 $f26 $f27 $f28 $f29 $f30 $f31 Context Random EntryLo0 EntryLo1 Context PageMask Wired EntryHi HWREna BadVAddr Count Compare SR IntCtl SRSCtl SRSMap Cause EPC PRId EBase Config Config1 Config2 Config3 LLAddr Debug DEPC DESAVE CacheErr ECC ErrorEPC TagLo DataLo TagHi DataHi WatchLo WatchHi PerfCtl PerfCnt "
      // Coprocessor 0 registers
    },
    contains: [
      {
        className: "keyword",
        begin: "\\b(addi?u?|andi?|b(al)?|beql?|bgez(al)?l?|bgtzl?|blezl?|bltz(al)?l?|bnel?|cl[oz]|divu?|ext|ins|j(al)?|jalr(\\.hb)?|jr(\\.hb)?|lbu?|lhu?|ll|lui|lw[lr]?|maddu?|mfhi|mflo|movn|movz|move|msubu?|mthi|mtlo|mul|multu?|nop|nor|ori?|rotrv?|sb|sc|se[bh]|sh|sllv?|slti?u?|srav?|srlv?|subu?|sw[lr]?|xori?|wsbh|abs\\.[sd]|add\\.[sd]|alnv.ps|bc1[ft]l?|c\\.(s?f|un|u?eq|[ou]lt|[ou]le|ngle?|seq|l[et]|ng[et])\\.[sd]|(ceil|floor|round|trunc)\\.[lw]\\.[sd]|cfc1|cvt\\.d\\.[lsw]|cvt\\.l\\.[dsw]|cvt\\.ps\\.s|cvt\\.s\\.[dlw]|cvt\\.s\\.p[lu]|cvt\\.w\\.[dls]|div\\.[ds]|ldx?c1|luxc1|lwx?c1|madd\\.[sd]|mfc1|mov[fntz]?\\.[ds]|msub\\.[sd]|mth?c1|mul\\.[ds]|neg\\.[ds]|nmadd\\.[ds]|nmsub\\.[ds]|p[lu][lu]\\.ps|recip\\.fmt|r?sqrt\\.[ds]|sdx?c1|sub\\.[ds]|suxc1|swx?c1|break|cache|d?eret|[de]i|ehb|mfc0|mtc0|pause|prefx?|rdhwr|rdpgpr|sdbbp|ssnop|synci?|syscall|teqi?|tgei?u?|tlb(p|r|w[ir])|tlti?u?|tnei?|wait|wrpgpr)",
        end: "\\s"
      },
      // lines ending with ; or # aren't really comments, probably auto-detect fail
      t.COMMENT("[;#](?!\\s*$)", "$"),
      t.C_BLOCK_COMMENT_MODE,
      t.QUOTE_STRING_MODE,
      {
        className: "string",
        begin: "'",
        end: "[^\\\\]'",
        relevance: 0
      },
      {
        className: "title",
        begin: "\\|",
        end: "\\|",
        illegal: "\\n",
        relevance: 0
      },
      {
        className: "number",
        variants: [
          {
            // hex
            begin: "0x[0-9a-f]+"
          },
          {
            // bare number
            begin: "\\b-?\\d+"
          }
        ],
        relevance: 0
      },
      {
        className: "symbol",
        variants: [
          {
            // GNU MIPS syntax
            begin: "^\\s*[a-z_\\.\\$][a-z0-9_\\.\\$]+:"
          },
          {
            // numbered local labels
            begin: "^\\s*[0-9]+:"
          },
          {
            // number local label reference (backwards, forwards)
            begin: "[0-9]+[bf]"
          }
        ],
        relevance: 0
      }
    ],
    // forward slashes are not allowed
    illegal: /\//
  };
}
function _g(t) {
  return {
    name: "Mizar",
    keywords: "environ vocabularies notations constructors definitions registrations theorems schemes requirements begin end definition registration cluster existence pred func defpred deffunc theorem proof let take assume then thus hence ex for st holds consider reconsider such that and in provided of as from be being by means equals implies iff redefine define now not or attr is mode suppose per cases set thesis contradiction scheme reserve struct correctness compatibility coherence symmetry assymetry reflexivity irreflexivity connectedness uniqueness commutativity idempotence involutiveness projectivity",
    contains: [t.COMMENT("::", "$")]
  };
}
function pg(t) {
  return {
    name: "Mojolicious",
    subLanguage: "xml",
    contains: [
      {
        className: "meta",
        begin: "^__(END|DATA)__$"
      },
      // mojolicious line
      {
        begin: "^\\s*%{1,2}={0,2}",
        end: "$",
        subLanguage: "perl"
      },
      // mojolicious block
      {
        begin: "<%{1,2}={0,2}",
        end: "={0,1}%>",
        subLanguage: "perl",
        excludeBegin: !0,
        excludeEnd: !0
      }
    ]
  };
}
function mg(t) {
  const e = {
    className: "number",
    relevance: 0,
    variants: [
      { begin: "[$][a-fA-F0-9]+" },
      t.NUMBER_MODE
    ]
  }, n = {
    variants: [
      { match: [
        /(function|method)/,
        /\s+/,
        t.UNDERSCORE_IDENT_RE
      ] }
    ],
    scope: {
      1: "keyword",
      3: "title.function"
    }
  }, i = {
    variants: [
      { match: [
        /(class|interface|extends|implements)/,
        /\s+/,
        t.UNDERSCORE_IDENT_RE
      ] }
    ],
    scope: {
      1: "keyword",
      3: "title.class"
    }
  };
  return {
    name: "Monkey",
    case_insensitive: !0,
    keywords: {
      keyword: [
        "public",
        "private",
        "property",
        "continue",
        "exit",
        "extern",
        "new",
        "try",
        "catch",
        "eachin",
        "not",
        "abstract",
        "final",
        "select",
        "case",
        "default",
        "const",
        "local",
        "global",
        "field",
        "end",
        "if",
        "then",
        "else",
        "elseif",
        "endif",
        "while",
        "wend",
        "repeat",
        "until",
        "forever",
        "for",
        "to",
        "step",
        "next",
        "return",
        "module",
        "inline",
        "throw",
        "import",
        // not positive, but these are not literals
        "and",
        "or",
        "shl",
        "shr",
        "mod"
      ],
      built_in: [
        "DebugLog",
        "DebugStop",
        "Error",
        "Print",
        "ACos",
        "ACosr",
        "ASin",
        "ASinr",
        "ATan",
        "ATan2",
        "ATan2r",
        "ATanr",
        "Abs",
        "Abs",
        "Ceil",
        "Clamp",
        "Clamp",
        "Cos",
        "Cosr",
        "Exp",
        "Floor",
        "Log",
        "Max",
        "Max",
        "Min",
        "Min",
        "Pow",
        "Sgn",
        "Sgn",
        "Sin",
        "Sinr",
        "Sqrt",
        "Tan",
        "Tanr",
        "Seed",
        "PI",
        "HALFPI",
        "TWOPI"
      ],
      literal: [
        "true",
        "false",
        "null"
      ]
    },
    illegal: /\/\*/,
    contains: [
      t.COMMENT("#rem", "#end"),
      t.COMMENT(
        "'",
        "$",
        { relevance: 0 }
      ),
      n,
      i,
      {
        className: "variable.language",
        begin: /\b(self|super)\b/
      },
      {
        className: "meta",
        begin: /\s*#/,
        end: "$",
        keywords: { keyword: "if else elseif endif end then" }
      },
      {
        match: [
          /^\s*/,
          /strict\b/
        ],
        scope: { 2: "meta" }
      },
      {
        beginKeywords: "alias",
        end: "=",
        contains: [t.UNDERSCORE_TITLE_MODE]
      },
      t.QUOTE_STRING_MODE,
      e
    ]
  };
}
function Eg(t) {
  const e = {
    keyword: (
      // Moonscript keywords
      "if then not for in while do return else elseif break continue switch and or unless when class extends super local import export from using"
    ),
    literal: "true false nil",
    built_in: "_G _VERSION assert collectgarbage dofile error getfenv getmetatable ipairs load loadfile loadstring module next pairs pcall print rawequal rawget rawset require select setfenv setmetatable tonumber tostring type unpack xpcall coroutine debug io math os package string table"
  }, n = "[A-Za-z$_][0-9A-Za-z$_]*", i = {
    className: "subst",
    begin: /#\{/,
    end: /\}/,
    keywords: e
  }, r = [
    t.inherit(
      t.C_NUMBER_MODE,
      { starts: {
        end: "(\\s*/)?",
        relevance: 0
      } }
    ),
    // a number tries to eat the following slash to prevent treating it as a regexp
    {
      className: "string",
      variants: [
        {
          begin: /'/,
          end: /'/,
          contains: [t.BACKSLASH_ESCAPE]
        },
        {
          begin: /"/,
          end: /"/,
          contains: [
            t.BACKSLASH_ESCAPE,
            i
          ]
        }
      ]
    },
    {
      className: "built_in",
      begin: "@__" + t.IDENT_RE
    },
    {
      begin: "@" + t.IDENT_RE
      // relevance booster on par with CoffeeScript
    },
    {
      begin: t.IDENT_RE + "\\\\" + t.IDENT_RE
      // inst\method
    }
  ];
  i.contains = r;
  const a = t.inherit(t.TITLE_MODE, { begin: n }), s = "(\\(.*\\)\\s*)?\\B[-=]>", o = {
    className: "params",
    begin: "\\([^\\(]",
    returnBegin: !0,
    /* We need another contained nameless mode to not have every nested
    pair of parens to be called "params" */
    contains: [
      {
        begin: /\(/,
        end: /\)/,
        keywords: e,
        contains: ["self"].concat(r)
      }
    ]
  };
  return {
    name: "MoonScript",
    aliases: ["moon"],
    keywords: e,
    illegal: /\/\*/,
    contains: r.concat([
      t.COMMENT("--", "$"),
      {
        className: "function",
        // function: -> =>
        begin: "^\\s*" + n + "\\s*=\\s*" + s,
        end: "[-=]>",
        returnBegin: !0,
        contains: [
          a,
          o
        ]
      },
      {
        begin: /[\(,:=]\s*/,
        // anonymous function start
        relevance: 0,
        contains: [
          {
            className: "function",
            begin: s,
            end: "[-=]>",
            returnBegin: !0,
            contains: [o]
          }
        ]
      },
      {
        className: "class",
        beginKeywords: "class",
        end: "$",
        illegal: /[:="\[\]]/,
        contains: [
          {
            beginKeywords: "extends",
            endsWithParent: !0,
            illegal: /[:="\[\]]/,
            contains: [a]
          },
          a
        ]
      },
      {
        className: "name",
        // table
        begin: n + ":",
        end: ":",
        returnBegin: !0,
        returnEnd: !0,
        relevance: 0
      }
    ])
  };
}
function gg(t) {
  return {
    name: "N1QL",
    case_insensitive: !0,
    contains: [
      {
        beginKeywords: "build create index delete drop explain infer|10 insert merge prepare select update upsert|10",
        end: /;/,
        keywords: {
          keyword: [
            "all",
            "alter",
            "analyze",
            "and",
            "any",
            "array",
            "as",
            "asc",
            "begin",
            "between",
            "binary",
            "boolean",
            "break",
            "bucket",
            "build",
            "by",
            "call",
            "case",
            "cast",
            "cluster",
            "collate",
            "collection",
            "commit",
            "connect",
            "continue",
            "correlate",
            "cover",
            "create",
            "database",
            "dataset",
            "datastore",
            "declare",
            "decrement",
            "delete",
            "derived",
            "desc",
            "describe",
            "distinct",
            "do",
            "drop",
            "each",
            "element",
            "else",
            "end",
            "every",
            "except",
            "exclude",
            "execute",
            "exists",
            "explain",
            "fetch",
            "first",
            "flatten",
            "for",
            "force",
            "from",
            "function",
            "grant",
            "group",
            "gsi",
            "having",
            "if",
            "ignore",
            "ilike",
            "in",
            "include",
            "increment",
            "index",
            "infer",
            "inline",
            "inner",
            "insert",
            "intersect",
            "into",
            "is",
            "join",
            "key",
            "keys",
            "keyspace",
            "known",
            "last",
            "left",
            "let",
            "letting",
            "like",
            "limit",
            "lsm",
            "map",
            "mapping",
            "matched",
            "materialized",
            "merge",
            "minus",
            "namespace",
            "nest",
            "not",
            "number",
            "object",
            "offset",
            "on",
            "option",
            "or",
            "order",
            "outer",
            "over",
            "parse",
            "partition",
            "password",
            "path",
            "pool",
            "prepare",
            "primary",
            "private",
            "privilege",
            "procedure",
            "public",
            "raw",
            "realm",
            "reduce",
            "rename",
            "return",
            "returning",
            "revoke",
            "right",
            "role",
            "rollback",
            "satisfies",
            "schema",
            "select",
            "self",
            "semi",
            "set",
            "show",
            "some",
            "start",
            "statistics",
            "string",
            "system",
            "then",
            "to",
            "transaction",
            "trigger",
            "truncate",
            "under",
            "union",
            "unique",
            "unknown",
            "unnest",
            "unset",
            "update",
            "upsert",
            "use",
            "user",
            "using",
            "validate",
            "value",
            "valued",
            "values",
            "via",
            "view",
            "when",
            "where",
            "while",
            "with",
            "within",
            "work",
            "xor"
          ],
          literal: [
            "true",
            "false",
            "null",
            "missing|5"
          ],
          built_in: [
            "array_agg",
            "array_append",
            "array_concat",
            "array_contains",
            "array_count",
            "array_distinct",
            "array_ifnull",
            "array_length",
            "array_max",
            "array_min",
            "array_position",
            "array_prepend",
            "array_put",
            "array_range",
            "array_remove",
            "array_repeat",
            "array_replace",
            "array_reverse",
            "array_sort",
            "array_sum",
            "avg",
            "count",
            "max",
            "min",
            "sum",
            "greatest",
            "least",
            "ifmissing",
            "ifmissingornull",
            "ifnull",
            "missingif",
            "nullif",
            "ifinf",
            "ifnan",
            "ifnanorinf",
            "naninf",
            "neginfif",
            "posinfif",
            "clock_millis",
            "clock_str",
            "date_add_millis",
            "date_add_str",
            "date_diff_millis",
            "date_diff_str",
            "date_part_millis",
            "date_part_str",
            "date_trunc_millis",
            "date_trunc_str",
            "duration_to_str",
            "millis",
            "str_to_millis",
            "millis_to_str",
            "millis_to_utc",
            "millis_to_zone_name",
            "now_millis",
            "now_str",
            "str_to_duration",
            "str_to_utc",
            "str_to_zone_name",
            "decode_json",
            "encode_json",
            "encoded_size",
            "poly_length",
            "base64",
            "base64_encode",
            "base64_decode",
            "meta",
            "uuid",
            "abs",
            "acos",
            "asin",
            "atan",
            "atan2",
            "ceil",
            "cos",
            "degrees",
            "e",
            "exp",
            "ln",
            "log",
            "floor",
            "pi",
            "power",
            "radians",
            "random",
            "round",
            "sign",
            "sin",
            "sqrt",
            "tan",
            "trunc",
            "object_length",
            "object_names",
            "object_pairs",
            "object_inner_pairs",
            "object_values",
            "object_inner_values",
            "object_add",
            "object_put",
            "object_remove",
            "object_unwrap",
            "regexp_contains",
            "regexp_like",
            "regexp_position",
            "regexp_replace",
            "contains",
            "initcap",
            "length",
            "lower",
            "ltrim",
            "position",
            "repeat",
            "replace",
            "rtrim",
            "split",
            "substr",
            "title",
            "trim",
            "upper",
            "isarray",
            "isatom",
            "isboolean",
            "isnumber",
            "isobject",
            "isstring",
            "type",
            "toarray",
            "toatom",
            "toboolean",
            "tonumber",
            "toobject",
            "tostring"
          ]
        },
        contains: [
          {
            className: "string",
            begin: "'",
            end: "'",
            contains: [t.BACKSLASH_ESCAPE]
          },
          {
            className: "string",
            begin: '"',
            end: '"',
            contains: [t.BACKSLASH_ESCAPE]
          },
          {
            className: "symbol",
            begin: "`",
            end: "`",
            contains: [t.BACKSLASH_ESCAPE]
          },
          t.C_NUMBER_MODE,
          t.C_BLOCK_COMMENT_MODE
        ]
      },
      t.C_BLOCK_COMMENT_MODE
    ]
  };
}
function Sg(t) {
  const e = {
    match: [
      /^\s*(?=\S)/,
      // have to look forward here to avoid polynomial backtracking
      /[^:]+/,
      /:\s*/,
      /$/
    ],
    className: {
      2: "attribute",
      3: "punctuation"
    }
  }, n = {
    match: [
      /^\s*(?=\S)/,
      // have to look forward here to avoid polynomial backtracking
      /[^:]*[^: ]/,
      /[ ]*:/,
      /[ ]/,
      /.*$/
    ],
    className: {
      2: "attribute",
      3: "punctuation",
      5: "string"
    }
  }, i = {
    match: [
      /^\s*/,
      />/,
      /[ ]/,
      /.*$/
    ],
    className: {
      2: "punctuation",
      4: "string"
    }
  }, r = {
    variants: [
      { match: [
        /^\s*/,
        /-/,
        /[ ]/,
        /.*$/
      ] },
      { match: [
        /^\s*/,
        /-$/
      ] }
    ],
    className: {
      2: "bullet",
      4: "string"
    }
  };
  return {
    name: "Nested Text",
    aliases: ["nt"],
    contains: [
      t.inherit(t.HASH_COMMENT_MODE, {
        begin: /^\s*(?=#)/,
        excludeBegin: !0
      }),
      r,
      i,
      e,
      n
    ]
  };
}
function hg(t) {
  const e = t.regex, n = {
    className: "variable",
    variants: [
      { begin: /\$\d+/ },
      { begin: /\$\{\w+\}/ },
      { begin: e.concat(/[$@]/, t.UNDERSCORE_IDENT_RE) }
    ]
  }, r = {
    endsWithParent: !0,
    keywords: {
      $pattern: /[a-z_]{2,}|\/dev\/poll/,
      literal: [
        "on",
        "off",
        "yes",
        "no",
        "true",
        "false",
        "none",
        "blocked",
        "debug",
        "info",
        "notice",
        "warn",
        "error",
        "crit",
        "select",
        "break",
        "last",
        "permanent",
        "redirect",
        "kqueue",
        "rtsig",
        "epoll",
        "poll",
        "/dev/poll"
      ]
    },
    relevance: 0,
    illegal: "=>",
    contains: [
      t.HASH_COMMENT_MODE,
      {
        className: "string",
        contains: [
          t.BACKSLASH_ESCAPE,
          n
        ],
        variants: [
          {
            begin: /"/,
            end: /"/
          },
          {
            begin: /'/,
            end: /'/
          }
        ]
      },
      // this swallows entire URLs to avoid detecting numbers within
      {
        begin: "([a-z]+):/",
        end: "\\s",
        endsWithParent: !0,
        excludeEnd: !0,
        contains: [n]
      },
      {
        className: "regexp",
        contains: [
          t.BACKSLASH_ESCAPE,
          n
        ],
        variants: [
          {
            begin: "\\s\\^",
            end: "\\s|\\{|;",
            returnEnd: !0
          },
          // regexp locations (~, ~*)
          {
            begin: "~\\*?\\s+",
            end: "\\s|\\{|;",
            returnEnd: !0
          },
          // *.example.com
          { begin: "\\*(\\.[a-z\\-]+)+" },
          // sub.example.*
          { begin: "([a-z\\-]+\\.)+\\*" }
        ]
      },
      // IP
      {
        className: "number",
        begin: "\\b\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}(:\\d{1,5})?\\b"
      },
      // units
      {
        className: "number",
        begin: "\\b\\d+[kKmMgGdshdwy]?\\b",
        relevance: 0
      },
      n
    ]
  };
  return {
    name: "Nginx config",
    aliases: ["nginxconf"],
    contains: [
      t.HASH_COMMENT_MODE,
      {
        beginKeywords: "upstream location",
        end: /;|\{/,
        contains: r.contains,
        keywords: { section: "upstream location" }
      },
      {
        className: "section",
        begin: e.concat(t.UNDERSCORE_IDENT_RE + e.lookahead(/\s+\{/)),
        relevance: 0
      },
      {
        begin: e.lookahead(t.UNDERSCORE_IDENT_RE + "\\s"),
        end: ";|\\{",
        contains: [
          {
            className: "attribute",
            begin: t.UNDERSCORE_IDENT_RE,
            starts: r
          }
        ],
        relevance: 0
      }
    ],
    illegal: "[^\\s\\}\\{]"
  };
}
function fg(t) {
  return {
    name: "Nim",
    keywords: {
      keyword: [
        "addr",
        "and",
        "as",
        "asm",
        "bind",
        "block",
        "break",
        "case",
        "cast",
        "concept",
        "const",
        "continue",
        "converter",
        "defer",
        "discard",
        "distinct",
        "div",
        "do",
        "elif",
        "else",
        "end",
        "enum",
        "except",
        "export",
        "finally",
        "for",
        "from",
        "func",
        "generic",
        "guarded",
        "if",
        "import",
        "in",
        "include",
        "interface",
        "is",
        "isnot",
        "iterator",
        "let",
        "macro",
        "method",
        "mixin",
        "mod",
        "nil",
        "not",
        "notin",
        "object",
        "of",
        "or",
        "out",
        "proc",
        "ptr",
        "raise",
        "ref",
        "return",
        "shared",
        "shl",
        "shr",
        "static",
        "template",
        "try",
        "tuple",
        "type",
        "using",
        "var",
        "when",
        "while",
        "with",
        "without",
        "xor",
        "yield"
      ],
      literal: [
        "true",
        "false"
      ],
      type: [
        "int",
        "int8",
        "int16",
        "int32",
        "int64",
        "uint",
        "uint8",
        "uint16",
        "uint32",
        "uint64",
        "float",
        "float32",
        "float64",
        "bool",
        "char",
        "string",
        "cstring",
        "pointer",
        "expr",
        "stmt",
        "void",
        "auto",
        "any",
        "range",
        "array",
        "openarray",
        "varargs",
        "seq",
        "set",
        "clong",
        "culong",
        "cchar",
        "cschar",
        "cshort",
        "cint",
        "csize",
        "clonglong",
        "cfloat",
        "cdouble",
        "clongdouble",
        "cuchar",
        "cushort",
        "cuint",
        "culonglong",
        "cstringarray",
        "semistatic"
      ],
      built_in: [
        "stdin",
        "stdout",
        "stderr",
        "result"
      ]
    },
    contains: [
      {
        className: "meta",
        // Actually pragma
        begin: /\{\./,
        end: /\.\}/,
        relevance: 10
      },
      {
        className: "string",
        begin: /[a-zA-Z]\w*"/,
        end: /"/,
        contains: [{ begin: /""/ }]
      },
      {
        className: "string",
        begin: /([a-zA-Z]\w*)?"""/,
        end: /"""/
      },
      t.QUOTE_STRING_MODE,
      {
        className: "type",
        begin: /\b[A-Z]\w+\b/,
        relevance: 0
      },
      {
        className: "number",
        relevance: 0,
        variants: [
          { begin: /\b(0[xX][0-9a-fA-F][_0-9a-fA-F]*)('?[iIuU](8|16|32|64))?/ },
          { begin: /\b(0o[0-7][_0-7]*)('?[iIuUfF](8|16|32|64))?/ },
          { begin: /\b(0(b|B)[01][_01]*)('?[iIuUfF](8|16|32|64))?/ },
          { begin: /\b(\d[_\d]*)('?[iIuUfF](8|16|32|64))?/ }
        ]
      },
      t.HASH_COMMENT_MODE
    ]
  };
}
function Tg(t) {
  const e = t.regex, n = {
    keyword: [
      "assert",
      "else",
      "if",
      "in",
      "inherit",
      "let",
      "or",
      "rec",
      "then",
      "with"
    ],
    literal: [
      "true",
      "false",
      "null"
    ],
    built_in: [
      // toplevel builtins
      "abort",
      "baseNameOf",
      "builtins",
      "derivation",
      "derivationStrict",
      "dirOf",
      "fetchGit",
      "fetchMercurial",
      "fetchTarball",
      "fetchTree",
      "fromTOML",
      "import",
      "isNull",
      "map",
      "placeholder",
      "removeAttrs",
      "scopedImport",
      "throw",
      "toString"
    ]
  }, i = {
    scope: "built_in",
    match: e.either(...[
      "abort",
      "add",
      "addDrvOutputDependencies",
      "addErrorContext",
      "all",
      "any",
      "appendContext",
      "attrNames",
      "attrValues",
      "baseNameOf",
      "bitAnd",
      "bitOr",
      "bitXor",
      "break",
      "builtins",
      "catAttrs",
      "ceil",
      "compareVersions",
      "concatLists",
      "concatMap",
      "concatStringsSep",
      "convertHash",
      "currentSystem",
      "currentTime",
      "deepSeq",
      "derivation",
      "derivationStrict",
      "dirOf",
      "div",
      "elem",
      "elemAt",
      "false",
      "fetchGit",
      "fetchMercurial",
      "fetchTarball",
      "fetchTree",
      "fetchurl",
      "filter",
      "filterSource",
      "findFile",
      "flakeRefToString",
      "floor",
      "foldl'",
      "fromJSON",
      "fromTOML",
      "functionArgs",
      "genList",
      "genericClosure",
      "getAttr",
      "getContext",
      "getEnv",
      "getFlake",
      "groupBy",
      "hasAttr",
      "hasContext",
      "hashFile",
      "hashString",
      "head",
      "import",
      "intersectAttrs",
      "isAttrs",
      "isBool",
      "isFloat",
      "isFunction",
      "isInt",
      "isList",
      "isNull",
      "isPath",
      "isString",
      "langVersion",
      "length",
      "lessThan",
      "listToAttrs",
      "map",
      "mapAttrs",
      "match",
      "mul",
      "nixPath",
      "nixVersion",
      "null",
      "parseDrvName",
      "parseFlakeRef",
      "partition",
      "path",
      "pathExists",
      "placeholder",
      "readDir",
      "readFile",
      "readFileType",
      "removeAttrs",
      "replaceStrings",
      "scopedImport",
      "seq",
      "sort",
      "split",
      "splitVersion",
      "storeDir",
      "storePath",
      "stringLength",
      "sub",
      "substring",
      "tail",
      "throw",
      "toFile",
      "toJSON",
      "toPath",
      "toString",
      "toXML",
      "trace",
      "traceVerbose",
      "true",
      "tryEval",
      "typeOf",
      "unsafeDiscardOutputDependency",
      "unsafeDiscardStringContext",
      "unsafeGetAttrPos",
      "warn",
      "zipAttrsWith"
    ].map((O) => `builtins\\.${O}`)),
    relevance: 10
  }, r = "[A-Za-z_][A-Za-z0-9_'-]*", a = {
    scope: "symbol",
    match: new RegExp(`<${r}(/${r})*>`)
  }, s = "[A-Za-z0-9_\\+\\.-]+", o = {
    scope: "symbol",
    match: new RegExp(`(\\.\\.|\\.|~)?/(${s})?(/${s})*(?=[\\s;])`)
  }, l = e.either("==", "=", "\\+\\+", "\\+", "<=", "<\\|", "<", ">=", ">", "->", "//", "/", "!=", "!", "\\|\\|", "\\|>", "\\?", "\\*", "&&"), c = {
    scope: "operator",
    match: e.concat(l, /(?!-)/),
    relevance: 0
  }, d = {
    scope: "number",
    match: new RegExp(`${t.NUMBER_RE}(?!-)`),
    relevance: 0
  }, u = {
    variants: [
      {
        scope: "operator",
        beforeMatch: /\s/,
        // The (?!>) is used to ensure this doesn't collide with the '->' operator
        begin: /-(?!>)/
      },
      {
        begin: [
          new RegExp(`${t.NUMBER_RE}`),
          /-/,
          /(?!>)/
        ],
        beginScope: {
          1: "number",
          2: "operator"
        }
      },
      {
        begin: [
          l,
          /-/,
          /(?!>)/
        ],
        beginScope: {
          1: "operator",
          2: "operator"
        }
      }
    ],
    relevance: 0
  }, _ = {
    beforeMatch: /(^|\{|;)\s*/,
    begin: new RegExp(`${r}(\\.${r})*\\s*=(?!=)`),
    returnBegin: !0,
    relevance: 0,
    contains: [
      {
        scope: "attr",
        match: new RegExp(`${r}(\\.${r})*(?=\\s*=)`),
        relevance: 0.2
      }
    ]
  }, m = {
    scope: "char.escape",
    match: /\\\$/
  }, g = {
    scope: "char.escape",
    match: /''\$/
  }, S = {
    scope: "subst",
    begin: /\$\{/,
    end: /\}/,
    keywords: n
  }, E = {
    scope: "char.escape",
    match: /'''/
  }, h = {
    scope: "char.escape",
    match: /\\(?!\$)./
  }, T = {
    scope: "string",
    variants: [
      {
        begin: "''",
        end: "''",
        contains: [
          g,
          S,
          E,
          h
        ]
      },
      {
        begin: '"',
        end: '"',
        contains: [
          m,
          S,
          h
        ]
      }
    ]
  }, b = {
    scope: "params",
    match: new RegExp(`${r}\\s*:(?=\\s)`)
  }, C = [
    d,
    t.HASH_COMMENT_MODE,
    t.C_BLOCK_COMMENT_MODE,
    t.COMMENT(
      /\/\*\*(?!\/)/,
      /\*\//,
      {
        subLanguage: "markdown",
        relevance: 0
      }
    ),
    i,
    T,
    a,
    o,
    b,
    _,
    u,
    c
  ];
  S.contains = C;
  const y = [
    {
      scope: "meta.prompt",
      match: /^nix-repl>(?=\s)/,
      relevance: 10
    },
    {
      scope: "meta",
      beforeMatch: /\s+/,
      begin: /:([a-z]+|\?)/
    }
  ];
  return {
    name: "Nix",
    aliases: ["nixos"],
    keywords: n,
    contains: C.concat(y)
  };
}
function bg(t) {
  return {
    name: "Node REPL",
    contains: [
      {
        className: "meta.prompt",
        starts: {
          // a space separates the REPL prefix from the actual code
          // this is purely for cleaner HTML output
          end: / |$/,
          starts: {
            end: "$",
            subLanguage: "javascript"
          }
        },
        variants: [
          { begin: /^>(?=[ ]|$)/ },
          { begin: /^\.\.\.(?=[ ]|$)/ }
        ]
      }
    ]
  };
}
function Cg(t) {
  const e = t.regex, n = [
    "ADMINTOOLS",
    "APPDATA",
    "CDBURN_AREA",
    "CMDLINE",
    "COMMONFILES32",
    "COMMONFILES64",
    "COMMONFILES",
    "COOKIES",
    "DESKTOP",
    "DOCUMENTS",
    "EXEDIR",
    "EXEFILE",
    "EXEPATH",
    "FAVORITES",
    "FONTS",
    "HISTORY",
    "HWNDPARENT",
    "INSTDIR",
    "INTERNET_CACHE",
    "LANGUAGE",
    "LOCALAPPDATA",
    "MUSIC",
    "NETHOOD",
    "OUTDIR",
    "PICTURES",
    "PLUGINSDIR",
    "PRINTHOOD",
    "PROFILE",
    "PROGRAMFILES32",
    "PROGRAMFILES64",
    "PROGRAMFILES",
    "QUICKLAUNCH",
    "RECENT",
    "RESOURCES_LOCALIZED",
    "RESOURCES",
    "SENDTO",
    "SMPROGRAMS",
    "SMSTARTUP",
    "STARTMENU",
    "SYSDIR",
    "TEMP",
    "TEMPLATES",
    "VIDEOS",
    "WINDIR"
  ], i = [
    "ARCHIVE",
    "FILE_ATTRIBUTE_ARCHIVE",
    "FILE_ATTRIBUTE_NORMAL",
    "FILE_ATTRIBUTE_OFFLINE",
    "FILE_ATTRIBUTE_READONLY",
    "FILE_ATTRIBUTE_SYSTEM",
    "FILE_ATTRIBUTE_TEMPORARY",
    "HKCR",
    "HKCU",
    "HKDD",
    "HKEY_CLASSES_ROOT",
    "HKEY_CURRENT_CONFIG",
    "HKEY_CURRENT_USER",
    "HKEY_DYN_DATA",
    "HKEY_LOCAL_MACHINE",
    "HKEY_PERFORMANCE_DATA",
    "HKEY_USERS",
    "HKLM",
    "HKPD",
    "HKU",
    "IDABORT",
    "IDCANCEL",
    "IDIGNORE",
    "IDNO",
    "IDOK",
    "IDRETRY",
    "IDYES",
    "MB_ABORTRETRYIGNORE",
    "MB_DEFBUTTON1",
    "MB_DEFBUTTON2",
    "MB_DEFBUTTON3",
    "MB_DEFBUTTON4",
    "MB_ICONEXCLAMATION",
    "MB_ICONINFORMATION",
    "MB_ICONQUESTION",
    "MB_ICONSTOP",
    "MB_OK",
    "MB_OKCANCEL",
    "MB_RETRYCANCEL",
    "MB_RIGHT",
    "MB_RTLREADING",
    "MB_SETFOREGROUND",
    "MB_TOPMOST",
    "MB_USERICON",
    "MB_YESNO",
    "NORMAL",
    "OFFLINE",
    "READONLY",
    "SHCTX",
    "SHELL_CONTEXT",
    "SYSTEM|TEMPORARY"
  ], r = [
    "addincludedir",
    "addplugindir",
    "appendfile",
    "assert",
    "cd",
    "define",
    "delfile",
    "echo",
    "else",
    "endif",
    "error",
    "execute",
    "finalize",
    "getdllversion",
    "gettlbversion",
    "if",
    "ifdef",
    "ifmacrodef",
    "ifmacrondef",
    "ifndef",
    "include",
    "insertmacro",
    "macro",
    "macroend",
    "makensis",
    "packhdr",
    "searchparse",
    "searchreplace",
    "system",
    "tempfile",
    "undef",
    "uninstfinalize",
    "verbose",
    "warning"
  ], a = {
    className: "variable.constant",
    begin: e.concat(/\$/, e.either(...n))
  }, s = {
    // ${defines}
    className: "variable",
    begin: /\$+\{[\!\w.:-]+\}/
  }, o = {
    // $variables
    className: "variable",
    begin: /\$+\w[\w\.]*/,
    illegal: /\(\)\{\}/
  }, l = {
    // $(language_strings)
    className: "variable",
    begin: /\$+\([\w^.:!-]+\)/
  }, c = {
    // command parameters
    className: "params",
    begin: e.either(...i)
  }, d = {
    // !compiler_flags
    className: "keyword",
    begin: e.concat(
      /!/,
      e.either(...r)
    )
  }, u = {
    // $\n, $\r, $\t, $$
    className: "char.escape",
    begin: /\$(\\[nrt]|\$)/
  }, _ = {
    // plug::ins
    className: "title.function",
    begin: /\w+::\w+/
  }, m = {
    className: "string",
    variants: [
      {
        begin: '"',
        end: '"'
      },
      {
        begin: "'",
        end: "'"
      },
      {
        begin: "`",
        end: "`"
      }
    ],
    illegal: /\n/,
    contains: [
      u,
      a,
      s,
      o,
      l
    ]
  }, g = [
    "Abort",
    "AddBrandingImage",
    "AddSize",
    "AllowRootDirInstall",
    "AllowSkipFiles",
    "AutoCloseWindow",
    "BGFont",
    "BGGradient",
    "BrandingText",
    "BringToFront",
    "Call",
    "CallInstDLL",
    "Caption",
    "ChangeUI",
    "CheckBitmap",
    "ClearErrors",
    "CompletedText",
    "ComponentText",
    "CopyFiles",
    "CRCCheck",
    "CreateDirectory",
    "CreateFont",
    "CreateShortCut",
    "Delete",
    "DeleteINISec",
    "DeleteINIStr",
    "DeleteRegKey",
    "DeleteRegValue",
    "DetailPrint",
    "DetailsButtonText",
    "DirText",
    "DirVar",
    "DirVerify",
    "EnableWindow",
    "EnumRegKey",
    "EnumRegValue",
    "Exch",
    "Exec",
    "ExecShell",
    "ExecShellWait",
    "ExecWait",
    "ExpandEnvStrings",
    "File",
    "FileBufSize",
    "FileClose",
    "FileErrorText",
    "FileOpen",
    "FileRead",
    "FileReadByte",
    "FileReadUTF16LE",
    "FileReadWord",
    "FileWriteUTF16LE",
    "FileSeek",
    "FileWrite",
    "FileWriteByte",
    "FileWriteWord",
    "FindClose",
    "FindFirst",
    "FindNext",
    "FindWindow",
    "FlushINI",
    "GetCurInstType",
    "GetCurrentAddress",
    "GetDlgItem",
    "GetDLLVersion",
    "GetDLLVersionLocal",
    "GetErrorLevel",
    "GetFileTime",
    "GetFileTimeLocal",
    "GetFullPathName",
    "GetFunctionAddress",
    "GetInstDirError",
    "GetKnownFolderPath",
    "GetLabelAddress",
    "GetTempFileName",
    "GetWinVer",
    "Goto",
    "HideWindow",
    "Icon",
    "IfAbort",
    "IfErrors",
    "IfFileExists",
    "IfRebootFlag",
    "IfRtlLanguage",
    "IfShellVarContextAll",
    "IfSilent",
    "InitPluginsDir",
    "InstallButtonText",
    "InstallColors",
    "InstallDir",
    "InstallDirRegKey",
    "InstProgressFlags",
    "InstType",
    "InstTypeGetText",
    "InstTypeSetText",
    "Int64Cmp",
    "Int64CmpU",
    "Int64Fmt",
    "IntCmp",
    "IntCmpU",
    "IntFmt",
    "IntOp",
    "IntPtrCmp",
    "IntPtrCmpU",
    "IntPtrOp",
    "IsWindow",
    "LangString",
    "LicenseBkColor",
    "LicenseData",
    "LicenseForceSelection",
    "LicenseLangString",
    "LicenseText",
    "LoadAndSetImage",
    "LoadLanguageFile",
    "LockWindow",
    "LogSet",
    "LogText",
    "ManifestDPIAware",
    "ManifestLongPathAware",
    "ManifestMaxVersionTested",
    "ManifestSupportedOS",
    "MessageBox",
    "MiscButtonText",
    "Name|0",
    "Nop",
    "OutFile",
    "Page",
    "PageCallbacks",
    "PEAddResource",
    "PEDllCharacteristics",
    "PERemoveResource",
    "PESubsysVer",
    "Pop",
    "Push",
    "Quit",
    "ReadEnvStr",
    "ReadINIStr",
    "ReadRegDWORD",
    "ReadRegStr",
    "Reboot",
    "RegDLL",
    "Rename",
    "RequestExecutionLevel",
    "ReserveFile",
    "Return",
    "RMDir",
    "SearchPath",
    "SectionGetFlags",
    "SectionGetInstTypes",
    "SectionGetSize",
    "SectionGetText",
    "SectionIn",
    "SectionSetFlags",
    "SectionSetInstTypes",
    "SectionSetSize",
    "SectionSetText",
    "SendMessage",
    "SetAutoClose",
    "SetBrandingImage",
    "SetCompress",
    "SetCompressor",
    "SetCompressorDictSize",
    "SetCtlColors",
    "SetCurInstType",
    "SetDatablockOptimize",
    "SetDateSave",
    "SetDetailsPrint",
    "SetDetailsView",
    "SetErrorLevel",
    "SetErrors",
    "SetFileAttributes",
    "SetFont",
    "SetOutPath",
    "SetOverwrite",
    "SetRebootFlag",
    "SetRegView",
    "SetShellVarContext",
    "SetSilent",
    "ShowInstDetails",
    "ShowUninstDetails",
    "ShowWindow",
    "SilentInstall",
    "SilentUnInstall",
    "Sleep",
    "SpaceTexts",
    "StrCmp",
    "StrCmpS",
    "StrCpy",
    "StrLen",
    "SubCaption",
    "Unicode",
    "UninstallButtonText",
    "UninstallCaption",
    "UninstallIcon",
    "UninstallSubCaption",
    "UninstallText",
    "UninstPage",
    "UnRegDLL",
    "Var",
    "VIAddVersionKey",
    "VIFileVersion",
    "VIProductVersion",
    "WindowIcon",
    "WriteINIStr",
    "WriteRegBin",
    "WriteRegDWORD",
    "WriteRegExpandStr",
    "WriteRegMultiStr",
    "WriteRegNone",
    "WriteRegStr",
    "WriteUninstaller",
    "XPStyle"
  ], S = [
    "admin",
    "all",
    "auto",
    "both",
    "bottom",
    "bzip2",
    "colored",
    "components",
    "current",
    "custom",
    "directory",
    "false",
    "force",
    "hide",
    "highest",
    "ifdiff",
    "ifnewer",
    "instfiles",
    "lastused",
    "leave",
    "left",
    "license",
    "listonly",
    "lzma",
    "nevershow",
    "none",
    "normal",
    "notset",
    "off",
    "on",
    "open",
    "print",
    "right",
    "show",
    "silent",
    "silentlog",
    "smooth",
    "textonly",
    "top",
    "true",
    "try",
    "un.components",
    "un.custom",
    "un.directory",
    "un.instfiles",
    "un.license",
    "uninstConfirm",
    "user",
    "Win10",
    "Win7",
    "Win8",
    "WinVista",
    "zlib"
  ], E = {
    match: [
      /Function/,
      /\s+/,
      e.concat(/(\.)?/, t.IDENT_RE)
    ],
    scope: {
      1: "keyword",
      3: "title.function"
    }
  }, T = {
    match: [
      /Var/,
      /\s+/,
      /(?:\/GLOBAL\s+)?/,
      /[A-Za-z][\w.]*/
    ],
    scope: {
      1: "keyword",
      3: "params",
      4: "variable"
    }
  };
  return {
    name: "NSIS",
    case_insensitive: !0,
    keywords: {
      keyword: g,
      literal: S
    },
    contains: [
      t.HASH_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      t.COMMENT(
        ";",
        "$",
        { relevance: 0 }
      ),
      T,
      E,
      { beginKeywords: "Function PageEx Section SectionGroup FunctionEnd SectionEnd" },
      m,
      d,
      s,
      o,
      l,
      c,
      _,
      t.NUMBER_MODE
    ]
  };
}
function yg(t) {
  return {
    name: "OCaml",
    aliases: ["ml"],
    keywords: {
      $pattern: "[a-z_]\\w*!?",
      keyword: "and as assert asr begin class constraint do done downto else end exception external for fun function functor if in include inherit! inherit initializer land lazy let lor lsl lsr lxor match method!|10 method mod module mutable new object of open! open or private rec sig struct then to try type val! val virtual when while with parser value",
      built_in: (
        /* built-in types */
        "array bool bytes char exn|5 float int int32 int64 list lazy_t|5 nativeint|5 string unit in_channel out_channel ref"
      ),
      literal: "true false"
    },
    illegal: /\/\/|>>/,
    contains: [
      {
        className: "literal",
        begin: "\\[(\\|\\|)?\\]|\\(\\)",
        relevance: 0
      },
      t.COMMENT(
        "\\(\\*",
        "\\*\\)",
        { contains: ["self"] }
      ),
      {
        /* type variable */
        className: "symbol",
        begin: "'[A-Za-z_](?!')[\\w']*"
        /* the grammar is ambiguous on how 'a'b should be interpreted but not the compiler */
      },
      {
        /* polymorphic variant */
        className: "type",
        begin: "`[A-Z][\\w']*"
      },
      {
        /* module or constructor */
        className: "type",
        begin: "\\b[A-Z][\\w']*",
        relevance: 0
      },
      {
        /* don't color identifiers, but safely catch all identifiers with ' */
        begin: "[a-z_]\\w*'[\\w']*",
        relevance: 0
      },
      t.inherit(t.APOS_STRING_MODE, {
        className: "string",
        relevance: 0
      }),
      t.inherit(t.QUOTE_STRING_MODE, { illegal: null }),
      {
        className: "number",
        begin: "\\b(0[xX][a-fA-F0-9_]+[Lln]?|0[oO][0-7_]+[Lln]?|0[bB][01_]+[Lln]?|[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)",
        relevance: 0
      },
      {
        begin: /->/
        // relevance booster
      }
    ]
  };
}
function Rg(t) {
  const e = {
    className: "keyword",
    begin: "\\$(f[asn]|t|vp[rtd]|children)"
  }, n = {
    className: "literal",
    begin: "false|true|PI|undef"
  }, i = {
    className: "number",
    begin: "\\b\\d+(\\.\\d+)?(e-?\\d+)?",
    // adds 1e5, 1e-10
    relevance: 0
  }, r = t.inherit(t.QUOTE_STRING_MODE, { illegal: null }), a = {
    className: "meta",
    keywords: { keyword: "include use" },
    begin: "include|use <",
    end: ">"
  }, s = {
    className: "params",
    begin: "\\(",
    end: "\\)",
    contains: [
      "self",
      i,
      r,
      e,
      n
    ]
  }, o = {
    begin: "[*!#%]",
    relevance: 0
  }, l = {
    className: "function",
    beginKeywords: "module function",
    end: /=|\{/,
    contains: [
      s,
      t.UNDERSCORE_TITLE_MODE
    ]
  };
  return {
    name: "OpenSCAD",
    aliases: ["scad"],
    keywords: {
      keyword: "function module include use for intersection_for if else \\%",
      literal: "false true PI undef",
      built_in: "circle square polygon text sphere cube cylinder polyhedron translate rotate scale resize mirror multmatrix color offset hull minkowski union difference intersection abs sign sin cos tan acos asin atan atan2 floor round ceil ln log pow sqrt exp rands min max concat lookup str chr search version version_num norm cross parent_module echo import import_dxf dxf_linear_extrude linear_extrude rotate_extrude surface projection render children dxf_cross dxf_dim let assign"
    },
    contains: [
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      i,
      a,
      r,
      e,
      o,
      l
    ]
  };
}
function Ng(t) {
  const e = {
    $pattern: /\.?\w+/,
    keyword: "abstract add and array as asc aspect assembly async begin break block by case class concat const copy constructor continue create default delegate desc distinct div do downto dynamic each else empty end ensure enum equals event except exit extension external false final finalize finalizer finally flags for forward from function future global group has if implementation implements implies in index inherited inline interface into invariants is iterator join locked locking loop matching method mod module namespace nested new nil not notify nullable of old on operator or order out override parallel params partial pinned private procedure property protected public queryable raise read readonly record reintroduce remove repeat require result reverse sealed select self sequence set shl shr skip static step soft take then to true try tuple type union unit unsafe until uses using var virtual raises volatile where while with write xor yield await mapped deprecated stdcall cdecl pascal register safecall overload library platform reference packed strict published autoreleasepool selector strong weak unretained"
  }, n = t.COMMENT(
    /\{/,
    /\}/,
    { relevance: 0 }
  ), i = t.COMMENT(
    "\\(\\*",
    "\\*\\)",
    { relevance: 10 }
  ), r = {
    className: "string",
    begin: "'",
    end: "'",
    contains: [{ begin: "''" }]
  }, a = {
    className: "string",
    begin: "(#\\d+)+"
  }, s = {
    beginKeywords: "function constructor destructor procedure method",
    end: "[:;]",
    keywords: "function constructor|10 destructor|10 procedure|10 method|10",
    contains: [
      t.inherit(t.TITLE_MODE, { scope: "title.function" }),
      {
        className: "params",
        begin: "\\(",
        end: "\\)",
        keywords: e,
        contains: [
          r,
          a
        ]
      },
      n,
      i
    ]
  }, o = {
    scope: "punctuation",
    match: /;/,
    relevance: 0
  };
  return {
    name: "Oxygene",
    case_insensitive: !0,
    keywords: e,
    illegal: '("|\\$[G-Zg-z]|\\/\\*|</|=>|->)',
    contains: [
      n,
      i,
      t.C_LINE_COMMENT_MODE,
      r,
      a,
      t.NUMBER_MODE,
      s,
      o
    ]
  };
}
function Og(t) {
  const e = t.COMMENT(
    /\{/,
    /\}/,
    { contains: ["self"] }
  );
  return {
    name: "Parser3",
    subLanguage: "xml",
    relevance: 0,
    contains: [
      t.COMMENT("^#", "$"),
      t.COMMENT(
        /\^rem\{/,
        /\}/,
        {
          relevance: 10,
          contains: [e]
        }
      ),
      {
        className: "meta",
        begin: "^@(?:BASE|USE|CLASS|OPTIONS)$",
        relevance: 10
      },
      {
        className: "title",
        begin: "@[\\w\\-]+\\[[\\w^;\\-]*\\](?:\\[[\\w^;\\-]*\\])?(?:.*)$"
      },
      {
        className: "variable",
        begin: /\$\{?[\w\-.:]+\}?/
      },
      {
        className: "keyword",
        begin: /\^[\w\-.:]+/
      },
      {
        className: "number",
        begin: "\\^#[0-9a-fA-F]+"
      },
      t.C_NUMBER_MODE
    ]
  };
}
function vg(t) {
  const e = {
    className: "variable",
    begin: /\$[\w\d#@][\w\d_]*/,
    relevance: 0
  }, n = {
    className: "variable",
    begin: /<(?!\/)/,
    end: />/
  };
  return {
    name: "Packet Filter config",
    aliases: ["pf.conf"],
    keywords: {
      $pattern: /[a-z0-9_<>-]+/,
      built_in: (
        /* block match pass are "actions" in pf.conf(5), the rest are
         * lexically similar top-level commands.
         */
        "block match pass load anchor|5 antispoof|10 set table"
      ),
      keyword: "in out log quick on rdomain inet inet6 proto from port os to route allow-opts divert-packet divert-reply divert-to flags group icmp-type icmp6-type label once probability recieved-on rtable prio queue tos tag tagged user keep fragment for os drop af-to|10 binat-to|10 nat-to|10 rdr-to|10 bitmask least-stats random round-robin source-hash static-port dup-to reply-to route-to parent bandwidth default min max qlimit block-policy debug fingerprints hostid limit loginterface optimization reassemble ruleset-optimization basic none profile skip state-defaults state-policy timeout const counters persist no modulate synproxy state|5 floating if-bound no-sync pflow|10 sloppy source-track global rule max-src-nodes max-src-states max-src-conn max-src-conn-rate overload flush scrub|5 max-mss min-ttl no-df|10 random-id",
      literal: "all any no-route self urpf-failed egress|5 unknown"
    },
    contains: [
      t.HASH_COMMENT_MODE,
      t.NUMBER_MODE,
      t.QUOTE_STRING_MODE,
      e,
      n
    ]
  };
}
function Ag(t) {
  const e = t.COMMENT("--", "$"), n = "[a-zA-Z_][a-zA-Z_0-9$]*", i = "\\$([a-zA-Z_]?|[a-zA-Z_][a-zA-Z_0-9]*)\\$", r = "<<\\s*" + n + "\\s*>>", a = (
    // https://www.postgresql.org/docs/11/static/sql-keywords-appendix.html
    // https://www.postgresql.org/docs/11/static/sql-commands.html
    // SQL commands (starting words)
    "ABORT ALTER ANALYZE BEGIN CALL CHECKPOINT|10 CLOSE CLUSTER COMMENT COMMIT COPY CREATE DEALLOCATE DECLARE DELETE DISCARD DO DROP END EXECUTE EXPLAIN FETCH GRANT IMPORT INSERT LISTEN LOAD LOCK MOVE NOTIFY PREPARE REASSIGN|10 REFRESH REINDEX RELEASE RESET REVOKE ROLLBACK SAVEPOINT SECURITY SELECT SET SHOW START TRUNCATE UNLISTEN|10 UPDATE VACUUM|10 VALUES AGGREGATE COLLATION CONVERSION|10 DATABASE DEFAULT PRIVILEGES DOMAIN TRIGGER EXTENSION FOREIGN WRAPPER|10 TABLE FUNCTION GROUP LANGUAGE LARGE OBJECT MATERIALIZED VIEW OPERATOR CLASS FAMILY POLICY PUBLICATION|10 ROLE RULE SCHEMA SEQUENCE SERVER STATISTICS SUBSCRIPTION SYSTEM TABLESPACE CONFIGURATION DICTIONARY PARSER TEMPLATE TYPE USER MAPPING PREPARED ACCESS METHOD CAST AS TRANSFORM TRANSACTION OWNED TO INTO SESSION AUTHORIZATION INDEX PROCEDURE ASSERTION ALL ANALYSE AND ANY ARRAY ASC ASYMMETRIC|10 BOTH CASE CHECK COLLATE COLUMN CONCURRENTLY|10 CONSTRAINT CROSS DEFERRABLE RANGE DESC DISTINCT ELSE EXCEPT FOR FREEZE|10 FROM FULL HAVING ILIKE IN INITIALLY INNER INTERSECT IS ISNULL JOIN LATERAL LEADING LIKE LIMIT NATURAL NOT NOTNULL NULL OFFSET ON ONLY OR ORDER OUTER OVERLAPS PLACING PRIMARY REFERENCES RETURNING SIMILAR SOME SYMMETRIC TABLESAMPLE THEN TRAILING UNION UNIQUE USING VARIADIC|10 VERBOSE WHEN WHERE WINDOW WITH BY RETURNS INOUT OUT SETOF|10 IF STRICT CURRENT CONTINUE OWNER LOCATION OVER PARTITION WITHIN BETWEEN ESCAPE EXTERNAL INVOKER DEFINER WORK RENAME VERSION CONNECTION CONNECT TABLES TEMP TEMPORARY FUNCTIONS SEQUENCES TYPES SCHEMAS OPTION CASCADE RESTRICT ADD ADMIN EXISTS VALID VALIDATE ENABLE DISABLE REPLICA|10 ALWAYS PASSING COLUMNS PATH REF VALUE OVERRIDING IMMUTABLE STABLE VOLATILE BEFORE AFTER EACH ROW PROCEDURAL ROUTINE NO HANDLER VALIDATOR OPTIONS STORAGE OIDS|10 WITHOUT INHERIT DEPENDS CALLED INPUT LEAKPROOF|10 COST ROWS NOWAIT SEARCH UNTIL ENCRYPTED|10 PASSWORD CONFLICT|10 INSTEAD INHERITS CHARACTERISTICS WRITE CURSOR ALSO STATEMENT SHARE EXCLUSIVE INLINE ISOLATION REPEATABLE READ COMMITTED SERIALIZABLE UNCOMMITTED LOCAL GLOBAL SQL PROCEDURES RECURSIVE SNAPSHOT ROLLUP CUBE TRUSTED|10 INCLUDE FOLLOWING PRECEDING UNBOUNDED RANGE GROUPS UNENCRYPTED|10 SYSID FORMAT DELIMITER HEADER QUOTE ENCODING FILTER OFF FORCE_QUOTE FORCE_NOT_NULL FORCE_NULL COSTS BUFFERS TIMING SUMMARY DISABLE_PAGE_SKIPPING RESTART CYCLE GENERATED IDENTITY DEFERRED IMMEDIATE LEVEL LOGGED UNLOGGED OF NOTHING NONE EXCLUDE ATTRIBUTE USAGE ROUTINES TRUE FALSE NAN INFINITY "
  ), s = (
    // only those not in keywrods already
    "SUPERUSER NOSUPERUSER CREATEDB NOCREATEDB CREATEROLE NOCREATEROLE INHERIT NOINHERIT LOGIN NOLOGIN REPLICATION NOREPLICATION BYPASSRLS NOBYPASSRLS "
  ), o = "ALIAS BEGIN CONSTANT DECLARE END EXCEPTION RETURN PERFORM|10 RAISE GET DIAGNOSTICS STACKED|10 FOREACH LOOP ELSIF EXIT WHILE REVERSE SLICE DEBUG LOG INFO NOTICE WARNING ASSERT OPEN ", l = (
    // https://www.postgresql.org/docs/11/static/datatype.html
    "BIGINT INT8 BIGSERIAL SERIAL8 BIT VARYING VARBIT BOOLEAN BOOL BOX BYTEA CHARACTER CHAR VARCHAR CIDR CIRCLE DATE DOUBLE PRECISION FLOAT8 FLOAT INET INTEGER INT INT4 INTERVAL JSON JSONB LINE LSEG|10 MACADDR MACADDR8 MONEY NUMERIC DEC DECIMAL PATH POINT POLYGON REAL FLOAT4 SMALLINT INT2 SMALLSERIAL|10 SERIAL2|10 SERIAL|10 SERIAL4|10 TEXT TIME ZONE TIMETZ|10 TIMESTAMP TIMESTAMPTZ|10 TSQUERY|10 TSVECTOR|10 TXID_SNAPSHOT|10 UUID XML NATIONAL NCHAR INT4RANGE|10 INT8RANGE|10 NUMRANGE|10 TSRANGE|10 TSTZRANGE|10 DATERANGE|10 ANYELEMENT ANYARRAY ANYNONARRAY ANYENUM ANYRANGE CSTRING INTERNAL RECORD PG_DDL_COMMAND VOID UNKNOWN OPAQUE REFCURSOR NAME OID REGPROC|10 REGPROCEDURE|10 REGOPER|10 REGOPERATOR|10 REGCLASS|10 REGTYPE|10 REGROLE|10 REGNAMESPACE|10 REGCONFIG|10 REGDICTIONARY|10 "
  ), c = l.trim().split(" ").map(function(S) {
    return S.split("|")[0];
  }).join("|"), d = "CURRENT_TIME CURRENT_TIMESTAMP CURRENT_USER CURRENT_CATALOG|10 CURRENT_DATE LOCALTIME LOCALTIMESTAMP CURRENT_ROLE|10 CURRENT_SCHEMA|10 SESSION_USER PUBLIC ", u = "FOUND NEW OLD TG_NAME|10 TG_WHEN|10 TG_LEVEL|10 TG_OP|10 TG_RELID|10 TG_RELNAME|10 TG_TABLE_NAME|10 TG_TABLE_SCHEMA|10 TG_NARGS|10 TG_ARGV|10 TG_EVENT|10 TG_TAG|10 ROW_COUNT RESULT_OID|10 PG_CONTEXT|10 RETURNED_SQLSTATE COLUMN_NAME CONSTRAINT_NAME PG_DATATYPE_NAME|10 MESSAGE_TEXT TABLE_NAME SCHEMA_NAME PG_EXCEPTION_DETAIL|10 PG_EXCEPTION_HINT|10 PG_EXCEPTION_CONTEXT|10 ", _ = (
    // exceptions https://www.postgresql.org/docs/current/static/errcodes-appendix.html
    "SQLSTATE SQLERRM|10 SUCCESSFUL_COMPLETION WARNING DYNAMIC_RESULT_SETS_RETURNED IMPLICIT_ZERO_BIT_PADDING NULL_VALUE_ELIMINATED_IN_SET_FUNCTION PRIVILEGE_NOT_GRANTED PRIVILEGE_NOT_REVOKED STRING_DATA_RIGHT_TRUNCATION DEPRECATED_FEATURE NO_DATA NO_ADDITIONAL_DYNAMIC_RESULT_SETS_RETURNED SQL_STATEMENT_NOT_YET_COMPLETE CONNECTION_EXCEPTION CONNECTION_DOES_NOT_EXIST CONNECTION_FAILURE SQLCLIENT_UNABLE_TO_ESTABLISH_SQLCONNECTION SQLSERVER_REJECTED_ESTABLISHMENT_OF_SQLCONNECTION TRANSACTION_RESOLUTION_UNKNOWN PROTOCOL_VIOLATION TRIGGERED_ACTION_EXCEPTION FEATURE_NOT_SUPPORTED INVALID_TRANSACTION_INITIATION LOCATOR_EXCEPTION INVALID_LOCATOR_SPECIFICATION INVALID_GRANTOR INVALID_GRANT_OPERATION INVALID_ROLE_SPECIFICATION DIAGNOSTICS_EXCEPTION STACKED_DIAGNOSTICS_ACCESSED_WITHOUT_ACTIVE_HANDLER CASE_NOT_FOUND CARDINALITY_VIOLATION DATA_EXCEPTION ARRAY_SUBSCRIPT_ERROR CHARACTER_NOT_IN_REPERTOIRE DATETIME_FIELD_OVERFLOW DIVISION_BY_ZERO ERROR_IN_ASSIGNMENT ESCAPE_CHARACTER_CONFLICT INDICATOR_OVERFLOW INTERVAL_FIELD_OVERFLOW INVALID_ARGUMENT_FOR_LOGARITHM INVALID_ARGUMENT_FOR_NTILE_FUNCTION INVALID_ARGUMENT_FOR_NTH_VALUE_FUNCTION INVALID_ARGUMENT_FOR_POWER_FUNCTION INVALID_ARGUMENT_FOR_WIDTH_BUCKET_FUNCTION INVALID_CHARACTER_VALUE_FOR_CAST INVALID_DATETIME_FORMAT INVALID_ESCAPE_CHARACTER INVALID_ESCAPE_OCTET INVALID_ESCAPE_SEQUENCE NONSTANDARD_USE_OF_ESCAPE_CHARACTER INVALID_INDICATOR_PARAMETER_VALUE INVALID_PARAMETER_VALUE INVALID_REGULAR_EXPRESSION INVALID_ROW_COUNT_IN_LIMIT_CLAUSE INVALID_ROW_COUNT_IN_RESULT_OFFSET_CLAUSE INVALID_TABLESAMPLE_ARGUMENT INVALID_TABLESAMPLE_REPEAT INVALID_TIME_ZONE_DISPLACEMENT_VALUE INVALID_USE_OF_ESCAPE_CHARACTER MOST_SPECIFIC_TYPE_MISMATCH NULL_VALUE_NOT_ALLOWED NULL_VALUE_NO_INDICATOR_PARAMETER NUMERIC_VALUE_OUT_OF_RANGE SEQUENCE_GENERATOR_LIMIT_EXCEEDED STRING_DATA_LENGTH_MISMATCH STRING_DATA_RIGHT_TRUNCATION SUBSTRING_ERROR TRIM_ERROR UNTERMINATED_C_STRING ZERO_LENGTH_CHARACTER_STRING FLOATING_POINT_EXCEPTION INVALID_TEXT_REPRESENTATION INVALID_BINARY_REPRESENTATION BAD_COPY_FILE_FORMAT UNTRANSLATABLE_CHARACTER NOT_AN_XML_DOCUMENT INVALID_XML_DOCUMENT INVALID_XML_CONTENT INVALID_XML_COMMENT INVALID_XML_PROCESSING_INSTRUCTION INTEGRITY_CONSTRAINT_VIOLATION RESTRICT_VIOLATION NOT_NULL_VIOLATION FOREIGN_KEY_VIOLATION UNIQUE_VIOLATION CHECK_VIOLATION EXCLUSION_VIOLATION INVALID_CURSOR_STATE INVALID_TRANSACTION_STATE ACTIVE_SQL_TRANSACTION BRANCH_TRANSACTION_ALREADY_ACTIVE HELD_CURSOR_REQUIRES_SAME_ISOLATION_LEVEL INAPPROPRIATE_ACCESS_MODE_FOR_BRANCH_TRANSACTION INAPPROPRIATE_ISOLATION_LEVEL_FOR_BRANCH_TRANSACTION NO_ACTIVE_SQL_TRANSACTION_FOR_BRANCH_TRANSACTION READ_ONLY_SQL_TRANSACTION SCHEMA_AND_DATA_STATEMENT_MIXING_NOT_SUPPORTED NO_ACTIVE_SQL_TRANSACTION IN_FAILED_SQL_TRANSACTION IDLE_IN_TRANSACTION_SESSION_TIMEOUT INVALID_SQL_STATEMENT_NAME TRIGGERED_DATA_CHANGE_VIOLATION INVALID_AUTHORIZATION_SPECIFICATION INVALID_PASSWORD DEPENDENT_PRIVILEGE_DESCRIPTORS_STILL_EXIST DEPENDENT_OBJECTS_STILL_EXIST INVALID_TRANSACTION_TERMINATION SQL_ROUTINE_EXCEPTION FUNCTION_EXECUTED_NO_RETURN_STATEMENT MODIFYING_SQL_DATA_NOT_PERMITTED PROHIBITED_SQL_STATEMENT_ATTEMPTED READING_SQL_DATA_NOT_PERMITTED INVALID_CURSOR_NAME EXTERNAL_ROUTINE_EXCEPTION CONTAINING_SQL_NOT_PERMITTED MODIFYING_SQL_DATA_NOT_PERMITTED PROHIBITED_SQL_STATEMENT_ATTEMPTED READING_SQL_DATA_NOT_PERMITTED EXTERNAL_ROUTINE_INVOCATION_EXCEPTION INVALID_SQLSTATE_RETURNED NULL_VALUE_NOT_ALLOWED TRIGGER_PROTOCOL_VIOLATED SRF_PROTOCOL_VIOLATED EVENT_TRIGGER_PROTOCOL_VIOLATED SAVEPOINT_EXCEPTION INVALID_SAVEPOINT_SPECIFICATION INVALID_CATALOG_NAME INVALID_SCHEMA_NAME TRANSACTION_ROLLBACK TRANSACTION_INTEGRITY_CONSTRAINT_VIOLATION SERIALIZATION_FAILURE STATEMENT_COMPLETION_UNKNOWN DEADLOCK_DETECTED SYNTAX_ERROR_OR_ACCESS_RULE_VIOLATION SYNTAX_ERROR INSUFFICIENT_PRIVILEGE CANNOT_COERCE GROUPING_ERROR WINDOWING_ERROR INVALID_RECURSION INVALID_FOREIGN_KEY INVALID_NAME NAME_TOO_LONG RESERVED_NAME DATATYPE_MISMATCH INDETERMINATE_DATATYPE COLLATION_MISMATCH INDETERMINATE_COLLATION WRONG_OBJECT_TYPE GENERATED_ALWAYS UNDEFINED_COLUMN UNDEFINED_FUNCTION UNDEFINED_TABLE UNDEFINED_PARAMETER UNDEFINED_OBJECT DUPLICATE_COLUMN DUPLICATE_CURSOR DUPLICATE_DATABASE DUPLICATE_FUNCTION DUPLICATE_PREPARED_STATEMENT DUPLICATE_SCHEMA DUPLICATE_TABLE DUPLICATE_ALIAS DUPLICATE_OBJECT AMBIGUOUS_COLUMN AMBIGUOUS_FUNCTION AMBIGUOUS_PARAMETER AMBIGUOUS_ALIAS INVALID_COLUMN_REFERENCE INVALID_COLUMN_DEFINITION INVALID_CURSOR_DEFINITION INVALID_DATABASE_DEFINITION INVALID_FUNCTION_DEFINITION INVALID_PREPARED_STATEMENT_DEFINITION INVALID_SCHEMA_DEFINITION INVALID_TABLE_DEFINITION INVALID_OBJECT_DEFINITION WITH_CHECK_OPTION_VIOLATION INSUFFICIENT_RESOURCES DISK_FULL OUT_OF_MEMORY TOO_MANY_CONNECTIONS CONFIGURATION_LIMIT_EXCEEDED PROGRAM_LIMIT_EXCEEDED STATEMENT_TOO_COMPLEX TOO_MANY_COLUMNS TOO_MANY_ARGUMENTS OBJECT_NOT_IN_PREREQUISITE_STATE OBJECT_IN_USE CANT_CHANGE_RUNTIME_PARAM LOCK_NOT_AVAILABLE OPERATOR_INTERVENTION QUERY_CANCELED ADMIN_SHUTDOWN CRASH_SHUTDOWN CANNOT_CONNECT_NOW DATABASE_DROPPED SYSTEM_ERROR IO_ERROR UNDEFINED_FILE DUPLICATE_FILE SNAPSHOT_TOO_OLD CONFIG_FILE_ERROR LOCK_FILE_EXISTS FDW_ERROR FDW_COLUMN_NAME_NOT_FOUND FDW_DYNAMIC_PARAMETER_VALUE_NEEDED FDW_FUNCTION_SEQUENCE_ERROR FDW_INCONSISTENT_DESCRIPTOR_INFORMATION FDW_INVALID_ATTRIBUTE_VALUE FDW_INVALID_COLUMN_NAME FDW_INVALID_COLUMN_NUMBER FDW_INVALID_DATA_TYPE FDW_INVALID_DATA_TYPE_DESCRIPTORS FDW_INVALID_DESCRIPTOR_FIELD_IDENTIFIER FDW_INVALID_HANDLE FDW_INVALID_OPTION_INDEX FDW_INVALID_OPTION_NAME FDW_INVALID_STRING_LENGTH_OR_BUFFER_LENGTH FDW_INVALID_STRING_FORMAT FDW_INVALID_USE_OF_NULL_POINTER FDW_TOO_MANY_HANDLES FDW_OUT_OF_MEMORY FDW_NO_SCHEMAS FDW_OPTION_NAME_NOT_FOUND FDW_REPLY_HANDLE FDW_SCHEMA_NOT_FOUND FDW_TABLE_NOT_FOUND FDW_UNABLE_TO_CREATE_EXECUTION FDW_UNABLE_TO_CREATE_REPLY FDW_UNABLE_TO_ESTABLISH_CONNECTION PLPGSQL_ERROR RAISE_EXCEPTION NO_DATA_FOUND TOO_MANY_ROWS ASSERT_FAILURE INTERNAL_ERROR DATA_CORRUPTED INDEX_CORRUPTED "
  ), g = /* https://www.postgresql.org/docs/11/static/functions-aggregate.html */ "ARRAY_AGG AVG BIT_AND BIT_OR BOOL_AND BOOL_OR COUNT EVERY JSON_AGG JSONB_AGG JSON_OBJECT_AGG JSONB_OBJECT_AGG MAX MIN MODE STRING_AGG SUM XMLAGG CORR COVAR_POP COVAR_SAMP REGR_AVGX REGR_AVGY REGR_COUNT REGR_INTERCEPT REGR_R2 REGR_SLOPE REGR_SXX REGR_SXY REGR_SYY STDDEV STDDEV_POP STDDEV_SAMP VARIANCE VAR_POP VAR_SAMP PERCENTILE_CONT PERCENTILE_DISC ROW_NUMBER RANK DENSE_RANK PERCENT_RANK CUME_DIST NTILE LAG LEAD FIRST_VALUE LAST_VALUE NTH_VALUE NUM_NONNULLS NUM_NULLS ABS CBRT CEIL CEILING DEGREES DIV EXP FLOOR LN LOG MOD PI POWER RADIANS ROUND SCALE SIGN SQRT TRUNC WIDTH_BUCKET RANDOM SETSEED ACOS ACOSD ASIN ASIND ATAN ATAND ATAN2 ATAN2D COS COSD COT COTD SIN SIND TAN TAND BIT_LENGTH CHAR_LENGTH CHARACTER_LENGTH LOWER OCTET_LENGTH OVERLAY POSITION SUBSTRING TREAT TRIM UPPER ASCII BTRIM CHR CONCAT CONCAT_WS CONVERT CONVERT_FROM CONVERT_TO DECODE ENCODE INITCAP LEFT LENGTH LPAD LTRIM MD5 PARSE_IDENT PG_CLIENT_ENCODING QUOTE_IDENT|10 QUOTE_LITERAL|10 QUOTE_NULLABLE|10 REGEXP_MATCH REGEXP_MATCHES REGEXP_REPLACE REGEXP_SPLIT_TO_ARRAY REGEXP_SPLIT_TO_TABLE REPEAT REPLACE REVERSE RIGHT RPAD RTRIM SPLIT_PART STRPOS SUBSTR TO_ASCII TO_HEX TRANSLATE OCTET_LENGTH GET_BIT GET_BYTE SET_BIT SET_BYTE TO_CHAR TO_DATE TO_NUMBER TO_TIMESTAMP AGE CLOCK_TIMESTAMP|10 DATE_PART DATE_TRUNC ISFINITE JUSTIFY_DAYS JUSTIFY_HOURS JUSTIFY_INTERVAL MAKE_DATE MAKE_INTERVAL|10 MAKE_TIME MAKE_TIMESTAMP|10 MAKE_TIMESTAMPTZ|10 NOW STATEMENT_TIMESTAMP|10 TIMEOFDAY TRANSACTION_TIMESTAMP|10 ENUM_FIRST ENUM_LAST ENUM_RANGE AREA CENTER DIAMETER HEIGHT ISCLOSED ISOPEN NPOINTS PCLOSE POPEN RADIUS WIDTH BOX BOUND_BOX CIRCLE LINE LSEG PATH POLYGON ABBREV BROADCAST HOST HOSTMASK MASKLEN NETMASK NETWORK SET_MASKLEN TEXT INET_SAME_FAMILY INET_MERGE MACADDR8_SET7BIT ARRAY_TO_TSVECTOR GET_CURRENT_TS_CONFIG NUMNODE PLAINTO_TSQUERY PHRASETO_TSQUERY WEBSEARCH_TO_TSQUERY QUERYTREE SETWEIGHT STRIP TO_TSQUERY TO_TSVECTOR JSON_TO_TSVECTOR JSONB_TO_TSVECTOR TS_DELETE TS_FILTER TS_HEADLINE TS_RANK TS_RANK_CD TS_REWRITE TSQUERY_PHRASE TSVECTOR_TO_ARRAY TSVECTOR_UPDATE_TRIGGER TSVECTOR_UPDATE_TRIGGER_COLUMN XMLCOMMENT XMLCONCAT XMLELEMENT XMLFOREST XMLPI XMLROOT XMLEXISTS XML_IS_WELL_FORMED XML_IS_WELL_FORMED_DOCUMENT XML_IS_WELL_FORMED_CONTENT XPATH XPATH_EXISTS XMLTABLE XMLNAMESPACES TABLE_TO_XML TABLE_TO_XMLSCHEMA TABLE_TO_XML_AND_XMLSCHEMA QUERY_TO_XML QUERY_TO_XMLSCHEMA QUERY_TO_XML_AND_XMLSCHEMA CURSOR_TO_XML CURSOR_TO_XMLSCHEMA SCHEMA_TO_XML SCHEMA_TO_XMLSCHEMA SCHEMA_TO_XML_AND_XMLSCHEMA DATABASE_TO_XML DATABASE_TO_XMLSCHEMA DATABASE_TO_XML_AND_XMLSCHEMA XMLATTRIBUTES TO_JSON TO_JSONB ARRAY_TO_JSON ROW_TO_JSON JSON_BUILD_ARRAY JSONB_BUILD_ARRAY JSON_BUILD_OBJECT JSONB_BUILD_OBJECT JSON_OBJECT JSONB_OBJECT JSON_ARRAY_LENGTH JSONB_ARRAY_LENGTH JSON_EACH JSONB_EACH JSON_EACH_TEXT JSONB_EACH_TEXT JSON_EXTRACT_PATH JSONB_EXTRACT_PATH JSON_OBJECT_KEYS JSONB_OBJECT_KEYS JSON_POPULATE_RECORD JSONB_POPULATE_RECORD JSON_POPULATE_RECORDSET JSONB_POPULATE_RECORDSET JSON_ARRAY_ELEMENTS JSONB_ARRAY_ELEMENTS JSON_ARRAY_ELEMENTS_TEXT JSONB_ARRAY_ELEMENTS_TEXT JSON_TYPEOF JSONB_TYPEOF JSON_TO_RECORD JSONB_TO_RECORD JSON_TO_RECORDSET JSONB_TO_RECORDSET JSON_STRIP_NULLS JSONB_STRIP_NULLS JSONB_SET JSONB_INSERT JSONB_PRETTY CURRVAL LASTVAL NEXTVAL SETVAL COALESCE NULLIF GREATEST LEAST ARRAY_APPEND ARRAY_CAT ARRAY_NDIMS ARRAY_DIMS ARRAY_FILL ARRAY_LENGTH ARRAY_LOWER ARRAY_POSITION ARRAY_POSITIONS ARRAY_PREPEND ARRAY_REMOVE ARRAY_REPLACE ARRAY_TO_STRING ARRAY_UPPER CARDINALITY STRING_TO_ARRAY UNNEST ISEMPTY LOWER_INC UPPER_INC LOWER_INF UPPER_INF RANGE_MERGE GENERATE_SERIES GENERATE_SUBSCRIPTS CURRENT_DATABASE CURRENT_QUERY CURRENT_SCHEMA|10 CURRENT_SCHEMAS|10 INET_CLIENT_ADDR INET_CLIENT_PORT INET_SERVER_ADDR INET_SERVER_PORT ROW_SECURITY_ACTIVE FORMAT_TYPE TO_REGCLASS TO_REGPROC TO_REGPROCEDURE TO_REGOPER TO_REGOPERATOR TO_REGTYPE TO_REGNAMESPACE TO_REGROLE COL_DESCRIPTION OBJ_DESCRIPTION SHOBJ_DESCRIPTION TXID_CURRENT TXID_CURRENT_IF_ASSIGNED TXID_CURRENT_SNAPSHOT TXID_SNAPSHOT_XIP TXID_SNAPSHOT_XMAX TXID_SNAPSHOT_XMIN TXID_VISIBLE_IN_SNAPSHOT TXID_STATUS CURRENT_SETTING SET_CONFIG BRIN_SUMMARIZE_NEW_VALUES BRIN_SUMMARIZE_RANGE BRIN_DESUMMARIZE_RANGE GIN_CLEAN_PENDING_LIST SUPPRESS_REDUNDANT_UPDATES_TRIGGER LO_FROM_BYTEA LO_PUT LO_GET LO_CREAT LO_CREATE LO_UNLINK LO_IMPORT LO_EXPORT LOREAD LOWRITE GROUPING CAST ".trim().split(" ").map(function(S) {
    return S.split("|")[0];
  }).join("|");
  return {
    name: "PostgreSQL",
    aliases: [
      "postgres",
      "postgresql"
    ],
    supersetOf: "sql",
    case_insensitive: !0,
    keywords: {
      keyword: a + o + s,
      built_in: d + u + _
    },
    // Forbid some cunstructs from other languages to improve autodetect. In fact
    // "[a-z]:" is legal (as part of array slice), but improbabal.
    illegal: /:==|\W\s*\(\*|(^|\s)\$[a-z]|\{\{|[a-z]:\s*$|\.\.\.|TO:|DO:/,
    contains: [
      // special handling of some words, which are reserved only in some contexts
      {
        className: "keyword",
        variants: [
          { begin: /\bTEXT\s*SEARCH\b/ },
          { begin: /\b(PRIMARY|FOREIGN|FOR(\s+NO)?)\s+KEY\b/ },
          { begin: /\bPARALLEL\s+(UNSAFE|RESTRICTED|SAFE)\b/ },
          { begin: /\bSTORAGE\s+(PLAIN|EXTERNAL|EXTENDED|MAIN)\b/ },
          { begin: /\bMATCH\s+(FULL|PARTIAL|SIMPLE)\b/ },
          { begin: /\bNULLS\s+(FIRST|LAST)\b/ },
          { begin: /\bEVENT\s+TRIGGER\b/ },
          { begin: /\b(MAPPING|OR)\s+REPLACE\b/ },
          { begin: /\b(FROM|TO)\s+(PROGRAM|STDIN|STDOUT)\b/ },
          { begin: /\b(SHARE|EXCLUSIVE)\s+MODE\b/ },
          { begin: /\b(LEFT|RIGHT)\s+(OUTER\s+)?JOIN\b/ },
          { begin: /\b(FETCH|MOVE)\s+(NEXT|PRIOR|FIRST|LAST|ABSOLUTE|RELATIVE|FORWARD|BACKWARD)\b/ },
          { begin: /\bPRESERVE\s+ROWS\b/ },
          { begin: /\bDISCARD\s+PLANS\b/ },
          { begin: /\bREFERENCING\s+(OLD|NEW)\b/ },
          { begin: /\bSKIP\s+LOCKED\b/ },
          { begin: /\bGROUPING\s+SETS\b/ },
          { begin: /\b(BINARY|INSENSITIVE|SCROLL|NO\s+SCROLL)\s+(CURSOR|FOR)\b/ },
          { begin: /\b(WITH|WITHOUT)\s+HOLD\b/ },
          { begin: /\bWITH\s+(CASCADED|LOCAL)\s+CHECK\s+OPTION\b/ },
          { begin: /\bEXCLUDE\s+(TIES|NO\s+OTHERS)\b/ },
          { begin: /\bFORMAT\s+(TEXT|XML|JSON|YAML)\b/ },
          { begin: /\bSET\s+((SESSION|LOCAL)\s+)?NAMES\b/ },
          { begin: /\bIS\s+(NOT\s+)?UNKNOWN\b/ },
          { begin: /\bSECURITY\s+LABEL\b/ },
          { begin: /\bSTANDALONE\s+(YES|NO|NO\s+VALUE)\b/ },
          { begin: /\bWITH\s+(NO\s+)?DATA\b/ },
          { begin: /\b(FOREIGN|SET)\s+DATA\b/ },
          { begin: /\bSET\s+(CATALOG|CONSTRAINTS)\b/ },
          { begin: /\b(WITH|FOR)\s+ORDINALITY\b/ },
          { begin: /\bIS\s+(NOT\s+)?DOCUMENT\b/ },
          { begin: /\bXML\s+OPTION\s+(DOCUMENT|CONTENT)\b/ },
          { begin: /\b(STRIP|PRESERVE)\s+WHITESPACE\b/ },
          { begin: /\bNO\s+(ACTION|MAXVALUE|MINVALUE)\b/ },
          { begin: /\bPARTITION\s+BY\s+(RANGE|LIST|HASH)\b/ },
          { begin: /\bAT\s+TIME\s+ZONE\b/ },
          { begin: /\bGRANTED\s+BY\b/ },
          { begin: /\bRETURN\s+(QUERY|NEXT)\b/ },
          { begin: /\b(ATTACH|DETACH)\s+PARTITION\b/ },
          { begin: /\bFORCE\s+ROW\s+LEVEL\s+SECURITY\b/ },
          { begin: /\b(INCLUDING|EXCLUDING)\s+(COMMENTS|CONSTRAINTS|DEFAULTS|IDENTITY|INDEXES|STATISTICS|STORAGE|ALL)\b/ },
          { begin: /\bAS\s+(ASSIGNMENT|IMPLICIT|PERMISSIVE|RESTRICTIVE|ENUM|RANGE)\b/ }
        ]
      },
      // functions named as keywords, followed by '('
      {
        begin: /\b(FORMAT|FAMILY|VERSION)\s*\(/
        // keywords: { built_in: 'FORMAT FAMILY VERSION' }
      },
      // INCLUDE ( ... ) in index_parameters in CREATE TABLE
      {
        begin: /\bINCLUDE\s*\(/,
        keywords: "INCLUDE"
      },
      // not highlight RANGE if not in frame_clause (not 100% correct, but seems satisfactory)
      { begin: /\bRANGE(?!\s*(BETWEEN|UNBOUNDED|CURRENT|[-0-9]+))/ },
      // disable highlighting in commands CREATE AGGREGATE/COLLATION/DATABASE/OPERTOR/TEXT SEARCH .../TYPE
      // and in PL/pgSQL RAISE ... USING
      { begin: /\b(VERSION|OWNER|TEMPLATE|TABLESPACE|CONNECTION\s+LIMIT|PROCEDURE|RESTRICT|JOIN|PARSER|COPY|START|END|COLLATION|INPUT|ANALYZE|STORAGE|LIKE|DEFAULT|DELIMITER|ENCODING|COLUMN|CONSTRAINT|TABLE|SCHEMA)\s*=/ },
      // PG_smth; HAS_some_PRIVILEGE
      {
        // className: 'built_in',
        begin: /\b(PG_\w+?|HAS_[A-Z_]+_PRIVILEGE)\b/,
        relevance: 10
      },
      // extract
      {
        begin: /\bEXTRACT\s*\(/,
        end: /\bFROM\b/,
        returnEnd: !0,
        keywords: {
          // built_in: 'EXTRACT',
          type: "CENTURY DAY DECADE DOW DOY EPOCH HOUR ISODOW ISOYEAR MICROSECONDS MILLENNIUM MILLISECONDS MINUTE MONTH QUARTER SECOND TIMEZONE TIMEZONE_HOUR TIMEZONE_MINUTE WEEK YEAR"
        }
      },
      // xmlelement, xmlpi - special NAME
      {
        begin: /\b(XMLELEMENT|XMLPI)\s*\(\s*NAME/,
        keywords: {
          // built_in: 'XMLELEMENT XMLPI',
          keyword: "NAME"
        }
      },
      // xmlparse, xmlserialize
      {
        begin: /\b(XMLPARSE|XMLSERIALIZE)\s*\(\s*(DOCUMENT|CONTENT)/,
        keywords: {
          // built_in: 'XMLPARSE XMLSERIALIZE',
          keyword: "DOCUMENT CONTENT"
        }
      },
      // Sequences. We actually skip everything between CACHE|INCREMENT|MAXVALUE|MINVALUE and
      // nearest following numeric constant. Without with trick we find a lot of "keywords"
      // in 'avrasm' autodetection test...
      {
        beginKeywords: "CACHE INCREMENT MAXVALUE MINVALUE",
        end: t.C_NUMBER_RE,
        returnEnd: !0,
        keywords: "BY CACHE INCREMENT MAXVALUE MINVALUE"
      },
      // WITH|WITHOUT TIME ZONE as part of datatype
      {
        className: "type",
        begin: /\b(WITH|WITHOUT)\s+TIME\s+ZONE\b/
      },
      // INTERVAL optional fields
      {
        className: "type",
        begin: /\bINTERVAL\s+(YEAR|MONTH|DAY|HOUR|MINUTE|SECOND)(\s+TO\s+(MONTH|HOUR|MINUTE|SECOND))?\b/
      },
      // Pseudo-types which allowed only as return type
      {
        begin: /\bRETURNS\s+(LANGUAGE_HANDLER|TRIGGER|EVENT_TRIGGER|FDW_HANDLER|INDEX_AM_HANDLER|TSM_HANDLER)\b/,
        keywords: {
          keyword: "RETURNS",
          type: "LANGUAGE_HANDLER TRIGGER EVENT_TRIGGER FDW_HANDLER INDEX_AM_HANDLER TSM_HANDLER"
        }
      },
      // Known functions - only when followed by '('
      {
        begin: "\\b(" + g + ")\\s*\\("
        // keywords: { built_in: FUNCTIONS }
      },
      // Types
      {
        begin: "\\.(" + c + ")\\b"
        // prevent highlight as type, say, 'oid' in 'pgclass.oid'
      },
      {
        begin: "\\b(" + c + ")\\s+PATH\\b",
        // in XMLTABLE
        keywords: {
          keyword: "PATH",
          // hopefully no one would use PATH type in XMLTABLE...
          type: l.replace("PATH ", "")
        }
      },
      {
        className: "type",
        begin: "\\b(" + c + ")\\b"
      },
      // Strings, see https://www.postgresql.org/docs/11/static/sql-syntax-lexical.html#SQL-SYNTAX-CONSTANTS
      {
        className: "string",
        begin: "'",
        end: "'",
        contains: [{ begin: "''" }]
      },
      {
        className: "string",
        begin: "(e|E|u&|U&)'",
        end: "'",
        contains: [{ begin: "\\\\." }],
        relevance: 10
      },
      t.END_SAME_AS_BEGIN({
        begin: i,
        end: i,
        contains: [
          {
            // actually we want them all except SQL; listed are those with known implementations
            // and XML + JSON just in case
            subLanguage: [
              "pgsql",
              "perl",
              "python",
              "tcl",
              "r",
              "lua",
              "java",
              "php",
              "ruby",
              "bash",
              "scheme",
              "xml",
              "json"
            ],
            endsWithParent: !0
          }
        ]
      }),
      // identifiers in quotes
      {
        begin: '"',
        end: '"',
        contains: [{ begin: '""' }]
      },
      // numbers
      t.C_NUMBER_MODE,
      // comments
      t.C_BLOCK_COMMENT_MODE,
      e,
      // PL/pgSQL staff
      // %ROWTYPE, %TYPE, $n
      {
        className: "meta",
        variants: [
          {
            // %TYPE, %ROWTYPE
            begin: "%(ROW)?TYPE",
            relevance: 10
          },
          {
            // $n
            begin: "\\$\\d+"
          },
          {
            // #compiler option
            begin: "^#\\w",
            end: "$"
          }
        ]
      },
      // <<labeles>>
      {
        className: "symbol",
        begin: r,
        relevance: 10
      }
    ]
  };
}
function Ig(t) {
  const e = {
    keyword: "actor addressof and as be break class compile_error compile_intrinsic consume continue delegate digestof do else elseif embed end error for fun if ifdef in interface is isnt lambda let match new not object or primitive recover repeat return struct then trait try type until use var where while with xor",
    meta: "iso val tag trn box ref",
    literal: "this false true"
  }, n = {
    className: "string",
    begin: '"""',
    end: '"""',
    relevance: 10
  }, i = {
    className: "string",
    begin: '"',
    end: '"',
    contains: [t.BACKSLASH_ESCAPE]
  }, r = {
    className: "string",
    begin: "'",
    end: "'",
    contains: [t.BACKSLASH_ESCAPE],
    relevance: 0
  }, a = {
    className: "type",
    begin: "\\b_?[A-Z][\\w]*",
    relevance: 0
  }, s = {
    begin: t.IDENT_RE + "'",
    relevance: 0
  };
  return {
    name: "Pony",
    keywords: e,
    contains: [
      a,
      n,
      i,
      r,
      s,
      {
        className: "number",
        begin: "(-?)(\\b0[xX][a-fA-F0-9]+|\\b0[bB][01]+|(\\b\\d+(_\\d+)?(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)",
        relevance: 0
      },
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE
    ]
  };
}
function Dg(t) {
  const e = [
    "string",
    "char",
    "byte",
    "int",
    "long",
    "bool",
    "decimal",
    "single",
    "double",
    "DateTime",
    "xml",
    "array",
    "hashtable",
    "void"
  ], n = "Add|Clear|Close|Copy|Enter|Exit|Find|Format|Get|Hide|Join|Lock|Move|New|Open|Optimize|Pop|Push|Redo|Remove|Rename|Reset|Resize|Search|Select|Set|Show|Skip|Split|Step|Switch|Undo|Unlock|Watch|Backup|Checkpoint|Compare|Compress|Convert|ConvertFrom|ConvertTo|Dismount|Edit|Expand|Export|Group|Import|Initialize|Limit|Merge|Mount|Out|Publish|Restore|Save|Sync|Unpublish|Update|Approve|Assert|Build|Complete|Confirm|Deny|Deploy|Disable|Enable|Install|Invoke|Register|Request|Restart|Resume|Start|Stop|Submit|Suspend|Uninstall|Unregister|Wait|Debug|Measure|Ping|Repair|Resolve|Test|Trace|Connect|Disconnect|Read|Receive|Send|Write|Block|Grant|Protect|Revoke|Unblock|Unprotect|Use|ForEach|Sort|Tee|Where", i = "-and|-as|-band|-bnot|-bor|-bxor|-casesensitive|-ccontains|-ceq|-cge|-cgt|-cle|-clike|-clt|-cmatch|-cne|-cnotcontains|-cnotlike|-cnotmatch|-contains|-creplace|-csplit|-eq|-exact|-f|-file|-ge|-gt|-icontains|-ieq|-ige|-igt|-ile|-ilike|-ilt|-imatch|-in|-ine|-inotcontains|-inotlike|-inotmatch|-ireplace|-is|-isnot|-isplit|-join|-le|-like|-lt|-match|-ne|-not|-notcontains|-notin|-notlike|-notmatch|-or|-regex|-replace|-shl|-shr|-split|-wildcard|-xor", r = {
    $pattern: /-?[A-z\.\-]+\b/,
    keyword: "if else foreach return do while until elseif begin for trap data dynamicparam end break throw param continue finally in switch exit filter try process catch hidden static parameter",
    // "echo" relevance has been set to 0 to avoid auto-detect conflicts with shell transcripts
    built_in: "ac asnp cat cd CFS chdir clc clear clhy cli clp cls clv cnsn compare copy cp cpi cpp curl cvpa dbp del diff dir dnsn ebp echo|0 epal epcsv epsn erase etsn exsn fc fhx fl ft fw gal gbp gc gcb gci gcm gcs gdr gerr ghy gi gin gjb gl gm gmo gp gps gpv group gsn gsnp gsv gtz gu gv gwmi h history icm iex ihy ii ipal ipcsv ipmo ipsn irm ise iwmi iwr kill lp ls man md measure mi mount move mp mv nal ndr ni nmo npssc nsn nv ogv oh popd ps pushd pwd r rbp rcjb rcsn rd rdr ren ri rjb rm rmdir rmo rni rnp rp rsn rsnp rujb rv rvpa rwmi sajb sal saps sasv sbp sc scb select set shcm si sl sleep sls sort sp spjb spps spsv start stz sujb sv swmi tee trcm type wget where wjb write"
    // TODO: 'validate[A-Z]+' can't work in keywords
  }, a = /\w[\w\d]*((-)[\w\d]+)*/, s = {
    begin: "`[\\s\\S]",
    relevance: 0
  }, o = {
    className: "variable",
    variants: [
      { begin: /\$\B/ },
      {
        className: "keyword",
        begin: /\$this/
      },
      { begin: /\$[\w\d][\w\d_:]*/ }
    ]
  }, l = {
    className: "literal",
    begin: /\$(null|true|false)\b/
  }, c = {
    className: "string",
    variants: [
      {
        begin: /"/,
        end: /"/
      },
      {
        begin: /@"/,
        end: /^"@/
      }
    ],
    contains: [
      s,
      o,
      {
        className: "variable",
        begin: /\$[A-z]/,
        end: /[^A-z]/
      }
    ]
  }, d = {
    className: "string",
    variants: [
      {
        begin: /'/,
        end: /'/
      },
      {
        begin: /@'/,
        end: /^'@/
      }
    ]
  }, u = {
    className: "doctag",
    variants: [
      /* no paramater help tags */
      { begin: /\.(synopsis|description|example|inputs|outputs|notes|link|component|role|functionality)/ },
      /* one parameter help tags */
      { begin: /\.(parameter|forwardhelptargetname|forwardhelpcategory|remotehelprunspace|externalhelp)\s+\S+/ }
    ]
  }, _ = t.inherit(
    t.COMMENT(null, null),
    {
      variants: [
        /* single-line comment */
        {
          begin: /#/,
          end: /$/
        },
        /* multi-line comment */
        {
          begin: /<#/,
          end: /#>/
        }
      ],
      contains: [u]
    }
  ), m = {
    className: "built_in",
    variants: [{ begin: "(".concat(n, ")+(-)[\\w\\d]+") }]
  }, g = {
    className: "class",
    beginKeywords: "class enum",
    end: /\s*[{]/,
    excludeEnd: !0,
    relevance: 0,
    contains: [t.TITLE_MODE]
  }, S = {
    className: "function",
    begin: /function\s+/,
    end: /\s*\{|$/,
    excludeEnd: !0,
    returnBegin: !0,
    relevance: 0,
    contains: [
      {
        begin: "function",
        relevance: 0,
        className: "keyword"
      },
      {
        className: "title",
        begin: a,
        relevance: 0
      },
      {
        begin: /\(/,
        end: /\)/,
        className: "params",
        relevance: 0,
        contains: [o]
      }
      // CMDLETS
    ]
  }, E = {
    begin: /using\s/,
    end: /$/,
    returnBegin: !0,
    contains: [
      c,
      d,
      {
        className: "keyword",
        begin: /(using|assembly|command|module|namespace|type)/
      }
    ]
  }, h = { variants: [
    // PS literals are pretty verbose so it's a good idea to accent them a bit.
    {
      className: "operator",
      begin: "(".concat(i, ")\\b")
    },
    {
      className: "literal",
      begin: /(-){1,2}[\w\d-]+/,
      relevance: 0
    }
  ] }, T = {
    className: "selector-tag",
    begin: /@\B/,
    relevance: 0
  }, b = {
    className: "function",
    begin: /\[.*\]\s*[\w]+[ ]??\(/,
    end: /$/,
    returnBegin: !0,
    relevance: 0,
    contains: [
      {
        className: "keyword",
        begin: "(".concat(
          r.keyword.toString().replace(
            /\s/g,
            "|"
          ),
          ")\\b"
        ),
        endsParent: !0,
        relevance: 0
      },
      t.inherit(t.TITLE_MODE, { endsParent: !0 })
    ]
  }, C = [
    // STATIC_MEMBER,
    b,
    _,
    s,
    t.NUMBER_MODE,
    c,
    d,
    // PS_NEW_OBJECT_TYPE,
    m,
    o,
    l,
    T
  ], y = {
    begin: /\[/,
    end: /\]/,
    excludeBegin: !0,
    excludeEnd: !0,
    relevance: 0,
    contains: [].concat(
      "self",
      C,
      {
        begin: "(" + e.join("|") + ")",
        className: "built_in",
        relevance: 0
      },
      {
        className: "type",
        begin: /[\.\w\d]+/,
        relevance: 0
      }
    )
  };
  return b.contains.unshift(y), {
    name: "PowerShell",
    aliases: [
      "pwsh",
      "ps",
      "ps1"
    ],
    case_insensitive: !0,
    keywords: r,
    contains: C.concat(
      g,
      S,
      E,
      h,
      y
    )
  };
}
function Mg(t) {
  const e = t.regex, n = [
    "displayHeight",
    "displayWidth",
    "mouseY",
    "mouseX",
    "mousePressed",
    "pmouseX",
    "pmouseY",
    "key",
    "keyCode",
    "pixels",
    "focused",
    "frameCount",
    "frameRate",
    "height",
    "width",
    "size",
    "createGraphics",
    "beginDraw",
    "createShape",
    "loadShape",
    "PShape",
    "arc",
    "ellipse",
    "line",
    "point",
    "quad",
    "rect",
    "triangle",
    "bezier",
    "bezierDetail",
    "bezierPoint",
    "bezierTangent",
    "curve",
    "curveDetail",
    "curvePoint",
    "curveTangent",
    "curveTightness",
    "shape",
    "shapeMode",
    "beginContour",
    "beginShape",
    "bezierVertex",
    "curveVertex",
    "endContour",
    "endShape",
    "quadraticVertex",
    "vertex",
    "ellipseMode",
    "noSmooth",
    "rectMode",
    "smooth",
    "strokeCap",
    "strokeJoin",
    "strokeWeight",
    "mouseClicked",
    "mouseDragged",
    "mouseMoved",
    "mousePressed",
    "mouseReleased",
    "mouseWheel",
    "keyPressed",
    "keyPressedkeyReleased",
    "keyTyped",
    "print",
    "println",
    "save",
    "saveFrame",
    "day",
    "hour",
    "millis",
    "minute",
    "month",
    "second",
    "year",
    "background",
    "clear",
    "colorMode",
    "fill",
    "noFill",
    "noStroke",
    "stroke",
    "alpha",
    "blue",
    "brightness",
    "color",
    "green",
    "hue",
    "lerpColor",
    "red",
    "saturation",
    "modelX",
    "modelY",
    "modelZ",
    "screenX",
    "screenY",
    "screenZ",
    "ambient",
    "emissive",
    "shininess",
    "specular",
    "add",
    "createImage",
    "beginCamera",
    "camera",
    "endCamera",
    "frustum",
    "ortho",
    "perspective",
    "printCamera",
    "printProjection",
    "cursor",
    "frameRate",
    "noCursor",
    "exit",
    "loop",
    "noLoop",
    "popStyle",
    "pushStyle",
    "redraw",
    "binary",
    "boolean",
    "byte",
    "char",
    "float",
    "hex",
    "int",
    "str",
    "unbinary",
    "unhex",
    "join",
    "match",
    "matchAll",
    "nf",
    "nfc",
    "nfp",
    "nfs",
    "split",
    "splitTokens",
    "trim",
    "append",
    "arrayCopy",
    "concat",
    "expand",
    "reverse",
    "shorten",
    "sort",
    "splice",
    "subset",
    "box",
    "sphere",
    "sphereDetail",
    "createInput",
    "createReader",
    "loadBytes",
    "loadJSONArray",
    "loadJSONObject",
    "loadStrings",
    "loadTable",
    "loadXML",
    "open",
    "parseXML",
    "saveTable",
    "selectFolder",
    "selectInput",
    "beginRaw",
    "beginRecord",
    "createOutput",
    "createWriter",
    "endRaw",
    "endRecord",
    "PrintWritersaveBytes",
    "saveJSONArray",
    "saveJSONObject",
    "saveStream",
    "saveStrings",
    "saveXML",
    "selectOutput",
    "popMatrix",
    "printMatrix",
    "pushMatrix",
    "resetMatrix",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "scale",
    "shearX",
    "shearY",
    "translate",
    "ambientLight",
    "directionalLight",
    "lightFalloff",
    "lights",
    "lightSpecular",
    "noLights",
    "normal",
    "pointLight",
    "spotLight",
    "image",
    "imageMode",
    "loadImage",
    "noTint",
    "requestImage",
    "tint",
    "texture",
    "textureMode",
    "textureWrap",
    "blend",
    "copy",
    "filter",
    "get",
    "loadPixels",
    "set",
    "updatePixels",
    "blendMode",
    "loadShader",
    "PShaderresetShader",
    "shader",
    "createFont",
    "loadFont",
    "text",
    "textFont",
    "textAlign",
    "textLeading",
    "textMode",
    "textSize",
    "textWidth",
    "textAscent",
    "textDescent",
    "abs",
    "ceil",
    "constrain",
    "dist",
    "exp",
    "floor",
    "lerp",
    "log",
    "mag",
    "map",
    "max",
    "min",
    "norm",
    "pow",
    "round",
    "sq",
    "sqrt",
    "acos",
    "asin",
    "atan",
    "atan2",
    "cos",
    "degrees",
    "radians",
    "sin",
    "tan",
    "noise",
    "noiseDetail",
    "noiseSeed",
    "random",
    "randomGaussian",
    "randomSeed"
  ], i = t.IDENT_RE, r = { variants: [
    {
      match: e.concat(e.either(...n), e.lookahead(/\s*\(/)),
      className: "built_in"
    },
    {
      relevance: 0,
      match: e.concat(
        /\b(?!for|if|while)/,
        i,
        e.lookahead(/\s*\(/)
      ),
      className: "title.function"
    }
  ] }, a = {
    match: [
      /new\s+/,
      i
    ],
    className: {
      1: "keyword",
      2: "class.title"
    }
  }, s = {
    relevance: 0,
    match: [
      /\./,
      i
    ],
    className: { 2: "property" }
  }, o = {
    variants: [
      { match: [
        /class/,
        /\s+/,
        i,
        /\s+/,
        /extends/,
        /\s+/,
        i
      ] },
      { match: [
        /class/,
        /\s+/,
        i
      ] }
    ],
    className: {
      1: "keyword",
      3: "title.class",
      5: "keyword",
      7: "title.class.inherited"
    }
  }, l = [
    "boolean",
    "byte",
    "char",
    "color",
    "double",
    "float",
    "int",
    "long",
    "short"
  ], c = [
    "BufferedReader",
    "PVector",
    "PFont",
    "PImage",
    "PGraphics",
    "HashMap",
    "String",
    "Array",
    "FloatDict",
    "ArrayList",
    "FloatList",
    "IntDict",
    "IntList",
    "JSONArray",
    "JSONObject",
    "Object",
    "StringDict",
    "StringList",
    "Table",
    "TableRow",
    "XML"
  ];
  return {
    name: "Processing",
    aliases: ["pde"],
    keywords: {
      keyword: [...[
        "abstract",
        "assert",
        "break",
        "case",
        "catch",
        "const",
        "continue",
        "default",
        "else",
        "enum",
        "final",
        "finally",
        "for",
        "if",
        "import",
        "instanceof",
        "long",
        "native",
        "new",
        "package",
        "private",
        "private",
        "protected",
        "protected",
        "public",
        "public",
        "return",
        "static",
        "strictfp",
        "switch",
        "synchronized",
        "throw",
        "throws",
        "transient",
        "try",
        "void",
        "volatile",
        "while"
      ]],
      literal: "P2D P3D HALF_PI PI QUARTER_PI TAU TWO_PI null true false",
      title: "setup draw",
      variable: "super this",
      built_in: [
        ...n,
        ...c
      ],
      type: l
    },
    contains: [
      o,
      a,
      r,
      s,
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE,
      t.C_NUMBER_MODE
    ]
  };
}
function wg(t) {
  return {
    name: "Python profiler",
    contains: [
      t.C_NUMBER_MODE,
      {
        begin: "[a-zA-Z_][\\da-zA-Z_]+\\.[\\da-zA-Z_]{1,3}",
        end: ":",
        excludeEnd: !0
      },
      {
        begin: "(ncalls|tottime|cumtime)",
        end: "$",
        keywords: "ncalls tottime|10 cumtime|10 filename",
        relevance: 10
      },
      {
        begin: "function calls",
        end: "$",
        contains: [t.C_NUMBER_MODE],
        relevance: 10
      },
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE,
      {
        className: "string",
        begin: "\\(",
        end: "\\)$",
        excludeBegin: !0,
        excludeEnd: !0,
        relevance: 0
      }
    ]
  };
}
function xg(t) {
  const e = {
    begin: /[a-z][A-Za-z0-9_]*/,
    relevance: 0
  }, n = {
    className: "symbol",
    variants: [
      { begin: /[A-Z][a-zA-Z0-9_]*/ },
      { begin: /_[A-Za-z0-9_]*/ }
    ],
    relevance: 0
  }, i = {
    begin: /\(/,
    end: /\)/,
    relevance: 0
  }, r = {
    begin: /\[/,
    end: /\]/
  }, a = {
    className: "comment",
    begin: /%/,
    end: /$/,
    contains: [t.PHRASAL_WORDS_MODE]
  }, s = {
    className: "string",
    begin: /`/,
    end: /`/,
    contains: [t.BACKSLASH_ESCAPE]
  }, o = {
    className: "string",
    // 0'a etc.
    begin: /0'(\\'|.)/
  }, l = {
    className: "string",
    begin: /0'\\s/
    // 0'\s
  }, d = [
    e,
    n,
    i,
    {
      // relevance booster
      begin: /:-/
    },
    r,
    a,
    t.C_BLOCK_COMMENT_MODE,
    t.QUOTE_STRING_MODE,
    t.APOS_STRING_MODE,
    s,
    o,
    l,
    t.C_NUMBER_MODE
  ];
  return i.contains = d, r.contains = d, {
    name: "Prolog",
    contains: d.concat([
      {
        // relevance booster
        begin: /\.$/
      }
    ])
  };
}
function Lg(t) {
  const e = "[ \\t\\f]*", n = "[ \\t\\f]+", i = e + "[:=]" + e, r = n, a = "(" + i + "|" + r + ")", s = "([^\\\\:= \\t\\f\\n]|\\\\.)+", o = {
    // skip DELIM
    end: a,
    relevance: 0,
    starts: {
      // value: everything until end of line (again, taking into account backslashes)
      className: "string",
      end: /$/,
      relevance: 0,
      contains: [
        { begin: "\\\\\\\\" },
        { begin: "\\\\\\n" }
      ]
    }
  };
  return {
    name: ".properties",
    disableAutodetect: !0,
    case_insensitive: !0,
    illegal: /\S/,
    contains: [
      t.COMMENT("^\\s*[!#]", "$"),
      // key: everything until whitespace or = or : (taking into account backslashes)
      // case of a key-value pair
      {
        returnBegin: !0,
        variants: [
          { begin: s + i },
          { begin: s + r }
        ],
        contains: [
          {
            className: "attr",
            begin: s,
            endsParent: !0
          }
        ],
        starts: o
      },
      // case of an empty key
      {
        className: "attr",
        begin: s + e + "$"
      }
    ]
  };
}
function Pg(t) {
  const e = [
    "package",
    "import",
    "option",
    "optional",
    "required",
    "repeated",
    "group",
    "oneof"
  ], n = [
    "double",
    "float",
    "int32",
    "int64",
    "uint32",
    "uint64",
    "sint32",
    "sint64",
    "fixed32",
    "fixed64",
    "sfixed32",
    "sfixed64",
    "bool",
    "string",
    "bytes"
  ], i = {
    match: [
      /(message|enum|service)\s+/,
      t.IDENT_RE
    ],
    scope: {
      1: "keyword",
      2: "title.class"
    }
  };
  return {
    name: "Protocol Buffers",
    aliases: ["proto"],
    keywords: {
      keyword: e,
      type: n,
      literal: [
        "true",
        "false"
      ]
    },
    contains: [
      t.QUOTE_STRING_MODE,
      t.NUMBER_MODE,
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      i,
      {
        className: "function",
        beginKeywords: "rpc",
        end: /[{;]/,
        excludeEnd: !0,
        keywords: "rpc returns"
      },
      {
        // match enum items (relevance)
        // BLAH = ...;
        begin: /^\s*[A-Z_]+(?=\s*=[^\n]+;$)/
      }
    ]
  };
}
function kg(t) {
  const e = {
    keyword: (
      /* language keywords */
      "and case default else elsif false if in import enherits node or true undef unless main settings $string "
    ),
    literal: (
      /* metaparameters */
      "alias audit before loglevel noop require subscribe tag owner ensure group mode name|0 changes context force incl lens load_path onlyif provider returns root show_diff type_check en_address ip_address realname command environment hour monute month monthday special target weekday creates cwd ogoutput refresh refreshonly tries try_sleep umask backup checksum content ctime force ignore links mtime purge recurse recurselimit replace selinux_ignore_defaults selrange selrole seltype seluser source souirce_permissions sourceselect validate_cmd validate_replacement allowdupe attribute_membership auth_membership forcelocal gid ia_load_module members system host_aliases ip allowed_trunk_vlans description device_url duplex encapsulation etherchannel native_vlan speed principals allow_root auth_class auth_type authenticate_user k_of_n mechanisms rule session_owner shared options device fstype enable hasrestart directory present absent link atboot blockdevice device dump pass remounts poller_tag use message withpath adminfile allow_virtual allowcdrom category configfiles flavor install_options instance package_settings platform responsefile status uninstall_options vendor unless_system_user unless_uid binary control flags hasstatus manifest pattern restart running start stop allowdupe auths expiry gid groups home iterations key_membership keys managehome membership password password_max_age password_min_age profile_membership profiles project purge_ssh_keys role_membership roles salt shell uid baseurl cost descr enabled enablegroups exclude failovermethod gpgcheck gpgkey http_caching include includepkgs keepalive metadata_expire metalink mirrorlist priority protect proxy proxy_password proxy_username repo_gpgcheck s3_enabled skip_if_unavailable sslcacert sslclientcert sslclientkey sslverify mounted"
    ),
    built_in: (
      /* core facts */
      "architecture augeasversion blockdevices boardmanufacturer boardproductname boardserialnumber cfkey dhcp_servers domain ec2_ ec2_userdata facterversion filesystems ldom fqdn gid hardwareisa hardwaremodel hostname id|0 interfaces ipaddress ipaddress_ ipaddress6 ipaddress6_ iphostnumber is_virtual kernel kernelmajversion kernelrelease kernelversion kernelrelease kernelversion lsbdistcodename lsbdistdescription lsbdistid lsbdistrelease lsbmajdistrelease lsbminordistrelease lsbrelease macaddress macaddress_ macosx_buildversion macosx_productname macosx_productversion macosx_productverson_major macosx_productversion_minor manufacturer memoryfree memorysize netmask metmask_ network_ operatingsystem operatingsystemmajrelease operatingsystemrelease osfamily partitions path physicalprocessorcount processor processorcount productname ps puppetversion rubysitedir rubyversion selinux selinux_config_mode selinux_config_policy selinux_current_mode selinux_current_mode selinux_enforced selinux_policyversion serialnumber sp_ sshdsakey sshecdsakey sshrsakey swapencrypted swapfree swapsize timezone type uniqueid uptime uptime_days uptime_hours uptime_seconds uuid virtual vlans xendomains zfs_version zonenae zones zpool_version"
    )
  }, n = t.COMMENT("#", "$"), i = "([A-Za-z_]|::)(\\w|::)*", r = t.inherit(t.TITLE_MODE, { begin: i }), a = {
    className: "variable",
    begin: "\\$" + i
  }, s = {
    className: "string",
    contains: [
      t.BACKSLASH_ESCAPE,
      a
    ],
    variants: [
      {
        begin: /'/,
        end: /'/
      },
      {
        begin: /"/,
        end: /"/
      }
    ]
  };
  return {
    name: "Puppet",
    aliases: ["pp"],
    contains: [
      n,
      a,
      s,
      {
        beginKeywords: "class",
        end: "\\{|;",
        illegal: /=/,
        contains: [
          r,
          n
        ]
      },
      {
        beginKeywords: "define",
        end: /\{/,
        contains: [
          {
            className: "section",
            begin: t.IDENT_RE,
            endsParent: !0
          }
        ]
      },
      {
        begin: t.IDENT_RE + "\\s+\\{",
        returnBegin: !0,
        end: /\S/,
        contains: [
          {
            className: "keyword",
            begin: t.IDENT_RE,
            relevance: 0.2
          },
          {
            begin: /\{/,
            end: /\}/,
            keywords: e,
            relevance: 0,
            contains: [
              s,
              n,
              {
                begin: "[a-zA-Z_]+\\s*=>",
                returnBegin: !0,
                end: "=>",
                contains: [
                  {
                    className: "attr",
                    begin: t.IDENT_RE
                  }
                ]
              },
              {
                className: "number",
                begin: "(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b",
                relevance: 0
              },
              a
            ]
          }
        ],
        relevance: 0
      }
    ]
  };
}
function Ug(t) {
  const e = {
    // PB IDE color: #0080FF (Azure Radiance)
    className: "string",
    begin: '(~)?"',
    end: '"',
    illegal: "\\n"
  }, n = {
    // PB IDE color: #924B72 (Cannon Pink)
    //  "#" + a letter or underscore + letters, digits or underscores + (optional) "$"
    className: "symbol",
    begin: "#[a-zA-Z_]\\w*\\$?"
  };
  return {
    name: "PureBASIC",
    aliases: [
      "pb",
      "pbi"
    ],
    keywords: (
      // PB IDE color: #006666 (Blue Stone) + Bold
      // Keywords from all version of PureBASIC 5.00 upward ...
      "Align And Array As Break CallDebugger Case CompilerCase CompilerDefault CompilerElse CompilerElseIf CompilerEndIf CompilerEndSelect CompilerError CompilerIf CompilerSelect CompilerWarning Continue Data DataSection Debug DebugLevel Declare DeclareC DeclareCDLL DeclareDLL DeclareModule Default Define Dim DisableASM DisableDebugger DisableExplicit Else ElseIf EnableASM EnableDebugger EnableExplicit End EndDataSection EndDeclareModule EndEnumeration EndIf EndImport EndInterface EndMacro EndModule EndProcedure EndSelect EndStructure EndStructureUnion EndWith Enumeration EnumerationBinary Extends FakeReturn For ForEach ForEver Global Gosub Goto If Import ImportC IncludeBinary IncludeFile IncludePath Interface List Macro MacroExpandedCount Map Module NewList NewMap Next Not Or Procedure ProcedureC ProcedureCDLL ProcedureDLL ProcedureReturn Protected Prototype PrototypeC ReDim Read Repeat Restore Return Runtime Select Shared Static Step Structure StructureUnion Swap Threaded To UndefineMacro Until Until  UnuseModule UseModule Wend While With XIncludeFile XOr"
    ),
    contains: [
      // COMMENTS | PB IDE color: #00AAAA (Persian Green)
      t.COMMENT(";", "$", { relevance: 0 }),
      {
        // PROCEDURES DEFINITIONS
        className: "function",
        begin: "\\b(Procedure|Declare)(C|CDLL|DLL)?\\b",
        end: "\\(",
        excludeEnd: !0,
        returnBegin: !0,
        contains: [
          {
            // PROCEDURE KEYWORDS | PB IDE color: #006666 (Blue Stone) + Bold
            className: "keyword",
            begin: "(Procedure|Declare)(C|CDLL|DLL)?",
            excludeEnd: !0
          },
          {
            // PROCEDURE RETURN TYPE SETTING | PB IDE color: #000000 (Black)
            className: "type",
            begin: "\\.\\w*"
            // end: ' ',
          },
          t.UNDERSCORE_TITLE_MODE
          // PROCEDURE NAME | PB IDE color: #006666 (Blue Stone)
        ]
      },
      e,
      n
    ]
  };
}
function Fg(t) {
  return {
    name: "Q",
    aliases: [
      "k",
      "kdb"
    ],
    keywords: {
      $pattern: /(`?)[A-Za-z0-9_]+\b/,
      keyword: "do while select delete by update from",
      literal: "0b 1b",
      built_in: "neg not null string reciprocal floor ceiling signum mod xbar xlog and or each scan over prior mmu lsq inv md5 ltime gtime count first var dev med cov cor all any rand sums prds mins maxs fills deltas ratios avgs differ prev next rank reverse iasc idesc asc desc msum mcount mavg mdev xrank mmin mmax xprev rotate distinct group where flip type key til get value attr cut set upsert raze union inter except cross sv vs sublist enlist read0 read1 hopen hclose hdel hsym hcount peach system ltrim rtrim trim lower upper ssr view tables views cols xcols keys xkey xcol xasc xdesc fkeys meta lj aj aj0 ij pj asof uj ww wj wj1 fby xgroup ungroup ej save load rsave rload show csv parse eval min max avg wavg wsum sin cos tan sum",
      type: "`float `double int `timestamp `timespan `datetime `time `boolean `symbol `char `byte `short `long `real `month `date `minute `second `guid"
    },
    contains: [
      t.C_LINE_COMMENT_MODE,
      t.QUOTE_STRING_MODE,
      t.C_NUMBER_MODE
    ]
  };
}
function Bg(t) {
  const e = t.regex, n = {
    keyword: "in of on if for while finally var new function do return void else break catch instanceof with throw case default try this switch continue typeof delete let yield const export super debugger as async await import",
    literal: "true false null undefined NaN Infinity",
    built_in: "eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent encodeURI encodeURIComponent escape unescape Object Function Boolean Error EvalError InternalError RangeError ReferenceError StopIteration SyntaxError TypeError URIError Number Math Date String RegExp Array Float32Array Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require module console window document Symbol Set Map WeakSet WeakMap Proxy Reflect Behavior bool color coordinate date double enumeration font geocircle georectangle geoshape int list matrix4x4 parent point quaternion real rect size string url variant vector2d vector3d vector4d Promise"
  }, i = "[a-zA-Z_][a-zA-Z0-9\\._]*", r = {
    className: "keyword",
    begin: "\\bproperty\\b",
    starts: {
      className: "string",
      end: "(:|=|;|,|//|/\\*|$)",
      returnEnd: !0
    }
  }, a = {
    className: "keyword",
    begin: "\\bsignal\\b",
    starts: {
      className: "string",
      end: "(\\(|:|=|;|,|//|/\\*|$)",
      returnEnd: !0
    }
  }, s = {
    className: "attribute",
    begin: "\\bid\\s*:",
    starts: {
      className: "string",
      end: i,
      returnEnd: !1
    }
  }, o = {
    begin: i + "\\s*:",
    returnBegin: !0,
    contains: [
      {
        className: "attribute",
        begin: i,
        end: "\\s*:",
        excludeEnd: !0,
        relevance: 0
      }
    ],
    relevance: 0
  }, l = {
    begin: e.concat(i, /\s*\{/),
    end: /\{/,
    returnBegin: !0,
    relevance: 0,
    contains: [t.inherit(t.TITLE_MODE, { begin: i })]
  };
  return {
    name: "QML",
    aliases: ["qt"],
    case_insensitive: !1,
    keywords: n,
    contains: [
      {
        className: "meta",
        begin: /^\s*['"]use (strict|asm)['"]/
      },
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE,
      {
        // template string
        className: "string",
        begin: "`",
        end: "`",
        contains: [
          t.BACKSLASH_ESCAPE,
          {
            className: "subst",
            begin: "\\$\\{",
            end: "\\}"
          }
        ]
      },
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      {
        className: "number",
        variants: [
          { begin: "\\b(0[bB][01]+)" },
          { begin: "\\b(0[oO][0-7]+)" },
          { begin: t.C_NUMBER_RE }
        ],
        relevance: 0
      },
      {
        // "value" container
        begin: "(" + t.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
        keywords: "return throw case",
        contains: [
          t.C_LINE_COMMENT_MODE,
          t.C_BLOCK_COMMENT_MODE,
          t.REGEXP_MODE,
          {
            // E4X / JSX
            begin: /</,
            end: />\s*[);\]]/,
            relevance: 0,
            subLanguage: "xml"
          }
        ],
        relevance: 0
      },
      a,
      r,
      {
        className: "function",
        beginKeywords: "function",
        end: /\{/,
        excludeEnd: !0,
        contains: [
          t.inherit(t.TITLE_MODE, { begin: /[A-Za-z$_][0-9A-Za-z$_]*/ }),
          {
            className: "params",
            begin: /\(/,
            end: /\)/,
            excludeBegin: !0,
            excludeEnd: !0,
            contains: [
              t.C_LINE_COMMENT_MODE,
              t.C_BLOCK_COMMENT_MODE
            ]
          }
        ],
        illegal: /\[|%/
      },
      {
        // hack: prevents detection of keywords after dots
        begin: "\\." + t.IDENT_RE,
        relevance: 0
      },
      s,
      o,
      l
    ],
    illegal: /#/
  };
}
function Gg(t) {
  return {
    name: "ReasonML",
    aliases: ["re"],
    keywords: {
      $pattern: /[a-z_]\w*!?/,
      keyword: [
        "and",
        "as",
        "asr",
        "assert",
        "begin",
        "class",
        "constraint",
        "do",
        "done",
        "downto",
        "else",
        "end",
        "esfun",
        "exception",
        "external",
        "for",
        "fun",
        "function",
        "functor",
        "if",
        "in",
        "include",
        "inherit",
        "initializer",
        "land",
        "lazy",
        "let",
        "lor",
        "lsl",
        "lsr",
        "lxor",
        "mod",
        "module",
        "mutable",
        "new",
        "nonrec",
        "object",
        "of",
        "open",
        "or",
        "pri",
        "pub",
        "rec",
        "sig",
        "struct",
        "switch",
        "then",
        "to",
        "try",
        "type",
        "val",
        "virtual",
        "when",
        "while",
        "with"
      ],
      built_in: [
        "array",
        "bool",
        "bytes",
        "char",
        "exn|5",
        "float",
        "int",
        "int32",
        "int64",
        "list",
        "lazy_t|5",
        "nativeint|5",
        "ref",
        "string",
        "unit"
      ],
      literal: ["true", "false"]
    },
    illegal: /(:-|:=|\$\{|\+=)/,
    contains: [
      {
        scope: "literal",
        match: /\[(\|\|)?\]|\(\)/,
        relevance: 0
      },
      t.C_LINE_COMMENT_MODE,
      t.COMMENT(/\/\*/, /\*\//, { illegal: /^(#,\/\/)/ }),
      {
        /* type variable */
        scope: "symbol",
        match: /\'[A-Za-z_](?!\')[\w\']*/
        /* the grammar is ambiguous on how 'a'b should be interpreted but not the compiler */
      },
      {
        /* polymorphic variant */
        scope: "type",
        match: /`[A-Z][\w\']*/
      },
      {
        /* module or constructor */
        scope: "type",
        match: /\b[A-Z][\w\']*/,
        relevance: 0
      },
      {
        /* don't color identifiers, but safely catch all identifiers with ' */
        match: /[a-z_]\w*\'[\w\']*/,
        relevance: 0
      },
      {
        scope: "operator",
        match: /\s+(\|\||\+[\+\.]?|\*[\*\/\.]?|\/[\.]?|\.\.\.|\|>|&&|===?)\s+/,
        relevance: 0
      },
      t.inherit(t.APOS_STRING_MODE, {
        scope: "string",
        relevance: 0
      }),
      t.inherit(t.QUOTE_STRING_MODE, { illegal: null }),
      {
        scope: "number",
        variants: [
          { match: /\b0[xX][a-fA-F0-9_]+[Lln]?/ },
          { match: /\b0[oO][0-7_]+[Lln]?/ },
          { match: /\b0[bB][01_]+[Lln]?/ },
          { match: /\b[0-9][0-9_]*([Lln]|(\.[0-9_]*)?([eE][-+]?[0-9_]+)?)/ }
        ],
        relevance: 0
      }
    ]
  };
}
function Yg(t) {
  return {
    name: "RenderMan RIB",
    keywords: "ArchiveRecord AreaLightSource Atmosphere Attribute AttributeBegin AttributeEnd Basis Begin Blobby Bound Clipping ClippingPlane Color ColorSamples ConcatTransform Cone CoordinateSystem CoordSysTransform CropWindow Curves Cylinder DepthOfField Detail DetailRange Disk Displacement Display End ErrorHandler Exposure Exterior Format FrameAspectRatio FrameBegin FrameEnd GeneralPolygon GeometricApproximation Geometry Hider Hyperboloid Identity Illuminate Imager Interior LightSource MakeCubeFaceEnvironment MakeLatLongEnvironment MakeShadow MakeTexture Matte MotionBegin MotionEnd NuPatch ObjectBegin ObjectEnd ObjectInstance Opacity Option Orientation Paraboloid Patch PatchMesh Perspective PixelFilter PixelSamples PixelVariance Points PointsGeneralPolygons PointsPolygons Polygon Procedural Projection Quantize ReadArchive RelativeDetail ReverseOrientation Rotate Scale ScreenWindow ShadingInterpolation ShadingRate Shutter Sides Skew SolidBegin SolidEnd Sphere SubdivisionMesh Surface TextureCoordinates Torus Transform TransformBegin TransformEnd TransformPoints Translate TrimCurve WorldBegin WorldEnd",
    illegal: "</",
    contains: [
      t.HASH_COMMENT_MODE,
      t.C_NUMBER_MODE,
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE
    ]
  };
}
function $g(t) {
  const e = "[a-zA-Z-_][^\\n{]+\\{", n = {
    className: "attribute",
    begin: /[a-zA-Z-_]+/,
    end: /\s*:/,
    excludeEnd: !0,
    starts: {
      end: ";",
      relevance: 0,
      contains: [
        {
          className: "variable",
          begin: /\.[a-zA-Z-_]+/
        },
        {
          className: "keyword",
          begin: /\(optional\)/
        }
      ]
    }
  };
  return {
    name: "Roboconf",
    aliases: [
      "graph",
      "instances"
    ],
    case_insensitive: !0,
    keywords: "import",
    contains: [
      // Facet sections
      {
        begin: "^facet " + e,
        end: /\}/,
        keywords: "facet",
        contains: [
          n,
          t.HASH_COMMENT_MODE
        ]
      },
      // Instance sections
      {
        begin: "^\\s*instance of " + e,
        end: /\}/,
        keywords: "name count channels instance-data instance-state instance of",
        illegal: /\S/,
        contains: [
          "self",
          n,
          t.HASH_COMMENT_MODE
        ]
      },
      // Component sections
      {
        begin: "^" + e,
        end: /\}/,
        contains: [
          n,
          t.HASH_COMMENT_MODE
        ]
      },
      // Comments
      t.HASH_COMMENT_MODE
    ]
  };
}
function Vg(t) {
  const e = "foreach do while for if from to step else on-error and or not in", n = "global local beep delay put len typeof pick log time set find environment terminal error execute parse resolve toarray tobool toid toip toip6 tonum tostr totime", i = "add remove enable disable set get print export edit find run debug error info warning", r = "true false yes no nothing nil null", a = "traffic-flow traffic-generator firewall scheduler aaa accounting address-list address align area bandwidth-server bfd bgp bridge client clock community config connection console customer default dhcp-client dhcp-server discovery dns e-mail ethernet filter firmware gps graphing group hardware health hotspot identity igmp-proxy incoming instance interface ip ipsec ipv6 irq l2tp-server lcd ldp logging mac-server mac-winbox mangle manual mirror mme mpls nat nd neighbor network note ntp ospf ospf-v3 ovpn-server page peer pim ping policy pool port ppp pppoe-client pptp-server prefix profile proposal proxy queue radius resource rip ripng route routing screen script security-profiles server service service-port settings shares smb sms sniffer snmp snooper socks sstp-server system tool tracking type upgrade upnp user-manager users user vlan secret vrrp watchdog web-access wireless pptp pppoe lan wan layer7-protocol lease simple raw", s = {
    className: "variable",
    variants: [
      { begin: /\$[\w\d#@][\w\d_]*/ },
      { begin: /\$\{(.*?)\}/ }
    ]
  }, o = {
    className: "string",
    begin: /"/,
    end: /"/,
    contains: [
      t.BACKSLASH_ESCAPE,
      s,
      {
        className: "variable",
        begin: /\$\(/,
        end: /\)/,
        contains: [t.BACKSLASH_ESCAPE]
      }
    ]
  }, l = {
    className: "string",
    begin: /'/,
    end: /'/
  };
  return {
    name: "MikroTik RouterOS script",
    aliases: ["mikrotik"],
    case_insensitive: !0,
    keywords: {
      $pattern: /:?[\w-]+/,
      literal: r,
      keyword: e + " :" + e.split(" ").join(" :") + " :" + n.split(" ").join(" :")
    },
    contains: [
      {
        // illegal syntax
        variants: [
          {
            // -- comment
            begin: /\/\*/,
            end: /\*\//
          },
          {
            // Stan comment
            begin: /\/\//,
            end: /$/
          },
          {
            // HTML tags
            begin: /<\//,
            end: />/
          }
        ],
        illegal: /./
      },
      t.COMMENT("^#", "$"),
      o,
      l,
      s,
      // attribute=value
      {
        // > is to avoid matches with => in other grammars
        begin: /[\w-]+=([^\s{}[\]()>]+)/,
        relevance: 0,
        returnBegin: !0,
        contains: [
          {
            className: "attribute",
            begin: /[^=]+/
          },
          {
            begin: /=/,
            endsWithParent: !0,
            relevance: 0,
            contains: [
              o,
              l,
              s,
              {
                className: "literal",
                begin: "\\b(" + r.split(" ").join("|") + ")\\b"
              },
              {
                // Do not format unclassified values. Needed to exclude highlighting of values as built_in.
                begin: /("[^"]*"|[^\s{}[\]]+)/
              }
              /*
              {
                // IPv4 addresses and subnets
                className: 'number',
                variants: [
                  {begin: IPADDR_wBITMASK+'(,'+IPADDR_wBITMASK+')*'}, //192.168.0.0/24,1.2.3.0/24
                  {begin: IPADDR+'-'+IPADDR},       // 192.168.0.1-192.168.0.3
                  {begin: IPADDR+'(,'+IPADDR+')*'}, // 192.168.0.1,192.168.0.34,192.168.24.1,192.168.0.1
                ]
              },
              {
                // MAC addresses and DHCP Client IDs
                className: 'number',
                begin: /\b(1:)?([0-9A-Fa-f]{1,2}[:-]){5}([0-9A-Fa-f]){1,2}\b/,
              },
              */
            ]
          }
        ]
      },
      {
        // HEX values
        className: "number",
        begin: /\*[0-9a-fA-F]+/
      },
      {
        begin: "\\b(" + i.split(" ").join("|") + ")([\\s[(\\]|])",
        returnBegin: !0,
        contains: [
          {
            className: "built_in",
            // 'function',
            begin: /\w+/
          }
        ]
      },
      {
        className: "built_in",
        variants: [
          { begin: "(\\.\\./|/|\\s)((" + a.split(" ").join("|") + ");?\\s)+" },
          {
            begin: /\.\./,
            relevance: 0
          }
        ]
      }
    ]
  };
}
function Hg(t) {
  const e = [
    "abs",
    "acos",
    "ambient",
    "area",
    "asin",
    "atan",
    "atmosphere",
    "attribute",
    "calculatenormal",
    "ceil",
    "cellnoise",
    "clamp",
    "comp",
    "concat",
    "cos",
    "degrees",
    "depth",
    "Deriv",
    "diffuse",
    "distance",
    "Du",
    "Dv",
    "environment",
    "exp",
    "faceforward",
    "filterstep",
    "floor",
    "format",
    "fresnel",
    "incident",
    "length",
    "lightsource",
    "log",
    "match",
    "max",
    "min",
    "mod",
    "noise",
    "normalize",
    "ntransform",
    "opposite",
    "option",
    "phong",
    "pnoise",
    "pow",
    "printf",
    "ptlined",
    "radians",
    "random",
    "reflect",
    "refract",
    "renderinfo",
    "round",
    "setcomp",
    "setxcomp",
    "setycomp",
    "setzcomp",
    "shadow",
    "sign",
    "sin",
    "smoothstep",
    "specular",
    "specularbrdf",
    "spline",
    "sqrt",
    "step",
    "tan",
    "texture",
    "textureinfo",
    "trace",
    "transform",
    "vtransform",
    "xcomp",
    "ycomp",
    "zcomp"
  ], n = [
    "matrix",
    "float",
    "color",
    "point",
    "normal",
    "vector"
  ], i = [
    "while",
    "for",
    "if",
    "do",
    "return",
    "else",
    "break",
    "extern",
    "continue"
  ], r = {
    match: [
      /(surface|displacement|light|volume|imager)/,
      /\s+/,
      t.IDENT_RE
    ],
    scope: {
      1: "keyword",
      3: "title.class"
    }
  };
  return {
    name: "RenderMan RSL",
    keywords: {
      keyword: i,
      built_in: e,
      type: n
    },
    illegal: "</",
    contains: [
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      t.QUOTE_STRING_MODE,
      t.APOS_STRING_MODE,
      t.C_NUMBER_MODE,
      {
        className: "meta",
        begin: "#",
        end: "$"
      },
      r,
      {
        beginKeywords: "illuminate illuminance gather",
        end: "\\("
      }
    ]
  };
}
function qg(t) {
  return {
    name: "Oracle Rules Language",
    keywords: {
      keyword: "BILL_PERIOD BILL_START BILL_STOP RS_EFFECTIVE_START RS_EFFECTIVE_STOP RS_JURIS_CODE RS_OPCO_CODE INTDADDATTRIBUTE|5 INTDADDVMSG|5 INTDBLOCKOP|5 INTDBLOCKOPNA|5 INTDCLOSE|5 INTDCOUNT|5 INTDCOUNTSTATUSCODE|5 INTDCREATEMASK|5 INTDCREATEDAYMASK|5 INTDCREATEFACTORMASK|5 INTDCREATEHANDLE|5 INTDCREATEOVERRIDEDAYMASK|5 INTDCREATEOVERRIDEMASK|5 INTDCREATESTATUSCODEMASK|5 INTDCREATETOUPERIOD|5 INTDDELETE|5 INTDDIPTEST|5 INTDEXPORT|5 INTDGETERRORCODE|5 INTDGETERRORMESSAGE|5 INTDISEQUAL|5 INTDJOIN|5 INTDLOAD|5 INTDLOADACTUALCUT|5 INTDLOADDATES|5 INTDLOADHIST|5 INTDLOADLIST|5 INTDLOADLISTDATES|5 INTDLOADLISTENERGY|5 INTDLOADLISTHIST|5 INTDLOADRELATEDCHANNEL|5 INTDLOADSP|5 INTDLOADSTAGING|5 INTDLOADUOM|5 INTDLOADUOMDATES|5 INTDLOADUOMHIST|5 INTDLOADVERSION|5 INTDOPEN|5 INTDREADFIRST|5 INTDREADNEXT|5 INTDRECCOUNT|5 INTDRELEASE|5 INTDREPLACE|5 INTDROLLAVG|5 INTDROLLPEAK|5 INTDSCALAROP|5 INTDSCALE|5 INTDSETATTRIBUTE|5 INTDSETDSTPARTICIPANT|5 INTDSETSTRING|5 INTDSETVALUE|5 INTDSETVALUESTATUS|5 INTDSHIFTSTARTTIME|5 INTDSMOOTH|5 INTDSORT|5 INTDSPIKETEST|5 INTDSUBSET|5 INTDTOU|5 INTDTOURELEASE|5 INTDTOUVALUE|5 INTDUPDATESTATS|5 INTDVALUE|5 STDEV INTDDELETEEX|5 INTDLOADEXACTUAL|5 INTDLOADEXCUT|5 INTDLOADEXDATES|5 INTDLOADEX|5 INTDLOADEXRELATEDCHANNEL|5 INTDSAVEEX|5 MVLOAD|5 MVLOADACCT|5 MVLOADACCTDATES|5 MVLOADACCTHIST|5 MVLOADDATES|5 MVLOADHIST|5 MVLOADLIST|5 MVLOADLISTDATES|5 MVLOADLISTHIST|5 IF FOR NEXT DONE SELECT END CALL ABORT CLEAR CHANNEL FACTOR LIST NUMBER OVERRIDE SET WEEK DISTRIBUTIONNODE ELSE WHEN THEN OTHERWISE IENUM CSV INCLUDE LEAVE RIDER SAVE DELETE NOVALUE SECTION WARN SAVE_UPDATE DETERMINANT LABEL REPORT REVENUE EACH IN FROM TOTAL CHARGE BLOCK AND OR CSV_FILE RATE_CODE AUXILIARY_DEMAND UIDACCOUNT RS BILL_PERIOD_SELECT HOURS_PER_MONTH INTD_ERROR_STOP SEASON_SCHEDULE_NAME ACCOUNTFACTOR ARRAYUPPERBOUND CALLSTOREDPROC GETADOCONNECTION GETCONNECT GETDATASOURCE GETQUALIFIER GETUSERID HASVALUE LISTCOUNT LISTOP LISTUPDATE LISTVALUE PRORATEFACTOR RSPRORATE SETBINPATH SETDBMONITOR WQ_OPEN BILLINGHOURS DATE DATEFROMFLOAT DATETIMEFROMSTRING DATETIMETOSTRING DATETOFLOAT DAY DAYDIFF DAYNAME DBDATETIME HOUR MINUTE MONTH MONTHDIFF MONTHHOURS MONTHNAME ROUNDDATE SAMEWEEKDAYLASTYEAR SECOND WEEKDAY WEEKDIFF YEAR YEARDAY YEARSTR COMPSUM HISTCOUNT HISTMAX HISTMIN HISTMINNZ HISTVALUE MAXNRANGE MAXRANGE MINRANGE COMPIKVA COMPKVA COMPKVARFROMKQKW COMPLF IDATTR FLAG LF2KW LF2KWH MAXKW POWERFACTOR READING2USAGE AVGSEASON MAXSEASON MONTHLYMERGE SEASONVALUE SUMSEASON ACCTREADDATES ACCTTABLELOAD CONFIGADD CONFIGGET CREATEOBJECT CREATEREPORT EMAILCLIENT EXPBLKMDMUSAGE EXPMDMUSAGE EXPORT_USAGE FACTORINEFFECT GETUSERSPECIFIEDSTOP INEFFECT ISHOLIDAY RUNRATE SAVE_PROFILE SETREPORTTITLE USEREXIT WATFORRUNRATE TO TABLE ACOS ASIN ATAN ATAN2 BITAND CEIL COS COSECANT COSH COTANGENT DIVQUOT DIVREM EXP FABS FLOOR FMOD FREPM FREXPN LOG LOG10 MAX MAXN MIN MINNZ MODF POW ROUND ROUND2VALUE ROUNDINT SECANT SIN SINH SQROOT TAN TANH FLOAT2STRING FLOAT2STRINGNC INSTR LEFT LEN LTRIM MID RIGHT RTRIM STRING STRINGNC TOLOWER TOUPPER TRIM NUMDAYS READ_DATE STAGING",
      built_in: "IDENTIFIER OPTIONS XML_ELEMENT XML_OP XML_ELEMENT_OF DOMDOCCREATE DOMDOCLOADFILE DOMDOCLOADXML DOMDOCSAVEFILE DOMDOCGETROOT DOMDOCADDPI DOMNODEGETNAME DOMNODEGETTYPE DOMNODEGETVALUE DOMNODEGETCHILDCT DOMNODEGETFIRSTCHILD DOMNODEGETSIBLING DOMNODECREATECHILDELEMENT DOMNODESETATTRIBUTE DOMNODEGETCHILDELEMENTCT DOMNODEGETFIRSTCHILDELEMENT DOMNODEGETSIBLINGELEMENT DOMNODEGETATTRIBUTECT DOMNODEGETATTRIBUTEI DOMNODEGETATTRIBUTEBYNAME DOMNODEGETBYNAME"
    },
    contains: [
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE,
      t.C_NUMBER_MODE,
      {
        className: "literal",
        variants: [
          {
            // looks like #-comment
            begin: "#\\s+",
            relevance: 0
          },
          { begin: "#[a-zA-Z .]+" }
        ]
      }
    ]
  };
}
function zg(t) {
  const e = t.regex, n = [
    "do",
    "if",
    "then",
    "else",
    "end",
    "until",
    "while",
    "abort",
    "array",
    "attrib",
    "by",
    "call",
    "cards",
    "cards4",
    "catname",
    "continue",
    "datalines",
    "datalines4",
    "delete",
    "delim",
    "delimiter",
    "display",
    "dm",
    "drop",
    "endsas",
    "error",
    "file",
    "filename",
    "footnote",
    "format",
    "goto",
    "in",
    "infile",
    "informat",
    "input",
    "keep",
    "label",
    "leave",
    "length",
    "libname",
    "link",
    "list",
    "lostcard",
    "merge",
    "missing",
    "modify",
    "options",
    "output",
    "out",
    "page",
    "put",
    "redirect",
    "remove",
    "rename",
    "replace",
    "retain",
    "return",
    "select",
    "set",
    "skip",
    "startsas",
    "stop",
    "title",
    "update",
    "waitsas",
    "where",
    "window",
    "x|0",
    "systask",
    "add",
    "and",
    "alter",
    "as",
    "cascade",
    "check",
    "create",
    "delete",
    "describe",
    "distinct",
    "drop",
    "foreign",
    "from",
    "group",
    "having",
    "index",
    "insert",
    "into",
    "in",
    "key",
    "like",
    "message",
    "modify",
    "msgtype",
    "not",
    "null",
    "on",
    "or",
    "order",
    "primary",
    "references",
    "reset",
    "restrict",
    "select",
    "set",
    "table",
    "unique",
    "update",
    "validate",
    "view",
    "where"
  ], i = [
    "abs",
    "addr",
    "airy",
    "arcos",
    "arsin",
    "atan",
    "attrc",
    "attrn",
    "band",
    "betainv",
    "blshift",
    "bnot",
    "bor",
    "brshift",
    "bxor",
    "byte",
    "cdf",
    "ceil",
    "cexist",
    "cinv",
    "close",
    "cnonct",
    "collate",
    "compbl",
    "compound",
    "compress",
    "cos",
    "cosh",
    "css",
    "curobs",
    "cv",
    "daccdb",
    "daccdbsl",
    "daccsl",
    "daccsyd",
    "dacctab",
    "dairy",
    "date",
    "datejul",
    "datepart",
    "datetime",
    "day",
    "dclose",
    "depdb",
    "depdbsl",
    "depdbsl",
    "depsl",
    "depsl",
    "depsyd",
    "depsyd",
    "deptab",
    "deptab",
    "dequote",
    "dhms",
    "dif",
    "digamma",
    "dim",
    "dinfo",
    "dnum",
    "dopen",
    "doptname",
    "doptnum",
    "dread",
    "dropnote",
    "dsname",
    "erf",
    "erfc",
    "exist",
    "exp",
    "fappend",
    "fclose",
    "fcol",
    "fdelete",
    "fetch",
    "fetchobs",
    "fexist",
    "fget",
    "fileexist",
    "filename",
    "fileref",
    "finfo",
    "finv",
    "fipname",
    "fipnamel",
    "fipstate",
    "floor",
    "fnonct",
    "fnote",
    "fopen",
    "foptname",
    "foptnum",
    "fpoint",
    "fpos",
    "fput",
    "fread",
    "frewind",
    "frlen",
    "fsep",
    "fuzz",
    "fwrite",
    "gaminv",
    "gamma",
    "getoption",
    "getvarc",
    "getvarn",
    "hbound",
    "hms",
    "hosthelp",
    "hour",
    "ibessel",
    "index",
    "indexc",
    "indexw",
    "input",
    "inputc",
    "inputn",
    "int",
    "intck",
    "intnx",
    "intrr",
    "irr",
    "jbessel",
    "juldate",
    "kurtosis",
    "lag",
    "lbound",
    "left",
    "length",
    "lgamma",
    "libname",
    "libref",
    "log",
    "log10",
    "log2",
    "logpdf",
    "logpmf",
    "logsdf",
    "lowcase",
    "max",
    "mdy",
    "mean",
    "min",
    "minute",
    "mod",
    "month",
    "mopen",
    "mort",
    "n",
    "netpv",
    "nmiss",
    "normal",
    "note",
    "npv",
    "open",
    "ordinal",
    "pathname",
    "pdf",
    "peek",
    "peekc",
    "pmf",
    "point",
    "poisson",
    "poke",
    "probbeta",
    "probbnml",
    "probchi",
    "probf",
    "probgam",
    "probhypr",
    "probit",
    "probnegb",
    "probnorm",
    "probt",
    "put",
    "putc",
    "putn",
    "qtr",
    "quote",
    "ranbin",
    "rancau",
    "ranexp",
    "rangam",
    "range",
    "rank",
    "rannor",
    "ranpoi",
    "rantbl",
    "rantri",
    "ranuni",
    "repeat",
    "resolve",
    "reverse",
    "rewind",
    "right",
    "round",
    "saving",
    "scan",
    "sdf",
    "second",
    "sign",
    "sin",
    "sinh",
    "skewness",
    "soundex",
    "spedis",
    "sqrt",
    "std",
    "stderr",
    "stfips",
    "stname",
    "stnamel",
    "substr",
    "sum",
    "symget",
    "sysget",
    "sysmsg",
    "sysprod",
    "sysrc",
    "system",
    "tan",
    "tanh",
    "time",
    "timepart",
    "tinv",
    "tnonct",
    "today",
    "translate",
    "tranwrd",
    "trigamma",
    "trim",
    "trimn",
    "trunc",
    "uniform",
    "upcase",
    "uss",
    "var",
    "varfmt",
    "varinfmt",
    "varlabel",
    "varlen",
    "varname",
    "varnum",
    "varray",
    "varrayx",
    "vartype",
    "verify",
    "vformat",
    "vformatd",
    "vformatdx",
    "vformatn",
    "vformatnx",
    "vformatw",
    "vformatwx",
    "vformatx",
    "vinarray",
    "vinarrayx",
    "vinformat",
    "vinformatd",
    "vinformatdx",
    "vinformatn",
    "vinformatnx",
    "vinformatw",
    "vinformatwx",
    "vinformatx",
    "vlabel",
    "vlabelx",
    "vlength",
    "vlengthx",
    "vname",
    "vnamex",
    "vtype",
    "vtypex",
    "weekday",
    "year",
    "yyq",
    "zipfips",
    "zipname",
    "zipnamel",
    "zipstate"
  ], r = [
    "bquote",
    "nrbquote",
    "cmpres",
    "qcmpres",
    "compstor",
    "datatyp",
    "display",
    "do",
    "else",
    "end",
    "eval",
    "global",
    "goto",
    "if",
    "index",
    "input",
    "keydef",
    "label",
    "left",
    "length",
    "let",
    "local",
    "lowcase",
    "macro",
    "mend",
    "nrbquote",
    "nrquote",
    "nrstr",
    "put",
    "qcmpres",
    "qleft",
    "qlowcase",
    "qscan",
    "qsubstr",
    "qsysfunc",
    "qtrim",
    "quote",
    "qupcase",
    "scan",
    "str",
    "substr",
    "superq",
    "syscall",
    "sysevalf",
    "sysexec",
    "sysfunc",
    "sysget",
    "syslput",
    "sysprod",
    "sysrc",
    "sysrput",
    "then",
    "to",
    "trim",
    "unquote",
    "until",
    "upcase",
    "verify",
    "while",
    "window"
  ];
  return {
    name: "SAS",
    case_insensitive: !0,
    keywords: {
      literal: [
        "null",
        "missing",
        "_all_",
        "_automatic_",
        "_character_",
        "_infile_",
        "_n_",
        "_name_",
        "_null_",
        "_numeric_",
        "_user_",
        "_webout_"
      ],
      keyword: n
    },
    contains: [
      {
        // Distinct highlight for proc <proc>, data, run, quit
        className: "keyword",
        begin: /^\s*(proc [\w\d_]+|data|run|quit)[\s;]/
      },
      {
        // Macro variables
        className: "variable",
        begin: /&[a-zA-Z_&][a-zA-Z0-9_]*\.?/
      },
      {
        begin: [
          /^\s*/,
          /datalines;|cards;/,
          /(?:.*\n)+/,
          /^\s*;\s*$/
        ],
        className: {
          2: "keyword",
          3: "string"
        }
      },
      {
        begin: [
          /%mend|%macro/,
          /\s+/,
          /[a-zA-Z_&][a-zA-Z0-9_]*/
        ],
        className: {
          1: "built_in",
          3: "title.function"
        }
      },
      {
        // Built-in macro variables
        className: "built_in",
        begin: "%" + e.either(...r)
      },
      {
        // User-defined macro functions
        className: "title.function",
        begin: /%[a-zA-Z_][a-zA-Z_0-9]*/
      },
      {
        // TODO: this is most likely an incorrect classification
        // built_in may need more nuance
        // https://github.com/highlightjs/highlight.js/issues/2521
        className: "meta",
        begin: e.either(...i) + "(?=\\()"
      },
      {
        className: "string",
        variants: [
          t.APOS_STRING_MODE,
          t.QUOTE_STRING_MODE
        ]
      },
      t.COMMENT("\\*", ";"),
      t.C_BLOCK_COMMENT_MODE
    ]
  };
}
function Wg(t) {
  const e = t.regex, n = {
    className: "meta",
    begin: "@[A-Za-z]+"
  }, i = {
    className: "subst",
    variants: [
      { begin: "\\$[A-Za-z0-9_]+" },
      {
        begin: /\$\{/,
        end: /\}/
      }
    ]
  }, r = {
    className: "string",
    variants: [
      {
        begin: '"""',
        end: '"""'
      },
      {
        begin: '"',
        end: '"',
        illegal: "\\n",
        contains: [t.BACKSLASH_ESCAPE]
      },
      {
        begin: '[a-z]+"',
        end: '"',
        illegal: "\\n",
        contains: [
          t.BACKSLASH_ESCAPE,
          i
        ]
      },
      {
        className: "string",
        begin: '[a-z]+"""',
        end: '"""',
        contains: [i],
        relevance: 10
      }
    ]
  }, a = {
    className: "type",
    begin: "\\b[A-Z][A-Za-z0-9_]*",
    relevance: 0
  }, s = {
    className: "title",
    begin: /[^0-9\n\t "'(),.`{}\[\]:;][^\n\t "'(),.`{}\[\]:;]+|[^0-9\n\t "'(),.`{}\[\]:;=]/,
    relevance: 0
  }, o = {
    className: "class",
    beginKeywords: "class object trait type",
    end: /[:={\[\n;]/,
    excludeEnd: !0,
    contains: [
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      {
        beginKeywords: "extends with",
        relevance: 10
      },
      {
        begin: /\[/,
        end: /\]/,
        excludeBegin: !0,
        excludeEnd: !0,
        relevance: 0,
        contains: [
          a,
          t.C_LINE_COMMENT_MODE,
          t.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        className: "params",
        begin: /\(/,
        end: /\)/,
        excludeBegin: !0,
        excludeEnd: !0,
        relevance: 0,
        contains: [
          a,
          t.C_LINE_COMMENT_MODE,
          t.C_BLOCK_COMMENT_MODE
        ]
      },
      s
    ]
  }, l = {
    className: "function",
    beginKeywords: "def",
    end: e.lookahead(/[:={\[(\n;]/),
    contains: [s]
  }, c = {
    begin: [
      /^\s*/,
      // Is first token on the line
      "extension",
      /\s+(?=[[(])/
      // followed by at least one space and `[` or `(`
    ],
    beginScope: { 2: "keyword" }
  }, d = {
    begin: [
      /^\s*/,
      // Is first token on the line
      /end/,
      /\s+/,
      /(extension\b)?/
      // `extension` is the only marker that follows an `end` that cannot be captured by another rule.
    ],
    beginScope: {
      2: "keyword",
      4: "keyword"
    }
  }, u = [
    { match: /\.inline\b/ },
    {
      begin: /\binline(?=\s)/,
      keywords: "inline"
    }
  ], _ = {
    begin: [
      /\(\s*/,
      // Opening `(` of a parameter or argument list
      /using/,
      /\s+(?!\))/
      // Spaces not followed by `)`
    ],
    beginScope: { 2: "keyword" }
  };
  return {
    name: "Scala",
    keywords: {
      literal: "true false null",
      keyword: "type yield lazy override def with val var sealed abstract private trait object if then forSome for while do throw finally protected extends import final return else break new catch super class case package default try this match continue throws implicit export enum given transparent"
    },
    contains: [
      {
        begin: [
          "//>",
          /\s+/,
          /using/,
          /\s+/,
          /\S+/
        ],
        beginScope: {
          1: "comment",
          3: "keyword",
          5: "type"
        },
        end: /$/,
        contains: [
          {
            className: "string",
            begin: /\S+/
          }
        ]
      },
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      r,
      a,
      l,
      o,
      t.C_NUMBER_MODE,
      c,
      d,
      ...u,
      _,
      n
    ]
  };
}
function Kg(t) {
  const e = "[^\\(\\)\\[\\]\\{\\}\",'`;#|\\\\\\s]+", n = "(-|\\+)?\\d+([./]\\d+)?", i = n + "[+\\-]" + n + "i", r = {
    $pattern: e,
    built_in: "case-lambda call/cc class define-class exit-handler field import inherit init-field interface let*-values let-values let/ec mixin opt-lambda override protect provide public rename require require-for-syntax syntax syntax-case syntax-error unit/sig unless when with-syntax and begin call-with-current-continuation call-with-input-file call-with-output-file case cond define define-syntax delay do dynamic-wind else for-each if lambda let let* let-syntax letrec letrec-syntax map or syntax-rules ' * + , ,@ - ... / ; < <= = => > >= ` abs acos angle append apply asin assoc assq assv atan boolean? caar cadr call-with-input-file call-with-output-file call-with-values car cdddar cddddr cdr ceiling char->integer char-alphabetic? char-ci<=? char-ci<? char-ci=? char-ci>=? char-ci>? char-downcase char-lower-case? char-numeric? char-ready? char-upcase char-upper-case? char-whitespace? char<=? char<? char=? char>=? char>? char? close-input-port close-output-port complex? cons cos current-input-port current-output-port denominator display eof-object? eq? equal? eqv? eval even? exact->inexact exact? exp expt floor force gcd imag-part inexact->exact inexact? input-port? integer->char integer? interaction-environment lcm length list list->string list->vector list-ref list-tail list? load log magnitude make-polar make-rectangular make-string make-vector max member memq memv min modulo negative? newline not null-environment null? number->string number? numerator odd? open-input-file open-output-file output-port? pair? peek-char port? positive? procedure? quasiquote quote quotient rational? rationalize read read-char real-part real? remainder reverse round scheme-report-environment set! set-car! set-cdr! sin sqrt string string->list string->number string->symbol string-append string-ci<=? string-ci<? string-ci=? string-ci>=? string-ci>? string-copy string-fill! string-length string-ref string-set! string<=? string<? string=? string>=? string>? string? substring symbol->string symbol? tan transcript-off transcript-on truncate values vector vector->list vector-fill! vector-length vector-ref vector-set! with-input-from-file with-output-to-file write write-char zero?"
  }, a = {
    className: "literal",
    begin: "(#t|#f|#\\\\" + e + "|#\\\\.)"
  }, s = {
    className: "number",
    variants: [
      {
        begin: n,
        relevance: 0
      },
      {
        begin: i,
        relevance: 0
      },
      { begin: "#b[0-1]+(/[0-1]+)?" },
      { begin: "#o[0-7]+(/[0-7]+)?" },
      { begin: "#x[0-9a-f]+(/[0-9a-f]+)?" }
    ]
  }, o = t.QUOTE_STRING_MODE, l = [
    t.COMMENT(
      ";",
      "$",
      { relevance: 0 }
    ),
    t.COMMENT("#\\|", "\\|#")
  ], c = {
    begin: e,
    relevance: 0
  }, d = {
    className: "symbol",
    begin: "'" + e
  }, u = {
    endsWithParent: !0,
    relevance: 0
  }, _ = {
    variants: [
      { begin: /'/ },
      { begin: "`" }
    ],
    contains: [
      {
        begin: "\\(",
        end: "\\)",
        contains: [
          "self",
          a,
          o,
          s,
          c,
          d
        ]
      }
    ]
  }, m = {
    className: "name",
    relevance: 0,
    begin: e,
    keywords: r
  }, S = {
    variants: [
      {
        begin: "\\(",
        end: "\\)"
      },
      {
        begin: "\\[",
        end: "\\]"
      }
    ],
    contains: [
      {
        begin: /lambda/,
        endsWithParent: !0,
        returnBegin: !0,
        contains: [
          m,
          {
            endsParent: !0,
            variants: [
              {
                begin: /\(/,
                end: /\)/
              },
              {
                begin: /\[/,
                end: /\]/
              }
            ],
            contains: [c]
          }
        ]
      },
      m,
      u
    ]
  };
  return u.contains = [
    a,
    s,
    o,
    c,
    d,
    _,
    S
  ].concat(l), {
    name: "Scheme",
    aliases: ["scm"],
    illegal: /\S/,
    contains: [
      t.SHEBANG(),
      s,
      o,
      d,
      _,
      S
    ].concat(l)
  };
}
function Qg(t) {
  const e = [
    t.C_NUMBER_MODE,
    {
      className: "string",
      begin: `'|"`,
      end: `'|"`,
      contains: [
        t.BACKSLASH_ESCAPE,
        { begin: "''" }
      ]
    }
  ];
  return {
    name: "Scilab",
    aliases: ["sci"],
    keywords: {
      $pattern: /%?\w+/,
      keyword: "abort break case clear catch continue do elseif else endfunction end for function global if pause return resume select try then while",
      literal: "%f %F %t %T %pi %eps %inf %nan %e %i %z %s",
      built_in: (
        // Scilab has more than 2000 functions. Just list the most commons
        "abs and acos asin atan ceil cd chdir clearglobal cosh cos cumprod deff disp error exec execstr exists exp eye gettext floor fprintf fread fsolve imag isdef isempty isinfisnan isvector lasterror length load linspace list listfiles log10 log2 log max min msprintf mclose mopen ones or pathconvert poly printf prod pwd rand real round sinh sin size gsort sprintf sqrt strcat strcmps tring sum system tanh tan type typename warning zeros matrix"
      )
    },
    illegal: '("|#|/\\*|\\s+/\\w+)',
    contains: [
      {
        className: "function",
        beginKeywords: "function",
        end: "$",
        contains: [
          t.UNDERSCORE_TITLE_MODE,
          {
            className: "params",
            begin: "\\(",
            end: "\\)"
          }
        ]
      },
      // seems to be a guard against [ident]' or [ident].
      // perhaps to prevent attributes from flagging as keywords?
      {
        begin: "[a-zA-Z_][a-zA-Z_0-9]*[\\.']+",
        relevance: 0
      },
      {
        begin: "\\[",
        end: "\\][\\.']*",
        relevance: 0,
        contains: e
      },
      t.COMMENT("//", "$")
    ].concat(e)
  };
}
function Xg(t) {
  const e = [
    "add",
    "and",
    "cmp",
    "cmpg",
    "cmpl",
    "const",
    "div",
    "double",
    "float",
    "goto",
    "if",
    "int",
    "long",
    "move",
    "mul",
    "neg",
    "new",
    "nop",
    "not",
    "or",
    "rem",
    "return",
    "shl",
    "shr",
    "sput",
    "sub",
    "throw",
    "ushr",
    "xor"
  ], n = [
    "aget",
    "aput",
    "array",
    "check",
    "execute",
    "fill",
    "filled",
    "goto/16",
    "goto/32",
    "iget",
    "instance",
    "invoke",
    "iput",
    "monitor",
    "packed",
    "sget",
    "sparse"
  ], i = [
    "transient",
    "constructor",
    "abstract",
    "final",
    "synthetic",
    "public",
    "private",
    "protected",
    "static",
    "bridge",
    "system"
  ];
  return {
    name: "Smali",
    contains: [
      {
        className: "string",
        begin: '"',
        end: '"',
        relevance: 0
      },
      t.COMMENT(
        "#",
        "$",
        { relevance: 0 }
      ),
      {
        className: "keyword",
        variants: [
          { begin: "\\s*\\.end\\s[a-zA-Z0-9]*" },
          {
            begin: "^[ ]*\\.[a-zA-Z]*",
            relevance: 0
          },
          {
            begin: "\\s:[a-zA-Z_0-9]*",
            relevance: 0
          },
          { begin: "\\s(" + i.join("|") + ")" }
        ]
      },
      {
        className: "built_in",
        variants: [
          { begin: "\\s(" + e.join("|") + ")\\s" },
          {
            begin: "\\s(" + e.join("|") + ")((-|/)[a-zA-Z0-9]+)+\\s",
            relevance: 10
          },
          {
            begin: "\\s(" + n.join("|") + ")((-|/)[a-zA-Z0-9]+)*\\s",
            relevance: 10
          }
        ]
      },
      {
        className: "class",
        begin: `L[^(;:
]*;`,
        relevance: 0
      },
      { begin: "[vp][0-9]+" }
    ]
  };
}
function Zg(t) {
  const e = "[a-z][a-zA-Z0-9_]*", n = {
    className: "string",
    begin: "\\$.{1}"
  }, i = {
    className: "symbol",
    begin: "#" + t.UNDERSCORE_IDENT_RE
  };
  return {
    name: "Smalltalk",
    aliases: ["st"],
    keywords: [
      "self",
      "super",
      "nil",
      "true",
      "false",
      "thisContext"
    ],
    contains: [
      t.COMMENT('"', '"'),
      t.APOS_STRING_MODE,
      {
        className: "type",
        begin: "\\b[A-Z][A-Za-z0-9_]*",
        relevance: 0
      },
      {
        begin: e + ":",
        relevance: 0
      },
      t.C_NUMBER_MODE,
      i,
      n,
      {
        // This looks more complicated than needed to avoid combinatorial
        // explosion under V8. It effectively means `| var1 var2 ... |` with
        // whitespace adjacent to `|` being optional.
        begin: "\\|[ ]*" + e + "([ ]+" + e + ")*[ ]*\\|",
        returnBegin: !0,
        end: /\|/,
        illegal: /\S/,
        contains: [{ begin: "(\\|[ ]*)?" + e }]
      },
      {
        begin: "#\\(",
        end: "\\)",
        contains: [
          t.APOS_STRING_MODE,
          n,
          t.C_NUMBER_MODE,
          i
        ]
      }
    ]
  };
}
function Jg(t) {
  return {
    name: "SML (Standard ML)",
    aliases: ["ml"],
    keywords: {
      $pattern: "[a-z_]\\w*!?",
      keyword: (
        /* according to Definition of Standard ML 97  */
        "abstype and andalso as case datatype do else end eqtype exception fn fun functor handle if in include infix infixr let local nonfix of op open orelse raise rec sharing sig signature struct structure then type val with withtype where while"
      ),
      built_in: (
        /* built-in types according to basis library */
        "array bool char exn int list option order real ref string substring vector unit word"
      ),
      literal: "true false NONE SOME LESS EQUAL GREATER nil"
    },
    illegal: /\/\/|>>/,
    contains: [
      {
        className: "literal",
        begin: /\[(\|\|)?\]|\(\)/,
        relevance: 0
      },
      t.COMMENT(
        "\\(\\*",
        "\\*\\)",
        { contains: ["self"] }
      ),
      {
        /* type variable */
        className: "symbol",
        begin: "'[A-Za-z_](?!')[\\w']*"
        /* the grammar is ambiguous on how 'a'b should be interpreted but not the compiler */
      },
      {
        /* polymorphic variant */
        className: "type",
        begin: "`[A-Z][\\w']*"
      },
      {
        /* module or constructor */
        className: "type",
        begin: "\\b[A-Z][\\w']*",
        relevance: 0
      },
      {
        /* don't color identifiers, but safely catch all identifiers with ' */
        begin: "[a-z_]\\w*'[\\w']*"
      },
      t.inherit(t.APOS_STRING_MODE, {
        className: "string",
        relevance: 0
      }),
      t.inherit(t.QUOTE_STRING_MODE, { illegal: null }),
      {
        className: "number",
        begin: "\\b(0[xX][a-fA-F0-9_]+[Lln]?|0[oO][0-7_]+[Lln]?|0[bB][01_]+[Lln]?|[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)",
        relevance: 0
      },
      {
        begin: /[-=]>/
        // relevance booster
      }
    ]
  };
}
function jg(t) {
  const e = {
    className: "variable",
    begin: /\b_+[a-zA-Z]\w*/
  }, n = {
    className: "title",
    begin: /[a-zA-Z][a-zA-Z_0-9]*_fnc_[a-zA-Z_0-9]+/
  }, i = {
    className: "string",
    variants: [
      {
        begin: '"',
        end: '"',
        contains: [
          {
            begin: '""',
            relevance: 0
          }
        ]
      },
      {
        begin: "'",
        end: "'",
        contains: [
          {
            begin: "''",
            relevance: 0
          }
        ]
      }
    ]
  }, r = [
    "break",
    "breakWith",
    "breakOut",
    "breakTo",
    "case",
    "catch",
    "continue",
    "continueWith",
    "default",
    "do",
    "else",
    "exit",
    "exitWith",
    "for",
    "forEach",
    "from",
    "if",
    "local",
    "private",
    "switch",
    "step",
    "then",
    "throw",
    "to",
    "try",
    "waitUntil",
    "while",
    "with"
  ], a = [
    "blufor",
    "civilian",
    "configNull",
    "controlNull",
    "displayNull",
    "diaryRecordNull",
    "east",
    "endl",
    "false",
    "grpNull",
    "independent",
    "lineBreak",
    "locationNull",
    "nil",
    "objNull",
    "opfor",
    "pi",
    "resistance",
    "scriptNull",
    "sideAmbientLife",
    "sideEmpty",
    "sideEnemy",
    "sideFriendly",
    "sideLogic",
    "sideUnknown",
    "taskNull",
    "teamMemberNull",
    "true",
    "west"
  ], s = [
    "abs",
    "accTime",
    "acos",
    "action",
    "actionIDs",
    "actionKeys",
    "actionKeysEx",
    "actionKeysImages",
    "actionKeysNames",
    "actionKeysNamesArray",
    "actionName",
    "actionParams",
    "activateAddons",
    "activatedAddons",
    "activateKey",
    "activeTitleEffectParams",
    "add3DENConnection",
    "add3DENEventHandler",
    "add3DENLayer",
    "addAction",
    "addBackpack",
    "addBackpackCargo",
    "addBackpackCargoGlobal",
    "addBackpackGlobal",
    "addBinocularItem",
    "addCamShake",
    "addCuratorAddons",
    "addCuratorCameraArea",
    "addCuratorEditableObjects",
    "addCuratorEditingArea",
    "addCuratorPoints",
    "addEditorObject",
    "addEventHandler",
    "addForce",
    "addForceGeneratorRTD",
    "addGoggles",
    "addGroupIcon",
    "addHandgunItem",
    "addHeadgear",
    "addItem",
    "addItemCargo",
    "addItemCargoGlobal",
    "addItemPool",
    "addItemToBackpack",
    "addItemToUniform",
    "addItemToVest",
    "addLiveStats",
    "addMagazine",
    "addMagazineAmmoCargo",
    "addMagazineCargo",
    "addMagazineCargoGlobal",
    "addMagazineGlobal",
    "addMagazinePool",
    "addMagazines",
    "addMagazineTurret",
    "addMenu",
    "addMenuItem",
    "addMissionEventHandler",
    "addMPEventHandler",
    "addMusicEventHandler",
    "addonFiles",
    "addOwnedMine",
    "addPlayerScores",
    "addPrimaryWeaponItem",
    "addPublicVariableEventHandler",
    "addRating",
    "addResources",
    "addScore",
    "addScoreSide",
    "addSecondaryWeaponItem",
    "addSwitchableUnit",
    "addTeamMember",
    "addToRemainsCollector",
    "addTorque",
    "addUniform",
    "addUserActionEventHandler",
    "addVehicle",
    "addVest",
    "addWaypoint",
    "addWeapon",
    "addWeaponCargo",
    "addWeaponCargoGlobal",
    "addWeaponGlobal",
    "addWeaponItem",
    "addWeaponPool",
    "addWeaponTurret",
    "addWeaponWithAttachmentsCargo",
    "addWeaponWithAttachmentsCargoGlobal",
    "admin",
    "agent",
    "agents",
    "AGLToASL",
    "aimedAtTarget",
    "aimPos",
    "airDensityCurveRTD",
    "airDensityRTD",
    "airplaneThrottle",
    "airportSide",
    "AISFinishHeal",
    "alive",
    "all3DENEntities",
    "allActiveTitleEffects",
    "allAddonsInfo",
    "allAirports",
    "allControls",
    "allCurators",
    "allCutLayers",
    "allDead",
    "allDeadMen",
    "allDiaryRecords",
    "allDiarySubjects",
    "allDisplays",
    "allEnv3DSoundSources",
    "allGroups",
    "allLODs",
    "allMapMarkers",
    "allMines",
    "allMissionObjects",
    "allObjects",
    "allow3DMode",
    "allowCrewInImmobile",
    "allowCuratorLogicIgnoreAreas",
    "allowDamage",
    "allowDammage",
    "allowedService",
    "allowFileOperations",
    "allowFleeing",
    "allowGetIn",
    "allowService",
    "allowSprint",
    "allPlayers",
    "allSimpleObjects",
    "allSites",
    "allTurrets",
    "allUnits",
    "allUnitsUAV",
    "allUsers",
    "allVariables",
    "ambientTemperature",
    "ammo",
    "ammoOnPylon",
    "and",
    "animate",
    "animateBay",
    "animateDoor",
    "animatePylon",
    "animateSource",
    "animationNames",
    "animationPhase",
    "animationSourcePhase",
    "animationState",
    "apertureParams",
    "append",
    "apply",
    "armoryPoints",
    "arrayIntersect",
    "asin",
    "ASLToAGL",
    "ASLToATL",
    "assert",
    "assignAsCargo",
    "assignAsCargoIndex",
    "assignAsCommander",
    "assignAsDriver",
    "assignAsGunner",
    "assignAsTurret",
    "assignCurator",
    "assignedCargo",
    "assignedCommander",
    "assignedDriver",
    "assignedGroup",
    "assignedGunner",
    "assignedItems",
    "assignedTarget",
    "assignedTeam",
    "assignedVehicle",
    "assignedVehicleRole",
    "assignedVehicles",
    "assignItem",
    "assignTeam",
    "assignToAirport",
    "atan",
    "atan2",
    "atg",
    "ATLToASL",
    "attachedObject",
    "attachedObjects",
    "attachedTo",
    "attachObject",
    "attachTo",
    "attackEnabled",
    "awake",
    "backpack",
    "backpackCargo",
    "backpackContainer",
    "backpackItems",
    "backpackMagazines",
    "backpackSpaceFor",
    "behaviour",
    "benchmark",
    "bezierInterpolation",
    "binocular",
    "binocularItems",
    "binocularMagazine",
    "boundingBox",
    "boundingBoxReal",
    "boundingCenter",
    "brakesDisabled",
    "briefingName",
    "buildingExit",
    "buildingPos",
    "buldozer_EnableRoadDiag",
    "buldozer_IsEnabledRoadDiag",
    "buldozer_LoadNewRoads",
    "buldozer_reloadOperMap",
    "buttonAction",
    "buttonSetAction",
    "cadetMode",
    "calculatePath",
    "calculatePlayerVisibilityByFriendly",
    "call",
    "callExtension",
    "camCommand",
    "camCommit",
    "camCommitPrepared",
    "camCommitted",
    "camConstuctionSetParams",
    "camCreate",
    "camDestroy",
    "cameraEffect",
    "cameraEffectEnableHUD",
    "cameraInterest",
    "cameraOn",
    "cameraView",
    "campaignConfigFile",
    "camPreload",
    "camPreloaded",
    "camPrepareBank",
    "camPrepareDir",
    "camPrepareDive",
    "camPrepareFocus",
    "camPrepareFov",
    "camPrepareFovRange",
    "camPreparePos",
    "camPrepareRelPos",
    "camPrepareTarget",
    "camSetBank",
    "camSetDir",
    "camSetDive",
    "camSetFocus",
    "camSetFov",
    "camSetFovRange",
    "camSetPos",
    "camSetRelPos",
    "camSetTarget",
    "camTarget",
    "camUseNVG",
    "canAdd",
    "canAddItemToBackpack",
    "canAddItemToUniform",
    "canAddItemToVest",
    "cancelSimpleTaskDestination",
    "canDeployWeapon",
    "canFire",
    "canMove",
    "canSlingLoad",
    "canStand",
    "canSuspend",
    "canTriggerDynamicSimulation",
    "canUnloadInCombat",
    "canVehicleCargo",
    "captive",
    "captiveNum",
    "cbChecked",
    "cbSetChecked",
    "ceil",
    "channelEnabled",
    "cheatsEnabled",
    "checkAIFeature",
    "checkVisibility",
    "className",
    "clear3DENAttribute",
    "clear3DENInventory",
    "clearAllItemsFromBackpack",
    "clearBackpackCargo",
    "clearBackpackCargoGlobal",
    "clearForcesRTD",
    "clearGroupIcons",
    "clearItemCargo",
    "clearItemCargoGlobal",
    "clearItemPool",
    "clearMagazineCargo",
    "clearMagazineCargoGlobal",
    "clearMagazinePool",
    "clearOverlay",
    "clearRadio",
    "clearWeaponCargo",
    "clearWeaponCargoGlobal",
    "clearWeaponPool",
    "clientOwner",
    "closeDialog",
    "closeDisplay",
    "closeOverlay",
    "collapseObjectTree",
    "collect3DENHistory",
    "collectiveRTD",
    "collisionDisabledWith",
    "combatBehaviour",
    "combatMode",
    "commandArtilleryFire",
    "commandChat",
    "commander",
    "commandFire",
    "commandFollow",
    "commandFSM",
    "commandGetOut",
    "commandingMenu",
    "commandMove",
    "commandRadio",
    "commandStop",
    "commandSuppressiveFire",
    "commandTarget",
    "commandWatch",
    "comment",
    "commitOverlay",
    "compatibleItems",
    "compatibleMagazines",
    "compile",
    "compileFinal",
    "compileScript",
    "completedFSM",
    "composeText",
    "configClasses",
    "configFile",
    "configHierarchy",
    "configName",
    "configOf",
    "configProperties",
    "configSourceAddonList",
    "configSourceMod",
    "configSourceModList",
    "confirmSensorTarget",
    "connectTerminalToUAV",
    "connectToServer",
    "controlsGroupCtrl",
    "conversationDisabled",
    "copyFromClipboard",
    "copyToClipboard",
    "copyWaypoints",
    "cos",
    "count",
    "countEnemy",
    "countFriendly",
    "countSide",
    "countType",
    "countUnknown",
    "create3DENComposition",
    "create3DENEntity",
    "createAgent",
    "createCenter",
    "createDialog",
    "createDiaryLink",
    "createDiaryRecord",
    "createDiarySubject",
    "createDisplay",
    "createGearDialog",
    "createGroup",
    "createGuardedPoint",
    "createHashMap",
    "createHashMapFromArray",
    "createLocation",
    "createMarker",
    "createMarkerLocal",
    "createMenu",
    "createMine",
    "createMissionDisplay",
    "createMPCampaignDisplay",
    "createSimpleObject",
    "createSimpleTask",
    "createSite",
    "createSoundSource",
    "createTask",
    "createTeam",
    "createTrigger",
    "createUnit",
    "createVehicle",
    "createVehicleCrew",
    "createVehicleLocal",
    "crew",
    "ctAddHeader",
    "ctAddRow",
    "ctClear",
    "ctCurSel",
    "ctData",
    "ctFindHeaderRows",
    "ctFindRowHeader",
    "ctHeaderControls",
    "ctHeaderCount",
    "ctRemoveHeaders",
    "ctRemoveRows",
    "ctrlActivate",
    "ctrlAddEventHandler",
    "ctrlAngle",
    "ctrlAnimateModel",
    "ctrlAnimationPhaseModel",
    "ctrlAt",
    "ctrlAutoScrollDelay",
    "ctrlAutoScrollRewind",
    "ctrlAutoScrollSpeed",
    "ctrlBackgroundColor",
    "ctrlChecked",
    "ctrlClassName",
    "ctrlCommit",
    "ctrlCommitted",
    "ctrlCreate",
    "ctrlDelete",
    "ctrlEnable",
    "ctrlEnabled",
    "ctrlFade",
    "ctrlFontHeight",
    "ctrlForegroundColor",
    "ctrlHTMLLoaded",
    "ctrlIDC",
    "ctrlIDD",
    "ctrlMapAnimAdd",
    "ctrlMapAnimClear",
    "ctrlMapAnimCommit",
    "ctrlMapAnimDone",
    "ctrlMapCursor",
    "ctrlMapMouseOver",
    "ctrlMapPosition",
    "ctrlMapScale",
    "ctrlMapScreenToWorld",
    "ctrlMapSetPosition",
    "ctrlMapWorldToScreen",
    "ctrlModel",
    "ctrlModelDirAndUp",
    "ctrlModelScale",
    "ctrlMousePosition",
    "ctrlParent",
    "ctrlParentControlsGroup",
    "ctrlPosition",
    "ctrlRemoveAllEventHandlers",
    "ctrlRemoveEventHandler",
    "ctrlScale",
    "ctrlScrollValues",
    "ctrlSetActiveColor",
    "ctrlSetAngle",
    "ctrlSetAutoScrollDelay",
    "ctrlSetAutoScrollRewind",
    "ctrlSetAutoScrollSpeed",
    "ctrlSetBackgroundColor",
    "ctrlSetChecked",
    "ctrlSetDisabledColor",
    "ctrlSetEventHandler",
    "ctrlSetFade",
    "ctrlSetFocus",
    "ctrlSetFont",
    "ctrlSetFontH1",
    "ctrlSetFontH1B",
    "ctrlSetFontH2",
    "ctrlSetFontH2B",
    "ctrlSetFontH3",
    "ctrlSetFontH3B",
    "ctrlSetFontH4",
    "ctrlSetFontH4B",
    "ctrlSetFontH5",
    "ctrlSetFontH5B",
    "ctrlSetFontH6",
    "ctrlSetFontH6B",
    "ctrlSetFontHeight",
    "ctrlSetFontHeightH1",
    "ctrlSetFontHeightH2",
    "ctrlSetFontHeightH3",
    "ctrlSetFontHeightH4",
    "ctrlSetFontHeightH5",
    "ctrlSetFontHeightH6",
    "ctrlSetFontHeightSecondary",
    "ctrlSetFontP",
    "ctrlSetFontPB",
    "ctrlSetFontSecondary",
    "ctrlSetForegroundColor",
    "ctrlSetModel",
    "ctrlSetModelDirAndUp",
    "ctrlSetModelScale",
    "ctrlSetMousePosition",
    "ctrlSetPixelPrecision",
    "ctrlSetPosition",
    "ctrlSetPositionH",
    "ctrlSetPositionW",
    "ctrlSetPositionX",
    "ctrlSetPositionY",
    "ctrlSetScale",
    "ctrlSetScrollValues",
    "ctrlSetShadow",
    "ctrlSetStructuredText",
    "ctrlSetText",
    "ctrlSetTextColor",
    "ctrlSetTextColorSecondary",
    "ctrlSetTextSecondary",
    "ctrlSetTextSelection",
    "ctrlSetTooltip",
    "ctrlSetTooltipColorBox",
    "ctrlSetTooltipColorShade",
    "ctrlSetTooltipColorText",
    "ctrlSetTooltipMaxWidth",
    "ctrlSetURL",
    "ctrlSetURLOverlayMode",
    "ctrlShadow",
    "ctrlShow",
    "ctrlShown",
    "ctrlStyle",
    "ctrlText",
    "ctrlTextColor",
    "ctrlTextHeight",
    "ctrlTextSecondary",
    "ctrlTextSelection",
    "ctrlTextWidth",
    "ctrlTooltip",
    "ctrlType",
    "ctrlURL",
    "ctrlURLOverlayMode",
    "ctrlVisible",
    "ctRowControls",
    "ctRowCount",
    "ctSetCurSel",
    "ctSetData",
    "ctSetHeaderTemplate",
    "ctSetRowTemplate",
    "ctSetValue",
    "ctValue",
    "curatorAddons",
    "curatorCamera",
    "curatorCameraArea",
    "curatorCameraAreaCeiling",
    "curatorCoef",
    "curatorEditableObjects",
    "curatorEditingArea",
    "curatorEditingAreaType",
    "curatorMouseOver",
    "curatorPoints",
    "curatorRegisteredObjects",
    "curatorSelected",
    "curatorWaypointCost",
    "current3DENOperation",
    "currentChannel",
    "currentCommand",
    "currentMagazine",
    "currentMagazineDetail",
    "currentMagazineDetailTurret",
    "currentMagazineTurret",
    "currentMuzzle",
    "currentNamespace",
    "currentPilot",
    "currentTask",
    "currentTasks",
    "currentThrowable",
    "currentVisionMode",
    "currentWaypoint",
    "currentWeapon",
    "currentWeaponMode",
    "currentWeaponTurret",
    "currentZeroing",
    "cursorObject",
    "cursorTarget",
    "customChat",
    "customRadio",
    "customWaypointPosition",
    "cutFadeOut",
    "cutObj",
    "cutRsc",
    "cutText",
    "damage",
    "date",
    "dateToNumber",
    "dayTime",
    "deActivateKey",
    "debriefingText",
    "debugFSM",
    "debugLog",
    "decayGraphValues",
    "deg",
    "delete3DENEntities",
    "deleteAt",
    "deleteCenter",
    "deleteCollection",
    "deleteEditorObject",
    "deleteGroup",
    "deleteGroupWhenEmpty",
    "deleteIdentity",
    "deleteLocation",
    "deleteMarker",
    "deleteMarkerLocal",
    "deleteRange",
    "deleteResources",
    "deleteSite",
    "deleteStatus",
    "deleteTeam",
    "deleteVehicle",
    "deleteVehicleCrew",
    "deleteWaypoint",
    "detach",
    "detectedMines",
    "diag_activeMissionFSMs",
    "diag_activeScripts",
    "diag_activeSQFScripts",
    "diag_activeSQSScripts",
    "diag_allMissionEventHandlers",
    "diag_captureFrame",
    "diag_captureFrameToFile",
    "diag_captureSlowFrame",
    "diag_codePerformance",
    "diag_deltaTime",
    "diag_drawmode",
    "diag_dumpCalltraceToLog",
    "diag_dumpScriptAssembly",
    "diag_dumpTerrainSynth",
    "diag_dynamicSimulationEnd",
    "diag_enable",
    "diag_enabled",
    "diag_exportConfig",
    "diag_exportTerrainSVG",
    "diag_fps",
    "diag_fpsmin",
    "diag_frameno",
    "diag_getTerrainSegmentOffset",
    "diag_lightNewLoad",
    "diag_list",
    "diag_localized",
    "diag_log",
    "diag_logSlowFrame",
    "diag_mergeConfigFile",
    "diag_recordTurretLimits",
    "diag_resetFSM",
    "diag_resetshapes",
    "diag_scope",
    "diag_setLightNew",
    "diag_stacktrace",
    "diag_tickTime",
    "diag_toggle",
    "dialog",
    "diarySubjectExists",
    "didJIP",
    "didJIPOwner",
    "difficulty",
    "difficultyEnabled",
    "difficultyEnabledRTD",
    "difficultyOption",
    "direction",
    "directionStabilizationEnabled",
    "directSay",
    "disableAI",
    "disableBrakes",
    "disableCollisionWith",
    "disableConversation",
    "disableDebriefingStats",
    "disableMapIndicators",
    "disableNVGEquipment",
    "disableRemoteSensors",
    "disableSerialization",
    "disableTIEquipment",
    "disableUAVConnectability",
    "disableUserInput",
    "displayAddEventHandler",
    "displayChild",
    "displayCtrl",
    "displayParent",
    "displayRemoveAllEventHandlers",
    "displayRemoveEventHandler",
    "displaySetEventHandler",
    "displayUniqueName",
    "displayUpdate",
    "dissolveTeam",
    "distance",
    "distance2D",
    "distanceSqr",
    "distributionRegion",
    "do3DENAction",
    "doArtilleryFire",
    "doFire",
    "doFollow",
    "doFSM",
    "doGetOut",
    "doMove",
    "doorPhase",
    "doStop",
    "doSuppressiveFire",
    "doTarget",
    "doWatch",
    "drawArrow",
    "drawEllipse",
    "drawIcon",
    "drawIcon3D",
    "drawLaser",
    "drawLine",
    "drawLine3D",
    "drawLink",
    "drawLocation",
    "drawPolygon",
    "drawRectangle",
    "drawTriangle",
    "driver",
    "drop",
    "dynamicSimulationDistance",
    "dynamicSimulationDistanceCoef",
    "dynamicSimulationEnabled",
    "dynamicSimulationSystemEnabled",
    "echo",
    "edit3DENMissionAttributes",
    "editObject",
    "editorSetEventHandler",
    "effectiveCommander",
    "elevatePeriscope",
    "emptyPositions",
    "enableAI",
    "enableAIFeature",
    "enableAimPrecision",
    "enableAttack",
    "enableAudioFeature",
    "enableAutoStartUpRTD",
    "enableAutoTrimRTD",
    "enableCamShake",
    "enableCaustics",
    "enableChannel",
    "enableCollisionWith",
    "enableCopilot",
    "enableDebriefingStats",
    "enableDiagLegend",
    "enableDirectionStabilization",
    "enableDynamicSimulation",
    "enableDynamicSimulationSystem",
    "enableEndDialog",
    "enableEngineArtillery",
    "enableEnvironment",
    "enableFatigue",
    "enableGunLights",
    "enableInfoPanelComponent",
    "enableIRLasers",
    "enableMimics",
    "enablePersonTurret",
    "enableRadio",
    "enableReload",
    "enableRopeAttach",
    "enableSatNormalOnDetail",
    "enableSaving",
    "enableSentences",
    "enableSimulation",
    "enableSimulationGlobal",
    "enableStamina",
    "enableStressDamage",
    "enableTeamSwitch",
    "enableTraffic",
    "enableUAVConnectability",
    "enableUAVWaypoints",
    "enableVehicleCargo",
    "enableVehicleSensor",
    "enableWeaponDisassembly",
    "endLoadingScreen",
    "endMission",
    "engineOn",
    "enginesIsOnRTD",
    "enginesPowerRTD",
    "enginesRpmRTD",
    "enginesTorqueRTD",
    "entities",
    "environmentEnabled",
    "environmentVolume",
    "equipmentDisabled",
    "estimatedEndServerTime",
    "estimatedTimeLeft",
    "evalObjectArgument",
    "everyBackpack",
    "everyContainer",
    "exec",
    "execEditorScript",
    "execFSM",
    "execVM",
    "exp",
    "expectedDestination",
    "exportJIPMessages",
    "eyeDirection",
    "eyePos",
    "face",
    "faction",
    "fadeEnvironment",
    "fadeMusic",
    "fadeRadio",
    "fadeSound",
    "fadeSpeech",
    "failMission",
    "fileExists",
    "fillWeaponsFromPool",
    "find",
    "findAny",
    "findCover",
    "findDisplay",
    "findEditorObject",
    "findEmptyPosition",
    "findEmptyPositionReady",
    "findIf",
    "findNearestEnemy",
    "finishMissionInit",
    "finite",
    "fire",
    "fireAtTarget",
    "firstBackpack",
    "flag",
    "flagAnimationPhase",
    "flagOwner",
    "flagSide",
    "flagTexture",
    "flatten",
    "fleeing",
    "floor",
    "flyInHeight",
    "flyInHeightASL",
    "focusedCtrl",
    "fog",
    "fogForecast",
    "fogParams",
    "forceAddUniform",
    "forceAtPositionRTD",
    "forceCadetDifficulty",
    "forcedMap",
    "forceEnd",
    "forceFlagTexture",
    "forceFollowRoad",
    "forceGeneratorRTD",
    "forceMap",
    "forceRespawn",
    "forceSpeed",
    "forceUnicode",
    "forceWalk",
    "forceWeaponFire",
    "forceWeatherChange",
    "forEachMember",
    "forEachMemberAgent",
    "forEachMemberTeam",
    "forgetTarget",
    "format",
    "formation",
    "formationDirection",
    "formationLeader",
    "formationMembers",
    "formationPosition",
    "formationTask",
    "formatText",
    "formLeader",
    "freeExtension",
    "freeLook",
    "fromEditor",
    "fuel",
    "fullCrew",
    "gearIDCAmmoCount",
    "gearSlotAmmoCount",
    "gearSlotData",
    "gestureState",
    "get",
    "get3DENActionState",
    "get3DENAttribute",
    "get3DENCamera",
    "get3DENConnections",
    "get3DENEntity",
    "get3DENEntityID",
    "get3DENGrid",
    "get3DENIconsVisible",
    "get3DENLayerEntities",
    "get3DENLinesVisible",
    "get3DENMissionAttribute",
    "get3DENMouseOver",
    "get3DENSelected",
    "getAimingCoef",
    "getAllEnv3DSoundControllers",
    "getAllEnvSoundControllers",
    "getAllHitPointsDamage",
    "getAllOwnedMines",
    "getAllPylonsInfo",
    "getAllSoundControllers",
    "getAllUnitTraits",
    "getAmmoCargo",
    "getAnimAimPrecision",
    "getAnimSpeedCoef",
    "getArray",
    "getArtilleryAmmo",
    "getArtilleryComputerSettings",
    "getArtilleryETA",
    "getAssetDLCInfo",
    "getAssignedCuratorLogic",
    "getAssignedCuratorUnit",
    "getAttackTarget",
    "getAudioOptionVolumes",
    "getBackpackCargo",
    "getBleedingRemaining",
    "getBurningValue",
    "getCalculatePlayerVisibilityByFriendly",
    "getCameraViewDirection",
    "getCargoIndex",
    "getCenterOfMass",
    "getClientState",
    "getClientStateNumber",
    "getCompatiblePylonMagazines",
    "getConnectedUAV",
    "getConnectedUAVUnit",
    "getContainerMaxLoad",
    "getCorpse",
    "getCruiseControl",
    "getCursorObjectParams",
    "getCustomAimCoef",
    "getCustomSoundController",
    "getCustomSoundControllerCount",
    "getDammage",
    "getDebriefingText",
    "getDescription",
    "getDir",
    "getDirVisual",
    "getDiverState",
    "getDLCAssetsUsage",
    "getDLCAssetsUsageByName",
    "getDLCs",
    "getDLCUsageTime",
    "getEditorCamera",
    "getEditorMode",
    "getEditorObjectScope",
    "getElevationOffset",
    "getEngineTargetRPMRTD",
    "getEnv3DSoundController",
    "getEnvSoundController",
    "getEventHandlerInfo",
    "getFatigue",
    "getFieldManualStartPage",
    "getForcedFlagTexture",
    "getForcedSpeed",
    "getFriend",
    "getFSMVariable",
    "getFuelCargo",
    "getGraphValues",
    "getGroupIcon",
    "getGroupIconParams",
    "getGroupIcons",
    "getHideFrom",
    "getHit",
    "getHitIndex",
    "getHitPointDamage",
    "getItemCargo",
    "getLighting",
    "getLightingAt",
    "getLoadedModsInfo",
    "getMagazineCargo",
    "getMarkerColor",
    "getMarkerPos",
    "getMarkerSize",
    "getMarkerType",
    "getMass",
    "getMissionConfig",
    "getMissionConfigValue",
    "getMissionDLCs",
    "getMissionLayerEntities",
    "getMissionLayers",
    "getMissionPath",
    "getModelInfo",
    "getMousePosition",
    "getMusicPlayedTime",
    "getNumber",
    "getObjectArgument",
    "getObjectChildren",
    "getObjectDLC",
    "getObjectFOV",
    "getObjectID",
    "getObjectMaterials",
    "getObjectProxy",
    "getObjectScale",
    "getObjectTextures",
    "getObjectType",
    "getObjectViewDistance",
    "getOpticsMode",
    "getOrDefault",
    "getOrDefaultCall",
    "getOxygenRemaining",
    "getPersonUsedDLCs",
    "getPilotCameraDirection",
    "getPilotCameraPosition",
    "getPilotCameraRotation",
    "getPilotCameraTarget",
    "getPiPViewDistance",
    "getPlateNumber",
    "getPlayerChannel",
    "getPlayerID",
    "getPlayerScores",
    "getPlayerUID",
    "getPlayerVoNVolume",
    "getPos",
    "getPosASL",
    "getPosASLVisual",
    "getPosASLW",
    "getPosATL",
    "getPosATLVisual",
    "getPosVisual",
    "getPosWorld",
    "getPosWorldVisual",
    "getPylonMagazines",
    "getRelDir",
    "getRelPos",
    "getRemoteSensorsDisabled",
    "getRepairCargo",
    "getResolution",
    "getRoadInfo",
    "getRotorBrakeRTD",
    "getSensorTargets",
    "getSensorThreats",
    "getShadowDistance",
    "getShotParents",
    "getSlingLoad",
    "getSoundController",
    "getSoundControllerResult",
    "getSpeed",
    "getStamina",
    "getStatValue",
    "getSteamFriendsServers",
    "getSubtitleOptions",
    "getSuppression",
    "getTerrainGrid",
    "getTerrainHeight",
    "getTerrainHeightASL",
    "getTerrainInfo",
    "getText",
    "getTextRaw",
    "getTextureInfo",
    "getTextWidth",
    "getTiParameters",
    "getTotalDLCUsageTime",
    "getTrimOffsetRTD",
    "getTurretLimits",
    "getTurretOpticsMode",
    "getUnitFreefallInfo",
    "getUnitLoadout",
    "getUnitTrait",
    "getUnloadInCombat",
    "getUserInfo",
    "getUserMFDText",
    "getUserMFDValue",
    "getVariable",
    "getVehicleCargo",
    "getVehicleTiPars",
    "getWeaponCargo",
    "getWeaponSway",
    "getWingsOrientationRTD",
    "getWingsPositionRTD",
    "getWPPos",
    "glanceAt",
    "globalChat",
    "globalRadio",
    "goggles",
    "goto",
    "group",
    "groupChat",
    "groupFromNetId",
    "groupIconSelectable",
    "groupIconsVisible",
    "groupID",
    "groupOwner",
    "groupRadio",
    "groups",
    "groupSelectedUnits",
    "groupSelectUnit",
    "gunner",
    "gusts",
    "halt",
    "handgunItems",
    "handgunMagazine",
    "handgunWeapon",
    "handsHit",
    "hashValue",
    "hasInterface",
    "hasPilotCamera",
    "hasWeapon",
    "hcAllGroups",
    "hcGroupParams",
    "hcLeader",
    "hcRemoveAllGroups",
    "hcRemoveGroup",
    "hcSelected",
    "hcSelectGroup",
    "hcSetGroup",
    "hcShowBar",
    "hcShownBar",
    "headgear",
    "hideBody",
    "hideObject",
    "hideObjectGlobal",
    "hideSelection",
    "hint",
    "hintC",
    "hintCadet",
    "hintSilent",
    "hmd",
    "hostMission",
    "htmlLoad",
    "HUDMovementLevels",
    "humidity",
    "image",
    "importAllGroups",
    "importance",
    "in",
    "inArea",
    "inAreaArray",
    "incapacitatedState",
    "inflame",
    "inflamed",
    "infoPanel",
    "infoPanelComponentEnabled",
    "infoPanelComponents",
    "infoPanels",
    "inGameUISetEventHandler",
    "inheritsFrom",
    "initAmbientLife",
    "inPolygon",
    "inputAction",
    "inputController",
    "inputMouse",
    "inRangeOfArtillery",
    "insert",
    "insertEditorObject",
    "intersect",
    "is3DEN",
    "is3DENMultiplayer",
    "is3DENPreview",
    "isAbleToBreathe",
    "isActionMenuVisible",
    "isAgent",
    "isAimPrecisionEnabled",
    "isAllowedCrewInImmobile",
    "isArray",
    "isAutoHoverOn",
    "isAutonomous",
    "isAutoStartUpEnabledRTD",
    "isAutotest",
    "isAutoTrimOnRTD",
    "isAwake",
    "isBleeding",
    "isBurning",
    "isClass",
    "isCollisionLightOn",
    "isCopilotEnabled",
    "isDamageAllowed",
    "isDedicated",
    "isDLCAvailable",
    "isEngineOn",
    "isEqualRef",
    "isEqualTo",
    "isEqualType",
    "isEqualTypeAll",
    "isEqualTypeAny",
    "isEqualTypeArray",
    "isEqualTypeParams",
    "isFilePatchingEnabled",
    "isFinal",
    "isFlashlightOn",
    "isFlatEmpty",
    "isForcedWalk",
    "isFormationLeader",
    "isGameFocused",
    "isGamePaused",
    "isGroupDeletedWhenEmpty",
    "isHidden",
    "isInRemainsCollector",
    "isInstructorFigureEnabled",
    "isIRLaserOn",
    "isKeyActive",
    "isKindOf",
    "isLaserOn",
    "isLightOn",
    "isLocalized",
    "isManualFire",
    "isMarkedForCollection",
    "isMissionProfileNamespaceLoaded",
    "isMultiplayer",
    "isMultiplayerSolo",
    "isNil",
    "isNotEqualRef",
    "isNotEqualTo",
    "isNull",
    "isNumber",
    "isObjectHidden",
    "isObjectRTD",
    "isOnRoad",
    "isPiPEnabled",
    "isPlayer",
    "isRealTime",
    "isRemoteExecuted",
    "isRemoteExecutedJIP",
    "isSaving",
    "isSensorTargetConfirmed",
    "isServer",
    "isShowing3DIcons",
    "isSimpleObject",
    "isSprintAllowed",
    "isStaminaEnabled",
    "isSteamMission",
    "isSteamOverlayEnabled",
    "isStreamFriendlyUIEnabled",
    "isStressDamageEnabled",
    "isText",
    "isTouchingGround",
    "isTurnedOut",
    "isTutHintsEnabled",
    "isUAVConnectable",
    "isUAVConnected",
    "isUIContext",
    "isUniformAllowed",
    "isVehicleCargo",
    "isVehicleRadarOn",
    "isVehicleSensorEnabled",
    "isWalking",
    "isWeaponDeployed",
    "isWeaponRested",
    "itemCargo",
    "items",
    "itemsWithMagazines",
    "join",
    "joinAs",
    "joinAsSilent",
    "joinSilent",
    "joinString",
    "kbAddDatabase",
    "kbAddDatabaseTargets",
    "kbAddTopic",
    "kbHasTopic",
    "kbReact",
    "kbRemoveTopic",
    "kbTell",
    "kbWasSaid",
    "keyImage",
    "keyName",
    "keys",
    "knowsAbout",
    "land",
    "landAt",
    "landResult",
    "language",
    "laserTarget",
    "lbAdd",
    "lbClear",
    "lbColor",
    "lbColorRight",
    "lbCurSel",
    "lbData",
    "lbDelete",
    "lbIsSelected",
    "lbPicture",
    "lbPictureRight",
    "lbSelection",
    "lbSetColor",
    "lbSetColorRight",
    "lbSetCurSel",
    "lbSetData",
    "lbSetPicture",
    "lbSetPictureColor",
    "lbSetPictureColorDisabled",
    "lbSetPictureColorSelected",
    "lbSetPictureRight",
    "lbSetPictureRightColor",
    "lbSetPictureRightColorDisabled",
    "lbSetPictureRightColorSelected",
    "lbSetSelectColor",
    "lbSetSelectColorRight",
    "lbSetSelected",
    "lbSetText",
    "lbSetTextRight",
    "lbSetTooltip",
    "lbSetValue",
    "lbSize",
    "lbSort",
    "lbSortBy",
    "lbSortByValue",
    "lbText",
    "lbTextRight",
    "lbTooltip",
    "lbValue",
    "leader",
    "leaderboardDeInit",
    "leaderboardGetRows",
    "leaderboardInit",
    "leaderboardRequestRowsFriends",
    "leaderboardRequestRowsGlobal",
    "leaderboardRequestRowsGlobalAroundUser",
    "leaderboardsRequestUploadScore",
    "leaderboardsRequestUploadScoreKeepBest",
    "leaderboardState",
    "leaveVehicle",
    "libraryCredits",
    "libraryDisclaimers",
    "lifeState",
    "lightAttachObject",
    "lightDetachObject",
    "lightIsOn",
    "lightnings",
    "limitSpeed",
    "linearConversion",
    "lineIntersects",
    "lineIntersectsObjs",
    "lineIntersectsSurfaces",
    "lineIntersectsWith",
    "linkItem",
    "list",
    "listObjects",
    "listRemoteTargets",
    "listVehicleSensors",
    "ln",
    "lnbAddArray",
    "lnbAddColumn",
    "lnbAddRow",
    "lnbClear",
    "lnbColor",
    "lnbColorRight",
    "lnbCurSelRow",
    "lnbData",
    "lnbDeleteColumn",
    "lnbDeleteRow",
    "lnbGetColumnsPosition",
    "lnbPicture",
    "lnbPictureRight",
    "lnbSetColor",
    "lnbSetColorRight",
    "lnbSetColumnsPos",
    "lnbSetCurSelRow",
    "lnbSetData",
    "lnbSetPicture",
    "lnbSetPictureColor",
    "lnbSetPictureColorRight",
    "lnbSetPictureColorSelected",
    "lnbSetPictureColorSelectedRight",
    "lnbSetPictureRight",
    "lnbSetText",
    "lnbSetTextRight",
    "lnbSetTooltip",
    "lnbSetValue",
    "lnbSize",
    "lnbSort",
    "lnbSortBy",
    "lnbSortByValue",
    "lnbText",
    "lnbTextRight",
    "lnbValue",
    "load",
    "loadAbs",
    "loadBackpack",
    "loadConfig",
    "loadFile",
    "loadGame",
    "loadIdentity",
    "loadMagazine",
    "loadOverlay",
    "loadStatus",
    "loadUniform",
    "loadVest",
    "localize",
    "localNamespace",
    "locationPosition",
    "lock",
    "lockCameraTo",
    "lockCargo",
    "lockDriver",
    "locked",
    "lockedCameraTo",
    "lockedCargo",
    "lockedDriver",
    "lockedInventory",
    "lockedTurret",
    "lockIdentity",
    "lockInventory",
    "lockTurret",
    "lockWp",
    "log",
    "logEntities",
    "logNetwork",
    "logNetworkTerminate",
    "lookAt",
    "lookAtPos",
    "magazineCargo",
    "magazines",
    "magazinesAllTurrets",
    "magazinesAmmo",
    "magazinesAmmoCargo",
    "magazinesAmmoFull",
    "magazinesDetail",
    "magazinesDetailBackpack",
    "magazinesDetailUniform",
    "magazinesDetailVest",
    "magazinesTurret",
    "magazineTurretAmmo",
    "mapAnimAdd",
    "mapAnimClear",
    "mapAnimCommit",
    "mapAnimDone",
    "mapCenterOnCamera",
    "mapGridPosition",
    "markAsFinishedOnSteam",
    "markerAlpha",
    "markerBrush",
    "markerChannel",
    "markerColor",
    "markerDir",
    "markerPolyline",
    "markerPos",
    "markerShadow",
    "markerShape",
    "markerSize",
    "markerText",
    "markerType",
    "matrixMultiply",
    "matrixTranspose",
    "max",
    "maxLoad",
    "members",
    "menuAction",
    "menuAdd",
    "menuChecked",
    "menuClear",
    "menuCollapse",
    "menuData",
    "menuDelete",
    "menuEnable",
    "menuEnabled",
    "menuExpand",
    "menuHover",
    "menuPicture",
    "menuSetAction",
    "menuSetCheck",
    "menuSetData",
    "menuSetPicture",
    "menuSetShortcut",
    "menuSetText",
    "menuSetURL",
    "menuSetValue",
    "menuShortcut",
    "menuShortcutText",
    "menuSize",
    "menuSort",
    "menuText",
    "menuURL",
    "menuValue",
    "merge",
    "min",
    "mineActive",
    "mineDetectedBy",
    "missileTarget",
    "missileTargetPos",
    "missionConfigFile",
    "missionDifficulty",
    "missionEnd",
    "missionName",
    "missionNameSource",
    "missionNamespace",
    "missionProfileNamespace",
    "missionStart",
    "missionVersion",
    "mod",
    "modelToWorld",
    "modelToWorldVisual",
    "modelToWorldVisualWorld",
    "modelToWorldWorld",
    "modParams",
    "moonIntensity",
    "moonPhase",
    "morale",
    "move",
    "move3DENCamera",
    "moveInAny",
    "moveInCargo",
    "moveInCommander",
    "moveInDriver",
    "moveInGunner",
    "moveInTurret",
    "moveObjectToEnd",
    "moveOut",
    "moveTime",
    "moveTo",
    "moveToCompleted",
    "moveToFailed",
    "musicVolume",
    "name",
    "namedProperties",
    "nameSound",
    "nearEntities",
    "nearestBuilding",
    "nearestLocation",
    "nearestLocations",
    "nearestLocationWithDubbing",
    "nearestMines",
    "nearestObject",
    "nearestObjects",
    "nearestTerrainObjects",
    "nearObjects",
    "nearObjectsReady",
    "nearRoads",
    "nearSupplies",
    "nearTargets",
    "needReload",
    "needService",
    "netId",
    "netObjNull",
    "newOverlay",
    "nextMenuItemIndex",
    "nextWeatherChange",
    "nMenuItems",
    "not",
    "numberOfEnginesRTD",
    "numberToDate",
    "objectCurators",
    "objectFromNetId",
    "objectParent",
    "objStatus",
    "onBriefingGroup",
    "onBriefingNotes",
    "onBriefingPlan",
    "onBriefingTeamSwitch",
    "onCommandModeChanged",
    "onDoubleClick",
    "onEachFrame",
    "onGroupIconClick",
    "onGroupIconOverEnter",
    "onGroupIconOverLeave",
    "onHCGroupSelectionChanged",
    "onMapSingleClick",
    "onPlayerConnected",
    "onPlayerDisconnected",
    "onPreloadFinished",
    "onPreloadStarted",
    "onShowNewObject",
    "onTeamSwitch",
    "openCuratorInterface",
    "openDLCPage",
    "openGPS",
    "openMap",
    "openSteamApp",
    "openYoutubeVideo",
    "or",
    "orderGetIn",
    "overcast",
    "overcastForecast",
    "owner",
    "param",
    "params",
    "parseNumber",
    "parseSimpleArray",
    "parseText",
    "parsingNamespace",
    "particlesQuality",
    "periscopeElevation",
    "pickWeaponPool",
    "pitch",
    "pixelGrid",
    "pixelGridBase",
    "pixelGridNoUIScale",
    "pixelH",
    "pixelW",
    "playableSlotsNumber",
    "playableUnits",
    "playAction",
    "playActionNow",
    "player",
    "playerRespawnTime",
    "playerSide",
    "playersNumber",
    "playGesture",
    "playMission",
    "playMove",
    "playMoveNow",
    "playMusic",
    "playScriptedMission",
    "playSound",
    "playSound3D",
    "playSoundUI",
    "pose",
    "position",
    "positionCameraToWorld",
    "posScreenToWorld",
    "posWorldToScreen",
    "ppEffectAdjust",
    "ppEffectCommit",
    "ppEffectCommitted",
    "ppEffectCreate",
    "ppEffectDestroy",
    "ppEffectEnable",
    "ppEffectEnabled",
    "ppEffectForceInNVG",
    "precision",
    "preloadCamera",
    "preloadObject",
    "preloadSound",
    "preloadTitleObj",
    "preloadTitleRsc",
    "preprocessFile",
    "preprocessFileLineNumbers",
    "primaryWeapon",
    "primaryWeaponItems",
    "primaryWeaponMagazine",
    "priority",
    "processDiaryLink",
    "productVersion",
    "profileName",
    "profileNamespace",
    "profileNameSteam",
    "progressLoadingScreen",
    "progressPosition",
    "progressSetPosition",
    "publicVariable",
    "publicVariableClient",
    "publicVariableServer",
    "pushBack",
    "pushBackUnique",
    "putWeaponPool",
    "queryItemsPool",
    "queryMagazinePool",
    "queryWeaponPool",
    "rad",
    "radioChannelAdd",
    "radioChannelCreate",
    "radioChannelInfo",
    "radioChannelRemove",
    "radioChannelSetCallSign",
    "radioChannelSetLabel",
    "radioEnabled",
    "radioVolume",
    "rain",
    "rainbow",
    "rainParams",
    "random",
    "rank",
    "rankId",
    "rating",
    "rectangular",
    "regexFind",
    "regexMatch",
    "regexReplace",
    "registeredTasks",
    "registerTask",
    "reload",
    "reloadEnabled",
    "remoteControl",
    "remoteExec",
    "remoteExecCall",
    "remoteExecutedOwner",
    "remove3DENConnection",
    "remove3DENEventHandler",
    "remove3DENLayer",
    "removeAction",
    "removeAll3DENEventHandlers",
    "removeAllActions",
    "removeAllAssignedItems",
    "removeAllBinocularItems",
    "removeAllContainers",
    "removeAllCuratorAddons",
    "removeAllCuratorCameraAreas",
    "removeAllCuratorEditingAreas",
    "removeAllEventHandlers",
    "removeAllHandgunItems",
    "removeAllItems",
    "removeAllItemsWithMagazines",
    "removeAllMissionEventHandlers",
    "removeAllMPEventHandlers",
    "removeAllMusicEventHandlers",
    "removeAllOwnedMines",
    "removeAllPrimaryWeaponItems",
    "removeAllSecondaryWeaponItems",
    "removeAllUserActionEventHandlers",
    "removeAllWeapons",
    "removeBackpack",
    "removeBackpackGlobal",
    "removeBinocularItem",
    "removeCuratorAddons",
    "removeCuratorCameraArea",
    "removeCuratorEditableObjects",
    "removeCuratorEditingArea",
    "removeDiaryRecord",
    "removeDiarySubject",
    "removeDrawIcon",
    "removeDrawLinks",
    "removeEventHandler",
    "removeFromRemainsCollector",
    "removeGoggles",
    "removeGroupIcon",
    "removeHandgunItem",
    "removeHeadgear",
    "removeItem",
    "removeItemFromBackpack",
    "removeItemFromUniform",
    "removeItemFromVest",
    "removeItems",
    "removeMagazine",
    "removeMagazineGlobal",
    "removeMagazines",
    "removeMagazinesTurret",
    "removeMagazineTurret",
    "removeMenuItem",
    "removeMissionEventHandler",
    "removeMPEventHandler",
    "removeMusicEventHandler",
    "removeOwnedMine",
    "removePrimaryWeaponItem",
    "removeSecondaryWeaponItem",
    "removeSimpleTask",
    "removeSwitchableUnit",
    "removeTeamMember",
    "removeUniform",
    "removeUserActionEventHandler",
    "removeVest",
    "removeWeapon",
    "removeWeaponAttachmentCargo",
    "removeWeaponCargo",
    "removeWeaponGlobal",
    "removeWeaponTurret",
    "reportRemoteTarget",
    "requiredVersion",
    "resetCamShake",
    "resetSubgroupDirection",
    "resize",
    "resources",
    "respawnVehicle",
    "restartEditorCamera",
    "reveal",
    "revealMine",
    "reverse",
    "reversedMouseY",
    "roadAt",
    "roadsConnectedTo",
    "roleDescription",
    "ropeAttachedObjects",
    "ropeAttachedTo",
    "ropeAttachEnabled",
    "ropeAttachTo",
    "ropeCreate",
    "ropeCut",
    "ropeDestroy",
    "ropeDetach",
    "ropeEndPosition",
    "ropeLength",
    "ropes",
    "ropesAttachedTo",
    "ropeSegments",
    "ropeUnwind",
    "ropeUnwound",
    "rotorsForcesRTD",
    "rotorsRpmRTD",
    "round",
    "runInitScript",
    "safeZoneH",
    "safeZoneW",
    "safeZoneWAbs",
    "safeZoneX",
    "safeZoneXAbs",
    "safeZoneY",
    "save3DENInventory",
    "saveGame",
    "saveIdentity",
    "saveJoysticks",
    "saveMissionProfileNamespace",
    "saveOverlay",
    "saveProfileNamespace",
    "saveStatus",
    "saveVar",
    "savingEnabled",
    "say",
    "say2D",
    "say3D",
    "scopeName",
    "score",
    "scoreSide",
    "screenshot",
    "screenToWorld",
    "scriptDone",
    "scriptName",
    "scudState",
    "secondaryWeapon",
    "secondaryWeaponItems",
    "secondaryWeaponMagazine",
    "select",
    "selectBestPlaces",
    "selectDiarySubject",
    "selectedEditorObjects",
    "selectEditorObject",
    "selectionNames",
    "selectionPosition",
    "selectionVectorDirAndUp",
    "selectLeader",
    "selectMax",
    "selectMin",
    "selectNoPlayer",
    "selectPlayer",
    "selectRandom",
    "selectRandomWeighted",
    "selectWeapon",
    "selectWeaponTurret",
    "sendAUMessage",
    "sendSimpleCommand",
    "sendTask",
    "sendTaskResult",
    "sendUDPMessage",
    "sentencesEnabled",
    "serverCommand",
    "serverCommandAvailable",
    "serverCommandExecutable",
    "serverName",
    "serverNamespace",
    "serverTime",
    "set",
    "set3DENAttribute",
    "set3DENAttributes",
    "set3DENGrid",
    "set3DENIconsVisible",
    "set3DENLayer",
    "set3DENLinesVisible",
    "set3DENLogicType",
    "set3DENMissionAttribute",
    "set3DENMissionAttributes",
    "set3DENModelsVisible",
    "set3DENObjectType",
    "set3DENSelected",
    "setAccTime",
    "setActualCollectiveRTD",
    "setAirplaneThrottle",
    "setAirportSide",
    "setAmmo",
    "setAmmoCargo",
    "setAmmoOnPylon",
    "setAnimSpeedCoef",
    "setAperture",
    "setApertureNew",
    "setArmoryPoints",
    "setAttributes",
    "setAutonomous",
    "setBehaviour",
    "setBehaviourStrong",
    "setBleedingRemaining",
    "setBrakesRTD",
    "setCameraInterest",
    "setCamShakeDefParams",
    "setCamShakeParams",
    "setCamUseTi",
    "setCaptive",
    "setCenterOfMass",
    "setCollisionLight",
    "setCombatBehaviour",
    "setCombatMode",
    "setCompassOscillation",
    "setConvoySeparation",
    "setCruiseControl",
    "setCuratorCameraAreaCeiling",
    "setCuratorCoef",
    "setCuratorEditingAreaType",
    "setCuratorWaypointCost",
    "setCurrentChannel",
    "setCurrentTask",
    "setCurrentWaypoint",
    "setCustomAimCoef",
    "SetCustomMissionData",
    "setCustomSoundController",
    "setCustomWeightRTD",
    "setDamage",
    "setDammage",
    "setDate",
    "setDebriefingText",
    "setDefaultCamera",
    "setDestination",
    "setDetailMapBlendPars",
    "setDiaryRecordText",
    "setDiarySubjectPicture",
    "setDir",
    "setDirection",
    "setDrawIcon",
    "setDriveOnPath",
    "setDropInterval",
    "setDynamicSimulationDistance",
    "setDynamicSimulationDistanceCoef",
    "setEditorMode",
    "setEditorObjectScope",
    "setEffectCondition",
    "setEffectiveCommander",
    "setEngineRpmRTD",
    "setFace",
    "setFaceanimation",
    "setFatigue",
    "setFeatureType",
    "setFlagAnimationPhase",
    "setFlagOwner",
    "setFlagSide",
    "setFlagTexture",
    "setFog",
    "setForceGeneratorRTD",
    "setFormation",
    "setFormationTask",
    "setFormDir",
    "setFriend",
    "setFromEditor",
    "setFSMVariable",
    "setFuel",
    "setFuelCargo",
    "setGroupIcon",
    "setGroupIconParams",
    "setGroupIconsSelectable",
    "setGroupIconsVisible",
    "setGroupid",
    "setGroupIdGlobal",
    "setGroupOwner",
    "setGusts",
    "setHideBehind",
    "setHit",
    "setHitIndex",
    "setHitPointDamage",
    "setHorizonParallaxCoef",
    "setHUDMovementLevels",
    "setHumidity",
    "setIdentity",
    "setImportance",
    "setInfoPanel",
    "setLeader",
    "setLightAmbient",
    "setLightAttenuation",
    "setLightBrightness",
    "setLightColor",
    "setLightConePars",
    "setLightDayLight",
    "setLightFlareMaxDistance",
    "setLightFlareSize",
    "setLightIntensity",
    "setLightIR",
    "setLightnings",
    "setLightUseFlare",
    "setLightVolumeShape",
    "setLocalWindParams",
    "setMagazineTurretAmmo",
    "setMarkerAlpha",
    "setMarkerAlphaLocal",
    "setMarkerBrush",
    "setMarkerBrushLocal",
    "setMarkerColor",
    "setMarkerColorLocal",
    "setMarkerDir",
    "setMarkerDirLocal",
    "setMarkerPolyline",
    "setMarkerPolylineLocal",
    "setMarkerPos",
    "setMarkerPosLocal",
    "setMarkerShadow",
    "setMarkerShadowLocal",
    "setMarkerShape",
    "setMarkerShapeLocal",
    "setMarkerSize",
    "setMarkerSizeLocal",
    "setMarkerText",
    "setMarkerTextLocal",
    "setMarkerType",
    "setMarkerTypeLocal",
    "setMass",
    "setMaxLoad",
    "setMimic",
    "setMissileTarget",
    "setMissileTargetPos",
    "setMousePosition",
    "setMusicEffect",
    "setMusicEventHandler",
    "setName",
    "setNameSound",
    "setObjectArguments",
    "setObjectMaterial",
    "setObjectMaterialGlobal",
    "setObjectProxy",
    "setObjectScale",
    "setObjectTexture",
    "setObjectTextureGlobal",
    "setObjectViewDistance",
    "setOpticsMode",
    "setOvercast",
    "setOwner",
    "setOxygenRemaining",
    "setParticleCircle",
    "setParticleClass",
    "setParticleFire",
    "setParticleParams",
    "setParticleRandom",
    "setPilotCameraDirection",
    "setPilotCameraRotation",
    "setPilotCameraTarget",
    "setPilotLight",
    "setPiPEffect",
    "setPiPViewDistance",
    "setPitch",
    "setPlateNumber",
    "setPlayable",
    "setPlayerRespawnTime",
    "setPlayerVoNVolume",
    "setPos",
    "setPosASL",
    "setPosASL2",
    "setPosASLW",
    "setPosATL",
    "setPosition",
    "setPosWorld",
    "setPylonLoadout",
    "setPylonsPriority",
    "setRadioMsg",
    "setRain",
    "setRainbow",
    "setRandomLip",
    "setRank",
    "setRectangular",
    "setRepairCargo",
    "setRotorBrakeRTD",
    "setShadowDistance",
    "setShotParents",
    "setSide",
    "setSimpleTaskAlwaysVisible",
    "setSimpleTaskCustomData",
    "setSimpleTaskDescription",
    "setSimpleTaskDestination",
    "setSimpleTaskTarget",
    "setSimpleTaskType",
    "setSimulWeatherLayers",
    "setSize",
    "setSkill",
    "setSlingLoad",
    "setSoundEffect",
    "setSpeaker",
    "setSpeech",
    "setSpeedMode",
    "setStamina",
    "setStaminaScheme",
    "setStatValue",
    "setSuppression",
    "setSystemOfUnits",
    "setTargetAge",
    "setTaskMarkerOffset",
    "setTaskResult",
    "setTaskState",
    "setTerrainGrid",
    "setTerrainHeight",
    "setText",
    "setTimeMultiplier",
    "setTiParameter",
    "setTitleEffect",
    "setTowParent",
    "setTrafficDensity",
    "setTrafficDistance",
    "setTrafficGap",
    "setTrafficSpeed",
    "setTriggerActivation",
    "setTriggerArea",
    "setTriggerInterval",
    "setTriggerStatements",
    "setTriggerText",
    "setTriggerTimeout",
    "setTriggerType",
    "setTurretLimits",
    "setTurretOpticsMode",
    "setType",
    "setUnconscious",
    "setUnitAbility",
    "setUnitCombatMode",
    "setUnitFreefallHeight",
    "setUnitLoadout",
    "setUnitPos",
    "setUnitPosWeak",
    "setUnitRank",
    "setUnitRecoilCoefficient",
    "setUnitTrait",
    "setUnloadInCombat",
    "setUserActionText",
    "setUserMFDText",
    "setUserMFDValue",
    "setVariable",
    "setVectorDir",
    "setVectorDirAndUp",
    "setVectorUp",
    "setVehicleAmmo",
    "setVehicleAmmoDef",
    "setVehicleArmor",
    "setVehicleCargo",
    "setVehicleId",
    "setVehicleLock",
    "setVehiclePosition",
    "setVehicleRadar",
    "setVehicleReceiveRemoteTargets",
    "setVehicleReportOwnPosition",
    "setVehicleReportRemoteTargets",
    "setVehicleTiPars",
    "setVehicleVarName",
    "setVelocity",
    "setVelocityModelSpace",
    "setVelocityTransformation",
    "setViewDistance",
    "setVisibleIfTreeCollapsed",
    "setWantedRPMRTD",
    "setWaves",
    "setWaypointBehaviour",
    "setWaypointCombatMode",
    "setWaypointCompletionRadius",
    "setWaypointDescription",
    "setWaypointForceBehaviour",
    "setWaypointFormation",
    "setWaypointHousePosition",
    "setWaypointLoiterAltitude",
    "setWaypointLoiterRadius",
    "setWaypointLoiterType",
    "setWaypointName",
    "setWaypointPosition",
    "setWaypointScript",
    "setWaypointSpeed",
    "setWaypointStatements",
    "setWaypointTimeout",
    "setWaypointType",
    "setWaypointVisible",
    "setWeaponReloadingTime",
    "setWeaponZeroing",
    "setWind",
    "setWindDir",
    "setWindForce",
    "setWindStr",
    "setWingForceScaleRTD",
    "setWPPos",
    "show3DIcons",
    "showChat",
    "showCinemaBorder",
    "showCommandingMenu",
    "showCompass",
    "showCuratorCompass",
    "showGps",
    "showHUD",
    "showLegend",
    "showMap",
    "shownArtilleryComputer",
    "shownChat",
    "shownCompass",
    "shownCuratorCompass",
    "showNewEditorObject",
    "shownGps",
    "shownHUD",
    "shownMap",
    "shownPad",
    "shownRadio",
    "shownScoretable",
    "shownSubtitles",
    "shownUAVFeed",
    "shownWarrant",
    "shownWatch",
    "showPad",
    "showRadio",
    "showScoretable",
    "showSubtitles",
    "showUAVFeed",
    "showWarrant",
    "showWatch",
    "showWaypoint",
    "showWaypoints",
    "side",
    "sideChat",
    "sideRadio",
    "simpleTasks",
    "simulationEnabled",
    "simulCloudDensity",
    "simulCloudOcclusion",
    "simulInClouds",
    "simulWeatherSync",
    "sin",
    "size",
    "sizeOf",
    "skill",
    "skillFinal",
    "skipTime",
    "sleep",
    "sliderPosition",
    "sliderRange",
    "sliderSetPosition",
    "sliderSetRange",
    "sliderSetSpeed",
    "sliderSpeed",
    "slingLoadAssistantShown",
    "soldierMagazines",
    "someAmmo",
    "sort",
    "soundVolume",
    "spawn",
    "speaker",
    "speechVolume",
    "speed",
    "speedMode",
    "splitString",
    "sqrt",
    "squadParams",
    "stance",
    "startLoadingScreen",
    "stop",
    "stopEngineRTD",
    "stopped",
    "str",
    "sunOrMoon",
    "supportInfo",
    "suppressFor",
    "surfaceIsWater",
    "surfaceNormal",
    "surfaceTexture",
    "surfaceType",
    "swimInDepth",
    "switchableUnits",
    "switchAction",
    "switchCamera",
    "switchGesture",
    "switchLight",
    "switchMove",
    "synchronizedObjects",
    "synchronizedTriggers",
    "synchronizedWaypoints",
    "synchronizeObjectsAdd",
    "synchronizeObjectsRemove",
    "synchronizeTrigger",
    "synchronizeWaypoint",
    "systemChat",
    "systemOfUnits",
    "systemTime",
    "systemTimeUTC",
    "tan",
    "targetKnowledge",
    "targets",
    "targetsAggregate",
    "targetsQuery",
    "taskAlwaysVisible",
    "taskChildren",
    "taskCompleted",
    "taskCustomData",
    "taskDescription",
    "taskDestination",
    "taskHint",
    "taskMarkerOffset",
    "taskName",
    "taskParent",
    "taskResult",
    "taskState",
    "taskType",
    "teamMember",
    "teamName",
    "teams",
    "teamSwitch",
    "teamSwitchEnabled",
    "teamType",
    "terminate",
    "terrainIntersect",
    "terrainIntersectASL",
    "terrainIntersectAtASL",
    "text",
    "textLog",
    "textLogFormat",
    "tg",
    "time",
    "timeMultiplier",
    "titleCut",
    "titleFadeOut",
    "titleObj",
    "titleRsc",
    "titleText",
    "toArray",
    "toFixed",
    "toLower",
    "toLowerANSI",
    "toString",
    "toUpper",
    "toUpperANSI",
    "triggerActivated",
    "triggerActivation",
    "triggerAmmo",
    "triggerArea",
    "triggerAttachedVehicle",
    "triggerAttachObject",
    "triggerAttachVehicle",
    "triggerDynamicSimulation",
    "triggerInterval",
    "triggerStatements",
    "triggerText",
    "triggerTimeout",
    "triggerTimeoutCurrent",
    "triggerType",
    "trim",
    "turretLocal",
    "turretOwner",
    "turretUnit",
    "tvAdd",
    "tvClear",
    "tvCollapse",
    "tvCollapseAll",
    "tvCount",
    "tvCurSel",
    "tvData",
    "tvDelete",
    "tvExpand",
    "tvExpandAll",
    "tvIsSelected",
    "tvPicture",
    "tvPictureRight",
    "tvSelection",
    "tvSetColor",
    "tvSetCurSel",
    "tvSetData",
    "tvSetPicture",
    "tvSetPictureColor",
    "tvSetPictureColorDisabled",
    "tvSetPictureColorSelected",
    "tvSetPictureRight",
    "tvSetPictureRightColor",
    "tvSetPictureRightColorDisabled",
    "tvSetPictureRightColorSelected",
    "tvSetSelectColor",
    "tvSetSelected",
    "tvSetText",
    "tvSetTooltip",
    "tvSetValue",
    "tvSort",
    "tvSortAll",
    "tvSortByValue",
    "tvSortByValueAll",
    "tvText",
    "tvTooltip",
    "tvValue",
    "type",
    "typeName",
    "typeOf",
    "UAVControl",
    "uiNamespace",
    "uiSleep",
    "unassignCurator",
    "unassignItem",
    "unassignTeam",
    "unassignVehicle",
    "underwater",
    "uniform",
    "uniformContainer",
    "uniformItems",
    "uniformMagazines",
    "uniqueUnitItems",
    "unitAddons",
    "unitAimPosition",
    "unitAimPositionVisual",
    "unitBackpack",
    "unitCombatMode",
    "unitIsUAV",
    "unitPos",
    "unitReady",
    "unitRecoilCoefficient",
    "units",
    "unitsBelowHeight",
    "unitTurret",
    "unlinkItem",
    "unlockAchievement",
    "unregisterTask",
    "updateDrawIcon",
    "updateMenuItem",
    "updateObjectTree",
    "useAIOperMapObstructionTest",
    "useAISteeringComponent",
    "useAudioTimeForMoves",
    "userInputDisabled",
    "values",
    "vectorAdd",
    "vectorCos",
    "vectorCrossProduct",
    "vectorDiff",
    "vectorDir",
    "vectorDirVisual",
    "vectorDistance",
    "vectorDistanceSqr",
    "vectorDotProduct",
    "vectorFromTo",
    "vectorLinearConversion",
    "vectorMagnitude",
    "vectorMagnitudeSqr",
    "vectorModelToWorld",
    "vectorModelToWorldVisual",
    "vectorMultiply",
    "vectorNormalized",
    "vectorUp",
    "vectorUpVisual",
    "vectorWorldToModel",
    "vectorWorldToModelVisual",
    "vehicle",
    "vehicleCargoEnabled",
    "vehicleChat",
    "vehicleMoveInfo",
    "vehicleRadio",
    "vehicleReceiveRemoteTargets",
    "vehicleReportOwnPosition",
    "vehicleReportRemoteTargets",
    "vehicles",
    "vehicleVarName",
    "velocity",
    "velocityModelSpace",
    "verifySignature",
    "vest",
    "vestContainer",
    "vestItems",
    "vestMagazines",
    "viewDistance",
    "visibleCompass",
    "visibleGps",
    "visibleMap",
    "visiblePosition",
    "visiblePositionASL",
    "visibleScoretable",
    "visibleWatch",
    "waves",
    "waypointAttachedObject",
    "waypointAttachedVehicle",
    "waypointAttachObject",
    "waypointAttachVehicle",
    "waypointBehaviour",
    "waypointCombatMode",
    "waypointCompletionRadius",
    "waypointDescription",
    "waypointForceBehaviour",
    "waypointFormation",
    "waypointHousePosition",
    "waypointLoiterAltitude",
    "waypointLoiterRadius",
    "waypointLoiterType",
    "waypointName",
    "waypointPosition",
    "waypoints",
    "waypointScript",
    "waypointsEnabledUAV",
    "waypointShow",
    "waypointSpeed",
    "waypointStatements",
    "waypointTimeout",
    "waypointTimeoutCurrent",
    "waypointType",
    "waypointVisible",
    "weaponAccessories",
    "weaponAccessoriesCargo",
    "weaponCargo",
    "weaponDirection",
    "weaponInertia",
    "weaponLowered",
    "weaponReloadingTime",
    "weapons",
    "weaponsInfo",
    "weaponsItems",
    "weaponsItemsCargo",
    "weaponState",
    "weaponsTurret",
    "weightRTD",
    "WFSideText",
    "wind",
    "windDir",
    "windRTD",
    "windStr",
    "wingsForcesRTD",
    "worldName",
    "worldSize",
    "worldToModel",
    "worldToModelVisual",
    "worldToScreen"
  ], o = {
    className: "meta",
    begin: /#\s*[a-z]+\b/,
    end: /$/,
    keywords: "define undef ifdef ifndef else endif include if",
    contains: [
      {
        begin: /\\\n/,
        relevance: 0
      },
      t.inherit(i, { className: "string" }),
      {
        begin: /<[^\n>]*>/,
        end: /$/,
        illegal: "\\n"
      },
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE
    ]
  };
  return {
    name: "SQF",
    case_insensitive: !0,
    keywords: {
      keyword: r,
      built_in: s,
      literal: a
    },
    contains: [
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      t.NUMBER_MODE,
      e,
      n,
      i,
      o
    ],
    illegal: [
      //$ is only valid when used with Hex numbers (e.g. $FF)
      /\$[^a-fA-F0-9]/,
      /\w\$/,
      /\?/,
      //There's no ? in SQF
      /@/,
      //There's no @ in SQF
      // Brute-force-fixing the build error. See https://github.com/highlightjs/highlight.js/pull/3193#issuecomment-843088729
      / \| /,
      // . is only used in numbers
      /[a-zA-Z_]\./,
      /\:\=/,
      /\[\:/
    ]
  };
}
function eS(t) {
  const e = t.regex, n = [
    "functions",
    "model",
    "data",
    "parameters",
    "quantities",
    "transformed",
    "generated"
  ], i = [
    "for",
    "in",
    "if",
    "else",
    "while",
    "break",
    "continue",
    "return"
  ], r = [
    "array",
    "tuple",
    "complex",
    "int",
    "real",
    "vector",
    "complex_vector",
    "ordered",
    "positive_ordered",
    "simplex",
    "unit_vector",
    "row_vector",
    "complex_row_vector",
    "matrix",
    "complex_matrix",
    "cholesky_factor_corr|10",
    "cholesky_factor_cov|10",
    "corr_matrix|10",
    "cov_matrix|10",
    "void"
  ], a = [
    "abs",
    "acos",
    "acosh",
    "add_diag",
    "algebra_solver",
    "algebra_solver_newton",
    "append_array",
    "append_col",
    "append_row",
    "asin",
    "asinh",
    "atan",
    "atan2",
    "atanh",
    "bessel_first_kind",
    "bessel_second_kind",
    "binary_log_loss",
    "block",
    "cbrt",
    "ceil",
    "chol2inv",
    "cholesky_decompose",
    "choose",
    "col",
    "cols",
    "columns_dot_product",
    "columns_dot_self",
    "complex_schur_decompose",
    "complex_schur_decompose_t",
    "complex_schur_decompose_u",
    "conj",
    "cos",
    "cosh",
    "cov_exp_quad",
    "crossprod",
    "csr_extract",
    "csr_extract_u",
    "csr_extract_v",
    "csr_extract_w",
    "csr_matrix_times_vector",
    "csr_to_dense_matrix",
    "cumulative_sum",
    "dae",
    "dae_tol",
    "determinant",
    "diag_matrix",
    "diagonal",
    "diag_post_multiply",
    "diag_pre_multiply",
    "digamma",
    "dims",
    "distance",
    "dot_product",
    "dot_self",
    "eigendecompose",
    "eigendecompose_sym",
    "eigenvalues",
    "eigenvalues_sym",
    "eigenvectors",
    "eigenvectors_sym",
    "erf",
    "erfc",
    "exp",
    "exp2",
    "expm1",
    "falling_factorial",
    "fdim",
    "fft",
    "fft2",
    "floor",
    "fma",
    "fmax",
    "fmin",
    "fmod",
    "gamma_p",
    "gamma_q",
    "generalized_inverse",
    "get_imag",
    "get_real",
    "head",
    "hmm_hidden_state_prob",
    "hmm_marginal",
    "hypot",
    "identity_matrix",
    "inc_beta",
    "integrate_1d",
    "integrate_ode",
    "integrate_ode_adams",
    "integrate_ode_bdf",
    "integrate_ode_rk45",
    "int_step",
    "inv",
    "inv_cloglog",
    "inv_erfc",
    "inverse",
    "inverse_spd",
    "inv_fft",
    "inv_fft2",
    "inv_inc_beta",
    "inv_logit",
    "inv_Phi",
    "inv_sqrt",
    "inv_square",
    "is_inf",
    "is_nan",
    "lambert_w0",
    "lambert_wm1",
    "lbeta",
    "lchoose",
    "ldexp",
    "lgamma",
    "linspaced_array",
    "linspaced_int_array",
    "linspaced_row_vector",
    "linspaced_vector",
    "lmgamma",
    "lmultiply",
    "log",
    "log1m",
    "log1m_exp",
    "log1m_inv_logit",
    "log1p",
    "log1p_exp",
    "log_determinant",
    "log_diff_exp",
    "log_falling_factorial",
    "log_inv_logit",
    "log_inv_logit_diff",
    "logit",
    "log_mix",
    "log_modified_bessel_first_kind",
    "log_rising_factorial",
    "log_softmax",
    "log_sum_exp",
    "machine_precision",
    "map_rect",
    "matrix_exp",
    "matrix_exp_multiply",
    "matrix_power",
    "max",
    "mdivide_left_spd",
    "mdivide_left_tri_low",
    "mdivide_right_spd",
    "mdivide_right_tri_low",
    "mean",
    "min",
    "modified_bessel_first_kind",
    "modified_bessel_second_kind",
    "multiply_lower_tri_self_transpose",
    "negative_infinity",
    "norm",
    "norm1",
    "norm2",
    "not_a_number",
    "num_elements",
    "ode_adams",
    "ode_adams_tol",
    "ode_adjoint_tol_ctl",
    "ode_bdf",
    "ode_bdf_tol",
    "ode_ckrk",
    "ode_ckrk_tol",
    "ode_rk45",
    "ode_rk45_tol",
    "one_hot_array",
    "one_hot_int_array",
    "one_hot_row_vector",
    "one_hot_vector",
    "ones_array",
    "ones_int_array",
    "ones_row_vector",
    "ones_vector",
    "owens_t",
    "Phi",
    "Phi_approx",
    "polar",
    "positive_infinity",
    "pow",
    "print",
    "prod",
    "proj",
    "qr",
    "qr_Q",
    "qr_R",
    "qr_thin",
    "qr_thin_Q",
    "qr_thin_R",
    "quad_form",
    "quad_form_diag",
    "quad_form_sym",
    "quantile",
    "rank",
    "reduce_sum",
    "reject",
    "rep_array",
    "rep_matrix",
    "rep_row_vector",
    "rep_vector",
    "reverse",
    "rising_factorial",
    "round",
    "row",
    "rows",
    "rows_dot_product",
    "rows_dot_self",
    "scale_matrix_exp_multiply",
    "sd",
    "segment",
    "sin",
    "singular_values",
    "sinh",
    "size",
    "softmax",
    "sort_asc",
    "sort_desc",
    "sort_indices_asc",
    "sort_indices_desc",
    "sqrt",
    "square",
    "squared_distance",
    "step",
    "sub_col",
    "sub_row",
    "sum",
    "svd",
    "svd_U",
    "svd_V",
    "symmetrize_from_lower_tri",
    "tail",
    "tan",
    "tanh",
    "target",
    "tcrossprod",
    "tgamma",
    "to_array_1d",
    "to_array_2d",
    "to_complex",
    "to_int",
    "to_matrix",
    "to_row_vector",
    "to_vector",
    "trace",
    "trace_gen_quad_form",
    "trace_quad_form",
    "trigamma",
    "trunc",
    "uniform_simplex",
    "variance",
    "zeros_array",
    "zeros_int_array",
    "zeros_row_vector"
  ], s = [
    "bernoulli",
    "bernoulli_logit",
    "bernoulli_logit_glm",
    "beta",
    "beta_binomial",
    "beta_proportion",
    "binomial",
    "binomial_logit",
    "categorical",
    "categorical_logit",
    "categorical_logit_glm",
    "cauchy",
    "chi_square",
    "dirichlet",
    "discrete_range",
    "double_exponential",
    "exp_mod_normal",
    "exponential",
    "frechet",
    "gamma",
    "gaussian_dlm_obs",
    "gumbel",
    "hmm_latent",
    "hypergeometric",
    "inv_chi_square",
    "inv_gamma",
    "inv_wishart",
    "inv_wishart_cholesky",
    "lkj_corr",
    "lkj_corr_cholesky",
    "logistic",
    "loglogistic",
    "lognormal",
    "multi_gp",
    "multi_gp_cholesky",
    "multinomial",
    "multinomial_logit",
    "multi_normal",
    "multi_normal_cholesky",
    "multi_normal_prec",
    "multi_student_cholesky_t",
    "multi_student_t",
    "multi_student_t_cholesky",
    "neg_binomial",
    "neg_binomial_2",
    "neg_binomial_2_log",
    "neg_binomial_2_log_glm",
    "normal",
    "normal_id_glm",
    "ordered_logistic",
    "ordered_logistic_glm",
    "ordered_probit",
    "pareto",
    "pareto_type_2",
    "poisson",
    "poisson_log",
    "poisson_log_glm",
    "rayleigh",
    "scaled_inv_chi_square",
    "skew_double_exponential",
    "skew_normal",
    "std_normal",
    "std_normal_log",
    "student_t",
    "uniform",
    "von_mises",
    "weibull",
    "wiener",
    "wishart",
    "wishart_cholesky"
  ], o = t.COMMENT(
    /\/\*/,
    /\*\//,
    {
      relevance: 0,
      contains: [
        {
          scope: "doctag",
          match: /@(return|param)/
        }
      ]
    }
  ), l = {
    scope: "meta",
    begin: /#include\b/,
    end: /$/,
    contains: [
      {
        match: /[a-z][a-z-._]+/,
        scope: "string"
      },
      t.C_LINE_COMMENT_MODE
    ]
  }, c = [
    "lower",
    "upper",
    "offset",
    "multiplier"
  ];
  return {
    name: "Stan",
    aliases: ["stanfuncs"],
    keywords: {
      $pattern: t.IDENT_RE,
      title: n,
      type: r,
      keyword: i,
      built_in: a
    },
    contains: [
      t.C_LINE_COMMENT_MODE,
      l,
      t.HASH_COMMENT_MODE,
      o,
      {
        scope: "built_in",
        match: /\s(pi|e|sqrt2|log2|log10)(?=\()/,
        relevance: 0
      },
      {
        match: e.concat(/[<,]\s*/, e.either(...c), /\s*=/),
        keywords: c
      },
      {
        scope: "keyword",
        match: /\btarget(?=\s*\+=)/
      },
      {
        // highlights the 'T' in T[,] for only Stan language distributrions
        match: [
          /~\s*/,
          e.either(...s),
          /(?:\(\))/,
          /\s*T(?=\s*\[)/
        ],
        scope: {
          2: "built_in",
          4: "keyword"
        }
      },
      {
        // highlights distributions that end with special endings
        scope: "built_in",
        keywords: s,
        begin: e.concat(/\w*/, e.either(...s), /(_lpdf|_lupdf|_lpmf|_cdf|_lcdf|_lccdf|_qf)(?=\s*[\(.*\)])/)
      },
      {
        // highlights distributions after ~
        begin: [
          /~/,
          /\s*/,
          e.concat(e.either(...s), /(?=\s*[\(.*\)])/)
        ],
        scope: { 3: "built_in" }
      },
      {
        // highlights user defined distributions after ~
        begin: [
          /~/,
          /\s*\w+(?=\s*[\(.*\)])/,
          "(?!.*/\b(" + e.either(...s) + ")\b)"
        ],
        scope: { 2: "title.function" }
      },
      {
        // highlights user defined distributions with special endings
        scope: "title.function",
        begin: /\w*(_lpdf|_lupdf|_lpmf|_cdf|_lcdf|_lccdf|_qf)(?=\s*[\(.*\)])/
      },
      {
        scope: "number",
        match: e.concat(
          // Comes from @RunDevelopment accessed 11/29/2021 at
          // https://github.com/PrismJS/prism/blob/c53ad2e65b7193ab4f03a1797506a54bbb33d5a2/components/prism-stan.js#L56
          // start of big noncapture group which
          // 1. gets numbers that are by themselves
          // 2. numbers that are separated by _
          // 3. numbers that are separted by .
          /(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)/,
          // grabs scientific notation
          // grabs complex numbers with i
          /(?:[eE][+-]?\d+(?:_\d+)*)?i?(?!\w)/
        ),
        relevance: 0
      },
      {
        scope: "string",
        begin: /"/,
        end: /"/
      }
    ]
  };
}
function tS(t) {
  return {
    name: "Stata",
    aliases: [
      "do",
      "ado"
    ],
    case_insensitive: !0,
    keywords: "if else in foreach for forv forva forval forvalu forvalue forvalues by bys bysort xi quietly qui capture about ac ac_7 acprplot acprplot_7 adjust ado adopath adoupdate alpha ameans an ano anov anova anova_estat anova_terms anovadef aorder ap app appe appen append arch arch_dr arch_estat arch_p archlm areg areg_p args arima arima_dr arima_estat arima_p as asmprobit asmprobit_estat asmprobit_lf asmprobit_mfx__dlg asmprobit_p ass asse asser assert avplot avplot_7 avplots avplots_7 bcskew0 bgodfrey bias binreg bip0_lf biplot bipp_lf bipr_lf bipr_p biprobit bitest bitesti bitowt blogit bmemsize boot bootsamp bootstrap bootstrap_8 boxco_l boxco_p boxcox boxcox_6 boxcox_p bprobit br break brier bro brow brows browse brr brrstat bs bs_7 bsampl_w bsample bsample_7 bsqreg bstat bstat_7 bstat_8 bstrap bstrap_7 bubble bubbleplot ca ca_estat ca_p cabiplot camat canon canon_8 canon_8_p canon_estat canon_p cap caprojection capt captu captur capture cat cc cchart cchart_7 cci cd censobs_table centile cf char chdir checkdlgfiles checkestimationsample checkhlpfiles checksum chelp ci cii cl class classutil clear cli clis clist clo clog clog_lf clog_p clogi clogi_sw clogit clogit_lf clogit_p clogitp clogl_sw cloglog clonevar clslistarray cluster cluster_measures cluster_stop cluster_tree cluster_tree_8 clustermat cmdlog cnr cnre cnreg cnreg_p cnreg_sw cnsreg codebook collaps4 collapse colormult_nb colormult_nw compare compress conf confi confir confirm conren cons const constr constra constrai constrain constraint continue contract copy copyright copysource cor corc corr corr2data corr_anti corr_kmo corr_smc corre correl correla correlat correlate corrgram cou coun count cox cox_p cox_sw coxbase coxhaz coxvar cprplot cprplot_7 crc cret cretu cretur creturn cross cs cscript cscript_log csi ct ct_is ctset ctst_5 ctst_st cttost cumsp cumsp_7 cumul cusum cusum_7 cutil d|0 datasig datasign datasigna datasignat datasignatu datasignatur datasignature datetof db dbeta de dec deco decod decode deff des desc descr descri describ describe destring dfbeta dfgls dfuller di di_g dir dirstats dis discard disp disp_res disp_s displ displa display distinct do doe doed doedi doedit dotplot dotplot_7 dprobit drawnorm drop ds ds_util dstdize duplicates durbina dwstat dydx e|0 ed edi edit egen eivreg emdef en enc enco encod encode eq erase ereg ereg_lf ereg_p ereg_sw ereghet ereghet_glf ereghet_glf_sh ereghet_gp ereghet_ilf ereghet_ilf_sh ereghet_ip eret eretu eretur ereturn err erro error esize est est_cfexist est_cfname est_clickable est_expand est_hold est_table est_unhold est_unholdok estat estat_default estat_summ estat_vce_only esti estimates etodow etof etomdy ex exi exit expand expandcl fac fact facto factor factor_estat factor_p factor_pca_rotated factor_rotate factormat fcast fcast_compute fcast_graph fdades fdadesc fdadescr fdadescri fdadescrib fdadescribe fdasav fdasave fdause fh_st file open file read file close file filefilter fillin find_hlp_file findfile findit findit_7 fit fl fli flis flist for5_0 forest forestplot form forma format fpredict frac_154 frac_adj frac_chk frac_cox frac_ddp frac_dis frac_dv frac_in frac_mun frac_pp frac_pq frac_pv frac_wgt frac_xo fracgen fracplot fracplot_7 fracpoly fracpred fron_ex fron_hn fron_p fron_tn fron_tn2 frontier ftodate ftoe ftomdy ftowdate funnel funnelplot g|0 gamhet_glf gamhet_gp gamhet_ilf gamhet_ip gamma gamma_d2 gamma_p gamma_sw gammahet gdi_hexagon gdi_spokes ge gen gene gener genera generat generate genrank genstd genvmean gettoken gl gladder gladder_7 glim_l01 glim_l02 glim_l03 glim_l04 glim_l05 glim_l06 glim_l07 glim_l08 glim_l09 glim_l10 glim_l11 glim_l12 glim_lf glim_mu glim_nw1 glim_nw2 glim_nw3 glim_p glim_v1 glim_v2 glim_v3 glim_v4 glim_v5 glim_v6 glim_v7 glm glm_6 glm_p glm_sw glmpred glo glob globa global glogit glogit_8 glogit_p gmeans gnbre_lf gnbreg gnbreg_5 gnbreg_p gomp_lf gompe_sw gomper_p gompertz gompertzhet gomphet_glf gomphet_glf_sh gomphet_gp gomphet_ilf gomphet_ilf_sh gomphet_ip gphdot gphpen gphprint gprefs gprobi_p gprobit gprobit_8 gr gr7 gr_copy gr_current gr_db gr_describe gr_dir gr_draw gr_draw_replay gr_drop gr_edit gr_editviewopts gr_example gr_example2 gr_export gr_print gr_qscheme gr_query gr_read gr_rename gr_replay gr_save gr_set gr_setscheme gr_table gr_undo gr_use graph graph7 grebar greigen greigen_7 greigen_8 grmeanby grmeanby_7 gs_fileinfo gs_filetype gs_graphinfo gs_stat gsort gwood h|0 hadimvo hareg hausman haver he heck_d2 heckma_p heckman heckp_lf heckpr_p heckprob hel help hereg hetpr_lf hetpr_p hetprob hettest hexdump hilite hist hist_7 histogram hlogit hlu hmeans hotel hotelling hprobit hreg hsearch icd9 icd9_ff icd9p iis impute imtest inbase include inf infi infil infile infix inp inpu input ins insheet insp inspe inspec inspect integ inten intreg intreg_7 intreg_p intrg2_ll intrg_ll intrg_ll2 ipolate iqreg ir irf irf_create irfm iri is_svy is_svysum isid istdize ivprob_1_lf ivprob_lf ivprobit ivprobit_p ivreg ivreg_footnote ivtob_1_lf ivtob_lf ivtobit ivtobit_p jackknife jacknife jknife jknife_6 jknife_8 jkstat joinby kalarma1 kap kap_3 kapmeier kappa kapwgt kdensity kdensity_7 keep ksm ksmirnov ktau kwallis l|0 la lab labbe labbeplot labe label labelbook ladder levels levelsof leverage lfit lfit_p li lincom line linktest lis list lloghet_glf lloghet_glf_sh lloghet_gp lloghet_ilf lloghet_ilf_sh lloghet_ip llogi_sw llogis_p llogist llogistic llogistichet lnorm_lf lnorm_sw lnorma_p lnormal lnormalhet lnormhet_glf lnormhet_glf_sh lnormhet_gp lnormhet_ilf lnormhet_ilf_sh lnormhet_ip lnskew0 loadingplot loc loca local log logi logis_lf logistic logistic_p logit logit_estat logit_p loglogs logrank loneway lookfor lookup lowess lowess_7 lpredict lrecomp lroc lroc_7 lrtest ls lsens lsens_7 lsens_x lstat ltable ltable_7 ltriang lv lvr2plot lvr2plot_7 m|0 ma mac macr macro makecns man manova manova_estat manova_p manovatest mantel mark markin markout marksample mat mat_capp mat_order mat_put_rr mat_rapp mata mata_clear mata_describe mata_drop mata_matdescribe mata_matsave mata_matuse mata_memory mata_mlib mata_mosave mata_rename mata_which matalabel matcproc matlist matname matr matri matrix matrix_input__dlg matstrik mcc mcci md0_ md1_ md1debug_ md2_ md2debug_ mds mds_estat mds_p mdsconfig mdslong mdsmat mdsshepard mdytoe mdytof me_derd mean means median memory memsize menl meqparse mer merg merge meta mfp mfx mhelp mhodds minbound mixed_ll mixed_ll_reparm mkassert mkdir mkmat mkspline ml ml_5 ml_adjs ml_bhhhs ml_c_d ml_check ml_clear ml_cnt ml_debug ml_defd ml_e0 ml_e0_bfgs ml_e0_cycle ml_e0_dfp ml_e0i ml_e1 ml_e1_bfgs ml_e1_bhhh ml_e1_cycle ml_e1_dfp ml_e2 ml_e2_cycle ml_ebfg0 ml_ebfr0 ml_ebfr1 ml_ebh0q ml_ebhh0 ml_ebhr0 ml_ebr0i ml_ecr0i ml_edfp0 ml_edfr0 ml_edfr1 ml_edr0i ml_eds ml_eer0i ml_egr0i ml_elf ml_elf_bfgs ml_elf_bhhh ml_elf_cycle ml_elf_dfp ml_elfi ml_elfs ml_enr0i ml_enrr0 ml_erdu0 ml_erdu0_bfgs ml_erdu0_bhhh ml_erdu0_bhhhq ml_erdu0_cycle ml_erdu0_dfp ml_erdu0_nrbfgs ml_exde ml_footnote ml_geqnr ml_grad0 ml_graph ml_hbhhh ml_hd0 ml_hold ml_init ml_inv ml_log ml_max ml_mlout ml_mlout_8 ml_model ml_nb0 ml_opt ml_p ml_plot ml_query ml_rdgrd ml_repor ml_s_e ml_score ml_searc ml_technique ml_unhold mleval mlf_ mlmatbysum mlmatsum mlog mlogi mlogit mlogit_footnote mlogit_p mlopts mlsum mlvecsum mnl0_ mor more mov move mprobit mprobit_lf mprobit_p mrdu0_ mrdu1_ mvdecode mvencode mvreg mvreg_estat n|0 nbreg nbreg_al nbreg_lf nbreg_p nbreg_sw nestreg net newey newey_7 newey_p news nl nl_7 nl_9 nl_9_p nl_p nl_p_7 nlcom nlcom_p nlexp2 nlexp2_7 nlexp2a nlexp2a_7 nlexp3 nlexp3_7 nlgom3 nlgom3_7 nlgom4 nlgom4_7 nlinit nllog3 nllog3_7 nllog4 nllog4_7 nlog_rd nlogit nlogit_p nlogitgen nlogittree nlpred no nobreak noi nois noisi noisil noisily note notes notes_dlg nptrend numlabel numlist odbc old_ver olo olog ologi ologi_sw ologit ologit_p ologitp on one onew onewa oneway op_colnm op_comp op_diff op_inv op_str opr opro oprob oprob_sw oprobi oprobi_p oprobit oprobitp opts_exclusive order orthog orthpoly ou out outf outfi outfil outfile outs outsh outshe outshee outsheet ovtest pac pac_7 palette parse parse_dissim pause pca pca_8 pca_display pca_estat pca_p pca_rotate pcamat pchart pchart_7 pchi pchi_7 pcorr pctile pentium pergram pergram_7 permute permute_8 personal peto_st pkcollapse pkcross pkequiv pkexamine pkexamine_7 pkshape pksumm pksumm_7 pl plo plot plugin pnorm pnorm_7 poisgof poiss_lf poiss_sw poisso_p poisson poisson_estat post postclose postfile postutil pperron pr prais prais_e prais_e2 prais_p predict predictnl preserve print pro prob probi probit probit_estat probit_p proc_time procoverlay procrustes procrustes_estat procrustes_p profiler prog progr progra program prop proportion prtest prtesti pwcorr pwd q\\s qby qbys qchi qchi_7 qladder qladder_7 qnorm qnorm_7 qqplot qqplot_7 qreg qreg_c qreg_p qreg_sw qu quadchk quantile quantile_7 que quer query range ranksum ratio rchart rchart_7 rcof recast reclink recode reg reg3 reg3_p regdw regr regre regre_p2 regres regres_p regress regress_estat regriv_p remap ren rena renam rename renpfix repeat replace report reshape restore ret retu retur return rm rmdir robvar roccomp roccomp_7 roccomp_8 rocf_lf rocfit rocfit_8 rocgold rocplot rocplot_7 roctab roctab_7 rolling rologit rologit_p rot rota rotat rotate rotatemat rreg rreg_p ru run runtest rvfplot rvfplot_7 rvpplot rvpplot_7 sa safesum sample sampsi sav save savedresults saveold sc sca scal scala scalar scatter scm_mine sco scob_lf scob_p scobi_sw scobit scor score scoreplot scoreplot_help scree screeplot screeplot_help sdtest sdtesti se search separate seperate serrbar serrbar_7 serset set set_defaults sfrancia sh she shel shell shewhart shewhart_7 signestimationsample signrank signtest simul simul_7 simulate simulate_8 sktest sleep slogit slogit_d2 slogit_p smooth snapspan so sor sort spearman spikeplot spikeplot_7 spikeplt spline_x split sqreg sqreg_p sret sretu sretur sreturn ssc st st_ct st_hc st_hcd st_hcd_sh st_is st_issys st_note st_promo st_set st_show st_smpl st_subid stack statsby statsby_8 stbase stci stci_7 stcox stcox_estat stcox_fr stcox_fr_ll stcox_p stcox_sw stcoxkm stcoxkm_7 stcstat stcurv stcurve stcurve_7 stdes stem stepwise stereg stfill stgen stir stjoin stmc stmh stphplot stphplot_7 stphtest stphtest_7 stptime strate strate_7 streg streg_sw streset sts sts_7 stset stsplit stsum sttocc sttoct stvary stweib su suest suest_8 sum summ summa summar summari summariz summarize sunflower sureg survcurv survsum svar svar_p svmat svy svy_disp svy_dreg svy_est svy_est_7 svy_estat svy_get svy_gnbreg_p svy_head svy_header svy_heckman_p svy_heckprob_p svy_intreg_p svy_ivreg_p svy_logistic_p svy_logit_p svy_mlogit_p svy_nbreg_p svy_ologit_p svy_oprobit_p svy_poisson_p svy_probit_p svy_regress_p svy_sub svy_sub_7 svy_x svy_x_7 svy_x_p svydes svydes_8 svygen svygnbreg svyheckman svyheckprob svyintreg svyintreg_7 svyintrg svyivreg svylc svylog_p svylogit svymarkout svymarkout_8 svymean svymlog svymlogit svynbreg svyolog svyologit svyoprob svyoprobit svyopts svypois svypois_7 svypoisson svyprobit svyprobt svyprop svyprop_7 svyratio svyreg svyreg_p svyregress svyset svyset_7 svyset_8 svytab svytab_7 svytest svytotal sw sw_8 swcnreg swcox swereg swilk swlogis swlogit swologit swoprbt swpois swprobit swqreg swtobit swweib symmetry symmi symplot symplot_7 syntax sysdescribe sysdir sysuse szroeter ta tab tab1 tab2 tab_or tabd tabdi tabdis tabdisp tabi table tabodds tabodds_7 tabstat tabu tabul tabula tabulat tabulate te tempfile tempname tempvar tes test testnl testparm teststd tetrachoric time_it timer tis tob tobi tobit tobit_p tobit_sw token tokeni tokeniz tokenize tostring total translate translator transmap treat_ll treatr_p treatreg trim trimfill trnb_cons trnb_mean trpoiss_d2 trunc_ll truncr_p truncreg tsappend tset tsfill tsline tsline_ex tsreport tsrevar tsrline tsset tssmooth tsunab ttest ttesti tut_chk tut_wait tutorial tw tware_st two twoway twoway__fpfit_serset twoway__function_gen twoway__histogram_gen twoway__ipoint_serset twoway__ipoints_serset twoway__kdensity_gen twoway__lfit_serset twoway__normgen_gen twoway__pci_serset twoway__qfit_serset twoway__scatteri_serset twoway__sunflower_gen twoway_ksm_serset ty typ type typeof u|0 unab unabbrev unabcmd update us use uselabel var var_mkcompanion var_p varbasic varfcast vargranger varirf varirf_add varirf_cgraph varirf_create varirf_ctable varirf_describe varirf_dir varirf_drop varirf_erase varirf_graph varirf_ograph varirf_rename varirf_set varirf_table varlist varlmar varnorm varsoc varstable varstable_w varstable_w2 varwle vce vec vec_fevd vec_mkphi vec_p vec_p_w vecirf_create veclmar veclmar_w vecnorm vecnorm_w vecrank vecstable verinst vers versi versio version view viewsource vif vwls wdatetof webdescribe webseek webuse weib1_lf weib2_lf weib_lf weib_lf0 weibhet_glf weibhet_glf_sh weibhet_glfa weibhet_glfa_sh weibhet_gp weibhet_ilf weibhet_ilf_sh weibhet_ilfa weibhet_ilfa_sh weibhet_ip weibu_sw weibul_p weibull weibull_c weibull_s weibullhet wh whelp whi which whil while wilc_st wilcoxon win wind windo window winexec wntestb wntestb_7 wntestq xchart xchart_7 xcorr xcorr_7 xi xi_6 xmlsav xmlsave xmluse xpose xsh xshe xshel xshell xt_iis xt_tis xtab_p xtabond xtbin_p xtclog xtcloglog xtcloglog_8 xtcloglog_d2 xtcloglog_pa_p xtcloglog_re_p xtcnt_p xtcorr xtdata xtdes xtfront_p xtfrontier xtgee xtgee_elink xtgee_estat xtgee_makeivar xtgee_p xtgee_plink xtgls xtgls_p xthaus xthausman xtht_p xthtaylor xtile xtint_p xtintreg xtintreg_8 xtintreg_d2 xtintreg_p xtivp_1 xtivp_2 xtivreg xtline xtline_ex xtlogit xtlogit_8 xtlogit_d2 xtlogit_fe_p xtlogit_pa_p xtlogit_re_p xtmixed xtmixed_estat xtmixed_p xtnb_fe xtnb_lf xtnbreg xtnbreg_pa_p xtnbreg_refe_p xtpcse xtpcse_p xtpois xtpoisson xtpoisson_d2 xtpoisson_pa_p xtpoisson_refe_p xtpred xtprobit xtprobit_8 xtprobit_d2 xtprobit_re_p xtps_fe xtps_lf xtps_ren xtps_ren_8 xtrar_p xtrc xtrc_p xtrchh xtrefe_p xtreg xtreg_be xtreg_fe xtreg_ml xtreg_pa_p xtreg_re xtregar xtrere_p xtset xtsf_ll xtsf_llti xtsum xttab xttest0 xttobit xttobit_8 xttobit_p xttrans yx yxview__barlike_draw yxview_area_draw yxview_bar_draw yxview_dot_draw yxview_dropline_draw yxview_function_draw yxview_iarrow_draw yxview_ilabels_draw yxview_normal_draw yxview_pcarrow_draw yxview_pcbarrow_draw yxview_pccapsym_draw yxview_pcscatter_draw yxview_pcspike_draw yxview_rarea_draw yxview_rbar_draw yxview_rbarm_draw yxview_rcap_draw yxview_rcapsym_draw yxview_rconnected_draw yxview_rline_draw yxview_rscatter_draw yxview_rspike_draw yxview_spike_draw yxview_sunflower_draw zap_s zinb zinb_llf zinb_plf zip zip_llf zip_p zip_plf zt_ct_5 zt_hc_5 zt_hcd_5 zt_is_5 zt_iss_5 zt_sho_5 zt_smp_5 ztbase_5 ztcox_5 ztdes_5 ztereg_5 ztfill_5 ztgen_5 ztir_5 ztjoin_5 ztnb ztnb_p ztp ztp_p zts_5 ztset_5 ztspli_5 ztsum_5 zttoct_5 ztvary_5 ztweib_5",
    contains: [
      {
        className: "symbol",
        begin: /`[a-zA-Z0-9_]+'/
      },
      {
        className: "variable",
        begin: /\$\{?[a-zA-Z0-9_]+\}?/,
        relevance: 0
      },
      {
        className: "string",
        variants: [
          { begin: `\`"[^\r
]*?"'` },
          { begin: `"[^\r
"]*"` }
        ]
      },
      {
        className: "built_in",
        variants: [{ begin: "\\b(abs|acos|asin|atan|atan2|atanh|ceil|cloglog|comb|cos|digamma|exp|floor|invcloglog|invlogit|ln|lnfact|lnfactorial|lngamma|log|log10|max|min|mod|reldif|round|sign|sin|sqrt|sum|tan|tanh|trigamma|trunc|betaden|Binomial|binorm|binormal|chi2|chi2tail|dgammapda|dgammapdada|dgammapdadx|dgammapdx|dgammapdxdx|F|Fden|Ftail|gammaden|gammap|ibeta|invbinomial|invchi2|invchi2tail|invF|invFtail|invgammap|invibeta|invnchi2|invnFtail|invnibeta|invnorm|invnormal|invttail|nbetaden|nchi2|nFden|nFtail|nibeta|norm|normal|normalden|normd|npnchi2|tden|ttail|uniform|abbrev|char|index|indexnot|length|lower|ltrim|match|plural|proper|real|regexm|regexr|regexs|reverse|rtrim|string|strlen|strlower|strltrim|strmatch|strofreal|strpos|strproper|strreverse|strrtrim|strtrim|strupper|subinstr|subinword|substr|trim|upper|word|wordcount|_caller|autocode|byteorder|chop|clip|cond|e|epsdouble|epsfloat|group|inlist|inrange|irecode|matrix|maxbyte|maxdouble|maxfloat|maxint|maxlong|mi|minbyte|mindouble|minfloat|minint|minlong|missing|r|recode|replay|return|s|scalar|d|date|day|dow|doy|halfyear|mdy|month|quarter|week|year|d|daily|dofd|dofh|dofm|dofq|dofw|dofy|h|halfyearly|hofd|m|mofd|monthly|q|qofd|quarterly|tin|twithin|w|weekly|wofd|y|yearly|yh|ym|yofd|yq|yw|cholesky|colnumb|colsof|corr|det|diag|diag0cnt|el|get|hadamard|I|inv|invsym|issym|issymmetric|J|matmissing|matuniform|mreldif|nullmat|rownumb|rowsof|sweep|syminv|trace|vec|vecdiag)(?=\\()" }]
      },
      t.COMMENT("^[ 	]*\\*.*$", !1),
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE
    ]
  };
}
function nS(t) {
  return {
    name: "STEP Part 21",
    aliases: [
      "p21",
      "step",
      "stp"
    ],
    case_insensitive: !0,
    // STEP 21 is case insensitive in theory, in practice all non-comments are capitalized.
    keywords: {
      $pattern: "[A-Z_][A-Z0-9_.]*",
      keyword: [
        "HEADER",
        "ENDSEC",
        "DATA"
      ]
    },
    contains: [
      {
        className: "meta",
        begin: "ISO-10303-21;",
        relevance: 10
      },
      {
        className: "meta",
        begin: "END-ISO-10303-21;",
        relevance: 10
      },
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      t.COMMENT("/\\*\\*!", "\\*/"),
      t.C_NUMBER_MODE,
      t.inherit(t.APOS_STRING_MODE, { illegal: null }),
      t.inherit(t.QUOTE_STRING_MODE, { illegal: null }),
      {
        className: "string",
        begin: "'",
        end: "'"
      },
      {
        className: "symbol",
        variants: [
          {
            begin: "#",
            end: "\\d+",
            illegal: "\\W"
          }
        ]
      }
    ]
  };
}
const iS = (t) => ({
  IMPORTANT: {
    scope: "meta",
    begin: "!important"
  },
  BLOCK_COMMENT: t.C_BLOCK_COMMENT_MODE,
  HEXCOLOR: {
    scope: "number",
    begin: /#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\b/
  },
  FUNCTION_DISPATCH: {
    className: "built_in",
    begin: /[\w-]+(?=\()/
  },
  ATTRIBUTE_SELECTOR_MODE: {
    scope: "selector-attr",
    begin: /\[/,
    end: /\]/,
    illegal: "$",
    contains: [
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE
    ]
  },
  CSS_NUMBER_MODE: {
    scope: "number",
    begin: t.NUMBER_RE + "(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",
    relevance: 0
  },
  CSS_VARIABLE: {
    className: "attr",
    begin: /--[A-Za-z_][A-Za-z0-9_-]*/
  }
}), rS = [
  "a",
  "abbr",
  "address",
  "article",
  "aside",
  "audio",
  "b",
  "blockquote",
  "body",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "dd",
  "del",
  "details",
  "dfn",
  "div",
  "dl",
  "dt",
  "em",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "header",
  "hgroup",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "label",
  "legend",
  "li",
  "main",
  "mark",
  "menu",
  "nav",
  "object",
  "ol",
  "optgroup",
  "option",
  "p",
  "picture",
  "q",
  "quote",
  "samp",
  "section",
  "select",
  "source",
  "span",
  "strong",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "tr",
  "ul",
  "var",
  "video"
], aS = [
  "defs",
  "g",
  "marker",
  "mask",
  "pattern",
  "svg",
  "switch",
  "symbol",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feFlood",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMorphology",
  "feOffset",
  "feSpecularLighting",
  "feTile",
  "feTurbulence",
  "linearGradient",
  "radialGradient",
  "stop",
  "circle",
  "ellipse",
  "image",
  "line",
  "path",
  "polygon",
  "polyline",
  "rect",
  "text",
  "use",
  "textPath",
  "tspan",
  "foreignObject",
  "clipPath"
], sS = [
  ...rS,
  ...aS
], oS = [
  "any-hover",
  "any-pointer",
  "aspect-ratio",
  "color",
  "color-gamut",
  "color-index",
  "device-aspect-ratio",
  "device-height",
  "device-width",
  "display-mode",
  "forced-colors",
  "grid",
  "height",
  "hover",
  "inverted-colors",
  "monochrome",
  "orientation",
  "overflow-block",
  "overflow-inline",
  "pointer",
  "prefers-color-scheme",
  "prefers-contrast",
  "prefers-reduced-motion",
  "prefers-reduced-transparency",
  "resolution",
  "scan",
  "scripting",
  "update",
  "width",
  // TODO: find a better solution?
  "min-width",
  "max-width",
  "min-height",
  "max-height"
].sort().reverse(), lS = [
  "active",
  "any-link",
  "blank",
  "checked",
  "current",
  "default",
  "defined",
  "dir",
  // dir()
  "disabled",
  "drop",
  "empty",
  "enabled",
  "first",
  "first-child",
  "first-of-type",
  "fullscreen",
  "future",
  "focus",
  "focus-visible",
  "focus-within",
  "has",
  // has()
  "host",
  // host or host()
  "host-context",
  // host-context()
  "hover",
  "indeterminate",
  "in-range",
  "invalid",
  "is",
  // is()
  "lang",
  // lang()
  "last-child",
  "last-of-type",
  "left",
  "link",
  "local-link",
  "not",
  // not()
  "nth-child",
  // nth-child()
  "nth-col",
  // nth-col()
  "nth-last-child",
  // nth-last-child()
  "nth-last-col",
  // nth-last-col()
  "nth-last-of-type",
  //nth-last-of-type()
  "nth-of-type",
  //nth-of-type()
  "only-child",
  "only-of-type",
  "optional",
  "out-of-range",
  "past",
  "placeholder-shown",
  "read-only",
  "read-write",
  "required",
  "right",
  "root",
  "scope",
  "target",
  "target-within",
  "user-invalid",
  "valid",
  "visited",
  "where"
  // where()
].sort().reverse(), cS = [
  "after",
  "backdrop",
  "before",
  "cue",
  "cue-region",
  "first-letter",
  "first-line",
  "grammar-error",
  "marker",
  "part",
  "placeholder",
  "selection",
  "slotted",
  "spelling-error"
].sort().reverse(), dS = [
  "accent-color",
  "align-content",
  "align-items",
  "align-self",
  "alignment-baseline",
  "all",
  "anchor-name",
  "animation",
  "animation-composition",
  "animation-delay",
  "animation-direction",
  "animation-duration",
  "animation-fill-mode",
  "animation-iteration-count",
  "animation-name",
  "animation-play-state",
  "animation-range",
  "animation-range-end",
  "animation-range-start",
  "animation-timeline",
  "animation-timing-function",
  "appearance",
  "aspect-ratio",
  "backdrop-filter",
  "backface-visibility",
  "background",
  "background-attachment",
  "background-blend-mode",
  "background-clip",
  "background-color",
  "background-image",
  "background-origin",
  "background-position",
  "background-position-x",
  "background-position-y",
  "background-repeat",
  "background-size",
  "baseline-shift",
  "block-size",
  "border",
  "border-block",
  "border-block-color",
  "border-block-end",
  "border-block-end-color",
  "border-block-end-style",
  "border-block-end-width",
  "border-block-start",
  "border-block-start-color",
  "border-block-start-style",
  "border-block-start-width",
  "border-block-style",
  "border-block-width",
  "border-bottom",
  "border-bottom-color",
  "border-bottom-left-radius",
  "border-bottom-right-radius",
  "border-bottom-style",
  "border-bottom-width",
  "border-collapse",
  "border-color",
  "border-end-end-radius",
  "border-end-start-radius",
  "border-image",
  "border-image-outset",
  "border-image-repeat",
  "border-image-slice",
  "border-image-source",
  "border-image-width",
  "border-inline",
  "border-inline-color",
  "border-inline-end",
  "border-inline-end-color",
  "border-inline-end-style",
  "border-inline-end-width",
  "border-inline-start",
  "border-inline-start-color",
  "border-inline-start-style",
  "border-inline-start-width",
  "border-inline-style",
  "border-inline-width",
  "border-left",
  "border-left-color",
  "border-left-style",
  "border-left-width",
  "border-radius",
  "border-right",
  "border-right-color",
  "border-right-style",
  "border-right-width",
  "border-spacing",
  "border-start-end-radius",
  "border-start-start-radius",
  "border-style",
  "border-top",
  "border-top-color",
  "border-top-left-radius",
  "border-top-right-radius",
  "border-top-style",
  "border-top-width",
  "border-width",
  "bottom",
  "box-align",
  "box-decoration-break",
  "box-direction",
  "box-flex",
  "box-flex-group",
  "box-lines",
  "box-ordinal-group",
  "box-orient",
  "box-pack",
  "box-shadow",
  "box-sizing",
  "break-after",
  "break-before",
  "break-inside",
  "caption-side",
  "caret-color",
  "clear",
  "clip",
  "clip-path",
  "clip-rule",
  "color",
  "color-interpolation",
  "color-interpolation-filters",
  "color-profile",
  "color-rendering",
  "color-scheme",
  "column-count",
  "column-fill",
  "column-gap",
  "column-rule",
  "column-rule-color",
  "column-rule-style",
  "column-rule-width",
  "column-span",
  "column-width",
  "columns",
  "contain",
  "contain-intrinsic-block-size",
  "contain-intrinsic-height",
  "contain-intrinsic-inline-size",
  "contain-intrinsic-size",
  "contain-intrinsic-width",
  "container",
  "container-name",
  "container-type",
  "content",
  "content-visibility",
  "counter-increment",
  "counter-reset",
  "counter-set",
  "cue",
  "cue-after",
  "cue-before",
  "cursor",
  "cx",
  "cy",
  "direction",
  "display",
  "dominant-baseline",
  "empty-cells",
  "enable-background",
  "field-sizing",
  "fill",
  "fill-opacity",
  "fill-rule",
  "filter",
  "flex",
  "flex-basis",
  "flex-direction",
  "flex-flow",
  "flex-grow",
  "flex-shrink",
  "flex-wrap",
  "float",
  "flood-color",
  "flood-opacity",
  "flow",
  "font",
  "font-display",
  "font-family",
  "font-feature-settings",
  "font-kerning",
  "font-language-override",
  "font-optical-sizing",
  "font-palette",
  "font-size",
  "font-size-adjust",
  "font-smooth",
  "font-smoothing",
  "font-stretch",
  "font-style",
  "font-synthesis",
  "font-synthesis-position",
  "font-synthesis-small-caps",
  "font-synthesis-style",
  "font-synthesis-weight",
  "font-variant",
  "font-variant-alternates",
  "font-variant-caps",
  "font-variant-east-asian",
  "font-variant-emoji",
  "font-variant-ligatures",
  "font-variant-numeric",
  "font-variant-position",
  "font-variation-settings",
  "font-weight",
  "forced-color-adjust",
  "gap",
  "glyph-orientation-horizontal",
  "glyph-orientation-vertical",
  "grid",
  "grid-area",
  "grid-auto-columns",
  "grid-auto-flow",
  "grid-auto-rows",
  "grid-column",
  "grid-column-end",
  "grid-column-start",
  "grid-gap",
  "grid-row",
  "grid-row-end",
  "grid-row-start",
  "grid-template",
  "grid-template-areas",
  "grid-template-columns",
  "grid-template-rows",
  "hanging-punctuation",
  "height",
  "hyphenate-character",
  "hyphenate-limit-chars",
  "hyphens",
  "icon",
  "image-orientation",
  "image-rendering",
  "image-resolution",
  "ime-mode",
  "initial-letter",
  "initial-letter-align",
  "inline-size",
  "inset",
  "inset-area",
  "inset-block",
  "inset-block-end",
  "inset-block-start",
  "inset-inline",
  "inset-inline-end",
  "inset-inline-start",
  "isolation",
  "justify-content",
  "justify-items",
  "justify-self",
  "kerning",
  "left",
  "letter-spacing",
  "lighting-color",
  "line-break",
  "line-height",
  "line-height-step",
  "list-style",
  "list-style-image",
  "list-style-position",
  "list-style-type",
  "margin",
  "margin-block",
  "margin-block-end",
  "margin-block-start",
  "margin-bottom",
  "margin-inline",
  "margin-inline-end",
  "margin-inline-start",
  "margin-left",
  "margin-right",
  "margin-top",
  "margin-trim",
  "marker",
  "marker-end",
  "marker-mid",
  "marker-start",
  "marks",
  "mask",
  "mask-border",
  "mask-border-mode",
  "mask-border-outset",
  "mask-border-repeat",
  "mask-border-slice",
  "mask-border-source",
  "mask-border-width",
  "mask-clip",
  "mask-composite",
  "mask-image",
  "mask-mode",
  "mask-origin",
  "mask-position",
  "mask-repeat",
  "mask-size",
  "mask-type",
  "masonry-auto-flow",
  "math-depth",
  "math-shift",
  "math-style",
  "max-block-size",
  "max-height",
  "max-inline-size",
  "max-width",
  "min-block-size",
  "min-height",
  "min-inline-size",
  "min-width",
  "mix-blend-mode",
  "nav-down",
  "nav-index",
  "nav-left",
  "nav-right",
  "nav-up",
  "none",
  "normal",
  "object-fit",
  "object-position",
  "offset",
  "offset-anchor",
  "offset-distance",
  "offset-path",
  "offset-position",
  "offset-rotate",
  "opacity",
  "order",
  "orphans",
  "outline",
  "outline-color",
  "outline-offset",
  "outline-style",
  "outline-width",
  "overflow",
  "overflow-anchor",
  "overflow-block",
  "overflow-clip-margin",
  "overflow-inline",
  "overflow-wrap",
  "overflow-x",
  "overflow-y",
  "overlay",
  "overscroll-behavior",
  "overscroll-behavior-block",
  "overscroll-behavior-inline",
  "overscroll-behavior-x",
  "overscroll-behavior-y",
  "padding",
  "padding-block",
  "padding-block-end",
  "padding-block-start",
  "padding-bottom",
  "padding-inline",
  "padding-inline-end",
  "padding-inline-start",
  "padding-left",
  "padding-right",
  "padding-top",
  "page",
  "page-break-after",
  "page-break-before",
  "page-break-inside",
  "paint-order",
  "pause",
  "pause-after",
  "pause-before",
  "perspective",
  "perspective-origin",
  "place-content",
  "place-items",
  "place-self",
  "pointer-events",
  "position",
  "position-anchor",
  "position-visibility",
  "print-color-adjust",
  "quotes",
  "r",
  "resize",
  "rest",
  "rest-after",
  "rest-before",
  "right",
  "rotate",
  "row-gap",
  "ruby-align",
  "ruby-position",
  "scale",
  "scroll-behavior",
  "scroll-margin",
  "scroll-margin-block",
  "scroll-margin-block-end",
  "scroll-margin-block-start",
  "scroll-margin-bottom",
  "scroll-margin-inline",
  "scroll-margin-inline-end",
  "scroll-margin-inline-start",
  "scroll-margin-left",
  "scroll-margin-right",
  "scroll-margin-top",
  "scroll-padding",
  "scroll-padding-block",
  "scroll-padding-block-end",
  "scroll-padding-block-start",
  "scroll-padding-bottom",
  "scroll-padding-inline",
  "scroll-padding-inline-end",
  "scroll-padding-inline-start",
  "scroll-padding-left",
  "scroll-padding-right",
  "scroll-padding-top",
  "scroll-snap-align",
  "scroll-snap-stop",
  "scroll-snap-type",
  "scroll-timeline",
  "scroll-timeline-axis",
  "scroll-timeline-name",
  "scrollbar-color",
  "scrollbar-gutter",
  "scrollbar-width",
  "shape-image-threshold",
  "shape-margin",
  "shape-outside",
  "shape-rendering",
  "speak",
  "speak-as",
  "src",
  // @font-face
  "stop-color",
  "stop-opacity",
  "stroke",
  "stroke-dasharray",
  "stroke-dashoffset",
  "stroke-linecap",
  "stroke-linejoin",
  "stroke-miterlimit",
  "stroke-opacity",
  "stroke-width",
  "tab-size",
  "table-layout",
  "text-align",
  "text-align-all",
  "text-align-last",
  "text-anchor",
  "text-combine-upright",
  "text-decoration",
  "text-decoration-color",
  "text-decoration-line",
  "text-decoration-skip",
  "text-decoration-skip-ink",
  "text-decoration-style",
  "text-decoration-thickness",
  "text-emphasis",
  "text-emphasis-color",
  "text-emphasis-position",
  "text-emphasis-style",
  "text-indent",
  "text-justify",
  "text-orientation",
  "text-overflow",
  "text-rendering",
  "text-shadow",
  "text-size-adjust",
  "text-transform",
  "text-underline-offset",
  "text-underline-position",
  "text-wrap",
  "text-wrap-mode",
  "text-wrap-style",
  "timeline-scope",
  "top",
  "touch-action",
  "transform",
  "transform-box",
  "transform-origin",
  "transform-style",
  "transition",
  "transition-behavior",
  "transition-delay",
  "transition-duration",
  "transition-property",
  "transition-timing-function",
  "translate",
  "unicode-bidi",
  "user-modify",
  "user-select",
  "vector-effect",
  "vertical-align",
  "view-timeline",
  "view-timeline-axis",
  "view-timeline-inset",
  "view-timeline-name",
  "view-transition-name",
  "visibility",
  "voice-balance",
  "voice-duration",
  "voice-family",
  "voice-pitch",
  "voice-range",
  "voice-rate",
  "voice-stress",
  "voice-volume",
  "white-space",
  "white-space-collapse",
  "widows",
  "width",
  "will-change",
  "word-break",
  "word-spacing",
  "word-wrap",
  "writing-mode",
  "x",
  "y",
  "z-index",
  "zoom"
].sort().reverse();
function uS(t) {
  const e = iS(t), n = "and or not only", i = {
    className: "variable",
    begin: "\\$" + t.IDENT_RE
  }, r = [
    "charset",
    "css",
    "debug",
    "extend",
    "font-face",
    "for",
    "import",
    "include",
    "keyframes",
    "media",
    "mixin",
    "page",
    "warn",
    "while"
  ], a = "(?=[.\\s\\n[:,(])";
  return {
    name: "Stylus",
    aliases: ["styl"],
    case_insensitive: !1,
    keywords: "if else for in",
    illegal: "(" + [
      "\\?",
      "(\\bReturn\\b)",
      // monkey
      "(\\bEnd\\b)",
      // monkey
      "(\\bend\\b)",
      // vbscript
      "(\\bdef\\b)",
      // gradle
      ";",
      // a whole lot of languages
      "#\\s",
      // markdown
      "\\*\\s",
      // markdown
      "===\\s",
      // markdown
      "\\|",
      "%"
      // prolog
    ].join("|") + ")",
    contains: [
      // strings
      t.QUOTE_STRING_MODE,
      t.APOS_STRING_MODE,
      // comments
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      // hex colors
      e.HEXCOLOR,
      // class tag
      {
        begin: "\\.[a-zA-Z][a-zA-Z0-9_-]*" + a,
        className: "selector-class"
      },
      // id tag
      {
        begin: "#[a-zA-Z][a-zA-Z0-9_-]*" + a,
        className: "selector-id"
      },
      // tags
      {
        begin: "\\b(" + sS.join("|") + ")" + a,
        className: "selector-tag"
      },
      // psuedo selectors
      {
        className: "selector-pseudo",
        begin: "&?:(" + lS.join("|") + ")" + a
      },
      {
        className: "selector-pseudo",
        begin: "&?:(:)?(" + cS.join("|") + ")" + a
      },
      e.ATTRIBUTE_SELECTOR_MODE,
      {
        className: "keyword",
        begin: /@media/,
        starts: {
          end: /[{;}]/,
          keywords: {
            $pattern: /[a-z-]+/,
            keyword: n,
            attribute: oS.join(" ")
          },
          contains: [e.CSS_NUMBER_MODE]
        }
      },
      // @ keywords
      {
        className: "keyword",
        begin: "@((-(o|moz|ms|webkit)-)?(" + r.join("|") + "))\\b"
      },
      // variables
      i,
      // dimension
      e.CSS_NUMBER_MODE,
      // functions
      //  - only from beginning of line + whitespace
      {
        className: "function",
        begin: "^[a-zA-Z][a-zA-Z0-9_-]*\\(.*\\)",
        illegal: "[\\n]",
        returnBegin: !0,
        contains: [
          {
            className: "title",
            begin: "\\b[a-zA-Z][a-zA-Z0-9_-]*"
          },
          {
            className: "params",
            begin: /\(/,
            end: /\)/,
            contains: [
              e.HEXCOLOR,
              i,
              t.APOS_STRING_MODE,
              e.CSS_NUMBER_MODE,
              t.QUOTE_STRING_MODE
            ]
          }
        ]
      },
      // css variables
      e.CSS_VARIABLE,
      // attributes
      //  - only from beginning of line + whitespace
      //  - must have whitespace after it
      {
        className: "attribute",
        begin: "\\b(" + dS.join("|") + ")\\b",
        starts: {
          // value container
          end: /;|$/,
          contains: [
            e.HEXCOLOR,
            i,
            t.APOS_STRING_MODE,
            t.QUOTE_STRING_MODE,
            e.CSS_NUMBER_MODE,
            t.C_BLOCK_COMMENT_MODE,
            e.IMPORTANT,
            e.FUNCTION_DISPATCH
          ],
          illegal: /\./,
          relevance: 0
        }
      },
      e.FUNCTION_DISPATCH
    ]
  };
}
function _S(t) {
  return {
    name: "SubUnit",
    case_insensitive: !0,
    contains: [
      {
        className: "string",
        begin: `\\[
(multipart)?`,
        end: `\\]
`
      },
      {
        className: "string",
        begin: "\\d{4}-\\d{2}-\\d{2}(\\s+)\\d{2}:\\d{2}:\\d{2}.\\d+Z"
      },
      {
        className: "string",
        begin: "(\\+|-)\\d+"
      },
      {
        className: "keyword",
        relevance: 10,
        variants: [
          { begin: "^(test|testing|success|successful|failure|error|skip|xfail|uxsuccess)(:?)\\s+(test)?" },
          { begin: "^progress(:?)(\\s+)?(pop|push)?" },
          { begin: "^tags:" },
          { begin: "^time:" }
        ]
      }
    ]
  };
}
function pS(t) {
  return {
    name: "Tagger Script",
    contains: [
      {
        className: "comment",
        begin: /\$noop\(/,
        end: /\)/,
        contains: [
          { begin: /\\[()]/ },
          {
            begin: /\(/,
            end: /\)/,
            contains: [
              { begin: /\\[()]/ },
              "self"
            ]
          }
        ],
        relevance: 10
      },
      {
        className: "keyword",
        begin: /\$[_a-zA-Z0-9]+(?=\()/
      },
      {
        className: "variable",
        begin: /%[_a-zA-Z0-9:]+%/
      },
      {
        className: "symbol",
        begin: /\\[\\nt$%,()]/
      },
      {
        className: "symbol",
        begin: /\\u[a-fA-F0-9]{4}/
      }
    ]
  };
}
function mS(t) {
  return {
    name: "Test Anything Protocol",
    case_insensitive: !0,
    contains: [
      t.HASH_COMMENT_MODE,
      // version of format and total amount of testcases
      {
        className: "meta",
        variants: [
          { begin: "^TAP version (\\d+)$" },
          { begin: "^1\\.\\.(\\d+)$" }
        ]
      },
      // YAML block
      {
        begin: /---$/,
        end: "\\.\\.\\.$",
        subLanguage: "yaml",
        relevance: 0
      },
      // testcase number
      {
        className: "number",
        begin: " (\\d+) "
      },
      // testcase status and description
      {
        className: "symbol",
        variants: [
          { begin: "^ok" },
          { begin: "^not ok" }
        ]
      }
    ]
  };
}
function ES(t) {
  const e = t.regex, n = /[a-zA-Z_][a-zA-Z0-9_]*/, i = {
    className: "number",
    variants: [
      t.BINARY_NUMBER_MODE,
      t.C_NUMBER_MODE
    ]
  };
  return {
    name: "Tcl",
    aliases: ["tk"],
    keywords: [
      "after",
      "append",
      "apply",
      "array",
      "auto_execok",
      "auto_import",
      "auto_load",
      "auto_mkindex",
      "auto_mkindex_old",
      "auto_qualify",
      "auto_reset",
      "bgerror",
      "binary",
      "break",
      "catch",
      "cd",
      "chan",
      "clock",
      "close",
      "concat",
      "continue",
      "dde",
      "dict",
      "encoding",
      "eof",
      "error",
      "eval",
      "exec",
      "exit",
      "expr",
      "fblocked",
      "fconfigure",
      "fcopy",
      "file",
      "fileevent",
      "filename",
      "flush",
      "for",
      "foreach",
      "format",
      "gets",
      "glob",
      "global",
      "history",
      "http",
      "if",
      "incr",
      "info",
      "interp",
      "join",
      "lappend|10",
      "lassign|10",
      "lindex|10",
      "linsert|10",
      "list",
      "llength|10",
      "load",
      "lrange|10",
      "lrepeat|10",
      "lreplace|10",
      "lreverse|10",
      "lsearch|10",
      "lset|10",
      "lsort|10",
      "mathfunc",
      "mathop",
      "memory",
      "msgcat",
      "namespace",
      "open",
      "package",
      "parray",
      "pid",
      "pkg::create",
      "pkg_mkIndex",
      "platform",
      "platform::shell",
      "proc",
      "puts",
      "pwd",
      "read",
      "refchan",
      "regexp",
      "registry",
      "regsub|10",
      "rename",
      "return",
      "safe",
      "scan",
      "seek",
      "set",
      "socket",
      "source",
      "split",
      "string",
      "subst",
      "switch",
      "tcl_endOfWord",
      "tcl_findLibrary",
      "tcl_startOfNextWord",
      "tcl_startOfPreviousWord",
      "tcl_wordBreakAfter",
      "tcl_wordBreakBefore",
      "tcltest",
      "tclvars",
      "tell",
      "time",
      "tm",
      "trace",
      "unknown",
      "unload",
      "unset",
      "update",
      "uplevel",
      "upvar",
      "variable",
      "vwait",
      "while"
    ],
    contains: [
      t.COMMENT(";[ \\t]*#", "$"),
      t.COMMENT("^[ \\t]*#", "$"),
      {
        beginKeywords: "proc",
        end: "[\\{]",
        excludeEnd: !0,
        contains: [
          {
            className: "title",
            begin: "[ \\t\\n\\r]+(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*",
            end: "[ \\t\\n\\r]",
            endsWithParent: !0,
            excludeEnd: !0
          }
        ]
      },
      {
        className: "variable",
        variants: [
          { begin: e.concat(
            /\$/,
            e.optional(/::/),
            n,
            "(::",
            n,
            ")*"
          ) },
          {
            begin: "\\$\\{(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*",
            end: "\\}",
            contains: [i]
          }
        ]
      },
      {
        className: "string",
        contains: [t.BACKSLASH_ESCAPE],
        variants: [t.inherit(t.QUOTE_STRING_MODE, { illegal: null })]
      },
      i
    ]
  };
}
function gS(t) {
  const e = [
    "bool",
    "byte",
    "i16",
    "i32",
    "i64",
    "double",
    "string",
    "binary"
  ];
  return {
    name: "Thrift",
    keywords: {
      keyword: [
        "namespace",
        "const",
        "typedef",
        "struct",
        "enum",
        "service",
        "exception",
        "void",
        "oneway",
        "set",
        "list",
        "map",
        "required",
        "optional"
      ],
      type: e,
      literal: "true false"
    },
    contains: [
      t.QUOTE_STRING_MODE,
      t.NUMBER_MODE,
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      {
        className: "class",
        beginKeywords: "struct enum service exception",
        end: /\{/,
        illegal: /\n/,
        contains: [
          t.inherit(t.TITLE_MODE, {
            // hack: eating everything after the first title
            starts: {
              endsWithParent: !0,
              excludeEnd: !0
            }
          })
        ]
      },
      {
        begin: "\\b(set|list|map)\\s*<",
        keywords: { type: [
          ...e,
          "set",
          "list",
          "map"
        ] },
        end: ">",
        contains: ["self"]
      }
    ]
  };
}
function SS(t) {
  const e = {
    className: "number",
    begin: "[1-9][0-9]*",
    /* no leading zeros */
    relevance: 0
  }, n = {
    className: "symbol",
    begin: ":[^\\]]+"
  }, i = {
    className: "built_in",
    begin: "(AR|P|PAYLOAD|PR|R|SR|RSR|LBL|VR|UALM|MESSAGE|UTOOL|UFRAME|TIMER|TIMER_OVERFLOW|JOINT_MAX_SPEED|RESUME_PROG|DIAG_REC)\\[",
    end: "\\]",
    contains: [
      "self",
      e,
      n
    ]
  }, r = {
    className: "built_in",
    begin: "(AI|AO|DI|DO|F|RI|RO|UI|UO|GI|GO|SI|SO)\\[",
    end: "\\]",
    contains: [
      "self",
      e,
      t.QUOTE_STRING_MODE,
      /* for pos section at bottom */
      n
    ]
  };
  return {
    name: "TP",
    keywords: {
      keyword: [
        "ABORT",
        "ACC",
        "ADJUST",
        "AND",
        "AP_LD",
        "BREAK",
        "CALL",
        "CNT",
        "COL",
        "CONDITION",
        "CONFIG",
        "DA",
        "DB",
        "DIV",
        "DETECT",
        "ELSE",
        "END",
        "ENDFOR",
        "ERR_NUM",
        "ERROR_PROG",
        "FINE",
        "FOR",
        "GP",
        "GUARD",
        "INC",
        "IF",
        "JMP",
        "LINEAR_MAX_SPEED",
        "LOCK",
        "MOD",
        "MONITOR",
        "OFFSET",
        "Offset",
        "OR",
        "OVERRIDE",
        "PAUSE",
        "PREG",
        "PTH",
        "RT_LD",
        "RUN",
        "SELECT",
        "SKIP",
        "Skip",
        "TA",
        "TB",
        "TO",
        "TOOL_OFFSET",
        "Tool_Offset",
        "UF",
        "UT",
        "UFRAME_NUM",
        "UTOOL_NUM",
        "UNLOCK",
        "WAIT",
        "X",
        "Y",
        "Z",
        "W",
        "P",
        "R",
        "STRLEN",
        "SUBSTR",
        "FINDSTR",
        "VOFFSET",
        "PROG",
        "ATTR",
        "MN",
        "POS"
      ],
      literal: [
        "ON",
        "OFF",
        "max_speed",
        "LPOS",
        "JPOS",
        "ENABLE",
        "DISABLE",
        "START",
        "STOP",
        "RESET"
      ]
    },
    contains: [
      i,
      r,
      {
        className: "keyword",
        begin: "/(PROG|ATTR|MN|POS|END)\\b"
      },
      {
        /* this is for cases like ,CALL */
        className: "keyword",
        begin: "(CALL|RUN|POINT_LOGIC|LBL)\\b"
      },
      {
        /* this is for cases like CNT100 where the default lexemes do not
         * separate the keyword and the number */
        className: "keyword",
        begin: "\\b(ACC|CNT|Skip|Offset|PSPD|RT_LD|AP_LD|Tool_Offset)"
      },
      {
        /* to catch numbers that do not have a word boundary on the left */
        className: "number",
        begin: "\\d+(sec|msec|mm/sec|cm/min|inch/min|deg/sec|mm|in|cm)?\\b",
        relevance: 0
      },
      t.COMMENT("//", "[;$]"),
      t.COMMENT("!", "[;$]"),
      t.COMMENT("--eg:", "$"),
      t.QUOTE_STRING_MODE,
      {
        className: "string",
        begin: "'",
        end: "'"
      },
      t.C_NUMBER_MODE,
      {
        className: "variable",
        begin: "\\$[A-Za-z0-9_]+"
      }
    ]
  };
}
function hS(t) {
  const e = t.regex, n = [
    "absolute_url",
    "asset|0",
    "asset_version",
    "attribute",
    "block",
    "constant",
    "controller|0",
    "country_timezones",
    "csrf_token",
    "cycle",
    "date",
    "dump",
    "expression",
    "form|0",
    "form_end",
    "form_errors",
    "form_help",
    "form_label",
    "form_rest",
    "form_row",
    "form_start",
    "form_widget",
    "html_classes",
    "include",
    "is_granted",
    "logout_path",
    "logout_url",
    "max",
    "min",
    "parent",
    "path|0",
    "random",
    "range",
    "relative_path",
    "render",
    "render_esi",
    "source",
    "template_from_string",
    "url|0"
  ], i = [
    "abs",
    "abbr_class",
    "abbr_method",
    "batch",
    "capitalize",
    "column",
    "convert_encoding",
    "country_name",
    "currency_name",
    "currency_symbol",
    "data_uri",
    "date",
    "date_modify",
    "default",
    "escape",
    "file_excerpt",
    "file_link",
    "file_relative",
    "filter",
    "first",
    "format",
    "format_args",
    "format_args_as_text",
    "format_currency",
    "format_date",
    "format_datetime",
    "format_file",
    "format_file_from_text",
    "format_number",
    "format_time",
    "html_to_markdown",
    "humanize",
    "inky_to_html",
    "inline_css",
    "join",
    "json_encode",
    "keys",
    "language_name",
    "last",
    "length",
    "locale_name",
    "lower",
    "map",
    "markdown",
    "markdown_to_html",
    "merge",
    "nl2br",
    "number_format",
    "raw",
    "reduce",
    "replace",
    "reverse",
    "round",
    "slice",
    "slug",
    "sort",
    "spaceless",
    "split",
    "striptags",
    "timezone_name",
    "title",
    "trans",
    "transchoice",
    "trim",
    "u|0",
    "upper",
    "url_encode",
    "yaml_dump",
    "yaml_encode"
  ];
  let r = [
    "apply",
    "autoescape",
    "block",
    "cache",
    "deprecated",
    "do",
    "embed",
    "extends",
    "filter",
    "flush",
    "for",
    "form_theme",
    "from",
    "if",
    "import",
    "include",
    "macro",
    "sandbox",
    "set",
    "stopwatch",
    "trans",
    "trans_default_domain",
    "transchoice",
    "use",
    "verbatim",
    "with"
  ];
  r = r.concat(r.map((g) => `end${g}`));
  const a = {
    scope: "string",
    variants: [
      {
        begin: /'/,
        end: /'/
      },
      {
        begin: /"/,
        end: /"/
      }
    ]
  }, s = {
    scope: "number",
    match: /\d+/
  }, o = {
    begin: /\(/,
    end: /\)/,
    excludeBegin: !0,
    excludeEnd: !0,
    contains: [
      a,
      s
    ]
  }, l = {
    beginKeywords: n.join(" "),
    keywords: { name: n },
    relevance: 0,
    contains: [o]
  }, c = {
    match: /\|(?=[A-Za-z_]+:?)/,
    beginScope: "punctuation",
    relevance: 0,
    contains: [
      {
        match: /[A-Za-z_]+:?/,
        keywords: i
      }
    ]
  }, d = (g, { relevance: S }) => ({
    beginScope: {
      1: "template-tag",
      3: "name"
    },
    relevance: S || 2,
    endScope: "template-tag",
    begin: [
      /\{%/,
      /\s*/,
      e.either(...g)
    ],
    end: /%\}/,
    keywords: "in",
    contains: [
      c,
      l,
      a,
      s
    ]
  }), u = /[a-z_]+/, _ = d(r, { relevance: 2 }), m = d([u], { relevance: 1 });
  return {
    name: "Twig",
    aliases: ["craftcms"],
    case_insensitive: !0,
    subLanguage: "xml",
    contains: [
      t.COMMENT(/\{#/, /#\}/),
      _,
      m,
      {
        className: "template-variable",
        begin: /\{\{/,
        end: /\}\}/,
        contains: [
          "self",
          c,
          l,
          a,
          s
        ]
      }
    ]
  };
}
function fS(t) {
  return {
    name: "Vala",
    keywords: {
      keyword: (
        // Value types
        "char uchar unichar int uint long ulong short ushort int8 int16 int32 int64 uint8 uint16 uint32 uint64 float double bool struct enum string void weak unowned owned async signal static abstract interface override virtual delegate if while do for foreach else switch case break default return try catch public private protected internal using new this get set const stdout stdin stderr var"
      ),
      built_in: "DBus GLib CCode Gee Object Gtk Posix",
      literal: "false true null"
    },
    contains: [
      {
        className: "class",
        beginKeywords: "class interface namespace",
        end: /\{/,
        excludeEnd: !0,
        illegal: "[^,:\\n\\s\\.]",
        contains: [t.UNDERSCORE_TITLE_MODE]
      },
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      {
        className: "string",
        begin: '"""',
        end: '"""',
        relevance: 5
      },
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE,
      t.C_NUMBER_MODE,
      {
        className: "meta",
        begin: "^#",
        end: "$"
      }
    ]
  };
}
function TS(t) {
  const e = t.regex, n = [
    "lcase",
    "month",
    "vartype",
    "instrrev",
    "ubound",
    "setlocale",
    "getobject",
    "rgb",
    "getref",
    "string",
    "weekdayname",
    "rnd",
    "dateadd",
    "monthname",
    "now",
    "day",
    "minute",
    "isarray",
    "cbool",
    "round",
    "formatcurrency",
    "conversions",
    "csng",
    "timevalue",
    "second",
    "year",
    "space",
    "abs",
    "clng",
    "timeserial",
    "fixs",
    "len",
    "asc",
    "isempty",
    "maths",
    "dateserial",
    "atn",
    "timer",
    "isobject",
    "filter",
    "weekday",
    "datevalue",
    "ccur",
    "isdate",
    "instr",
    "datediff",
    "formatdatetime",
    "replace",
    "isnull",
    "right",
    "sgn",
    "array",
    "snumeric",
    "log",
    "cdbl",
    "hex",
    "chr",
    "lbound",
    "msgbox",
    "ucase",
    "getlocale",
    "cos",
    "cdate",
    "cbyte",
    "rtrim",
    "join",
    "hour",
    "oct",
    "typename",
    "trim",
    "strcomp",
    "int",
    "createobject",
    "loadpicture",
    "tan",
    "formatnumber",
    "mid",
    "split",
    "cint",
    "sin",
    "datepart",
    "ltrim",
    "sqr",
    "time",
    "derived",
    "eval",
    "date",
    "formatpercent",
    "exp",
    "inputbox",
    "left",
    "ascw",
    "chrw",
    "regexp",
    "cstr",
    "err"
  ], i = [
    "server",
    "response",
    "request",
    // take no arguments so can be called without ()
    "scriptengine",
    "scriptenginebuildversion",
    "scriptengineminorversion",
    "scriptenginemajorversion"
  ], r = {
    begin: e.concat(e.either(...n), "\\s*\\("),
    // relevance 0 because this is acting as a beginKeywords really
    relevance: 0,
    keywords: { built_in: n }
  };
  return {
    name: "VBScript",
    aliases: ["vbs"],
    case_insensitive: !0,
    keywords: {
      keyword: [
        "call",
        "class",
        "const",
        "dim",
        "do",
        "loop",
        "erase",
        "execute",
        "executeglobal",
        "exit",
        "for",
        "each",
        "next",
        "function",
        "if",
        "then",
        "else",
        "on",
        "error",
        "option",
        "explicit",
        "new",
        "private",
        "property",
        "let",
        "get",
        "public",
        "randomize",
        "redim",
        "rem",
        "select",
        "case",
        "set",
        "stop",
        "sub",
        "while",
        "wend",
        "with",
        "end",
        "to",
        "elseif",
        "is",
        "or",
        "xor",
        "and",
        "not",
        "class_initialize",
        "class_terminate",
        "default",
        "preserve",
        "in",
        "me",
        "byval",
        "byref",
        "step",
        "resume",
        "goto"
      ],
      built_in: i,
      literal: [
        "true",
        "false",
        "null",
        "nothing",
        "empty"
      ]
    },
    illegal: "//",
    contains: [
      r,
      t.inherit(t.QUOTE_STRING_MODE, { contains: [{ begin: '""' }] }),
      t.COMMENT(
        /'/,
        /$/,
        { relevance: 0 }
      ),
      t.C_NUMBER_MODE
    ]
  };
}
function bS(t) {
  return {
    name: "VBScript in HTML",
    subLanguage: "xml",
    contains: [
      {
        begin: "<%",
        end: "%>",
        subLanguage: "vbscript"
      }
    ]
  };
}
function CS(t) {
  const e = t.regex, n = {
    $pattern: /\$?[\w]+(\$[\w]+)*/,
    keyword: [
      "accept_on",
      "alias",
      "always",
      "always_comb",
      "always_ff",
      "always_latch",
      "and",
      "assert",
      "assign",
      "assume",
      "automatic",
      "before",
      "begin",
      "bind",
      "bins",
      "binsof",
      "bit",
      "break",
      "buf|0",
      "bufif0",
      "bufif1",
      "byte",
      "case",
      "casex",
      "casez",
      "cell",
      "chandle",
      "checker",
      "class",
      "clocking",
      "cmos",
      "config",
      "const",
      "constraint",
      "context",
      "continue",
      "cover",
      "covergroup",
      "coverpoint",
      "cross",
      "deassign",
      "default",
      "defparam",
      "design",
      "disable",
      "dist",
      "do",
      "edge",
      "else",
      "end",
      "endcase",
      "endchecker",
      "endclass",
      "endclocking",
      "endconfig",
      "endfunction",
      "endgenerate",
      "endgroup",
      "endinterface",
      "endmodule",
      "endpackage",
      "endprimitive",
      "endprogram",
      "endproperty",
      "endspecify",
      "endsequence",
      "endtable",
      "endtask",
      "enum",
      "event",
      "eventually",
      "expect",
      "export",
      "extends",
      "extern",
      "final",
      "first_match",
      "for",
      "force",
      "foreach",
      "forever",
      "fork",
      "forkjoin",
      "function",
      "generate|5",
      "genvar",
      "global",
      "highz0",
      "highz1",
      "if",
      "iff",
      "ifnone",
      "ignore_bins",
      "illegal_bins",
      "implements",
      "implies",
      "import",
      "incdir",
      "include",
      "initial",
      "inout",
      "input",
      "inside",
      "instance",
      "int",
      "integer",
      "interconnect",
      "interface",
      "intersect",
      "join",
      "join_any",
      "join_none",
      "large",
      "let",
      "liblist",
      "library",
      "local",
      "localparam",
      "logic",
      "longint",
      "macromodule",
      "matches",
      "medium",
      "modport",
      "module",
      "nand",
      "negedge",
      "nettype",
      "new",
      "nexttime",
      "nmos",
      "nor",
      "noshowcancelled",
      "not",
      "notif0",
      "notif1",
      "or",
      "output",
      "package",
      "packed",
      "parameter",
      "pmos",
      "posedge",
      "primitive",
      "priority",
      "program",
      "property",
      "protected",
      "pull0",
      "pull1",
      "pulldown",
      "pullup",
      "pulsestyle_ondetect",
      "pulsestyle_onevent",
      "pure",
      "rand",
      "randc",
      "randcase",
      "randsequence",
      "rcmos",
      "real",
      "realtime",
      "ref",
      "reg",
      "reject_on",
      "release",
      "repeat",
      "restrict",
      "return",
      "rnmos",
      "rpmos",
      "rtran",
      "rtranif0",
      "rtranif1",
      "s_always",
      "s_eventually",
      "s_nexttime",
      "s_until",
      "s_until_with",
      "scalared",
      "sequence",
      "shortint",
      "shortreal",
      "showcancelled",
      "signed",
      "small",
      "soft",
      "solve",
      "specify",
      "specparam",
      "static",
      "string",
      "strong",
      "strong0",
      "strong1",
      "struct",
      "super",
      "supply0",
      "supply1",
      "sync_accept_on",
      "sync_reject_on",
      "table",
      "tagged",
      "task",
      "this",
      "throughout",
      "time",
      "timeprecision",
      "timeunit",
      "tran",
      "tranif0",
      "tranif1",
      "tri",
      "tri0",
      "tri1",
      "triand",
      "trior",
      "trireg",
      "type",
      "typedef",
      "union",
      "unique",
      "unique0",
      "unsigned",
      "until",
      "until_with",
      "untyped",
      "use",
      "uwire",
      "var",
      "vectored",
      "virtual",
      "void",
      "wait",
      "wait_order",
      "wand",
      "weak",
      "weak0",
      "weak1",
      "while",
      "wildcard",
      "wire",
      "with",
      "within",
      "wor",
      "xnor",
      "xor"
    ],
    literal: ["null"],
    built_in: [
      "$finish",
      "$stop",
      "$exit",
      "$fatal",
      "$error",
      "$warning",
      "$info",
      "$realtime",
      "$time",
      "$printtimescale",
      "$bitstoreal",
      "$bitstoshortreal",
      "$itor",
      "$signed",
      "$cast",
      "$bits",
      "$stime",
      "$timeformat",
      "$realtobits",
      "$shortrealtobits",
      "$rtoi",
      "$unsigned",
      "$asserton",
      "$assertkill",
      "$assertpasson",
      "$assertfailon",
      "$assertnonvacuouson",
      "$assertoff",
      "$assertcontrol",
      "$assertpassoff",
      "$assertfailoff",
      "$assertvacuousoff",
      "$isunbounded",
      "$sampled",
      "$fell",
      "$changed",
      "$past_gclk",
      "$fell_gclk",
      "$changed_gclk",
      "$rising_gclk",
      "$steady_gclk",
      "$coverage_control",
      "$coverage_get",
      "$coverage_save",
      "$set_coverage_db_name",
      "$rose",
      "$stable",
      "$past",
      "$rose_gclk",
      "$stable_gclk",
      "$future_gclk",
      "$falling_gclk",
      "$changing_gclk",
      "$display",
      "$coverage_get_max",
      "$coverage_merge",
      "$get_coverage",
      "$load_coverage_db",
      "$typename",
      "$unpacked_dimensions",
      "$left",
      "$low",
      "$increment",
      "$clog2",
      "$ln",
      "$log10",
      "$exp",
      "$sqrt",
      "$pow",
      "$floor",
      "$ceil",
      "$sin",
      "$cos",
      "$tan",
      "$countbits",
      "$onehot",
      "$isunknown",
      "$fatal",
      "$warning",
      "$dimensions",
      "$right",
      "$high",
      "$size",
      "$asin",
      "$acos",
      "$atan",
      "$atan2",
      "$hypot",
      "$sinh",
      "$cosh",
      "$tanh",
      "$asinh",
      "$acosh",
      "$atanh",
      "$countones",
      "$onehot0",
      "$error",
      "$info",
      "$random",
      "$dist_chi_square",
      "$dist_erlang",
      "$dist_exponential",
      "$dist_normal",
      "$dist_poisson",
      "$dist_t",
      "$dist_uniform",
      "$q_initialize",
      "$q_remove",
      "$q_exam",
      "$async$and$array",
      "$async$nand$array",
      "$async$or$array",
      "$async$nor$array",
      "$sync$and$array",
      "$sync$nand$array",
      "$sync$or$array",
      "$sync$nor$array",
      "$q_add",
      "$q_full",
      "$psprintf",
      "$async$and$plane",
      "$async$nand$plane",
      "$async$or$plane",
      "$async$nor$plane",
      "$sync$and$plane",
      "$sync$nand$plane",
      "$sync$or$plane",
      "$sync$nor$plane",
      "$system",
      "$display",
      "$displayb",
      "$displayh",
      "$displayo",
      "$strobe",
      "$strobeb",
      "$strobeh",
      "$strobeo",
      "$write",
      "$readmemb",
      "$readmemh",
      "$writememh",
      "$value$plusargs",
      "$dumpvars",
      "$dumpon",
      "$dumplimit",
      "$dumpports",
      "$dumpportson",
      "$dumpportslimit",
      "$writeb",
      "$writeh",
      "$writeo",
      "$monitor",
      "$monitorb",
      "$monitorh",
      "$monitoro",
      "$writememb",
      "$dumpfile",
      "$dumpoff",
      "$dumpall",
      "$dumpflush",
      "$dumpportsoff",
      "$dumpportsall",
      "$dumpportsflush",
      "$fclose",
      "$fdisplay",
      "$fdisplayb",
      "$fdisplayh",
      "$fdisplayo",
      "$fstrobe",
      "$fstrobeb",
      "$fstrobeh",
      "$fstrobeo",
      "$swrite",
      "$swriteb",
      "$swriteh",
      "$swriteo",
      "$fscanf",
      "$fread",
      "$fseek",
      "$fflush",
      "$feof",
      "$fopen",
      "$fwrite",
      "$fwriteb",
      "$fwriteh",
      "$fwriteo",
      "$fmonitor",
      "$fmonitorb",
      "$fmonitorh",
      "$fmonitoro",
      "$sformat",
      "$sformatf",
      "$fgetc",
      "$ungetc",
      "$fgets",
      "$sscanf",
      "$rewind",
      "$ftell",
      "$ferror"
    ]
  }, i = [
    "__FILE__",
    "__LINE__"
  ], r = [
    "begin_keywords",
    "celldefine",
    "default_nettype",
    "default_decay_time",
    "default_trireg_strength",
    "define",
    "delay_mode_distributed",
    "delay_mode_path",
    "delay_mode_unit",
    "delay_mode_zero",
    "else",
    "elsif",
    "end_keywords",
    "endcelldefine",
    "endif",
    "ifdef",
    "ifndef",
    "include",
    "line",
    "nounconnected_drive",
    "pragma",
    "resetall",
    "timescale",
    "unconnected_drive",
    "undef",
    "undefineall"
  ];
  return {
    name: "Verilog",
    aliases: [
      "v",
      "sv",
      "svh"
    ],
    case_insensitive: !1,
    keywords: n,
    contains: [
      t.C_BLOCK_COMMENT_MODE,
      t.C_LINE_COMMENT_MODE,
      t.QUOTE_STRING_MODE,
      {
        scope: "number",
        contains: [t.BACKSLASH_ESCAPE],
        variants: [
          { begin: /\b((\d+'([bhodBHOD]))[0-9xzXZa-fA-F_]+)/ },
          { begin: /\B(('([bhodBHOD]))[0-9xzXZa-fA-F_]+)/ },
          {
            // decimal
            begin: /\b[0-9][0-9_]*/,
            relevance: 0
          }
        ]
      },
      /* parameters to instances */
      {
        scope: "variable",
        variants: [
          { begin: "#\\((?!parameter).+\\)" },
          {
            begin: "\\.\\w+",
            relevance: 0
          }
        ]
      },
      {
        scope: "variable.constant",
        match: e.concat(/`/, e.either(...i))
      },
      {
        scope: "meta",
        begin: e.concat(/`/, e.either(...r)),
        end: /$|\/\/|\/\*/,
        returnEnd: !0,
        keywords: r
      }
    ]
  };
}
function yS(t) {
  const e = "\\d(_|\\d)*", n = "[eE][-+]?" + e, i = e + "(\\." + e + ")?(" + n + ")?", r = "\\w+", s = "\\b(" + (e + "#" + r + "(\\." + r + ")?#(" + n + ")?") + "|" + i + ")";
  return {
    name: "VHDL",
    case_insensitive: !0,
    keywords: {
      keyword: [
        "abs",
        "access",
        "after",
        "alias",
        "all",
        "and",
        "architecture",
        "array",
        "assert",
        "assume",
        "assume_guarantee",
        "attribute",
        "begin",
        "block",
        "body",
        "buffer",
        "bus",
        "case",
        "component",
        "configuration",
        "constant",
        "context",
        "cover",
        "disconnect",
        "downto",
        "default",
        "else",
        "elsif",
        "end",
        "entity",
        "exit",
        "fairness",
        "file",
        "for",
        "force",
        "function",
        "generate",
        "generic",
        "group",
        "guarded",
        "if",
        "impure",
        "in",
        "inertial",
        "inout",
        "is",
        "label",
        "library",
        "linkage",
        "literal",
        "loop",
        "map",
        "mod",
        "nand",
        "new",
        "next",
        "nor",
        "not",
        "null",
        "of",
        "on",
        "open",
        "or",
        "others",
        "out",
        "package",
        "parameter",
        "port",
        "postponed",
        "procedure",
        "process",
        "property",
        "protected",
        "pure",
        "range",
        "record",
        "register",
        "reject",
        "release",
        "rem",
        "report",
        "restrict",
        "restrict_guarantee",
        "return",
        "rol",
        "ror",
        "select",
        "sequence",
        "severity",
        "shared",
        "signal",
        "sla",
        "sll",
        "sra",
        "srl",
        "strong",
        "subtype",
        "then",
        "to",
        "transport",
        "type",
        "unaffected",
        "units",
        "until",
        "use",
        "variable",
        "view",
        "vmode",
        "vprop",
        "vunit",
        "wait",
        "when",
        "while",
        "with",
        "xnor",
        "xor"
      ],
      built_in: [
        "boolean",
        "bit",
        "character",
        "integer",
        "time",
        "delay_length",
        "natural",
        "positive",
        "string",
        "bit_vector",
        "file_open_kind",
        "file_open_status",
        "std_logic",
        "std_logic_vector",
        "unsigned",
        "signed",
        "boolean_vector",
        "integer_vector",
        "std_ulogic",
        "std_ulogic_vector",
        "unresolved_unsigned",
        "u_unsigned",
        "unresolved_signed",
        "u_signed",
        "real_vector",
        "time_vector"
      ],
      literal: [
        // severity_level
        "false",
        "true",
        "note",
        "warning",
        "error",
        "failure",
        // textio
        "line",
        "text",
        "side",
        "width"
      ]
    },
    illegal: /\{/,
    contains: [
      t.C_BLOCK_COMMENT_MODE,
      // VHDL-2008 block commenting.
      t.COMMENT("--", "$"),
      t.QUOTE_STRING_MODE,
      {
        className: "number",
        begin: s,
        relevance: 0
      },
      {
        className: "string",
        begin: "'(U|X|0|1|Z|W|L|H|-)'",
        contains: [t.BACKSLASH_ESCAPE]
      },
      {
        className: "symbol",
        begin: "'[A-Za-z](_?[A-Za-z0-9])*",
        contains: [t.BACKSLASH_ESCAPE]
      }
    ]
  };
}
function RS(t) {
  return {
    name: "Vim Script",
    keywords: {
      $pattern: /[!#@\w]+/,
      keyword: (
        // express version except: ! & * < = > !! # @ @@
        "N|0 P|0 X|0 a|0 ab abc abo al am an|0 ar arga argd arge argdo argg argl argu as au aug aun b|0 bN ba bad bd be bel bf bl bm bn bo bp br brea breaka breakd breakl bro bufdo buffers bun bw c|0 cN cNf ca cabc caddb cad caddf cal cat cb cc ccl cd ce cex cf cfir cgetb cgete cg changes chd che checkt cl cla clo cm cmapc cme cn cnew cnf cno cnorea cnoreme co col colo com comc comp con conf cope cp cpf cq cr cs cst cu cuna cunme cw delm deb debugg delc delf dif diffg diffo diffp diffpu diffs diffthis dig di dl dell dj dli do doautoa dp dr ds dsp e|0 ea ec echoe echoh echom echon el elsei em en endfo endf endt endw ene ex exe exi exu f|0 files filet fin fina fini fir fix fo foldc foldd folddoc foldo for fu go gr grepa gu gv ha helpf helpg helpt hi hid his ia iabc if ij il im imapc ime ino inorea inoreme int is isp iu iuna iunme j|0 ju k|0 keepa kee keepj lN lNf l|0 lad laddb laddf la lan lat lb lc lch lcl lcs le lefta let lex lf lfir lgetb lgete lg lgr lgrepa lh ll lla lli lmak lm lmapc lne lnew lnf ln loadk lo loc lockv lol lope lp lpf lr ls lt lu lua luad luaf lv lvimgrepa lw m|0 ma mak map mapc marks mat me menut mes mk mks mksp mkv mkvie mod mz mzf nbc nb nbs new nm nmapc nme nn nnoreme noa no noh norea noreme norm nu nun nunme ol o|0 om omapc ome on ono onoreme opt ou ounme ow p|0 profd prof pro promptr pc ped pe perld po popu pp pre prev ps pt ptN ptf ptj ptl ptn ptp ptr pts pu pw py3 python3 py3d py3f py pyd pyf quita qa rec red redi redr redraws reg res ret retu rew ri rightb rub rubyd rubyf rund ru rv sN san sa sal sav sb sbN sba sbf sbl sbm sbn sbp sbr scrip scripte scs se setf setg setl sf sfir sh sim sig sil sl sla sm smap smapc sme sn sni sno snor snoreme sor so spelld spe spelli spellr spellu spellw sp spr sre st sta startg startr star stopi stj sts sun sunm sunme sus sv sw sy synti sync tN tabN tabc tabdo tabe tabf tabfir tabl tabm tabnew tabn tabo tabp tabr tabs tab ta tags tc tcld tclf te tf th tj tl tm tn to tp tr try ts tu u|0 undoj undol una unh unl unlo unm unme uns up ve verb vert vim vimgrepa vi viu vie vm vmapc vme vne vn vnoreme vs vu vunme windo w|0 wN wa wh wi winc winp wn wp wq wqa ws wu wv x|0 xa xmapc xm xme xn xnoreme xu xunme y|0 z|0 ~ Next Print append abbreviate abclear aboveleft all amenu anoremenu args argadd argdelete argedit argglobal arglocal argument ascii autocmd augroup aunmenu buffer bNext ball badd bdelete behave belowright bfirst blast bmodified bnext botright bprevious brewind break breakadd breakdel breaklist browse bunload bwipeout change cNext cNfile cabbrev cabclear caddbuffer caddexpr caddfile call catch cbuffer cclose center cexpr cfile cfirst cgetbuffer cgetexpr cgetfile chdir checkpath checktime clist clast close cmap cmapclear cmenu cnext cnewer cnfile cnoremap cnoreabbrev cnoremenu copy colder colorscheme command comclear compiler continue confirm copen cprevious cpfile cquit crewind cscope cstag cunmap cunabbrev cunmenu cwindow delete delmarks debug debuggreedy delcommand delfunction diffupdate diffget diffoff diffpatch diffput diffsplit digraphs display deletel djump dlist doautocmd doautoall deletep drop dsearch dsplit edit earlier echo echoerr echohl echomsg else elseif emenu endif endfor endfunction endtry endwhile enew execute exit exusage file filetype find finally finish first fixdel fold foldclose folddoopen folddoclosed foldopen function global goto grep grepadd gui gvim hardcopy help helpfind helpgrep helptags highlight hide history insert iabbrev iabclear ijump ilist imap imapclear imenu inoremap inoreabbrev inoremenu intro isearch isplit iunmap iunabbrev iunmenu join jumps keepalt keepmarks keepjumps lNext lNfile list laddexpr laddbuffer laddfile last language later lbuffer lcd lchdir lclose lcscope left leftabove lexpr lfile lfirst lgetbuffer lgetexpr lgetfile lgrep lgrepadd lhelpgrep llast llist lmake lmap lmapclear lnext lnewer lnfile lnoremap loadkeymap loadview lockmarks lockvar lolder lopen lprevious lpfile lrewind ltag lunmap luado luafile lvimgrep lvimgrepadd lwindow move mark make mapclear match menu menutranslate messages mkexrc mksession mkspell mkvimrc mkview mode mzscheme mzfile nbclose nbkey nbsart next nmap nmapclear nmenu nnoremap nnoremenu noautocmd noremap nohlsearch noreabbrev noremenu normal number nunmap nunmenu oldfiles open omap omapclear omenu only onoremap onoremenu options ounmap ounmenu ownsyntax print profdel profile promptfind promptrepl pclose pedit perl perldo pop popup ppop preserve previous psearch ptag ptNext ptfirst ptjump ptlast ptnext ptprevious ptrewind ptselect put pwd py3do py3file python pydo pyfile quit quitall qall read recover redo redir redraw redrawstatus registers resize retab return rewind right rightbelow ruby rubydo rubyfile rundo runtime rviminfo substitute sNext sandbox sargument sall saveas sbuffer sbNext sball sbfirst sblast sbmodified sbnext sbprevious sbrewind scriptnames scriptencoding scscope set setfiletype setglobal setlocal sfind sfirst shell simalt sign silent sleep slast smagic smapclear smenu snext sniff snomagic snoremap snoremenu sort source spelldump spellgood spellinfo spellrepall spellundo spellwrong split sprevious srewind stop stag startgreplace startreplace startinsert stopinsert stjump stselect sunhide sunmap sunmenu suspend sview swapname syntax syntime syncbind tNext tabNext tabclose tabedit tabfind tabfirst tablast tabmove tabnext tabonly tabprevious tabrewind tag tcl tcldo tclfile tearoff tfirst throw tjump tlast tmenu tnext topleft tprevious trewind tselect tunmenu undo undojoin undolist unabbreviate unhide unlet unlockvar unmap unmenu unsilent update vglobal version verbose vertical vimgrep vimgrepadd visual viusage view vmap vmapclear vmenu vnew vnoremap vnoremenu vsplit vunmap vunmenu write wNext wall while winsize wincmd winpos wnext wprevious wqall wsverb wundo wviminfo xit xall xmapclear xmap xmenu xnoremap xnoremenu xunmap xunmenu yank"
      ),
      built_in: (
        // built in func
        "synIDtrans atan2 range matcharg did_filetype asin feedkeys xor argv complete_check add getwinposx getqflist getwinposy screencol clearmatches empty extend getcmdpos mzeval garbagecollect setreg ceil sqrt diff_hlID inputsecret get getfperm getpid filewritable shiftwidth max sinh isdirectory synID system inputrestore winline atan visualmode inputlist tabpagewinnr round getregtype mapcheck hasmapto histdel argidx findfile sha256 exists toupper getcmdline taglist string getmatches bufnr strftime winwidth bufexists strtrans tabpagebuflist setcmdpos remote_read printf setloclist getpos getline bufwinnr float2nr len getcmdtype diff_filler luaeval resolve libcallnr foldclosedend reverse filter has_key bufname str2float strlen setline getcharmod setbufvar index searchpos shellescape undofile foldclosed setqflist buflisted strchars str2nr virtcol floor remove undotree remote_expr winheight gettabwinvar reltime cursor tabpagenr finddir localtime acos getloclist search tanh matchend rename gettabvar strdisplaywidth type abs py3eval setwinvar tolower wildmenumode log10 spellsuggest bufloaded synconcealed nextnonblank server2client complete settabwinvar executable input wincol setmatches getftype hlID inputsave searchpair or screenrow line settabvar histadd deepcopy strpart remote_peek and eval getftime submatch screenchar winsaveview matchadd mkdir screenattr getfontname libcall reltimestr getfsize winnr invert pow getbufline byte2line soundfold repeat fnameescape tagfiles sin strwidth spellbadword trunc maparg log lispindent hostname setpos globpath remote_foreground getchar synIDattr fnamemodify cscope_connection stridx winbufnr indent min complete_add nr2char searchpairpos inputdialog values matchlist items hlexists strridx browsedir expand fmod pathshorten line2byte argc count getwinvar glob foldtextresult getreg foreground cosh matchdelete has char2nr simplify histget searchdecl iconv winrestcmd pumvisible writefile foldlevel haslocaldir keys cos matchstr foldtext histnr tan tempname getcwd byteidx getbufvar islocked escape eventhandler remote_send serverlist winrestview synstack pyeval prevnonblank readfile cindent filereadable changenr exp"
      )
    },
    illegal: /;/,
    contains: [
      t.NUMBER_MODE,
      {
        className: "string",
        begin: "'",
        end: "'",
        illegal: "\\n"
      },
      /*
            A double quote can start either a string or a line comment. Strings are
            ended before the end of a line by another double quote and can contain
            escaped double-quotes and post-escaped line breaks.
      
            Also, any double quote at the beginning of a line is a comment but we
            don't handle that properly at the moment: any double quote inside will
            turn them into a string. Handling it properly will require a smarter
            parser.
            */
      {
        className: "string",
        begin: /"(\\"|\n\\|[^"\n])*"/
      },
      t.COMMENT('"', "$"),
      {
        className: "variable",
        begin: /[bwtglsav]:[\w\d_]+/
      },
      {
        begin: [
          /\b(?:function|function!)/,
          /\s+/,
          t.IDENT_RE
        ],
        className: {
          1: "keyword",
          3: "title"
        },
        end: "$",
        relevance: 0,
        contains: [
          {
            className: "params",
            begin: "\\(",
            end: "\\)"
          }
        ]
      },
      {
        className: "symbol",
        begin: /<[\w-]+>/
      }
    ]
  };
}
function NS(t) {
  const e = t.regex, n = /[a-zA-Z]\w*/, i = [
    "as",
    "break",
    "class",
    "construct",
    "continue",
    "else",
    "for",
    "foreign",
    "if",
    "import",
    "in",
    "is",
    "return",
    "static",
    "var",
    "while"
  ], r = [
    "true",
    "false",
    "null"
  ], a = [
    "this",
    "super"
  ], s = [
    "Bool",
    "Class",
    "Fiber",
    "Fn",
    "List",
    "Map",
    "Null",
    "Num",
    "Object",
    "Range",
    "Sequence",
    "String",
    "System"
  ], o = [
    "-",
    "~",
    /\*/,
    "%",
    /\.\.\./,
    /\.\./,
    /\+/,
    "<<",
    ">>",
    ">=",
    "<=",
    "<",
    ">",
    /\^/,
    /!=/,
    /!/,
    /\bis\b/,
    "==",
    "&&",
    "&",
    /\|\|/,
    /\|/,
    /\?:/,
    "="
  ], l = {
    relevance: 0,
    match: e.concat(/\b(?!(if|while|for|else|super)\b)/, n, /(?=\s*[({])/),
    className: "title.function"
  }, c = {
    match: e.concat(
      e.either(
        e.concat(/\b(?!(if|while|for|else|super)\b)/, n),
        e.either(...o)
      ),
      /(?=\s*\([^)]+\)\s*\{)/
    ),
    className: "title.function",
    starts: { contains: [
      {
        begin: /\(/,
        end: /\)/,
        contains: [
          {
            relevance: 0,
            scope: "params",
            match: n
          }
        ]
      }
    ] }
  }, d = {
    variants: [
      { match: [
        /class\s+/,
        n,
        /\s+is\s+/,
        n
      ] },
      { match: [
        /class\s+/,
        n
      ] }
    ],
    scope: {
      2: "title.class",
      4: "title.class.inherited"
    },
    keywords: i
  }, u = {
    relevance: 0,
    match: e.either(...o),
    className: "operator"
  }, _ = {
    className: "string",
    begin: /"""/,
    end: /"""/
  }, m = {
    className: "property",
    begin: e.concat(/\./, e.lookahead(n)),
    end: n,
    excludeBegin: !0,
    relevance: 0
  }, g = {
    relevance: 0,
    match: e.concat(/\b_/, n),
    scope: "variable"
  }, S = {
    relevance: 0,
    match: /\b[A-Z]+[a-z]+([A-Z]+[a-z]+)*/,
    scope: "title.class",
    keywords: { _: s }
  }, E = t.C_NUMBER_MODE, h = {
    match: [
      n,
      /\s*/,
      /=/,
      /\s*/,
      /\(/,
      n,
      /\)\s*\{/
    ],
    scope: {
      1: "title.function",
      3: "operator",
      6: "params"
    }
  }, T = t.COMMENT(
    /\/\*\*/,
    /\*\//,
    { contains: [
      {
        match: /@[a-z]+/,
        scope: "doctag"
      },
      "self"
    ] }
  ), b = {
    scope: "subst",
    begin: /%\(/,
    end: /\)/,
    contains: [
      E,
      S,
      l,
      g,
      u
    ]
  }, C = {
    scope: "string",
    begin: /"/,
    end: /"/,
    contains: [
      b,
      {
        scope: "char.escape",
        variants: [
          { match: /\\\\|\\["0%abefnrtv]/ },
          { match: /\\x[0-9A-F]{2}/ },
          { match: /\\u[0-9A-F]{4}/ },
          { match: /\\U[0-9A-F]{8}/ }
        ]
      }
    ]
  };
  b.contains.push(C);
  const y = [
    ...i,
    ...a,
    ...r
  ], O = {
    relevance: 0,
    match: e.concat(
      "\\b(?!",
      y.join("|"),
      "\\b)",
      /[a-zA-Z_]\w*(?:[?!]|\b)/
    ),
    className: "variable"
  };
  return {
    name: "Wren",
    keywords: {
      keyword: i,
      "variable.language": a,
      literal: r
    },
    contains: [
      {
        // scope: "meta",
        scope: "comment",
        variants: [
          {
            begin: [
              /#!?/,
              /[A-Za-z_]+(?=\()/
            ],
            beginScope: {
              // 2: "attr"
            },
            keywords: { literal: r },
            contains: [
              // NUMBER,
              // VARIABLE
            ],
            end: /\)/
          },
          {
            begin: [
              /#!?/,
              /[A-Za-z_]+/
            ],
            beginScope: {
              // 2: "attr"
            },
            end: /$/
          }
        ]
      },
      E,
      C,
      _,
      T,
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      S,
      d,
      h,
      c,
      l,
      u,
      g,
      m,
      O
    ]
  };
}
function OS(t) {
  return {
    name: "Intel x86 Assembly",
    case_insensitive: !0,
    keywords: {
      $pattern: "[.%]?" + t.IDENT_RE,
      keyword: "lock rep repe repz repne repnz xaquire xrelease bnd nobnd aaa aad aam aas adc add and arpl bb0_reset bb1_reset bound bsf bsr bswap bt btc btr bts call cbw cdq cdqe clc cld cli clts cmc cmp cmpsb cmpsd cmpsq cmpsw cmpxchg cmpxchg486 cmpxchg8b cmpxchg16b cpuid cpu_read cpu_write cqo cwd cwde daa das dec div dmint emms enter equ f2xm1 fabs fadd faddp fbld fbstp fchs fclex fcmovb fcmovbe fcmove fcmovnb fcmovnbe fcmovne fcmovnu fcmovu fcom fcomi fcomip fcomp fcompp fcos fdecstp fdisi fdiv fdivp fdivr fdivrp femms feni ffree ffreep fiadd ficom ficomp fidiv fidivr fild fimul fincstp finit fist fistp fisttp fisub fisubr fld fld1 fldcw fldenv fldl2e fldl2t fldlg2 fldln2 fldpi fldz fmul fmulp fnclex fndisi fneni fninit fnop fnsave fnstcw fnstenv fnstsw fpatan fprem fprem1 fptan frndint frstor fsave fscale fsetpm fsin fsincos fsqrt fst fstcw fstenv fstp fstsw fsub fsubp fsubr fsubrp ftst fucom fucomi fucomip fucomp fucompp fxam fxch fxtract fyl2x fyl2xp1 hlt ibts icebp idiv imul in inc incbin insb insd insw int int01 int1 int03 int3 into invd invpcid invlpg invlpga iret iretd iretq iretw jcxz jecxz jrcxz jmp jmpe lahf lar lds lea leave les lfence lfs lgdt lgs lidt lldt lmsw loadall loadall286 lodsb lodsd lodsq lodsw loop loope loopne loopnz loopz lsl lss ltr mfence monitor mov movd movq movsb movsd movsq movsw movsx movsxd movzx mul mwait neg nop not or out outsb outsd outsw packssdw packsswb packuswb paddb paddd paddsb paddsiw paddsw paddusb paddusw paddw pand pandn pause paveb pavgusb pcmpeqb pcmpeqd pcmpeqw pcmpgtb pcmpgtd pcmpgtw pdistib pf2id pfacc pfadd pfcmpeq pfcmpge pfcmpgt pfmax pfmin pfmul pfrcp pfrcpit1 pfrcpit2 pfrsqit1 pfrsqrt pfsub pfsubr pi2fd pmachriw pmaddwd pmagw pmulhriw pmulhrwa pmulhrwc pmulhw pmullw pmvgezb pmvlzb pmvnzb pmvzb pop popa popad popaw popf popfd popfq popfw por prefetch prefetchw pslld psllq psllw psrad psraw psrld psrlq psrlw psubb psubd psubsb psubsiw psubsw psubusb psubusw psubw punpckhbw punpckhdq punpckhwd punpcklbw punpckldq punpcklwd push pusha pushad pushaw pushf pushfd pushfq pushfw pxor rcl rcr rdshr rdmsr rdpmc rdtsc rdtscp ret retf retn rol ror rdm rsdc rsldt rsm rsts sahf sal salc sar sbb scasb scasd scasq scasw sfence sgdt shl shld shr shrd sidt sldt skinit smi smint smintold smsw stc std sti stosb stosd stosq stosw str sub svdc svldt svts swapgs syscall sysenter sysexit sysret test ud0 ud1 ud2b ud2 ud2a umov verr verw fwait wbinvd wrshr wrmsr xadd xbts xchg xlatb xlat xor cmove cmovz cmovne cmovnz cmova cmovnbe cmovae cmovnb cmovb cmovnae cmovbe cmovna cmovg cmovnle cmovge cmovnl cmovl cmovnge cmovle cmovng cmovc cmovnc cmovo cmovno cmovs cmovns cmovp cmovpe cmovnp cmovpo je jz jne jnz ja jnbe jae jnb jb jnae jbe jna jg jnle jge jnl jl jnge jle jng jc jnc jo jno js jns jpo jnp jpe jp sete setz setne setnz seta setnbe setae setnb setnc setb setnae setcset setbe setna setg setnle setge setnl setl setnge setle setng sets setns seto setno setpe setp setpo setnp addps addss andnps andps cmpeqps cmpeqss cmpleps cmpless cmpltps cmpltss cmpneqps cmpneqss cmpnleps cmpnless cmpnltps cmpnltss cmpordps cmpordss cmpunordps cmpunordss cmpps cmpss comiss cvtpi2ps cvtps2pi cvtsi2ss cvtss2si cvttps2pi cvttss2si divps divss ldmxcsr maxps maxss minps minss movaps movhps movlhps movlps movhlps movmskps movntps movss movups mulps mulss orps rcpps rcpss rsqrtps rsqrtss shufps sqrtps sqrtss stmxcsr subps subss ucomiss unpckhps unpcklps xorps fxrstor fxrstor64 fxsave fxsave64 xgetbv xsetbv xsave xsave64 xsaveopt xsaveopt64 xrstor xrstor64 prefetchnta prefetcht0 prefetcht1 prefetcht2 maskmovq movntq pavgb pavgw pextrw pinsrw pmaxsw pmaxub pminsw pminub pmovmskb pmulhuw psadbw pshufw pf2iw pfnacc pfpnacc pi2fw pswapd maskmovdqu clflush movntdq movnti movntpd movdqa movdqu movdq2q movq2dq paddq pmuludq pshufd pshufhw pshuflw pslldq psrldq psubq punpckhqdq punpcklqdq addpd addsd andnpd andpd cmpeqpd cmpeqsd cmplepd cmplesd cmpltpd cmpltsd cmpneqpd cmpneqsd cmpnlepd cmpnlesd cmpnltpd cmpnltsd cmpordpd cmpordsd cmpunordpd cmpunordsd cmppd comisd cvtdq2pd cvtdq2ps cvtpd2dq cvtpd2pi cvtpd2ps cvtpi2pd cvtps2dq cvtps2pd cvtsd2si cvtsd2ss cvtsi2sd cvtss2sd cvttpd2pi cvttpd2dq cvttps2dq cvttsd2si divpd divsd maxpd maxsd minpd minsd movapd movhpd movlpd movmskpd movupd mulpd mulsd orpd shufpd sqrtpd sqrtsd subpd subsd ucomisd unpckhpd unpcklpd xorpd addsubpd addsubps haddpd haddps hsubpd hsubps lddqu movddup movshdup movsldup clgi stgi vmcall vmclear vmfunc vmlaunch vmload vmmcall vmptrld vmptrst vmread vmresume vmrun vmsave vmwrite vmxoff vmxon invept invvpid pabsb pabsw pabsd palignr phaddw phaddd phaddsw phsubw phsubd phsubsw pmaddubsw pmulhrsw pshufb psignb psignw psignd extrq insertq movntsd movntss lzcnt blendpd blendps blendvpd blendvps dppd dpps extractps insertps movntdqa mpsadbw packusdw pblendvb pblendw pcmpeqq pextrb pextrd pextrq phminposuw pinsrb pinsrd pinsrq pmaxsb pmaxsd pmaxud pmaxuw pminsb pminsd pminud pminuw pmovsxbw pmovsxbd pmovsxbq pmovsxwd pmovsxwq pmovsxdq pmovzxbw pmovzxbd pmovzxbq pmovzxwd pmovzxwq pmovzxdq pmuldq pmulld ptest roundpd roundps roundsd roundss crc32 pcmpestri pcmpestrm pcmpistri pcmpistrm pcmpgtq popcnt getsec pfrcpv pfrsqrtv movbe aesenc aesenclast aesdec aesdeclast aesimc aeskeygenassist vaesenc vaesenclast vaesdec vaesdeclast vaesimc vaeskeygenassist vaddpd vaddps vaddsd vaddss vaddsubpd vaddsubps vandpd vandps vandnpd vandnps vblendpd vblendps vblendvpd vblendvps vbroadcastss vbroadcastsd vbroadcastf128 vcmpeq_ospd vcmpeqpd vcmplt_ospd vcmpltpd vcmple_ospd vcmplepd vcmpunord_qpd vcmpunordpd vcmpneq_uqpd vcmpneqpd vcmpnlt_uspd vcmpnltpd vcmpnle_uspd vcmpnlepd vcmpord_qpd vcmpordpd vcmpeq_uqpd vcmpnge_uspd vcmpngepd vcmpngt_uspd vcmpngtpd vcmpfalse_oqpd vcmpfalsepd vcmpneq_oqpd vcmpge_ospd vcmpgepd vcmpgt_ospd vcmpgtpd vcmptrue_uqpd vcmptruepd vcmplt_oqpd vcmple_oqpd vcmpunord_spd vcmpneq_uspd vcmpnlt_uqpd vcmpnle_uqpd vcmpord_spd vcmpeq_uspd vcmpnge_uqpd vcmpngt_uqpd vcmpfalse_ospd vcmpneq_ospd vcmpge_oqpd vcmpgt_oqpd vcmptrue_uspd vcmppd vcmpeq_osps vcmpeqps vcmplt_osps vcmpltps vcmple_osps vcmpleps vcmpunord_qps vcmpunordps vcmpneq_uqps vcmpneqps vcmpnlt_usps vcmpnltps vcmpnle_usps vcmpnleps vcmpord_qps vcmpordps vcmpeq_uqps vcmpnge_usps vcmpngeps vcmpngt_usps vcmpngtps vcmpfalse_oqps vcmpfalseps vcmpneq_oqps vcmpge_osps vcmpgeps vcmpgt_osps vcmpgtps vcmptrue_uqps vcmptrueps vcmplt_oqps vcmple_oqps vcmpunord_sps vcmpneq_usps vcmpnlt_uqps vcmpnle_uqps vcmpord_sps vcmpeq_usps vcmpnge_uqps vcmpngt_uqps vcmpfalse_osps vcmpneq_osps vcmpge_oqps vcmpgt_oqps vcmptrue_usps vcmpps vcmpeq_ossd vcmpeqsd vcmplt_ossd vcmpltsd vcmple_ossd vcmplesd vcmpunord_qsd vcmpunordsd vcmpneq_uqsd vcmpneqsd vcmpnlt_ussd vcmpnltsd vcmpnle_ussd vcmpnlesd vcmpord_qsd vcmpordsd vcmpeq_uqsd vcmpnge_ussd vcmpngesd vcmpngt_ussd vcmpngtsd vcmpfalse_oqsd vcmpfalsesd vcmpneq_oqsd vcmpge_ossd vcmpgesd vcmpgt_ossd vcmpgtsd vcmptrue_uqsd vcmptruesd vcmplt_oqsd vcmple_oqsd vcmpunord_ssd vcmpneq_ussd vcmpnlt_uqsd vcmpnle_uqsd vcmpord_ssd vcmpeq_ussd vcmpnge_uqsd vcmpngt_uqsd vcmpfalse_ossd vcmpneq_ossd vcmpge_oqsd vcmpgt_oqsd vcmptrue_ussd vcmpsd vcmpeq_osss vcmpeqss vcmplt_osss vcmpltss vcmple_osss vcmpless vcmpunord_qss vcmpunordss vcmpneq_uqss vcmpneqss vcmpnlt_usss vcmpnltss vcmpnle_usss vcmpnless vcmpord_qss vcmpordss vcmpeq_uqss vcmpnge_usss vcmpngess vcmpngt_usss vcmpngtss vcmpfalse_oqss vcmpfalsess vcmpneq_oqss vcmpge_osss vcmpgess vcmpgt_osss vcmpgtss vcmptrue_uqss vcmptruess vcmplt_oqss vcmple_oqss vcmpunord_sss vcmpneq_usss vcmpnlt_uqss vcmpnle_uqss vcmpord_sss vcmpeq_usss vcmpnge_uqss vcmpngt_uqss vcmpfalse_osss vcmpneq_osss vcmpge_oqss vcmpgt_oqss vcmptrue_usss vcmpss vcomisd vcomiss vcvtdq2pd vcvtdq2ps vcvtpd2dq vcvtpd2ps vcvtps2dq vcvtps2pd vcvtsd2si vcvtsd2ss vcvtsi2sd vcvtsi2ss vcvtss2sd vcvtss2si vcvttpd2dq vcvttps2dq vcvttsd2si vcvttss2si vdivpd vdivps vdivsd vdivss vdppd vdpps vextractf128 vextractps vhaddpd vhaddps vhsubpd vhsubps vinsertf128 vinsertps vlddqu vldqqu vldmxcsr vmaskmovdqu vmaskmovps vmaskmovpd vmaxpd vmaxps vmaxsd vmaxss vminpd vminps vminsd vminss vmovapd vmovaps vmovd vmovq vmovddup vmovdqa vmovqqa vmovdqu vmovqqu vmovhlps vmovhpd vmovhps vmovlhps vmovlpd vmovlps vmovmskpd vmovmskps vmovntdq vmovntqq vmovntdqa vmovntpd vmovntps vmovsd vmovshdup vmovsldup vmovss vmovupd vmovups vmpsadbw vmulpd vmulps vmulsd vmulss vorpd vorps vpabsb vpabsw vpabsd vpacksswb vpackssdw vpackuswb vpackusdw vpaddb vpaddw vpaddd vpaddq vpaddsb vpaddsw vpaddusb vpaddusw vpalignr vpand vpandn vpavgb vpavgw vpblendvb vpblendw vpcmpestri vpcmpestrm vpcmpistri vpcmpistrm vpcmpeqb vpcmpeqw vpcmpeqd vpcmpeqq vpcmpgtb vpcmpgtw vpcmpgtd vpcmpgtq vpermilpd vpermilps vperm2f128 vpextrb vpextrw vpextrd vpextrq vphaddw vphaddd vphaddsw vphminposuw vphsubw vphsubd vphsubsw vpinsrb vpinsrw vpinsrd vpinsrq vpmaddwd vpmaddubsw vpmaxsb vpmaxsw vpmaxsd vpmaxub vpmaxuw vpmaxud vpminsb vpminsw vpminsd vpminub vpminuw vpminud vpmovmskb vpmovsxbw vpmovsxbd vpmovsxbq vpmovsxwd vpmovsxwq vpmovsxdq vpmovzxbw vpmovzxbd vpmovzxbq vpmovzxwd vpmovzxwq vpmovzxdq vpmulhuw vpmulhrsw vpmulhw vpmullw vpmulld vpmuludq vpmuldq vpor vpsadbw vpshufb vpshufd vpshufhw vpshuflw vpsignb vpsignw vpsignd vpslldq vpsrldq vpsllw vpslld vpsllq vpsraw vpsrad vpsrlw vpsrld vpsrlq vptest vpsubb vpsubw vpsubd vpsubq vpsubsb vpsubsw vpsubusb vpsubusw vpunpckhbw vpunpckhwd vpunpckhdq vpunpckhqdq vpunpcklbw vpunpcklwd vpunpckldq vpunpcklqdq vpxor vrcpps vrcpss vrsqrtps vrsqrtss vroundpd vroundps vroundsd vroundss vshufpd vshufps vsqrtpd vsqrtps vsqrtsd vsqrtss vstmxcsr vsubpd vsubps vsubsd vsubss vtestps vtestpd vucomisd vucomiss vunpckhpd vunpckhps vunpcklpd vunpcklps vxorpd vxorps vzeroall vzeroupper pclmullqlqdq pclmulhqlqdq pclmullqhqdq pclmulhqhqdq pclmulqdq vpclmullqlqdq vpclmulhqlqdq vpclmullqhqdq vpclmulhqhqdq vpclmulqdq vfmadd132ps vfmadd132pd vfmadd312ps vfmadd312pd vfmadd213ps vfmadd213pd vfmadd123ps vfmadd123pd vfmadd231ps vfmadd231pd vfmadd321ps vfmadd321pd vfmaddsub132ps vfmaddsub132pd vfmaddsub312ps vfmaddsub312pd vfmaddsub213ps vfmaddsub213pd vfmaddsub123ps vfmaddsub123pd vfmaddsub231ps vfmaddsub231pd vfmaddsub321ps vfmaddsub321pd vfmsub132ps vfmsub132pd vfmsub312ps vfmsub312pd vfmsub213ps vfmsub213pd vfmsub123ps vfmsub123pd vfmsub231ps vfmsub231pd vfmsub321ps vfmsub321pd vfmsubadd132ps vfmsubadd132pd vfmsubadd312ps vfmsubadd312pd vfmsubadd213ps vfmsubadd213pd vfmsubadd123ps vfmsubadd123pd vfmsubadd231ps vfmsubadd231pd vfmsubadd321ps vfmsubadd321pd vfnmadd132ps vfnmadd132pd vfnmadd312ps vfnmadd312pd vfnmadd213ps vfnmadd213pd vfnmadd123ps vfnmadd123pd vfnmadd231ps vfnmadd231pd vfnmadd321ps vfnmadd321pd vfnmsub132ps vfnmsub132pd vfnmsub312ps vfnmsub312pd vfnmsub213ps vfnmsub213pd vfnmsub123ps vfnmsub123pd vfnmsub231ps vfnmsub231pd vfnmsub321ps vfnmsub321pd vfmadd132ss vfmadd132sd vfmadd312ss vfmadd312sd vfmadd213ss vfmadd213sd vfmadd123ss vfmadd123sd vfmadd231ss vfmadd231sd vfmadd321ss vfmadd321sd vfmsub132ss vfmsub132sd vfmsub312ss vfmsub312sd vfmsub213ss vfmsub213sd vfmsub123ss vfmsub123sd vfmsub231ss vfmsub231sd vfmsub321ss vfmsub321sd vfnmadd132ss vfnmadd132sd vfnmadd312ss vfnmadd312sd vfnmadd213ss vfnmadd213sd vfnmadd123ss vfnmadd123sd vfnmadd231ss vfnmadd231sd vfnmadd321ss vfnmadd321sd vfnmsub132ss vfnmsub132sd vfnmsub312ss vfnmsub312sd vfnmsub213ss vfnmsub213sd vfnmsub123ss vfnmsub123sd vfnmsub231ss vfnmsub231sd vfnmsub321ss vfnmsub321sd rdfsbase rdgsbase rdrand wrfsbase wrgsbase vcvtph2ps vcvtps2ph adcx adox rdseed clac stac xstore xcryptecb xcryptcbc xcryptctr xcryptcfb xcryptofb montmul xsha1 xsha256 llwpcb slwpcb lwpval lwpins vfmaddpd vfmaddps vfmaddsd vfmaddss vfmaddsubpd vfmaddsubps vfmsubaddpd vfmsubaddps vfmsubpd vfmsubps vfmsubsd vfmsubss vfnmaddpd vfnmaddps vfnmaddsd vfnmaddss vfnmsubpd vfnmsubps vfnmsubsd vfnmsubss vfrczpd vfrczps vfrczsd vfrczss vpcmov vpcomb vpcomd vpcomq vpcomub vpcomud vpcomuq vpcomuw vpcomw vphaddbd vphaddbq vphaddbw vphadddq vphaddubd vphaddubq vphaddubw vphaddudq vphadduwd vphadduwq vphaddwd vphaddwq vphsubbw vphsubdq vphsubwd vpmacsdd vpmacsdqh vpmacsdql vpmacssdd vpmacssdqh vpmacssdql vpmacsswd vpmacssww vpmacswd vpmacsww vpmadcsswd vpmadcswd vpperm vprotb vprotd vprotq vprotw vpshab vpshad vpshaq vpshaw vpshlb vpshld vpshlq vpshlw vbroadcasti128 vpblendd vpbroadcastb vpbroadcastw vpbroadcastd vpbroadcastq vpermd vpermpd vpermps vpermq vperm2i128 vextracti128 vinserti128 vpmaskmovd vpmaskmovq vpsllvd vpsllvq vpsravd vpsrlvd vpsrlvq vgatherdpd vgatherqpd vgatherdps vgatherqps vpgatherdd vpgatherqd vpgatherdq vpgatherqq xabort xbegin xend xtest andn bextr blci blcic blsi blsic blcfill blsfill blcmsk blsmsk blsr blcs bzhi mulx pdep pext rorx sarx shlx shrx tzcnt tzmsk t1mskc valignd valignq vblendmpd vblendmps vbroadcastf32x4 vbroadcastf64x4 vbroadcasti32x4 vbroadcasti64x4 vcompresspd vcompressps vcvtpd2udq vcvtps2udq vcvtsd2usi vcvtss2usi vcvttpd2udq vcvttps2udq vcvttsd2usi vcvttss2usi vcvtudq2pd vcvtudq2ps vcvtusi2sd vcvtusi2ss vexpandpd vexpandps vextractf32x4 vextractf64x4 vextracti32x4 vextracti64x4 vfixupimmpd vfixupimmps vfixupimmsd vfixupimmss vgetexppd vgetexpps vgetexpsd vgetexpss vgetmantpd vgetmantps vgetmantsd vgetmantss vinsertf32x4 vinsertf64x4 vinserti32x4 vinserti64x4 vmovdqa32 vmovdqa64 vmovdqu32 vmovdqu64 vpabsq vpandd vpandnd vpandnq vpandq vpblendmd vpblendmq vpcmpltd vpcmpled vpcmpneqd vpcmpnltd vpcmpnled vpcmpd vpcmpltq vpcmpleq vpcmpneqq vpcmpnltq vpcmpnleq vpcmpq vpcmpequd vpcmpltud vpcmpleud vpcmpnequd vpcmpnltud vpcmpnleud vpcmpud vpcmpequq vpcmpltuq vpcmpleuq vpcmpnequq vpcmpnltuq vpcmpnleuq vpcmpuq vpcompressd vpcompressq vpermi2d vpermi2pd vpermi2ps vpermi2q vpermt2d vpermt2pd vpermt2ps vpermt2q vpexpandd vpexpandq vpmaxsq vpmaxuq vpminsq vpminuq vpmovdb vpmovdw vpmovqb vpmovqd vpmovqw vpmovsdb vpmovsdw vpmovsqb vpmovsqd vpmovsqw vpmovusdb vpmovusdw vpmovusqb vpmovusqd vpmovusqw vpord vporq vprold vprolq vprolvd vprolvq vprord vprorq vprorvd vprorvq vpscatterdd vpscatterdq vpscatterqd vpscatterqq vpsraq vpsravq vpternlogd vpternlogq vptestmd vptestmq vptestnmd vptestnmq vpxord vpxorq vrcp14pd vrcp14ps vrcp14sd vrcp14ss vrndscalepd vrndscaleps vrndscalesd vrndscaless vrsqrt14pd vrsqrt14ps vrsqrt14sd vrsqrt14ss vscalefpd vscalefps vscalefsd vscalefss vscatterdpd vscatterdps vscatterqpd vscatterqps vshuff32x4 vshuff64x2 vshufi32x4 vshufi64x2 kandnw kandw kmovw knotw kortestw korw kshiftlw kshiftrw kunpckbw kxnorw kxorw vpbroadcastmb2q vpbroadcastmw2d vpconflictd vpconflictq vplzcntd vplzcntq vexp2pd vexp2ps vrcp28pd vrcp28ps vrcp28sd vrcp28ss vrsqrt28pd vrsqrt28ps vrsqrt28sd vrsqrt28ss vgatherpf0dpd vgatherpf0dps vgatherpf0qpd vgatherpf0qps vgatherpf1dpd vgatherpf1dps vgatherpf1qpd vgatherpf1qps vscatterpf0dpd vscatterpf0dps vscatterpf0qpd vscatterpf0qps vscatterpf1dpd vscatterpf1dps vscatterpf1qpd vscatterpf1qps prefetchwt1 bndmk bndcl bndcu bndcn bndmov bndldx bndstx sha1rnds4 sha1nexte sha1msg1 sha1msg2 sha256rnds2 sha256msg1 sha256msg2 hint_nop0 hint_nop1 hint_nop2 hint_nop3 hint_nop4 hint_nop5 hint_nop6 hint_nop7 hint_nop8 hint_nop9 hint_nop10 hint_nop11 hint_nop12 hint_nop13 hint_nop14 hint_nop15 hint_nop16 hint_nop17 hint_nop18 hint_nop19 hint_nop20 hint_nop21 hint_nop22 hint_nop23 hint_nop24 hint_nop25 hint_nop26 hint_nop27 hint_nop28 hint_nop29 hint_nop30 hint_nop31 hint_nop32 hint_nop33 hint_nop34 hint_nop35 hint_nop36 hint_nop37 hint_nop38 hint_nop39 hint_nop40 hint_nop41 hint_nop42 hint_nop43 hint_nop44 hint_nop45 hint_nop46 hint_nop47 hint_nop48 hint_nop49 hint_nop50 hint_nop51 hint_nop52 hint_nop53 hint_nop54 hint_nop55 hint_nop56 hint_nop57 hint_nop58 hint_nop59 hint_nop60 hint_nop61 hint_nop62 hint_nop63",
      built_in: (
        // Instruction pointer
        "ip eip rip al ah bl bh cl ch dl dh sil dil bpl spl r8b r9b r10b r11b r12b r13b r14b r15b ax bx cx dx si di bp sp r8w r9w r10w r11w r12w r13w r14w r15w eax ebx ecx edx esi edi ebp esp eip r8d r9d r10d r11d r12d r13d r14d r15d rax rbx rcx rdx rsi rdi rbp rsp r8 r9 r10 r11 r12 r13 r14 r15 cs ds es fs gs ss st st0 st1 st2 st3 st4 st5 st6 st7 mm0 mm1 mm2 mm3 mm4 mm5 mm6 mm7 xmm0  xmm1  xmm2  xmm3  xmm4  xmm5  xmm6  xmm7  xmm8  xmm9 xmm10  xmm11 xmm12 xmm13 xmm14 xmm15 xmm16 xmm17 xmm18 xmm19 xmm20 xmm21 xmm22 xmm23 xmm24 xmm25 xmm26 xmm27 xmm28 xmm29 xmm30 xmm31 ymm0  ymm1  ymm2  ymm3  ymm4  ymm5  ymm6  ymm7  ymm8  ymm9 ymm10  ymm11 ymm12 ymm13 ymm14 ymm15 ymm16 ymm17 ymm18 ymm19 ymm20 ymm21 ymm22 ymm23 ymm24 ymm25 ymm26 ymm27 ymm28 ymm29 ymm30 ymm31 zmm0  zmm1  zmm2  zmm3  zmm4  zmm5  zmm6  zmm7  zmm8  zmm9 zmm10  zmm11 zmm12 zmm13 zmm14 zmm15 zmm16 zmm17 zmm18 zmm19 zmm20 zmm21 zmm22 zmm23 zmm24 zmm25 zmm26 zmm27 zmm28 zmm29 zmm30 zmm31 k0 k1 k2 k3 k4 k5 k6 k7 bnd0 bnd1 bnd2 bnd3 cr0 cr1 cr2 cr3 cr4 cr8 dr0 dr1 dr2 dr3 dr8 tr3 tr4 tr5 tr6 tr7 r0 r1 r2 r3 r4 r5 r6 r7 r0b r1b r2b r3b r4b r5b r6b r7b r0w r1w r2w r3w r4w r5w r6w r7w r0d r1d r2d r3d r4d r5d r6d r7d r0h r1h r2h r3h r0l r1l r2l r3l r4l r5l r6l r7l r8l r9l r10l r11l r12l r13l r14l r15l db dw dd dq dt ddq do dy dz resb resw resd resq rest resdq reso resy resz incbin equ times byte word dword qword nosplit rel abs seg wrt strict near far a32 ptr"
      ),
      meta: "%define %xdefine %+ %undef %defstr %deftok %assign %strcat %strlen %substr %rotate %elif %else %endif %if %ifmacro %ifctx %ifidn %ifidni %ifid %ifnum %ifstr %iftoken %ifempty %ifenv %error %warning %fatal %rep %endrep %include %push %pop %repl %pathsearch %depend %use %arg %stacksize %local %line %comment %endcomment .nolist __FILE__ __LINE__ __SECT__  __BITS__ __OUTPUT_FORMAT__ __DATE__ __TIME__ __DATE_NUM__ __TIME_NUM__ __UTC_DATE__ __UTC_TIME__ __UTC_DATE_NUM__ __UTC_TIME_NUM__  __PASS__ struc endstruc istruc at iend align alignb sectalign daz nodaz up down zero default option assume public bits use16 use32 use64 default section segment absolute extern global common cpu float __utf16__ __utf16le__ __utf16be__ __utf32__ __utf32le__ __utf32be__ __float8__ __float16__ __float32__ __float64__ __float80m__ __float80e__ __float128l__ __float128h__ __Infinity__ __QNaN__ __SNaN__ Inf NaN QNaN SNaN float8 float16 float32 float64 float80m float80e float128l float128h __FLOAT_DAZ__ __FLOAT_ROUND__ __FLOAT__"
    },
    contains: [
      t.COMMENT(
        ";",
        "$",
        { relevance: 0 }
      ),
      {
        className: "number",
        variants: [
          // Float number and x87 BCD
          {
            begin: "\\b(?:([0-9][0-9_]*)?\\.[0-9_]*(?:[eE][+-]?[0-9_]+)?|(0[Xx])?[0-9][0-9_]*(\\.[0-9_]*)?(?:[pP](?:[+-]?[0-9_]+)?)?)\\b",
            relevance: 0
          },
          // Hex number in $
          {
            begin: "\\$[0-9][0-9A-Fa-f]*",
            relevance: 0
          },
          // Number in H,D,T,Q,O,B,Y suffix
          { begin: "\\b(?:[0-9A-Fa-f][0-9A-Fa-f_]*[Hh]|[0-9][0-9_]*[DdTt]?|[0-7][0-7_]*[QqOo]|[0-1][0-1_]*[BbYy])\\b" },
          // Number in X,D,T,Q,O,B,Y prefix
          { begin: "\\b(?:0[Xx][0-9A-Fa-f_]+|0[DdTt][0-9_]+|0[QqOo][0-7_]+|0[BbYy][0-1_]+)\\b" }
        ]
      },
      // Double quote string
      t.QUOTE_STRING_MODE,
      {
        className: "string",
        variants: [
          // Single-quoted string
          {
            begin: "'",
            end: "[^\\\\]'"
          },
          // Backquoted string
          {
            begin: "`",
            end: "[^\\\\]`"
          }
        ],
        relevance: 0
      },
      {
        className: "symbol",
        variants: [
          // Global label and local label
          { begin: "^\\s*[A-Za-z._?][A-Za-z0-9_$#@~.?]*(:|\\s+label)" },
          // Macro-local label
          { begin: "^\\s*%%[A-Za-z0-9_$#@~.?]*:" }
        ],
        relevance: 0
      },
      // Macro parameter
      {
        className: "subst",
        begin: "%[0-9]+",
        relevance: 0
      },
      // Macro parameter
      {
        className: "subst",
        begin: "%!S+",
        relevance: 0
      },
      {
        className: "meta",
        begin: /^\s*\.[\w_-]+/
      }
    ]
  };
}
function vS(t) {
  const e = [
    "if",
    "then",
    "else",
    "do",
    "while",
    "until",
    "for",
    "loop",
    "import",
    "with",
    "is",
    "as",
    "where",
    "when",
    "by",
    "data",
    "constant",
    "integer",
    "real",
    "text",
    "name",
    "boolean",
    "symbol",
    "infix",
    "prefix",
    "postfix",
    "block",
    "tree"
  ], n = [
    "in",
    "mod",
    "rem",
    "and",
    "or",
    "xor",
    "not",
    "abs",
    "sign",
    "floor",
    "ceil",
    "sqrt",
    "sin",
    "cos",
    "tan",
    "asin",
    "acos",
    "atan",
    "exp",
    "expm1",
    "log",
    "log2",
    "log10",
    "log1p",
    "pi",
    "at",
    "text_length",
    "text_range",
    "text_find",
    "text_replace",
    "contains",
    "page",
    "slide",
    "basic_slide",
    "title_slide",
    "title",
    "subtitle",
    "fade_in",
    "fade_out",
    "fade_at",
    "clear_color",
    "color",
    "line_color",
    "line_width",
    "texture_wrap",
    "texture_transform",
    "texture",
    "scale_?x",
    "scale_?y",
    "scale_?z?",
    "translate_?x",
    "translate_?y",
    "translate_?z?",
    "rotate_?x",
    "rotate_?y",
    "rotate_?z?",
    "rectangle",
    "circle",
    "ellipse",
    "sphere",
    "path",
    "line_to",
    "move_to",
    "quad_to",
    "curve_to",
    "theme",
    "background",
    "contents",
    "locally",
    "time",
    "mouse_?x",
    "mouse_?y",
    "mouse_buttons"
  ], i = [
    "ObjectLoader",
    "Animate",
    "MovieCredits",
    "Slides",
    "Filters",
    "Shading",
    "Materials",
    "LensFlare",
    "Mapping",
    "VLCAudioVideo",
    "StereoDecoder",
    "PointCloud",
    "NetworkAccess",
    "RemoteControl",
    "RegExp",
    "ChromaKey",
    "Snowfall",
    "NodeJS",
    "Speech",
    "Charts"
  ], a = {
    $pattern: /[a-zA-Z][a-zA-Z0-9_?]*/,
    keyword: e,
    literal: [
      "true",
      "false",
      "nil"
    ],
    built_in: n.concat(i)
  }, s = {
    className: "string",
    begin: '"',
    end: '"',
    illegal: "\\n"
  }, o = {
    className: "string",
    begin: "'",
    end: "'",
    illegal: "\\n"
  }, l = {
    className: "string",
    begin: "<<",
    end: ">>"
  }, c = {
    className: "number",
    begin: "[0-9]+#[0-9A-Z_]+(\\.[0-9-A-Z_]+)?#?([Ee][+-]?[0-9]+)?"
  }, d = {
    beginKeywords: "import",
    end: "$",
    keywords: a,
    contains: [s]
  }, u = {
    className: "function",
    begin: /[a-z][^\n]*->/,
    returnBegin: !0,
    end: /->/,
    contains: [
      t.inherit(t.TITLE_MODE, { starts: {
        endsWithParent: !0,
        keywords: a
      } })
    ]
  };
  return {
    name: "XL",
    aliases: ["tao"],
    keywords: a,
    contains: [
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      s,
      o,
      l,
      u,
      d,
      c,
      t.NUMBER_MODE
    ]
  };
}
function AS(t) {
  return {
    name: "XQuery",
    aliases: [
      "xpath",
      "xq",
      "xqm"
    ],
    case_insensitive: !1,
    illegal: /(proc)|(abstract)|(extends)|(until)|(#)/,
    keywords: {
      $pattern: /[a-zA-Z$][a-zA-Z0-9_:-]*/,
      keyword: [
        "module",
        "schema",
        "namespace",
        "boundary-space",
        "preserve",
        "no-preserve",
        "strip",
        "default",
        "collation",
        "base-uri",
        "ordering",
        "context",
        "decimal-format",
        "decimal-separator",
        "copy-namespaces",
        "empty-sequence",
        "except",
        "exponent-separator",
        "external",
        "grouping-separator",
        "inherit",
        "no-inherit",
        "lax",
        "minus-sign",
        "per-mille",
        "percent",
        "schema-attribute",
        "schema-element",
        "strict",
        "unordered",
        "zero-digit",
        "declare",
        "import",
        "option",
        "function",
        "validate",
        "variable",
        "for",
        "at",
        "in",
        "let",
        "where",
        "order",
        "group",
        "by",
        "return",
        "if",
        "then",
        "else",
        "tumbling",
        "sliding",
        "window",
        "start",
        "when",
        "only",
        "end",
        "previous",
        "next",
        "stable",
        "ascending",
        "descending",
        "allowing",
        "empty",
        "greatest",
        "least",
        "some",
        "every",
        "satisfies",
        "switch",
        "case",
        "typeswitch",
        "try",
        "catch",
        "and",
        "or",
        "to",
        "union",
        "intersect",
        "instance",
        "of",
        "treat",
        "as",
        "castable",
        "cast",
        "map",
        "array",
        "delete",
        "insert",
        "into",
        "replace",
        "value",
        "rename",
        "copy",
        "modify",
        "update"
      ],
      type: [
        "item",
        "document-node",
        "node",
        "attribute",
        "document",
        "element",
        "comment",
        "namespace",
        "namespace-node",
        "processing-instruction",
        "text",
        "construction",
        "xs:anyAtomicType",
        "xs:untypedAtomic",
        "xs:duration",
        "xs:time",
        "xs:decimal",
        "xs:float",
        "xs:double",
        "xs:gYearMonth",
        "xs:gYear",
        "xs:gMonthDay",
        "xs:gMonth",
        "xs:gDay",
        "xs:boolean",
        "xs:base64Binary",
        "xs:hexBinary",
        "xs:anyURI",
        "xs:QName",
        "xs:NOTATION",
        "xs:dateTime",
        "xs:dateTimeStamp",
        "xs:date",
        "xs:string",
        "xs:normalizedString",
        "xs:token",
        "xs:language",
        "xs:NMTOKEN",
        "xs:Name",
        "xs:NCName",
        "xs:ID",
        "xs:IDREF",
        "xs:ENTITY",
        "xs:integer",
        "xs:nonPositiveInteger",
        "xs:negativeInteger",
        "xs:long",
        "xs:int",
        "xs:short",
        "xs:byte",
        "xs:nonNegativeInteger",
        "xs:unisignedLong",
        "xs:unsignedInt",
        "xs:unsignedShort",
        "xs:unsignedByte",
        "xs:positiveInteger",
        "xs:yearMonthDuration",
        "xs:dayTimeDuration"
      ],
      literal: [
        "eq",
        "ne",
        "lt",
        "le",
        "gt",
        "ge",
        "is",
        "self::",
        "child::",
        "descendant::",
        "descendant-or-self::",
        "attribute::",
        "following::",
        "following-sibling::",
        "parent::",
        "ancestor::",
        "ancestor-or-self::",
        "preceding::",
        "preceding-sibling::",
        "NaN"
      ]
    },
    contains: [
      {
        className: "variable",
        begin: /[$][\w\-:]+/
      },
      {
        className: "built_in",
        variants: [
          {
            begin: /\barray:/,
            end: /(?:append|filter|flatten|fold-(?:left|right)|for-each(?:-pair)?|get|head|insert-before|join|put|remove|reverse|size|sort|subarray|tail)\b/
          },
          {
            begin: /\bmap:/,
            end: /(?:contains|entry|find|for-each|get|keys|merge|put|remove|size)\b/
          },
          {
            begin: /\bmath:/,
            end: /(?:a(?:cos|sin|tan[2]?)|cos|exp(?:10)?|log(?:10)?|pi|pow|sin|sqrt|tan)\b/
          },
          {
            begin: /\bop:/,
            end: /\(/,
            excludeEnd: !0
          },
          {
            begin: /\bfn:/,
            end: /\(/,
            excludeEnd: !0
          },
          // do not highlight inbuilt strings as variable or xml element names
          { begin: /[^</$:'"-]\b(?:abs|accumulator-(?:after|before)|adjust-(?:date(?:Time)?|time)-to-timezone|analyze-string|apply|available-(?:environment-variables|system-properties)|avg|base-uri|boolean|ceiling|codepoints?-(?:equal|to-string)|collation-key|collection|compare|concat|contains(?:-token)?|copy-of|count|current(?:-)?(?:date(?:Time)?|time|group(?:ing-key)?|output-uri|merge-(?:group|key))?data|dateTime|days?-from-(?:date(?:Time)?|duration)|deep-equal|default-(?:collation|language)|distinct-values|document(?:-uri)?|doc(?:-available)?|element-(?:available|with-id)|empty|encode-for-uri|ends-with|environment-variable|error|escape-html-uri|exactly-one|exists|false|filter|floor|fold-(?:left|right)|for-each(?:-pair)?|format-(?:date(?:Time)?|time|integer|number)|function-(?:arity|available|lookup|name)|generate-id|has-children|head|hours-from-(?:dateTime|duration|time)|id(?:ref)?|implicit-timezone|in-scope-prefixes|index-of|innermost|insert-before|iri-to-uri|json-(?:doc|to-xml)|key|lang|last|load-xquery-module|local-name(?:-from-QName)?|(?:lower|upper)-case|matches|max|minutes-from-(?:dateTime|duration|time)|min|months?-from-(?:date(?:Time)?|duration)|name(?:space-uri-?(?:for-prefix|from-QName)?)?|nilled|node-name|normalize-(?:space|unicode)|not|number|one-or-more|outermost|parse-(?:ietf-date|json)|path|position|(?:prefix-from-)?QName|random-number-generator|regex-group|remove|replace|resolve-(?:QName|uri)|reverse|root|round(?:-half-to-even)?|seconds-from-(?:dateTime|duration|time)|snapshot|sort|starts-with|static-base-uri|stream-available|string-?(?:join|length|to-codepoints)?|subsequence|substring-?(?:after|before)?|sum|system-property|tail|timezone-from-(?:date(?:Time)?|time)|tokenize|trace|trans(?:form|late)|true|type-available|unordered|unparsed-(?:entity|text)?-?(?:public-id|uri|available|lines)?|uri-collection|xml-to-json|years?-from-(?:date(?:Time)?|duration)|zero-or-one)\b/ },
          {
            begin: /\blocal:/,
            end: /\(/,
            excludeEnd: !0
          },
          {
            begin: /\bzip:/,
            end: /(?:zip-file|(?:xml|html|text|binary)-entry| (?:update-)?entries)\b/
          },
          {
            begin: /\b(?:util|db|functx|app|xdmp|xmldb):/,
            end: /\(/,
            excludeEnd: !0
          }
        ]
      },
      {
        className: "string",
        variants: [
          {
            begin: /"/,
            end: /"/,
            contains: [
              {
                begin: /""/,
                relevance: 0
              }
            ]
          },
          {
            begin: /'/,
            end: /'/,
            contains: [
              {
                begin: /''/,
                relevance: 0
              }
            ]
          }
        ]
      },
      {
        className: "number",
        begin: /(\b0[0-7_]+)|(\b0x[0-9a-fA-F_]+)|(\b[1-9][0-9_]*(\.[0-9_]+)?)|[0_]\b/,
        relevance: 0
      },
      {
        className: "comment",
        begin: /\(:/,
        end: /:\)/,
        relevance: 10,
        contains: [
          {
            className: "doctag",
            begin: /@\w+/
          }
        ]
      },
      {
        className: "meta",
        begin: /%[\w\-:]+/
      },
      {
        className: "title",
        begin: /\bxquery version "[13]\.[01]"\s?(?:encoding ".+")?/,
        end: /;/
      },
      {
        beginKeywords: "element attribute comment document processing-instruction",
        end: /\{/,
        excludeEnd: !0
      },
      {
        begin: /<([\w._:-]+)(\s+\S*=('|").*('|"))?>/,
        end: /(\/[\w._:-]+>)/,
        subLanguage: "xml",
        contains: [
          {
            begin: /\{/,
            end: /\}/,
            subLanguage: "xquery"
          },
          "self"
        ]
      }
    ]
  };
}
function IS(t) {
  const e = {
    className: "string",
    contains: [t.BACKSLASH_ESCAPE],
    variants: [
      t.inherit(t.APOS_STRING_MODE, { illegal: null }),
      t.inherit(t.QUOTE_STRING_MODE, { illegal: null })
    ]
  }, n = t.UNDERSCORE_TITLE_MODE, i = { variants: [
    t.BINARY_NUMBER_MODE,
    t.C_NUMBER_MODE
  ] }, r = (
    // classes and objects
    "namespace class interface use extends function return abstract final public protected private static deprecated throw try catch Exception echo empty isset instanceof unset let var new const self require if else elseif switch case default do while loop for continue break likely unlikely __LINE__ __FILE__ __DIR__ __FUNCTION__ __CLASS__ __TRAIT__ __METHOD__ __NAMESPACE__ array boolean float double integer object resource string char long unsigned bool int uint ulong uchar true false null undefined"
  );
  return {
    name: "Zephir",
    aliases: ["zep"],
    keywords: r,
    contains: [
      t.C_LINE_COMMENT_MODE,
      t.COMMENT(
        /\/\*/,
        /\*\//,
        { contains: [
          {
            className: "doctag",
            begin: /@[A-Za-z]+/
          }
        ] }
      ),
      {
        className: "string",
        begin: /<<<['"]?\w+['"]?$/,
        end: /^\w+;/,
        contains: [t.BACKSLASH_ESCAPE]
      },
      {
        // swallow composed identifiers to avoid parsing them as keywords
        begin: /(::|->)+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/
      },
      {
        className: "function",
        beginKeywords: "function fn",
        end: /[;{]/,
        excludeEnd: !0,
        illegal: /\$|\[|%/,
        contains: [
          n,
          {
            className: "params",
            begin: /\(/,
            end: /\)/,
            keywords: r,
            contains: [
              "self",
              t.C_BLOCK_COMMENT_MODE,
              e,
              i
            ]
          }
        ]
      },
      {
        className: "class",
        beginKeywords: "class interface",
        end: /\{/,
        excludeEnd: !0,
        illegal: /[:($"]/,
        contains: [
          { beginKeywords: "extends implements" },
          n
        ]
      },
      {
        beginKeywords: "namespace",
        end: /;/,
        illegal: /[.']/,
        contains: [n]
      },
      {
        beginKeywords: "use",
        end: /;/,
        contains: [n]
      },
      {
        begin: /=>/
        // No markup, just a relevance booster
      },
      e,
      i
    ]
  };
}
function DS(t) {
  const e = t.regex, n = t.COMMENT("//", "$", { contains: [{ begin: /\\\n/ }] }), i = "decltype\\(auto\\)", r = "[a-zA-Z_]\\w*::", s = "(?!struct)(" + i + "|" + e.optional(r) + "[a-zA-Z_]\\w*" + e.optional("<[^<>]+>") + ")", o = {
    className: "type",
    begin: "\\b[a-z\\d_]*_t\\b"
  }, c = {
    className: "string",
    variants: [
      {
        begin: '(u8?|U|L)?"',
        end: '"',
        illegal: "\\n",
        contains: [t.BACKSLASH_ESCAPE]
      },
      {
        begin: "(u8?|U|L)?'(" + "\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)" + "|.)",
        end: "'",
        illegal: "."
      },
      t.END_SAME_AS_BEGIN({
        begin: /(?:u8?|U|L)?R"([^()\\ ]{0,16})\(/,
        end: /\)([^()\\ ]{0,16})"/
      })
    ]
  }, d = {
    className: "number",
    variants: [
      // Floating-point literal.
      {
        begin: "[+-]?(?:(?:[0-9](?:'?[0-9])*\\.(?:[0-9](?:'?[0-9])*)?|\\.[0-9](?:'?[0-9])*)(?:[Ee][+-]?[0-9](?:'?[0-9])*)?|[0-9](?:'?[0-9])*[Ee][+-]?[0-9](?:'?[0-9])*|0[Xx](?:[0-9A-Fa-f](?:'?[0-9A-Fa-f])*(?:\\.(?:[0-9A-Fa-f](?:'?[0-9A-Fa-f])*)?)?|\\.[0-9A-Fa-f](?:'?[0-9A-Fa-f])*)[Pp][+-]?[0-9](?:'?[0-9])*)(?:[Ff](?:16|32|64|128)?|(BF|bf)16|[Ll]|)"
      },
      // Integer literal.
      {
        begin: "[+-]?\\b(?:0[Bb][01](?:'?[01])*|0[Xx][0-9A-Fa-f](?:'?[0-9A-Fa-f])*|0(?:'?[0-7])*|[1-9](?:'?[0-9])*)(?:[Uu](?:LL?|ll?)|[Uu][Zz]?|(?:LL?|ll?)[Uu]?|[Zz][Uu]|)"
        // Note: there are user-defined literal suffixes too, but perhaps having the custom suffix not part of the
        // literal highlight actually makes it stand out more.
      }
    ],
    relevance: 0
  }, u = {
    className: "meta",
    begin: /#\s*[a-z]+\b/,
    end: /$/,
    keywords: { keyword: "if else elif endif define undef warning error line pragma _Pragma ifdef ifndef include" },
    contains: [
      {
        begin: /\\\n/,
        relevance: 0
      },
      t.inherit(c, { className: "string" }),
      {
        className: "string",
        begin: /<.*?>/
      },
      n,
      t.C_BLOCK_COMMENT_MODE
    ]
  }, _ = {
    className: "title",
    begin: e.optional(r) + t.IDENT_RE,
    relevance: 0
  }, m = e.optional(r) + t.IDENT_RE + "\\s*\\(", g = [
    "alignas",
    "alignof",
    "and",
    "and_eq",
    "asm",
    "atomic_cancel",
    "atomic_commit",
    "atomic_noexcept",
    "auto",
    "bitand",
    "bitor",
    "break",
    "case",
    "catch",
    "class",
    "co_await",
    "co_return",
    "co_yield",
    "compl",
    "concept",
    "const_cast|10",
    "consteval",
    "constexpr",
    "constinit",
    "continue",
    "decltype",
    "default",
    "delete",
    "do",
    "dynamic_cast|10",
    "else",
    "enum",
    "explicit",
    "export",
    "extern",
    "false",
    "final",
    "for",
    "friend",
    "goto",
    "if",
    "import",
    "inline",
    "module",
    "mutable",
    "namespace",
    "new",
    "noexcept",
    "not",
    "not_eq",
    "nullptr",
    "operator",
    "or",
    "or_eq",
    "override",
    "private",
    "protected",
    "public",
    "reflexpr",
    "register",
    "reinterpret_cast|10",
    "requires",
    "return",
    "sizeof",
    "static_assert",
    "static_cast|10",
    "struct",
    "switch",
    "synchronized",
    "template",
    "this",
    "thread_local",
    "throw",
    "transaction_safe",
    "transaction_safe_dynamic",
    "true",
    "try",
    "typedef",
    "typeid",
    "typename",
    "union",
    "using",
    "virtual",
    "volatile",
    "while",
    "xor",
    "xor_eq"
  ], S = [
    "bool",
    "char",
    "char16_t",
    "char32_t",
    "char8_t",
    "double",
    "float",
    "int",
    "long",
    "short",
    "void",
    "wchar_t",
    "unsigned",
    "signed",
    "const",
    "static"
  ], E = [
    "any",
    "auto_ptr",
    "barrier",
    "binary_semaphore",
    "bitset",
    "complex",
    "condition_variable",
    "condition_variable_any",
    "counting_semaphore",
    "deque",
    "false_type",
    "flat_map",
    "flat_set",
    "future",
    "imaginary",
    "initializer_list",
    "istringstream",
    "jthread",
    "latch",
    "lock_guard",
    "multimap",
    "multiset",
    "mutex",
    "optional",
    "ostringstream",
    "packaged_task",
    "pair",
    "promise",
    "priority_queue",
    "queue",
    "recursive_mutex",
    "recursive_timed_mutex",
    "scoped_lock",
    "set",
    "shared_future",
    "shared_lock",
    "shared_mutex",
    "shared_timed_mutex",
    "shared_ptr",
    "stack",
    "string_view",
    "stringstream",
    "timed_mutex",
    "thread",
    "true_type",
    "tuple",
    "unique_lock",
    "unique_ptr",
    "unordered_map",
    "unordered_multimap",
    "unordered_multiset",
    "unordered_set",
    "variant",
    "vector",
    "weak_ptr",
    "wstring",
    "wstring_view"
  ], h = [
    "abort",
    "abs",
    "acos",
    "apply",
    "as_const",
    "asin",
    "atan",
    "atan2",
    "calloc",
    "ceil",
    "cerr",
    "cin",
    "clog",
    "cos",
    "cosh",
    "cout",
    "declval",
    "endl",
    "exchange",
    "exit",
    "exp",
    "fabs",
    "floor",
    "fmod",
    "forward",
    "fprintf",
    "fputs",
    "free",
    "frexp",
    "fscanf",
    "future",
    "invoke",
    "isalnum",
    "isalpha",
    "iscntrl",
    "isdigit",
    "isgraph",
    "islower",
    "isprint",
    "ispunct",
    "isspace",
    "isupper",
    "isxdigit",
    "labs",
    "launder",
    "ldexp",
    "log",
    "log10",
    "make_pair",
    "make_shared",
    "make_shared_for_overwrite",
    "make_tuple",
    "make_unique",
    "malloc",
    "memchr",
    "memcmp",
    "memcpy",
    "memset",
    "modf",
    "move",
    "pow",
    "printf",
    "putchar",
    "puts",
    "realloc",
    "scanf",
    "sin",
    "sinh",
    "snprintf",
    "sprintf",
    "sqrt",
    "sscanf",
    "std",
    "stderr",
    "stdin",
    "stdout",
    "strcat",
    "strchr",
    "strcmp",
    "strcpy",
    "strcspn",
    "strlen",
    "strncat",
    "strncmp",
    "strncpy",
    "strpbrk",
    "strrchr",
    "strspn",
    "strstr",
    "swap",
    "tan",
    "tanh",
    "terminate",
    "to_underlying",
    "tolower",
    "toupper",
    "vfprintf",
    "visit",
    "vprintf",
    "vsprintf"
  ], C = {
    type: S,
    keyword: g,
    literal: [
      "NULL",
      "false",
      "nullopt",
      "nullptr",
      "true"
    ],
    built_in: ["_Pragma"],
    _type_hints: E
  }, y = {
    className: "function.dispatch",
    relevance: 0,
    keywords: {
      // Only for relevance, not highlighting.
      _hint: h
    },
    begin: e.concat(
      /\b/,
      /(?!decltype)/,
      /(?!if)/,
      /(?!for)/,
      /(?!switch)/,
      /(?!while)/,
      t.IDENT_RE,
      e.lookahead(/(<[^<>]+>|)\s*\(/)
    )
  }, O = [
    y,
    u,
    o,
    n,
    t.C_BLOCK_COMMENT_MODE,
    d,
    c
  ], A = {
    // This mode covers expression context where we can't expect a function
    // definition and shouldn't highlight anything that looks like one:
    // `return some()`, `else if()`, `(x*sum(1, 2))`
    variants: [
      {
        begin: /=/,
        end: /;/
      },
      {
        begin: /\(/,
        end: /\)/
      },
      {
        beginKeywords: "new throw return else",
        end: /;/
      }
    ],
    keywords: C,
    contains: O.concat([
      {
        begin: /\(/,
        end: /\)/,
        keywords: C,
        contains: O.concat(["self"]),
        relevance: 0
      }
    ]),
    relevance: 0
  }, I = {
    className: "function",
    begin: "(" + s + "[\\*&\\s]+)+" + m,
    returnBegin: !0,
    end: /[{;=]/,
    excludeEnd: !0,
    keywords: C,
    illegal: /[^\w\s\*&:<>.]/,
    contains: [
      {
        // to prevent it from being confused as the function title
        begin: i,
        keywords: C,
        relevance: 0
      },
      {
        begin: m,
        returnBegin: !0,
        contains: [_],
        relevance: 0
      },
      // needed because we do not have look-behind on the below rule
      // to prevent it from grabbing the final : in a :: pair
      {
        begin: /::/,
        relevance: 0
      },
      // initializers
      {
        begin: /:/,
        endsWithParent: !0,
        contains: [
          c,
          d
        ]
      },
      // allow for multiple declarations, e.g.:
      // extern void f(int), g(char);
      {
        relevance: 0,
        match: /,/
      },
      {
        className: "params",
        begin: /\(/,
        end: /\)/,
        keywords: C,
        relevance: 0,
        contains: [
          n,
          t.C_BLOCK_COMMENT_MODE,
          c,
          d,
          o,
          // Count matching parentheses.
          {
            begin: /\(/,
            end: /\)/,
            keywords: C,
            relevance: 0,
            contains: [
              "self",
              n,
              t.C_BLOCK_COMMENT_MODE,
              c,
              d,
              o
            ]
          }
        ]
      },
      o,
      n,
      t.C_BLOCK_COMMENT_MODE,
      u
    ]
  };
  return {
    name: "C++",
    aliases: [
      "cc",
      "c++",
      "h++",
      "hpp",
      "hh",
      "hxx",
      "cxx"
    ],
    keywords: C,
    illegal: "</",
    classNameAliases: { "function.dispatch": "built_in" },
    contains: [].concat(
      A,
      I,
      y,
      O,
      [
        u,
        {
          // containers: ie, `vector <int> rooms (9);`
          begin: "\\b(deque|list|queue|priority_queue|pair|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array|tuple|optional|variant|function|flat_map|flat_set)\\s*<(?!<)",
          end: ">",
          keywords: C,
          contains: [
            "self",
            o
          ]
        },
        {
          begin: t.IDENT_RE + "::",
          keywords: C
        },
        {
          match: [
            // extra complexity to deal with `enum class` and `enum struct`
            /\b(?:enum(?:\s+(?:class|struct))?|class|struct|union)/,
            /\s+/,
            /\w+/
          ],
          className: {
            1: "keyword",
            3: "title.class"
          }
        }
      ]
    )
  };
}
function MS(t) {
  const e = {
    type: [
      "boolean",
      "byte",
      "word",
      "String"
    ],
    built_in: [
      "KeyboardController",
      "MouseController",
      "SoftwareSerial",
      "EthernetServer",
      "EthernetClient",
      "LiquidCrystal",
      "RobotControl",
      "GSMVoiceCall",
      "EthernetUDP",
      "EsploraTFT",
      "HttpClient",
      "RobotMotor",
      "WiFiClient",
      "GSMScanner",
      "FileSystem",
      "Scheduler",
      "GSMServer",
      "YunClient",
      "YunServer",
      "IPAddress",
      "GSMClient",
      "GSMModem",
      "Keyboard",
      "Ethernet",
      "Console",
      "GSMBand",
      "Esplora",
      "Stepper",
      "Process",
      "WiFiUDP",
      "GSM_SMS",
      "Mailbox",
      "USBHost",
      "Firmata",
      "PImage",
      "Client",
      "Server",
      "GSMPIN",
      "FileIO",
      "Bridge",
      "Serial",
      "EEPROM",
      "Stream",
      "Mouse",
      "Audio",
      "Servo",
      "File",
      "Task",
      "GPRS",
      "WiFi",
      "Wire",
      "TFT",
      "GSM",
      "SPI",
      "SD"
    ],
    _hints: [
      "setup",
      "loop",
      "runShellCommandAsynchronously",
      "analogWriteResolution",
      "retrieveCallingNumber",
      "printFirmwareVersion",
      "analogReadResolution",
      "sendDigitalPortPair",
      "noListenOnLocalhost",
      "readJoystickButton",
      "setFirmwareVersion",
      "readJoystickSwitch",
      "scrollDisplayRight",
      "getVoiceCallStatus",
      "scrollDisplayLeft",
      "writeMicroseconds",
      "delayMicroseconds",
      "beginTransmission",
      "getSignalStrength",
      "runAsynchronously",
      "getAsynchronously",
      "listenOnLocalhost",
      "getCurrentCarrier",
      "readAccelerometer",
      "messageAvailable",
      "sendDigitalPorts",
      "lineFollowConfig",
      "countryNameWrite",
      "runShellCommand",
      "readStringUntil",
      "rewindDirectory",
      "readTemperature",
      "setClockDivider",
      "readLightSensor",
      "endTransmission",
      "analogReference",
      "detachInterrupt",
      "countryNameRead",
      "attachInterrupt",
      "encryptionType",
      "readBytesUntil",
      "robotNameWrite",
      "readMicrophone",
      "robotNameRead",
      "cityNameWrite",
      "userNameWrite",
      "readJoystickY",
      "readJoystickX",
      "mouseReleased",
      "openNextFile",
      "scanNetworks",
      "noInterrupts",
      "digitalWrite",
      "beginSpeaker",
      "mousePressed",
      "isActionDone",
      "mouseDragged",
      "displayLogos",
      "noAutoscroll",
      "addParameter",
      "remoteNumber",
      "getModifiers",
      "keyboardRead",
      "userNameRead",
      "waitContinue",
      "processInput",
      "parseCommand",
      "printVersion",
      "readNetworks",
      "writeMessage",
      "blinkVersion",
      "cityNameRead",
      "readMessage",
      "setDataMode",
      "parsePacket",
      "isListening",
      "setBitOrder",
      "beginPacket",
      "isDirectory",
      "motorsWrite",
      "drawCompass",
      "digitalRead",
      "clearScreen",
      "serialEvent",
      "rightToLeft",
      "setTextSize",
      "leftToRight",
      "requestFrom",
      "keyReleased",
      "compassRead",
      "analogWrite",
      "interrupts",
      "WiFiServer",
      "disconnect",
      "playMelody",
      "parseFloat",
      "autoscroll",
      "getPINUsed",
      "setPINUsed",
      "setTimeout",
      "sendAnalog",
      "readSlider",
      "analogRead",
      "beginWrite",
      "createChar",
      "motorsStop",
      "keyPressed",
      "tempoWrite",
      "readButton",
      "subnetMask",
      "debugPrint",
      "macAddress",
      "writeGreen",
      "randomSeed",
      "attachGPRS",
      "readString",
      "sendString",
      "remotePort",
      "releaseAll",
      "mouseMoved",
      "background",
      "getXChange",
      "getYChange",
      "answerCall",
      "getResult",
      "voiceCall",
      "endPacket",
      "constrain",
      "getSocket",
      "writeJSON",
      "getButton",
      "available",
      "connected",
      "findUntil",
      "readBytes",
      "exitValue",
      "readGreen",
      "writeBlue",
      "startLoop",
      "IPAddress",
      "isPressed",
      "sendSysex",
      "pauseMode",
      "gatewayIP",
      "setCursor",
      "getOemKey",
      "tuneWrite",
      "noDisplay",
      "loadImage",
      "switchPIN",
      "onRequest",
      "onReceive",
      "changePIN",
      "playFile",
      "noBuffer",
      "parseInt",
      "overflow",
      "checkPIN",
      "knobRead",
      "beginTFT",
      "bitClear",
      "updateIR",
      "bitWrite",
      "position",
      "writeRGB",
      "highByte",
      "writeRed",
      "setSpeed",
      "readBlue",
      "noStroke",
      "remoteIP",
      "transfer",
      "shutdown",
      "hangCall",
      "beginSMS",
      "endWrite",
      "attached",
      "maintain",
      "noCursor",
      "checkReg",
      "checkPUK",
      "shiftOut",
      "isValid",
      "shiftIn",
      "pulseIn",
      "connect",
      "println",
      "localIP",
      "pinMode",
      "getIMEI",
      "display",
      "noBlink",
      "process",
      "getBand",
      "running",
      "beginSD",
      "drawBMP",
      "lowByte",
      "setBand",
      "release",
      "bitRead",
      "prepare",
      "pointTo",
      "readRed",
      "setMode",
      "noFill",
      "remove",
      "listen",
      "stroke",
      "detach",
      "attach",
      "noTone",
      "exists",
      "buffer",
      "height",
      "bitSet",
      "circle",
      "config",
      "cursor",
      "random",
      "IRread",
      "setDNS",
      "endSMS",
      "getKey",
      "micros",
      "millis",
      "begin",
      "print",
      "write",
      "ready",
      "flush",
      "width",
      "isPIN",
      "blink",
      "clear",
      "press",
      "mkdir",
      "rmdir",
      "close",
      "point",
      "yield",
      "image",
      "BSSID",
      "click",
      "delay",
      "read",
      "text",
      "move",
      "peek",
      "beep",
      "rect",
      "line",
      "open",
      "seek",
      "fill",
      "size",
      "turn",
      "stop",
      "home",
      "find",
      "step",
      "tone",
      "sqrt",
      "RSSI",
      "SSID",
      "end",
      "bit",
      "tan",
      "cos",
      "sin",
      "pow",
      "map",
      "abs",
      "max",
      "min",
      "get",
      "run",
      "put"
    ],
    literal: [
      "DIGITAL_MESSAGE",
      "FIRMATA_STRING",
      "ANALOG_MESSAGE",
      "REPORT_DIGITAL",
      "REPORT_ANALOG",
      "INPUT_PULLUP",
      "SET_PIN_MODE",
      "INTERNAL2V56",
      "SYSTEM_RESET",
      "LED_BUILTIN",
      "INTERNAL1V1",
      "SYSEX_START",
      "INTERNAL",
      "EXTERNAL",
      "DEFAULT",
      "OUTPUT",
      "INPUT",
      "HIGH",
      "LOW"
    ]
  }, n = DS(t), i = (
    /** @type {Record<string,any>} */
    n.keywords
  );
  return i.type = [
    ...i.type,
    ...e.type
  ], i.literal = [
    ...i.literal,
    ...e.literal
  ], i.built_in = [
    ...i.built_in,
    ...e.built_in
  ], i._hints = e._hints, n.name = "Arduino", n.aliases = ["ino"], n.supersetOf = "cpp", n;
}
function wS(t) {
  const e = t.regex, n = {}, i = {
    begin: /\$\{/,
    end: /\}/,
    contains: [
      "self",
      {
        begin: /:-/,
        contains: [n]
      }
      // default values
    ]
  };
  Object.assign(n, {
    className: "variable",
    variants: [
      { begin: e.concat(
        /\$[\w\d#@][\w\d_]*/,
        // negative look-ahead tries to avoid matching patterns that are not
        // Perl at all like $ident$, @ident@, etc.
        "(?![\\w\\d])(?![$])"
      ) },
      i
    ]
  });
  const r = {
    className: "subst",
    begin: /\$\(/,
    end: /\)/,
    contains: [t.BACKSLASH_ESCAPE]
  }, a = t.inherit(
    t.COMMENT(),
    {
      match: [
        /(^|\s)/,
        /#.*$/
      ],
      scope: {
        2: "comment"
      }
    }
  ), s = {
    begin: /<<-?\s*(?=\w+)/,
    starts: { contains: [
      t.END_SAME_AS_BEGIN({
        begin: /(\w+)/,
        end: /(\w+)/,
        className: "string"
      })
    ] }
  }, o = {
    className: "string",
    begin: /"/,
    end: /"/,
    contains: [
      t.BACKSLASH_ESCAPE,
      n,
      r
    ]
  };
  r.contains.push(o);
  const l = {
    match: /\\"/
  }, c = {
    className: "string",
    begin: /'/,
    end: /'/
  }, d = {
    match: /\\'/
  }, u = {
    begin: /\$?\(\(/,
    end: /\)\)/,
    contains: [
      {
        begin: /\d+#[0-9a-f]+/,
        className: "number"
      },
      t.NUMBER_MODE,
      n
    ]
  }, _ = [
    "fish",
    "bash",
    "zsh",
    "sh",
    "csh",
    "ksh",
    "tcsh",
    "dash",
    "scsh"
  ], m = t.SHEBANG({
    binary: `(${_.join("|")})`,
    relevance: 10
  }), g = {
    className: "function",
    begin: /\w[\w\d_]*\s*\(\s*\)\s*\{/,
    returnBegin: !0,
    contains: [t.inherit(t.TITLE_MODE, { begin: /\w[\w\d_]*/ })],
    relevance: 0
  }, S = [
    "if",
    "then",
    "else",
    "elif",
    "fi",
    "time",
    "for",
    "while",
    "until",
    "in",
    "do",
    "done",
    "case",
    "esac",
    "coproc",
    "function",
    "select"
  ], E = [
    "true",
    "false"
  ], h = { match: /(\/[a-z._-]+)+/ }, T = [
    "break",
    "cd",
    "continue",
    "eval",
    "exec",
    "exit",
    "export",
    "getopts",
    "hash",
    "pwd",
    "readonly",
    "return",
    "shift",
    "test",
    "times",
    "trap",
    "umask",
    "unset"
  ], b = [
    "alias",
    "bind",
    "builtin",
    "caller",
    "command",
    "declare",
    "echo",
    "enable",
    "help",
    "let",
    "local",
    "logout",
    "mapfile",
    "printf",
    "read",
    "readarray",
    "source",
    "sudo",
    "type",
    "typeset",
    "ulimit",
    "unalias"
  ], C = [
    "autoload",
    "bg",
    "bindkey",
    "bye",
    "cap",
    "chdir",
    "clone",
    "comparguments",
    "compcall",
    "compctl",
    "compdescribe",
    "compfiles",
    "compgroups",
    "compquote",
    "comptags",
    "comptry",
    "compvalues",
    "dirs",
    "disable",
    "disown",
    "echotc",
    "echoti",
    "emulate",
    "fc",
    "fg",
    "float",
    "functions",
    "getcap",
    "getln",
    "history",
    "integer",
    "jobs",
    "kill",
    "limit",
    "log",
    "noglob",
    "popd",
    "print",
    "pushd",
    "pushln",
    "rehash",
    "sched",
    "setcap",
    "setopt",
    "stat",
    "suspend",
    "ttyctl",
    "unfunction",
    "unhash",
    "unlimit",
    "unsetopt",
    "vared",
    "wait",
    "whence",
    "where",
    "which",
    "zcompile",
    "zformat",
    "zftp",
    "zle",
    "zmodload",
    "zparseopts",
    "zprof",
    "zpty",
    "zregexparse",
    "zsocket",
    "zstyle",
    "ztcp"
  ], y = [
    "chcon",
    "chgrp",
    "chown",
    "chmod",
    "cp",
    "dd",
    "df",
    "dir",
    "dircolors",
    "ln",
    "ls",
    "mkdir",
    "mkfifo",
    "mknod",
    "mktemp",
    "mv",
    "realpath",
    "rm",
    "rmdir",
    "shred",
    "sync",
    "touch",
    "truncate",
    "vdir",
    "b2sum",
    "base32",
    "base64",
    "cat",
    "cksum",
    "comm",
    "csplit",
    "cut",
    "expand",
    "fmt",
    "fold",
    "head",
    "join",
    "md5sum",
    "nl",
    "numfmt",
    "od",
    "paste",
    "ptx",
    "pr",
    "sha1sum",
    "sha224sum",
    "sha256sum",
    "sha384sum",
    "sha512sum",
    "shuf",
    "sort",
    "split",
    "sum",
    "tac",
    "tail",
    "tr",
    "tsort",
    "unexpand",
    "uniq",
    "wc",
    "arch",
    "basename",
    "chroot",
    "date",
    "dirname",
    "du",
    "echo",
    "env",
    "expr",
    "factor",
    // "false", // keyword literal already
    "groups",
    "hostid",
    "id",
    "link",
    "logname",
    "nice",
    "nohup",
    "nproc",
    "pathchk",
    "pinky",
    "printenv",
    "printf",
    "pwd",
    "readlink",
    "runcon",
    "seq",
    "sleep",
    "stat",
    "stdbuf",
    "stty",
    "tee",
    "test",
    "timeout",
    // "true", // keyword literal already
    "tty",
    "uname",
    "unlink",
    "uptime",
    "users",
    "who",
    "whoami",
    "yes"
  ];
  return {
    name: "Bash",
    aliases: [
      "sh",
      "zsh"
    ],
    keywords: {
      $pattern: /\b[a-z][a-z0-9._-]+\b/,
      keyword: S,
      literal: E,
      built_in: [
        ...T,
        ...b,
        // Shell modifiers
        "set",
        "shopt",
        ...C,
        ...y
      ]
    },
    contains: [
      m,
      // to catch known shells and boost relevancy
      t.SHEBANG(),
      // to catch unknown shells but still highlight the shebang
      g,
      u,
      a,
      s,
      h,
      o,
      l,
      c,
      d,
      n
    ]
  };
}
function xS(t) {
  const e = t.regex, n = t.COMMENT("//", "$", { contains: [{ begin: /\\\n/ }] }), i = "decltype\\(auto\\)", r = "[a-zA-Z_]\\w*::", s = "(" + i + "|" + e.optional(r) + "[a-zA-Z_]\\w*" + e.optional("<[^<>]+>") + ")", o = {
    className: "type",
    variants: [
      { begin: "\\b[a-z\\d_]*_t\\b" },
      { match: /\batomic_[a-z]{3,6}\b/ }
    ]
  }, c = {
    className: "string",
    variants: [
      {
        begin: '(u8?|U|L)?"',
        end: '"',
        illegal: "\\n",
        contains: [t.BACKSLASH_ESCAPE]
      },
      {
        begin: "(u8?|U|L)?'(" + "\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)" + "|.)",
        end: "'",
        illegal: "."
      },
      t.END_SAME_AS_BEGIN({
        begin: /(?:u8?|U|L)?R"([^()\\ ]{0,16})\(/,
        end: /\)([^()\\ ]{0,16})"/
      })
    ]
  }, d = {
    className: "number",
    variants: [
      { match: /\b(0b[01']+)/ },
      { match: /(-?)\b([\d']+(\.[\d']*)?|\.[\d']+)((ll|LL|l|L)(u|U)?|(u|U)(ll|LL|l|L)?|f|F|b|B)/ },
      { match: /(-?)\b(0[xX][a-fA-F0-9]+(?:'[a-fA-F0-9]+)*(?:\.[a-fA-F0-9]*(?:'[a-fA-F0-9]*)*)?(?:[pP][-+]?[0-9]+)?(l|L)?(u|U)?)/ },
      { match: /(-?)\b\d+(?:'\d+)*(?:\.\d*(?:'\d*)*)?(?:[eE][-+]?\d+)?/ }
    ],
    relevance: 0
  }, u = {
    className: "meta",
    begin: /#\s*[a-z]+\b/,
    end: /$/,
    keywords: { keyword: "if else elif endif define undef warning error line pragma _Pragma ifdef ifndef elifdef elifndef include" },
    contains: [
      {
        begin: /\\\n/,
        relevance: 0
      },
      t.inherit(c, { className: "string" }),
      {
        className: "string",
        begin: /<.*?>/
      },
      n,
      t.C_BLOCK_COMMENT_MODE
    ]
  }, _ = {
    className: "title",
    begin: e.optional(r) + t.IDENT_RE,
    relevance: 0
  }, m = e.optional(r) + t.IDENT_RE + "\\s*\\(", E = {
    keyword: [
      "asm",
      "auto",
      "break",
      "case",
      "continue",
      "default",
      "do",
      "else",
      "enum",
      "extern",
      "for",
      "fortran",
      "goto",
      "if",
      "inline",
      "register",
      "restrict",
      "return",
      "sizeof",
      "typeof",
      "typeof_unqual",
      "struct",
      "switch",
      "typedef",
      "union",
      "volatile",
      "while",
      "_Alignas",
      "_Alignof",
      "_Atomic",
      "_Generic",
      "_Noreturn",
      "_Static_assert",
      "_Thread_local",
      // aliases
      "alignas",
      "alignof",
      "noreturn",
      "static_assert",
      "thread_local",
      // not a C keyword but is, for all intents and purposes, treated exactly like one.
      "_Pragma"
    ],
    type: [
      "float",
      "double",
      "signed",
      "unsigned",
      "int",
      "short",
      "long",
      "char",
      "void",
      "_Bool",
      "_BitInt",
      "_Complex",
      "_Imaginary",
      "_Decimal32",
      "_Decimal64",
      "_Decimal96",
      "_Decimal128",
      "_Decimal64x",
      "_Decimal128x",
      "_Float16",
      "_Float32",
      "_Float64",
      "_Float128",
      "_Float32x",
      "_Float64x",
      "_Float128x",
      // modifiers
      "const",
      "static",
      "constexpr",
      // aliases
      "complex",
      "bool",
      "imaginary"
    ],
    literal: "true false NULL",
    // TODO: apply hinting work similar to what was done in cpp.js
    built_in: "std string wstring cin cout cerr clog stdin stdout stderr stringstream istringstream ostringstream auto_ptr deque list queue stack vector map set pair bitset multiset multimap unordered_set unordered_map unordered_multiset unordered_multimap priority_queue make_pair array shared_ptr abort terminate abs acos asin atan2 atan calloc ceil cosh cos exit exp fabs floor fmod fprintf fputs free frexp fscanf future isalnum isalpha iscntrl isdigit isgraph islower isprint ispunct isspace isupper isxdigit tolower toupper labs ldexp log10 log malloc realloc memchr memcmp memcpy memset modf pow printf putchar puts scanf sinh sin snprintf sprintf sqrt sscanf strcat strchr strcmp strcpy strcspn strlen strncat strncmp strncpy strpbrk strrchr strspn strstr tanh tan vfprintf vprintf vsprintf endl initializer_list unique_ptr"
  }, h = [
    u,
    o,
    n,
    t.C_BLOCK_COMMENT_MODE,
    d,
    c
  ], T = {
    // This mode covers expression context where we can't expect a function
    // definition and shouldn't highlight anything that looks like one:
    // `return some()`, `else if()`, `(x*sum(1, 2))`
    variants: [
      {
        begin: /=/,
        end: /;/
      },
      {
        begin: /\(/,
        end: /\)/
      },
      {
        beginKeywords: "new throw return else",
        end: /;/
      }
    ],
    keywords: E,
    contains: h.concat([
      {
        begin: /\(/,
        end: /\)/,
        keywords: E,
        contains: h.concat(["self"]),
        relevance: 0
      }
    ]),
    relevance: 0
  }, b = {
    begin: "(" + s + "[\\*&\\s]+)+" + m,
    returnBegin: !0,
    end: /[{;=]/,
    excludeEnd: !0,
    keywords: E,
    illegal: /[^\w\s\*&:<>.]/,
    contains: [
      {
        // to prevent it from being confused as the function title
        begin: i,
        keywords: E,
        relevance: 0
      },
      {
        begin: m,
        returnBegin: !0,
        contains: [t.inherit(_, { className: "title.function" })],
        relevance: 0
      },
      // allow for multiple declarations, e.g.:
      // extern void f(int), g(char);
      {
        relevance: 0,
        match: /,/
      },
      {
        className: "params",
        begin: /\(/,
        end: /\)/,
        keywords: E,
        relevance: 0,
        contains: [
          n,
          t.C_BLOCK_COMMENT_MODE,
          c,
          d,
          o,
          // Count matching parentheses.
          {
            begin: /\(/,
            end: /\)/,
            keywords: E,
            relevance: 0,
            contains: [
              "self",
              n,
              t.C_BLOCK_COMMENT_MODE,
              c,
              d,
              o
            ]
          }
        ]
      },
      o,
      n,
      t.C_BLOCK_COMMENT_MODE,
      u
    ]
  };
  return {
    name: "C",
    aliases: ["h"],
    keywords: E,
    // Until differentiations are added between `c` and `cpp`, `c` will
    // not be auto-detected to avoid auto-detect conflicts between C and C++
    disableAutodetect: !0,
    illegal: "</",
    contains: [].concat(
      T,
      b,
      h,
      [
        u,
        {
          begin: t.IDENT_RE + "::",
          keywords: E
        },
        {
          className: "class",
          beginKeywords: "enum class struct union",
          end: /[{;:<>=]/,
          contains: [
            { beginKeywords: "final class struct" },
            t.TITLE_MODE
          ]
        }
      ]
    ),
    exports: {
      preprocessor: u,
      strings: c,
      keywords: E
    }
  };
}
function LS(t) {
  const e = t.regex, n = t.COMMENT("//", "$", { contains: [{ begin: /\\\n/ }] }), i = "decltype\\(auto\\)", r = "[a-zA-Z_]\\w*::", s = "(?!struct)(" + i + "|" + e.optional(r) + "[a-zA-Z_]\\w*" + e.optional("<[^<>]+>") + ")", o = {
    className: "type",
    begin: "\\b[a-z\\d_]*_t\\b"
  }, c = {
    className: "string",
    variants: [
      {
        begin: '(u8?|U|L)?"',
        end: '"',
        illegal: "\\n",
        contains: [t.BACKSLASH_ESCAPE]
      },
      {
        begin: "(u8?|U|L)?'(" + "\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)" + "|.)",
        end: "'",
        illegal: "."
      },
      t.END_SAME_AS_BEGIN({
        begin: /(?:u8?|U|L)?R"([^()\\ ]{0,16})\(/,
        end: /\)([^()\\ ]{0,16})"/
      })
    ]
  }, d = {
    className: "number",
    variants: [
      // Floating-point literal.
      {
        begin: "[+-]?(?:(?:[0-9](?:'?[0-9])*\\.(?:[0-9](?:'?[0-9])*)?|\\.[0-9](?:'?[0-9])*)(?:[Ee][+-]?[0-9](?:'?[0-9])*)?|[0-9](?:'?[0-9])*[Ee][+-]?[0-9](?:'?[0-9])*|0[Xx](?:[0-9A-Fa-f](?:'?[0-9A-Fa-f])*(?:\\.(?:[0-9A-Fa-f](?:'?[0-9A-Fa-f])*)?)?|\\.[0-9A-Fa-f](?:'?[0-9A-Fa-f])*)[Pp][+-]?[0-9](?:'?[0-9])*)(?:[Ff](?:16|32|64|128)?|(BF|bf)16|[Ll]|)"
      },
      // Integer literal.
      {
        begin: "[+-]?\\b(?:0[Bb][01](?:'?[01])*|0[Xx][0-9A-Fa-f](?:'?[0-9A-Fa-f])*|0(?:'?[0-7])*|[1-9](?:'?[0-9])*)(?:[Uu](?:LL?|ll?)|[Uu][Zz]?|(?:LL?|ll?)[Uu]?|[Zz][Uu]|)"
        // Note: there are user-defined literal suffixes too, but perhaps having the custom suffix not part of the
        // literal highlight actually makes it stand out more.
      }
    ],
    relevance: 0
  }, u = {
    className: "meta",
    begin: /#\s*[a-z]+\b/,
    end: /$/,
    keywords: { keyword: "if else elif endif define undef warning error line pragma _Pragma ifdef ifndef include" },
    contains: [
      {
        begin: /\\\n/,
        relevance: 0
      },
      t.inherit(c, { className: "string" }),
      {
        className: "string",
        begin: /<.*?>/
      },
      n,
      t.C_BLOCK_COMMENT_MODE
    ]
  }, _ = {
    className: "title",
    begin: e.optional(r) + t.IDENT_RE,
    relevance: 0
  }, m = e.optional(r) + t.IDENT_RE + "\\s*\\(", g = [
    "alignas",
    "alignof",
    "and",
    "and_eq",
    "asm",
    "atomic_cancel",
    "atomic_commit",
    "atomic_noexcept",
    "auto",
    "bitand",
    "bitor",
    "break",
    "case",
    "catch",
    "class",
    "co_await",
    "co_return",
    "co_yield",
    "compl",
    "concept",
    "const_cast|10",
    "consteval",
    "constexpr",
    "constinit",
    "continue",
    "decltype",
    "default",
    "delete",
    "do",
    "dynamic_cast|10",
    "else",
    "enum",
    "explicit",
    "export",
    "extern",
    "false",
    "final",
    "for",
    "friend",
    "goto",
    "if",
    "import",
    "inline",
    "module",
    "mutable",
    "namespace",
    "new",
    "noexcept",
    "not",
    "not_eq",
    "nullptr",
    "operator",
    "or",
    "or_eq",
    "override",
    "private",
    "protected",
    "public",
    "reflexpr",
    "register",
    "reinterpret_cast|10",
    "requires",
    "return",
    "sizeof",
    "static_assert",
    "static_cast|10",
    "struct",
    "switch",
    "synchronized",
    "template",
    "this",
    "thread_local",
    "throw",
    "transaction_safe",
    "transaction_safe_dynamic",
    "true",
    "try",
    "typedef",
    "typeid",
    "typename",
    "union",
    "using",
    "virtual",
    "volatile",
    "while",
    "xor",
    "xor_eq"
  ], S = [
    "bool",
    "char",
    "char16_t",
    "char32_t",
    "char8_t",
    "double",
    "float",
    "int",
    "long",
    "short",
    "void",
    "wchar_t",
    "unsigned",
    "signed",
    "const",
    "static"
  ], E = [
    "any",
    "auto_ptr",
    "barrier",
    "binary_semaphore",
    "bitset",
    "complex",
    "condition_variable",
    "condition_variable_any",
    "counting_semaphore",
    "deque",
    "false_type",
    "flat_map",
    "flat_set",
    "future",
    "imaginary",
    "initializer_list",
    "istringstream",
    "jthread",
    "latch",
    "lock_guard",
    "multimap",
    "multiset",
    "mutex",
    "optional",
    "ostringstream",
    "packaged_task",
    "pair",
    "promise",
    "priority_queue",
    "queue",
    "recursive_mutex",
    "recursive_timed_mutex",
    "scoped_lock",
    "set",
    "shared_future",
    "shared_lock",
    "shared_mutex",
    "shared_timed_mutex",
    "shared_ptr",
    "stack",
    "string_view",
    "stringstream",
    "timed_mutex",
    "thread",
    "true_type",
    "tuple",
    "unique_lock",
    "unique_ptr",
    "unordered_map",
    "unordered_multimap",
    "unordered_multiset",
    "unordered_set",
    "variant",
    "vector",
    "weak_ptr",
    "wstring",
    "wstring_view"
  ], h = [
    "abort",
    "abs",
    "acos",
    "apply",
    "as_const",
    "asin",
    "atan",
    "atan2",
    "calloc",
    "ceil",
    "cerr",
    "cin",
    "clog",
    "cos",
    "cosh",
    "cout",
    "declval",
    "endl",
    "exchange",
    "exit",
    "exp",
    "fabs",
    "floor",
    "fmod",
    "forward",
    "fprintf",
    "fputs",
    "free",
    "frexp",
    "fscanf",
    "future",
    "invoke",
    "isalnum",
    "isalpha",
    "iscntrl",
    "isdigit",
    "isgraph",
    "islower",
    "isprint",
    "ispunct",
    "isspace",
    "isupper",
    "isxdigit",
    "labs",
    "launder",
    "ldexp",
    "log",
    "log10",
    "make_pair",
    "make_shared",
    "make_shared_for_overwrite",
    "make_tuple",
    "make_unique",
    "malloc",
    "memchr",
    "memcmp",
    "memcpy",
    "memset",
    "modf",
    "move",
    "pow",
    "printf",
    "putchar",
    "puts",
    "realloc",
    "scanf",
    "sin",
    "sinh",
    "snprintf",
    "sprintf",
    "sqrt",
    "sscanf",
    "std",
    "stderr",
    "stdin",
    "stdout",
    "strcat",
    "strchr",
    "strcmp",
    "strcpy",
    "strcspn",
    "strlen",
    "strncat",
    "strncmp",
    "strncpy",
    "strpbrk",
    "strrchr",
    "strspn",
    "strstr",
    "swap",
    "tan",
    "tanh",
    "terminate",
    "to_underlying",
    "tolower",
    "toupper",
    "vfprintf",
    "visit",
    "vprintf",
    "vsprintf"
  ], C = {
    type: S,
    keyword: g,
    literal: [
      "NULL",
      "false",
      "nullopt",
      "nullptr",
      "true"
    ],
    built_in: ["_Pragma"],
    _type_hints: E
  }, y = {
    className: "function.dispatch",
    relevance: 0,
    keywords: {
      // Only for relevance, not highlighting.
      _hint: h
    },
    begin: e.concat(
      /\b/,
      /(?!decltype)/,
      /(?!if)/,
      /(?!for)/,
      /(?!switch)/,
      /(?!while)/,
      t.IDENT_RE,
      e.lookahead(/(<[^<>]+>|)\s*\(/)
    )
  }, O = [
    y,
    u,
    o,
    n,
    t.C_BLOCK_COMMENT_MODE,
    d,
    c
  ], A = {
    // This mode covers expression context where we can't expect a function
    // definition and shouldn't highlight anything that looks like one:
    // `return some()`, `else if()`, `(x*sum(1, 2))`
    variants: [
      {
        begin: /=/,
        end: /;/
      },
      {
        begin: /\(/,
        end: /\)/
      },
      {
        beginKeywords: "new throw return else",
        end: /;/
      }
    ],
    keywords: C,
    contains: O.concat([
      {
        begin: /\(/,
        end: /\)/,
        keywords: C,
        contains: O.concat(["self"]),
        relevance: 0
      }
    ]),
    relevance: 0
  }, I = {
    className: "function",
    begin: "(" + s + "[\\*&\\s]+)+" + m,
    returnBegin: !0,
    end: /[{;=]/,
    excludeEnd: !0,
    keywords: C,
    illegal: /[^\w\s\*&:<>.]/,
    contains: [
      {
        // to prevent it from being confused as the function title
        begin: i,
        keywords: C,
        relevance: 0
      },
      {
        begin: m,
        returnBegin: !0,
        contains: [_],
        relevance: 0
      },
      // needed because we do not have look-behind on the below rule
      // to prevent it from grabbing the final : in a :: pair
      {
        begin: /::/,
        relevance: 0
      },
      // initializers
      {
        begin: /:/,
        endsWithParent: !0,
        contains: [
          c,
          d
        ]
      },
      // allow for multiple declarations, e.g.:
      // extern void f(int), g(char);
      {
        relevance: 0,
        match: /,/
      },
      {
        className: "params",
        begin: /\(/,
        end: /\)/,
        keywords: C,
        relevance: 0,
        contains: [
          n,
          t.C_BLOCK_COMMENT_MODE,
          c,
          d,
          o,
          // Count matching parentheses.
          {
            begin: /\(/,
            end: /\)/,
            keywords: C,
            relevance: 0,
            contains: [
              "self",
              n,
              t.C_BLOCK_COMMENT_MODE,
              c,
              d,
              o
            ]
          }
        ]
      },
      o,
      n,
      t.C_BLOCK_COMMENT_MODE,
      u
    ]
  };
  return {
    name: "C++",
    aliases: [
      "cc",
      "c++",
      "h++",
      "hpp",
      "hh",
      "hxx",
      "cxx"
    ],
    keywords: C,
    illegal: "</",
    classNameAliases: { "function.dispatch": "built_in" },
    contains: [].concat(
      A,
      I,
      y,
      O,
      [
        u,
        {
          // containers: ie, `vector <int> rooms (9);`
          begin: "\\b(deque|list|queue|priority_queue|pair|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array|tuple|optional|variant|function|flat_map|flat_set)\\s*<(?!<)",
          end: ">",
          keywords: C,
          contains: [
            "self",
            o
          ]
        },
        {
          begin: t.IDENT_RE + "::",
          keywords: C
        },
        {
          match: [
            // extra complexity to deal with `enum class` and `enum struct`
            /\b(?:enum(?:\s+(?:class|struct))?|class|struct|union)/,
            /\s+/,
            /\w+/
          ],
          className: {
            1: "keyword",
            3: "title.class"
          }
        }
      ]
    )
  };
}
function PS(t) {
  const e = [
    "bool",
    "byte",
    "char",
    "decimal",
    "delegate",
    "double",
    "dynamic",
    "enum",
    "float",
    "int",
    "long",
    "nint",
    "nuint",
    "object",
    "sbyte",
    "short",
    "string",
    "ulong",
    "uint",
    "ushort"
  ], n = [
    "public",
    "private",
    "protected",
    "static",
    "internal",
    "protected",
    "abstract",
    "async",
    "extern",
    "override",
    "unsafe",
    "virtual",
    "new",
    "sealed",
    "partial"
  ], i = [
    "default",
    "false",
    "null",
    "true"
  ], r = [
    "abstract",
    "as",
    "base",
    "break",
    "case",
    "catch",
    "class",
    "const",
    "continue",
    "do",
    "else",
    "event",
    "explicit",
    "extern",
    "finally",
    "fixed",
    "for",
    "foreach",
    "goto",
    "if",
    "implicit",
    "in",
    "interface",
    "internal",
    "is",
    "lock",
    "namespace",
    "new",
    "operator",
    "out",
    "override",
    "params",
    "private",
    "protected",
    "public",
    "readonly",
    "record",
    "ref",
    "return",
    "scoped",
    "sealed",
    "sizeof",
    "stackalloc",
    "static",
    "struct",
    "switch",
    "this",
    "throw",
    "try",
    "typeof",
    "unchecked",
    "unsafe",
    "using",
    "virtual",
    "void",
    "volatile",
    "while"
  ], a = [
    "add",
    "alias",
    "and",
    "ascending",
    "args",
    "async",
    "await",
    "by",
    "descending",
    "dynamic",
    "equals",
    "file",
    "from",
    "get",
    "global",
    "group",
    "init",
    "into",
    "join",
    "let",
    "nameof",
    "not",
    "notnull",
    "on",
    "or",
    "orderby",
    "partial",
    "record",
    "remove",
    "required",
    "scoped",
    "select",
    "set",
    "unmanaged",
    "value|0",
    "var",
    "when",
    "where",
    "with",
    "yield"
  ], s = {
    keyword: r.concat(a),
    built_in: e,
    literal: i
  }, o = t.inherit(t.TITLE_MODE, { begin: "[a-zA-Z](\\.?\\w)*" }), l = {
    className: "number",
    variants: [
      { begin: "\\b(0b[01']+)" },
      { begin: "(-?)\\b([\\d']+(\\.[\\d']*)?|\\.[\\d']+)(u|U|l|L|ul|UL|f|F|b|B)" },
      { begin: "(-?)(\\b0[xX][a-fA-F0-9']+|(\\b[\\d']+(\\.[\\d']*)?|\\.[\\d']+)([eE][-+]?[\\d']+)?)" }
    ],
    relevance: 0
  }, c = {
    className: "string",
    begin: /"""("*)(?!")(.|\n)*?"""\1/,
    relevance: 1
  }, d = {
    className: "string",
    begin: '@"',
    end: '"',
    contains: [{ begin: '""' }]
  }, u = t.inherit(d, { illegal: /\n/ }), _ = {
    className: "subst",
    begin: /\{/,
    end: /\}/,
    keywords: s
  }, m = t.inherit(_, { illegal: /\n/ }), g = {
    className: "string",
    begin: /\$"/,
    end: '"',
    illegal: /\n/,
    contains: [
      { begin: /\{\{/ },
      { begin: /\}\}/ },
      t.BACKSLASH_ESCAPE,
      m
    ]
  }, S = {
    className: "string",
    begin: /\$@"/,
    end: '"',
    contains: [
      { begin: /\{\{/ },
      { begin: /\}\}/ },
      { begin: '""' },
      _
    ]
  }, E = t.inherit(S, {
    illegal: /\n/,
    contains: [
      { begin: /\{\{/ },
      { begin: /\}\}/ },
      { begin: '""' },
      m
    ]
  });
  _.contains = [
    S,
    g,
    d,
    t.APOS_STRING_MODE,
    t.QUOTE_STRING_MODE,
    l,
    t.C_BLOCK_COMMENT_MODE
  ], m.contains = [
    E,
    g,
    u,
    t.APOS_STRING_MODE,
    t.QUOTE_STRING_MODE,
    l,
    t.inherit(t.C_BLOCK_COMMENT_MODE, { illegal: /\n/ })
  ];
  const h = { variants: [
    c,
    S,
    g,
    d,
    t.APOS_STRING_MODE,
    t.QUOTE_STRING_MODE
  ] }, T = {
    begin: "<",
    end: ">",
    contains: [
      { beginKeywords: "in out" },
      o
    ]
  }, b = t.IDENT_RE + "(<" + t.IDENT_RE + "(\\s*,\\s*" + t.IDENT_RE + ")*>)?(\\[\\])?", C = {
    // prevents expressions like `@class` from incorrect flagging
    // `class` as a keyword
    begin: "@" + t.IDENT_RE,
    relevance: 0
  };
  return {
    name: "C#",
    aliases: [
      "cs",
      "c#"
    ],
    keywords: s,
    illegal: /::/,
    contains: [
      t.COMMENT(
        "///",
        "$",
        {
          returnBegin: !0,
          contains: [
            {
              className: "doctag",
              variants: [
                {
                  begin: "///",
                  relevance: 0
                },
                { begin: "<!--|-->" },
                {
                  begin: "</?",
                  end: ">"
                }
              ]
            }
          ]
        }
      ),
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      {
        className: "meta",
        begin: "#",
        end: "$",
        keywords: { keyword: "if else elif endif define undef warning error line region endregion pragma checksum" }
      },
      h,
      l,
      {
        beginKeywords: "class interface",
        relevance: 0,
        end: /[{;=]/,
        illegal: /[^\s:,]/,
        contains: [
          { beginKeywords: "where class" },
          o,
          T,
          t.C_LINE_COMMENT_MODE,
          t.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        beginKeywords: "namespace",
        relevance: 0,
        end: /[{;=]/,
        illegal: /[^\s:]/,
        contains: [
          o,
          t.C_LINE_COMMENT_MODE,
          t.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        beginKeywords: "record",
        relevance: 0,
        end: /[{;=]/,
        illegal: /[^\s:]/,
        contains: [
          o,
          T,
          t.C_LINE_COMMENT_MODE,
          t.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        // [Attributes("")]
        className: "meta",
        begin: "^\\s*\\[(?=[\\w])",
        excludeBegin: !0,
        end: "\\]",
        excludeEnd: !0,
        contains: [
          {
            className: "string",
            begin: /"/,
            end: /"/
          }
        ]
      },
      {
        // Expression keywords prevent 'keyword Name(...)' from being
        // recognized as a function definition
        beginKeywords: "new return throw await else",
        relevance: 0
      },
      {
        className: "function",
        begin: "(" + b + "\\s+)+" + t.IDENT_RE + "\\s*(<[^=]+>\\s*)?\\(",
        returnBegin: !0,
        end: /\s*[{;=]/,
        excludeEnd: !0,
        keywords: s,
        contains: [
          // prevents these from being highlighted `title`
          {
            beginKeywords: n.join(" "),
            relevance: 0
          },
          {
            begin: t.IDENT_RE + "\\s*(<[^=]+>\\s*)?\\(",
            returnBegin: !0,
            contains: [
              t.TITLE_MODE,
              T
            ],
            relevance: 0
          },
          { match: /\(\)/ },
          {
            className: "params",
            begin: /\(/,
            end: /\)/,
            excludeBegin: !0,
            excludeEnd: !0,
            keywords: s,
            relevance: 0,
            contains: [
              h,
              l,
              t.C_BLOCK_COMMENT_MODE
            ]
          },
          t.C_LINE_COMMENT_MODE,
          t.C_BLOCK_COMMENT_MODE
        ]
      },
      C
    ]
  };
}
const kS = (t) => ({
  IMPORTANT: {
    scope: "meta",
    begin: "!important"
  },
  BLOCK_COMMENT: t.C_BLOCK_COMMENT_MODE,
  HEXCOLOR: {
    scope: "number",
    begin: /#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\b/
  },
  FUNCTION_DISPATCH: {
    className: "built_in",
    begin: /[\w-]+(?=\()/
  },
  ATTRIBUTE_SELECTOR_MODE: {
    scope: "selector-attr",
    begin: /\[/,
    end: /\]/,
    illegal: "$",
    contains: [
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE
    ]
  },
  CSS_NUMBER_MODE: {
    scope: "number",
    begin: t.NUMBER_RE + "(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",
    relevance: 0
  },
  CSS_VARIABLE: {
    className: "attr",
    begin: /--[A-Za-z_][A-Za-z0-9_-]*/
  }
}), US = [
  "a",
  "abbr",
  "address",
  "article",
  "aside",
  "audio",
  "b",
  "blockquote",
  "body",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "dd",
  "del",
  "details",
  "dfn",
  "div",
  "dl",
  "dt",
  "em",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "header",
  "hgroup",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "label",
  "legend",
  "li",
  "main",
  "mark",
  "menu",
  "nav",
  "object",
  "ol",
  "optgroup",
  "option",
  "p",
  "picture",
  "q",
  "quote",
  "samp",
  "section",
  "select",
  "source",
  "span",
  "strong",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "tr",
  "ul",
  "var",
  "video"
], FS = [
  "defs",
  "g",
  "marker",
  "mask",
  "pattern",
  "svg",
  "switch",
  "symbol",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feFlood",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMorphology",
  "feOffset",
  "feSpecularLighting",
  "feTile",
  "feTurbulence",
  "linearGradient",
  "radialGradient",
  "stop",
  "circle",
  "ellipse",
  "image",
  "line",
  "path",
  "polygon",
  "polyline",
  "rect",
  "text",
  "use",
  "textPath",
  "tspan",
  "foreignObject",
  "clipPath"
], BS = [
  ...US,
  ...FS
], GS = [
  "any-hover",
  "any-pointer",
  "aspect-ratio",
  "color",
  "color-gamut",
  "color-index",
  "device-aspect-ratio",
  "device-height",
  "device-width",
  "display-mode",
  "forced-colors",
  "grid",
  "height",
  "hover",
  "inverted-colors",
  "monochrome",
  "orientation",
  "overflow-block",
  "overflow-inline",
  "pointer",
  "prefers-color-scheme",
  "prefers-contrast",
  "prefers-reduced-motion",
  "prefers-reduced-transparency",
  "resolution",
  "scan",
  "scripting",
  "update",
  "width",
  // TODO: find a better solution?
  "min-width",
  "max-width",
  "min-height",
  "max-height"
].sort().reverse(), YS = [
  "active",
  "any-link",
  "blank",
  "checked",
  "current",
  "default",
  "defined",
  "dir",
  // dir()
  "disabled",
  "drop",
  "empty",
  "enabled",
  "first",
  "first-child",
  "first-of-type",
  "fullscreen",
  "future",
  "focus",
  "focus-visible",
  "focus-within",
  "has",
  // has()
  "host",
  // host or host()
  "host-context",
  // host-context()
  "hover",
  "indeterminate",
  "in-range",
  "invalid",
  "is",
  // is()
  "lang",
  // lang()
  "last-child",
  "last-of-type",
  "left",
  "link",
  "local-link",
  "not",
  // not()
  "nth-child",
  // nth-child()
  "nth-col",
  // nth-col()
  "nth-last-child",
  // nth-last-child()
  "nth-last-col",
  // nth-last-col()
  "nth-last-of-type",
  //nth-last-of-type()
  "nth-of-type",
  //nth-of-type()
  "only-child",
  "only-of-type",
  "optional",
  "out-of-range",
  "past",
  "placeholder-shown",
  "read-only",
  "read-write",
  "required",
  "right",
  "root",
  "scope",
  "target",
  "target-within",
  "user-invalid",
  "valid",
  "visited",
  "where"
  // where()
].sort().reverse(), $S = [
  "after",
  "backdrop",
  "before",
  "cue",
  "cue-region",
  "first-letter",
  "first-line",
  "grammar-error",
  "marker",
  "part",
  "placeholder",
  "selection",
  "slotted",
  "spelling-error"
].sort().reverse(), VS = [
  "accent-color",
  "align-content",
  "align-items",
  "align-self",
  "alignment-baseline",
  "all",
  "anchor-name",
  "animation",
  "animation-composition",
  "animation-delay",
  "animation-direction",
  "animation-duration",
  "animation-fill-mode",
  "animation-iteration-count",
  "animation-name",
  "animation-play-state",
  "animation-range",
  "animation-range-end",
  "animation-range-start",
  "animation-timeline",
  "animation-timing-function",
  "appearance",
  "aspect-ratio",
  "backdrop-filter",
  "backface-visibility",
  "background",
  "background-attachment",
  "background-blend-mode",
  "background-clip",
  "background-color",
  "background-image",
  "background-origin",
  "background-position",
  "background-position-x",
  "background-position-y",
  "background-repeat",
  "background-size",
  "baseline-shift",
  "block-size",
  "border",
  "border-block",
  "border-block-color",
  "border-block-end",
  "border-block-end-color",
  "border-block-end-style",
  "border-block-end-width",
  "border-block-start",
  "border-block-start-color",
  "border-block-start-style",
  "border-block-start-width",
  "border-block-style",
  "border-block-width",
  "border-bottom",
  "border-bottom-color",
  "border-bottom-left-radius",
  "border-bottom-right-radius",
  "border-bottom-style",
  "border-bottom-width",
  "border-collapse",
  "border-color",
  "border-end-end-radius",
  "border-end-start-radius",
  "border-image",
  "border-image-outset",
  "border-image-repeat",
  "border-image-slice",
  "border-image-source",
  "border-image-width",
  "border-inline",
  "border-inline-color",
  "border-inline-end",
  "border-inline-end-color",
  "border-inline-end-style",
  "border-inline-end-width",
  "border-inline-start",
  "border-inline-start-color",
  "border-inline-start-style",
  "border-inline-start-width",
  "border-inline-style",
  "border-inline-width",
  "border-left",
  "border-left-color",
  "border-left-style",
  "border-left-width",
  "border-radius",
  "border-right",
  "border-right-color",
  "border-right-style",
  "border-right-width",
  "border-spacing",
  "border-start-end-radius",
  "border-start-start-radius",
  "border-style",
  "border-top",
  "border-top-color",
  "border-top-left-radius",
  "border-top-right-radius",
  "border-top-style",
  "border-top-width",
  "border-width",
  "bottom",
  "box-align",
  "box-decoration-break",
  "box-direction",
  "box-flex",
  "box-flex-group",
  "box-lines",
  "box-ordinal-group",
  "box-orient",
  "box-pack",
  "box-shadow",
  "box-sizing",
  "break-after",
  "break-before",
  "break-inside",
  "caption-side",
  "caret-color",
  "clear",
  "clip",
  "clip-path",
  "clip-rule",
  "color",
  "color-interpolation",
  "color-interpolation-filters",
  "color-profile",
  "color-rendering",
  "color-scheme",
  "column-count",
  "column-fill",
  "column-gap",
  "column-rule",
  "column-rule-color",
  "column-rule-style",
  "column-rule-width",
  "column-span",
  "column-width",
  "columns",
  "contain",
  "contain-intrinsic-block-size",
  "contain-intrinsic-height",
  "contain-intrinsic-inline-size",
  "contain-intrinsic-size",
  "contain-intrinsic-width",
  "container",
  "container-name",
  "container-type",
  "content",
  "content-visibility",
  "counter-increment",
  "counter-reset",
  "counter-set",
  "cue",
  "cue-after",
  "cue-before",
  "cursor",
  "cx",
  "cy",
  "direction",
  "display",
  "dominant-baseline",
  "empty-cells",
  "enable-background",
  "field-sizing",
  "fill",
  "fill-opacity",
  "fill-rule",
  "filter",
  "flex",
  "flex-basis",
  "flex-direction",
  "flex-flow",
  "flex-grow",
  "flex-shrink",
  "flex-wrap",
  "float",
  "flood-color",
  "flood-opacity",
  "flow",
  "font",
  "font-display",
  "font-family",
  "font-feature-settings",
  "font-kerning",
  "font-language-override",
  "font-optical-sizing",
  "font-palette",
  "font-size",
  "font-size-adjust",
  "font-smooth",
  "font-smoothing",
  "font-stretch",
  "font-style",
  "font-synthesis",
  "font-synthesis-position",
  "font-synthesis-small-caps",
  "font-synthesis-style",
  "font-synthesis-weight",
  "font-variant",
  "font-variant-alternates",
  "font-variant-caps",
  "font-variant-east-asian",
  "font-variant-emoji",
  "font-variant-ligatures",
  "font-variant-numeric",
  "font-variant-position",
  "font-variation-settings",
  "font-weight",
  "forced-color-adjust",
  "gap",
  "glyph-orientation-horizontal",
  "glyph-orientation-vertical",
  "grid",
  "grid-area",
  "grid-auto-columns",
  "grid-auto-flow",
  "grid-auto-rows",
  "grid-column",
  "grid-column-end",
  "grid-column-start",
  "grid-gap",
  "grid-row",
  "grid-row-end",
  "grid-row-start",
  "grid-template",
  "grid-template-areas",
  "grid-template-columns",
  "grid-template-rows",
  "hanging-punctuation",
  "height",
  "hyphenate-character",
  "hyphenate-limit-chars",
  "hyphens",
  "icon",
  "image-orientation",
  "image-rendering",
  "image-resolution",
  "ime-mode",
  "initial-letter",
  "initial-letter-align",
  "inline-size",
  "inset",
  "inset-area",
  "inset-block",
  "inset-block-end",
  "inset-block-start",
  "inset-inline",
  "inset-inline-end",
  "inset-inline-start",
  "isolation",
  "justify-content",
  "justify-items",
  "justify-self",
  "kerning",
  "left",
  "letter-spacing",
  "lighting-color",
  "line-break",
  "line-height",
  "line-height-step",
  "list-style",
  "list-style-image",
  "list-style-position",
  "list-style-type",
  "margin",
  "margin-block",
  "margin-block-end",
  "margin-block-start",
  "margin-bottom",
  "margin-inline",
  "margin-inline-end",
  "margin-inline-start",
  "margin-left",
  "margin-right",
  "margin-top",
  "margin-trim",
  "marker",
  "marker-end",
  "marker-mid",
  "marker-start",
  "marks",
  "mask",
  "mask-border",
  "mask-border-mode",
  "mask-border-outset",
  "mask-border-repeat",
  "mask-border-slice",
  "mask-border-source",
  "mask-border-width",
  "mask-clip",
  "mask-composite",
  "mask-image",
  "mask-mode",
  "mask-origin",
  "mask-position",
  "mask-repeat",
  "mask-size",
  "mask-type",
  "masonry-auto-flow",
  "math-depth",
  "math-shift",
  "math-style",
  "max-block-size",
  "max-height",
  "max-inline-size",
  "max-width",
  "min-block-size",
  "min-height",
  "min-inline-size",
  "min-width",
  "mix-blend-mode",
  "nav-down",
  "nav-index",
  "nav-left",
  "nav-right",
  "nav-up",
  "none",
  "normal",
  "object-fit",
  "object-position",
  "offset",
  "offset-anchor",
  "offset-distance",
  "offset-path",
  "offset-position",
  "offset-rotate",
  "opacity",
  "order",
  "orphans",
  "outline",
  "outline-color",
  "outline-offset",
  "outline-style",
  "outline-width",
  "overflow",
  "overflow-anchor",
  "overflow-block",
  "overflow-clip-margin",
  "overflow-inline",
  "overflow-wrap",
  "overflow-x",
  "overflow-y",
  "overlay",
  "overscroll-behavior",
  "overscroll-behavior-block",
  "overscroll-behavior-inline",
  "overscroll-behavior-x",
  "overscroll-behavior-y",
  "padding",
  "padding-block",
  "padding-block-end",
  "padding-block-start",
  "padding-bottom",
  "padding-inline",
  "padding-inline-end",
  "padding-inline-start",
  "padding-left",
  "padding-right",
  "padding-top",
  "page",
  "page-break-after",
  "page-break-before",
  "page-break-inside",
  "paint-order",
  "pause",
  "pause-after",
  "pause-before",
  "perspective",
  "perspective-origin",
  "place-content",
  "place-items",
  "place-self",
  "pointer-events",
  "position",
  "position-anchor",
  "position-visibility",
  "print-color-adjust",
  "quotes",
  "r",
  "resize",
  "rest",
  "rest-after",
  "rest-before",
  "right",
  "rotate",
  "row-gap",
  "ruby-align",
  "ruby-position",
  "scale",
  "scroll-behavior",
  "scroll-margin",
  "scroll-margin-block",
  "scroll-margin-block-end",
  "scroll-margin-block-start",
  "scroll-margin-bottom",
  "scroll-margin-inline",
  "scroll-margin-inline-end",
  "scroll-margin-inline-start",
  "scroll-margin-left",
  "scroll-margin-right",
  "scroll-margin-top",
  "scroll-padding",
  "scroll-padding-block",
  "scroll-padding-block-end",
  "scroll-padding-block-start",
  "scroll-padding-bottom",
  "scroll-padding-inline",
  "scroll-padding-inline-end",
  "scroll-padding-inline-start",
  "scroll-padding-left",
  "scroll-padding-right",
  "scroll-padding-top",
  "scroll-snap-align",
  "scroll-snap-stop",
  "scroll-snap-type",
  "scroll-timeline",
  "scroll-timeline-axis",
  "scroll-timeline-name",
  "scrollbar-color",
  "scrollbar-gutter",
  "scrollbar-width",
  "shape-image-threshold",
  "shape-margin",
  "shape-outside",
  "shape-rendering",
  "speak",
  "speak-as",
  "src",
  // @font-face
  "stop-color",
  "stop-opacity",
  "stroke",
  "stroke-dasharray",
  "stroke-dashoffset",
  "stroke-linecap",
  "stroke-linejoin",
  "stroke-miterlimit",
  "stroke-opacity",
  "stroke-width",
  "tab-size",
  "table-layout",
  "text-align",
  "text-align-all",
  "text-align-last",
  "text-anchor",
  "text-combine-upright",
  "text-decoration",
  "text-decoration-color",
  "text-decoration-line",
  "text-decoration-skip",
  "text-decoration-skip-ink",
  "text-decoration-style",
  "text-decoration-thickness",
  "text-emphasis",
  "text-emphasis-color",
  "text-emphasis-position",
  "text-emphasis-style",
  "text-indent",
  "text-justify",
  "text-orientation",
  "text-overflow",
  "text-rendering",
  "text-shadow",
  "text-size-adjust",
  "text-transform",
  "text-underline-offset",
  "text-underline-position",
  "text-wrap",
  "text-wrap-mode",
  "text-wrap-style",
  "timeline-scope",
  "top",
  "touch-action",
  "transform",
  "transform-box",
  "transform-origin",
  "transform-style",
  "transition",
  "transition-behavior",
  "transition-delay",
  "transition-duration",
  "transition-property",
  "transition-timing-function",
  "translate",
  "unicode-bidi",
  "user-modify",
  "user-select",
  "vector-effect",
  "vertical-align",
  "view-timeline",
  "view-timeline-axis",
  "view-timeline-inset",
  "view-timeline-name",
  "view-transition-name",
  "visibility",
  "voice-balance",
  "voice-duration",
  "voice-family",
  "voice-pitch",
  "voice-range",
  "voice-rate",
  "voice-stress",
  "voice-volume",
  "white-space",
  "white-space-collapse",
  "widows",
  "width",
  "will-change",
  "word-break",
  "word-spacing",
  "word-wrap",
  "writing-mode",
  "x",
  "y",
  "z-index",
  "zoom"
].sort().reverse();
function HS(t) {
  const e = t.regex, n = kS(t), i = { begin: /-(webkit|moz|ms|o)-(?=[a-z])/ }, r = "and or not only", a = /@-?\w[\w]*(-\w+)*/, s = "[a-zA-Z-][a-zA-Z0-9_-]*", o = [
    t.APOS_STRING_MODE,
    t.QUOTE_STRING_MODE
  ];
  return {
    name: "CSS",
    case_insensitive: !0,
    illegal: /[=|'\$]/,
    keywords: { keyframePosition: "from to" },
    classNameAliases: {
      // for visual continuity with `tag {}` and because we
      // don't have a great class for this?
      keyframePosition: "selector-tag"
    },
    contains: [
      n.BLOCK_COMMENT,
      i,
      // to recognize keyframe 40% etc which are outside the scope of our
      // attribute value mode
      n.CSS_NUMBER_MODE,
      {
        className: "selector-id",
        begin: /#[A-Za-z0-9_-]+/,
        relevance: 0
      },
      {
        className: "selector-class",
        begin: "\\." + s,
        relevance: 0
      },
      n.ATTRIBUTE_SELECTOR_MODE,
      {
        className: "selector-pseudo",
        variants: [
          { begin: ":(" + YS.join("|") + ")" },
          { begin: ":(:)?(" + $S.join("|") + ")" }
        ]
      },
      // we may actually need this (12/2020)
      // { // pseudo-selector params
      //   begin: /\(/,
      //   end: /\)/,
      //   contains: [ hljs.CSS_NUMBER_MODE ]
      // },
      n.CSS_VARIABLE,
      {
        className: "attribute",
        begin: "\\b(" + VS.join("|") + ")\\b"
      },
      // attribute values
      {
        begin: /:/,
        end: /[;}{]/,
        contains: [
          n.BLOCK_COMMENT,
          n.HEXCOLOR,
          n.IMPORTANT,
          n.CSS_NUMBER_MODE,
          ...o,
          // needed to highlight these as strings and to avoid issues with
          // illegal characters that might be inside urls that would tigger the
          // languages illegal stack
          {
            begin: /(url|data-uri)\(/,
            end: /\)/,
            relevance: 0,
            // from keywords
            keywords: { built_in: "url data-uri" },
            contains: [
              ...o,
              {
                className: "string",
                // any character other than `)` as in `url()` will be the start
                // of a string, which ends with `)` (from the parent mode)
                begin: /[^)]/,
                endsWithParent: !0,
                excludeEnd: !0
              }
            ]
          },
          n.FUNCTION_DISPATCH
        ]
      },
      {
        begin: e.lookahead(/@/),
        end: "[{;]",
        relevance: 0,
        illegal: /:/,
        // break on Less variables @var: ...
        contains: [
          {
            className: "keyword",
            begin: a
          },
          {
            begin: /\s/,
            endsWithParent: !0,
            excludeEnd: !0,
            relevance: 0,
            keywords: {
              $pattern: /[a-z-]+/,
              keyword: r,
              attribute: GS.join(" ")
            },
            contains: [
              {
                begin: /[a-z-]+(?=:)/,
                className: "attribute"
              },
              ...o,
              n.CSS_NUMBER_MODE
            ]
          }
        ]
      },
      {
        className: "selector-tag",
        begin: "\\b(" + BS.join("|") + ")\\b"
      }
    ]
  };
}
function qS(t) {
  const e = t.regex;
  return {
    name: "Diff",
    aliases: ["patch"],
    contains: [
      {
        className: "meta",
        relevance: 10,
        match: e.either(
          /^@@ +-\d+,\d+ +\+\d+,\d+ +@@/,
          /^\*\*\* +\d+,\d+ +\*\*\*\*$/,
          /^--- +\d+,\d+ +----$/
        )
      },
      {
        className: "comment",
        variants: [
          {
            begin: e.either(
              /Index: /,
              /^index/,
              /={3,}/,
              /^-{3}/,
              /^\*{3} /,
              /^\+{3}/,
              /^diff --git/
            ),
            end: /$/
          },
          { match: /^\*{15}$/ }
        ]
      },
      {
        className: "addition",
        begin: /^\+/,
        end: /$/
      },
      {
        className: "deletion",
        begin: /^-/,
        end: /$/
      },
      {
        className: "addition",
        begin: /^!/,
        end: /$/
      }
    ]
  };
}
function zS(t) {
  const a = {
    keyword: [
      "break",
      "case",
      "chan",
      "const",
      "continue",
      "default",
      "defer",
      "else",
      "fallthrough",
      "for",
      "func",
      "go",
      "goto",
      "if",
      "import",
      "interface",
      "map",
      "package",
      "range",
      "return",
      "select",
      "struct",
      "switch",
      "type",
      "var"
    ],
    type: [
      "bool",
      "byte",
      "complex64",
      "complex128",
      "error",
      "float32",
      "float64",
      "int8",
      "int16",
      "int32",
      "int64",
      "string",
      "uint8",
      "uint16",
      "uint32",
      "uint64",
      "int",
      "uint",
      "uintptr",
      "rune"
    ],
    literal: [
      "true",
      "false",
      "iota",
      "nil"
    ],
    built_in: [
      "append",
      "cap",
      "close",
      "complex",
      "copy",
      "imag",
      "len",
      "make",
      "new",
      "panic",
      "print",
      "println",
      "real",
      "recover",
      "delete"
    ]
  };
  return {
    name: "Go",
    aliases: ["golang"],
    keywords: a,
    illegal: "</",
    contains: [
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      {
        className: "string",
        variants: [
          t.QUOTE_STRING_MODE,
          t.APOS_STRING_MODE,
          {
            begin: "`",
            end: "`"
          }
        ]
      },
      {
        className: "number",
        variants: [
          {
            match: /-?\b0[xX]\.[a-fA-F0-9](_?[a-fA-F0-9])*[pP][+-]?\d(_?\d)*i?/,
            // hex without a present digit before . (making a digit afterwards required)
            relevance: 0
          },
          {
            match: /-?\b0[xX](_?[a-fA-F0-9])+((\.([a-fA-F0-9](_?[a-fA-F0-9])*)?)?[pP][+-]?\d(_?\d)*)?i?/,
            // hex with a present digit before . (making a digit afterwards optional)
            relevance: 0
          },
          {
            match: /-?\b0[oO](_?[0-7])*i?/,
            // leading 0o octal
            relevance: 0
          },
          {
            match: /-?\.\d(_?\d)*([eE][+-]?\d(_?\d)*)?i?/,
            // decimal without a present digit before . (making a digit afterwards required)
            relevance: 0
          },
          {
            match: /-?\b\d(_?\d)*(\.(\d(_?\d)*)?)?([eE][+-]?\d(_?\d)*)?i?/,
            // decimal with a present digit before . (making a digit afterwards optional)
            relevance: 0
          }
        ]
      },
      {
        begin: /:=/
        // relevance booster
      },
      {
        className: "function",
        beginKeywords: "func",
        end: "\\s*(\\{|$)",
        excludeEnd: !0,
        contains: [
          t.TITLE_MODE,
          {
            className: "params",
            begin: /\(/,
            end: /\)/,
            endsParent: !0,
            keywords: a,
            illegal: /["']/
          }
        ]
      }
    ]
  };
}
function WS(t) {
  const e = t.regex, n = /[_A-Za-z][_0-9A-Za-z]*/;
  return {
    name: "GraphQL",
    aliases: ["gql"],
    case_insensitive: !0,
    disableAutodetect: !1,
    keywords: {
      keyword: [
        "query",
        "mutation",
        "subscription",
        "type",
        "input",
        "schema",
        "directive",
        "interface",
        "union",
        "scalar",
        "fragment",
        "enum",
        "on"
      ],
      literal: [
        "true",
        "false",
        "null"
      ]
    },
    contains: [
      t.HASH_COMMENT_MODE,
      t.QUOTE_STRING_MODE,
      t.NUMBER_MODE,
      {
        scope: "punctuation",
        match: /[.]{3}/,
        relevance: 0
      },
      {
        scope: "punctuation",
        begin: /[\!\(\)\:\=\[\]\{\|\}]{1}/,
        relevance: 0
      },
      {
        scope: "variable",
        begin: /\$/,
        end: /\W/,
        excludeEnd: !0,
        relevance: 0
      },
      {
        scope: "meta",
        match: /@\w+/,
        excludeEnd: !0
      },
      {
        scope: "symbol",
        begin: e.concat(n, e.lookahead(/\s*:/)),
        relevance: 0
      }
    ],
    illegal: [
      /[;<']/,
      /BEGIN/
    ]
  };
}
function KS(t) {
  const e = t.regex, n = {
    className: "number",
    relevance: 0,
    variants: [
      { begin: /([+-]+)?[\d]+_[\d_]+/ },
      { begin: t.NUMBER_RE }
    ]
  }, i = t.COMMENT();
  i.variants = [
    {
      begin: /;/,
      end: /$/
    },
    {
      begin: /#/,
      end: /$/
    }
  ];
  const r = {
    className: "variable",
    variants: [
      { begin: /\$[\w\d"][\w\d_]*/ },
      { begin: /\$\{(.*?)\}/ }
    ]
  }, a = {
    className: "literal",
    begin: /\bon|off|true|false|yes|no\b/
  }, s = {
    className: "string",
    contains: [t.BACKSLASH_ESCAPE],
    variants: [
      {
        begin: "'''",
        end: "'''",
        relevance: 10
      },
      {
        begin: '"""',
        end: '"""',
        relevance: 10
      },
      {
        begin: '"',
        end: '"'
      },
      {
        begin: "'",
        end: "'"
      }
    ]
  }, o = {
    begin: /\[/,
    end: /\]/,
    contains: [
      i,
      a,
      r,
      s,
      n,
      "self"
    ],
    relevance: 0
  }, l = /[A-Za-z0-9_-]+/, c = /"(\\"|[^"])*"/, d = /'[^']*'/, u = e.either(
    l,
    c,
    d
  ), _ = e.concat(
    u,
    "(\\s*\\.\\s*",
    u,
    ")*",
    e.lookahead(/\s*=\s*[^#\s]/)
  );
  return {
    name: "TOML, also INI",
    aliases: ["toml"],
    case_insensitive: !0,
    illegal: /\S/,
    contains: [
      i,
      {
        className: "section",
        begin: /\[+/,
        end: /\]+/
      },
      {
        begin: _,
        className: "attr",
        starts: {
          end: /$/,
          contains: [
            i,
            o,
            a,
            r,
            s,
            n
          ]
        }
      }
    ]
  };
}
var ci = "[0-9](_*[0-9])*", vr = `\\.(${ci})`, Ar = "[0-9a-fA-F](_*[0-9a-fA-F])*", ol = {
  className: "number",
  variants: [
    // DecimalFloatingPointLiteral
    // including ExponentPart
    { begin: `(\\b(${ci})((${vr})|\\.)?|(${vr}))[eE][+-]?(${ci})[fFdD]?\\b` },
    // excluding ExponentPart
    { begin: `\\b(${ci})((${vr})[fFdD]?\\b|\\.([fFdD]\\b)?)` },
    { begin: `(${vr})[fFdD]?\\b` },
    { begin: `\\b(${ci})[fFdD]\\b` },
    // HexadecimalFloatingPointLiteral
    { begin: `\\b0[xX]((${Ar})\\.?|(${Ar})?\\.(${Ar}))[pP][+-]?(${ci})[fFdD]?\\b` },
    // DecimalIntegerLiteral
    { begin: "\\b(0|[1-9](_*[0-9])*)[lL]?\\b" },
    // HexIntegerLiteral
    { begin: `\\b0[xX](${Ar})[lL]?\\b` },
    // OctalIntegerLiteral
    { begin: "\\b0(_*[0-7])*[lL]?\\b" },
    // BinaryIntegerLiteral
    { begin: "\\b0[bB][01](_*[01])*[lL]?\\b" }
  ],
  relevance: 0
};
function Oc(t, e, n) {
  return n === -1 ? "" : t.replace(e, (i) => Oc(t, e, n - 1));
}
function QS(t) {
  const e = t.regex, n = "[À-ʸa-zA-Z_$][À-ʸa-zA-Z_$0-9]*", i = n + Oc("(?:<" + n + "~~~(?:\\s*,\\s*" + n + "~~~)*>)?", /~~~/g, 2), l = {
    keyword: [
      "synchronized",
      "abstract",
      "private",
      "var",
      "static",
      "if",
      "const ",
      "for",
      "while",
      "strictfp",
      "finally",
      "protected",
      "import",
      "native",
      "final",
      "void",
      "enum",
      "else",
      "break",
      "transient",
      "catch",
      "instanceof",
      "volatile",
      "case",
      "assert",
      "package",
      "default",
      "public",
      "try",
      "switch",
      "continue",
      "throws",
      "protected",
      "public",
      "private",
      "module",
      "requires",
      "exports",
      "do",
      "sealed",
      "yield",
      "permits",
      "goto",
      "when"
    ],
    literal: [
      "false",
      "true",
      "null"
    ],
    type: [
      "char",
      "boolean",
      "long",
      "float",
      "int",
      "byte",
      "short",
      "double"
    ],
    built_in: [
      "super",
      "this"
    ]
  }, c = {
    className: "meta",
    begin: "@" + n,
    contains: [
      {
        begin: /\(/,
        end: /\)/,
        contains: ["self"]
        // allow nested () inside our annotation
      }
    ]
  }, d = {
    className: "params",
    begin: /\(/,
    end: /\)/,
    keywords: l,
    relevance: 0,
    contains: [t.C_BLOCK_COMMENT_MODE],
    endsParent: !0
  };
  return {
    name: "Java",
    aliases: ["jsp"],
    keywords: l,
    illegal: /<\/|#/,
    contains: [
      t.COMMENT(
        "/\\*\\*",
        "\\*/",
        {
          relevance: 0,
          contains: [
            {
              // eat up @'s in emails to prevent them to be recognized as doctags
              begin: /\w+@/,
              relevance: 0
            },
            {
              className: "doctag",
              begin: "@[A-Za-z]+"
            }
          ]
        }
      ),
      // relevance boost
      {
        begin: /import java\.[a-z]+\./,
        keywords: "import",
        relevance: 2
      },
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      {
        begin: /"""/,
        end: /"""/,
        className: "string",
        contains: [t.BACKSLASH_ESCAPE]
      },
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE,
      {
        match: [
          /\b(?:class|interface|enum|extends|implements|new)/,
          /\s+/,
          n
        ],
        className: {
          1: "keyword",
          3: "title.class"
        }
      },
      {
        // Exceptions for hyphenated keywords
        match: /non-sealed/,
        scope: "keyword"
      },
      {
        begin: [
          e.concat(/(?!else)/, n),
          /\s+/,
          n,
          /\s+/,
          /=(?!=)/
        ],
        className: {
          1: "type",
          3: "variable",
          5: "operator"
        }
      },
      {
        begin: [
          /record/,
          /\s+/,
          n
        ],
        className: {
          1: "keyword",
          3: "title.class"
        },
        contains: [
          d,
          t.C_LINE_COMMENT_MODE,
          t.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        // Expression keywords prevent 'keyword Name(...)' from being
        // recognized as a function definition
        beginKeywords: "new throw return else",
        relevance: 0
      },
      {
        begin: [
          "(?:" + i + "\\s+)",
          t.UNDERSCORE_IDENT_RE,
          /\s*(?=\()/
        ],
        className: { 2: "title.function" },
        keywords: l,
        contains: [
          {
            className: "params",
            begin: /\(/,
            end: /\)/,
            keywords: l,
            relevance: 0,
            contains: [
              c,
              t.APOS_STRING_MODE,
              t.QUOTE_STRING_MODE,
              ol,
              t.C_BLOCK_COMMENT_MODE
            ]
          },
          t.C_LINE_COMMENT_MODE,
          t.C_BLOCK_COMMENT_MODE
        ]
      },
      ol,
      c
    ]
  };
}
const ll = "[A-Za-z$_][0-9A-Za-z$_]*", XS = [
  "as",
  // for exports
  "in",
  "of",
  "if",
  "for",
  "while",
  "finally",
  "var",
  "new",
  "function",
  "do",
  "return",
  "void",
  "else",
  "break",
  "catch",
  "instanceof",
  "with",
  "throw",
  "case",
  "default",
  "try",
  "switch",
  "continue",
  "typeof",
  "delete",
  "let",
  "yield",
  "const",
  "class",
  // JS handles these with a special rule
  // "get",
  // "set",
  "debugger",
  "async",
  "await",
  "static",
  "import",
  "from",
  "export",
  "extends",
  // It's reached stage 3, which is "recommended for implementation":
  "using"
], ZS = [
  "true",
  "false",
  "null",
  "undefined",
  "NaN",
  "Infinity"
], vc = [
  // Fundamental objects
  "Object",
  "Function",
  "Boolean",
  "Symbol",
  // numbers and dates
  "Math",
  "Date",
  "Number",
  "BigInt",
  // text
  "String",
  "RegExp",
  // Indexed collections
  "Array",
  "Float32Array",
  "Float64Array",
  "Int8Array",
  "Uint8Array",
  "Uint8ClampedArray",
  "Int16Array",
  "Int32Array",
  "Uint16Array",
  "Uint32Array",
  "BigInt64Array",
  "BigUint64Array",
  // Keyed collections
  "Set",
  "Map",
  "WeakSet",
  "WeakMap",
  // Structured data
  "ArrayBuffer",
  "SharedArrayBuffer",
  "Atomics",
  "DataView",
  "JSON",
  // Control abstraction objects
  "Promise",
  "Generator",
  "GeneratorFunction",
  "AsyncFunction",
  // Reflection
  "Reflect",
  "Proxy",
  // Internationalization
  "Intl",
  // WebAssembly
  "WebAssembly"
], Ac = [
  "Error",
  "EvalError",
  "InternalError",
  "RangeError",
  "ReferenceError",
  "SyntaxError",
  "TypeError",
  "URIError"
], Ic = [
  "setInterval",
  "setTimeout",
  "clearInterval",
  "clearTimeout",
  "require",
  "exports",
  "eval",
  "isFinite",
  "isNaN",
  "parseFloat",
  "parseInt",
  "decodeURI",
  "decodeURIComponent",
  "encodeURI",
  "encodeURIComponent",
  "escape",
  "unescape"
], JS = [
  "arguments",
  "this",
  "super",
  "console",
  "window",
  "document",
  "localStorage",
  "sessionStorage",
  "module",
  "global"
  // Node.js
], jS = [].concat(
  Ic,
  vc,
  Ac
);
function eh(t) {
  const e = t.regex, n = (V, { after: Z }) => {
    const fe = "</" + V[0].slice(1);
    return V.input.indexOf(fe, Z) !== -1;
  }, i = ll, r = {
    begin: "<>",
    end: "</>"
  }, a = /<[A-Za-z0-9\\._:-]+\s*\/>/, s = {
    begin: /<[A-Za-z0-9\\._:-]+/,
    end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
    /**
     * @param {RegExpMatchArray} match
     * @param {CallbackResponse} response
     */
    isTrulyOpeningTag: (V, Z) => {
      const fe = V[0].length + V.index, _e = V.input[fe];
      if (
        // HTML should not include another raw `<` inside a tag
        // nested type?
        // `<Array<Array<number>>`, etc.
        _e === "<" || // the , gives away that this is not HTML
        // `<T, A extends keyof T, V>`
        _e === ","
      ) {
        Z.ignoreMatch();
        return;
      }
      _e === ">" && (n(V, { after: fe }) || Z.ignoreMatch());
      let me;
      const Me = V.input.substring(fe);
      if (me = Me.match(/^\s*=/)) {
        Z.ignoreMatch();
        return;
      }
      if ((me = Me.match(/^\s+extends\s+/)) && me.index === 0) {
        Z.ignoreMatch();
        return;
      }
    }
  }, o = {
    $pattern: ll,
    keyword: XS,
    literal: ZS,
    built_in: jS,
    "variable.language": JS
  }, l = "[0-9](_?[0-9])*", c = `\\.(${l})`, d = "0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*", u = {
    className: "number",
    variants: [
      // DecimalLiteral
      { begin: `(\\b(${d})((${c})|\\.)?|(${c}))[eE][+-]?(${l})\\b` },
      { begin: `\\b(${d})\\b((${c})\\b|\\.)?|(${c})\\b` },
      // DecimalBigIntegerLiteral
      { begin: "\\b(0|[1-9](_?[0-9])*)n\\b" },
      // NonDecimalIntegerLiteral
      { begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b" },
      { begin: "\\b0[bB][0-1](_?[0-1])*n?\\b" },
      { begin: "\\b0[oO][0-7](_?[0-7])*n?\\b" },
      // LegacyOctalIntegerLiteral (does not include underscore separators)
      // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
      { begin: "\\b0[0-7]+n?\\b" }
    ],
    relevance: 0
  }, _ = {
    className: "subst",
    begin: "\\$\\{",
    end: "\\}",
    keywords: o,
    contains: []
    // defined later
  }, m = {
    begin: ".?html`",
    end: "",
    starts: {
      end: "`",
      returnEnd: !1,
      contains: [
        t.BACKSLASH_ESCAPE,
        _
      ],
      subLanguage: "xml"
    }
  }, g = {
    begin: ".?css`",
    end: "",
    starts: {
      end: "`",
      returnEnd: !1,
      contains: [
        t.BACKSLASH_ESCAPE,
        _
      ],
      subLanguage: "css"
    }
  }, S = {
    begin: ".?gql`",
    end: "",
    starts: {
      end: "`",
      returnEnd: !1,
      contains: [
        t.BACKSLASH_ESCAPE,
        _
      ],
      subLanguage: "graphql"
    }
  }, E = {
    className: "string",
    begin: "`",
    end: "`",
    contains: [
      t.BACKSLASH_ESCAPE,
      _
    ]
  }, T = {
    className: "comment",
    variants: [
      t.COMMENT(
        /\/\*\*(?!\/)/,
        "\\*/",
        {
          relevance: 0,
          contains: [
            {
              begin: "(?=@[A-Za-z]+)",
              relevance: 0,
              contains: [
                {
                  className: "doctag",
                  begin: "@[A-Za-z]+"
                },
                {
                  className: "type",
                  begin: "\\{",
                  end: "\\}",
                  excludeEnd: !0,
                  excludeBegin: !0,
                  relevance: 0
                },
                {
                  className: "variable",
                  begin: i + "(?=\\s*(-)|$)",
                  endsParent: !0,
                  relevance: 0
                },
                // eat spaces (not newlines) so we can find
                // types or variables
                {
                  begin: /(?=[^\n])\s/,
                  relevance: 0
                }
              ]
            }
          ]
        }
      ),
      t.C_BLOCK_COMMENT_MODE,
      t.C_LINE_COMMENT_MODE
    ]
  }, b = [
    t.APOS_STRING_MODE,
    t.QUOTE_STRING_MODE,
    m,
    g,
    S,
    E,
    // Skip numbers when they are part of a variable name
    { match: /\$\d+/ },
    u
    // This is intentional:
    // See https://github.com/highlightjs/highlight.js/issues/3288
    // hljs.REGEXP_MODE
  ];
  _.contains = b.concat({
    // we need to pair up {} inside our subst to prevent
    // it from ending too early by matching another }
    begin: /\{/,
    end: /\}/,
    keywords: o,
    contains: [
      "self"
    ].concat(b)
  });
  const C = [].concat(T, _.contains), y = C.concat([
    // eat recursive parens in sub expressions
    {
      begin: /(\s*)\(/,
      end: /\)/,
      keywords: o,
      contains: ["self"].concat(C)
    }
  ]), O = {
    className: "params",
    // convert this to negative lookbehind in v12
    begin: /(\s*)\(/,
    // to match the parms with
    end: /\)/,
    excludeBegin: !0,
    excludeEnd: !0,
    keywords: o,
    contains: y
  }, A = {
    variants: [
      // class Car extends vehicle
      {
        match: [
          /class/,
          /\s+/,
          i,
          /\s+/,
          /extends/,
          /\s+/,
          e.concat(i, "(", e.concat(/\./, i), ")*")
        ],
        scope: {
          1: "keyword",
          3: "title.class",
          5: "keyword",
          7: "title.class.inherited"
        }
      },
      // class Car
      {
        match: [
          /class/,
          /\s+/,
          i
        ],
        scope: {
          1: "keyword",
          3: "title.class"
        }
      }
    ]
  }, I = {
    relevance: 0,
    match: e.either(
      // Hard coded exceptions
      /\bJSON/,
      // Float32Array, OutT
      /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/,
      // CSSFactory, CSSFactoryT
      /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/,
      // FPs, FPsT
      /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/
      // P
      // single letters are not highlighted
      // BLAH
      // this will be flagged as a UPPER_CASE_CONSTANT instead
    ),
    className: "title.class",
    keywords: {
      _: [
        // se we still get relevance credit for JS library classes
        ...vc,
        ...Ac
      ]
    }
  }, k = {
    label: "use_strict",
    className: "meta",
    relevance: 10,
    begin: /^\s*['"]use (strict|asm)['"]/
  }, x = {
    variants: [
      {
        match: [
          /function/,
          /\s+/,
          i,
          /(?=\s*\()/
        ]
      },
      // anonymous function
      {
        match: [
          /function/,
          /\s*(?=\()/
        ]
      }
    ],
    className: {
      1: "keyword",
      3: "title.function"
    },
    label: "func.def",
    contains: [O],
    illegal: /%/
  }, B = {
    relevance: 0,
    match: /\b[A-Z][A-Z_0-9]+\b/,
    className: "variable.constant"
  };
  function X(V) {
    return e.concat("(?!", V.join("|"), ")");
  }
  const J = {
    match: e.concat(
      /\b/,
      X([
        ...Ic,
        "super",
        "import"
      ].map((V) => `${V}\\s*\\(`)),
      i,
      e.lookahead(/\s*\(/)
    ),
    className: "title.function",
    relevance: 0
  }, D = {
    begin: e.concat(/\./, e.lookahead(
      e.concat(i, /(?![0-9A-Za-z$_(])/)
    )),
    end: i,
    excludeBegin: !0,
    keywords: "prototype",
    className: "property",
    relevance: 0
  }, L = {
    match: [
      /get|set/,
      /\s+/,
      i,
      /(?=\()/
    ],
    className: {
      1: "keyword",
      3: "title.function"
    },
    contains: [
      {
        // eat to avoid empty params
        begin: /\(\)/
      },
      O
    ]
  }, G = "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + t.UNDERSCORE_IDENT_RE + ")\\s*=>", q = {
    match: [
      /const|var|let/,
      /\s+/,
      i,
      /\s*/,
      /=\s*/,
      /(async\s*)?/,
      // async is optional
      e.lookahead(G)
    ],
    keywords: "async",
    className: {
      1: "keyword",
      3: "title.function"
    },
    contains: [
      O
    ]
  };
  return {
    name: "JavaScript",
    aliases: ["js", "jsx", "mjs", "cjs"],
    keywords: o,
    // this will be extended by TypeScript
    exports: { PARAMS_CONTAINS: y, CLASS_REFERENCE: I },
    illegal: /#(?![$_A-z])/,
    contains: [
      t.SHEBANG({
        label: "shebang",
        binary: "node",
        relevance: 5
      }),
      k,
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE,
      m,
      g,
      S,
      E,
      T,
      // Skip numbers when they are part of a variable name
      { match: /\$\d+/ },
      u,
      I,
      {
        scope: "attr",
        match: i + e.lookahead(":"),
        relevance: 0
      },
      q,
      {
        // "value" container
        begin: "(" + t.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
        keywords: "return throw case",
        relevance: 0,
        contains: [
          T,
          t.REGEXP_MODE,
          {
            className: "function",
            // we have to count the parens to make sure we actually have the
            // correct bounding ( ) before the =>.  There could be any number of
            // sub-expressions inside also surrounded by parens.
            begin: G,
            returnBegin: !0,
            end: "\\s*=>",
            contains: [
              {
                className: "params",
                variants: [
                  {
                    begin: t.UNDERSCORE_IDENT_RE,
                    relevance: 0
                  },
                  {
                    className: null,
                    begin: /\(\s*\)/,
                    skip: !0
                  },
                  {
                    begin: /(\s*)\(/,
                    end: /\)/,
                    excludeBegin: !0,
                    excludeEnd: !0,
                    keywords: o,
                    contains: y
                  }
                ]
              }
            ]
          },
          {
            // could be a comma delimited list of params to a function call
            begin: /,/,
            relevance: 0
          },
          {
            match: /\s+/,
            relevance: 0
          },
          {
            // JSX
            variants: [
              { begin: r.begin, end: r.end },
              { match: a },
              {
                begin: s.begin,
                // we carefully check the opening tag to see if it truly
                // is a tag and not a false positive
                "on:begin": s.isTrulyOpeningTag,
                end: s.end
              }
            ],
            subLanguage: "xml",
            contains: [
              {
                begin: s.begin,
                end: s.end,
                skip: !0,
                contains: ["self"]
              }
            ]
          }
        ]
      },
      x,
      {
        // prevent this from getting swallowed up by function
        // since they appear "function like"
        beginKeywords: "while if switch catch for"
      },
      {
        // we have to count the parens to make sure we actually have the correct
        // bounding ( ).  There could be any number of sub-expressions inside
        // also surrounded by parens.
        begin: "\\b(?!function)" + t.UNDERSCORE_IDENT_RE + "\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)\\s*\\{",
        // end parens
        returnBegin: !0,
        label: "func.def",
        contains: [
          O,
          t.inherit(t.TITLE_MODE, { begin: i, className: "title.function" })
        ]
      },
      // catch ... so it won't trigger the property rule below
      {
        match: /\.\.\./,
        relevance: 0
      },
      D,
      // hack: prevents detection of keywords in some circumstances
      // .keyword()
      // $keyword = x
      {
        match: "\\$" + i,
        relevance: 0
      },
      {
        match: [/\bconstructor(?=\s*\()/],
        className: { 1: "title.function" },
        contains: [O]
      },
      J,
      B,
      A,
      L,
      {
        match: /\$[(.]/
        // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
      }
    ]
  };
}
function th(t) {
  const e = {
    className: "attr",
    begin: /"(\\.|[^\\"\r\n])*"(?=\s*:)/,
    relevance: 1.01
  }, n = {
    match: /[{}[\],:]/,
    className: "punctuation",
    relevance: 0
  }, i = [
    "true",
    "false",
    "null"
  ], r = {
    scope: "literal",
    beginKeywords: i.join(" ")
  };
  return {
    name: "JSON",
    aliases: ["jsonc"],
    keywords: {
      literal: i
    },
    contains: [
      e,
      n,
      t.QUOTE_STRING_MODE,
      r,
      t.C_NUMBER_MODE,
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE
    ],
    illegal: "\\S"
  };
}
var di = "[0-9](_*[0-9])*", Ir = `\\.(${di})`, Dr = "[0-9a-fA-F](_*[0-9a-fA-F])*", nh = {
  className: "number",
  variants: [
    // DecimalFloatingPointLiteral
    // including ExponentPart
    { begin: `(\\b(${di})((${Ir})|\\.)?|(${Ir}))[eE][+-]?(${di})[fFdD]?\\b` },
    // excluding ExponentPart
    { begin: `\\b(${di})((${Ir})[fFdD]?\\b|\\.([fFdD]\\b)?)` },
    { begin: `(${Ir})[fFdD]?\\b` },
    { begin: `\\b(${di})[fFdD]\\b` },
    // HexadecimalFloatingPointLiteral
    { begin: `\\b0[xX]((${Dr})\\.?|(${Dr})?\\.(${Dr}))[pP][+-]?(${di})[fFdD]?\\b` },
    // DecimalIntegerLiteral
    { begin: "\\b(0|[1-9](_*[0-9])*)[lL]?\\b" },
    // HexIntegerLiteral
    { begin: `\\b0[xX](${Dr})[lL]?\\b` },
    // OctalIntegerLiteral
    { begin: "\\b0(_*[0-7])*[lL]?\\b" },
    // BinaryIntegerLiteral
    { begin: "\\b0[bB][01](_*[01])*[lL]?\\b" }
  ],
  relevance: 0
};
function ih(t) {
  const e = {
    keyword: "abstract as val var vararg get set class object open private protected public noinline crossinline dynamic final enum if else do while for when throw try catch finally import package is in fun override companion reified inline lateinit init interface annotation data sealed internal infix operator out by constructor super tailrec where const inner suspend typealias external expect actual",
    built_in: "Byte Short Char Int Long Boolean Float Double Void Unit Nothing",
    literal: "true false null"
  }, n = {
    className: "keyword",
    begin: /\b(break|continue|return|this)\b/,
    starts: { contains: [
      {
        className: "symbol",
        begin: /@\w+/
      }
    ] }
  }, i = {
    className: "symbol",
    begin: t.UNDERSCORE_IDENT_RE + "@"
  }, r = {
    className: "subst",
    begin: /\$\{/,
    end: /\}/,
    contains: [t.C_NUMBER_MODE]
  }, a = {
    className: "variable",
    begin: "\\$" + t.UNDERSCORE_IDENT_RE
  }, s = {
    className: "string",
    variants: [
      {
        begin: '"""',
        end: '"""(?=[^"])',
        contains: [
          a,
          r
        ]
      },
      // Can't use built-in modes easily, as we want to use STRING in the meta
      // context as 'meta-string' and there's no syntax to remove explicitly set
      // classNames in built-in modes.
      {
        begin: "'",
        end: "'",
        illegal: /\n/,
        contains: [t.BACKSLASH_ESCAPE]
      },
      {
        begin: '"',
        end: '"',
        illegal: /\n/,
        contains: [
          t.BACKSLASH_ESCAPE,
          a,
          r
        ]
      }
    ]
  };
  r.contains.push(s);
  const o = {
    className: "meta",
    begin: "@(?:file|property|field|get|set|receiver|param|setparam|delegate)\\s*:(?:\\s*" + t.UNDERSCORE_IDENT_RE + ")?"
  }, l = {
    className: "meta",
    begin: "@" + t.UNDERSCORE_IDENT_RE,
    contains: [
      {
        begin: /\(/,
        end: /\)/,
        contains: [
          t.inherit(s, { className: "string" }),
          "self"
        ]
      }
    ]
  }, c = nh, d = t.COMMENT(
    "/\\*",
    "\\*/",
    { contains: [t.C_BLOCK_COMMENT_MODE] }
  ), u = { variants: [
    {
      className: "type",
      begin: t.UNDERSCORE_IDENT_RE
    },
    {
      begin: /\(/,
      end: /\)/,
      contains: []
      // defined later
    }
  ] }, _ = u;
  return _.variants[1].contains = [u], u.variants[1].contains = [_], {
    name: "Kotlin",
    aliases: [
      "kt",
      "kts"
    ],
    keywords: e,
    contains: [
      t.COMMENT(
        "/\\*\\*",
        "\\*/",
        {
          relevance: 0,
          contains: [
            {
              className: "doctag",
              begin: "@[A-Za-z]+"
            }
          ]
        }
      ),
      t.C_LINE_COMMENT_MODE,
      d,
      n,
      i,
      o,
      l,
      {
        className: "function",
        beginKeywords: "fun",
        end: "[(]|$",
        returnBegin: !0,
        excludeEnd: !0,
        keywords: e,
        relevance: 5,
        contains: [
          {
            begin: t.UNDERSCORE_IDENT_RE + "\\s*\\(",
            returnBegin: !0,
            relevance: 0,
            contains: [t.UNDERSCORE_TITLE_MODE]
          },
          {
            className: "type",
            begin: /</,
            end: />/,
            keywords: "reified",
            relevance: 0
          },
          {
            className: "params",
            begin: /\(/,
            end: /\)/,
            endsParent: !0,
            keywords: e,
            relevance: 0,
            contains: [
              {
                begin: /:/,
                end: /[=,\/]/,
                endsWithParent: !0,
                contains: [
                  u,
                  t.C_LINE_COMMENT_MODE,
                  d
                ],
                relevance: 0
              },
              t.C_LINE_COMMENT_MODE,
              d,
              o,
              l,
              s,
              t.C_NUMBER_MODE
            ]
          },
          d
        ]
      },
      {
        begin: [
          /class|interface|trait/,
          /\s+/,
          t.UNDERSCORE_IDENT_RE
        ],
        beginScope: {
          3: "title.class"
        },
        keywords: "class interface trait",
        end: /[:\{(]|$/,
        excludeEnd: !0,
        illegal: "extends implements",
        contains: [
          { beginKeywords: "public protected internal private constructor" },
          t.UNDERSCORE_TITLE_MODE,
          {
            className: "type",
            begin: /</,
            end: />/,
            excludeBegin: !0,
            excludeEnd: !0,
            relevance: 0
          },
          {
            className: "type",
            begin: /[,:]\s*/,
            end: /[<\(,){\s]|$/,
            excludeBegin: !0,
            returnEnd: !0
          },
          o,
          l
        ]
      },
      s,
      {
        className: "meta",
        begin: "^#!/usr/bin/env",
        end: "$",
        illegal: `
`
      },
      c
    ]
  };
}
const rh = (t) => ({
  IMPORTANT: {
    scope: "meta",
    begin: "!important"
  },
  BLOCK_COMMENT: t.C_BLOCK_COMMENT_MODE,
  HEXCOLOR: {
    scope: "number",
    begin: /#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\b/
  },
  FUNCTION_DISPATCH: {
    className: "built_in",
    begin: /[\w-]+(?=\()/
  },
  ATTRIBUTE_SELECTOR_MODE: {
    scope: "selector-attr",
    begin: /\[/,
    end: /\]/,
    illegal: "$",
    contains: [
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE
    ]
  },
  CSS_NUMBER_MODE: {
    scope: "number",
    begin: t.NUMBER_RE + "(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",
    relevance: 0
  },
  CSS_VARIABLE: {
    className: "attr",
    begin: /--[A-Za-z_][A-Za-z0-9_-]*/
  }
}), ah = [
  "a",
  "abbr",
  "address",
  "article",
  "aside",
  "audio",
  "b",
  "blockquote",
  "body",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "dd",
  "del",
  "details",
  "dfn",
  "div",
  "dl",
  "dt",
  "em",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "header",
  "hgroup",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "label",
  "legend",
  "li",
  "main",
  "mark",
  "menu",
  "nav",
  "object",
  "ol",
  "optgroup",
  "option",
  "p",
  "picture",
  "q",
  "quote",
  "samp",
  "section",
  "select",
  "source",
  "span",
  "strong",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "tr",
  "ul",
  "var",
  "video"
], sh = [
  "defs",
  "g",
  "marker",
  "mask",
  "pattern",
  "svg",
  "switch",
  "symbol",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feFlood",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMorphology",
  "feOffset",
  "feSpecularLighting",
  "feTile",
  "feTurbulence",
  "linearGradient",
  "radialGradient",
  "stop",
  "circle",
  "ellipse",
  "image",
  "line",
  "path",
  "polygon",
  "polyline",
  "rect",
  "text",
  "use",
  "textPath",
  "tspan",
  "foreignObject",
  "clipPath"
], oh = [
  ...ah,
  ...sh
], lh = [
  "any-hover",
  "any-pointer",
  "aspect-ratio",
  "color",
  "color-gamut",
  "color-index",
  "device-aspect-ratio",
  "device-height",
  "device-width",
  "display-mode",
  "forced-colors",
  "grid",
  "height",
  "hover",
  "inverted-colors",
  "monochrome",
  "orientation",
  "overflow-block",
  "overflow-inline",
  "pointer",
  "prefers-color-scheme",
  "prefers-contrast",
  "prefers-reduced-motion",
  "prefers-reduced-transparency",
  "resolution",
  "scan",
  "scripting",
  "update",
  "width",
  // TODO: find a better solution?
  "min-width",
  "max-width",
  "min-height",
  "max-height"
].sort().reverse(), Dc = [
  "active",
  "any-link",
  "blank",
  "checked",
  "current",
  "default",
  "defined",
  "dir",
  // dir()
  "disabled",
  "drop",
  "empty",
  "enabled",
  "first",
  "first-child",
  "first-of-type",
  "fullscreen",
  "future",
  "focus",
  "focus-visible",
  "focus-within",
  "has",
  // has()
  "host",
  // host or host()
  "host-context",
  // host-context()
  "hover",
  "indeterminate",
  "in-range",
  "invalid",
  "is",
  // is()
  "lang",
  // lang()
  "last-child",
  "last-of-type",
  "left",
  "link",
  "local-link",
  "not",
  // not()
  "nth-child",
  // nth-child()
  "nth-col",
  // nth-col()
  "nth-last-child",
  // nth-last-child()
  "nth-last-col",
  // nth-last-col()
  "nth-last-of-type",
  //nth-last-of-type()
  "nth-of-type",
  //nth-of-type()
  "only-child",
  "only-of-type",
  "optional",
  "out-of-range",
  "past",
  "placeholder-shown",
  "read-only",
  "read-write",
  "required",
  "right",
  "root",
  "scope",
  "target",
  "target-within",
  "user-invalid",
  "valid",
  "visited",
  "where"
  // where()
].sort().reverse(), Mc = [
  "after",
  "backdrop",
  "before",
  "cue",
  "cue-region",
  "first-letter",
  "first-line",
  "grammar-error",
  "marker",
  "part",
  "placeholder",
  "selection",
  "slotted",
  "spelling-error"
].sort().reverse(), ch = [
  "accent-color",
  "align-content",
  "align-items",
  "align-self",
  "alignment-baseline",
  "all",
  "anchor-name",
  "animation",
  "animation-composition",
  "animation-delay",
  "animation-direction",
  "animation-duration",
  "animation-fill-mode",
  "animation-iteration-count",
  "animation-name",
  "animation-play-state",
  "animation-range",
  "animation-range-end",
  "animation-range-start",
  "animation-timeline",
  "animation-timing-function",
  "appearance",
  "aspect-ratio",
  "backdrop-filter",
  "backface-visibility",
  "background",
  "background-attachment",
  "background-blend-mode",
  "background-clip",
  "background-color",
  "background-image",
  "background-origin",
  "background-position",
  "background-position-x",
  "background-position-y",
  "background-repeat",
  "background-size",
  "baseline-shift",
  "block-size",
  "border",
  "border-block",
  "border-block-color",
  "border-block-end",
  "border-block-end-color",
  "border-block-end-style",
  "border-block-end-width",
  "border-block-start",
  "border-block-start-color",
  "border-block-start-style",
  "border-block-start-width",
  "border-block-style",
  "border-block-width",
  "border-bottom",
  "border-bottom-color",
  "border-bottom-left-radius",
  "border-bottom-right-radius",
  "border-bottom-style",
  "border-bottom-width",
  "border-collapse",
  "border-color",
  "border-end-end-radius",
  "border-end-start-radius",
  "border-image",
  "border-image-outset",
  "border-image-repeat",
  "border-image-slice",
  "border-image-source",
  "border-image-width",
  "border-inline",
  "border-inline-color",
  "border-inline-end",
  "border-inline-end-color",
  "border-inline-end-style",
  "border-inline-end-width",
  "border-inline-start",
  "border-inline-start-color",
  "border-inline-start-style",
  "border-inline-start-width",
  "border-inline-style",
  "border-inline-width",
  "border-left",
  "border-left-color",
  "border-left-style",
  "border-left-width",
  "border-radius",
  "border-right",
  "border-right-color",
  "border-right-style",
  "border-right-width",
  "border-spacing",
  "border-start-end-radius",
  "border-start-start-radius",
  "border-style",
  "border-top",
  "border-top-color",
  "border-top-left-radius",
  "border-top-right-radius",
  "border-top-style",
  "border-top-width",
  "border-width",
  "bottom",
  "box-align",
  "box-decoration-break",
  "box-direction",
  "box-flex",
  "box-flex-group",
  "box-lines",
  "box-ordinal-group",
  "box-orient",
  "box-pack",
  "box-shadow",
  "box-sizing",
  "break-after",
  "break-before",
  "break-inside",
  "caption-side",
  "caret-color",
  "clear",
  "clip",
  "clip-path",
  "clip-rule",
  "color",
  "color-interpolation",
  "color-interpolation-filters",
  "color-profile",
  "color-rendering",
  "color-scheme",
  "column-count",
  "column-fill",
  "column-gap",
  "column-rule",
  "column-rule-color",
  "column-rule-style",
  "column-rule-width",
  "column-span",
  "column-width",
  "columns",
  "contain",
  "contain-intrinsic-block-size",
  "contain-intrinsic-height",
  "contain-intrinsic-inline-size",
  "contain-intrinsic-size",
  "contain-intrinsic-width",
  "container",
  "container-name",
  "container-type",
  "content",
  "content-visibility",
  "counter-increment",
  "counter-reset",
  "counter-set",
  "cue",
  "cue-after",
  "cue-before",
  "cursor",
  "cx",
  "cy",
  "direction",
  "display",
  "dominant-baseline",
  "empty-cells",
  "enable-background",
  "field-sizing",
  "fill",
  "fill-opacity",
  "fill-rule",
  "filter",
  "flex",
  "flex-basis",
  "flex-direction",
  "flex-flow",
  "flex-grow",
  "flex-shrink",
  "flex-wrap",
  "float",
  "flood-color",
  "flood-opacity",
  "flow",
  "font",
  "font-display",
  "font-family",
  "font-feature-settings",
  "font-kerning",
  "font-language-override",
  "font-optical-sizing",
  "font-palette",
  "font-size",
  "font-size-adjust",
  "font-smooth",
  "font-smoothing",
  "font-stretch",
  "font-style",
  "font-synthesis",
  "font-synthesis-position",
  "font-synthesis-small-caps",
  "font-synthesis-style",
  "font-synthesis-weight",
  "font-variant",
  "font-variant-alternates",
  "font-variant-caps",
  "font-variant-east-asian",
  "font-variant-emoji",
  "font-variant-ligatures",
  "font-variant-numeric",
  "font-variant-position",
  "font-variation-settings",
  "font-weight",
  "forced-color-adjust",
  "gap",
  "glyph-orientation-horizontal",
  "glyph-orientation-vertical",
  "grid",
  "grid-area",
  "grid-auto-columns",
  "grid-auto-flow",
  "grid-auto-rows",
  "grid-column",
  "grid-column-end",
  "grid-column-start",
  "grid-gap",
  "grid-row",
  "grid-row-end",
  "grid-row-start",
  "grid-template",
  "grid-template-areas",
  "grid-template-columns",
  "grid-template-rows",
  "hanging-punctuation",
  "height",
  "hyphenate-character",
  "hyphenate-limit-chars",
  "hyphens",
  "icon",
  "image-orientation",
  "image-rendering",
  "image-resolution",
  "ime-mode",
  "initial-letter",
  "initial-letter-align",
  "inline-size",
  "inset",
  "inset-area",
  "inset-block",
  "inset-block-end",
  "inset-block-start",
  "inset-inline",
  "inset-inline-end",
  "inset-inline-start",
  "isolation",
  "justify-content",
  "justify-items",
  "justify-self",
  "kerning",
  "left",
  "letter-spacing",
  "lighting-color",
  "line-break",
  "line-height",
  "line-height-step",
  "list-style",
  "list-style-image",
  "list-style-position",
  "list-style-type",
  "margin",
  "margin-block",
  "margin-block-end",
  "margin-block-start",
  "margin-bottom",
  "margin-inline",
  "margin-inline-end",
  "margin-inline-start",
  "margin-left",
  "margin-right",
  "margin-top",
  "margin-trim",
  "marker",
  "marker-end",
  "marker-mid",
  "marker-start",
  "marks",
  "mask",
  "mask-border",
  "mask-border-mode",
  "mask-border-outset",
  "mask-border-repeat",
  "mask-border-slice",
  "mask-border-source",
  "mask-border-width",
  "mask-clip",
  "mask-composite",
  "mask-image",
  "mask-mode",
  "mask-origin",
  "mask-position",
  "mask-repeat",
  "mask-size",
  "mask-type",
  "masonry-auto-flow",
  "math-depth",
  "math-shift",
  "math-style",
  "max-block-size",
  "max-height",
  "max-inline-size",
  "max-width",
  "min-block-size",
  "min-height",
  "min-inline-size",
  "min-width",
  "mix-blend-mode",
  "nav-down",
  "nav-index",
  "nav-left",
  "nav-right",
  "nav-up",
  "none",
  "normal",
  "object-fit",
  "object-position",
  "offset",
  "offset-anchor",
  "offset-distance",
  "offset-path",
  "offset-position",
  "offset-rotate",
  "opacity",
  "order",
  "orphans",
  "outline",
  "outline-color",
  "outline-offset",
  "outline-style",
  "outline-width",
  "overflow",
  "overflow-anchor",
  "overflow-block",
  "overflow-clip-margin",
  "overflow-inline",
  "overflow-wrap",
  "overflow-x",
  "overflow-y",
  "overlay",
  "overscroll-behavior",
  "overscroll-behavior-block",
  "overscroll-behavior-inline",
  "overscroll-behavior-x",
  "overscroll-behavior-y",
  "padding",
  "padding-block",
  "padding-block-end",
  "padding-block-start",
  "padding-bottom",
  "padding-inline",
  "padding-inline-end",
  "padding-inline-start",
  "padding-left",
  "padding-right",
  "padding-top",
  "page",
  "page-break-after",
  "page-break-before",
  "page-break-inside",
  "paint-order",
  "pause",
  "pause-after",
  "pause-before",
  "perspective",
  "perspective-origin",
  "place-content",
  "place-items",
  "place-self",
  "pointer-events",
  "position",
  "position-anchor",
  "position-visibility",
  "print-color-adjust",
  "quotes",
  "r",
  "resize",
  "rest",
  "rest-after",
  "rest-before",
  "right",
  "rotate",
  "row-gap",
  "ruby-align",
  "ruby-position",
  "scale",
  "scroll-behavior",
  "scroll-margin",
  "scroll-margin-block",
  "scroll-margin-block-end",
  "scroll-margin-block-start",
  "scroll-margin-bottom",
  "scroll-margin-inline",
  "scroll-margin-inline-end",
  "scroll-margin-inline-start",
  "scroll-margin-left",
  "scroll-margin-right",
  "scroll-margin-top",
  "scroll-padding",
  "scroll-padding-block",
  "scroll-padding-block-end",
  "scroll-padding-block-start",
  "scroll-padding-bottom",
  "scroll-padding-inline",
  "scroll-padding-inline-end",
  "scroll-padding-inline-start",
  "scroll-padding-left",
  "scroll-padding-right",
  "scroll-padding-top",
  "scroll-snap-align",
  "scroll-snap-stop",
  "scroll-snap-type",
  "scroll-timeline",
  "scroll-timeline-axis",
  "scroll-timeline-name",
  "scrollbar-color",
  "scrollbar-gutter",
  "scrollbar-width",
  "shape-image-threshold",
  "shape-margin",
  "shape-outside",
  "shape-rendering",
  "speak",
  "speak-as",
  "src",
  // @font-face
  "stop-color",
  "stop-opacity",
  "stroke",
  "stroke-dasharray",
  "stroke-dashoffset",
  "stroke-linecap",
  "stroke-linejoin",
  "stroke-miterlimit",
  "stroke-opacity",
  "stroke-width",
  "tab-size",
  "table-layout",
  "text-align",
  "text-align-all",
  "text-align-last",
  "text-anchor",
  "text-combine-upright",
  "text-decoration",
  "text-decoration-color",
  "text-decoration-line",
  "text-decoration-skip",
  "text-decoration-skip-ink",
  "text-decoration-style",
  "text-decoration-thickness",
  "text-emphasis",
  "text-emphasis-color",
  "text-emphasis-position",
  "text-emphasis-style",
  "text-indent",
  "text-justify",
  "text-orientation",
  "text-overflow",
  "text-rendering",
  "text-shadow",
  "text-size-adjust",
  "text-transform",
  "text-underline-offset",
  "text-underline-position",
  "text-wrap",
  "text-wrap-mode",
  "text-wrap-style",
  "timeline-scope",
  "top",
  "touch-action",
  "transform",
  "transform-box",
  "transform-origin",
  "transform-style",
  "transition",
  "transition-behavior",
  "transition-delay",
  "transition-duration",
  "transition-property",
  "transition-timing-function",
  "translate",
  "unicode-bidi",
  "user-modify",
  "user-select",
  "vector-effect",
  "vertical-align",
  "view-timeline",
  "view-timeline-axis",
  "view-timeline-inset",
  "view-timeline-name",
  "view-transition-name",
  "visibility",
  "voice-balance",
  "voice-duration",
  "voice-family",
  "voice-pitch",
  "voice-range",
  "voice-rate",
  "voice-stress",
  "voice-volume",
  "white-space",
  "white-space-collapse",
  "widows",
  "width",
  "will-change",
  "word-break",
  "word-spacing",
  "word-wrap",
  "writing-mode",
  "x",
  "y",
  "z-index",
  "zoom"
].sort().reverse(), dh = Dc.concat(Mc).sort().reverse();
function uh(t) {
  const e = rh(t), n = dh, i = "and or not only", r = "[\\w-]+", a = "(" + r + "|@\\{" + r + "\\})", s = [], o = [], l = function(b) {
    return {
      // Less strings are not multiline (also include '~' for more consistent coloring of "escaped" strings)
      className: "string",
      begin: "~?" + b + ".*?" + b
    };
  }, c = function(b, C, y) {
    return {
      className: b,
      begin: C,
      relevance: y
    };
  }, d = {
    $pattern: /[a-z-]+/,
    keyword: i,
    attribute: lh.join(" ")
  }, u = {
    // used only to properly balance nested parens inside mixin call, def. arg list
    begin: "\\(",
    end: "\\)",
    contains: o,
    keywords: d,
    relevance: 0
  };
  o.push(
    t.C_LINE_COMMENT_MODE,
    t.C_BLOCK_COMMENT_MODE,
    l("'"),
    l('"'),
    e.CSS_NUMBER_MODE,
    // fixme: it does not include dot for numbers like .5em :(
    {
      begin: "(url|data-uri)\\(",
      starts: {
        className: "string",
        end: "[\\)\\n]",
        excludeEnd: !0
      }
    },
    e.HEXCOLOR,
    u,
    c("variable", "@@?" + r, 10),
    c("variable", "@\\{" + r + "\\}"),
    c("built_in", "~?`[^`]*?`"),
    // inline javascript (or whatever host language) *multiline* string
    {
      // @media features (it’s here to not duplicate things in AT_RULE_MODE with extra PARENS_MODE overriding):
      className: "attribute",
      begin: r + "\\s*:",
      end: ":",
      returnBegin: !0,
      excludeEnd: !0
    },
    e.IMPORTANT,
    { beginKeywords: "and not" },
    e.FUNCTION_DISPATCH
  );
  const _ = o.concat({
    begin: /\{/,
    end: /\}/,
    contains: s
  }), m = {
    beginKeywords: "when",
    endsWithParent: !0,
    contains: [{ beginKeywords: "and not" }].concat(o)
    // using this form to override VALUE’s 'function' match
  }, g = {
    begin: a + "\\s*:",
    returnBegin: !0,
    end: /[;}]/,
    relevance: 0,
    contains: [
      { begin: /-(webkit|moz|ms|o)-/ },
      e.CSS_VARIABLE,
      {
        className: "attribute",
        begin: "\\b(" + ch.join("|") + ")\\b",
        end: /(?=:)/,
        starts: {
          endsWithParent: !0,
          illegal: "[<=$]",
          relevance: 0,
          contains: o
        }
      }
    ]
  }, S = {
    className: "keyword",
    begin: "@(import|media|charset|font-face|(-[a-z]+-)?keyframes|supports|document|namespace|page|viewport|host)\\b",
    starts: {
      end: "[;{}]",
      keywords: d,
      returnEnd: !0,
      contains: o,
      relevance: 0
    }
  }, E = {
    className: "variable",
    variants: [
      // using more strict pattern for higher relevance to increase chances of Less detection.
      // this is *the only* Less specific statement used in most of the sources, so...
      // (we’ll still often loose to the css-parser unless there's '//' comment,
      // simply because 1 variable just can't beat 99 properties :)
      {
        begin: "@" + r + "\\s*:",
        relevance: 15
      },
      { begin: "@" + r }
    ],
    starts: {
      end: "[;}]",
      returnEnd: !0,
      contains: _
    }
  }, h = {
    // first parse unambiguous selectors (i.e. those not starting with tag)
    // then fall into the scary lookahead-discriminator variant.
    // this mode also handles mixin definitions and calls
    variants: [
      {
        begin: "[\\.#:&\\[>]",
        end: "[;{}]"
        // mixin calls end with ';'
      },
      {
        begin: a,
        end: /\{/
      }
    ],
    returnBegin: !0,
    returnEnd: !0,
    illegal: `[<='$"]`,
    relevance: 0,
    contains: [
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      m,
      c("keyword", "all\\b"),
      c("variable", "@\\{" + r + "\\}"),
      // otherwise it’s identified as tag
      {
        begin: "\\b(" + oh.join("|") + ")\\b",
        className: "selector-tag"
      },
      e.CSS_NUMBER_MODE,
      c("selector-tag", a, 0),
      c("selector-id", "#" + a),
      c("selector-class", "\\." + a, 0),
      c("selector-tag", "&", 0),
      e.ATTRIBUTE_SELECTOR_MODE,
      {
        className: "selector-pseudo",
        begin: ":(" + Dc.join("|") + ")"
      },
      {
        className: "selector-pseudo",
        begin: ":(:)?(" + Mc.join("|") + ")"
      },
      {
        begin: /\(/,
        end: /\)/,
        relevance: 0,
        contains: _
      },
      // argument list of parametric mixins
      { begin: "!important" },
      // eat !important after mixin call or it will be colored as tag
      e.FUNCTION_DISPATCH
    ]
  }, T = {
    begin: r + `:(:)?(${n.join("|")})`,
    returnBegin: !0,
    contains: [h]
  };
  return s.push(
    t.C_LINE_COMMENT_MODE,
    t.C_BLOCK_COMMENT_MODE,
    S,
    E,
    T,
    g,
    h,
    m,
    e.FUNCTION_DISPATCH
  ), {
    name: "Less",
    case_insensitive: !0,
    illegal: `[=>'/<($"]`,
    contains: s
  };
}
function _h(t) {
  const e = "\\[=*\\[", n = "\\]=*\\]", i = {
    begin: e,
    end: n,
    contains: ["self"]
  }, r = [
    t.COMMENT("--(?!" + e + ")", "$"),
    t.COMMENT(
      "--" + e,
      n,
      {
        contains: [i],
        relevance: 10
      }
    )
  ];
  return {
    name: "Lua",
    aliases: ["pluto"],
    keywords: {
      $pattern: t.UNDERSCORE_IDENT_RE,
      literal: "true false nil",
      keyword: "and break do else elseif end for goto if in local not or repeat return then until while",
      built_in: (
        // Metatags and globals:
        "_G _ENV _VERSION __index __newindex __mode __call __metatable __tostring __len __gc __add __sub __mul __div __mod __pow __concat __unm __eq __lt __le assert collectgarbage dofile error getfenv getmetatable ipairs load loadfile loadstring module next pairs pcall print rawequal rawget rawset require select setfenv setmetatable tonumber tostring type unpack xpcall arg self coroutine resume yield status wrap create running debug getupvalue debug sethook getmetatable gethook setmetatable setlocal traceback setfenv getinfo setupvalue getlocal getregistry getfenv io lines write close flush open output type read stderr stdin input stdout popen tmpfile math log max acos huge ldexp pi cos tanh pow deg tan cosh sinh random randomseed frexp ceil floor rad abs sqrt modf asin min mod fmod log10 atan2 exp sin atan os exit setlocale date getenv difftime remove time clock tmpname rename execute package preload loadlib loaded loaders cpath config path seeall string sub upper len gfind rep find match char dump gmatch reverse byte format gsub lower table setn insert getn foreachi maxn foreach concat sort remove"
      )
    },
    contains: r.concat([
      {
        className: "function",
        beginKeywords: "function",
        end: "\\)",
        contains: [
          t.inherit(t.TITLE_MODE, { begin: "([_a-zA-Z]\\w*\\.)*([_a-zA-Z]\\w*:)?[_a-zA-Z]\\w*" }),
          {
            className: "params",
            begin: "\\(",
            endsWithParent: !0,
            contains: r
          }
        ].concat(r)
      },
      t.C_NUMBER_MODE,
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE,
      {
        className: "string",
        begin: e,
        end: n,
        contains: [i],
        relevance: 5
      }
    ])
  };
}
function ph(t) {
  const e = {
    className: "variable",
    variants: [
      {
        begin: "\\$\\(" + t.UNDERSCORE_IDENT_RE + "\\)",
        contains: [t.BACKSLASH_ESCAPE]
      },
      { begin: /\$[@%<?\^\+\*]/ }
    ]
  }, n = {
    className: "string",
    begin: /"/,
    end: /"/,
    contains: [
      t.BACKSLASH_ESCAPE,
      e
    ]
  }, i = {
    className: "variable",
    begin: /\$\([\w-]+\s/,
    end: /\)/,
    keywords: { built_in: "subst patsubst strip findstring filter filter-out sort word wordlist firstword lastword dir notdir suffix basename addsuffix addprefix join wildcard realpath abspath error warning shell origin flavor foreach if or and call eval file value" },
    contains: [
      e,
      n
      // Added QUOTE_STRING as they can be a part of functions
    ]
  }, r = { begin: "^" + t.UNDERSCORE_IDENT_RE + "\\s*(?=[:+?]?=)" }, a = {
    className: "meta",
    begin: /^\.PHONY:/,
    end: /$/,
    keywords: {
      $pattern: /[\.\w]+/,
      keyword: ".PHONY"
    }
  }, s = {
    className: "section",
    begin: /^[^\s]+:/,
    end: /$/,
    contains: [e]
  };
  return {
    name: "Makefile",
    aliases: [
      "mk",
      "mak",
      "make"
    ],
    keywords: {
      $pattern: /[\w-]+/,
      keyword: "define endef undefine ifdef ifndef ifeq ifneq else endif include -include sinclude override export unexport private vpath"
    },
    contains: [
      t.HASH_COMMENT_MODE,
      e,
      n,
      i,
      r,
      a,
      s
    ]
  };
}
function mh(t) {
  const e = t.regex, n = {
    begin: /<\/?[A-Za-z_]/,
    end: ">",
    subLanguage: "xml",
    relevance: 0
  }, i = {
    begin: "^[-\\*]{3,}",
    end: "$"
  }, r = {
    className: "code",
    variants: [
      // TODO: fix to allow these to work with sublanguage also
      { begin: "(`{3,})[^`](.|\\n)*?\\1`*[ ]*" },
      { begin: "(~{3,})[^~](.|\\n)*?\\1~*[ ]*" },
      // needed to allow markdown as a sublanguage to work
      {
        begin: "```",
        end: "```+[ ]*$"
      },
      {
        begin: "~~~",
        end: "~~~+[ ]*$"
      },
      { begin: "`.+?`" },
      {
        begin: "(?=^( {4}|\\t))",
        // use contains to gobble up multiple lines to allow the block to be whatever size
        // but only have a single open/close tag vs one per line
        contains: [
          {
            begin: "^( {4}|\\t)",
            end: "(\\n)$"
          }
        ],
        relevance: 0
      }
    ]
  }, a = {
    className: "bullet",
    begin: "^[ 	]*([*+-]|(\\d+\\.))(?=\\s+)",
    end: "\\s+",
    excludeEnd: !0
  }, s = {
    begin: /^\[[^\n]+\]:/,
    returnBegin: !0,
    contains: [
      {
        className: "symbol",
        begin: /\[/,
        end: /\]/,
        excludeBegin: !0,
        excludeEnd: !0
      },
      {
        className: "link",
        begin: /:\s*/,
        end: /$/,
        excludeBegin: !0
      }
    ]
  }, o = /[A-Za-z][A-Za-z0-9+.-]*/, l = {
    variants: [
      // too much like nested array access in so many languages
      // to have any real relevance
      {
        begin: /\[.+?\]\[.*?\]/,
        relevance: 0
      },
      // popular internet URLs
      {
        begin: /\[.+?\]\(((data|javascript|mailto):|(?:http|ftp)s?:\/\/).*?\)/,
        relevance: 2
      },
      {
        begin: e.concat(/\[.+?\]\(/, o, /:\/\/.*?\)/),
        relevance: 2
      },
      // relative urls
      {
        begin: /\[.+?\]\([./?&#].*?\)/,
        relevance: 1
      },
      // whatever else, lower relevance (might not be a link at all)
      {
        begin: /\[.*?\]\(.*?\)/,
        relevance: 0
      }
    ],
    returnBegin: !0,
    contains: [
      {
        // empty strings for alt or link text
        match: /\[(?=\])/
      },
      {
        className: "string",
        relevance: 0,
        begin: "\\[",
        end: "\\]",
        excludeBegin: !0,
        returnEnd: !0
      },
      {
        className: "link",
        relevance: 0,
        begin: "\\]\\(",
        end: "\\)",
        excludeBegin: !0,
        excludeEnd: !0
      },
      {
        className: "symbol",
        relevance: 0,
        begin: "\\]\\[",
        end: "\\]",
        excludeBegin: !0,
        excludeEnd: !0
      }
    ]
  }, c = {
    className: "strong",
    contains: [],
    // defined later
    variants: [
      {
        begin: /_{2}(?!\s)/,
        end: /_{2}/
      },
      {
        begin: /\*{2}(?!\s)/,
        end: /\*{2}/
      }
    ]
  }, d = {
    className: "emphasis",
    contains: [],
    // defined later
    variants: [
      {
        begin: /\*(?![*\s])/,
        end: /\*/
      },
      {
        begin: /_(?![_\s])/,
        end: /_/,
        relevance: 0
      }
    ]
  }, u = t.inherit(c, { contains: [] }), _ = t.inherit(d, { contains: [] });
  c.contains.push(_), d.contains.push(u);
  let m = [
    n,
    l
  ];
  return [
    c,
    d,
    u,
    _
  ].forEach((h) => {
    h.contains = h.contains.concat(m);
  }), m = m.concat(c, d), {
    name: "Markdown",
    aliases: [
      "md",
      "mkdown",
      "mkd"
    ],
    contains: [
      {
        className: "section",
        variants: [
          {
            begin: "^#{1,6}",
            end: "$",
            contains: m
          },
          {
            begin: "(?=^.+?\\n[=-]{2,}$)",
            contains: [
              { begin: "^[=-]*$" },
              {
                begin: "^",
                end: "\\n",
                contains: m
              }
            ]
          }
        ]
      },
      n,
      a,
      c,
      d,
      {
        className: "quote",
        begin: "^>\\s+",
        contains: m,
        end: "$"
      },
      r,
      i,
      l,
      s,
      {
        //https://spec.commonmark.org/0.31.2/#entity-references
        scope: "literal",
        match: /&([a-zA-Z0-9]+|#[0-9]{1,7}|#[Xx][0-9a-fA-F]{1,6});/
      }
    ]
  };
}
function Eh(t) {
  const e = {
    className: "built_in",
    begin: "\\b(AV|CA|CF|CG|CI|CL|CM|CN|CT|MK|MP|MTK|MTL|NS|SCN|SK|UI|WK|XC)\\w+"
  }, n = /[a-zA-Z@][a-zA-Z0-9_]*/, o = {
    "variable.language": [
      "this",
      "super"
    ],
    $pattern: n,
    keyword: [
      "while",
      "export",
      "sizeof",
      "typedef",
      "const",
      "struct",
      "for",
      "union",
      "volatile",
      "static",
      "mutable",
      "if",
      "do",
      "return",
      "goto",
      "enum",
      "else",
      "break",
      "extern",
      "asm",
      "case",
      "default",
      "register",
      "explicit",
      "typename",
      "switch",
      "continue",
      "inline",
      "readonly",
      "assign",
      "readwrite",
      "self",
      "@synchronized",
      "id",
      "typeof",
      "nonatomic",
      "IBOutlet",
      "IBAction",
      "strong",
      "weak",
      "copy",
      "in",
      "out",
      "inout",
      "bycopy",
      "byref",
      "oneway",
      "__strong",
      "__weak",
      "__block",
      "__autoreleasing",
      "@private",
      "@protected",
      "@public",
      "@try",
      "@property",
      "@end",
      "@throw",
      "@catch",
      "@finally",
      "@autoreleasepool",
      "@synthesize",
      "@dynamic",
      "@selector",
      "@optional",
      "@required",
      "@encode",
      "@package",
      "@import",
      "@defs",
      "@compatibility_alias",
      "__bridge",
      "__bridge_transfer",
      "__bridge_retained",
      "__bridge_retain",
      "__covariant",
      "__contravariant",
      "__kindof",
      "_Nonnull",
      "_Nullable",
      "_Null_unspecified",
      "__FUNCTION__",
      "__PRETTY_FUNCTION__",
      "__attribute__",
      "getter",
      "setter",
      "retain",
      "unsafe_unretained",
      "nonnull",
      "nullable",
      "null_unspecified",
      "null_resettable",
      "class",
      "instancetype",
      "NS_DESIGNATED_INITIALIZER",
      "NS_UNAVAILABLE",
      "NS_REQUIRES_SUPER",
      "NS_RETURNS_INNER_POINTER",
      "NS_INLINE",
      "NS_AVAILABLE",
      "NS_DEPRECATED",
      "NS_ENUM",
      "NS_OPTIONS",
      "NS_SWIFT_UNAVAILABLE",
      "NS_ASSUME_NONNULL_BEGIN",
      "NS_ASSUME_NONNULL_END",
      "NS_REFINED_FOR_SWIFT",
      "NS_SWIFT_NAME",
      "NS_SWIFT_NOTHROW",
      "NS_DURING",
      "NS_HANDLER",
      "NS_ENDHANDLER",
      "NS_VALUERETURN",
      "NS_VOIDRETURN"
    ],
    literal: [
      "false",
      "true",
      "FALSE",
      "TRUE",
      "nil",
      "YES",
      "NO",
      "NULL"
    ],
    built_in: [
      "dispatch_once_t",
      "dispatch_queue_t",
      "dispatch_sync",
      "dispatch_async",
      "dispatch_once"
    ],
    type: [
      "int",
      "float",
      "char",
      "unsigned",
      "signed",
      "short",
      "long",
      "double",
      "wchar_t",
      "unichar",
      "void",
      "bool",
      "BOOL",
      "id|0",
      "_Bool"
    ]
  }, l = {
    $pattern: n,
    keyword: [
      "@interface",
      "@class",
      "@protocol",
      "@implementation"
    ]
  };
  return {
    name: "Objective-C",
    aliases: [
      "mm",
      "objc",
      "obj-c",
      "obj-c++",
      "objective-c++"
    ],
    keywords: o,
    illegal: "</",
    contains: [
      e,
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      t.C_NUMBER_MODE,
      t.QUOTE_STRING_MODE,
      t.APOS_STRING_MODE,
      {
        className: "string",
        variants: [
          {
            begin: '@"',
            end: '"',
            illegal: "\\n",
            contains: [t.BACKSLASH_ESCAPE]
          }
        ]
      },
      {
        className: "meta",
        begin: /#\s*[a-z]+\b/,
        end: /$/,
        keywords: { keyword: "if else elif endif define undef warning error line pragma ifdef ifndef include" },
        contains: [
          {
            begin: /\\\n/,
            relevance: 0
          },
          t.inherit(t.QUOTE_STRING_MODE, { className: "string" }),
          {
            className: "string",
            begin: /<.*?>/,
            end: /$/,
            illegal: "\\n"
          },
          t.C_LINE_COMMENT_MODE,
          t.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        className: "class",
        begin: "(" + l.keyword.join("|") + ")\\b",
        end: /(\{|$)/,
        excludeEnd: !0,
        keywords: l,
        contains: [t.UNDERSCORE_TITLE_MODE]
      },
      {
        begin: "\\." + t.UNDERSCORE_IDENT_RE,
        relevance: 0
      }
    ]
  };
}
function gh(t) {
  const e = t.regex, n = [
    "abs",
    "accept",
    "alarm",
    "and",
    "atan2",
    "bind",
    "binmode",
    "bless",
    "break",
    "caller",
    "chdir",
    "chmod",
    "chomp",
    "chop",
    "chown",
    "chr",
    "chroot",
    "class",
    "close",
    "closedir",
    "connect",
    "continue",
    "cos",
    "crypt",
    "dbmclose",
    "dbmopen",
    "defined",
    "delete",
    "die",
    "do",
    "dump",
    "each",
    "else",
    "elsif",
    "endgrent",
    "endhostent",
    "endnetent",
    "endprotoent",
    "endpwent",
    "endservent",
    "eof",
    "eval",
    "exec",
    "exists",
    "exit",
    "exp",
    "fcntl",
    "field",
    "fileno",
    "flock",
    "for",
    "foreach",
    "fork",
    "format",
    "formline",
    "getc",
    "getgrent",
    "getgrgid",
    "getgrnam",
    "gethostbyaddr",
    "gethostbyname",
    "gethostent",
    "getlogin",
    "getnetbyaddr",
    "getnetbyname",
    "getnetent",
    "getpeername",
    "getpgrp",
    "getpriority",
    "getprotobyname",
    "getprotobynumber",
    "getprotoent",
    "getpwent",
    "getpwnam",
    "getpwuid",
    "getservbyname",
    "getservbyport",
    "getservent",
    "getsockname",
    "getsockopt",
    "given",
    "glob",
    "gmtime",
    "goto",
    "grep",
    "gt",
    "hex",
    "if",
    "index",
    "int",
    "ioctl",
    "join",
    "keys",
    "kill",
    "last",
    "lc",
    "lcfirst",
    "length",
    "link",
    "listen",
    "local",
    "localtime",
    "log",
    "lstat",
    "lt",
    "ma",
    "map",
    "method",
    "mkdir",
    "msgctl",
    "msgget",
    "msgrcv",
    "msgsnd",
    "my",
    "ne",
    "next",
    "no",
    "not",
    "oct",
    "open",
    "opendir",
    "or",
    "ord",
    "our",
    "pack",
    "package",
    "pipe",
    "pop",
    "pos",
    "print",
    "printf",
    "prototype",
    "push",
    "q|0",
    "qq",
    "quotemeta",
    "qw",
    "qx",
    "rand",
    "read",
    "readdir",
    "readline",
    "readlink",
    "readpipe",
    "recv",
    "redo",
    "ref",
    "rename",
    "require",
    "reset",
    "return",
    "reverse",
    "rewinddir",
    "rindex",
    "rmdir",
    "say",
    "scalar",
    "seek",
    "seekdir",
    "select",
    "semctl",
    "semget",
    "semop",
    "send",
    "setgrent",
    "sethostent",
    "setnetent",
    "setpgrp",
    "setpriority",
    "setprotoent",
    "setpwent",
    "setservent",
    "setsockopt",
    "shift",
    "shmctl",
    "shmget",
    "shmread",
    "shmwrite",
    "shutdown",
    "sin",
    "sleep",
    "socket",
    "socketpair",
    "sort",
    "splice",
    "split",
    "sprintf",
    "sqrt",
    "srand",
    "stat",
    "state",
    "study",
    "sub",
    "substr",
    "symlink",
    "syscall",
    "sysopen",
    "sysread",
    "sysseek",
    "system",
    "syswrite",
    "tell",
    "telldir",
    "tie",
    "tied",
    "time",
    "times",
    "tr",
    "truncate",
    "uc",
    "ucfirst",
    "umask",
    "undef",
    "unless",
    "unlink",
    "unpack",
    "unshift",
    "untie",
    "until",
    "use",
    "utime",
    "values",
    "vec",
    "wait",
    "waitpid",
    "wantarray",
    "warn",
    "when",
    "while",
    "write",
    "x|0",
    "xor",
    "y|0"
  ], i = /[dualxmsipngr]{0,12}/, r = {
    $pattern: /[\w.]+/,
    keyword: n.join(" ")
  }, a = {
    className: "subst",
    begin: "[$@]\\{",
    end: "\\}",
    keywords: r
  }, s = {
    begin: /->\{/,
    end: /\}/
    // contains defined later
  }, o = {
    scope: "attr",
    match: /\s+:\s*\w+(\s*\(.*?\))?/
  }, l = {
    scope: "variable",
    variants: [
      { begin: /\$\d/ },
      {
        begin: e.concat(
          /[$%@](?!")(\^\w\b|#\w+(::\w+)*|\{\w+\}|\w+(::\w*)*)/,
          // negative look-ahead tries to avoid matching patterns that are not
          // Perl at all like $ident$, @ident@, etc.
          "(?![A-Za-z])(?![@$%])"
        )
      },
      {
        // Only $= is a special Perl variable and one can't declare @= or %=.
        begin: /[$%@](?!")[^\s\w{=]|\$=/,
        relevance: 0
      }
    ],
    contains: [o]
  }, c = {
    className: "number",
    variants: [
      // decimal numbers:
      // include the case where a number starts with a dot (eg. .9), and
      // the leading 0? avoids mixing the first and second match on 0.x cases
      { match: /0?\.[0-9][0-9_]+\b/ },
      // include the special versioned number (eg. v5.38)
      { match: /\bv?(0|[1-9][0-9_]*(\.[0-9_]+)?|[1-9][0-9_]*)\b/ },
      // non-decimal numbers:
      { match: /\b0[0-7][0-7_]*\b/ },
      { match: /\b0x[0-9a-fA-F][0-9a-fA-F_]*\b/ },
      { match: /\b0b[0-1][0-1_]*\b/ }
    ],
    relevance: 0
  }, d = [
    t.BACKSLASH_ESCAPE,
    a,
    l
  ], u = [
    /!/,
    /\//,
    /\|/,
    /\?/,
    /'/,
    /"/,
    // valid but infrequent and weird
    /#/
    // valid but infrequent and weird
  ], _ = (S, E, h = "\\1") => {
    const T = h === "\\1" ? h : e.concat(h, E);
    return e.concat(
      e.concat("(?:", S, ")"),
      E,
      /(?:\\.|[^\\\/])*?/,
      T,
      /(?:\\.|[^\\\/])*?/,
      h,
      i
    );
  }, m = (S, E, h) => e.concat(
    e.concat("(?:", S, ")"),
    E,
    /(?:\\.|[^\\\/])*?/,
    h,
    i
  ), g = [
    l,
    t.HASH_COMMENT_MODE,
    t.COMMENT(
      /^=\w/,
      /=cut/,
      { endsWithParent: !0 }
    ),
    s,
    {
      className: "string",
      contains: d,
      variants: [
        {
          begin: "q[qwxr]?\\s*\\(",
          end: "\\)",
          relevance: 5
        },
        {
          begin: "q[qwxr]?\\s*\\[",
          end: "\\]",
          relevance: 5
        },
        {
          begin: "q[qwxr]?\\s*\\{",
          end: "\\}",
          relevance: 5
        },
        {
          begin: "q[qwxr]?\\s*\\|",
          end: "\\|",
          relevance: 5
        },
        {
          begin: "q[qwxr]?\\s*<",
          end: ">",
          relevance: 5
        },
        {
          begin: "qw\\s+q",
          end: "q",
          relevance: 5
        },
        {
          begin: "'",
          end: "'",
          contains: [t.BACKSLASH_ESCAPE]
        },
        {
          begin: '"',
          end: '"'
        },
        {
          begin: "`",
          end: "`",
          contains: [t.BACKSLASH_ESCAPE]
        },
        {
          begin: /\{\w+\}/,
          relevance: 0
        },
        {
          begin: "-?\\w+\\s*=>",
          relevance: 0
        }
      ]
    },
    c,
    {
      // regexp container
      begin: "(\\/\\/|" + t.RE_STARTERS_RE + "|\\b(split|return|print|reverse|grep)\\b)\\s*",
      keywords: "split return print reverse grep",
      relevance: 0,
      contains: [
        t.HASH_COMMENT_MODE,
        {
          className: "regexp",
          variants: [
            // allow matching common delimiters
            { begin: _("s|tr|y", e.either(...u, { capture: !0 })) },
            // and then paired delmis
            { begin: _("s|tr|y", "\\(", "\\)") },
            { begin: _("s|tr|y", "\\[", "\\]") },
            { begin: _("s|tr|y", "\\{", "\\}") }
          ],
          relevance: 2
        },
        {
          className: "regexp",
          variants: [
            {
              // could be a comment in many languages so do not count
              // as relevant
              begin: /(m|qr)\/\//,
              relevance: 0
            },
            // prefix is optional with /regex/
            { begin: m("(?:m|qr)?", /\//, /\//) },
            // allow matching common delimiters
            { begin: m("m|qr", e.either(...u, { capture: !0 }), /\1/) },
            // allow common paired delmins
            { begin: m("m|qr", /\(/, /\)/) },
            { begin: m("m|qr", /\[/, /\]/) },
            { begin: m("m|qr", /\{/, /\}/) }
          ]
        }
      ]
    },
    {
      className: "function",
      beginKeywords: "sub method",
      end: "(\\s*\\(.*?\\))?[;{]",
      excludeEnd: !0,
      relevance: 5,
      contains: [t.TITLE_MODE, o]
    },
    {
      className: "class",
      beginKeywords: "class",
      end: "[;{]",
      excludeEnd: !0,
      relevance: 5,
      contains: [t.TITLE_MODE, o, c]
    },
    {
      begin: "-\\w\\b",
      relevance: 0
    },
    {
      begin: "^__DATA__$",
      end: "^__END__$",
      subLanguage: "mojolicious",
      contains: [
        {
          begin: "^@@.*",
          end: "$",
          className: "comment"
        }
      ]
    }
  ];
  return a.contains = g, s.contains = g, {
    name: "Perl",
    aliases: [
      "pl",
      "pm"
    ],
    keywords: r,
    contains: g
  };
}
function Sh(t) {
  const e = t.regex, n = /(?![A-Za-z0-9])(?![$])/, i = e.concat(
    /[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/,
    n
  ), r = e.concat(
    /(\\?[A-Z][a-z0-9_\x7f-\xff]+|\\?[A-Z]+(?=[A-Z][a-z0-9_\x7f-\xff])){1,}/,
    n
  ), a = e.concat(
    /[A-Z]+/,
    n
  ), s = {
    scope: "variable",
    match: "\\$+" + i
  }, o = {
    scope: "meta",
    variants: [
      { begin: /<\?php/, relevance: 10 },
      // boost for obvious PHP
      { begin: /<\?=/ },
      // less relevant per PSR-1 which says not to use short-tags
      { begin: /<\?/, relevance: 0.1 },
      { begin: /\?>/ }
      // end php tag
    ]
  }, l = {
    scope: "subst",
    variants: [
      { begin: /\$\w+/ },
      {
        begin: /\{\$/,
        end: /\}/
      }
    ]
  }, c = t.inherit(t.APOS_STRING_MODE, { illegal: null }), d = t.inherit(t.QUOTE_STRING_MODE, {
    illegal: null,
    contains: t.QUOTE_STRING_MODE.contains.concat(l)
  }), u = {
    begin: /<<<[ \t]*(?:(\w+)|"(\w+)")\n/,
    end: /[ \t]*(\w+)\b/,
    contains: t.QUOTE_STRING_MODE.contains.concat(l),
    "on:begin": (D, L) => {
      L.data._beginMatch = D[1] || D[2];
    },
    "on:end": (D, L) => {
      L.data._beginMatch !== D[1] && L.ignoreMatch();
    }
  }, _ = t.END_SAME_AS_BEGIN({
    begin: /<<<[ \t]*'(\w+)'\n/,
    end: /[ \t]*(\w+)\b/
  }), m = `[ 	
]`, g = {
    scope: "string",
    variants: [
      d,
      c,
      u,
      _
    ]
  }, S = {
    scope: "number",
    variants: [
      { begin: "\\b0[bB][01]+(?:_[01]+)*\\b" },
      // Binary w/ underscore support
      { begin: "\\b0[oO][0-7]+(?:_[0-7]+)*\\b" },
      // Octals w/ underscore support
      { begin: "\\b0[xX][\\da-fA-F]+(?:_[\\da-fA-F]+)*\\b" },
      // Hex w/ underscore support
      // Decimals w/ underscore support, with optional fragments and scientific exponent (e) suffix.
      { begin: "(?:\\b\\d+(?:_\\d+)*(\\.(?:\\d+(?:_\\d+)*))?|\\B\\.\\d+)(?:[eE][+-]?\\d+)?" }
    ],
    relevance: 0
  }, E = [
    "false",
    "null",
    "true"
  ], h = [
    // Magic constants:
    // <https://www.php.net/manual/en/language.constants.predefined.php>
    "__CLASS__",
    "__DIR__",
    "__FILE__",
    "__FUNCTION__",
    "__COMPILER_HALT_OFFSET__",
    "__LINE__",
    "__METHOD__",
    "__NAMESPACE__",
    "__TRAIT__",
    // Function that look like language construct or language construct that look like function:
    // List of keywords that may not require parenthesis
    "die",
    "echo",
    "exit",
    "include",
    "include_once",
    "print",
    "require",
    "require_once",
    // These are not language construct (function) but operate on the currently-executing function and can access the current symbol table
    // 'compact extract func_get_arg func_get_args func_num_args get_called_class get_parent_class ' +
    // Other keywords:
    // <https://www.php.net/manual/en/reserved.php>
    // <https://www.php.net/manual/en/language.types.type-juggling.php>
    "array",
    "abstract",
    "and",
    "as",
    "binary",
    "bool",
    "boolean",
    "break",
    "callable",
    "case",
    "catch",
    "class",
    "clone",
    "const",
    "continue",
    "declare",
    "default",
    "do",
    "double",
    "else",
    "elseif",
    "empty",
    "enddeclare",
    "endfor",
    "endforeach",
    "endif",
    "endswitch",
    "endwhile",
    "enum",
    "eval",
    "extends",
    "final",
    "finally",
    "float",
    "for",
    "foreach",
    "from",
    "global",
    "goto",
    "if",
    "implements",
    "instanceof",
    "insteadof",
    "int",
    "integer",
    "interface",
    "isset",
    "iterable",
    "list",
    "match|0",
    "mixed",
    "new",
    "never",
    "object",
    "or",
    "private",
    "protected",
    "public",
    "readonly",
    "real",
    "return",
    "string",
    "switch",
    "throw",
    "trait",
    "try",
    "unset",
    "use",
    "var",
    "void",
    "while",
    "xor",
    "yield"
  ], T = [
    // Standard PHP library:
    // <https://www.php.net/manual/en/book.spl.php>
    "Error|0",
    "AppendIterator",
    "ArgumentCountError",
    "ArithmeticError",
    "ArrayIterator",
    "ArrayObject",
    "AssertionError",
    "BadFunctionCallException",
    "BadMethodCallException",
    "CachingIterator",
    "CallbackFilterIterator",
    "CompileError",
    "Countable",
    "DirectoryIterator",
    "DivisionByZeroError",
    "DomainException",
    "EmptyIterator",
    "ErrorException",
    "Exception",
    "FilesystemIterator",
    "FilterIterator",
    "GlobIterator",
    "InfiniteIterator",
    "InvalidArgumentException",
    "IteratorIterator",
    "LengthException",
    "LimitIterator",
    "LogicException",
    "MultipleIterator",
    "NoRewindIterator",
    "OutOfBoundsException",
    "OutOfRangeException",
    "OuterIterator",
    "OverflowException",
    "ParentIterator",
    "ParseError",
    "RangeException",
    "RecursiveArrayIterator",
    "RecursiveCachingIterator",
    "RecursiveCallbackFilterIterator",
    "RecursiveDirectoryIterator",
    "RecursiveFilterIterator",
    "RecursiveIterator",
    "RecursiveIteratorIterator",
    "RecursiveRegexIterator",
    "RecursiveTreeIterator",
    "RegexIterator",
    "RuntimeException",
    "SeekableIterator",
    "SplDoublyLinkedList",
    "SplFileInfo",
    "SplFileObject",
    "SplFixedArray",
    "SplHeap",
    "SplMaxHeap",
    "SplMinHeap",
    "SplObjectStorage",
    "SplObserver",
    "SplPriorityQueue",
    "SplQueue",
    "SplStack",
    "SplSubject",
    "SplTempFileObject",
    "TypeError",
    "UnderflowException",
    "UnexpectedValueException",
    "UnhandledMatchError",
    // Reserved interfaces:
    // <https://www.php.net/manual/en/reserved.interfaces.php>
    "ArrayAccess",
    "BackedEnum",
    "Closure",
    "Fiber",
    "Generator",
    "Iterator",
    "IteratorAggregate",
    "Serializable",
    "Stringable",
    "Throwable",
    "Traversable",
    "UnitEnum",
    "WeakReference",
    "WeakMap",
    // Reserved classes:
    // <https://www.php.net/manual/en/reserved.classes.php>
    "Directory",
    "__PHP_Incomplete_Class",
    "parent",
    "php_user_filter",
    "self",
    "static",
    "stdClass"
  ], C = {
    keyword: h,
    literal: ((D) => {
      const L = [];
      return D.forEach((G) => {
        L.push(G), G.toLowerCase() === G ? L.push(G.toUpperCase()) : L.push(G.toLowerCase());
      }), L;
    })(E),
    built_in: T
  }, y = (D) => D.map((L) => L.replace(/\|\d+$/, "")), O = { variants: [
    {
      match: [
        /new/,
        e.concat(m, "+"),
        // to prevent built ins from being confused as the class constructor call
        e.concat("(?!", y(T).join("\\b|"), "\\b)"),
        r
      ],
      scope: {
        1: "keyword",
        4: "title.class"
      }
    }
  ] }, A = e.concat(i, "\\b(?!\\()"), I = { variants: [
    {
      match: [
        e.concat(
          /::/,
          e.lookahead(/(?!class\b)/)
        ),
        A
      ],
      scope: { 2: "variable.constant" }
    },
    {
      match: [
        /::/,
        /class/
      ],
      scope: { 2: "variable.language" }
    },
    {
      match: [
        r,
        e.concat(
          /::/,
          e.lookahead(/(?!class\b)/)
        ),
        A
      ],
      scope: {
        1: "title.class",
        3: "variable.constant"
      }
    },
    {
      match: [
        r,
        e.concat(
          "::",
          e.lookahead(/(?!class\b)/)
        )
      ],
      scope: { 1: "title.class" }
    },
    {
      match: [
        r,
        /::/,
        /class/
      ],
      scope: {
        1: "title.class",
        3: "variable.language"
      }
    }
  ] }, k = {
    scope: "attr",
    match: e.concat(i, e.lookahead(":"), e.lookahead(/(?!::)/))
  }, x = {
    relevance: 0,
    begin: /\(/,
    end: /\)/,
    keywords: C,
    contains: [
      k,
      s,
      I,
      t.C_BLOCK_COMMENT_MODE,
      g,
      S,
      O
    ]
  }, B = {
    relevance: 0,
    match: [
      /\b/,
      // to prevent keywords from being confused as the function title
      e.concat("(?!fn\\b|function\\b|", y(h).join("\\b|"), "|", y(T).join("\\b|"), "\\b)"),
      i,
      e.concat(m, "*"),
      e.lookahead(/(?=\()/)
    ],
    scope: { 3: "title.function.invoke" },
    contains: [x]
  };
  x.contains.push(B);
  const X = [
    k,
    I,
    t.C_BLOCK_COMMENT_MODE,
    g,
    S,
    O
  ], J = {
    begin: e.concat(
      /#\[\s*\\?/,
      e.either(
        r,
        a
      )
    ),
    beginScope: "meta",
    end: /]/,
    endScope: "meta",
    keywords: {
      literal: E,
      keyword: [
        "new",
        "array"
      ]
    },
    contains: [
      {
        begin: /\[/,
        end: /]/,
        keywords: {
          literal: E,
          keyword: [
            "new",
            "array"
          ]
        },
        contains: [
          "self",
          ...X
        ]
      },
      ...X,
      {
        scope: "meta",
        variants: [
          { match: r },
          { match: a }
        ]
      }
    ]
  };
  return {
    case_insensitive: !1,
    keywords: C,
    contains: [
      J,
      t.HASH_COMMENT_MODE,
      t.COMMENT("//", "$"),
      t.COMMENT(
        "/\\*",
        "\\*/",
        { contains: [
          {
            scope: "doctag",
            match: "@[A-Za-z]+"
          }
        ] }
      ),
      {
        match: /__halt_compiler\(\);/,
        keywords: "__halt_compiler",
        starts: {
          scope: "comment",
          end: t.MATCH_NOTHING_RE,
          contains: [
            {
              match: /\?>/,
              scope: "meta",
              endsParent: !0
            }
          ]
        }
      },
      o,
      {
        scope: "variable.language",
        match: /\$this\b/
      },
      s,
      B,
      I,
      {
        match: [
          /const/,
          /\s/,
          i
        ],
        scope: {
          1: "keyword",
          3: "variable.constant"
        }
      },
      O,
      {
        scope: "function",
        relevance: 0,
        beginKeywords: "fn function",
        end: /[;{]/,
        excludeEnd: !0,
        illegal: "[$%\\[]",
        contains: [
          { beginKeywords: "use" },
          t.UNDERSCORE_TITLE_MODE,
          {
            begin: "=>",
            // No markup, just a relevance booster
            endsParent: !0
          },
          {
            scope: "params",
            begin: "\\(",
            end: "\\)",
            excludeBegin: !0,
            excludeEnd: !0,
            keywords: C,
            contains: [
              "self",
              J,
              s,
              I,
              t.C_BLOCK_COMMENT_MODE,
              g,
              S
            ]
          }
        ]
      },
      {
        scope: "class",
        variants: [
          {
            beginKeywords: "enum",
            illegal: /[($"]/
          },
          {
            beginKeywords: "class interface trait",
            illegal: /[:($"]/
          }
        ],
        relevance: 0,
        end: /\{/,
        excludeEnd: !0,
        contains: [
          { beginKeywords: "extends implements" },
          t.UNDERSCORE_TITLE_MODE
        ]
      },
      // both use and namespace still use "old style" rules (vs multi-match)
      // because the namespace name can include `\` and we still want each
      // element to be treated as its own *individual* title
      {
        beginKeywords: "namespace",
        relevance: 0,
        end: ";",
        illegal: /[.']/,
        contains: [t.inherit(t.UNDERSCORE_TITLE_MODE, { scope: "title.class" })]
      },
      {
        beginKeywords: "use",
        relevance: 0,
        end: ";",
        contains: [
          // TODO: title.function vs title.class
          {
            match: /\b(as|const|function)\b/,
            scope: "keyword"
          },
          // TODO: could be title.class or title.function
          t.UNDERSCORE_TITLE_MODE
        ]
      },
      g,
      S
    ]
  };
}
function hh(t) {
  return {
    name: "PHP template",
    subLanguage: "xml",
    contains: [
      {
        begin: /<\?(php|=)?/,
        end: /\?>/,
        subLanguage: "php",
        contains: [
          // We don't want the php closing tag ?> to close the PHP block when
          // inside any of the following blocks:
          {
            begin: "/\\*",
            end: "\\*/",
            skip: !0
          },
          {
            begin: 'b"',
            end: '"',
            skip: !0
          },
          {
            begin: "b'",
            end: "'",
            skip: !0
          },
          t.inherit(t.APOS_STRING_MODE, {
            illegal: null,
            className: null,
            contains: null,
            skip: !0
          }),
          t.inherit(t.QUOTE_STRING_MODE, {
            illegal: null,
            className: null,
            contains: null,
            skip: !0
          })
        ]
      }
    ]
  };
}
function fh(t) {
  return {
    name: "Plain text",
    aliases: [
      "text",
      "txt"
    ],
    disableAutodetect: !0
  };
}
function Th(t) {
  const e = t.regex, n = new RegExp("[\\p{XID_Start}_]\\p{XID_Continue}*", "u"), i = [
    "and",
    "as",
    "assert",
    "async",
    "await",
    "break",
    "case",
    "class",
    "continue",
    "def",
    "del",
    "elif",
    "else",
    "except",
    "finally",
    "for",
    "from",
    "global",
    "if",
    "import",
    "in",
    "is",
    "lambda",
    "match",
    "nonlocal|10",
    "not",
    "or",
    "pass",
    "raise",
    "return",
    "try",
    "while",
    "with",
    "yield"
  ], o = {
    $pattern: /[A-Za-z]\w+|__\w+__/,
    keyword: i,
    built_in: [
      "__import__",
      "abs",
      "all",
      "any",
      "ascii",
      "bin",
      "bool",
      "breakpoint",
      "bytearray",
      "bytes",
      "callable",
      "chr",
      "classmethod",
      "compile",
      "complex",
      "delattr",
      "dict",
      "dir",
      "divmod",
      "enumerate",
      "eval",
      "exec",
      "filter",
      "float",
      "format",
      "frozenset",
      "getattr",
      "globals",
      "hasattr",
      "hash",
      "help",
      "hex",
      "id",
      "input",
      "int",
      "isinstance",
      "issubclass",
      "iter",
      "len",
      "list",
      "locals",
      "map",
      "max",
      "memoryview",
      "min",
      "next",
      "object",
      "oct",
      "open",
      "ord",
      "pow",
      "print",
      "property",
      "range",
      "repr",
      "reversed",
      "round",
      "set",
      "setattr",
      "slice",
      "sorted",
      "staticmethod",
      "str",
      "sum",
      "super",
      "tuple",
      "type",
      "vars",
      "zip"
    ],
    literal: [
      "__debug__",
      "Ellipsis",
      "False",
      "None",
      "NotImplemented",
      "True"
    ],
    type: [
      "Any",
      "Callable",
      "Coroutine",
      "Dict",
      "List",
      "Literal",
      "Generic",
      "Optional",
      "Sequence",
      "Set",
      "Tuple",
      "Type",
      "Union"
    ]
  }, l = {
    className: "meta",
    begin: /^(>>>|\.\.\.) /
  }, c = {
    className: "subst",
    begin: /\{/,
    end: /\}/,
    keywords: o,
    illegal: /#/
  }, d = {
    begin: /\{\{/,
    relevance: 0
  }, u = {
    className: "string",
    contains: [t.BACKSLASH_ESCAPE],
    variants: [
      {
        begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?'''/,
        end: /'''/,
        contains: [
          t.BACKSLASH_ESCAPE,
          l
        ],
        relevance: 10
      },
      {
        begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?"""/,
        end: /"""/,
        contains: [
          t.BACKSLASH_ESCAPE,
          l
        ],
        relevance: 10
      },
      {
        begin: /([fF][rR]|[rR][fF]|[fF])'''/,
        end: /'''/,
        contains: [
          t.BACKSLASH_ESCAPE,
          l,
          d,
          c
        ]
      },
      {
        begin: /([fF][rR]|[rR][fF]|[fF])"""/,
        end: /"""/,
        contains: [
          t.BACKSLASH_ESCAPE,
          l,
          d,
          c
        ]
      },
      {
        begin: /([uU]|[rR])'/,
        end: /'/,
        relevance: 10
      },
      {
        begin: /([uU]|[rR])"/,
        end: /"/,
        relevance: 10
      },
      {
        begin: /([bB]|[bB][rR]|[rR][bB])'/,
        end: /'/
      },
      {
        begin: /([bB]|[bB][rR]|[rR][bB])"/,
        end: /"/
      },
      {
        begin: /([fF][rR]|[rR][fF]|[fF])'/,
        end: /'/,
        contains: [
          t.BACKSLASH_ESCAPE,
          d,
          c
        ]
      },
      {
        begin: /([fF][rR]|[rR][fF]|[fF])"/,
        end: /"/,
        contains: [
          t.BACKSLASH_ESCAPE,
          d,
          c
        ]
      },
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE
    ]
  }, _ = "[0-9](_?[0-9])*", m = `(\\b(${_}))?\\.(${_})|\\b(${_})\\.`, g = `\\b|${i.join("|")}`, S = {
    className: "number",
    relevance: 0,
    variants: [
      // exponentfloat, pointfloat
      // https://docs.python.org/3.9/reference/lexical_analysis.html#floating-point-literals
      // optionally imaginary
      // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
      // Note: no leading \b because floats can start with a decimal point
      // and we don't want to mishandle e.g. `fn(.5)`,
      // no trailing \b for pointfloat because it can end with a decimal point
      // and we don't want to mishandle e.g. `0..hex()`; this should be safe
      // because both MUST contain a decimal point and so cannot be confused with
      // the interior part of an identifier
      {
        begin: `(\\b(${_})|(${m}))[eE][+-]?(${_})[jJ]?(?=${g})`
      },
      {
        begin: `(${m})[jJ]?`
      },
      // decinteger, bininteger, octinteger, hexinteger
      // https://docs.python.org/3.9/reference/lexical_analysis.html#integer-literals
      // optionally "long" in Python 2
      // https://docs.python.org/2.7/reference/lexical_analysis.html#integer-and-long-integer-literals
      // decinteger is optionally imaginary
      // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
      {
        begin: `\\b([1-9](_?[0-9])*|0+(_?0)*)[lLjJ]?(?=${g})`
      },
      {
        begin: `\\b0[bB](_?[01])+[lL]?(?=${g})`
      },
      {
        begin: `\\b0[oO](_?[0-7])+[lL]?(?=${g})`
      },
      {
        begin: `\\b0[xX](_?[0-9a-fA-F])+[lL]?(?=${g})`
      },
      // imagnumber (digitpart-based)
      // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
      {
        begin: `\\b(${_})[jJ](?=${g})`
      }
    ]
  }, E = {
    className: "comment",
    begin: e.lookahead(/# type:/),
    end: /$/,
    keywords: o,
    contains: [
      {
        // prevent keywords from coloring `type`
        begin: /# type:/
      },
      // comment within a datatype comment includes no keywords
      {
        begin: /#/,
        end: /\b\B/,
        endsWithParent: !0
      }
    ]
  }, h = {
    className: "params",
    variants: [
      // Exclude params in functions without params
      {
        className: "",
        begin: /\(\s*\)/,
        skip: !0
      },
      {
        begin: /\(/,
        end: /\)/,
        excludeBegin: !0,
        excludeEnd: !0,
        keywords: o,
        contains: [
          "self",
          l,
          S,
          u,
          t.HASH_COMMENT_MODE
        ]
      }
    ]
  };
  return c.contains = [
    u,
    S,
    l
  ], {
    name: "Python",
    aliases: [
      "py",
      "gyp",
      "ipython"
    ],
    unicodeRegex: !0,
    keywords: o,
    illegal: /(<\/|\?)|=>/,
    contains: [
      l,
      S,
      {
        // very common convention
        scope: "variable.language",
        match: /\bself\b/
      },
      {
        // eat "if" prior to string so that it won't accidentally be
        // labeled as an f-string
        beginKeywords: "if",
        relevance: 0
      },
      { match: /\bor\b/, scope: "keyword" },
      u,
      E,
      t.HASH_COMMENT_MODE,
      {
        match: [
          /\bdef/,
          /\s+/,
          n
        ],
        scope: {
          1: "keyword",
          3: "title.function"
        },
        contains: [h]
      },
      {
        variants: [
          {
            match: [
              /\bclass/,
              /\s+/,
              n,
              /\s*/,
              /\(\s*/,
              n,
              /\s*\)/
            ]
          },
          {
            match: [
              /\bclass/,
              /\s+/,
              n
            ]
          }
        ],
        scope: {
          1: "keyword",
          3: "title.class",
          6: "title.class.inherited"
        }
      },
      {
        className: "meta",
        begin: /^[\t ]*@/,
        end: /(?=#)|$/,
        contains: [
          S,
          h,
          u
        ]
      }
    ]
  };
}
function bh(t) {
  return {
    aliases: ["pycon"],
    contains: [
      {
        className: "meta.prompt",
        starts: {
          // a space separates the REPL prefix from the actual code
          // this is purely for cleaner HTML output
          end: / |$/,
          starts: {
            end: "$",
            subLanguage: "python"
          }
        },
        variants: [
          { begin: /^>>>(?=[ ]|$)/ },
          { begin: /^\.\.\.(?=[ ]|$)/ }
        ]
      }
    ]
  };
}
function Ch(t) {
  const e = t.regex, n = /(?:(?:[a-zA-Z]|\.[._a-zA-Z])[._a-zA-Z0-9]*)|\.(?!\d)/, i = e.either(
    // Special case: only hexadecimal binary powers can contain fractions
    /0[xX][0-9a-fA-F]+\.[0-9a-fA-F]*[pP][+-]?\d+i?/,
    // Hexadecimal numbers without fraction and optional binary power
    /0[xX][0-9a-fA-F]+(?:[pP][+-]?\d+)?[Li]?/,
    // Decimal numbers
    /(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?[Li]?/
  ), r = /[=!<>:]=|\|\||&&|:::?|<-|<<-|->>|->|\|>|[-+*\/?!$&|:<=>@^~]|\*\*/, a = e.either(
    /[()]/,
    /[{}]/,
    /\[\[/,
    /[[\]]/,
    /\\/,
    /,/
  );
  return {
    name: "R",
    keywords: {
      $pattern: n,
      keyword: "function if in break next repeat else for while",
      literal: "NULL NA TRUE FALSE Inf NaN NA_integer_|10 NA_real_|10 NA_character_|10 NA_complex_|10",
      built_in: (
        // Builtin constants
        "LETTERS letters month.abb month.name pi T F abs acos acosh all any anyNA Arg as.call as.character as.complex as.double as.environment as.integer as.logical as.null.default as.numeric as.raw asin asinh atan atanh attr attributes baseenv browser c call ceiling class Conj cos cosh cospi cummax cummin cumprod cumsum digamma dim dimnames emptyenv exp expression floor forceAndCall gamma gc.time globalenv Im interactive invisible is.array is.atomic is.call is.character is.complex is.double is.environment is.expression is.finite is.function is.infinite is.integer is.language is.list is.logical is.matrix is.na is.name is.nan is.null is.numeric is.object is.pairlist is.raw is.recursive is.single is.symbol lazyLoadDBfetch length lgamma list log max min missing Mod names nargs nzchar oldClass on.exit pos.to.env proc.time prod quote range Re rep retracemem return round seq_along seq_len seq.int sign signif sin sinh sinpi sqrt standardGeneric substitute sum switch tan tanh tanpi tracemem trigamma trunc unclass untracemem UseMethod xtfrm"
      )
    },
    contains: [
      // Roxygen comments
      t.COMMENT(
        /#'/,
        /$/,
        { contains: [
          {
            // Handle `@examples` separately to cause all subsequent code
            // until the next `@`-tag on its own line to be kept as-is,
            // preventing highlighting. This code is example R code, so nested
            // doctags shouldn’t be treated as such. See
            // `test/markup/r/roxygen.txt` for an example.
            scope: "doctag",
            match: /@examples/,
            starts: {
              end: e.lookahead(e.either(
                // end if another doc comment
                /\n^#'\s*(?=@[a-zA-Z]+)/,
                // or a line with no comment
                /\n^(?!#')/
              )),
              endsParent: !0
            }
          },
          {
            // Handle `@param` to highlight the parameter name following
            // after.
            scope: "doctag",
            begin: "@param",
            end: /$/,
            contains: [
              {
                scope: "variable",
                variants: [
                  { match: n },
                  { match: /`(?:\\.|[^`\\])+`/ }
                ],
                endsParent: !0
              }
            ]
          },
          {
            scope: "doctag",
            match: /@[a-zA-Z]+/
          },
          {
            scope: "keyword",
            match: /\\[a-zA-Z]+/
          }
        ] }
      ),
      t.HASH_COMMENT_MODE,
      {
        scope: "string",
        contains: [t.BACKSLASH_ESCAPE],
        variants: [
          t.END_SAME_AS_BEGIN({
            begin: /[rR]"(-*)\(/,
            end: /\)(-*)"/
          }),
          t.END_SAME_AS_BEGIN({
            begin: /[rR]"(-*)\{/,
            end: /\}(-*)"/
          }),
          t.END_SAME_AS_BEGIN({
            begin: /[rR]"(-*)\[/,
            end: /\](-*)"/
          }),
          t.END_SAME_AS_BEGIN({
            begin: /[rR]'(-*)\(/,
            end: /\)(-*)'/
          }),
          t.END_SAME_AS_BEGIN({
            begin: /[rR]'(-*)\{/,
            end: /\}(-*)'/
          }),
          t.END_SAME_AS_BEGIN({
            begin: /[rR]'(-*)\[/,
            end: /\](-*)'/
          }),
          {
            begin: '"',
            end: '"',
            relevance: 0
          },
          {
            begin: "'",
            end: "'",
            relevance: 0
          }
        ]
      },
      // Matching numbers immediately following punctuation and operators is
      // tricky since we need to look at the character ahead of a number to
      // ensure the number is not part of an identifier, and we cannot use
      // negative look-behind assertions. So instead we explicitly handle all
      // possible combinations of (operator|punctuation), number.
      // TODO: replace with negative look-behind when available
      // { begin: /(?<![a-zA-Z0-9._])0[xX][0-9a-fA-F]+\.[0-9a-fA-F]*[pP][+-]?\d+i?/ },
      // { begin: /(?<![a-zA-Z0-9._])0[xX][0-9a-fA-F]+([pP][+-]?\d+)?[Li]?/ },
      // { begin: /(?<![a-zA-Z0-9._])(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?[Li]?/ }
      {
        relevance: 0,
        variants: [
          {
            scope: {
              1: "operator",
              2: "number"
            },
            match: [
              r,
              i
            ]
          },
          {
            scope: {
              1: "operator",
              2: "number"
            },
            match: [
              /%[^%]*%/,
              i
            ]
          },
          {
            scope: {
              1: "punctuation",
              2: "number"
            },
            match: [
              a,
              i
            ]
          },
          {
            scope: { 2: "number" },
            match: [
              /[^a-zA-Z0-9._]|^/,
              // not part of an identifier, or start of document
              i
            ]
          }
        ]
      },
      // Operators/punctuation when they're not directly followed by numbers
      {
        // Relevance boost for the most common assignment form.
        scope: { 3: "operator" },
        match: [
          n,
          /\s+/,
          /<-/,
          /\s+/
        ]
      },
      {
        scope: "operator",
        relevance: 0,
        variants: [
          { match: r },
          { match: /%[^%]*%/ }
        ]
      },
      {
        scope: "punctuation",
        relevance: 0,
        match: a
      },
      {
        // Escaped identifier
        begin: "`",
        end: "`",
        contains: [{ begin: /\\./ }]
      }
    ]
  };
}
function yh(t) {
  const e = t.regex, n = "([a-zA-Z_]\\w*[!?=]?|[-+~]@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?)", i = e.either(
    /\b([A-Z]+[a-z0-9]+)+/,
    // ends in caps
    /\b([A-Z]+[a-z0-9]+)+[A-Z]+/
  ), r = e.concat(i, /(::\w+)*/), s = {
    "variable.constant": [
      "__FILE__",
      "__LINE__",
      "__ENCODING__"
    ],
    "variable.language": [
      "self",
      "super"
    ],
    keyword: [
      "alias",
      "and",
      "begin",
      "BEGIN",
      "break",
      "case",
      "class",
      "defined",
      "do",
      "else",
      "elsif",
      "end",
      "END",
      "ensure",
      "for",
      "if",
      "in",
      "module",
      "next",
      "not",
      "or",
      "redo",
      "require",
      "rescue",
      "retry",
      "return",
      "then",
      "undef",
      "unless",
      "until",
      "when",
      "while",
      "yield",
      ...[
        "include",
        "extend",
        "prepend",
        "public",
        "private",
        "protected",
        "raise",
        "throw"
      ]
    ],
    built_in: [
      "proc",
      "lambda",
      "attr_accessor",
      "attr_reader",
      "attr_writer",
      "define_method",
      "private_constant",
      "module_function"
    ],
    literal: [
      "true",
      "false",
      "nil"
    ]
  }, o = {
    className: "doctag",
    begin: "@[A-Za-z]+"
  }, l = {
    begin: "#<",
    end: ">"
  }, c = [
    t.COMMENT(
      "#",
      "$",
      { contains: [o] }
    ),
    t.COMMENT(
      "^=begin",
      "^=end",
      {
        contains: [o],
        relevance: 10
      }
    ),
    t.COMMENT("^__END__", t.MATCH_NOTHING_RE)
  ], d = {
    className: "subst",
    begin: /#\{/,
    end: /\}/,
    keywords: s
  }, u = {
    className: "string",
    contains: [
      t.BACKSLASH_ESCAPE,
      d
    ],
    variants: [
      {
        begin: /'/,
        end: /'/
      },
      {
        begin: /"/,
        end: /"/
      },
      {
        begin: /`/,
        end: /`/
      },
      {
        begin: /%[qQwWx]?\(/,
        end: /\)/
      },
      {
        begin: /%[qQwWx]?\[/,
        end: /\]/
      },
      {
        begin: /%[qQwWx]?\{/,
        end: /\}/
      },
      {
        begin: /%[qQwWx]?</,
        end: />/
      },
      {
        begin: /%[qQwWx]?\//,
        end: /\//
      },
      {
        begin: /%[qQwWx]?%/,
        end: /%/
      },
      {
        begin: /%[qQwWx]?-/,
        end: /-/
      },
      {
        begin: /%[qQwWx]?\|/,
        end: /\|/
      },
      // in the following expressions, \B in the beginning suppresses recognition of ?-sequences
      // where ? is the last character of a preceding identifier, as in: `func?4`
      { begin: /\B\?(\\\d{1,3})/ },
      { begin: /\B\?(\\x[A-Fa-f0-9]{1,2})/ },
      { begin: /\B\?(\\u\{?[A-Fa-f0-9]{1,6}\}?)/ },
      { begin: /\B\?(\\M-\\C-|\\M-\\c|\\c\\M-|\\M-|\\C-\\M-)[\x20-\x7e]/ },
      { begin: /\B\?\\(c|C-)[\x20-\x7e]/ },
      { begin: /\B\?\\?\S/ },
      // heredocs
      {
        // this guard makes sure that we have an entire heredoc and not a false
        // positive (auto-detect, etc.)
        begin: e.concat(
          /<<[-~]?'?/,
          e.lookahead(/(\w+)(?=\W)[^\n]*\n(?:[^\n]*\n)*?\s*\1\b/)
        ),
        contains: [
          t.END_SAME_AS_BEGIN({
            begin: /(\w+)/,
            end: /(\w+)/,
            contains: [
              t.BACKSLASH_ESCAPE,
              d
            ]
          })
        ]
      }
    ]
  }, _ = "[1-9](_?[0-9])*|0", m = "[0-9](_?[0-9])*", g = {
    className: "number",
    relevance: 0,
    variants: [
      // decimal integer/float, optionally exponential or rational, optionally imaginary
      { begin: `\\b(${_})(\\.(${m}))?([eE][+-]?(${m})|r)?i?\\b` },
      // explicit decimal/binary/octal/hexadecimal integer,
      // optionally rational and/or imaginary
      { begin: "\\b0[dD][0-9](_?[0-9])*r?i?\\b" },
      { begin: "\\b0[bB][0-1](_?[0-1])*r?i?\\b" },
      { begin: "\\b0[oO][0-7](_?[0-7])*r?i?\\b" },
      { begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*r?i?\\b" },
      // 0-prefixed implicit octal integer, optionally rational and/or imaginary
      { begin: "\\b0(_?[0-7])+r?i?\\b" }
    ]
  }, S = {
    variants: [
      {
        match: /\(\)/
      },
      {
        className: "params",
        begin: /\(/,
        end: /(?=\))/,
        excludeBegin: !0,
        endsParent: !0,
        keywords: s
      }
    ]
  }, O = [
    u,
    {
      variants: [
        {
          match: [
            /class\s+/,
            r,
            /\s+<\s+/,
            r
          ]
        },
        {
          match: [
            /\b(class|module)\s+/,
            r
          ]
        }
      ],
      scope: {
        2: "title.class",
        4: "title.class.inherited"
      },
      keywords: s
    },
    {
      match: [
        /(include|extend)\s+/,
        r
      ],
      scope: {
        2: "title.class"
      },
      keywords: s
    },
    {
      relevance: 0,
      match: [
        r,
        /\.new[. (]/
      ],
      scope: {
        1: "title.class"
      }
    },
    {
      relevance: 0,
      match: /\b[A-Z][A-Z_0-9]+\b/,
      className: "variable.constant"
    },
    {
      relevance: 0,
      match: i,
      scope: "title.class"
    },
    {
      match: [
        /def/,
        /\s+/,
        n
      ],
      scope: {
        1: "keyword",
        3: "title.function"
      },
      contains: [
        S
      ]
    },
    {
      // swallow namespace qualifiers before symbols
      begin: t.IDENT_RE + "::"
    },
    {
      className: "symbol",
      begin: t.UNDERSCORE_IDENT_RE + "(!|\\?)?:",
      relevance: 0
    },
    {
      className: "symbol",
      begin: ":(?!\\s)",
      contains: [
        u,
        { begin: n }
      ],
      relevance: 0
    },
    g,
    {
      // negative-look forward attempts to prevent false matches like:
      // @ident@ or $ident$ that might indicate this is not ruby at all
      className: "variable",
      begin: "(\\$\\W)|((\\$|@@?)(\\w+))(?=[^@$?])(?![A-Za-z])(?![@$?'])"
    },
    {
      className: "params",
      begin: /\|(?!=)/,
      end: /\|/,
      excludeBegin: !0,
      excludeEnd: !0,
      relevance: 0,
      // this could be a lot of things (in other languages) other than params
      keywords: s
    },
    {
      // regexp container
      begin: "(" + t.RE_STARTERS_RE + "|unless)\\s*",
      keywords: "unless",
      contains: [
        {
          className: "regexp",
          contains: [
            t.BACKSLASH_ESCAPE,
            d
          ],
          illegal: /\n/,
          variants: [
            {
              begin: "/",
              end: "/[a-z]*"
            },
            {
              begin: /%r\{/,
              end: /\}[a-z]*/
            },
            {
              begin: "%r\\(",
              end: "\\)[a-z]*"
            },
            {
              begin: "%r!",
              end: "![a-z]*"
            },
            {
              begin: "%r\\[",
              end: "\\][a-z]*"
            }
          ]
        }
      ].concat(l, c),
      relevance: 0
    }
  ].concat(l, c);
  d.contains = O, S.contains = O;
  const x = [
    {
      begin: /^\s*=>/,
      starts: {
        end: "$",
        contains: O
      }
    },
    {
      className: "meta.prompt",
      begin: "^(" + "[>?]>" + "|" + "[\\w#]+\\(\\w+\\):\\d+:\\d+[>*]" + "|" + "(\\w+-)?\\d+\\.\\d+\\.\\d+(p\\d+)?[^\\d][^>]+>" + ")(?=[ ])",
      starts: {
        end: "$",
        keywords: s,
        contains: O
      }
    }
  ];
  return c.unshift(l), {
    name: "Ruby",
    aliases: [
      "rb",
      "gemspec",
      "podspec",
      "thor",
      "irb"
    ],
    keywords: s,
    illegal: /\/\*/,
    contains: [t.SHEBANG({ binary: "ruby" })].concat(x).concat(c).concat(O)
  };
}
function Rh(t) {
  const e = t.regex, n = /(r#)?/, i = e.concat(n, t.UNDERSCORE_IDENT_RE), r = e.concat(n, t.IDENT_RE), a = {
    className: "title.function.invoke",
    relevance: 0,
    begin: e.concat(
      /\b/,
      /(?!let|for|while|if|else|match\b)/,
      r,
      e.lookahead(/\s*\(/)
    )
  }, s = "([ui](8|16|32|64|128|size)|f(32|64))?", o = [
    "abstract",
    "as",
    "async",
    "await",
    "become",
    "box",
    "break",
    "const",
    "continue",
    "crate",
    "do",
    "dyn",
    "else",
    "enum",
    "extern",
    "false",
    "final",
    "fn",
    "for",
    "if",
    "impl",
    "in",
    "let",
    "loop",
    "macro",
    "match",
    "mod",
    "move",
    "mut",
    "override",
    "priv",
    "pub",
    "ref",
    "return",
    "self",
    "Self",
    "static",
    "struct",
    "super",
    "trait",
    "true",
    "try",
    "type",
    "typeof",
    "union",
    "unsafe",
    "unsized",
    "use",
    "virtual",
    "where",
    "while",
    "yield"
  ], l = [
    "true",
    "false",
    "Some",
    "None",
    "Ok",
    "Err"
  ], c = [
    // functions
    "drop ",
    // traits
    "Copy",
    "Send",
    "Sized",
    "Sync",
    "Drop",
    "Fn",
    "FnMut",
    "FnOnce",
    "ToOwned",
    "Clone",
    "Debug",
    "PartialEq",
    "PartialOrd",
    "Eq",
    "Ord",
    "AsRef",
    "AsMut",
    "Into",
    "From",
    "Default",
    "Iterator",
    "Extend",
    "IntoIterator",
    "DoubleEndedIterator",
    "ExactSizeIterator",
    "SliceConcatExt",
    "ToString",
    // macros
    "assert!",
    "assert_eq!",
    "bitflags!",
    "bytes!",
    "cfg!",
    "col!",
    "concat!",
    "concat_idents!",
    "debug_assert!",
    "debug_assert_eq!",
    "env!",
    "eprintln!",
    "panic!",
    "file!",
    "format!",
    "format_args!",
    "include_bytes!",
    "include_str!",
    "line!",
    "local_data_key!",
    "module_path!",
    "option_env!",
    "print!",
    "println!",
    "select!",
    "stringify!",
    "try!",
    "unimplemented!",
    "unreachable!",
    "vec!",
    "write!",
    "writeln!",
    "macro_rules!",
    "assert_ne!",
    "debug_assert_ne!"
  ], d = [
    "i8",
    "i16",
    "i32",
    "i64",
    "i128",
    "isize",
    "u8",
    "u16",
    "u32",
    "u64",
    "u128",
    "usize",
    "f32",
    "f64",
    "str",
    "char",
    "bool",
    "Box",
    "Option",
    "Result",
    "String",
    "Vec"
  ];
  return {
    name: "Rust",
    aliases: ["rs"],
    keywords: {
      $pattern: t.IDENT_RE + "!?",
      type: d,
      keyword: o,
      literal: l,
      built_in: c
    },
    illegal: "</",
    contains: [
      t.C_LINE_COMMENT_MODE,
      t.COMMENT("/\\*", "\\*/", { contains: ["self"] }),
      t.inherit(t.QUOTE_STRING_MODE, {
        begin: /b?"/,
        illegal: null
      }),
      {
        className: "symbol",
        // negative lookahead to avoid matching `'`
        begin: /'[a-zA-Z_][a-zA-Z0-9_]*(?!')/
      },
      {
        scope: "string",
        variants: [
          { begin: /b?r(#*)"(.|\n)*?"\1(?!#)/ },
          {
            begin: /b?'/,
            end: /'/,
            contains: [
              {
                scope: "char.escape",
                match: /\\('|\w|x\w{2}|u\w{4}|U\w{8})/
              }
            ]
          }
        ]
      },
      {
        className: "number",
        variants: [
          { begin: "\\b0b([01_]+)" + s },
          { begin: "\\b0o([0-7_]+)" + s },
          { begin: "\\b0x([A-Fa-f0-9_]+)" + s },
          { begin: "\\b(\\d[\\d_]*(\\.[0-9_]+)?([eE][+-]?[0-9_]+)?)" + s }
        ],
        relevance: 0
      },
      {
        begin: [
          /fn/,
          /\s+/,
          i
        ],
        className: {
          1: "keyword",
          3: "title.function"
        }
      },
      {
        className: "meta",
        begin: "#!?\\[",
        end: "\\]",
        contains: [
          {
            className: "string",
            begin: /"/,
            end: /"/,
            contains: [
              t.BACKSLASH_ESCAPE
            ]
          }
        ]
      },
      {
        begin: [
          /let/,
          /\s+/,
          /(?:mut\s+)?/,
          i
        ],
        className: {
          1: "keyword",
          3: "keyword",
          4: "variable"
        }
      },
      // must come before impl/for rule later
      {
        begin: [
          /for/,
          /\s+/,
          i,
          /\s+/,
          /in/
        ],
        className: {
          1: "keyword",
          3: "variable",
          5: "keyword"
        }
      },
      {
        begin: [
          /type/,
          /\s+/,
          i
        ],
        className: {
          1: "keyword",
          3: "title.class"
        }
      },
      {
        begin: [
          /(?:trait|enum|struct|union|impl|for)/,
          /\s+/,
          i
        ],
        className: {
          1: "keyword",
          3: "title.class"
        }
      },
      {
        begin: t.IDENT_RE + "::",
        keywords: {
          keyword: "Self",
          built_in: c,
          type: d
        }
      },
      {
        className: "punctuation",
        begin: "->"
      },
      a
    ]
  };
}
const Nh = (t) => ({
  IMPORTANT: {
    scope: "meta",
    begin: "!important"
  },
  BLOCK_COMMENT: t.C_BLOCK_COMMENT_MODE,
  HEXCOLOR: {
    scope: "number",
    begin: /#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\b/
  },
  FUNCTION_DISPATCH: {
    className: "built_in",
    begin: /[\w-]+(?=\()/
  },
  ATTRIBUTE_SELECTOR_MODE: {
    scope: "selector-attr",
    begin: /\[/,
    end: /\]/,
    illegal: "$",
    contains: [
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE
    ]
  },
  CSS_NUMBER_MODE: {
    scope: "number",
    begin: t.NUMBER_RE + "(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",
    relevance: 0
  },
  CSS_VARIABLE: {
    className: "attr",
    begin: /--[A-Za-z_][A-Za-z0-9_-]*/
  }
}), Oh = [
  "a",
  "abbr",
  "address",
  "article",
  "aside",
  "audio",
  "b",
  "blockquote",
  "body",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "dd",
  "del",
  "details",
  "dfn",
  "div",
  "dl",
  "dt",
  "em",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "header",
  "hgroup",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "label",
  "legend",
  "li",
  "main",
  "mark",
  "menu",
  "nav",
  "object",
  "ol",
  "optgroup",
  "option",
  "p",
  "picture",
  "q",
  "quote",
  "samp",
  "section",
  "select",
  "source",
  "span",
  "strong",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "tr",
  "ul",
  "var",
  "video"
], vh = [
  "defs",
  "g",
  "marker",
  "mask",
  "pattern",
  "svg",
  "switch",
  "symbol",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feFlood",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMorphology",
  "feOffset",
  "feSpecularLighting",
  "feTile",
  "feTurbulence",
  "linearGradient",
  "radialGradient",
  "stop",
  "circle",
  "ellipse",
  "image",
  "line",
  "path",
  "polygon",
  "polyline",
  "rect",
  "text",
  "use",
  "textPath",
  "tspan",
  "foreignObject",
  "clipPath"
], Ah = [
  ...Oh,
  ...vh
], Ih = [
  "any-hover",
  "any-pointer",
  "aspect-ratio",
  "color",
  "color-gamut",
  "color-index",
  "device-aspect-ratio",
  "device-height",
  "device-width",
  "display-mode",
  "forced-colors",
  "grid",
  "height",
  "hover",
  "inverted-colors",
  "monochrome",
  "orientation",
  "overflow-block",
  "overflow-inline",
  "pointer",
  "prefers-color-scheme",
  "prefers-contrast",
  "prefers-reduced-motion",
  "prefers-reduced-transparency",
  "resolution",
  "scan",
  "scripting",
  "update",
  "width",
  // TODO: find a better solution?
  "min-width",
  "max-width",
  "min-height",
  "max-height"
].sort().reverse(), Dh = [
  "active",
  "any-link",
  "blank",
  "checked",
  "current",
  "default",
  "defined",
  "dir",
  // dir()
  "disabled",
  "drop",
  "empty",
  "enabled",
  "first",
  "first-child",
  "first-of-type",
  "fullscreen",
  "future",
  "focus",
  "focus-visible",
  "focus-within",
  "has",
  // has()
  "host",
  // host or host()
  "host-context",
  // host-context()
  "hover",
  "indeterminate",
  "in-range",
  "invalid",
  "is",
  // is()
  "lang",
  // lang()
  "last-child",
  "last-of-type",
  "left",
  "link",
  "local-link",
  "not",
  // not()
  "nth-child",
  // nth-child()
  "nth-col",
  // nth-col()
  "nth-last-child",
  // nth-last-child()
  "nth-last-col",
  // nth-last-col()
  "nth-last-of-type",
  //nth-last-of-type()
  "nth-of-type",
  //nth-of-type()
  "only-child",
  "only-of-type",
  "optional",
  "out-of-range",
  "past",
  "placeholder-shown",
  "read-only",
  "read-write",
  "required",
  "right",
  "root",
  "scope",
  "target",
  "target-within",
  "user-invalid",
  "valid",
  "visited",
  "where"
  // where()
].sort().reverse(), Mh = [
  "after",
  "backdrop",
  "before",
  "cue",
  "cue-region",
  "first-letter",
  "first-line",
  "grammar-error",
  "marker",
  "part",
  "placeholder",
  "selection",
  "slotted",
  "spelling-error"
].sort().reverse(), wh = [
  "accent-color",
  "align-content",
  "align-items",
  "align-self",
  "alignment-baseline",
  "all",
  "anchor-name",
  "animation",
  "animation-composition",
  "animation-delay",
  "animation-direction",
  "animation-duration",
  "animation-fill-mode",
  "animation-iteration-count",
  "animation-name",
  "animation-play-state",
  "animation-range",
  "animation-range-end",
  "animation-range-start",
  "animation-timeline",
  "animation-timing-function",
  "appearance",
  "aspect-ratio",
  "backdrop-filter",
  "backface-visibility",
  "background",
  "background-attachment",
  "background-blend-mode",
  "background-clip",
  "background-color",
  "background-image",
  "background-origin",
  "background-position",
  "background-position-x",
  "background-position-y",
  "background-repeat",
  "background-size",
  "baseline-shift",
  "block-size",
  "border",
  "border-block",
  "border-block-color",
  "border-block-end",
  "border-block-end-color",
  "border-block-end-style",
  "border-block-end-width",
  "border-block-start",
  "border-block-start-color",
  "border-block-start-style",
  "border-block-start-width",
  "border-block-style",
  "border-block-width",
  "border-bottom",
  "border-bottom-color",
  "border-bottom-left-radius",
  "border-bottom-right-radius",
  "border-bottom-style",
  "border-bottom-width",
  "border-collapse",
  "border-color",
  "border-end-end-radius",
  "border-end-start-radius",
  "border-image",
  "border-image-outset",
  "border-image-repeat",
  "border-image-slice",
  "border-image-source",
  "border-image-width",
  "border-inline",
  "border-inline-color",
  "border-inline-end",
  "border-inline-end-color",
  "border-inline-end-style",
  "border-inline-end-width",
  "border-inline-start",
  "border-inline-start-color",
  "border-inline-start-style",
  "border-inline-start-width",
  "border-inline-style",
  "border-inline-width",
  "border-left",
  "border-left-color",
  "border-left-style",
  "border-left-width",
  "border-radius",
  "border-right",
  "border-right-color",
  "border-right-style",
  "border-right-width",
  "border-spacing",
  "border-start-end-radius",
  "border-start-start-radius",
  "border-style",
  "border-top",
  "border-top-color",
  "border-top-left-radius",
  "border-top-right-radius",
  "border-top-style",
  "border-top-width",
  "border-width",
  "bottom",
  "box-align",
  "box-decoration-break",
  "box-direction",
  "box-flex",
  "box-flex-group",
  "box-lines",
  "box-ordinal-group",
  "box-orient",
  "box-pack",
  "box-shadow",
  "box-sizing",
  "break-after",
  "break-before",
  "break-inside",
  "caption-side",
  "caret-color",
  "clear",
  "clip",
  "clip-path",
  "clip-rule",
  "color",
  "color-interpolation",
  "color-interpolation-filters",
  "color-profile",
  "color-rendering",
  "color-scheme",
  "column-count",
  "column-fill",
  "column-gap",
  "column-rule",
  "column-rule-color",
  "column-rule-style",
  "column-rule-width",
  "column-span",
  "column-width",
  "columns",
  "contain",
  "contain-intrinsic-block-size",
  "contain-intrinsic-height",
  "contain-intrinsic-inline-size",
  "contain-intrinsic-size",
  "contain-intrinsic-width",
  "container",
  "container-name",
  "container-type",
  "content",
  "content-visibility",
  "counter-increment",
  "counter-reset",
  "counter-set",
  "cue",
  "cue-after",
  "cue-before",
  "cursor",
  "cx",
  "cy",
  "direction",
  "display",
  "dominant-baseline",
  "empty-cells",
  "enable-background",
  "field-sizing",
  "fill",
  "fill-opacity",
  "fill-rule",
  "filter",
  "flex",
  "flex-basis",
  "flex-direction",
  "flex-flow",
  "flex-grow",
  "flex-shrink",
  "flex-wrap",
  "float",
  "flood-color",
  "flood-opacity",
  "flow",
  "font",
  "font-display",
  "font-family",
  "font-feature-settings",
  "font-kerning",
  "font-language-override",
  "font-optical-sizing",
  "font-palette",
  "font-size",
  "font-size-adjust",
  "font-smooth",
  "font-smoothing",
  "font-stretch",
  "font-style",
  "font-synthesis",
  "font-synthesis-position",
  "font-synthesis-small-caps",
  "font-synthesis-style",
  "font-synthesis-weight",
  "font-variant",
  "font-variant-alternates",
  "font-variant-caps",
  "font-variant-east-asian",
  "font-variant-emoji",
  "font-variant-ligatures",
  "font-variant-numeric",
  "font-variant-position",
  "font-variation-settings",
  "font-weight",
  "forced-color-adjust",
  "gap",
  "glyph-orientation-horizontal",
  "glyph-orientation-vertical",
  "grid",
  "grid-area",
  "grid-auto-columns",
  "grid-auto-flow",
  "grid-auto-rows",
  "grid-column",
  "grid-column-end",
  "grid-column-start",
  "grid-gap",
  "grid-row",
  "grid-row-end",
  "grid-row-start",
  "grid-template",
  "grid-template-areas",
  "grid-template-columns",
  "grid-template-rows",
  "hanging-punctuation",
  "height",
  "hyphenate-character",
  "hyphenate-limit-chars",
  "hyphens",
  "icon",
  "image-orientation",
  "image-rendering",
  "image-resolution",
  "ime-mode",
  "initial-letter",
  "initial-letter-align",
  "inline-size",
  "inset",
  "inset-area",
  "inset-block",
  "inset-block-end",
  "inset-block-start",
  "inset-inline",
  "inset-inline-end",
  "inset-inline-start",
  "isolation",
  "justify-content",
  "justify-items",
  "justify-self",
  "kerning",
  "left",
  "letter-spacing",
  "lighting-color",
  "line-break",
  "line-height",
  "line-height-step",
  "list-style",
  "list-style-image",
  "list-style-position",
  "list-style-type",
  "margin",
  "margin-block",
  "margin-block-end",
  "margin-block-start",
  "margin-bottom",
  "margin-inline",
  "margin-inline-end",
  "margin-inline-start",
  "margin-left",
  "margin-right",
  "margin-top",
  "margin-trim",
  "marker",
  "marker-end",
  "marker-mid",
  "marker-start",
  "marks",
  "mask",
  "mask-border",
  "mask-border-mode",
  "mask-border-outset",
  "mask-border-repeat",
  "mask-border-slice",
  "mask-border-source",
  "mask-border-width",
  "mask-clip",
  "mask-composite",
  "mask-image",
  "mask-mode",
  "mask-origin",
  "mask-position",
  "mask-repeat",
  "mask-size",
  "mask-type",
  "masonry-auto-flow",
  "math-depth",
  "math-shift",
  "math-style",
  "max-block-size",
  "max-height",
  "max-inline-size",
  "max-width",
  "min-block-size",
  "min-height",
  "min-inline-size",
  "min-width",
  "mix-blend-mode",
  "nav-down",
  "nav-index",
  "nav-left",
  "nav-right",
  "nav-up",
  "none",
  "normal",
  "object-fit",
  "object-position",
  "offset",
  "offset-anchor",
  "offset-distance",
  "offset-path",
  "offset-position",
  "offset-rotate",
  "opacity",
  "order",
  "orphans",
  "outline",
  "outline-color",
  "outline-offset",
  "outline-style",
  "outline-width",
  "overflow",
  "overflow-anchor",
  "overflow-block",
  "overflow-clip-margin",
  "overflow-inline",
  "overflow-wrap",
  "overflow-x",
  "overflow-y",
  "overlay",
  "overscroll-behavior",
  "overscroll-behavior-block",
  "overscroll-behavior-inline",
  "overscroll-behavior-x",
  "overscroll-behavior-y",
  "padding",
  "padding-block",
  "padding-block-end",
  "padding-block-start",
  "padding-bottom",
  "padding-inline",
  "padding-inline-end",
  "padding-inline-start",
  "padding-left",
  "padding-right",
  "padding-top",
  "page",
  "page-break-after",
  "page-break-before",
  "page-break-inside",
  "paint-order",
  "pause",
  "pause-after",
  "pause-before",
  "perspective",
  "perspective-origin",
  "place-content",
  "place-items",
  "place-self",
  "pointer-events",
  "position",
  "position-anchor",
  "position-visibility",
  "print-color-adjust",
  "quotes",
  "r",
  "resize",
  "rest",
  "rest-after",
  "rest-before",
  "right",
  "rotate",
  "row-gap",
  "ruby-align",
  "ruby-position",
  "scale",
  "scroll-behavior",
  "scroll-margin",
  "scroll-margin-block",
  "scroll-margin-block-end",
  "scroll-margin-block-start",
  "scroll-margin-bottom",
  "scroll-margin-inline",
  "scroll-margin-inline-end",
  "scroll-margin-inline-start",
  "scroll-margin-left",
  "scroll-margin-right",
  "scroll-margin-top",
  "scroll-padding",
  "scroll-padding-block",
  "scroll-padding-block-end",
  "scroll-padding-block-start",
  "scroll-padding-bottom",
  "scroll-padding-inline",
  "scroll-padding-inline-end",
  "scroll-padding-inline-start",
  "scroll-padding-left",
  "scroll-padding-right",
  "scroll-padding-top",
  "scroll-snap-align",
  "scroll-snap-stop",
  "scroll-snap-type",
  "scroll-timeline",
  "scroll-timeline-axis",
  "scroll-timeline-name",
  "scrollbar-color",
  "scrollbar-gutter",
  "scrollbar-width",
  "shape-image-threshold",
  "shape-margin",
  "shape-outside",
  "shape-rendering",
  "speak",
  "speak-as",
  "src",
  // @font-face
  "stop-color",
  "stop-opacity",
  "stroke",
  "stroke-dasharray",
  "stroke-dashoffset",
  "stroke-linecap",
  "stroke-linejoin",
  "stroke-miterlimit",
  "stroke-opacity",
  "stroke-width",
  "tab-size",
  "table-layout",
  "text-align",
  "text-align-all",
  "text-align-last",
  "text-anchor",
  "text-combine-upright",
  "text-decoration",
  "text-decoration-color",
  "text-decoration-line",
  "text-decoration-skip",
  "text-decoration-skip-ink",
  "text-decoration-style",
  "text-decoration-thickness",
  "text-emphasis",
  "text-emphasis-color",
  "text-emphasis-position",
  "text-emphasis-style",
  "text-indent",
  "text-justify",
  "text-orientation",
  "text-overflow",
  "text-rendering",
  "text-shadow",
  "text-size-adjust",
  "text-transform",
  "text-underline-offset",
  "text-underline-position",
  "text-wrap",
  "text-wrap-mode",
  "text-wrap-style",
  "timeline-scope",
  "top",
  "touch-action",
  "transform",
  "transform-box",
  "transform-origin",
  "transform-style",
  "transition",
  "transition-behavior",
  "transition-delay",
  "transition-duration",
  "transition-property",
  "transition-timing-function",
  "translate",
  "unicode-bidi",
  "user-modify",
  "user-select",
  "vector-effect",
  "vertical-align",
  "view-timeline",
  "view-timeline-axis",
  "view-timeline-inset",
  "view-timeline-name",
  "view-transition-name",
  "visibility",
  "voice-balance",
  "voice-duration",
  "voice-family",
  "voice-pitch",
  "voice-range",
  "voice-rate",
  "voice-stress",
  "voice-volume",
  "white-space",
  "white-space-collapse",
  "widows",
  "width",
  "will-change",
  "word-break",
  "word-spacing",
  "word-wrap",
  "writing-mode",
  "x",
  "y",
  "z-index",
  "zoom"
].sort().reverse();
function xh(t) {
  const e = Nh(t), n = Mh, i = Dh, r = "@[a-z-]+", a = "and or not only", o = {
    className: "variable",
    begin: "(\\$" + "[a-zA-Z-][a-zA-Z0-9_-]*" + ")\\b",
    relevance: 0
  };
  return {
    name: "SCSS",
    case_insensitive: !0,
    illegal: "[=/|']",
    contains: [
      t.C_LINE_COMMENT_MODE,
      t.C_BLOCK_COMMENT_MODE,
      // to recognize keyframe 40% etc which are outside the scope of our
      // attribute value mode
      e.CSS_NUMBER_MODE,
      {
        className: "selector-id",
        begin: "#[A-Za-z0-9_-]+",
        relevance: 0
      },
      {
        className: "selector-class",
        begin: "\\.[A-Za-z0-9_-]+",
        relevance: 0
      },
      e.ATTRIBUTE_SELECTOR_MODE,
      {
        className: "selector-tag",
        begin: "\\b(" + Ah.join("|") + ")\\b",
        // was there, before, but why?
        relevance: 0
      },
      {
        className: "selector-pseudo",
        begin: ":(" + i.join("|") + ")"
      },
      {
        className: "selector-pseudo",
        begin: ":(:)?(" + n.join("|") + ")"
      },
      o,
      {
        // pseudo-selector params
        begin: /\(/,
        end: /\)/,
        contains: [e.CSS_NUMBER_MODE]
      },
      e.CSS_VARIABLE,
      {
        className: "attribute",
        begin: "\\b(" + wh.join("|") + ")\\b"
      },
      { begin: "\\b(whitespace|wait|w-resize|visible|vertical-text|vertical-ideographic|uppercase|upper-roman|upper-alpha|underline|transparent|top|thin|thick|text|text-top|text-bottom|tb-rl|table-header-group|table-footer-group|sw-resize|super|strict|static|square|solid|small-caps|separate|se-resize|scroll|s-resize|rtl|row-resize|ridge|right|repeat|repeat-y|repeat-x|relative|progress|pointer|overline|outside|outset|oblique|nowrap|not-allowed|normal|none|nw-resize|no-repeat|no-drop|newspaper|ne-resize|n-resize|move|middle|medium|ltr|lr-tb|lowercase|lower-roman|lower-alpha|loose|list-item|line|line-through|line-edge|lighter|left|keep-all|justify|italic|inter-word|inter-ideograph|inside|inset|inline|inline-block|inherit|inactive|ideograph-space|ideograph-parenthesis|ideograph-numeric|ideograph-alpha|horizontal|hidden|help|hand|groove|fixed|ellipsis|e-resize|double|dotted|distribute|distribute-space|distribute-letter|distribute-all-lines|disc|disabled|default|decimal|dashed|crosshair|collapse|col-resize|circle|char|center|capitalize|break-word|break-all|bottom|both|bolder|bold|block|bidi-override|below|baseline|auto|always|all-scroll|absolute|table|table-cell)\\b" },
      {
        begin: /:/,
        end: /[;}{]/,
        relevance: 0,
        contains: [
          e.BLOCK_COMMENT,
          o,
          e.HEXCOLOR,
          e.CSS_NUMBER_MODE,
          t.QUOTE_STRING_MODE,
          t.APOS_STRING_MODE,
          e.IMPORTANT,
          e.FUNCTION_DISPATCH
        ]
      },
      // matching these here allows us to treat them more like regular CSS
      // rules so everything between the {} gets regular rule highlighting,
      // which is what we want for page and font-face
      {
        begin: "@(page|font-face)",
        keywords: {
          $pattern: r,
          keyword: "@page @font-face"
        }
      },
      {
        begin: "@",
        end: "[{;]",
        returnBegin: !0,
        keywords: {
          $pattern: /[a-z-]+/,
          keyword: a,
          attribute: Ih.join(" ")
        },
        contains: [
          {
            begin: r,
            className: "keyword"
          },
          {
            begin: /[a-z-]+(?=:)/,
            className: "attribute"
          },
          o,
          t.QUOTE_STRING_MODE,
          t.APOS_STRING_MODE,
          e.HEXCOLOR,
          e.CSS_NUMBER_MODE
        ]
      },
      e.FUNCTION_DISPATCH
    ]
  };
}
function Lh(t) {
  return {
    name: "Shell Session",
    aliases: [
      "console",
      "shellsession"
    ],
    contains: [
      {
        className: "meta.prompt",
        // We cannot add \s (spaces) in the regular expression otherwise it will be too broad and produce unexpected result.
        // For instance, in the following example, it would match "echo /path/to/home >" as a prompt:
        // echo /path/to/home > t.exe
        begin: /^\s{0,3}[/~\w\d[\]()@-]*[>%$#][ ]?/,
        starts: {
          end: /[^\\](?=\s*$)/,
          subLanguage: "bash"
        }
      }
    ]
  };
}
function Ph(t) {
  const e = t.regex, n = t.COMMENT("--", "$"), i = {
    scope: "string",
    variants: [
      {
        begin: /'/,
        end: /'/,
        contains: [{ match: /''/ }]
      }
    ]
  }, r = {
    begin: /"/,
    end: /"/,
    contains: [{ match: /""/ }]
  }, a = [
    "true",
    "false",
    // Not sure it's correct to call NULL literal, and clauses like IS [NOT] NULL look strange that way.
    // "null",
    "unknown"
  ], s = [
    "double precision",
    "large object",
    "with timezone",
    "without timezone"
  ], o = [
    "bigint",
    "binary",
    "blob",
    "boolean",
    "char",
    "character",
    "clob",
    "date",
    "dec",
    "decfloat",
    "decimal",
    "float",
    "int",
    "integer",
    "interval",
    "nchar",
    "nclob",
    "national",
    "numeric",
    "real",
    "row",
    "smallint",
    "time",
    "timestamp",
    "varchar",
    "varying",
    // modifier (character varying)
    "varbinary"
  ], l = [
    "add",
    "asc",
    "collation",
    "desc",
    "final",
    "first",
    "last",
    "view"
  ], c = [
    "abs",
    "acos",
    "all",
    "allocate",
    "alter",
    "and",
    "any",
    "are",
    "array",
    "array_agg",
    "array_max_cardinality",
    "as",
    "asensitive",
    "asin",
    "asymmetric",
    "at",
    "atan",
    "atomic",
    "authorization",
    "avg",
    "begin",
    "begin_frame",
    "begin_partition",
    "between",
    "bigint",
    "binary",
    "blob",
    "boolean",
    "both",
    "by",
    "call",
    "called",
    "cardinality",
    "cascaded",
    "case",
    "cast",
    "ceil",
    "ceiling",
    "char",
    "char_length",
    "character",
    "character_length",
    "check",
    "classifier",
    "clob",
    "close",
    "coalesce",
    "collate",
    "collect",
    "column",
    "commit",
    "condition",
    "connect",
    "constraint",
    "contains",
    "convert",
    "copy",
    "corr",
    "corresponding",
    "cos",
    "cosh",
    "count",
    "covar_pop",
    "covar_samp",
    "create",
    "cross",
    "cube",
    "cume_dist",
    "current",
    "current_catalog",
    "current_date",
    "current_default_transform_group",
    "current_path",
    "current_role",
    "current_row",
    "current_schema",
    "current_time",
    "current_timestamp",
    "current_path",
    "current_role",
    "current_transform_group_for_type",
    "current_user",
    "cursor",
    "cycle",
    "date",
    "day",
    "deallocate",
    "dec",
    "decimal",
    "decfloat",
    "declare",
    "default",
    "define",
    "delete",
    "dense_rank",
    "deref",
    "describe",
    "deterministic",
    "disconnect",
    "distinct",
    "double",
    "drop",
    "dynamic",
    "each",
    "element",
    "else",
    "empty",
    "end",
    "end_frame",
    "end_partition",
    "end-exec",
    "equals",
    "escape",
    "every",
    "except",
    "exec",
    "execute",
    "exists",
    "exp",
    "external",
    "extract",
    "false",
    "fetch",
    "filter",
    "first_value",
    "float",
    "floor",
    "for",
    "foreign",
    "frame_row",
    "free",
    "from",
    "full",
    "function",
    "fusion",
    "get",
    "global",
    "grant",
    "group",
    "grouping",
    "groups",
    "having",
    "hold",
    "hour",
    "identity",
    "in",
    "indicator",
    "initial",
    "inner",
    "inout",
    "insensitive",
    "insert",
    "int",
    "integer",
    "intersect",
    "intersection",
    "interval",
    "into",
    "is",
    "join",
    "json_array",
    "json_arrayagg",
    "json_exists",
    "json_object",
    "json_objectagg",
    "json_query",
    "json_table",
    "json_table_primitive",
    "json_value",
    "lag",
    "language",
    "large",
    "last_value",
    "lateral",
    "lead",
    "leading",
    "left",
    "like",
    "like_regex",
    "listagg",
    "ln",
    "local",
    "localtime",
    "localtimestamp",
    "log",
    "log10",
    "lower",
    "match",
    "match_number",
    "match_recognize",
    "matches",
    "max",
    "member",
    "merge",
    "method",
    "min",
    "minute",
    "mod",
    "modifies",
    "module",
    "month",
    "multiset",
    "national",
    "natural",
    "nchar",
    "nclob",
    "new",
    "no",
    "none",
    "normalize",
    "not",
    "nth_value",
    "ntile",
    "null",
    "nullif",
    "numeric",
    "octet_length",
    "occurrences_regex",
    "of",
    "offset",
    "old",
    "omit",
    "on",
    "one",
    "only",
    "open",
    "or",
    "order",
    "out",
    "outer",
    "over",
    "overlaps",
    "overlay",
    "parameter",
    "partition",
    "pattern",
    "per",
    "percent",
    "percent_rank",
    "percentile_cont",
    "percentile_disc",
    "period",
    "portion",
    "position",
    "position_regex",
    "power",
    "precedes",
    "precision",
    "prepare",
    "primary",
    "procedure",
    "ptf",
    "range",
    "rank",
    "reads",
    "real",
    "recursive",
    "ref",
    "references",
    "referencing",
    "regr_avgx",
    "regr_avgy",
    "regr_count",
    "regr_intercept",
    "regr_r2",
    "regr_slope",
    "regr_sxx",
    "regr_sxy",
    "regr_syy",
    "release",
    "result",
    "return",
    "returns",
    "revoke",
    "right",
    "rollback",
    "rollup",
    "row",
    "row_number",
    "rows",
    "running",
    "savepoint",
    "scope",
    "scroll",
    "search",
    "second",
    "seek",
    "select",
    "sensitive",
    "session_user",
    "set",
    "show",
    "similar",
    "sin",
    "sinh",
    "skip",
    "smallint",
    "some",
    "specific",
    "specifictype",
    "sql",
    "sqlexception",
    "sqlstate",
    "sqlwarning",
    "sqrt",
    "start",
    "static",
    "stddev_pop",
    "stddev_samp",
    "submultiset",
    "subset",
    "substring",
    "substring_regex",
    "succeeds",
    "sum",
    "symmetric",
    "system",
    "system_time",
    "system_user",
    "table",
    "tablesample",
    "tan",
    "tanh",
    "then",
    "time",
    "timestamp",
    "timezone_hour",
    "timezone_minute",
    "to",
    "trailing",
    "translate",
    "translate_regex",
    "translation",
    "treat",
    "trigger",
    "trim",
    "trim_array",
    "true",
    "truncate",
    "uescape",
    "union",
    "unique",
    "unknown",
    "unnest",
    "update",
    "upper",
    "user",
    "using",
    "value",
    "values",
    "value_of",
    "var_pop",
    "var_samp",
    "varbinary",
    "varchar",
    "varying",
    "versioning",
    "when",
    "whenever",
    "where",
    "width_bucket",
    "window",
    "with",
    "within",
    "without",
    "year"
  ], d = [
    "abs",
    "acos",
    "array_agg",
    "asin",
    "atan",
    "avg",
    "cast",
    "ceil",
    "ceiling",
    "coalesce",
    "corr",
    "cos",
    "cosh",
    "count",
    "covar_pop",
    "covar_samp",
    "cume_dist",
    "dense_rank",
    "deref",
    "element",
    "exp",
    "extract",
    "first_value",
    "floor",
    "json_array",
    "json_arrayagg",
    "json_exists",
    "json_object",
    "json_objectagg",
    "json_query",
    "json_table",
    "json_table_primitive",
    "json_value",
    "lag",
    "last_value",
    "lead",
    "listagg",
    "ln",
    "log",
    "log10",
    "lower",
    "max",
    "min",
    "mod",
    "nth_value",
    "ntile",
    "nullif",
    "percent_rank",
    "percentile_cont",
    "percentile_disc",
    "position",
    "position_regex",
    "power",
    "rank",
    "regr_avgx",
    "regr_avgy",
    "regr_count",
    "regr_intercept",
    "regr_r2",
    "regr_slope",
    "regr_sxx",
    "regr_sxy",
    "regr_syy",
    "row_number",
    "sin",
    "sinh",
    "sqrt",
    "stddev_pop",
    "stddev_samp",
    "substring",
    "substring_regex",
    "sum",
    "tan",
    "tanh",
    "translate",
    "translate_regex",
    "treat",
    "trim",
    "trim_array",
    "unnest",
    "upper",
    "value_of",
    "var_pop",
    "var_samp",
    "width_bucket"
  ], u = [
    "current_catalog",
    "current_date",
    "current_default_transform_group",
    "current_path",
    "current_role",
    "current_schema",
    "current_transform_group_for_type",
    "current_user",
    "session_user",
    "system_time",
    "system_user",
    "current_time",
    "localtime",
    "current_timestamp",
    "localtimestamp"
  ], _ = [
    "create table",
    "insert into",
    "primary key",
    "foreign key",
    "not null",
    "alter table",
    "add constraint",
    "grouping sets",
    "on overflow",
    "character set",
    "respect nulls",
    "ignore nulls",
    "nulls first",
    "nulls last",
    "depth first",
    "breadth first"
  ], m = d, g = [
    ...c,
    ...l
  ].filter((y) => !d.includes(y)), S = {
    scope: "variable",
    match: /@[a-z0-9][a-z0-9_]*/
  }, E = {
    scope: "operator",
    match: /[-+*/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?/,
    relevance: 0
  }, h = {
    match: e.concat(/\b/, e.either(...m), /\s*\(/),
    relevance: 0,
    keywords: { built_in: m }
  };
  function T(y) {
    return e.concat(
      /\b/,
      e.either(...y.map((O) => O.replace(/\s+/, "\\s+"))),
      /\b/
    );
  }
  const b = {
    scope: "keyword",
    match: T(_),
    relevance: 0
  };
  function C(y, {
    exceptions: O,
    when: A
  } = {}) {
    const I = A;
    return O = O || [], y.map((k) => k.match(/\|\d+$/) || O.includes(k) ? k : I(k) ? `${k}|0` : k);
  }
  return {
    name: "SQL",
    case_insensitive: !0,
    // does not include {} or HTML tags `</`
    illegal: /[{}]|<\//,
    keywords: {
      $pattern: /\b[\w\.]+/,
      keyword: C(g, { when: (y) => y.length < 3 }),
      literal: a,
      type: o,
      built_in: u
    },
    contains: [
      {
        scope: "type",
        match: T(s)
      },
      b,
      h,
      S,
      i,
      r,
      t.C_NUMBER_MODE,
      t.C_BLOCK_COMMENT_MODE,
      n,
      E
    ]
  };
}
function wc(t) {
  return t ? typeof t == "string" ? t : t.source : null;
}
function Vi(t) {
  return Ie("(?=", t, ")");
}
function Ie(...t) {
  return t.map((n) => wc(n)).join("");
}
function kh(t) {
  const e = t[t.length - 1];
  return typeof e == "object" && e.constructor === Object ? (t.splice(t.length - 1, 1), e) : {};
}
function _t(...t) {
  return "(" + (kh(t).capture ? "" : "?:") + t.map((i) => wc(i)).join("|") + ")";
}
const Ms = (t) => Ie(
  /\b/,
  t,
  /\w$/.test(t) ? /\b/ : /\B/
), Uh = [
  "Protocol",
  // contextual
  "Type"
  // contextual
].map(Ms), cl = [
  "init",
  "self"
].map(Ms), Fh = [
  "Any",
  "Self"
], Pa = [
  // strings below will be fed into the regular `keywords` engine while regex
  // will result in additional modes being created to scan for those keywords to
  // avoid conflicts with other rules
  "actor",
  "any",
  // contextual
  "associatedtype",
  "async",
  "await",
  /as\?/,
  // operator
  /as!/,
  // operator
  "as",
  // operator
  "borrowing",
  // contextual
  "break",
  "case",
  "catch",
  "class",
  "consume",
  // contextual
  "consuming",
  // contextual
  "continue",
  "convenience",
  // contextual
  "copy",
  // contextual
  "default",
  "defer",
  "deinit",
  "didSet",
  // contextual
  "distributed",
  "do",
  "dynamic",
  // contextual
  "each",
  "else",
  "enum",
  "extension",
  "fallthrough",
  /fileprivate\(set\)/,
  "fileprivate",
  "final",
  // contextual
  "for",
  "func",
  "get",
  // contextual
  "guard",
  "if",
  "import",
  "indirect",
  // contextual
  "infix",
  // contextual
  /init\?/,
  /init!/,
  "inout",
  /internal\(set\)/,
  "internal",
  "in",
  "is",
  // operator
  "isolated",
  // contextual
  "nonisolated",
  // contextual
  "lazy",
  // contextual
  "let",
  "macro",
  "mutating",
  // contextual
  "nonmutating",
  // contextual
  /open\(set\)/,
  // contextual
  "open",
  // contextual
  "operator",
  "optional",
  // contextual
  "override",
  // contextual
  "package",
  "postfix",
  // contextual
  "precedencegroup",
  "prefix",
  // contextual
  /private\(set\)/,
  "private",
  "protocol",
  /public\(set\)/,
  "public",
  "repeat",
  "required",
  // contextual
  "rethrows",
  "return",
  "set",
  // contextual
  "some",
  // contextual
  "static",
  "struct",
  "subscript",
  "super",
  "switch",
  "throws",
  "throw",
  /try\?/,
  // operator
  /try!/,
  // operator
  "try",
  // operator
  "typealias",
  /unowned\(safe\)/,
  // contextual
  /unowned\(unsafe\)/,
  // contextual
  "unowned",
  // contextual
  "var",
  "weak",
  // contextual
  "where",
  "while",
  "willSet"
  // contextual
], dl = [
  "false",
  "nil",
  "true"
], Bh = [
  "assignment",
  "associativity",
  "higherThan",
  "left",
  "lowerThan",
  "none",
  "right"
], Gh = [
  "#colorLiteral",
  "#column",
  "#dsohandle",
  "#else",
  "#elseif",
  "#endif",
  "#error",
  "#file",
  "#fileID",
  "#fileLiteral",
  "#filePath",
  "#function",
  "#if",
  "#imageLiteral",
  "#keyPath",
  "#line",
  "#selector",
  "#sourceLocation",
  "#warning"
], ul = [
  "abs",
  "all",
  "any",
  "assert",
  "assertionFailure",
  "debugPrint",
  "dump",
  "fatalError",
  "getVaList",
  "isKnownUniquelyReferenced",
  "max",
  "min",
  "numericCast",
  "pointwiseMax",
  "pointwiseMin",
  "precondition",
  "preconditionFailure",
  "print",
  "readLine",
  "repeatElement",
  "sequence",
  "stride",
  "swap",
  "swift_unboxFromSwiftValueWithType",
  "transcode",
  "type",
  "unsafeBitCast",
  "unsafeDowncast",
  "withExtendedLifetime",
  "withUnsafeMutablePointer",
  "withUnsafePointer",
  "withVaList",
  "withoutActuallyEscaping",
  "zip"
], xc = _t(
  /[/=\-+!*%<>&|^~?]/,
  /[\u00A1-\u00A7]/,
  /[\u00A9\u00AB]/,
  /[\u00AC\u00AE]/,
  /[\u00B0\u00B1]/,
  /[\u00B6\u00BB\u00BF\u00D7\u00F7]/,
  /[\u2016-\u2017]/,
  /[\u2020-\u2027]/,
  /[\u2030-\u203E]/,
  /[\u2041-\u2053]/,
  /[\u2055-\u205E]/,
  /[\u2190-\u23FF]/,
  /[\u2500-\u2775]/,
  /[\u2794-\u2BFF]/,
  /[\u2E00-\u2E7F]/,
  /[\u3001-\u3003]/,
  /[\u3008-\u3020]/,
  /[\u3030]/
), Lc = _t(
  xc,
  /[\u0300-\u036F]/,
  /[\u1DC0-\u1DFF]/,
  /[\u20D0-\u20FF]/,
  /[\uFE00-\uFE0F]/,
  /[\uFE20-\uFE2F]/
  // TODO: The following characters are also allowed, but the regex isn't supported yet.
  // /[\u{E0100}-\u{E01EF}]/u
), ka = Ie(xc, Lc, "*"), Pc = _t(
  /[a-zA-Z_]/,
  /[\u00A8\u00AA\u00AD\u00AF\u00B2-\u00B5\u00B7-\u00BA]/,
  /[\u00BC-\u00BE\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF]/,
  /[\u0100-\u02FF\u0370-\u167F\u1681-\u180D\u180F-\u1DBF]/,
  /[\u1E00-\u1FFF]/,
  /[\u200B-\u200D\u202A-\u202E\u203F-\u2040\u2054\u2060-\u206F]/,
  /[\u2070-\u20CF\u2100-\u218F\u2460-\u24FF\u2776-\u2793]/,
  /[\u2C00-\u2DFF\u2E80-\u2FFF]/,
  /[\u3004-\u3007\u3021-\u302F\u3031-\u303F\u3040-\uD7FF]/,
  /[\uF900-\uFD3D\uFD40-\uFDCF\uFDF0-\uFE1F\uFE30-\uFE44]/,
  /[\uFE47-\uFEFE\uFF00-\uFFFD]/
  // Should be /[\uFE47-\uFFFD]/, but we have to exclude FEFF.
  // The following characters are also allowed, but the regexes aren't supported yet.
  // /[\u{10000}-\u{1FFFD}\u{20000-\u{2FFFD}\u{30000}-\u{3FFFD}\u{40000}-\u{4FFFD}]/u,
  // /[\u{50000}-\u{5FFFD}\u{60000-\u{6FFFD}\u{70000}-\u{7FFFD}\u{80000}-\u{8FFFD}]/u,
  // /[\u{90000}-\u{9FFFD}\u{A0000-\u{AFFFD}\u{B0000}-\u{BFFFD}\u{C0000}-\u{CFFFD}]/u,
  // /[\u{D0000}-\u{DFFFD}\u{E0000-\u{EFFFD}]/u
), zr = _t(
  Pc,
  /\d/,
  /[\u0300-\u036F\u1DC0-\u1DFF\u20D0-\u20FF\uFE20-\uFE2F]/
), sn = Ie(Pc, zr, "*"), Mr = Ie(/[A-Z]/, zr, "*"), Yh = [
  "attached",
  "autoclosure",
  Ie(/convention\(/, _t("swift", "block", "c"), /\)/),
  "discardableResult",
  "dynamicCallable",
  "dynamicMemberLookup",
  "escaping",
  "freestanding",
  "frozen",
  "GKInspectable",
  "IBAction",
  "IBDesignable",
  "IBInspectable",
  "IBOutlet",
  "IBSegueAction",
  "inlinable",
  "main",
  "nonobjc",
  "NSApplicationMain",
  "NSCopying",
  "NSManaged",
  Ie(/objc\(/, sn, /\)/),
  "objc",
  "objcMembers",
  "propertyWrapper",
  "requires_stored_property_inits",
  "resultBuilder",
  "Sendable",
  "testable",
  "UIApplicationMain",
  "unchecked",
  "unknown",
  "usableFromInline",
  "warn_unqualified_access"
], $h = [
  "iOS",
  "iOSApplicationExtension",
  "macOS",
  "macOSApplicationExtension",
  "macCatalyst",
  "macCatalystApplicationExtension",
  "watchOS",
  "watchOSApplicationExtension",
  "tvOS",
  "tvOSApplicationExtension",
  "swift"
];
function Vh(t) {
  const e = {
    match: /\s+/,
    relevance: 0
  }, n = t.COMMENT(
    "/\\*",
    "\\*/",
    { contains: ["self"] }
  ), i = [
    t.C_LINE_COMMENT_MODE,
    n
  ], r = {
    match: [
      /\./,
      _t(...Uh, ...cl)
    ],
    className: { 2: "keyword" }
  }, a = {
    // Consume .keyword to prevent highlighting properties and methods as keywords.
    match: Ie(/\./, _t(...Pa)),
    relevance: 0
  }, s = Pa.filter((ae) => typeof ae == "string").concat(["_|0"]), o = Pa.filter((ae) => typeof ae != "string").concat(Fh).map(Ms), l = { variants: [
    {
      className: "keyword",
      match: _t(...o, ...cl)
    }
  ] }, c = {
    $pattern: _t(
      /\b\w+/,
      // regular keywords
      /#\w+/
      // number keywords
    ),
    keyword: s.concat(Gh),
    literal: dl
  }, d = [
    r,
    a,
    l
  ], u = {
    // Consume .built_in to prevent highlighting properties and methods.
    match: Ie(/\./, _t(...ul)),
    relevance: 0
  }, _ = {
    className: "built_in",
    match: Ie(/\b/, _t(...ul), /(?=\()/)
  }, m = [
    u,
    _
  ], g = {
    // Prevent -> from being highlighting as an operator.
    match: /->/,
    relevance: 0
  }, S = {
    className: "operator",
    relevance: 0,
    variants: [
      { match: ka },
      {
        // dot-operator: only operators that start with a dot are allowed to use dots as
        // characters (..., ...<, .*, etc). So there rule here is: a dot followed by one or more
        // characters that may also include dots.
        match: `\\.(\\.|${Lc})+`
      }
    ]
  }, E = [
    g,
    S
  ], h = "([0-9]_*)+", T = "([0-9a-fA-F]_*)+", b = {
    className: "number",
    relevance: 0,
    variants: [
      // decimal floating-point-literal (subsumes decimal-literal)
      { match: `\\b(${h})(\\.(${h}))?([eE][+-]?(${h}))?\\b` },
      // hexadecimal floating-point-literal (subsumes hexadecimal-literal)
      { match: `\\b0x(${T})(\\.(${T}))?([pP][+-]?(${h}))?\\b` },
      // octal-literal
      { match: /\b0o([0-7]_*)+\b/ },
      // binary-literal
      { match: /\b0b([01]_*)+\b/ }
    ]
  }, C = (ae = "") => ({
    className: "subst",
    variants: [
      { match: Ie(/\\/, ae, /[0\\tnr"']/) },
      { match: Ie(/\\/, ae, /u\{[0-9a-fA-F]{1,8}\}/) }
    ]
  }), y = (ae = "") => ({
    className: "subst",
    match: Ie(/\\/, ae, /[\t ]*(?:[\r\n]|\r\n)/)
  }), O = (ae = "") => ({
    className: "subst",
    label: "interpol",
    begin: Ie(/\\/, ae, /\(/),
    end: /\)/
  }), A = (ae = "") => ({
    begin: Ie(ae, /"""/),
    end: Ie(/"""/, ae),
    contains: [
      C(ae),
      y(ae),
      O(ae)
    ]
  }), I = (ae = "") => ({
    begin: Ie(ae, /"/),
    end: Ie(/"/, ae),
    contains: [
      C(ae),
      O(ae)
    ]
  }), k = {
    className: "string",
    variants: [
      A(),
      A("#"),
      A("##"),
      A("###"),
      I(),
      I("#"),
      I("##"),
      I("###")
    ]
  }, x = [
    t.BACKSLASH_ESCAPE,
    {
      begin: /\[/,
      end: /\]/,
      relevance: 0,
      contains: [t.BACKSLASH_ESCAPE]
    }
  ], B = {
    begin: /\/[^\s](?=[^/\n]*\/)/,
    end: /\//,
    contains: x
  }, X = (ae) => {
    const ot = Ie(ae, /\//), lt = Ie(/\//, ae);
    return {
      begin: ot,
      end: lt,
      contains: [
        ...x,
        {
          scope: "comment",
          begin: `#(?!.*${lt})`,
          end: /$/
        }
      ]
    };
  }, J = {
    scope: "regexp",
    variants: [
      X("###"),
      X("##"),
      X("#"),
      B
    ]
  }, D = { match: Ie(/`/, sn, /`/) }, L = {
    className: "variable",
    match: /\$\d+/
  }, G = {
    className: "variable",
    match: `\\$${zr}+`
  }, q = [
    D,
    L,
    G
  ], V = {
    match: /(@|#(un)?)available/,
    scope: "keyword",
    starts: { contains: [
      {
        begin: /\(/,
        end: /\)/,
        keywords: $h,
        contains: [
          ...E,
          b,
          k
        ]
      }
    ] }
  }, Z = {
    scope: "keyword",
    match: Ie(/@/, _t(...Yh), Vi(_t(/\(/, /\s+/)))
  }, fe = {
    scope: "meta",
    match: Ie(/@/, sn)
  }, _e = [
    V,
    Z,
    fe
  ], me = {
    match: Vi(/\b[A-Z]/),
    relevance: 0,
    contains: [
      {
        // Common Apple frameworks, for relevance boost
        className: "type",
        match: Ie(/(AV|CA|CF|CG|CI|CL|CM|CN|CT|MK|MP|MTK|MTL|NS|SCN|SK|UI|WK|XC)/, zr, "+")
      },
      {
        // Type identifier
        className: "type",
        match: Mr,
        relevance: 0
      },
      {
        // Optional type
        match: /[?!]+/,
        relevance: 0
      },
      {
        // Variadic parameter
        match: /\.\.\./,
        relevance: 0
      },
      {
        // Protocol composition
        match: Ie(/\s+&\s+/, Vi(Mr)),
        relevance: 0
      }
    ]
  }, Me = {
    begin: /</,
    end: />/,
    keywords: c,
    contains: [
      ...i,
      ...d,
      ..._e,
      g,
      me
    ]
  };
  me.contains.push(Me);
  const ke = {
    match: Ie(sn, /\s*:/),
    keywords: "_|0",
    relevance: 0
  }, tt = {
    begin: /\(/,
    end: /\)/,
    relevance: 0,
    keywords: c,
    contains: [
      "self",
      ke,
      ...i,
      J,
      ...d,
      ...m,
      ...E,
      b,
      k,
      ...q,
      ..._e,
      me
    ]
  }, Ke = {
    begin: /</,
    end: />/,
    keywords: "repeat each",
    contains: [
      ...i,
      me
    ]
  }, Ue = {
    begin: _t(
      Vi(Ie(sn, /\s*:/)),
      Vi(Ie(sn, /\s+/, sn, /\s*:/))
    ),
    end: /:/,
    relevance: 0,
    contains: [
      {
        className: "keyword",
        match: /\b_\b/
      },
      {
        className: "params",
        match: sn
      }
    ]
  }, ye = {
    begin: /\(/,
    end: /\)/,
    keywords: c,
    contains: [
      Ue,
      ...i,
      ...d,
      ...E,
      b,
      k,
      ..._e,
      me,
      tt
    ],
    endsParent: !0,
    illegal: /["']/
  }, Fe = {
    match: [
      /(func|macro)/,
      /\s+/,
      _t(D.match, sn, ka)
    ],
    className: {
      1: "keyword",
      3: "title.function"
    },
    contains: [
      Ke,
      ye,
      e
    ],
    illegal: [
      /\[/,
      /%/
    ]
  }, Ce = {
    match: [
      /\b(?:subscript|init[?!]?)/,
      /\s*(?=[<(])/
    ],
    className: { 1: "keyword" },
    contains: [
      Ke,
      ye,
      e
    ],
    illegal: /\[|%/
  }, Ee = {
    match: [
      /operator/,
      /\s+/,
      ka
    ],
    className: {
      1: "keyword",
      3: "title"
    }
  }, Y = {
    begin: [
      /precedencegroup/,
      /\s+/,
      Mr
    ],
    className: {
      1: "keyword",
      3: "title"
    },
    contains: [me],
    keywords: [
      ...Bh,
      ...dl
    ],
    end: /}/
  }, ge = {
    match: [
      /class\b/,
      /\s+/,
      /func\b/,
      /\s+/,
      /\b[A-Za-z_][A-Za-z0-9_]*\b/
    ],
    scope: {
      1: "keyword",
      3: "keyword",
      5: "title.function"
    }
  }, Oe = {
    match: [
      /class\b/,
      /\s+/,
      /var\b/
    ],
    scope: {
      1: "keyword",
      3: "keyword"
    }
  }, Ye = {
    begin: [
      /(struct|protocol|class|extension|enum|actor)/,
      /\s+/,
      sn,
      /\s*/
    ],
    beginScope: {
      1: "keyword",
      3: "title.class"
    },
    keywords: c,
    contains: [
      Ke,
      ...d,
      {
        begin: /:/,
        end: /\{/,
        keywords: c,
        contains: [
          {
            scope: "title.class.inherited",
            match: Mr
          },
          ...d
        ],
        relevance: 0
      }
    ]
  };
  for (const ae of k.variants) {
    const ot = ae.contains.find((vt) => vt.label === "interpol");
    ot.keywords = c;
    const lt = [
      ...d,
      ...m,
      ...E,
      b,
      k,
      ...q
    ];
    ot.contains = [
      ...lt,
      {
        begin: /\(/,
        end: /\)/,
        contains: [
          "self",
          ...lt
        ]
      }
    ];
  }
  return {
    name: "Swift",
    keywords: c,
    contains: [
      ...i,
      Fe,
      Ce,
      ge,
      Oe,
      Ye,
      Ee,
      Y,
      {
        beginKeywords: "import",
        end: /$/,
        contains: [...i],
        relevance: 0
      },
      J,
      ...d,
      ...m,
      ...E,
      b,
      k,
      ...q,
      ..._e,
      me,
      tt
    ]
  };
}
const Wr = "[A-Za-z$_][0-9A-Za-z$_]*", kc = [
  "as",
  // for exports
  "in",
  "of",
  "if",
  "for",
  "while",
  "finally",
  "var",
  "new",
  "function",
  "do",
  "return",
  "void",
  "else",
  "break",
  "catch",
  "instanceof",
  "with",
  "throw",
  "case",
  "default",
  "try",
  "switch",
  "continue",
  "typeof",
  "delete",
  "let",
  "yield",
  "const",
  "class",
  // JS handles these with a special rule
  // "get",
  // "set",
  "debugger",
  "async",
  "await",
  "static",
  "import",
  "from",
  "export",
  "extends",
  // It's reached stage 3, which is "recommended for implementation":
  "using"
], Uc = [
  "true",
  "false",
  "null",
  "undefined",
  "NaN",
  "Infinity"
], Fc = [
  // Fundamental objects
  "Object",
  "Function",
  "Boolean",
  "Symbol",
  // numbers and dates
  "Math",
  "Date",
  "Number",
  "BigInt",
  // text
  "String",
  "RegExp",
  // Indexed collections
  "Array",
  "Float32Array",
  "Float64Array",
  "Int8Array",
  "Uint8Array",
  "Uint8ClampedArray",
  "Int16Array",
  "Int32Array",
  "Uint16Array",
  "Uint32Array",
  "BigInt64Array",
  "BigUint64Array",
  // Keyed collections
  "Set",
  "Map",
  "WeakSet",
  "WeakMap",
  // Structured data
  "ArrayBuffer",
  "SharedArrayBuffer",
  "Atomics",
  "DataView",
  "JSON",
  // Control abstraction objects
  "Promise",
  "Generator",
  "GeneratorFunction",
  "AsyncFunction",
  // Reflection
  "Reflect",
  "Proxy",
  // Internationalization
  "Intl",
  // WebAssembly
  "WebAssembly"
], Bc = [
  "Error",
  "EvalError",
  "InternalError",
  "RangeError",
  "ReferenceError",
  "SyntaxError",
  "TypeError",
  "URIError"
], Gc = [
  "setInterval",
  "setTimeout",
  "clearInterval",
  "clearTimeout",
  "require",
  "exports",
  "eval",
  "isFinite",
  "isNaN",
  "parseFloat",
  "parseInt",
  "decodeURI",
  "decodeURIComponent",
  "encodeURI",
  "encodeURIComponent",
  "escape",
  "unescape"
], Yc = [
  "arguments",
  "this",
  "super",
  "console",
  "window",
  "document",
  "localStorage",
  "sessionStorage",
  "module",
  "global"
  // Node.js
], $c = [].concat(
  Gc,
  Fc,
  Bc
);
function Hh(t) {
  const e = t.regex, n = (V, { after: Z }) => {
    const fe = "</" + V[0].slice(1);
    return V.input.indexOf(fe, Z) !== -1;
  }, i = Wr, r = {
    begin: "<>",
    end: "</>"
  }, a = /<[A-Za-z0-9\\._:-]+\s*\/>/, s = {
    begin: /<[A-Za-z0-9\\._:-]+/,
    end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
    /**
     * @param {RegExpMatchArray} match
     * @param {CallbackResponse} response
     */
    isTrulyOpeningTag: (V, Z) => {
      const fe = V[0].length + V.index, _e = V.input[fe];
      if (
        // HTML should not include another raw `<` inside a tag
        // nested type?
        // `<Array<Array<number>>`, etc.
        _e === "<" || // the , gives away that this is not HTML
        // `<T, A extends keyof T, V>`
        _e === ","
      ) {
        Z.ignoreMatch();
        return;
      }
      _e === ">" && (n(V, { after: fe }) || Z.ignoreMatch());
      let me;
      const Me = V.input.substring(fe);
      if (me = Me.match(/^\s*=/)) {
        Z.ignoreMatch();
        return;
      }
      if ((me = Me.match(/^\s+extends\s+/)) && me.index === 0) {
        Z.ignoreMatch();
        return;
      }
    }
  }, o = {
    $pattern: Wr,
    keyword: kc,
    literal: Uc,
    built_in: $c,
    "variable.language": Yc
  }, l = "[0-9](_?[0-9])*", c = `\\.(${l})`, d = "0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*", u = {
    className: "number",
    variants: [
      // DecimalLiteral
      { begin: `(\\b(${d})((${c})|\\.)?|(${c}))[eE][+-]?(${l})\\b` },
      { begin: `\\b(${d})\\b((${c})\\b|\\.)?|(${c})\\b` },
      // DecimalBigIntegerLiteral
      { begin: "\\b(0|[1-9](_?[0-9])*)n\\b" },
      // NonDecimalIntegerLiteral
      { begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b" },
      { begin: "\\b0[bB][0-1](_?[0-1])*n?\\b" },
      { begin: "\\b0[oO][0-7](_?[0-7])*n?\\b" },
      // LegacyOctalIntegerLiteral (does not include underscore separators)
      // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
      { begin: "\\b0[0-7]+n?\\b" }
    ],
    relevance: 0
  }, _ = {
    className: "subst",
    begin: "\\$\\{",
    end: "\\}",
    keywords: o,
    contains: []
    // defined later
  }, m = {
    begin: ".?html`",
    end: "",
    starts: {
      end: "`",
      returnEnd: !1,
      contains: [
        t.BACKSLASH_ESCAPE,
        _
      ],
      subLanguage: "xml"
    }
  }, g = {
    begin: ".?css`",
    end: "",
    starts: {
      end: "`",
      returnEnd: !1,
      contains: [
        t.BACKSLASH_ESCAPE,
        _
      ],
      subLanguage: "css"
    }
  }, S = {
    begin: ".?gql`",
    end: "",
    starts: {
      end: "`",
      returnEnd: !1,
      contains: [
        t.BACKSLASH_ESCAPE,
        _
      ],
      subLanguage: "graphql"
    }
  }, E = {
    className: "string",
    begin: "`",
    end: "`",
    contains: [
      t.BACKSLASH_ESCAPE,
      _
    ]
  }, T = {
    className: "comment",
    variants: [
      t.COMMENT(
        /\/\*\*(?!\/)/,
        "\\*/",
        {
          relevance: 0,
          contains: [
            {
              begin: "(?=@[A-Za-z]+)",
              relevance: 0,
              contains: [
                {
                  className: "doctag",
                  begin: "@[A-Za-z]+"
                },
                {
                  className: "type",
                  begin: "\\{",
                  end: "\\}",
                  excludeEnd: !0,
                  excludeBegin: !0,
                  relevance: 0
                },
                {
                  className: "variable",
                  begin: i + "(?=\\s*(-)|$)",
                  endsParent: !0,
                  relevance: 0
                },
                // eat spaces (not newlines) so we can find
                // types or variables
                {
                  begin: /(?=[^\n])\s/,
                  relevance: 0
                }
              ]
            }
          ]
        }
      ),
      t.C_BLOCK_COMMENT_MODE,
      t.C_LINE_COMMENT_MODE
    ]
  }, b = [
    t.APOS_STRING_MODE,
    t.QUOTE_STRING_MODE,
    m,
    g,
    S,
    E,
    // Skip numbers when they are part of a variable name
    { match: /\$\d+/ },
    u
    // This is intentional:
    // See https://github.com/highlightjs/highlight.js/issues/3288
    // hljs.REGEXP_MODE
  ];
  _.contains = b.concat({
    // we need to pair up {} inside our subst to prevent
    // it from ending too early by matching another }
    begin: /\{/,
    end: /\}/,
    keywords: o,
    contains: [
      "self"
    ].concat(b)
  });
  const C = [].concat(T, _.contains), y = C.concat([
    // eat recursive parens in sub expressions
    {
      begin: /(\s*)\(/,
      end: /\)/,
      keywords: o,
      contains: ["self"].concat(C)
    }
  ]), O = {
    className: "params",
    // convert this to negative lookbehind in v12
    begin: /(\s*)\(/,
    // to match the parms with
    end: /\)/,
    excludeBegin: !0,
    excludeEnd: !0,
    keywords: o,
    contains: y
  }, A = {
    variants: [
      // class Car extends vehicle
      {
        match: [
          /class/,
          /\s+/,
          i,
          /\s+/,
          /extends/,
          /\s+/,
          e.concat(i, "(", e.concat(/\./, i), ")*")
        ],
        scope: {
          1: "keyword",
          3: "title.class",
          5: "keyword",
          7: "title.class.inherited"
        }
      },
      // class Car
      {
        match: [
          /class/,
          /\s+/,
          i
        ],
        scope: {
          1: "keyword",
          3: "title.class"
        }
      }
    ]
  }, I = {
    relevance: 0,
    match: e.either(
      // Hard coded exceptions
      /\bJSON/,
      // Float32Array, OutT
      /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/,
      // CSSFactory, CSSFactoryT
      /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/,
      // FPs, FPsT
      /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/
      // P
      // single letters are not highlighted
      // BLAH
      // this will be flagged as a UPPER_CASE_CONSTANT instead
    ),
    className: "title.class",
    keywords: {
      _: [
        // se we still get relevance credit for JS library classes
        ...Fc,
        ...Bc
      ]
    }
  }, k = {
    label: "use_strict",
    className: "meta",
    relevance: 10,
    begin: /^\s*['"]use (strict|asm)['"]/
  }, x = {
    variants: [
      {
        match: [
          /function/,
          /\s+/,
          i,
          /(?=\s*\()/
        ]
      },
      // anonymous function
      {
        match: [
          /function/,
          /\s*(?=\()/
        ]
      }
    ],
    className: {
      1: "keyword",
      3: "title.function"
    },
    label: "func.def",
    contains: [O],
    illegal: /%/
  }, B = {
    relevance: 0,
    match: /\b[A-Z][A-Z_0-9]+\b/,
    className: "variable.constant"
  };
  function X(V) {
    return e.concat("(?!", V.join("|"), ")");
  }
  const J = {
    match: e.concat(
      /\b/,
      X([
        ...Gc,
        "super",
        "import"
      ].map((V) => `${V}\\s*\\(`)),
      i,
      e.lookahead(/\s*\(/)
    ),
    className: "title.function",
    relevance: 0
  }, D = {
    begin: e.concat(/\./, e.lookahead(
      e.concat(i, /(?![0-9A-Za-z$_(])/)
    )),
    end: i,
    excludeBegin: !0,
    keywords: "prototype",
    className: "property",
    relevance: 0
  }, L = {
    match: [
      /get|set/,
      /\s+/,
      i,
      /(?=\()/
    ],
    className: {
      1: "keyword",
      3: "title.function"
    },
    contains: [
      {
        // eat to avoid empty params
        begin: /\(\)/
      },
      O
    ]
  }, G = "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + t.UNDERSCORE_IDENT_RE + ")\\s*=>", q = {
    match: [
      /const|var|let/,
      /\s+/,
      i,
      /\s*/,
      /=\s*/,
      /(async\s*)?/,
      // async is optional
      e.lookahead(G)
    ],
    keywords: "async",
    className: {
      1: "keyword",
      3: "title.function"
    },
    contains: [
      O
    ]
  };
  return {
    name: "JavaScript",
    aliases: ["js", "jsx", "mjs", "cjs"],
    keywords: o,
    // this will be extended by TypeScript
    exports: { PARAMS_CONTAINS: y, CLASS_REFERENCE: I },
    illegal: /#(?![$_A-z])/,
    contains: [
      t.SHEBANG({
        label: "shebang",
        binary: "node",
        relevance: 5
      }),
      k,
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE,
      m,
      g,
      S,
      E,
      T,
      // Skip numbers when they are part of a variable name
      { match: /\$\d+/ },
      u,
      I,
      {
        scope: "attr",
        match: i + e.lookahead(":"),
        relevance: 0
      },
      q,
      {
        // "value" container
        begin: "(" + t.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
        keywords: "return throw case",
        relevance: 0,
        contains: [
          T,
          t.REGEXP_MODE,
          {
            className: "function",
            // we have to count the parens to make sure we actually have the
            // correct bounding ( ) before the =>.  There could be any number of
            // sub-expressions inside also surrounded by parens.
            begin: G,
            returnBegin: !0,
            end: "\\s*=>",
            contains: [
              {
                className: "params",
                variants: [
                  {
                    begin: t.UNDERSCORE_IDENT_RE,
                    relevance: 0
                  },
                  {
                    className: null,
                    begin: /\(\s*\)/,
                    skip: !0
                  },
                  {
                    begin: /(\s*)\(/,
                    end: /\)/,
                    excludeBegin: !0,
                    excludeEnd: !0,
                    keywords: o,
                    contains: y
                  }
                ]
              }
            ]
          },
          {
            // could be a comma delimited list of params to a function call
            begin: /,/,
            relevance: 0
          },
          {
            match: /\s+/,
            relevance: 0
          },
          {
            // JSX
            variants: [
              { begin: r.begin, end: r.end },
              { match: a },
              {
                begin: s.begin,
                // we carefully check the opening tag to see if it truly
                // is a tag and not a false positive
                "on:begin": s.isTrulyOpeningTag,
                end: s.end
              }
            ],
            subLanguage: "xml",
            contains: [
              {
                begin: s.begin,
                end: s.end,
                skip: !0,
                contains: ["self"]
              }
            ]
          }
        ]
      },
      x,
      {
        // prevent this from getting swallowed up by function
        // since they appear "function like"
        beginKeywords: "while if switch catch for"
      },
      {
        // we have to count the parens to make sure we actually have the correct
        // bounding ( ).  There could be any number of sub-expressions inside
        // also surrounded by parens.
        begin: "\\b(?!function)" + t.UNDERSCORE_IDENT_RE + "\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)\\s*\\{",
        // end parens
        returnBegin: !0,
        label: "func.def",
        contains: [
          O,
          t.inherit(t.TITLE_MODE, { begin: i, className: "title.function" })
        ]
      },
      // catch ... so it won't trigger the property rule below
      {
        match: /\.\.\./,
        relevance: 0
      },
      D,
      // hack: prevents detection of keywords in some circumstances
      // .keyword()
      // $keyword = x
      {
        match: "\\$" + i,
        relevance: 0
      },
      {
        match: [/\bconstructor(?=\s*\()/],
        className: { 1: "title.function" },
        contains: [O]
      },
      J,
      B,
      A,
      L,
      {
        match: /\$[(.]/
        // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
      }
    ]
  };
}
function qh(t) {
  const e = t.regex, n = Hh(t), i = Wr, r = [
    "any",
    "void",
    "number",
    "boolean",
    "string",
    "object",
    "never",
    "symbol",
    "bigint",
    "unknown"
  ], a = {
    begin: [
      /namespace/,
      /\s+/,
      t.IDENT_RE
    ],
    beginScope: {
      1: "keyword",
      3: "title.class"
    }
  }, s = {
    beginKeywords: "interface",
    end: /\{/,
    excludeEnd: !0,
    keywords: {
      keyword: "interface extends",
      built_in: r
    },
    contains: [n.exports.CLASS_REFERENCE]
  }, o = {
    className: "meta",
    relevance: 10,
    begin: /^\s*['"]use strict['"]/
  }, l = [
    "type",
    // "namespace",
    "interface",
    "public",
    "private",
    "protected",
    "implements",
    "declare",
    "abstract",
    "readonly",
    "enum",
    "override",
    "satisfies"
  ], c = {
    $pattern: Wr,
    keyword: kc.concat(l),
    literal: Uc,
    built_in: $c.concat(r),
    "variable.language": Yc
  }, d = {
    className: "meta",
    begin: "@" + i
  }, u = (S, E, h) => {
    const T = S.contains.findIndex((b) => b.label === E);
    if (T === -1)
      throw new Error("can not find mode to replace");
    S.contains.splice(T, 1, h);
  };
  Object.assign(n.keywords, c), n.exports.PARAMS_CONTAINS.push(d);
  const _ = n.contains.find((S) => S.scope === "attr"), m = Object.assign(
    {},
    _,
    { match: e.concat(i, e.lookahead(/\s*\?:/)) }
  );
  n.exports.PARAMS_CONTAINS.push([
    n.exports.CLASS_REFERENCE,
    // class reference for highlighting the params types
    _,
    // highlight the params key
    m
    // Added for optional property assignment highlighting
  ]), n.contains = n.contains.concat([
    d,
    a,
    s,
    m
    // Added for optional property assignment highlighting
  ]), u(n, "shebang", t.SHEBANG()), u(n, "use_strict", o);
  const g = n.contains.find((S) => S.label === "func.def");
  return g.relevance = 0, Object.assign(n, {
    name: "TypeScript",
    aliases: [
      "ts",
      "tsx",
      "mts",
      "cts"
    ]
  }), n;
}
function zh(t) {
  const e = t.regex, n = {
    className: "string",
    begin: /"(""|[^/n])"C\b/
  }, i = {
    className: "string",
    begin: /"/,
    end: /"/,
    illegal: /\n/,
    contains: [
      {
        // double quote escape
        begin: /""/
      }
    ]
  }, r = /\d{1,2}\/\d{1,2}\/\d{4}/, a = /\d{4}-\d{1,2}-\d{1,2}/, s = /(\d|1[012])(:\d+){0,2} *(AM|PM)/, o = /\d{1,2}(:\d{1,2}){1,2}/, l = {
    className: "literal",
    variants: [
      {
        // #YYYY-MM-DD# (ISO-Date) or #M/D/YYYY# (US-Date)
        begin: e.concat(/# */, e.either(a, r), / *#/)
      },
      {
        // #H:mm[:ss]# (24h Time)
        begin: e.concat(/# */, o, / *#/)
      },
      {
        // #h[:mm[:ss]] A# (12h Time)
        begin: e.concat(/# */, s, / *#/)
      },
      {
        // date plus time
        begin: e.concat(
          /# */,
          e.either(a, r),
          / +/,
          e.either(s, o),
          / *#/
        )
      }
    ]
  }, c = {
    className: "number",
    relevance: 0,
    variants: [
      {
        // Float
        begin: /\b\d[\d_]*((\.[\d_]+(E[+-]?[\d_]+)?)|(E[+-]?[\d_]+))[RFD@!#]?/
      },
      {
        // Integer (base 10)
        begin: /\b\d[\d_]*((U?[SIL])|[%&])?/
      },
      {
        // Integer (base 16)
        begin: /&H[\dA-F_]+((U?[SIL])|[%&])?/
      },
      {
        // Integer (base 8)
        begin: /&O[0-7_]+((U?[SIL])|[%&])?/
      },
      {
        // Integer (base 2)
        begin: /&B[01_]+((U?[SIL])|[%&])?/
      }
    ]
  }, d = {
    className: "label",
    begin: /^\w+:/
  }, u = t.COMMENT(/'''/, /$/, { contains: [
    {
      className: "doctag",
      begin: /<\/?/,
      end: />/
    }
  ] }), _ = t.COMMENT(null, /$/, { variants: [
    { begin: /'/ },
    {
      // TODO: Use multi-class for leading spaces
      begin: /([\t ]|^)REM(?=\s)/
    }
  ] });
  return {
    name: "Visual Basic .NET",
    aliases: ["vb"],
    case_insensitive: !0,
    classNameAliases: { label: "symbol" },
    keywords: {
      keyword: "addhandler alias aggregate ansi as async assembly auto binary by byref byval call case catch class compare const continue custom declare default delegate dim distinct do each equals else elseif end enum erase error event exit explicit finally for friend from function get global goto group handles if implements imports in inherits interface into iterator join key let lib loop me mid module mustinherit mustoverride mybase myclass namespace narrowing new next notinheritable notoverridable of off on operator option optional order overloads overridable overrides paramarray partial preserve private property protected public raiseevent readonly redim removehandler resume return select set shadows shared skip static step stop structure strict sub synclock take text then throw to try unicode until using when where while widening with withevents writeonly yield",
      built_in: (
        // Operators https://docs.microsoft.com/dotnet/visual-basic/language-reference/operators
        "addressof and andalso await directcast gettype getxmlnamespace is isfalse isnot istrue like mod nameof new not or orelse trycast typeof xor cbool cbyte cchar cdate cdbl cdec cint clng cobj csbyte cshort csng cstr cuint culng cushort"
      ),
      type: (
        // Data types https://docs.microsoft.com/dotnet/visual-basic/language-reference/data-types
        "boolean byte char date decimal double integer long object sbyte short single string uinteger ulong ushort"
      ),
      literal: "true false nothing"
    },
    illegal: "//|\\{|\\}|endif|gosub|variant|wend|^\\$ ",
    contains: [
      n,
      i,
      l,
      c,
      d,
      u,
      _,
      {
        className: "meta",
        // TODO: Use multi-class for indentation once available
        begin: /[\t ]*#(const|disable|else|elseif|enable|end|externalsource|if|region)\b/,
        end: /$/,
        keywords: { keyword: "const disable else elseif enable end externalsource if region then" },
        contains: [_]
      }
    ]
  };
}
function Wh(t) {
  t.regex;
  const e = t.COMMENT(/\(;/, /;\)/);
  e.contains.push("self");
  const n = t.COMMENT(/;;/, /$/), i = [
    "anyfunc",
    "block",
    "br",
    "br_if",
    "br_table",
    "call",
    "call_indirect",
    "data",
    "drop",
    "elem",
    "else",
    "end",
    "export",
    "func",
    "global.get",
    "global.set",
    "local.get",
    "local.set",
    "local.tee",
    "get_global",
    "get_local",
    "global",
    "if",
    "import",
    "local",
    "loop",
    "memory",
    "memory.grow",
    "memory.size",
    "module",
    "mut",
    "nop",
    "offset",
    "param",
    "result",
    "return",
    "select",
    "set_global",
    "set_local",
    "start",
    "table",
    "tee_local",
    "then",
    "type",
    "unreachable"
  ], r = {
    begin: [
      /(?:func|call|call_indirect)/,
      /\s+/,
      /\$[^\s)]+/
    ],
    className: {
      1: "keyword",
      3: "title.function"
    }
  }, a = {
    className: "variable",
    begin: /\$[\w_]+/
  }, s = {
    match: /(\((?!;)|\))+/,
    className: "punctuation",
    relevance: 0
  }, o = {
    className: "number",
    relevance: 0,
    // borrowed from Prism, TODO: split out into variants
    match: /[+-]?\b(?:\d(?:_?\d)*(?:\.\d(?:_?\d)*)?(?:[eE][+-]?\d(?:_?\d)*)?|0x[\da-fA-F](?:_?[\da-fA-F])*(?:\.[\da-fA-F](?:_?[\da-fA-D])*)?(?:[pP][+-]?\d(?:_?\d)*)?)\b|\binf\b|\bnan(?::0x[\da-fA-F](?:_?[\da-fA-D])*)?\b/
  }, l = {
    // look-ahead prevents us from gobbling up opcodes
    match: /(i32|i64|f32|f64)(?!\.)/,
    className: "type"
  }, c = {
    className: "keyword",
    // borrowed from Prism, TODO: split out into variants
    match: /\b(f32|f64|i32|i64)(?:\.(?:abs|add|and|ceil|clz|const|convert_[su]\/i(?:32|64)|copysign|ctz|demote\/f64|div(?:_[su])?|eqz?|extend_[su]\/i32|floor|ge(?:_[su])?|gt(?:_[su])?|le(?:_[su])?|load(?:(?:8|16|32)_[su])?|lt(?:_[su])?|max|min|mul|nearest|neg?|or|popcnt|promote\/f32|reinterpret\/[fi](?:32|64)|rem_[su]|rot[lr]|shl|shr_[su]|store(?:8|16|32)?|sqrt|sub|trunc(?:_[su]\/f(?:32|64))?|wrap\/i64|xor))\b/
  };
  return {
    name: "WebAssembly",
    keywords: {
      $pattern: /[\w.]+/,
      keyword: i
    },
    contains: [
      n,
      e,
      {
        match: [
          /(?:offset|align)/,
          /\s*/,
          /=/
        ],
        className: {
          1: "keyword",
          3: "operator"
        }
      },
      a,
      s,
      r,
      t.QUOTE_STRING_MODE,
      l,
      c,
      o
    ]
  };
}
function Kh(t) {
  const e = t.regex, n = e.concat(/[\p{L}_]/u, e.optional(/[\p{L}0-9_.-]*:/u), /[\p{L}0-9_.-]*/u), i = /[\p{L}0-9._:-]+/u, r = {
    className: "symbol",
    begin: /&[a-z]+;|&#[0-9]+;|&#x[a-f0-9]+;/
  }, a = {
    begin: /\s/,
    contains: [
      {
        className: "keyword",
        begin: /#?[a-z_][a-z1-9_-]+/,
        illegal: /\n/
      }
    ]
  }, s = t.inherit(a, {
    begin: /\(/,
    end: /\)/
  }), o = t.inherit(t.APOS_STRING_MODE, { className: "string" }), l = t.inherit(t.QUOTE_STRING_MODE, { className: "string" }), c = {
    endsWithParent: !0,
    illegal: /</,
    relevance: 0,
    contains: [
      {
        className: "attr",
        begin: i,
        relevance: 0
      },
      {
        begin: /=\s*/,
        relevance: 0,
        contains: [
          {
            className: "string",
            endsParent: !0,
            variants: [
              {
                begin: /"/,
                end: /"/,
                contains: [r]
              },
              {
                begin: /'/,
                end: /'/,
                contains: [r]
              },
              { begin: /[^\s"'=<>`]+/ }
            ]
          }
        ]
      }
    ]
  };
  return {
    name: "HTML, XML",
    aliases: [
      "html",
      "xhtml",
      "rss",
      "atom",
      "xjb",
      "xsd",
      "xsl",
      "plist",
      "wsf",
      "svg"
    ],
    case_insensitive: !0,
    unicodeRegex: !0,
    contains: [
      {
        className: "meta",
        begin: /<![a-z]/,
        end: />/,
        relevance: 10,
        contains: [
          a,
          l,
          o,
          s,
          {
            begin: /\[/,
            end: /\]/,
            contains: [
              {
                className: "meta",
                begin: /<![a-z]/,
                end: />/,
                contains: [
                  a,
                  s,
                  l,
                  o
                ]
              }
            ]
          }
        ]
      },
      t.COMMENT(
        /<!--/,
        /-->/,
        { relevance: 10 }
      ),
      {
        begin: /<!\[CDATA\[/,
        end: /\]\]>/,
        relevance: 10
      },
      r,
      // xml processing instructions
      {
        className: "meta",
        end: /\?>/,
        variants: [
          {
            begin: /<\?xml/,
            relevance: 10,
            contains: [
              l
            ]
          },
          {
            begin: /<\?[a-z][a-z0-9]+/
          }
        ]
      },
      {
        className: "tag",
        /*
        The lookahead pattern (?=...) ensures that 'begin' only matches
        '<style' as a single word, followed by a whitespace or an
        ending bracket.
        */
        begin: /<style(?=\s|>)/,
        end: />/,
        keywords: { name: "style" },
        contains: [c],
        starts: {
          end: /<\/style>/,
          returnEnd: !0,
          subLanguage: [
            "css",
            "xml"
          ]
        }
      },
      {
        className: "tag",
        // See the comment in the <style tag about the lookahead pattern
        begin: /<script(?=\s|>)/,
        end: />/,
        keywords: { name: "script" },
        contains: [c],
        starts: {
          end: /<\/script>/,
          returnEnd: !0,
          subLanguage: [
            "javascript",
            "handlebars",
            "xml"
          ]
        }
      },
      // we need this for now for jSX
      {
        className: "tag",
        begin: /<>|<\/>/
      },
      // open tag
      {
        className: "tag",
        begin: e.concat(
          /</,
          e.lookahead(e.concat(
            n,
            // <tag/>
            // <tag>
            // <tag ...
            e.either(/\/>/, />/, /\s/)
          ))
        ),
        end: /\/?>/,
        contains: [
          {
            className: "name",
            begin: n,
            relevance: 0,
            starts: c
          }
        ]
      },
      // close tag
      {
        className: "tag",
        begin: e.concat(
          /<\//,
          e.lookahead(e.concat(
            n,
            />/
          ))
        ),
        contains: [
          {
            className: "name",
            begin: n,
            relevance: 0
          },
          {
            begin: />/,
            relevance: 0,
            endsParent: !0
          }
        ]
      }
    ]
  };
}
function Qh(t) {
  const e = "true false yes no null", n = "[\\w#;/?:@&=+$,.~*'()[\\]]+", i = {
    className: "attr",
    variants: [
      // added brackets support and special char support
      { begin: /[\w*@][\w*@ :()\./-]*:(?=[ \t]|$)/ },
      {
        // double quoted keys - with brackets and special char support
        begin: /"[\w*@][\w*@ :()\./-]*":(?=[ \t]|$)/
      },
      {
        // single quoted keys - with brackets and special char support
        begin: /'[\w*@][\w*@ :()\./-]*':(?=[ \t]|$)/
      }
    ]
  }, r = {
    className: "template-variable",
    variants: [
      {
        // jinja templates Ansible
        begin: /\{\{/,
        end: /\}\}/
      },
      {
        // Ruby i18n
        begin: /%\{/,
        end: /\}/
      }
    ]
  }, a = {
    className: "string",
    relevance: 0,
    begin: /'/,
    end: /'/,
    contains: [
      {
        match: /''/,
        scope: "char.escape",
        relevance: 0
      }
    ]
  }, s = {
    className: "string",
    relevance: 0,
    variants: [
      {
        begin: /"/,
        end: /"/
      },
      { begin: /\S+/ }
    ],
    contains: [
      t.BACKSLASH_ESCAPE,
      r
    ]
  }, o = t.inherit(s, { variants: [
    {
      begin: /'/,
      end: /'/,
      contains: [
        {
          begin: /''/,
          relevance: 0
        }
      ]
    },
    {
      begin: /"/,
      end: /"/
    },
    { begin: /[^\s,{}[\]]+/ }
  ] }), _ = {
    className: "number",
    begin: "\\b" + "[0-9]{4}(-[0-9][0-9]){0,2}" + "([Tt \\t][0-9][0-9]?(:[0-9][0-9]){2})?" + "(\\.[0-9]*)?" + "([ \\t])*(Z|[-+][0-9][0-9]?(:[0-9][0-9])?)?" + "\\b"
  }, m = {
    end: ",",
    endsWithParent: !0,
    excludeEnd: !0,
    keywords: e,
    relevance: 0
  }, g = {
    begin: /\{/,
    end: /\}/,
    contains: [m],
    illegal: "\\n",
    relevance: 0
  }, S = {
    begin: "\\[",
    end: "\\]",
    contains: [m],
    illegal: "\\n",
    relevance: 0
  }, E = [
    i,
    {
      className: "meta",
      begin: "^---\\s*$",
      relevance: 10
    },
    {
      // multi line string
      // Blocks start with a | or > followed by a newline
      //
      // Indentation of subsequent lines must be the same to
      // be considered part of the block
      className: "string",
      begin: "[\\|>]([1-9]?[+-])?[ ]*\\n( +)[^ ][^\\n]*\\n(\\2[^\\n]+\\n?)*"
    },
    {
      // Ruby/Rails erb
      begin: "<%[%=-]?",
      end: "[%-]?%>",
      subLanguage: "ruby",
      excludeBegin: !0,
      excludeEnd: !0,
      relevance: 0
    },
    {
      // named tags
      className: "type",
      begin: "!\\w+!" + n
    },
    // https://yaml.org/spec/1.2/spec.html#id2784064
    {
      // verbatim tags
      className: "type",
      begin: "!<" + n + ">"
    },
    {
      // primary tags
      className: "type",
      begin: "!" + n
    },
    {
      // secondary tags
      className: "type",
      begin: "!!" + n
    },
    {
      // fragment id &ref
      className: "meta",
      begin: "&" + t.UNDERSCORE_IDENT_RE + "$"
    },
    {
      // fragment reference *ref
      className: "meta",
      begin: "\\*" + t.UNDERSCORE_IDENT_RE + "$"
    },
    {
      // array listing
      className: "bullet",
      // TODO: remove |$ hack when we have proper look-ahead support
      begin: "-(?=[ ]|$)",
      relevance: 0
    },
    t.HASH_COMMENT_MODE,
    {
      beginKeywords: e,
      keywords: { literal: e }
    },
    _,
    // numbers are any valid C-style number that
    // sit isolated from other words
    {
      className: "number",
      begin: t.C_NUMBER_RE + "\\b",
      relevance: 0
    },
    g,
    S,
    a,
    s
  ], h = [...E];
  return h.pop(), h.push(o), m.contains = h, {
    name: "YAML",
    case_insensitive: !0,
    aliases: ["yml"],
    contains: E
  };
}
const Xh = {
  arduino: MS,
  bash: wS,
  c: xS,
  cpp: LS,
  csharp: PS,
  css: HS,
  diff: qS,
  go: zS,
  graphql: WS,
  ini: KS,
  java: QS,
  javascript: eh,
  json: th,
  kotlin: ih,
  less: uh,
  lua: _h,
  makefile: ph,
  markdown: mh,
  objectivec: Eh,
  perl: gh,
  php: Sh,
  "php-template": hh,
  plaintext: fh,
  python: Th,
  "python-repl": bh,
  r: Ch,
  ruby: yh,
  rust: Rh,
  scss: xh,
  shell: Lh,
  sql: Ph,
  swift: Vh,
  typescript: qh,
  vbnet: zh,
  wasm: Wh,
  xml: Kh,
  yaml: Qh
}, Zh = {
  ...Xh,
  "1c": mm,
  abnf: Em,
  accesslog: gm,
  actionscript: Sm,
  ada: hm,
  angelscript: fm,
  apache: Tm,
  applescript: bm,
  arcade: Cm,
  armasm: ym,
  asciidoc: Rm,
  aspectj: Nm,
  autohotkey: Om,
  autoit: vm,
  avrasm: Am,
  awk: Im,
  axapta: Dm,
  basic: Mm,
  bnf: wm,
  brainfuck: xm,
  cal: Lm,
  capnproto: Pm,
  ceylon: km,
  clean: Um,
  clojure: Fm,
  "clojure-repl": Bm,
  cmake: Gm,
  coffeescript: Wm,
  coq: Km,
  cos: Qm,
  crmsh: Xm,
  crystal: Zm,
  csp: Jm,
  d: jm,
  dart: eE,
  delphi: tE,
  django: nE,
  dns: iE,
  dockerfile: rE,
  dos: aE,
  dsconfig: sE,
  dts: oE,
  dust: lE,
  ebnf: cE,
  elixir: dE,
  elm: uE,
  erb: _E,
  erlang: pE,
  "erlang-repl": mE,
  excel: EE,
  fix: gE,
  flix: SE,
  fortran: hE,
  fsharp: bE,
  gams: CE,
  gauss: yE,
  gcode: RE,
  gherkin: NE,
  glsl: OE,
  gml: vE,
  golo: AE,
  gradle: IE,
  groovy: DE,
  haml: ME,
  handlebars: wE,
  haskell: xE,
  haxe: LE,
  hsp: PE,
  http: kE,
  hy: UE,
  inform7: FE,
  irpf90: BE,
  isbl: GE,
  "jboss-cli": YE,
  julia: $E,
  "julia-repl": VE,
  lasso: HE,
  latex: qE,
  ldif: zE,
  leaf: WE,
  lisp: KE,
  livecodeserver: QE,
  livescript: ng,
  llvm: ig,
  lsl: rg,
  mathematica: sg,
  matlab: og,
  maxima: lg,
  mel: cg,
  mercury: dg,
  mipsasm: ug,
  mizar: _g,
  mojolicious: pg,
  monkey: mg,
  moonscript: Eg,
  n1ql: gg,
  nestedtext: Sg,
  nginx: hg,
  nim: fg,
  nix: Tg,
  "node-repl": bg,
  nsis: Cg,
  ocaml: yg,
  openscad: Rg,
  oxygene: Ng,
  parser3: Og,
  pf: vg,
  pgsql: Ag,
  pony: Ig,
  powershell: Dg,
  processing: Mg,
  profile: wg,
  prolog: xg,
  properties: Lg,
  protobuf: Pg,
  puppet: kg,
  purebasic: Ug,
  q: Fg,
  qml: Bg,
  reasonml: Gg,
  rib: Yg,
  roboconf: $g,
  routeros: Vg,
  rsl: Hg,
  ruleslanguage: qg,
  sas: zg,
  scala: Wg,
  scheme: Kg,
  scilab: Qg,
  smali: Xg,
  smalltalk: Zg,
  sml: Jg,
  sqf: jg,
  stan: eS,
  stata: tS,
  step21: nS,
  stylus: uS,
  subunit: _S,
  taggerscript: pS,
  tap: mS,
  tcl: ES,
  thrift: gS,
  tp: SS,
  twig: hS,
  vala: fS,
  vbscript: TS,
  "vbscript-html": bS,
  verilog: CS,
  vhdl: yS,
  vim: RS,
  wren: NS,
  x86asm: OS,
  xl: vS,
  xquery: AS,
  zephir: IS
};
var Ua, _l;
function Jh() {
  if (_l) return Ua;
  _l = 1;
  function t(f) {
    return f instanceof Map ? f.clear = f.delete = f.set = function() {
      throw new Error("map is read-only");
    } : f instanceof Set && (f.add = f.clear = f.delete = function() {
      throw new Error("set is read-only");
    }), Object.freeze(f), Object.getOwnPropertyNames(f).forEach((v) => {
      const P = f[v], ee = typeof P;
      (ee === "object" || ee === "function") && !Object.isFrozen(P) && t(P);
    }), f;
  }
  class e {
    /**
     * @param {CompiledMode} mode
     */
    constructor(v) {
      v.data === void 0 && (v.data = {}), this.data = v.data, this.isMatchIgnored = !1;
    }
    ignoreMatch() {
      this.isMatchIgnored = !0;
    }
  }
  function n(f) {
    return f.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
  }
  function i(f, ...v) {
    const P = /* @__PURE__ */ Object.create(null);
    for (const ee in f)
      P[ee] = f[ee];
    return v.forEach(function(ee) {
      for (const He in ee)
        P[He] = ee[He];
    }), /** @type {T} */
    P;
  }
  const r = "</span>", a = (f) => !!f.scope, s = (f, { prefix: v }) => {
    if (f.startsWith("language:"))
      return f.replace("language:", "language-");
    if (f.includes(".")) {
      const P = f.split(".");
      return [
        `${v}${P.shift()}`,
        ...P.map((ee, He) => `${ee}${"_".repeat(He + 1)}`)
      ].join(" ");
    }
    return `${v}${f}`;
  };
  class o {
    /**
     * Creates a new HTMLRenderer
     *
     * @param {Tree} parseTree - the parse tree (must support `walk` API)
     * @param {{classPrefix: string}} options
     */
    constructor(v, P) {
      this.buffer = "", this.classPrefix = P.classPrefix, v.walk(this);
    }
    /**
     * Adds texts to the output stream
     *
     * @param {string} text */
    addText(v) {
      this.buffer += n(v);
    }
    /**
     * Adds a node open to the output stream (if needed)
     *
     * @param {Node} node */
    openNode(v) {
      if (!a(v)) return;
      const P = s(
        v.scope,
        { prefix: this.classPrefix }
      );
      this.span(P);
    }
    /**
     * Adds a node close to the output stream (if needed)
     *
     * @param {Node} node */
    closeNode(v) {
      a(v) && (this.buffer += r);
    }
    /**
     * returns the accumulated buffer
    */
    value() {
      return this.buffer;
    }
    // helpers
    /**
     * Builds a span element
     *
     * @param {string} className */
    span(v) {
      this.buffer += `<span class="${v}">`;
    }
  }
  const l = (f = {}) => {
    const v = { children: [] };
    return Object.assign(v, f), v;
  };
  class c {
    constructor() {
      this.rootNode = l(), this.stack = [this.rootNode];
    }
    get top() {
      return this.stack[this.stack.length - 1];
    }
    get root() {
      return this.rootNode;
    }
    /** @param {Node} node */
    add(v) {
      this.top.children.push(v);
    }
    /** @param {string} scope */
    openNode(v) {
      const P = l({ scope: v });
      this.add(P), this.stack.push(P);
    }
    closeNode() {
      if (this.stack.length > 1)
        return this.stack.pop();
    }
    closeAllNodes() {
      for (; this.closeNode(); ) ;
    }
    toJSON() {
      return JSON.stringify(this.rootNode, null, 4);
    }
    /**
     * @typedef { import("./html_renderer").Renderer } Renderer
     * @param {Renderer} builder
     */
    walk(v) {
      return this.constructor._walk(v, this.rootNode);
    }
    /**
     * @param {Renderer} builder
     * @param {Node} node
     */
    static _walk(v, P) {
      return typeof P == "string" ? v.addText(P) : P.children && (v.openNode(P), P.children.forEach((ee) => this._walk(v, ee)), v.closeNode(P)), v;
    }
    /**
     * @param {Node} node
     */
    static _collapse(v) {
      typeof v != "string" && v.children && (v.children.every((P) => typeof P == "string") ? v.children = [v.children.join("")] : v.children.forEach((P) => {
        c._collapse(P);
      }));
    }
  }
  class d extends c {
    /**
     * @param {*} options
     */
    constructor(v) {
      super(), this.options = v;
    }
    /**
     * @param {string} text
     */
    addText(v) {
      v !== "" && this.add(v);
    }
    /** @param {string} scope */
    startScope(v) {
      this.openNode(v);
    }
    endScope() {
      this.closeNode();
    }
    /**
     * @param {Emitter & {root: DataNode}} emitter
     * @param {string} name
     */
    __addSublanguage(v, P) {
      const ee = v.root;
      P && (ee.scope = `language:${P}`), this.add(ee);
    }
    toHTML() {
      return new o(this, this.options).value();
    }
    finalize() {
      return this.closeAllNodes(), !0;
    }
  }
  function u(f) {
    return f ? typeof f == "string" ? f : f.source : null;
  }
  function _(f) {
    return S("(?=", f, ")");
  }
  function m(f) {
    return S("(?:", f, ")*");
  }
  function g(f) {
    return S("(?:", f, ")?");
  }
  function S(...f) {
    return f.map((P) => u(P)).join("");
  }
  function E(f) {
    const v = f[f.length - 1];
    return typeof v == "object" && v.constructor === Object ? (f.splice(f.length - 1, 1), v) : {};
  }
  function h(...f) {
    return "(" + (E(f).capture ? "" : "?:") + f.map((ee) => u(ee)).join("|") + ")";
  }
  function T(f) {
    return new RegExp(f.toString() + "|").exec("").length - 1;
  }
  function b(f, v) {
    const P = f && f.exec(v);
    return P && P.index === 0;
  }
  const C = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;
  function y(f, { joinWith: v }) {
    let P = 0;
    return f.map((ee) => {
      P += 1;
      const He = P;
      let qe = u(ee), z = "";
      for (; qe.length > 0; ) {
        const $ = C.exec(qe);
        if (!$) {
          z += qe;
          break;
        }
        z += qe.substring(0, $.index), qe = qe.substring($.index + $[0].length), $[0][0] === "\\" && $[1] ? z += "\\" + String(Number($[1]) + He) : (z += $[0], $[0] === "(" && P++);
      }
      return z;
    }).map((ee) => `(${ee})`).join(v);
  }
  const O = /\b\B/, A = "[a-zA-Z]\\w*", I = "[a-zA-Z_]\\w*", k = "\\b\\d+(\\.\\d+)?", x = "(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)", B = "\\b(0b[01]+)", X = "!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~", J = (f = {}) => {
    const v = /^#![ ]*\//;
    return f.binary && (f.begin = S(
      v,
      /.*\b/,
      f.binary,
      /\b.*/
    )), i({
      scope: "meta",
      begin: v,
      end: /$/,
      relevance: 0,
      /** @type {ModeCallback} */
      "on:begin": (P, ee) => {
        P.index !== 0 && ee.ignoreMatch();
      }
    }, f);
  }, D = {
    begin: "\\\\[\\s\\S]",
    relevance: 0
  }, L = {
    scope: "string",
    begin: "'",
    end: "'",
    illegal: "\\n",
    contains: [D]
  }, G = {
    scope: "string",
    begin: '"',
    end: '"',
    illegal: "\\n",
    contains: [D]
  }, q = {
    begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
  }, V = function(f, v, P = {}) {
    const ee = i(
      {
        scope: "comment",
        begin: f,
        end: v,
        contains: []
      },
      P
    );
    ee.contains.push({
      scope: "doctag",
      // hack to avoid the space from being included. the space is necessary to
      // match here to prevent the plain text rule below from gobbling up doctags
      begin: "[ ]*(?=(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):)",
      end: /(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):/,
      excludeBegin: !0,
      relevance: 0
    });
    const He = h(
      // list of common 1 and 2 letter words in English
      "I",
      "a",
      "is",
      "so",
      "us",
      "to",
      "at",
      "if",
      "in",
      "it",
      "on",
      // note: this is not an exhaustive list of contractions, just popular ones
      /[A-Za-z]+['](d|ve|re|ll|t|s|n)/,
      // contractions - can't we'd they're let's, etc
      /[A-Za-z]+[-][a-z]+/,
      // `no-way`, etc.
      /[A-Za-z][a-z]{2,}/
      // allow capitalized words at beginning of sentences
    );
    return ee.contains.push(
      {
        // TODO: how to include ", (, ) without breaking grammars that use these for
        // comment delimiters?
        // begin: /[ ]+([()"]?([A-Za-z'-]{3,}|is|a|I|so|us|[tT][oO]|at|if|in|it|on)[.]?[()":]?([.][ ]|[ ]|\))){3}/
        // ---
        // this tries to find sequences of 3 english words in a row (without any
        // "programming" type syntax) this gives us a strong signal that we've
        // TRULY found a comment - vs perhaps scanning with the wrong language.
        // It's possible to find something that LOOKS like the start of the
        // comment - but then if there is no readable text - good chance it is a
        // false match and not a comment.
        //
        // for a visual example please see:
        // https://github.com/highlightjs/highlight.js/issues/2827
        begin: S(
          /[ ]+/,
          // necessary to prevent us gobbling up doctags like /* @author Bob Mcgill */
          "(",
          He,
          /[.]?[:]?([.][ ]|[ ])/,
          "){3}"
        )
        // look for 3 words in a row
      }
    ), ee;
  }, Z = V("//", "$"), fe = V("/\\*", "\\*/"), _e = V("#", "$"), me = {
    scope: "number",
    begin: k,
    relevance: 0
  }, Me = {
    scope: "number",
    begin: x,
    relevance: 0
  }, ke = {
    scope: "number",
    begin: B,
    relevance: 0
  }, tt = {
    scope: "regexp",
    begin: /\/(?=[^/\n]*\/)/,
    end: /\/[gimuy]*/,
    contains: [
      D,
      {
        begin: /\[/,
        end: /\]/,
        relevance: 0,
        contains: [D]
      }
    ]
  }, Ke = {
    scope: "title",
    begin: A,
    relevance: 0
  }, Ue = {
    scope: "title",
    begin: I,
    relevance: 0
  }, ye = {
    // excludes method names from keyword processing
    begin: "\\.\\s*" + I,
    relevance: 0
  };
  var Ce = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    APOS_STRING_MODE: L,
    BACKSLASH_ESCAPE: D,
    BINARY_NUMBER_MODE: ke,
    BINARY_NUMBER_RE: B,
    COMMENT: V,
    C_BLOCK_COMMENT_MODE: fe,
    C_LINE_COMMENT_MODE: Z,
    C_NUMBER_MODE: Me,
    C_NUMBER_RE: x,
    END_SAME_AS_BEGIN: function(f) {
      return Object.assign(
        f,
        {
          /** @type {ModeCallback} */
          "on:begin": (v, P) => {
            P.data._beginMatch = v[1];
          },
          /** @type {ModeCallback} */
          "on:end": (v, P) => {
            P.data._beginMatch !== v[1] && P.ignoreMatch();
          }
        }
      );
    },
    HASH_COMMENT_MODE: _e,
    IDENT_RE: A,
    MATCH_NOTHING_RE: O,
    METHOD_GUARD: ye,
    NUMBER_MODE: me,
    NUMBER_RE: k,
    PHRASAL_WORDS_MODE: q,
    QUOTE_STRING_MODE: G,
    REGEXP_MODE: tt,
    RE_STARTERS_RE: X,
    SHEBANG: J,
    TITLE_MODE: Ke,
    UNDERSCORE_IDENT_RE: I,
    UNDERSCORE_TITLE_MODE: Ue
  });
  function Ee(f, v) {
    f.input[f.index - 1] === "." && v.ignoreMatch();
  }
  function Y(f, v) {
    f.className !== void 0 && (f.scope = f.className, delete f.className);
  }
  function ge(f, v) {
    v && f.beginKeywords && (f.begin = "\\b(" + f.beginKeywords.split(" ").join("|") + ")(?!\\.)(?=\\b|\\s)", f.__beforeBegin = Ee, f.keywords = f.keywords || f.beginKeywords, delete f.beginKeywords, f.relevance === void 0 && (f.relevance = 0));
  }
  function Oe(f, v) {
    Array.isArray(f.illegal) && (f.illegal = h(...f.illegal));
  }
  function Ye(f, v) {
    if (f.match) {
      if (f.begin || f.end) throw new Error("begin & end are not supported with match");
      f.begin = f.match, delete f.match;
    }
  }
  function ae(f, v) {
    f.relevance === void 0 && (f.relevance = 1);
  }
  const ot = (f, v) => {
    if (!f.beforeMatch) return;
    if (f.starts) throw new Error("beforeMatch cannot be used with starts");
    const P = Object.assign({}, f);
    Object.keys(f).forEach((ee) => {
      delete f[ee];
    }), f.keywords = P.keywords, f.begin = S(P.beforeMatch, _(P.begin)), f.starts = {
      relevance: 0,
      contains: [
        Object.assign(P, { endsParent: !0 })
      ]
    }, f.relevance = 0, delete P.beforeMatch;
  }, lt = [
    "of",
    "and",
    "for",
    "in",
    "not",
    "or",
    "if",
    "then",
    "parent",
    // common variable name
    "list",
    // common variable name
    "value"
    // common variable name
  ], vt = "keyword";
  function Vt(f, v, P = vt) {
    const ee = /* @__PURE__ */ Object.create(null);
    return typeof f == "string" ? He(P, f.split(" ")) : Array.isArray(f) ? He(P, f) : Object.keys(f).forEach(function(qe) {
      Object.assign(
        ee,
        Vt(f[qe], v, qe)
      );
    }), ee;
    function He(qe, z) {
      v && (z = z.map(($) => $.toLowerCase())), z.forEach(function($) {
        const te = $.split("|");
        ee[te[0]] = [qe, bn(te[0], te[1])];
      });
    }
  }
  function bn(f, v) {
    return v ? Number(v) : Xn(f) ? 0 : 1;
  }
  function Xn(f) {
    return lt.includes(f.toLowerCase());
  }
  const Mn = {}, Ht = (f) => {
    console.error(f);
  }, Zn = (f, ...v) => {
    console.log(`WARN: ${f}`, ...v);
  }, pn = (f, v) => {
    Mn[`${f}/${v}`] || (console.log(`Deprecated as of ${f}. ${v}`), Mn[`${f}/${v}`] = !0);
  }, Cn = new Error();
  function Mi(f, v, { key: P }) {
    let ee = 0;
    const He = f[P], qe = {}, z = {};
    for (let $ = 1; $ <= v.length; $++)
      z[$ + ee] = He[$], qe[$ + ee] = !0, ee += T(v[$ - 1]);
    f[P] = z, f[P]._emit = qe, f[P]._multi = !0;
  }
  function Jn(f) {
    if (Array.isArray(f.begin)) {
      if (f.skip || f.excludeBegin || f.returnBegin)
        throw Ht("skip, excludeBegin, returnBegin not compatible with beginScope: {}"), Cn;
      if (typeof f.beginScope != "object" || f.beginScope === null)
        throw Ht("beginScope must be object"), Cn;
      Mi(f, f.begin, { key: "beginScope" }), f.begin = y(f.begin, { joinWith: "" });
    }
  }
  function mn(f) {
    if (Array.isArray(f.end)) {
      if (f.skip || f.excludeEnd || f.returnEnd)
        throw Ht("skip, excludeEnd, returnEnd not compatible with endScope: {}"), Cn;
      if (typeof f.endScope != "object" || f.endScope === null)
        throw Ht("endScope must be object"), Cn;
      Mi(f, f.end, { key: "endScope" }), f.end = y(f.end, { joinWith: "" });
    }
  }
  function jn(f) {
    f.scope && typeof f.scope == "object" && f.scope !== null && (f.beginScope = f.scope, delete f.scope);
  }
  function ei(f) {
    jn(f), typeof f.beginScope == "string" && (f.beginScope = { _wrap: f.beginScope }), typeof f.endScope == "string" && (f.endScope = { _wrap: f.endScope }), Jn(f), mn(f);
  }
  function wn(f) {
    function v(z, $) {
      return new RegExp(
        u(z),
        "m" + (f.case_insensitive ? "i" : "") + (f.unicodeRegex ? "u" : "") + ($ ? "g" : "")
      );
    }
    class P {
      constructor() {
        this.matchIndexes = {}, this.regexes = [], this.matchAt = 1, this.position = 0;
      }
      // @ts-ignore
      addRule($, te) {
        te.position = this.position++, this.matchIndexes[this.matchAt] = te, this.regexes.push([te, $]), this.matchAt += T($) + 1;
      }
      compile() {
        this.regexes.length === 0 && (this.exec = () => null);
        const $ = this.regexes.map((te) => te[1]);
        this.matcherRe = v(y($, { joinWith: "|" }), !0), this.lastIndex = 0;
      }
      /** @param {string} s */
      exec($) {
        this.matcherRe.lastIndex = this.lastIndex;
        const te = this.matcherRe.exec($);
        if (!te)
          return null;
        const nt = te.findIndex((ri, Cr) => Cr > 0 && ri !== void 0), We = this.matchIndexes[nt];
        return te.splice(0, nt), Object.assign(te, We);
      }
    }
    class ee {
      constructor() {
        this.rules = [], this.multiRegexes = [], this.count = 0, this.lastIndex = 0, this.regexIndex = 0;
      }
      // @ts-ignore
      getMatcher($) {
        if (this.multiRegexes[$]) return this.multiRegexes[$];
        const te = new P();
        return this.rules.slice($).forEach(([nt, We]) => te.addRule(nt, We)), te.compile(), this.multiRegexes[$] = te, te;
      }
      resumingScanAtSamePosition() {
        return this.regexIndex !== 0;
      }
      considerAll() {
        this.regexIndex = 0;
      }
      // @ts-ignore
      addRule($, te) {
        this.rules.push([$, te]), te.type === "begin" && this.count++;
      }
      /** @param {string} s */
      exec($) {
        const te = this.getMatcher(this.regexIndex);
        te.lastIndex = this.lastIndex;
        let nt = te.exec($);
        if (this.resumingScanAtSamePosition() && !(nt && nt.index === this.lastIndex)) {
          const We = this.getMatcher(0);
          We.lastIndex = this.lastIndex + 1, nt = We.exec($);
        }
        return nt && (this.regexIndex += nt.position + 1, this.regexIndex === this.count && this.considerAll()), nt;
      }
    }
    function He(z) {
      const $ = new ee();
      return z.contains.forEach((te) => $.addRule(te.begin, { rule: te, type: "begin" })), z.terminatorEnd && $.addRule(z.terminatorEnd, { type: "end" }), z.illegal && $.addRule(z.illegal, { type: "illegal" }), $;
    }
    function qe(z, $) {
      const te = (
        /** @type CompiledMode */
        z
      );
      if (z.isCompiled) return te;
      [
        Y,
        // do this early so compiler extensions generally don't have to worry about
        // the distinction between match/begin
        Ye,
        ei,
        ot
      ].forEach((We) => We(z, $)), f.compilerExtensions.forEach((We) => We(z, $)), z.__beforeBegin = null, [
        ge,
        // do this later so compiler extensions that come earlier have access to the
        // raw array if they wanted to perhaps manipulate it, etc.
        Oe,
        // default to 1 relevance if not specified
        ae
      ].forEach((We) => We(z, $)), z.isCompiled = !0;
      let nt = null;
      return typeof z.keywords == "object" && z.keywords.$pattern && (z.keywords = Object.assign({}, z.keywords), nt = z.keywords.$pattern, delete z.keywords.$pattern), nt = nt || /\w+/, z.keywords && (z.keywords = Vt(z.keywords, f.case_insensitive)), te.keywordPatternRe = v(nt, !0), $ && (z.begin || (z.begin = /\B|\b/), te.beginRe = v(te.begin), !z.end && !z.endsWithParent && (z.end = /\B|\b/), z.end && (te.endRe = v(te.end)), te.terminatorEnd = u(te.end) || "", z.endsWithParent && $.terminatorEnd && (te.terminatorEnd += (z.end ? "|" : "") + $.terminatorEnd)), z.illegal && (te.illegalRe = v(
        /** @type {RegExp | string} */
        z.illegal
      )), z.contains || (z.contains = []), z.contains = [].concat(...z.contains.map(function(We) {
        return fr(We === "self" ? z : We);
      })), z.contains.forEach(function(We) {
        qe(
          /** @type Mode */
          We,
          te
        );
      }), z.starts && qe(z.starts, $), te.matcher = He(te), te;
    }
    if (f.compilerExtensions || (f.compilerExtensions = []), f.contains && f.contains.includes("self"))
      throw new Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
    return f.classNameAliases = i(f.classNameAliases || {}), qe(
      /** @type Mode */
      f
    );
  }
  function wi(f) {
    return f ? f.endsWithParent || wi(f.starts) : !1;
  }
  function fr(f) {
    return f.variants && !f.cachedVariants && (f.cachedVariants = f.variants.map(function(v) {
      return i(f, { variants: null }, v);
    })), f.cachedVariants ? f.cachedVariants : wi(f) ? i(f, { starts: f.starts ? i(f.starts) : null }) : Object.isFrozen(f) ? i(f) : f;
  }
  var Tr = "11.11.1";
  class br extends Error {
    constructor(v, P) {
      super(v), this.name = "HTMLInjectionError", this.html = P;
    }
  }
  const ti = n, ni = i, xi = /* @__PURE__ */ Symbol("nomatch"), Li = 7, ii = function(f) {
    const v = /* @__PURE__ */ Object.create(null), P = /* @__PURE__ */ Object.create(null), ee = [];
    let He = !0;
    const qe = "Could not find the language '{}', did you forget to load/include a language module?", z = { disableAutodetect: !0, name: "Plain text", contains: [] };
    let $ = {
      ignoreUnescapedHTML: !1,
      throwUnescapedHTML: !1,
      noHighlightRe: /^(no-?highlight)$/i,
      languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
      classPrefix: "hljs-",
      cssSelector: "pre code",
      languages: null,
      // beta configuration options, subject to change, welcome to discuss
      // https://github.com/highlightjs/highlight.js/issues/1086
      __emitter: d
    };
    function te(w) {
      return $.noHighlightRe.test(w);
    }
    function nt(w) {
      let K = w.className + " ";
      K += w.parentNode ? w.parentNode.className : "";
      const pe = $.languageDetectRe.exec(K);
      if (pe) {
        const we = En(pe[1]);
        return we || (Zn(qe.replace("{}", pe[1])), Zn("Falling back to no-highlight mode for this block.", w)), we ? pe[1] : "no-highlight";
      }
      return K.split(/\s+/).find((we) => te(we) || En(we));
    }
    function We(w, K, pe) {
      let we = "", Qe = "";
      typeof K == "object" ? (we = w, pe = K.ignoreIllegals, Qe = K.language) : (pn("10.7.0", "highlight(lang, code, ...args) has been deprecated."), pn("10.7.0", `Please use highlight(code, options) instead.
https://github.com/highlightjs/highlight.js/issues/2277`), Qe = w, we = K), pe === void 0 && (pe = !0);
      const Ft = {
        code: we,
        language: Qe
      };
      ki("before:highlight", Ft);
      const gn = Ft.result ? Ft.result : ri(Ft.language, Ft.code, pe);
      return gn.code = Ft.code, ki("after:highlight", gn), gn;
    }
    function ri(w, K, pe, we) {
      const Qe = /* @__PURE__ */ Object.create(null);
      function Ft(U, W) {
        return U.keywords[W];
      }
      function gn() {
        if (!ne.keywords) {
          Xe.addText(ve);
          return;
        }
        let U = 0;
        ne.keywordPatternRe.lastIndex = 0;
        let W = ne.keywordPatternRe.exec(ve), se = "";
        for (; W; ) {
          se += ve.substring(U, W.index);
          const Te = Bt.case_insensitive ? W[0].toLowerCase() : W[0], it = Ft(ne, Te);
          if (it) {
            const [an, Ko] = it;
            if (Xe.addText(se), se = "", Qe[Te] = (Qe[Te] || 0) + 1, Qe[Te] <= Li && (xn += Ko), an.startsWith("_"))
              se += W[0];
            else {
              const __ = Bt.classNameAliases[an] || an;
              qt(W[0], __);
            }
          } else
            se += W[0];
          U = ne.keywordPatternRe.lastIndex, W = ne.keywordPatternRe.exec(ve);
        }
        se += ve.substring(U), Xe.addText(se);
      }
      function Ui() {
        if (ve === "") return;
        let U = null;
        if (typeof ne.subLanguage == "string") {
          if (!v[ne.subLanguage]) {
            Xe.addText(ve);
            return;
          }
          U = ri(ne.subLanguage, ve, !0, Or[ne.subLanguage]), Or[ne.subLanguage] = /** @type {CompiledMode} */
          U._top;
        } else
          U = yr(ve, ne.subLanguage.length ? ne.subLanguage : null);
        ne.relevance > 0 && (xn += U.relevance), Xe.__addSublanguage(U._emitter, U.language);
      }
      function ht() {
        ne.subLanguage != null ? Ui() : gn(), ve = "";
      }
      function qt(U, W) {
        U !== "" && (Xe.startScope(W), Xe.addText(U), Xe.endScope());
      }
      function Aa(U, W) {
        let se = 1;
        const Te = W.length - 1;
        for (; se <= Te; ) {
          if (!U._emit[se]) {
            se++;
            continue;
          }
          const it = Bt.classNameAliases[U[se]] || U[se], an = W[se];
          it ? qt(an, it) : (ve = an, gn(), ve = ""), se++;
        }
      }
      function Ia(U, W) {
        return U.scope && typeof U.scope == "string" && Xe.openNode(Bt.classNameAliases[U.scope] || U.scope), U.beginScope && (U.beginScope._wrap ? (qt(ve, Bt.classNameAliases[U.beginScope._wrap] || U.beginScope._wrap), ve = "") : U.beginScope._multi && (Aa(U.beginScope, W), ve = "")), ne = Object.create(U, { parent: { value: ne } }), ne;
      }
      function Da(U, W, se) {
        let Te = b(U.endRe, se);
        if (Te) {
          if (U["on:end"]) {
            const it = new e(U);
            U["on:end"](W, it), it.isMatchIgnored && (Te = !1);
          }
          if (Te) {
            for (; U.endsParent && U.parent; )
              U = U.parent;
            return U;
          }
        }
        if (U.endsWithParent)
          return Da(U.parent, W, se);
      }
      function Ho(U) {
        return ne.matcher.regexIndex === 0 ? (ve += U[0], 1) : (si = !0, 0);
      }
      function qo(U) {
        const W = U[0], se = U.rule, Te = new e(se), it = [se.__beforeBegin, se["on:begin"]];
        for (const an of it)
          if (an && (an(U, Te), Te.isMatchIgnored))
            return Ho(W);
        return se.skip ? ve += W : (se.excludeBegin && (ve += W), ht(), !se.returnBegin && !se.excludeBegin && (ve = W)), Ia(se, U), se.returnBegin ? 0 : W.length;
      }
      function zo(U) {
        const W = U[0], se = K.substring(U.index), Te = Da(ne, U, se);
        if (!Te)
          return xi;
        const it = ne;
        ne.endScope && ne.endScope._wrap ? (ht(), qt(W, ne.endScope._wrap)) : ne.endScope && ne.endScope._multi ? (ht(), Aa(ne.endScope, U)) : it.skip ? ve += W : (it.returnEnd || it.excludeEnd || (ve += W), ht(), it.excludeEnd && (ve = W));
        do
          ne.scope && Xe.closeNode(), !ne.skip && !ne.subLanguage && (xn += ne.relevance), ne = ne.parent;
        while (ne !== Te.parent);
        return Te.starts && Ia(Te.starts, U), it.returnEnd ? 0 : W.length;
      }
      function Wo() {
        const U = [];
        for (let W = ne; W !== Bt; W = W.parent)
          W.scope && U.unshift(W.scope);
        U.forEach((W) => Xe.openNode(W));
      }
      let ai = {};
      function Nr(U, W) {
        const se = W && W[0];
        if (ve += U, se == null)
          return ht(), 0;
        if (ai.type === "begin" && W.type === "end" && ai.index === W.index && se === "") {
          if (ve += K.slice(W.index, W.index + 1), !He) {
            const Te = new Error(`0 width match regex (${w})`);
            throw Te.languageName = w, Te.badRule = ai.rule, Te;
          }
          return 1;
        }
        if (ai = W, W.type === "begin")
          return qo(W);
        if (W.type === "illegal" && !pe) {
          const Te = new Error('Illegal lexeme "' + se + '" for mode "' + (ne.scope || "<unnamed>") + '"');
          throw Te.mode = ne, Te;
        } else if (W.type === "end") {
          const Te = zo(W);
          if (Te !== xi)
            return Te;
        }
        if (W.type === "illegal" && se === "")
          return ve += `
`, 1;
        if (Bi > 1e5 && Bi > W.index * 3)
          throw new Error("potential infinite loop, way more iterations than matches");
        return ve += se, se.length;
      }
      const Bt = En(w);
      if (!Bt)
        throw Ht(qe.replace("{}", w)), new Error('Unknown language: "' + w + '"');
      const Ma = wn(Bt);
      let Fi = "", ne = we || Ma;
      const Or = {}, Xe = new $.__emitter($);
      Wo();
      let ve = "", xn = 0, Sn = 0, Bi = 0, si = !1;
      try {
        if (Bt.__emitTokens)
          Bt.__emitTokens(K, Xe);
        else {
          for (ne.matcher.considerAll(); ; ) {
            Bi++, si ? si = !1 : ne.matcher.considerAll(), ne.matcher.lastIndex = Sn;
            const U = ne.matcher.exec(K);
            if (!U) break;
            const W = K.substring(Sn, U.index), se = Nr(W, U);
            Sn = U.index + se;
          }
          Nr(K.substring(Sn));
        }
        return Xe.finalize(), Fi = Xe.toHTML(), {
          language: w,
          value: Fi,
          relevance: xn,
          illegal: !1,
          _emitter: Xe,
          _top: ne
        };
      } catch (U) {
        if (U.message && U.message.includes("Illegal"))
          return {
            language: w,
            value: ti(K),
            illegal: !0,
            relevance: 0,
            _illegalBy: {
              message: U.message,
              index: Sn,
              context: K.slice(Sn - 100, Sn + 100),
              mode: U.mode,
              resultSoFar: Fi
            },
            _emitter: Xe
          };
        if (He)
          return {
            language: w,
            value: ti(K),
            illegal: !1,
            relevance: 0,
            errorRaised: U,
            _emitter: Xe,
            _top: ne
          };
        throw U;
      }
    }
    function Cr(w) {
      const K = {
        value: ti(w),
        illegal: !1,
        relevance: 0,
        _top: z,
        _emitter: new $.__emitter($)
      };
      return K._emitter.addText(w), K;
    }
    function yr(w, K) {
      K = K || $.languages || Object.keys(v);
      const pe = Cr(w), we = K.filter(En).filter(va).map(
        (ht) => ri(ht, w, !1)
      );
      we.unshift(pe);
      const Qe = we.sort((ht, qt) => {
        if (ht.relevance !== qt.relevance) return qt.relevance - ht.relevance;
        if (ht.language && qt.language) {
          if (En(ht.language).supersetOf === qt.language)
            return 1;
          if (En(qt.language).supersetOf === ht.language)
            return -1;
        }
        return 0;
      }), [Ft, gn] = Qe, Ui = Ft;
      return Ui.secondBest = gn, Ui;
    }
    function xo(w, K, pe) {
      const we = K && P[K] || pe;
      w.classList.add("hljs"), w.classList.add(`language-${we}`);
    }
    function Rr(w) {
      let K = null;
      const pe = nt(w);
      if (te(pe)) return;
      if (ki(
        "before:highlightElement",
        { el: w, language: pe }
      ), w.dataset.highlighted) {
        console.log("Element previously highlighted. To highlight again, first unset `dataset.highlighted`.", w);
        return;
      }
      if (w.children.length > 0 && ($.ignoreUnescapedHTML || (console.warn("One of your code blocks includes unescaped HTML. This is a potentially serious security risk."), console.warn("https://github.com/highlightjs/highlight.js/wiki/security"), console.warn("The element with unescaped HTML:"), console.warn(w)), $.throwUnescapedHTML))
        throw new br(
          "One of your code blocks includes unescaped HTML.",
          w.innerHTML
        );
      K = w;
      const we = K.textContent, Qe = pe ? We(we, { language: pe, ignoreIllegals: !0 }) : yr(we);
      w.innerHTML = Qe.value, w.dataset.highlighted = "yes", xo(w, pe, Qe.language), w.result = {
        language: Qe.language,
        // TODO: remove with version 11.0
        re: Qe.relevance,
        relevance: Qe.relevance
      }, Qe.secondBest && (w.secondBest = {
        language: Qe.secondBest.language,
        relevance: Qe.secondBest.relevance
      }), ki("after:highlightElement", { el: w, result: Qe, text: we });
    }
    function Lo(w) {
      $ = ni($, w);
    }
    const Po = () => {
      Pi(), pn("10.6.0", "initHighlighting() deprecated.  Use highlightAll() now.");
    };
    function ko() {
      Pi(), pn("10.6.0", "initHighlightingOnLoad() deprecated.  Use highlightAll() now.");
    }
    let Na = !1;
    function Pi() {
      function w() {
        Pi();
      }
      if (document.readyState === "loading") {
        Na || window.addEventListener("DOMContentLoaded", w, !1), Na = !0;
        return;
      }
      document.querySelectorAll($.cssSelector).forEach(Rr);
    }
    function Uo(w, K) {
      let pe = null;
      try {
        pe = K(f);
      } catch (we) {
        if (Ht("Language definition for '{}' could not be registered.".replace("{}", w)), He)
          Ht(we);
        else
          throw we;
        pe = z;
      }
      pe.name || (pe.name = w), v[w] = pe, pe.rawDefinition = K.bind(null, f), pe.aliases && Oa(pe.aliases, { languageName: w });
    }
    function Fo(w) {
      delete v[w];
      for (const K of Object.keys(P))
        P[K] === w && delete P[K];
    }
    function Bo() {
      return Object.keys(v);
    }
    function En(w) {
      return w = (w || "").toLowerCase(), v[w] || v[P[w]];
    }
    function Oa(w, { languageName: K }) {
      typeof w == "string" && (w = [w]), w.forEach((pe) => {
        P[pe.toLowerCase()] = K;
      });
    }
    function va(w) {
      const K = En(w);
      return K && !K.disableAutodetect;
    }
    function Go(w) {
      w["before:highlightBlock"] && !w["before:highlightElement"] && (w["before:highlightElement"] = (K) => {
        w["before:highlightBlock"](
          Object.assign({ block: K.el }, K)
        );
      }), w["after:highlightBlock"] && !w["after:highlightElement"] && (w["after:highlightElement"] = (K) => {
        w["after:highlightBlock"](
          Object.assign({ block: K.el }, K)
        );
      });
    }
    function Yo(w) {
      Go(w), ee.push(w);
    }
    function $o(w) {
      const K = ee.indexOf(w);
      K !== -1 && ee.splice(K, 1);
    }
    function ki(w, K) {
      const pe = w;
      ee.forEach(function(we) {
        we[pe] && we[pe](K);
      });
    }
    function Vo(w) {
      return pn("10.7.0", "highlightBlock will be removed entirely in v12.0"), pn("10.7.0", "Please use highlightElement now."), Rr(w);
    }
    Object.assign(f, {
      highlight: We,
      highlightAuto: yr,
      highlightAll: Pi,
      highlightElement: Rr,
      // TODO: Remove with v12 API
      highlightBlock: Vo,
      configure: Lo,
      initHighlighting: Po,
      initHighlightingOnLoad: ko,
      registerLanguage: Uo,
      unregisterLanguage: Fo,
      listLanguages: Bo,
      getLanguage: En,
      registerAliases: Oa,
      autoDetection: va,
      inherit: ni,
      addPlugin: Yo,
      removePlugin: $o
    }), f.debugMode = function() {
      He = !1;
    }, f.safeMode = function() {
      He = !0;
    }, f.versionString = Tr, f.regex = {
      concat: S,
      lookahead: _,
      either: h,
      optional: g,
      anyNumberOfTimes: m
    };
    for (const w in Ce)
      typeof Ce[w] == "object" && t(Ce[w]);
    return Object.assign(f, Ce), f;
  }, rn = ii({});
  return rn.newInstance = () => ii({}), Ua = rn, rn.HighlightJS = rn, rn.default = rn, Ua;
}
var jh = /* @__PURE__ */ Jh();
const ef = /* @__PURE__ */ Tc(jh), pl = {}, tf = "hljs-";
function nf(t) {
  const e = ef.newInstance();
  return t && a(t), {
    highlight: n,
    highlightAuto: i,
    listLanguages: r,
    register: a,
    registerAlias: s,
    registered: o
  };
  function n(l, c, d) {
    const u = d || pl, _ = typeof u.prefix == "string" ? u.prefix : tf;
    if (!e.getLanguage(l))
      throw new Error("Unknown language: `" + l + "` is not registered");
    e.configure({ __emitter: rf, classPrefix: _ });
    const m = (
      /** @type {HighlightResult & {_emitter: HastEmitter}} */
      e.highlight(c, { ignoreIllegals: !0, language: l })
    );
    if (m.errorRaised)
      throw new Error("Could not highlight with `Highlight.js`", {
        cause: m.errorRaised
      });
    const g = m._emitter.root, S = (
      /** @type {RootData} */
      g.data
    );
    return S.language = m.language, S.relevance = m.relevance, g;
  }
  function i(l, c) {
    const u = (c || pl).subset || r();
    let _ = -1, m = 0, g;
    for (; ++_ < u.length; ) {
      const S = u[_];
      if (!e.getLanguage(S)) continue;
      const E = n(S, l, c);
      E.data && E.data.relevance !== void 0 && E.data.relevance > m && (m = E.data.relevance, g = E);
    }
    return g || {
      type: "root",
      children: [],
      data: { language: void 0, relevance: m }
    };
  }
  function r() {
    return e.listLanguages();
  }
  function a(l, c) {
    if (typeof l == "string")
      e.registerLanguage(l, c);
    else {
      let d;
      for (d in l)
        Object.hasOwn(l, d) && e.registerLanguage(d, l[d]);
    }
  }
  function s(l, c) {
    if (typeof l == "string")
      e.registerAliases(
        // Note: copy needed because hljs doesn’t accept readonly arrays yet.
        typeof c == "string" ? c : [...c],
        { languageName: l }
      );
    else {
      let d;
      for (d in l)
        if (Object.hasOwn(l, d)) {
          const u = l[d];
          e.registerAliases(
            // Note: copy needed because hljs doesn’t accept readonly arrays yet.
            typeof u == "string" ? u : [...u],
            { languageName: d }
          );
        }
    }
  }
  function o(l) {
    return !!e.getLanguage(l);
  }
}
class rf {
  /**
   * @param {Readonly<HljsOptions>} options
   *   Configuration.
   * @returns
   *   Instance.
   */
  constructor(e) {
    this.options = e, this.root = {
      type: "root",
      children: [],
      data: { language: void 0, relevance: 0 }
    }, this.stack = [this.root];
  }
  /**
   * @param {string} value
   *   Text to add.
   * @returns {undefined}
   *   Nothing.
   *
   */
  addText(e) {
    if (e === "") return;
    const n = this.stack[this.stack.length - 1], i = n.children[n.children.length - 1];
    i && i.type === "text" ? i.value += e : n.children.push({ type: "text", value: e });
  }
  /**
   *
   * @param {unknown} rawName
   *   Name to add.
   * @returns {undefined}
   *   Nothing.
   */
  startScope(e) {
    this.openNode(String(e));
  }
  /**
   * @returns {undefined}
   *   Nothing.
   */
  endScope() {
    this.closeNode();
  }
  /**
   * @param {HastEmitter} other
   *   Other emitter.
   * @param {string} name
   *   Name of the sublanguage.
   * @returns {undefined}
   *   Nothing.
   */
  __addSublanguage(e, n) {
    const i = this.stack[this.stack.length - 1], r = (
      /** @type {Array<ElementContent>} */
      e.root.children
    );
    n ? i.children.push({
      type: "element",
      tagName: "span",
      properties: { className: [n] },
      children: r
    }) : i.children.push(...r);
  }
  /**
   * @param {string} name
   *   Name to add.
   * @returns {undefined}
   *   Nothing.
   */
  openNode(e) {
    const n = this, i = e.split(".").map(function(s, o) {
      return o ? s + "_".repeat(o) : n.options.classPrefix + s;
    }), r = this.stack[this.stack.length - 1], a = {
      type: "element",
      tagName: "span",
      properties: { className: i },
      children: []
    };
    r.children.push(a), this.stack.push(a);
  }
  /**
   * @returns {undefined}
   *   Nothing.
   */
  closeNode() {
    this.stack.pop();
  }
  /**
   * @returns {undefined}
   *   Nothing.
   */
  finalize() {
  }
  /**
   * @returns {string}
   *   Nothing.
   */
  toHTML() {
    return "";
  }
}
const af = "_backdrop_xltu9_1", sf = "_popup_xltu9_15", of = "_close_xltu9_73", Fa = {
  backdrop: af,
  popup: sf,
  close: of
}, lf = "_btn_64d9v_1", cf = "_size_md_64d9v_15", df = "_size_sm_64d9v_21", uf = "_variant_primary_64d9v_27", _f = "_variant_secondary_64d9v_32", pf = "_variant_danger_64d9v_38", mf = "_variant_ghost_64d9v_43", Ba = {
  btn: lf,
  size_md: cf,
  size_sm: df,
  variant_primary: uf,
  variant_secondary: _f,
  variant_danger: pf,
  variant_ghost: mf
}, Ef = "_wrapper_8d571_1", gf = "_alignLeft_8d571_7", Sf = "_alignCenter_8d571_11", hf = "_alignRight_8d571_15", ff = "_imageWrapper_8d571_19", Tf = "_image_8d571_19", bf = "_imageBlock_8d571_30", Cf = "_placeholder_8d571_34", yf = "_placeholderIcon_8d571_45", Rf = "_imageProcessing_8d571_50", Nf = "_processingSuccess_8d571_60", Of = "_processingError_8d571_64", vf = "_processingText_8d571_68", Af = "_textSuccess_8d571_85", If = "_textDanger_8d571_89", Df = "_modalImage_8d571_98", rt = {
  wrapper: Ef,
  alignLeft: gf,
  alignCenter: Sf,
  alignRight: hf,
  imageWrapper: ff,
  image: Tf,
  imageBlock: bf,
  placeholder: Cf,
  placeholderIcon: yf,
  imageProcessing: Rf,
  processingSuccess: Nf,
  processingError: Of,
  processingText: vf,
  textSuccess: Af,
  textDanger: If,
  modalImage: Df
}, Mf = "_galleryGrid_19om1_1", wf = "_galleryGridItem_19om1_9", xf = "_galleryGridItemImage_19om1_19", Lf = "_galleryGridItemHoverText_19om1_25", Pf = "_galleryGridItemText_19om1_45", kf = "_galleryGridItemNotLoaded_19om1_82", Uf = "_galleryGridItemError_19om1_91", kn = {
  galleryGrid: Mf,
  galleryGridItem: wf,
  galleryGridItemImage: xf,
  galleryGridItemHoverText: Lf,
  galleryGridItemText: Pf,
  galleryGridItemNotLoaded: kf,
  galleryGridItemError: Uf
};
function Ff(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function ml(t) {
  return Ff(t) || Array.isArray(t);
}
function Bf() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function ws(t, e) {
  const n = Object.keys(t), i = Object.keys(e);
  if (n.length !== i.length) return !1;
  const r = JSON.stringify(Object.keys(t.breakpoints || {})), a = JSON.stringify(Object.keys(e.breakpoints || {}));
  return r !== a ? !1 : n.every((s) => {
    const o = t[s], l = e[s];
    return typeof o == "function" ? `${o}` == `${l}` : !ml(o) || !ml(l) ? o === l : ws(o, l);
  });
}
function El(t) {
  return t.concat().sort((e, n) => e.name > n.name ? 1 : -1).map((e) => e.options);
}
function Gf(t, e) {
  if (t.length !== e.length) return !1;
  const n = El(t), i = El(e);
  return n.every((r, a) => {
    const s = i[a];
    return ws(r, s);
  });
}
function xs(t) {
  return typeof t == "number";
}
function is(t) {
  return typeof t == "string";
}
function ca(t) {
  return typeof t == "boolean";
}
function gl(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function $e(t) {
  return Math.abs(t);
}
function Ls(t) {
  return Math.sign(t);
}
function Qi(t, e) {
  return $e(t - e);
}
function Yf(t, e) {
  if (t === 0 || e === 0 || $e(t) <= $e(e)) return 0;
  const n = Qi($e(t), $e(e));
  return $e(n / t);
}
function $f(t) {
  return Math.round(t * 100) / 100;
}
function tr(t) {
  return nr(t).map(Number);
}
function Wt(t) {
  return t[lr(t)];
}
function lr(t) {
  return Math.max(0, t.length - 1);
}
function Ps(t, e) {
  return e === lr(t);
}
function Sl(t, e = 0) {
  return Array.from(Array(t), (n, i) => e + i);
}
function nr(t) {
  return Object.keys(t);
}
function Vc(t, e) {
  return [t, e].reduce((n, i) => (nr(i).forEach((r) => {
    const a = n[r], s = i[r], o = gl(a) && gl(s);
    n[r] = o ? Vc(a, s) : s;
  }), n), {});
}
function rs(t, e) {
  return typeof e.MouseEvent < "u" && t instanceof e.MouseEvent;
}
function Vf(t, e) {
  const n = {
    start: i,
    center: r,
    end: a
  };
  function i() {
    return 0;
  }
  function r(l) {
    return a(l) / 2;
  }
  function a(l) {
    return e - l;
  }
  function s(l, c) {
    return is(t) ? n[t](l) : t(e, l, c);
  }
  return {
    measure: s
  };
}
function ir() {
  let t = [];
  function e(r, a, s, o = {
    passive: !0
  }) {
    let l;
    if ("addEventListener" in r)
      r.addEventListener(a, s, o), l = () => r.removeEventListener(a, s, o);
    else {
      const c = r;
      c.addListener(s), l = () => c.removeListener(s);
    }
    return t.push(l), i;
  }
  function n() {
    t = t.filter((r) => r());
  }
  const i = {
    add: e,
    clear: n
  };
  return i;
}
function Hf(t, e, n, i) {
  const r = ir(), a = 1e3 / 60;
  let s = null, o = 0, l = 0;
  function c() {
    r.add(t, "visibilitychange", () => {
      t.hidden && g();
    });
  }
  function d() {
    m(), r.clear();
  }
  function u(E) {
    if (!l) return;
    s || (s = E, n(), n());
    const h = E - s;
    for (s = E, o += h; o >= a; )
      n(), o -= a;
    const T = o / a;
    i(T), l && (l = e.requestAnimationFrame(u));
  }
  function _() {
    l || (l = e.requestAnimationFrame(u));
  }
  function m() {
    e.cancelAnimationFrame(l), s = null, o = 0, l = 0;
  }
  function g() {
    s = null, o = 0;
  }
  return {
    init: c,
    destroy: d,
    start: _,
    stop: m,
    update: n,
    render: i
  };
}
function qf(t, e) {
  const n = e === "rtl", i = t === "y", r = i ? "y" : "x", a = i ? "x" : "y", s = !i && n ? -1 : 1, o = d(), l = u();
  function c(g) {
    const {
      height: S,
      width: E
    } = g;
    return i ? S : E;
  }
  function d() {
    return i ? "top" : n ? "right" : "left";
  }
  function u() {
    return i ? "bottom" : n ? "left" : "right";
  }
  function _(g) {
    return g * s;
  }
  return {
    scroll: r,
    cross: a,
    startEdge: o,
    endEdge: l,
    measureSize: c,
    direction: _
  };
}
function Yn(t = 0, e = 0) {
  const n = $e(t - e);
  function i(c) {
    return c < t;
  }
  function r(c) {
    return c > e;
  }
  function a(c) {
    return i(c) || r(c);
  }
  function s(c) {
    return a(c) ? i(c) ? t : e : c;
  }
  function o(c) {
    return n ? c - n * Math.ceil((c - e) / n) : c;
  }
  return {
    length: n,
    max: e,
    min: t,
    constrain: s,
    reachedAny: a,
    reachedMax: r,
    reachedMin: i,
    removeOffset: o
  };
}
function Hc(t, e, n) {
  const {
    constrain: i
  } = Yn(0, t), r = t + 1;
  let a = s(e);
  function s(_) {
    return n ? $e((r + _) % r) : i(_);
  }
  function o() {
    return a;
  }
  function l(_) {
    return a = s(_), u;
  }
  function c(_) {
    return d().set(o() + _);
  }
  function d() {
    return Hc(t, o(), n);
  }
  const u = {
    get: o,
    set: l,
    add: c,
    clone: d
  };
  return u;
}
function zf(t, e, n, i, r, a, s, o, l, c, d, u, _, m, g, S, E, h, T) {
  const {
    cross: b,
    direction: C
  } = t, y = ["INPUT", "SELECT", "TEXTAREA"], O = {
    passive: !1
  }, A = ir(), I = ir(), k = Yn(50, 225).constrain(m.measure(20)), x = {
    mouse: 300,
    touch: 400
  }, B = {
    mouse: 500,
    touch: 600
  }, X = g ? 43 : 25;
  let J = !1, D = 0, L = 0, G = !1, q = !1, V = !1, Z = !1;
  function fe(Y) {
    if (!T) return;
    function ge(Ye) {
      (ca(T) || T(Y, Ye)) && Ke(Ye);
    }
    const Oe = e;
    A.add(Oe, "dragstart", (Ye) => Ye.preventDefault(), O).add(Oe, "touchmove", () => {
    }, O).add(Oe, "touchend", () => {
    }).add(Oe, "touchstart", ge).add(Oe, "mousedown", ge).add(Oe, "touchcancel", ye).add(Oe, "contextmenu", ye).add(Oe, "click", Fe, !0);
  }
  function _e() {
    A.clear(), I.clear();
  }
  function me() {
    const Y = Z ? n : e;
    I.add(Y, "touchmove", Ue, O).add(Y, "touchend", ye).add(Y, "mousemove", Ue, O).add(Y, "mouseup", ye);
  }
  function Me(Y) {
    const ge = Y.nodeName || "";
    return y.includes(ge);
  }
  function ke() {
    return (g ? B : x)[Z ? "mouse" : "touch"];
  }
  function tt(Y, ge) {
    const Oe = u.add(Ls(Y) * -1), Ye = d.byDistance(Y, !g).distance;
    return g || $e(Y) < k ? Ye : E && ge ? Ye * 0.5 : d.byIndex(Oe.get(), 0).distance;
  }
  function Ke(Y) {
    const ge = rs(Y, i);
    Z = ge, V = g && ge && !Y.buttons && J, J = Qi(r.get(), s.get()) >= 2, !(ge && Y.button !== 0) && (Me(Y.target) || (G = !0, a.pointerDown(Y), c.useFriction(0).useDuration(0), r.set(s), me(), D = a.readPoint(Y), L = a.readPoint(Y, b), _.emit("pointerDown")));
  }
  function Ue(Y) {
    if (!rs(Y, i) && Y.touches.length >= 2) return ye(Y);
    const Oe = a.readPoint(Y), Ye = a.readPoint(Y, b), ae = Qi(Oe, D), ot = Qi(Ye, L);
    if (!q && !Z && (!Y.cancelable || (q = ae > ot, !q)))
      return ye(Y);
    const lt = a.pointerMove(Y);
    ae > S && (V = !0), c.useFriction(0.3).useDuration(0.75), o.start(), r.add(C(lt)), Y.preventDefault();
  }
  function ye(Y) {
    const Oe = d.byDistance(0, !1).index !== u.get(), Ye = a.pointerUp(Y) * ke(), ae = tt(C(Ye), Oe), ot = Yf(Ye, ae), lt = X - 10 * ot, vt = h + ot / 50;
    q = !1, G = !1, I.clear(), c.useDuration(lt).useFriction(vt), l.distance(ae, !g), Z = !1, _.emit("pointerUp");
  }
  function Fe(Y) {
    V && (Y.stopPropagation(), Y.preventDefault(), V = !1);
  }
  function Ce() {
    return G;
  }
  return {
    init: fe,
    destroy: _e,
    pointerDown: Ce
  };
}
function Wf(t, e) {
  let i, r;
  function a(u) {
    return u.timeStamp;
  }
  function s(u, _) {
    const g = `client${(_ || t.scroll) === "x" ? "X" : "Y"}`;
    return (rs(u, e) ? u : u.touches[0])[g];
  }
  function o(u) {
    return i = u, r = u, s(u);
  }
  function l(u) {
    const _ = s(u) - s(r), m = a(u) - a(i) > 170;
    return r = u, m && (i = u), _;
  }
  function c(u) {
    if (!i || !r) return 0;
    const _ = s(r) - s(i), m = a(u) - a(i), g = a(u) - a(r) > 170, S = _ / m;
    return m && !g && $e(S) > 0.1 ? S : 0;
  }
  return {
    pointerDown: o,
    pointerMove: l,
    pointerUp: c,
    readPoint: s
  };
}
function Kf() {
  function t(n) {
    const {
      offsetTop: i,
      offsetLeft: r,
      offsetWidth: a,
      offsetHeight: s
    } = n;
    return {
      top: i,
      right: r + a,
      bottom: i + s,
      left: r,
      width: a,
      height: s
    };
  }
  return {
    measure: t
  };
}
function Qf(t) {
  function e(i) {
    return t * (i / 100);
  }
  return {
    measure: e
  };
}
function Xf(t, e, n, i, r, a, s) {
  const o = [t].concat(i);
  let l, c, d = [], u = !1;
  function _(E) {
    return r.measureSize(s.measure(E));
  }
  function m(E) {
    if (!a) return;
    c = _(t), d = i.map(_);
    function h(T) {
      for (const b of T) {
        if (u) return;
        const C = b.target === t, y = i.indexOf(b.target), O = C ? c : d[y], A = _(C ? t : i[y]);
        if ($e(A - O) >= 0.5) {
          E.reInit(), e.emit("resize");
          break;
        }
      }
    }
    l = new ResizeObserver((T) => {
      (ca(a) || a(E, T)) && h(T);
    }), n.requestAnimationFrame(() => {
      o.forEach((T) => l.observe(T));
    });
  }
  function g() {
    u = !0, l && l.disconnect();
  }
  return {
    init: m,
    destroy: g
  };
}
function Zf(t, e, n, i, r, a) {
  let s = 0, o = 0, l = r, c = a, d = t.get(), u = 0;
  function _() {
    const O = i.get() - t.get(), A = !l;
    let I = 0;
    return A ? (s = 0, n.set(i), t.set(i), I = O) : (n.set(t), s += O / l, s *= c, d += s, t.add(s), I = d - u), o = Ls(I), u = d, y;
  }
  function m() {
    const O = i.get() - e.get();
    return $e(O) < 1e-3;
  }
  function g() {
    return l;
  }
  function S() {
    return o;
  }
  function E() {
    return s;
  }
  function h() {
    return b(r);
  }
  function T() {
    return C(a);
  }
  function b(O) {
    return l = O, y;
  }
  function C(O) {
    return c = O, y;
  }
  const y = {
    direction: S,
    duration: g,
    velocity: E,
    seek: _,
    settled: m,
    useBaseFriction: T,
    useBaseDuration: h,
    useFriction: C,
    useDuration: b
  };
  return y;
}
function Jf(t, e, n, i, r) {
  const a = r.measure(10), s = r.measure(50), o = Yn(0.1, 0.99);
  let l = !1;
  function c() {
    return !(l || !t.reachedAny(n.get()) || !t.reachedAny(e.get()));
  }
  function d(m) {
    if (!c()) return;
    const g = t.reachedMin(e.get()) ? "min" : "max", S = $e(t[g] - e.get()), E = n.get() - e.get(), h = o.constrain(S / s);
    n.subtract(E * h), !m && $e(E) < a && (n.set(t.constrain(n.get())), i.useDuration(25).useBaseFriction());
  }
  function u(m) {
    l = !m;
  }
  return {
    shouldConstrain: c,
    constrain: d,
    toggleActive: u
  };
}
function jf(t, e, n, i, r) {
  const a = Yn(-e + t, 0), s = u(), o = d(), l = _();
  function c(g, S) {
    return Qi(g, S) <= 1;
  }
  function d() {
    const g = s[0], S = Wt(s), E = s.lastIndexOf(g), h = s.indexOf(S) + 1;
    return Yn(E, h);
  }
  function u() {
    return n.map((g, S) => {
      const {
        min: E,
        max: h
      } = a, T = a.constrain(g), b = !S, C = Ps(n, S);
      return b ? h : C || c(E, T) ? E : c(h, T) ? h : T;
    }).map((g) => parseFloat(g.toFixed(3)));
  }
  function _() {
    if (e <= t + r) return [a.max];
    if (i === "keepSnaps") return s;
    const {
      min: g,
      max: S
    } = o;
    return s.slice(g, S);
  }
  return {
    snapsContained: l,
    scrollContainLimit: o
  };
}
function eT(t, e, n) {
  const i = e[0], r = n ? i - t : Wt(e);
  return {
    limit: Yn(r, i)
  };
}
function tT(t, e, n, i) {
  const a = e.min + 0.1, s = e.max + 0.1, {
    reachedMin: o,
    reachedMax: l
  } = Yn(a, s);
  function c(_) {
    return _ === 1 ? l(n.get()) : _ === -1 ? o(n.get()) : !1;
  }
  function d(_) {
    if (!c(_)) return;
    const m = t * (_ * -1);
    i.forEach((g) => g.add(m));
  }
  return {
    loop: d
  };
}
function nT(t) {
  const {
    max: e,
    length: n
  } = t;
  function i(a) {
    const s = a - e;
    return n ? s / -n : 0;
  }
  return {
    get: i
  };
}
function iT(t, e, n, i, r) {
  const {
    startEdge: a,
    endEdge: s
  } = t, {
    groupSlides: o
  } = r, l = u().map(e.measure), c = _(), d = m();
  function u() {
    return o(i).map((S) => Wt(S)[s] - S[0][a]).map($e);
  }
  function _() {
    return i.map((S) => n[a] - S[a]).map((S) => -$e(S));
  }
  function m() {
    return o(c).map((S) => S[0]).map((S, E) => S + l[E]);
  }
  return {
    snaps: c,
    snapsAligned: d
  };
}
function rT(t, e, n, i, r, a) {
  const {
    groupSlides: s
  } = r, {
    min: o,
    max: l
  } = i, c = d();
  function d() {
    const _ = s(a), m = !t || e === "keepSnaps";
    return n.length === 1 ? [a] : m ? _ : _.slice(o, l).map((g, S, E) => {
      const h = !S, T = Ps(E, S);
      if (h) {
        const b = Wt(E[0]) + 1;
        return Sl(b);
      }
      if (T) {
        const b = lr(a) - Wt(E)[0] + 1;
        return Sl(b, Wt(E)[0]);
      }
      return g;
    });
  }
  return {
    slideRegistry: c
  };
}
function aT(t, e, n, i, r) {
  const {
    reachedAny: a,
    removeOffset: s,
    constrain: o
  } = i;
  function l(g) {
    return g.concat().sort((S, E) => $e(S) - $e(E))[0];
  }
  function c(g) {
    const S = t ? s(g) : o(g), E = e.map((T, b) => ({
      diff: d(T - S, 0),
      index: b
    })).sort((T, b) => $e(T.diff) - $e(b.diff)), {
      index: h
    } = E[0];
    return {
      index: h,
      distance: S
    };
  }
  function d(g, S) {
    const E = [g, g + n, g - n];
    if (!t) return g;
    if (!S) return l(E);
    const h = E.filter((T) => Ls(T) === S);
    return h.length ? l(h) : Wt(E) - n;
  }
  function u(g, S) {
    const E = e[g] - r.get(), h = d(E, S);
    return {
      index: g,
      distance: h
    };
  }
  function _(g, S) {
    const E = r.get() + g, {
      index: h,
      distance: T
    } = c(E), b = !t && a(E);
    if (!S || b) return {
      index: h,
      distance: g
    };
    const C = e[h] - T, y = g + d(C, 0);
    return {
      index: h,
      distance: y
    };
  }
  return {
    byDistance: _,
    byIndex: u,
    shortcut: d
  };
}
function sT(t, e, n, i, r, a, s) {
  function o(u) {
    const _ = u.distance, m = u.index !== e.get();
    a.add(_), _ && (i.duration() ? t.start() : (t.update(), t.render(1), t.update())), m && (n.set(e.get()), e.set(u.index), s.emit("select"));
  }
  function l(u, _) {
    const m = r.byDistance(u, _);
    o(m);
  }
  function c(u, _) {
    const m = e.clone().set(u), g = r.byIndex(m.get(), _);
    o(g);
  }
  return {
    distance: l,
    index: c
  };
}
function oT(t, e, n, i, r, a, s, o) {
  const l = {
    passive: !0,
    capture: !0
  };
  let c = 0;
  function d(m) {
    if (!o) return;
    function g(S) {
      if ((/* @__PURE__ */ new Date()).getTime() - c > 10) return;
      s.emit("slideFocusStart"), t.scrollLeft = 0;
      const T = n.findIndex((b) => b.includes(S));
      xs(T) && (r.useDuration(0), i.index(T, 0), s.emit("slideFocus"));
    }
    a.add(document, "keydown", u, !1), e.forEach((S, E) => {
      a.add(S, "focus", (h) => {
        (ca(o) || o(m, h)) && g(E);
      }, l);
    });
  }
  function u(m) {
    m.code === "Tab" && (c = (/* @__PURE__ */ new Date()).getTime());
  }
  return {
    init: d
  };
}
function Wi(t) {
  let e = t;
  function n() {
    return e;
  }
  function i(l) {
    e = s(l);
  }
  function r(l) {
    e += s(l);
  }
  function a(l) {
    e -= s(l);
  }
  function s(l) {
    return xs(l) ? l : l.get();
  }
  return {
    get: n,
    set: i,
    add: r,
    subtract: a
  };
}
function qc(t, e) {
  const n = t.scroll === "x" ? s : o, i = e.style;
  let r = null, a = !1;
  function s(_) {
    return `translate3d(${_}px,0px,0px)`;
  }
  function o(_) {
    return `translate3d(0px,${_}px,0px)`;
  }
  function l(_) {
    if (a) return;
    const m = $f(t.direction(_));
    m !== r && (i.transform = n(m), r = m);
  }
  function c(_) {
    a = !_;
  }
  function d() {
    a || (i.transform = "", e.getAttribute("style") || e.removeAttribute("style"));
  }
  return {
    clear: d,
    to: l,
    toggleActive: c
  };
}
function lT(t, e, n, i, r, a, s, o, l) {
  const d = tr(r), u = tr(r).reverse(), _ = h().concat(T());
  function m(A, I) {
    return A.reduce((k, x) => k - r[x], I);
  }
  function g(A, I) {
    return A.reduce((k, x) => m(k, I) > 0 ? k.concat([x]) : k, []);
  }
  function S(A) {
    return a.map((I, k) => ({
      start: I - i[k] + 0.5 + A,
      end: I + e - 0.5 + A
    }));
  }
  function E(A, I, k) {
    const x = S(I);
    return A.map((B) => {
      const X = k ? 0 : -n, J = k ? n : 0, D = k ? "end" : "start", L = x[B][D];
      return {
        index: B,
        loopPoint: L,
        slideLocation: Wi(-1),
        translate: qc(t, l[B]),
        target: () => o.get() > L ? X : J
      };
    });
  }
  function h() {
    const A = s[0], I = g(u, A);
    return E(I, n, !1);
  }
  function T() {
    const A = e - s[0] - 1, I = g(d, A);
    return E(I, -n, !0);
  }
  function b() {
    return _.every(({
      index: A
    }) => {
      const I = d.filter((k) => k !== A);
      return m(I, e) <= 0.1;
    });
  }
  function C() {
    _.forEach((A) => {
      const {
        target: I,
        translate: k,
        slideLocation: x
      } = A, B = I();
      B !== x.get() && (k.to(B), x.set(B));
    });
  }
  function y() {
    _.forEach((A) => A.translate.clear());
  }
  return {
    canLoop: b,
    clear: y,
    loop: C,
    loopPoints: _
  };
}
function cT(t, e, n) {
  let i, r = !1;
  function a(l) {
    if (!n) return;
    function c(d) {
      for (const u of d)
        if (u.type === "childList") {
          l.reInit(), e.emit("slidesChanged");
          break;
        }
    }
    i = new MutationObserver((d) => {
      r || (ca(n) || n(l, d)) && c(d);
    }), i.observe(t, {
      childList: !0
    });
  }
  function s() {
    i && i.disconnect(), r = !0;
  }
  return {
    init: a,
    destroy: s
  };
}
function dT(t, e, n, i) {
  const r = {};
  let a = null, s = null, o, l = !1;
  function c() {
    o = new IntersectionObserver((g) => {
      l || (g.forEach((S) => {
        const E = e.indexOf(S.target);
        r[E] = S;
      }), a = null, s = null, n.emit("slidesInView"));
    }, {
      root: t.parentElement,
      threshold: i
    }), e.forEach((g) => o.observe(g));
  }
  function d() {
    o && o.disconnect(), l = !0;
  }
  function u(g) {
    return nr(r).reduce((S, E) => {
      const h = parseInt(E), {
        isIntersecting: T
      } = r[h];
      return (g && T || !g && !T) && S.push(h), S;
    }, []);
  }
  function _(g = !0) {
    if (g && a) return a;
    if (!g && s) return s;
    const S = u(g);
    return g && (a = S), g || (s = S), S;
  }
  return {
    init: c,
    destroy: d,
    get: _
  };
}
function uT(t, e, n, i, r, a) {
  const {
    measureSize: s,
    startEdge: o,
    endEdge: l
  } = t, c = n[0] && r, d = g(), u = S(), _ = n.map(s), m = E();
  function g() {
    if (!c) return 0;
    const T = n[0];
    return $e(e[o] - T[o]);
  }
  function S() {
    if (!c) return 0;
    const T = a.getComputedStyle(Wt(i));
    return parseFloat(T.getPropertyValue(`margin-${l}`));
  }
  function E() {
    return n.map((T, b, C) => {
      const y = !b, O = Ps(C, b);
      return y ? _[b] + d : O ? _[b] + u : C[b + 1][o] - T[o];
    }).map($e);
  }
  return {
    slideSizes: _,
    slideSizesWithGaps: m,
    startGap: d,
    endGap: u
  };
}
function _T(t, e, n, i, r, a, s, o, l) {
  const {
    startEdge: c,
    endEdge: d,
    direction: u
  } = t, _ = xs(n);
  function m(h, T) {
    return tr(h).filter((b) => b % T === 0).map((b) => h.slice(b, b + T));
  }
  function g(h) {
    return h.length ? tr(h).reduce((T, b, C) => {
      const y = Wt(T) || 0, O = y === 0, A = b === lr(h), I = r[c] - a[y][c], k = r[c] - a[b][d], x = !i && O ? u(s) : 0, B = !i && A ? u(o) : 0, X = $e(k - B - (I + x));
      return C && X > e + l && T.push(b), A && T.push(h.length), T;
    }, []).map((T, b, C) => {
      const y = Math.max(C[b - 1] || 0);
      return h.slice(y, T);
    }) : [];
  }
  function S(h) {
    return _ ? m(h, n) : g(h);
  }
  return {
    groupSlides: S
  };
}
function pT(t, e, n, i, r, a, s) {
  const {
    align: o,
    axis: l,
    direction: c,
    startIndex: d,
    loop: u,
    duration: _,
    dragFree: m,
    dragThreshold: g,
    inViewThreshold: S,
    slidesToScroll: E,
    skipSnaps: h,
    containScroll: T,
    watchResize: b,
    watchSlides: C,
    watchDrag: y,
    watchFocus: O
  } = a, A = 2, I = Kf(), k = I.measure(e), x = n.map(I.measure), B = qf(l, c), X = B.measureSize(k), J = Qf(X), D = Vf(o, X), L = !u && !!T, G = u || !!T, {
    slideSizes: q,
    slideSizesWithGaps: V,
    startGap: Z,
    endGap: fe
  } = uT(B, k, x, n, G, r), _e = _T(B, X, E, u, k, x, Z, fe, A), {
    snaps: me,
    snapsAligned: Me
  } = iT(B, D, k, x, _e), ke = -Wt(me) + Wt(V), {
    snapsContained: tt,
    scrollContainLimit: Ke
  } = jf(X, ke, Me, T, A), Ue = L ? tt : Me, {
    limit: ye
  } = eT(ke, Ue, u), Fe = Hc(lr(Ue), d, u), Ce = Fe.clone(), Ee = tr(n), Y = ({
    dragHandler: mn,
    scrollBody: jn,
    scrollBounds: ei,
    options: {
      loop: wn
    }
  }) => {
    wn || ei.constrain(mn.pointerDown()), jn.seek();
  }, ge = ({
    scrollBody: mn,
    translate: jn,
    location: ei,
    offsetLocation: wn,
    previousLocation: wi,
    scrollLooper: fr,
    slideLooper: Tr,
    dragHandler: br,
    animation: ti,
    eventHandler: ni,
    scrollBounds: xi,
    options: {
      loop: Li
    }
  }, ii) => {
    const rn = mn.settled(), f = !xi.shouldConstrain(), v = Li ? rn : rn && f, P = v && !br.pointerDown();
    P && ti.stop();
    const ee = ei.get() * ii + wi.get() * (1 - ii);
    wn.set(ee), Li && (fr.loop(mn.direction()), Tr.loop()), jn.to(wn.get()), P && ni.emit("settle"), v || ni.emit("scroll");
  }, Oe = Hf(i, r, () => Y(Jn), (mn) => ge(Jn, mn)), Ye = 0.68, ae = Ue[Fe.get()], ot = Wi(ae), lt = Wi(ae), vt = Wi(ae), Vt = Wi(ae), bn = Zf(ot, vt, lt, Vt, _, Ye), Xn = aT(u, Ue, ke, ye, Vt), Mn = sT(Oe, Fe, Ce, bn, Xn, Vt, s), Ht = nT(ye), Zn = ir(), pn = dT(e, n, s, S), {
    slideRegistry: Cn
  } = rT(L, T, Ue, Ke, _e, Ee), Mi = oT(t, n, Cn, Mn, bn, Zn, s, O), Jn = {
    ownerDocument: i,
    ownerWindow: r,
    eventHandler: s,
    containerRect: k,
    slideRects: x,
    animation: Oe,
    axis: B,
    dragHandler: zf(B, t, i, r, Vt, Wf(B, r), ot, Oe, Mn, bn, Xn, Fe, s, J, m, g, h, Ye, y),
    eventStore: Zn,
    percentOfView: J,
    index: Fe,
    indexPrevious: Ce,
    limit: ye,
    location: ot,
    offsetLocation: vt,
    previousLocation: lt,
    options: a,
    resizeHandler: Xf(e, s, r, n, B, b, I),
    scrollBody: bn,
    scrollBounds: Jf(ye, vt, Vt, bn, J),
    scrollLooper: tT(ke, ye, vt, [ot, vt, lt, Vt]),
    scrollProgress: Ht,
    scrollSnapList: Ue.map(Ht.get),
    scrollSnaps: Ue,
    scrollTarget: Xn,
    scrollTo: Mn,
    slideLooper: lT(B, X, ke, q, V, me, Ue, vt, n),
    slideFocus: Mi,
    slidesHandler: cT(e, s, C),
    slidesInView: pn,
    slideIndexes: Ee,
    slideRegistry: Cn,
    slidesToScroll: _e,
    target: Vt,
    translate: qc(B, e)
  };
  return Jn;
}
function mT() {
  let t = {}, e;
  function n(c) {
    e = c;
  }
  function i(c) {
    return t[c] || [];
  }
  function r(c) {
    return i(c).forEach((d) => d(e, c)), l;
  }
  function a(c, d) {
    return t[c] = i(c).concat([d]), l;
  }
  function s(c, d) {
    return t[c] = i(c).filter((u) => u !== d), l;
  }
  function o() {
    t = {};
  }
  const l = {
    init: n,
    emit: r,
    off: s,
    on: a,
    clear: o
  };
  return l;
}
const ET = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function gT(t) {
  function e(a, s) {
    return Vc(a, s || {});
  }
  function n(a) {
    const s = a.breakpoints || {}, o = nr(s).filter((l) => t.matchMedia(l).matches).map((l) => s[l]).reduce((l, c) => e(l, c), {});
    return e(a, o);
  }
  function i(a) {
    return a.map((s) => nr(s.breakpoints || {})).reduce((s, o) => s.concat(o), []).map(t.matchMedia);
  }
  return {
    mergeOptions: e,
    optionsAtMedia: n,
    optionsMediaQueries: i
  };
}
function ST(t) {
  let e = [];
  function n(a, s) {
    return e = s.filter(({
      options: o
    }) => t.optionsAtMedia(o).active !== !1), e.forEach((o) => o.init(a, t)), s.reduce((o, l) => Object.assign(o, {
      [l.name]: l
    }), {});
  }
  function i() {
    e = e.filter((a) => a.destroy());
  }
  return {
    init: n,
    destroy: i
  };
}
function Kr(t, e, n) {
  const i = t.ownerDocument, r = i.defaultView, a = gT(r), s = ST(a), o = ir(), l = mT(), {
    mergeOptions: c,
    optionsAtMedia: d,
    optionsMediaQueries: u
  } = a, {
    on: _,
    off: m,
    emit: g
  } = l, S = B;
  let E = !1, h, T = c(ET, Kr.globalOptions), b = c(T), C = [], y, O, A;
  function I() {
    const {
      container: Ee,
      slides: Y
    } = b;
    O = (is(Ee) ? t.querySelector(Ee) : Ee) || t.children[0];
    const Oe = is(Y) ? O.querySelectorAll(Y) : Y;
    A = [].slice.call(Oe || O.children);
  }
  function k(Ee) {
    const Y = pT(t, O, A, i, r, Ee, l);
    if (Ee.loop && !Y.slideLooper.canLoop()) {
      const ge = Object.assign({}, Ee, {
        loop: !1
      });
      return k(ge);
    }
    return Y;
  }
  function x(Ee, Y) {
    E || (T = c(T, Ee), b = d(T), C = Y || C, I(), h = k(b), u([T, ...C.map(({
      options: ge
    }) => ge)]).forEach((ge) => o.add(ge, "change", B)), b.active && (h.translate.to(h.location.get()), h.animation.init(), h.slidesInView.init(), h.slideFocus.init(Ce), h.eventHandler.init(Ce), h.resizeHandler.init(Ce), h.slidesHandler.init(Ce), h.options.loop && h.slideLooper.loop(), O.offsetParent && A.length && h.dragHandler.init(Ce), y = s.init(Ce, C)));
  }
  function B(Ee, Y) {
    const ge = _e();
    X(), x(c({
      startIndex: ge
    }, Ee), Y), l.emit("reInit");
  }
  function X() {
    h.dragHandler.destroy(), h.eventStore.clear(), h.translate.clear(), h.slideLooper.clear(), h.resizeHandler.destroy(), h.slidesHandler.destroy(), h.slidesInView.destroy(), h.animation.destroy(), s.destroy(), o.clear();
  }
  function J() {
    E || (E = !0, o.clear(), X(), l.emit("destroy"), l.clear());
  }
  function D(Ee, Y, ge) {
    !b.active || E || (h.scrollBody.useBaseFriction().useDuration(Y === !0 ? 0 : b.duration), h.scrollTo.index(Ee, ge || 0));
  }
  function L(Ee) {
    const Y = h.index.add(1).get();
    D(Y, Ee, -1);
  }
  function G(Ee) {
    const Y = h.index.add(-1).get();
    D(Y, Ee, 1);
  }
  function q() {
    return h.index.add(1).get() !== _e();
  }
  function V() {
    return h.index.add(-1).get() !== _e();
  }
  function Z() {
    return h.scrollSnapList;
  }
  function fe() {
    return h.scrollProgress.get(h.offsetLocation.get());
  }
  function _e() {
    return h.index.get();
  }
  function me() {
    return h.indexPrevious.get();
  }
  function Me() {
    return h.slidesInView.get();
  }
  function ke() {
    return h.slidesInView.get(!1);
  }
  function tt() {
    return y;
  }
  function Ke() {
    return h;
  }
  function Ue() {
    return t;
  }
  function ye() {
    return O;
  }
  function Fe() {
    return A;
  }
  const Ce = {
    canScrollNext: q,
    canScrollPrev: V,
    containerNode: ye,
    internalEngine: Ke,
    destroy: J,
    off: m,
    on: _,
    emit: g,
    plugins: tt,
    previousScrollSnap: me,
    reInit: S,
    rootNode: Ue,
    scrollNext: L,
    scrollPrev: G,
    scrollProgress: fe,
    scrollSnapList: Z,
    scrollTo: D,
    selectedScrollSnap: _e,
    slideNodes: Fe,
    slidesInView: Me,
    slidesNotInView: ke
  };
  return x(e, n), setTimeout(() => l.emit("init"), 0), Ce;
}
Kr.globalOptions = void 0;
function Qr(t = {}, e = []) {
  const n = wt(t), i = wt(e), [r, a] = Je(), [s, o] = Je(), l = Jt(() => {
    r && r.reInit(n.current, i.current);
  }, [r]);
  return gt(() => {
    ws(n.current, t) || (n.current = t, l());
  }, [t, l]), gt(() => {
    Gf(i.current, e) || (i.current = e, l());
  }, [e, l]), gt(() => {
    if (Bf() && s) {
      Kr.globalOptions = Qr.globalOptions;
      const c = Kr(s, n.current, i.current);
      return a(c), () => c.destroy();
    } else
      a(void 0);
  }, [s, a]), [o, r];
}
Qr.globalOptions = void 0;
const hT = "_carouselWrapper_1ldpw_1", fT = "_carouselViewport_1ldpw_14", TT = "_carouselContainer_1ldpw_22", bT = "_carouselSlide_1ldpw_29", CT = "_carouselSlideItem_1ldpw_40", yT = "_carouselSlideDescription_1ldpw_59", RT = "_carouselThumbsWrapper_1ldpw_69", NT = "_carouselThumbsViewport_1ldpw_76", OT = "_carouselThumbsContainer_1ldpw_82", vT = "_carouselThumb_1ldpw_69", AT = "_selectedCarouselThumb_1ldpw_112", IT = "_snapDisplay_1ldpw_121", DT = "_actions_1ldpw_130", MT = "_actionsButton_1ldpw_144", pt = {
  carouselWrapper: hT,
  carouselViewport: fT,
  carouselContainer: TT,
  carouselSlide: bT,
  carouselSlideItem: CT,
  carouselSlideDescription: yT,
  carouselThumbsWrapper: RT,
  carouselThumbsViewport: NT,
  carouselThumbsContainer: OT,
  carouselThumb: vT,
  selectedCarouselThumb: AT,
  snapDisplay: IT,
  actions: DT,
  actionsButton: MT
}, wT = "_tooltip_usgtd_1", xT = "_image_usgtd_17", LT = "_imageProcessing_usgtd_40", PT = "_bannerWrapper_usgtd_59", kT = "_bannerIcon_usgtd_67", UT = "_alignLeft_usgtd_74", FT = "_alignCenter_usgtd_78", BT = "_alignRight_usgtd_82", GT = "_processingText_usgtd_114", YT = "_textSuccess_usgtd_131", $T = "_textDanger_usgtd_135", st = {
  tooltip: wT,
  image: xT,
  imageProcessing: LT,
  bannerWrapper: PT,
  bannerIcon: kT,
  alignLeft: UT,
  alignCenter: FT,
  alignRight: BT,
  processingText: GT,
  textSuccess: YT,
  textDanger: $T
}, jt = typeof document > "u", cn = /* @__PURE__ */ Symbol(0);
let Xr = !1, as = !1, Kt = null, pi = null, $t = null, Dt = 0, ui = [], ks = {};
const VT = () => {
}, Ci = 0, zc = 1, Zr = 2, da = 3;
function HT() {
  Xr = !0, queueMicrotask(Wc);
}
function Wc() {
  if (!ui.length) {
    Xr = !1;
    return;
  }
  as = !0;
  for (let t = 0; t < ui.length; t++)
    ui[t].$st !== Ci && qT(ui[t]);
  ui = [], Xr = !1, as = !1;
}
function qT(t) {
  let e = [t];
  for (; t = t[cn]; )
    t.$e && t.$st !== Ci && e.push(t);
  for (let n = e.length - 1; n >= 0; n--)
    Vs(e[n]);
}
function zT(t) {
  const e = Si();
  return cr(e, t.length ? t.bind(null, gi.bind(e)) : t, null);
}
function F(t) {
  return cr(Kt, t, null);
}
function Ei(t) {
  return cr(null, t, null);
}
function on() {
  as || Wc();
}
function ua() {
  return Kt;
}
function Tt(t, e) {
  try {
    return cr(e, t, null);
  } catch (n) {
    Fs(e, n);
    return;
  }
}
function Us(t, e = Kt) {
  return e?.$cx[t];
}
function WT(t, e, n = Kt) {
  n && (n.$cx = { ...n.$cx, [t]: e });
}
function ue(t) {
  if (!t || !Kt)
    return t || VT;
  const e = Kt;
  return e.$d ? Array.isArray(e.$d) ? e.$d.push(t) : e.$d = [e.$d, t] : e.$d = t, function() {
    e.$st !== da && (t.call(null), _a(e.$d) ? e.$d = null : Array.isArray(e.$d) && e.$d.splice(e.$d.indexOf(t), 1));
  };
}
function gi(t = !0) {
  if (this.$st !== da) {
    if (this.$h)
      if (Array.isArray(this.$h))
        for (let e = this.$h.length - 1; e >= 0; e--)
          gi.call(this.$h[e]);
      else
        gi.call(this.$h);
    if (t) {
      const e = this[cn];
      e && (Array.isArray(e.$h) ? e.$h.splice(e.$h.indexOf(this), 1) : e.$h = null), KT(this);
    }
  }
}
function KT(t) {
  t.$st = da, t.$d && Kc(t), t.$s && ss(t, 0), t[cn] = null, t.$s = null, t.$o = null, t.$h = null, t.$cx = ks, t.$eh = null;
}
function Kc(t) {
  try {
    if (Array.isArray(t.$d))
      for (let e = t.$d.length - 1; e >= 0; e--) {
        const n = t.$d[e];
        n.call(n);
      }
    else
      t.$d.call(t.$d);
    t.$d = null;
  } catch (e) {
    Fs(t, e);
  }
}
function cr(t, e, n) {
  const i = Kt, r = pi;
  Kt = t, pi = n;
  try {
    return e.call(t);
  } finally {
    Kt = i, pi = r;
  }
}
function Fs(t, e) {
  if (!t || !t.$eh)
    throw e;
  let n = 0, i = t.$eh.length, r = e;
  for (n = 0; n < i; n++)
    try {
      t.$eh[n](r);
      break;
    } catch (a) {
      r = a;
    }
  if (n === i)
    throw r;
}
function Bs() {
  return this.$st === da ? this.$v : (pi && !this.$e && (!$t && pi.$s && pi.$s[Dt] == this ? Dt++ : $t ? $t.push(this) : $t = [this]), this.$c && Vs(this), this.$v);
}
function Qc(t) {
  const e = _a(t) ? t(this.$v) : t;
  if (this.$ch(this.$v, e) && (this.$v = e, this.$o))
    for (let n = 0; n < this.$o.length; n++)
      Jc(this.$o[n], Zr);
  return this.$v;
}
const Gs = function() {
  this[cn] = null, this.$h = null, Kt && Kt.append(this);
}, qn = Gs.prototype;
qn.$cx = ks;
qn.$eh = null;
qn.$c = null;
qn.$d = null;
qn.append = function(t) {
  t[cn] = this, this.$h ? Array.isArray(this.$h) ? this.$h.push(t) : this.$h = [this.$h, t] : this.$h = t, t.$cx = t.$cx === ks ? this.$cx : { ...this.$cx, ...t.$cx }, this.$eh && (t.$eh = t.$eh ? [...t.$eh, ...this.$eh] : this.$eh);
};
qn.dispose = function() {
  gi.call(this);
};
function Si() {
  return new Gs();
}
const Xc = function(e, n, i) {
  Gs.call(this), this.$st = n ? Zr : Ci, this.$i = !1, this.$e = !1, this.$s = null, this.$o = null, this.$v = e, n && (this.$c = n), i && i.dirty && (this.$ch = i.dirty);
}, Ys = Xc.prototype;
Object.setPrototypeOf(Ys, qn);
Ys.$ch = QT;
Ys.call = Bs;
function $s(t, e, n) {
  return new Xc(t, e, n);
}
function QT(t, e) {
  return t !== e;
}
function _a(t) {
  return typeof t == "function";
}
function Vs(t) {
  if (t.$st === zc)
    for (let e = 0; e < t.$s.length && (Vs(t.$s[e]), t.$st !== Zr); e++)
      ;
  t.$st === Zr ? Zc(t) : t.$st = Ci;
}
function XT(t) {
  t.$h && gi.call(t, !1), t.$d && Kc(t), t.$eh = t[cn] ? t[cn].$eh : null;
}
function Zc(t) {
  let e = $t, n = Dt;
  $t = null, Dt = 0;
  try {
    XT(t);
    const i = cr(t, t.$c, t);
    hl(t), !t.$e && t.$i ? Qc.call(t, i) : (t.$v = i, t.$i = !0);
  } catch (i) {
    hl(t), Fs(t, i);
  } finally {
    $t = e, Dt = n, t.$st = Ci;
  }
}
function hl(t) {
  if ($t) {
    if (t.$s && ss(t, Dt), t.$s && Dt > 0) {
      t.$s.length = Dt + $t.length;
      for (let n = 0; n < $t.length; n++)
        t.$s[Dt + n] = $t[n];
    } else
      t.$s = $t;
    let e;
    for (let n = Dt; n < t.$s.length; n++)
      e = t.$s[n], e.$o ? e.$o.push(t) : e.$o = [t];
  } else t.$s && Dt < t.$s.length && (ss(t, Dt), t.$s.length = Dt);
}
function Jc(t, e) {
  if (!(t.$st >= e) && (t.$e && t.$st === Ci && (ui.push(t), Xr || HT()), t.$st = e, t.$o))
    for (let n = 0; n < t.$o.length; n++)
      Jc(t.$o[n], zc);
}
function ss(t, e) {
  let n, i;
  for (let r = e; r < t.$s.length; r++)
    n = t.$s[r], n.$o && (i = n.$o.indexOf(t), n.$o[i] = n.$o[n.$o.length - 1], n.$o.pop());
}
function j(t, e) {
  const n = $s(t, null, e), i = Bs.bind(n);
  return i[cn] = !0, i.set = Qc.bind(n), i;
}
function ZT(t) {
  return _a(t) && cn in t;
}
function yi(t, e) {
  const n = $s(
    e?.initial,
    t,
    e
  ), i = Bs.bind(n);
  return i[cn] = !0, i;
}
function Hs(t, e) {
  const n = $s(
    null,
    function() {
      let r = t();
      return _a(r) && ue(r), null;
    },
    void 0
  );
  return n.$e = !0, Zc(n), gi.bind(n, !0);
}
function jc(t) {
  return ZT(t) && "set" in t;
}
function xt(...t) {
}
function Qt(t) {
  return t === null;
}
function je(t) {
  return typeof t > "u";
}
function ed(t) {
  return Qt(t) || je(t);
}
function td(t) {
  return t?.constructor === Object;
}
function mt(t) {
  return typeof t == "number" && !Number.isNaN(t);
}
function Q(t) {
  return typeof t == "string";
}
function os(t) {
  return typeof t == "boolean";
}
function yt(t) {
  return typeof t == "function";
}
function Et(t) {
  return Array.isArray(t);
}
const N = jt ? JT : Hs;
function JT(t, e) {
  return typeof process < "u" && process.env?.NODE_ENV === "test" ? Hs(t) : xt;
}
const jT = jt ? class {
} : Event, nd = /* @__PURE__ */ Symbol("DOM_EVENT");
class Se extends jT {
  [nd] = !0;
  /**
   * The event detail.
   */
  detail;
  /**
   * The event trigger chain.
   */
  triggers = new eb();
  /**
   * The preceding event that was responsible for this event being fired.
   */
  get trigger() {
    return this.triggers.source;
  }
  /**
   * The origin event that lead to this event being fired.
   */
  get originEvent() {
    return this.triggers.origin;
  }
  /**
   * Whether the origin event was triggered by the user.
   *
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Event/isTrusted}
   */
  get isOriginTrusted() {
    return this.triggers.origin?.isTrusted ?? !1;
  }
  constructor(e, ...n) {
    super(e, n[0]), this.detail = n[0]?.detail;
    const i = n[0]?.trigger;
    i && this.triggers.add(i);
  }
}
class eb {
  chain = [];
  get source() {
    return this.chain[0];
  }
  get origin() {
    return this.chain[this.chain.length - 1];
  }
  /**
   * Appends the event to the end of the chain.
   */
  add(e) {
    this.chain.push(e), tb(e) && this.chain.push(...e.triggers);
  }
  /**
   * Removes the event from the chain and returns it (if found).
   */
  remove(e) {
    return this.chain.splice(this.chain.indexOf(e), 1)[0];
  }
  /**
   * Returns whether the chain contains the given `event`.
   */
  has(e) {
    return this.chain.some((n) => n === e);
  }
  /**
   * Returns whether the chain contains the given event type.
   */
  hasType(e) {
    return !!this.findType(e);
  }
  /**
   * Returns the first event with the given `type` found in the chain.
   */
  findType(e) {
    return this.chain.find((n) => n.type === e);
  }
  /**
   * Walks an event chain on a given `event`, and invokes the given `callback` for each trigger event.
   */
  walk(e) {
    for (const n of this.chain) {
      const i = e(n);
      if (i) return [n, i];
    }
  }
  [Symbol.iterator]() {
    return this.chain.values();
  }
}
function tb(t) {
  return !!t?.[nd];
}
class qs extends EventTarget {
  /** @internal type only */
  $ts__events;
  addEventListener(e, n, i) {
    return super.addEventListener(e, n, i);
  }
  removeEventListener(e, n, i) {
    return super.removeEventListener(e, n, i);
  }
}
function Ve(t, e, n, i) {
  return jt ? xt : (t.addEventListener(e, n, i), ue(() => t.removeEventListener(e, n, i)));
}
class Ae {
  #e;
  #t;
  get signal() {
    return this.#t.signal;
  }
  constructor(e) {
    this.#e = e, this.#t = new AbortController(), ue(this.abort.bind(this));
  }
  add(e, n, i) {
    if (this.signal.aborted) throw Error("aborted");
    return this.#e.addEventListener(e, n, {
      ...i,
      signal: i?.signal ? nb(this.signal, i.signal) : this.signal
    }), this;
  }
  remove(e, n) {
    return this.#e.removeEventListener(e, n), this;
  }
  abort(e) {
    this.#t.abort(e);
  }
}
function nb(...t) {
  const e = new AbortController(), n = { signal: e.signal };
  function i(r) {
    e.abort(r.target.reason);
  }
  for (const r of t) {
    if (r.aborted) {
      e.abort(r.reason);
      break;
    }
    r.addEventListener("abort", i, n);
  }
  return e.signal;
}
function ls(t) {
  return !!t?.type.startsWith("pointer");
}
function Xi(t) {
  return !!t?.type.startsWith("touch");
}
function id(t) {
  return /^(click|mouse)/.test(t?.type ?? "");
}
function zn(t) {
  return !!t?.type.startsWith("key");
}
function rd(t) {
  return zn(t) && t.key === "Enter";
}
function dr(t) {
  return zn(t) && (t.key === "Enter" || t.key === " ");
}
function ad(t) {
  return t instanceof Node;
}
function re(t, e, n) {
  if (t) if (!n && n !== "" && n !== 0)
    t.removeAttribute(e);
  else {
    const i = n === !0 ? "" : n + "";
    t.getAttribute(e) !== i && t.setAttribute(e, i);
  }
  else return;
}
function Xt(t, e, n) {
  if (t) !n && n !== 0 ? t.style.removeProperty(e) : t.style.setProperty(e, n + "");
  else return;
}
function fl(t) {
  let e = t;
  for (; typeof e == "function"; ) e = e.call(this);
  return e;
}
function An(t) {
  return { id: /* @__PURE__ */ Symbol(), provide: t };
}
function en(t, e, n = ua()) {
  const i = !je(e);
  WT(t.id, i ? e : t.provide?.(), n);
}
function ut(t) {
  return Us(t.id);
}
function dn(t) {
  return !je(Us(t.id));
}
const Ga = /* @__PURE__ */ Symbol(0), Ya = /* @__PURE__ */ Symbol(0), pa = /* @__PURE__ */ Symbol(0), $a = {};
class ib {
  /** @internal type only */
  $ts__events;
  /** @internal type only */
  $ts__vars;
  /* @internal */
  [pa] = null;
  $el = j(null);
  el = null;
  scope = null;
  attachScope = null;
  connectScope = null;
  component = null;
  destroyed = !1;
  props = $a;
  attrs = null;
  styles = null;
  state;
  $state;
  #e = [];
  #t = [];
  #n = [];
  #i = [];
  constructor(e, n, i) {
    this.scope = n, i?.scope && i.scope.append(n);
    let r = e.state, a = e.props;
    if (r && (this.$state = r.create(), this.state = new Proxy(this.$state, {
      get: (s, o) => this.$state[o]()
    }), en(r, this.$state)), a && (this.props = rb(a), i?.props))
      for (const s of Object.keys(i.props))
        this.props[s]?.set(i.props[s]);
    ue(this.destroy.bind(this));
  }
  setup() {
    Tt(() => {
      for (const e of this.#e) e();
    }, this.scope);
  }
  attach(e) {
    this.el || (this.el = e, this.$el.set(e), Tt(() => {
      this.attachScope = Si(), Tt(() => {
        for (const n of this.#t) n(this.el);
        this.#r(), this.#a();
      }, this.attachScope);
    }, this.scope), e.dispatchEvent(new Event("attached")));
  }
  detach() {
    this.attachScope?.dispose(), this.attachScope = null, this.connectScope = null, this.el = null, this.$el.set(null);
  }
  connect() {
    !this.el || !this.attachScope || !this.#n.length || Tt(() => {
      this.connectScope = Si(), Tt(() => {
        for (const e of this.#n) e(this.el);
      }, this.connectScope);
    }, this.attachScope);
  }
  disconnect() {
    this.connectScope?.dispose(), this.connectScope = null;
  }
  destroy() {
    if (this.destroyed) return;
    this.destroyed = !0, Tt(() => {
      for (const n of this.#i) n(this.el);
    }, this.scope);
    const e = this.el;
    this.detach(), this.scope.dispose(), this.#e.length = 0, this.#t.length = 0, this.#n.length = 0, this.#i.length = 0, this.component = null, this.attrs = null, this.styles = null, this.props = $a, this.scope = null, this.state = $a, this.$state = null, e && delete e.$;
  }
  addHooks(e) {
    e.onSetup && this.#e.push(e.onSetup.bind(e)), e.onAttach && this.#t.push(e.onAttach.bind(e)), e.onConnect && this.#n.push(e.onConnect.bind(e)), e.onDestroy && this.#i.push(e.onDestroy.bind(e));
  }
  #r() {
    if (this.attrs)
      for (const e of Object.keys(this.attrs))
        jt ? re(this.el, e, fl.call(this.component, this.attrs[e])) : yt(this.attrs[e]) ? N(this.#s.bind(this, e)) : re(this.el, e, this.attrs[e]);
  }
  #a() {
    if (this.styles)
      for (const e of Object.keys(this.styles))
        jt ? Xt(this.el, e, fl.call(this.component, this.styles[e])) : yt(this.styles[e]) ? N(this.#l.bind(this, e)) : Xt(this.el, e, this.styles[e]);
  }
  #s(e) {
    re(this.el, e, this.attrs[e].call(this.component));
  }
  #l(e) {
    Xt(this.el, e, this.styles[e].call(this.component));
  }
}
function rb(t) {
  const e = {};
  for (const n of Object.keys(t)) {
    const i = t[n];
    e[n] = j(i, i);
  }
  return e;
}
let Zi = { $$: null };
function sd(t, e) {
  return zT(() => {
    Zi.$$ = new ib(t, ua(), e);
    const n = new t();
    return Zi.$$.component = n, Zi.$$ = null, n;
  });
}
class Ut extends EventTarget {
  /** @internal */
  $$;
  get el() {
    return this.$$.el;
  }
  get $el() {
    return this.$$.$el();
  }
  get scope() {
    return this.$$.scope;
  }
  get attachScope() {
    return this.$$.attachScope;
  }
  get connectScope() {
    return this.$$.connectScope;
  }
  /** @internal */
  get $props() {
    return this.$$.props;
  }
  /** @internal */
  get $state() {
    return this.$$.$state;
  }
  get state() {
    return this.$$.state;
  }
  constructor() {
    super(), Zi.$$ && this.attach(Zi);
  }
  attach({ $$: e }) {
    return this.$$ = e, e.addHooks(this), this;
  }
  addEventListener(e, n, i) {
    this.listen(e, n, i);
  }
  removeEventListener(e, n, i) {
    this.el?.removeEventListener(e, n, i);
  }
  /**
   * The given callback is invoked when the component is ready to be set up.
   *
   * - This hook will run once.
   * - This hook is called both client-side and server-side.
   * - It's safe to use context inside this hook.
   * - The host element has not attached yet - wait for `onAttach`.
   */
  /**
   * This method can be used to specify attributes that should be set on the host element. Any
   * attributes that are assigned to a function will be considered a signal and updated accordingly.
   */
  setAttributes(e) {
    this.$$.attrs || (this.$$.attrs = {}), Object.assign(this.$$.attrs, e);
  }
  /**
   * This method can be used to specify styles that should set be set on the host element. Any
   * styles that are assigned to a function will be considered a signal and updated accordingly.
   */
  setStyles(e) {
    this.$$.styles || (this.$$.styles = {}), Object.assign(this.$$.styles, e);
  }
  /**
   * This method is used to satisfy the CSS variables contract specified on the current
   * component. Other CSS variables can be set via the `setStyles` method.
   */
  setCSSVars(e) {
    this.setStyles(e);
  }
  /**
   * Type-safe utility for creating component DOM events.
   */
  createEvent(e, ...n) {
    return new Se(e, n[0]);
  }
  /**
   * Creates a `DOMEvent` and dispatches it from the host element. This method is typed to
   * match all component events.
   */
  dispatch(e, ...n) {
    if (jt || !this.el) return !1;
    const i = e instanceof Event ? e : new Se(e, n[0]);
    return Object.defineProperty(i, "target", {
      get: () => this.$$.component
    }), Ei(() => (this.$$[pa]?.(i), this.el.dispatchEvent(i)));
  }
  dispatchEvent(e) {
    return this.dispatch(e);
  }
  /**
   * Adds an event listener for the given `type` and returns a function which can be invoked to
   * remove the event listener.
   *
   * - The listener is removed if the current scope is disposed.
   * - This method is safe to use on the server (noop).
   */
  listen(e, n, i) {
    return jt || !this.el ? xt : Ve(this.el, e, n, i);
  }
}
class be extends Ut {
  subscribe(e) {
    return Tt(() => N(() => e(this.state)), this.$$.scope);
  }
  destroy() {
    this.$$.destroy();
  }
}
function he(t, e, n) {
  t[Ga] || (t[Ga] = /* @__PURE__ */ new Set()), t[Ga].add(e);
}
function et(t, e, n) {
  t[Ya] || (t[Ya] = /* @__PURE__ */ new Set()), t[Ya].add(e);
}
class In {
  id = /* @__PURE__ */ Symbol(0);
  record;
  #e;
  constructor(e) {
    this.record = e, this.#e = Object.getOwnPropertyDescriptors(e);
  }
  create() {
    const e = {}, n = new Proxy(e, { get: (i, r) => e[r]() });
    for (const i of Object.keys(this.record)) {
      const r = this.#e[i].get;
      e[i] = r ? yi(r.bind(n)) : j(this.record[i]);
    }
    return e;
  }
  reset(e, n) {
    for (const i of Object.keys(e))
      !this.#e[i].get && (!n || n(i)) && e[i].set(this.record[i]);
  }
}
function Ri(t) {
  return ut(t);
}
function ma(t) {
  return t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function zs(t) {
  return t.replace(/-./g, (e) => e[1].toUpperCase());
}
function ab(t) {
  return sb(t).replace(/\s/g, "");
}
function sb(t) {
  return Ea(t.replace(/-./g, (e) => " " + e[1].toUpperCase()));
}
function Ea(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}
const ur = p.createContext({ current: null });
ur.displayName = "Scope";
function od(t, ...e) {
  return p.createElement(ur.Provider, { value: t }, ...e);
}
function ld() {
  return p.useContext(ur).current;
}
function Ws(t) {
  const e = ld();
  return p.useMemo(() => Us(t.id, e), [e]);
}
function cd(t, e) {
  typeof t == "function" ? t(e) : t && (t.current = e);
}
function Pe(...t) {
  return (e) => t.forEach((n) => cd(n, e));
}
function ob(t, e) {
  const n = p.forwardRef((i, r) => {
    let a = p.useContext(ur), s = p.useRef(null), o = p.useRef();
    if (!o.current) {
      const E = cb(), h = Cl(t, E, i, a.current);
      E.component = h, o.current = E, s.current = h.scope;
    }
    function l() {
      let E = o.current, h = a.current;
      if (window.cancelAnimationFrame(E.destroyId), E.destroyId = -1, E.component.$$.destroyed) {
        const T = Cl(t, E, i, h);
        E.component = T, E.attached = !1, E.forwardRef = !1, s.current = T.scope;
      }
      return E.el && bl(E, E.el), E.forwardRef || (cd(r, E.component), E.forwardRef = !0), () => Br(E);
    }
    function c(E) {
      const h = o.current;
      if (!h.forwardRef) {
        h.el = E;
        return;
      }
      window.cancelAnimationFrame(h.refChangeId), h.refChangeId = window.requestAnimationFrame(() => {
        const T = o.current;
        T.refChangeId = -1, T.el !== E && (Br(T), E && bl(T, E), T.el = E);
      });
    }
    p.useEffect(() => {
      const E = o.current;
      return window.cancelAnimationFrame(E.destroyId), E.destroyId = -1, function() {
        yt(i.children) && (window.cancelAnimationFrame(E.refChangeId), E.refChangeId = -1, window.cancelAnimationFrame(E.connectId), E.connectId = -1, window.cancelAnimationFrame(E.destroyId), E.destroyId = window.requestAnimationFrame(() => {
          E.destroyId = -1, Br(E), E.component.$$.destroy(), E.component.$$[pa] = null, E.callbacks = {}, E.domCallbacks = {}, s.current = null;
        }));
      };
    }, []), p.useEffect(on);
    let d = o.current, { children: u, ..._ } = i, m = {}, g = d.prevProps, S = Object.keys(_);
    d.callbacks = {};
    for (const E of [...g, ...S])
      if (e.props.has(E))
        d.component.$props[E].set(
          // If the prop was removed we'll use the default value provided on Component creation.
          je(_[E]) ? t.props?.[E] : _[E]
        );
      else if (e.events?.has(E) || e.eventsRE?.test(E))
        d.callbacks[E] = _[E];
      else if (e.domEvents?.has(E) || e.domEventsRE?.test(E)) {
        let h = ma(E.slice(2));
        d.domCallbacks[h] = _[E], S.includes(E) ? d.el && !d.listening?.has(h) && (d.listening || (d.listening = /* @__PURE__ */ new Set()), d.listening.add(h), d.el.addEventListener(h, d.onDOMEvent)) : (d.el?.removeEventListener(h, d.onDOMEvent), d.listening?.delete(h));
      } else
        m[E] = _[E];
    return d.prevProps = S, od(
      s,
      p.createElement(lb, {
        effect: l
      }),
      yt(u) ? u?.(
        {
          ...m,
          suppressHydrationWarning: !0,
          ref: c
        },
        d.component
      ) : u
    );
  });
  return n.displayName = t.name + "Bridge", n;
}
function lb({ effect: t }) {
  return p.useEffect(t, []), null;
}
const Tl = /* @__PURE__ */ new Map();
function cb() {
  const t = {
    el: null,
    prevProps: [],
    callbacks: {},
    domCallbacks: {},
    refChangeId: -1,
    connectId: -1,
    destroyId: -1,
    attached: !1,
    forwardRef: !1,
    listening: null,
    onDOMEvent(e) {
      const n = je(e.detail) ? [e] : [e.detail, e];
      t.domCallbacks[e.type]?.(...n);
    }
  };
  return t;
}
function bl(t, e) {
  if (!(t.el === e && t.attached)) {
    if (t.attached && Br(t), t.domCallbacks) {
      t.listening || (t.listening = /* @__PURE__ */ new Set());
      for (const n of Object.keys(t.domCallbacks))
        t.listening.has(n) || (e.addEventListener(n, t.onDOMEvent), t.listening.add(n));
    }
    t.component.$$.attach(e), t.connectId = window.requestAnimationFrame(() => {
      t.component.$$.connect(), t.connectId = -1;
    }), t.attached = !0;
  }
}
function Br(t) {
  if (t.attached && (window.cancelAnimationFrame(t.connectId), t.connectId = -1, t.component.$$.detach(), t.attached = !1, t.el && t.listening)) {
    for (const e of t.listening)
      t.el.removeEventListener(e, t.onDOMEvent);
    t.listening.clear();
  }
}
function db(t) {
  let e = Tl.get(t.type), n = je(t.detail) ? [t] : [t.detail, t];
  e || Tl.set(t.type, e = `on${ab(t.type)}`), this.callbacks[e]?.(...n);
}
function Cl(t, e, n, i) {
  const r = sd(t, { props: n, scope: i });
  return r.$$[pa] = db.bind(e), r.$$.setup(), r;
}
function dd(t, e = !1) {
  const n = typeof t;
  if (n !== "string")
    return !e && n === "function" ? dd(t()) : e && n === "boolean" ? t + "" : t;
  const i = e ? '"' : "<", r = e ? "&quot;" : "&lt;";
  let a = t.indexOf(i), s = t.indexOf("&");
  if (a < 0 && s < 0) return t;
  let o = 0, l = "";
  for (; a >= 0 && s >= 0; )
    a < s ? (o < a && (l += t.substring(o, a)), l += r, o = a + 1, a = t.indexOf(i, o)) : (o < s && (l += t.substring(o, s)), l += "&amp;", o = s + 1, s = t.indexOf("&", o));
  if (a >= 0)
    do
      o < a && (l += t.substring(o, a)), l += r, o = a + 1, a = t.indexOf(i, o);
    while (a >= 0);
  else
    for (; s >= 0; )
      o < s && (l += t.substring(o, s)), l += "&amp;", o = s + 1, s = t.indexOf("&", o);
  return o < t.length ? l + t.substring(o) : l;
}
const ub = /* @__PURE__ */ Symbol(0), _b = /\s+/;
function pb(t, e) {
  const n = e.trim().split(_b);
  for (const i of n) t.add(i);
}
const mb = /\s*:\s*/, Eb = /\s*;\s*/;
function gb(t, e) {
  const n = e.trim().split(Eb);
  for (let i = 0; i < n.length; i++) {
    if (n[i] === "") continue;
    const [r, a] = n[i].split(mb);
    t.set(r, a);
  }
}
class Sb {
  keepAlive = !1;
  forwardKeepAlive = !0;
  $;
  attributes = new hb();
  style = new fb();
  classList = new Tb();
  get $props() {
    return this.$.$$.props;
  }
  get $state() {
    return this.$.$$.$state;
  }
  get state() {
    return this.$.state;
  }
  constructor(e) {
    this.$ = e;
  }
  setup() {
    const e = this.$.$$;
    Tt(() => {
      this.hasAttribute("class") && pb(this.classList.tokens, this.getAttribute("class")), this.hasAttribute("style") && gb(this.style.tokens, this.getAttribute("style")), e.setup(), e.attach(this), this.classList.length > 0 && this.setAttribute("class", this.classList.toString()), this.style.length > 0 && this.setAttribute("style", this.style.toString()), this.keepAlive && this.setAttribute("keep-alive", "");
    }, e.scope);
  }
  getAttribute(e) {
    return this.attributes.getAttribute(e);
  }
  setAttribute(e, n) {
    this.attributes.setAttribute(e, n);
  }
  hasAttribute(e) {
    return this.attributes.hasAttribute(e);
  }
  removeAttribute(e) {
    return this.attributes.removeAttribute(e);
  }
  [ub]() {
  }
  addEventListener() {
  }
  removeEventListener() {
  }
  dispatchEvent() {
    return !1;
  }
  subscribe() {
    return xt;
  }
  destroy() {
    this.$.destroy();
  }
}
class hb {
  #e = /* @__PURE__ */ new Map();
  get length() {
    return this.#e.size;
  }
  get tokens() {
    return this.#e;
  }
  getAttribute(e) {
    return this.#e.get(e) ?? null;
  }
  hasAttribute(e) {
    return this.#e.has(e);
  }
  setAttribute(e, n) {
    this.#e.set(e, n + "");
  }
  removeAttribute(e) {
    this.#e.delete(e);
  }
  toString() {
    if (this.#e.size === 0) return "";
    let e = "";
    for (const [n, i] of this.#e)
      e += ` ${n}="${dd(i, !0)}"`;
    return e;
  }
}
class fb {
  #e = /* @__PURE__ */ new Map();
  get length() {
    return this.#e.size;
  }
  get tokens() {
    return this.#e;
  }
  getPropertyValue(e) {
    return this.#e.get(e) ?? "";
  }
  setProperty(e, n) {
    this.#e.set(e, n ?? "");
  }
  removeProperty(e) {
    const n = this.#e.get(e);
    return this.#e.delete(e), n ?? "";
  }
  toString() {
    if (this.#e.size === 0) return "";
    let e = "";
    for (const [n, i] of this.#e)
      e += `${n}: ${i};`;
    return e;
  }
}
class Tb {
  #e = /* @__PURE__ */ new Set();
  get length() {
    return this.#e.size;
  }
  get tokens() {
    return this.#e;
  }
  add(...e) {
    for (const n of e)
      this.#e.add(n);
  }
  contains(e) {
    return this.#e.has(e);
  }
  remove(e) {
    this.#e.delete(e);
  }
  replace(e, n) {
    return this.#e.has(e) ? (this.#e.delete(e), this.#e.add(n), !0) : !1;
  }
  toggle(e, n) {
    return n !== !0 && (this.#e.has(e) || n === !1) ? (this.#e.delete(e), !1) : (this.#e.add(e), !0);
  }
  toString() {
    return Array.from(this.#e).join(" ");
  }
}
const bb = {
  acceptcharset: "acceptCharset",
  "accept-charset": "acceptCharset",
  accesskey: "accessKey",
  allowfullscreen: "allowFullScreen",
  autocapitalize: "autoCapitalize",
  autocomplete: "autoComplete",
  autocorrect: "autoCorrect",
  autofocus: "autoFocus",
  autoplay: "autoPlay",
  autosave: "autoSave",
  cellpadding: "cellPadding",
  cellspacing: "cellSpacing",
  charset: "charSet",
  class: "className",
  classid: "classID",
  classname: "className",
  colspan: "colSpan",
  contenteditable: "contentEditable",
  contextmenu: "contextMenu",
  controlslist: "controlsList",
  crossorigin: "crossOrigin",
  dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
  datetime: "dateTime",
  defaultchecked: "defaultChecked",
  defaultvalue: "defaultValue",
  disablepictureinpicture: "disablePictureInPicture",
  disableremoteplayback: "disableRemotePlayback",
  enctype: "encType",
  enterkeyhint: "enterKeyHint",
  fetchpriority: "fetchPriority",
  for: "htmlFor",
  formmethod: "formMethod",
  formaction: "formAction",
  formenctype: "formEncType",
  formnovalidate: "formNoValidate",
  formtarget: "formTarget",
  frameborder: "frameBorder",
  hreflang: "hrefLang",
  htmlfor: "htmlFor",
  httpequiv: "httpEquiv",
  "http-equiv": "httpEquiv",
  imagesizes: "imageSizes",
  imagesrcset: "imageSrcSet",
  innerhtml: "innerHTML",
  inputmode: "inputMode",
  itemid: "itemID",
  itemprop: "itemProp",
  itemref: "itemRef",
  itemscope: "itemScope",
  itemtype: "itemType",
  keyparams: "keyParams",
  keytype: "keyType",
  marginwidth: "marginWidth",
  marginheight: "marginHeight",
  maxlength: "maxLength",
  mediagroup: "mediaGroup",
  minlength: "minLength",
  nomodule: "noModule",
  novalidate: "noValidate",
  playsinline: "playsInline",
  radiogroup: "radioGroup",
  readonly: "readOnly",
  referrerpolicy: "referrerPolicy",
  rowspan: "rowSpan",
  spellcheck: "spellCheck",
  srcdoc: "srcDoc",
  srclang: "srcLang",
  srcset: "srcSet",
  tabindex: "tabIndex",
  usemap: "useMap"
};
function Cb(t, e) {
  function n(i) {
    let r = p.useContext(ur), a = sd(t, {
      props: i,
      scope: r.current
    }), s = new Sb(a), o = {}, { style: l = {}, children: c, forwardRef: d, ...u } = i;
    if (e.props.size)
      for (const _ of Object.keys(u))
        e.props.has(_) || (o[_] = u[_]);
    else
      o = u;
    if (s.setup(), s.hasAttribute("style")) {
      for (const [_, m] of s.style.tokens)
        l[_.startsWith("--") ? _ : zs(_)] = m;
      s.removeAttribute("style");
    }
    for (const [_, m] of s.attributes.tokens) {
      const g = bb[_];
      g && (g in o || (o[g] = m), s.removeAttribute(_));
    }
    return od(
      { current: a.$$.scope },
      yt(c) ? c?.(
        {
          ...Object.fromEntries(s.attributes.tokens),
          ...o,
          style: l
        },
        a
      ) : c,
      p.createElement(() => (s.destroy(), null))
    );
  }
  return n.displayName = t.name + "Bridge", n;
}
function Ni(t) {
  return Ws(t);
}
function ce(t, e) {
  const [, n] = p.useState();
  return p.useEffect(() => Hs(() => {
    t(), n({});
  }), [e ?? t]), t();
}
function rr(t) {
  return t ? "true" : "false";
}
function ud() {
  const t = /* @__PURE__ */ new Set();
  return {
    add(...e) {
      for (const n of e) t.add(n);
    },
    empty() {
      for (const e of t) e();
      t.clear();
    }
  };
}
function yb(t) {
  return Object.keys(t);
}
function Jr() {
  let t, e;
  return { promise: new Promise((i, r) => {
    t = i, e = r;
  }), resolve: t, reject: e };
}
function _d(t) {
  return new Promise((e) => setTimeout(e, t));
}
function Wn(t) {
  if (jt) return xt;
  let e = -1, n;
  function i(...r) {
    n = r, !(e >= 0) && (e = window.requestAnimationFrame(() => {
      t.apply(this, n), e = -1, n = void 0;
    }));
  }
  return i;
}
const Rb = jt ? xt : typeof window < "u" ? "requestIdleCallback" in window ? window.requestIdleCallback : (t) => window.setTimeout(t, 1) : xt;
function pd(t, e) {
  return jt ? Promise.resolve() : new Promise((n) => {
    Rb((i) => {
      t?.(i), n();
    }, e);
  });
}
function Ne(t, e) {
  return jt ? Cb(t, {
    props: new Set(Object.keys(t.props || {}))
  }) : ob(t, {
    props: new Set(Object.keys(t.props || {})),
    events: new Set(e?.events),
    eventsRE: e?.eventsRegex,
    domEvents: e?.domEvents,
    domEventsRE: e?.domEventsRegex
  });
}
var It = {
  fullscreenEnabled: 0,
  fullscreenElement: 1,
  requestFullscreen: 2,
  exitFullscreen: 3,
  fullscreenchange: 4,
  fullscreenerror: 5,
  fullscreen: 6
}, yl = [
  "webkitFullscreenEnabled",
  "webkitFullscreenElement",
  "webkitRequestFullscreen",
  "webkitExitFullscreen",
  "webkitfullscreenchange",
  "webkitfullscreenerror",
  "-webkit-full-screen"
], Rl = [
  "mozFullScreenEnabled",
  "mozFullScreenElement",
  "mozRequestFullScreen",
  "mozCancelFullScreen",
  "mozfullscreenchange",
  "mozfullscreenerror",
  "-moz-full-screen"
], Nl = [
  "msFullscreenEnabled",
  "msFullscreenElement",
  "msRequestFullscreen",
  "msExitFullscreen",
  "MSFullscreenChange",
  "MSFullscreenError",
  "-ms-fullscreen"
], ft = typeof window < "u" && typeof window.document < "u" ? window.document : {}, Gt = "fullscreenEnabled" in ft && Object.keys(It) || yl[0] in ft && yl || Rl[0] in ft && Rl || Nl[0] in ft && Nl || [], Rn = {
  requestFullscreen: function(t) {
    return t[Gt[It.requestFullscreen]]();
  },
  requestFullscreenFunction: function(t) {
    return t[Gt[It.requestFullscreen]];
  },
  get exitFullscreen() {
    return ft[Gt[It.exitFullscreen]].bind(ft);
  },
  get fullscreenPseudoClass() {
    return ":" + Gt[It.fullscreen];
  },
  addEventListener: function(t, e, n) {
    return ft.addEventListener(Gt[It[t]], e, n);
  },
  removeEventListener: function(t, e, n) {
    return ft.removeEventListener(Gt[It[t]], e, n);
  },
  get fullscreenEnabled() {
    return !!ft[Gt[It.fullscreenEnabled]];
  },
  set fullscreenEnabled(t) {
  },
  get fullscreenElement() {
    return ft[Gt[It.fullscreenElement]];
  },
  set fullscreenElement(t) {
  },
  get onfullscreenchange() {
    return ft[("on" + Gt[It.fullscreenchange]).toLowerCase()];
  },
  set onfullscreenchange(t) {
    return ft[("on" + Gt[It.fullscreenchange]).toLowerCase()] = t;
  },
  get onfullscreenerror() {
    return ft[("on" + Gt[It.fullscreenerror]).toLowerCase()];
  },
  set onfullscreenerror(t) {
    return ft[("on" + Gt[It.fullscreenerror]).toLowerCase()] = t;
  }
}, Oi = Nb;
function Nb(t, e, n) {
  var i = null, r = null, a = n && n.leading, s = n && n.trailing;
  a == null && (a = !0), s == null && (s = !a), a == !0 && (s = !1);
  var o = function() {
    i && (clearTimeout(i), i = null);
  }, l = function() {
    var d = r;
    o(), d && d();
  }, c = function() {
    var d = a && !i, u = this, _ = arguments;
    if (r = function() {
      return t.apply(u, _);
    }, i || (i = setTimeout(function() {
      if (i = null, s)
        return r();
    }, e)), d)
      return d = !1, r();
  };
  return c.cancel = o, c.flush = l, c;
}
var ga = Ob;
function Ob(t, e, n) {
  var i = null, r = null, a = function() {
    i && (clearTimeout(i), r = null, i = null);
  }, s = function() {
    var l = r;
    a(), l && l();
  }, o = function() {
    if (!e)
      return t.apply(this, arguments);
    var l = this, c = arguments, d = n && !i;
    if (a(), r = function() {
      t.apply(l, c);
    }, i = setTimeout(function() {
      if (i = null, !d) {
        var u = r;
        return r = null, u();
      }
    }, e), d)
      return r();
  };
  return o.cancel = a, o.flush = s, o;
}
const Ol = (t) => typeof t == "object" && t != null && t.nodeType === 1, vl = (t, e) => (!e || t !== "hidden") && t !== "visible" && t !== "clip", wr = (t, e) => {
  if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
    const n = getComputedStyle(t, null);
    return vl(n.overflowY, e) || vl(n.overflowX, e) || ((i) => {
      const r = ((a) => {
        if (!a.ownerDocument || !a.ownerDocument.defaultView) return null;
        try {
          return a.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(i);
      return !!r && (r.clientHeight < i.scrollHeight || r.clientWidth < i.scrollWidth);
    })(t);
  }
  return !1;
}, xr = (t, e, n, i, r, a, s, o) => a < t && s > e || a > t && s < e ? 0 : a <= t && o <= n || s >= e && o >= n ? a - t - i : s > e && o < n || a < t && o > n ? s - e + r : 0, vb = (t) => {
  const e = t.parentElement;
  return e ?? (t.getRootNode().host || null);
}, md = (t, e) => {
  var n, i, r, a;
  if (typeof document > "u") return [];
  const { scrollMode: s, block: o, inline: l, boundary: c, skipOverflowHiddenElements: d } = e, u = typeof c == "function" ? c : (G) => G !== c;
  if (!Ol(t)) throw new TypeError("Invalid target");
  const _ = document.scrollingElement || document.documentElement, m = [];
  let g = t;
  for (; Ol(g) && u(g); ) {
    if (g = vb(g), g === _) {
      m.push(g);
      break;
    }
    g != null && g === document.body && wr(g) && !wr(document.documentElement) || g != null && wr(g, d) && m.push(g);
  }
  const S = (i = (n = window.visualViewport) == null ? void 0 : n.width) != null ? i : innerWidth, E = (a = (r = window.visualViewport) == null ? void 0 : r.height) != null ? a : innerHeight, { scrollX: h, scrollY: T } = window, { height: b, width: C, top: y, right: O, bottom: A, left: I } = t.getBoundingClientRect(), { top: k, right: x, bottom: B, left: X } = ((G) => {
    const q = window.getComputedStyle(G);
    return { top: parseFloat(q.scrollMarginTop) || 0, right: parseFloat(q.scrollMarginRight) || 0, bottom: parseFloat(q.scrollMarginBottom) || 0, left: parseFloat(q.scrollMarginLeft) || 0 };
  })(t);
  let J = o === "start" || o === "nearest" ? y - k : o === "end" ? A + B : y + b / 2 - k + B, D = l === "center" ? I + C / 2 - X + x : l === "end" ? O + x : I - X;
  const L = [];
  for (let G = 0; G < m.length; G++) {
    const q = m[G], { height: V, width: Z, top: fe, right: _e, bottom: me, left: Me } = q.getBoundingClientRect();
    if (s === "if-needed" && y >= 0 && I >= 0 && A <= E && O <= S && (q === _ && !wr(q) || y >= fe && A <= me && I >= Me && O <= _e)) return L;
    const ke = getComputedStyle(q), tt = parseInt(ke.borderLeftWidth, 10), Ke = parseInt(ke.borderTopWidth, 10), Ue = parseInt(ke.borderRightWidth, 10), ye = parseInt(ke.borderBottomWidth, 10);
    let Fe = 0, Ce = 0;
    const Ee = "offsetWidth" in q ? q.offsetWidth - q.clientWidth - tt - Ue : 0, Y = "offsetHeight" in q ? q.offsetHeight - q.clientHeight - Ke - ye : 0, ge = "offsetWidth" in q ? q.offsetWidth === 0 ? 0 : Z / q.offsetWidth : 0, Oe = "offsetHeight" in q ? q.offsetHeight === 0 ? 0 : V / q.offsetHeight : 0;
    if (_ === q) Fe = o === "start" ? J : o === "end" ? J - E : o === "nearest" ? xr(T, T + E, E, Ke, ye, T + J, T + J + b, b) : J - E / 2, Ce = l === "start" ? D : l === "center" ? D - S / 2 : l === "end" ? D - S : xr(h, h + S, S, tt, Ue, h + D, h + D + C, C), Fe = Math.max(0, Fe + T), Ce = Math.max(0, Ce + h);
    else {
      Fe = o === "start" ? J - fe - Ke : o === "end" ? J - me + ye + Y : o === "nearest" ? xr(fe, me, V, Ke, ye + Y, J, J + b, b) : J - (fe + V / 2) + Y / 2, Ce = l === "start" ? D - Me - tt : l === "center" ? D - (Me + Z / 2) + Ee / 2 : l === "end" ? D - _e + Ue + Ee : xr(Me, _e, Z, tt, Ue + Ee, D, D + C, C);
      const { scrollLeft: Ye, scrollTop: ae } = q;
      Fe = Oe === 0 ? 0 : Math.max(0, Math.min(ae + Fe / Oe, q.scrollHeight - V / Oe + Y)), Ce = ge === 0 ? 0 : Math.max(0, Math.min(Ye + Ce / ge, q.scrollWidth - Z / ge + Ee)), J += ae - Fe, D += Ye - Ce;
    }
    L.push({ el: q, top: Fe, left: Ce });
  }
  return L;
};
var Ed = '<path fill-rule="evenodd" clip-rule="evenodd" d="M6 7C5.63181 7 5.33333 7.29848 5.33333 7.66667V14.8667C5.33333 14.9403 5.39361 14.9999 5.46724 15.0009C10.8844 15.0719 15.2614 19.449 15.3325 24.8661C15.3334 24.9397 15.393 25 15.4667 25H26C26.3682 25 26.6667 24.7015 26.6667 24.3333V7.66667C26.6667 7.29848 26.3682 7 26 7H6ZM17.0119 22.2294C17.0263 22.29 17.0802 22.3333 17.1425 22.3333H23.3333C23.7015 22.3333 24 22.0349 24 21.6667V10.3333C24 9.96514 23.7015 9.66667 23.3333 9.66667H8.66667C8.29848 9.66667 8 9.96514 8 10.3333V13.1909C8 13.2531 8.04332 13.3071 8.10392 13.3214C12.5063 14.3618 15.9715 17.827 17.0119 22.2294Z" fill="currentColor"/> <path d="M13.2 25C13.2736 25 13.3334 24.9398 13.3322 24.8661C13.2615 20.5544 9.77889 17.0718 5.46718 17.0011C5.39356 16.9999 5.33333 17.0597 5.33333 17.1333V18.8667C5.33333 18.9403 5.39348 18.9999 5.4671 19.0015C8.67465 19.0716 11.2617 21.6587 11.3319 24.8662C11.3335 24.9399 11.393 25 11.4667 25H13.2Z" fill="currentColor"/> <path d="M5.33333 21.1333C5.33333 21.0597 5.39332 20.9998 5.46692 21.0022C7.57033 21.0712 9.26217 22.763 9.33114 24.8664C9.33356 24.94 9.27364 25 9.2 25H6C5.63181 25 5.33333 24.7015 5.33333 24.3333V21.1333Z" fill="currentColor"/>', Ab = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Ed
});
const Ib = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Component: be,
  DOMEvent: Se,
  EventsController: Ae,
  EventsTarget: qs,
  Icon$24: Ed,
  State: In,
  ViewController: Ut,
  animationFrameThrottle: Wn,
  ariaBool: rr,
  camelToKebabCase: ma,
  chromecast: Ab,
  composeRefs: Pe,
  computed: yi,
  createContext: An,
  createDisposalBin: ud,
  createReactComponent: Ne,
  createScope: Si,
  deferredPromise: Jr,
  effect: N,
  fscreen: Rn,
  functionDebounce: ga,
  functionThrottle: Oi,
  getScope: ua,
  hasProvidedContext: dn,
  isArray: Et,
  isBoolean: os,
  isDOMNode: ad,
  isFunction: yt,
  isKeyboardClick: dr,
  isKeyboardEvent: zn,
  isMouseEvent: id,
  isNil: ed,
  isNull: Qt,
  isNumber: mt,
  isObject: td,
  isPointerEvent: ls,
  isString: Q,
  isTouchEvent: Xi,
  isUndefined: je,
  isWriteSignal: jc,
  kebabToCamelCase: zs,
  keysOf: yb,
  listenEvent: Ve,
  method: et,
  noop: xt,
  onDispose: ue,
  peek: F,
  prop: he,
  provideContext: en,
  r: md,
  scoped: Tt,
  setAttribute: re,
  setStyle: Xt,
  signal: j,
  tick: on,
  untrack: Ei,
  uppercaseFirstChar: Ea,
  useContext: ut,
  useReactContext: Ws,
  useReactScope: ld,
  useSignal: ce,
  useState: Ri,
  useStateContext: Ni,
  waitIdlePeriod: pd,
  waitTimeout: _d,
  wasEnterKeyPressed: rd
}, Symbol.toStringTag, { value: "Module" })), jr = Math.min, Gn = Math.max, ea = Math.round, Lr = Math.floor, ln = (t) => ({
  x: t,
  y: t
}), Db = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Al(t, e, n) {
  return Gn(t, jr(e, n));
}
function Ks(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function hi(t) {
  return t.split("-")[0];
}
function Qs(t) {
  return t.split("-")[1];
}
function gd(t) {
  return t === "x" ? "y" : "x";
}
function Sd(t) {
  return t === "y" ? "height" : "width";
}
function Bn(t) {
  const e = t[0];
  return e === "t" || e === "b" ? "y" : "x";
}
function hd(t) {
  return gd(Bn(t));
}
function Mb(t, e, n) {
  n === void 0 && (n = !1);
  const i = Qs(t), r = hd(t), a = Sd(r);
  let s = r === "x" ? i === (n ? "end" : "start") ? "right" : "left" : i === "start" ? "bottom" : "top";
  return e.reference[a] > e.floating[a] && (s = ta(s)), [s, ta(s)];
}
function wb(t) {
  const e = ta(t);
  return [cs(t), e, cs(e)];
}
function cs(t) {
  return t.includes("start") ? t.replace("start", "end") : t.replace("end", "start");
}
const Il = ["left", "right"], Dl = ["right", "left"], xb = ["top", "bottom"], Lb = ["bottom", "top"];
function Pb(t, e, n) {
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? Dl : Il : e ? Il : Dl;
    case "left":
    case "right":
      return e ? xb : Lb;
    default:
      return [];
  }
}
function kb(t, e, n, i) {
  const r = Qs(t);
  let a = Pb(hi(t), n === "start", i);
  return r && (a = a.map((s) => s + "-" + r), e && (a = a.concat(a.map(cs)))), a;
}
function ta(t) {
  const e = hi(t);
  return Db[e] + t.slice(e.length);
}
function Ub(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function Fb(t) {
  return typeof t != "number" ? Ub(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function na(t) {
  const {
    x: e,
    y: n,
    width: i,
    height: r
  } = t;
  return {
    width: i,
    height: r,
    top: n,
    left: e,
    right: e + i,
    bottom: n + r,
    x: e,
    y: n
  };
}
function Ml(t, e, n) {
  let {
    reference: i,
    floating: r
  } = t;
  const a = Bn(e), s = hd(e), o = Sd(s), l = hi(e), c = a === "y", d = i.x + i.width / 2 - r.width / 2, u = i.y + i.height / 2 - r.height / 2, _ = i[o] / 2 - r[o] / 2;
  let m;
  switch (l) {
    case "top":
      m = {
        x: d,
        y: i.y - r.height
      };
      break;
    case "bottom":
      m = {
        x: d,
        y: i.y + i.height
      };
      break;
    case "right":
      m = {
        x: i.x + i.width,
        y: u
      };
      break;
    case "left":
      m = {
        x: i.x - r.width,
        y: u
      };
      break;
    default:
      m = {
        x: i.x,
        y: i.y
      };
  }
  switch (Qs(e)) {
    case "start":
      m[s] -= _ * (n && c ? -1 : 1);
      break;
    case "end":
      m[s] += _ * (n && c ? -1 : 1);
      break;
  }
  return m;
}
async function Bb(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: i,
    y: r,
    platform: a,
    rects: s,
    elements: o,
    strategy: l
  } = t, {
    boundary: c = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: u = "floating",
    altBoundary: _ = !1,
    padding: m = 0
  } = Ks(e, t), g = Fb(m), E = o[_ ? u === "floating" ? "reference" : "floating" : u], h = na(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(E))) == null || n ? E : E.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(o.floating)),
    boundary: c,
    rootBoundary: d,
    strategy: l
  })), T = u === "floating" ? {
    x: i,
    y: r,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, b = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(o.floating)), C = await (a.isElement == null ? void 0 : a.isElement(b)) ? await (a.getScale == null ? void 0 : a.getScale(b)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, y = na(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: o,
    rect: T,
    offsetParent: b,
    strategy: l
  }) : T);
  return {
    top: (h.top - y.top + g.top) / C.y,
    bottom: (y.bottom - h.bottom + g.bottom) / C.y,
    left: (h.left - y.left + g.left) / C.x,
    right: (y.right - h.right + g.right) / C.x
  };
}
const Gb = 50, Yb = async (t, e, n) => {
  const {
    placement: i = "bottom",
    strategy: r = "absolute",
    middleware: a = [],
    platform: s
  } = n, o = s.detectOverflow ? s : {
    ...s,
    detectOverflow: Bb
  }, l = await (s.isRTL == null ? void 0 : s.isRTL(e));
  let c = await s.getElementRects({
    reference: t,
    floating: e,
    strategy: r
  }), {
    x: d,
    y: u
  } = Ml(c, i, l), _ = i, m = 0;
  const g = {};
  for (let S = 0; S < a.length; S++) {
    const E = a[S];
    if (!E)
      continue;
    const {
      name: h,
      fn: T
    } = E, {
      x: b,
      y: C,
      data: y,
      reset: O
    } = await T({
      x: d,
      y: u,
      initialPlacement: i,
      placement: _,
      strategy: r,
      middlewareData: g,
      rects: c,
      platform: o,
      elements: {
        reference: t,
        floating: e
      }
    });
    d = b ?? d, u = C ?? u, g[h] = {
      ...g[h],
      ...y
    }, O && m < Gb && (m++, typeof O == "object" && (O.placement && (_ = O.placement), O.rects && (c = O.rects === !0 ? await s.getElementRects({
      reference: t,
      floating: e,
      strategy: r
    }) : O.rects), {
      x: d,
      y: u
    } = Ml(c, _, l)), S = -1);
  }
  return {
    x: d,
    y: u,
    placement: _,
    strategy: r,
    middlewareData: g
  };
}, $b = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, i;
      const {
        placement: r,
        middlewareData: a,
        rects: s,
        initialPlacement: o,
        platform: l,
        elements: c
      } = e, {
        mainAxis: d = !0,
        crossAxis: u = !0,
        fallbackPlacements: _,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: S = !0,
        ...E
      } = Ks(t, e);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const h = hi(r), T = Bn(o), b = hi(o) === o, C = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), y = _ || (b || !S ? [ta(o)] : wb(o)), O = g !== "none";
      !_ && O && y.push(...kb(o, S, g, C));
      const A = [o, ...y], I = await l.detectOverflow(e, E), k = [];
      let x = ((i = a.flip) == null ? void 0 : i.overflows) || [];
      if (d && k.push(I[h]), u) {
        const D = Mb(r, s, C);
        k.push(I[D[0]], I[D[1]]);
      }
      if (x = [...x, {
        placement: r,
        overflows: k
      }], !k.every((D) => D <= 0)) {
        var B, X;
        const D = (((B = a.flip) == null ? void 0 : B.index) || 0) + 1, L = A[D];
        if (L && (!(u === "alignment" ? T !== Bn(L) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        x.every((V) => Bn(V.placement) === T ? V.overflows[0] > 0 : !0)))
          return {
            data: {
              index: D,
              overflows: x
            },
            reset: {
              placement: L
            }
          };
        let G = (X = x.filter((q) => q.overflows[0] <= 0).sort((q, V) => q.overflows[1] - V.overflows[1])[0]) == null ? void 0 : X.placement;
        if (!G)
          switch (m) {
            case "bestFit": {
              var J;
              const q = (J = x.filter((V) => {
                if (O) {
                  const Z = Bn(V.placement);
                  return Z === T || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  Z === "y";
                }
                return !0;
              }).map((V) => [V.placement, V.overflows.filter((Z) => Z > 0).reduce((Z, fe) => Z + fe, 0)]).sort((V, Z) => V[1] - Z[1])[0]) == null ? void 0 : J[0];
              q && (G = q);
              break;
            }
            case "initialPlacement":
              G = o;
              break;
          }
        if (r !== G)
          return {
            reset: {
              placement: G
            }
          };
      }
      return {};
    }
  };
}, Vb = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: i,
        placement: r,
        platform: a
      } = e, {
        mainAxis: s = !0,
        crossAxis: o = !1,
        limiter: l = {
          fn: (h) => {
            let {
              x: T,
              y: b
            } = h;
            return {
              x: T,
              y: b
            };
          }
        },
        ...c
      } = Ks(t, e), d = {
        x: n,
        y: i
      }, u = await a.detectOverflow(e, c), _ = Bn(hi(r)), m = gd(_);
      let g = d[m], S = d[_];
      if (s) {
        const h = m === "y" ? "top" : "left", T = m === "y" ? "bottom" : "right", b = g + u[h], C = g - u[T];
        g = Al(b, g, C);
      }
      if (o) {
        const h = _ === "y" ? "top" : "left", T = _ === "y" ? "bottom" : "right", b = S + u[h], C = S - u[T];
        S = Al(b, S, C);
      }
      const E = l.fn({
        ...e,
        [m]: g,
        [_]: S
      });
      return {
        ...E,
        data: {
          x: E.x - n,
          y: E.y - i,
          enabled: {
            [m]: s,
            [_]: o
          }
        }
      };
    }
  };
};
function Sa() {
  return typeof window < "u";
}
function vi(t) {
  return fd(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function Lt(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function un(t) {
  var e;
  return (e = (fd(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function fd(t) {
  return Sa() ? t instanceof Node || t instanceof Lt(t).Node : !1;
}
function tn(t) {
  return Sa() ? t instanceof Element || t instanceof Lt(t).Element : !1;
}
function Tn(t) {
  return Sa() ? t instanceof HTMLElement || t instanceof Lt(t).HTMLElement : !1;
}
function wl(t) {
  return !Sa() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof Lt(t).ShadowRoot;
}
function _r(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: i,
    display: r
  } = nn(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && r !== "inline" && r !== "contents";
}
function Hb(t) {
  return /^(table|td|th)$/.test(vi(t));
}
function ha(t) {
  try {
    if (t.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return t.matches(":modal");
  } catch {
    return !1;
  }
}
const qb = /transform|translate|scale|rotate|perspective|filter/, zb = /paint|layout|strict|content/, Pn = (t) => !!t && t !== "none";
let Va;
function Xs(t) {
  const e = tn(t) ? nn(t) : t;
  return Pn(e.transform) || Pn(e.translate) || Pn(e.scale) || Pn(e.rotate) || Pn(e.perspective) || !Zs() && (Pn(e.backdropFilter) || Pn(e.filter)) || qb.test(e.willChange || "") || zb.test(e.contain || "");
}
function Wb(t) {
  let e = Nn(t);
  for (; Tn(e) && !fi(e); ) {
    if (Xs(e))
      return e;
    if (ha(e))
      return null;
    e = Nn(e);
  }
  return null;
}
function Zs() {
  return Va == null && (Va = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), Va;
}
function fi(t) {
  return /^(html|body|#document)$/.test(vi(t));
}
function nn(t) {
  return Lt(t).getComputedStyle(t);
}
function fa(t) {
  return tn(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function Nn(t) {
  if (vi(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    wl(t) && t.host || // Fallback.
    un(t)
  );
  return wl(e) ? e.host : e;
}
function Td(t) {
  const e = Nn(t);
  return fi(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : Tn(e) && _r(e) ? e : Td(e);
}
function ar(t, e, n) {
  var i;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const r = Td(t), a = r === ((i = t.ownerDocument) == null ? void 0 : i.body), s = Lt(r);
  if (a) {
    const o = ds(s);
    return e.concat(s, s.visualViewport || [], _r(r) ? r : [], o && n ? ar(o) : []);
  } else
    return e.concat(r, ar(r, [], n));
}
function ds(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function bd(t) {
  const e = nn(t);
  let n = parseFloat(e.width) || 0, i = parseFloat(e.height) || 0;
  const r = Tn(t), a = r ? t.offsetWidth : n, s = r ? t.offsetHeight : i, o = ea(n) !== a || ea(i) !== s;
  return o && (n = a, i = s), {
    width: n,
    height: i,
    $: o
  };
}
function Js(t) {
  return tn(t) ? t : t.contextElement;
}
function mi(t) {
  const e = Js(t);
  if (!Tn(e))
    return ln(1);
  const n = e.getBoundingClientRect(), {
    width: i,
    height: r,
    $: a
  } = bd(e);
  let s = (a ? ea(n.width) : n.width) / i, o = (a ? ea(n.height) : n.height) / r;
  return (!s || !Number.isFinite(s)) && (s = 1), (!o || !Number.isFinite(o)) && (o = 1), {
    x: s,
    y: o
  };
}
const Kb = /* @__PURE__ */ ln(0);
function Cd(t) {
  const e = Lt(t);
  return !Zs() || !e.visualViewport ? Kb : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function Qb(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== Lt(t) ? !1 : e;
}
function $n(t, e, n, i) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const r = t.getBoundingClientRect(), a = Js(t);
  let s = ln(1);
  e && (i ? tn(i) && (s = mi(i)) : s = mi(t));
  const o = Qb(a, n, i) ? Cd(a) : ln(0);
  let l = (r.left + o.x) / s.x, c = (r.top + o.y) / s.y, d = r.width / s.x, u = r.height / s.y;
  if (a) {
    const _ = Lt(a), m = i && tn(i) ? Lt(i) : i;
    let g = _, S = ds(g);
    for (; S && i && m !== g; ) {
      const E = mi(S), h = S.getBoundingClientRect(), T = nn(S), b = h.left + (S.clientLeft + parseFloat(T.paddingLeft)) * E.x, C = h.top + (S.clientTop + parseFloat(T.paddingTop)) * E.y;
      l *= E.x, c *= E.y, d *= E.x, u *= E.y, l += b, c += C, g = Lt(S), S = ds(g);
    }
  }
  return na({
    width: d,
    height: u,
    x: l,
    y: c
  });
}
function Ta(t, e) {
  const n = fa(t).scrollLeft;
  return e ? e.left + n : $n(un(t)).left + n;
}
function yd(t, e) {
  const n = t.getBoundingClientRect(), i = n.left + e.scrollLeft - Ta(t, n), r = n.top + e.scrollTop;
  return {
    x: i,
    y: r
  };
}
function Xb(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: i,
    strategy: r
  } = t;
  const a = r === "fixed", s = un(i), o = e ? ha(e.floating) : !1;
  if (i === s || o && a)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = ln(1);
  const d = ln(0), u = Tn(i);
  if ((u || !u && !a) && ((vi(i) !== "body" || _r(s)) && (l = fa(i)), u)) {
    const m = $n(i);
    c = mi(i), d.x = m.x + i.clientLeft, d.y = m.y + i.clientTop;
  }
  const _ = s && !u && !a ? yd(s, l) : ln(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + d.x + _.x,
    y: n.y * c.y - l.scrollTop * c.y + d.y + _.y
  };
}
function Zb(t) {
  return Array.from(t.getClientRects());
}
function Jb(t) {
  const e = un(t), n = fa(t), i = t.ownerDocument.body, r = Gn(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), a = Gn(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
  let s = -n.scrollLeft + Ta(t);
  const o = -n.scrollTop;
  return nn(i).direction === "rtl" && (s += Gn(e.clientWidth, i.clientWidth) - r), {
    width: r,
    height: a,
    x: s,
    y: o
  };
}
const xl = 25;
function jb(t, e) {
  const n = Lt(t), i = un(t), r = n.visualViewport;
  let a = i.clientWidth, s = i.clientHeight, o = 0, l = 0;
  if (r) {
    a = r.width, s = r.height;
    const d = Zs();
    (!d || d && e === "fixed") && (o = r.offsetLeft, l = r.offsetTop);
  }
  const c = Ta(i);
  if (c <= 0) {
    const d = i.ownerDocument, u = d.body, _ = getComputedStyle(u), m = d.compatMode === "CSS1Compat" && parseFloat(_.marginLeft) + parseFloat(_.marginRight) || 0, g = Math.abs(i.clientWidth - u.clientWidth - m);
    g <= xl && (a -= g);
  } else c <= xl && (a += c);
  return {
    width: a,
    height: s,
    x: o,
    y: l
  };
}
function eC(t, e) {
  const n = $n(t, !0, e === "fixed"), i = n.top + t.clientTop, r = n.left + t.clientLeft, a = Tn(t) ? mi(t) : ln(1), s = t.clientWidth * a.x, o = t.clientHeight * a.y, l = r * a.x, c = i * a.y;
  return {
    width: s,
    height: o,
    x: l,
    y: c
  };
}
function Ll(t, e, n) {
  let i;
  if (e === "viewport")
    i = jb(t, n);
  else if (e === "document")
    i = Jb(un(t));
  else if (tn(e))
    i = eC(e, n);
  else {
    const r = Cd(t);
    i = {
      x: e.x - r.x,
      y: e.y - r.y,
      width: e.width,
      height: e.height
    };
  }
  return na(i);
}
function Rd(t, e) {
  const n = Nn(t);
  return n === e || !tn(n) || fi(n) ? !1 : nn(n).position === "fixed" || Rd(n, e);
}
function tC(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let i = ar(t, [], !1).filter((o) => tn(o) && vi(o) !== "body"), r = null;
  const a = nn(t).position === "fixed";
  let s = a ? Nn(t) : t;
  for (; tn(s) && !fi(s); ) {
    const o = nn(s), l = Xs(s);
    !l && o.position === "fixed" && (r = null), (a ? !l && !r : !l && o.position === "static" && !!r && (r.position === "absolute" || r.position === "fixed") || _r(s) && !l && Rd(t, s)) ? i = i.filter((d) => d !== s) : r = o, s = Nn(s);
  }
  return e.set(t, i), i;
}
function nC(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: i,
    strategy: r
  } = t;
  const s = [...n === "clippingAncestors" ? ha(e) ? [] : tC(e, this._c) : [].concat(n), i], o = Ll(e, s[0], r);
  let l = o.top, c = o.right, d = o.bottom, u = o.left;
  for (let _ = 1; _ < s.length; _++) {
    const m = Ll(e, s[_], r);
    l = Gn(m.top, l), c = jr(m.right, c), d = jr(m.bottom, d), u = Gn(m.left, u);
  }
  return {
    width: c - u,
    height: d - l,
    x: u,
    y: l
  };
}
function iC(t) {
  const {
    width: e,
    height: n
  } = bd(t);
  return {
    width: e,
    height: n
  };
}
function rC(t, e, n) {
  const i = Tn(e), r = un(e), a = n === "fixed", s = $n(t, !0, a, e);
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = ln(0);
  function c() {
    l.x = Ta(r);
  }
  if (i || !i && !a)
    if ((vi(e) !== "body" || _r(r)) && (o = fa(e)), i) {
      const m = $n(e, !0, a, e);
      l.x = m.x + e.clientLeft, l.y = m.y + e.clientTop;
    } else r && c();
  a && !i && r && c();
  const d = r && !i && !a ? yd(r, o) : ln(0), u = s.left + o.scrollLeft - l.x - d.x, _ = s.top + o.scrollTop - l.y - d.y;
  return {
    x: u,
    y: _,
    width: s.width,
    height: s.height
  };
}
function Ha(t) {
  return nn(t).position === "static";
}
function Pl(t, e) {
  if (!Tn(t) || nn(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let n = t.offsetParent;
  return un(t) === n && (n = n.ownerDocument.body), n;
}
function Nd(t, e) {
  const n = Lt(t);
  if (ha(t))
    return n;
  if (!Tn(t)) {
    let r = Nn(t);
    for (; r && !fi(r); ) {
      if (tn(r) && !Ha(r))
        return r;
      r = Nn(r);
    }
    return n;
  }
  let i = Pl(t, e);
  for (; i && Hb(i) && Ha(i); )
    i = Pl(i, e);
  return i && fi(i) && Ha(i) && !Xs(i) ? n : i || Wb(t) || n;
}
const aC = async function(t) {
  const e = this.getOffsetParent || Nd, n = this.getDimensions, i = await n(t.floating);
  return {
    reference: rC(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: i.width,
      height: i.height
    }
  };
};
function sC(t) {
  return nn(t).direction === "rtl";
}
const oC = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Xb,
  getDocumentElement: un,
  getClippingRect: nC,
  getOffsetParent: Nd,
  getElementRects: aC,
  getClientRects: Zb,
  getDimensions: iC,
  getScale: mi,
  isElement: tn,
  isRTL: sC
};
function Od(t, e) {
  return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
}
function lC(t, e) {
  let n = null, i;
  const r = un(t);
  function a() {
    var o;
    clearTimeout(i), (o = n) == null || o.disconnect(), n = null;
  }
  function s(o, l) {
    o === void 0 && (o = !1), l === void 0 && (l = 1), a();
    const c = t.getBoundingClientRect(), {
      left: d,
      top: u,
      width: _,
      height: m
    } = c;
    if (o || e(), !_ || !m)
      return;
    const g = Lr(u), S = Lr(r.clientWidth - (d + _)), E = Lr(r.clientHeight - (u + m)), h = Lr(d), b = {
      rootMargin: -g + "px " + -S + "px " + -E + "px " + -h + "px",
      threshold: Gn(0, jr(1, l)) || 1
    };
    let C = !0;
    function y(O) {
      const A = O[0].intersectionRatio;
      if (A !== l) {
        if (!C)
          return s();
        A ? s(!1, A) : i = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      A === 1 && !Od(c, t.getBoundingClientRect()) && s(), C = !1;
    }
    try {
      n = new IntersectionObserver(y, {
        ...b,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(y, b);
    }
    n.observe(t);
  }
  return s(!0), a;
}
function cC(t, e, n, i) {
  i === void 0 && (i = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: a = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: o = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = i, c = Js(t), d = r || a ? [...c ? ar(c) : [], ...e ? ar(e) : []] : [];
  d.forEach((h) => {
    r && h.addEventListener("scroll", n, {
      passive: !0
    }), a && h.addEventListener("resize", n);
  });
  const u = c && o ? lC(c, n) : null;
  let _ = -1, m = null;
  s && (m = new ResizeObserver((h) => {
    let [T] = h;
    T && T.target === c && m && e && (m.unobserve(e), cancelAnimationFrame(_), _ = requestAnimationFrame(() => {
      var b;
      (b = m) == null || b.observe(e);
    })), n();
  }), c && !l && m.observe(c), e && m.observe(e));
  let g, S = l ? $n(t) : null;
  l && E();
  function E() {
    const h = $n(t);
    S && !Od(S, h) && n(), S = h, g = requestAnimationFrame(E);
  }
  return n(), () => {
    var h;
    d.forEach((T) => {
      r && T.removeEventListener("scroll", n), a && T.removeEventListener("resize", n);
    }), u?.(), (h = m) == null || h.disconnect(), m = null, l && cancelAnimationFrame(g);
  };
}
const dC = Vb, uC = $b, _C = (t, e, n) => {
  const i = /* @__PURE__ */ new Map(), r = {
    platform: oC,
    ...n
  }, a = {
    ...r.platform,
    _c: i
  };
  return Yb(t, e, {
    ...r,
    platform: a
  });
};
function us(t) {
  return !Q(t) && "width" in t && "height" in t && mt(t.width) && mt(t.height);
}
const H = typeof document > "u", pC = H ? "" : navigator?.userAgent.toLowerCase() || "", js = !H && /iphone|ipad|ipod|ios|crios|fxios/i.test(pC), vd = !H && /(iphone|ipod)/gi.test(navigator?.platform || ""), Ad = !H && !!window.chrome, ia = !H && (!!window.safari || js);
function Id() {
  return mC() && yt(screen.orientation.unlock);
}
function mC() {
  return !H && !je(window.screen.orientation) && !je(window.screen.orientation.lock);
}
function Dd(t, e) {
  return H ? !1 : (t || (t = document.createElement("audio")), t.canPlayType(e).length > 0);
}
function Md(t, e) {
  return H ? !1 : (t || (t = document.createElement("video")), t.canPlayType(e).length > 0);
}
function wd(t) {
  return H ? !1 : (t || (t = document.createElement("video")), t.canPlayType("application/vnd.apple.mpegurl").length > 0);
}
function xd(t) {
  return H ? !1 : !!document.pictureInPictureEnabled && !t?.disablePictureInPicture;
}
function Ld(t) {
  return H ? !1 : yt(t?.webkitSupportsPresentationMode) && yt(t?.webkitSetPresentationMode);
}
async function EC() {
  const t = document.createElement("video");
  return t.volume = 0.5, await _d(0), t.volume === 0.5;
}
function gC() {
  return H ? void 0 : window?.ManagedMediaSource ?? window?.MediaSource ?? window?.WebKitMediaSource;
}
function SC() {
  return H ? void 0 : window?.SourceBuffer ?? window?.WebKitSourceBuffer;
}
function eo() {
  if (H) return !1;
  const t = gC();
  if (je(t)) return !1;
  const e = t && yt(t.isTypeSupported) && t.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'), n = SC(), i = je(n) || !je(n.prototype) && yt(n.prototype.appendBuffer) && yt(n.prototype.remove);
  return !!e && !!i;
}
function Pd() {
  return eo();
}
class Gr {
  #e;
  get length() {
    return this.#e.length;
  }
  constructor(e, n) {
    Et(e) ? this.#e = e : !je(e) && !je(n) ? this.#e = [[e, n]] : this.#e = [];
  }
  start(e) {
    return this.#e[e][0] ?? 1 / 0;
  }
  end(e) {
    return this.#e[e][1] ?? 1 / 0;
  }
}
function kl(t) {
  if (!t.length) return null;
  let e = t.start(0);
  for (let n = 1; n < t.length; n++) {
    const i = t.start(n);
    i < e && (e = i);
  }
  return e;
}
function Fn(t) {
  if (!t.length) return null;
  let e = t.end(0);
  for (let n = 1; n < t.length; n++) {
    const i = t.end(n);
    i > e && (e = i);
  }
  return e;
}
function hC(t) {
  if (t.length <= 1)
    return t;
  t.sort((i, r) => i[0] - r[0]);
  let e = [], n = t[0];
  for (let i = 1; i < t.length; i++) {
    const r = t[i];
    n[1] >= r[0] - 1 ? n = [n[0], Math.max(n[1], r[1])] : (e.push(n), n = r);
  }
  return e.push(n), e;
}
function fC(t, e, n) {
  let i = e[0], r = e[1];
  return n < i ? [n, -1] : n === i ? e : i === -1 ? (e[0] = n, e) : (n > i && (e[1] = n, r === -1 && t.push(e)), hC(t), e);
}
const TC = /\.(m4a|m4b|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx|flac)($|\?)/i, bC = /* @__PURE__ */ new Set([
  "audio/mpeg",
  "audio/ogg",
  "audio/3gp",
  "audio/mp3",
  "audio/webm",
  "audio/flac",
  "audio/m4a",
  "audio/m4b",
  "audio/mp4a",
  "audio/mp4"
]), CC = /\.(mp4|og[gv]|webm|mov|m4v)(#t=[,\d+]+)?($|\?)/i, yC = /* @__PURE__ */ new Set([
  "video/mp4",
  "video/webm",
  "video/3gp",
  "video/ogg",
  "video/avi",
  "video/mpeg"
]), RC = /\.(m3u8)($|\?)/i, NC = /\.(mpd)($|\?)/i, OC = /* @__PURE__ */ new Set([
  // Apple sanctioned
  "application/vnd.apple.mpegurl",
  // Apple sanctioned for backwards compatibility
  "audio/mpegurl",
  // Very common
  "audio/x-mpegurl",
  // Very common
  "application/x-mpegurl",
  // Included for completeness
  "video/x-mpegurl",
  "video/mpegurl",
  "application/mpegurl"
]), vC = /* @__PURE__ */ new Set(["application/dash+xml"]);
function to({ src: t, type: e }) {
  return Q(t) ? TC.test(t) || bC.has(e) || t.startsWith("blob:") && e === "audio/object" : e === "audio/object";
}
function no(t) {
  return Q(t.src) ? CC.test(t.src) || yC.has(t.type) || t.src.startsWith("blob:") && t.type === "video/object" || Ai(t) && (H || wd()) : t.type === "video/object";
}
function Ai({ src: t, type: e }) {
  return Q(t) && RC.test(t) || OC.has(e);
}
function io({ src: t, type: e }) {
  return Q(t) && NC.test(t) || vC.has(e);
}
function AC(t) {
  return Q(t.src) && (to(t) || no(t) || Ai(t));
}
function IC(t) {
  return !H && typeof window.MediaStream < "u" && t instanceof window.MediaStream;
}
function hA(t, e) {
  const n = new URL(t);
  for (const i of Object.keys(e))
    n.searchParams.set(i, e[i] + "");
  return n.toString();
}
function Ii(t, e = "preconnect") {
  if (H) return !1;
  const n = document.querySelector(`link[href="${t}"]`);
  if (!Qt(n)) return !0;
  const i = document.createElement("link");
  return i.rel = e, i.href = t, i.crossOrigin = "true", document.head.append(i), !0;
}
const Hi = {};
function DC(t) {
  if (Hi[t]) return Hi[t].promise;
  const e = Jr(), n = document.querySelector(`script[src="${t}"]`);
  if (!Qt(n))
    return e.resolve(), e.promise;
  Hi[t] = e;
  const i = document.createElement("script");
  return i.src = t, i.onload = () => {
    e.resolve(), delete Hi[t];
  }, i.onerror = () => {
    e.reject(), delete Hi[t];
  }, setTimeout(() => document.head.append(i), 0), e.promise;
}
function Ji(t) {
  return t === "use-credentials" ? "include" : Q(t) ? "same-origin" : void 0;
}
function MC({
  title: t,
  src: e,
  download: n
}) {
  const i = os(n) || n === "" ? e.src : Q(n) ? n : n?.url;
  return wC({ url: i, src: e, download: n }) ? {
    url: i,
    name: !os(n) && !Q(n) && n?.filename || t.toLowerCase() || "media"
  } : null;
}
function wC({
  url: t,
  src: e,
  download: n
}) {
  return Q(t) && (n && n !== !0 || to(e) || no(e));
}
const xC = /* @__PURE__ */ Symbol(0), LC = /* @__PURE__ */ Symbol(0), PC = /* @__PURE__ */ Symbol(0), kC = /* @__PURE__ */ Symbol(0), UC = /* @__PURE__ */ Symbol(0), FC = /* @__PURE__ */ Symbol(0), BC = /* @__PURE__ */ Symbol(0), ie = {
  crossOrigin: xC,
  readyState: LC,
  updateActiveCues: PC,
  canLoad: kC,
  onModeChange: UC,
  native: FC,
  nativeHLS: BC
};
function Ul(t, e) {
  return e >= t.startTime && e < t.endTime;
}
function kd(t, e, n) {
  let i = null, r = ua();
  function a() {
    const s = Q(e) ? [e] : e, o = t.toArray().find((l) => s.includes(l.kind) && l.mode === "showing");
    if (o !== i) {
      if (!o) {
        n(null), i = null;
        return;
      }
      o.readyState == 2 ? n(o) : (n(null), Tt(() => {
        const l = Ve(
          o,
          "load",
          () => {
            n(o), l();
          },
          { once: !0 }
        );
      }, r)), i = o;
    }
  }
  return a(), Ve(t, "mode-change", a);
}
class Vn extends qs {
  static createId(e) {
    return `vds-${e.type}-${e.kind}-${e.src ?? e.label ?? "?"}`;
  }
  src;
  content;
  type;
  encoding;
  id = "";
  label = "";
  language = "";
  kind;
  default = !1;
  #e = !1;
  #t = 0;
  #n = "disabled";
  #i = {};
  #r = [];
  #a = [];
  #s = [];
  /** @internal */
  [ie.readyState] = 0;
  /** @internal */
  [ie.crossOrigin];
  /** @internal */
  [ie.onModeChange] = null;
  /** @internal */
  [ie.native] = null;
  get metadata() {
    return this.#i;
  }
  get regions() {
    return this.#r;
  }
  get cues() {
    return this.#a;
  }
  get activeCues() {
    return this.#s;
  }
  /**
   * - 0: Not Loading
   * - 1: Loading
   * - 2: Ready
   * - 3: Error
   */
  get readyState() {
    return this[ie.readyState];
  }
  get mode() {
    return this.#n;
  }
  set mode(e) {
    this.setMode(e);
  }
  constructor(e) {
    super();
    for (const n of Object.keys(e)) this[n] = e[n];
    this.type || (this.type = "vtt"), !H && e.content ? this.#l(e) : e.src || (this[ie.readyState] = 2);
  }
  addCue(e, n) {
    let i = 0, r = this.#a.length;
    for (i = 0; i < r && !(e.endTime <= this.#a[i].startTime); i++) ;
    i === r ? this.#a.push(e) : this.#a.splice(i, 0, e), e instanceof TextTrackCue || this[ie.native]?.track.addCue(e), this.dispatchEvent(new Se("add-cue", { detail: e, trigger: n })), Ul(e, this.#t) && this[ie.updateActiveCues](this.#t, n);
  }
  removeCue(e, n) {
    const i = this.#a.indexOf(e);
    if (i >= 0) {
      const r = this.#s.includes(e);
      this.#a.splice(i, 1), this[ie.native]?.track.removeCue(e), this.dispatchEvent(new Se("remove-cue", { detail: e, trigger: n })), r && this[ie.updateActiveCues](this.#t, n);
    }
  }
  setMode(e, n) {
    this.#n !== e && (this.#n = e, e === "disabled" ? (this.#s = [], this.#d()) : this.readyState === 2 ? this[ie.updateActiveCues](this.#t, n) : this.#o(), this.dispatchEvent(new Se("mode-change", { detail: this, trigger: n })), this[ie.onModeChange]?.());
  }
  /** @internal */
  [ie.updateActiveCues](e, n) {
    if (this.#t = e, this.mode === "disabled" || !this.#a.length) return;
    const i = [];
    for (let a = 0, s = this.#a.length; a < s; a++) {
      const o = this.#a[a];
      Ul(o, e) && i.push(o);
    }
    let r = i.length !== this.#s.length;
    if (!r) {
      for (let a = 0; a < i.length; a++)
        if (!this.#s.includes(i[a])) {
          r = !0;
          break;
        }
    }
    this.#s = i, r && this.#d(n);
  }
  /** @internal */
  [ie.canLoad]() {
    this.#e = !0, this.#n !== "disabled" && this.#o();
  }
  #l(e) {
    import("./prod-BQ6GYK89.js").then((n) => n.d).then(({ parseText: n, VTTCue: i, VTTRegion: r }) => {
      !Q(e.content) || e.type === "json" ? (this.#u(e.content, i, r), this.readyState !== 3 && this.#c()) : n(e.content, { type: e.type }).then(({ cues: a, regions: s }) => {
        this.#a = a, this.#r = s, this.#c();
      });
    });
  }
  async #o() {
    if (!(!this.#e || this[ie.readyState] > 0)) {
      if (this[ie.readyState] = 1, this.dispatchEvent(new Se("load-start")), !this.src) {
        this.#c();
        return;
      }
      try {
        const { parseResponse: e, VTTCue: n, VTTRegion: i } = await import("./prod-BQ6GYK89.js").then((s) => s.d), r = this[ie.crossOrigin]?.(), a = fetch(this.src, {
          headers: this.type === "json" ? { "Content-Type": "application/json" } : void 0,
          credentials: Ji(r)
        });
        if (this.type === "json")
          this.#u(await (await a).text(), n, i);
        else {
          const { errors: s, metadata: o, regions: l, cues: c } = await e(a, {
            type: this.type,
            encoding: this.encoding
          });
          if (s[0]?.code === 0)
            throw s[0];
          this.#i = o, this.#r = l, this.#a = c;
        }
        this.#c();
      } catch (e) {
        this.#_(e);
      }
    }
  }
  #c() {
    if (this[ie.readyState] = 2, !this.src || this.type !== "vtt") {
      const n = this[ie.native];
      if (n && !n.managed)
        for (const i of this.#a) n.track.addCue(i);
    }
    const e = new Se("load");
    this[ie.updateActiveCues](this.#t, e), this.dispatchEvent(e);
  }
  #_(e) {
    this[ie.readyState] = 3, this.dispatchEvent(new Se("error", { detail: e }));
  }
  #u(e, n, i) {
    try {
      const { regions: r, cues: a } = YC(e, n, i);
      this.#r = r, this.#a = a;
    } catch (r) {
      this.#_(r);
    }
  }
  #d(e) {
    this.dispatchEvent(new Se("cue-change", { trigger: e }));
  }
}
const GC = /captions|subtitles/;
function bt(t) {
  return GC.test(t.kind);
}
function YC(t, e, n) {
  const i = Q(t) ? JSON.parse(t) : t;
  let r = [], a = [];
  return i.regions && n && (r = i.regions.map((s) => Object.assign(new n(), s))), (i.cues || Et(i)) && (a = (Et(i) ? i : i.cues).filter((s) => mt(s.startTime) && mt(s.endTime)).map((s) => Object.assign(new e(0, 0, ""), s))), { regions: r, cues: a };
}
const pr = new In({
  artist: "",
  artwork: null,
  audioTrack: null,
  audioTracks: [],
  autoPlay: !1,
  autoPlayError: null,
  audioGain: null,
  buffered: new Gr(),
  canLoad: !1,
  canLoadPoster: !1,
  canFullscreen: !1,
  canOrientScreen: Id(),
  canPictureInPicture: !1,
  canPlay: !1,
  clipStartTime: 0,
  clipEndTime: 0,
  controls: !1,
  get iOSControls() {
    return vd && this.mediaType === "video" && (!this.playsInline || !Rn.fullscreenEnabled && this.fullscreen);
  },
  get nativeControls() {
    return this.controls || this.iOSControls;
  },
  controlsVisible: !1,
  get controlsHidden() {
    return !this.controlsVisible;
  },
  crossOrigin: null,
  ended: !1,
  error: null,
  fullscreen: !1,
  get loop() {
    return this.providedLoop || this.userPrefersLoop;
  },
  logLevel: "silent",
  mediaType: "unknown",
  muted: !1,
  paused: !0,
  played: new Gr(),
  playing: !1,
  playsInline: !1,
  pictureInPicture: !1,
  preload: "metadata",
  playbackRate: 1,
  qualities: [],
  quality: null,
  autoQuality: !1,
  canSetQuality: !0,
  canSetPlaybackRate: !0,
  canSetVolume: !1,
  canSetAudioGain: !1,
  seekable: new Gr(),
  seeking: !1,
  source: { src: "", type: "" },
  sources: [],
  started: !1,
  textTracks: [],
  textTrack: null,
  get hasCaptions() {
    return this.textTracks.filter(bt).length > 0;
  },
  volume: 1,
  waiting: !1,
  realCurrentTime: 0,
  get currentTime() {
    return this.ended ? this.duration : this.clipStartTime > 0 ? Math.max(0, Math.min(this.realCurrentTime - this.clipStartTime, this.duration)) : this.realCurrentTime;
  },
  providedDuration: -1,
  intrinsicDuration: 0,
  get duration() {
    return this.seekableWindow;
  },
  get title() {
    return this.providedTitle || this.inferredTitle;
  },
  get poster() {
    return this.providedPoster || this.inferredPoster;
  },
  get viewType() {
    return this.providedViewType !== "unknown" ? this.providedViewType : this.inferredViewType;
  },
  get streamType() {
    return this.providedStreamType !== "unknown" ? this.providedStreamType : this.inferredStreamType;
  },
  get currentSrc() {
    return this.source;
  },
  get bufferedStart() {
    const t = kl(this.buffered) ?? 0;
    return Math.max(t, this.clipStartTime);
  },
  get bufferedEnd() {
    const t = Fn(this.buffered) ?? 0;
    return Math.min(this.seekableEnd, Math.max(0, t - this.clipStartTime));
  },
  get bufferedWindow() {
    return Math.max(0, this.bufferedEnd - this.bufferedStart);
  },
  get seekableStart() {
    if (this.isLiveDVR && this.liveDVRWindow > 0)
      return Math.max(0, this.seekableEnd - this.liveDVRWindow);
    const t = kl(this.seekable) ?? 0;
    return Math.max(t, this.clipStartTime);
  },
  get seekableEnd() {
    if (this.providedDuration > 0) return this.providedDuration;
    const t = this.liveSyncPosition > 0 ? this.liveSyncPosition : this.canPlay ? Fn(this.seekable) ?? 1 / 0 : 0;
    return this.clipEndTime > 0 ? Math.min(this.clipEndTime, t) : t;
  },
  get seekableWindow() {
    const t = this.seekableEnd - this.seekableStart;
    return isNaN(t) ? 1 / 0 : Math.max(0, t);
  },
  // ~~ remote playback ~~
  canAirPlay: !1,
  canGoogleCast: !1,
  remotePlaybackState: "disconnected",
  remotePlaybackType: "none",
  remotePlaybackLoader: null,
  remotePlaybackInfo: null,
  get isAirPlayConnected() {
    return this.remotePlaybackType === "airplay" && this.remotePlaybackState === "connected";
  },
  get isGoogleCastConnected() {
    return this.remotePlaybackType === "google-cast" && this.remotePlaybackState === "connected";
  },
  // ~~ responsive design ~~
  pointer: "fine",
  orientation: "landscape",
  width: 0,
  height: 0,
  mediaWidth: 0,
  mediaHeight: 0,
  lastKeyboardAction: null,
  // ~~ user props ~~
  userBehindLiveEdge: !1,
  // ~~ live props ~~
  liveEdgeTolerance: 10,
  minLiveDVRWindow: 60,
  get canSeek() {
    return /unknown|on-demand|:dvr/.test(this.streamType) && Number.isFinite(this.duration) && (!this.isLiveDVR || this.duration >= this.liveDVRWindow);
  },
  get live() {
    return this.streamType.includes("live") || !Number.isFinite(this.duration);
  },
  get liveEdgeStart() {
    return this.live && Number.isFinite(this.seekableEnd) ? Math.max(0, this.seekableEnd - this.liveEdgeTolerance) : 0;
  },
  get liveEdge() {
    return this.live && (!this.canSeek || !this.userBehindLiveEdge && this.currentTime >= this.liveEdgeStart);
  },
  get liveEdgeWindow() {
    return this.live && Number.isFinite(this.seekableEnd) ? this.seekableEnd - this.liveEdgeStart : 0;
  },
  get isLiveDVR() {
    return /:dvr/.test(this.streamType);
  },
  get liveDVRWindow() {
    return Math.max(this.inferredLiveDVRWindow, this.minLiveDVRWindow);
  },
  // ~~ internal props ~~
  autoPlaying: !1,
  providedTitle: "",
  inferredTitle: "",
  providedLoop: !1,
  userPrefersLoop: !1,
  providedPoster: "",
  inferredPoster: "",
  inferredViewType: "unknown",
  providedViewType: "unknown",
  providedStreamType: "unknown",
  inferredStreamType: "unknown",
  liveSyncPosition: null,
  inferredLiveDVRWindow: 0,
  savedState: null
}), Ud = /* @__PURE__ */ new Set([
  "autoPlayError",
  "autoPlaying",
  "buffered",
  "canPlay",
  "error",
  "paused",
  "played",
  "playing",
  "seekable",
  "seeking",
  "waiting"
]), $C = /* @__PURE__ */ new Set([
  ...Ud,
  "ended",
  "inferredPoster",
  "inferredStreamType",
  "inferredTitle",
  "intrinsicDuration",
  "inferredLiveDVRWindow",
  "liveSyncPosition",
  "realCurrentTime",
  "savedState",
  "started",
  "userBehindLiveEdge"
]);
function Fl(t, e = !1) {
  const n = e ? Ud : $C;
  pr.reset(t, (i) => n.has(i)), on();
}
function Fd(t, e) {
  const n = t + e.clipStartTime(), i = Math.floor(t) === Math.floor(e.seekableStart()), r = Math.floor(n) === Math.floor(e.seekableEnd());
  return i ? e.seekableStart() : r ? e.seekableEnd() : e.isLiveDVR() && e.liveDVRWindow() > 0 && n < e.seekableEnd() - e.liveDVRWindow() ? e.bufferedStart() : Math.min(Math.max(e.seekableStart() + 0.1, n), e.seekableEnd() - 0.1);
}
const ro = An();
function Ge() {
  return ut(ro);
}
class Bd {
  #e = null;
  #t = null;
  #n = -1;
  #i;
  constructor(e = void 0) {
    this.#i = e;
  }
  /**
   * Set the target from which to dispatch media requests events from. The events should bubble
   * up from this target to the player element.
   *
   * @example
   * ```ts
   * const button = document.querySelector('button');
   * remote.setTarget(button);
   * ```
   */
  setTarget(e) {
    this.#e = e;
  }
  /**
   * Returns the current player element. This method will attempt to find the player by
   * searching up from either the given `target` or default target set via `remote.setTarget`.
   *
   * @example
   * ```ts
   * const player = remote.getPlayer();
   * ```
   */
  getPlayer(e) {
    return this.#t ? this.#t : ((e ?? this.#e)?.dispatchEvent(
      new Se("find-media-player", {
        detail: (n) => {
          this.#t = n;
        },
        bubbles: !0,
        composed: !0
      })
    ), this.#t);
  }
  /**
   * Set the current player element so the remote can support toggle methods such as
   * `togglePaused` as they rely on the current media state.
   */
  setPlayer(e) {
    this.#t = e;
  }
  /**
   * Dispatch a request to start the media loading process. This will only work if the media
   * player has been initialized with a custom loading strategy `load="custom">`.
   *
   * @docs {@link https://www.vidstack.io/docs/player/core-concepts/loading#load-strategies}
   */
  startLoading(e) {
    this.#r("media-start-loading", e);
  }
  /**
   * Dispatch a request to start the poster loading process. This will only work if the media
   * player has been initialized with a custom poster loading strategy `posterLoad="custom">`.
   *
   * @docs {@link https://www.vidstack.io/docs/player/core-concepts/loading#load-strategies}
   */
  startLoadingPoster(e) {
    this.#r("media-poster-start-loading", e);
  }
  /**
   * Dispatch a request to connect to AirPlay.
   *
   * @see {@link https://www.apple.com/au/airplay}
   */
  requestAirPlay(e) {
    this.#r("media-airplay-request", e);
  }
  /**
   * Dispatch a request to connect to Google Cast.
   *
   * @see {@link https://developers.google.com/cast/docs/overview}
   */
  requestGoogleCast(e) {
    this.#r("media-google-cast-request", e);
  }
  /**
   * Dispatch a request to begin/resume media playback.
   */
  play(e) {
    this.#r("media-play-request", e);
  }
  /**
   * Dispatch a request to pause media playback.
   */
  pause(e) {
    this.#r("media-pause-request", e);
  }
  /**
   * Dispatch a request to set the media volume to mute (0).
   */
  mute(e) {
    this.#r("media-mute-request", e);
  }
  /**
   * Dispatch a request to unmute the media volume and set it back to it's previous state.
   */
  unmute(e) {
    this.#r("media-unmute-request", e);
  }
  /**
   * Dispatch a request to enter fullscreen.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/fullscreen#remote-control}
   */
  enterFullscreen(e, n) {
    this.#r("media-enter-fullscreen-request", n, e);
  }
  /**
   * Dispatch a request to exit fullscreen.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/fullscreen#remote-control}
   */
  exitFullscreen(e, n) {
    this.#r("media-exit-fullscreen-request", n, e);
  }
  /**
   * Dispatch a request to lock the screen orientation.
   *
   * @docs {@link https://www.vidstack.io/docs/player/screen-orientation#remote-control}
   */
  lockScreenOrientation(e, n) {
    this.#r("media-orientation-lock-request", n, e);
  }
  /**
   * Dispatch a request to unlock the screen orientation.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/screen-orientation#remote-control}
   */
  unlockScreenOrientation(e) {
    this.#r("media-orientation-unlock-request", e);
  }
  /**
   * Dispatch a request to enter picture-in-picture mode.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/picture-in-picture#remote-control}
   */
  enterPictureInPicture(e) {
    this.#r("media-enter-pip-request", e);
  }
  /**
   * Dispatch a request to exit picture-in-picture mode.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/picture-in-picture#remote-control}
   */
  exitPictureInPicture(e) {
    this.#r("media-exit-pip-request", e);
  }
  /**
   * Notify the media player that a seeking process is happening and to seek to the given `time`.
   */
  seeking(e, n) {
    this.#r("media-seeking-request", n, e);
  }
  /**
   * Notify the media player that a seeking operation has completed and to seek to the given `time`.
   * This is generally called after a series of `remote.seeking()` calls.
   */
  seek(e, n) {
    this.#r("media-seek-request", n, e);
  }
  seekToLiveEdge(e) {
    this.#r("media-live-edge-request", e);
  }
  /**
   * Dispatch a request to update the length of the media in seconds.
   *
   * @example
   * ```ts
   * remote.changeDuration(100); // 100 seconds
   * ```
   */
  changeDuration(e, n) {
    this.#r("media-duration-change-request", n, e);
  }
  /**
   * Dispatch a request to update the clip start time. This is the time at which media playback
   * should start at.
   *
   * @example
   * ```ts
   * remote.changeClipStart(100); // start at 100 seconds
   * ```
   */
  changeClipStart(e, n) {
    this.#r("media-clip-start-change-request", n, e);
  }
  /**
   * Dispatch a request to update the clip end time. This is the time at which media playback
   * should end at.
   *
   * @example
   * ```ts
   * remote.changeClipEnd(100); // end at 100 seconds
   * ```
   */
  changeClipEnd(e, n) {
    this.#r("media-clip-end-change-request", n, e);
  }
  /**
   * Dispatch a request to update the media volume to the given `volume` level which is a value
   * between 0 and 1.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/audio-gain#remote-control}
   * @example
   * ```ts
   * remote.changeVolume(0); // 0%
   * remote.changeVolume(0.05); // 5%
   * remote.changeVolume(0.5); // 50%
   * remote.changeVolume(0.75); // 70%
   * remote.changeVolume(1); // 100%
   * ```
   */
  changeVolume(e, n) {
    this.#r("media-volume-change-request", n, Math.max(0, Math.min(1, e)));
  }
  /**
   * Dispatch a request to change the current audio track.
   *
   * @example
   * ```ts
   * remote.changeAudioTrack(1); // track at index 1
   * ```
   */
  changeAudioTrack(e, n) {
    this.#r("media-audio-track-change-request", n, e);
  }
  /**
   * Dispatch a request to change the video quality. The special value `-1` represents auto quality
   * selection.
   *
   * @example
   * ```ts
   * remote.changeQuality(-1); // auto
   * remote.changeQuality(1); // quality at index 1
   * ```
   */
  changeQuality(e, n) {
    this.#r("media-quality-change-request", n, e);
  }
  /**
   * Request auto quality selection.
   */
  requestAutoQuality(e) {
    this.changeQuality(-1, e);
  }
  /**
   * Dispatch a request to change the mode of the text track at the given index.
   *
   * @example
   * ```ts
   * remote.changeTextTrackMode(1, 'showing'); // track at index 1
   * ```
   */
  changeTextTrackMode(e, n, i) {
    this.#r("media-text-track-change-request", i, {
      index: e,
      mode: n
    });
  }
  /**
   * Dispatch a request to change the media playback rate.
   *
   * @example
   * ```ts
   * remote.changePlaybackRate(0.5); // Half the normal speed
   * remote.changePlaybackRate(1); // Normal speed
   * remote.changePlaybackRate(1.5); // 50% faster than normal
   * remote.changePlaybackRate(2); // Double the normal speed
   * ```
   */
  changePlaybackRate(e, n) {
    this.#r("media-rate-change-request", n, e);
  }
  /**
   * Dispatch a request to change the media audio gain.
   *
   * @example
   * ```ts
   * remote.changeAudioGain(1); // Disable audio gain
   * remote.changeAudioGain(1.5); // 50% louder
   * remote.changeAudioGain(2); // 100% louder
   * ```
   */
  changeAudioGain(e, n) {
    this.#r("media-audio-gain-change-request", n, e);
  }
  /**
   * Dispatch a request to resume idle tracking on controls.
   */
  resumeControls(e) {
    this.#r("media-resume-controls-request", e);
  }
  /**
   * Dispatch a request to pause controls idle tracking. Pausing tracking will result in the
   * controls being visible until `remote.resumeControls()` is called. This method
   * is generally used when building custom controls and you'd like to prevent the UI from
   * disappearing.
   *
   * @example
   * ```ts
   * // Prevent controls hiding while menu is being interacted with.
   * function onSettingsOpen() {
   *   remote.pauseControls();
   * }
   *
   * function onSettingsClose() {
   *   remote.resumeControls();
   * }
   * ```
   */
  pauseControls(e) {
    this.#r("media-pause-controls-request", e);
  }
  /**
   * Dispatch a request to toggle the media playback state.
   */
  togglePaused(e) {
    const n = this.getPlayer(e?.target);
    n && (n.state.paused ? this.play(e) : this.pause(e));
  }
  /**
   * Dispatch a request to toggle the controls visibility.
   */
  toggleControls(e) {
    const n = this.getPlayer(e?.target);
    n && (n.controls.showing ? n.controls.hide(0, e) : n.controls.show(0, e));
  }
  /**
   * Dispatch a request to toggle the media muted state.
   */
  toggleMuted(e) {
    const n = this.getPlayer(e?.target);
    n && (n.state.muted ? this.unmute(e) : this.mute(e));
  }
  /**
   * Dispatch a request to toggle the media fullscreen state.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/fullscreen#remote-control}
   */
  toggleFullscreen(e, n) {
    const i = this.getPlayer(n?.target);
    i && (i.state.fullscreen ? this.exitFullscreen(e, n) : this.enterFullscreen(e, n));
  }
  /**
   * Dispatch a request to toggle the media picture-in-picture mode.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/picture-in-picture#remote-control}
   */
  togglePictureInPicture(e) {
    const n = this.getPlayer(e?.target);
    n && (n.state.pictureInPicture ? this.exitPictureInPicture(e) : this.enterPictureInPicture(e));
  }
  /**
   * Show captions.
   */
  showCaptions(e) {
    const n = this.getPlayer(e?.target);
    if (!n)
      return;
    let i = n.state.textTracks, r = this.#n;
    (!i[r] || !bt(i[r])) && (r = -1), r === -1 && (r = i.findIndex((a) => bt(a) && a.default)), r === -1 && (r = i.findIndex((a) => bt(a))), r >= 0 && this.changeTextTrackMode(r, "showing", e), this.#n = -1;
  }
  /**
   * Turn captions off.
   */
  disableCaptions(e) {
    const n = this.getPlayer(e?.target);
    if (!n)
      return;
    const i = n.state.textTracks, r = n.state.textTrack;
    if (r) {
      const a = i.indexOf(r);
      this.changeTextTrackMode(a, "disabled", e), this.#n = a;
    }
  }
  /**
   * Dispatch a request to toggle the current captions mode.
   */
  toggleCaptions(e) {
    const n = this.getPlayer(e?.target);
    n && (n.state.textTrack ? this.disableCaptions() : this.showCaptions());
  }
  userPrefersLoopChange(e, n) {
    this.#r("media-user-loop-change-request", n, e);
  }
  #r(e, n, i) {
    const r = new Se(e, {
      bubbles: !0,
      composed: !0,
      cancelable: !0,
      detail: i,
      trigger: n
    });
    let a = n?.target || null;
    a && a instanceof be && (a = a.el), a = !a || a === document || a === window || a === document.body || this.#t?.el && a instanceof Node && !this.#t.el.contains(a) ? this.#e ?? this.getPlayer()?.el : a ?? this.#e, this.#t ? e === "media-play-request" && !this.#t.state.canLoad ? a?.dispatchEvent(r) : this.#t.canPlayQueue.enqueue(e, () => a?.dispatchEvent(r)) : a?.dispatchEvent(r);
  }
  #a(e) {
  }
}
class VC {
  playerId = "vds-player";
  mediaId = null;
  #e = {
    volume: null,
    muted: null,
    audioGain: null,
    time: null,
    lang: null,
    captions: null,
    rate: null,
    quality: null
  };
  async getVolume() {
    return this.#e.volume;
  }
  async setVolume(e) {
    this.#e.volume = e, this.save();
  }
  async getMuted() {
    return this.#e.muted;
  }
  async setMuted(e) {
    this.#e.muted = e, this.save();
  }
  async getTime() {
    return this.#e.time;
  }
  async setTime(e, n) {
    const i = e < 0;
    this.#e.time = i ? null : e, i || n ? this.saveTime() : this.saveTimeThrottled();
  }
  async getLang() {
    return this.#e.lang;
  }
  async setLang(e) {
    this.#e.lang = e, this.save();
  }
  async getCaptions() {
    return this.#e.captions;
  }
  async setCaptions(e) {
    this.#e.captions = e, this.save();
  }
  async getPlaybackRate() {
    return this.#e.rate;
  }
  async setPlaybackRate(e) {
    this.#e.rate = e, this.save();
  }
  async getAudioGain() {
    return this.#e.audioGain;
  }
  async setAudioGain(e) {
    this.#e.audioGain = e, this.save();
  }
  async getVideoQuality() {
    return this.#e.quality;
  }
  async setVideoQuality(e) {
    this.#e.quality = e, this.save();
  }
  onChange(e, n, i = "vds-player") {
    const r = i ? localStorage.getItem(i) : null, a = n ? localStorage.getItem(n) : null;
    this.playerId = i, this.mediaId = n, this.#e = {
      volume: null,
      muted: null,
      audioGain: null,
      lang: null,
      captions: null,
      rate: null,
      quality: null,
      ...r ? JSON.parse(r) : {},
      time: a ? +a : null
    };
  }
  save() {
    if (H || !this.playerId) return;
    const e = JSON.stringify({ ...this.#e, time: void 0 });
    localStorage.setItem(this.playerId, e);
  }
  saveTimeThrottled = Oi(this.saveTime.bind(this), 1e3);
  saveTime() {
    if (H || !this.mediaId) return;
    const e = (this.#e.time ?? 0).toString();
    localStorage.setItem(this.mediaId, e);
  }
}
const HC = /* @__PURE__ */ Symbol(0), qC = /* @__PURE__ */ Symbol(0), zC = /* @__PURE__ */ Symbol(0), WC = /* @__PURE__ */ Symbol(0), KC = /* @__PURE__ */ Symbol(0), QC = /* @__PURE__ */ Symbol(0), XC = /* @__PURE__ */ Symbol(0), ZC = /* @__PURE__ */ Symbol(0), JC = /* @__PURE__ */ Symbol(0), le = {
  add: HC,
  remove: qC,
  reset: zC,
  select: WC,
  readonly: KC,
  setReadonly: QC,
  onReset: XC,
  onRemove: ZC,
  onUserSelect: JC
};
class Gd extends qs {
  items = [];
  /** @internal */
  [le.readonly] = !1;
  get length() {
    return this.items.length;
  }
  get readonly() {
    return this[le.readonly];
  }
  /**
   * Returns the index of the first occurrence of the given item, or -1 if it is not present.
   */
  indexOf(e) {
    return this.items.indexOf(e);
  }
  /**
   * Returns an item matching the given `id`, or `null` if not present.
   */
  getById(e) {
    return e === "" ? null : this.items.find((n) => n.id === e) ?? null;
  }
  /**
   * Transform list to an array.
   */
  toArray() {
    return [...this.items];
  }
  [Symbol.iterator]() {
    return this.items.values();
  }
  /** @internal */
  [le.add](e, n) {
    const i = this.items.length;
    "" + i in this || Object.defineProperty(this, i, {
      get() {
        return this.items[i];
      }
    }), !this.items.includes(e) && (this.items.push(e), this.dispatchEvent(new Se("add", { detail: e, trigger: n })));
  }
  /** @internal */
  [le.remove](e, n) {
    const i = this.items.indexOf(e);
    i >= 0 && (this[le.onRemove]?.(e, n), this.items.splice(i, 1), this.dispatchEvent(new Se("remove", { detail: e, trigger: n })));
  }
  /** @internal */
  [le.reset](e) {
    for (const n of [...this.items]) this[le.remove](n, e);
    this.items = [], this[le.setReadonly](!1, e), this[le.onReset]?.();
  }
  /** @internal */
  [le.setReadonly](e, n) {
    this[le.readonly] !== e && (this[le.readonly] = e, this.dispatchEvent(new Se("readonly-change", { detail: e, trigger: n })));
  }
}
const qi = /* @__PURE__ */ Symbol(0);
class Yd extends Gd {
  get selected() {
    return this.items.find((e) => e.selected) ?? null;
  }
  get selectedIndex() {
    return this.items.findIndex((e) => e.selected);
  }
  /** @internal */
  [le.onRemove](e, n) {
    this[le.select](e, !1, n);
  }
  /** @internal */
  [le.add](e, n) {
    e[qi] = !1, Object.defineProperty(e, "selected", {
      get() {
        return this[qi];
      },
      set: (i) => {
        this.readonly || (this[le.onUserSelect]?.(), this[le.select](e, i));
      }
    }), super[le.add](e, n);
  }
  /** @internal */
  [le.select](e, n, i) {
    if (n === e?.[qi]) return;
    const r = this.selected;
    e && (e[qi] = n), (n ? r !== e : r === e) && (r && (r[qi] = !1), this.dispatchEvent(
      new Se("change", {
        detail: {
          prev: r,
          current: this.selected
        },
        trigger: i
      })
    ));
  }
}
class jC extends Yd {
}
function Rt(t, e = 2) {
  return Number(t.toFixed(e));
}
function _s(t) {
  return String(t).split(".")[1]?.length ?? 0;
}
function ao(t, e, n) {
  return Math.max(t, Math.min(n, e));
}
function Bl(t, e) {
  const n = e.composedPath()[0];
  return ad(n) && t.contains(n);
}
const ps = /* @__PURE__ */ new Set();
if (!H) {
  let t = function() {
    for (const e of ps)
      try {
        e();
      } catch {
      }
    window.requestAnimationFrame(t);
  };
  t();
}
function ey(t) {
  return ps.add(t), () => ps.delete(t);
}
function Be(t, e, n) {
  t.hasAttribute(e) || t.setAttribute(e, n);
}
function Kn(t, e) {
  if (t.hasAttribute("aria-label") || t.hasAttribute("data-no-label")) return;
  if (!yt(e)) {
    re(t, "aria-label", e);
    return;
  }
  function n() {
    re(t, "aria-label", e());
  }
  H ? n() : N(n);
}
function $d(t) {
  const e = getComputedStyle(t);
  return e.display !== "none" && parseInt(e.opacity) > 0;
}
function ty(t) {
  return !!t && ("checkVisibility" in t ? t.checkVisibility({ checkOpacity: !0, checkVisibilityCSS: !0 }) : $d(t));
}
function Vd(t, e) {
  return ey(() => e(ty(t)));
}
function Hd(t, e, n) {
  for (; e; ) {
    if (e === t)
      return !0;
    if (n?.(e))
      break;
    e = e.parentElement;
  }
  return !1;
}
function On(t, e) {
  return new Ae(t).add("pointerup", (n) => {
    n.button === 0 && !n.defaultPrevented && e(n);
  }).add("keydown", (n) => {
    dr(n) && e(n);
  });
}
function so(t) {
  return Xi(t) && (t.touches.length > 1 || t.changedTouches.length > 1);
}
function ny(t, e, n, {
  offsetVarName: i,
  xOffset: r,
  yOffset: a,
  ...s
}) {
  if (!t) return;
  const o = n.replace(" ", "-").replace("-center", "");
  if (Xt(t, "visibility", e ? null : "hidden"), !e) return;
  let l = n.includes("top");
  const c = (u) => n.includes("left") ? `calc(-1 * ${u})` : u, d = (u) => l ? `calc(-1 * ${u})` : u;
  return cC(e, t, () => {
    _C(e, t, {
      placement: o,
      middleware: [
        ...s.middleware ?? [],
        uC({ fallbackAxisSideDirection: "start", crossAxis: !1 }),
        dC()
      ],
      ...s
    }).then(({ x: u, y: _, middlewareData: m }) => {
      const g = !!m.flip?.index;
      l = n.includes(g ? "bottom" : "top"), t.setAttribute(
        "data-placement",
        g ? n.startsWith("top") ? n.replace("top", "bottom") : n.replace("bottom", "top") : n
      ), Object.assign(t.style, {
        top: `calc(${_ + "px"} + ${d(
          a ? a + "px" : `var(--${i}-y-offset, 0px)`
        )})`,
        left: `calc(${u + "px"} + ${c(
          r ? r + "px" : `var(--${i}-x-offset, 0px)`
        )})`
      });
    });
  });
}
function iy(t) {
  return getComputedStyle(t).animationName !== "none";
}
function ra(t) {
  return t instanceof HTMLElement;
}
class ry {
  priority = 0;
  #e = !0;
  #t = null;
  #n = null;
  #i = /* @__PURE__ */ new Set();
  canRender(e, n) {
    return !!n;
  }
  attach(e) {
    this.#t = e, e && (e.textTracks.onchange = this.#l.bind(this));
  }
  addTrack(e) {
    this.#i.add(e), this.#r(e);
  }
  removeTrack(e) {
    e[ie.native]?.remove?.(), e[ie.native] = null, this.#i.delete(e);
  }
  changeTrack(e) {
    const n = e?.[ie.native];
    n && n.track.mode !== "showing" && (n.track.mode = "showing"), this.#n = e;
  }
  setDisplay(e) {
    this.#e = e, this.#l();
  }
  detach() {
    this.#t && (this.#t.textTracks.onchange = null);
    for (const e of this.#i) this.removeTrack(e);
    this.#i.clear(), this.#t = null, this.#n = null;
  }
  #r(e) {
    if (!this.#t) return;
    const n = e[ie.native] ??= this.#a(e);
    ra(n) && (this.#t.append(n), n.track.mode = n.default ? "showing" : "disabled");
  }
  #a(e) {
    const n = document.createElement("track"), i = e.default || e.mode === "showing", r = e.src && e.type === "vtt";
    return n.id = e.id, n.src = r ? e.src : "", n.label = e.label, n.kind = e.kind, n.default = i, e.language && (n.srclang = e.language), i && !r && this.#s(e, n.track), n;
  }
  #s(e, n) {
    if (!(e.src && e.type === "vtt" || n.cues?.length))
      for (const i of e.cues) n.addCue(i);
  }
  #l(e) {
    for (const n of this.#i) {
      const i = n[ie.native];
      if (!i) continue;
      if (!this.#e) {
        i.track.mode = i.managed ? "hidden" : "disabled";
        continue;
      }
      const r = i.track.mode === "showing";
      r && this.#s(n, i.track), n.setMode(r ? "showing" : "disabled", e);
    }
  }
}
class ay {
  #e = null;
  #t;
  #n = [];
  #i;
  #r = !1;
  #a = null;
  #s = null;
  constructor(e) {
    this.#i = e;
    const n = e.textTracks;
    this.#t = n, N(this.#l.bind(this)), ue(this.#p.bind(this)), new Ae(n).add("add", this.#_.bind(this)).add("remove", this.#u.bind(this)).add("mode-change", this.#d.bind(this));
  }
  #l() {
    const { nativeControls: e } = this.#i.$state;
    this.#r = e(), this.#d();
  }
  add(e) {
    this.#n.push(e), Ei(this.#d.bind(this));
  }
  remove(e) {
    e.detach(), this.#n.splice(this.#n.indexOf(e), 1), Ei(this.#d.bind(this));
  }
  /** @internal */
  attachVideo(e) {
    requestAnimationFrame(() => {
      if (this.#e = e, e) {
        this.#a = new ry(), this.#a.attach(e);
        for (const n of this.#t) this.#o(n);
      }
      this.#d();
    });
  }
  #o(e) {
    bt(e) && this.#a?.addTrack(e);
  }
  #c(e) {
    bt(e) && this.#a?.removeTrack(e);
  }
  #_(e) {
    this.#o(e.detail);
  }
  #u(e) {
    this.#c(e.detail);
  }
  #d() {
    const e = this.#t.selected;
    if (this.#e && (this.#r || e?.[ie.nativeHLS])) {
      this.#s?.changeTrack(null), this.#a?.setDisplay(!0), this.#a?.changeTrack(e);
      return;
    }
    if (this.#a?.setDisplay(!1), this.#a?.changeTrack(null), !e) {
      this.#s?.changeTrack(null);
      return;
    }
    const n = this.#n.sort((i, r) => i.priority - r.priority).find((i) => i.canRender(e, this.#e));
    this.#s !== n && (this.#s?.detach(), n?.attach(this.#e), this.#s = n ?? null), n?.changeTrack(e);
  }
  #p() {
    this.#a?.detach(), this.#a = null, this.#s?.detach(), this.#s = null;
  }
}
class sy extends Gd {
  #e = !1;
  #t = {};
  #n = null;
  #i = null;
  /** @internal */
  [ie.crossOrigin];
  constructor() {
    super();
  }
  get selected() {
    return this.items.find((n) => n.mode === "showing" && bt(n)) ?? null;
  }
  get selectedIndex() {
    const e = this.selected;
    return e ? this.indexOf(e) : -1;
  }
  get preferredLang() {
    return this.#i;
  }
  set preferredLang(e) {
    this.#i = e, this.#c(e);
  }
  add(e, n) {
    const i = e instanceof Vn, r = i ? e : new Vn(e), a = e.kind === "captions" || e.kind === "subtitles" ? "captions" : e.kind;
    return this.#t[a] && e.default && delete e.default, r.addEventListener("mode-change", this.#s), this[le.add](r, n), r[ie.crossOrigin] = this[ie.crossOrigin], this.#e && r[ie.canLoad](), e.default && (this.#t[a] = r), this.#r(), this;
  }
  remove(e, n) {
    if (this.#a = e, !!this.items.includes(e))
      return e === this.#t[e.kind] && delete this.#t[e.kind], e.mode = "disabled", e[ie.onModeChange] = null, e.removeEventListener("mode-change", this.#s), this[le.remove](e, n), this.#a = null, this;
  }
  clear(e) {
    for (const n of [...this.items])
      this.remove(n, e);
    return this;
  }
  getByKind(e) {
    const n = Array.isArray(e) ? e : [e];
    return this.items.filter((i) => n.includes(i.kind));
  }
  /** @internal */
  [ie.canLoad]() {
    if (!this.#e) {
      for (const e of this.items) e[ie.canLoad]();
      this.#e = !0, this.#r();
    }
  }
  #r = ga(async () => {
    if (!this.#e) return;
    !this.#i && this.#n && (this.#i = await this.#n.getLang());
    const e = await this.#n?.getCaptions(), n = [
      ["captions", "subtitles"],
      "chapters",
      "descriptions",
      "metadata"
    ];
    for (const i of n) {
      const r = this.getByKind(i);
      if (r.find((c) => c.mode === "showing")) continue;
      const a = this.#i ? r.find((c) => c.language === this.#i) : null, s = Et(i) ? this.#t[i.find((c) => this.#t[c]) || ""] : this.#t[i], o = a ?? s, l = o && bt(o);
      o && (!l || e !== !1) && (o.mode = "showing", l && this.#o(o));
    }
  }, 300);
  #a = null;
  #s = this.#l.bind(this);
  #l(e) {
    const n = e.detail;
    if (this.#n && bt(n) && n !== this.#a && this.#o(n), n.mode === "showing") {
      const i = bt(n) ? ["captions", "subtitles"] : [n.kind];
      for (const r of this.items)
        r.mode === "showing" && r != n && i.includes(r.kind) && (r.mode = "disabled");
    }
    this.dispatchEvent(
      new Se("mode-change", {
        detail: e.detail,
        trigger: e
      })
    );
  }
  #o(e) {
    e.mode !== "disabled" && this.#c(e.language), this.#n?.setCaptions?.(e.mode === "showing");
  }
  #c(e) {
    this.#n?.setLang?.(this.#i = e);
  }
  setStorage(e) {
    this.#n = e;
  }
}
const oy = /* @__PURE__ */ Symbol(0), ly = /* @__PURE__ */ Symbol(0), Mt = {
  setAuto: oy,
  enableAuto: ly
};
class cy extends Yd {
  #e = !1;
  /**
   * Configures quality switching:
   *
   * - `current`: Trigger an immediate quality level switch. This will abort the current fragment
   * request if any, flush the whole buffer, and fetch fragment matching with current position
   * and requested quality level.
   *
   * - `next`: Trigger a quality level switch for next fragment. This could eventually flush
   * already buffered next fragment.
   *
   * - `load`: Set quality level for next loaded fragment.
   *
   * @see {@link https://www.vidstack.io/docs/player/api/video-quality#switch}
   * @see {@link https://github.com/video-dev/hls.js/blob/master/docs/API.md#quality-switch-control-api}
   */
  switch = "current";
  /**
   * Whether automatic quality selection is enabled.
   */
  get auto() {
    return this.#e || this.readonly;
  }
  /** @internal */
  [Mt.enableAuto];
  /** @internal */
  [le.onUserSelect]() {
    this[Mt.setAuto](!1);
  }
  /** @internal */
  [le.onReset](e) {
    this[Mt.enableAuto] = void 0, this[Mt.setAuto](!1, e);
  }
  /**
   * Request automatic quality selection (if supported). This will be a no-op if the list is
   * `readonly` as that already implies auto-selection.
   */
  autoSelect(e) {
    this.readonly || this.#e || !this[Mt.enableAuto] || (this[Mt.enableAuto]?.(e), this[Mt.setAuto](!0, e));
  }
  getBySrc(e) {
    return this.items.find((n) => n.src === e);
  }
  /** @internal */
  [Mt.setAuto](e, n) {
    this.#e !== e && (this.#e = e, this.dispatchEvent(
      new Se("auto-change", {
        detail: e,
        trigger: n
      })
    ));
  }
}
function dy(t, e) {
  return [...t].sort(e ? _y : uy);
}
function uy(t, e) {
  return t.height === e.height ? (t.bitrate ?? 0) - (e.bitrate ?? 0) : t.height - e.height;
}
function _y(t, e) {
  return e.height === t.height ? (e.bitrate ?? 0) - (t.bitrate ?? 0) : e.height - t.height;
}
function py(t) {
  return t?.$$PROVIDER_TYPE === "HLS";
}
function my(t) {
  return !H && t instanceof HTMLAudioElement;
}
function Ey(t) {
  return !H && t instanceof HTMLVideoElement;
}
function gy(t) {
  return my(t) || Ey(t);
}
class Qn extends Ut {
}
const Sy = {
  togglePaused: "k Space",
  toggleMuted: "m",
  toggleFullscreen: "f",
  togglePictureInPicture: "i",
  toggleCaptions: "c",
  seekBackward: "j J ArrowLeft",
  seekForward: "l L ArrowRight",
  volumeUp: "ArrowUp",
  volumeDown: "ArrowDown",
  speedUp: ">",
  slowDown: "<"
}, Ki = /* @__PURE__ */ new Set(["Shift", "Alt", "Meta", "Ctrl"]), hy = 'button, [role="button"]', Gl = 'input, textarea, select, [contenteditable], [role^="menuitem"], [role="timer"]';
class fy extends Qn {
  #e;
  constructor(e) {
    super(), this.#e = e;
  }
  onConnect() {
    N(this.#t.bind(this));
  }
  #t() {
    const { keyDisabled: e, keyTarget: n } = this.$props;
    if (e()) return;
    const i = n() === "player" ? this.el : document, r = j(!1);
    i === this.el ? new Ae(this.el).add("focusin", () => r.set(!0)).add("focusout", (a) => {
      this.el.contains(a.target) || r.set(!1);
    }) : (F(r) || r.set(document.querySelector("[data-media-player]") === this.el), Ve(document, "focusin", (a) => {
      const s = a.composedPath().find((o) => o instanceof Element && o.localName === "media-player");
      s !== void 0 && r.set(this.el === s);
    })), N(() => {
      r() && new Ae(i).add("keyup", this.#n.bind(this)).add("keydown", this.#i.bind(this)).add("keydown", this.#r.bind(this), { capture: !0 });
    });
  }
  #n(e) {
    const n = document.activeElement;
    if (!e.key || !this.$state.canSeek() || n?.matches(Gl))
      return;
    let { method: i, value: r } = this.#a(e);
    if (!Q(r) && !Et(r)) {
      r?.onKeyUp?.({
        event: e,
        player: this.#e.player,
        remote: this.#e.remote
      }), r?.callback?.(e, this.#e.remote);
      return;
    }
    i?.startsWith("seek") && (e.preventDefault(), e.stopPropagation(), this.#o ? (this.#c(e, i === "seekForward"), this.#o = null) : (this.#e.remote.seek(this.#s, e), this.#s = void 0)), i?.startsWith("volume") && this.el.querySelector("[data-media-volume-slider]")?.dispatchEvent(
      new KeyboardEvent("keyup", {
        key: i === "volumeUp" ? "Up" : "Down",
        shiftKey: e.shiftKey,
        trigger: e
      })
    );
  }
  #i(e) {
    if (!e.key || Ki.has(e.key)) return;
    const n = document.activeElement;
    if (n?.matches(Gl) || dr(e) && n?.matches(hy))
      return;
    let { method: i, value: r } = this.#a(e), a = !e.metaKey && /^[0-9]$/.test(e.key);
    if (!Q(r) && !Et(r) && !a) {
      r?.onKeyDown?.({
        event: e,
        player: this.#e.player,
        remote: this.#e.remote
      }), r?.callback?.(e, this.#e.remote);
      return;
    }
    if (!i && a && !Cy(e)) {
      e.preventDefault(), e.stopPropagation(), this.#e.remote.seek(this.$state.duration() / 10 * Number(e.key), e);
      return;
    }
    if (i) {
      switch (e.preventDefault(), e.stopPropagation(), i) {
        case "seekForward":
        case "seekBackward":
          this.#_(e, i, i === "seekForward");
          break;
        case "volumeUp":
        case "volumeDown":
          const s = this.el.querySelector("[data-media-volume-slider]");
          if (s)
            s.dispatchEvent(
              new KeyboardEvent("keydown", {
                key: i === "volumeUp" ? "Up" : "Down",
                shiftKey: e.shiftKey,
                trigger: e
              })
            );
          else {
            const l = e.shiftKey ? 0.1 : 0.05;
            this.#e.remote.changeVolume(
              this.$state.volume() + (i === "volumeUp" ? +l : -l),
              e
            );
          }
          break;
        case "toggleFullscreen":
          this.#e.remote.toggleFullscreen("prefer-media", e);
          break;
        case "speedUp":
        case "slowDown":
          const o = this.$state.playbackRate();
          this.#e.remote.changePlaybackRate(
            Math.max(0.25, Math.min(2, o + (i === "speedUp" ? 0.25 : -0.25))),
            e
          );
          break;
        default:
          this.#e.remote[i]?.(e);
      }
      this.$state.lastKeyboardAction.set({
        action: i,
        event: e
      });
    }
  }
  #r(e) {
    gy(e.target) && this.#a(e).method && e.preventDefault();
  }
  #a(e) {
    const n = {
      ...this.$props.keyShortcuts(),
      ...this.#e.ariaKeys
    }, i = Object.keys(n).find((r) => {
      const a = n[r], s = Et(a) ? a.join(" ") : Q(a) ? a : a?.keys;
      return (Et(s) ? s : s?.split(" "))?.map(
        (l) => by(l).replace(/Control/g, "Ctrl").split("+")
      )?.some((l) => {
        const c = new Set(l.filter((d) => Ki.has(d)));
        for (const d of Ki) {
          const u = d.toLowerCase() + "Key";
          if (!c.has(d) && e[u])
            return !1;
        }
        return l.every((d) => Ki.has(d) ? e[d.toLowerCase() + "Key"] : e.key === d.replace("Space", " "));
      });
    });
    return {
      method: i,
      value: i ? n[i] : null
    };
  }
  #s;
  #l(e, n) {
    const i = e.shiftKey ? 10 : 5;
    return this.#s = Math.max(
      0,
      Math.min(
        (this.#s ?? this.$state.currentTime()) + (n === "seekForward" ? +i : -i),
        this.$state.duration()
      )
    );
  }
  #o = null;
  #c(e, n) {
    this.#o?.dispatchEvent(
      new KeyboardEvent(e.type, {
        key: n ? "Right" : "Left",
        shiftKey: e.shiftKey,
        trigger: e
      })
    );
  }
  #_(e, n, i) {
    this.$state.canSeek() && (this.#o || (this.#o = this.el.querySelector("[data-media-time-slider]")), this.#o ? this.#c(e, i) : this.#e.remote.seeking(this.#l(e, n), e));
  }
}
const Ty = ["!", "@", "#", "$", "%", "^", "&", "*", "(", ")"];
function by(t) {
  return t.replace(/Shift\+(\d)/g, (e, n) => Ty[n - 1]);
}
function Cy(t) {
  for (const e of Ki)
    if (t[e.toLowerCase() + "Key"])
      return !0;
  return !1;
}
class yy extends Ut {
  #e;
  constructor(e) {
    super(), this.#e = e;
  }
  onAttach(e) {
    const { $props: n, ariaKeys: i } = Ge(), r = e.getAttribute("aria-keyshortcuts");
    if (r) {
      i[this.#e] = r, H || ue(() => {
        delete i[this.#e];
      });
      return;
    }
    const a = n.keyShortcuts()[this.#e];
    if (a) {
      const s = Et(a) ? a.join(" ") : Q(a) ? a : a?.keys;
      e.setAttribute("aria-keyshortcuts", Et(s) ? s.join(" ") : s);
    }
  }
}
class Ry extends Qn {
  #e = -2;
  #t = !1;
  #n = j(!1);
  #i = j(!1);
  #r = null;
  #a = j(!0);
  /**
   * The default amount of delay in milliseconds while media playback is progressing without user
   * activity to indicate an idle state (i.e., hide controls).
   *
   * @defaultValue 2000
   */
  defaultDelay = 2e3;
  /**
   * Whether controls can hide after a delay in user interaction. If this is false, controls will
   * not hide and be user controlled.
   */
  get canIdle() {
    return this.#a();
  }
  set canIdle(e) {
    this.#a.set(e);
  }
  /**
   * Whether controls visibility should be toggled when the mouse enters and leaves the player
   * container.
   *
   * @defaultValue false
   */
  get hideOnMouseLeave() {
    const { hideControlsOnMouseLeave: e } = this.$props;
    return this.#n() || e();
  }
  set hideOnMouseLeave(e) {
    this.#n.set(e);
  }
  /**
   * Whether media controls are currently visible.
   */
  get showing() {
    return this.$state.controlsVisible();
  }
  /**
   * Show controls.
   */
  show(e = 0, n) {
    this.#E(), this.#t || this.#S(!0, e, n);
  }
  /**
   * Hide controls.
   */
  hide(e = this.defaultDelay, n) {
    this.#E(), this.#t || this.#S(!1, e, n);
  }
  /**
   * Whether all idle tracking on controls should be paused until resumed again.
   */
  pause(e) {
    this.#t = !0, this.#E(), this.#S(!0, 0, e);
  }
  resume(e) {
    this.#t = !1, !this.$state.paused() && this.#S(!1, this.defaultDelay, e);
  }
  onConnect() {
    N(this.#s.bind(this));
  }
  #s() {
    const { viewType: e } = this.$state;
    if (!this.el || !this.#a()) return;
    if (e() === "audio") {
      this.show();
      return;
    }
    N(this.#l.bind(this)), N(this.#o.bind(this));
    const n = this.#c.bind(this), i = this.#_.bind(this), r = this.#u.bind(this);
    new Ae(this.el).add("can-play", (a) => this.show(0, a)).add("play", n).add("pause", i).add("end", r).add("auto-play-fail", i);
  }
  #l() {
    if (!this.el) return;
    const { started: e, pointer: n, paused: i } = this.$state;
    if (!e() || n() !== "fine") return;
    const r = new Ae(this.el), a = this.hideOnMouseLeave;
    (!a || !this.#i()) && N(() => {
      i() || r.add("pointermove", this.#f.bind(this));
    }), a && r.add("mouseenter", this.#d.bind(this)).add("mouseleave", this.#p.bind(this));
  }
  #o() {
    const { paused: e, started: n, autoPlayError: i } = this.$state;
    if (e() || i() && !n()) return;
    const r = this.#f.bind(this);
    N(() => {
      if (!this.el) return;
      const a = this.$state.pointer(), s = a === "coarse", o = new Ae(this.el), l = [s ? "touchend" : "pointerup", "keydown"];
      for (const c of l)
        o.add(c, r, { passive: !1 });
    });
  }
  #c(e) {
    e.triggers.hasType("ended") || (this.show(0, e), this.hide(void 0, e));
  }
  #_(e) {
    this.show(0, e);
  }
  #u(e) {
    const { loop: n } = this.$state;
    n() && this.hide(0, e);
  }
  #d(e) {
    this.#i.set(!1), this.show(0, e), this.hide(void 0, e);
  }
  #p(e) {
    this.#i.set(!0), this.hide(0, e);
  }
  #E() {
    window.clearTimeout(this.#e), this.#e = -1;
  }
  #f(e) {
    // @ts-expect-error
    e.MEDIA_GESTURE || this.#t || so(e) || (zn(e) && (e.key === "Escape" ? (this.el?.focus(), this.#r = null) : this.#r && (e.preventDefault(), requestAnimationFrame(() => {
      this.#r?.focus(), this.#r = null;
    }))), this.show(0, e), this.hide(this.defaultDelay, e));
  }
  #S(e, n, i) {
    if (n === 0) {
      this.#T(e, i);
      return;
    }
    this.#e = window.setTimeout(() => {
      this.scope && this.#T(e && !this.#t, i);
    }, n);
  }
  #T(e, n) {
    this.$state.controlsVisible() !== e && (this.$state.controlsVisible.set(e), !e && document.activeElement && this.el?.contains(document.activeElement) && (this.#r = document.activeElement, requestAnimationFrame(() => {
      this.el?.focus({ preventScroll: !0 });
    })), this.dispatch("controls-change", {
      detail: e,
      trigger: n
    }));
  }
}
const ms = Rn.fullscreenEnabled;
class Ny extends Ut {
  /**
   * Tracks whether we're the active fullscreen event listener. Fullscreen events can only be
   * listened to globally on the document so we need to know if they relate to the current host
   * element or not.
   */
  #e = !1;
  #t = !1;
  get active() {
    return this.#t;
  }
  get supported() {
    return ms;
  }
  onConnect() {
    new Ae(Rn).add("fullscreenchange", this.#i.bind(this)).add("fullscreenerror", this.#r.bind(this)), ue(this.#n.bind(this));
  }
  async #n() {
    ms && await this.exit();
  }
  #i(e) {
    const n = qa(this.el);
    n !== this.#t && (n || (this.#e = !1), this.#t = n, this.dispatch("fullscreen-change", { detail: n, trigger: e }));
  }
  #r(e) {
    this.#e && (this.dispatch("fullscreen-error", { detail: null, trigger: e }), this.#e = !1);
  }
  async enter() {
    try {
      return this.#e = !0, !this.el || qa(this.el) ? void 0 : (Yl(), Rn.requestFullscreen(this.el));
    } catch (e) {
      throw this.#e = !1, e;
    }
  }
  async exit() {
    if (!(!this.el || !qa(this.el)))
      return Yl(), Rn.exitFullscreen();
  }
}
function qa(t) {
  if (Rn.fullscreenElement === t) return !0;
  try {
    return t.matches(
      // @ts-expect-error - `fullscreenPseudoClass` is missing from `@types/fscreen`.
      Rn.fullscreenPseudoClass
    );
  } catch {
    return !1;
  }
}
function Yl() {
  if (!ms)
    throw Error(
      "[vidstack] no fullscreen API"
    );
}
class ba extends Ut {
  #e = j(this.#s());
  #t = j(!1);
  #n;
  /**
   * The current screen orientation type.
   *
   * @signal
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/ScreenOrientation}
   * @see https://w3c.github.io/screen-orientation/#screen-orientation-types-and-locks
   */
  get type() {
    return this.#e();
  }
  /**
   * Whether the screen orientation is currently locked.
   *
   * @signal
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/ScreenOrientation}
   * @see https://w3c.github.io/screen-orientation/#screen-orientation-types-and-locks
   */
  get locked() {
    return this.#t();
  }
  /**
   * Whether the viewport is in a portrait orientation.
   *
   * @signal
   */
  get portrait() {
    return this.#e().startsWith("portrait");
  }
  /**
   * Whether the viewport is in a landscape orientation.
   *
   * @signal
   */
  get landscape() {
    return this.#e().startsWith("landscape");
  }
  /**
   * Whether the native Screen Orientation API is available.
   */
  static supported = Id();
  /**
   * Whether the native Screen Orientation API is available.
   */
  get supported() {
    return ba.supported;
  }
  onConnect() {
    if (this.supported)
      Ve(screen.orientation, "change", this.#r.bind(this));
    else {
      const e = window.matchMedia("(orientation: landscape)");
      e.onchange = this.#r.bind(this), ue(() => e.onchange = null);
    }
    ue(this.#i.bind(this));
  }
  async #i() {
    this.supported && this.#t() && await this.unlock();
  }
  #r(e) {
    this.#e.set(this.#s()), this.dispatch("orientation-change", {
      detail: {
        orientation: F(this.#e),
        lock: this.#n
      },
      trigger: e
    });
  }
  /**
   * Locks the orientation of the screen to the desired orientation type using the
   * Screen Orientation API.
   *
   * @param lockType - The screen lock orientation type.
   * @throws Error - If screen orientation API is unavailable.
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Screen/orientation}
   * @see {@link https://w3c.github.io/screen-orientation}
   */
  async lock(e) {
    F(this.#t) || this.#n === e || (this.#a(), await screen.orientation.lock(e), this.#t.set(!0), this.#n = e);
  }
  /**
   * Unlocks the orientation of the screen to it's default state using the Screen Orientation
   * API. This method will throw an error if the API is unavailable.
   *
   * @throws Error - If screen orientation API is unavailable.
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Screen/orientation}
   * @see {@link https://w3c.github.io/screen-orientation}
   */
  async unlock() {
    F(this.#t) && (this.#a(), this.#n = void 0, await screen.orientation.unlock(), this.#t.set(!1));
  }
  #a() {
    if (!this.supported)
      throw Error(
        "[vidstack] no orientation API"
      );
  }
  #s() {
    return H ? "portrait-primary" : this.supported ? window.screen.orientation.type : window.innerWidth >= window.innerHeight ? "landscape-primary" : "portrait-primary";
  }
}
class Oy {
  name = "audio";
  target;
  canPlay(e) {
    return to(e) ? H || !Q(e.src) || e.type === "?" || Dd(this.target, e.type) : !1;
  }
  mediaType() {
    return "audio";
  }
  async load(e) {
    if (H)
      throw Error("[vidstack] can not load audio provider server-side");
    return new (await import("./vidstack-R_ot4AhB-HSebz5OE.js")).AudioProvider(this.target, e);
  }
}
class oo {
  name = "video";
  target;
  canPlay(e) {
    return no(e) ? H || !Q(e.src) || e.type === "?" || Md(this.target, e.type) : !1;
  }
  mediaType() {
    return "video";
  }
  async load(e) {
    if (H)
      throw Error("[vidstack] can not load video provider server-side");
    return new (await Promise.resolve().then(function() {
      return qy;
    })).VideoProvider(this.target, e);
  }
}
class lo extends oo {
  static supported = eo();
  name = "hls";
  canPlay(e) {
    return lo.supported && Ai(e);
  }
  async load(e) {
    if (H)
      throw Error("[vidstack] can not load hls provider server-side");
    return new (await import("./vidstack-BN7_0WI--DrOy_hl0.js")).HLSProvider(this.target, e);
  }
}
let Yr = null, aa = [], sa = [];
function co() {
  return Yr ??= new AudioContext();
}
function vy() {
  const t = co(), e = t.createGain();
  return e.connect(t.destination), aa.push(e), e;
}
function Ay(t, e) {
  const n = co(), i = n.createMediaElementSource(t);
  return e && i.connect(e), sa.push(i), i;
}
function Iy(t) {
  const e = aa.indexOf(t);
  e !== -1 && (aa.splice(e, 1), t.disconnect(), qd());
}
function Dy(t) {
  const e = sa.indexOf(t);
  e !== -1 && (sa.splice(e, 1), t.disconnect(), qd());
}
function qd() {
  Yr && aa.length === 0 && sa.length === 0 && Yr.close().then(() => {
    Yr = null;
  });
}
class My {
  #e;
  #t;
  #n = null;
  #i = null;
  get currentGain() {
    return this.#n?.gain?.value ?? null;
  }
  get supported() {
    return !0;
  }
  constructor(e, n) {
    this.#e = e, this.#t = n;
  }
  setGain(e) {
    const n = this.currentGain;
    if (e !== this.currentGain) {
      if (e === 1 && n !== 1) {
        this.removeGain();
        return;
      }
      this.#n || (this.#n = vy(), this.#i && this.#i.connect(this.#n)), this.#i || (this.#i = Ay(this.#e, this.#n)), this.#n.gain.value = e, this.#t(e);
    }
  }
  removeGain() {
    this.#n && (this.#i && this.#i.connect(co().destination), this.#a(), this.#t(null));
  }
  destroy() {
    this.#r(), this.#a();
  }
  #r() {
    if (this.#i)
      try {
        Dy(this.#i);
      } catch {
      } finally {
        this.#i = null;
      }
  }
  #a() {
    if (this.#n)
      try {
        Iy(this.#n);
      } catch {
      } finally {
        this.#n = null;
      }
  }
}
const wy = ["focus", "blur", "visibilitychange", "pageshow", "pagehide"];
class xy {
  #e = j($l());
  #t = j(H ? "visible" : document.visibilityState);
  #n;
  connect() {
    const e = new Ae(window), n = this.#i.bind(this);
    for (const i of wy)
      e.add(i, n);
    ia && e.add("beforeunload", (i) => {
      this.#n = setTimeout(() => {
        i.defaultPrevented || i.returnValue.length > 0 || (this.#e.set("hidden"), this.#t.set("hidden"));
      }, 0);
    });
  }
  /**
   * The current page state. Important to note we only account for a subset of page states, as
   * the rest aren't valuable to the player at the moment.
   *
   * - **active:** A page is in the active state if it is visible and has input focus.
   * - **passive:** A page is in the passive state if it is visible and does not have input focus.
   * - **hidden:** A page is in the hidden state if it is not visible.
   *
   * @see https://developers.google.com/web/updates/2018/07/page-lifecycle-api#states
   */
  get pageState() {
    return this.#e();
  }
  /**
   * The current document visibility state.
   *
   * - **visible:** The page content may be at least partially visible. In practice, this means that
   * the page is the foreground tab of a non-minimized window.
   * - **hidden:** The page content is not visible to the user. In practice this means that the
   * document is either a background tab or part of a minimized window, or the OS screen lock is
   * active.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilityState
   */
  get visibility() {
    return this.#t();
  }
  #i(e) {
    ia && window.clearTimeout(this.#n), (e.type !== "blur" || this.#e() === "active") && (this.#e.set($l(e)), this.#t.set(document.visibilityState == "hidden" ? "hidden" : "visible"));
  }
}
function $l(t) {
  return H || t?.type === "blur" || document.visibilityState === "hidden" ? "hidden" : document.hasFocus() ? "active" : "passive";
}
class zd {
  #e;
  #t;
  constructor(e) {
    this.#t = e;
  }
  start() {
    je(this.#e) && this.#n();
  }
  stop() {
    mt(this.#e) && window.cancelAnimationFrame(this.#e), this.#e = void 0;
  }
  #n() {
    this.#e = window.requestAnimationFrame(() => {
      je(this.#e) || (this.#t(), this.#n());
    });
  }
}
class Ly {
  #e;
  #t;
  #n = !1;
  #i = !1;
  #r = !1;
  #a = new zd(this.#d.bind(this));
  #s = new xy();
  #l;
  get #o() {
    return this.#e.media;
  }
  constructor(e, n) {
    this.#e = e, this.#t = n, this.#l = new Ae(e.media), this.#p(), this.#s.connect(), N(this.#M.bind(this)), ue(this.#c.bind(this));
  }
  #c() {
    this.#i = !1, this.#r = !1, this.#a.stop(), this.#l.abort(), this.#S?.clear();
  }
  /**
   * The `timeupdate` event fires surprisingly infrequently during playback, meaning your progress
   * bar (or whatever else is synced to the currentTime) moves in a choppy fashion. This helps
   * resolve that by retrieving time updates in a request animation frame loop.
   */
  #_ = 0;
  #u = -1;
  #d() {
    const e = this.#o.currentTime;
    !(ia && e - this.#u < 0.35) && this.#_ !== e && (this.#h(e), this.#_ = e);
  }
  #p() {
    this.#m("loadstart", this.#C), this.#m("abort", this.#g), this.#m("emptied", this.#R), this.#m("error", this.#H), this.#m("volumechange", this.#G);
  }
  #E() {
    this.#i || (this.#m("loadeddata", this.#y), this.#m("loadedmetadata", this.#N), this.#m("canplay", this.#A), this.#m("canplaythrough", this.#D), this.#m("durationchange", this.#P), this.#m("play", this.#v), this.#m("progress", this.#B), this.#m("stalled", this.#L), this.#m("suspend", this.#$), this.#m("ratechange", this.#V), this.#i = !0);
  }
  #f() {
    this.#r || (this.#m("pause", this.#I), this.#m("playing", this.#w), this.#m("seeked", this.#Y), this.#m("seeking", this.#F), this.#m("ended", this.#k), this.#m("waiting", this.#x), this.#r = !0);
  }
  #S = void 0;
  #T = void 0;
  #m(e, n) {
    this.#l.add(e, n.bind(this));
  }
  #b(e) {
  }
  #h(e, n) {
    const i = Math.min(e, this.#t.$state.seekableEnd());
    this.#t.notify("time-change", i, n);
  }
  #C(e) {
    if (this.#o.networkState === 3) {
      this.#g(e);
      return;
    }
    this.#E(), this.#t.notify("load-start", void 0, e);
  }
  #g(e) {
    this.#t.notify("abort", void 0, e);
  }
  #R() {
    this.#t.notify("emptied", void 0, event);
  }
  #y(e) {
    this.#t.notify("loaded-data", void 0, e);
  }
  #N(e) {
    this.#_ = 0, this.#u = -1, this.#f(), this.#t.notify("loaded-metadata", void 0, e), (js || ia && Ai(this.#t.$state.source())) && this.#t.delegate.ready(this.#O(), e);
  }
  #O() {
    return {
      provider: F(this.#t.$provider),
      duration: this.#o.duration,
      buffered: this.#o.buffered,
      seekable: this.#o.seekable
    };
  }
  #v(e) {
    this.#t.$state.canPlay && this.#t.notify("play", void 0, e);
  }
  #I(e) {
    this.#o.readyState === 1 && !this.#n || (this.#n = !1, this.#a.stop(), this.#t.notify("pause", void 0, e));
  }
  #A(e) {
    this.#t.delegate.ready(this.#O(), e);
  }
  #D(e) {
    this.#t.$state.started() || this.#t.notify("can-play-through", this.#O(), e);
  }
  #w(e) {
    this.#o.paused || (this.#n = !1, this.#t.notify("playing", void 0, e), this.#a.start());
  }
  #L(e) {
    this.#t.notify("stalled", void 0, e), this.#o.readyState < 3 && (this.#n = !0, this.#t.notify("waiting", void 0, e));
  }
  #x(e) {
    this.#o.readyState < 3 && (this.#n = !0, this.#t.notify("waiting", void 0, e));
  }
  #k(e) {
    this.#a.stop(), this.#h(this.#o.duration, e), this.#t.notify("end", void 0, e), this.#t.$state.loop() && ed(this.#o.controls) && (this.#o.controls = !1);
  }
  #M() {
    const e = this.#t.$state.paused(), n = this.#s.visibility === "hidden";
    (e || n) && Ve(this.#o, "timeupdate", this.#U.bind(this));
  }
  #U(e) {
    this.#h(this.#o.currentTime, e);
  }
  #P(e) {
    this.#t.$state.ended() && this.#h(this.#o.duration, e), this.#t.notify("duration-change", this.#o.duration, e);
  }
  #G(e) {
    const n = {
      volume: this.#o.volume,
      muted: this.#o.muted
    };
    this.#t.notify("volume-change", n, e);
  }
  #Y(e) {
    this.#u = this.#o.currentTime, this.#h(this.#o.currentTime, e), this.#t.notify("seeked", this.#o.currentTime, e), Math.trunc(this.#o.currentTime) === Math.trunc(this.#o.duration) && _s(this.#o.duration) > _s(this.#o.currentTime) && (this.#h(this.#o.duration, e), this.#o.ended || this.#t.player.dispatch(
      new Se("media-play-request", {
        trigger: e
      })
    ));
  }
  #F(e) {
    this.#t.notify("seeking", this.#o.currentTime, e);
  }
  #B(e) {
    const n = {
      buffered: this.#o.buffered,
      seekable: this.#o.seekable
    };
    this.#t.notify("progress", n, e);
  }
  #$(e) {
    this.#t.notify("suspend", void 0, e);
  }
  #V(e) {
    this.#t.notify("rate-change", this.#o.playbackRate, e);
  }
  #H(e) {
    const n = this.#o.error;
    if (!n) return;
    const i = {
      message: n.message,
      code: n.code,
      mediaError: n
    };
    this.#t.notify("error", i, e);
  }
}
class Py {
  #e;
  #t;
  get #n() {
    return this.#e.media.audioTracks;
  }
  constructor(e, n) {
    this.#e = e, this.#t = n, this.#n.onaddtrack = this.#i.bind(this), this.#n.onremovetrack = this.#r.bind(this), this.#n.onchange = this.#a.bind(this), Ve(this.#t.audioTracks, "change", this.#l.bind(this));
  }
  #i(e) {
    const n = e.track;
    if (n.label === "") return;
    const i = n.id.toString() || `native-audio-${this.#t.audioTracks.length}`, r = {
      id: i,
      label: n.label,
      language: n.language,
      kind: n.kind,
      selected: !1
    };
    this.#t.audioTracks[le.add](r, e), n.enabled && (r.selected = !0);
  }
  #r(e) {
    const n = this.#t.audioTracks.getById(e.track.id);
    n && this.#t.audioTracks[le.remove](n, e);
  }
  #a(e) {
    let n = this.#s();
    if (!n) return;
    const i = this.#t.audioTracks.getById(n.id);
    i && this.#t.audioTracks[le.select](i, !0, e);
  }
  #s() {
    return Array.from(this.#n).find((e) => e.enabled);
  }
  #l(e) {
    const { current: n } = e.detail;
    if (!n) return;
    const i = this.#n.getTrackById(n.id);
    if (i) {
      const r = this.#s();
      r && (r.enabled = !1), i.enabled = !0;
    }
  }
}
class ky {
  constructor(e, n) {
    this.media = e, this.ctx = n, this.audioGain = new My(e, (i) => {
      this.ctx.notify("audio-gain-change", i);
    });
  }
  scope = Si();
  currentSrc = null;
  audioGain;
  setup() {
    new Ly(this, this.ctx), "audioTracks" in this.media && new Py(this, this.ctx), ue(() => {
      this.audioGain.destroy(), this.media.srcObject = null, this.media.removeAttribute("src");
      for (const e of this.media.querySelectorAll("source")) e.remove();
      this.media.load();
    });
  }
  get type() {
    return "";
  }
  setPlaybackRate(e) {
    this.media.playbackRate = e;
  }
  async play() {
    return this.media.play();
  }
  async pause() {
    return this.media.pause();
  }
  setMuted(e) {
    this.media.muted = e;
  }
  setVolume(e) {
    this.media.volume = e;
  }
  setCurrentTime(e) {
    this.media.currentTime = e;
  }
  setPlaysInline(e) {
    re(this.media, "playsinline", e);
  }
  async loadSource({ src: e, type: n }, i) {
    this.media.preload = i || "", IC(e) ? (this.removeSource(), this.media.srcObject = e) : (this.media.srcObject = null, Q(e) ? n !== "?" ? this.appendSource({ src: e, type: n }) : (this.removeSource(), this.media.src = this.#e(e)) : (this.removeSource(), this.media.src = window.URL.createObjectURL(e))), this.media.load(), this.currentSrc = { src: e, type: n };
  }
  /**
   * Append source so it works when requesting AirPlay since hls.js will remove it.
   */
  appendSource(e, n) {
    const i = this.media.querySelector("source[data-vds]"), r = i ?? document.createElement("source");
    re(r, "src", this.#e(e.src)), re(r, "type", e.type !== "?" ? e.type : n), re(r, "data-vds", ""), i || this.media.append(r);
  }
  removeSource() {
    this.media.querySelector("source[data-vds]")?.remove();
  }
  #e(e) {
    const { clipStartTime: n, clipEndTime: i } = this.ctx.$state, r = n(), a = i();
    return r > 0 && a > 0 ? `${e}#t=${r},${a}` : r > 0 ? `${e}#t=${r}` : a > 0 ? `${e}#t=0,${a}` : e;
  }
}
class Uy {
  #e;
  #t;
  #n;
  #i = j(!1);
  get supported() {
    return this.#i();
  }
  constructor(e, n) {
    this.#e = e, this.#t = n, this.#r();
  }
  #r() {
    H || !this.#e?.remote || !this.canPrompt || (this.#e.remote.watchAvailability((e) => {
      this.#i.set(e);
    }).catch(() => {
      this.#i.set(!1);
    }), N(this.#a.bind(this)));
  }
  #a() {
    if (!this.#i()) return;
    const e = ["connecting", "connect", "disconnect"], n = this.#s.bind(this);
    n(), Ve(this.#e, "playing", n);
    const i = new Ae(this.#e.remote);
    for (const r of e)
      i.add(r, n);
  }
  async prompt() {
    if (!this.supported) throw Error("Not supported on this platform.");
    return this.type === "airplay" && this.#e.webkitShowPlaybackTargetPicker ? this.#e.webkitShowPlaybackTargetPicker() : this.#e.remote.prompt();
  }
  #s(e) {
    const n = this.#e.remote.state;
    if (n === this.#n) return;
    const i = { type: this.type, state: n };
    this.#t.notify("remote-playback-change", i, e), this.#n = n;
  }
}
class Fy extends Uy {
  type = "airplay";
  get canPrompt() {
    return "WebKitPlaybackTargetAvailabilityEvent" in window;
  }
}
class By {
  #e;
  #t;
  constructor(e, n) {
    this.#e = e, this.#t = n, e.textTracks.onaddtrack = this.#n.bind(this), ue(this.#i.bind(this));
  }
  #n(e) {
    const n = e.track;
    if (!n || Gy(this.#e, n)) return;
    const i = new Vn({
      id: n.id,
      kind: n.kind,
      label: n.label ?? "",
      language: n.language,
      type: "vtt"
    });
    i[ie.native] = { track: n }, i[ie.readyState] = 2, i[ie.nativeHLS] = !0;
    let r = 0;
    const a = (s) => {
      if (n.cues)
        for (let o = r; o < n.cues.length; o++)
          i.addCue(n.cues[o], s), r++;
    };
    a(e), n.oncuechange = a, this.#t.textTracks.add(i, e), i.setMode(n.mode, e);
  }
  #i() {
    this.#e.textTracks.onaddtrack = null;
    for (const e of this.#t.textTracks) {
      const n = e[ie.native]?.track;
      n?.oncuechange && (n.oncuechange = null);
    }
  }
}
function Gy(t, e) {
  return Array.from(t.children).find((n) => n.track === e);
}
class Yy {
  #e;
  #t;
  constructor(e, n) {
    this.#e = e, this.#t = n, new Ae(e).add("enterpictureinpicture", this.#n.bind(this)).add("leavepictureinpicture", this.#i.bind(this));
  }
  get active() {
    return document.pictureInPictureElement === this.#e;
  }
  get supported() {
    return xd(this.#e);
  }
  async enter() {
    return this.#e.requestPictureInPicture();
  }
  exit() {
    return document.exitPictureInPicture();
  }
  #n(e) {
    this.#r(!0, e);
  }
  #i(e) {
    this.#r(!1, e);
  }
  #r = (e, n) => {
    this.#t.notify("picture-in-picture-change", e, n);
  };
}
class $y {
  #e;
  #t;
  #n = "inline";
  get mode() {
    return this.#n;
  }
  constructor(e, n) {
    this.#e = e, this.#t = n, Ve(e, "webkitpresentationmodechanged", this.#i.bind(this));
  }
  get supported() {
    return Ld(this.#e);
  }
  async setPresentationMode(e) {
    this.#n !== e && this.#e.webkitSetPresentationMode(e);
  }
  #i(e) {
    const n = this.#n;
    this.#n = this.#e.webkitPresentationMode, this.#t.player?.dispatch(
      new Se("video-presentation-change", {
        detail: this.#n,
        trigger: e
      })
    ), ["fullscreen", "picture-in-picture"].forEach((i) => {
      (this.#n === i || n === i) && this.#t.notify(`${i}-change`, this.#n === i, e);
    });
  }
}
class Vy {
  #e;
  get active() {
    return this.#e.mode === "fullscreen";
  }
  get supported() {
    return this.#e.supported;
  }
  constructor(e) {
    this.#e = e;
  }
  async enter() {
    this.#e.setPresentationMode("fullscreen");
  }
  async exit() {
    this.#e.setPresentationMode("inline");
  }
}
class Hy {
  #e;
  get active() {
    return this.#e.mode === "picture-in-picture";
  }
  get supported() {
    return this.#e.supported;
  }
  constructor(e) {
    this.#e = e;
  }
  async enter() {
    this.#e.setPresentationMode("picture-in-picture");
  }
  async exit() {
    this.#e.setPresentationMode("inline");
  }
}
let Wd = class extends ky {
  $$PROVIDER_TYPE = "VIDEO";
  get type() {
    return "video";
  }
  airPlay;
  fullscreen;
  pictureInPicture;
  constructor(e, n) {
    super(e, n), Tt(() => {
      if (this.airPlay = new Fy(e, n), Ld(e)) {
        const i = new $y(e, n);
        this.fullscreen = new Vy(i), this.pictureInPicture = new Hy(i);
      } else xd(e) && (this.pictureInPicture = new Yy(e, n));
    }, this.scope);
  }
  setup() {
    super.setup(), wd(this.video) && new By(this.video, this.ctx), this.ctx.textRenderers.attachVideo(this.video), ue(() => {
      this.ctx.textRenderers.attachVideo(null);
    }), this.type === "video" && this.ctx.notify("provider-setup", this);
  }
  /**
   * The native HTML `<video>` element.
   *
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLVideoElement}
   */
  get video() {
    return this.media;
  }
};
var qy = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  VideoProvider: Wd
});
function Vl(t) {
  try {
    return new Intl.DisplayNames(navigator.languages, { type: "language" }).of(t) ?? null;
  } catch {
    return null;
  }
}
const zy = (t) => `dash-${ma(t)}`;
class Wy {
  #e;
  #t;
  #n = null;
  #i = /* @__PURE__ */ new Set();
  #r = null;
  config = {};
  get instance() {
    return this.#n;
  }
  constructor(e, n) {
    this.#e = e, this.#t = n;
  }
  setup(e) {
    this.#n = e().create();
    const n = this.#o.bind(this);
    for (const i of Object.values(e.events)) this.#n.on(i, n);
    this.#n.on(e.events.ERROR, this.#S.bind(this));
    for (const i of this.#i) i(this.#n);
    this.#t.player.dispatch("dash-instance", {
      detail: this.#n
    }), this.#n.initialize(this.#e, void 0, !1), this.#n.updateSettings({
      streaming: {
        text: {
          // Disabling text rendering by dash.
          defaultEnabled: !1,
          dispatchForManualRendering: !0
        },
        buffer: {
          /// Enables buffer replacement when switching bitrates for faster switching.
          fastSwitchEnabled: !0
        }
      },
      ...this.config
    }), this.#n.on(e.events.FRAGMENT_LOADING_STARTED, this.#T.bind(this)), this.#n.on(
      e.events.FRAGMENT_LOADING_COMPLETED,
      this.#m.bind(this)
    ), this.#n.on(e.events.MANIFEST_LOADED, this.#f.bind(this)), this.#n.on(e.events.QUALITY_CHANGE_RENDERED, this.#E.bind(this)), this.#n.on(e.events.TEXT_TRACKS_ADDED, this.#d.bind(this)), this.#n.on(e.events.TRACK_CHANGE_RENDERED, this.#p.bind(this)), this.#t.qualities[Mt.enableAuto] = this.#R.bind(this), Ve(this.#t.qualities, "change", this.#N.bind(this)), Ve(this.#t.audioTracks, "change", this.#O.bind(this)), this.#r = N(this.#s.bind(this));
  }
  #a(e) {
    return new Se(zy(e.type), { detail: e });
  }
  #s() {
    if (!this.#t.$state.live()) return;
    const e = new zd(this.#l.bind(this));
    return e.start(), e.stop.bind(e);
  }
  #l() {
    if (!this.#n) return;
    const e = this.#n.duration() - this.#n.time();
    this.#t.$state.liveSyncPosition.set(isNaN(e) ? 1 / 0 : e);
  }
  #o(e) {
    this.#t.player?.dispatch(this.#a(e));
  }
  #c = null;
  #_ = {};
  #u(e) {
    const n = this.#c?.[ie.native], i = (n?.track).cues;
    if (!n || !i) return;
    const r = this.#c.id, a = this.#_[r] ?? 0, s = this.#a(e);
    for (let o = a; o < i.length; o++) {
      const l = i[o];
      l.positionAlign || (l.positionAlign = "auto"), this.#c.addCue(l, s);
    }
    this.#_[r] = i.length;
  }
  #d(e) {
    if (!this.#n) return;
    const n = e.tracks, i = [...this.#e.textTracks].filter((a) => "manualMode" in a), r = this.#a(e);
    for (let a = 0; a < i.length; a++) {
      const s = n[a], o = i[a], l = `dash-${s.kind}-${a}`, c = new Vn({
        id: l,
        label: s?.label ?? s.labels.find((d) => d.text)?.text ?? (s?.lang && Vl(s.lang)) ?? s?.lang ?? void 0,
        language: s.lang ?? void 0,
        kind: s.kind,
        default: s.defaultTrack
      });
      c[ie.native] = {
        managed: !0,
        track: o
      }, c[ie.readyState] = 2, c[ie.onModeChange] = () => {
        this.#n && (c.mode === "showing" ? (this.#n.setTextTrack(a), this.#c = c) : (this.#n.setTextTrack(-1), this.#c = null));
      }, this.#t.textTracks.add(c, r);
    }
  }
  #p(e) {
    const { mediaType: n, newMediaInfo: i } = e;
    if (n === "audio") {
      const r = this.#t.audioTracks.getById(`dash-audio-${i.index}`);
      if (r) {
        const a = this.#a(e);
        this.#t.audioTracks[le.select](r, !0, a);
      }
    }
  }
  #E(e) {
    if (e.mediaType !== "video") return;
    const n = this.#t.qualities[e.newQuality];
    if (n) {
      const i = this.#a(e);
      this.#t.qualities[le.select](n, !0, i);
    }
  }
  #f(e) {
    if (this.#t.$state.canPlay() || !this.#n) return;
    const { type: n, mediaPresentationDuration: i } = e.data, r = this.#a(e);
    this.#t.notify("stream-type-change", n !== "static" ? "live" : "on-demand", r), this.#t.notify("duration-change", i, r), this.#t.qualities[Mt.setAuto](!0, r);
    const a = this.#n.getVideoElement(), s = this.#n.getTracksForTypeFromManifest(
      "video",
      e.data
    ), o = [...new Set(s.map((u) => u.mimeType))].find(
      (u) => u && Md(a, u)
    ), l = s.filter(
      (u) => o === u.mimeType
    )[0];
    let c = this.#n.getTracksForTypeFromManifest(
      "audio",
      e.data
    );
    const d = [...new Set(c.map((u) => u.mimeType))].find(
      (u) => u && Dd(a, u)
    );
    if (c = c.filter((u) => d === u.mimeType), l.bitrateList.forEach((u, _) => {
      const m = {
        id: u.id?.toString() ?? `dash-bitrate-${_}`,
        width: u.width ?? 0,
        height: u.height ?? 0,
        bitrate: u.bandwidth ?? 0,
        codec: l.codec,
        index: _
      };
      this.#t.qualities[le.add](m, r);
    }), mt(l.index)) {
      const u = this.#t.qualities[l.index];
      u && this.#t.qualities[le.select](u, !0, r);
    }
    c.forEach((u, _) => {
      const g = u.labels.find((E) => navigator.languages.some((h) => E.lang && h.toLowerCase().startsWith(E.lang.toLowerCase()))) || u.labels[0], S = {
        id: `dash-audio-${u?.index}`,
        label: g?.text ?? (u.lang && Vl(u.lang)) ?? u.lang ?? "",
        language: u.lang ?? "",
        kind: "main",
        mimeType: u.mimeType,
        codec: u.codec,
        index: _
      };
      this.#t.audioTracks[le.add](S, r);
    }), a.dispatchEvent(new Se("canplay", { trigger: r }));
  }
  #S(e) {
    const { type: n, error: i } = e;
    i.code === 27 ? this.#h(i) : this.#g(i);
  }
  #T() {
    this.#b >= 0 && this.#C();
  }
  #m(e) {
    e.mediaType === "text" && requestAnimationFrame(this.#u.bind(this, e));
  }
  #b = -1;
  #h(e) {
    this.#C(), this.#n?.play(), this.#b = window.setTimeout(() => {
      this.#b = -1, this.#g(e);
    }, 5e3);
  }
  #C() {
    clearTimeout(this.#b), this.#b = -1;
  }
  #g(e) {
    this.#t.notify("error", {
      message: e.message ?? "",
      code: 1,
      error: e
    });
  }
  #R() {
    this.#y("video", !0);
    const { qualities: e } = this.#t;
    this.#n?.setQualityFor("video", e.selectedIndex, !0);
  }
  #y(e, n) {
    this.#n?.updateSettings({
      streaming: { abr: { autoSwitchBitrate: { [e]: n } } }
    });
  }
  #N() {
    const { qualities: e } = this.#t;
    !this.#n || e.auto || !e.selected || (this.#y("video", !1), this.#n.setQualityFor("video", e.selectedIndex, e.switch === "current"), Ad && (this.#e.currentTime = this.#e.currentTime));
  }
  #O() {
    if (!this.#n) return;
    const { audioTracks: e } = this.#t, n = this.#n.getTracksFor("audio").find(
      (i) => e.selected && e.selected.id === `dash-audio-${i.index}`
    );
    n && this.#n.setCurrentTrack(n);
  }
  #v() {
    this.#C(), this.#c = null, this.#_ = {};
  }
  onInstance(e) {
    return this.#i.add(e), () => this.#i.delete(e);
  }
  loadSource(e) {
    this.#v(), Q(e.src) && this.#n?.attachSource(e.src);
  }
  destroy() {
    this.#v(), this.#n?.destroy(), this.#n = null, this.#r?.(), this.#r = null;
  }
}
function $r(t) {
  return t instanceof Error ? t : Error(typeof t == "string" ? t : JSON.stringify(t));
}
function hn(t, e) {
  if (!t)
    throw Error("Assertion failed.");
}
class Ky {
  #e;
  #t;
  #n;
  constructor(e, n, i) {
    this.#e = e, this.#t = n, this.#n = i, this.#i();
  }
  async #i() {
    const e = {
      onLoadStart: this.#r.bind(this),
      onLoaded: this.#a.bind(this),
      onLoadError: this.#s.bind(this)
    };
    let n = await Xy(this.#e, e);
    if (je(n) && !Q(this.#e) && (n = await Qy(this.#e, e)), !n) return null;
    if (!window.dashjs.supportsMediaSource()) {
      const i = "[vidstack] `dash.js` is not supported in this environment";
      return this.#t.player.dispatch(new Se("dash-unsupported")), this.#t.notify("error", { message: i, code: 4 }), null;
    }
    return n;
  }
  #r() {
    this.#t.player.dispatch(new Se("dash-lib-load-start"));
  }
  #a(e) {
    this.#t.player.dispatch(
      new Se("dash-lib-loaded", {
        detail: e
      })
    ), this.#n(e);
  }
  #s(e) {
    const n = $r(e);
    this.#t.player.dispatch(
      new Se("dash-lib-load-error", {
        detail: n
      })
    ), this.#t.notify("error", {
      message: n.message,
      code: 4,
      error: n
    });
  }
}
async function Qy(t, e = {}) {
  if (!je(t)) {
    if (e.onLoadStart?.(), Zy(t))
      return e.onLoaded?.(t), t;
    if (Hl(t)) {
      const n = t.MediaPlayer;
      return e.onLoaded?.(n), n;
    }
    try {
      const n = (await t())?.default;
      if (Hl(n))
        return e.onLoaded?.(n.MediaPlayer), n.MediaPlayer;
      if (n)
        e.onLoaded?.(n);
      else
        throw Error(
          ""
        );
      return n;
    } catch (n) {
      e.onLoadError?.(n);
    }
  }
}
async function Xy(t, e = {}) {
  if (Q(t)) {
    e.onLoadStart?.();
    try {
      if (await DC(t), !yt(window.dashjs.MediaPlayer))
        throw Error(
          ""
        );
      const n = window.dashjs.MediaPlayer;
      return e.onLoaded?.(n), n;
    } catch (n) {
      e.onLoadError?.(n);
    }
  }
}
function Zy(t) {
  return t && t.prototype && t.prototype !== Function;
}
function Hl(t) {
  return t && "MediaPlayer" in t;
}
const Jy = "https://cdn.jsdelivr.net";
class jy extends Wd {
  $$PROVIDER_TYPE = "DASH";
  #e = null;
  #t = new Wy(this.video, this.ctx);
  /**
   * The `dash.js` constructor.
   */
  get ctor() {
    return this.#e;
  }
  /**
   * The current `dash.js` instance.
   */
  get instance() {
    return this.#t.instance;
  }
  /**
   * Whether `dash.js` is supported in this environment.
   */
  static supported = Pd();
  get type() {
    return "dash";
  }
  get canLiveSync() {
    return !0;
  }
  #n = `${Jy}/npm/dashjs@4.7.4/dist/dash.all.min.js`;
  /**
   * The `dash.js` configuration object.
   *
   * @see {@link https://cdn.dashjs.org/latest/jsdoc/module-Settings.html}
   */
  get config() {
    return this.#t.config;
  }
  set config(e) {
    this.#t.config = e;
  }
  /**
   * The `dash.js` constructor (supports dynamic imports) or a URL of where it can be found.
   *
   * @defaultValue `https://cdn.jsdelivr.net/npm/dashjs@4.7.4/dist/dash.all.min.js`
   */
  get library() {
    return this.#n;
  }
  set library(e) {
    this.#n = e;
  }
  preconnect() {
    Q(this.#n) && Ii(this.#n);
  }
  setup() {
    super.setup(), new Ky(this.#n, this.ctx, (e) => {
      this.#e = e, this.#t.setup(e), this.ctx.notify("provider-setup", this);
      const n = F(this.ctx.$state.source);
      n && this.loadSource(n);
    });
  }
  async loadSource(e, n) {
    if (!Q(e.src)) {
      this.removeSource();
      return;
    }
    this.media.preload = n || "", this.appendSource(e, "application/x-mpegurl"), this.#t.loadSource(e), this.currentSrc = e;
  }
  /**
   * The given callback is invoked when a new `dash.js` instance is created and right before it's
   * attached to media.
   */
  onInstance(e) {
    const n = this.#t.instance;
    return n && e(n), this.#t.onInstance(e);
  }
  destroy() {
    this.#t.destroy();
  }
}
var eR = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  DASHProvider: jy
});
class uo extends oo {
  static supported = Pd();
  name = "dash";
  canPlay(e) {
    return uo.supported && io(e);
  }
  async load(e) {
    if (H)
      throw Error("[vidstack] can not load dash provider server-side");
    return new (await Promise.resolve().then(function() {
      return eR;
    })).DASHProvider(this.target, e);
  }
}
class tR {
  name = "vimeo";
  target;
  preconnect() {
    const e = [
      "https://i.vimeocdn.com",
      "https://f.vimeocdn.com",
      "https://fresnel.vimeocdn.com"
    ];
    for (const n of e)
      Ii(n);
  }
  canPlay(e) {
    return Q(e.src) && e.type === "video/vimeo";
  }
  mediaType() {
    return "video";
  }
  async load(e) {
    if (H)
      throw Error("[vidstack] can not load vimeo provider server-side");
    return new (await import("./vidstack-BqgQkvb4-Dadz6dij.js")).VimeoProvider(this.target, e);
  }
  async loadPoster(e, n, i) {
    const { resolveVimeoVideoId: r, getVimeoVideoInfo: a } = await import("./vidstack-krOAtKMi-CpIdpldx.js");
    if (!Q(e.src)) return null;
    const { videoId: s, hash: o } = r(e.src);
    return s ? a(s, i, o).then((l) => l ? l.poster : null) : null;
  }
}
class nR {
  name = "youtube";
  target;
  preconnect() {
    const e = [
      // Botguard script.
      "https://www.google.com",
      // Posters.
      "https://i.ytimg.com",
      // Ads.
      "https://googleads.g.doubleclick.net",
      "https://static.doubleclick.net"
    ];
    for (const n of e)
      Ii(n);
  }
  canPlay(e) {
    return Q(e.src) && e.type === "video/youtube";
  }
  mediaType() {
    return "video";
  }
  async load(e) {
    if (H)
      throw Error("[vidstack] can not load youtube provider server-side");
    return new (await import("./vidstack-DHmfHold-RkxNfW6e.js")).YouTubeProvider(this.target, e);
  }
  async loadPoster(e, n, i) {
    const { findYouTubePoster: r, resolveYouTubeVideoId: a } = await import("./vidstack-Dm1xEU9Q-CBrl43Bg.js"), s = Q(e.src) && a(e.src);
    return s ? r(s, i) : null;
  }
}
function za(t, e) {
  const n = String(t), i = n.length;
  if (i < e) {
    const a = e - i;
    return `${"0".repeat(a)}${t}`;
  }
  return n;
}
function Kd(t) {
  const e = Math.trunc(t / 3600), n = Math.trunc(t % 3600 / 60), i = Math.trunc(t % 60), r = Number((t - Math.trunc(t)).toPrecision(3));
  return {
    hours: e,
    minutes: n,
    seconds: i,
    fraction: r
  };
}
function _o(t, { padHrs: e = null, padMins: n = null, showHrs: i = !1, showMs: r = !1 } = {}) {
  const { hours: a, minutes: s, seconds: o, fraction: l } = Kd(t), c = e ? za(a, 2) : a, d = n || Qt(n) && t >= 3600 ? za(s, 2) : s, u = za(o, 2), _ = r && l > 0 ? `.${String(l).replace(/^0?\./, "")}` : "", m = `${d}:${u}${_}`;
  return a > 0 || i ? `${c}:${m}` : m;
}
function ql(t) {
  const e = [], { hours: n, minutes: i, seconds: r } = Kd(t);
  return n > 0 && e.push(`${n} hour`), i > 0 && e.push(`${i} min`), (r > 0 || e.length === 0) && e.push(`${r} sec`), e.join(" ");
}
const Wa = /* @__PURE__ */ Symbol(0), iR = [
  "autoPlay",
  "canAirPlay",
  "canFullscreen",
  "canGoogleCast",
  "canLoad",
  "canLoadPoster",
  "canPictureInPicture",
  "canPlay",
  "canSeek",
  "ended",
  "fullscreen",
  "isAirPlayConnected",
  "isGoogleCastConnected",
  "live",
  "liveEdge",
  "loop",
  "mediaType",
  "muted",
  "paused",
  "pictureInPicture",
  "playing",
  "playsInline",
  "remotePlaybackState",
  "remotePlaybackType",
  "seeking",
  "started",
  "streamType",
  "viewType",
  "waiting"
], rR = {
  artist: "",
  artwork: null,
  autoplay: !1,
  autoPlay: !1,
  clipStartTime: 0,
  clipEndTime: 0,
  controls: !1,
  currentTime: 0,
  crossorigin: null,
  crossOrigin: null,
  duration: -1,
  fullscreenOrientation: "landscape",
  googleCast: {},
  load: "visible",
  posterLoad: "visible",
  logLevel: "silent",
  loop: !1,
  muted: !1,
  paused: !0,
  playsinline: !1,
  playsInline: !1,
  playbackRate: 1,
  poster: "",
  preload: "metadata",
  preferNativeHLS: !1,
  src: "",
  title: "",
  controlsDelay: 2e3,
  hideControlsOnMouseLeave: !1,
  viewType: "unknown",
  streamType: "unknown",
  volume: 1,
  liveEdgeTolerance: 10,
  minLiveDVRWindow: 60,
  keyDisabled: !1,
  keyTarget: "player",
  keyShortcuts: Sy,
  storage: null
};
class zl extends Qn {
  #e;
  #t;
  constructor(e, n) {
    super(), this.#e = e, this.#t = n;
  }
  async onAttach(e) {
    if (H) return;
    const n = this.$props[this.#e]();
    if (n === "eager")
      requestAnimationFrame(this.#t);
    else if (n === "idle")
      pd(this.#t);
    else if (n === "visible") {
      let i, r = new IntersectionObserver((a) => {
        this.scope && a[0].isIntersecting && (i?.(), i = void 0, this.#t());
      });
      r.observe(e), i = ue(() => r.disconnect());
    }
  }
}
class aR {
  #e;
  #t;
  constructor(e, n) {
    this.#e = e, this.#t = n;
  }
  notify(e, ...n) {
    H || this.#e(
      new Se(e, {
        detail: n?.[0],
        trigger: n?.[1]
      })
    );
  }
  async ready(e, n) {
    if (!H)
      return Ei(async () => {
        const { logger: i } = this.#t, {
          autoPlay: r,
          canPlay: a,
          started: s,
          duration: o,
          seekable: l,
          buffered: c,
          remotePlaybackInfo: d,
          playsInline: u,
          savedState: _,
          source: m
        } = this.#t.$state;
        if (a()) return;
        const g = {
          duration: e?.duration ?? o(),
          seekable: e?.seekable ?? l(),
          buffered: e?.buffered ?? c(),
          provider: this.#t.$provider()
        };
        this.notify("can-play", g, n), on();
        let S = this.#t.$provider(), { storage: E, qualities: h } = this.#t, { muted: T, volume: b, clipStartTime: C, playbackRate: y } = this.#t.$props;
        await E?.onLoad?.(m());
        const O = _()?.currentTime, A = _()?.paused, I = await E?.getTime(), k = O ?? I ?? C(), x = A === !1 || A !== !0 && !s() && r();
        if (S) {
          S.setVolume(await E?.getVolume() ?? b()), S.setMuted(T() || !!await E?.getMuted());
          const X = await E?.getAudioGain() ?? 1;
          X > 1 && S.audioGain?.setGain?.(X), S.setPlaybackRate?.(await E?.getPlaybackRate() ?? y()), S.setPlaysInline?.(u()), k > 0 && S.setCurrentTime(k);
        }
        const B = await E?.getVideoQuality();
        if (B && h.length) {
          let X = null, J = 1 / 0;
          for (const D of h) {
            const L = Math.abs(B.width - D.width) + Math.abs(B.height - D.height) + (B.bitrate ? Math.abs(B.bitrate - (D.bitrate ?? 0)) : 0);
            L < J && (X = D, J = L);
          }
          X && (X.selected = !0);
        }
        a() && x ? await this.#n(n) : I && I > 0 && this.notify("started", void 0, n), d.set(null);
      });
  }
  async #n(e) {
    const {
      player: n,
      $state: { autoPlaying: i, muted: r }
    } = this.#t;
    i.set(!0);
    const a = new Se("auto-play-attempt", { trigger: e });
    try {
      await n.play(a);
    } catch {
    }
  }
}
class sR {
  #e = /* @__PURE__ */ new Map();
  /**
   * Queue the given `item` under the given `key` to be processed at a later time by calling
   * `serve(key)`.
   */
  enqueue(e, n) {
    this.#e.set(e, n);
  }
  /**
   * Process item in queue for the given `key`.
   */
  serve(e) {
    const n = this.peek(e);
    return this.#e.delete(e), n;
  }
  /**
   * Peek at item in queue for the given `key`.
   */
  peek(e) {
    return this.#e.get(e);
  }
  /**
   * Removes queued item under the given `key`.
   */
  delete(e) {
    this.#e.delete(e);
  }
  /**
   * Clear all items in the queue.
   */
  clear() {
    this.#e.clear();
  }
}
class Qd {
  #e = !1;
  #t = Jr();
  #n = /* @__PURE__ */ new Map();
  /**
   * The number of callbacks that are currently in queue.
   */
  get size() {
    return this.#n.size;
  }
  /**
   * Whether items in the queue are being served immediately, otherwise they're queued to
   * be processed later.
   */
  get isServing() {
    return this.#e;
  }
  /**
   * Waits for the queue to be flushed (ie: start serving).
   */
  async waitForFlush() {
    this.#e || await this.#t.promise;
  }
  /**
   * Queue the given `callback` to be invoked at a later time by either calling the `serve()` or
   * `start()` methods. If the queue has started serving (i.e., `start()` was already called),
   * then the callback will be invoked immediately.
   *
   * @param key - Uniquely identifies this callback so duplicates are ignored.
   * @param callback - The function to call when this item in the queue is being served.
   */
  enqueue(e, n) {
    if (this.#e) {
      n();
      return;
    }
    this.#n.delete(e), this.#n.set(e, n);
  }
  /**
   * Invokes the callback with the given `key` in the queue (if it exists).
   */
  serve(e) {
    this.#n.get(e)?.(), this.#n.delete(e);
  }
  /**
   * Flush all queued items and start serving future requests immediately until `stop()` is called.
   */
  start() {
    this.#i(), this.#e = !0, this.#n.size > 0 && this.#i();
  }
  /**
   * Stop serving requests, they'll be queued until you begin processing again by calling `start()`.
   */
  stop() {
    this.#e = !1;
  }
  /**
   * Stop serving requests, empty the request queue, and release any promises waiting for the
   * queue to flush.
   */
  reset() {
    this.stop(), this.#n.clear(), this.#r();
  }
  #i() {
    for (const e of this.#n.keys()) this.serve(e);
    this.#r();
  }
  #r() {
    this.#t.resolve(), this.#t = Jr();
  }
}
function oR(t) {
  return t ? "true" : "false";
}
function Pt(t) {
  return () => oR(t());
}
function lR() {
  return typeof window > "u" ? !1 : window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
class cR extends Qn {
  #e;
  #t;
  #n;
  controls;
  #i;
  #r;
  #a;
  #s = new Qd();
  constructor(e, n, i) {
    super(), this.#e = e, this.#t = n, this.#n = i, this.#a = i.$provider, this.controls = new Ry(), this.#i = new Ny(), this.#r = new ba();
  }
  onAttach() {
    this.listen("fullscreen-change", this.#C.bind(this));
  }
  onConnect(e) {
    const n = Object.getOwnPropertyNames(Object.getPrototypeOf(this)), i = new Ae(e), r = this.#c.bind(this);
    for (const a of n)
      a.startsWith("media-") && i.add(a, r);
    this.#l(), N(this.#o.bind(this)), N(this.#E.bind(this)), N(this.#f.bind(this)), N(this.#S.bind(this)), N(this.#T.bind(this)), N(this.#m.bind(this)), N(this.#b.bind(this));
  }
  onDestroy() {
    try {
      const e = this.createEvent("destroy"), { pictureInPicture: n, fullscreen: i } = this.$state;
      i() && this.exitFullscreen("prefer-media", e), n() && this.exitPictureInPicture(e);
    } catch {
    }
    this.#s.reset();
  }
  #l() {
    const { load: e } = this.$props, { canLoad: n } = this.$state;
    if (e() !== "play" || n()) return;
    const i = this.listen("media-play-request", (r) => {
      this.#_(r), i();
    });
  }
  #o() {
    const e = this.#a(), n = this.$state.canPlay();
    return e && n && this.#s.start(), () => {
      this.#s.stop();
    };
  }
  #c(e) {
    e.stopPropagation(), !e.defaultPrevented && this[e.type] && (F(this.#a) ? this[e.type](e) : this.#s.enqueue(e.type, () => {
      F(this.#a) && this[e.type](e);
    }));
  }
  async play(e) {
    if (H) return;
    const { canPlay: n, paused: i, autoPlaying: r } = this.$state;
    if (this.#_(e) || !F(i)) return;
    e && this.#t.queue.enqueue("media-play-request", e);
    const a = F(r);
    try {
      const s = F(this.#a);
      return Ka(s, F(n)), dR(a), await s.play();
    } catch (s) {
      const o = this.createEvent("play-fail", {
        detail: $r(s),
        trigger: e
      });
      throw o.autoPlay = a, this.#e.handle(o), s;
    }
  }
  #_(e) {
    const { load: n } = this.$props, { canLoad: i } = this.$state;
    if (n() === "play" && !i()) {
      const r = this.createEvent("media-start-loading", { trigger: e });
      return this.dispatchEvent(r), this.#s.enqueue("media-play-request", async () => {
        try {
          await this.play(r);
        } catch {
        }
      }), !0;
    }
    return !1;
  }
  async pause(e) {
    if (H) return;
    const { canPlay: n, paused: i } = this.$state;
    if (!F(i)) {
      e && this.#t.queue.enqueue("media-pause-request", e);
      try {
        const r = F(this.#a);
        return Ka(r, F(n)), await r.pause();
      } catch (r) {
        throw this.#t.queue.delete("media-pause-request"), r;
      }
    }
  }
  setAudioGain(e, n) {
    const { audioGain: i, canSetAudioGain: r } = this.$state;
    if (i() === e) return;
    const a = this.#a();
    if (!a?.audioGain || !r())
      throw Error("[vidstack] audio gain api not available");
    n && this.#t.queue.enqueue("media-audio-gain-change-request", n), a.audioGain.setGain(e);
  }
  seekToLiveEdge(e) {
    if (H) return;
    const { canPlay: n, live: i, liveEdge: r, canSeek: a, liveSyncPosition: s, seekableEnd: o, userBehindLiveEdge: l } = this.$state;
    if (l.set(!1), F(() => !i() || r() || !a())) return;
    const c = F(this.#a);
    Ka(c, F(n)), e && this.#t.queue.enqueue("media-seek-request", e);
    const d = o() - 2;
    c.setCurrentTime(Math.min(d, s() ?? d));
  }
  #u = !1;
  async enterFullscreen(e = "prefer-media", n) {
    if (H) return;
    const i = this.#d(e);
    if (Wl(e, i), !i.active)
      return F(this.$state.pictureInPicture) && (this.#u = !0, await this.exitPictureInPicture(n)), n && this.#t.queue.enqueue("media-enter-fullscreen-request", n), i.enter();
  }
  async exitFullscreen(e = "prefer-media", n) {
    if (H) return;
    const i = this.#d(e);
    if (Wl(e, i), !!i.active) {
      n && this.#t.queue.enqueue("media-exit-fullscreen-request", n);
      try {
        const r = await i.exit();
        return this.#u && F(this.$state.canPictureInPicture) && await this.enterPictureInPicture(), r;
      } finally {
        this.#u = !1;
      }
    }
  }
  #d(e) {
    const n = F(this.#a);
    return e === "prefer-media" && this.#i.supported || e === "media" ? this.#i : n?.fullscreen;
  }
  async enterPictureInPicture(e) {
    if (!H && (this.#p(), !this.$state.pictureInPicture()))
      return e && this.#t.queue.enqueue("media-enter-pip-request", e), await this.#a().pictureInPicture.enter();
  }
  async exitPictureInPicture(e) {
    if (!H && (this.#p(), !!this.$state.pictureInPicture()))
      return e && this.#t.queue.enqueue("media-exit-pip-request", e), await this.#a().pictureInPicture.exit();
  }
  #p() {
    if (!this.$state.canPictureInPicture())
      throw Error(
        "[vidstack] no pip support"
      );
  }
  #E() {
    this.controls.defaultDelay = this.$props.controlsDelay();
  }
  #f() {
    const { canSetAudioGain: e } = this.$state, n = !!this.#a()?.audioGain?.supported;
    e.set(n);
  }
  #S() {
    const { canAirPlay: e } = this.$state, n = !!this.#a()?.airPlay?.supported;
    e.set(n);
  }
  #T() {
    const { canGoogleCast: e, source: n } = this.$state, i = Ad && !js && AC(n());
    e.set(i);
  }
  #m() {
    const { canFullscreen: e } = this.$state, n = this.#i.supported || !!this.#a()?.fullscreen?.supported;
    e.set(n);
  }
  #b() {
    const { canPictureInPicture: e } = this.$state, n = !!this.#a()?.pictureInPicture?.supported;
    e.set(n);
  }
  async "media-airplay-request"(e) {
    try {
      await this.requestAirPlay(e);
    } catch {
    }
  }
  async requestAirPlay(e) {
    try {
      const n = this.#a()?.airPlay;
      if (!n?.supported)
        throw Error("No AirPlay adapter.");
      return e && this.#t.queue.enqueue("media-airplay-request", e), await n.prompt();
    } catch (n) {
      throw this.#t.queue.delete("media-airplay-request"), n;
    }
  }
  async "media-google-cast-request"(e) {
    try {
      await this.requestGoogleCast(e);
    } catch {
    }
  }
  #h;
  async requestGoogleCast(e) {
    try {
      const { canGoogleCast: n } = this.$state;
      if (!F(n)) {
        const r = Error(
          "Cast not available."
        );
        throw r.code = "CAST_NOT_AVAILABLE", r;
      }
      if (Ii("https://www.gstatic.com"), !this.#h) {
        const r = await import("./vidstack-CQQ1xKSy-yAqUigEJ.js").then(function(a) {
          return a.loader;
        });
        this.#h = new r.GoogleCastLoader();
      }
      await this.#h.prompt(this.#n), e && this.#t.queue.enqueue("media-google-cast-request", e);
      const i = F(this.$state.remotePlaybackState) !== "disconnected";
      i && this.$state.savedState.set({
        paused: F(this.$state.paused),
        currentTime: F(this.$state.currentTime)
      }), this.$state.remotePlaybackLoader.set(i ? this.#h : null);
    } catch (n) {
      throw this.#t.queue.delete("media-google-cast-request"), n;
    }
  }
  "media-clip-start-change-request"(e) {
    const { clipStartTime: n } = this.$state;
    n.set(e.detail);
  }
  "media-clip-end-change-request"(e) {
    const { clipEndTime: n } = this.$state;
    n.set(e.detail), this.dispatch("duration-change", {
      detail: e.detail,
      trigger: e
    });
  }
  "media-duration-change-request"(e) {
    const { providedDuration: n, clipEndTime: i } = this.$state;
    n.set(e.detail), i() <= 0 && this.dispatch("duration-change", {
      detail: e.detail,
      trigger: e
    });
  }
  "media-audio-track-change-request"(e) {
    const { logger: n, audioTracks: i } = this.#n;
    if (i.readonly)
      return;
    const r = e.detail, a = i[r];
    if (a) {
      const s = e.type;
      this.#t.queue.enqueue(s, e), a.selected = !0;
    }
  }
  async "media-enter-fullscreen-request"(e) {
    try {
      await this.enterFullscreen(e.detail, e);
    } catch (n) {
      this.#g(n, e);
    }
  }
  async "media-exit-fullscreen-request"(e) {
    try {
      await this.exitFullscreen(e.detail, e);
    } catch (n) {
      this.#g(n, e);
    }
  }
  async #C(e) {
    const n = F(this.$props.fullscreenOrientation), i = e.detail;
    if (!(je(n) || n === "none" || !this.#r.supported))
      if (i) {
        if (this.#r.locked) return;
        this.dispatch("media-orientation-lock-request", {
          detail: n,
          trigger: e
        });
      } else this.#r.locked && this.dispatch("media-orientation-unlock-request", {
        trigger: e
      });
  }
  #g(e, n) {
    this.#e.handle(
      this.createEvent("fullscreen-error", {
        detail: $r(e)
      })
    );
  }
  async "media-orientation-lock-request"(e) {
    const n = e.type;
    try {
      this.#t.queue.enqueue(n, e), await this.#r.lock(e.detail);
    } catch {
      this.#t.queue.delete(n);
    }
  }
  async "media-orientation-unlock-request"(e) {
    const n = e.type;
    try {
      this.#t.queue.enqueue(n, e), await this.#r.unlock();
    } catch {
      this.#t.queue.delete(n);
    }
  }
  async "media-enter-pip-request"(e) {
    try {
      await this.enterPictureInPicture(e);
    } catch (n) {
      this.#R(n, e);
    }
  }
  async "media-exit-pip-request"(e) {
    try {
      await this.exitPictureInPicture(e);
    } catch (n) {
      this.#R(n, e);
    }
  }
  #R(e, n) {
    this.#e.handle(
      this.createEvent("picture-in-picture-error", {
        detail: $r(e)
      })
    );
  }
  "media-live-edge-request"(e) {
    const { live: n, liveEdge: i, canSeek: r } = this.$state;
    if (!(!n() || i() || !r())) {
      this.#t.queue.enqueue("media-seek-request", e);
      try {
        this.seekToLiveEdge();
      } catch {
        this.#t.queue.delete("media-seek-request");
      }
    }
  }
  async "media-loop-request"(e) {
    try {
      this.#t.looping = !0, this.#t.replaying = !0, await this.play(e);
    } catch {
      this.#t.looping = !1;
    }
  }
  "media-user-loop-change-request"(e) {
    this.$state.userPrefersLoop.set(e.detail);
  }
  async "media-pause-request"(e) {
    if (!this.$state.paused())
      try {
        await this.pause(e);
      } catch {
      }
  }
  async "media-play-request"(e) {
    if (this.$state.paused())
      try {
        await this.play(e);
      } catch {
      }
  }
  "media-rate-change-request"(e) {
    const { playbackRate: n, canSetPlaybackRate: i } = this.$state;
    if (n() === e.detail || !i()) return;
    const r = this.#a();
    r?.setPlaybackRate && (this.#t.queue.enqueue("media-rate-change-request", e), r.setPlaybackRate(e.detail));
  }
  "media-audio-gain-change-request"(e) {
    try {
      this.setAudioGain(e.detail, e);
    } catch {
    }
  }
  "media-quality-change-request"(e) {
    const { qualities: n, storage: i, logger: r } = this.#n;
    if (n.readonly)
      return;
    this.#t.queue.enqueue("media-quality-change-request", e);
    const a = e.detail;
    if (a < 0)
      n.autoSelect(e), e.isOriginTrusted && i?.setVideoQuality?.(null);
    else {
      const s = n[a];
      s && (s.selected = !0, e.isOriginTrusted && i?.setVideoQuality?.({
        id: s.id,
        width: s.width,
        height: s.height,
        bitrate: s.bitrate
      }));
    }
  }
  "media-pause-controls-request"(e) {
    const n = e.type;
    this.#t.queue.enqueue(n, e), this.controls.pause(e);
  }
  "media-resume-controls-request"(e) {
    const n = e.type;
    this.#t.queue.enqueue(n, e), this.controls.resume(e);
  }
  "media-seek-request"(e) {
    const { canSeek: n, ended: i, live: r, seekableEnd: a, userBehindLiveEdge: s } = this.$state, o = e.detail;
    i() && (this.#t.replaying = !0);
    const l = e.type;
    this.#t.seeking = !1, this.#t.queue.delete(l);
    const c = Fd(o, this.$state);
    !Number.isFinite(c) || !n() || (this.#t.queue.enqueue(l, e), this.#a().setCurrentTime(c), r() && e.isOriginTrusted && Math.abs(a() - c) >= 2 && s.set(!0));
  }
  "media-seeking-request"(e) {
    const n = e.type;
    this.#t.queue.enqueue(n, e), this.$state.seeking.set(!0), this.#t.seeking = !0;
  }
  "media-start-loading"(e) {
    if (this.$state.canLoad()) return;
    const n = e.type;
    this.#t.queue.enqueue(n, e), this.#e.handle(this.createEvent("can-load"));
  }
  "media-poster-start-loading"(e) {
    if (this.$state.canLoadPoster()) return;
    const n = e.type;
    this.#t.queue.enqueue(n, e), this.#e.handle(this.createEvent("can-load-poster"));
  }
  "media-text-track-change-request"(e) {
    const { index: n, mode: i } = e.detail, r = this.#n.textTracks[n];
    if (r) {
      const a = e.type;
      this.#t.queue.enqueue(a, e), r.setMode(i, e);
    }
  }
  "media-mute-request"(e) {
    if (this.$state.muted()) return;
    const n = e.type;
    this.#t.queue.enqueue(n, e), this.#a().setMuted(!0);
  }
  "media-unmute-request"(e) {
    const { muted: n, volume: i } = this.$state;
    if (!n()) return;
    const r = e.type;
    this.#t.queue.enqueue(r, e), this.#n.$provider().setMuted(!1), i() === 0 && (this.#t.queue.enqueue(r, e), this.#a().setVolume(0.25));
  }
  "media-volume-change-request"(e) {
    const { muted: n, volume: i } = this.$state, r = e.detail;
    if (i() === r) return;
    const a = e.type;
    this.#t.queue.enqueue(a, e), this.#a().setVolume(r), r > 0 && n() && (this.#t.queue.enqueue(a, e), this.#a().setMuted(!1));
  }
  #y(e, n, i) {
  }
}
function Ka(t, e) {
  if (!(t && e))
    throw Error(
      "[vidstack] media not ready"
    );
}
function Wl(t, e) {
  if (!e?.supported)
    throw Error(
      "[vidstack] no fullscreen support"
    );
}
function dR(t) {
  if (!(!lR() || !t))
    throw Error(
      "[vidstack] autoplay blocked"
    );
}
class uR {
  seeking = !1;
  looping = !1;
  replaying = !1;
  queue = new sR();
}
const _R = /* @__PURE__ */ new Set([
  "auto-play",
  "auto-play-fail",
  "can-load",
  "sources-change",
  "source-change",
  "load-start",
  "abort",
  "error",
  "loaded-metadata",
  "loaded-data",
  "can-play",
  "play",
  "play-fail",
  "pause",
  "playing",
  "seeking",
  "seeked",
  "waiting"
]);
class pR extends Qn {
  #e;
  #t;
  #n = /* @__PURE__ */ new Map();
  #i = !1;
  #r = [];
  #a = [-1, -1];
  #s = !1;
  #l;
  constructor(e, n) {
    super(), this.#e = e, this.#t = n;
  }
  onAttach(e) {
    e.setAttribute("aria-busy", "true"), new Ae(this).add("fullscreen-change", this["fullscreen-change"].bind(this)).add("fullscreen-error", this["fullscreen-error"].bind(this)).add("orientation-change", this["orientation-change"].bind(this));
  }
  onConnect(e) {
    N(this.#v.bind(this)), this.#p(), this.#E(), this.#f(), this.#c(), ue(this.#_.bind(this));
  }
  onDestroy() {
    const { audioTracks: e, qualities: n, textTracks: i } = this.#t;
    e[le.reset](), n[le.reset](), i[le.reset](), this.#N();
  }
  handle(e) {
    if (!this.scope) return;
    const n = e.type;
    Ei(() => this[e.type]?.(e)), H || (_R.has(n) && this.#n.set(n, e), this.dispatch(e));
  }
  #o = !1;
  #c() {
    this.#o && (requestAnimationFrame(() => {
      this.scope && this.#t.remote.play(new Se("dom-connect"));
    }), this.#o = !1);
  }
  #_() {
    this.#o || (this.#o = !this.$state.paused(), this.#t.$provider()?.pause());
  }
  #u() {
    this.#P(), this.#i = !1, this.#e.replaying = !1, this.#e.looping = !1, this.#s = !1, this.#l = void 0, this.#n.clear();
  }
  #d(e, n) {
    const i = this.#e.queue.serve(e);
    i && (n.request = i, n.triggers.add(i));
  }
  #p() {
    this.#S(), this.#T();
    const e = this.#t.textTracks;
    new Ae(e).add("add", this.#S.bind(this)).add("remove", this.#S.bind(this)).add("mode-change", this.#T.bind(this));
  }
  #E() {
    const e = this.#t.qualities;
    new Ae(e).add("add", this.#h.bind(this)).add("remove", this.#h.bind(this)).add("change", this.#C.bind(this)).add("auto-change", this.#g.bind(this)).add("readonly-change", this.#O.bind(this));
  }
  #f() {
    const e = this.#t.audioTracks;
    new Ae(e).add("add", this.#m.bind(this)).add("remove", this.#m.bind(this)).add("change", this.#b.bind(this));
  }
  #S(e) {
    const { textTracks: n } = this.$state;
    n.set(this.#t.textTracks.toArray()), this.dispatch("text-tracks-change", {
      detail: n(),
      trigger: e
    });
  }
  #T(e) {
    e && this.#d("media-text-track-change-request", e);
    const n = this.#t.textTracks.selected, { textTrack: i } = this.$state;
    i() !== n && (i.set(n), this.dispatch("text-track-change", {
      detail: n,
      trigger: e
    }));
  }
  #m(e) {
    const { audioTracks: n } = this.$state;
    n.set(this.#t.audioTracks.toArray()), this.dispatch("audio-tracks-change", {
      detail: n(),
      trigger: e
    });
  }
  #b(e) {
    const { audioTrack: n } = this.$state;
    n.set(this.#t.audioTracks.selected), e && this.#d("media-audio-track-change-request", e), this.dispatch("audio-track-change", {
      detail: n(),
      trigger: e
    });
  }
  #h(e) {
    const { qualities: n } = this.$state;
    n.set(this.#t.qualities.toArray()), this.dispatch("qualities-change", {
      detail: n(),
      trigger: e
    });
  }
  #C(e) {
    const { quality: n } = this.$state;
    n.set(this.#t.qualities.selected), e && this.#d("media-quality-change-request", e), this.dispatch("quality-change", {
      detail: n(),
      trigger: e
    });
  }
  #g() {
    const { qualities: e } = this.#t, n = e.auto;
    this.$state.autoQuality.set(n), n || this.#N();
  }
  #R = null;
  #y() {
    this.#N(), this.#R = N(() => {
      const { qualities: e } = this.#t, { mediaWidth: n, mediaHeight: i } = this.$state, r = n(), a = i();
      if (r === 0 || a === 0) return;
      let s = null, o = 1 / 0;
      for (const l of e) {
        const c = Math.abs(l.width - r) + Math.abs(l.height - a);
        c < o && (o = c, s = l);
      }
      s && e[le.select](
        s,
        !0,
        new Se("resize", { detail: { width: r, height: a } })
      );
    });
  }
  #N() {
    this.#R?.(), this.#R = null;
  }
  #O() {
    this.$state.canSetQuality.set(!this.#t.qualities.readonly);
  }
  #v() {
    const { canSetVolume: e, isGoogleCastConnected: n } = this.$state;
    if (n()) {
      e.set(!1);
      return;
    }
    EC().then(e.set);
  }
  "provider-change"(e) {
    const n = this.#t.$provider(), i = e.detail;
    n?.type !== i?.type && (n?.destroy?.(), n?.scope?.dispose(), this.#t.$provider.set(e.detail), n && e.detail === null && this.#A(e));
  }
  "provider-loader-change"(e) {
  }
  "auto-play"(e) {
    this.$state.autoPlayError.set(null);
  }
  "auto-play-fail"(e) {
    this.$state.autoPlayError.set(e.detail), this.#u();
  }
  "can-load"(e) {
    this.$state.canLoad.set(!0), this.#n.set("can-load", e), this.#t.textTracks[ie.canLoad](), this.#d("media-start-loading", e);
  }
  "can-load-poster"(e) {
    this.$state.canLoadPoster.set(!0), this.#n.set("can-load-poster", e), this.#d("media-poster-start-loading", e);
  }
  "media-type-change"(e) {
    const n = this.#n.get("source-change");
    n && e.triggers.add(n);
    const i = this.$state.viewType();
    this.$state.mediaType.set(e.detail);
    const r = this.$state.providedViewType(), a = r === "unknown" ? e.detail : r;
    i !== a && (H ? this.$state.inferredViewType.set(a) : setTimeout(() => {
      requestAnimationFrame(() => {
        this.scope && (this.$state.inferredViewType.set(e.detail), this.dispatch("view-type-change", {
          detail: a,
          trigger: e
        }));
      });
    }, 0));
  }
  "stream-type-change"(e) {
    const n = this.#n.get("source-change");
    n && e.triggers.add(n);
    const { streamType: i, inferredStreamType: r } = this.$state;
    r.set(e.detail), e.detail = i();
  }
  "rate-change"(e) {
    const { storage: n } = this.#t, { canPlay: i } = this.$state;
    this.$state.playbackRate.set(e.detail), this.#d("media-rate-change-request", e), i() && n?.setPlaybackRate?.(e.detail);
  }
  "remote-playback-change"(e) {
    const { remotePlaybackState: n, remotePlaybackType: i } = this.$state, { type: r, state: a } = e.detail, s = a === "connected";
    i.set(r), n.set(a);
    const o = r === "airplay" ? "media-airplay-request" : "media-google-cast-request";
    if (s)
      this.#d(o, e);
    else {
      const l = this.#e.queue.peek(o);
      l && (e.request = l, e.triggers.add(l));
    }
  }
  "sources-change"(e) {
    const n = this.$state.sources(), i = e.detail;
    this.$state.sources.set(i), this.#I(n, i, e);
  }
  #I(e, n, i) {
    let { qualities: r } = this.#t, a = !1, s = !1;
    for (const o of e) {
      if (!us(o)) continue;
      if (!n.some((c) => c.src === o.src)) {
        const c = r.getBySrc(o.src);
        c && (r[le.remove](c, i), s = !0);
      }
    }
    s && !r.length && (this.$state.savedState.set(null), r[le.reset](i));
    for (const o of n) {
      if (!us(o) || r.getBySrc(o.src)) continue;
      const l = {
        id: o.id ?? o.height + "p",
        bitrate: null,
        codec: null,
        ...o,
        selected: !1
      };
      r[le.add](l, i), a = !0;
    }
    a && !r[Mt.enableAuto] && (this.#y(), r[Mt.enableAuto] = this.#y.bind(this), r[Mt.setAuto](!0, i));
  }
  "source-change"(e) {
    e.isQualityChange = e.originEvent?.type === "quality-change";
    const n = e.detail;
    this.#A(e, e.isQualityChange), this.#n.set(e.type, e), this.$state.source.set(n), this.el?.setAttribute("aria-busy", "true");
  }
  #A(e, n = !1) {
    const { audioTracks: i, qualities: r } = this.#t;
    if (!n) {
      this.#r = [], this.#a = [-1, -1], i[le.reset](e), r[le.reset](e), Fl(this.$state, n), this.#u();
      return;
    }
    Fl(this.$state, n), this.#u();
  }
  abort(e) {
    const n = this.#n.get("source-change");
    n && e.triggers.add(n);
    const i = this.#n.get("can-load");
    i && !e.triggers.hasType("can-load") && e.triggers.add(i);
  }
  "load-start"(e) {
    const n = this.#n.get("source-change");
    n && e.triggers.add(n);
  }
  error(e) {
    this.$state.error.set(e.detail);
    const n = this.#n.get("abort");
    n && e.triggers.add(n);
  }
  "loaded-metadata"(e) {
    const n = this.#n.get("load-start");
    n && e.triggers.add(n);
  }
  "loaded-data"(e) {
    const n = this.#n.get("load-start");
    n && e.triggers.add(n);
  }
  "can-play"(e) {
    const n = this.#n.get("loaded-metadata");
    n && e.triggers.add(n), this.#D(e.detail), this.el?.setAttribute("aria-busy", "false");
  }
  "can-play-through"(e) {
    this.#D(e.detail);
    const n = this.#n.get("can-play");
    n && e.triggers.add(n);
  }
  #D(e) {
    const { seekable: n, buffered: i, intrinsicDuration: r, canPlay: a } = this.$state;
    a.set(!0), i.set(e.buffered), n.set(e.seekable);
    const s = Fn(e.seekable) ?? 1 / 0;
    r.set(s);
  }
  "duration-change"(e) {
    const { live: n, intrinsicDuration: i, providedDuration: r, clipEndTime: a, ended: s } = this.$state, o = e.detail;
    if (!n()) {
      const l = Number.isNaN(o) ? 0 : o;
      i.set(l), s() && this.#x(e);
    }
    (r() > 0 || a() > 0) && e.stopImmediatePropagation();
  }
  progress(e) {
    const { buffered: n, seekable: i } = this.$state, { buffered: r, seekable: a } = e.detail, s = Fn(r), o = r.length !== n().length, l = s !== Fn(n()), c = Fn(a), d = a.length !== i().length, u = c !== Fn(i());
    (o || l) && n.set(r), (d || u) && i.set(a);
  }
  play(e) {
    const {
      paused: n,
      autoPlayError: i,
      ended: r,
      autoPlaying: a,
      playsInline: s,
      pointer: o,
      muted: l,
      viewType: c,
      live: d,
      userBehindLiveEdge: u
    } = this.$state;
    if (this.#w(), !n()) {
      e.stopImmediatePropagation();
      return;
    }
    e.autoPlay = a();
    const _ = this.#n.get("waiting");
    _ && e.triggers.add(_), this.#d("media-play-request", e), this.#n.set("play", e), n.set(!1), i.set(null), e.autoPlay && (this.handle(
      this.createEvent("auto-play", {
        detail: { muted: l() },
        trigger: e
      })
    ), a.set(!1)), (r() || this.#e.replaying) && (this.#e.replaying = !1, r.set(!1), this.handle(this.createEvent("replay", { trigger: e }))), !s() && c() === "video" && o() === "coarse" && this.#t.remote.enterFullscreen("prefer-media", e), d() && !u() && this.#t.remote.seekToLiveEdge(e);
  }
  #w(e) {
    if (!F(this.#t.$provider)) return;
    const { ended: i, seekableStart: r, clipEndTime: a, currentTime: s, realCurrentTime: o, duration: l } = this.$state, c = i() || o() < r() || a() > 0 && o() >= a() || Math.abs(s() - l()) < 0.1;
    return c && this.dispatch("media-seek-request", {
      detail: r(),
      trigger: e
    }), c;
  }
  "play-fail"(e) {
    const { muted: n, autoPlaying: i } = this.$state, r = this.#n.get("play");
    r && e.triggers.add(r), this.#d("media-play-request", e);
    const { paused: a, playing: s } = this.$state;
    a.set(!0), s.set(!1), this.#u(), this.#n.set("play-fail", e), e.autoPlay && (this.handle(
      this.createEvent("auto-play-fail", {
        detail: {
          muted: n(),
          error: e.detail
        },
        trigger: e
      })
    ), i.set(!1));
  }
  playing(e) {
    const n = this.#n.get("play"), i = this.#n.get("seeked");
    n ? e.triggers.add(n) : i && e.triggers.add(i), setTimeout(() => this.#u(), 0);
    const {
      paused: r,
      playing: a,
      live: s,
      liveSyncPosition: o,
      seekableEnd: l,
      started: c,
      currentTime: d,
      seeking: u,
      ended: _
    } = this.$state;
    if (r.set(!1), a.set(!0), u.set(!1), _.set(!1), this.#e.looping) {
      this.#e.looping = !1;
      return;
    }
    if (s() && !c() && d() === 0) {
      const m = o() ?? l() - 2;
      Number.isFinite(m) && this.#t.$provider().setCurrentTime(m);
    }
    this.started(e);
  }
  started(e) {
    const { started: n } = this.$state;
    n() || (n.set(!0), this.handle(this.createEvent("started", { trigger: e })));
  }
  pause(e) {
    this.el?.isConnected || (this.#o = !0), this.#d("media-pause-request", e);
    const n = this.#n.get("seeked");
    n && e.triggers.add(n);
    const { paused: i, playing: r } = this.$state;
    i.set(!0), r.set(!1), this.#i && setTimeout(() => {
      this.handle(this.createEvent("end", { trigger: e })), this.#i = !1;
    }, 0), this.#u();
  }
  "time-change"(e) {
    if (this.#e.looping) {
      e.stopImmediatePropagation();
      return;
    }
    let { waiting: n, played: i, clipEndTime: r, realCurrentTime: a, currentTime: s } = this.$state, o = e.detail, l = r();
    a.set(o), this.#L(), n.set(!1);
    for (const c of this.#t.textTracks)
      c[ie.updateActiveCues](o, e);
    l > 0 && o >= l && (this.#i = !0, this.dispatch("media-pause-request", { trigger: e })), this.#k(), this.dispatch("time-update", {
      detail: { currentTime: s(), played: i() },
      trigger: e
    });
  }
  #L() {
    const { currentTime: e, played: n, paused: i } = this.$state;
    i() || (this.#a = fC(
      this.#r,
      this.#a,
      e()
    ), n.set(new Gr(this.#r)));
  }
  // Called to update time again incase duration precision has changed.
  #x(e) {
    const { clipStartTime: n, clipEndTime: i, duration: r } = this.$state;
    n() > 0 || i() > 0 || this.handle(
      this.createEvent("time-change", {
        detail: r(),
        trigger: e
      })
    );
  }
  #k() {
    const { storage: e } = this.#t, { canPlay: n, realCurrentTime: i } = this.$state;
    n() && e?.setTime?.(i());
  }
  "audio-gain-change"(e) {
    const { storage: n } = this.#t, { canPlay: i, audioGain: r } = this.$state;
    r.set(e.detail), this.#d("media-audio-gain-change-request", e), i() && n?.setAudioGain?.(r());
  }
  "volume-change"(e) {
    const { storage: n } = this.#t, { volume: i, muted: r, canPlay: a } = this.$state, s = e.detail;
    i.set(s.volume), r.set(s.muted || s.volume === 0), this.#d("media-volume-change-request", e), this.#d(s.muted ? "media-mute-request" : "media-unmute-request", e), a() && (n?.setVolume?.(i()), n?.setMuted?.(r()));
  }
  seeking = Oi(
    (e) => {
      const { seeking: n, realCurrentTime: i, paused: r } = this.$state;
      n.set(!0), i.set(e.detail), this.#d("media-seeking-request", e), r() && (this.#l = e, this.#M()), this.#a = [-1, -1];
    },
    150,
    { leading: !0 }
  );
  seeked(e) {
    const { seeking: n, currentTime: i, realCurrentTime: r, paused: a, seekableEnd: s, ended: o, live: l } = this.$state;
    if (this.#e.seeking)
      n.set(!0), e.stopImmediatePropagation();
    else if (n()) {
      const c = this.#n.get("waiting");
      c && e.triggers.add(c);
      const d = this.#n.get("seeking");
      d && !e.triggers.has(d) && e.triggers.add(d), a() && this.#P(), n.set(!1), r.set(e.detail), this.#d("media-seek-request", e);
      const u = e?.originEvent;
      u?.isTrusted && !(u instanceof MessageEvent) && !/seek/.test(u.type) && this.started(e);
    }
    l() || (Math.floor(i()) !== Math.floor(s()) ? o.set(!1) : this.end(e));
  }
  waiting(e) {
    this.#s || this.#e.seeking || (e.stopImmediatePropagation(), this.#l = e, this.#M());
  }
  #M = ga(() => {
    if (!this.#l) return;
    this.#s = !0;
    const { waiting: e, playing: n } = this.$state;
    e.set(!0), n.set(!1);
    const i = this.createEvent("waiting", { trigger: this.#l });
    this.#n.set("waiting", i), this.dispatch(i), this.#l = void 0, this.#s = !1;
  }, 300);
  end(e) {
    const { loop: n, ended: i } = this.$state;
    if (!(!n() && i())) {
      if (n()) {
        setTimeout(() => {
          requestAnimationFrame(() => {
            this.#w(e), this.dispatch("media-loop-request", { trigger: e });
          });
        }, 10);
        return;
      }
      setTimeout(() => this.#U(e), 0);
    }
  }
  #U(e) {
    const { storage: n } = this.#t, { paused: i, seeking: r, ended: a, duration: s } = this.$state;
    this.#x(e), i() || this.dispatch("pause", { trigger: e }), r() && this.dispatch("seeked", {
      detail: s(),
      trigger: e
    }), a.set(!0), this.#u(), n?.setTime?.(s(), !0), this.dispatch("ended", {
      trigger: e
    });
  }
  #P() {
    this.#M.cancel(), this.$state.waiting.set(!1);
  }
  "fullscreen-change"(e) {
    const n = e.detail;
    this.$state.fullscreen.set(n), this.#d(
      n ? "media-enter-fullscreen-request" : "media-exit-fullscreen-request",
      e
    );
  }
  "fullscreen-error"(e) {
    this.#d("media-enter-fullscreen-request", e), this.#d("media-exit-fullscreen-request", e);
  }
  "orientation-change"(e) {
    const n = e.detail.lock;
    this.#d(
      n ? "media-orientation-lock-request" : "media-orientation-unlock-request",
      e
    );
  }
  "picture-in-picture-change"(e) {
    const n = e.detail;
    this.$state.pictureInPicture.set(n), this.#d(n ? "media-enter-pip-request" : "media-exit-pip-request", e);
  }
  "picture-in-picture-error"(e) {
    this.#d("media-enter-pip-request", e), this.#d("media-exit-pip-request", e);
  }
  "title-change"(e) {
    e.trigger && (e.stopImmediatePropagation(), this.$state.inferredTitle.set(e.detail));
  }
  "poster-change"(e) {
    e.trigger && (e.stopImmediatePropagation(), this.$state.inferredPoster.set(e.detail));
  }
}
class mR extends Qn {
  onSetup() {
    if (this.#e(), H) return;
    const e = [
      this.#i,
      this.#a,
      this.#d,
      this.#p,
      this.#l,
      this.#c,
      this.#_,
      this.#E,
      this.#S,
      this.#f,
      this.#s,
      this.#u,
      this.#o,
      this.#t,
      this.#r
    ];
    for (const n of e)
      N(n.bind(this));
  }
  #e() {
    const e = {
      duration: "providedDuration",
      loop: "providedLoop",
      poster: "providedPoster",
      streamType: "providedStreamType",
      title: "providedTitle",
      viewType: "providedViewType"
    }, n = /* @__PURE__ */ new Set([
      "currentTime",
      "paused",
      "playbackRate",
      "volume"
    ]);
    for (const i of Object.keys(this.$props))
      n.has(i) || this.$state[e[i] ?? i]?.set(this.$props[i]());
    this.$state.muted.set(this.$props.muted() || this.$props.volume() === 0);
  }
  // Sync "provided" props with internal state. Provided props are used to differentiate from
  // provider inferred values.
  #t() {
    const { viewType: e, streamType: n, title: i, poster: r, loop: a } = this.$props, s = this.$state;
    s.providedPoster.set(r()), s.providedStreamType.set(n()), s.providedViewType.set(e()), s.providedTitle.set(i()), s.providedLoop.set(a());
  }
  #n() {
  }
  #i() {
    const { artist: e, artwork: n } = this.$props;
    this.$state.artist.set(e()), this.$state.artwork.set(n());
  }
  #r() {
    const { title: e } = this.$state;
    this.dispatch("title-change", { detail: e() });
  }
  #a() {
    const e = this.$props.autoPlay() || this.$props.autoplay();
    this.$state.autoPlay.set(e), this.dispatch("auto-play-change", { detail: e });
  }
  #s() {
    const e = this.$state.loop();
    this.dispatch("loop-change", { detail: e });
  }
  #l() {
    const e = this.$props.controls();
    this.$state.controls.set(e);
  }
  #o() {
    const { poster: e } = this.$state;
    this.dispatch("poster-change", { detail: e() });
  }
  #c() {
    const e = this.$props.crossOrigin() ?? this.$props.crossorigin(), n = e === !0 ? "" : e;
    this.$state.crossOrigin.set(n);
  }
  #_() {
    const { duration: e } = this.$props;
    this.dispatch("media-duration-change-request", {
      detail: e()
    });
  }
  #u() {
    const e = this.$props.playsInline() || this.$props.playsinline();
    this.$state.playsInline.set(e), this.dispatch("plays-inline-change", { detail: e });
  }
  #d() {
    const { clipStartTime: e } = this.$props;
    this.dispatch("media-clip-start-change-request", {
      detail: e()
    });
  }
  #p() {
    const { clipEndTime: e } = this.$props;
    this.dispatch("media-clip-end-change-request", {
      detail: e()
    });
  }
  #E() {
    this.dispatch("live-change", { detail: this.$state.live() });
  }
  #f() {
    this.$state.liveEdgeTolerance.set(this.$props.liveEdgeTolerance()), this.$state.minLiveDVRWindow.set(this.$props.minLiveDVRWindow());
  }
  #S() {
    this.dispatch("live-edge-change", { detail: this.$state.liveEdge() });
  }
}
const Kl = ["play", "pause", "seekforward", "seekbackward", "seekto"];
class ER extends Qn {
  onConnect() {
    N(this.#t.bind(this)), N(this.#n.bind(this));
    const e = this.#i.bind(this);
    for (const n of Kl)
      navigator.mediaSession.setActionHandler(n, e);
    ue(this.#e.bind(this));
  }
  #e() {
    for (const e of Kl)
      navigator.mediaSession.setActionHandler(e, null);
  }
  #t() {
    const { title: e, artist: n, artwork: i, poster: r } = this.$state;
    navigator.mediaSession.metadata = new MediaMetadata({
      title: e(),
      artist: n(),
      artwork: i() ?? [{ src: r() }]
    });
  }
  #n() {
    const { canPlay: e, paused: n } = this.$state;
    navigator.mediaSession.playbackState = e() ? n() ? "paused" : "playing" : "none";
  }
  #i(e) {
    const n = new Se("media-session-action", { detail: e });
    switch (e.action) {
      case "play":
        this.dispatch("media-play-request", { trigger: n });
        break;
      case "pause":
        this.dispatch("media-pause-request", { trigger: n });
        break;
      case "seekto":
      case "seekforward":
      case "seekbackward":
        this.dispatch("media-seek-request", {
          detail: mt(e.seekTime) ? e.seekTime : this.$state.currentTime() + (e.seekOffset ?? (e.action === "seekforward" ? 10 : -10)),
          trigger: n
        });
        break;
    }
  }
}
let Es = j(!1);
H || (Ve(document, "pointerdown", () => {
  Es.set(!1);
}), Ve(document, "keydown", (t) => {
  t.metaKey || t.altKey || t.ctrlKey || Es.set(!0);
}));
class Dn extends Ut {
  #e = j(!1);
  onConnect(e) {
    N(() => {
      const n = new Ae(e);
      if (!Es()) {
        this.#e.set(!1), Pr(e, !1), n.add("pointerenter", this.#i.bind(this)).add("pointerleave", this.#r.bind(this));
        return;
      }
      const i = document.activeElement === e;
      this.#e.set(i), Pr(e, i), n.add("focus", this.#t.bind(this)).add("blur", this.#n.bind(this));
    });
  }
  focused() {
    return this.#e();
  }
  #t() {
    this.#e.set(!0), Pr(this.el, !0);
  }
  #n() {
    this.#e.set(!1), Pr(this.el, !1);
  }
  #i() {
    Ql(this.el, !0);
  }
  #r() {
    Ql(this.el, !1);
  }
}
function Pr(t, e) {
  re(t, "data-focus", e), re(t, "data-hocus", e);
}
function Ql(t, e) {
  re(t, "data-hocus", e), re(t, "data-hover", e);
}
let Xd = class Vr extends be {
  static props = rR;
  static state = pr;
  #e;
  #t;
  #n;
  canPlayQueue = new Qd();
  remoteControl;
  get #i() {
    return this.#e.$provider();
  }
  get #r() {
    return this.$props;
  }
  constructor() {
    super(), new mR();
    const e = {
      player: this,
      qualities: new cy(),
      audioTracks: new jC(),
      storage: null,
      $provider: j(null),
      $providerSetup: j(!1),
      $props: this.$props,
      $state: this.$state
    };
    e.remote = this.remoteControl = new Bd(
      void 0
    ), e.remote.setPlayer(this), e.textTracks = new sy(), e.textTracks[ie.crossOrigin] = this.$state.crossOrigin, e.textRenderers = new ay(e), e.ariaKeys = {}, this.#e = e, en(ro, e), this.orientation = new ba(), new Dn(), new fy(e);
    const n = new uR();
    this.#t = new pR(n, e), this.#n = new cR(this.#t, n, e), e.delegate = new aR(this.#t.handle.bind(this.#t), e), e.notify = e.delegate.notify.bind(e.delegate), typeof navigator < "u" && "mediaSession" in navigator && new ER(), new zl("load", this.startLoading.bind(this)), new zl("posterLoad", this.startLoadingPoster.bind(this));
  }
  onSetup() {
    this.#c(), N(this.#o.bind(this)), N(this.#f.bind(this)), N(this.#p.bind(this)), N(this.#b.bind(this)), N(this.#T.bind(this)), N(this.#R.bind(this)), N(this.#C.bind(this));
  }
  onAttach(e) {
    e.setAttribute("data-media-player", ""), Be(e, "tabindex", "0"), Be(e, "role", "region"), N(this.#N.bind(this)), H ? this.#s() : N(this.#s.bind(this)), H ? this.#l() : N(this.#l.bind(this)), Ve(e, "find-media-player", this.#_.bind(this));
  }
  onConnect(e) {
    vd && re(e, "data-iphone", "");
    const n = window.matchMedia("(pointer: coarse)");
    this.#d(n), n.onchange = this.#d.bind(this);
    const i = new ResizeObserver(Wn(this.#u.bind(this)));
    i.observe(e), N(this.#u.bind(this)), this.dispatch("media-player-connect", {
      detail: this,
      bubbles: !0,
      composed: !0
    }), ue(() => {
      i.disconnect(), n.onchange = null;
    });
  }
  onDestroy() {
    this.#e.player = null, this.canPlayQueue.reset();
  }
  #a = !1;
  #s() {
    const e = this.$el, { title: n, live: i, viewType: r, providedTitle: a } = this.$state, s = i(), o = Ea(r()), l = o !== "Unknown" ? `${s ? "Live " : ""}${o}` : s ? "Live" : "Media", c = n();
    re(
      this.el,
      "aria-label",
      `${l} Player` + (c ? ` - ${c}` : "")
    ), !H && e?.hasAttribute("title") && (this.#a = !0, e?.removeAttribute("title"));
  }
  #l() {
    const e = this.orientation.landscape ? "landscape" : "portrait";
    this.$state.orientation.set(e), re(this.el, "data-orientation", e), this.#u();
  }
  #o() {
    this.$state.canPlay() && this.#i ? this.canPlayQueue.start() : this.canPlayQueue.stop();
  }
  #c() {
    if (Vr[Wa]) {
      this.setAttributes(Vr[Wa]);
      return;
    }
    const e = {
      "data-load": function() {
        return this.$props.load();
      },
      "data-captions": function() {
        const i = this.$state.textTrack();
        return !!i && bt(i);
      },
      "data-ios-controls": function() {
        return this.$state.iOSControls();
      },
      "data-controls": function() {
        return this.controls.showing;
      },
      "data-buffering": function() {
        const { canLoad: i, canPlay: r, waiting: a } = this.$state;
        return i() && (!r() || a());
      },
      "data-error": function() {
        const { error: i } = this.$state;
        return !!i();
      },
      "data-autoplay-error": function() {
        const { autoPlayError: i } = this.$state;
        return !!i();
      }
    }, n = {
      autoPlay: "autoplay",
      canAirPlay: "can-airplay",
      canPictureInPicture: "can-pip",
      pictureInPicture: "pip",
      playsInline: "playsinline",
      remotePlaybackState: "remote-state",
      remotePlaybackType: "remote-type",
      isAirPlayConnected: "airplay",
      isGoogleCastConnected: "google-cast"
    };
    for (const i of iR) {
      const r = "data-" + (n[i] ?? ma(i));
      e[r] = function() {
        return this.$state[i]();
      };
    }
    delete e.title, Vr[Wa] = e, this.setAttributes(e);
  }
  #_(e) {
    e.detail(this);
  }
  #u() {
    if (H || !this.el) return;
    const e = this.el.clientWidth, n = this.el.clientHeight;
    this.$state.width.set(e), this.$state.height.set(n), Xt(this.el, "--player-width", e + "px"), Xt(this.el, "--player-height", n + "px");
  }
  #d(e) {
    if (H) return;
    const n = e.matches ? "coarse" : "fine";
    re(this.el, "data-pointer", n), this.$state.pointer.set(n), this.#u();
  }
  /**
   * The current media provider.
   */
  get provider() {
    return this.#i;
  }
  /**
   * Media controls settings.
   */
  get controls() {
    return this.#n.controls;
  }
  set controls(e) {
    this.#r.controls.set(e);
  }
  /**
   * Controls the screen orientation of the current browser window and dispatches orientation
   * change events on the player.
   */
  orientation;
  /**
   * The title of the current media.
   */
  get title() {
    return F(this.$state.title);
  }
  set title(e) {
    if (this.#a) {
      this.#a = !1;
      return;
    }
    this.#r.title.set(e);
  }
  /**
   * A list of all `VideoQuality` objects representing the set of available video renditions.
   *
   * @see {@link https://vidstack.io/docs/player/api/video-quality}
   */
  get qualities() {
    return this.#e.qualities;
  }
  /**
   * A list of all `AudioTrack` objects representing the set of available audio tracks.
   *
   * @see {@link https://vidstack.io/docs/player/api/audio-tracks}
   */
  get audioTracks() {
    return this.#e.audioTracks;
  }
  /**
   * A list of all `TextTrack` objects representing the set of available text tracks.
   *
   * @see {@link https://vidstack.io/docs/player/api/text-tracks}
   */
  get textTracks() {
    return this.#e.textTracks;
  }
  /**
   * Contains text renderers which are responsible for loading, parsing, and rendering text
   * tracks.
   */
  get textRenderers() {
    return this.#e.textRenderers;
  }
  get duration() {
    return this.$state.duration();
  }
  set duration(e) {
    this.#r.duration.set(e);
  }
  get paused() {
    return F(this.$state.paused);
  }
  set paused(e) {
    this.#E(e);
  }
  #p() {
    this.#E(this.$props.paused());
  }
  #E(e) {
    e ? this.canPlayQueue.enqueue("paused", () => this.#n.pause()) : this.canPlayQueue.enqueue("paused", () => this.#n.play());
  }
  get muted() {
    return F(this.$state.muted);
  }
  set muted(e) {
    this.#S(e);
  }
  #f() {
    this.#S(this.$props.muted());
  }
  #S(e) {
    this.canPlayQueue.enqueue("muted", () => {
      this.#i && this.#i.setMuted(e);
    });
  }
  get currentTime() {
    return F(this.$state.currentTime);
  }
  set currentTime(e) {
    this.#m(e);
  }
  #T() {
    this.#m(this.$props.currentTime());
  }
  #m(e) {
    this.canPlayQueue.enqueue("currentTime", () => {
      const { currentTime: n } = this.$state;
      e !== F(n) && F(() => {
        if (!this.#i) return;
        const i = Fd(e, this.$state);
        Number.isFinite(i) && this.#i.setCurrentTime(i);
      });
    });
  }
  get volume() {
    return F(this.$state.volume);
  }
  set volume(e) {
    this.#h(e);
  }
  #b() {
    this.#h(this.$props.volume());
  }
  #h(e) {
    const n = ao(0, e, 1);
    this.canPlayQueue.enqueue("volume", () => {
      this.#i && this.#i.setVolume(n);
    });
  }
  get playbackRate() {
    return F(this.$state.playbackRate);
  }
  set playbackRate(e) {
    this.#g(e);
  }
  #C() {
    this.#g(this.$props.playbackRate());
  }
  #g(e) {
    this.canPlayQueue.enqueue("rate", () => {
      this.#i && this.#i.setPlaybackRate?.(e);
    });
  }
  #R() {
    this.#y(this.$props.playsInline());
  }
  #y(e) {
    this.canPlayQueue.enqueue("playsinline", () => {
      this.#i && this.#i.setPlaysInline?.(e);
    });
  }
  #N() {
    let e = this.$props.storage(), n = Q(e) ? new VC() : e;
    if (n?.onChange) {
      const { source: i } = this.$state, r = Q(e) ? e : this.el?.id, a = yi(this.#O.bind(this));
      N(() => n.onChange(i(), a(), r || void 0));
    }
    this.#e.storage = n, this.#e.textTracks.setStorage(n), ue(() => {
      n?.onDestroy?.(), this.#e.storage = null, this.#e.textTracks.setStorage(null);
    });
  }
  #O() {
    const { clipStartTime: e, clipEndTime: n } = this.$props, { source: i } = this.$state, r = i();
    return r.src ? `${r.src}:${e()}:${n()}` : null;
  }
  /**
   * Begins/resumes playback of the media. If this method is called programmatically before the
   * user has interacted with the player, the promise may be rejected subject to the browser's
   * autoplay policies. This method will throw if called before media is ready for playback.
   *
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/play}
   */
  async play(e) {
    return this.#n.play(e);
  }
  /**
   * Pauses playback of the media. This method will throw if called before media is ready for
   * playback.
   *
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/pause}
   */
  async pause(e) {
    return this.#n.pause(e);
  }
  /**
   * Attempts to display the player in fullscreen. The promise will resolve if successful, and
   * reject if not. This method will throw if any fullscreen API is _not_ currently available.
   *
   * @see {@link https://vidstack.io/docs/player/api/fullscreen}
   */
  async enterFullscreen(e, n) {
    return this.#n.enterFullscreen(e, n);
  }
  /**
   * Attempts to display the player inline by exiting fullscreen. This method will throw if any
   * fullscreen API is _not_ currently available.
   *
   * @see {@link https://vidstack.io/docs/player/api/fullscreen}
   */
  async exitFullscreen(e, n) {
    return this.#n.exitFullscreen(e, n);
  }
  /**
   * Attempts to display the player in picture-in-picture mode. This method will throw if PIP is
   * not supported. This method will also return a `PictureInPictureWindow` if the current
   * provider supports it.
   *
   * @see {@link https://vidstack.io/docs/player/api/picture-in-picture}
   */
  enterPictureInPicture(e) {
    return this.#n.enterPictureInPicture(e);
  }
  /**
   * Attempts to display the player in inline by exiting picture-in-picture mode. This method
   * will throw if not supported.
   *
   * @see {@link https://vidstack.io/docs/player/api/picture-in-picture}
   */
  exitPictureInPicture(e) {
    return this.#n.exitPictureInPicture(e);
  }
  /**
   * Sets the current time to the live edge (i.e., `duration`). This is a no-op for non-live
   * streams and will throw if called before media is ready for playback.
   *
   * @see {@link https://vidstack.io/docs/player/api/live}
   */
  seekToLiveEdge(e) {
    this.#n.seekToLiveEdge(e);
  }
  /**
   * Called when media can begin loading. Calling this method will trigger the initial provider
   * loading process. Calling it more than once has no effect.
   *
   * @see {@link https://vidstack.io/docs/player/core-concepts/loading#load-strategies}
   */
  startLoading(e) {
    this.#e.notify("can-load", void 0, e);
  }
  /**
   * Called when the poster image can begin loading. Calling it more than once has no effect.
   *
   * @see {@link https://vidstack.io/docs/player/core-concepts/loading#load-strategies}
   */
  startLoadingPoster(e) {
    this.#e.notify("can-load-poster", void 0, e);
  }
  /**
   * Request Apple AirPlay picker to open.
   */
  requestAirPlay(e) {
    return this.#n.requestAirPlay(e);
  }
  /**
   * Request Google Cast device picker to open. The Google Cast framework will be loaded if it
   * hasn't yet.
   */
  requestGoogleCast(e) {
    return this.#n.requestGoogleCast(e);
  }
  /**
   * Set the audio gain, amplifying volume and enabling a maximum volume above 100%.
   *
   * @see {@link https://vidstack.io/docs/player/api/audio-gain}
   */
  setAudioGain(e, n) {
    return this.#n.setAudioGain(e, n);
  }
  destroy() {
    super.destroy(), this.#e.remote.setPlayer(null), this.dispatch("destroy");
  }
};
const De = Xd.prototype;
he(De, "canPlayQueue");
he(De, "remoteControl");
he(De, "provider");
he(De, "controls");
he(De, "orientation");
he(De, "title");
he(De, "qualities");
he(De, "audioTracks");
he(De, "textTracks");
he(De, "textRenderers");
he(De, "duration");
he(De, "paused");
he(De, "muted");
he(De, "currentTime");
he(De, "volume");
he(De, "playbackRate");
et(De, "play");
et(De, "pause");
et(De, "enterFullscreen");
et(De, "exitFullscreen");
et(De, "enterPictureInPicture");
et(De, "exitPictureInPicture");
et(De, "seekToLiveEdge");
et(De, "startLoading");
et(De, "startLoadingPoster");
et(De, "requestAirPlay");
et(De, "requestGoogleCast");
et(De, "setAudioGain");
function gR(t, e) {
  return fetch(t, e).then((n) => n.text()).then((n) => /type="static"/.test(n) ? "on-demand" : "live");
}
function Zd(t, e) {
  return fetch(t, e).then((n) => n.text()).then((n) => {
    const i = SR(n);
    if (i)
      return Zd(
        /^https?:/.test(i) ? i : new URL(i, t).href,
        e
      );
    const r = /EXT-X-PLAYLIST-TYPE:\s*VOD/.test(n) ? "on-demand" : "live";
    return r === "live" && hR(n) >= 10 && (/#EXT-X-DVR-ENABLED:\s*true/.test(n) || n.includes("#EXT-X-DISCONTINUITY")) ? "live:dvr" : r;
  });
}
function SR(t) {
  const e = t.match(/#EXT-X-STREAM-INF:[^\n]+(\n[^\n]+)*/g);
  return e ? e[0].split(`
`)[1].trim() : null;
}
function hR(t) {
  const e = t.split(`
`);
  for (const n of e)
    if (n.startsWith("#EXT-X-TARGETDURATION")) {
      const i = parseFloat(n.split(":")[1]);
      if (!isNaN(i))
        return i;
    }
  return -1;
}
const gs = /* @__PURE__ */ new Map();
class fR {
  #e = !1;
  #t;
  #n;
  #i;
  #r;
  constructor(e, n, i, r = []) {
    this.#n = e, this.#i = n, this.#r = i;
    const a = new uo(), s = new lo(), o = new oo(), l = new Oy(), c = new nR(), d = new tR(), u = [c, d];
    this.#t = yi(() => {
      const m = n.$state.remotePlaybackLoader(), g = n.$props.preferNativeHLS() ? [o, l, a, s, ...u, ...r] : [s, o, l, a, ...u, ...r];
      return m ? [m, ...g] : g;
    });
    const { $state: _ } = n;
    _.sources.set(Xl(n.$props.src()));
    for (const m of _.sources()) {
      const g = this.#t().find((E) => E.canPlay(m));
      if (!g) continue;
      const S = g.mediaType(m);
      n.$state.source.set(m), n.$state.mediaType.set(S), n.$state.inferredViewType.set(S), this.#r.set(g), this.#e = !0;
      break;
    }
  }
  connect() {
    const e = this.#r();
    this.#e && (this.#o(this.#i.$state.source(), e), this.#c(e), this.#e = !1), N(this.#a.bind(this)), N(this.#s.bind(this)), N(this.#_.bind(this)), N(this.#u.bind(this)), N(this.#d.bind(this));
  }
  #a() {
    this.#i.notify("sources-change", [
      ...Xl(this.#i.$props.src()),
      ...this.#n()
    ]);
  }
  #s() {
    const { $state: e } = this.#i, n = e.sources(), i = F(e.source), r = this.#l(i, n);
    if (n[0]?.src && !r.src && !r.type) {
      const { crossOrigin: s } = e, o = Ji(s()), l = new AbortController();
      return Promise.all(
        n.map(
          (c) => Q(c.src) && c.type === "?" ? fetch(c.src, {
            method: "HEAD",
            credentials: o,
            signal: l.signal
          }).then((d) => (c.type = d.headers.get("content-type") || "??", gs.set(c.src, c.type), c)).catch(() => c) : c
        )
      ).then((c) => {
        if (l.signal.aborted) return;
        const d = this.#l(F(e.source), c);
        on(), d.src || this.#i.notify("error", {
          message: "Failed to load resource.",
          code: 4
        });
      }), () => l.abort();
    }
    on();
  }
  #l(e, n) {
    let i = { src: "", type: "" }, r = null, a = new Se("sources-change", { detail: { sources: n } }), s = this.#t(), { started: o, paused: l, currentTime: c, quality: d, savedState: u } = this.#i.$state;
    for (const _ of n) {
      const m = s.find((g) => g.canPlay(_));
      if (m) {
        i = _, r = m;
        break;
      }
    }
    if (us(i)) {
      const _ = d(), m = n.find((g) => g.src === _?.src);
      F(o) ? u.set({
        paused: F(l),
        currentTime: F(c)
      }) : u.set(null), m && (i = m, a = new Se("quality-change", {
        detail: { quality: _ }
      }));
    }
    return Jl(e, i) || this.#o(i, r, a), r !== F(this.#r) && this.#c(r, a), i;
  }
  #o(e, n, i) {
    this.#i.notify("source-change", e, i), this.#i.notify("media-type-change", n?.mediaType(e) || "unknown", i);
  }
  #c(e, n) {
    this.#i.$providerSetup.set(!1), this.#i.notify("provider-change", null, n), e && F(() => e.preconnect?.(this.#i)), this.#r.set(e), this.#i.notify("provider-loader-change", e, n);
  }
  #_() {
    const e = this.#i.$provider();
    if (!(!e || F(this.#i.$providerSetup))) {
      if (this.#i.$state.canLoad()) {
        Tt(() => e.setup(), e.scope), this.#i.$providerSetup.set(!0);
        return;
      }
      F(() => e.preconnect?.());
    }
  }
  #u() {
    if (!this.#i.$providerSetup()) return;
    const e = this.#i.$provider(), n = this.#i.$state.source(), i = F(this.#i.$state.crossOrigin), r = F(this.#i.$props.preferNativeHLS);
    if (!Jl(e?.currentSrc, n)) {
      if (this.#i.$state.canLoad()) {
        const a = new AbortController();
        return Ai(n) ? (r || !eo()) && Zd(n.src, {
          credentials: Ji(i),
          signal: a.signal
        }).then((s) => {
          this.#i.notify("stream-type-change", s);
        }).catch(xt) : io(n) ? gR(n.src, {
          credentials: Ji(i),
          signal: a.signal
        }).then((s) => {
          this.#i.notify("stream-type-change", s);
        }).catch(xt) : this.#i.notify("stream-type-change", "on-demand"), F(() => {
          const s = F(this.#i.$state.preload);
          return e?.loadSource(n, s).catch((o) => {
          });
        }), () => a.abort();
      }
      try {
        Q(n.src) && Ii(new URL(n.src).origin);
      } catch {
      }
    }
  }
  #d() {
    const e = this.#r(), { providedPoster: n, source: i, canLoadPoster: r } = this.#i.$state;
    if (!e || !e.loadPoster || !i() || !r() || n()) return;
    const a = new AbortController(), s = new Se("source-change", { detail: i });
    return e.loadPoster(i(), this.#i, a).then((o) => {
      this.#i.notify("poster-change", o || "", s);
    }).catch(() => {
      this.#i.notify("poster-change", "", s);
    }), () => {
      a.abort();
    };
  }
}
function Xl(t) {
  return (Et(t) ? t : [t]).map((e) => Q(e) ? { src: e, type: Zl(e) } : { ...e, type: Zl(e.src, e.type) });
}
function Zl(t, e) {
  return Q(e) && e.length ? e : Q(t) && gs.has(t) ? gs.get(t) : !e && Ai({ src: t, type: "" }) ? "application/x-mpegurl" : !e && io({ src: t, type: "" }) ? "application/dash+xml" : !Q(t) || t.startsWith("blob:") ? "video/object" : t.includes("youtube") || t.includes("youtu.be") ? "video/youtube" : t.includes("vimeo") && !t.includes("progressive_redirect") && !t.includes(".m3u8") ? "video/vimeo" : "?";
}
function Jl(t, e) {
  return t?.src === e?.src && t?.type === e?.type;
}
class TR {
  #e;
  #t;
  #n = [];
  constructor(e, n) {
    this.#e = e, this.#t = n, N(this.#i.bind(this));
  }
  #i() {
    const e = this.#e();
    for (const n of this.#n)
      if (!e.some((i) => i.id === n.id)) {
        const i = n.id && this.#t.textTracks.getById(n.id);
        i && this.#t.textTracks.remove(i);
      }
    for (const n of e) {
      const i = n.id || Vn.createId(n);
      this.#t.textTracks.getById(i) || (n.id = i, this.#t.textTracks.add(n));
    }
    this.#n = e;
  }
}
let Jd = class extends be {
  static props = {
    loaders: []
  };
  static state = new In({
    loader: null
  });
  #e;
  #t;
  #n = j([]);
  #i = j([]);
  #r = null;
  onSetup() {
    this.#e = Ge(), this.#t = new fR(
      this.#n,
      this.#e,
      this.$state.loader,
      this.$props.loaders()
    );
  }
  onAttach(e) {
    e.setAttribute("data-media-provider", "");
  }
  onConnect(e) {
    this.#t.connect(), new TR(this.#i, this.#e);
    const n = new ResizeObserver(Wn(this.#o.bind(this)));
    n.observe(e);
    const i = new MutationObserver(this.#c.bind(this));
    i.observe(e, { attributes: !0, childList: !0 }), this.#o(), this.#c(), ue(() => {
      n.disconnect(), i.disconnect();
    });
  }
  #a = -1;
  load(e) {
    e?.setAttribute("aria-hidden", "true"), window.cancelAnimationFrame(this.#a), this.#a = requestAnimationFrame(() => this.#s(e)), ue(() => {
      window.cancelAnimationFrame(this.#a);
    });
  }
  #s(e) {
    if (!this.scope) return;
    const n = this.$state.loader(), { $provider: i } = this.#e;
    this.#r === n && n?.target === e && F(i) || (this.#l(), this.#r = n, n && (n.target = e || null), !(!n || !e) && n.load(this.#e).then((r) => {
      this.scope && F(this.$state.loader) === n && this.#e.notify("provider-change", r);
    }));
  }
  onDestroy() {
    this.#r = null, this.#l();
  }
  #l() {
    this.#e?.notify("provider-change", null);
  }
  #o() {
    if (!this.el) return;
    const { player: e, $state: n } = this.#e, i = this.el.offsetWidth, r = this.el.offsetHeight;
    e && (n.mediaWidth.set(i), n.mediaHeight.set(r), e.el && (Xt(e.el, "--media-width", i + "px"), Xt(e.el, "--media-height", r + "px")));
  }
  #c() {
    const e = [], n = [], i = this.el.children;
    for (const r of i)
      if (!r.hasAttribute("data-vds")) {
        if (r instanceof HTMLSourceElement) {
          const a = {
            id: r.id,
            src: r.src,
            type: r.type
          };
          for (const s of ["id", "src", "width", "height", "bitrate", "codec"]) {
            const o = r.getAttribute(`data-${s}`);
            Q(o) && (a[s] = /id|src|codec/.test(s) ? o : Number(o));
          }
          e.push(a);
        } else if (r instanceof HTMLTrackElement) {
          const a = {
            src: r.src,
            kind: r.track.kind,
            language: r.srclang,
            label: r.label,
            default: r.default,
            type: r.getAttribute("data-type")
          };
          n.push({
            id: r.id || Vn.createId(a),
            ...a
          });
        }
      }
    this.#n.set(e), this.#i.set(n), on();
  }
};
const bR = Jd.prototype;
et(bR, "load");
class CR extends Ut {
  #e;
  constructor(e) {
    super(), this.#e = e, N(this.#t.bind(this));
  }
  onDestroy() {
    this.#r?.(), this.#r = null;
  }
  #t() {
    const e = this.#e.trigger();
    if (!e) {
      this.hide();
      return;
    }
    const n = this.show.bind(this), i = this.hide.bind(this);
    this.#e.listen(e, n, i);
  }
  #n = -1;
  #i = -1;
  #r = null;
  show(e) {
    this.#a(), window.cancelAnimationFrame(this.#i), this.#i = -1, this.#r?.(), this.#r = null, this.#n = window.setTimeout(() => {
      this.#n = -1;
      const n = this.#e.content();
      n && n.style.removeProperty("display"), F(() => this.#e.onChange(!0, e));
    }, this.#e.showDelay?.() ?? 0);
  }
  hide(e) {
    this.#a(), F(() => this.#e.onChange(!1, e)), this.#i = requestAnimationFrame(() => {
      this.#a(), this.#i = -1;
      const n = this.#e.content();
      if (n) {
        const i = () => {
          n.style.display = "none", this.#r = null;
        };
        if (iy(n)) {
          this.#r?.();
          const a = Ve(n, "animationend", i, { once: !0 });
          this.#r = a;
        } else
          i();
      }
    });
  }
  #a() {
    window.clearTimeout(this.#n), this.#n = -1;
  }
}
class kt extends Ut {
  static props = {
    disabled: !1
  };
  #e;
  constructor(e) {
    super(), this.#e = e, new Dn(), e.keyShortcut && new yy(e.keyShortcut);
  }
  onSetup() {
    const { disabled: e } = this.$props;
    this.setAttributes({
      "data-pressed": this.#e.isPresssed,
      "aria-pressed": this.#t.bind(this),
      "aria-disabled": () => e() ? "true" : null
    });
  }
  onAttach(e) {
    Be(e, "tabindex", "0"), Be(e, "role", "button"), Be(e, "type", "button");
  }
  onConnect(e) {
    const n = On(e, this.#i.bind(this));
    for (const i of ["click", "touchstart"])
      n.add(i, this.#r.bind(this), {
        passive: !0
      });
  }
  #t() {
    return rr(this.#e.isPresssed());
  }
  #n(e) {
    jc(this.#e.isPresssed) && this.#e.isPresssed.set((n) => !n);
  }
  #i(e) {
    if (this.$props.disabled() || this.el.hasAttribute("data-disabled")) {
      e.preventDefault(), e.stopImmediatePropagation();
      return;
    }
    e.preventDefault(), (this.#e.onPress ?? this.#n).call(this, e);
  }
  #r(e) {
    this.$props.disabled() && (e.preventDefault(), e.stopImmediatePropagation());
  }
}
let jd = class extends be {
  static props = {
    disabled: !1,
    defaultPressed: !1
  };
  #e = j(!1);
  /**
   * Whether the toggle is currently in a `pressed` state.
   */
  get pressed() {
    return this.#e();
  }
  constructor() {
    super(), new kt({
      isPresssed: this.#e
    });
  }
};
const yR = jd.prototype;
he(yR, "pressed");
let RR = class extends be {
  static props = kt.props;
  #e;
  constructor() {
    super(), new kt({
      isPresssed: this.#n.bind(this),
      onPress: this.#t.bind(this)
    });
  }
  onSetup() {
    this.#e = Ge();
    const { canAirPlay: e, isAirPlayConnected: n } = this.#e.$state;
    this.setAttributes({
      "data-active": n,
      "data-supported": e,
      "data-state": this.#i.bind(this),
      "aria-hidden": Pt(() => !e())
    });
  }
  onAttach(e) {
    e.setAttribute("data-media-tooltip", "airplay"), Kn(e, this.#r.bind(this));
  }
  #t(e) {
    this.#e.remote.requestAirPlay(e);
  }
  #n() {
    const { remotePlaybackType: e, remotePlaybackState: n } = this.#e.$state;
    return e() === "airplay" && n() !== "disconnected";
  }
  #i() {
    const { remotePlaybackType: e, remotePlaybackState: n } = this.#e.$state;
    return e() === "airplay" && n();
  }
  #r() {
    const { remotePlaybackState: e } = this.#e.$state;
    return `AirPlay ${e()}`;
  }
}, NR = class extends be {
  static props = kt.props;
  #e;
  constructor() {
    super(), new kt({
      isPresssed: this.#n.bind(this),
      keyShortcut: "togglePaused",
      onPress: this.#t.bind(this)
    });
  }
  onSetup() {
    this.#e = Ge();
    const { paused: e, ended: n } = this.#e.$state;
    this.setAttributes({
      "data-paused": e,
      "data-ended": n
    });
  }
  onAttach(e) {
    e.setAttribute("data-media-tooltip", "play"), Kn(e, "Play");
  }
  #t(e) {
    const n = this.#e.remote;
    this.#n() ? n.pause(e) : n.play(e);
  }
  #n() {
    const { paused: e } = this.#e.$state;
    return !e();
  }
}, OR = class extends be {
  static props = kt.props;
  #e;
  constructor() {
    super(), new kt({
      isPresssed: this.#n.bind(this),
      keyShortcut: "toggleCaptions",
      onPress: this.#t.bind(this)
    });
  }
  onSetup() {
    this.#e = Ge(), this.setAttributes({
      "data-active": this.#n.bind(this),
      "data-supported": () => !this.#i(),
      "aria-hidden": Pt(this.#i.bind(this))
    });
  }
  onAttach(e) {
    e.setAttribute("data-media-tooltip", "caption"), Kn(e, "Captions");
  }
  #t(e) {
    this.#e.remote.toggleCaptions(e);
  }
  #n() {
    const { textTrack: e } = this.#e.$state, n = e();
    return !!n && bt(n);
  }
  #i() {
    const { hasCaptions: e } = this.#e.$state;
    return !e();
  }
}, vR = class extends be {
  static props = {
    ...kt.props,
    target: "prefer-media"
  };
  #e;
  constructor() {
    super(), new kt({
      isPresssed: this.#n.bind(this),
      keyShortcut: "toggleFullscreen",
      onPress: this.#t.bind(this)
    });
  }
  onSetup() {
    this.#e = Ge();
    const { fullscreen: e } = this.#e.$state, n = this.#i.bind(this);
    this.setAttributes({
      "data-active": e,
      "data-supported": n,
      "aria-hidden": Pt(() => !n())
    });
  }
  onAttach(e) {
    e.setAttribute("data-media-tooltip", "fullscreen"), Kn(e, "Fullscreen");
  }
  #t(e) {
    const n = this.#e.remote, i = this.$props.target();
    this.#n() ? n.exitFullscreen(i, e) : n.enterFullscreen(i, e);
  }
  #n() {
    const { fullscreen: e } = this.#e.$state;
    return e();
  }
  #i() {
    const { canFullscreen: e } = this.#e.$state;
    return e();
  }
}, AR = class extends be {
  static props = kt.props;
  #e;
  constructor() {
    super(), new kt({
      isPresssed: this.#n.bind(this),
      keyShortcut: "toggleMuted",
      onPress: this.#t.bind(this)
    });
  }
  onSetup() {
    this.#e = Ge(), this.setAttributes({
      "data-muted": this.#n.bind(this),
      "data-state": this.#i.bind(this)
    });
  }
  onAttach(e) {
    e.setAttribute("data-media-mute-button", ""), e.setAttribute("data-media-tooltip", "mute"), Kn(e, "Mute");
  }
  #t(e) {
    const n = this.#e.remote;
    this.#n() ? n.unmute(e) : n.mute(e);
  }
  #n() {
    const { muted: e, volume: n } = this.#e.$state;
    return e() || n() === 0;
  }
  #i() {
    const { muted: e, volume: n } = this.#e.$state, i = n();
    if (e() || i === 0) return "muted";
    if (i >= 0.5) return "high";
    if (i < 0.5) return "low";
  }
}, IR = class extends be {
  static props = kt.props;
  #e;
  constructor() {
    super(), new kt({
      isPresssed: this.#n.bind(this),
      keyShortcut: "togglePictureInPicture",
      onPress: this.#t.bind(this)
    });
  }
  onSetup() {
    this.#e = Ge();
    const { pictureInPicture: e } = this.#e.$state, n = this.#i.bind(this);
    this.setAttributes({
      "data-active": e,
      "data-supported": n,
      "aria-hidden": Pt(() => !n())
    });
  }
  onAttach(e) {
    e.setAttribute("data-media-tooltip", "pip"), Kn(e, "PiP");
  }
  #t(e) {
    const n = this.#e.remote;
    this.#n() ? n.exitPictureInPicture(e) : n.enterPictureInPicture(e);
  }
  #n() {
    const { pictureInPicture: e } = this.#e.$state;
    return e();
  }
  #i() {
    const { canPictureInPicture: e } = this.#e.$state;
    return e();
  }
}, DR = class extends be {
  static props = {
    disabled: !1,
    seconds: 30
  };
  #e;
  constructor() {
    super(), new Dn();
  }
  onSetup() {
    this.#e = Ge();
    const { seeking: e } = this.#e.$state, { seconds: n } = this.$props, i = this.#t.bind(this);
    this.setAttributes({
      seconds: n,
      "data-seeking": e,
      "data-supported": i,
      "aria-hidden": Pt(() => !i())
    });
  }
  onAttach(e) {
    Be(e, "tabindex", "0"), Be(e, "role", "button"), Be(e, "type", "button"), e.setAttribute("data-media-tooltip", "seek"), Kn(e, this.#n.bind(this));
  }
  onConnect(e) {
    On(e, this.#i.bind(this));
  }
  #t() {
    const { canSeek: e } = this.#e.$state;
    return e();
  }
  #n() {
    const { seconds: e } = this.$props;
    return `Seek ${e() > 0 ? "forward" : "backward"} ${e()} seconds`;
  }
  #i(e) {
    const { seconds: n, disabled: i } = this.$props;
    if (i()) return;
    const { currentTime: r } = this.#e.$state, a = r() + n();
    this.#e.remote.seek(a, e);
  }
}, MR = class extends be {
  static props = {
    disabled: !1
  };
  #e;
  constructor() {
    super(), new Dn();
  }
  onSetup() {
    this.#e = Ge();
    const { disabled: e } = this.$props, { live: n, liveEdge: i } = this.#e.$state, r = () => !n();
    this.setAttributes({
      "data-edge": i,
      "data-hidden": r,
      "aria-disabled": Pt(() => e() || i()),
      "aria-hidden": Pt(r)
    });
  }
  onAttach(e) {
    Be(e, "tabindex", "0"), Be(e, "role", "button"), Be(e, "type", "button"), e.setAttribute("data-media-tooltip", "live");
  }
  onConnect(e) {
    On(e, this.#t.bind(this));
  }
  #t(e) {
    const { disabled: n } = this.$props, { liveEdge: i } = this.#e.$state;
    n() || i() || this.#e.remote.seekToLiveEdge(e);
  }
};
const Ca = new In({
  min: 0,
  max: 100,
  value: 0,
  step: 1,
  pointerValue: 0,
  focused: !1,
  dragging: !1,
  pointing: !1,
  hidden: !1,
  get active() {
    return this.dragging || this.focused || this.pointing;
  },
  get fillRate() {
    return jl(this.min, this.max, this.value);
  },
  get fillPercent() {
    return this.fillRate * 100;
  },
  get pointerRate() {
    return jl(this.min, this.max, this.pointerValue);
  },
  get pointerPercent() {
    return this.pointerRate * 100;
  }
});
function jl(t, e, n) {
  const i = e - t, r = n - t;
  return i > 0 ? r / i : 0;
}
class eu extends Ut {
  #e;
  #t;
  constructor(e) {
    super(), this.#e = e;
  }
  onConnect(e) {
    this.#t = new IntersectionObserver((n) => {
      this.#e.callback?.(n, this.#t);
    }, this.#e), this.#t.observe(e), ue(this.#n.bind(this));
  }
  /**
   * Disconnect any active intersection observers.
   */
  #n() {
    this.#t?.disconnect(), this.#t = void 0;
  }
}
const po = An(), ji = An();
function wR(t, e, n, i) {
  return ao(t, Rt(n, _s(i)), e);
}
function xR(t, e, n, i) {
  const r = ao(0, n, 1), a = e - t, s = a * r, o = s / i, l = i * Math.round(o);
  return t + l;
}
const Qa = {
  Left: -1,
  ArrowLeft: -1,
  Up: 1,
  ArrowUp: 1,
  Right: 1,
  ArrowRight: 1,
  Down: -1,
  ArrowDown: -1
};
class LR extends Ut {
  #e;
  #t;
  #n;
  constructor(e, n) {
    super(), this.#e = e, this.#t = n;
  }
  onSetup() {
    dn(ji) && (this.#n = ut(ji));
  }
  onConnect(e) {
    N(this.#c.bind(this, e)), N(this.#_.bind(this, e)), this.#e.swipeGesture && N(this.#i.bind(this));
  }
  #i() {
    const { pointer: e } = this.#t.$state;
    if (e() !== "coarse" || !this.#e.swipeGesture()) {
      this.#r = null;
      return;
    }
    this.#r = this.#t.player.el?.querySelector(
      "media-provider,[data-media-provider]"
    ), this.#r && new Ae(this.#r).add("touchstart", this.#l.bind(this), {
      passive: !0
    }).add("touchmove", this.#o.bind(this), { passive: !1 });
  }
  #r = null;
  #a = null;
  #s = null;
  #l(e) {
    this.#a = e.touches[0];
  }
  #o(e) {
    if (Qt(this.#a) || so(e)) return;
    const n = e.touches[0], i = n.clientX - this.#a.clientX, r = n.clientY - this.#a.clientY, a = this.$state.dragging();
    !a && Math.abs(r) > 5 || a || (e.preventDefault(), Math.abs(i) > 20 && (this.#a = n, this.#s = this.$state.value(), this.#b(this.#s, e)));
  }
  #c(e) {
    const { hidden: n } = this.$props;
    Ve(e, "focus", this.#u.bind(this)), !(n() || this.#e.isDisabled()) && new Ae(e).add("keyup", this.#y.bind(this)).add("keydown", this.#R.bind(this)).add("pointerenter", this.#f.bind(this)).add("pointermove", this.#S.bind(this)).add("pointerleave", this.#T.bind(this)).add("pointerdown", this.#m.bind(this));
  }
  #_(e) {
    this.#e.isDisabled() || !this.$state.dragging() || new Ae(document).add("pointerup", this.#v.bind(this), { capture: !0 }).add("pointermove", this.#A.bind(this)).add("touchmove", this.#I.bind(this), {
      passive: !1
    });
  }
  #u() {
    this.#p(this.$state.value());
  }
  #d(e, n) {
    const { value: i, min: r, max: a, dragging: s } = this.$state, o = Math.max(r(), Math.min(e, a()));
    i.set(o);
    const l = this.createEvent("value-change", { detail: o, trigger: n });
    if (this.dispatch(l), this.#e.onValueChange?.(l), s()) {
      const c = this.createEvent("drag-value-change", { detail: o, trigger: n });
      this.dispatch(c), this.#e.onDragValueChange?.(c);
    }
  }
  #p(e, n) {
    const { pointerValue: i, dragging: r } = this.$state;
    i.set(e), this.dispatch("pointer-value-change", { detail: e, trigger: n }), r() && this.#d(e, n);
  }
  #E(e) {
    let n, i = this.el.getBoundingClientRect(), { min: r, max: a } = this.$state;
    if (this.$props.orientation() === "vertical") {
      const { bottom: s, height: o } = i;
      n = (s - e.clientY) / o;
    } else if (this.#a && mt(this.#s)) {
      const { width: s } = this.#r.getBoundingClientRect(), o = (e.clientX - this.#a.clientX) / s, l = a() - r(), c = l * Math.abs(o);
      n = (o < 0 ? this.#s - c : this.#s + c) / l;
    } else {
      const { left: s, width: o } = i;
      n = (e.clientX - s) / o;
    }
    return Math.max(
      r(),
      Math.min(
        a(),
        this.#e.roundValue(
          xR(r(), a(), n, this.#e.getStep())
        )
      )
    );
  }
  #f(e) {
    this.$state.pointing.set(!0);
  }
  #S(e) {
    const { dragging: n } = this.$state;
    n() || this.#p(this.#E(e), e);
  }
  #T(e) {
    this.$state.pointing.set(!1);
  }
  #m(e) {
    if (e.button !== 0) return;
    const n = this.#E(e);
    this.#b(n, e), this.#p(n, e);
  }
  #b(e, n) {
    const { dragging: i } = this.$state;
    if (i()) return;
    i.set(!0), this.#t.remote.pauseControls(n);
    const r = this.createEvent("drag-start", { detail: e, trigger: n });
    this.dispatch(r), this.#e.onDragStart?.(r), this.#n?.onDragStart?.();
  }
  #h(e, n) {
    const { dragging: i } = this.$state;
    if (!i()) return;
    i.set(!1), this.#t.remote.resumeControls(n);
    const r = this.createEvent("drag-end", { detail: e, trigger: n });
    this.dispatch(r), this.#e.onDragEnd?.(r), this.#a = null, this.#s = null, this.#n?.onDragEnd?.();
  }
  // -------------------------------------------------------------------------------------------
  // Keyboard Events
  // -------------------------------------------------------------------------------------------
  #C;
  #g = !1;
  #R(e) {
    if (!Object.keys(Qa).includes(e.key)) return;
    const { key: i } = e, r = this.#N(e);
    if (!Qt(r)) {
      this.#p(r, e), this.#d(r, e);
      return;
    }
    const a = this.#O(e);
    this.#g || (this.#g = i === this.#C, !this.$state.dragging() && this.#g && this.#b(a, e)), this.#p(a, e), this.#C = i;
  }
  #y(e) {
    if (!Object.keys(Qa).includes(e.key) || !Qt(this.#N(e))) return;
    const i = this.#g ? this.$state.pointerValue() : this.#O(e);
    this.#d(i, e), this.#h(i, e), this.#C = "", this.#g = !1;
  }
  #N(e) {
    let n = e.key, { min: i, max: r } = this.$state;
    return n === "Home" || n === "PageUp" ? i() : n === "End" || n === "PageDown" ? r() : !e.metaKey && /^[0-9]$/.test(n) ? (r() - i()) / 10 * Number(n) : null;
  }
  #O(e) {
    const { key: n, shiftKey: i } = e;
    e.preventDefault(), e.stopPropagation();
    const { shiftKeyMultiplier: r } = this.$props, { min: a, max: s, value: o, pointerValue: l } = this.$state, c = this.#e.getStep(), d = this.#e.getKeyStep(), u = i ? d * r() : d, _ = Number(Qa[n]), m = u * _, g = this.#g ? l() : this.#e.getValue?.() ?? o(), S = (g + m) / c;
    return Math.max(a(), Math.min(s(), Number((c * S).toFixed(3))));
  }
  // -------------------------------------------------------------------------------------------
  // Document (Pointer Events)
  // -------------------------------------------------------------------------------------------
  #v(e) {
    if (e.button !== 0) return;
    e.preventDefault(), e.stopImmediatePropagation();
    const n = this.#E(e);
    this.#p(n, e), this.#h(n, e);
  }
  #I(e) {
    e.preventDefault();
  }
  #A = Oi(
    (e) => {
      this.#p(this.#E(e), e);
    },
    20,
    { leading: !0 }
  );
}
const sr = An(() => ({}));
class Ti extends Ut {
  static props = {
    hidden: !1,
    disabled: !1,
    step: 1,
    keyStep: 1,
    orientation: "horizontal",
    shiftKeyMultiplier: 5
  };
  #e;
  #t;
  #n = j(!0);
  #i = j(!0);
  constructor(e) {
    super(), this.#t = e;
  }
  onSetup() {
    this.#e = Ge();
    const e = new Dn();
    e.attach(this), this.$state.focused = e.focused.bind(e), dn(sr) || en(sr, {
      default: "value"
    }), en(po, {
      orientation: this.$props.orientation,
      disabled: this.#t.isDisabled,
      preview: j(null)
    }), N(this.#s.bind(this)), N(this.#l.bind(this)), N(this.#o.bind(this)), this.#_(), new LR(this.#t, this.#e).attach(this), new eu({
      callback: this.#r.bind(this)
    }).attach(this);
  }
  onAttach(e) {
    Be(e, "role", "slider"), Be(e, "tabindex", "0"), Be(e, "autocomplete", "off"), H ? this.#u() : N(this.#u.bind(this));
  }
  onConnect(e) {
    ue(Vd(e, this.#n.set)), N(this.#a.bind(this));
  }
  #r(e) {
    this.#i.set(e[0].isIntersecting);
  }
  // -------------------------------------------------------------------------------------------
  // Watch
  // -------------------------------------------------------------------------------------------
  #a() {
    const { hidden: e } = this.$props;
    this.$state.hidden.set(e() || !this.#n() || !this.#i.bind(this));
  }
  #s() {
    const { dragging: e, value: n, min: i, max: r } = this.$state;
    F(e) || n.set(wR(i(), r(), n(), this.#t.getStep()));
  }
  #l() {
    this.$state.step.set(this.#t.getStep());
  }
  #o() {
    if (!this.#t.isDisabled()) return;
    const { dragging: e, pointing: n } = this.$state;
    e.set(!1), n.set(!1);
  }
  // -------------------------------------------------------------------------------------------
  // ARIA
  // -------------------------------------------------------------------------------------------
  #c() {
    return rr(this.#t.isDisabled());
  }
  // -------------------------------------------------------------------------------------------
  // Attributes
  // -------------------------------------------------------------------------------------------
  #_() {
    const { orientation: e } = this.$props, { dragging: n, active: i, pointing: r } = this.$state;
    this.setAttributes({
      "data-dragging": n,
      "data-pointing": r,
      "data-active": i,
      "aria-disabled": this.#c.bind(this),
      "aria-valuemin": this.#t.aria.valueMin ?? this.$state.min,
      "aria-valuemax": this.#t.aria.valueMax ?? this.$state.max,
      "aria-valuenow": this.#t.aria.valueNow,
      "aria-valuetext": this.#t.aria.valueText,
      "aria-orientation": e
    });
  }
  #u() {
    const { fillPercent: e, pointerPercent: n } = this.$state;
    this.#d(Rt(e(), 3), Rt(n(), 3));
  }
  #d = Wn((e, n) => {
    this.el?.style.setProperty("--slider-fill", e + "%"), this.el?.style.setProperty("--slider-pointer", n + "%");
  });
}
class mr extends be {
  static props = {
    ...Ti.props,
    min: 0,
    max: 100,
    value: 0
  };
  static state = Ca;
  constructor() {
    super(), new Ti({
      getStep: this.$props.step,
      getKeyStep: this.$props.keyStep,
      roundValue: Math.round,
      isDisabled: this.$props.disabled,
      aria: {
        valueNow: this.#e.bind(this),
        valueText: this.#t.bind(this)
      }
    });
  }
  onSetup() {
    N(this.#n.bind(this)), N(this.#i.bind(this));
  }
  // -------------------------------------------------------------------------------------------
  // Props
  // -------------------------------------------------------------------------------------------
  #e() {
    const { value: e } = this.$state;
    return Math.round(e());
  }
  #t() {
    const { value: e, max: n } = this.$state;
    return Rt(e() / n() * 100, 2) + "%";
  }
  // -------------------------------------------------------------------------------------------
  // Watch
  // -------------------------------------------------------------------------------------------
  #n() {
    const { value: e } = this.$props;
    this.$state.value.set(e());
  }
  #i() {
    const { min: e, max: n } = this.$props;
    this.$state.min.set(e()), this.$state.max.set(n());
  }
}
const fn = /* @__PURE__ */ new Map(), kr = /* @__PURE__ */ new Map();
class mo {
  #e;
  #t;
  #n;
  $images = j([]);
  static create(e, n) {
    const i = Ge();
    return new mo(e, n, i);
  }
  constructor(e, n, i) {
    this.#t = e, this.#n = n, this.#e = i, N(this.#i.bind(this));
  }
  #i() {
    const { canLoad: e } = this.#e.$state;
    if (!e()) return;
    const n = this.#t();
    if (n) {
      if (Q(n) && fn.has(n)) {
        const i = fn.get(n);
        if (fn.delete(n), fn.set(n, i), fn.size > 99) {
          const r = fn.keys().next().value;
          fn.delete(r);
        }
        this.$images.set(fn.get(n));
      } else if (Q(n)) {
        const i = this.#n(), r = n + "::" + i;
        if (!kr.has(r)) {
          const a = new Promise(async (s, o) => {
            try {
              const l = await fetch(n, {
                credentials: Ji(i)
              });
              if (l.headers.get("content-type") === "application/json") {
                const d = await l.json();
                if (Et(d))
                  if (d[0] && "text" in d[0])
                    s(this.#s(d));
                  else {
                    for (let u = 0; u < d.length; u++) {
                      const _ = d[u];
                      hn(td(_), !1), hn(
                        "url" in _ && Q(_.url),
                        !1
                      ), hn(
                        "startTime" in _ && mt(_.startTime),
                        !1
                      );
                    }
                    s(d);
                  }
                else
                  s(this.#a(d));
                return;
              }
              import("./prod-BQ6GYK89.js").then((d) => d.d).then(async ({ parseResponse: d }) => {
                try {
                  const { cues: u } = await d(l);
                  s(this.#s(u));
                } catch (u) {
                  o(u);
                }
              });
            } catch (l) {
              o(l);
            }
          }).then((s) => (fn.set(r, s), s)).catch((s) => {
            this.#_(n, s);
          }).finally(() => {
            Q(r) && kr.delete(r);
          });
          kr.set(r, a);
        }
        kr.get(r)?.then((a) => {
          this.$images.set(a || []);
        });
      } else if (Et(n))
        try {
          this.$images.set(this.#r(n));
        } catch (i) {
          this.#_(n, i);
        }
      else
        try {
          this.$images.set(this.#a(n));
        } catch (i) {
          this.#_(n, i);
        }
      return () => {
        this.$images.set([]);
      };
    }
  }
  #r(e) {
    const n = this.#l();
    return e.map((i, r) => (hn(
      i.url && Q(i.url)
    ), hn(
      "startTime" in i && mt(i.startTime)
    ), {
      ...i,
      url: Q(i.url) ? this.#o(i.url, n) : i.url
    }));
  }
  #a(e) {
    hn(Q(e.url)), hn(Et(e.tiles) && e.tiles?.length);
    const n = new URL(e.url), i = [], r = "tile_width" in e ? e.tile_width : e.tileWidth, a = "tile_height" in e ? e.tile_height : e.tileHeight;
    for (const s of e.tiles)
      i.push({
        url: n,
        startTime: "start" in s ? s.start : s.startTime,
        width: r,
        height: a,
        coords: { x: s.x, y: s.y }
      });
    return i;
  }
  #s(e) {
    for (let r = 0; r < e.length; r++) {
      const a = e[r];
      hn(
        "startTime" in a && mt(a.startTime)
      ), hn(
        "text" in a && Q(a.text)
      );
    }
    const n = [], i = this.#l();
    for (const r of e) {
      const [a, s] = r.text.split("#"), o = this.#c(s);
      n.push({
        url: this.#o(a, i),
        startTime: r.startTime,
        endTime: r.endTime,
        width: o?.w,
        height: o?.h,
        coords: o && mt(o.x) && mt(o.y) ? { x: o.x, y: o.y } : void 0
      });
    }
    return n;
  }
  #l() {
    let e = F(this.#t);
    return !Q(e) || !/^https?:/.test(e) ? location.href : e;
  }
  #o(e, n) {
    return /^https?:/.test(e) ? new URL(e) : new URL(e, n);
  }
  #c(e) {
    if (!e) return {};
    const [n, i] = e.split("="), r = i?.split(","), a = {};
    if (!n || !r)
      return null;
    for (let s = 0; s < n.length; s++) {
      const o = +r[s];
      isNaN(o) || (a[n[s]] = o);
    }
    return a;
  }
  #_(e, n) {
  }
}
let tu = class extends be {
  static props = {
    src: null,
    time: 0,
    crossOrigin: null
  };
  static state = new In({
    src: "",
    img: null,
    thumbnails: [],
    activeThumbnail: null,
    crossOrigin: null,
    loading: !1,
    error: null,
    hidden: !1
  });
  media;
  #e;
  #t = [];
  onSetup() {
    this.media = Ge(), this.#e = mo.create(this.$props.src, this.$state.crossOrigin), this.#i(), this.setAttributes({
      "data-loading": this.#l.bind(this),
      "data-error": this.#o.bind(this),
      "data-hidden": this.$state.hidden,
      "aria-hidden": Pt(this.$state.hidden)
    });
  }
  onConnect(e) {
    N(this.#n.bind(this)), N(this.#c.bind(this)), N(this.#i.bind(this)), N(this.#r.bind(this)), N(this.#_.bind(this)), N(this.#u.bind(this));
  }
  #n() {
    const e = this.$state.img();
    e && new Ae(e).add("load", this.#a.bind(this)).add("error", this.#s.bind(this));
  }
  #i() {
    const { crossOrigin: e } = this.$props, { crossOrigin: n } = this.$state, { crossOrigin: i } = this.media.$state, r = e() !== null ? e() : i();
    n.set(r === !0 ? "anonymous" : r);
  }
  #r() {
    const { src: e, loading: n, error: i } = this.$state;
    return e() && (n.set(!0), i.set(null)), () => {
      this.#p(), n.set(!1), i.set(null);
    };
  }
  #a() {
    const { loading: e, error: n } = this.$state;
    this.#u(), e.set(!1), n.set(null);
  }
  #s(e) {
    const { loading: n, error: i } = this.$state;
    n.set(!1), i.set(e);
  }
  #l() {
    const { loading: e, hidden: n } = this.$state;
    return !n() && e();
  }
  #o() {
    const { error: e } = this.$state;
    return !Qt(e());
  }
  #c() {
    const { hidden: e } = this.$state, { duration: n } = this.media.$state, i = this.#e.$images();
    e.set(this.#o() || !Number.isFinite(n()) || i.length === 0);
  }
  getTime() {
    return this.$props.time();
  }
  #_() {
    let e = this.#e.$images();
    if (!e.length) return;
    let n = this.getTime(), { src: i, activeThumbnail: r } = this.$state, a = -1, s = null;
    for (let o = e.length - 1; o >= 0; o--) {
      const l = e[o];
      if (n >= l.startTime && (!l.endTime || n < l.endTime)) {
        a = o;
        break;
      }
    }
    e[a] && (s = e[a]), r.set(s), i.set(s?.url.href || "");
  }
  #u() {
    if (!this.scope || this.$state.hidden()) return;
    const e = this.el, n = this.$state.img(), i = this.$state.activeThumbnail();
    if (!n || !i || !e) return;
    let r = i.width ?? n.naturalWidth, a = i?.height ?? n.naturalHeight, {
      maxWidth: s,
      maxHeight: o,
      minWidth: l,
      minHeight: c,
      width: d,
      height: u
    } = getComputedStyle(this.el);
    l === "100%" && (l = parseFloat(d) + ""), c === "100%" && (c = parseFloat(u) + "");
    let _ = Math.max(parseInt(l) / r, parseInt(c) / a), m = Math.min(
      Math.max(parseInt(l), parseInt(s)) / r,
      Math.max(parseInt(c), parseInt(o)) / a
    ), g = !isNaN(m) && m < 1 ? m : _ > 1 ? _ : 1;
    this.#d(e, "--thumbnail-width", `${r * g}px`), this.#d(e, "--thumbnail-height", `${a * g}px`), this.#d(e, "--thumbnail-aspect-ratio", String(Rt(r / a, 5))), this.#d(n, "width", `${n.naturalWidth * g}px`), this.#d(n, "height", `${n.naturalHeight * g}px`), this.#d(
      n,
      "transform",
      i.coords ? `translate(-${i.coords.x * g}px, -${i.coords.y * g}px)` : ""
    ), this.#d(n, "max-width", "none");
  }
  #d(e, n, i) {
    e.style.setProperty(n, i), this.#t.push(() => e.style.removeProperty(n));
  }
  #p() {
    for (const e of this.#t) e();
    this.#t = [];
  }
};
class PR extends tu {
  #e;
  onAttach(e) {
    this.#e = Ri(mr.state);
  }
  getTime() {
    const { duration: e, clipStartTime: n } = this.media.$state;
    return n() + this.#e.pointerRate() * e();
  }
}
class nu extends be {
  static props = {
    src: null,
    crossOrigin: null
  };
  static state = new In({
    video: null,
    src: null,
    crossOrigin: null,
    canPlay: !1,
    error: null,
    hidden: !1
  });
  #e;
  #t;
  get video() {
    return this.$state.video();
  }
  onSetup() {
    this.#e = Ge(), this.#t = Ri(mr.state), this.#r(), this.setAttributes({
      "data-loading": this.#a.bind(this),
      "data-hidden": this.$state.hidden,
      "data-error": this.#s.bind(this),
      "aria-hidden": Pt(this.$state.hidden)
    });
  }
  onAttach(e) {
    N(this.#n.bind(this)), N(this.#i.bind(this)), N(this.#r.bind(this)), N(this.#l.bind(this)), N(this.#o.bind(this)), N(this.#u.bind(this));
  }
  #n() {
    const e = this.$state.video();
    e && (e.readyState >= 2 && this.#c(), new Ae(e).add("canplay", this.#c.bind(this)).add("error", this.#_.bind(this)));
  }
  #i() {
    const { src: e } = this.$state, { canLoad: n } = this.#e.$state;
    e.set(n() ? this.$props.src() : null);
  }
  #r() {
    const { crossOrigin: e } = this.$props, { crossOrigin: n } = this.$state, { crossOrigin: i } = this.#e.$state, r = e() !== null ? e() : i();
    n.set(r === !0 ? "anonymous" : r);
  }
  #a() {
    const { canPlay: e, hidden: n } = this.$state;
    return !e() && !n();
  }
  #s() {
    const { error: e } = this.$state;
    return !Qt(e);
  }
  #l() {
    const { src: e, hidden: n } = this.$state, { canLoad: i, duration: r } = this.#e.$state;
    n.set(i() && (!e() || this.#s() || !Number.isFinite(r())));
  }
  #o() {
    const { src: e, canPlay: n, error: i } = this.$state;
    e(), n.set(!1), i.set(null);
  }
  #c(e) {
    const { canPlay: n, error: i } = this.$state;
    n.set(!0), i.set(null), this.dispatch("can-play", { trigger: e });
  }
  #_(e) {
    const { canPlay: n, error: i } = this.$state;
    n.set(!1), i.set(e), this.dispatch("error", { trigger: e });
  }
  #u() {
    const { video: e, canPlay: n } = this.$state, { duration: i } = this.#e.$state, { pointerRate: r } = this.#t, a = e();
    n() && a && Number.isFinite(i()) && Number.isFinite(r()) && (a.currentTime = r() * i());
  }
}
const kR = nu.prototype;
he(kR, "video");
class iu extends be {
  static props = {
    type: "pointer",
    format: null,
    showHours: !1,
    showMs: !1,
    padHours: null,
    padMinutes: null,
    decimalPlaces: 2
  };
  #e;
  #t;
  #n;
  onSetup() {
    this.#n = Ri(mr.state), this.#e = ut(sr), this.#t = yi(this.getValueText.bind(this));
  }
  /**
   * Returns the current value formatted as text based on prop settings.
   */
  getValueText() {
    const {
      type: e,
      format: n,
      decimalPlaces: i,
      padHours: r,
      padMinutes: a,
      showHours: s,
      showMs: o
    } = this.$props, { value: l, pointerValue: c, min: d, max: u } = this.#n, _ = n?.() ?? this.#e.default, m = e() === "current" ? l() : c();
    if (_ === "percent") {
      const g = u() - d(), S = m / g * 100;
      return (this.#e.percent ?? Rt)(S, i()) + "%";
    } else return _ === "time" ? (this.#e.time ?? _o)(m, {
      padHrs: r(),
      padMins: a(),
      showHrs: s(),
      showMs: o()
    }) : (this.#e.value?.(m) ?? m.toFixed(2)) + "";
  }
}
const UR = iu.prototype;
et(UR, "getValueText");
class FR extends be {
  static props = {
    offset: 0,
    noClamp: !1
  };
  #e;
  onSetup() {
    this.#e = ut(po);
    const { active: e } = Ri(mr.state);
    this.setAttributes({
      "data-visible": e
    });
  }
  onAttach(e) {
    Object.assign(e.style, {
      position: "absolute",
      top: 0,
      left: 0,
      width: "max-content"
    });
  }
  onConnect(e) {
    const { preview: n } = this.#e;
    n.set(e), ue(() => n.set(null)), N(this.#t.bind(this));
    const i = new ResizeObserver(this.#t.bind(this));
    i.observe(e), ue(() => i.disconnect());
  }
  #t = Wn(() => {
    const { disabled: e, orientation: n } = this.#e;
    if (e()) return;
    const i = this.el, { offset: r, noClamp: a } = this.$props;
    i && BR(i, {
      clamp: !a(),
      offset: r(),
      orientation: n()
    });
  });
}
function BR(t, {
  clamp: e,
  offset: n,
  orientation: i
}) {
  const r = getComputedStyle(t), a = parseFloat(r.width), s = parseFloat(r.height), o = {
    top: null,
    right: null,
    bottom: null,
    left: null
  };
  if (o[i === "horizontal" ? "bottom" : "left"] = `calc(100% + var(--media-slider-preview-offset, ${n}px))`, i === "horizontal") {
    const l = a / 2;
    if (!e)
      o.left = `calc(var(--slider-pointer) - ${l}px)`;
    else {
      const c = `max(0px, calc(var(--slider-pointer) - ${l}px))`, d = `calc(100% - ${a}px)`;
      o.left = `min(${c}, ${d})`;
    }
  } else {
    const l = s / 2;
    if (!e)
      o.bottom = `calc(var(--slider-pointer) - ${l}px)`;
    else {
      const c = `max(${l}px, calc(var(--slider-pointer) - ${l}px))`, d = `calc(100% - ${s}px)`;
      o.bottom = `min(${c}, ${d})`;
    }
  }
  Object.assign(t.style, o);
}
class GR extends be {
  static props = {
    ...Ti.props,
    keyStep: 5,
    shiftKeyMultiplier: 2
  };
  static state = Ca;
  #e;
  onSetup() {
    this.#e = Ge();
    const { audioGain: e } = this.#e.$state;
    en(sr, {
      default: "percent",
      value(n) {
        return (n * (e() ?? 1)).toFixed(2);
      },
      percent(n) {
        return Math.round(n * (e() ?? 1));
      }
    }), new Ti({
      getStep: this.$props.step,
      getKeyStep: this.$props.keyStep,
      roundValue: Math.round,
      isDisabled: this.#r.bind(this),
      aria: {
        valueMax: this.#i.bind(this),
        valueNow: this.#t.bind(this),
        valueText: this.#n.bind(this)
      },
      onDragValueChange: this.#c.bind(this),
      onValueChange: this.#o.bind(this)
    }).attach(this), N(this.#a.bind(this));
  }
  onAttach(e) {
    e.setAttribute("data-media-volume-slider", ""), Be(e, "aria-label", "Volume");
    const { canSetVolume: n } = this.#e.$state;
    this.setAttributes({
      "data-supported": n,
      "aria-hidden": Pt(() => !n())
    });
  }
  #t() {
    const { value: e } = this.$state, { audioGain: n } = this.#e.$state;
    return Math.round(e() * (n() ?? 1));
  }
  #n() {
    const { value: e, max: n } = this.$state, { audioGain: i } = this.#e.$state;
    return Rt(e() / n() * (i() ?? 1) * 100, 2) + "%";
  }
  #i() {
    const { audioGain: e } = this.#e.$state;
    return this.$state.max() * (e() ?? 1);
  }
  #r() {
    const { disabled: e } = this.$props, { canSetVolume: n } = this.#e.$state;
    return e() || !n();
  }
  #a() {
    const { muted: e, volume: n } = this.#e.$state, i = e() ? 0 : n() * 100;
    this.$state.value.set(i), this.dispatch("value-change", { detail: i });
  }
  #s = Oi(this.#l.bind(this), 25);
  #l(e) {
    if (!e.trigger) return;
    const n = Rt(e.detail / 100, 3);
    this.#e.remote.changeVolume(n, e);
  }
  #o(e) {
    this.#s(e);
  }
  #c(e) {
    this.#s(e);
  }
}
class ru extends be {
  static props = {
    ...Ti.props,
    step: 0.1,
    keyStep: 5,
    shiftKeyMultiplier: 2,
    pauseWhileDragging: !1,
    noSwipeGesture: !1,
    seekingRequestThrottle: 100
  };
  static state = Ca;
  #e;
  #t;
  #n = j(null);
  constructor() {
    super();
    const { noSwipeGesture: e } = this.$props;
    new Ti({
      swipeGesture: () => !e(),
      getValue: this.#f.bind(this),
      getStep: this.#S.bind(this),
      getKeyStep: this.#T.bind(this),
      roundValue: this.#m,
      isDisabled: this.#b.bind(this),
      aria: {
        valueNow: this.#h.bind(this),
        valueText: this.#C.bind(this)
      },
      onDragStart: this.#u.bind(this),
      onDragValueChange: this.#d.bind(this),
      onDragEnd: this.#p.bind(this),
      onValueChange: this.#E.bind(this)
    });
  }
  onSetup() {
    this.#e = Ge(), en(sr, {
      default: "time",
      value: this.#y.bind(this),
      time: this.#N.bind(this)
    }), this.setAttributes({
      "data-chapters": this.#r.bind(this)
    }), this.setStyles({
      "--slider-progress": this.#i.bind(this)
    }), N(this.#s.bind(this)), N(this.#a.bind(this));
  }
  onAttach(e) {
    e.setAttribute("data-media-time-slider", ""), Be(e, "aria-label", "Seek");
  }
  onConnect(e) {
    N(this.#l.bind(this)), kd(this.#e.textTracks, "chapters", this.#n.set);
  }
  #i() {
    const { bufferedEnd: e, duration: n } = this.#e.$state;
    return Rt(Math.min(e() / Math.max(n(), 1), 1) * 100, 3) + "%";
  }
  #r() {
    const { duration: e } = this.#e.$state;
    return this.#n()?.cues.length && Number.isFinite(e()) && e() > 0;
  }
  #a() {
    this.#t = Oi(
      this.#o.bind(this),
      this.$props.seekingRequestThrottle()
    );
  }
  #s() {
    if (this.$state.hidden()) return;
    const { value: e, dragging: n } = this.$state, i = this.#f();
    F(n) || (e.set(i), this.dispatch("value-change", { detail: i }));
  }
  #l() {
    const e = this.#e.player.el, { preview: n } = ut(po);
    e && n() && re(e, "data-preview", this.$state.active());
  }
  #o(e, n) {
    this.#e.remote.seeking(e, n);
  }
  #c(e, n, i) {
    this.#t.cancel();
    const { live: r } = this.#e.$state;
    if (r() && n >= 99) {
      this.#e.remote.seekToLiveEdge(i);
      return;
    }
    this.#e.remote.seek(e, i);
  }
  #_ = !1;
  #u(e) {
    const { pauseWhileDragging: n } = this.$props;
    if (n()) {
      const { paused: i } = this.#e.$state;
      this.#_ = !i(), this.#e.remote.pause(e);
    }
  }
  #d(e) {
    this.#t(this.#g(e.detail), e);
  }
  #p(e) {
    const { seeking: n } = this.#e.$state;
    F(n) || this.#o(this.#g(e.detail), e);
    const i = e.detail;
    this.#c(this.#g(i), i, e);
    const { pauseWhileDragging: r } = this.$props;
    r() && this.#_ && (this.#e.remote.play(e), this.#_ = !1);
  }
  #E(e) {
    const { dragging: n } = this.$state;
    n() || !e.trigger || this.#p(e);
  }
  // -------------------------------------------------------------------------------------------
  // Props
  // -------------------------------------------------------------------------------------------
  #f() {
    const { currentTime: e } = this.#e.$state;
    return this.#R(e());
  }
  #S() {
    const e = this.$props.step() / this.#e.$state.duration() * 100;
    return Number.isFinite(e) ? e : 1;
  }
  #T() {
    const e = this.$props.keyStep() / this.#e.$state.duration() * 100;
    return Number.isFinite(e) ? e : 1;
  }
  #m(e) {
    return Rt(e, 3);
  }
  #b() {
    const { disabled: e } = this.$props, { canSeek: n } = this.#e.$state;
    return e() || !n();
  }
  // -------------------------------------------------------------------------------------------
  // ARIA
  // -------------------------------------------------------------------------------------------
  #h() {
    const { value: e } = this.$state;
    return Math.round(e());
  }
  #C() {
    const e = this.#g(this.$state.value()), { duration: n } = this.#e.$state;
    return Number.isFinite(e) ? `${ql(e)} out of ${ql(n())}` : "live";
  }
  // -------------------------------------------------------------------------------------------
  // Format
  // -------------------------------------------------------------------------------------------
  #g(e) {
    const { duration: n } = this.#e.$state;
    return Rt(e / 100 * n(), 5);
  }
  #R(e) {
    const { liveEdge: n, duration: i } = this.#e.$state, r = Math.max(0, Math.min(1, n() ? 1 : Math.min(e, i()) / i()));
    return Number.isNaN(r) ? 0 : Number.isFinite(r) ? r * 100 : 100;
  }
  #y(e) {
    const n = this.#g(e), { live: i, duration: r } = this.#e.$state;
    return Number.isFinite(n) ? (i() ? n - r() : n).toFixed(0) : "LIVE";
  }
  #N(e, n) {
    const i = this.#g(e), { live: r, duration: a } = this.#e.$state, s = r() ? i - a() : i;
    return Number.isFinite(i) ? `${s < 0 ? "-" : ""}${_o(Math.abs(s), n)}` : "LIVE";
  }
}
class au extends be {
  static props = {
    disabled: !1
  };
  #e;
  #t;
  #n;
  #i = null;
  #r = [];
  #a = j(null);
  #s = j([]);
  #l = j(-1);
  #o = j(-1);
  #c = 0;
  get cues() {
    return this.#s();
  }
  get activeCue() {
    return this.#s()[this.#l()] || null;
  }
  get activePointerCue() {
    return this.#s()[this.#o()] || null;
  }
  onSetup() {
    this.#e = Ge(), this.#t = Ri(ru.state);
  }
  onAttach(e) {
    kd(this.#e.textTracks, "chapters", this.#_.bind(this)), N(this.#v.bind(this));
  }
  onConnect() {
    ue(() => this.#u.bind(this));
  }
  onDestroy() {
    this.#_(null);
  }
  setRefs(e) {
    if (this.#r = e, this.#n?.dispose(), this.#r.length === 1) {
      const n = this.#r[0];
      n.style.width = "100%", n.style.setProperty("--chapter-fill", "var(--slider-fill)"), n.style.setProperty("--chapter-progress", "var(--slider-progress)");
    } else this.#r.length > 0 && Tt(() => this.#d(), this.#n = Si());
  }
  #_(e) {
    F(this.#a) !== e && (this.#u(), this.#a.set(e));
  }
  #u() {
    this.#r = [], this.#s.set([]), this.#l.set(-1), this.#o.set(-1), this.#c = 0, this.#n?.dispose();
  }
  #d() {
    this.#r.length && N(this.#p.bind(this));
  }
  #p() {
    const { hidden: e } = this.#t;
    e() || (N(this.#E.bind(this)), N(this.#f.bind(this)), N(this.#S.bind(this)), N(this.#h.bind(this)));
  }
  #E() {
    const e = this.#s();
    if (!e.length) return;
    let n, { seekableStart: i, seekableEnd: r } = this.#e.$state, a = i(), s = r() || e[e.length - 1].endTime, o = s - a, l = 100;
    for (let c = 0; c < e.length; c++)
      if (n = e[c], this.#r[c]) {
        const d = c === e.length - 1 ? l : Rt((n.endTime - Math.max(a, n.startTime)) / o * 100, 3);
        this.#r[c].style.width = d + "%", l -= d;
      }
  }
  #f() {
    let { liveEdge: e, seekableStart: n, seekableEnd: i } = this.#e.$state, { fillPercent: r, value: a } = this.#t, s = this.#s(), o = e(), l = F(this.#l), c = s[l], d = o ? this.#s.length - 1 : this.#b(
      c && c.startTime / i() * 100 <= F(a) ? l : 0,
      r()
    );
    o || !c ? this.#T(0, s.length, 100) : d > l ? this.#T(l, d, 100) : d < l && this.#T(d + 1, l + 1, 0);
    const u = o ? 100 : this.#N(
      s[d],
      r(),
      n(),
      this.#y(s)
    );
    this.#m(this.#r[d], u), this.#l.set(d);
  }
  #S() {
    let { hidden: e, pointerPercent: n } = this.#t;
    if (e()) {
      this.#o.set(-1);
      return;
    }
    const i = this.#b(0, n());
    this.#o.set(i);
  }
  #T(e, n, i) {
    for (let r = e; r < n; r++) this.#m(this.#r[r], i);
  }
  #m(e, n) {
    e && (e.style.setProperty("--chapter-fill", n + "%"), re(e, "data-active", n > 0 && n < 100), re(e, "data-ended", n === 100));
  }
  #b(e, n) {
    let i = 0, r = this.#s();
    if (n === 0) return 0;
    if (n === 100) return r.length - 1;
    let { seekableStart: a } = this.#e.$state, s = a(), o = this.#y(r);
    for (let l = e; l < r.length; l++)
      if (i = this.#N(r[l], n, s, o), i >= 0 && i < 100) return l;
    return 0;
  }
  #h() {
    this.#C(this.#g());
  }
  #C = Wn((e) => {
    let n, i = this.#s(), { seekableStart: r } = this.#e.$state, a = r(), s = this.#y(i);
    for (let o = this.#c; o < this.#r.length; o++)
      if (n = this.#N(i[o], e, a, s), this.#r[o]?.style.setProperty("--chapter-progress", n + "%"), n < 100) {
        this.#c = o;
        break;
      }
  });
  #g = yi(this.#R.bind(this));
  #R() {
    const { bufferedEnd: e, duration: n } = this.#e.$state;
    return Rt(Math.min(e() / Math.max(n(), 1), 1), 3) * 100;
  }
  #y(e) {
    const { seekableEnd: n } = this.#e.$state, i = n();
    return Number.isFinite(i) ? i : e[e.length - 1]?.endTime || 0;
  }
  #N(e, n, i, r) {
    if (!e || this.#s().length === 0) return 0;
    const s = r - i, o = Math.max(0, e.startTime - i), l = Math.min(r, e.endTime) - i, c = o / s, d = c * 100, u = Math.min(1, c + (l - o) / s) * 100;
    return Math.max(
      0,
      Rt(
        n >= u ? 100 : (n - d) / (u - d) * 100,
        3
      )
    );
  }
  #O(e) {
    let n = [], { seekableStart: i, seekableEnd: r, duration: a } = this.#e.$state, s = i(), o = r();
    e = e.filter((d) => d.startTime <= o && d.endTime >= s);
    const l = e[0];
    l && l.startTime > s && n.push(new window.VTTCue(s, l.startTime, ""));
    for (let d = 0; d < e.length - 1; d++) {
      const u = e[d], _ = e[d + 1];
      if (n.push(u), _) {
        const m = _.startTime - u.endTime;
        m > 0 && n.push(new window.VTTCue(u.endTime, u.endTime + m, ""));
      }
    }
    const c = e[e.length - 1];
    if (c) {
      n.push(c);
      const d = a();
      d >= 0 && d - c.endTime > 1 && n.push(new window.VTTCue(c.endTime, a(), ""));
    }
    return n;
  }
  #v() {
    const { source: e } = this.#e.$state;
    e(), this.#I();
  }
  #I() {
    if (!this.scope) return;
    const { disabled: e } = this.$props;
    if (e()) {
      this.#s.set([]), this.#l.set(0), this.#c = 0;
      return;
    }
    const n = this.#a();
    if (n) {
      const i = this.#D.bind(this);
      i(), new Ae(n).add("add-cue", i).add("remove-cue", i), N(this.#A.bind(this));
    }
    return this.#i = this.#x(), this.#i && N(this.#w.bind(this)), () => {
      this.#i && (this.#i.textContent = "", this.#i = null);
    };
  }
  #A() {
    this.#e.$state.duration(), this.#D();
  }
  #D = ga(
    () => {
      const e = F(this.#a);
      !this.scope || !e || !e.cues.length || (this.#s.set(this.#O(e.cues)), this.#l.set(0), this.#c = 0);
    },
    150,
    !0
  );
  #w() {
    const e = this.activePointerCue || this.activeCue;
    this.#i && (this.#i.textContent = e?.text || "");
  }
  #L() {
    let e = this.el;
    for (; e && e.getAttribute("role") !== "slider"; )
      e = e.parentElement;
    return e;
  }
  #x() {
    const e = this.#L();
    return e ? e.querySelector('[data-part="chapter-title"]') : null;
  }
}
const ya = au.prototype;
he(ya, "cues");
he(ya, "activeCue");
he(ya, "activePointerCue");
et(ya, "setRefs");
const Zt = An();
function YR(t, e) {
  const n = md(t, e);
  for (const { el: i, top: r, left: a } of n)
    i.scroll({ top: r, left: a, behavior: e.behavior });
}
function $R(t, e = {}) {
  YR(t, {
    scrollMode: "if-needed",
    block: "center",
    inline: "center",
    ...e
  });
}
const VR = /* @__PURE__ */ [
  "a[href]",
  "[tabindex]",
  "input",
  "select",
  "button"
].map((t) => `${t}:not([aria-hidden='true'])`).join(","), HR = /* @__PURE__ */ new Set([
  "Escape",
  "Tab",
  "ArrowUp",
  "ArrowDown",
  "Home",
  "PageUp",
  "End",
  "PageDown",
  "Enter",
  " "
]);
class qR {
  #e = -1;
  #t = null;
  #n = [];
  #i;
  get items() {
    return this.#n;
  }
  constructor(e) {
    this.#i = e;
  }
  attachMenu(e) {
    Ve(e, "focus", this.#s.bind(this)), this.#t = e, ue(() => {
      this.#t = null;
    });
  }
  listen() {
    this.#t && (this.update(), new Ae(this.#t).add("keyup", this.#o.bind(this)).add("keydown", this.#c.bind(this)), ue(() => {
      this.#e = -1, this.#n = [];
    }));
  }
  update() {
    this.#e = 0, this.#n = this.#u();
  }
  scroll(e = this.#a()) {
    const n = this.#n[e];
    n && requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        $R(n, {
          behavior: "smooth",
          boundary: (i) => !i.hasAttribute("data-root")
        });
      });
    });
  }
  focusActive(e = !0) {
    const n = this.#a();
    this.#r(n >= 0 ? n : 0, e);
  }
  #r(e, n = !0) {
    this.#e = e, this.#n[e] ? (this.#n[e].focus({ preventScroll: !0 }), n && this.scroll(e)) : this.#t?.focus({ preventScroll: !0 });
  }
  #a() {
    return this.#n.findIndex(
      (e) => document.activeElement === e || e.getAttribute("role") === "menuitemradio" && e.getAttribute("aria-checked") === "true"
    );
  }
  #s() {
    this.#e >= 0 || (this.update(), this.focusActive());
  }
  #l(e) {
    const n = e.target;
    if (rd(e) && n instanceof Element) {
      const i = n.getAttribute("role");
      return !/a|input|select|button/.test(n.localName) && !i;
    }
    return HR.has(e.key);
  }
  #o(e) {
    this.#l(e) && (e.stopPropagation(), e.preventDefault());
  }
  #c(e) {
    if (this.#l(e))
      switch (e.stopPropagation(), e.preventDefault(), e.key) {
        case "Escape":
          this.#i.closeMenu(e);
          break;
        case "Tab":
          this.#r(this.#_(e.shiftKey ? -1 : 1));
          break;
        case "ArrowUp":
          this.#r(this.#_(-1));
          break;
        case "ArrowDown":
          this.#r(this.#_(1));
          break;
        case "Home":
        case "PageUp":
          this.#r(0);
          break;
        case "End":
        case "PageDown":
          this.#r(this.#n.length - 1);
          break;
      }
  }
  #_(e) {
    let n = this.#e;
    do
      n = (n + e + this.#n.length) % this.#n.length;
    while (this.#n[n]?.offsetParent === null);
    return n;
  }
  #u() {
    if (!this.#t) return [];
    const e = this.#t.querySelectorAll(VR), n = [], i = (r) => r.getAttribute("role") === "menu";
    for (const r of e)
      ra(r) && r.offsetParent !== null && // does not have display: none
      Hd(this.#t, r, i) && n.push(r);
    return n;
  }
}
var zR = Object.defineProperty, WR = Object.getOwnPropertyDescriptor, Er = (t, e, n, i) => {
  for (var r = WR(e, n), a = t.length - 1, s; a >= 0; a--)
    (s = t[a]) && (r = s(e, n, r) || r);
  return r && zR(e, n, r), r;
};
let KR = 0;
class Di extends be {
  static props = {
    showDelay: 0
  };
  #e;
  #t;
  #n;
  #i = j(!1);
  #r = j(!1);
  #a = j(null);
  #s = j(null);
  #l;
  #o = /* @__PURE__ */ new Set();
  #c = null;
  #_;
  #u;
  #d = !1;
  #p = j(!1);
  #E = /* @__PURE__ */ new Set();
  get triggerElement() {
    return this.#a();
  }
  get contentElement() {
    return this.#s();
  }
  get isSubmenu() {
    return !!this.#l;
  }
  constructor() {
    super();
    const { showDelay: e } = this.$props;
    this.#_ = new CR({
      trigger: this.#a,
      content: this.#s,
      showDelay: e,
      listen: (n, i, r) => {
        On(n, (s) => {
          this.#i() ? r(s) : i(s);
        });
        const a = this.#D();
        a && On(a, (s) => {
          s.stopPropagation(), r(s);
        });
      },
      onChange: this.#R.bind(this)
    });
  }
  onSetup() {
    this.#e = Ge();
    const e = ++KR;
    this.#t = `media-menu-${e}`, this.#n = `media-menu-button-${e}`, this.#u = new qR({
      closeMenu: this.close.bind(this)
    }), dn(Zt) && (this.#l = ut(Zt)), this.#f(), this.setAttributes({
      "data-open": this.#i,
      "data-root": !this.isSubmenu,
      "data-submenu": this.isSubmenu,
      "data-disabled": this.#O.bind(this)
    }), en(Zt, {
      button: this.#a,
      content: this.#s,
      expanded: this.#i,
      hint: j(""),
      submenu: !!this.#l,
      disable: this.#v.bind(this),
      attachMenuButton: this.#T.bind(this),
      attachMenuItems: this.#m.bind(this),
      attachObserver: this.#b.bind(this),
      disableMenuButton: this.#C.bind(this),
      addSubmenu: this.#L.bind(this),
      onTransitionEvent: (n) => {
        this.#E.add(n), ue(() => {
          this.#E.delete(n);
        });
      }
    });
  }
  onAttach(e) {
    e.style.setProperty("display", "contents");
  }
  onConnect(e) {
    N(this.#S.bind(this)), this.isSubmenu && this.#l?.addSubmenu(this);
  }
  onDestroy() {
    this.#a.set(null), this.#s.set(null), this.#c = null, this.#E.clear();
  }
  #f() {
    let e = -1, n = dn(ji) ? ut(ji) : null;
    en(ji, {
      onDragStart: () => {
        n?.onDragStart?.(), window.clearTimeout(e), e = -1, this.#d = !0;
      },
      onDragEnd: () => {
        n?.onDragEnd?.(), e = window.setTimeout(() => {
          this.#d = !1, e = -1;
        }, 300);
      }
    });
  }
  #S() {
    const e = this.#N();
    this.isSubmenu || this.#F(), this.#h(e), e && (N(() => {
      const { height: n } = this.#e.$state, i = this.#s();
      i && Xt(i, "--player-height", n() + "px");
    }), this.#u.listen(), this.listen("pointerup", this.#I.bind(this)), Ve(window, "pointerup", this.#A.bind(this)));
  }
  #T(e) {
    const n = e.el, i = this.isSubmenu, r = Pt(this.#O.bind(this));
    Be(n, "tabindex", i ? "-1" : "0"), Be(n, "role", i ? "menuitem" : "button"), re(n, "id", this.#n), re(n, "aria-haspopup", "menu"), re(n, "aria-expanded", "false"), re(n, "data-root", !this.isSubmenu), re(n, "data-submenu", this.isSubmenu);
    const a = () => {
      re(n, "data-open", this.#i()), re(n, "aria-disabled", r());
    };
    H ? a() : N(a), this.#a.set(n), ue(() => {
      this.#a.set(null);
    });
  }
  #m(e) {
    const n = e.el;
    n.style.setProperty("display", "none"), re(n, "id", this.#t), Be(n, "role", "menu"), Be(n, "tabindex", "-1"), re(n, "data-root", !this.isSubmenu), re(n, "data-submenu", this.isSubmenu), this.#s.set(n), ue(() => this.#s.set(null));
    const i = () => re(n, "data-open", this.#i());
    H ? i() : N(i), this.#u.attachMenu(n), this.#h(!1);
    const r = this.#$.bind(this);
    this.isSubmenu ? this.#l?.onTransitionEvent(r) : (e.listen("transitionstart", r), e.listen("transitionend", r), e.listen("animationend", this.#F), e.listen("vds-menu-resize", this.#F));
  }
  #b(e) {
    this.#c = e;
  }
  #h(e) {
    const n = F(this.#s);
    n && re(n, "aria-hidden", rr(!e));
  }
  #C(e) {
    this.#p.set(e);
  }
  #g = !1;
  #R(e, n) {
    if (this.#g = zn(n), n?.stopPropagation(), this.#i() === e) return;
    if (this.#O()) {
      e && this.#_.hide(n);
      return;
    }
    this.el?.dispatchEvent(
      new Event("vds-menu-resize", {
        bubbles: !0,
        composed: !0
      })
    );
    const i = this.#a(), r = this.#s();
    if (i && (re(i, "aria-controls", e && this.#t), re(i, "aria-expanded", rr(e))), r && re(r, "aria-labelledby", e && this.#n), this.#i.set(e), this.#w(n), on(), this.#g) {
      e ? r?.focus() : i?.focus();
      for (const a of [this.el, r])
        a && a.setAttribute("data-keyboard", "");
    } else
      for (const a of [this.el, r])
        a && a.removeAttribute("data-keyboard");
    if (this.dispatch(e ? "open" : "close", { trigger: n }), e)
      !this.isSubmenu && this.#e.activeMenu !== this && (this.#e.activeMenu?.close(n), this.#e.activeMenu = this), this.#c?.onOpen?.(n);
    else {
      if (this.isSubmenu)
        for (const a of this.#o) a.close(n);
      else
        this.#e.activeMenu = null;
      this.#c?.onClose?.(n);
    }
    e && requestAnimationFrame(this.#y.bind(this));
  }
  #y() {
    this.#B || this.#M || (this.#u.update(), requestAnimationFrame(() => {
      this.#g ? this.#u.focusActive() : this.#u.scroll();
    }));
  }
  #N() {
    return !this.#O() && this.#i();
  }
  #O() {
    return this.#r() || this.#p();
  }
  #v(e) {
    this.#r.set(e);
  }
  #I(e) {
    const n = this.#s();
    this.#d || n && Bl(n, e) || e.stopPropagation();
  }
  #A(e) {
    const n = this.#s();
    this.#d || n && Bl(n, e) || this.close(e);
  }
  #D() {
    const e = this.el?.querySelector('[data-part="close-target"]');
    return this.el && e && Hd(this.el, e, (n) => n.getAttribute("role") === "menu") ? e : null;
  }
  #w(e) {
    this.isSubmenu || (this.#i() ? this.#e.remote.pauseControls(e) : this.#e.remote.resumeControls(e));
  }
  #L(e) {
    this.#o.add(e), new Ae(e).add("open", this.#U).add("close", this.#G), ue(this.#x);
  }
  #x = this.#k.bind(this);
  #k(e) {
    this.#o.delete(e);
  }
  #M = !1;
  #U = this.#P.bind(this);
  #P(e) {
    this.#M = !0;
    const n = this.#s();
    this.isSubmenu && this.triggerElement?.setAttribute("aria-hidden", "true");
    for (const i of this.#o)
      if (i !== e.target)
        for (const r of [i.el, i.triggerElement])
          r?.setAttribute("aria-hidden", "true");
    if (n) {
      const i = e.target.el;
      for (const r of n.children)
        r.contains(i) ? r.setAttribute("data-open", "") : r !== i && r.setAttribute("data-hidden", "");
    }
  }
  #G = this.#Y.bind(this);
  #Y(e) {
    this.#M = !1;
    const n = this.#s();
    this.isSubmenu && this.triggerElement?.setAttribute("aria-hidden", "false");
    for (const i of this.#o)
      for (const r of [i.el, i.triggerElement])
        r?.setAttribute("aria-hidden", "false");
    if (n)
      for (const i of n.children)
        i.removeAttribute("data-open"), i.removeAttribute("data-hidden");
  }
  #F = Wn(() => {
    const e = F(this.#s);
    if (!e || H) return;
    let n = 0, i = getComputedStyle(e), r = [...e.children];
    for (const a of ["paddingTop", "paddingBottom", "borderTopWidth", "borderBottomWidth"])
      n += parseFloat(i[a]) || 0;
    for (const a of r)
      if (ra(a) && a.style.display === "contents")
        r.push(...a.children);
      else if (a.nodeType === 3)
        n += parseFloat(getComputedStyle(a).fontSize);
      else if (ra(a)) {
        if (!$d(a)) continue;
        const s = getComputedStyle(a);
        n += a.offsetHeight + (parseFloat(s.marginTop) || 0) + (parseFloat(s.marginBottom) || 0);
      }
    Xt(e, "--menu-height", n + "px");
  });
  #B = !1;
  #$(e) {
    const n = this.#s();
    n && e.propertyName === "height" && (this.#B = e.type === "transitionstart", re(n, "data-transition", this.#B ? "height" : null), this.#i() && this.#y());
    for (const i of this.#E) i(e);
  }
  open(e) {
    F(this.#i) || (this.#_.show(e), on());
  }
  close(e) {
    F(this.#i) && (this.#_.hide(e), on());
  }
}
Er([
  he
], Di.prototype, "triggerElement");
Er([
  he
], Di.prototype, "contentElement");
Er([
  he
], Di.prototype, "isSubmenu");
Er([
  et
], Di.prototype, "open");
Er([
  et
], Di.prototype, "close");
class Eo extends be {
  static props = {
    disabled: !1
  };
  #e;
  #t = j(null);
  get expanded() {
    return this.#e?.expanded() ?? !1;
  }
  constructor() {
    super(), new Dn();
  }
  onSetup() {
    this.#e = ut(Zt);
  }
  onAttach(e) {
    this.#e.attachMenuButton(this), N(this.#n.bind(this)), Be(e, "type", "button");
  }
  onConnect(e) {
    N(this.#i.bind(this)), this.#r();
    const n = new MutationObserver(this.#r.bind(this));
    n.observe(e, { attributeFilter: ["data-part"], childList: !0, subtree: !0 }), ue(() => n.disconnect()), On(e, (i) => {
      this.dispatch("select", { trigger: i });
    });
  }
  #n() {
    this.#e.disableMenuButton(this.$props.disabled());
  }
  #i() {
    const e = this.#t();
    e && N(() => {
      const n = this.#e.hint();
      n && (e.textContent = n);
    });
  }
  #r() {
    const e = this.el?.querySelector('[data-part="hint"]');
    this.#t.set(e ?? null);
  }
}
const QR = Eo.prototype;
he(QR, "expanded");
class XR extends Eo {
}
const Xa = An();
class ZR extends be {
  static props = {
    placement: null,
    offset: 0,
    alignOffset: 0
  };
  #e;
  constructor() {
    super(), new Dn();
    const { placement: e } = this.$props;
    this.setAttributes({
      "data-placement": e
    });
  }
  onAttach(e) {
    if (this.#e = ut(Zt), this.#e.attachMenuItems(this), dn(Xa)) {
      const n = ut(Xa);
      n && (en(Xa, null), n.attach(e), ue(() => n.attach(null)));
    }
  }
  onConnect(e) {
    N(this.#t.bind(this));
  }
  #t() {
    const { expanded: e } = this.#e;
    if (!this.el || !e()) return;
    const n = this.$props.placement();
    if (!n) return;
    Object.assign(this.el.style, {
      position: "absolute",
      top: 0,
      left: 0,
      width: "max-content"
    });
    const { offset: i, alignOffset: r } = this.$props;
    ue(
      ny(this.el, this.#i(), n, {
        offsetVarName: "media-menu",
        xOffset: r(),
        yOffset: i()
      })
    ), ue(this.#n.bind(this));
  }
  #n() {
    this.el && (this.el.removeAttribute("style"), this.el.style.display = "none");
  }
  #i() {
    return this.#e.button();
  }
}
const Ss = An();
class go extends Ut {
  #e = /* @__PURE__ */ new Set();
  #t = j("");
  #n = null;
  onValueChange;
  get values() {
    return Array.from(this.#e).map((e) => e.value());
  }
  get value() {
    return this.#t();
  }
  set value(e) {
    this.#s(e);
  }
  onSetup() {
    en(Ss, {
      add: this.#i.bind(this),
      remove: this.#r.bind(this)
    });
  }
  onAttach(e) {
    dn(Zt) || Be(e, "role", "radiogroup"), this.setAttributes({ value: this.#t });
  }
  onDestroy() {
    this.#e.clear();
  }
  #i(e) {
    this.#e.has(e) || (this.#e.add(e), e.onCheck = this.#a, e.check(e.value() === this.#t()));
  }
  #r(e) {
    e.onCheck = null, this.#e.delete(e);
  }
  #a = this.#s.bind(this);
  #s(e, n) {
    const i = F(this.#t);
    if (!e || e === i) return;
    const r = this.#l(i), a = this.#l(e);
    r?.check(!1, n), a?.check(!0, n), this.#t.set(e), this.onValueChange?.(e, n);
  }
  #l(e) {
    for (const n of this.#e)
      if (e === F(n.value)) return n;
    return null;
  }
}
class su extends be {
  static props = {
    value: ""
  };
  #e;
  /**
   * A list of radio values that belong this group.
   */
  get values() {
    return this.#e.values;
  }
  /**
   * The radio value that is checked in this group.
   */
  get value() {
    return this.#e.value;
  }
  set value(e) {
    this.#e.value = e;
  }
  constructor() {
    super(), this.#e = new go(), this.#e.onValueChange = this.#n.bind(this);
  }
  onSetup() {
    H ? this.#t() : N(this.#t.bind(this));
  }
  #t() {
    this.#e.value = this.$props.value();
  }
  #n(e, n) {
    const i = this.createEvent("change", { detail: e, trigger: n });
    this.dispatch(i);
  }
}
const ou = su.prototype;
he(ou, "values");
he(ou, "value");
class lu extends be {
  static props = {
    value: ""
  };
  #e = j(!1);
  #t = {
    value: this.$props.value,
    check: this.#s.bind(this),
    onCheck: null
  };
  /**
   * Whether this radio is currently checked.
   */
  get checked() {
    return this.#e();
  }
  constructor() {
    super(), new Dn();
  }
  onSetup() {
    this.setAttributes({
      value: this.$props.value,
      "data-checked": this.#e,
      "aria-checked": Pt(this.#e)
    });
  }
  onAttach(e) {
    const n = dn(Zt);
    Be(e, "tabindex", n ? "-1" : "0"), Be(e, "role", n ? "menuitemradio" : "radio"), N(this.#r.bind(this));
  }
  onConnect(e) {
    this.#i(), On(e, this.#a.bind(this)), ue(this.#n.bind(this));
  }
  #n() {
    Tt(() => {
      ut(Ss).remove(this.#t);
    }, this.connectScope);
  }
  #i() {
    ut(Ss).add(this.#t);
  }
  #r() {
    const { value: e } = this.$props, n = e();
    F(this.#e) && this.#t.onCheck?.(n);
  }
  #a(e) {
    F(this.#e) || (this.#l(!0, e), this.#o(e), this.#t.onCheck?.(F(this.$props.value), e));
  }
  #s(e, n) {
    F(this.#e) !== e && this.#l(e, n);
  }
  #l(e, n) {
    this.#e.set(e), this.dispatch("change", { detail: e, trigger: n });
  }
  #o(e) {
    this.dispatch("select", { trigger: e });
  }
}
const JR = lu.prototype;
he(JR, "checked");
let jR = class extends be {
  static props = {
    disabled: !1,
    event: void 0,
    action: void 0
  };
  #e;
  #t = null;
  onSetup() {
    this.#e = Ge();
    const { event: e, action: n } = this.$props;
    this.setAttributes({
      event: e,
      action: n
    });
  }
  onAttach(e) {
    e.setAttribute("data-media-gesture", ""), e.style.setProperty("pointer-events", "none");
  }
  onConnect(e) {
    this.#t = this.#e.player.el?.querySelector(
      "[data-media-provider]"
    ), N(this.#n.bind(this));
  }
  #n() {
    let e = this.$props.event(), n = this.$props.disabled();
    !this.#t || !e || n || (/^dbl/.test(e) && (e = e.split(/^dbl/)[1]), (e === "pointerup" || e === "pointerdown") && this.#e.$state.pointer() === "coarse" && (e = e === "pointerup" ? "touchend" : "touchstart"), Ve(
      this.#t,
      e,
      this.#a.bind(this),
      { passive: !1 }
    ));
  }
  #i = 0;
  #r = -1;
  #a(e) {
    if (this.$props.disabled() || ls(e) && (e.button !== 0 || this.#e.activeMenu) || Xi(e) && this.#e.activeMenu || so(e) || !this.#l(e))
      return;
    if (e.MEDIA_GESTURE = !0, e.preventDefault(), !F(this.$props.event)?.startsWith("dbl"))
      this.#i === 0 && setTimeout(() => {
        this.#i === 1 && this.#s(e);
      }, 250);
    else if (this.#i === 1) {
      queueMicrotask(() => this.#s(e)), clearTimeout(this.#r), this.#i = 0;
      return;
    }
    this.#i === 0 && (this.#r = window.setTimeout(() => {
      this.#i = 0;
    }, 275)), this.#i++;
  }
  #s(e) {
    this.el.setAttribute("data-triggered", ""), requestAnimationFrame(() => {
      this.#o() && this.#c(F(this.$props.action), e), requestAnimationFrame(() => {
        this.el.removeAttribute("data-triggered");
      });
    });
  }
  /** Validate event occurred in gesture bounds. */
  #l(e) {
    if (!this.el) return !1;
    if (ls(e) || id(e) || Xi(e)) {
      const n = Xi(e) ? e.changedTouches[0] ?? e.touches[0] : void 0, i = n?.clientX ?? e.clientX, r = n?.clientY ?? e.clientY, a = this.el.getBoundingClientRect(), s = r >= a.top && r <= a.bottom && i >= a.left && i <= a.right;
      return e.type.includes("leave") ? !s : s;
    }
    return !0;
  }
  /** Validate gesture has the highest z-index in this triggered group. */
  #o() {
    const e = this.#e.player.el.querySelectorAll(
      "[data-media-gesture][data-triggered]"
    );
    return Array.from(e).sort(
      (n, i) => +getComputedStyle(i).zIndex - +getComputedStyle(n).zIndex
    )[0] === this.el;
  }
  #c(e, n) {
    if (!e) return;
    const i = new Se("will-trigger", {
      detail: e,
      cancelable: !0,
      trigger: n
    });
    if (this.dispatchEvent(i), i.defaultPrevented) return;
    const [r, a] = e.replace(/:([a-z])/, "-$1").split(":");
    e.includes(":fullscreen") ? this.#e.remote.toggleFullscreen("prefer-media", n) : e.includes("seek:") ? this.#e.remote.seek(F(this.#e.$state.currentTime) + (+a || 0), n) : this.#e.remote[zs(r)](n), this.dispatch("trigger", {
      detail: e,
      trigger: n
    });
  }
};
class eN {
  priority = 10;
  #e = null;
  #t;
  #n;
  constructor(e) {
    this.#t = e;
  }
  attach() {
  }
  canRender() {
    return !0;
  }
  detach() {
    this.#n?.abort(), this.#n = void 0, this.#t.reset(), this.#e = null;
  }
  changeTrack(e) {
    !e || this.#e === e || (this.#n?.abort(), this.#n = new Ae(e), e.readyState < 2 ? (this.#t.reset(), this.#n.add("load", () => this.#i(e), { once: !0 })) : this.#i(e), this.#n.add("add-cue", (n) => {
      this.#t.addCue(n.detail);
    }).add("remove-cue", (n) => {
      this.#t.removeCue(n.detail);
    }), this.#e = e);
  }
  #i(e) {
    this.#t.changeTrack({
      cues: [...e.cues],
      regions: [...e.regions]
    });
  }
}
class Un extends be {
  static props = {
    textDir: "ltr",
    exampleText: "Captions look like this."
  };
  #e;
  static lib = j(null);
  onSetup() {
    this.#e = Ge(), this.setAttributes({
      "aria-hidden": Pt(this.#t.bind(this))
    });
  }
  onAttach(e) {
    e.style.setProperty("pointer-events", "none");
  }
  onConnect(e) {
    Un.lib() || import("./prod-BQ6GYK89.js").then((n) => n.d).then((n) => Un.lib.set(n)), N(this.#n.bind(this));
  }
  #t() {
    const { textTrack: e, remotePlaybackState: n, iOSControls: i } = this.#e.$state, r = e();
    return i() || n() === "connected" || !r || !bt(r);
  }
  #n() {
    if (!Un.lib()) return;
    const { viewType: e } = this.#e.$state;
    return e() === "audio" ? this.#i() : this.#l();
  }
  #i() {
    return N(this.#r.bind(this)), this.#_(null), () => {
      this.el.textContent = "";
    };
  }
  #r() {
    if (this.#t()) return;
    this.#a();
    const { textTrack: e } = this.#e.$state;
    Ve(e(), "cue-change", this.#a.bind(this)), N(this.#s.bind(this));
  }
  #a() {
    this.el.textContent = "", this.#p >= 0 && this.#f();
    const { realCurrentTime: e, textTrack: n } = this.#e.$state, { renderVTTCueString: i } = Un.lib(), r = F(e), a = F(n).activeCues;
    for (const s of a) {
      const o = this.#S(), l = this.#T();
      l.innerHTML = i(s, r), o.append(l), this.el.append(l);
    }
  }
  #s() {
    const { realCurrentTime: e } = this.#e.$state, { updateTimedVTTCueNodes: n } = Un.lib();
    n(this.el, e());
  }
  #l() {
    const { CaptionsRenderer: e } = Un.lib(), n = new e(this.el), i = new eN(n);
    return this.#e.textRenderers.add(i), N(this.#o.bind(this, n)), N(this.#c.bind(this, n)), this.#_(n), () => {
      this.el.textContent = "", this.#e.textRenderers.remove(i), n.destroy();
    };
  }
  #o(e) {
    e.dir = this.$props.textDir();
  }
  #c(e) {
    if (this.#t()) return;
    const { realCurrentTime: n, textTrack: i } = this.#e.$state;
    e.currentTime = n(), this.#p >= 0 && i()?.activeCues[0] && this.#f();
  }
  #_(e) {
    const n = this.#e.player;
    if (!n) return;
    const i = this.#u.bind(this, e);
    Ve(n, "vds-font-change", i);
  }
  #u(e) {
    if (this.#p >= 0) {
      this.#E();
      return;
    }
    const { textTrack: n } = this.#e.$state;
    n()?.activeCues[0] ? e?.update(!0) : this.#d();
  }
  #d() {
    const e = this.#S();
    re(e, "data-example", "");
    const n = this.#T();
    re(n, "data-example", ""), n.textContent = this.$props.exampleText(), e?.append(n), this.el?.append(e), this.el?.setAttribute("data-example", ""), this.#E();
  }
  #p = -1;
  #E() {
    window.clearTimeout(this.#p), this.#p = window.setTimeout(this.#f.bind(this), 2500);
  }
  #f() {
    this.el?.removeAttribute("data-example"), this.el?.querySelector("[data-example]") && (this.el.textContent = ""), this.#p = -1;
  }
  #S() {
    const e = document.createElement("div");
    return re(e, "data-part", "cue-display"), e;
  }
  #T() {
    const e = document.createElement("div");
    return re(e, "data-part", "cue"), e;
  }
}
let tN = class extends be {
  static props = {
    src: null,
    alt: null,
    crossOrigin: null
  };
  static state = new In({
    img: null,
    src: null,
    alt: null,
    crossOrigin: null,
    loading: !0,
    error: null,
    hidden: !1
  });
  #e;
  onSetup() {
    this.#e = Ge(), this.#l(), this.#o(), this.#c(), this.#i();
  }
  onAttach(e) {
    e.style.setProperty("pointer-events", "none"), N(this.#a.bind(this)), N(this.#l.bind(this)), N(this.#o.bind(this)), N(this.#c.bind(this)), N(this.#i.bind(this));
    const { started: n } = this.#e.$state;
    this.setAttributes({
      "data-visible": () => !n() && !this.$state.hidden(),
      "data-loading": this.#r.bind(this),
      "data-error": this.#t.bind(this),
      "data-hidden": this.$state.hidden
    });
  }
  onConnect(e) {
    N(this.#n.bind(this)), N(this.#_.bind(this));
  }
  #t() {
    const { error: e } = this.$state;
    return !Qt(e());
  }
  #n() {
    const { canLoadPoster: e, poster: n } = this.#e.$state;
    !e() && n() && Ii(n(), "preconnect");
  }
  #i() {
    const { src: e } = this.$props, { poster: n, nativeControls: i } = this.#e.$state;
    this.el && re(this.el, "display", i() ? "none" : null), this.$state.hidden.set(this.#t() || !(e() || n()) || i());
  }
  #r() {
    const { loading: e, hidden: n } = this.$state;
    return !n() && e();
  }
  #a() {
    const e = this.$state.img();
    e && (new Ae(e).add("load", this.#u.bind(this)).add("error", this.#d.bind(this)), e.complete && this.#u());
  }
  #s = "";
  #l() {
    const { poster: e } = this.#e.$props, { canLoadPoster: n, providedPoster: i, inferredPoster: r } = this.#e.$state, a = this.$props.src() || "", s = a || e() || r();
    this.#s === i() && i.set(a), this.$state.src.set(n() && s.length ? s : null), this.#s = a;
  }
  #o() {
    const { src: e } = this.$props, { alt: n } = this.$state, { poster: i } = this.#e.$state;
    n.set(e() || i() ? this.$props.alt() : null);
  }
  #c() {
    const { crossOrigin: e } = this.$props, { crossOrigin: n } = this.$state, { crossOrigin: i, poster: r } = this.#e.$state, a = e() !== null ? e() : i();
    n.set(
      /ytimg\.com|vimeo/.test(r() || "") ? null : a === !0 ? "anonymous" : a
    );
  }
  #_() {
    const { loading: e, error: n } = this.$state, { canLoadPoster: i, poster: r } = this.#e.$state;
    e.set(i() && !!r()), n.set(null);
  }
  #u() {
    const { loading: e, error: n } = this.$state;
    e.set(!1), n.set(null);
  }
  #d(e) {
    const { loading: n, error: i } = this.$state;
    n.set(!1), i.set(e);
  }
}, nN = class extends be {
  static props = {
    type: "current",
    showHours: !1,
    padHours: null,
    padMinutes: null,
    remainder: !1,
    toggle: !1,
    hidden: !1
  };
  static state = new In({
    timeText: "",
    hidden: !1
  });
  #e;
  #t = j(null);
  #n = j(!0);
  #i = j(!0);
  onSetup() {
    this.#e = Ge(), this.#l();
    const { type: e } = this.$props;
    this.setAttributes({
      "data-type": e,
      "data-remainder": this.#_.bind(this)
    }), new eu({
      callback: this.#r.bind(this)
    }).attach(this);
  }
  onAttach(e) {
    e.hasAttribute("role") || N(this.#o.bind(this)), N(this.#l.bind(this));
  }
  onConnect(e) {
    ue(Vd(e, this.#n.set)), N(this.#a.bind(this)), N(this.#s.bind(this));
  }
  #r(e) {
    this.#i.set(e[0].isIntersecting);
  }
  #a() {
    const { hidden: e } = this.$props;
    this.$state.hidden.set(e() || !this.#n() || !this.#i());
  }
  #s() {
    if (!this.$props.toggle()) {
      this.#t.set(null);
      return;
    }
    this.el && On(this.el, this.#u.bind(this));
  }
  #l() {
    const { hidden: e, timeText: n } = this.$state, { duration: i } = this.#e.$state;
    if (e()) return;
    const { type: r, padHours: a, padMinutes: s, showHours: o } = this.$props, l = this.#c(r()), c = i(), d = this.#_();
    if (!Number.isFinite(l + c)) {
      n.set("LIVE");
      return;
    }
    const u = d ? Math.max(0, c - l) : l, _ = _o(u, {
      padHrs: a(),
      padMins: s(),
      showHrs: o()
    });
    n.set((d ? "-" : "") + _);
  }
  #o() {
    if (!this.el) return;
    const { toggle: e } = this.$props;
    re(this.el, "role", e() ? "timer" : null), re(this.el, "tabindex", e() ? 0 : null);
  }
  #c(e) {
    const { bufferedEnd: n, duration: i, currentTime: r } = this.#e.$state;
    switch (e) {
      case "buffered":
        return n();
      case "duration":
        return i();
      default:
        return r();
    }
  }
  #_() {
    return this.$props.remainder() && this.#t() !== !1;
  }
  #u(e) {
    if (e.preventDefault(), this.#t() === null) {
      this.#t.set(!this.$props.remainder());
      return;
    }
    this.#t.set((n) => !n);
  }
};
class So extends Xd {
}
class iN extends Jd {
}
class rN extends jd {
}
class aN extends OR {
}
class sN extends vR {
}
class oN extends MR {
}
class lN extends AR {
}
class cN extends IR {
}
class dN extends NR {
}
class uN extends RR {
}
class _N extends DR {
}
class cu extends mr {
}
class pN extends ru {
}
class mN extends GR {
}
class EN extends PR {
}
class gN extends iu {
}
class SN extends nu {
}
class hN extends FR {
}
class fN extends au {
}
class TN extends Di {
}
class bN extends Eo {
}
class CN extends ZR {
}
class yN extends XR {
}
class RN extends su {
}
class NN extends lu {
}
class ON extends jR {
}
class vN extends tN {
}
class du extends tu {
}
class AN extends nN {
}
const uu = p.forwardRef((t, e) => {
  const { children: n, ...i } = t, r = p.Children.toArray(n), a = r.find(DN);
  if (a) {
    const s = a.props.children, o = r.map((l) => l === a ? p.Children.count(s) > 1 ? p.Children.only(null) : p.isValidElement(s) ? s.props.children : null : l);
    return /* @__PURE__ */ p.createElement(hs, { ...i, ref: e }, p.isValidElement(s) ? p.cloneElement(s, void 0, o) : null);
  }
  return /* @__PURE__ */ p.createElement(hs, { ...i, ref: e }, n);
});
uu.displayName = "Slot";
const hs = p.forwardRef((t, e) => {
  const { children: n, ...i } = t;
  return p.isValidElement(n) ? p.cloneElement(n, {
    ...MN(i, n.props),
    ref: e ? Pe(e, n.ref) : n.ref
  }) : p.Children.count(n) > 1 ? p.Children.only(null) : null;
});
hs.displayName = "SlotClone";
const IN = ({ children: t }) => /* @__PURE__ */ p.createElement(p.Fragment, null, t);
function DN(t) {
  return p.isValidElement(t) && t.type === IN;
}
function MN(t, e) {
  const n = { ...e };
  for (const i in e) {
    const r = t[i], a = e[i];
    /^on[A-Z]/.test(i) ? r && a ? n[i] = (...o) => {
      a(...o), r(...o);
    } : r && (n[i] = r) : i === "style" ? n[i] = { ...r, ...a } : i === "className" && (n[i] = [r, a].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
const wN = ["button", "div", "span", "img", "video", "audio"], de = wN.reduce((t, e) => {
  const n = p.forwardRef((i, r) => {
    const { asChild: a, ...s } = i, o = a ? uu : e;
    return /* @__PURE__ */ p.createElement(o, { ...s, ref: r });
  });
  return n.displayName = `Primitive.${e}`, { ...t, [e]: n };
}, {});
function xN(t) {
  return t?.$$PROVIDER_TYPE === "REMOTION";
}
function ho(t) {
  return t?.type === "video/remotion";
}
const ec = cu.state.record, LN = Object.keys(ec).reduce(
  (t, e) => ({
    ...t,
    [e]() {
      return ec[e];
    }
  }),
  {}
);
function Za(t, e) {
  const n = Ni(Ca);
  return ce((n || LN)[t]);
}
const tc = So.state.record, PN = Object.keys(tc).reduce(
  (t, e) => ({
    ...t,
    [e]() {
      return tc[e];
    }
  }),
  {}
);
function Nt(t, e) {
  const n = Ni(pr);
  return ce((n || PN)[t]);
}
function _n() {
  return Ws(ro);
}
const kN = Ne(uN, {
  domEventsRegex: /^onMedia/
}), _u = p.forwardRef(
  ({ children: t, ...e }, n) => /* @__PURE__ */ p.createElement(kN, { ...e }, (i) => /* @__PURE__ */ p.createElement(
    de.button,
    {
      ...i,
      ref: Pe(i.ref, n)
    },
    t
  ))
);
_u.displayName = "AirPlayButton";
const UN = Ne(dN, {
  domEventsRegex: /^onMedia/
}), fo = p.forwardRef(
  ({ children: t, ...e }, n) => /* @__PURE__ */ p.createElement(UN, { ...e }, (i) => /* @__PURE__ */ p.createElement(
    de.button,
    {
      ...i,
      ref: Pe(i.ref, n)
    },
    t
  ))
);
fo.displayName = "PlayButton";
const FN = Ne(aN, {
  domEventsRegex: /^onMedia/
}), pu = p.forwardRef(
  ({ children: t, ...e }, n) => /* @__PURE__ */ p.createElement(FN, { ...e }, (i) => /* @__PURE__ */ p.createElement(
    de.button,
    {
      ...i,
      ref: Pe(i.ref, n)
    },
    t
  ))
);
pu.displayName = "CaptionButton";
const BN = Ne(sN, {
  domEventsRegex: /^onMedia/
}), mu = p.forwardRef(
  ({ children: t, ...e }, n) => /* @__PURE__ */ p.createElement(BN, { ...e }, (i) => /* @__PURE__ */ p.createElement(
    de.button,
    {
      ...i,
      ref: Pe(i.ref, n)
    },
    t
  ))
);
mu.displayName = "FullscreenButton";
const GN = Ne(lN, {
  domEventsRegex: /^onMedia/
}), Eu = p.forwardRef(
  ({ children: t, ...e }, n) => /* @__PURE__ */ p.createElement(GN, { ...e }, (i) => /* @__PURE__ */ p.createElement(
    de.button,
    {
      ...i,
      ref: Pe(i.ref, n)
    },
    t
  ))
);
Eu.displayName = "MuteButton";
const YN = Ne(cN, {
  domEventsRegex: /^onMedia/
}), gu = p.forwardRef(
  ({ children: t, ...e }, n) => /* @__PURE__ */ p.createElement(YN, { ...e }, (i) => /* @__PURE__ */ p.createElement(
    de.button,
    {
      ...i,
      ref: Pe(i.ref, n)
    },
    t
  ))
);
gu.displayName = "PIPButton";
const $N = Ne(_N, {
  domEventsRegex: /^onMedia/
}), To = p.forwardRef(
  ({ children: t, ...e }, n) => /* @__PURE__ */ p.createElement($N, { ...e }, (i) => /* @__PURE__ */ p.createElement(
    de.button,
    {
      ...i,
      ref: Pe(i.ref, n)
    },
    t
  ))
);
To.displayName = "SeekButton";
const VN = Ne(oN, {
  domEventsRegex: /^onMedia/
}), Su = p.forwardRef(
  ({ children: t, ...e }, n) => /* @__PURE__ */ p.createElement(VN, { ...e }, (i) => /* @__PURE__ */ p.createElement(
    de.button,
    {
      ...i,
      ref: Pe(i.ref, n)
    },
    t
  ))
);
Su.displayName = "LiveButton";
const bo = [
  "onDragStart",
  "onDragEnd",
  "onDragValueChange",
  "onValueChange",
  "onPointerValueChange"
], HN = Ne(gN), qN = Ne(cu, {
  events: bo
}), zN = p.forwardRef(({ children: t, ...e }, n) => /* @__PURE__ */ p.createElement(qN, { ...e, ref: n }, (i) => /* @__PURE__ */ p.createElement(de.div, { ...i }, t)));
zN.displayName = "Slider";
const WN = p.forwardRef((t, e) => /* @__PURE__ */ p.createElement(de.div, { ...t, ref: e }));
WN.displayName = "SliderThumb";
const KN = p.forwardRef((t, e) => /* @__PURE__ */ p.createElement(de.div, { ...t, ref: e }));
KN.displayName = "SliderTrack";
const QN = p.forwardRef((t, e) => /* @__PURE__ */ p.createElement(de.div, { ...t, ref: e }));
QN.displayName = "SliderTrackFill";
const XN = Ne(hN), fs = p.forwardRef(
  ({ children: t, ...e }, n) => /* @__PURE__ */ p.createElement(XN, { ...e }, (i) => /* @__PURE__ */ p.createElement(
    de.div,
    {
      ...i,
      ref: Pe(i.ref, n)
    },
    t
  ))
);
fs.displayName = "SliderPreview";
const Hr = p.forwardRef(({ children: t, ...e }, n) => /* @__PURE__ */ p.createElement(HN, { ...e }, (i, r) => {
  const a = ce(() => r.getValueText(), r);
  return /* @__PURE__ */ p.createElement(de.div, { ...i, ref: n }, a, t);
}));
Hr.displayName = "SliderValue";
const ZN = p.forwardRef(({ children: t, ...e }, n) => {
  const i = Za("min"), r = Za("max"), a = Za("step"), s = (r - i) / a;
  return /* @__PURE__ */ p.createElement(de.div, { ...e, ref: n }, Array.from({ length: Math.floor(s) + 1 }).map((o, l) => t(l)));
});
ZN.displayName = "SliderSteps";
const JN = Ne(mN, {
  events: bo,
  domEventsRegex: /^onMedia/
}), hu = p.forwardRef(
  ({ children: t, ...e }, n) => /* @__PURE__ */ p.createElement(JN, { ...e, ref: n }, (i) => /* @__PURE__ */ p.createElement(de.div, { ...i }, t))
);
hu.displayName = "VolumeSlider";
function jN(t = 0, e = 0, n = "") {
  return H ? {
    startTime: t,
    endTime: e,
    text: n,
    addEventListener: xt,
    removeEventListener: xt,
    dispatchEvent: xt
  } : new window.VTTCue(t, e, n);
}
function eO(t, e) {
  const n = new URL(t);
  for (const i of Object.keys(e))
    n.searchParams.set(i, e[i] + "");
  return n.toString();
}
const tO = Ne(du), fu = p.forwardRef(({ children: t, ...e }, n) => /* @__PURE__ */ p.createElement(tO, { ...e }, (i) => /* @__PURE__ */ p.createElement(
  de.div,
  {
    ...i,
    ref: Pe(i.ref, n)
  },
  t
)));
fu.displayName = "Thumbnail";
const Co = p.forwardRef(({ children: t, ...e }, n) => {
  const { src: i, img: r, crossOrigin: a } = Ni(du.state), s = ce(i), o = ce(a);
  return /* @__PURE__ */ p.createElement(
    de.img,
    {
      crossOrigin: o,
      ...e,
      src: s || void 0,
      ref: Pe(r.set, n)
    },
    t
  );
});
Co.displayName = "ThumbnailImg";
const Ra = p.createContext({
  $chapters: j(null)
});
Ra.displayName = "TimeSliderContext";
const nO = Ne(pN, {
  events: bo,
  domEventsRegex: /^onMedia/
}), Tu = p.forwardRef(
  ({ children: t, ...e }, n) => {
    const i = p.useMemo(() => j(null), []);
    return /* @__PURE__ */ p.createElement(Ra.Provider, { value: { $chapters: i } }, /* @__PURE__ */ p.createElement(nO, { ...e, ref: n }, (r) => /* @__PURE__ */ p.createElement(de.div, { ...r }, t)));
  }
);
Tu.displayName = "TimeSlider";
const iO = Ne(fN), rO = p.forwardRef(
  ({ children: t, ...e }, n) => /* @__PURE__ */ p.createElement(iO, { ...e }, (i, r) => /* @__PURE__ */ p.createElement(
    de.div,
    {
      ...i,
      ref: Pe(i.ref, n)
    },
    /* @__PURE__ */ p.createElement(bu, { instance: r }, t)
  ))
);
rO.displayName = "SliderChapters";
function bu({ instance: t, children: e }) {
  const n = ce(() => t.cues, t), i = p.useRef([]), r = p.useRef(null), { $chapters: a } = p.useContext(Ra);
  return r.current || (r.current = jN()), p.useEffect(() => (a.set(t), () => {
    a.set(null);
  }), [t]), p.useEffect(() => {
    t.setRefs(i.current);
  }, [n]), e(n.length ? n : [r.current], (s) => {
    if (!s) {
      i.current.length = 0;
      return;
    }
    i.current.push(s);
  });
}
bu.displayName = "SliderChapterTracks";
const aO = p.forwardRef(
  ({ children: t, ...e }, n) => {
    const { $chapters: i } = p.useContext(Ra), [r, a] = p.useState();
    return p.useEffect(() => N(() => {
      const s = i(), o = s?.activePointerCue || s?.activeCue;
      a(o?.text || "");
    }), []), /* @__PURE__ */ p.createElement(de.div, { ...e, ref: n }, r, t);
  }
);
aO.displayName = "SliderChapterTitle";
const sO = p.forwardRef((t, e) => /* @__PURE__ */ p.createElement(de.div, { ...t, ref: e }));
sO.displayName = "SliderProgress";
const oO = Ne(EN), Cu = p.forwardRef(
  ({ children: t, ...e }, n) => /* @__PURE__ */ p.createElement(oO, { ...e }, (i) => /* @__PURE__ */ p.createElement(de.div, { ...i, ref: Pe(i.ref, n) }, t))
);
Cu.displayName = "SliderThumbnail";
const nc = {
  Root: Cu,
  Img: Co
}, lO = Ne(SN, {
  events: ["onCanPlay", "onError"]
}), cO = p.forwardRef(
  ({ children: t, ...e }, n) => /* @__PURE__ */ p.createElement(lO, { ...e }, (i, r) => /* @__PURE__ */ p.createElement(
    yu,
    {
      ...i,
      instance: r,
      ref: Pe(i.ref, n)
    },
    t
  ))
);
cO.displayName = "SliderVideo";
const yu = p.forwardRef(
  ({ instance: t, children: e, ...n }, i) => {
    const { canLoad: r } = Ni(pr), { src: a, video: s, crossOrigin: o } = t.$state, l = ce(a), c = ce(r), d = ce(o);
    return /* @__PURE__ */ p.createElement(
      de.video,
      {
        style: { maxWidth: "unset" },
        ...n,
        src: l || void 0,
        muted: !0,
        playsInline: !0,
        preload: c ? "auto" : "none",
        crossOrigin: d || void 0,
        ref: Pe(s.set, i)
      },
      e
    );
  }
);
yu.displayName = "SliderVideoProvider";
const dO = Ne(RN, {
  events: ["onChange"]
}), gr = p.forwardRef(
  ({ children: t, ...e }, n) => /* @__PURE__ */ p.createElement(dO, { ...e, ref: n }, (i) => /* @__PURE__ */ p.createElement(de.div, { ...i }, t))
);
gr.displayName = "RadioGroup";
const uO = Ne(NN, {
  events: ["onChange", "onSelect"]
}), Sr = p.forwardRef(({ children: t, ...e }, n) => /* @__PURE__ */ p.createElement(uO, { ...e }, (i) => /* @__PURE__ */ p.createElement(
  de.div,
  {
    ...i,
    ref: Pe(i.ref, n)
  },
  t
)));
Sr.displayName = "RadioItem";
const _O = Ne(TN, {
  events: ["onOpen", "onClose"],
  domEventsRegex: /^onMedia/
}), yo = p.forwardRef(({ children: t, ...e }, n) => /* @__PURE__ */ p.createElement(_O, { ...e, ref: n }, (i, r) => /* @__PURE__ */ p.createElement(
  de.div,
  {
    ...i,
    style: { display: r.isSubmenu ? void 0 : "contents", ...i.style }
  },
  t
)));
yo.displayName = "Menu";
const pO = Ne(bN, {
  events: ["onSelect"]
}), Ro = p.forwardRef(
  ({ children: t, ...e }, n) => /* @__PURE__ */ p.createElement(pO, { ...e }, (i) => /* @__PURE__ */ p.createElement(
    de.button,
    {
      ...i,
      ref: Pe(i.ref, n)
    },
    t
  ))
);
Ro.displayName = "MenuButton";
const mO = p.forwardRef(
  ({ container: t = null, disabled: e = !1, children: n, ...i }, r) => {
    let a = Nt("fullscreen"), s = e === "fullscreen" ? !a : !e;
    const o = p.useMemo(() => H ? null : (Q(t) ? document.querySelector(t) : t) ?? document.body, [t]);
    return !o || !s ? n : uc(
      /* @__PURE__ */ p.createElement(
        de.div,
        {
          ...i,
          style: { display: "contents", ...i.style },
          ref: r
        },
        n
      ),
      o
    );
  }
);
mO.displayName = "MenuPortal";
const EO = Ne(CN), No = p.forwardRef(({ children: t, ...e }, n) => /* @__PURE__ */ p.createElement(EO, { ...e }, (i) => /* @__PURE__ */ p.createElement(
  de.div,
  {
    ...i,
    ref: Pe(i.ref, n)
  },
  t
)));
No.displayName = "MenuItems";
const gO = Ne(yN), SO = p.forwardRef(({ children: t, ...e }, n) => /* @__PURE__ */ p.createElement(gO, { ...e }, (i) => /* @__PURE__ */ p.createElement(
  de.div,
  {
    ...i,
    ref: Pe(i.ref, n)
  },
  t
)));
SO.displayName = "MenuItem";
const hO = Ne(ON, {
  events: ["onWillTrigger", "onTrigger"]
}), Ts = p.forwardRef(
  ({ children: t, ...e }, n) => /* @__PURE__ */ p.createElement(hO, { ...e, ref: n }, (i) => /* @__PURE__ */ p.createElement(de.div, { ...i }, t))
);
Ts.displayName = "Gesture";
const fO = Ne(AN), Oo = p.forwardRef(({ children: t, ...e }, n) => /* @__PURE__ */ p.createElement(fO, { ...e }, (i, r) => /* @__PURE__ */ p.createElement(
  Ru,
  {
    ...i,
    instance: r,
    ref: Pe(i.ref, n)
  },
  t
)));
Oo.displayName = "Time";
const Ru = p.forwardRef(
  ({ instance: t, children: e, ...n }, i) => {
    const { timeText: r } = t.$state, a = ce(r);
    return /* @__PURE__ */ p.createElement(de.div, { ...n, ref: i }, a, e);
  }
);
Ru.displayName = "TimeText";
function TO() {
  return _n()?.player || null;
}
function bO() {
  const t = _n(), { audioTracks: e, audioTrack: n } = t.$state, i = ce(e);
  return ce(n), p.useMemo(() => {
    const r = i.map((a) => ({
      track: a,
      label: a.label,
      value: ic(a),
      get selected() {
        return n() === a;
      },
      select(s) {
        const o = e().indexOf(a);
        o >= 0 && t.remote.changeAudioTrack(o, s);
      }
    }));
    return Object.defineProperty(r, "disabled", {
      get() {
        return r.length <= 1;
      }
    }), Object.defineProperty(r, "selectedTrack", {
      get() {
        return n();
      }
    }), Object.defineProperty(r, "selectedValue", {
      get() {
        const a = n();
        return a ? ic(a) : void 0;
      }
    }), r;
  }, [i]);
}
function ic(t) {
  return t.label.toLowerCase();
}
function CO({ off: t = !0 } = {}) {
  const e = _n(), { textTracks: n, textTrack: i } = e.$state, r = ce(n);
  return ce(i), p.useMemo(() => {
    const a = r.filter(bt), s = a.map((o) => ({
      track: o,
      label: o.label,
      value: rc(o),
      get selected() {
        return i() === o;
      },
      select(l) {
        const c = n().indexOf(o);
        c >= 0 && e.remote.changeTextTrackMode(c, "showing", l);
      }
    }));
    return t && s.unshift({
      track: null,
      label: Q(t) ? t : "Off",
      value: "off",
      get selected() {
        return !i();
      },
      select(o) {
        e.remote.toggleCaptions(o);
      }
    }), Object.defineProperty(s, "disabled", {
      get() {
        return !a.length;
      }
    }), Object.defineProperty(s, "selectedTrack", {
      get() {
        return i();
      }
    }), Object.defineProperty(s, "selectedValue", {
      get() {
        const o = i();
        return o ? rc(o) : "off";
      }
    }), s;
  }, [r]);
}
function rc(t) {
  return t.id + ":" + t.kind + "-" + t.label.toLowerCase();
}
const vo = /* @__PURE__ */ p.forwardRef((t, e) => {
  const { width: n, height: i, size: r = null, paths: a, ...s } = t;
  return p.createElement("svg", {
    viewBox: "0 0 32 32",
    ...s,
    width: n ?? r,
    height: i ?? r,
    fill: "none",
    "aria-hidden": "true",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    ref: e,
    dangerouslySetInnerHTML: { __html: a }
  });
});
vo.displayName = "VidstackIcon";
const Nu = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];
class yO extends be {
  static props = {
    normalLabel: "Normal",
    rates: Nu
  };
  #e;
  #t;
  #n;
  get value() {
    return this.#n.value;
  }
  get disabled() {
    const { rates: e } = this.$props, { canSetPlaybackRate: n } = this.#e.$state;
    return !n() || e().length === 0;
  }
  constructor() {
    super(), this.#n = new go(), this.#n.onValueChange = this.#l.bind(this);
  }
  onSetup() {
    this.#e = Ge(), dn(Zt) && (this.#t = ut(Zt));
  }
  onConnect(e) {
    N(this.#i.bind(this)), N(this.#r.bind(this)), N(this.#a.bind(this));
  }
  getOptions() {
    const { rates: e, normalLabel: n } = this.$props;
    return e().map((i) => ({
      label: i === 1 ? n : i + "×",
      value: i.toString()
    }));
  }
  #i() {
    this.#n.value = this.#s();
  }
  #r() {
    const { normalLabel: e } = this.$props, { playbackRate: n } = this.#e.$state, i = n();
    this.#t?.hint.set(i === 1 ? e() : i + "×");
  }
  #a() {
    this.#t?.disable(this.disabled);
  }
  #s() {
    const { playbackRate: e } = this.#e.$state;
    return e().toString();
  }
  #l(e, n) {
    if (this.disabled) return;
    const i = +e;
    this.#e.remote.changePlaybackRate(i, n), this.dispatch("change", { detail: i, trigger: n });
  }
}
const Ao = yO.prototype;
he(Ao, "value");
he(Ao, "disabled");
et(Ao, "getOptions");
function RO(t) {
  const e = _n(), n = p.useRef(null);
  return n.current || (n.current = new Bd()), p.useEffect(() => {
    const i = t, r = i instanceof So, a = r ? i : e?.player;
    n.current.setPlayer(a ?? null), n.current.setTarget(null);
  }, [e, t]), n.current;
}
function NO({
  auto: t = !0,
  sort: e = "descending"
} = {}) {
  const n = _n(), { qualities: i, quality: r, autoQuality: a, canSetQuality: s } = n.$state, o = ce(i);
  return ce(r), ce(a), ce(s), p.useMemo(() => {
    const l = dy(o, e === "descending"), c = l.map((d) => ({
      quality: d,
      label: d.height + "p",
      value: ac(d),
      bitrateText: d.bitrate && d.bitrate > 0 ? `${(d.bitrate / 1e6).toFixed(2)} Mbps` : null,
      get selected() {
        return d === r();
      },
      get autoSelected() {
        return a();
      },
      select(u) {
        const _ = i().indexOf(d);
        _ >= 0 && n.remote.changeQuality(_, u);
      }
    }));
    return t && c.unshift({
      quality: null,
      label: Q(t) ? t : "Auto",
      value: "auto",
      bitrateText: null,
      get selected() {
        return a();
      },
      get autoSelected() {
        return a();
      },
      select(d) {
        n.remote.requestAutoQuality(d);
      }
    }), Object.defineProperty(c, "disabled", {
      get() {
        return !s() || o.length <= 1;
      }
    }), Object.defineProperty(c, "selectedQuality", {
      get() {
        return r();
      }
    }), Object.defineProperty(c, "selectedValue", {
      get() {
        const d = r();
        return !a() && d ? ac(d) : "auto";
      }
    }), c;
  }, [o, e]);
}
function ac(t) {
  return t.height + "_" + t.bitrate;
}
function OO({
  rates: t = Nu,
  normalLabel: e = "Normal"
} = {}) {
  const n = _n(), { playbackRate: i, canSetPlaybackRate: r } = n.$state;
  return ce(i), ce(r), p.useMemo(() => {
    const a = t.map((s) => {
      const o = typeof s == "number" ? s === 1 && e ? e : s + "x" : s.label, l = typeof s == "number" ? s : s.rate;
      return {
        label: o,
        value: l.toString(),
        rate: l,
        get selected() {
          return i() === l;
        },
        select(c) {
          n.remote.changePlaybackRate(l, c);
        }
      };
    });
    return Object.defineProperty(a, "disabled", {
      get() {
        return !r() || !a.length;
      }
    }), Object.defineProperty(a, "selectedValue", {
      get() {
        return i().toString();
      }
    }), a;
  }, [t]);
}
const vO = [1, 1.25, 1.5, 1.75, 2, 2.5, 3, 4];
class AO extends be {
  static props = {
    normalLabel: "Disabled",
    gains: vO
  };
  #e;
  #t;
  #n;
  get value() {
    return this.#n.value;
  }
  get disabled() {
    const { gains: e } = this.$props, { canSetAudioGain: n } = this.#e.$state;
    return !n() || e().length === 0;
  }
  constructor() {
    super(), this.#n = new go(), this.#n.onValueChange = this.#l.bind(this);
  }
  onSetup() {
    this.#e = Ge(), dn(Zt) && (this.#t = ut(Zt));
  }
  onConnect(e) {
    N(this.#i.bind(this)), N(this.#r.bind(this)), N(this.#a.bind(this));
  }
  getOptions() {
    const { gains: e, normalLabel: n } = this.$props;
    return e().map((i) => ({
      label: i === 1 || i === null ? n : String(i * 100) + "%",
      value: i.toString()
    }));
  }
  #i() {
    this.#n.value = this.#s();
  }
  #r() {
    const { normalLabel: e } = this.$props, { audioGain: n } = this.#e.$state, i = n();
    this.#t?.hint.set(i === 1 || i == null ? e() : String(i * 100) + "%");
  }
  #a() {
    this.#t?.disable(this.disabled);
  }
  #s() {
    const { audioGain: e } = this.#e.$state;
    return e()?.toString() ?? "1";
  }
  #l(e, n) {
    if (this.disabled) return;
    const i = +e;
    this.#e.remote.changeAudioGain(i, n), this.dispatch("change", { detail: i, trigger: n });
  }
}
const Io = AO.prototype;
he(Io, "value");
he(Io, "disabled");
et(Io, "getOptions");
const IO = [
  "onAbort",
  "onAudioTrackChange",
  "onAudioTracksChange",
  "onAutoPlay",
  "onAutoPlayChange",
  "onAutoPlayFail",
  "onCanLoad",
  "onCanPlay",
  "onCanPlayThrough",
  "onControlsChange",
  "onDestroy",
  "onDurationChange",
  "onEmptied",
  "onEnd",
  "onEnded",
  "onError",
  "onFindMediaPlayer",
  "onFullscreenChange",
  "onFullscreenError",
  "onLiveChange",
  "onLiveEdgeChange",
  "onLoadedData",
  "onLoadedMetadata",
  "onLoadStart",
  "onLoopChange",
  "onOrientationChange",
  "onPause",
  "onPictureInPictureChange",
  "onPictureInPictureError",
  "onPlay",
  "onPlayFail",
  "onPlaying",
  "onPlaysInlineChange",
  "onPosterChange",
  "onProgress",
  "onProviderChange",
  "onProviderLoaderChange",
  "onProviderSetup",
  "onQualitiesChange",
  "onQualityChange",
  "onRateChange",
  "onReplay",
  "onSeeked",
  "onSeeking",
  "onSourceChange",
  "onSourceChange",
  "onStalled",
  "onStarted",
  "onStreamTypeChange",
  "onSuspend",
  "onTextTrackChange",
  "onTextTracksChange",
  "onTimeUpdate",
  "onTitleChange",
  "onVdsLog",
  "onVideoPresentationChange",
  "onVolumeChange",
  "onWaiting"
], DO = Ne(So, {
  events: IO,
  eventsRegex: /^onHls/,
  domEventsRegex: /^onMedia/
}), Ou = p.forwardRef(
  ({ aspectRatio: t, children: e, ...n }, i) => /* @__PURE__ */ p.createElement(
    DO,
    {
      ...n,
      src: n.src,
      ref: i,
      style: {
        aspectRatio: t,
        ...n.style
      }
    },
    (r) => /* @__PURE__ */ p.createElement(de.div, { ...r }, e)
  )
);
Ou.displayName = "MediaPlayer";
const MO = Ne(iN), vu = p.forwardRef(
  ({ loaders: t = [], children: e, iframeProps: n, mediaProps: i, ...r }, a) => {
    const s = p.useMemo(() => t.map((o) => new o()), t);
    return /* @__PURE__ */ p.createElement(MO, { ...r, loaders: s, ref: a }, (o, l) => /* @__PURE__ */ p.createElement("div", { ...o }, /* @__PURE__ */ p.createElement(Au, { provider: l, mediaProps: i, iframeProps: n }), e));
  }
);
vu.displayName = "MediaProvider";
function Au({ provider: t, mediaProps: e, iframeProps: n }) {
  const { sources: i, crossOrigin: r, poster: a, remotePlaybackInfo: s, nativeControls: o, viewType: l } = Ni(pr), { loader: c } = t.$state, { $provider: d, $providerSetup: u } = _n(), _ = ce(i), m = ce(o), g = ce(r), S = ce(a), E = ce(c), h = ce(d), T = ce(u), b = ce(s), C = E?.mediaType(), y = ce(l), O = y === "audio", A = E?.name === "youtube", I = E?.name === "vimeo", k = A || I, x = E?.name === "remotion", B = E?.name === "google-cast", [X, J] = p.useState(""), [D, L] = p.useState(!1);
  return p.useEffect(() => {
    !B || X || Promise.resolve().then(() => Ib).then(function(G) {
      return G.chromecast;
    }).then((G) => {
      J(G.default);
    });
  }, [B]), p.useEffect(() => {
    L(!0);
  }, []), B ? /* @__PURE__ */ p.createElement(
    "div",
    {
      className: "vds-google-cast",
      ref: (G) => {
        t.load(G);
      }
    },
    /* @__PURE__ */ p.createElement(vo, { paths: X }),
    b?.deviceName ? /* @__PURE__ */ p.createElement("span", { className: "vds-google-cast-info" }, "Google Cast on", " ", /* @__PURE__ */ p.createElement("span", { className: "vds-google-cast-device-name" }, b.deviceName)) : null
  ) : x ? /* @__PURE__ */ p.createElement("div", { "data-remotion-canvas": !0 }, /* @__PURE__ */ p.createElement(
    "div",
    {
      "data-remotion-container": !0,
      ref: (G) => {
        t.load(G);
      }
    },
    xN(h) && T ? p.createElement(h.render) : null
  )) : k ? p.createElement(
    p.Fragment,
    null,
    p.createElement("iframe", {
      ...n,
      className: (n?.className ? `${n.className} ` : "") + A ? "vds-youtube" : "vds-vimeo",
      suppressHydrationWarning: !0,
      tabIndex: m ? void 0 : -1,
      "aria-hidden": "true",
      "data-no-controls": m ? void 0 : "",
      ref(G) {
        t.load(G);
      }
    }),
    !m && !O ? p.createElement("div", { className: "vds-blocker" }) : null
  ) : C ? p.createElement(C === "audio" ? "audio" : "video", {
    ...e,
    controls: m ? !0 : null,
    crossOrigin: typeof g == "boolean" ? "" : g,
    poster: C === "video" && m && S ? S : null,
    suppressHydrationWarning: !0,
    children: D ? null : _.map(
      ({ src: G, type: q }) => Q(G) ? /* @__PURE__ */ p.createElement("source", { src: G, type: q !== "?" ? q : void 0, key: G }) : null
    ),
    ref(G) {
      t.load(G);
    }
  }) : null;
}
Au.displayName = "MediaOutlet";
function wO(t) {
  const e = _n(), n = p.useMemo(() => new Vn(t), Object.values(t));
  return p.useEffect(() => (e.textTracks.add(n), () => {
    e.textTracks.remove(n);
  }), [n]), n;
}
function Iu({ lang: t, ...e }) {
  return wO({ language: t, ...e }), null;
}
Iu.displayName = "Track";
const xO = Ne(rN), LO = p.forwardRef(
  ({ children: t, ...e }, n) => /* @__PURE__ */ p.createElement(xO, { ...e }, (i) => /* @__PURE__ */ p.createElement(
    de.button,
    {
      ...i,
      ref: Pe(i.ref, n)
    },
    t
  ))
);
LO.displayName = "ToggleButton";
const PO = Ne(vN), Du = p.forwardRef(
  ({ children: t, ...e }, n) => /* @__PURE__ */ p.createElement(
    PO,
    {
      src: e.asChild && p.isValidElement(t) ? t.props.src : void 0,
      ...e
    },
    (i, r) => /* @__PURE__ */ p.createElement(
      Mu,
      {
        ...i,
        instance: r,
        ref: Pe(i.ref, n)
      },
      t
    )
  )
);
Du.displayName = "Poster";
const Mu = p.forwardRef(
  ({ instance: t, children: e, ...n }, i) => {
    const { src: r, img: a, alt: s, crossOrigin: o, hidden: l } = t.$state, c = ce(r), d = ce(s), u = ce(o), _ = ce(l);
    return /* @__PURE__ */ p.createElement(
      de.img,
      {
        ...n,
        src: c || void 0,
        alt: d || void 0,
        crossOrigin: u || void 0,
        ref: Pe(a.set, i),
        style: { display: _ ? "none" : void 0 }
      },
      e
    );
  }
);
Mu.displayName = "PosterImg";
const kO = p.forwardRef(({ children: t, ...e }, n) => /* @__PURE__ */ p.createElement(
  de.div,
  {
    translate: "yes",
    "aria-live": "off",
    "aria-atomic": "true",
    ...e,
    ref: n
  },
  t
));
kO.displayName = "Caption";
const UO = p.forwardRef((t, e) => {
  const n = Nt("textTrack"), [i, r] = p.useState();
  return p.useEffect(() => {
    if (!n) return;
    function a() {
      r(n?.activeCues[0]);
    }
    return n.addEventListener("cue-change", a), () => {
      n.removeEventListener("cue-change", a), r(void 0);
    };
  }, [n]), /* @__PURE__ */ p.createElement(
    de.span,
    {
      ...t,
      "data-part": "cue",
      dangerouslySetInnerHTML: {
        __html: i?.text || ""
      },
      ref: e
    }
  );
});
UO.displayName = "CaptionText";
function FO(t, e) {
  p.useEffect(() => {
    if (!t || !e) return;
    const n = e.split(" ");
    for (const i of n) t.classList.add(i);
    return () => {
      for (const i of n) t.classList.remove(i);
    };
  }, [t, e]);
}
function BO(t) {
  const e = TO();
  p.useEffect(() => {
    if (e)
      return N(() => {
        const n = e.$el;
        return n?.setAttribute("data-layout", t), () => n?.removeAttribute("data-layout");
      });
  }, [e]);
}
const GO = /* @__PURE__ */ j(null), YO = /* @__PURE__ */ j(null), $O = /* @__PURE__ */ j(null);
var VO = '<g><path d="M16,1 L2,1 C1.447,1 1,1.447 1,2 L1,12 C1,12.553 1.447,13 2,13 L5,13 L5,11 L3,11 L3,3 L15,3 L15,11 L13,11 L13,13 L16,13 C16.553,13 17,12.553 17,12 L17,2 C17,1.447 16.553,1 16,1 L16,1 Z"></path><polygon points="4 17 14 17 9 11"></polygon></g>', HO = '<g fill-rule="evenodd" fill-opacity="0.5"><path d="M1,1 C0.4,1 0,1.4 0,2 L0,13 C0,13.6 0.4,14 1,14 L5.6,14 L8.3,16.7 C8.5,16.9 8.7,17 9,17 C9.3,17 9.5,16.9 9.7,16.7 L12.4,14 L17,14 C17.6,14 18,13.6 18,13 L18,2 C18,1.4 17.6,1 17,1 L1,1 Z M5.52,11.15 C7.51,11.15 8.53,9.83 8.8,8.74 L7.51,8.35 C7.32,9.01 6.73,9.8 5.52,9.8 C4.38,9.8 3.32,8.97 3.32,7.46 C3.32,5.85 4.44,5.09 5.5,5.09 C6.73,5.09 7.28,5.84 7.45,6.52 L8.75,6.11 C8.47,4.96 7.46,3.76 5.5,3.76 C3.6,3.76 1.89,5.2 1.89,7.46 C1.89,9.72 3.54,11.15 5.52,11.15 Z M13.09,11.15 C15.08,11.15 16.1,9.83 16.37,8.74 L15.08,8.35 C14.89,9.01 14.3,9.8 13.09,9.8 C11.95,9.8 10.89,8.97 10.89,7.46 C10.89,5.85 12.01,5.09 13.07,5.09 C14.3,5.09 14.85,5.84 15.02,6.52 L16.32,6.11 C16.04,4.96 15.03,3.76 13.07,3.76 C11.17,3.76 9.46,5.2 9.46,7.46 C9.46,9.72 11.11,11.15 13.09,11.15 Z"></path></g>', qO = '<g fill-rule="evenodd"><path d="M1,1 C0.4,1 0,1.4 0,2 L0,13 C0,13.6 0.4,14 1,14 L5.6,14 L8.3,16.7 C8.5,16.9 8.7,17 9,17 C9.3,17 9.5,16.9 9.7,16.7 L12.4,14 L17,14 C17.6,14 18,13.6 18,13 L18,2 C18,1.4 17.6,1 17,1 L1,1 Z M5.52,11.15 C7.51,11.15 8.53,9.83 8.8,8.74 L7.51,8.35 C7.32,9.01 6.73,9.8 5.52,9.8 C4.38,9.8 3.32,8.97 3.32,7.46 C3.32,5.85 4.44,5.09 5.5,5.09 C6.73,5.09 7.28,5.84 7.45,6.52 L8.75,6.11 C8.47,4.96 7.46,3.76 5.5,3.76 C3.6,3.76 1.89,5.2 1.89,7.46 C1.89,9.72 3.54,11.15 5.52,11.15 Z M13.09,11.15 C15.08,11.15 16.1,9.83 16.37,8.74 L15.08,8.35 C14.89,9.01 14.3,9.8 13.09,9.8 C11.95,9.8 10.89,8.97 10.89,7.46 C10.89,5.85 12.01,5.09 13.07,5.09 C14.3,5.09 14.85,5.84 15.02,6.52 L16.32,6.11 C16.04,4.96 15.03,3.76 13.07,3.76 C11.17,3.76 9.46,5.2 9.46,7.46 C9.46,9.72 11.11,11.15 13.09,11.15 Z"></path></g>', zO = '<g transform="translate(2 1)"><path d="M7,12 C7.3,12 7.5,11.9 7.7,11.7 L13.4,6 L12,4.6 L8,8.6 L8,0 L6,0 L6,8.6 L2,4.6 L0.6,6 L6.3,11.7 C6.5,11.9 6.7,12 7,12 Z" /><rect width="14" height="2" y="14" /></g>', WO = '<polygon points="10 3 13.6 3 9.6 7 11 8.4 15 4.4 15 8 17 8 17 1 10 1"></polygon><polygon points="7 9.6 3 13.6 3 10 1 10 1 17 8 17 8 15 4.4 15 8.4 11"></polygon>', KO = '<polygon points="1 12 4.6 12 0.6 16 2 17.4 6 13.4 6 17 8 17 8 10 1 10"></polygon><polygon points="16 0.6 12 4.6 12 1 10 1 10 8 17 8 17 6 13.4 6 17.4 2"></polygon>', QO = '<polygon points="7.875 7.17142857 0 1 0 17 7.875 10.8285714 7.875 17 18 9 7.875 1"></polygon>', XO = '<polygon points="12.4 12.5 14.5 10.4 16.6 12.5 18 11.1 15.9 9 18 6.9 16.6 5.5 14.5 7.6 12.4 5.5 11 6.9 13.1 9 11 11.1"></polygon><path d="M3.78571429,6.00820648 L0.714285714,6.00820648 C0.285714286,6.00820648 0,6.30901277 0,6.76022222 L0,11.2723167 C0,11.7235261 0.285714286,12.0243324 0.714285714,12.0243324 L3.78571429,12.0243324 L7.85714286,15.8819922 C8.35714286,16.1827985 9,15.8819922 9,15.2803796 L9,2.75215925 C9,2.15054666 8.35714286,1.77453879 7.85714286,2.15054666 L3.78571429,6.00820648 Z"></path>', ZO = '<path d="M6,1 L3,1 C2.4,1 2,1.4 2,2 L2,16 C2,16.6 2.4,17 3,17 L6,17 C6.6,17 7,16.6 7,16 L7,2 C7,1.4 6.6,1 6,1 L6,1 Z"></path><path d="M12,1 C11.4,1 11,1.4 11,2 L11,16 C11,16.6 11.4,17 12,17 L15,17 C15.6,17 16,16.6 16,16 L16,2 C16,1.4 15.6,1 15,1 L12,1 Z"></path>', sc = '<polygon points="13.293 3.293 7.022 9.564 8.436 10.978 14.707 4.707 17 7 17 1 11 1"></polygon><path d="M13,15 L3,15 L3,5 L8,5 L8,3 L2,3 C1.448,3 1,3.448 1,4 L1,16 C1,16.552 1.448,17 2,17 L14,17 C14.552,17 15,16.552 15,16 L15,10 L13,10 L13,15 L13,15 Z"></path>', JO = '<path d="M15.5615866,8.10002147 L3.87056367,0.225209313 C3.05219207,-0.33727727 2,0.225209313 2,1.12518784 L2,16.8748122 C2,17.7747907 3.05219207,18.3372773 3.87056367,17.7747907 L15.5615866,9.89997853 C16.1461378,9.44998927 16.1461378,8.55001073 15.5615866,8.10002147 L15.5615866,8.10002147 Z"></path>', jO = '<path d="M9.7,1.2 L10.4,7.6 L12.5,5.5 C14.4,7.4 14.4,10.6 12.5,12.5 C11.6,13.5 10.3,14 9,14 C7.7,14 6.4,13.5 5.5,12.5 C3.6,10.6 3.6,7.4 5.5,5.5 C6.1,4.9 6.9,4.4 7.8,4.2 L7.2,2.3 C6,2.6 4.9,3.2 4,4.1 C1.3,6.8 1.3,11.2 4,14 C5.3,15.3 7.1,16 8.9,16 C10.8,16 12.5,15.3 13.8,14 C16.5,11.3 16.5,6.9 13.8,4.1 L16,1.9 L9.7,1.2 L9.7,1.2 Z"></path>', ev = '<polygon points="10.125 1 0 9 10.125 17 10.125 10.8285714 18 17 18 1 10.125 7.17142857"></polygon>', tv = '<path d="M16.135,7.784 C14.832,7.458 14.214,5.966 14.905,4.815 C15.227,4.279 15.13,3.817 14.811,3.499 L14.501,3.189 C14.183,2.871 13.721,2.774 13.185,3.095 C12.033,3.786 10.541,3.168 10.216,1.865 C10.065,1.258 9.669,1 9.219,1 L8.781,1 C8.331,1 7.936,1.258 7.784,1.865 C7.458,3.168 5.966,3.786 4.815,3.095 C4.279,2.773 3.816,2.87 3.498,3.188 L3.188,3.498 C2.87,3.816 2.773,4.279 3.095,4.815 C3.786,5.967 3.168,7.459 1.865,7.784 C1.26,7.935 1,8.33 1,8.781 L1,9.219 C1,9.669 1.258,10.064 1.865,10.216 C3.168,10.542 3.786,12.034 3.095,13.185 C2.773,13.721 2.87,14.183 3.189,14.501 L3.499,14.811 C3.818,15.13 4.281,15.226 4.815,14.905 C5.967,14.214 7.459,14.832 7.784,16.135 C7.935,16.742 8.331,17 8.781,17 L9.219,17 C9.669,17 10.064,16.742 10.216,16.135 C10.542,14.832 12.034,14.214 13.185,14.905 C13.72,15.226 14.182,15.13 14.501,14.811 L14.811,14.501 C15.129,14.183 15.226,13.72 14.905,13.185 C14.214,12.033 14.832,10.541 16.135,10.216 C16.742,10.065 17,9.669 17,9.219 L17,8.781 C17,8.33 16.74,7.935 16.135,7.784 L16.135,7.784 Z M9,12 C7.343,12 6,10.657 6,9 C6,7.343 7.343,6 9,6 C10.657,6 12,7.343 12,9 C12,10.657 10.657,12 9,12 L9,12 Z"></path>', nv = '<path d="M15.5999996,3.3 C15.1999996,2.9 14.5999996,2.9 14.1999996,3.3 C13.7999996,3.7 13.7999996,4.3 14.1999996,4.7 C15.3999996,5.9 15.9999996,7.4 15.9999996,9 C15.9999996,10.6 15.3999996,12.1 14.1999996,13.3 C13.7999996,13.7 13.7999996,14.3 14.1999996,14.7 C14.3999996,14.9 14.6999996,15 14.8999996,15 C15.1999996,15 15.3999996,14.9 15.5999996,14.7 C17.0999996,13.2 17.9999996,11.2 17.9999996,9 C17.9999996,6.8 17.0999996,4.8 15.5999996,3.3 L15.5999996,3.3 Z"></path><path d="M11.2819745,5.28197449 C10.9060085,5.65794047 10.9060085,6.22188944 11.2819745,6.59785542 C12.0171538,7.33303477 12.2772954,8.05605449 12.2772954,9.00000021 C12.2772954,9.93588462 11.851678,10.9172014 11.2819745,11.4869049 C10.9060085,11.8628709 10.9060085,12.4268199 11.2819745,12.8027859 C11.4271642,12.9479755 11.9176724,13.0649528 12.2998149,12.9592565 C12.4124479,12.9281035 12.5156669,12.8776063 12.5978555,12.8027859 C13.773371,11.732654 14.1311161,10.1597914 14.1312523,9.00000021 C14.1312723,8.8299555 14.1286311,8.66015647 14.119665,8.4897429 C14.0674781,7.49784946 13.8010171,6.48513613 12.5978554,5.28197449 C12.2218894,4.9060085 11.6579405,4.9060085 11.2819745,5.28197449 Z"></path><path d="M3.78571429,6.00820648 L0.714285714,6.00820648 C0.285714286,6.00820648 0,6.30901277 0,6.76022222 L0,11.2723167 C0,11.7235261 0.285714286,12.0243324 0.714285714,12.0243324 L3.78571429,12.0243324 L7.85714286,15.8819922 C8.35714286,16.1827985 9,15.8819922 9,15.2803796 L9,2.75215925 C9,2.15054666 8.35714286,1.77453879 7.85714286,2.15054666 L3.78571429,6.00820648 Z"></path>';
function ct(t) {
  function e(n) {
    return /* @__PURE__ */ p.createElement(vo, { viewBox: "0 0 18 18", paths: t, ...n });
  }
  return e.displayName = "PlyrLayoutIcon", e;
}
const iv = {
  AirPlay: ct(VO),
  CaptionsOff: ct(HO),
  CaptionsOn: ct(qO),
  Download: ct(zO),
  EnterFullscreen: ct(KO),
  EnterPiP: ct(sc),
  ExitFullscreen: ct(WO),
  ExitPiP: ct(sc),
  FastForward: ct(QO),
  Muted: ct(XO),
  Pause: ct(ZO),
  Play: ct(JO),
  Restart: ct(jO),
  Rewind: ct(ev),
  Settings: ct(tv),
  Volume: ct(nv)
};
function rv(t, e) {
  const {
    canAirPlay: n,
    canFullscreen: i,
    canPictureInPicture: r,
    controlsHidden: a,
    currentTime: s,
    fullscreen: o,
    hasCaptions: l,
    isAirPlayConnected: c,
    paused: d,
    pictureInPicture: u,
    playing: _,
    pointer: m,
    poster: g,
    textTrack: S,
    viewType: E,
    waiting: h
  } = e.$state;
  t.classList.add("plyr"), t.classList.add("plyr--full-ui");
  const T = {
    "plyr--airplay-active": c,
    "plyr--airplay-supported": n,
    "plyr--fullscreen-active": o,
    "plyr--fullscreen-enabled": i,
    "plyr--hide-controls": a,
    "plyr--is-touch": () => m() === "coarse",
    "plyr--loading": h,
    "plyr--paused": d,
    "plyr--pip-active": u,
    "plyr--pip-enabled": r,
    "plyr--playing": _,
    "plyr__poster-enabled": g,
    "plyr--stopped": () => d() && s() === 0,
    "plyr--captions-active": S,
    "plyr--captions-enabled": l
  }, b = ud();
  for (const C of Object.keys(T))
    b.add(N(() => {
      t.classList.toggle(C, !!T[C]());
    }));
  return b.add(
    N(() => {
      const C = `plyr--${E()}`;
      return t.classList.add(C), () => t.classList.remove(C);
    }),
    N(() => {
      const { $provider: C } = e, y = C()?.type, O = `plyr--${av(y) ? "html5" : y}`;
      return t.classList.toggle(O, !!y), () => t.classList.remove(O);
    })
  ), () => b.empty();
}
function av(t) {
  return t === "audio" || t === "video";
}
const Do = p.createContext({});
Do.displayName = "PlyrLayoutContext";
function ze() {
  return p.useContext(Do);
}
function xe(t) {
  const { translations: e } = ze();
  return wu(e, t);
}
function wu(t, e) {
  return t?.[e] ?? e;
}
const sv = {
  clickToPlay: !0,
  clickToFullscreen: !0,
  controls: [
    "play-large",
    "play",
    "progress",
    "current-time",
    "mute+volume",
    "captions",
    "settings",
    "pip",
    "airplay",
    "fullscreen"
  ],
  displayDuration: !1,
  download: null,
  markers: null,
  invertTime: !0,
  thumbnails: null,
  toggleTime: !0,
  translations: null,
  seekTime: 10,
  speed: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 4]
};
function at(t, e) {
  const { slots: n } = ze(), i = n?.[t], r = Ea(t);
  return /* @__PURE__ */ p.createElement(p.Fragment, null, n?.[`before${r}`], je(i) ? e : i, n?.[`after${r}`]);
}
const xu = p.forwardRef(
  (t, e) => {
    const {
      clickToPlay: n,
      clickToFullscreen: i,
      controls: r,
      displayDuration: a,
      download: s,
      markers: o,
      invertTime: l,
      thumbnails: c,
      toggleTime: d,
      translations: u,
      seekTime: _,
      speed: m,
      icons: g,
      slots: S,
      posterFrame: E,
      className: h,
      ...T
    } = { ...sv, ...t }, [b, C] = p.useState(null), y = _n(), O = p.useMemo(() => j(0), []), A = Nt("viewType");
    return BO("plyr"), FO(b, h), p.useEffect(() => {
      if (!(!b || !y))
        return rv(b, y);
    }, [b, y]), /* @__PURE__ */ p.createElement(
      Do.Provider,
      {
        value: {
          clickToPlay: n,
          clickToFullscreen: i,
          controls: r,
          displayDuration: a,
          download: s,
          markers: o,
          invertTime: l,
          thumbnails: c,
          toggleTime: d,
          translations: u,
          seekTime: _,
          speed: m,
          previewTime: O,
          icons: g,
          slots: S,
          posterFrame: E
        }
      },
      /* @__PURE__ */ p.createElement(
        de.div,
        {
          ...T,
          className: H ? `plyr plyr--full-ui plyr--${A} ${h || ""}` : void 0,
          ref: Pe(C, e)
        },
        A === "audio" ? /* @__PURE__ */ p.createElement(Lu, null) : A === "video" ? /* @__PURE__ */ p.createElement(Pu, null) : null
      )
    );
  }
);
xu.displayName = "PlyrLayout";
function Lu() {
  return Uu();
}
Lu.displayName = "PlyrAudioLayout";
function Pu() {
  const t = _n(), { controls: e } = ze(), { load: n } = t.$props, { canLoad: i } = t.$state, r = ce(n), a = ce(i);
  return r === "play" && !a ? /* @__PURE__ */ p.createElement(p.Fragment, null, /* @__PURE__ */ p.createElement(bs, null), /* @__PURE__ */ p.createElement(Cs, null)) : /* @__PURE__ */ p.createElement(p.Fragment, null, e.includes("play-large") ? /* @__PURE__ */ p.createElement(bs, null) : null, /* @__PURE__ */ p.createElement(ku, null), /* @__PURE__ */ p.createElement(Cs, null), /* @__PURE__ */ p.createElement(Fu, null), /* @__PURE__ */ p.createElement(e_, null), /* @__PURE__ */ p.createElement(t_, null));
}
Pu.displayName = "PlyrVideoLayout";
function bs() {
  const { translations: t, icons: e } = ze(), n = Nt("title"), i = `${wu(t, "Play")} ${n}`;
  return at(
    "playLargeButton",
    /* @__PURE__ */ p.createElement(
      fo,
      {
        className: "plyr__control plyr__control--overlaid",
        "aria-label": i,
        "data-plyr": "play"
      },
      /* @__PURE__ */ p.createElement(e.Play, null)
    )
  );
}
bs.displayName = "PlyrPlayLargeButton";
function ku() {
  const t = Nt("source"), { thumbnails: e, previewTime: n } = ze(), i = ce(n), r = ce(GO);
  return r && ho(t) ? /* @__PURE__ */ p.createElement(r, { className: "plyr__preview-scrubbing", frame: i * t.fps }) : /* @__PURE__ */ p.createElement(fu, { src: e, className: "plyr__preview-scrubbing", time: i }, /* @__PURE__ */ p.createElement(Co, null));
}
ku.displayName = "PlyrPreviewScrubbing";
function Cs() {
  const t = Nt("source"), e = Nt("poster"), { posterFrame: n } = ze(), i = ce($O), r = i && ho(t) && mt(n);
  return at(
    "poster",
    r ? /* @__PURE__ */ p.createElement(i, { frame: n, className: "plyr__poster" }) : /* @__PURE__ */ p.createElement("div", { className: "plyr__poster", style: { backgroundImage: `url("${e}")` } })
  );
}
Cs.displayName = "PlyrPoster";
const ov = /* @__PURE__ */ new Set(["captions", "pip", "airplay", "fullscreen"]);
function Uu() {
  const { controls: t } = ze();
  return /* @__PURE__ */ p.createElement("div", { className: "plyr__controls" }, t.filter((e) => !ov.has(e)).map((e, n) => {
    const i = Bu(e);
    return i ? p.createElement(i, { key: n }) : null;
  }));
}
Uu.displayName = "PlyrAudioControls";
function Fu() {
  const { controls: t } = ze();
  return /* @__PURE__ */ p.createElement("div", { className: "plyr__controls" }, t.map((e, n) => {
    const i = Bu(e);
    return i ? p.createElement(i, { key: n }) : null;
  }));
}
Fu.displayName = "PlyrVideoControls";
function Bu(t) {
  switch (t) {
    case "airplay":
      return Gu;
    case "captions":
      return Yu;
    case "current-time":
      return Ju;
    case "download":
      return ju;
    case "duration":
      return Mo;
    case "fast-forward":
      return Wu;
    case "fullscreen":
      return $u;
    case "mute":
    case "volume":
    case "mute+volume":
      return () => Zu({ type: t });
    case "pip":
      return Vu;
    case "play":
      return qu;
    case "progress":
      return Qu;
    case "restart":
      return zu;
    case "rewind":
      return Ku;
    case "settings":
      return n_;
    default:
      return null;
  }
}
function Gu() {
  const { icons: t } = ze(), e = xe("AirPlay");
  return at(
    "airPlayButton",
    /* @__PURE__ */ p.createElement(_u, { className: "plyr__controls__item plyr__control", "data-plyr": "airplay" }, /* @__PURE__ */ p.createElement(t.AirPlay, null), /* @__PURE__ */ p.createElement("span", { className: "plyr__tooltip" }, e))
  );
}
Gu.displayName = "PlyrAirPlayButton";
function Yu() {
  const { icons: t } = ze(), e = xe("Enable captions"), n = xe("Disable captions");
  return at(
    "captionsButton",
    /* @__PURE__ */ p.createElement(
      pu,
      {
        className: "plyr__controls__item plyr__control",
        "data-no-label": !0,
        "data-plyr": "captions"
      },
      /* @__PURE__ */ p.createElement(t.CaptionsOn, { className: "icon--pressed" }),
      /* @__PURE__ */ p.createElement(t.CaptionsOff, { className: "icon--not-pressed" }),
      /* @__PURE__ */ p.createElement("span", { className: "label--pressed plyr__tooltip" }, n),
      /* @__PURE__ */ p.createElement("span", { className: "label--not-pressed plyr__tooltip" }, e)
    )
  );
}
Yu.displayName = "PlyrCaptionsButton";
function $u() {
  const { icons: t } = ze(), e = xe("Enter Fullscreen"), n = xe("Exit Fullscreen");
  return at(
    "fullscreenButton",
    /* @__PURE__ */ p.createElement(
      mu,
      {
        className: "plyr__controls__item plyr__control",
        "data-no-label": !0,
        "data-plyr": "fullscreen"
      },
      /* @__PURE__ */ p.createElement(t.EnterFullscreen, { className: "icon--pressed" }),
      /* @__PURE__ */ p.createElement(t.ExitFullscreen, { className: "icon--not-pressed" }),
      /* @__PURE__ */ p.createElement("span", { className: "label--pressed plyr__tooltip" }, n),
      /* @__PURE__ */ p.createElement("span", { className: "label--not-pressed plyr__tooltip" }, e)
    )
  );
}
$u.displayName = "PlyrFullscreenButton";
function Vu() {
  const { icons: t } = ze(), e = xe("Enter PiP"), n = xe("Exit PiP");
  return at(
    "pipButton",
    /* @__PURE__ */ p.createElement(gu, { className: "plyr__controls__item plyr__control", "data-no-label": !0, "data-plyr": "pip" }, /* @__PURE__ */ p.createElement(t.EnterPiP, { className: "icon--pressed" }), /* @__PURE__ */ p.createElement(t.ExitPiP, { className: "icon--not-pressed" }), /* @__PURE__ */ p.createElement("span", { className: "label--pressed plyr__tooltip" }, n), /* @__PURE__ */ p.createElement("span", { className: "label--not-pressed plyr__tooltip" }, e))
  );
}
Vu.displayName = "PlyrPIPButton";
function Hu() {
  const { icons: t } = ze(), e = xe("Mute"), n = xe("Unmute");
  return at(
    "muteButton",
    /* @__PURE__ */ p.createElement(Eu, { className: "plyr__control", "data-no-label": !0, "data-plyr": "mute" }, /* @__PURE__ */ p.createElement(t.Muted, { className: "icon--pressed" }), /* @__PURE__ */ p.createElement(t.Volume, { className: "icon--not-pressed" }), /* @__PURE__ */ p.createElement("span", { className: "label--pressed plyr__tooltip" }, n), /* @__PURE__ */ p.createElement("span", { className: "label--not-pressed plyr__tooltip" }, e))
  );
}
Hu.displayName = "PlyrMuteButton";
function qu() {
  const { icons: t } = ze(), e = xe("Play"), n = xe("Pause");
  return at(
    "playButton",
    /* @__PURE__ */ p.createElement(fo, { className: "plyr__controls__item plyr__control", "data-no-label": !0, "data-plyr": "play" }, /* @__PURE__ */ p.createElement(t.Pause, { className: "icon--pressed" }), /* @__PURE__ */ p.createElement(t.Play, { className: "icon--not-pressed" }), /* @__PURE__ */ p.createElement("span", { className: "label--pressed plyr__tooltip" }, n), /* @__PURE__ */ p.createElement("span", { className: "label--not-pressed plyr__tooltip" }, e))
  );
}
qu.displayName = "PlyrPlayButton";
function zu() {
  const { icons: t } = ze(), e = xe("Restart"), n = RO();
  function i({ nativeEvent: r }) {
    zn(r) && !dr(r) || n.seek(0, r);
  }
  return at(
    "restartButton",
    /* @__PURE__ */ p.createElement(
      "button",
      {
        type: "button",
        className: "plyr__control",
        "data-plyr": "restart",
        onPointerUp: i,
        onKeyDown: i
      },
      /* @__PURE__ */ p.createElement("slot", { name: "restart-icon", "data-class": "" }),
      /* @__PURE__ */ p.createElement(t.Restart, null),
      /* @__PURE__ */ p.createElement("span", { className: "plyr__tooltip" }, e)
    )
  );
}
zu.displayName = "PlyrRestartButton";
function Wu() {
  const { icons: t, seekTime: e } = ze(), n = xe("Forward"), i = `${n} ${e}s`;
  return at(
    "fastForwardButton",
    /* @__PURE__ */ p.createElement(
      To,
      {
        className: "plyr__controls__item plyr__control",
        seconds: e,
        "data-no-label": !0,
        "data-plyr": "fast-forward"
      },
      /* @__PURE__ */ p.createElement(t.FastForward, null),
      /* @__PURE__ */ p.createElement("span", { className: "plyr__tooltip" }, i)
    )
  );
}
Wu.displayName = "PlyrFastForwardButton";
function Ku() {
  const { icons: t, seekTime: e } = ze(), n = xe("Rewind"), i = `${n} ${e}s`;
  return at(
    "rewindButton",
    /* @__PURE__ */ p.createElement(
      To,
      {
        className: "plyr__controls__item plyr__control",
        seconds: -1 * e,
        "data-no-label": !0,
        "data-plyr": "rewind"
      },
      /* @__PURE__ */ p.createElement(t.Rewind, null),
      /* @__PURE__ */ p.createElement("span", { className: "plyr__tooltip" }, i)
    )
  );
}
Ku.displayName = "PlyrRewindButton";
function Qu() {
  const { markers: t, thumbnails: e, seekTime: n, previewTime: i } = ze(), r = Nt("source"), a = Nt("duration"), s = xe("Seek"), [o, l] = p.useState(null), c = ce(YO), d = c && ho(r);
  function u(S) {
    i.set(S);
  }
  function _() {
    l(this);
  }
  function m() {
    l(null);
  }
  const g = o ? /* @__PURE__ */ p.createElement(
    "span",
    {
      className: "plyr__progress__marker-label",
      dangerouslySetInnerHTML: { __html: o.label + "<br />" }
    }
  ) : null;
  return at(
    "timeSlider",
    /* @__PURE__ */ p.createElement("div", { className: "plyr__controls__item plyr__progress__container" }, /* @__PURE__ */ p.createElement("div", { className: "plyr__progress" }, /* @__PURE__ */ p.createElement(
      Tu,
      {
        className: "plyr__slider",
        pauseWhileDragging: !0,
        keyStep: n,
        "aria-label": s,
        "data-plyr": "seek",
        onMediaSeekingRequest: u
      },
      /* @__PURE__ */ p.createElement("div", { className: "plyr__slider__track" }),
      /* @__PURE__ */ p.createElement("div", { className: "plyr__slider__thumb" }),
      /* @__PURE__ */ p.createElement("div", { className: "plyr__slider__buffer" }),
      !e && !d ? /* @__PURE__ */ p.createElement("span", { className: "plyr__tooltip" }, g, /* @__PURE__ */ p.createElement(Hr, null)) : d ? /* @__PURE__ */ p.createElement(fs, { className: "plyr__slider__preview" }, /* @__PURE__ */ p.createElement("div", { className: "plyr__slider__preview__thumbnail" }, /* @__PURE__ */ p.createElement("span", { className: "plyr__slider__preview__time-container" }, g, /* @__PURE__ */ p.createElement(Hr, { className: "plyr__slider__preview__time" })), /* @__PURE__ */ p.createElement(c, { className: "plyr__slider__preview__thumbnail" }))) : /* @__PURE__ */ p.createElement(fs, { className: "plyr__slider__preview" }, /* @__PURE__ */ p.createElement(
        nc.Root,
        {
          src: e,
          className: "plyr__slider__preview__thumbnail"
        },
        /* @__PURE__ */ p.createElement("span", { className: "plyr__slider__preview__time-container" }, g, /* @__PURE__ */ p.createElement(Hr, { className: "plyr__slider__preview__time" })),
        /* @__PURE__ */ p.createElement(nc.Img, null)
      )),
      t && Number.isFinite(a) ? t.map((S, E) => /* @__PURE__ */ p.createElement(
        "span",
        {
          className: "plyr__progress__marker",
          key: E,
          onMouseEnter: _.bind(S),
          onMouseLeave: m,
          style: { left: `${S.time / a * 100}%` }
        }
      )) : null
    )))
  );
}
Qu.displayName = "PlyrTimeSlider";
function Xu() {
  const t = xe("Volume");
  return at(
    "volumeSlider",
    /* @__PURE__ */ p.createElement(hu, { className: "plyr__slider", "data-plyr": "volume", "aria-label": t }, /* @__PURE__ */ p.createElement("div", { className: "plyr__slider__track" }), /* @__PURE__ */ p.createElement("div", { className: "plyr__slider__thumb" }))
  );
}
Xu.displayName = "PlyrVolumeSlider";
function Zu({ type: t }) {
  const e = t === "mute" || t === "mute+volume", n = t === "volume" || t === "mute+volume";
  return /* @__PURE__ */ p.createElement("div", { className: "plyr__controls__item plyr__volume" }, e ? /* @__PURE__ */ p.createElement(Hu, null) : null, n ? /* @__PURE__ */ p.createElement(Xu, null) : null);
}
Zu.displayName = "PlyrVolume";
function Ju() {
  const { invertTime: t, toggleTime: e, displayDuration: n } = ze(), i = Nt("streamType"), r = xe("Current time"), a = xe("LIVE"), [s, o] = p.useState(t), l = !n && s;
  function c({ nativeEvent: d }) {
    !e || n || zn(d) && !dr(d) || o((u) => !u);
  }
  return at(
    "currentTime",
    i === "live" || i === "ll-live" ? /* @__PURE__ */ p.createElement(Su, { className: "plyr__controls__item plyr__control plyr__live-button", "data-plyr": "live" }, /* @__PURE__ */ p.createElement("span", { className: "plyr__live-button__text" }, a)) : /* @__PURE__ */ p.createElement(p.Fragment, null, /* @__PURE__ */ p.createElement(
      Oo,
      {
        type: "current",
        className: "plyr__controls__item plyr__time plyr__time--current",
        role: "timer",
        "aria-label": r,
        tabIndex: 0,
        remainder: l,
        onPointerUp: c,
        onKeyDown: c
      }
    ), n ? /* @__PURE__ */ p.createElement(Mo, null) : null)
  );
}
Ju.displayName = "PlyrCurrentTime";
function Mo() {
  const t = xe("Duration");
  return at(
    "duration",
    /* @__PURE__ */ p.createElement(
      Oo,
      {
        className: "plyr__controls__item plyr__time plyr__time--duration",
        type: "duration",
        role: "timer",
        tabIndex: 0,
        "aria-label": t
      }
    )
  );
}
Mo.displayName = "PlyrDuration";
function ju() {
  const { download: t } = ze(), e = Nt("source"), n = Nt("title"), i = MC({
    title: n,
    src: e,
    download: t
  }), r = xe("Download");
  return at(
    "download",
    Q(i?.url) ? /* @__PURE__ */ p.createElement(
      "a",
      {
        className: "plyr__controls__item plyr__control",
        href: eO(i.url, { download: i.name }),
        download: i.name,
        target: "_blank"
      },
      /* @__PURE__ */ p.createElement("slot", { name: "download-icon" }),
      /* @__PURE__ */ p.createElement("span", { className: "plyr__tooltip" }, r)
    ) : null
  );
}
ju.displayName = "PlyrDownloadButton";
function e_() {
  const { clickToPlay: t, clickToFullscreen: e } = ze();
  return /* @__PURE__ */ p.createElement(p.Fragment, null, t ? /* @__PURE__ */ p.createElement(Ts, { className: "plyr__gesture", event: "pointerup", action: "toggle:paused" }) : null, e ? /* @__PURE__ */ p.createElement(Ts, { className: "plyr__gesture", event: "dblpointerup", action: "toggle:fullscreen" }) : null);
}
e_.displayName = "PlyrGestures";
function t_() {
  const t = Nt("textTrack"), [e, n] = p.useState(null);
  return p.useEffect(() => {
    if (!t) return;
    function i() {
      n(t ? t.activeCues[0] : null);
    }
    return i(), Ve(t, "cue-change", i);
  }, [t]), /* @__PURE__ */ p.createElement("div", { className: "plyr__captions", dir: "auto" }, /* @__PURE__ */ p.createElement(
    "span",
    {
      className: "plyr__caption",
      dangerouslySetInnerHTML: {
        __html: e?.text || ""
      }
    }
  ));
}
t_.displayName = "PlyrCaptions";
function n_() {
  const { icons: t } = ze(), e = xe("Settings");
  return at(
    "settings",
    /* @__PURE__ */ p.createElement("div", { className: "plyr__controls__item plyr__menu" }, /* @__PURE__ */ p.createElement(yo, null, /* @__PURE__ */ p.createElement(Ro, { className: "plyr__control", "data-plyr": "settings" }, at(
      "settingsButton",
      /* @__PURE__ */ p.createElement(p.Fragment, null, /* @__PURE__ */ p.createElement(t.Settings, null), /* @__PURE__ */ p.createElement("span", { className: "plyr__tooltip" }, e))
    )), /* @__PURE__ */ p.createElement(No, { className: "plyr__menu__container", placement: "top end" }, /* @__PURE__ */ p.createElement("div", null, /* @__PURE__ */ p.createElement("div", null, at(
      "settingsMenu",
      /* @__PURE__ */ p.createElement(p.Fragment, null, /* @__PURE__ */ p.createElement(r_, null), /* @__PURE__ */ p.createElement(s_, null), /* @__PURE__ */ p.createElement(o_, null), /* @__PURE__ */ p.createElement(a_, null))
    ))))))
  );
}
n_.displayName = "PlyrSettings";
function i_({
  label: t,
  hint: e,
  open: n,
  disabled: i
}) {
  const r = xe(t), a = xe("Go back to previous menu");
  return /* @__PURE__ */ p.createElement(
    Ro,
    {
      className: `plyr__control plyr__control--${n ? "back" : "forward"}`,
      "data-plyr": "settings",
      disabled: i
    },
    /* @__PURE__ */ p.createElement("span", { className: "plyr__menu__label", "aria-hidden": n ? "true" : void 0 }, r),
    e ? /* @__PURE__ */ p.createElement("span", { className: "plyr__menu__value" }, e) : null,
    n ? /* @__PURE__ */ p.createElement("span", { className: "plyr__sr-only" }, a) : null
  );
}
i_.displayName = "PlyrMenuButton";
function hr({
  label: t,
  hint: e,
  children: n,
  disabled: i
}) {
  const [r, a] = p.useState(!1);
  function s() {
    a(!0);
  }
  function o() {
    a(!1);
  }
  return /* @__PURE__ */ p.createElement(yo, { onOpen: s, onClose: o }, /* @__PURE__ */ p.createElement(i_, { label: t, open: r, hint: e, disabled: i }), /* @__PURE__ */ p.createElement(No, null, n));
}
hr.displayName = "PlyrMenu";
function r_() {
  const t = xe("Default"), e = Nt("audioTrack"), n = bO();
  return /* @__PURE__ */ p.createElement(hr, { label: "Audio", hint: e?.label ?? t, disabled: n.disabled }, /* @__PURE__ */ p.createElement(gr, { value: n.selectedValue }, n.map(({ label: i, value: r, select: a }) => /* @__PURE__ */ p.createElement(Sr, { className: "plyr__control", value: r, onSelect: a, key: r }, /* @__PURE__ */ p.createElement("span", null, i)))));
}
r_.displayName = "PlyrAudioMenu";
function a_() {
  const t = xe("Normal"), e = OO({ normalLabel: t }), n = e.selectedValue === "1" ? t : e.selectedValue + "x";
  return /* @__PURE__ */ p.createElement(hr, { label: "Speed", hint: n, disabled: e.disabled }, /* @__PURE__ */ p.createElement(gr, { value: e.selectedValue }, e.map(({ label: i, value: r, select: a }) => /* @__PURE__ */ p.createElement(Sr, { className: "plyr__control", value: r, onSelect: a, key: r }, /* @__PURE__ */ p.createElement("span", null, i)))));
}
a_.displayName = "PlyrSpeedMenu";
function s_() {
  const t = xe("Disabled"), e = CO({ off: t }), n = e.selectedTrack?.label ?? t;
  return /* @__PURE__ */ p.createElement(hr, { label: "Captions", hint: n, disabled: e.disabled }, /* @__PURE__ */ p.createElement(gr, { value: e.selectedValue }, e.map(({ label: i, value: r, select: a }) => /* @__PURE__ */ p.createElement(Sr, { className: "plyr__control", value: r, onSelect: a, key: r }, /* @__PURE__ */ p.createElement("span", null, i)))));
}
s_.displayName = "PlyrCaptionsMenu";
function o_() {
  const t = xe("Auto"), e = NO({ auto: t, sort: "descending" }), n = e.selectedQuality?.height, i = e.selectedValue !== "auto" && n ? `${n}p` : `${t}${n ? ` (${n}p)` : ""}`;
  return /* @__PURE__ */ p.createElement(hr, { label: "Quality", hint: i, disabled: e.disabled }, /* @__PURE__ */ p.createElement(gr, { value: e.selectedValue }, e.map(({ label: r, value: a, select: s }) => /* @__PURE__ */ p.createElement(Sr, { className: "plyr__control", value: a, onSelect: s, key: a }, /* @__PURE__ */ p.createElement("span", null, r)))));
}
o_.displayName = "PlyrQualityMenu";
const lv = "_wrapper_1szer_1", cv = "_loader_1szer_8", dv = "_processed_1szer_24", uv = "_processedWrapper_1szer_35", oa = {
  wrapper: lv,
  loader: cv,
  processed: dv,
  processedWrapper: uv
}, Ur = {};
function _v(t, e, n) {
  process.env.NODE_ENV !== "production" && console.error("[reportError]", t, e, n);
}
var pv = class extends yn.Component {
  constructor() {
    super(...arguments), this.state = { hasError: !1, error: null }, this.reset = () => {
      this.setState({ hasError: !1, error: null });
    };
  }
  static getDerivedStateFromError(t) {
    return { hasError: !0, error: t };
  }
  componentDidCatch(t, e) {
    this.props.onError?.(t, { componentStack: e.componentStack }), _v(t, { componentStack: e.componentStack });
  }
  componentDidUpdate(t) {
    this.props.resetKey !== t.resetKey && this.state.hasError && this.reset();
  }
  render() {
    if (this.state.hasError) {
      const t = this.props.fallback;
      return typeof t == "function" ? t({ error: this.state.error, reset: this.reset }) : t || /* @__PURE__ */ Re(
        "div",
        {
          style: {
            fontFamily: "Inter, system-ui, sans-serif",
            padding: 16,
            border: "1px solid var(--border,#e5e7eb)",
            borderRadius: 12
          },
          children: [
            /* @__PURE__ */ R("b", { children: "Что-то пошло не так." }),
            /* @__PURE__ */ R("div", { style: { marginTop: 8 }, children: /* @__PURE__ */ R(
              "button",
              {
                onClick: this.reset,
                style: { padding: "6px 10px", borderRadius: 8 },
                children: "Попробовать снова"
              }
            ) })
          ]
        }
      );
    }
    return this.props.children;
  }
}, l_ = p.createContext(null), mv = ({
  selectionMode: t = "multiple",
  defaultOpenKeys: e,
  className: n,
  children: i
}) => {
  const [r, a] = p.useState(() => new Set(e ?? [])), s = p.useCallback(
    (l) => {
      a((c) => {
        const d = new Set(c), u = d.has(l);
        return t === "single" ? (d.clear(), u || d.add(l), d) : (u ? d.delete(l) : d.add(l), d);
      });
    },
    [t]
  ), o = p.useMemo(() => ({ selectionMode: t, openKeys: r, toggle: s }), [t, r, s]);
  return /* @__PURE__ */ R("div", { className: [Yt.root, n].filter(Boolean).join(" "), children: /* @__PURE__ */ R(l_.Provider, { value: o, children: i }) });
}, Ev = ({
  itemKey: t,
  title: e,
  indicator: n,
  className: i,
  headerClassName: r,
  panelClassName: a,
  children: s,
  ...o
}) => {
  const l = p.useRef(null), [c, d] = p.useState(0), u = p.useContext(l_);
  if (!u)
    throw new Error("AccordionItem must be used inside <Accordion />");
  const _ = u.openKeys.has(t);
  p.useEffect(() => {
    if (l.current) {
      const S = _ ? l.current.scrollHeight : 0;
      d(S);
    }
  }, [_, s]);
  const m = p.useId(), g = p.useId();
  return /* @__PURE__ */ Re(
    "div",
    {
      className: [Yt.item, _ && Yt.itemOpen, i].filter(Boolean).join(" "),
      "data-open": _ ? "true" : "false",
      children: [
        /* @__PURE__ */ R("div", { className: [Yt.header, r].filter(Boolean).join(" "), children: /* @__PURE__ */ Re(
          "button",
          {
            id: m,
            type: "button",
            className: Yt.trigger,
            "aria-expanded": _,
            "aria-controls": g,
            ...o,
            onClick: () => u.toggle(t),
            children: [
              /* @__PURE__ */ R("span", { className: Yt.title, children: e }),
              n ? /* @__PURE__ */ R("span", { className: Yt.indicatorSlot, children: n }) : /* @__PURE__ */ R(
                "span",
                {
                  className: Yt.indicatorSlot,
                  "aria-hidden": "true",
                  children: /* @__PURE__ */ R(
                    "svg",
                    {
                      className: Yt.chevron,
                      viewBox: "0 0 16 16",
                      children: /* @__PURE__ */ R(
                        "path",
                        {
                          d: "M4 6l4 4 4-4",
                          fill: "none",
                          stroke: "currentColor",
                          strokeWidth: "1.5",
                          strokeLinecap: "round",
                          strokeLinejoin: "round"
                        }
                      )
                    }
                  )
                }
              )
            ]
          }
        ) }),
        /* @__PURE__ */ R(
          "div",
          {
            id: g,
            role: "region",
            "aria-labelledby": m,
            className: [Yt.panel, a].filter(Boolean).join(" "),
            "data-open": _ ? "true" : "false",
            style: {
              maxHeight: `${c}px`
            },
            children: /* @__PURE__ */ R(
              "div",
              {
                ref: l,
                className: Yt.panelInner,
                children: s
              }
            )
          }
        )
      ]
    }
  );
}, gv = ({ content: t = [], children: e = [] }) => {
  const n = p.Children.toArray(e);
  return /* @__PURE__ */ R(
    mv,
    {
      selectionMode: "multiple",
      className: `ce-accordion ${Yt.accordion}`,
      children: t.map((i, r) => /* @__PURE__ */ R(
        Ev,
        {
          itemKey: `${i.type}-${r}`,
          "aria-label": i.attrs?.title,
          title: i.attrs?.title,
          indicator: /* @__PURE__ */ R(
            A_,
            {
              size: 22,
              strokeWidth: "1px"
            }
          ),
          children: n[r]
        },
        `${i.type}-${r}`
      ))
    }
  );
}, Sv = ({ children: t = [] }) => {
  const e = Ct(() => yn.Children.toArray(t), [t]);
  return /* @__PURE__ */ R("figure", { "data-type": "blockquoteFigure", children: /* @__PURE__ */ Re("div", { children: [
    /* @__PURE__ */ R("blockquote", { children: e[0] }),
    e[1] && /* @__PURE__ */ R("figcaption", { children: e[1] })
  ] }) });
}, ys = ({
  className: t,
  onChange: e,
  defaultSelected: n,
  isDisabled: i,
  isInvalid: r,
  isReadOnly: a,
  isRequired: s,
  lineThrough: o,
  content: l,
  attrs: c
}) => {
  const d = l?.[0]?.content?.[0]?.text, u = !!c?.checked, _ = u !== void 0, [m, g] = Je(n ?? !1), S = _ ? !!u : m, E = (h) => {
    if (i || a) return;
    const T = h.target.checked;
    _ || g(T), e?.(T);
  };
  return /* @__PURE__ */ Re(
    "label",
    {
      className: [
        "ce-checkbox",
        dt.checkBoxRoot,
        S && dt.checkBoxIsSelected,
        i && dt.checkBoxIsDisabled,
        r && dt.checkBoxIsInvalid,
        t
      ].filter(Boolean).join(" "),
      children: [
        /* @__PURE__ */ Re("span", { className: dt.checkBoxBox, children: [
          /* @__PURE__ */ R(
            "input",
            {
              type: "checkbox",
              className: dt.checkBoxInput,
              checked: S,
              disabled: i,
              readOnly: a,
              required: s,
              onChange: E
            }
          ),
          /* @__PURE__ */ R(
            "span",
            {
              className: dt.checkBoxIcon,
              "aria-hidden": "true",
              children: /* @__PURE__ */ R(
                "svg",
                {
                  viewBox: "0 0 16 16",
                  className: dt.checkBoxCheckSvg,
                  children: /* @__PURE__ */ R(
                    "path",
                    {
                      d: "M6.2 11.3 2.9 8l1.1-1.1 2.2 2.2 5-5L12.3 5l-6.1 6.3Z",
                      fill: "currentColor"
                    }
                  )
                }
              )
            }
          )
        ] }),
        d != null && /* @__PURE__ */ R(
          "span",
          {
            className: [dt.checkBoxLabel, o && S && dt.checkBoxLabelLineThrough].filter(Boolean).join(" "),
            children: d
          }
        )
      ]
    }
  );
};
ys.displayName = "Checkbox";
var hv = ({ content: t, attrs: e }) => {
  const n = nf(Zh), i = t?.[0]?.text || "", r = e?.language ? n.highlight(e.language, i) : n.highlightAuto(i), a = e?.language ?? (typeof r.data?.language == "string" ? r.data.language : void 0);
  return /* @__PURE__ */ R("pre", { className: "hljs", children: /* @__PURE__ */ R("code", { className: a ? `language-${a}` : void 0, children: Jp(r, { Fragment: la, jsx: R, jsxs: Re }) }) });
}, fv = ({ attrs: t, children: e }) => {
  const n = t?.backgroundColor || "#e8edf5";
  return /* @__PURE__ */ R(
    "div",
    {
      className: `ce-colorNote ${dt.colorNote}`,
      style: { backgroundColor: n },
      children: e
    }
  );
}, Tv = ({ attrs: t, children: e, content: n = [] }) => {
  const i = yn.Children.toArray(e), r = t?.layout ? `layout-${t.layout}` : "";
  return /* @__PURE__ */ R(
    "div",
    {
      "data-type": "columns",
      className: r,
      children: n.map((a, s) => /* @__PURE__ */ R(
        "div",
        {
          "data-type": "column",
          "data-position": a.attrs?.position ?? s,
          children: i[s]
        },
        s
      ))
    }
  );
}, bv = ({ attrs: t, children: e }) => {
  const n = `h${t.level || 2}`;
  return /* @__PURE__ */ R(n, { id: t.id, children: t.text ?? e });
}, Cv = () => /* @__PURE__ */ R(
  "div",
  {
    "data-type": "horizontalRule",
    className: "ProseMirror-selectednode",
    children: /* @__PURE__ */ R("hr", {})
  }
), yv = ({ attrs: t }) => {
  const {
    text: e,
    href: n,
    backgroundColor: i = "#000000",
    color: r = "#f6f6f9",
    align: a = "start",
    target: s = "_self",
    rel: o,
    variant: l = "primary",
    size: c = "md"
  } = t, d = s === "_blank" ? [o, "noopener", "noreferrer"].filter(Boolean).join(" ") || void 0 : o || void 0, u = [dt.linkButton, dt[`linkButton_variant_${l}`], dt[`linkButton_size_${c}`]].filter(Boolean).join(" ");
  return /* @__PURE__ */ R("div", { className: "react-renderer node-linkButton", children: /* @__PURE__ */ R(
    "div",
    {
      className: dt.linkButtonWrapper,
      style: {
        justifyContent: a
      },
      children: /* @__PURE__ */ R(
        "a",
        {
          className: u,
          href: n,
          target: s,
          rel: d,
          style: { color: r, backgroundColor: i, justifySelf: a },
          children: e
        }
      )
    }
  ) });
}, Rv = ({ children: t }) => /* @__PURE__ */ R("ul", { children: t }), Nv = ({ children: t }) => /* @__PURE__ */ R("ol", { children: t }), Ov = ({ children: t }) => /* @__PURE__ */ R("li", { children: t }), vv = ({ children: t }) => /* @__PURE__ */ R("p", { children: t }), Av = ({ children: t }) => /* @__PURE__ */ R("table", { children: /* @__PURE__ */ R("tbody", { children: t }) }), Iv = ({ children: t }) => /* @__PURE__ */ R("td", { children: t }), Dv = ({ children: t }) => /* @__PURE__ */ R("tr", { children: t }), Mv = ({ children: t }) => /* @__PURE__ */ R("div", { className: dt.taskList, children: t });
function wv(...t) {
  return t.filter(Boolean).join(" ");
}
function Rs({ variant: t = "primary", size: e = "md", className: n, type: i, ...r }) {
  return /* @__PURE__ */ R(
    "button",
    {
      ...r,
      type: i ?? "button",
      className: wv(Ba.btn, Ba[`variant_${t}`], Ba[`size_${e}`], n)
    }
  );
}
function Ja(...t) {
  return t.filter(Boolean).join(" ");
}
var xv = 200, c_ = p_(null);
function Fr() {
  const t = g_(c_);
  if (!t) throw new Error("Dialog components must be used within <Dialog.Root>.");
  return t;
}
function Lv({
  value: t,
  defaultValue: e,
  onChange: n
}) {
  const [i, r] = Je(e ?? !1), a = t !== void 0;
  return [a ? t : i, (l) => {
    a || r(l), n?.(l);
  }];
}
function d_(t) {
  const e = [
    "a[href]",
    "button:not([disabled])",
    "textarea:not([disabled])",
    "input:not([disabled])",
    "select:not([disabled])",
    '[tabindex]:not([tabindex="-1"])'
  ].join(",");
  return Array.from(t.querySelectorAll(e)).filter(
    (n) => !n.hasAttribute("disabled") && !n.getAttribute("aria-hidden")
  );
}
function Pv(t) {
  (d_(t)[0] ?? t).focus();
}
function kv(t) {
  gt(() => {
    if (!t) return;
    const e = document.body.style.overflow;
    return document.body.style.overflow = "hidden", () => {
      document.body.style.overflow = e;
    };
  }, [t]);
}
function Uv(t, e) {
  gt(() => {
    if (!t) return;
    const n = (i) => {
      i.key === "Escape" && e();
    };
    return document.addEventListener("keydown", n), () => document.removeEventListener("keydown", n);
  }, [t, e]);
}
function Fv(t) {
  const e = wt(null);
  gt(() => {
    if (!t.open) return;
    e.current = document.activeElement;
    const n = window.setTimeout(() => {
      t.contentRef?.current && Pv(t.contentRef.current);
    }, 0);
    return () => {
      window.clearTimeout(n), (t.triggerRef?.current ?? e.current)?.focus?.();
    };
  }, [t.open, t.contentRef, t.triggerRef]);
}
var zi = {
  Root: function({ open: e, defaultOpen: n, onOpenChange: i, children: r }) {
    const a = E_(), s = `dialog-title-${a}`, o = `dialog-desc-${a}`, l = wt(null), c = wt(null), [d, u] = Lv({
      value: e,
      defaultValue: n,
      onChange: i
    }), _ = Ct(
      () => ({
        open: d,
        setOpen: u,
        titleId: s,
        descriptionId: o,
        triggerRef: l,
        contentRef: c
      }),
      [d, u, s, o]
    );
    return kv(d), Uv(d, () => u(!1)), Fv(_), /* @__PURE__ */ R(c_.Provider, { value: _, children: r });
  },
  Portal: function({ children: e }) {
    const n = Fr(), [i, r] = Je(!1), [a, s] = Je(!1), o = wt(null);
    return gt(() => r(!0), []), gt(() => {
      if (n.open) {
        s(!0), o.current && window.clearTimeout(o.current);
        return;
      }
      return o.current = window.setTimeout(() => {
        s(!1);
      }, xv), () => {
        o.current && window.clearTimeout(o.current);
      };
    }, [n.open]), !i || !a ? null : uc(e, document.body);
  },
  Backdrop: function(e) {
    const { closeOnClick: n = !0, onMouseDown: i, className: r, ...a } = e, s = Fr();
    return /* @__PURE__ */ R(
      "div",
      {
        ...a,
        "data-state": s.open ? "open" : "closed",
        className: Ja("ce-dialog-backdrop", Fa.backdrop, r),
        onMouseDown: (o) => {
          i?.(o), n && o.target === o.currentTarget && s.setOpen(!1);
        }
      }
    );
  },
  Popup: function(e) {
    const n = Fr(), { className: i, onKeyDown: r, ...a } = e;
    return /* @__PURE__ */ R(
      "div",
      {
        ...a,
        ref: n.contentRef,
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": n.titleId,
        "aria-describedby": n.descriptionId,
        tabIndex: -1,
        className: Ja("ce-dialog-popup", Fa.popup, i),
        onKeyDown: (s) => {
          if (r?.(s), s.key !== "Tab") return;
          const o = n.contentRef.current;
          if (!o) return;
          const l = d_(o);
          if (l.length === 0) return;
          const c = l[0], d = l[l.length - 1], u = document.activeElement;
          !s.shiftKey && u === d ? (s.preventDefault(), c.focus()) : s.shiftKey && u === c && (s.preventDefault(), d.focus());
        }
      }
    );
  },
  Close: function(e) {
    const { asChild: n, onClick: i, className: r, ...a } = e, s = Fr();
    if (n) {
      const o = yn.Children.only(a.children);
      return yn.cloneElement(o, {
        onClick: (l) => {
          o.props.onClick?.(l), i?.(l), s.setOpen(!1);
        }
      });
    }
    return /* @__PURE__ */ R(
      Rs,
      {
        ...a,
        type: a.type ?? "button",
        className: Ja("ce-dialog-close", Fa.close, r),
        onClick: (o) => {
          i?.(o), s.setOpen(!1);
        },
        children: /* @__PURE__ */ R($_, { size: 16 })
      }
    );
  }
}, u_ = ({ isOpen: t, onClose: e, children: n }) => {
  const i = (r) => {
    r || e();
  };
  return /* @__PURE__ */ R(
    zi.Root,
    {
      open: t,
      onOpenChange: i,
      children: /* @__PURE__ */ R(zi.Portal, { children: /* @__PURE__ */ Re(zi.Backdrop, { children: [
        /* @__PURE__ */ R(zi.Close, {}),
        /* @__PURE__ */ R(zi.Popup, { children: n })
      ] }) })
    }
  );
};
function oc(t) {
  return t ? t.startsWith("/assets/") || t.startsWith("data:image/") : !0;
}
function Bv(t, e) {
  return new Promise((n, i) => {
    const r = window.setTimeout(n, t), a = () => {
      window.clearTimeout(r), i(new DOMException("Aborted", "AbortError"));
    };
    if (e) {
      if (e.aborted) return a();
      e.addEventListener("abort", a, { once: !0 });
    }
  });
}
function Gv(t, e) {
  return new Promise((n, i) => {
    const r = new Image(), a = () => {
      r.onload = null, r.onerror = null, e && e.removeEventListener("abort", s);
    }, s = () => {
      a(), r.src = "", i(new DOMException("Aborted", "AbortError"));
    };
    if (e) {
      if (e.aborted) return s();
      e.addEventListener("abort", s);
    }
    r.onload = () => {
      a(), n({ width: r.naturalWidth, height: r.naturalHeight });
    }, r.onerror = () => {
      a(), i(new Error("IMAGE_LOAD_ERROR"));
    }, r.src = t;
  });
}
var wo = (t) => {
  const { src: e, maxRetries: n = 5, initialDelay: i = 1e3, staleTime: r = 1e3 * 60 * 5, cacheTime: a = 1e3 * 60 * 5 } = t, [s, o] = Je({
    status: "idle",
    dimensions: null,
    error: null
  }), l = oc(e), c = wt(null), d = Jt(
    async (_) => {
      const m = _ ?? e;
      c.current?.abort();
      const g = new AbortController();
      if (c.current = g, !m) {
        o({ status: "error", dimensions: null, error: "Нет изображения" });
        return;
      }
      if (oc(m)) {
        o({ status: "success", dimensions: null, error: null });
        return;
      }
      o({ status: "fetching", dimensions: null, error: null });
      let S = 0;
      for (; ; )
        try {
          const E = await Gv(m, g.signal);
          o({ status: "success", dimensions: E, error: null });
          return;
        } catch (E) {
          if (E instanceof DOMException && E.name === "AbortError") return;
          if (S += 1, S >= n) {
            o({
              status: "error",
              dimensions: null,
              error: "Не удалось загрузить изображение"
            });
            return;
          }
          const h = i * S;
          try {
            await Bv(h, g.signal);
          } catch (T) {
            if (T instanceof DOMException && T.name === "AbortError") return;
          }
        }
    },
    [e, n, i]
  );
  gt(() => (d(e ?? null), () => {
    c.current?.abort();
  }), [e, d]);
  const u = Jt(() => d(e ?? null), [d, e]);
  return e ? l ? {
    imageLoaded: !0,
    error: null,
    dimensions: null,
    isFetching: !1,
    refetch: u
  } : {
    imageLoaded: s.status === "success",
    error: s.status === "error" ? s.error : null,
    dimensions: s.dimensions,
    isFetching: s.status === "fetching",
    refetch: u
  } : {
    imageLoaded: !1,
    error: "Нет изображения",
    dimensions: null,
    isFetching: !1,
    refetch: u
  };
}, Yv = (t) => {
  const { attrs: e } = t || {}, { width: n, align: i } = e || {}, [r, a] = Je(!1), { src: s } = e, { imageLoaded: o, error: l } = wo({ src: s }), c = wt(null), d = Ct(() => i === "left" ? `${rt.wrapper} ${rt.alignLeft}` : i === "right" ? `${rt.wrapper} ${rt.alignRight}` : `ce-image ${rt.wrapper} ${rt.alignCenter}`, [i]), u = Ct(() => {
    let g = rt.imageProcessing;
    return l || (g += ` ${rt.processingSuccess}`), l && (g += ` ${rt.processingError}`), g;
  }, [l]), _ = !o || l ? "100%" : n ? `${n}` : "100%", m = Jt(() => {
    a(!0);
  }, []);
  return /* @__PURE__ */ Re(la, { children: [
    /* @__PURE__ */ R(
      "div",
      {
        className: d,
        ref: c,
        children: /* @__PURE__ */ Re(
          "div",
          {
            className: `ce-image-wrapper ${rt.imageWrapper}`,
            style: { width: _ },
            children: [
              s ? /* @__PURE__ */ R(
                "img",
                {
                  className: `${rt.image} ${rt.imageBlock}`,
                  style: {
                    aspectRatio: o ? "auto" : "2"
                  },
                  src: o ? s : void 0,
                  alt: "",
                  onClick: o ? m : () => null
                }
              ) : /* @__PURE__ */ R("div", { className: `ce-image-placeholder ${rt.placeholder}`, children: /* @__PURE__ */ R(k_, { className: rt.placeholderIcon }) }),
              !o && /* @__PURE__ */ Re("div", { className: `ce-image-overlay ${u}`, children: [
                !l && /* @__PURE__ */ R("div", { className: `${rt.processingText} ${rt.textSuccess}`, children: "Изображение обрабатывается..." }),
                l && /* @__PURE__ */ Re("div", { className: `ce-image-error ${rt.processingText} ${rt.textDanger}`, children: [
                  "Error: ",
                  l
                ] })
              ] })
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ R(
      u_,
      {
        isOpen: r,
        onClose: () => a(!1),
        children: /* @__PURE__ */ R(
          "img",
          {
            className: rt.modalImage,
            src: s
          }
        )
      }
    )
  ] });
};
function $v(t, e) {
  let n = 0, i = null;
  const r = (...a) => {
    const s = Date.now(), o = e - (s - n);
    o <= 0 ? (i && (clearTimeout(i), i = null), n = s, t(...a)) : i || (i = setTimeout(() => {
      n = Date.now(), i = null, t(...a);
    }, o));
  };
  return r.cancel = () => {
    i && (clearTimeout(i), i = null);
  }, r;
}
var Vv = {
  1: [3],
  2: [3],
  3: [3],
  4: [2, 2],
  5: [2, 3],
  6: [3, 3],
  7: [2, 2, 3],
  8: [3, 3, 2],
  9: [3, 3, 3]
};
function Hv({
  images: t,
  layout: e,
  containerWidth: n,
  gap: i = 4
}) {
  const r = [];
  let a = 0;
  return e.forEach((s, o) => {
    const l = t.slice(a, a + s), c = l.reduce((m, g) => m + g.aspectRatio, 0), d = i * (s - 1), _ = (n - d) / c;
    l.forEach((m) => {
      const g = m.aspectRatio * _;
      r.push({
        ...m,
        displayWidth: g,
        displayHeight: _,
        rowIndex: o
      });
    }), a += s;
  }), r;
}
var qv = ({ image: t, onClick: e, onImageLoad: n, layoutHeight: i, layoutWidth: r }) => {
  const { imageLoaded: a, error: s } = wo({ src: t.src }), o = (c) => {
    const { naturalWidth: d, naturalHeight: u } = c.currentTarget;
    n(t.id, d, u);
  }, l = Ct(() => {
    const c = {
      borderRadius: `${t.borderRadius || 0}px`
    };
    return a ? c : {
      ...c,
      ...r ? { width: `${r}px` } : s ? { width: "100%" } : { minWidth: 200 },
      height: i || 200
    };
  }, [a, s, r, i, t.borderRadius]);
  return /* @__PURE__ */ Re(
    "div",
    {
      className: `ce-gallery-grid-item ${kn.galleryGridItem}`,
      style: l,
      onClick: a && !s ? e : void 0,
      children: [
        a && !s ? /* @__PURE__ */ R(
          "img",
          {
            className: `ce-gallery-image ${kn.galleryGridItemImage}`,
            style: { borderRadius: `${t.borderRadius || 0}px` },
            src: t.src,
            alt: t.description || "",
            onLoad: o
          }
        ) : /* @__PURE__ */ R(
          "div",
          {
            className: `ce-gallery-image-not-loaded ${kn.galleryGridItemNotLoaded} ${s ? kn.galleryGridItemError : ""}`,
            style: { borderRadius: `${t.borderRadius || 0}px` },
            children: s && /* @__PURE__ */ R("span", { children: "Ошибка загрузки" })
          }
        ),
        t.description && a && !s && /* @__PURE__ */ Re(la, { children: [
          /* @__PURE__ */ R("div", { className: `ce-gallery-grid-item-text ${kn.galleryGridItemText}`, children: /* @__PURE__ */ R(
            F_,
            {
              size: 20,
              className: "text-white"
            }
          ) }),
          /* @__PURE__ */ R(
            "div",
            {
              className: `ce-gallery-grid-item-hover-text ${kn.galleryGridItemHoverText}`,
              style: { borderRadius: `0 0 ${t.borderRadius || 0}px ${t.borderRadius || 0}px` },
              children: t.description
            }
          )
        ] })
      ]
    }
  );
}, zv = ({ emblaApi: t }) => {
  const [e, n] = Je(0), [i, r] = Je(0), a = Jt((s) => {
    r(s.scrollSnapList().length), n(s.selectedScrollSnap());
  }, []);
  return gt(() => {
    if (t)
      return a(t), t.on("select", a), t.on("reInit", a), () => {
        t.off("select", a), t.off("reInit", a);
      };
  }, [t, a]), /* @__PURE__ */ Re("div", { className: pt.snapDisplay, children: [
    e + 1,
    " / ",
    i
  ] });
}, Wv = ({ emblaApi: t }) => {
  const e = Jt(() => {
    t && t.scrollPrev();
  }, [t]), n = Jt(() => {
    t && t.scrollNext();
  }, [t]);
  return /* @__PURE__ */ Re("div", { className: pt.actions, children: [
    /* @__PURE__ */ R(
      Rs,
      {
        variant: "ghost",
        className: pt.actionsButton,
        onClick: e,
        children: /* @__PURE__ */ R(D_, { size: 24 })
      }
    ),
    /* @__PURE__ */ R(
      Rs,
      {
        variant: "ghost",
        className: pt.actionsButton,
        onClick: n,
        children: /* @__PURE__ */ R(w_, { size: 24 })
      }
    )
  ] });
}, Kv = ({ selected: t, image: e, onClick: n }) => /* @__PURE__ */ R(
  "div",
  {
    className: `ce-gallery-thumb ${pt.carouselThumb} ${t ? pt.selectedCarouselThumb : ""}`,
    onClick: n,
    children: /* @__PURE__ */ R(
      "img",
      {
        src: e.src,
        alt: e.description || ""
      }
    )
  }
), Qv = ({ images: t, startedImageIndex: e }) => {
  const [n, i] = Je(e || 0), [r, a] = Qr({ loop: !0, startIndex: e || 0 }), [s, o] = Qr({
    containScroll: "trimSnaps",
    dragFree: !0
  }), l = Ct(() => t.length > 1, [t.length]), c = Jt(() => {
    !a || !o || (i(a.selectedScrollSnap()), o.scrollTo(a.selectedScrollSnap()));
  }, [a, o]);
  gt(() => {
    if (a)
      return c(), a.on("select", c).on("reInit", c), () => {
        a.off("select", c).off("reInit", c);
      };
  }, [a, c]);
  const d = Jt(
    (u) => {
      !a || !o || a.scrollTo(u);
    },
    [a, o]
  );
  return /* @__PURE__ */ Re("div", { className: `ce-gallery-carousel ${pt.carouselWrapper}`, children: [
    /* @__PURE__ */ R(zv, { emblaApi: a }),
    /* @__PURE__ */ Re(
      "div",
      {
        className: `ce-gallery-viewport ${pt.carouselViewport}`,
        ref: r,
        children: [
          /* @__PURE__ */ R("div", { className: `ce-gallery-container ${pt.carouselContainer}`, children: t.map((u) => /* @__PURE__ */ Re(
            "div",
            {
              className: `ce-gallery-slide ${pt.carouselSlide}`,
              children: [
                /* @__PURE__ */ R("div", { className: `ce-gallery-slide-item ${pt.carouselSlideItem}`, children: /* @__PURE__ */ R(
                  "img",
                  {
                    src: u.src,
                    alt: u.description || ""
                  }
                ) }),
                u.description && /* @__PURE__ */ R("div", { className: `ce-gallery-slide-description ${pt.carouselSlideDescription}`, children: u.description })
              ]
            },
            u.id
          )) }),
          l && /* @__PURE__ */ R(Wv, { emblaApi: a })
        ]
      }
    ),
    l && /* @__PURE__ */ R("div", { className: `ce-gallery-thumbs ${pt.carouselThumbsWrapper}`, children: /* @__PURE__ */ R(
      "div",
      {
        className: pt.carouselThumbsViewport,
        ref: s,
        children: /* @__PURE__ */ R("div", { className: pt.carouselThumbsContainer, children: t.map((u, _) => /* @__PURE__ */ R(
          Kv,
          {
            image: u,
            onClick: () => d(_),
            selected: _ === n
          },
          u.id
        )) })
      }
    ) })
  ] });
}, Xv = (t) => {
  const { attrs: e } = t || {}, { images: n = [] } = e || {}, [i, r] = Je({}), [a, s] = Je([]), [o, l] = Je(null), c = wt(null), [d, u] = Je(null), _ = Ct(() => $v((E) => u(E), 300), []);
  gt(() => {
    if (!c.current) return;
    const E = c.current.offsetWidth;
    E > 0 && u(E);
    const h = new ResizeObserver((T) => {
      for (const b of T) {
        const C = b.contentRect.width;
        _(C);
      }
    });
    return h.observe(c.current), () => {
      h.disconnect(), _.cancel();
    };
  }, [_]), gt(() => {
    if (!d || n.length === 0) return;
    const E = n.map((b) => {
      const C = i[b.id], y = C?.width || 200, O = C?.height || 200, A = y / O;
      return {
        ...b,
        width: y,
        height: O,
        aspectRatio: A
      };
    }), h = Vv[n.length] || [3], T = Hv({ images: E, layout: h, containerWidth: d });
    s(T);
  }, [n, i, d]);
  const m = Jt((E, h, T) => {
    r((b) => b[E]?.width === h && b[E]?.height === T ? b : { ...b, [E]: { width: h, height: T } });
  }, []), g = Ct(() => new Map(a.map((E) => [E.id, E])), [a]), S = Ct(() => new Map(n.map((E) => [E.id, E])), [n]);
  return n.length === 0 ? null : /* @__PURE__ */ Re(la, { children: [
    /* @__PURE__ */ R(
      "div",
      {
        ref: c,
        className: `ce-gallery ${kn.galleryGrid}`,
        children: a.map((E, h) => {
          const T = g.get(E.id), b = S.get(E.id), C = T?.displayWidth ?? "auto", y = T?.displayHeight ?? "auto";
          return b ? /* @__PURE__ */ R(
            "div",
            {
              style: {
                width: C,
                height: y,
                display: "inline-block"
              },
              children: /* @__PURE__ */ R(
                qv,
                {
                  image: b,
                  onClick: () => l(h),
                  onImageLoad: m,
                  layoutHeight: T?.displayHeight,
                  layoutWidth: T?.displayWidth
                }
              )
            },
            E.id
          ) : null;
        })
      }
    ),
    /* @__PURE__ */ R(
      u_,
      {
        isOpen: o !== null,
        onClose: () => l(null),
        children: /* @__PURE__ */ R(
          Qv,
          {
            images: n,
            startedImageIndex: o
          }
        )
      }
    )
  ] });
}, Zv = ({ bannerLink: t, tooltipRef: e }) => {
  const [n, i] = Je(null);
  return m_(e, () => ({
    handleMouseMove: (r, a) => {
      i({ x: r, y: a });
    },
    handleMouseLeave: () => {
      i(null);
    }
  })), n ? /* @__PURE__ */ Re(
    "div",
    {
      className: st.tooltip,
      style: { left: n.x, top: n.y },
      children: [
        Jv(t),
        "…"
      ]
    }
  ) : null;
};
function Jv(t) {
  if (!t) return "";
  try {
    return new URL(t).hostname;
  } catch {
    return t.split("/")[0];
  }
}
var jv = (t) => {
  const { attrs: e } = t || {}, { src: n, align: i, link: r, width: a, target: s = "_blank" } = e, { imageLoaded: o, error: l, dimensions: c } = wo({ src: n }), d = wt(null), u = wt(null), _ = Ct(() => i === "left" ? `${st.bannerWrapper} ${st.alignLeft}` : i === "right" ? `${st.bannerWrapper} ${st.alignRight}` : `ce-banner ${st.bannerWrapper} ${st.alignCenter}`, [i]), m = Ct(() => {
    let h = st.imageProcessing;
    return l || (h += ` ${st.processingSuccess}`), l && (h += ` ${st.processingError}`), h;
  }, [l]), g = r, S = !o || l ? "100%" : a ? `${a}%` : "100%", E = () => {
    g && window.open(g, s);
  };
  return /* @__PURE__ */ Re(
    "div",
    {
      className: _,
      ref: d,
      children: [
        /* @__PURE__ */ Re(
          "div",
          {
            contentEditable: !1,
            className: st.bannerWrapper,
            style: { width: S },
            children: [
              /* @__PURE__ */ R(
                "img",
                {
                  className: `ce-banner-image ${st.image}`,
                  style: {
                    aspectRatio: o ? "auto" : "2"
                  },
                  src: o ? n : void 0,
                  alt: "",
                  onMouseMove: (h) => u.current?.handleMouseMove(h.clientX + 16, h.clientY + 16),
                  onMouseLeave: () => u.current?.handleMouseLeave(),
                  onClick: o && g ? E : void 0
                }
              ),
              !o && /* @__PURE__ */ Re("div", { className: `ce-banner-overlay ${st.imageProcessing} ${m}`, children: [
                !l && /* @__PURE__ */ R("div", { className: `${st.processingText} ${st.textSuccess}`, children: "Изображение обрабатывается..." }),
                l && /* @__PURE__ */ Re("div", { className: `ce-banner-error ${st.processingText} ${st.textDanger}`, children: [
                  "Error: ",
                  l
                ] })
              ] }),
              /* @__PURE__ */ R("div", { className: st.bannerIcon, children: /* @__PURE__ */ R(G_, { size: 16 }) })
            ]
          }
        ),
        g && /* @__PURE__ */ R(
          Zv,
          {
            bannerLink: g,
            tooltipRef: u
          }
        )
      ]
    }
  );
}, eA = ({
  url: t,
  interval: e = 1e3,
  maxRetries: n = 5,
  strategy: i = "fixed"
}) => {
  const [r, a] = Je(!0), [s, o] = Je(null), [l, c] = Je(null), d = wt(null);
  return gt(() => {
    if (!t) return;
    let u = !1;
    const _ = async (m) => {
      if (!u) {
        a(!0);
        try {
          const g = await fetch(t, { method: "HEAD" });
          if (!g.ok)
            throw new Error(`Request failed with status ${g.status}`);
          u || (o(!0), a(!1));
        } catch (g) {
          if (!u)
            if (m < n - 1) {
              const S = i === "fixed" ? e : e * Math.pow(2, m);
              d.current = setTimeout(() => {
                _(m + 1);
              }, S);
            } else
              o(!1), c(g), a(!1);
        }
      }
    };
    return _(0), () => {
      u = !0, d.current && clearTimeout(d.current);
    };
  }, [t, e, n, i]), { isLoading: r, isAvailable: s, error: l };
}, tA = {
  "Current time": "Текущее время",
  "Disable captions": "Отключить субтитры",
  "Enable captions": "Включить субтитры",
  "Enter Fullscreen": "На весь экран",
  "Enter PiP": "Включить PiP",
  "Exit Fullscreen": "Выйти из полноэкранного режима",
  "Exit PiP": "Выйти из PiP",
  "Go back to previous menu": "Вернуться в предыдущее меню",
  Ad: "Реклама",
  AirPlay: "AirPlay",
  All: "Все",
  Audio: "Аудио",
  Auto: "Авто",
  Buffered: "Буферизация",
  Captions: "Субтитры",
  Default: "По умолчанию",
  Disabled: "Отключено",
  Download: "Скачать",
  Duration: "Длительность",
  Enabled: "Включено",
  End: "Конец",
  Forward: "Вперёд",
  LIVE: "Прямой эфир",
  Loop: "Повтор",
  Mute: "Выключить звук",
  Normal: "Обычный",
  Pause: "Пауза",
  Play: "Воспроизведение",
  Played: "Просмотрено",
  Quality: "Качество",
  Reset: "Сброс",
  Restart: "Перезапуск",
  Rewind: "Назад",
  Seek: "Перемотка",
  Settings: "Настройки",
  Speed: "Скорость",
  Start: "Начало",
  Unmute: "Включить звук",
  Volume: "Громкость"
}, nA = ({ size: t = 16, strokeWidth: e = 3, className: n, ...i }) => /* @__PURE__ */ R(
  "span",
  {
    role: "status",
    "aria-label": "Loading",
    className: ["ce-spinner", Ur.root, n].filter(Boolean).join(" "),
    ...i,
    children: /* @__PURE__ */ Re(
      "svg",
      {
        viewBox: "0 0 24 24",
        width: t,
        height: t,
        className: Ur.svg,
        fill: "none",
        children: [
          /* @__PURE__ */ R(
            "circle",
            {
              cx: "12",
              cy: "12",
              r: "9",
              stroke: "currentColor",
              strokeWidth: e,
              className: Ur.track
            }
          ),
          /* @__PURE__ */ R(
            "path",
            {
              d: "M21 12a9 9 0 0 0-9-9",
              stroke: "currentColor",
              strokeWidth: e,
              className: Ur.indicator
            }
          )
        ]
      }
    )
  }
), iA = ({
  src: t,
  viewType: e = "video",
  streamType: n = "on-demand",
  width: i,
  playsInline: r = !0,
  title: a,
  poster: s,
  textTracks: o,
  markers: l
}) => {
  const [c, d] = Je(!1), { isAvailable: u } = eA({ url: t, maxRetries: 10, interval: 5e3, strategy: "exponential" }), _ = Jt(() => {
    d(!0);
  }, []), m = (S) => {
    py(S) && (S.config = {});
  }, g = wt(null);
  return gt(() => {
    g?.current && u && g?.current?.startLoading();
  }, [u]), /* @__PURE__ */ Re(
    "div",
    {
      style: { width: i },
      className: `ce-player ${oa.wrapper}`,
      children: [
        u ? /* @__PURE__ */ Re(
          Ou,
          {
            ref: g,
            src: t,
            viewType: e,
            streamType: n,
            logLevel: "warn",
            crossOrigin: !0,
            playsInline: r,
            onCanPlay: _,
            onProviderChange: m,
            title: a,
            poster: s,
            children: [
              /* @__PURE__ */ Re(vu, { children: [
                !!s && /* @__PURE__ */ R(Du, { className: "vds-poster" }),
                o?.map((S) => /* @__PURE__ */ qr(
                  Iu,
                  {
                    ...S,
                    key: S.src
                  }
                ))
              ] }),
              /* @__PURE__ */ R(
                xu,
                {
                  icons: iv,
                  translations: tA,
                  markers: l
                }
              )
            ]
          }
        ) : /* @__PURE__ */ R(rA, {}),
        !c && u && /* @__PURE__ */ R("div", { className: oa.loader, children: /* @__PURE__ */ R(nA, {}) })
      ]
    }
  );
}, rA = () => /* @__PURE__ */ R("div", { className: oa.processed, children: /* @__PURE__ */ Re("div", { className: oa.processedWrapper, children: [
  /* @__PURE__ */ R(L_, { size: 32 }),
  /* @__PURE__ */ R("h2", { children: "Видео скоро появится" }),
  /* @__PURE__ */ R("p", { children: "Обработка занимает не больше 24 часов" })
] }) }), aA = (t) => {
  const { attrs: e } = t || {}, { src: n } = e || {};
  return /* @__PURE__ */ R(
    iA,
    {
      src: n,
      viewType: "video",
      streamType: "on-demand"
    }
  );
}, lc = {
  heading: bv,
  paragraph: vv,
  bulletList: Rv,
  orderedList: Nv,
  listItem: Ov,
  linkButton: yv,
  accordionExt: gv,
  blockquoteFigure: Sv,
  taskList: Mv,
  checkbox: ys,
  taskItem: (t) => /* @__PURE__ */ R(
    ys,
    {
      lineThrough: !0,
      isDisabled: !0,
      className: "opacity-100",
      ...t
    }
  ),
  codeBlock: hv,
  colorNote: fv,
  columns: Tv,
  table: Av,
  tableRow: Dv,
  tableCell: Iv,
  horizontalRule: Cv,
  imageBlock: Yv,
  gallery: Xv,
  bannerBlock: jv,
  videoBlock: aA
}, li = (t) => t.join(".");
function sA(t, e = {}) {
  const n = {
    ...lc,
    ...typeof t == "function" ? t(lc) : t
  }, i = e.onUnknownNode ?? ((c, d) => d ?? null), r = e.getKey ?? li, a = (c) => {
    const { text: d, marks: u } = c;
    let _ = d;
    if (!u?.length) return _;
    for (let m = u.length - 1; m >= 0; m--) {
      const g = u[m];
      switch (g.type) {
        case "bold":
          _ = /* @__PURE__ */ R("strong", { children: _ }, `m-${m}`);
          break;
        case "italic":
          _ = /* @__PURE__ */ R("em", { children: _ }, `m-${m}`);
          break;
        case "underline":
          _ = /* @__PURE__ */ R("u", { children: _ }, `m-${m}`);
          break;
        case "strike":
          _ = /* @__PURE__ */ R("s", { children: _ }, `m-${m}`);
          break;
        case "code":
          _ = /* @__PURE__ */ R("code", { children: _ }, `m-${m}`);
          break;
        case "link": {
          const S = g.attrs?.href, E = g.attrs?.target, h = g.attrs?.class;
          _ = /* @__PURE__ */ R(
            "a",
            {
              href: S,
              target: E,
              rel: E === "_blank" ? "noopener noreferrer" : void 0,
              className: h,
              children: _
            },
            `m-${m}`
          );
          break;
        }
        case "textStyle": {
          const S = {};
          Object.entries(g?.attrs).map(([E, h]) => {
            h && (S[E] = h);
          }), _ = /* @__PURE__ */ R(
            "span",
            {
              style: S,
              children: _
            },
            `m-${m}`
          );
          break;
        }
      }
    }
    return _;
  }, s = (c, d) => {
    const { level: u, ..._ } = c.attrs;
    let m = typeof u == "number" ? u : parseInt(u ?? "1", 10) || 1;
    m = Math.min(6, Math.max(1, u));
    const g = `h${m}`, S = {};
    return Object.entries(_ ?? {}).map(([E, h]) => {
      h && (S[E] = h);
    }), /* @__PURE__ */ R(
      g,
      {
        style: S,
        children: c?.content?.map((E, h) => /* @__PURE__ */ R(Qo, { children: o(E) }, `h-f-${li(d)}-${h}`)) ?? null
      },
      `h-${li(d)}`
    );
  }, o = (c, d = []) => {
    if (!c) return null;
    if (c.type === "hardBreak")
      return /* @__PURE__ */ R("br", {}, `br-${li(d)}`);
    if (c.type === "text")
      return a(c);
    if (c.type === "heading")
      return s(c, d);
    if (c.type === "paragraph")
      return l(c, d);
    const u = c.content?.map((g, S) => o(g, [...d, S])) ?? null, _ = n[c.type];
    if (_)
      return yn.createElement(_, { key: r(d, c), ...c }, u);
    const m = i(c, u);
    return yn.isValidElement(m) ? yn.cloneElement(m, { key: r(d, c) }) : m;
  };
  function l(c, d) {
    const u = {};
    return Object.entries(c?.attrs ?? {}).map(([_, m]) => {
      m && (u[_] = m);
    }), /* @__PURE__ */ R(
      "p",
      {
        style: u,
        children: c?.content?.map((_, m) => /* @__PURE__ */ R(Qo, { children: o(_) }, `p-f-${li(d)}-${m}`)) ?? null
      },
      `p-${li(d)}`
    );
  }
  return {
    render(c) {
      return o(c, [0]);
    },
    renderNode: o
  };
}
var oA = ({ doc: t, views: e, options: n, className: i = "" }) => {
  const { render: r } = Ct(() => sA(e, n), [e, n?.getKey, n?.onUnknownNode]);
  return t ? /* @__PURE__ */ R(pv, { children: /* @__PURE__ */ R("div", { className: `ProseMirror render ${i}`, children: r(t) }) }) : null;
};
const cc = {
  left: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start"
  },
  center: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  right: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end"
  }
}, lA = (t) => {
  const {
    src: e,
    alt: n,
    width: i,
    height: r,
    align: a = "left",
    indent: s = 0,
    topIndent: o = 0
  } = t.attrs ?? {}, c = typeof e == "string" && /^https?:\/\//.test(e) ? e : h_(e);
  if (!c) return null;
  const d = {
    ...cc[a] || cc.left,
    paddingLeft: s ? `${s}px` : void 0,
    paddingTop: o ? `${o}px` : void 0
  };
  return /* @__PURE__ */ R("div", { style: d, children: /* @__PURE__ */ R(
    "img",
    {
      alt: n || "",
      src: c,
      style: {
        width: i ? `${i}px` : "100%",
        height: r ? `${r}px` : "auto",
        maxWidth: "100%"
      }
    }
  ) });
}, cA = { verticalAlign: "super", fontSize: "smaller" }, dA = { verticalAlign: "sub", fontSize: "smaller" };
function uA(t) {
  return t?.type === "highlight" && t?.attrs?.color ? { type: "textStyle", attrs: { backgroundColor: t.attrs.color } } : t?.type === "superscript" ? { type: "textStyle", attrs: { ...cA } } : t?.type === "subscript" ? { type: "textStyle", attrs: { ...dA } } : t;
}
function Ns(t) {
  if (Array.isArray(t))
    return t.map((e) => Ns(e));
  if (t && typeof t == "object") {
    const e = t, n = { ...e };
    return Array.isArray(e.marks) && (n.marks = e.marks.map(uA)), Array.isArray(e.content) && (n.content = e.content.map((i) => Ns(i))), n;
  }
  return t;
}
const LA = S_(function({
  content: e,
  views: n,
  options: i,
  className: r
}) {
  f_({
    inheritTheme: "app",
    initialTheme: T_.Light
  });
  const a = Ct(() => {
    const o = typeof e == "string" ? JSON.parse(e) : e;
    return Ns(o);
  }, [e]), s = Ct(() => ({
    imageBlock: lA,
    ...n
  }), [n]);
  return /* @__PURE__ */ R(
    b_,
    {
      className: r,
      name: "content-client",
      children: /* @__PURE__ */ R(
        oA,
        {
          className: r,
          doc: a,
          options: i,
          views: s
        }
      )
    }
  );
});
export {
  yb as A,
  ue as B,
  Ei as C,
  Se as D,
  LA as E,
  ky as H,
  Ad as I,
  le as L,
  Mt as Q,
  zd as R,
  Vn as T,
  Wd as V,
  Fy as a,
  Q as b,
  F as c,
  ie as d,
  N as e,
  je as f,
  $r as g,
  ma as h,
  eo as i,
  DC as j,
  yt as k,
  Ve as l,
  Si as m,
  j as n,
  Gr as o,
  Ii as p,
  Jr as q,
  Et as r,
  Tt as s,
  td as t,
  mt as u,
  os as v,
  hA as w,
  H as x,
  js as y,
  AC as z
};
